(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["OktaSignIn"] = factory();
	else
		root["OktaSignIn"] = factory();
})(self, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@sindresorhus/to-milliseconds/index.js":
/*!*************************************************************!*\
  !*** ./node_modules/@sindresorhus/to-milliseconds/index.js ***!
  \*************************************************************/
/***/ (function(module) {

"use strict";


const converters = {
  days: value => value * 864e5,
  hours: value => value * 36e5,
  minutes: value => value * 6e4,
  seconds: value => value * 1e3,
  milliseconds: value => value,
  microseconds: value => value / 1e3,
  nanoseconds: value => value / 1e6
};
const toMilliseconds = object => Object.entries(object).reduce((milliseconds, [key, value]) => {
  if (typeof value !== 'number') {
    throw new TypeError(`Expected a \`number\` for key \`${key}\`, got \`${value}\` (${typeof value})`);
  }
  if (!converters[key]) {
    throw new Error('Unsupported time key');
  }
  return milliseconds + converters[key](value);
}, 0);
module.exports = toMilliseconds;
// TODO: remove this for next major version
module.exports["default"] = toMilliseconds;

/***/ }),

/***/ "./node_modules/parse-ms/index.js":
/*!****************************************!*\
  !*** ./node_modules/parse-ms/index.js ***!
  \****************************************/
/***/ (function(module) {

"use strict";


module.exports = milliseconds => {
  if (typeof milliseconds !== 'number') {
    throw new TypeError('Expected a number');
  }
  const roundTowardsZero = milliseconds > 0 ? Math.floor : Math.ceil;
  return {
    days: roundTowardsZero(milliseconds / 86400000),
    hours: roundTowardsZero(milliseconds / 3600000) % 24,
    minutes: roundTowardsZero(milliseconds / 60000) % 60,
    seconds: roundTowardsZero(milliseconds / 1000) % 60,
    milliseconds: roundTowardsZero(milliseconds) % 1000,
    microseconds: roundTowardsZero(milliseconds * 1000) % 1000,
    nanoseconds: roundTowardsZero(milliseconds * 1e6) % 1000
  };
};

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/_commonjsHelpers.js":
/*!**********************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/_commonjsHelpers.js ***!
  \**********************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.commonjsGlobal = void 0;
exports.getDefaultExportFromCjs = getDefaultExportFromCjs;
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
exports.commonjsGlobal = commonjsGlobal;
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/backbone.js":
/*!**************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/backbone.js ***!
  \**************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.b = void 0;
var backbone = {
  exports: {}
};
exports.b = backbone;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/base.js":
/*!**********************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/base.js ***!
  \**********************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.__exports = void 0;
var base = {};
exports.__exports = base;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/block-helper-missing.js":
/*!**************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/block-helper-missing.js ***!
  \**************************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.b = void 0;
var blockHelperMissing = {
  exports: {}
};
exports.b = blockHelperMissing;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/create-new-lookup-object.js":
/*!******************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/create-new-lookup-object.js ***!
  \******************************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.__exports = void 0;
var createNewLookupObject = {};
exports.__exports = createNewLookupObject;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/decorators.js":
/*!****************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/decorators.js ***!
  \****************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.__exports = void 0;
var decorators = {};
exports.__exports = decorators;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/each.js":
/*!**********************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/each.js ***!
  \**********************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.e = void 0;
var each = {
  exports: {}
};
exports.e = each;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/exception.js":
/*!***************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/exception.js ***!
  \***************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.e = void 0;
var exception = {
  exports: {}
};
exports.e = exception;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/handlebars.runtime.js":
/*!************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/handlebars.runtime.js ***!
  \************************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.h = void 0;
var handlebars_runtime = {
  exports: {}
};
exports.h = handlebars_runtime;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/helper-missing.js":
/*!********************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/helper-missing.js ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.h = void 0;
var helperMissing = {
  exports: {}
};
exports.h = helperMissing;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/helpers.js":
/*!*************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/helpers.js ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.__exports = void 0;
var helpers = {};
exports.__exports = helpers;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/if.js":
/*!********************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/if.js ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports._ = void 0;
var _if = {
  exports: {}
};
exports._ = _if;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/inline.js":
/*!************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/inline.js ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.i = void 0;
var inline = {
  exports: {}
};
exports.i = inline;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/js.cookie.js":
/*!***************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/js.cookie.js ***!
  \***************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.j = void 0;
var js_cookie = {
  exports: {}
};
exports.j = js_cookie;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/log.js":
/*!*********************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/log.js ***!
  \*********************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.l = void 0;
var log = {
  exports: {}
};
exports.l = log;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/logger.js":
/*!************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/logger.js ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.l = void 0;
var logger = {
  exports: {}
};
exports.l = logger;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/lookup.js":
/*!************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/lookup.js ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.l = void 0;
var lookup = {
  exports: {}
};
exports.l = lookup;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/no-conflict.js":
/*!*****************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/no-conflict.js ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.n = void 0;
var noConflict = {
  exports: {}
};
exports.n = noConflict;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/proto-access.js":
/*!******************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/proto-access.js ***!
  \******************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.__exports = void 0;
var protoAccess = {};
exports.__exports = protoAccess;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/runtime.js":
/*!*************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/runtime.js ***!
  \*************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.__exports = void 0;
var runtime = {};
exports.__exports = runtime;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/safe-string.js":
/*!*****************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/safe-string.js ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.s = void 0;
var safeString = {
  exports: {}
};
exports.s = safeString;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/underscore-min.js":
/*!********************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/underscore-min.js ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.u = void 0;
var underscoreMin = {
  exports: {}
};
exports.u = underscoreMin;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/utils.js":
/*!***********************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/utils.js ***!
  \***********************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.__exports = void 0;
var utils = {};
exports.__exports = utils;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/with.js":
/*!**********************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/with.js ***!
  \**********************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports._ = void 0;
var _with = {
  exports: {}
};
exports._ = _with;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/_virtual/wrapHelper.js":
/*!****************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/_virtual/wrapHelper.js ***!
  \****************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.__exports = void 0;
var wrapHelper = {};
exports.__exports = wrapHelper;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js":
/*!***************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js ***!
  \***************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _commonjsHelpers = __webpack_require__(/*! ../../../../_virtual/_commonjsHelpers.js */ "./packages/@okta/courage-dist/esm/_virtual/_commonjsHelpers.js");
var _handlebarsRuntime2 = __webpack_require__(/*! ../../../../_virtual/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/_virtual/handlebars.runtime.js");
__webpack_require__(/*! ./handlebars/base.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/base.js");
__webpack_require__(/*! ./handlebars/safe-string.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/safe-string.js");
__webpack_require__(/*! ./handlebars/exception.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/exception.js");
__webpack_require__(/*! ./handlebars/utils.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/utils.js");
__webpack_require__(/*! ./handlebars/runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/runtime.js");
__webpack_require__(/*! ./handlebars/no-conflict.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/no-conflict.js");
var _base2 = __webpack_require__(/*! ../../../../_virtual/base.js */ "./packages/@okta/courage-dist/esm/_virtual/base.js");
var _utils2 = __webpack_require__(/*! ../../../../_virtual/utils.js */ "./packages/@okta/courage-dist/esm/_virtual/utils.js");
var _runtime2 = __webpack_require__(/*! ../../../../_virtual/runtime.js */ "./packages/@okta/courage-dist/esm/_virtual/runtime.js");
var _exception2 = __webpack_require__(/*! ../../../../_virtual/exception.js */ "./packages/@okta/courage-dist/esm/_virtual/exception.js");
var _noConflict2 = __webpack_require__(/*! ../../../../_virtual/no-conflict.js */ "./packages/@okta/courage-dist/esm/_virtual/no-conflict.js");
var _safeString2 = __webpack_require__(/*! ../../../../_virtual/safe-string.js */ "./packages/@okta/courage-dist/esm/_virtual/safe-string.js");
(function (module, exports) {
  exports.__esModule = true; // istanbul ignore next

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  } // istanbul ignore next

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }
      newObj['default'] = obj;
      return newObj;
    }
  }
  var _handlebarsBase = _base2.__exports;
  var base$1 = _interopRequireWildcard(_handlebarsBase); // Each of these augment the Handlebars object. No need to setup here.
  // (This is done to easily share code between commonjs and browse envs)

  var _handlebarsSafeString = _safeString2.s.exports;
  var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);
  var _handlebarsException = _exception2.e.exports;
  var _handlebarsException2 = _interopRequireDefault(_handlebarsException);
  var _handlebarsUtils = _utils2.__exports;
  var Utils = _interopRequireWildcard(_handlebarsUtils);
  var _handlebarsRuntime = _runtime2.__exports;
  var runtime$1 = _interopRequireWildcard(_handlebarsRuntime);
  var _handlebarsNoConflict = _noConflict2.n.exports;
  var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict); // For compatibility and usage outside of module systems, make the Handlebars object a namespace

  function create() {
    var hb = new base$1.HandlebarsEnvironment();
    Utils.extend(hb, base$1);
    hb.SafeString = _handlebarsSafeString2['default'];
    hb.Exception = _handlebarsException2['default'];
    hb.Utils = Utils;
    hb.escapeExpression = Utils.escapeExpression;
    hb.VM = runtime$1;
    hb.template = function (spec) {
      return runtime$1.template(spec, hb);
    };
    return hb;
  }
  var inst = create();
  inst.create = create;
  _handlebarsNoConflict2['default'](inst);
  inst['default'] = inst;
  exports['default'] = inst;
  module.exports = exports['default'];
})(_handlebarsRuntime2.h, _handlebarsRuntime2.h.exports);
var _Handlebars2 = /*@__PURE__*/(0, _commonjsHelpers.getDefaultExportFromCjs)(_handlebarsRuntime2.h.exports);
exports["default"] = _Handlebars2;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/base.js":
/*!************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/base.js ***!
  \************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function () {
    return _base.__exports;
  }
}));
var _base = __webpack_require__(/*! ../../../../../_virtual/base.js */ "./packages/@okta/courage-dist/esm/_virtual/base.js");
__webpack_require__(/*! ./utils.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/utils.js");
__webpack_require__(/*! ./exception.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/exception.js");
__webpack_require__(/*! ./helpers.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers.js");
__webpack_require__(/*! ./decorators.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/decorators.js");
__webpack_require__(/*! ./logger.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/logger.js");
__webpack_require__(/*! ./internal/proto-access.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/internal/proto-access.js");
var _utils3 = __webpack_require__(/*! ../../../../../_virtual/utils.js */ "./packages/@okta/courage-dist/esm/_virtual/utils.js");
var _protoAccess2 = __webpack_require__(/*! ../../../../../_virtual/proto-access.js */ "./packages/@okta/courage-dist/esm/_virtual/proto-access.js");
var _helpers3 = __webpack_require__(/*! ../../../../../_virtual/helpers.js */ "./packages/@okta/courage-dist/esm/_virtual/helpers.js");
var _decorators3 = __webpack_require__(/*! ../../../../../_virtual/decorators.js */ "./packages/@okta/courage-dist/esm/_virtual/decorators.js");
var _logger4 = __webpack_require__(/*! ../../../../../_virtual/logger.js */ "./packages/@okta/courage-dist/esm/_virtual/logger.js");
var _exception4 = __webpack_require__(/*! ../../../../../_virtual/exception.js */ "./packages/@okta/courage-dist/esm/_virtual/exception.js");
_base.__exports.__esModule = true;
_base.__exports.HandlebarsEnvironment = HandlebarsEnvironment; // istanbul ignore next

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var _utils = _utils3.__exports;
var _exception = _exception4.e.exports;
var _exception2 = _interopRequireDefault(_exception);
var _helpers = _helpers3.__exports;
var _decorators = _decorators3.__exports;
var _logger = _logger4.l.exports;
var _logger2 = _interopRequireDefault(_logger);
var _internalProtoAccess = _protoAccess2.__exports;
var VERSION = '4.7.7';
_base.__exports.VERSION = VERSION;
var COMPILER_REVISION = 8;
_base.__exports.COMPILER_REVISION = COMPILER_REVISION;
var LAST_COMPATIBLE_COMPILER_REVISION = 7;
_base.__exports.LAST_COMPATIBLE_COMPILER_REVISION = LAST_COMPATIBLE_COMPILER_REVISION;
var REVISION_CHANGES = {
  1: '<= 1.0.rc.2',
  // 1.0.rc.2 is actually rev2 but doesn't report it
  2: '== 1.0.0-rc.3',
  3: '== 1.0.0-rc.4',
  4: '== 1.x.x',
  5: '== 2.0.0-alpha.x',
  6: '>= 2.0.0-beta.1',
  7: '>= 4.0.0 <4.3.0',
  8: '>= 4.3.0'
};
_base.__exports.REVISION_CHANGES = REVISION_CHANGES;
var objectType = '[object Object]';
function HandlebarsEnvironment(helpers, partials, decorators) {
  this.helpers = helpers || {};
  this.partials = partials || {};
  this.decorators = decorators || {};
  _helpers.registerDefaultHelpers(this);
  _decorators.registerDefaultDecorators(this);
}
HandlebarsEnvironment.prototype = {
  constructor: HandlebarsEnvironment,
  logger: _logger2['default'],
  log: _logger2['default'].log,
  registerHelper: function registerHelper(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple helpers');
      }
      _utils.extend(this.helpers, name);
    } else {
      this.helpers[name] = fn;
    }
  },
  unregisterHelper: function unregisterHelper(name) {
    delete this.helpers[name];
  },
  registerPartial: function registerPartial(name, partial) {
    if (_utils.toString.call(name) === objectType) {
      _utils.extend(this.partials, name);
    } else {
      if (typeof partial === 'undefined') {
        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
      }
      this.partials[name] = partial;
    }
  },
  unregisterPartial: function unregisterPartial(name) {
    delete this.partials[name];
  },
  registerDecorator: function registerDecorator(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple decorators');
      }
      _utils.extend(this.decorators, name);
    } else {
      this.decorators[name] = fn;
    }
  },
  unregisterDecorator: function unregisterDecorator(name) {
    delete this.decorators[name];
  },
  /**
   * Reset the memory of illegal property accesses that have already been logged.
   * @deprecated should only be used in handlebars test-cases
   */
  resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
    _internalProtoAccess.resetLoggedProperties();
  }
};
var log = _logger2['default'].log;
_base.__exports.log = log;
_base.__exports.createFrame = _utils.createFrame;
_base.__exports.logger = _logger2['default'];
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/decorators.js":
/*!******************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/decorators.js ***!
  \******************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function () {
    return _decorators.__exports;
  }
}));
var _decorators = __webpack_require__(/*! ../../../../../_virtual/decorators.js */ "./packages/@okta/courage-dist/esm/_virtual/decorators.js");
__webpack_require__(/*! ./decorators/inline.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/decorators/inline.js");
var _inline2 = __webpack_require__(/*! ../../../../../_virtual/inline.js */ "./packages/@okta/courage-dist/esm/_virtual/inline.js");
_decorators.__exports.__esModule = true;
_decorators.__exports.registerDefaultDecorators = registerDefaultDecorators; // istanbul ignore next

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var _decoratorsInline = _inline2.i.exports;
var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);
function registerDefaultDecorators(instance) {
  _decoratorsInline2['default'](instance);
}
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/decorators/inline.js":
/*!*************************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/decorators/inline.js ***!
  \*************************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _inline = __webpack_require__(/*! ../../../../../../_virtual/inline.js */ "./packages/@okta/courage-dist/esm/_virtual/inline.js");
__webpack_require__(/*! ../utils.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/utils.js");
var _utils3 = __webpack_require__(/*! ../../../../../../_virtual/utils.js */ "./packages/@okta/courage-dist/esm/_virtual/utils.js");
(function (module, exports) {
  exports.__esModule = true;
  var _utils = _utils3.__exports;
  exports['default'] = function (instance) {
    instance.registerDecorator('inline', function (fn, props, container, options) {
      var ret = fn;
      if (!props.partials) {
        props.partials = {};
        ret = function (context, options) {
          // Create a new partials stack frame prior to exec.
          var original = container.partials;
          container.partials = _utils.extend({}, original, props.partials);
          var ret = fn(context, options);
          container.partials = original;
          return ret;
        };
      }
      props.partials[options.args[0]] = options.fn;
      return ret;
    });
  };
  module.exports = exports['default'];
})(_inline.i, _inline.i.exports);

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/exception.js":
/*!*****************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/exception.js ***!
  \*****************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _exception = __webpack_require__(/*! ../../../../../_virtual/exception.js */ "./packages/@okta/courage-dist/esm/_virtual/exception.js");
(function (module, exports) {
  exports.__esModule = true;
  var errorProps = ['description', 'fileName', 'lineNumber', 'endLineNumber', 'message', 'name', 'number', 'stack'];
  function Exception(message, node) {
    var loc = node && node.loc,
      line = undefined,
      endLineNumber = undefined,
      column = undefined,
      endColumn = undefined;
    if (loc) {
      line = loc.start.line;
      endLineNumber = loc.end.line;
      column = loc.start.column;
      endColumn = loc.end.column;
      message += ' - ' + line + ':' + column;
    }
    var tmp = Error.prototype.constructor.call(this, message); // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.

    for (var idx = 0; idx < errorProps.length; idx++) {
      this[errorProps[idx]] = tmp[errorProps[idx]];
    }
    /* istanbul ignore else */

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, Exception);
    }
    try {
      if (loc) {
        this.lineNumber = line;
        this.endLineNumber = endLineNumber; // Work around issue under safari where we can't directly set the column value

        /* istanbul ignore next */

        if (Object.defineProperty) {
          Object.defineProperty(this, 'column', {
            value: column,
            enumerable: true
          });
          Object.defineProperty(this, 'endColumn', {
            value: endColumn,
            enumerable: true
          });
        } else {
          this.column = column;
          this.endColumn = endColumn;
        }
      }
    } catch (nop) {
      /* Ignore if the browser is very particular */
    }
  }
  Exception.prototype = new Error();
  exports['default'] = Exception;
  module.exports = exports['default'];
})(_exception.e, _exception.e.exports);

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers.js":
/*!***************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers.js ***!
  \***************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function () {
    return _helpers.__exports;
  }
}));
var _helpers = __webpack_require__(/*! ../../../../../_virtual/helpers.js */ "./packages/@okta/courage-dist/esm/_virtual/helpers.js");
__webpack_require__(/*! ./helpers/block-helper-missing.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/block-helper-missing.js");
__webpack_require__(/*! ./helpers/each.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/each.js");
__webpack_require__(/*! ./helpers/helper-missing.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/helper-missing.js");
__webpack_require__(/*! ./helpers/if.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/if.js");
__webpack_require__(/*! ./helpers/log.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/log.js");
__webpack_require__(/*! ./helpers/lookup.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/lookup.js");
__webpack_require__(/*! ./helpers/with.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/with.js");
var _each2 = __webpack_require__(/*! ../../../../../_virtual/each.js */ "./packages/@okta/courage-dist/esm/_virtual/each.js");
var _helperMissing2 = __webpack_require__(/*! ../../../../../_virtual/helper-missing.js */ "./packages/@okta/courage-dist/esm/_virtual/helper-missing.js");
var _if3 = __webpack_require__(/*! ../../../../../_virtual/if.js */ "./packages/@okta/courage-dist/esm/_virtual/if.js");
var _log2 = __webpack_require__(/*! ../../../../../_virtual/log.js */ "./packages/@okta/courage-dist/esm/_virtual/log.js");
var _lookup2 = __webpack_require__(/*! ../../../../../_virtual/lookup.js */ "./packages/@okta/courage-dist/esm/_virtual/lookup.js");
var _with3 = __webpack_require__(/*! ../../../../../_virtual/with.js */ "./packages/@okta/courage-dist/esm/_virtual/with.js");
var _blockHelperMissing2 = __webpack_require__(/*! ../../../../../_virtual/block-helper-missing.js */ "./packages/@okta/courage-dist/esm/_virtual/block-helper-missing.js");
_helpers.__exports.__esModule = true;
_helpers.__exports.registerDefaultHelpers = registerDefaultHelpers;
_helpers.__exports.moveHelperToHooks = moveHelperToHooks; // istanbul ignore next

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var _helpersBlockHelperMissing = _blockHelperMissing2.b.exports;
var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);
var _helpersEach = _each2.e.exports;
var _helpersEach2 = _interopRequireDefault(_helpersEach);
var _helpersHelperMissing = _helperMissing2.h.exports;
var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);
var _helpersIf = _if3._.exports;
var _helpersIf2 = _interopRequireDefault(_helpersIf);
var _helpersLog = _log2.l.exports;
var _helpersLog2 = _interopRequireDefault(_helpersLog);
var _helpersLookup = _lookup2.l.exports;
var _helpersLookup2 = _interopRequireDefault(_helpersLookup);
var _helpersWith = _with3._.exports;
var _helpersWith2 = _interopRequireDefault(_helpersWith);
function registerDefaultHelpers(instance) {
  _helpersBlockHelperMissing2['default'](instance);
  _helpersEach2['default'](instance);
  _helpersHelperMissing2['default'](instance);
  _helpersIf2['default'](instance);
  _helpersLog2['default'](instance);
  _helpersLookup2['default'](instance);
  _helpersWith2['default'](instance);
}
function moveHelperToHooks(instance, helperName, keepHelper) {
  if (instance.helpers[helperName]) {
    instance.hooks[helperName] = instance.helpers[helperName];
    if (!keepHelper) {
      delete instance.helpers[helperName];
    }
  }
}
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/block-helper-missing.js":
/*!************************************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/block-helper-missing.js ***!
  \************************************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _blockHelperMissing = __webpack_require__(/*! ../../../../../../_virtual/block-helper-missing.js */ "./packages/@okta/courage-dist/esm/_virtual/block-helper-missing.js");
__webpack_require__(/*! ../utils.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/utils.js");
var _utils3 = __webpack_require__(/*! ../../../../../../_virtual/utils.js */ "./packages/@okta/courage-dist/esm/_virtual/utils.js");
(function (module, exports) {
  exports.__esModule = true;
  var _utils = _utils3.__exports;
  exports['default'] = function (instance) {
    instance.registerHelper('blockHelperMissing', function (context, options) {
      var inverse = options.inverse,
        fn = options.fn;
      if (context === true) {
        return fn(this);
      } else if (context === false || context == null) {
        return inverse(this);
      } else if (_utils.isArray(context)) {
        if (context.length > 0) {
          if (options.ids) {
            options.ids = [options.name];
          }
          return instance.helpers.each(context, options);
        } else {
          return inverse(this);
        }
      } else {
        if (options.data && options.ids) {
          var data = _utils.createFrame(options.data);
          data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
          options = {
            data: data
          };
        }
        return fn(context, options);
      }
    });
  };
  module.exports = exports['default'];
})(_blockHelperMissing.b, _blockHelperMissing.b.exports);

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/each.js":
/*!********************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/each.js ***!
  \********************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _commonjsHelpers = __webpack_require__(/*! ../../../../../../_virtual/_commonjsHelpers.js */ "./packages/@okta/courage-dist/esm/_virtual/_commonjsHelpers.js");
var _each = __webpack_require__(/*! ../../../../../../_virtual/each.js */ "./packages/@okta/courage-dist/esm/_virtual/each.js");
__webpack_require__(/*! ../utils.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/utils.js");
__webpack_require__(/*! ../exception.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/exception.js");
var _utils3 = __webpack_require__(/*! ../../../../../../_virtual/utils.js */ "./packages/@okta/courage-dist/esm/_virtual/utils.js");
var _exception4 = __webpack_require__(/*! ../../../../../../_virtual/exception.js */ "./packages/@okta/courage-dist/esm/_virtual/exception.js");
(function (module, exports) {
  exports.__esModule = true; // istanbul ignore next

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }
  var _utils = _utils3.__exports;
  var _exception = _exception4.e.exports;
  var _exception2 = _interopRequireDefault(_exception);
  exports['default'] = function (instance) {
    instance.registerHelper('each', function (context, options) {
      if (!options) {
        throw new _exception2['default']('Must pass iterator to #each');
      }
      var fn = options.fn,
        inverse = options.inverse,
        i = 0,
        ret = '',
        data = undefined,
        contextPath = undefined;
      if (options.data && options.ids) {
        contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
      }
      if (_utils.isFunction(context)) {
        context = context.call(this);
      }
      if (options.data) {
        data = _utils.createFrame(options.data);
      }
      function execIteration(field, index, last) {
        if (data) {
          data.key = field;
          data.index = index;
          data.first = index === 0;
          data.last = !!last;
          if (contextPath) {
            data.contextPath = contextPath + field;
          }
        }
        ret = ret + fn(context[field], {
          data: data,
          blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
        });
      }
      if (context && typeof context === 'object') {
        if (_utils.isArray(context)) {
          for (var j = context.length; i < j; i++) {
            if (i in context) {
              execIteration(i, i, i === context.length - 1);
            }
          }
        } else if (_commonjsHelpers.commonjsGlobal.Symbol && context[_commonjsHelpers.commonjsGlobal.Symbol.iterator]) {
          var newContext = [];
          var iterator = context[_commonjsHelpers.commonjsGlobal.Symbol.iterator]();
          for (var it = iterator.next(); !it.done; it = iterator.next()) {
            newContext.push(it.value);
          }
          context = newContext;
          for (var j = context.length; i < j; i++) {
            execIteration(i, i, i === context.length - 1);
          }
        } else {
          (function () {
            var priorKey = undefined;
            Object.keys(context).forEach(function (key) {
              // We're running the iterations one step out of sync so we can detect
              // the last iteration without have to scan the object twice and create
              // an itermediate keys array.
              if (priorKey !== undefined) {
                execIteration(priorKey, i - 1);
              }
              priorKey = key;
              i++;
            });
            if (priorKey !== undefined) {
              execIteration(priorKey, i - 1, true);
            }
          })();
        }
      }
      if (i === 0) {
        ret = inverse(this);
      }
      return ret;
    });
  };
  module.exports = exports['default'];
})(_each.e, _each.e.exports);

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/helper-missing.js":
/*!******************************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/helper-missing.js ***!
  \******************************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _helperMissing = __webpack_require__(/*! ../../../../../../_virtual/helper-missing.js */ "./packages/@okta/courage-dist/esm/_virtual/helper-missing.js");
__webpack_require__(/*! ../exception.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/exception.js");
var _exception4 = __webpack_require__(/*! ../../../../../../_virtual/exception.js */ "./packages/@okta/courage-dist/esm/_virtual/exception.js");
(function (module, exports) {
  exports.__esModule = true; // istanbul ignore next

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }
  var _exception = _exception4.e.exports;
  var _exception2 = _interopRequireDefault(_exception);
  exports['default'] = function (instance) {
    instance.registerHelper('helperMissing', function () /* [args, ]options */
    {
      if (arguments.length === 1) {
        // A missing field in a {{foo}} construct.
        return undefined;
      } else {
        // Someone is actually trying to call something, blow up.
        throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
      }
    });
  };
  module.exports = exports['default'];
})(_helperMissing.h, _helperMissing.h.exports);

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/if.js":
/*!******************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/if.js ***!
  \******************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _if2 = __webpack_require__(/*! ../../../../../../_virtual/if.js */ "./packages/@okta/courage-dist/esm/_virtual/if.js");
__webpack_require__(/*! ../utils.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/utils.js");
__webpack_require__(/*! ../exception.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/exception.js");
var _utils3 = __webpack_require__(/*! ../../../../../../_virtual/utils.js */ "./packages/@okta/courage-dist/esm/_virtual/utils.js");
var _exception4 = __webpack_require__(/*! ../../../../../../_virtual/exception.js */ "./packages/@okta/courage-dist/esm/_virtual/exception.js");
(function (module, exports) {
  exports.__esModule = true; // istanbul ignore next

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }
  var _utils = _utils3.__exports;
  var _exception = _exception4.e.exports;
  var _exception2 = _interopRequireDefault(_exception);
  exports['default'] = function (instance) {
    instance.registerHelper('if', function (conditional, options) {
      if (arguments.length != 2) {
        throw new _exception2['default']('#if requires exactly one argument');
      }
      if (_utils.isFunction(conditional)) {
        conditional = conditional.call(this);
      } // Default behavior is to render the positive path if the value is truthy and not empty.
      // The `includeZero` option may be set to treat the condtional as purely not empty based on the
      // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.

      if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
        return options.inverse(this);
      } else {
        return options.fn(this);
      }
    });
    instance.registerHelper('unless', function (conditional, options) {
      if (arguments.length != 2) {
        throw new _exception2['default']('#unless requires exactly one argument');
      }
      return instance.helpers['if'].call(this, conditional, {
        fn: options.inverse,
        inverse: options.fn,
        hash: options.hash
      });
    });
  };
  module.exports = exports['default'];
})(_if2._, _if2._.exports);

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/log.js":
/*!*******************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/log.js ***!
  \*******************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _log = __webpack_require__(/*! ../../../../../../_virtual/log.js */ "./packages/@okta/courage-dist/esm/_virtual/log.js");
(function (module, exports) {
  exports.__esModule = true;
  exports['default'] = function (instance) {
    instance.registerHelper('log', function () /* message, options */
    {
      var args = [undefined],
        options = arguments[arguments.length - 1];
      for (var i = 0; i < arguments.length - 1; i++) {
        args.push(arguments[i]);
      }
      var level = 1;
      if (options.hash.level != null) {
        level = options.hash.level;
      } else if (options.data && options.data.level != null) {
        level = options.data.level;
      }
      args[0] = level;
      instance.log.apply(instance, args);
    });
  };
  module.exports = exports['default'];
})(_log.l, _log.l.exports);

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/lookup.js":
/*!**********************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/lookup.js ***!
  \**********************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _lookup = __webpack_require__(/*! ../../../../../../_virtual/lookup.js */ "./packages/@okta/courage-dist/esm/_virtual/lookup.js");
(function (module, exports) {
  exports.__esModule = true;
  exports['default'] = function (instance) {
    instance.registerHelper('lookup', function (obj, field, options) {
      if (!obj) {
        // Note for 5.0: Change to "obj == null" in 5.0
        return obj;
      }
      return options.lookupProperty(obj, field);
    });
  };
  module.exports = exports['default'];
})(_lookup.l, _lookup.l.exports);

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/with.js":
/*!********************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers/with.js ***!
  \********************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _with2 = __webpack_require__(/*! ../../../../../../_virtual/with.js */ "./packages/@okta/courage-dist/esm/_virtual/with.js");
__webpack_require__(/*! ../utils.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/utils.js");
__webpack_require__(/*! ../exception.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/exception.js");
var _utils3 = __webpack_require__(/*! ../../../../../../_virtual/utils.js */ "./packages/@okta/courage-dist/esm/_virtual/utils.js");
var _exception4 = __webpack_require__(/*! ../../../../../../_virtual/exception.js */ "./packages/@okta/courage-dist/esm/_virtual/exception.js");
(function (module, exports) {
  exports.__esModule = true; // istanbul ignore next

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }
  var _utils = _utils3.__exports;
  var _exception = _exception4.e.exports;
  var _exception2 = _interopRequireDefault(_exception);
  exports['default'] = function (instance) {
    instance.registerHelper('with', function (context, options) {
      if (arguments.length != 2) {
        throw new _exception2['default']('#with requires exactly one argument');
      }
      if (_utils.isFunction(context)) {
        context = context.call(this);
      }
      var fn = options.fn;
      if (!_utils.isEmpty(context)) {
        var data = options.data;
        if (options.data && options.ids) {
          data = _utils.createFrame(options.data);
          data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
        }
        return fn(context, {
          data: data,
          blockParams: _utils.blockParams([context], [data && data.contextPath])
        });
      } else {
        return options.inverse(this);
      }
    });
  };
  module.exports = exports['default'];
})(_with2._, _with2._.exports);

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/internal/create-new-lookup-object.js":
/*!*****************************************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/internal/create-new-lookup-object.js ***!
  \*****************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function () {
    return _createNewLookupObject.__exports;
  }
}));
var _createNewLookupObject = __webpack_require__(/*! ../../../../../../_virtual/create-new-lookup-object.js */ "./packages/@okta/courage-dist/esm/_virtual/create-new-lookup-object.js");
__webpack_require__(/*! ../utils.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/utils.js");
var _utils3 = __webpack_require__(/*! ../../../../../../_virtual/utils.js */ "./packages/@okta/courage-dist/esm/_virtual/utils.js");
_createNewLookupObject.__exports.__esModule = true;
_createNewLookupObject.__exports.createNewLookupObject = createNewLookupObject;
var _utils = _utils3.__exports;
/**
 * Create a new object with "null"-prototype to avoid truthy results on prototype properties.
 * The resulting object can be used with "object[property]" to check if a property exists
 * @param {...object} sources a varargs parameter of source objects that will be merged
 * @returns {object}
 */

function createNewLookupObject() {
  for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }
  return _utils.extend.apply(undefined, [Object.create(null)].concat(sources));
}
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/internal/proto-access.js":
/*!*****************************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/internal/proto-access.js ***!
  \*****************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function () {
    return _protoAccess.__exports;
  }
}));
var _protoAccess = __webpack_require__(/*! ../../../../../../_virtual/proto-access.js */ "./packages/@okta/courage-dist/esm/_virtual/proto-access.js");
__webpack_require__(/*! ./create-new-lookup-object.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/internal/create-new-lookup-object.js");
__webpack_require__(/*! ../logger.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/logger.js");
var _createNewLookupObject3 = __webpack_require__(/*! ../../../../../../_virtual/create-new-lookup-object.js */ "./packages/@okta/courage-dist/esm/_virtual/create-new-lookup-object.js");
var _logger3 = __webpack_require__(/*! ../../../../../../_virtual/logger.js */ "./packages/@okta/courage-dist/esm/_virtual/logger.js");
_protoAccess.__exports.__esModule = true;
_protoAccess.__exports.createProtoAccessControl = createProtoAccessControl;
_protoAccess.__exports.resultIsAllowed = resultIsAllowed;
_protoAccess.__exports.resetLoggedProperties = resetLoggedProperties; // istanbul ignore next

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj['default'] = obj;
    return newObj;
  }
}
var _createNewLookupObject = _createNewLookupObject3.__exports;
var _logger = _logger3.l.exports;
var logger = _interopRequireWildcard(_logger);
var loggedProperties = Object.create(null);
function createProtoAccessControl(runtimeOptions) {
  var defaultMethodWhiteList = Object.create(null);
  defaultMethodWhiteList['constructor'] = false;
  defaultMethodWhiteList['__defineGetter__'] = false;
  defaultMethodWhiteList['__defineSetter__'] = false;
  defaultMethodWhiteList['__lookupGetter__'] = false;
  var defaultPropertyWhiteList = Object.create(null); // eslint-disable-next-line no-proto

  defaultPropertyWhiteList['__proto__'] = false;
  return {
    properties: {
      whitelist: _createNewLookupObject.createNewLookupObject(defaultPropertyWhiteList, runtimeOptions.allowedProtoProperties),
      defaultValue: runtimeOptions.allowProtoPropertiesByDefault
    },
    methods: {
      whitelist: _createNewLookupObject.createNewLookupObject(defaultMethodWhiteList, runtimeOptions.allowedProtoMethods),
      defaultValue: runtimeOptions.allowProtoMethodsByDefault
    }
  };
}
function resultIsAllowed(result, protoAccessControl, propertyName) {
  if (typeof result === 'function') {
    return checkWhiteList(protoAccessControl.methods, propertyName);
  } else {
    return checkWhiteList(protoAccessControl.properties, propertyName);
  }
}
function checkWhiteList(protoAccessControlForType, propertyName) {
  if (protoAccessControlForType.whitelist[propertyName] !== undefined) {
    return protoAccessControlForType.whitelist[propertyName] === true;
  }
  if (protoAccessControlForType.defaultValue !== undefined) {
    return protoAccessControlForType.defaultValue;
  }
  logUnexpecedPropertyAccessOnce(propertyName);
  return false;
}
function logUnexpecedPropertyAccessOnce(propertyName) {
  if (loggedProperties[propertyName] !== true) {
    loggedProperties[propertyName] = true;
    logger.log('error', 'Handlebars: Access has been denied to resolve the property "' + propertyName + '" because it is not an "own property" of its parent.\n' + 'You can add a runtime option to disable the check or this warning:\n' + 'See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details');
  }
}
function resetLoggedProperties() {
  Object.keys(loggedProperties).forEach(function (propertyName) {
    delete loggedProperties[propertyName];
  });
}
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/internal/wrapHelper.js":
/*!***************************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/internal/wrapHelper.js ***!
  \***************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function () {
    return _wrapHelper.__exports;
  }
}));
var _wrapHelper = __webpack_require__(/*! ../../../../../../_virtual/wrapHelper.js */ "./packages/@okta/courage-dist/esm/_virtual/wrapHelper.js");
_wrapHelper.__exports.__esModule = true;
_wrapHelper.__exports.wrapHelper = wrapHelper;
function wrapHelper(helper, transformOptionsFn) {
  if (typeof helper !== 'function') {
    // This should not happen, but apparently it does in https://github.com/wycats/handlebars.js/issues/1639
    // We try to make the wrapper least-invasive by not wrapping it, if the helper is not a function.
    return helper;
  }
  var wrapper = function wrapper() /* dynamic arguments */
  {
    var options = arguments[arguments.length - 1];
    arguments[arguments.length - 1] = transformOptionsFn(options);
    return helper.apply(this, arguments);
  };
  return wrapper;
}
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/logger.js":
/*!**************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/logger.js ***!
  \**************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _logger = __webpack_require__(/*! ../../../../../_virtual/logger.js */ "./packages/@okta/courage-dist/esm/_virtual/logger.js");
__webpack_require__(/*! ./utils.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/utils.js");
var _utils3 = __webpack_require__(/*! ../../../../../_virtual/utils.js */ "./packages/@okta/courage-dist/esm/_virtual/utils.js");
(function (module, exports) {
  exports.__esModule = true;
  var _utils = _utils3.__exports;
  var logger = {
    methodMap: ['debug', 'info', 'warn', 'error'],
    level: 'info',
    // Maps a given level value to the `methodMap` indexes above.
    lookupLevel: function lookupLevel(level) {
      if (typeof level === 'string') {
        var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
        if (levelMap >= 0) {
          level = levelMap;
        } else {
          level = parseInt(level, 10);
        }
      }
      return level;
    },
    // Can be overridden in the host environment
    log: function log(level) {
      level = logger.lookupLevel(level);
      if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
        var method = logger.methodMap[level]; // eslint-disable-next-line no-console

        if (!console[method]) {
          method = 'log';
        }
        for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          message[_key - 1] = arguments[_key];
        }
        console[method].apply(console, message); // eslint-disable-line no-console
      }
    }
  };

  exports['default'] = logger;
  module.exports = exports['default'];
})(_logger.l, _logger.l.exports);

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/no-conflict.js":
/*!*******************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/no-conflict.js ***!
  \*******************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _commonjsHelpers = __webpack_require__(/*! ../../../../../_virtual/_commonjsHelpers.js */ "./packages/@okta/courage-dist/esm/_virtual/_commonjsHelpers.js");
var _noConflict = __webpack_require__(/*! ../../../../../_virtual/no-conflict.js */ "./packages/@okta/courage-dist/esm/_virtual/no-conflict.js");
(function (module, exports) {
  exports.__esModule = true;
  exports['default'] = function (Handlebars) {
    /* istanbul ignore next */
    var root = typeof _commonjsHelpers.commonjsGlobal !== 'undefined' ? _commonjsHelpers.commonjsGlobal : window,
      $Handlebars = root.Handlebars;
    /* istanbul ignore next */

    Handlebars.noConflict = function () {
      if (root.Handlebars === Handlebars) {
        root.Handlebars = $Handlebars;
      }
      return Handlebars;
    };
  };
  module.exports = exports['default'];
})(_noConflict.n, _noConflict.n.exports);

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/runtime.js":
/*!***************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/runtime.js ***!
  \***************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function () {
    return _runtime.__exports;
  }
}));
var _runtime = __webpack_require__(/*! ../../../../../_virtual/runtime.js */ "./packages/@okta/courage-dist/esm/_virtual/runtime.js");
__webpack_require__(/*! ./utils.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/utils.js");
__webpack_require__(/*! ./exception.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/exception.js");
__webpack_require__(/*! ./base.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/base.js");
__webpack_require__(/*! ./helpers.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/helpers.js");
__webpack_require__(/*! ./internal/wrapHelper.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/internal/wrapHelper.js");
__webpack_require__(/*! ./internal/proto-access.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/internal/proto-access.js");
var _utils3 = __webpack_require__(/*! ../../../../../_virtual/utils.js */ "./packages/@okta/courage-dist/esm/_virtual/utils.js");
var _base3 = __webpack_require__(/*! ../../../../../_virtual/base.js */ "./packages/@okta/courage-dist/esm/_virtual/base.js");
var _protoAccess2 = __webpack_require__(/*! ../../../../../_virtual/proto-access.js */ "./packages/@okta/courage-dist/esm/_virtual/proto-access.js");
var _helpers3 = __webpack_require__(/*! ../../../../../_virtual/helpers.js */ "./packages/@okta/courage-dist/esm/_virtual/helpers.js");
var _wrapHelper2 = __webpack_require__(/*! ../../../../../_virtual/wrapHelper.js */ "./packages/@okta/courage-dist/esm/_virtual/wrapHelper.js");
var _exception4 = __webpack_require__(/*! ../../../../../_virtual/exception.js */ "./packages/@okta/courage-dist/esm/_virtual/exception.js");
_runtime.__exports.__esModule = true;
_runtime.__exports.checkRevision = checkRevision;
_runtime.__exports.template = template;
_runtime.__exports.wrapProgram = wrapProgram;
_runtime.__exports.resolvePartial = resolvePartial;
_runtime.__exports.invokePartial = invokePartial;
_runtime.__exports.noop = noop; // istanbul ignore next

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
} // istanbul ignore next

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj['default'] = obj;
    return newObj;
  }
}
var _utils = _utils3.__exports;
var Utils = _interopRequireWildcard(_utils);
var _exception = _exception4.e.exports;
var _exception2 = _interopRequireDefault(_exception);
var _base = _base3.__exports;
var _helpers = _helpers3.__exports;
var _internalWrapHelper = _wrapHelper2.__exports;
var _internalProtoAccess = _protoAccess2.__exports;
function checkRevision(compilerInfo) {
  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
    currentRevision = _base.COMPILER_REVISION;
  if (compilerRevision >= _base.LAST_COMPATIBLE_COMPILER_REVISION && compilerRevision <= _base.COMPILER_REVISION) {
    return;
  }
  if (compilerRevision < _base.LAST_COMPATIBLE_COMPILER_REVISION) {
    var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
      compilerVersions = _base.REVISION_CHANGES[compilerRevision];
    throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
  } else {
    // Use the embedded version info since the runtime doesn't know about this revision yet
    throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
  }
}
function template(templateSpec, env) {
  /* istanbul ignore next */
  if (!env) {
    throw new _exception2['default']('No environment passed to template');
  }
  if (!templateSpec || !templateSpec.main) {
    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
  }
  templateSpec.main.decorator = templateSpec.main_d; // Note: Using env.VM references rather than local var references throughout this section to allow
  // for external users to override these as pseudo-supported APIs.

  env.VM.checkRevision(templateSpec.compiler); // backwards compatibility for precompiled templates with compiler-version 7 (<4.3.0)

  var templateWasPrecompiledWithCompilerV7 = templateSpec.compiler && templateSpec.compiler[0] === 7;
  function invokePartialWrapper(partial, context, options) {
    if (options.hash) {
      context = Utils.extend({}, context, options.hash);
      if (options.ids) {
        options.ids[0] = true;
      }
    }
    partial = env.VM.resolvePartial.call(this, partial, context, options);
    var extendedOptions = Utils.extend({}, options, {
      hooks: this.hooks,
      protoAccessControl: this.protoAccessControl
    });
    var result = env.VM.invokePartial.call(this, partial, context, extendedOptions);
    if (result == null && env.compile) {
      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
      result = options.partials[options.name](context, extendedOptions);
    }
    if (result != null) {
      if (options.indent) {
        var lines = result.split('\n');
        for (var i = 0, l = lines.length; i < l; i++) {
          if (!lines[i] && i + 1 === l) {
            break;
          }
          lines[i] = options.indent + lines[i];
        }
        result = lines.join('\n');
      }
      return result;
    } else {
      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
    }
  } // Just add water

  var container = {
    strict: function strict(obj, name, loc) {
      if (!obj || !(name in obj)) {
        throw new _exception2['default']('"' + name + '" not defined in ' + obj, {
          loc: loc
        });
      }
      return container.lookupProperty(obj, name);
    },
    lookupProperty: function lookupProperty(parent, propertyName) {
      var result = parent[propertyName];
      if (result == null) {
        return result;
      }
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return result;
      }
      if (_internalProtoAccess.resultIsAllowed(result, container.protoAccessControl, propertyName)) {
        return result;
      }
      return undefined;
    },
    lookup: function lookup(depths, name) {
      var len = depths.length;
      for (var i = 0; i < len; i++) {
        var result = depths[i] && container.lookupProperty(depths[i], name);
        if (result != null) {
          return depths[i][name];
        }
      }
    },
    lambda: function lambda(current, context) {
      return typeof current === 'function' ? current.call(context) : current;
    },
    escapeExpression: Utils.escapeExpression,
    invokePartial: invokePartialWrapper,
    fn: function fn(i) {
      var ret = templateSpec[i];
      ret.decorator = templateSpec[i + '_d'];
      return ret;
    },
    programs: [],
    program: function program(i, data, declaredBlockParams, blockParams, depths) {
      var programWrapper = this.programs[i],
        fn = this.fn(i);
      if (data || depths || blockParams || declaredBlockParams) {
        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
      } else if (!programWrapper) {
        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
      }
      return programWrapper;
    },
    data: function data(value, depth) {
      while (value && depth--) {
        value = value._parent;
      }
      return value;
    },
    mergeIfNeeded: function mergeIfNeeded(param, common) {
      var obj = param || common;
      if (param && common && param !== common) {
        obj = Utils.extend({}, common, param);
      }
      return obj;
    },
    // An empty object to use as replacement for null-contexts
    nullContext: Object.seal({}),
    noop: env.VM.noop,
    compilerInfo: templateSpec.compiler
  };
  function ret(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
    var data = options.data;
    ret._setup(options);
    if (!options.partial && templateSpec.useData) {
      data = initData(context, data);
    }
    var depths = undefined,
      blockParams = templateSpec.useBlockParams ? [] : undefined;
    if (templateSpec.useDepths) {
      if (options.depths) {
        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
      } else {
        depths = [context];
      }
    }
    function main(context
    /*, options*/) {
      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
    }
    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
    return main(context, options);
  }
  ret.isTop = true;
  ret._setup = function (options) {
    if (!options.partial) {
      var mergedHelpers = Utils.extend({}, env.helpers, options.helpers);
      wrapHelpersToPassLookupProperty(mergedHelpers, container);
      container.helpers = mergedHelpers;
      if (templateSpec.usePartial) {
        // Use mergeIfNeeded here to prevent compiling global partials multiple times
        container.partials = container.mergeIfNeeded(options.partials, env.partials);
      }
      if (templateSpec.usePartial || templateSpec.useDecorators) {
        container.decorators = Utils.extend({}, env.decorators, options.decorators);
      }
      container.hooks = {};
      container.protoAccessControl = _internalProtoAccess.createProtoAccessControl(options);
      var keepHelperInHelpers = options.allowCallsToHelperMissing || templateWasPrecompiledWithCompilerV7;
      _helpers.moveHelperToHooks(container, 'helperMissing', keepHelperInHelpers);
      _helpers.moveHelperToHooks(container, 'blockHelperMissing', keepHelperInHelpers);
    } else {
      container.protoAccessControl = options.protoAccessControl; // internal option

      container.helpers = options.helpers;
      container.partials = options.partials;
      container.decorators = options.decorators;
      container.hooks = options.hooks;
    }
  };
  ret._child = function (i, data, blockParams, depths) {
    if (templateSpec.useBlockParams && !blockParams) {
      throw new _exception2['default']('must pass block params');
    }
    if (templateSpec.useDepths && !depths) {
      throw new _exception2['default']('must pass parent depths');
    }
    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
  };
  return ret;
}
function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
  function prog(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
    var currentDepths = depths;
    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
      currentDepths = [context].concat(depths);
    }
    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
  }
  prog = executeDecorators(fn, prog, container, depths, data, blockParams);
  prog.program = i;
  prog.depth = depths ? depths.length : 0;
  prog.blockParams = declaredBlockParams || 0;
  return prog;
}
/**
 * This is currently part of the official API, therefore implementation details should not be changed.
 */

function resolvePartial(partial, context, options) {
  if (!partial) {
    if (options.name === '@partial-block') {
      partial = options.data['partial-block'];
    } else {
      partial = options.partials[options.name];
    }
  } else if (!partial.call && !options.name) {
    // This is a dynamic partial that returned a string
    options.name = partial;
    partial = options.partials[partial];
  }
  return partial;
}
function invokePartial(partial, context, options) {
  // Use the current closure context to save the partial-block if this partial
  var currentPartialBlock = options.data && options.data['partial-block'];
  options.partial = true;
  if (options.ids) {
    options.data.contextPath = options.ids[0] || options.data.contextPath;
  }
  var partialBlock = undefined;
  if (options.fn && options.fn !== noop) {
    (function () {
      options.data = _base.createFrame(options.data); // Wrapper function to get access to currentPartialBlock from the closure

      var fn = options.fn;
      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1]; // Restore the partial-block from the closure for the execution of the block
        // i.e. the part inside the block of the partial call.

        options.data = _base.createFrame(options.data);
        options.data['partial-block'] = currentPartialBlock;
        return fn(context, options);
      };
      if (fn.partials) {
        options.partials = Utils.extend({}, options.partials, fn.partials);
      }
    })();
  }
  if (partial === undefined && partialBlock) {
    partial = partialBlock;
  }
  if (partial === undefined) {
    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
  } else if (partial instanceof Function) {
    return partial(context, options);
  }
}
function noop() {
  return '';
}
function initData(context, data) {
  if (!data || !('root' in data)) {
    data = data ? _base.createFrame(data) : {};
    data.root = context;
  }
  return data;
}
function executeDecorators(fn, prog, container, depths, data, blockParams) {
  if (fn.decorator) {
    var props = {};
    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
    Utils.extend(prog, props);
  }
  return prog;
}
function wrapHelpersToPassLookupProperty(mergedHelpers, container) {
  Object.keys(mergedHelpers).forEach(function (helperName) {
    var helper = mergedHelpers[helperName];
    mergedHelpers[helperName] = passLookupPropertyOption(helper, container);
  });
}
function passLookupPropertyOption(helper, container) {
  var lookupProperty = container.lookupProperty;
  return _internalWrapHelper.wrapHelper(helper, function (options) {
    return Utils.extend({
      lookupProperty: lookupProperty
    }, options);
  });
}
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/safe-string.js":
/*!*******************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/safe-string.js ***!
  \*******************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _safeString = __webpack_require__(/*! ../../../../../_virtual/safe-string.js */ "./packages/@okta/courage-dist/esm/_virtual/safe-string.js");
(function (module, exports) {
  exports.__esModule = true;
  function SafeString(string) {
    this.string = string;
  }
  SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
    return '' + this.string;
  };
  exports['default'] = SafeString;
  module.exports = exports['default'];
})(_safeString.s, _safeString.s.exports);

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/utils.js":
/*!*************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars/utils.js ***!
  \*************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function () {
    return _utils.__exports;
  }
}));
var _utils = __webpack_require__(/*! ../../../../../_virtual/utils.js */ "./packages/@okta/courage-dist/esm/_virtual/utils.js");
_utils.__exports.__esModule = true;
_utils.__exports.extend = extend;
_utils.__exports.indexOf = indexOf;
_utils.__exports.escapeExpression = escapeExpression;
_utils.__exports.isEmpty = isEmpty;
_utils.__exports.createFrame = createFrame;
_utils.__exports.blockParams = blockParams;
_utils.__exports.appendContextPath = appendContextPath;
var escape = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '=': '&#x3D;'
};
var badChars = /[&<>"'`=]/g,
  possible = /[&<>"'`=]/;
function escapeChar(chr) {
  return escape[chr];
}
function extend(obj
/* , ...source */) {
  for (var i = 1; i < arguments.length; i++) {
    for (var key in arguments[i]) {
      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
        obj[key] = arguments[i][key];
      }
    }
  }
  return obj;
}
var toString = Object.prototype.toString;
_utils.__exports.toString = toString; // Sourced from lodash
// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt

/* eslint-disable func-style */

var isFunction = function isFunction(value) {
  return typeof value === 'function';
}; // fallback for older versions of Chrome and Safari

/* istanbul ignore next */

if (isFunction(/x/)) {
  _utils.__exports.isFunction = isFunction = function (value) {
    return typeof value === 'function' && toString.call(value) === '[object Function]';
  };
}
_utils.__exports.isFunction = isFunction;
/* eslint-enable func-style */

/* istanbul ignore next */

var isArray = Array.isArray || function (value) {
  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
};
_utils.__exports.isArray = isArray; // Older IE versions do not directly support indexOf so we must implement our own, sadly.

function indexOf(array, value) {
  for (var i = 0, len = array.length; i < len; i++) {
    if (array[i] === value) {
      return i;
    }
  }
  return -1;
}
function escapeExpression(string) {
  if (typeof string !== 'string') {
    // don't escape SafeStrings, since they're already safe
    if (string && string.toHTML) {
      return string.toHTML();
    } else if (string == null) {
      return '';
    } else if (!string) {
      return string + '';
    } // Force a string conversion as this will be done by the append regardless and
    // the regex test will do this transparently behind the scenes, causing issues if
    // an object's to string has escaped characters in it.

    string = '' + string;
  }
  if (!possible.test(string)) {
    return string;
  }
  return string.replace(badChars, escapeChar);
}
function isEmpty(value) {
  if (!value && value !== 0) {
    return true;
  } else if (isArray(value) && value.length === 0) {
    return true;
  } else {
    return false;
  }
}
function createFrame(object) {
  var frame = extend({}, object);
  frame._parent = object;
  return frame;
}
function blockParams(params, ids) {
  params.path = ids;
  return params;
}
function appendContextPath(contextPath, id) {
  return (contextPath ? contextPath + '.' : '') + id;
}
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/lib/underscore/underscore-min.js":
/*!**************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/lib/underscore/underscore-min.js ***!
  \**************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _commonjsHelpers = __webpack_require__(/*! ../../_virtual/_commonjsHelpers.js */ "./packages/@okta/courage-dist/esm/_virtual/_commonjsHelpers.js");
var _underscoreMin = __webpack_require__(/*! ../../_virtual/underscore-min.js */ "./packages/@okta/courage-dist/esm/_virtual/underscore-min.js");
(function (module, exports) {
  !function (n, r) {
    module.exports = r();
  }(_commonjsHelpers.commonjsGlobal, function () {
    //     Underscore.js 1.13.1
    //     https://underscorejs.org
    //     (c) 2009-2021 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
    //     Underscore may be freely distributed under the MIT license.
    var n = "1.13.1",
      r = "object" == typeof self && self.self === self && self || "object" == typeof _commonjsHelpers.commonjsGlobal && _commonjsHelpers.commonjsGlobal.global === _commonjsHelpers.commonjsGlobal && _commonjsHelpers.commonjsGlobal || Function("return this")() || {},
      t = Array.prototype,
      e = Object.prototype,
      u = "undefined" != typeof Symbol ? Symbol.prototype : null,
      o = t.push,
      i = t.slice,
      a = e.toString,
      f = e.hasOwnProperty,
      c = "undefined" != typeof ArrayBuffer,
      l = "undefined" != typeof DataView,
      s = Array.isArray,
      p = Object.keys,
      v = Object.create,
      h = c && ArrayBuffer.isView,
      y = isNaN,
      d = isFinite,
      g = !{
        toString: null
      }.propertyIsEnumerable("toString"),
      b = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
      m = Math.pow(2, 53) - 1;
    function j(n, r) {
      return r = null == r ? n.length - 1 : +r, function () {
        for (var t = Math.max(arguments.length - r, 0), e = Array(t), u = 0; u < t; u++) e[u] = arguments[u + r];
        switch (r) {
          case 0:
            return n.call(this, e);
          case 1:
            return n.call(this, arguments[0], e);
          case 2:
            return n.call(this, arguments[0], arguments[1], e);
        }
        var o = Array(r + 1);
        for (u = 0; u < r; u++) o[u] = arguments[u];
        return o[r] = e, n.apply(this, o);
      };
    }
    function _(n) {
      var r = typeof n;
      return "function" === r || "object" === r && !!n;
    }
    function w(n) {
      return void 0 === n;
    }
    function A(n) {
      return !0 === n || !1 === n || "[object Boolean]" === a.call(n);
    }
    function x(n) {
      var r = "[object " + n + "]";
      return function (n) {
        return a.call(n) === r;
      };
    }
    var S = x("String"),
      O = x("Number"),
      M = x("Date"),
      E = x("RegExp"),
      B = x("Error"),
      N = x("Symbol"),
      I = x("ArrayBuffer"),
      T = x("Function"),
      k = r.document && r.document.childNodes;
     true && "object" != typeof Int8Array && "function" != typeof k && (T = function (n) {
      return "function" == typeof n || !1;
    });
    var D = T,
      R = x("Object"),
      F = l && R(new DataView(new ArrayBuffer(8))),
      V = "undefined" != typeof Map && R(new Map()),
      P = x("DataView");
    var q = F ? function (n) {
        return null != n && D(n.getInt8) && I(n.buffer);
      } : P,
      U = s || x("Array");
    function W(n, r) {
      return null != n && f.call(n, r);
    }
    var z = x("Arguments");
    !function () {
      z(arguments) || (z = function (n) {
        return W(n, "callee");
      });
    }();
    var L = z;
    function $(n) {
      return O(n) && y(n);
    }
    function C(n) {
      return function () {
        return n;
      };
    }
    function K(n) {
      return function (r) {
        var t = n(r);
        return "number" == typeof t && t >= 0 && t <= m;
      };
    }
    function J(n) {
      return function (r) {
        return null == r ? void 0 : r[n];
      };
    }
    var G = J("byteLength"),
      H = K(G),
      Q = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
    var X = c ? function (n) {
        return h ? h(n) && !q(n) : H(n) && Q.test(a.call(n));
      } : C(!1),
      Y = J("length");
    function Z(n, r) {
      r = function (n) {
        for (var r = {}, t = n.length, e = 0; e < t; ++e) r[n[e]] = !0;
        return {
          contains: function (n) {
            return r[n];
          },
          push: function (t) {
            return r[t] = !0, n.push(t);
          }
        };
      }(r);
      var t = b.length,
        u = n.constructor,
        o = D(u) && u.prototype || e,
        i = "constructor";
      for (W(n, i) && !r.contains(i) && r.push(i); t--;) (i = b[t]) in n && n[i] !== o[i] && !r.contains(i) && r.push(i);
    }
    function nn(n) {
      if (!_(n)) return [];
      if (p) return p(n);
      var r = [];
      for (var t in n) W(n, t) && r.push(t);
      return g && Z(n, r), r;
    }
    function rn(n, r) {
      var t = nn(r),
        e = t.length;
      if (null == n) return !e;
      for (var u = Object(n), o = 0; o < e; o++) {
        var i = t[o];
        if (r[i] !== u[i] || !(i in u)) return !1;
      }
      return !0;
    }
    function tn(n) {
      return n instanceof tn ? n : this instanceof tn ? void (this._wrapped = n) : new tn(n);
    }
    function en(n) {
      return new Uint8Array(n.buffer || n, n.byteOffset || 0, G(n));
    }
    tn.VERSION = n, tn.prototype.value = function () {
      return this._wrapped;
    }, tn.prototype.valueOf = tn.prototype.toJSON = tn.prototype.value, tn.prototype.toString = function () {
      return String(this._wrapped);
    };
    var un = "[object DataView]";
    function on(n, r, t, e) {
      if (n === r) return 0 !== n || 1 / n == 1 / r;
      if (null == n || null == r) return !1;
      if (n != n) return r != r;
      var o = typeof n;
      return ("function" === o || "object" === o || "object" == typeof r) && function n(r, t, e, o) {
        r instanceof tn && (r = r._wrapped);
        t instanceof tn && (t = t._wrapped);
        var i = a.call(r);
        if (i !== a.call(t)) return !1;
        if (F && "[object Object]" == i && q(r)) {
          if (!q(t)) return !1;
          i = un;
        }
        switch (i) {
          case "[object RegExp]":
          case "[object String]":
            return "" + r == "" + t;
          case "[object Number]":
            return +r != +r ? +t != +t : 0 == +r ? 1 / +r == 1 / t : +r == +t;
          case "[object Date]":
          case "[object Boolean]":
            return +r == +t;
          case "[object Symbol]":
            return u.valueOf.call(r) === u.valueOf.call(t);
          case "[object ArrayBuffer]":
          case un:
            return n(en(r), en(t), e, o);
        }
        var f = "[object Array]" === i;
        if (!f && X(r)) {
          if (G(r) !== G(t)) return !1;
          if (r.buffer === t.buffer && r.byteOffset === t.byteOffset) return !0;
          f = !0;
        }
        if (!f) {
          if ("object" != typeof r || "object" != typeof t) return !1;
          var c = r.constructor,
            l = t.constructor;
          if (c !== l && !(D(c) && c instanceof c && D(l) && l instanceof l) && "constructor" in r && "constructor" in t) return !1;
        }
        o = o || [];
        var s = (e = e || []).length;
        for (; s--;) if (e[s] === r) return o[s] === t;
        if (e.push(r), o.push(t), f) {
          if ((s = r.length) !== t.length) return !1;
          for (; s--;) if (!on(r[s], t[s], e, o)) return !1;
        } else {
          var p,
            v = nn(r);
          if (s = v.length, nn(t).length !== s) return !1;
          for (; s--;) if (p = v[s], !W(t, p) || !on(r[p], t[p], e, o)) return !1;
        }
        return e.pop(), o.pop(), !0;
      }(n, r, t, e);
    }
    function an(n) {
      if (!_(n)) return [];
      var r = [];
      for (var t in n) r.push(t);
      return g && Z(n, r), r;
    }
    function fn(n) {
      var r = Y(n);
      return function (t) {
        if (null == t) return !1;
        var e = an(t);
        if (Y(e)) return !1;
        for (var u = 0; u < r; u++) if (!D(t[n[u]])) return !1;
        return n !== hn || !D(t[cn]);
      };
    }
    var cn = "forEach",
      ln = "has",
      sn = ["clear", "delete"],
      pn = ["get", ln, "set"],
      vn = sn.concat(cn, pn),
      hn = sn.concat(pn),
      yn = ["add"].concat(sn, cn, ln),
      dn = V ? fn(vn) : x("Map"),
      gn = V ? fn(hn) : x("WeakMap"),
      bn = V ? fn(yn) : x("Set"),
      mn = x("WeakSet");
    function jn(n) {
      for (var r = nn(n), t = r.length, e = Array(t), u = 0; u < t; u++) e[u] = n[r[u]];
      return e;
    }
    function _n(n) {
      for (var r = {}, t = nn(n), e = 0, u = t.length; e < u; e++) r[n[t[e]]] = t[e];
      return r;
    }
    function wn(n) {
      var r = [];
      for (var t in n) D(n[t]) && r.push(t);
      return r.sort();
    }
    function An(n, r) {
      return function (t) {
        var e = arguments.length;
        if (r && (t = Object(t)), e < 2 || null == t) return t;
        for (var u = 1; u < e; u++) for (var o = arguments[u], i = n(o), a = i.length, f = 0; f < a; f++) {
          var c = i[f];
          r && void 0 !== t[c] || (t[c] = o[c]);
        }
        return t;
      };
    }
    var xn = An(an),
      Sn = An(nn),
      On = An(an, !0);
    function Mn(n) {
      if (!_(n)) return {};
      if (v) return v(n);
      var r = function () {};
      r.prototype = n;
      var t = new r();
      return r.prototype = null, t;
    }
    function En(n) {
      return _(n) ? U(n) ? n.slice() : xn({}, n) : n;
    }
    function Bn(n) {
      return U(n) ? n : [n];
    }
    function Nn(n) {
      return tn.toPath(n);
    }
    function In(n, r) {
      for (var t = r.length, e = 0; e < t; e++) {
        if (null == n) return;
        n = n[r[e]];
      }
      return t ? n : void 0;
    }
    function Tn(n, r, t) {
      var e = In(n, Nn(r));
      return w(e) ? t : e;
    }
    function kn(n) {
      return n;
    }
    function Dn(n) {
      return n = Sn({}, n), function (r) {
        return rn(r, n);
      };
    }
    function Rn(n) {
      return n = Nn(n), function (r) {
        return In(r, n);
      };
    }
    function Fn(n, r, t) {
      if (void 0 === r) return n;
      switch (null == t ? 3 : t) {
        case 1:
          return function (t) {
            return n.call(r, t);
          };
        case 3:
          return function (t, e, u) {
            return n.call(r, t, e, u);
          };
        case 4:
          return function (t, e, u, o) {
            return n.call(r, t, e, u, o);
          };
      }
      return function () {
        return n.apply(r, arguments);
      };
    }
    function Vn(n, r, t) {
      return null == n ? kn : D(n) ? Fn(n, r, t) : _(n) && !U(n) ? Dn(n) : Rn(n);
    }
    function Pn(n, r) {
      return Vn(n, r, 1 / 0);
    }
    function qn(n, r, t) {
      return tn.iteratee !== Pn ? tn.iteratee(n, r) : Vn(n, r, t);
    }
    function Un() {}
    function Wn(n, r) {
      return null == r && (r = n, n = 0), n + Math.floor(Math.random() * (r - n + 1));
    }
    tn.toPath = Bn, tn.iteratee = Pn;
    var zn = Date.now || function () {
      return new Date().getTime();
    };
    function Ln(n) {
      var r = function (r) {
          return n[r];
        },
        t = "(?:" + nn(n).join("|") + ")",
        e = RegExp(t),
        u = RegExp(t, "g");
      return function (n) {
        return n = null == n ? "" : "" + n, e.test(n) ? n.replace(u, r) : n;
      };
    }
    var $n = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#x27;",
        "`": "&#x60;"
      },
      Cn = Ln($n),
      Kn = Ln(_n($n)),
      Jn = tn.templateSettings = {
        evaluate: /<%([\s\S]+?)%>/g,
        interpolate: /<%=([\s\S]+?)%>/g,
        escape: /<%-([\s\S]+?)%>/g
      },
      Gn = /(.)^/,
      Hn = {
        "'": "'",
        "\\": "\\",
        "\r": "r",
        "\n": "n",
        "\u2028": "u2028",
        "\u2029": "u2029"
      },
      Qn = /\\|'|\r|\n|\u2028|\u2029/g;
    function Xn(n) {
      return "\\" + Hn[n];
    }
    var Yn = /^\s*(\w|\$)+\s*$/;
    var Zn = 0;
    function nr(n, r, t, e, u) {
      if (!(e instanceof r)) return n.apply(t, u);
      var o = Mn(n.prototype),
        i = n.apply(o, u);
      return _(i) ? i : o;
    }
    var rr = j(function (n, r) {
      var t = rr.placeholder,
        e = function () {
          for (var u = 0, o = r.length, i = Array(o), a = 0; a < o; a++) i[a] = r[a] === t ? arguments[u++] : r[a];
          for (; u < arguments.length;) i.push(arguments[u++]);
          return nr(n, e, this, this, i);
        };
      return e;
    });
    rr.placeholder = tn;
    var tr = j(function (n, r, t) {
        if (!D(n)) throw new TypeError("Bind must be called on a function");
        var e = j(function (u) {
          return nr(n, e, r, this, t.concat(u));
        });
        return e;
      }),
      er = K(Y);
    function ur(n, r, t, e) {
      if (e = e || [], r || 0 === r) {
        if (r <= 0) return e.concat(n);
      } else r = 1 / 0;
      for (var u = e.length, o = 0, i = Y(n); o < i; o++) {
        var a = n[o];
        if (er(a) && (U(a) || L(a))) {
          if (r > 1) ur(a, r - 1, t, e), u = e.length;else for (var f = 0, c = a.length; f < c;) e[u++] = a[f++];
        } else t || (e[u++] = a);
      }
      return e;
    }
    var or = j(function (n, r) {
      var t = (r = ur(r, !1, !1)).length;
      if (t < 1) throw new Error("bindAll must be passed function names");
      for (; t--;) {
        var e = r[t];
        n[e] = tr(n[e], n);
      }
      return n;
    });
    var ir = j(function (n, r, t) {
        return setTimeout(function () {
          return n.apply(null, t);
        }, r);
      }),
      ar = rr(ir, tn, 1);
    function fr(n) {
      return function () {
        return !n.apply(this, arguments);
      };
    }
    function cr(n, r) {
      var t;
      return function () {
        return --n > 0 && (t = r.apply(this, arguments)), n <= 1 && (r = null), t;
      };
    }
    var lr = rr(cr, 2);
    function sr(n, r, t) {
      r = qn(r, t);
      for (var e, u = nn(n), o = 0, i = u.length; o < i; o++) if (r(n[e = u[o]], e, n)) return e;
    }
    function pr(n) {
      return function (r, t, e) {
        t = qn(t, e);
        for (var u = Y(r), o = n > 0 ? 0 : u - 1; o >= 0 && o < u; o += n) if (t(r[o], o, r)) return o;
        return -1;
      };
    }
    var vr = pr(1),
      hr = pr(-1);
    function yr(n, r, t, e) {
      for (var u = (t = qn(t, e, 1))(r), o = 0, i = Y(n); o < i;) {
        var a = Math.floor((o + i) / 2);
        t(n[a]) < u ? o = a + 1 : i = a;
      }
      return o;
    }
    function dr(n, r, t) {
      return function (e, u, o) {
        var a = 0,
          f = Y(e);
        if ("number" == typeof o) n > 0 ? a = o >= 0 ? o : Math.max(o + f, a) : f = o >= 0 ? Math.min(o + 1, f) : o + f + 1;else if (t && o && f) return e[o = t(e, u)] === u ? o : -1;
        if (u != u) return (o = r(i.call(e, a, f), $)) >= 0 ? o + a : -1;
        for (o = n > 0 ? a : f - 1; o >= 0 && o < f; o += n) if (e[o] === u) return o;
        return -1;
      };
    }
    var gr = dr(1, vr, yr),
      br = dr(-1, hr);
    function mr(n, r, t) {
      var e = (er(n) ? vr : sr)(n, r, t);
      if (void 0 !== e && -1 !== e) return n[e];
    }
    function jr(n, r, t) {
      var e, u;
      if (r = Fn(r, t), er(n)) for (e = 0, u = n.length; e < u; e++) r(n[e], e, n);else {
        var o = nn(n);
        for (e = 0, u = o.length; e < u; e++) r(n[o[e]], o[e], n);
      }
      return n;
    }
    function _r(n, r, t) {
      r = qn(r, t);
      for (var e = !er(n) && nn(n), u = (e || n).length, o = Array(u), i = 0; i < u; i++) {
        var a = e ? e[i] : i;
        o[i] = r(n[a], a, n);
      }
      return o;
    }
    function wr(n) {
      var r = function (r, t, e, u) {
        var o = !er(r) && nn(r),
          i = (o || r).length,
          a = n > 0 ? 0 : i - 1;
        for (u || (e = r[o ? o[a] : a], a += n); a >= 0 && a < i; a += n) {
          var f = o ? o[a] : a;
          e = t(e, r[f], f, r);
        }
        return e;
      };
      return function (n, t, e, u) {
        var o = arguments.length >= 3;
        return r(n, Fn(t, u, 4), e, o);
      };
    }
    var Ar = wr(1),
      xr = wr(-1);
    function Sr(n, r, t) {
      var e = [];
      return r = qn(r, t), jr(n, function (n, t, u) {
        r(n, t, u) && e.push(n);
      }), e;
    }
    function Or(n, r, t) {
      r = qn(r, t);
      for (var e = !er(n) && nn(n), u = (e || n).length, o = 0; o < u; o++) {
        var i = e ? e[o] : o;
        if (!r(n[i], i, n)) return !1;
      }
      return !0;
    }
    function Mr(n, r, t) {
      r = qn(r, t);
      for (var e = !er(n) && nn(n), u = (e || n).length, o = 0; o < u; o++) {
        var i = e ? e[o] : o;
        if (r(n[i], i, n)) return !0;
      }
      return !1;
    }
    function Er(n, r, t, e) {
      return er(n) || (n = jn(n)), ("number" != typeof t || e) && (t = 0), gr(n, r, t) >= 0;
    }
    var Br = j(function (n, r, t) {
      var e, u;
      return D(r) ? u = r : (r = Nn(r), e = r.slice(0, -1), r = r[r.length - 1]), _r(n, function (n) {
        var o = u;
        if (!o) {
          if (e && e.length && (n = In(n, e)), null == n) return;
          o = n[r];
        }
        return null == o ? o : o.apply(n, t);
      });
    });
    function Nr(n, r) {
      return _r(n, Rn(r));
    }
    function Ir(n, r, t) {
      var e,
        u,
        o = -1 / 0,
        i = -1 / 0;
      if (null == r || "number" == typeof r && "object" != typeof n[0] && null != n) for (var a = 0, f = (n = er(n) ? n : jn(n)).length; a < f; a++) null != (e = n[a]) && e > o && (o = e);else r = qn(r, t), jr(n, function (n, t, e) {
        ((u = r(n, t, e)) > i || u === -1 / 0 && o === -1 / 0) && (o = n, i = u);
      });
      return o;
    }
    function Tr(n, r, t) {
      if (null == r || t) return er(n) || (n = jn(n)), n[Wn(n.length - 1)];
      var e = er(n) ? En(n) : jn(n),
        u = Y(e);
      r = Math.max(Math.min(r, u), 0);
      for (var o = u - 1, i = 0; i < r; i++) {
        var a = Wn(i, o),
          f = e[i];
        e[i] = e[a], e[a] = f;
      }
      return e.slice(0, r);
    }
    function kr(n, r) {
      return function (t, e, u) {
        var o = r ? [[], []] : {};
        return e = qn(e, u), jr(t, function (r, u) {
          var i = e(r, u, t);
          n(o, r, i);
        }), o;
      };
    }
    var Dr = kr(function (n, r, t) {
        W(n, t) ? n[t].push(r) : n[t] = [r];
      }),
      Rr = kr(function (n, r, t) {
        n[t] = r;
      }),
      Fr = kr(function (n, r, t) {
        W(n, t) ? n[t]++ : n[t] = 1;
      }),
      Vr = kr(function (n, r, t) {
        n[t ? 0 : 1].push(r);
      }, !0),
      Pr = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
    function qr(n, r, t) {
      return r in t;
    }
    var Ur = j(function (n, r) {
        var t = {},
          e = r[0];
        if (null == n) return t;
        D(e) ? (r.length > 1 && (e = Fn(e, r[1])), r = an(n)) : (e = qr, r = ur(r, !1, !1), n = Object(n));
        for (var u = 0, o = r.length; u < o; u++) {
          var i = r[u],
            a = n[i];
          e(a, i, n) && (t[i] = a);
        }
        return t;
      }),
      Wr = j(function (n, r) {
        var t,
          e = r[0];
        return D(e) ? (e = fr(e), r.length > 1 && (t = r[1])) : (r = _r(ur(r, !1, !1), String), e = function (n, t) {
          return !Er(r, t);
        }), Ur(n, e, t);
      });
    function zr(n, r, t) {
      return i.call(n, 0, Math.max(0, n.length - (null == r || t ? 1 : r)));
    }
    function Lr(n, r, t) {
      return null == n || n.length < 1 ? null == r || t ? void 0 : [] : null == r || t ? n[0] : zr(n, n.length - r);
    }
    function $r(n, r, t) {
      return i.call(n, null == r || t ? 1 : r);
    }
    var Cr = j(function (n, r) {
        return r = ur(r, !0, !0), Sr(n, function (n) {
          return !Er(r, n);
        });
      }),
      Kr = j(function (n, r) {
        return Cr(n, r);
      });
    function Jr(n, r, t, e) {
      A(r) || (e = t, t = r, r = !1), null != t && (t = qn(t, e));
      for (var u = [], o = [], i = 0, a = Y(n); i < a; i++) {
        var f = n[i],
          c = t ? t(f, i, n) : f;
        r && !t ? (i && o === c || u.push(f), o = c) : t ? Er(o, c) || (o.push(c), u.push(f)) : Er(u, f) || u.push(f);
      }
      return u;
    }
    var Gr = j(function (n) {
      return Jr(ur(n, !0, !0));
    });
    function Hr(n) {
      for (var r = n && Ir(n, Y).length || 0, t = Array(r), e = 0; e < r; e++) t[e] = Nr(n, e);
      return t;
    }
    var Qr = j(Hr);
    function Xr(n, r) {
      return n._chain ? tn(r).chain() : r;
    }
    function Yr(n) {
      return jr(wn(n), function (r) {
        var t = tn[r] = n[r];
        tn.prototype[r] = function () {
          var n = [this._wrapped];
          return o.apply(n, arguments), Xr(this, t.apply(tn, n));
        };
      }), tn;
    }
    jr(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function (n) {
      var r = t[n];
      tn.prototype[n] = function () {
        var t = this._wrapped;
        return null != t && (r.apply(t, arguments), "shift" !== n && "splice" !== n || 0 !== t.length || delete t[0]), Xr(this, t);
      };
    }), jr(["concat", "join", "slice"], function (n) {
      var r = t[n];
      tn.prototype[n] = function () {
        var n = this._wrapped;
        return null != n && (n = r.apply(n, arguments)), Xr(this, n);
      };
    });
    var Zr = Yr({
      __proto__: null,
      VERSION: n,
      restArguments: j,
      isObject: _,
      isNull: function (n) {
        return null === n;
      },
      isUndefined: w,
      isBoolean: A,
      isElement: function (n) {
        return !(!n || 1 !== n.nodeType);
      },
      isString: S,
      isNumber: O,
      isDate: M,
      isRegExp: E,
      isError: B,
      isSymbol: N,
      isArrayBuffer: I,
      isDataView: q,
      isArray: U,
      isFunction: D,
      isArguments: L,
      isFinite: function (n) {
        return !N(n) && d(n) && !isNaN(parseFloat(n));
      },
      isNaN: $,
      isTypedArray: X,
      isEmpty: function (n) {
        if (null == n) return !0;
        var r = Y(n);
        return "number" == typeof r && (U(n) || S(n) || L(n)) ? 0 === r : 0 === Y(nn(n));
      },
      isMatch: rn,
      isEqual: function (n, r) {
        return on(n, r);
      },
      isMap: dn,
      isWeakMap: gn,
      isSet: bn,
      isWeakSet: mn,
      keys: nn,
      allKeys: an,
      values: jn,
      pairs: function (n) {
        for (var r = nn(n), t = r.length, e = Array(t), u = 0; u < t; u++) e[u] = [r[u], n[r[u]]];
        return e;
      },
      invert: _n,
      functions: wn,
      methods: wn,
      extend: xn,
      extendOwn: Sn,
      assign: Sn,
      defaults: On,
      create: function (n, r) {
        var t = Mn(n);
        return r && Sn(t, r), t;
      },
      clone: En,
      tap: function (n, r) {
        return r(n), n;
      },
      get: Tn,
      has: function (n, r) {
        for (var t = (r = Nn(r)).length, e = 0; e < t; e++) {
          var u = r[e];
          if (!W(n, u)) return !1;
          n = n[u];
        }
        return !!t;
      },
      mapObject: function (n, r, t) {
        r = qn(r, t);
        for (var e = nn(n), u = e.length, o = {}, i = 0; i < u; i++) {
          var a = e[i];
          o[a] = r(n[a], a, n);
        }
        return o;
      },
      identity: kn,
      constant: C,
      noop: Un,
      toPath: Bn,
      property: Rn,
      propertyOf: function (n) {
        return null == n ? Un : function (r) {
          return Tn(n, r);
        };
      },
      matcher: Dn,
      matches: Dn,
      times: function (n, r, t) {
        var e = Array(Math.max(0, n));
        r = Fn(r, t, 1);
        for (var u = 0; u < n; u++) e[u] = r(u);
        return e;
      },
      random: Wn,
      now: zn,
      escape: Cn,
      unescape: Kn,
      templateSettings: Jn,
      template: function (n, r, t) {
        !r && t && (r = t), r = On({}, r, tn.templateSettings);
        var e = RegExp([(r.escape || Gn).source, (r.interpolate || Gn).source, (r.evaluate || Gn).source].join("|") + "|$", "g"),
          u = 0,
          o = "__p+='";
        n.replace(e, function (r, t, e, i, a) {
          return o += n.slice(u, a).replace(Qn, Xn), u = a + r.length, t ? o += "'+\n((__t=(" + t + "))==null?'':_.escape(__t))+\n'" : e ? o += "'+\n((__t=(" + e + "))==null?'':__t)+\n'" : i && (o += "';\n" + i + "\n__p+='"), r;
        }), o += "';\n";
        var i,
          a = r.variable;
        if (a) {
          if (!Yn.test(a)) throw new Error("variable is not a bare identifier: " + a);
        } else o = "with(obj||{}){\n" + o + "}\n", a = "obj";
        o = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + o + "return __p;\n";
        try {
          i = new Function(a, "_", o);
        } catch (n) {
          throw n.source = o, n;
        }
        var f = function (n) {
          return i.call(this, n, tn);
        };
        return f.source = "function(" + a + "){\n" + o + "}", f;
      },
      result: function (n, r, t) {
        var e = (r = Nn(r)).length;
        if (!e) return D(t) ? t.call(n) : t;
        for (var u = 0; u < e; u++) {
          var o = null == n ? void 0 : n[r[u]];
          void 0 === o && (o = t, u = e), n = D(o) ? o.call(n) : o;
        }
        return n;
      },
      uniqueId: function (n) {
        var r = ++Zn + "";
        return n ? n + r : r;
      },
      chain: function (n) {
        var r = tn(n);
        return r._chain = !0, r;
      },
      iteratee: Pn,
      partial: rr,
      bind: tr,
      bindAll: or,
      memoize: function (n, r) {
        var t = function (e) {
          var u = t.cache,
            o = "" + (r ? r.apply(this, arguments) : e);
          return W(u, o) || (u[o] = n.apply(this, arguments)), u[o];
        };
        return t.cache = {}, t;
      },
      delay: ir,
      defer: ar,
      throttle: function (n, r, t) {
        var e,
          u,
          o,
          i,
          a = 0;
        t || (t = {});
        var f = function () {
            a = !1 === t.leading ? 0 : zn(), e = null, i = n.apply(u, o), e || (u = o = null);
          },
          c = function () {
            var c = zn();
            a || !1 !== t.leading || (a = c);
            var l = r - (c - a);
            return u = this, o = arguments, l <= 0 || l > r ? (e && (clearTimeout(e), e = null), a = c, i = n.apply(u, o), e || (u = o = null)) : e || !1 === t.trailing || (e = setTimeout(f, l)), i;
          };
        return c.cancel = function () {
          clearTimeout(e), a = 0, e = u = o = null;
        }, c;
      },
      debounce: function (n, r, t) {
        var e,
          u,
          o,
          i,
          a,
          f = function () {
            var c = zn() - u;
            r > c ? e = setTimeout(f, r - c) : (e = null, t || (i = n.apply(a, o)), e || (o = a = null));
          },
          c = j(function (c) {
            return a = this, o = c, u = zn(), e || (e = setTimeout(f, r), t && (i = n.apply(a, o))), i;
          });
        return c.cancel = function () {
          clearTimeout(e), e = o = a = null;
        }, c;
      },
      wrap: function (n, r) {
        return rr(r, n);
      },
      negate: fr,
      compose: function () {
        var n = arguments,
          r = n.length - 1;
        return function () {
          for (var t = r, e = n[r].apply(this, arguments); t--;) e = n[t].call(this, e);
          return e;
        };
      },
      after: function (n, r) {
        return function () {
          if (--n < 1) return r.apply(this, arguments);
        };
      },
      before: cr,
      once: lr,
      findKey: sr,
      findIndex: vr,
      findLastIndex: hr,
      sortedIndex: yr,
      indexOf: gr,
      lastIndexOf: br,
      find: mr,
      detect: mr,
      findWhere: function (n, r) {
        return mr(n, Dn(r));
      },
      each: jr,
      forEach: jr,
      map: _r,
      collect: _r,
      reduce: Ar,
      foldl: Ar,
      inject: Ar,
      reduceRight: xr,
      foldr: xr,
      filter: Sr,
      select: Sr,
      reject: function (n, r, t) {
        return Sr(n, fr(qn(r)), t);
      },
      every: Or,
      all: Or,
      some: Mr,
      any: Mr,
      contains: Er,
      includes: Er,
      include: Er,
      invoke: Br,
      pluck: Nr,
      where: function (n, r) {
        return Sr(n, Dn(r));
      },
      max: Ir,
      min: function (n, r, t) {
        var e,
          u,
          o = 1 / 0,
          i = 1 / 0;
        if (null == r || "number" == typeof r && "object" != typeof n[0] && null != n) for (var a = 0, f = (n = er(n) ? n : jn(n)).length; a < f; a++) null != (e = n[a]) && e < o && (o = e);else r = qn(r, t), jr(n, function (n, t, e) {
          ((u = r(n, t, e)) < i || u === 1 / 0 && o === 1 / 0) && (o = n, i = u);
        });
        return o;
      },
      shuffle: function (n) {
        return Tr(n, 1 / 0);
      },
      sample: Tr,
      sortBy: function (n, r, t) {
        var e = 0;
        return r = qn(r, t), Nr(_r(n, function (n, t, u) {
          return {
            value: n,
            index: e++,
            criteria: r(n, t, u)
          };
        }).sort(function (n, r) {
          var t = n.criteria,
            e = r.criteria;
          if (t !== e) {
            if (t > e || void 0 === t) return 1;
            if (t < e || void 0 === e) return -1;
          }
          return n.index - r.index;
        }), "value");
      },
      groupBy: Dr,
      indexBy: Rr,
      countBy: Fr,
      partition: Vr,
      toArray: function (n) {
        return n ? U(n) ? i.call(n) : S(n) ? n.match(Pr) : er(n) ? _r(n, kn) : jn(n) : [];
      },
      size: function (n) {
        return null == n ? 0 : er(n) ? n.length : nn(n).length;
      },
      pick: Ur,
      omit: Wr,
      first: Lr,
      head: Lr,
      take: Lr,
      initial: zr,
      last: function (n, r, t) {
        return null == n || n.length < 1 ? null == r || t ? void 0 : [] : null == r || t ? n[n.length - 1] : $r(n, Math.max(0, n.length - r));
      },
      rest: $r,
      tail: $r,
      drop: $r,
      compact: function (n) {
        return Sr(n, Boolean);
      },
      flatten: function (n, r) {
        return ur(n, r, !1);
      },
      without: Kr,
      uniq: Jr,
      unique: Jr,
      union: Gr,
      intersection: function (n) {
        for (var r = [], t = arguments.length, e = 0, u = Y(n); e < u; e++) {
          var o = n[e];
          if (!Er(r, o)) {
            var i;
            for (i = 1; i < t && Er(arguments[i], o); i++);
            i === t && r.push(o);
          }
        }
        return r;
      },
      difference: Cr,
      unzip: Hr,
      transpose: Hr,
      zip: Qr,
      object: function (n, r) {
        for (var t = {}, e = 0, u = Y(n); e < u; e++) r ? t[n[e]] = r[e] : t[n[e][0]] = n[e][1];
        return t;
      },
      range: function (n, r, t) {
        null == r && (r = n || 0, n = 0), t || (t = r < n ? -1 : 1);
        for (var e = Math.max(Math.ceil((r - n) / t), 0), u = Array(e), o = 0; o < e; o++, n += t) u[o] = n;
        return u;
      },
      chunk: function (n, r) {
        if (null == r || r < 1) return [];
        for (var t = [], e = 0, u = n.length; e < u;) t.push(i.call(n, e, e += r));
        return t;
      },
      mixin: Yr,
      default: tn
    });
    return Zr._ = Zr, Zr;
  });
})(_underscoreMin.u);
var _ = _underscoreMin.u.exports;
exports["default"] = _;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js":
/*!***********************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js ***!
  \***********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "$", ({
  enumerable: true,
  get: function () {
    return _jqueryWrapper.default;
  }
}));
Object.defineProperty(exports, "Backbone", ({
  enumerable: true,
  get: function () {
    return _backbone.default;
  }
}));
Object.defineProperty(exports, "BaseModel", ({
  enumerable: true,
  get: function () {
    return _BaseModel.default;
  }
}));
exports.Form = exports.Controller = exports.Collection = void 0;
Object.defineProperty(exports, "FrameworkView", ({
  enumerable: true,
  get: function () {
    return _View.default;
  }
}));
Object.defineProperty(exports, "Handlebars", ({
  enumerable: true,
  get: function () {
    return _handlebarsRuntime.default;
  }
}));
Object.defineProperty(exports, "ListView", ({
  enumerable: true,
  get: function () {
    return _BackboneListView.default;
  }
}));
Object.defineProperty(exports, "Model", ({
  enumerable: true,
  get: function () {
    return _Model.default;
  }
}));
exports.View = exports.Router = void 0;
Object.defineProperty(exports, "_", ({
  enumerable: true,
  get: function () {
    return _underscoreWrapper.default;
  }
}));
exports.internal = exports.createCallout = exports.createButton = void 0;
Object.defineProperty(exports, "isModelPropertySchema", ({
  enumerable: true,
  get: function () {
    return _Model2.isModelPropertySchema;
  }
}));
exports.registerInput = exports.loc = void 0;
var _BaseCollection = _interopRequireDefault(__webpack_require__(/*! ./courage/models/BaseCollection.js */ "./packages/@okta/courage-dist/esm/src/courage/models/BaseCollection.js"));
var _BaseModel = _interopRequireDefault(__webpack_require__(/*! ./courage/models/BaseModel.js */ "./packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js"));
var _BaseSchema = _interopRequireDefault(__webpack_require__(/*! ./courage/models/BaseSchema.js */ "./packages/@okta/courage-dist/esm/src/courage/models/BaseSchema.js"));
var _Model = _interopRequireDefault(__webpack_require__(/*! ./courage/models/Model.js */ "./packages/@okta/courage-dist/esm/src/courage/models/Model.js"));
var _SchemaProperty = _interopRequireDefault(__webpack_require__(/*! ./courage/models/SchemaProperty.js */ "./packages/@okta/courage-dist/esm/src/courage/models/SchemaProperty.js"));
var _BaseController = _interopRequireDefault(__webpack_require__(/*! ./courage/util/BaseController.js */ "./packages/@okta/courage-dist/esm/src/courage/util/BaseController.js"));
var _BaseRouter = _interopRequireDefault(__webpack_require__(/*! ./courage/util/BaseRouter.js */ "./packages/@okta/courage-dist/esm/src/courage/util/BaseRouter.js"));
var _ButtonFactory = _interopRequireDefault(__webpack_require__(/*! ./courage/util/ButtonFactory.js */ "./packages/@okta/courage-dist/esm/src/courage/util/ButtonFactory.js"));
var _Class = _interopRequireDefault(__webpack_require__(/*! ./courage/util/Class.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Class.js"));
var _Cookie = _interopRequireDefault(__webpack_require__(/*! ./courage/util/Cookie.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Cookie.js"));
var _Clipboard = _interopRequireDefault(__webpack_require__(/*! ./courage/util/Clipboard.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Clipboard.js"));
var _Keys = _interopRequireDefault(__webpack_require__(/*! ./courage/util/Keys.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Keys.js"));
var _Logger = _interopRequireDefault(__webpack_require__(/*! ./courage/util/Logger.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Logger.js"));
var _StringUtil = _interopRequireDefault(__webpack_require__(/*! ./courage/util/StringUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/StringUtil.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! ./courage/util/Util.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Util.js"));
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
__webpack_require__(/*! ./courage/util/handlebars/handle-url.js */ "./packages/@okta/courage-dist/esm/src/courage/util/handlebars/handle-url.js");
__webpack_require__(/*! ./courage/util/handlebars/helper-i18n.js */ "./packages/@okta/courage-dist/esm/src/courage/util/handlebars/helper-i18n.js");
var _jqueryWrapper = _interopRequireDefault(__webpack_require__(/*! ./courage/util/jquery-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ./courage/util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _BackboneListView = _interopRequireDefault(__webpack_require__(/*! ./courage/views/Backbone.ListView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ./courage/views/BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
var _BaseDropDown = _interopRequireDefault(__webpack_require__(/*! ./courage/views/components/BaseDropDown.js */ "./packages/@okta/courage-dist/esm/src/courage/views/components/BaseDropDown.js"));
var _Notification = _interopRequireDefault(__webpack_require__(/*! ./courage/views/components/Notification.js */ "./packages/@okta/courage-dist/esm/src/courage/views/components/Notification.js"));
var _BaseForm = _interopRequireDefault(__webpack_require__(/*! ./courage/views/forms/BaseForm.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/BaseForm.js"));
var _Toolbar = _interopRequireDefault(__webpack_require__(/*! ./courage/views/forms/components/Toolbar.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/components/Toolbar.js"));
var _FormUtil = _interopRequireDefault(__webpack_require__(/*! ./courage/views/forms/helpers/FormUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/FormUtil.js"));
var _InputRegistry = _interopRequireDefault(__webpack_require__(/*! ./courage/views/forms/helpers/InputRegistry.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/InputRegistry.js"));
var _SchemaFormFactory = _interopRequireDefault(__webpack_require__(/*! ./courage/views/forms/helpers/SchemaFormFactory.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/SchemaFormFactory.js"));
var _BaseInput = _interopRequireDefault(__webpack_require__(/*! ./courage/views/forms/BaseInput.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/BaseInput.js"));
var _CheckBox = _interopRequireDefault(__webpack_require__(/*! ./courage/views/forms/inputs/CheckBox.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/CheckBox.js"));
var _PasswordBox = _interopRequireDefault(__webpack_require__(/*! ./courage/views/forms/inputs/PasswordBox.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/PasswordBox.js"));
var _Radio = _interopRequireDefault(__webpack_require__(/*! ./courage/views/forms/inputs/Radio.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/Radio.js"));
var _Select = _interopRequireDefault(__webpack_require__(/*! ./courage/views/forms/inputs/Select.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/Select.js"));
var _InputGroup = _interopRequireDefault(__webpack_require__(/*! ./courage/views/forms/inputs/InputGroup.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/InputGroup.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! ./courage/views/forms/inputs/TextBox.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/TextBox.js"));
var _Callout = _interopRequireDefault(__webpack_require__(/*! ./courage/views/components/Callout.js */ "./packages/@okta/courage-dist/esm/src/courage/views/components/Callout.js"));
var _backbone = _interopRequireDefault(__webpack_require__(/*! ./courage/vendor/lib/backbone.js */ "./packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js"));
var _View = _interopRequireDefault(__webpack_require__(/*! ./courage/framework/View.js */ "./packages/@okta/courage-dist/esm/src/courage/framework/View.js"));
__webpack_require__(/*! ./util/scrollParent.js */ "./packages/@okta/courage-dist/esm/src/util/scrollParent.js");
var _Model2 = __webpack_require__(/*! ./courage/framework/Model.js */ "./packages/@okta/courage-dist/esm/src/courage/framework/Model.js");
__webpack_require__(/*! ./courage/util/SettingsModel.js */ "./packages/@okta/courage-dist/esm/src/courage/util/SettingsModel.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Controller = _BaseController.default.extend({
  // The courage BaseController renders asynchronously in current versions of jQuery
  // https://github.com/okta/okta-ui/blob/master/packages/courage/src/util/BaseController.ts#L117-L119
  // https://api.jquery.com/jquery/#jQuery-callback
  // Override so that render is synchronous
  render: function (...args) {
    _BaseView.default.prototype.render.apply(this, args);
    return this;
  }
});
exports.Controller = Controller;
_Select.default.prototype.remove = function () {
  // Patched to remove unneeded call to
  // this.$select.trigger('remove');
  // which causes error on IE11
  return _BaseInput.default.prototype.remove.apply(this, arguments);
}; // The string will be returned unchanged. All templates should be precompiled.

_View.default.prototype.compileTemplate = function (str) {
  const compiledTmpl = function fakeTemplate() {
    return str;
  };
  compiledTmpl.source = ''; // to satisfy TS

  return compiledTmpl;
}; // Override events to not support `Enter` submitting the form twice - OKTA-321999 and OKTA-317629

const events = {
  'input input': 'update',
  'change input': 'update',
  'keydown input': 'update',
  'keyup input': function (e) {
    if (_Keys.default.isEsc(e)) {
      this.model.trigger('form:cancel');
    }
  }
};
const TextBoxForSigninWidget = _TextBox.default.extend({
  events: events
});
const PasswordBoxForSigninWidget = _PasswordBox.default.extend({
  events: events
});
const Form = _BaseForm.default.extend({
  scrollOnError: function () {
    // scrollOnError is true by default. Override to false if `scrollOnError` has been set to false in widget settings.
    const {
      settings: settings
    } = this.options;
    if (settings.get('features.scrollOnError') === false) {
      return false;
    }
    return true;
  }
});
exports.Form = Form;
const loc = _StringUtil.default.localize;
exports.loc = loc;
const createButton = _ButtonFactory.default.create;
exports.createButton = createButton;
const createCallout = _Callout.default.create;
exports.createCallout = createCallout;
const registerInput = _InputRegistry.default.register;
exports.registerInput = registerInput;
const Collection = _BaseCollection.default;
exports.Collection = Collection;
const View = _BaseView.default;
exports.View = View;
const Router = _BaseRouter.default;
exports.Router = Router;
const internal = {
  util: {
    Util: _Util.default,
    Cookie: _Cookie.default,
    Clipboard: _Clipboard.default,
    Logger: _Logger.default,
    Class: _Class.default,
    Keys: _Keys.default
  },
  views: {
    components: {
      BaseDropDown: _BaseDropDown.default,
      Notification: _Notification.default
    },
    forms: {
      helpers: {
        FormUtil: _FormUtil.default,
        SchemaFormFactory: _SchemaFormFactory.default
      },
      components: {
        Toolbar: _Toolbar.default
      },
      inputs: {
        TextBox: TextBoxForSigninWidget,
        PasswordBox: PasswordBoxForSigninWidget,
        CheckBox: _CheckBox.default,
        Radio: _Radio.default,
        Select: _Select.default,
        InputGroup: _InputGroup.default
      }
    }
  },
  models: {
    BaseSchema: _BaseSchema.default,
    SchemaProperty: _SchemaProperty.default
  }
};
exports.internal = internal;
registerInput('text', TextBoxForSigninWidget);
registerInput('password', PasswordBoxForSigninWidget);
registerInput('checkbox', _CheckBox.default);
registerInput('radio', _Radio.default);
registerInput('select', _Select.default);
registerInput('group', _InputGroup.default);

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/framework/Collection.js":
/*!*****************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/framework/Collection.js ***!
  \*****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _backbone = _interopRequireDefault(__webpack_require__(/*! ../vendor/lib/backbone.js */ "./packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var STATE = '__STATE__';
var FETCH_DATA = 'FETCH_DATA';
var PAGINATION_DATA = 'PAGINATION_DATA';
var DEFAULT_PARAMS = 'DEFAULT_PARAMS';
var LINK_BY_HEADER = 'LINK_BY_HEADER';
var XHR = 'XHR'; // ################################################
// # Source: https://gist.github.com/deiu/9335803
// ################################################
// unquote string (utility)

function unquote(value) {
  if (value.charAt(0) === '"' && value.charAt(value.length - 1) === '"') {
    return value.substring(1, value.length - 1);
  }
  return value;
}
/*
parse a Link header
Link:<https://example.org/.meta>; rel=meta
var r = parseLinkHeader(xhr.getResponseHeader('Link');
r['meta']['href'] outputs https://example.org/.meta
*/

function parseLinkHeader(header) {
  /* eslint max-statements: 0 */
  var linkexp = /<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*")))*(,|$)/g;
  var paramexp = /[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*"))/g;
  var matches = header.match(linkexp);
  var rels = {};
  for (var i = 0; i < matches.length; i++) {
    var split = matches[i].split('>');
    var href = split[0].substring(1);
    var link = {
      href: undefined,
      rel: undefined
    };
    link.href = href;
    var s = split[1].match(paramexp);
    for (var j = 0; j < s.length; j++) {
      var paramsplit = s[j].split('=');
      var name = paramsplit[0];
      link[name] = unquote(paramsplit[1]);
    }
    if (link.rel !== undefined) {
      rels[link.rel] = link;
    }
  }
  return rels;
}
/*
 * Sets the next page URL on the collection from link headers
 * See: http://www.rfc-editor.org/rfc/rfc5988.txt
 *
 * This method is looking for a link header with `rel="next"`
 * An set's it as the next page's URL.
 *
 * If it doesn't find a next page, and current page is set by a link header
 * it assumes we are at the last page and deletes the current `next`
 */

function setLinkHeadersPagination(collection, xhr) {
  try {
    var links = parseLinkHeader(xhr.getResponseHeader('link'));
    collection[STATE].set(LINK_BY_HEADER, true);
    collection.setPagination(links['next'].href);
  } catch (e) {
    if (collection[STATE].get(LINK_BY_HEADER)) {
      collection.setPagination(null);
    }
  }
}
function parseQuery(url) {
  var params = {};
  var rawQueryStr = url && url.split('?')[1];
  var queryString = rawQueryStr && decodeURIComponent(rawQueryStr.split('#')[0]).replace(/\+/g, ' ');
  var props = queryString ? queryString.split('&') : [];
  for (var i = 0; i < props.length; i++) {
    var parts = props[i].split('=');
    params[parts.shift()] = parts.join('=');
  }
  return params;
} // ################################################
// # /Source
// ################################################
//

const collectionProps = /** @lends src/framework/Collection.prototype */
{
  /**
   * Default fetch parameters
   * @type {Object|Function}
   */
  params: {},
  preinitialize: function (models, options) {
    const state = new _backbone.default.Model();
    const defaultParams = _underscoreWrapper.default.defaults(options && options.params || {}, _underscoreWrapper.default.result(this, 'params') || {});
    state.set(DEFAULT_PARAMS, defaultParams);
    this[STATE] = state; // Adds support for child class to convert to ES6 Class.
    // After conversion, `this.model` has to be a pure function to return Model Class.
    // The changes below is trying to distinguish the ambiguity between a Class and normal function,
    // as both are JavaScript function essentially.
    // There are three ways to define class for `this.model`
    // 1. Object properties: `model: BaseModel.extend({..})`
    // 2. Function constructor:
    // See example from
    // - appversions/src/models/CustomType.js
    // - appversions/src/models/EnumType.js
    // - appversions/src/models/SignOnMode.js
    // - authn-factors/src/models/Feature.js
    // - shared/src/models/SamlAttribute.js
    // 3. Function that returns a class.
    //    model: function() { return BaseModel.extend({..}); }
    //
    // option 1 and 2 exists in code base today
    // option 3 is introduced to support child class to convert to ES6 class.
    // TODO: think of remove following check
    // The reason for `this.model !== Backbone.Model` is because `this.model` is default to `Backbone.Model`
    // set at Backbone.Collection.

    if (_underscoreWrapper.default.isFunction(this.model) && this.model.length === 0 && this.model.isCourageModel !== true) {
      this.model = _underscoreWrapper.default.result(this, 'model');
    }
    _backbone.default.Collection.prototype.preinitialize.apply(this, arguments);
  },
  /**
   * See [Backbone Collection.sync](http://backbonejs.org/#Collection-sync).
   */
  sync: function (method, collection, options) {
    var self = this;
    var success = options.success;
    options.success = function (resp, status, xhr) {
      // its important to set the pagination data *before* we call the success callback
      // because we want the pagination data to be ready when the collection triggers the `sync` event
      setLinkHeadersPagination(self, xhr);
      success.apply(null, arguments);
    };
    return _backbone.default.Collection.prototype.sync.call(this, method, collection, options);
  },
  /**
   * See [Backbone Collection.fetch](http://backbonejs.org/#Collection-fetch).
   */
  fetch: function (options) {
    options || (options = {});
    var state = this[STATE];
    var xhr = state.get(XHR);
    options.data = _underscoreWrapper.default.extend({}, state.get(DEFAULT_PARAMS), options.data || {});
    options.fromFetch = true;
    state.set(FETCH_DATA, options.data);
    if (xhr && xhr.abort && options.abort !== false) {
      xhr.abort();
    }
    xhr = _backbone.default.Collection.prototype.fetch.call(this, options);
    state.set(XHR, xhr);
    return xhr;
  },
  /**
   * Set pagination data to get to the next page
   * @param {Mixed} params
   * @param {Object} [options]
   * @param {Boolean} [options.fromFetch] should we include data from the previous fetch call in this object
   * @example
   * collection.setPagination({q: 'foo', page: '2'}); //=> {q: 'foo', page: '2'}
   *
   * collection.setPagination('/path/to/resource?q=baz&page=4'); //=> {q: 'baz', page: '4'}
   *
   * collection.setPagination('/path/to/resource'); //=> {}
   *
   * collection.fetch({data: {q: 'foo'}});
   * collection.setPagination({page: 2}, {fromFetch: true}); //=> {q: 'foo', page: 2}
   *
   * any "falsy" value resets pagination
   * collection.setPagination(); //=> {}
   * collection.setPagination(null); //=> {}
   * collection.setPagination(false); //=> {}
   * collection.setPagination(''); //=> {}
   * collection.setPagination(0); //=> {}
   * @protected
   */
  setPagination: function (params, options) {
    /* eslint complexity: [2, 8] */
    if (_underscoreWrapper.default.isString(params) && params) {
      params = parseQuery(params);
    }
    if (!_underscoreWrapper.default.isObject(params) || _underscoreWrapper.default.isArray(params) || !_underscoreWrapper.default.size(params)) {
      params = null;
    } else if (options && options.fromFetch) {
      params = _underscoreWrapper.default.extend({}, this.getFetchData(), params);
    }
    this[STATE].set(PAGINATION_DATA, params);
  },
  /**
   * Returns the `data` parameters applied in th most recent `fetch` call
   * It will include parameters set by {@link #params} and optios.params passed to the constructor
   * @return {Object}
   * @protected
   */
  getFetchData: function () {
    return this[STATE].get(FETCH_DATA) || {};
  },
  /**
   * Data object for constructing a request to fetch the next page
   * @return {Object}
   * @protected
   */
  getPaginationData: function () {
    return this[STATE].get(PAGINATION_DATA) || {};
  },
  /**
   * Does this collection have more data on the server (e.g is there a next "page")
   * @return {Boolean}
   */
  hasMore: function () {
    return _underscoreWrapper.default.size(this.getPaginationData()) > 0;
  },
  /**
   * Get the next page from the server
   * @return {Object} xhr returned by {@link #fetch}
   */
  fetchMore: function () {
    if (!this.hasMore()) {
      throw new Error('Invalid Request');
    }
    return this.fetch({
      data: this.getPaginationData(),
      add: true,
      remove: false,
      update: true
    });
  },
  /**
   * See [Backbone Collection.reset](http://backbonejs.org/#Collection-reset).
   */
  reset: function (models, options) {
    options || (options = {}); // only reset the pagination when reset is being called explicitly.
    // this is to avoid link headers pagination being overriden and reset when
    // fetching the collection using `collection.fetch({reset: true})`

    if (!options.fromFetch) {
      this.setPagination(null);
    }
    return _backbone.default.Collection.prototype.reset.apply(this, arguments);
  },
  // we want "where" to be able to search through derived properties as well
  where: function (attrs, first) {
    if (_underscoreWrapper.default.isEmpty(attrs)) {
      return first ? void 0 : [];
    }
    return this[first ? 'find' : 'filter'](function (model) {
      for (var key in attrs) {
        if (attrs[key] !== model.get(key)) {
          return false;
        }
      }
      return true;
    });
  },
  /**
   * See [Backbone Collection.create](http://backbonejs.org/#Collection-create).
   */
  create: function (model, options) {
    options || (options = {});
    if (!_underscoreWrapper.default.result(model, 'urlRoot')) {
      options.url = _underscoreWrapper.default.result(this, 'url');
    }
    return _backbone.default.Collection.prototype.create.call(this, model, options);
  },
  // Use Object.create instead of {} on _byId to avoid __proto__ functions to return
  // This can be removed once the issue has addressed in backbone framework
  // https://github.com/jashkenas/backbone/pull/4225
  _reset: function () {
    _backbone.default.Collection.prototype['_reset'].call(this);
    this._byId = Object.create(null);
  }
};
/**
 *
 * Archer.Collection is a standard [Backbone.Collection](http://backbonejs.org/#Collection) with pre-set `data`
 * parameters and built in pagination - works with [http link headers](https://tools.ietf.org/html/rfc5988)
 * out of the box:
 *
 * @class src/framework/Collection
 * @extends external:Backbone.Collection
 * @example
 * var Users = Archer.Collection.extend({
 *   url: '/api/v1/users'
 *   params: {expand: true}
 * });
 * var users = new Users(null, {params: {type: 'new'}}),
 *     $button = this.$('a.fetch-more');
 *
 * $button.click(function () {
 *   users.fetchMore();
 * });
 *
 * this.listenTo(users, 'sync', function () {
 *   $button.toggle(users.hasMore());
 * });
 *
 * collection.fetch(); //=> '/api/v1/users?expand=true&type=new'
 */

const Collection = _backbone.default.Collection.extend(collectionProps);
/**
 * It's used for distinguishing the ambiguity from _.isFunction()
 * which returns True for both a JavaScript Class constructor function
 * and normal function. With this flag, we can tell a function is actually
 * a Collection Class.
 * This flag is added in order to support the type of a parameter can be
 * either a Class or pure function that returns a Class.
 */
exports["default"] = Collection;
Collection.isCourageCollection = true;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/framework/ListView.js":
/*!***************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/framework/ListView.js ***!
  \***************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _View = _interopRequireDefault(__webpack_require__(/*! ./View.js */ "./packages/@okta/courage-dist/esm/src/courage/framework/View.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint-disable max-statements */
/**
   * Archer.ListView is a {@link src/framework/View} that operates on a
   * collection and builds a list of "things" of the same type.
   *
   * Automagically adds, removes and sorts upon standard collection events.
   *
   * Listen to collection events so the ListView will do the right thing when
   * a model is added or the collection is reset or sorted.
   *
   * @class src/framework/ListView
   * @extends src/framework/View
   * @param {Object} options options hash
   * @param {Object} options.collection The collection which this view operates on
   * @example
   * var UserList = Archer.ListView.extend({
   *   tagName: 'ul',
   *   item: '<li>{{fname}} {{lname}}</li>'
   * });
   *
   * var users = new Archer.Collection([
   *   {fname: 'John', lname: 'Doe'},
   *   {fname: 'Jane', lname: 'Doe'}
   * ]);
   *
   * var userList = new UserList({collection: users}).render();
   * userList.el; //=> "<ul><li>John Doe</li><li>Jane Doe</li></ul>"
   *
   * users.push({fname: 'Jim', lname: 'Doe'});
   * userList.el; //=> "<ul><li>John Doe</li><li>Jane Doe</li><li>Jim Doe</li></ul>"
   *
   * users.first().destroy();
   * userList.el; //=> "<ul><li>Jane Doe</li><li>Jim Doe</li></ul>"
   */

var ListView = _View.default.extend( /** @lends src/framework/ListView.prototype */
{
  constructor: function () {
    _View.default.apply(this, arguments);
    if (!this.collection) {
      throw new Error('Missing collection');
    }
    this.listenTo(this.collection, 'reset sort', this.reset);
    this.listenTo(this.collection, 'add', this.addItem);
    if (this.fetchCollection) {
      this.collection.fetch();
    } else {
      this.collection.each(this.addItem, this);
    }
  },
  /**
     * The view/template we will use to render each model in the collection.
     * @type {String|module:Okta.View}
     */
  item: null,
  /**
     * A selector in the local template where to append each item
     * @type {String}
     */
  itemSelector: null,
  /**
     * Empty the list and re-add everything from the collection.
     * Usefull for handling `collection.reset()` or for handling the initial load
     * @protected
     */
  reset: function () {
    this.removeChildren();
    this.collection.each((model, index) => {
      this.addItem(model, index);
    });
    return this;
  },
  /**
     * Add an item view to the list that will represent one model from the collection
     *
     * Listen to the model so when it is destoyed or removed from the collection
     * this item will remove itself from the list
     *
     * @param {Backbone.Model} model The model this row operates on
     * @protected
     */
  addItem: function (model) {
    var view = this.add(this.item, this.itemSelector, {
      options: {
        model: model
      }
    }).last();
    if (this.state && this.state.get('trackItemAdded')) {
      this.state.trigger('itemAdded', view);
    }
    view.listenTo(model, 'destroy remove', view.remove);
    return this;
  },
  addShowMore: _underscoreWrapper.default.noop
});
exports["default"] = ListView;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/framework/Model.js":
/*!************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/framework/Model.js ***!
  \************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
exports.isModelPropertySchema = isModelPropertySchema;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _backbone = _interopRequireDefault(__webpack_require__(/*! ../vendor/lib/backbone.js */ "./packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js"));
var _Logger = _interopRequireDefault(__webpack_require__(/*! ../util/Logger.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Logger.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function isModelPropertySchema(obj) {
  return obj && obj.type || obj.deps;
}

/**
   * Archer.Model is a standard [Backbone.Model](http://backbonejs.org/#Model) with a few additions:
   *
   * - {@link src/framework/Model#derived Derived properties}
   * - {@link src/framework/Model#props Built in schema validation}
   * - {@link src/framework/Model#local Private properties (with schema validation)}
   * - {@link src/framework/Model#flat Flattening of nested objects}
   *
   * Both derived and private properties are filtered out when sending the data to the server.
   *
   * See [Backbone.Model](http://backbonejs.org/#Model-constructor).
   *
   * @class src/framework/Model
   * @extends external:Backbone.Model
   * @param {Object} [attributes] - Initial model attributes (data)
   * @param {Object} [options] - Options hash
   * @example
   * var Person = Archer.Model.extend({
   *   props: {
   *     'fname': 'string',
   *     'lname': 'string'
   *   },
   *   local: {
   *     isLoggedIn: 'boolean'
   *   },
   *   derived: {
   *     name: {
   *       deps: ['fname', 'lname'],
   *       fn: function (fname, lname) {
   *         return fname + ' ' + lname;
   *       }
   *     }
   *   }
   * });
   * var model = new Person({fname: 'Joe', lname: 'Doe'});
   * model.get('name'); //=> "Joe Doe"
   * model.toJSON(); //=> {fname: 'Joe', lname: 'Doe'}
   *
   * model.set('isLoggedIn', true);
   * model.get('isLoggedIn'); //=> true
   * model.toJSON(); //=> {fname: 'Joe', lname: 'Doe'}
   */
let Model;
const statics = {
  ERROR_BLANK: 'model.validation.field.blank',
  ERROR_WRONG_TYPE: 'model.validation.field.wrong.type',
  ERROR_NOT_ALLOWED: 'model.validation.field.value.not.allowed',
  ERROR_INVALID: 'model.validation.field.invalid',
  ERROR_IARRAY_UNIQUE: 'model.validation.field.array.unique',
  ERROR_INVALID_FORMAT_EMAIL: 'model.validation.field.invalid.format.email',
  ERROR_INVALID_FORMAT_URI: 'model.validation.field.invalid.format.uri',
  ERROR_INVALID_FORMAT_IPV4: 'model.validation.field.invalid.format.ipv4',
  ERROR_INVALID_FORMAT_HOSTNAME: 'model.validation.field.invalid.format.hostname',
  ERROR_STRING_STRING_MIN_LENGTH: 'model.validation.field.string.minLength',
  ERROR_STRING_STRING_MAX_LENGTH: 'model.validation.field.string.maxLength'
};
function flatten(value, objectTypeFields, key, target) {
  var filter = _underscoreWrapper.default.contains(objectTypeFields, key);
  target || (target = {});
  if (!filter && _underscoreWrapper.default.isObject(value) && !_underscoreWrapper.default.isArray(value) && !_underscoreWrapper.default.isFunction(value)) {
    _underscoreWrapper.default.each(value, function (val, i) {
      flatten(val, objectTypeFields, key ? key + '.' + i : i, target);
    });
  } // Case where target is an empty object. Guard against returning {undefined: undefined}.
  else if (key !== undefined) {
    target[key] = value;
  }
  return target;
}
function unflatten(data) {
  _underscoreWrapper.default.each(data, function (value, key, data) {
    if (key.indexOf('.') === -1) {
      return;
    }
    var part;
    var ref = data;
    var parts = key.split('.');
    while ((part = parts.shift()) !== undefined) {
      if (!ref[part]) {
        ref[part] = parts.length ? {} : value;
      }
      ref = ref[part];
    }
    delete data[key];
  });
  return data;
}
function createMessage(field, msg) {
  var obj = {};
  obj[field.name] = msg;
  return obj;
}
function normalizeSchemaDef(field, name) {
  var target;
  if (_underscoreWrapper.default.isString(field)) {
    target = {
      type: field
    };
  } else if (_underscoreWrapper.default.isArray(field)) {
    target = {
      type: field[0],
      required: field[1],
      value: field[2]
    };
  } else {
    target = _underscoreWrapper.default.clone(field);
  }
  _underscoreWrapper.default.defaults(target, {
    required: false,
    name: name
  });
  return target;
}
function capitalize(string) {
  return string.toLowerCase().replace(/\b[a-z]/g, function (letter) {
    return letter.toUpperCase();
  });
}
function _validateRegex(value, pattern, error) {
  if (!pattern.test(value)) {
    return error;
  }
}
var StringFormatValidators = {
  /*eslint max-len: 0 */
  email: function (value) {
    // Taken from  http://emailregex.com/ on 2017-03-06.
    var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return _validateRegex(value, pattern, Model.ERROR_INVALID_FORMAT_EMAIL);
  },
  uri: function (value) {
    // source: https://mathiasbynens.be/demo/url-regex
    var pattern = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;
    return _validateRegex(value, pattern, Model.ERROR_INVALID_FORMAT_URI);
  },
  ipv4: function (value) {
    // source: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    var pattern = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    return _validateRegex(value, pattern, Model.ERROR_INVALID_FORMAT_IPV4);
  },
  hostname: function (value) {
    // source: http://www.regextester.com/23
    var pattern = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/;
    return _validateRegex(value, pattern, Model.ERROR_INVALID_FORMAT_HOSTNAME);
  }
};
function validateStringFormat(field, value) {
  var validator = StringFormatValidators[field.format];
  if (field.format && !validator) {
    throw new TypeError(field.format + ' is not a supported string format');
  }
  return validator && validator(value);
}
function validateString(field, value) {
  var createMessageWith = _underscoreWrapper.default.partial(createMessage, field);
  var invalidFormat = validateStringFormat(field, value);
  if (invalidFormat) {
    return createMessageWith(invalidFormat);
  }
  if (value && field.minLength && value.length < field.minLength) {
    return createMessageWith(Model.ERROR_STRING_STRING_MIN_LENGTH);
  }
  if (value && field.maxLength && value.length > field.maxLength) {
    return createMessageWith(Model.ERROR_STRING_STRING_MAX_LENGTH);
  }
}
function validateField(field, value) {
  /* eslint complexity: [2, 25], max-statements: [2, 30] */
  var createMessageWith = _underscoreWrapper.default.partial(createMessage, field);
  var isDefined = !_underscoreWrapper.default.isUndefined(value) && !_underscoreWrapper.default.isNull(value);
  var checkType;
  var errorMessage; // If using an array validator, perform the validation

  if (Array.isArray(field.validate)) {
    const output = [];
    let foundError = false;
    let result;
    field.validate.forEach(item => {
      if (!value) {
        result = false;
      } else {
        switch (item.type.toLowerCase()) {
          case 'regex':
            result = new RegExp(item.value.pattern, item.value.flags || '').test(value);
            break;
          default:
            result = false;
        }
      } // Append the result.

      foundError = foundError || !result;
      output.push({
        // eslint-disable-next-line no-prototype-builtins
        message: item.hasOwnProperty('message') ? item.message : '',
        passed: result
      });
    });
    if (foundError) {
      return createMessageWith(output);
    }
    return;
  } // check required fields

  if (field.required && (!isDefined || _underscoreWrapper.default.isNull(value) || value === '')) {
    return createMessageWith(Model.ERROR_BLANK);
  } // check type

  checkType = _underscoreWrapper.default['is' + capitalize(field.type)];
  if (isDefined && field.type !== 'any' && (!_underscoreWrapper.default.isFunction(checkType) || !checkType(value))) {
    return createMessageWith(Model.ERROR_WRONG_TYPE);
  } // validate string format

  if (value && field.type === 'string') {
    var error = validateString(field, value);
    if (error) {
      return error;
    }
  } // check pre set values (enum)

  if (isDefined && field.values && !_underscoreWrapper.default.contains(field.values, value)) {
    return createMessageWith(Model.ERROR_NOT_ALLOWED);
  } // check validate method

  if (_underscoreWrapper.default.isFunction(field.validate)) {
    var result = field.validate(value);
    if (_underscoreWrapper.default.isString(result) && result) {
      return createMessageWith(result);
    } else if (result === false) {
      return createMessageWith(Model.ERROR_INVALID);
    }
  } // check array items
  // eslint-disable-next-line @typescript-eslint/no-use-before-define

  if (isDefined && field.type === 'array' && (errorMessage = validateArrayField(field, value))) {
    return createMessageWith(errorMessage);
  }
}
function validateArrayField(field, arr) {
  if (field.minItems && arr.length < field.minItems) {
    return 'model.validation.field.array.minItems';
  } else if (field.maxItems && arr.length > field.maxItems) {
    return 'model.validation.field.array.maxItems';
  } else if (field.uniqueItems && arr.length > _underscoreWrapper.default.uniq(arr).length) {
    return Model.ERROR_IARRAY_UNIQUE;
  } else if (field.items) {
    /* eslint max-depth: [2, 3] */
    var arrayField = normalizeSchemaDef(field.items, 'placeholder');
    for (var i = 0; i < arr.length; i++) {
      var value = arr[i];
      var error = validateField(arrayField, value);
      if (error) {
        return error['placeholder'];
      }
    }
  }
}
const props = /** @lends src/framework/Model.prototype */
{
  /**
     * Pass props as an object to extend, describing the observable properties of your model. The props
     * properties should not be set on an instance, as this won't define new properties, they should only be passed to
     * extend.
     * Properties can be defined in three different ways:
     *
     * - As a string with the expected dataType. One of string, number, boolean, array, object, date, or any.
     * Eg: `name: 'string'`.
     * - An array of `[dataType, required, default]`
     * - An object `{type: 'string', format: '', required: true, value: '', values: [], validate: function() {}`
     *   - `value` will be the value that the property will be set to if it is undefined, either by not being set during
     *   initialization, or by being explicitly set to undefined.
     *   - `format` is a json-schame derived string format. Supported formats are: `email`, `uri`, `hostname` and `ipv4`.
     *   - If `required` is true, one of two things will happen. If a default is set for the property, the property will
     *   start with that value. If a default is not set for the property, validation will fail
     *   - If `values` array is passed, then you'll be able to change a property to one of those values only.
     *   - If `validate` is defined, it should return false or a custom message string when the validation fails.
     *   - If the type is defined as `array`, the array elements could be defined by `minItems` (Number),
     *   `uniqueItems` (Boolean) and `items` (a field definition such as this one that will validate each array member)
     *   To the `validate` method
     *   - Trying to set a property to an invalid type will raise an exception.
     *
     * @type {Mixed|Function}
     * @example
     * var Person = Model.extend({
     *   props: {
     *     name: 'string',
     *     age: 'number',
     *     paying: ['boolean', true, false], //required attribute, defaulted to false
     *     type: {
     *       type: 'string',
     *       values: ['regular-hero', 'super-hero', 'mega-hero']
     *     },
     *     likes: {
     *       type: 'string',
     *       validate: function (value) {
     *         return /^[\w]+ing$/.test(value)
     *       }
     *     }
     *   }
     * });
     */
  props: {},
  /**
     * Derived properties (also known as computed properties) are properties of the model that depend on the
     * other (props, local or even derived properties to determine their value. Best demonstrated with an example:
     *
     * Each derived property, is defined as an object with the current properties:
     *
     * - `deps` {Array} - An array of property names which the derived property depends on.
     * - `fn` {Function} - A function which returns the value of the computed property. It is called in the context of
     * the current object, so that this is set correctly.
     * - `cache` {Boolean} -  - Whether to cache the property. Uncached properties are computed every time they are
     * accessed. Useful if it depends on the current time for example. Defaults to `true`.
     *
     * Derived properties are retrieved and fire change events just like any other property. They cannot be set
     * directly.
     * @type {Object|Function}
     * @example
     * var Person = Model.extend({
     *   props: {
     *     firstName: 'string',
     *     lastName: 'string'
     *   },
     *   derived: {
     *     fullName: {
     *       deps: ['firstName', 'lastName'],
     *       fn: function (firstName, lastName) {
     *         return firstName + ' ' + lastName;
     *       }
     *     }
     *   }
     * });
     *
     * var person = new Person({ firstName: 'Phil', lastName: 'Roberts' })
     * console.log(person.get('fullName')) //=> "Phil Roberts"
     *
     * person.set('firstName', 'Bob');
     * console.log(person.get('fullName')) //=> "Bob Roberts"
     */
  derived: {},
  /**
     * local properties are defined and work in exactly the same way as {@link src/framework/Model#props|props}, but generally only exist for
     * the lifetime of the page.
     * They would not typically be persisted to the server, and are not returned by calls to {@link src/framework/Model#toJSON|toJSON}.
     *
     * @type {Object|Function}
     * @example
     * var Person = Model.extend({
     *   props: {
     *     name: 'string',
     *   },
     *   local: {
     *     isLoggedIn: 'boolean'
     *   }
     * );
     */
  local: {},
  /**
     * Flatten the payload into dot notation string keys:
     *
     * @type {Boolean|Function}
     * @example
     * var Person = Model.extend({
     *   props: {
     *     'profile.fname': 'string',
     *     'profile.lname': 'string',
     *     'profile.languages': 'object'
     *   },
     *   flat: true
     * });
     * var person = new Person({'profile': {
     *                            'fname': 'John',
     *                            'lname': 'Doe',
     *                            'languages': {name: "English", value: "EN"}
     *                         }}, {parse: true});
     * person.get('profile'); //=> undefined
     * person.get('profile.fname'); //=> 'John'
     * person.get('profile.lname'); //=> 'Doe'
     * person.get('profile.languages'); //=> {name: "English", value: "EN"}
     * person.get('profile.languages.name'); //=> undefined
     * person.toJSON(); //=> {'profile': {'fname': 'John'} }
     */
  flat: true,
  /**
     * @deprecated
     * @alias Backbone.Model#defaults
     */
  defaults: {},
  // FIXME: preinitialize takes parameter `attributes` and `options`, which inherit from constructor.
  preinitialize: function (options, ...rest) {
    this.options = options || {};
    var schema = this['__schema__'] = {};
    var objectTypeFields = [];
    schema.computedProperties = {};
    schema.props = _underscoreWrapper.default.clone(_underscoreWrapper.default.result(this, 'props') || {});
    schema.derived = _underscoreWrapper.default.clone(_underscoreWrapper.default.result(this, 'derived') || {});
    schema.local = _underscoreWrapper.default.clone(_underscoreWrapper.default.result(this, 'local') || {});
    var defaults = {};
    _underscoreWrapper.default.each(_underscoreWrapper.default.extend({}, schema.props, schema.local), function (options, name) {
      var schemaDef = normalizeSchemaDef(options, name);
      if (!_underscoreWrapper.default.isUndefined(schemaDef.value)) {
        defaults[name] = schemaDef.value;
      }
      if (schemaDef.type === 'object') {
        objectTypeFields.push(name);
      }
    }, this);
    if (_underscoreWrapper.default.size(defaults)) {
      var localDefaults = _underscoreWrapper.default.result(this, 'defaults');
      this.defaults = function () {
        return _underscoreWrapper.default.defaults({}, defaults, localDefaults);
      };
    } // override `validate`

    this.validate = _underscoreWrapper.default.wrap(this.validate, function (validate) {
      var args = _underscoreWrapper.default.rest(arguments);
      var res = _underscoreWrapper.default.extend(this._validateSchema.apply(this, args), validate.apply(this, args));
      return _underscoreWrapper.default.size(res) && res || undefined;
    }); // override `parse`

    this.parse = _underscoreWrapper.default.wrap(this.parse, function (parse) {
      var target = parse.apply(this, _underscoreWrapper.default.rest(arguments));
      if (_underscoreWrapper.default.result(this, 'flat')) {
        target = flatten(target, objectTypeFields);
      }
      return target;
    });
    _backbone.default.Model.prototype.preinitialize.call(this, options, ...rest);
  },
  // FIXME:
  // constructor takes parameter `attributes` and `options`.
  constructor: function () {
    _backbone.default.Model.apply(this, arguments);
    var schema = this['__schema__'];
    _underscoreWrapper.default.each(schema.derived, function (options, name) {
      schema.computedProperties[name] = this.__getDerivedValue(name); // set initial value;

      var deps = isModelPropertySchema(options) ? options.deps || [] : [];
      if (deps.length) {
        this.on('cache:clear change:' + deps.join(' change:'), function () {
          var value = this.__getDerivedValue(name);
          if (value !== schema.computedProperties[name]) {
            schema.computedProperties[name] = value;
            this.trigger('change:' + name, this, value);
          }
        }, this);
      }
    }, this);
    this.on('sync', function () {
      this.__syncedData = this.toJSON();
    }, this);
  },
  validate: function () {},
  /**
     * Check if the schema settings allow this field to exist in the model
     * @param  {String} key
     * @return {Boolean}
     */
  allows: function (key) {
    var schema = this['__schema__'];
    var all = _underscoreWrapper.default.extend({}, schema.props, schema.local);
    if (!_underscoreWrapper.default.has(all, key)) {
      _Logger.default.warn('Field not defined in schema', key);
    }
    return true;
  },
  /**
     * Returns the schema for the specific property
     *
     * @param propName - The name of the property
     * @returns {*} | null
     */
  getPropertySchema: function (propName) {
    var schema = this['__schema__'];
    return _underscoreWrapper.default.reduce([schema.props, schema.local], function (result, options) {
      return result || normalizeSchemaDef(options[propName], propName);
    }, null);
  },
  set: function (key, val) {
    var attrs;
    if (typeof key === 'object') {
      attrs = key;
    } else {
      (attrs = {})[key] = val;
    } // Don't override a computed properties

    _underscoreWrapper.default.each(attrs, function (value, key) {
      if (_underscoreWrapper.default.has(this['__schema__'].derived, key)) {
        throw new Error(`overriding derived properties is not supported: ${key}`);
      }
    }, this); // Schema validation

    var errorFields = [];
    _underscoreWrapper.default.each(attrs, function (value, key) {
      this.allows(key) || errorFields.push(key);
    }, this);
    if (errorFields.length) {
      throw new Error(`field not allowed: ${errorFields.join(', ')}`);
    }
    return _backbone.default.Model.prototype.set.apply(this, arguments);
  },
  get: function (attr) {
    var schema = this['__schema__'];
    if (_underscoreWrapper.default.has(schema.derived, attr)) {
      if (schema.derived[attr].cache !== false) {
        return schema.computedProperties[attr];
      } else {
        return this.__getDerivedValue(attr);
      }
    }
    return _backbone.default.Model.prototype.get.apply(this, arguments);
  },
  /**
     * Return a shallow copy of the model's attributes for JSON stringification.
     * This can be used for persistence, serialization, or for augmentation before being sent to the server.
     * The name of this method is a bit confusing, as it doesn't actually return a JSON string —
     * but I'm afraid that it's the way that the JavaScript API for JSON.stringify works.
     *
     * See [Backbone.Model.toJSON](http://backbonejs.org/#Model-toJSON)
     *
     * @param  {Object} options
     * @return {Object}
     * @example
     * var artist = new Model({
     *   firstName: 'Wassily',
     *   lastName: 'Kandinsky'
     * });
     *
     * artist.set({birthday: 'December 16, 1866'});
     * JSON.stringify(artist); //=> {'firstName':'Wassily','lastName':'Kandinsky','birthday':'December 16, 1866'}
     */
  toJSON: function (options) {
    options || (options = {});
    var res = _underscoreWrapper.default.clone(_backbone.default.Model.prototype.toJSON.apply(this, arguments));
    var schema = this['__schema__']; // cleanup local properties

    if (!options.verbose) {
      res = _underscoreWrapper.default.omit(res, _underscoreWrapper.default.keys(schema.local));
    } else {
      // add derived properties
      _underscoreWrapper.default.each(schema.derived, function (options, name) {
        res[name] = this.get(name);
      }, this);
    }
    if (this.flat) {
      res = unflatten(res);
    }
    return res;
  },
  /**
     * Removes all attributes from the model, including the id attribute.
     * Fires a `"change"` event unless `silent` is passed as an option.
     * Sets the default values to the model
     * @param {Object} [options]
     */
  reset: function (options) {
    this.clear(options);
    this.set(_underscoreWrapper.default.result(this, 'defaults'), options);
  },
  /**
     * Is the data on the model has local modifications since the last sync event?
     * @return {Boolean} is the model in sync with the server
     */
  isSynced: function () {
    return _underscoreWrapper.default.isEqual(this.__syncedData, this.toJSON());
  },
  /**
     * validate a specific field in the model.
     * @param  {String} key
     * @return {Object} returns `{fieldName: errorMessage}` if invalid, otherwise undefined.
     * @readonly
     */
  validateField: function (key) {
    var schema = key && this.getPropertySchema(key);
    return schema && validateField(schema, this.get(key));
  },
  /**
     * Runs local schema validation. Invoked internally by {@link src/framework/Model#validate|validate}.
     * @return {Object}
     * @protected
     */
  _validateSchema: function () {
    var schema = this['__schema__'];
    return _underscoreWrapper.default.reduce(_underscoreWrapper.default.extend({}, schema.props, schema.local), function (memo, options, name) {
      return _underscoreWrapper.default.extend(memo, this.validateField(name) || {});
    }, {}, this);
  },
  __getDerivedValue: function (name) {
    var options = this['__schema__'].derived[name];
    if (_underscoreWrapper.default.isString(options)) {
      var key = options;
      options = {
        deps: [key],
        fn: function () {
          return this.get(key);
        }
      };
    }
    var deps = options.deps || [];
    return options.fn.apply(this, _underscoreWrapper.default.map(deps, this.get, this));
  }
};
Model = _backbone.default.Model.extend(props, statics);
/**
 * It's used for distinguishing the ambiguity from _.isFunction()
 * which returns True for both a JavaScript Class constructor function
 * and normal function. With this flag, we can tell a function is actually
 * a Model Class.
 * This flag is added in order to support the type of a parameter can be
 * either a Class or pure function that returns a Class.
 */

Model.isCourageModel = true;
var FrameworkModel = Model;
exports["default"] = FrameworkModel;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/framework/View.js":
/*!***********************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/framework/View.js ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _backbone = _interopRequireDefault(__webpack_require__(/*! ../vendor/lib/backbone.js */ "./packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CHILDREN = '__children__';
var RENDERED = '__rendered__';
var PARENT = '__parent__';
var CHILD_DEFINITIONS = '__children_definitions__';
var ADD_TO_CONTAINER = '__add_to_container__';
function getIndex(container, view) {
  for (var i = 0; i < container[CHILDREN].length; i++) {
    if (view.cid === container[CHILDREN][i].cid) {
      return i;
    }
  }
}
function noop() {}
function doRender(view) {
  view[RENDERED] = true;
  var html = view.renderTemplate(view.template);
  if (html) {
    view.$el.html(html);
  } else if (view.length) {
    view.$el.empty();
  }
  view.each(function (view) {
    view[ADD_TO_CONTAINER]();
  });
}
function subscribeEvents(view) {
  var isEventPropertyRe = /^(?!(?:delegate|undelegate|_))([a-zA-Z0-9]+)(?:Events)$/;
  _underscoreWrapper.default.each(_underscoreWrapper.default.allKeys(view), function (key) {
    var matchKeys = key.match(isEventPropertyRe);
    if (!matchKeys) {
      return;
    }
    var bindings = _underscoreWrapper.default.result(view, key);
    var entity = view.options[matchKeys[1]] || view[matchKeys[1]];
    if (!entity || !_underscoreWrapper.default.isObject(bindings) || !_underscoreWrapper.default.isFunction(entity.trigger)) {
      return;
    }
    _underscoreWrapper.default.each(bindings, function (callback, event) {
      var callbacks = _underscoreWrapper.default.isFunction(callback) ? [callback] : _underscoreWrapper.default.reduce(callback.split(/\s+/), (arr, name) => {
        if (_underscoreWrapper.default.isFunction(view[name])) {
          arr.push(view[name]);
        }
        return arr;
      }, []);
      _underscoreWrapper.default.each(callbacks, function (cb) {
        view.listenTo(entity, event, cb);
      });
    });
  });
}
/**
   * A View operates on a string template, an token based template, or a model based template, with a few added hooks.
   * It provides a collection of child views, when a child view could be a View or another View.
   * Conceptually, if we were in a file system, the View is a folder, when the concrete child views are files,
   * and the child Views are sub folders.
   *
   * *Technically, when using a View as a container, it could have its own concrete logic,
   * but conceptually we like to keep it separated so a view is either a concrete view or a collection of child views.*
   *
   * In addition to the standard backbone options, we added `settings` and `state` as first class options.
   * it will automatically assign `options` to `this.options` as an instance member.
   *
   * See [Backbone.View](http://backbonejs.org/#View).
   *
   * @class src/framework/View
   * @extends external:Backbone.View
   * @param {Object} [options] options hash
   * @example
   * var DocumentView = Archer.View.extend({
   *   template: [
   *     '<header></header>',
   *     '<article></article>',
   *     '<footer></footer>'
   *   ].join(''),
   *   children: [[HeaderView, 'header'], [ContentView, 'article'], [FooterView, 'footer']]
   * });
   */

let View;
const proto = {
  /**
     * An object listing events and callback bind to this.{entity}
     * @name *Events
     * @memberof src/framework/View
     * @type {(Object|Function)}
     * @instance
     * @example
     * var FooView = View.extend({
     *   modelEvents: {
     *     'change:name': 'render'
     *   }
     * })
     * //equivalent to ==>
     * var FooView = View.extend({
     *   initialize: function() {
     *     this.listenTo(this.model, 'change:name', this.render);
     *   }
     * });
     *
     *
     * //Multiple callbacks:
     * var FooView = View.extend({
     *   modelEvents: {
     *     'change:name': 'render foo'
     *   },
     *   foo: function() {}
     * });
     *
     * //Callbacks As Function:
     * var FooView = View.extend({
     *   stateEvents: {
     *     'change': function() {
     *   }
     * });
     *
     * //Event Configuration As Function
     * var FooView = View.extend({
     *   collectionEvents: function() {
     *     var events = { 'change:name deleteItem': 'render' };
     *     events['changeItem'] = 'spin';
     *     events['addItem'] = function() {};
     *     return events;
     *   }
     * });
     */
  preinitialize: function (options) {
    /* eslint max-statements: [2, 17] */
    this.options = options || {};
    _underscoreWrapper.default.extend(this, _underscoreWrapper.default.pick(this.options, 'state', 'settings')); // init per-instance children collection

    this[CHILDREN] = [];
    this[RENDERED] = false;
    this[PARENT] = null;
    this[CHILD_DEFINITIONS] = this.children; // we want to make sure initialize is triggered *after* we append the views from the `this.views` array
    // FIXME:
    // It's actually can be done by override initialize method
    //  initialize() { run extra login; super.initialize(); }
    // BUT the problem is child classes would override initialize without invoke super.
    // hence we have to also looking into (refactoring) ALL child classes.

    this.__original_initialize__ = this.initialize;
    this.initialize = noop;
  },
  constructor: function (options, ...rest) {
    _backbone.default.View.call(this, options);
    _underscoreWrapper.default.each(_underscoreWrapper.default.result(this, CHILD_DEFINITIONS), function (childDefinition) {
      this.add.apply(this, _underscoreWrapper.default.isArray(childDefinition) ? childDefinition : [childDefinition]);
    }, this);
    delete this[CHILD_DEFINITIONS];
    const autoRender = _underscoreWrapper.default.result(this, 'autoRender');
    if (autoRender && this.model) {
      var event = _underscoreWrapper.default.isArray(autoRender) ? _underscoreWrapper.default.map(autoRender, function (field) {
        return 'change:' + field;
      }).join(' ') : 'change';
      this.listenTo(this.model, event, function () {
        this.render();
      });
    }
    this.initialize = this.__original_initialize__;
    this.initialize.call(this, options, ...rest); // initialize in child class may have any number of parameters

    subscribeEvents(this);
  },
  /**
     * Unregister view from container
     * Note: this will not remove the view from the dom
     * and will not call the `remove` method on the view
     *
     * @param {src/framework/View} view the view to unregister
     * @private
     */
  unregister: function (view) {
    this.stopListening(view);
    var viewIndex = getIndex(this, view); // viewIndex is undefined when the view is not found (may have been removed)
    // check if it is undefined to prevent unexpected thing to happen
    // array.splice(undefined, x) removes the first x element(s) from the array
    // this protects us against issues when calling `remove` on a child view multiple times

    if (_underscoreWrapper.default.isNumber(viewIndex)) {
      this[CHILDREN].splice(viewIndex, 1);
    }
  },
  /**
     * Should we auto render the view upon model change. Boolean or array of field names to listen to.
     * @type {Boolean|Array}
     * @deprecated Instead, please use modelEvents
     * @example
     * modelEvents: {
     *   change:name: 'render'
     * }
     */
  autoRender: false,
  /**
     *
     * When the template is an underscore template, the render method will pass the options has to the template
     * And the associated model, if exists, when it will prefer the model over the options in case of a conflict.
     * {@link #render View.render}
     * @type {(String|Function)}
     * @example
     * var View = View.extend({
     *   template: '<p class="name">{{name}}</p>'
     * };
     */
  template: null,
  /**
     * A list of child view definitions to be passed to {@link #add this.add()}.
     * Note: these definitions will be added **before** the {@link #constructor initiliaze} method invokes.
     * @type {(Array|Function)}
     * @example
     * var Container = View.extend({
     *    template: '<p class="content"></p>',
     *    children: [
     *      [ContentView, '.content'],
     *      [OtherContentView, '.content'],
     *      OtherView
     *    ]
     *  })
     *
     * var Container = View.extend({
     *    template: '<dov class="form-wrap"></div>',
     *    children: function () {
     *      return [
     *        [FormView, '.form-wrap', {options: {model: this.optiosn.otherModel}}]
     *      ]
     *    }
     *  })
     */
  children: [],
  /**
     * Add a child view to the container.
     * If the container is already rendered, will also render the view  and append it to the DOM.
     * Otherwise will render and append once the container is rendered.
     *
     * *We believe that for the sake of encapsulation, a view should control its own chilren, so we treat this method as
     * protected and even though technically you can call `view.add` externally we strongly discourage it.*
     *
     * @param {(src/framework/View|String)} view A class (or an instance which is discouraged) of a View - or an HTML
     * string/template
     * @param {String} [selector] selector in the view's template on which the view will be added to
     * @param {Object} [options]
     * @param {Boolean} [options.bubble=false] Bubble (proxy) events from this view up the chain
     * @param {Boolean} [options.prepend=false] Prepend the view instend of appending
     * @param {String} [options.selector] Selector in the view's template on which the view will be added to
     * @param {Object} [options.options] Extra options to pass to the child constructor
     * @protected
     * @returns {src/framework/View} - The instance of itself for the sake of chaining
     * @example
     * var Container = View.extend({
     *
     *   template: [
     *     '<h1></h1>',
     *     '<section></section>',
     *   ].join(''),
     *
     *   initalize: function () {
     *
     *     this.add(TitleView, 'h1'); // will be added to <h1>
     *
     *     this.add(ContentView1, 'section'); // will be added to <section>
     *
     *     this.add(ContentView2, 'section', {prepend: true}); // will be add into <section> **before** ContentView1
     *
     *     this.add(OtherView, {
     *       options: {
     *         model: new Model()
     *       }
     *     }); // will be added **after** the <section> element
     *
     *     this.add('<p class="name">some html</p>'); //=> "<p class="name">some html</p>"
     *     this.add('<p class="name">{{name}}</p>'); //=> "<p class="name">John Doe</p>"
     *     this.add('{{name}}') //=> "<div>John Doe</div>"
     *     this.add('<span>{{name}}</span> w00t') //=> "<div><span>John Doe</span> w00t</div>"
     *   }
     *
     * });
     *
     * var container - new View({name: 'John Doe'});
     */
  add: function (view, selector, bubble, prepend, extraOptions) {
    /* eslint max-statements: [2, 30], complexity: [2, 12] */
    var options = {};
    var args = _underscoreWrapper.default.toArray(arguments); // This will throw if a compiled template function is passed accidentally

    if (_underscoreWrapper.default.isFunction(view) && (!view.prototype || !view.prototype.render)) {
      throw new Error('Type passed to add() is not a View');
    }
    if (_underscoreWrapper.default.isObject(selector)) {
      options = selector;
      selector = options.selector;
      bubble = options.bubble;
      prepend = options.prepend;
      extraOptions = options.options;
    } else if (_underscoreWrapper.default.isObject(bubble)) {
      options = bubble;
      bubble = options.bubble;
      prepend = options.prepend;
      extraOptions = options.options;
    } // TODO: This will be deprecated at some point. Views should use precompiled templates

    if (_underscoreWrapper.default.isString(view)) {
      view = function (template) {
        return View.extend({
          constructor: function () {
            try {
              var $el = _backbone.default.$(template);
              if ($el.length !== 1) {
                throw new Error('invalid Element');
              }
              var unescapingRexExp = /&(\w+|#x\d+);/g;
              var elementUnescapedOuterHTMLLength = $el.prop('outerHTML').replace(unescapingRexExp, ' ').length;
              var templateUnescapedLength = template.replace(unescapingRexExp, ' ').length;
              if (elementUnescapedOuterHTMLLength !== templateUnescapedLength) {
                throw new Error('invalid Element');
              }
              this.template = $el.html(); // Template string will be compiled by handlebars

              this.el = $el.empty()[0];
            } catch (e) {
              // not a valid html tag.
              this.template = template;
            }
            View.apply(this, arguments);
          }
        });
      }(view);
    }
    if (view.prototype && view.prototype instanceof View) {
      /* eslint new-cap: 0 */
      var viewOptions = _underscoreWrapper.default.omit(_underscoreWrapper.default.extend({}, this.options, extraOptions), 'el');
      args[0] = new view(viewOptions);
      return this.add.apply(this, args);
    } // prevent dups

    if (_underscoreWrapper.default.isNumber(getIndex(this, view))) {
      throw new Error('Duplicate child');
    }
    view[PARENT] = this; // make the view responsible for adding itself to the parent:
    // * register the selector in the closure
    // * register a reference the parent in the closure

    view[ADD_TO_CONTAINER] = function (selector) {
      return function () {
        if (selector && view[PARENT].$(selector).length !== 1) {
          throw new Error('Invalid selector: ' + selector);
        }
        var $el = selector ? this[PARENT].$(selector) : this[PARENT].$el;
        this.render(); // we need to delegate events in case
        // the view was added and removed before

        this.delegateEvents(); // this[PARENT].at(index).$el.before(this.el);

        prepend ? $el.prepend(this.el) : $el.append(this.el);
      };
    }.call(view, selector); // if flag to bubble events is set
    // proxy all child view events

    if (bubble) {
      this.listenTo(view, 'all', function () {
        this.trigger.apply(this, arguments);
      });
    } // add to the dom if `render` has been called

    if (this.rendered()) {
      view[ADD_TO_CONTAINER]();
    } // add view to child views collection

    this[CHILDREN].push(view);
    return this;
  },
  /**
     * Remove all children from container
     */
  removeChildren: function () {
    this.each(function (view) {
      view.remove();
    });
    return this;
  },
  /**
     *  Removes a view from the DOM, and calls stopListening to remove any bound events that the view has listenTo'd.
     *  Also removes all childern of the view if any, and removes itself from its parent view(s)
     */
  remove: function () {
    this.removeChildren();
    if (this[PARENT]) {
      this[PARENT].unregister(this);
    }
    return _backbone.default.View.prototype.remove.apply(this, arguments);
  },
  /**
     * Compile the template to function you can apply tokens on on render time.
     * Uses the underscore tempalting engine by default
     * @protected
     * @param  {String} template
     * @return {Function} a compiled template
     */
  // TODO: This will be deprecated at some point. Views should use precompiled templates
  compileTemplate: function (template) {
    /* eslint  @okta/okta-ui/no-specific-methods: 0*/
    return _underscoreWrapper.default.template(template, undefined);
  },
  /**
     * Render a template with `this.model` and `this.options` as parameters
     * preferring the model over the options.
     *
     * @param  {(String|Function)} template The template to build
     * @return {String} An HTML string
     * @protected
     */
  renderTemplate: function (template) {
    if (_underscoreWrapper.default.isString(template)) {
      // TODO: This will be deprecated at some point. Views should use precompiled templates
      template = this.compileTemplate(template);
    }
    if (_underscoreWrapper.default.isFunction(template)) {
      return template(this.getTemplateData());
    }
  },
  /**
     * The data hash passed to the compiled template
     * @return {Object}
     * @protected
     */
  getTemplateData: function () {
    var modelData = this.model && this.model.toJSON({
      verbose: true
    }) || {};
    var options = _underscoreWrapper.default.omit(this.options, ['state', 'settings', 'model', 'collection']);
    return _underscoreWrapper.default.defaults({}, modelData, options);
  },
  /**
     * Renders the template to `$el` and append all children in order
     * {@link #template View.template}
     */
  render: function () {
    this.preRender();
    doRender(this);
    this.postRender();
    return this;
  },
  /**
     * Pre render routine. Will be called right *before* the logic in {@link #render} is executed
     * @method
     */
  preRender: noop,
  /**
     * Post render routine. Will be called right *after* the logic in {@link #render} is executed
     * @method
     */
  postRender: noop,
  /**
     * Was this instance rendered
     */
  rendered: function () {
    return this[RENDERED];
  },
  /**
     * Get all direct child views.
     * @returns {src/framework/View[]}
     * @example
     * var container = View.extend({
     *   children: [View1, View2]
     * }).render();
     * container.getChildren() //=> [view1, view2];
     */
  getChildren: function () {
    return this.toArray();
  },
  /**
     * Get a child by index
     * @param {number} index
     * @returns {src/framework/View} The child view
     */
  at: function (index) {
    return this.getChildren()[index];
  },
  /**
     * Invokes a method on all children down the tree
     *
     * @param {String} method The method to invoke
     */
  invoke: function (methodName) {
    var args = _underscoreWrapper.default.toArray(arguments);
    this.each(function (child) {
      // if child has children, bubble down the tree
      if (child.size()) {
        child.invoke.apply(child, args);
      } // run the function on the child

      if (_underscoreWrapper.default.isFunction(child[methodName])) {
        child[methodName].apply(child, args.slice(1));
      }
    });
    return this;
  }
};
View = _backbone.default.View.extend( /** @lends src/framework/View.prototype */
proto); // Code borrowed from Backbone.js source
// Underscore methods that we want to implement on the Container.

var methods = ['each', 'map', 'reduce', 'reduceRight', 'find', 'filter', 'reject', 'every', 'some', 'contains', 'toArray', 'size', 'first', 'initial', 'rest', 'last', 'without', 'indexOf', 'shuffle', 'lastIndexOf', 'isEmpty', 'chain', 'where', 'findWhere'];
_underscoreWrapper.default.each(methods, function (method) {
  View.prototype[method] = function () {
    var args = _underscoreWrapper.default.toArray(arguments);
    args.unshift(_underscoreWrapper.default.toArray(this[CHILDREN]));
    return _underscoreWrapper.default[method].apply(_underscoreWrapper.default, args);
  };
});
/**
   * See [_.each](http://underscorejs.org/#each)
   * @name each
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} iterator
   * @param {Object} [context]
   */

/**
   * See [_.map](http://underscorejs.org/#map)
   * @name map
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} iterator
   * @param {Object} [context]
   */

/**
   * See [_.reduce](http://underscorejs.org/#reduce)
   * @name reduce
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} iterator
   * @param {Mixed} memo
   * @param {Object} [context]
   */

/**
   * See [_.reduceRight](http://underscorejs.org/#reduceRight)
   * @name reduceRight
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} iterator
   * @param {Mixed} memo
   * @param {Object} [context]
   */

/**
   * See [_.find](http://underscorejs.org/#find)
   * @name find
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} predicate
   * @param {Object} [context]
   */

/**
   * See [_.filter](http://underscorejs.org/#filter)
   * @name filter
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} predicate
   * @param {Object} [context]
   */

/**
   * See [_.reject](http://underscorejs.org/#reject)
   * @name reject
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} predicate
   * @param {Object} [context]
   */

/**
   * See [_.every](http://underscorejs.org/#every)
   * @name every
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} [predicate]
   * @param {Object} [context]
   */

/**
   * See [_.some](http://underscorejs.org/#some)
   * @name some
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} [predicate]
   * @param {Object} [context]
   */

/**
   * See [_.contains](http://underscorejs.org/#contains)
   * @name contains
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Mixed} value
   */

/**
   * See [_.toArray](http://underscorejs.org/#toArray)
   * @name toArray
   * @memberof src/framework/View
   * @method
   * @instance
   */

/**
   * See [_.size](http://underscorejs.org/#size)
   * @name size
   * @memberof src/framework/View
   * @method
   * @instance
   */

/**
   * See [_.first](http://underscorejs.org/#first)
   * @name first
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Number} [n]
   */

/**
   * See [_.initial](http://underscorejs.org/#initial)
   * @name initial
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Number} [n]
   */

/**
   * See [_.last](http://underscorejs.org/#last)
   * @name last
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Number} [n]
   */

/**
   * See [_.rest](http://underscorejs.org/#rest)
   * @name rest
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Number} [index]
   */

/**
   * See [_.without](http://underscorejs.org/#without)
   * @name without
   * @memberof src/framework/View
   * @method
   * @instance
   */

/**
   * See [_.indexOf](http://underscorejs.org/#indexOf)
   * @name indexOf
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Mixed} value
   * @param {Boolean} [isSorted]
   */

/**
   * See [_.shuffle](http://underscorejs.org/#shuffle)
   * @name shuffle
   * @memberof src/framework/View
   * @method
   * @instance
   */

/**
   * See [_.shuffle](http://underscorejs.org/#lastIndexOf)
   * @name lastIndexOf
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Mixed} value
   * @param {Number} [fromIndex]
   */

/**
   * See [_.isEmpty](http://underscorejs.org/#isEmpty)
   * @name isEmpty
   * @memberof src/framework/View
   * @method
   * @instance
   */

/**
   * See [_.chain](http://underscorejs.org/#chain)
   * @name chain
   * @memberof src/framework/View
   * @method
   * @instance
   */

/**
   * See [_.where](http://underscorejs.org/#where)
   * @name where
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Object} properties
   */

/**
   * See [_.findWhere](http://underscorejs.org/#findWhere)
   * @name findWhere
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Object} properties
   */

/**
 * It's used for distinguishing the ambiguity from _.isFunction()
 * which returns True for both a JavaScript Class constructor function
 * and normal function. With this flag, we can tell a function is actually
 * a View Class.
 * This flag is added in order to support the type of a parameter can be
 * either a Class or pure function that returns a Class.
 */

View.isCourageView = true;
var FrameworkView = View;
exports["default"] = FrameworkView;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/models/BaseCollection.js":
/*!******************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/models/BaseCollection.js ***!
  \******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _Collection = _interopRequireDefault(__webpack_require__(/*! ../framework/Collection.js */ "./packages/@okta/courage-dist/esm/src/courage/framework/Collection.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const baseCollectionProps = /** @lends module:Okta.Collection.prototype */
{
  /**
   * Is the end point using the legacy "secureJSON" format
   * @type {Function|Boolean}
   */
  secureJSON: false,
  // TODO: may not be simplily moved to initialize as
  // child class override initialize but didn't invoke parent.initialize.
  // need to refactor child classes first.
  constructor: function () {
    _Collection.default.apply(this, arguments);
    if (_underscoreWrapper.default.result(this, 'secureJSON')) {
      this.sync = _underscoreWrapper.default.wrap(this.sync, function (sync, method, collection, options) {
        return sync.call(this, method, collection, _underscoreWrapper.default.extend({
          dataType: 'secureJSON'
        }, options));
      });
    }
  }
};
/**
 * Wrapper around the more generic {@link src/framework/Collection} that
 * contains Okta-specific logic.
 * @class module:Okta.Collection
 * @extends src/framework/Collection
 */

var BaseCollection = _Collection.default.extend(baseCollectionProps);
exports["default"] = BaseCollection;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js":
/*!*************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js ***!
  \*************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _Model = _interopRequireDefault(__webpack_require__(/*! ./Model.js */ "./packages/@okta/courage-dist/esm/src/courage/models/Model.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const hasProps = function (model) {
  const local = _underscoreWrapper.default.omit(model.local, _underscoreWrapper.default.keys(model._builtInLocalProps));
  return _underscoreWrapper.default.size(model.props) + _underscoreWrapper.default.size(local) > 0;
};
const props = /** @lends module:Okta.BaseModel.prototype */
{
  /**
   * @type {Boolean}
   */
  flat: false,
  constructor: function () {
    _Model.default.apply(this, arguments);
    this.on('sync', this._setSynced);
  },
  allows: function () {
    if (hasProps(this)) {
      return _Model.default.prototype.allows.apply(this, arguments);
    } else {
      return true;
    }
  },
  // bw compatibility support for old computed properties
  set: function (key, val) {
    let attrs;
    if (typeof key === 'object') {
      attrs = key;
    } else {
      (attrs = {})[key] = val;
    } // computed properties

    (0, _underscoreWrapper.default)(attrs).each(function (fn, attr) {
      if (!fn || !_underscoreWrapper.default.isArray(fn.__attributes)) {
        return;
      }
      this.on('change:' + fn.__attributes.join(' change:'), function () {
        const val = this.get(attr);
        if (val !== this['__schema__'].computedProperties[attr]) {
          this['__schema__'].computedProperties[attr] = val;
          this.trigger('change:' + attr, val);
        }
      }, this);
    }, this);
    return _Model.default.prototype.set.apply(this, arguments);
  },
  /**
   * Get the current value of an attribute from the model. For example: `note.get("title")`
   *
   * See [Model.get](http://backbonejs.org/#Model-get)
   * @param {String} attribute
   * @return {Mixed} The value of the model attribute
   */
  get: function () {
    const value = _Model.default.prototype.get.apply(this, arguments);
    if (_underscoreWrapper.default.isFunction(value)) {
      return value.apply(this, _underscoreWrapper.default.map(value.__attributes || [], this.get, this));
    }
    return value;
  },
  /**
   * Return a shallow copy of the model's attributes for JSON stringification.
   * This can be used for persistence, serialization, or for augmentation before being sent to the server.
   * The name of this method is a bit confusing, as it doesn't actually return a JSON string —
   *  but I'm afraid that it's the way that the JavaScript API for JSON.stringify works.
   *
   * ```javascript
   * var artist = new Model({
   *   firstName: "Wassily",
   *   lastName: "Kandinsky"
   * });
   *
   * artist.set({birthday: "December 16, 1866"});
   * alert(JSON.stringify(artist)); // {"firstName":"Wassily","lastName":"Kandinsky","birthday":"December 16, 1866"}
   * ```
   * See [Model.toJSON](http://backbonejs.org/#Model-toJSON)
   * @param  {Object} options
   * @return {Object}
   */
  toJSON: function (options) {
    options || (options = {});
    const res = _Model.default.prototype.toJSON.apply(this, arguments); // cleanup computed properties

    (0, _underscoreWrapper.default)(res).each(function (value, key) {
      if (typeof value === 'function') {
        if (options.verbose) {
          res[key] = this.get(key);
        } else {
          delete res[key];
        }
      }
    }, this); // cleanup private properties

    if (!options.verbose) {
      (0, _underscoreWrapper.default)(res).each(function (value, key) {
        if (/^__\w+__$/.test(key)) {
          delete res[key];
        }
      });
    }
    return res;
  },
  sanitizeAttributes: function (attributes) {
    const attrs = {};
    _underscoreWrapper.default.each(attributes, function (value, key) {
      if (!_underscoreWrapper.default.isFunction(value)) {
        attrs[key] = value;
      }
    });
    return attrs;
  },
  reset: function (options) {
    this.clear(options);
    this.set(this.sanitizeAttributes(this.defaults), options);
  },
  clear: function (options) {
    const attrs = {};
    _underscoreWrapper.default.each(this.sanitizeAttributes(this.attributes), function (value, key) {
      attrs[key] = void 0;
    });
    return this.set(attrs, _underscoreWrapper.default.extend({}, options, {
      unset: true
    }));
  },
  /**
   * @private
   */
  _setSynced: function (newModel) {
    this._syncedData = newModel && _underscoreWrapper.default.isFunction(newModel.toJSON) ? newModel.toJSON() : {};
  },
  /**
   * @private
   */
  _getSynced: function () {
    return this._syncedData;
  },
  isSynced: function () {
    return _underscoreWrapper.default.isEqual(this._getSynced(), this.toJSON());
  }
};
const statics = /** @lends module:Okta.BaseModel.prototype */
{
  /**
   * @static
   *
   * Example:
   *
   * ```javascript
   * var Model = BaseModel.extend({
   *   defaults: {
   *     name: BaseModel.ComputedProperty(['fname', 'lname'], function (fname, lname) {
   *       return fname + ' ' + lname;
   *     })
   *   }
   * });
   * var model = new Model({fname: 'Joe', lname: 'Doe'});
   * model.get('name'); // Joe Doe
   * model.toJSON(); // {fname: 'Joe', lname: 'Doe'}
   * ```
   *
   * @param {Array} attributes (optional) - an array of the attribute names this method depends on
   * @param {Function} callback the function that computes the value of the property
   *
   * @deprecated Use {@link #derived} instead
   */
  ComputedProperty: function (attributes, fn) {
    // First parameter is optional
    if (!fn && typeof attributes === 'function') {
      fn = attributes;
    } else {
      fn.__attributes = attributes;
    }
    return fn;
  }
};
/**
 * @class module:Okta.BaseModel
 * @extends module:Okta.Model
 * @deprecated Use {@link module:Okta.Model|Okta.Model} instead
 * @example
 * var Model = BaseModel.extend({
 *   defaults: {
 *     name: BaseModel.ComputedProperty(['fname', 'lname'], function (fname, lname) {
 *       return fname + ' ' + lname;
 *     })
 *   }
 * });
 * var model = new Model({fname: 'Joe', lname: 'Doe'});
 * model.get('name'); //=> "Joe Doe"
 * model.toJSON(); //=> {fname: 'Joe', lname: 'Doe'}
 *
 * model.set('__private__', 'private property');
 * model.get('__private__'); //=> "private property"
 * model.toJSON(); //=> {fname: 'Joe', lname: 'Doe'}
 */

var BaseModel = _Model.default.extend(props, statics);
exports["default"] = BaseModel;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/models/BaseSchema.js":
/*!**************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/models/BaseSchema.js ***!
  \**************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _BaseCollection = _interopRequireDefault(__webpack_require__(/*! ./BaseCollection.js */ "./packages/@okta/courage-dist/esm/src/courage/models/BaseCollection.js"));
var _BaseModel = _interopRequireDefault(__webpack_require__(/*! ./BaseModel.js */ "./packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js"));
var _SchemaProperty = _interopRequireDefault(__webpack_require__(/*! ./SchemaProperty.js */ "./packages/@okta/courage-dist/esm/src/courage/models/SchemaProperty.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const parseProperties = function (resp) {
  const schemaMeta = _underscoreWrapper.default.pick(resp, 'id', 'name', 'displayName');
  const properties = _underscoreWrapper.default.map(resp.schema.properties, function (property, name) {
    return _underscoreWrapper.default.extend({
      name: name
    }, property);
  });
  _underscoreWrapper.default.each(properties, function (property) {
    property['__schemaMeta__'] = schemaMeta;
    if (property.__metadata) {
      property['__metadata__'] = property.__metadata;
      delete property.__metadata;
    }
  });
  return properties;
};
const BaseSchemaSchema = _BaseModel.default.extend({
  defaults: {
    id: undefined,
    displayName: undefined,
    name: undefined
  },
  constructor: function () {
    this.properties = new _SchemaProperty.default.Collection();
    _BaseModel.default.apply(this, arguments);
  },
  getProperties: function () {
    return this.properties;
  },
  clone: function () {
    const model = _BaseModel.default.prototype.clone.apply(this, arguments);
    model.getProperties().set(this.getProperties().toJSON({
      verbose: true
    }));
    return model;
  },
  parse: function (resp) {
    const properties = parseProperties(resp);
    this.properties.set(properties, {
      parse: true
    });
    return _underscoreWrapper.default.omit(resp, 'schema');
  },
  trimProperty: function (property) {
    return _underscoreWrapper.default.omit(property, 'name');
  },
  toJSON: function () {
    const json = _BaseModel.default.prototype.toJSON.apply(this, arguments);
    json.schema = {
      properties: {}
    };
    this.getProperties().each(function (model) {
      const property = model.toJSON();
      json.schema.properties[property.name] = this.trimProperty(property);
    }, this);
    return json;
  },
  save: function () {
    this.getProperties().each(function (model) {
      model.cleanup();
    });
    return _BaseModel.default.prototype.save.apply(this, arguments);
  }
});
const BaseSchemaSchemas = _BaseCollection.default.extend({
  model: BaseSchemaSchema
});
var BaseSchema = {
  parseProperties: parseProperties,
  Model: BaseSchemaSchema,
  Collection: BaseSchemaSchemas
};
exports["default"] = BaseSchema;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/models/Model.js":
/*!*********************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/models/Model.js ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _Model = _interopRequireDefault(__webpack_require__(/*! ../framework/Model.js */ "./packages/@okta/courage-dist/esm/src/courage/framework/Model.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Wrapper around the more generic {@link src/framework/Model} that
 * contains Okta-specific logic.
 * @class module:Okta.Model
 * @extends src/framework/Model
 */
var Model = _Model.default.extend( /** @lends module:Okta.Model.prototype */
{
  /**
   * Is the end point using the legacy "secureJSON" format
   * @type {Function|Boolean}
   */
  secureJSON: false,
  _builtInLocalProps: {
    __edit__: 'boolean',
    __pending__: 'boolean'
  },
  preinitialize: function () {
    this.local = _underscoreWrapper.default.defaults({}, _underscoreWrapper.default.result(this, 'local'), this._builtInLocalProps);
    _Model.default.prototype.preinitialize.apply(this, arguments);
  },
  constructor: function () {
    _Model.default.apply(this, arguments);
    if (_underscoreWrapper.default.result(this, 'secureJSON')) {
      this.sync = _underscoreWrapper.default.wrap(this.sync, function (sync, method, model, options) {
        return sync.call(this, method, model, _underscoreWrapper.default.extend({
          dataType: 'secureJSON'
        }, options));
      });
    }
  }
});
exports["default"] = Model;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/models/SchemaProperty.js":
/*!******************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/models/SchemaProperty.js ***!
  \******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _jqueryWrapper = _interopRequireDefault(__webpack_require__(/*! ../util/jquery-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _BaseCollection = _interopRequireDefault(__webpack_require__(/*! ./BaseCollection.js */ "./packages/@okta/courage-dist/esm/src/courage/models/BaseCollection.js"));
var _BaseModel = _interopRequireDefault(__webpack_require__(/*! ./BaseModel.js */ "./packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js"));
var _Logger = _interopRequireDefault(__webpack_require__(/*! ../util/Logger.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Logger.js"));
var _SchemaUtil = _interopRequireDefault(__webpack_require__(/*! ../util/SchemaUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/SchemaUtil.js"));
var _StringUtil = _interopRequireDefault(__webpack_require__(/*! ../util/StringUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/StringUtil.js"));
var _EnumTypeHelper = _interopRequireDefault(__webpack_require__(/*! ../views/forms/helpers/EnumTypeHelper.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/EnumTypeHelper.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint-disable inclusive-language/use-inclusive-words */
const loc = _StringUtil.default.localize;
const STRING = _SchemaUtil.default.STRING;
const NUMBER = _SchemaUtil.default.NUMBER;
const INTEGER = _SchemaUtil.default.INTEGER;
const OBJECT = _SchemaUtil.default.OBJECT;
const getArrayTypeName = function (type, elementType) {
  return type + 'of' + elementType;
};
const SchemaPropertySubSchema = _BaseModel.default.extend({
  defaults: {
    description: undefined,
    minLength: undefined,
    maxLength: undefined,
    format: undefined
  },
  parse: function (resp) {
    if (_underscoreWrapper.default.isString(resp.format)) {
      const matcher = /^\/(.+)\/$/.exec(resp.format);
      if (matcher) {
        resp.format = matcher[1];
      }
    }
    return resp;
  }
});
const SchemaPropertySubSchemaCollection = _BaseCollection.default.extend({
  model: SchemaPropertySubSchema
});
const SchemaPropertySubSchemaAllOfCollection = SchemaPropertySubSchemaCollection.extend({
  _type: 'allOf'
});
const SchemaPropertySubSchemaOneOfCollection = SchemaPropertySubSchemaCollection.extend({
  _type: 'oneOf'
});
const SchemaPropertySubSchemaNoneOfCollection = SchemaPropertySubSchemaCollection.extend({
  _type: 'noneOf'
});
const constraintTypeErrorMessages = {
  string: loc('schema.validation.field.value.must.string', 'courage'),
  number: loc('schema.validation.field.value.must.number', 'courage'),
  integer: loc('schema.validation.field.value.must.integer', 'courage'),
  object: loc('schema.validation.field.value.must.object', 'courage')
};
const loginFormatNonePattern = '.+';
const escapedLoginCharsRe = /[^a-zA-Z0-9-]/;
const constraintHandlers = {
  between: '_checkBetweenConstraints',
  greaterThan: '_checkGreaterThanConstraint',
  lessThan: '_checkLessThanConstraint',
  equals: '_checkEqualsConstraint'
};
const SchemaPropertySchemaProperty = _BaseModel.default.extend({
  idAttribute: 'name',
  local: {
    __oneOf__: {
      type: 'array',
      minItems: 1
    }
  },
  defaults: {
    // OKTA-28445, set empty string by default as the key for each property when syncing with server
    // so that server can respond with error when a name is not provided
    name: '',
    title: undefined,
    type: undefined,
    description: undefined,
    required: false,
    format: undefined,
    // choose disable option be default.
    union: undefined,
    subSchemas: undefined,
    settings: {
      permissions: {
        SELF: _SchemaUtil.default.PERMISSION.READ_ONLY
      }
    },
    unique: undefined,
    __metadata__: undefined,
    __isSensitive__: _BaseModel.default.ComputedProperty(['settings'], function (settings) {
      return !!(settings && settings.sensitive && settings.sensitive !== 'NOT_SENSITIVE');
    }),
    __isPendingSensitive__: _BaseModel.default.ComputedProperty(['settings'], function (settings) {
      return !!(settings && settings.sensitive && settings.sensitive === 'PENDING_SENSITIVE');
    }),
    __unique__: false,
    __isUniqueValidated__: _BaseModel.default.ComputedProperty(['unique'], function (unique) {
      return unique === _SchemaUtil.default.UNIQUENESS.UNIQUE_VALIDATED;
    }),
    __isPendingUniqueness__: _BaseModel.default.ComputedProperty(['unique'], function (unique) {
      return unique === _SchemaUtil.default.UNIQUENESS.PENDING_UNIQUENESS;
    }),
    __isUniqueness__: _BaseModel.default.ComputedProperty(['__isUniqueValidated__', '__isPendingUniqueness__'], function (isValidated, isPending) {
      return isValidated || isPending;
    }),
    __canBeSensitive__: _BaseModel.default.ComputedProperty(['__metadata__'], function (metadata) {
      return !!(metadata && metadata.sensitivizable);
    }),
    __userPermission__: _SchemaUtil.default.PERMISSION.READ_ONLY,
    __displayType__: undefined,
    __displayTypeLabel__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
      return _SchemaUtil.default.DATATYPE[displayType] || displayType;
    }),
    __supportsMinMax__: false,
    // use the private naming convention for these computed properties,
    // to deal with the complexity in cloning schema with properties (toJSON({verbose: true})),
    // to make sure these attributes are being excluded from api request
    __isReadOnly__: _BaseModel.default.ComputedProperty(['mutability'], function (mutability) {
      return mutability === _SchemaUtil.default.MUTABILITY.READONLY;
    }),
    __isWriteOnly__: _BaseModel.default.ComputedProperty(['mutability'], function (mutability) {
      return mutability === _SchemaUtil.default.MUTABILITY.WRITEONLY;
    }),
    __displayScope__: undefined,
    __isScopeSelf__: _BaseModel.default.ComputedProperty(['scope'], function (scope) {
      return scope === _SchemaUtil.default.SCOPE.SELF;
    }),
    __isNoneScopeArrayType__: _BaseModel.default.ComputedProperty(['__isScopeSelf__', '__displayType__'], function (isScopeSelf, displayType) {
      return !isScopeSelf && _SchemaUtil.default.isArrayDataType(displayType);
    }),
    __isImported__: _BaseModel.default.ComputedProperty(['externalName'], function (externalName) {
      return !!externalName;
    }),
    __isFromBaseSchema__: _BaseModel.default.ComputedProperty(['__schemaMeta__'], function (schemaMeta) {
      return schemaMeta && schemaMeta.name === 'base';
    }),
    // Only UI can turn on __enumDefined__ and reprocess the enum/oneOf value; otherwise,
    // it should leave existing value untouch
    __enumDefined__: false,
    __supportEnum__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
      return _underscoreWrapper.default.contains(_SchemaUtil.default.SUPPORTENUM, displayType);
    }),
    __isNumberTypeEnum__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
      return _underscoreWrapper.default.contains([_SchemaUtil.default.NUMBER, _SchemaUtil.default.ARRAYDISPLAYTYPE.arrayofnumber], displayType);
    }),
    __isIntegerTypeEnum__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
      return _underscoreWrapper.default.contains([_SchemaUtil.default.INTEGER, _SchemaUtil.default.ARRAYDISPLAYTYPE.arrayofinteger], displayType);
    }),
    __isObjectTypeEnum__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
      return _underscoreWrapper.default.contains([_SchemaUtil.default.OBJECT, _SchemaUtil.default.ARRAYDISPLAYTYPE.arrayofobject], displayType);
    }),
    __isStringTypeEnum__: _BaseModel.default.ComputedProperty(['__displayType__'], function (displayType) {
      return _underscoreWrapper.default.contains([_SchemaUtil.default.STRING, _SchemaUtil.default.ARRAYDISPLAYTYPE.arrayofstring], displayType);
    }),
    __enumConstraintType__: _BaseModel.default.ComputedProperty(['__isStringTypeEnum__', '__isNumberTypeEnum__', '__isIntegerTypeEnum__', '__isObjectTypeEnum__'], function (isStringType, isNumberType, isIntegerType, isObjectType) {
      if (isStringType) {
        return STRING;
      }
      if (isNumberType) {
        return NUMBER;
      }
      if (isIntegerType) {
        return INTEGER;
      }
      if (isObjectType) {
        return OBJECT;
      }
    }),
    __isEnumDefinedAndSupported__: _BaseModel.default.ComputedProperty(['__enumDefined__', '__supportEnum__'], function (enumDefined, supportEnum) {
      return enumDefined && supportEnum;
    }),
    __isLoginOfBaseSchema__: _BaseModel.default.ComputedProperty(['__isFromBaseSchema__', 'name'], function (isFromBaseSchema, name) {
      return isFromBaseSchema && name === 'login';
    }),
    __isLoginFormatRestrictionToEmail__: _BaseModel.default.ComputedProperty(['__loginFormatRestriction__'], function (loginFormatRestriction) {
      return loginFormatRestriction === _SchemaUtil.default.LOGINPATTERNFORMAT.EMAIL;
    })
  },
  initialize: function () {
    _BaseModel.default.prototype.initialize.apply(this, arguments);
    this.listenTo(this, 'change:__displayType__', this._updateTypeFormatConstraints);
    this.listenTo(this, 'change:type change:format change:items', this._updateDisplayType);
    this.listenTo(this, 'change:__minVal__ change:__maxVal__', this._updateMinMax);
    this.listenTo(this, 'change:__equals__', this._convertEqualsToMinMax);
    this.listenTo(this, 'change:__constraint__', this._setConstraintText);
    this._setConstraintText();
    this._setLoginPattern();
  },
  parse: function (resp) {
    /* eslint complexity: [2, 9] */
    resp = _underscoreWrapper.default.clone(resp);
    if (resp.type === 'object' && resp.extendedType === 'image') {
      resp.type = 'image';
    }
    resp['__displayType__'] = _SchemaUtil.default.getDisplayType(resp.type, resp.format, resp.items ? resp.items.format ? resp.items.format : resp.items.type : undefined);
    this._setRangeConstraints(resp);
    resp['__supportsMinMax__'] = _SchemaUtil.default.SUPPORTSMINMAX.indexOf(resp['__displayType__']) !== -1;
    resp['__displayScope__'] = _SchemaUtil.default.DISPLAYSCOPE[resp.scope] || _SchemaUtil.default.DISPLAYSCOPE.NA;
    if (resp.settings && resp.settings.permissions && resp.settings.permissions.SELF) {
      resp['__userPermission__'] = resp.settings.permissions.SELF;
    }
    this._setMasterOverride(resp);
    this._setSubSchemas(resp);
    this._setUniqueness(resp);
    return resp;
  },
  validate: function () {
    const enumValidationError = this._validateEnumOneOf();
    if (enumValidationError) {
      return enumValidationError;
    }
    if (!this.get('__supportsMinMax__') || !this.get('__constraint__')) {
      return undefined;
    }
    const constraitType = this.get('__constraint__');
    const constraitHandler = this[constraintHandlers[constraitType]];
    if (_underscoreWrapper.default.isFunction(constraitHandler)) {
      return constraitHandler.call(this);
    } else {
      _Logger.default.warn('No constraint handler found for: ' + constraitType);
      return undefined;
    }
  },
  _checkBetweenConstraints: function () {
    const minVal = this.get('__minVal__');
    const maxVal = this.get('__maxVal__');
    if (!minVal && !maxVal) {
      return;
    }
    if (!minVal) {
      return {
        __minVal__: loc('schema.validation.field.enter.minimum.number', 'courage')
      };
    }
    if (!maxVal) {
      return {
        __maxVal__: loc('schema.validation.field.enter.maximum.number', 'courage')
      };
    }
    let val = this._checkIntegerConstraints('__minVal__', 'Min value');
    if (val) {
      return val;
    }
    val = this._checkIntegerConstraints('__maxVal__', 'Max value');
    if (val) {
      return val;
    }
    if (+minVal >= +maxVal) {
      return {
        __maxVal__: loc('schema.validation.field.maximum.must.be.greater.than.minimum', 'courage')
      };
    }
  },
  _checkGreaterThanConstraint: function () {
    const minVal = this.get('__minVal__');
    if (!minVal) {
      return;
    }
    const val = this._checkIntegerConstraints('__minVal__', 'Constraint');
    if (val) {
      return val;
    }
  },
  _checkLessThanConstraint: function () {
    const maxVal = this.get('__maxVal__');
    if (!maxVal) {
      return;
    }
    const val = this._checkIntegerConstraints('__maxVal__', 'Constraint');
    if (val) {
      return val;
    }
  },
  _checkEqualsConstraint: function () {
    const equals = this.get('__equals__');
    if (!equals) {
      return;
    }
    const val = this._checkIntegerConstraints('__equals__', 'Constraint');
    if (val) {
      return val;
    }
  },
  _checkIntegerConstraints: function (field, name) {
    const val = this.get(field);
    const error = {}; // eslint-disable-next-line no-restricted-globals

    if (isNaN(val)) {
      if (name === 'Min value') {
        error[field] = loc('schema.validation.field.minimum.value.must.be.number', 'courage');
      } else if (name === 'Max value') {
        error[field] = loc('schema.validation.field.maximum.value.must.be.number', 'courage');
      } else if (name === 'Constraint') {
        error[field] = loc('schema.validation.field.constraint.must.be.number', 'courage');
      }
      return error;
    }
    if (+val < 0) {
      if (name === 'Min value') {
        error[field] = loc('schema.validation.field.minimum.number.must.be.greater.than.zero', 'courage');
      } else if (name === 'Max value') {
        error[field] = loc('schema.validation.field.maximum.number.must.be.greater.than.zero', 'courage');
      } else if (name === 'Constraint') {
        error[field] = loc('schema.validation.field.number.must.be.greater.than.zero', 'courage');
      }
      return error;
    }
  },
  _setMasterOverride: function (resp) {
    if (resp.settings && resp.settings.masterOverride && resp.settings.masterOverride) {
      const masterOverrideValue = resp.settings.masterOverride.value;
      if (_underscoreWrapper.default.isArray(masterOverrideValue) && !_underscoreWrapper.default.isEmpty(masterOverrideValue)) {
        resp['__masterOverrideType__'] = 'OVERRIDE';
        resp['__masterOverrideValue__'] = masterOverrideValue || [];
      } else {
        resp['__masterOverrideType__'] = resp.settings.masterOverride.type;
      }
    } else {
      resp['__masterOverrideType__'] = 'INHERIT';
    }
  },
  _setRangeConstraints: function (resp) {
    /* eslint complexity: [2, 11] */
    if (resp['__displayType__'] === STRING) {
      resp['__minVal__'] = resp.minLength;
      resp['__maxVal__'] = resp.maxLength;
    } else if (resp['__displayType__'] === INTEGER || resp['__displayType__'] === NUMBER) {
      resp['__minVal__'] = resp.minimum;
      resp['__maxVal__'] = resp.maximum;
    }
    if (resp['__minVal__'] && resp['__maxVal__']) {
      if (resp['__minVal__'] === resp['__maxVal__']) {
        resp['__constraint__'] = 'equals';
        resp['__equals__'] = resp['__minVal__'];
      } else {
        resp['__constraint__'] = 'between';
      }
    } else if (!resp['__minVal__'] && resp['__maxVal__']) {
      resp['__constraint__'] = 'lessThan';
    } else if (!resp['__maxVal__'] && resp['__minVal__']) {
      resp['__constraint__'] = 'greaterThan';
    }
  },
  _setSubSchemas: function (resp) {
    if (resp.allOf) {
      resp['subSchemas'] = new SchemaPropertySubSchemaAllOfCollection(resp.allOf, {
        parse: true
      });
    } else if (resp.oneOf) {
      resp['subSchemas'] = new SchemaPropertySubSchemaOneOfCollection(resp.oneOf, {
        parse: true
      });
    } else if (resp.noneOf) {
      resp['subSchemas'] = new SchemaPropertySubSchemaNoneOfCollection(resp.noneOf, {
        parse: true
      });
    }
  },
  _setUniqueness: function (resp) {
    const unique = resp && resp.unique;
    resp['__unique__'] = !!(unique && (unique === _SchemaUtil.default.UNIQUENESS.UNIQUE_VALIDATED || unique === _SchemaUtil.default.UNIQUENESS.PENDING_UNIQUENESS));
  },
  _setLoginPattern: function () {
    if (!this.get('__isLoginOfBaseSchema__')) {
      return;
    }
    const pattern = this.get('pattern');
    if (pattern === loginFormatNonePattern) {
      this.set('__loginFormatRestriction__', _SchemaUtil.default.LOGINPATTERNFORMAT.NONE);
    } else if (pattern) {
      this.set('__loginFormatRestriction__', _SchemaUtil.default.LOGINPATTERNFORMAT.CUSTOM);
      this.set('__loginFormatRestrictionCustom__', this._extractLoginPattern(pattern));
    } else {
      this.set('__loginFormatRestriction__', _SchemaUtil.default.LOGINPATTERNFORMAT.EMAIL);
    }
  },
  _updateDisplayType: function () {
    const type = this.get('type');
    if (type === STRING && this.get('format')) {
      this.set('__displayType__', _SchemaUtil.default.FORMATDISPLAYTYPE[this.get('format')]);
    } else {
      const items = this.get('items');
      const arraytype = items && (items.format ? items.format : items.type);
      if (type && arraytype) {
        this.set('__displayType__', _SchemaUtil.default.ARRAYDISPLAYTYPE[getArrayTypeName(type, arraytype)]);
      } else {
        this.set('__displayType__', type);
      }
    }
  },
  _validateEnumOneOf: function () {
    if (!this.get('__isEnumDefinedAndSupported__')) {
      return;
    }
    const enumOneOf = this.get('__oneOf__') || [];
    if (_underscoreWrapper.default.isEmpty(enumOneOf)) {
      return {
        __oneOf__: loc('model.validation.field.blank', 'courage')
      };
    }
    if (!this._isValidateOneOfConstraint(enumOneOf)) {
      const constraintType = this.get('__enumConstraintType__');
      const errorTypeMsg = constraintTypeErrorMessages[constraintType];
      return {
        __oneOf__: errorTypeMsg
      };
    }
  },
  _isValidateOneOfConstraint: function (values) {
    const constraintType = this.get('__enumConstraintType__');
    return _underscoreWrapper.default.all(values, function (value) {
      return _EnumTypeHelper.default.isConstraintValueMatchType(value.const, constraintType);
    });
  },
  toJSON: function () {
    let json = _BaseModel.default.prototype.toJSON.apply(this, arguments);
    json.settings = {
      permissions: {}
    };
    json.settings.permissions['SELF'] = this.get('__userPermission__'); // omit "sensitive" filed will have default it value to false.

    if (this.get('__isSensitive__')) {
      json.settings.sensitive = this.get('__isSensitive__');
    }
    if (this.get('type') === 'image') {
      json.type = 'object';
      json.extendedType = 'image';
    }
    json = this._enumAssignment(json);
    json = this._attributeOverrideToJson(json);
    json = this._normalizeUnionValue(json);
    json = this._patternAssignment(json);
    json = this._uniquenessAssignment(json);
    return json;
  },
  _attributeOverrideToJson: function (json) {
    const masterOverrideType = this.get('__masterOverrideType__');
    const masterOverrideValue = this.get('__masterOverrideValue__');
    if (masterOverrideType === 'OKTA_MASTERED') {
      json.settings.masterOverride = {
        type: 'OKTA_MASTERED'
      };
    } else if (masterOverrideType === 'OVERRIDE') {
      json.settings.masterOverride = {
        type: 'ORDERED_LIST',
        value: []
      };
      if (masterOverrideValue instanceof _BaseCollection.default) {
        _underscoreWrapper.default.each(masterOverrideValue.toJSON(), function (overrideProfile) {
          json.settings.masterOverride.value.push(overrideProfile.id);
        });
      } else if (masterOverrideValue instanceof Array) {
        json.settings.masterOverride.value = masterOverrideValue;
      }
      if (_underscoreWrapper.default.isEmpty(json.settings.masterOverride.value)) {
        delete json.settings.masterOverride;
      }
    }
    if (masterOverrideType === 'INHERIT') {
      delete json.settings.masterOverride;
    }
    return json;
  },
  /**
   * Only allow set "union" value when isScopeSelf is NONE and displayType is
   * array of (string/number/integer), otherwise reset to default.
   *
   * @see /universal-directory/shared/views/components/UnionGroupValuesRadio.js
   */
  _normalizeUnionValue: function (json) {
    if (!this.get('__isNoneScopeArrayType__')) {
      json['union'] = undefined;
    }
    return json;
  },
  _enumAssignment: function (json) {
    if (!this.get('__isEnumDefinedAndSupported__')) {
      return json;
    } // backfill empty title by constraint

    const enumOneOf = this._getEnumOneOfWithTitleCheck();
    if (this.get('type') === 'array') {
      delete json.items.enum;
      json.items.oneOf = enumOneOf;
    } else {
      delete json.enum;
      json.oneOf = enumOneOf;
    }
    return json;
  },
  _patternAssignment: function (json) {
    if (!this.get('__isLoginOfBaseSchema__') || !this.get('__loginFormatRestriction__')) {
      return json;
    }
    switch (this.get('__loginFormatRestriction__')) {
      case _SchemaUtil.default.LOGINPATTERNFORMAT.EMAIL:
        delete json.pattern;
        break;
      case _SchemaUtil.default.LOGINPATTERNFORMAT.CUSTOM:
        json.pattern = this._buildLoginPattern(this.get('__loginFormatRestrictionCustom__'));
        break;
      case _SchemaUtil.default.LOGINPATTERNFORMAT.NONE:
        json.pattern = loginFormatNonePattern;
        break;
    }
    return json;
  },
  _uniquenessAssignment: function (json) {
    if (!this.get('__unique__')) {
      delete json.unique;
    } else if (!this.get('__isUniqueness__')) {
      json.unique = _SchemaUtil.default.UNIQUENESS.UNIQUE_VALIDATED;
    }
    return json;
  },
  /**
   * Character should be escaped except letters, digits and hyphen
   */
  _escapedRegexChar: function (pattern, index) {
    const char = pattern.charAt(index);
    if (escapedLoginCharsRe.test(char)) {
      return '\\' + char;
    }
    return char;
  },
  _buildLoginPattern: function (pattern) {
    let result = '';
    for (var i = 0; i < pattern.length; i++) {
      result += this._escapedRegexChar(pattern, i);
    }
    return '[' + result + ']+';
  },
  _extractLoginPattern: function (pattern) {
    const re = /^\[(.*)\]\+/;
    const matches = pattern.match(re);
    return matches ? matches[1].replace(/\\(.)/g, '$1') : pattern;
  },
  _getEnumOneOfWithTitleCheck: function () {
    const enumOneOf = this.get('__oneOf__');
    return _underscoreWrapper.default.map(enumOneOf, function (value) {
      if (_jqueryWrapper.default.trim(value.title) !== '') {
        return value;
      }
      value.title = !_underscoreWrapper.default.isString(value.const) ? JSON.stringify(value.const) : value.const;
      return value;
    });
  },
  _updateTypeFormatConstraints: function () {
    const displayType = this.get('__displayType__'); // OKTA-31952 reset format according to its displayType

    this.unset('format', {
      silent: true
    });
    this.unset('items', {
      silent: true
    });
    this.set(_SchemaUtil.default.DISPLAYTYPES[displayType]);
    if (displayType !== NUMBER && displayType !== INTEGER) {
      this.unset('minimum');
      this.unset('maximum');
    }
    if (displayType !== STRING) {
      this.unset('minLength');
      this.unset('maxLength');
    }
    this.unset('__minVal__');
    this.unset('__maxVal__');
    this.unset('__equals__');
    this.set('__supportsMinMax__', _SchemaUtil.default.SUPPORTSMINMAX.indexOf(this.get('__displayType__')) !== -1);
  },
  _updateMinMax: function () {
    let min;
    let max;
    const displayType = this.get('__displayType__');
    if (displayType === STRING) {
      min = 'minLength';
      max = 'maxLength';
    } else if (displayType === INTEGER || displayType === NUMBER) {
      min = 'minimum';
      max = 'maximum';
    }
    if (this.get('__minVal__')) {
      this.set(min, parseInt(this.get('__minVal__'), 10));
    } else {
      this.unset(min);
    }
    if (this.get('__maxVal__')) {
      this.set(max, parseInt(this.get('__maxVal__'), 10));
    } else {
      this.unset(max);
    }
  },
  _convertEqualsToMinMax: function () {
    const equals = this.get('__equals__');
    if (equals) {
      this.set('__minVal__', equals);
      this.set('__maxVal__', equals);
    }
  },
  /*
   Normally we would use a derived property here but derived properties do not work with the model Clone function
   so we use this workaround instead.
   */
  _setConstraintText: function () {
    const constraint = this.get('__constraint__');
    const min = this.get('__minVal__');
    const max = this.get('__maxVal__');
    const equals = this.get('__equals__');
    switch (constraint) {
      case 'between':
        this.set('__constraintText__', 'Between ' + min + ' and ' + max);
        break;
      case 'greaterThan':
        this.set('__constraintText__', 'Greater than ' + min);
        break;
      case 'lessThan':
        this.set('__constraintText__', 'Less than ' + max);
        break;
      case 'equals':
        this.set('__constraintText__', 'Equals ' + equals);
        break;
      default:
        this.set('__constraintText__', '');
        break;
    }
  },
  cleanup: function () {
    if (this.get('__constraint__') === 'lessThan') {
      this.unset('__minVal__');
    } else if (this.get('__constraint__') === 'greaterThan') {
      this.unset('__maxVal__');
    }
    if (this.get('scope') !== _SchemaUtil.default.SCOPE.SYSTEM) {
      if (this.get('__isScopeSelf__') === true) {
        this.set({
          scope: _SchemaUtil.default.SCOPE.SELF
        }, {
          silent: true
        });
      } else {
        this.unset('scope');
      }
    }
    if (!this.get('__unique__')) {
      this.unset('unique');
    }
  },
  /**
   * Since there is not an dedicated attribute to flag enum type,
   * use enum values to determine whether the property is enum type or not.
   */
  isEnumType: function () {
    return !!this.getEnumValues();
  },
  getEnumValues: function () {
    return this.get('oneOf') || this.get('enum') || this.get('items') && this.get('items')['oneOf'] || this.get('items') && this.get('items')['enum'];
  },
  detectHasEnumDefined: function () {
    const enumValues = this.getEnumValues();
    if (!enumValues) {
      return;
    }
    this.set('__oneOf__', _EnumTypeHelper.default.convertToOneOf(enumValues));
    this.set('__enumDefined__', true);
  }
});
const SchemaPropertySchemaProperties = _BaseCollection.default.extend({
  model: SchemaPropertySchemaProperty,
  clone: function () {
    return new this.constructor(this.toJSON({
      verbose: true
    }), {
      parse: true
    });
  },
  areAllReadOnly: function () {
    return _underscoreWrapper.default.all(this.pluck('__isReadOnly__'));
  },
  createModelProperties: function () {
    return this.reduce(function (p, schemaProperty) {
      const type = schemaProperty.get('type');
      p[schemaProperty.id] = _underscoreWrapper.default.clone(_SchemaUtil.default.DISPLAYTYPES[type]);
      if (_SchemaUtil.default.SUPPORTSMINMAX.indexOf(type) !== -1) {
        p[schemaProperty.id].minLength = schemaProperty.get('minLength');
        p[schemaProperty.id].maxLength = schemaProperty.get('maxLength');
      }
      if (type === 'string') {
        p[schemaProperty.id].format = schemaProperty.get('format');
      }
      return p;
    }, {});
  }
});
var SchemaProperty = {
  Model: SchemaPropertySchemaProperty,
  Collection: SchemaPropertySchemaProperties
};
exports["default"] = SchemaProperty;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/BaseController.js":
/*!****************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/BaseController.js ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _jqueryWrapper = _interopRequireDefault(__webpack_require__(/*! ./jquery-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ./underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _BaseRouter = _interopRequireDefault(__webpack_require__(/*! ./BaseRouter.js */ "./packages/@okta/courage-dist/esm/src/courage/util/BaseRouter.js"));
var _SettingsModel = _interopRequireDefault(__webpack_require__(/*! ./SettingsModel.js */ "./packages/@okta/courage-dist/esm/src/courage/util/SettingsModel.js"));
var _StateMachine = _interopRequireDefault(__webpack_require__(/*! ./StateMachine.js */ "./packages/@okta/courage-dist/esm/src/courage/util/StateMachine.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../views/BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function clean(obj) {
  const res = {};
  _underscoreWrapper.default.each(obj, function (value, key) {
    if (!_underscoreWrapper.default.isNull(value)) {
      res[key] = value;
    }
  });
  return res;
}
const proto = /** @lends module:Okta.Controller.prototype */
{
  preinitialize: function (options = {}) {
    // If 'state' is passed down as options, use it, else create a 'new StateMachine()'
    this.state = _underscoreWrapper.default.result(this, 'state');
    const hasStateBeenInitialized = this.state instanceof _StateMachine.default || options.state instanceof _StateMachine.default;
    if (!hasStateBeenInitialized) {
      const stateData = _underscoreWrapper.default.defaults(clean(options.state), this.state || {}); // TODO:
      // `framework/View.js set `this.state = options.state.`.
      // Therefore we could consider to do
      // 1. `options.state = new StateMachine()`
      // 2. remove `delete options.state`

      this.state = new _StateMachine.default(stateData);
      delete options.state;
    }
    if (!options.settings) {
      // allow the controller to live without a router
      options.settings = new _SettingsModel.default(_underscoreWrapper.default.omit(options || {}, 'el'));
      this.listen('notification', _BaseRouter.default.prototype._notify);
      this.listen('confirmation', _BaseRouter.default.prototype._confirm);
    }
    _BaseView.default.prototype.preinitialize.call(this, options);
  },
  constructor: function (options = {}) {
    _BaseView.default.call(this, options);
    this.listenTo(this.state, '__invoke__', function () {
      const args = _underscoreWrapper.default.toArray(arguments);
      const method = args.shift();
      if (_underscoreWrapper.default.isFunction(this[method])) {
        this[method].apply(this, args);
      }
    });
    let MainView; // if `this.View` is already a Backbone View

    if (this.View && this.View.isCourageView) {
      MainView = this.View;
    } // if `this.View` is a pure function that returns a Backbone View
    else if (_underscoreWrapper.default.result(this, 'View') && _underscoreWrapper.default.result(this, 'View').isCourageView) {
      MainView = _underscoreWrapper.default.result(this, 'View');
    }
    if (MainView) {
      this.add(new MainView(this.toJSON()));
    }
  },
  /**
   * The default values of our application state
   * @type {Object}
   * @default {}
   */
  state: {},
  /**
   * The main view this controller operate on
   * @type {module:Okta.View}
   * @default null
   */
  View: null,
  /**
   * Renders the {@link module:Okta.Controller#View|main view} after the DOM is ready
   * in case the controller is the root component of the page (e.g there's no router)
   */
  render: function () {
    const args = arguments;
    const self = this;
    (0, _jqueryWrapper.default)(function () {
      _BaseView.default.prototype.render.apply(self, args);
    });
    return this;
  },
  /**
   * Creates the view constructor options
   * @param {Object} [options] Extra options
   * @return {Object} The view constructor options
   */
  toJSON: function (options) {
    return _underscoreWrapper.default.extend(_underscoreWrapper.default.pick(this, 'state', 'settings', 'collection', 'model'), options || {});
  },
  /**
   * Removes the child views, empty the DOM element and stop listening to events
   */
  remove: function () {
    this.removeChildren();
    this.stopListening();
    this.$el.empty();
    return this;
  }
}; // eslint-disable-next-line inclusive-language/use-inclusive-words

/**
 * A Controller is our application control flow component.
 *
 * Typically it will:
 * - Initialize the models, controller and main views
 * - Listen to events
 * - Create, read, update and delete models
 * - Create modal dialogs, confirmation dialogs and alert dialogs
 * - Control the application flow
 *
 * The constructor is responsible for:
 * - Create the application state object
 * - Assign or creates the application settings object
 * - Create an instance of the main view with the relevant parameters
 *
 * See:
 * [Hello World Tutorial](https://github.com/okta/courage/wiki/Hello-World),
 * [Test Spec](https://github.com/atko-eng/okta-ui/blob/master/packages/courage/test/spec/util/BaseController_spec.js)
 *
 * @class module:Okta.Controller
 * @param {Object} options Options Hash
 * @param {SettingsModel} [options.settings] Application Settings Model
 * @param {String} options.el a jQuery selector string stating where to attach the controller in the DOM
 */

var BaseController = _BaseView.default.extend(proto);
exports["default"] = BaseController;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/BaseRouter.js":
/*!************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/BaseRouter.js ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _backbone = _interopRequireDefault(__webpack_require__(/*! ../vendor/lib/backbone.js */ "./packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js"));
var _empty = _interopRequireDefault(__webpack_require__(/*! ../../empty.js */ "./packages/@okta/courage-dist/esm/src/empty.js"));
var _jqueryWrapper = _interopRequireDefault(__webpack_require__(/*! ./jquery-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ./underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _Logger = _interopRequireDefault(__webpack_require__(/*! ./Logger.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Logger.js"));
var _SettingsModel = _interopRequireDefault(__webpack_require__(/*! ./SettingsModel.js */ "./packages/@okta/courage-dist/esm/src/courage/util/SettingsModel.js"));
var _Notification = _interopRequireDefault(__webpack_require__(/*! ../views/components/Notification.js */ "./packages/@okta/courage-dist/esm/src/courage/views/components/Notification.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function getRoute(router, route) {
  const root = _underscoreWrapper.default.result(router, 'root') || '';
  if (root && _underscoreWrapper.default.isString(route)) {
    return [root, route].join('/').replace(/\/{2,}/g, '/');
  }
  return route;
}
/**
 * BaseRouter is a standard [Backbone.Router](http://backbonejs.org/#Router)
 * with a few additions:
 * - Explicit mapping between routes and controllers
 * - Support for rendering notification and confirmation dialogs
 *
 * Checkout the [Hello World Tutorial](https://github.com/okta/courage/wiki/Hello-World)
 * for a step-by-step guide to using this.
 *
 * @class module:Okta.Router
 * @extends external:Backbone.Router
 * @param {Object} options options hash
 * @param {String} options.el a jQuery selector string stating where to attach the controller in the DOM
 */

const props = /** @lends module:Okta.Router.prototype */
{
  /**
   * The root URL for the router. When setting {@link http://backbonejs.org/#Router-routes|routes},
   * it will be prepended to each route.
   * @type {String|Function}
   */
  root: '',
  listen: _Notification.default.prototype.listen,
  constructor: function (options = {}) {
    this.el = options.el;
    /**
     * Make sure `this.settings` has been set before invoke super - `Backbone.Router.apply`,
     * which will invoke `this.initialize`, which could use `this.settings`.
     *
     * In theory we can set `this.settings` in `this.initialize` and assume `child.initialize`
     * will invoke `super.initialize` first. But in reality, `child.initialize` doesn't call
     * `super.initialize` at all.
     */

    this.settings = new _SettingsModel.default(_underscoreWrapper.default.omit(options, 'el'));
    if (options.root) {
      this.root = options.root;
    }
    _backbone.default.Router.apply(this, arguments);
    this.listen('notification', this._notify);
    this.listen('confirmation', this._confirm);
  },
  /**
   * Fires up a confirmation dialog
   *
   * @param  {Object} options Options Hash
   * @param  {String} options.title The title
   * @param  {Array<string>} buttonOrder The order of the buttons
   * @param  {String} options.subtitle The explain text
   * @param  {String} options.save The text for the save button
   * @param  {Function} options.ok The callback function to run when hitting "OK"
   * @param  {String} options.cancel The text for the cancel button
   * @param  {Function} options.cancelFn The callback function to run when hitting "Cancel"
   * @param  {Boolean} options.noCancelButton Don't render the cancel button (useful for alert dialogs)
   * @param  {Boolean} options.noSubmitButton Don't render the primary button (useful for alert dialogs)
   * @private
   *
   * @return {Okta.View} the dialog view
   */
  _confirm: function (options = {}) {
    const Dialog = _empty.default.extend(_underscoreWrapper.default.pick(options, 'title', 'subtitle', 'save', 'ok', 'cancel', 'cancelFn', 'noCancelButton', 'noSubmitButton', 'content', 'danger', 'type', 'closeOnOverlayClick', 'buttonOrder'));
    const dialog = new Dialog({
      model: this.settings
    }); // The model is here because itsa part of the BaseForm paradigm.
    // It will be ignored in the context of a confirmation dialog.

    dialog.render();
    return dialog; // test hook
  },

  /**
   * Fires up a notification banner
   *
   * @param  {Object} options Options Hash
   * @return {Okta.View} the notification view
   * @private
   */
  _notify: function (options) {
    const notification = new _Notification.default(options);
    (0, _jqueryWrapper.default)('#content').prepend(notification.render().el);
    return notification; // test hook
  },

  /**
   * Renders a Controller
   * This will initialize new instance of a controller and call render on it
   *
   * @param  {Okta.Controller} Controller The controller Class we which to render
   * @param  {Object} [options] Extra options to the controller constructor
   */
  render: function (Controller, options) {
    this.unload();
    options = _underscoreWrapper.default.extend(_underscoreWrapper.default.pick(this, 'settings', 'el'), options || {});
    this.controller = new Controller(options);
    this.controller.render();
  },
  /**
   * Starts the backbone history object
   *
   * Waits for the dom to be ready before calling `Backbone.history.start()` (IE issue).
   *
   * See [Backbone History](http://backbonejs.org/#History) for more information.
   */
  start: function (...args) {
    (0, _jqueryWrapper.default)(function () {
      if (_backbone.default.History.started) {
        _Logger.default.error('History has already been started');
        return;
      }
      _backbone.default.history.start(...args);
    });
  },
  /**
   * Removes active controller and frees up event listeners
   */
  unload: function () {
    if (this.controller) {
      this.stopListening(this.controller);
      this.stopListening(this.controller.state);
      this.controller.remove();
    }
  },
  route: function (route, name, callback) {
    return _backbone.default.Router.prototype.route.call(this, getRoute(this, route), name, callback);
  },
  navigate: function (fragment, options) {
    return _backbone.default.Router.prototype.navigate.call(this, getRoute(this, fragment), options);
  }
};
var BaseRouter = _backbone.default.Router.extend(props);
exports["default"] = BaseRouter;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/ButtonFactory.js":
/*!***************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/ButtonFactory.js ***!
  \***************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ./underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _BaseButtonLink = _interopRequireDefault(__webpack_require__(/*! ../views/components/BaseButtonLink.js */ "./packages/@okta/courage-dist/esm/src/courage/views/components/BaseButtonLink.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint '@okta/okta-ui/no-deprecated-methods': [0, [{ name: 'BaseButtonLink.extend', use: 'Okta.createButton'}, ]] */
/**
 * A factory method wrapper for {@link BaseButtonLink} creation
 * @class module:Okta.internal.util.ButtonFactory
 */

function normalizeEvents(options) {
  const events = _underscoreWrapper.default.extend(options.click ? {
    click: options.click
  } : {}, options.events || {});
  const target = {};
  _underscoreWrapper.default.each(events, function (fn, eventName) {
    target[eventName] = function (e) {
      if (!options.href) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (!(this.disabled && eventName === 'click')) {
        fn.apply(this, arguments);
      }
    };
  });
  return target;
}
var ButtonFactory = /** @lends module:Okta.internal.util.ButtonFactory */
{
  /**
   * Creates a {@link module:Okta.internal.views.components.BaseButtonLink|BaseButtonLink}.
   * @param  {Object} options Options hash
   * @param  {String} [options.title] The button text
   * @param  {String} [options.icon]
   * CSS class for the icon to display. See [Style guide](http://rain.okta1.com:1802/su/dev/style-guide#icons)
   * @param {String} [options.href] The button link
   * @param {Function} [options.click] On click callback
   * @param {Object} [options.events] a [Backbone events](http://backbonejs.org/#View-delegateEvents) hash
   * @returns {module:Okta.internal.views.components.BaseButtonLink} BaseButtonLink prototype ("class")
   */
  create: function (options) {
    options = _underscoreWrapper.default.clone(options);
    options.attrs = options.attributes;
    delete options.attributes;
    return _BaseButtonLink.default.extend(_underscoreWrapper.default.extend(options, {
      events: normalizeEvents(options)
    }));
  }
};
exports["default"] = ButtonFactory;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/Class.js":
/*!*******************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/Class.js ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = Class;
var _backbone = _interopRequireDefault(__webpack_require__(/*! ../vendor/lib/backbone.js */ "./packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ./underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function Class(options) {
  this.options = _underscoreWrapper.default.clone(options || {});
  this.cid = _underscoreWrapper.default.uniqueId('class');
  this.initialize.apply(this, arguments);
}
_underscoreWrapper.default.extend(Class.prototype, _backbone.default.Events, {
  initialize: function () {}
});
Class.extend = _backbone.default.Model.extend;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/Clipboard.js":
/*!***********************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/Clipboard.js ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _clipboard = _interopRequireDefault(__webpack_require__(/*! clipboard */ "./node_modules/clipboard/lib/clipboard.js"));
var _jqueryWrapper = _interopRequireDefault(__webpack_require__(/*! ./jquery-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ./underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _View = _interopRequireDefault(__webpack_require__(/*! ../framework/View.js */ "./packages/@okta/courage-dist/esm/src/courage/framework/View.js"));
var _Class = _interopRequireDefault(__webpack_require__(/*! ./Class.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Class.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Clipboard = _clipboard.default;
const OPTIONS = ['success', 'error', 'target', 'text'];
const ClipboardClipboardWrapper = _Class.default.extend({
  initialize: function (el, options) {
    /* eslint complexity:0, max-statements: [2, 24] */
    options = _underscoreWrapper.default.pick(options || {}, OPTIONS);
    let trigger;
    let target;
    let text;
    if (_underscoreWrapper.default.isString(el)) {
      trigger = el;
    }
    if (_underscoreWrapper.default.isElement(el)) {
      trigger = el;
    }
    if (el instanceof _jqueryWrapper.default) {
      trigger = el.selector; // TODO: use stronger type
    }

    if (el instanceof _View.default) {
      trigger = el.el;
    }
    if (_underscoreWrapper.default.isFunction(options.target)) {
      target = options.target;
    }
    if (_underscoreWrapper.default.isElement(options.target)) {
      target = _underscoreWrapper.default.constant(options.target);
    }
    if (_underscoreWrapper.default.isString(options.text)) {
      text = _underscoreWrapper.default.constant(options.text);
    } else if (_underscoreWrapper.default.isFunction(options.text)) {
      text = options.text;
    }
    this.__instance = new Clipboard(trigger, {
      target: target,
      text: text
    });
    this.done = _underscoreWrapper.default.partial(this.__setCallback, 'success');
    this.error = _underscoreWrapper.default.partial(this.__setCallback, 'error');
    this.done(options.success);
    this.error(options.error);
  },
  __setCallback: function (event, callback) {
    if (!_underscoreWrapper.default.isFunction(callback)) {
      return;
    }
    this.__instance.on(event, callback);
    return this.__instance;
  }
});
/**
 * @class Clipboard
 * @abstract
 *
 * Abstract class that initializes a Clipboard
 *   https://clipboardjs.com/
 *
 * ### Example:
 *
 *  ```javascript
 *  //attach a selector
 *  Clipboard.attach('.copy-button');
 *
 *  //attach a node, and set a constant string
 *  Clipboard.attach(buttonView.el, {
 *    text: 'this is the content'
 *  });
 *
 *  //attach a view, set text dynamically, and set callback
 *  Clipboard.attach(buttonView, {
 *    text: function (triggerNode) {
 *      return $(triggerNode).attr('foo') + model.get('userName');
 *    }
 *  }).done(function (targetNode) {
 *    var msg = ['"', targetNode.text, '" is copied'].join('');
 *    view.notify('success', msg);
 *  });
 *
 *  //attach a jquery object, set the target node, and set callback
 *  Clipboard.attach($('.customizeTarget'), {
 *    target: function (triggerNode) {
 *      return triggerNode;
 *    },
 *    success: function (targetNode) {
 *      view.notify('success', 'copied!');
 *    }
 *  });
 *
 * ```
 */

var Clipboard$1 = {
  /**
   * @param {String|Node|View|jQuery} [el] el could be a selector (recommended),
   *           a dom node, a view or a jquery object
   * @param {Object} [options] Options hash
   * @param  {Node|Function} [options.target] a static dom node
   *           or a function that takes trigger node and returns a target node
   * @param {String|Function} [options.text] a static string or a function that returns a string dynamically
   * @param {Function} [options.success] success callback
   * @param {Function} [options.error] error callback
   * @return {Object} The clipboard object
   */
  attach: function (el, options) {
    return new ClipboardClipboardWrapper(el, options);
  }
};
exports["default"] = Clipboard$1;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/Cookie.js":
/*!********************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/Cookie.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ./underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _jsCookie = _interopRequireDefault(__webpack_require__(/*! ../vendor/lib/js.cookie.js */ "./packages/@okta/courage-dist/esm/src/courage/vendor/lib/js.cookie.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SECURED_COOKIE = /^https/.test(window.location.href);
var Cookie = {
  setCookie: function (name, value, options) {
    _jsCookie.default.set(name, value, _underscoreWrapper.default.defaults(options || {}, {
      secure: SECURED_COOKIE,
      path: '/'
    }));
  },
  getCookie: function () {
    return _jsCookie.default.get.apply(_jsCookie.default, arguments);
  },
  removeCookie: function () {
    return _jsCookie.default.remove.apply(_jsCookie.default, arguments);
  }
};
exports["default"] = Cookie;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/Keys.js":
/*!******************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/Keys.js ***!
  \******************************************************************/
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var Keys = {
  UP: 38,
  DOWN: 40,
  DEL: 46,
  TAB: 9,
  RETURN: 13,
  ENTER: 13,
  ESC: 27,
  COMMA: 188,
  PAGEUP: 33,
  PAGEDOWN: 34,
  SPACE: 32,
  BACKSPACE: 8,
  __isKey: function (e, key) {
    return (e.which || e.keyCode) === this[key];
  },
  isEnter: function (e) {
    return this.__isKey(e, 'ENTER');
  },
  isEsc: function (e) {
    return this.__isKey(e, 'ESC');
  },
  isSpaceBar: function (e) {
    return this.__isKey(e, 'SPACE');
  }
};
exports["default"] = Keys;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/Logger.js":
/*!********************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/Logger.js ***!
  \********************************************************************/
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
function log(level, ...args) {
  if (window.console && window.okta && window.okta.debug) {
    window.console[level](...args);
  }
}
/**
 * Utility library of logging functions.
 * @class module:Okta.Logger
 */

var Logger = /** @lends module:Okta.Logger */
{
  /**
   * See [console.trace](https://developer.mozilla.org/en-US/docs/Web/API/Console.trace)
   * @static
   */
  trace: function (...args) {
    return log('trace', ...args);
  },
  /**
   * See [console.dir](https://developer.mozilla.org/en-US/docs/Web/API/Console.dir)
   * @static
   */
  dir: function (...args) {
    return log('dir', ...args);
  },
  /**
   * See [console.time](https://developer.mozilla.org/en-US/docs/Web/API/Console.time)
   * @static
   */
  time: function (...args) {
    return log('time', ...args);
  },
  /**
   * See [console.timeEnd](https://developer.mozilla.org/en-US/docs/Web/API/Console.timeEnd)
   * @static
   */
  timeEnd: function (...args) {
    return log('timeEnd', ...args);
  },
  /**
   * See [console.group](https://developer.mozilla.org/en-US/docs/Web/API/Console.group)
   * @static
   */
  group: function (...args) {
    return log('group', ...args);
  },
  /**
   * See [console.groupEnd](https://developer.mozilla.org/en-US/docs/Web/API/Console.groupEnd)
   * @static
   */
  groupEnd: function (...args) {
    return log('groupEnd', ...args);
  },
  /**
   * See [console.assert](https://developer.mozilla.org/en-US/docs/Web/API/Console.assert)
   * @static
   */
  assert: function (...args) {
    return log('assert', ...args);
  },
  /**
   * See [console.log](https://developer.mozilla.org/en-US/docs/Web/API/Console.log)
   * @static
   */
  log: function (...args) {
    return log('log', ...args);
  },
  /**
   * See [console.info](https://developer.mozilla.org/en-US/docs/Web/API/Console.info)
   * @static
   */
  info: function (...args) {
    return log('info', ...args);
  },
  /**
   * See [console.warn](https://developer.mozilla.org/en-US/docs/Web/API/Console.warn)
   * @static
   */
  warn: function (...args) {
    return log('warn', ...args);
  },
  /**
   * See [console.error](https://developer.mozilla.org/en-US/docs/Web/API/Console.error)
   * @static
   */
  error: function (...args) {
    return log('error', ...args);
  }
};
exports["default"] = Logger;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/SchemaUtil.js":
/*!************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/SchemaUtil.js ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ./underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _StringUtil = _interopRequireDefault(__webpack_require__(/*! ./StringUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/StringUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const loc = _StringUtil.default.localize;
const SchemaUtils = {
  STRING: 'string',
  NUMBER: 'number',
  INTEGER: 'integer',
  BOOLEAN: 'boolean',
  OBJECT: 'object',
  FORMATDISPLAYTYPE: {
    'date-time': 'date',
    uri: 'uri',
    email: 'email',
    // TODO: settle on using EITHER underscores OR hyphens --- not both (OKTA-202818)
    'country-code': 'country-code',
    'language-code': 'language-code',
    'country_code': 'country_code',
    'language_code': 'language_code',
    locale: 'locale',
    timezone: 'timezone',
    'ref-id': 'reference'
  },
  ARRAYDISPLAYTYPE: {
    arrayofobject: 'arrayofobject',
    arrayofstring: 'arrayofstring',
    arrayofnumber: 'arrayofnumber',
    arrayofinteger: 'arrayofinteger',
    'arrayofref-id': 'arrayofref-id'
  },
  DISPLAYTYPES: {
    date: {
      type: 'string',
      format: 'date-time'
    },
    uri: {
      type: 'string',
      format: 'uri'
    },
    email: {
      type: 'string',
      format: 'email'
    },
    // TODO: Resolve inconsistencies in hyphens vs. underscores for these properties (OKTA-202818)
    // use country-code if attribute should be restricted to country code type
    'country-code': {
      type: 'string',
      format: 'country-code'
    },
    'language-code': {
      type: 'string',
      format: 'language-code'
    },
    'country_code': {
      type: 'string'
    },
    'language_code': {
      type: 'string'
    },
    locale: {
      type: 'string',
      format: 'locale'
    },
    timezone: {
      type: 'string',
      format: 'timezone'
    },
    string: {
      type: 'string'
    },
    number: {
      type: 'number'
    },
    boolean: {
      type: 'boolean'
    },
    integer: {
      type: 'integer'
    },
    reference: {
      type: 'string',
      format: 'ref-id'
    },
    arrayofobject: {
      type: 'array',
      items: {
        type: 'object'
      }
    },
    arrayofstring: {
      type: 'array',
      items: {
        type: 'string'
      }
    },
    arrayofnumber: {
      type: 'array',
      items: {
        type: 'number'
      }
    },
    arrayofinteger: {
      type: 'array',
      items: {
        type: 'integer'
      }
    },
    'arrayofref-id': {
      type: 'array',
      items: {
        type: 'string',
        format: 'ref-id'
      }
    },
    image: {
      type: 'image'
    },
    password: {
      type: 'string'
    }
  },
  SUPPORTSMINMAX: ['string', 'number', 'integer', 'password'],
  SUPPORTENUM: ['string', 'number', 'integer', 'object', 'arrayofstring', 'arrayofnumber', 'arrayofinteger', 'arrayofobject'],
  DATATYPE: {
    string: 'string',
    number: 'number',
    boolean: 'boolean',
    integer: 'integer',
    date: 'datetime',
    object: 'object',
    arrayofobject: 'object array',
    arrayofstring: 'string array',
    arrayofnumber: 'number array',
    arrayofinteger: 'integer array',
    'arrayofref-id': 'reference array',
    // TODO: settle on using EITHER underscores OR hyphens --- not both (OKTA-202818)
    'country-code': 'country code',
    'language-code': 'language code',
    'country_code': 'country code',
    'language_code': 'language code',
    reference: 'reference',
    timezone: 'timezone',
    image: 'image'
  },
  MUTABILITY: {
    READONLY: 'READ_ONLY',
    WRITEONLY: 'WRITE_ONLY',
    READWRITE: 'READ_WRITE',
    IMMUTABLE: 'IMMUTABLE'
  },
  SCOPE: {
    NONE: 'NONE',
    SELF: 'SELF',
    SYSTEM: 'SYSTEM'
  },
  DISPLAYSCOPE: {
    SELF: 'User personal',
    SYSTEM: 'System',
    NA: 'None'
  },
  UNION: {
    DISABLE: 'DISABLE',
    ENABLE: 'ENABLE'
  },
  UNION_OPTIONS: {
    DISABLE: loc('universal-directory.profiles.attribute.form.union.enable.display', 'courage'),
    ENABLE: loc('universal-directory.profiles.attribute.form.union.disable.display', 'courage')
  },
  PERMISSION: {
    HIDE: 'HIDE',
    READ_ONLY: 'READ_ONLY',
    WRITE_ONLY: 'WRITE_ONLY',
    READ_WRITE: 'READ_WRITE'
  },
  ENDUSER_ATTRIBUTE_PERMISSION_OPTIONS: {
    HIDE: loc('universal-directory.profiles.attribute.enduser.permission.hide', 'courage'),
    READ_ONLY: loc('universal-directory.profiles.attribute.enduser.permission.readonly', 'courage'),
    READ_WRITE: loc('universal-directory.profiles.attribute.enduser.permission.readwrite', 'courage')
  },
  // eslint-disable-next-line inclusive-language/use-inclusive-words
  ATTRIBUTE_LEVEL_MASTERING_OPTIONS: {
    INHERIT: loc('universal-directory.profiles.attribute.source.inherit', 'courage'),
    // eslint-disable-next-line inclusive-language/use-inclusive-words
    OKTA_MASTERED: loc('universal-directory.profiles.attribute.source.oktamastered', 'courage'),
    OVERRIDE: loc('universal-directory.profiles.attribute.source.override', 'courage')
  },
  USERNAMETYPE: {
    NONE: 'non-username',
    OKTA_TO_APP: 'okta-to-app-username',
    OKTA_TO_AD: 'okta-to-ad-username',
    APP_TO_OKTA: 'app-to-okta-username',
    IDP_TO_OKTA: 'idp-to-okta-username'
  },
  LOGINPATTERNFORMAT: {
    EMAIL: 'EMAIL',
    CUSTOM: 'CUSTOM',
    NONE: 'NONE'
  },
  UNIQUENESS: {
    NOT_UNIQUE: 'NOT_UNIQUE',
    PENDING_UNIQUENESS: 'PENDING_UNIQUENESS',
    UNIQUE_VALIDATED: 'UNIQUE_VALIDATED'
  },
  /*
   * Get a display string for a schema attribute type.
   * @param {String} type Type of an attribute
   * @param {String} format Format of an attribute
   * @param {String} itemType Item type of an attribute if an array
   * @param {String} defaultValue The default value if an attribute type is undefined
   * @return {String} the display value
   */
  getDisplayType: function (type, format, itemType, defaultValue) {
    let displayType; // type is undefined for
    // - an un-mapped source attribute from mapping
    // - an source attribute which is mapped to username target attribute

    if (type) {
      // format is only defined for complicated types (ex. reference, date time, array)
      // not for simple types (ex. string, integer, boolean)
      if (format) {
        displayType = this.FORMATDISPLAYTYPE[format];
      } else {
        // itemType is only defined for array type
        // to specify an array element type (ex. string, integer, number)
        displayType = itemType ? this.ARRAYDISPLAYTYPE[type + 'of' + itemType] : type;
      }
    }
    if (!displayType) {
      displayType = typeof defaultValue === 'undefined' ? '' : defaultValue;
    }
    return displayType;
  },
  /*
   * Get attribute mapping source attribute username type
   * @param {String} mappingDirection
   * @param {String} targetName The mapping target attribute name
   * @param {String} appName The app name that's mapped to/from Okta
   * @return {String} the source attribute username type value
   */
  getSourceUsernameType: function (mappingDirection, targetName, appName) {
    let sourceUsernameType = this.USERNAMETYPE.NONE;
    /* eslint complexity: [2, 7] */

    if (mappingDirection === 'oktaToApp') {
      if (targetName === 'userName') {
        sourceUsernameType = this.USERNAMETYPE.OKTA_TO_APP;
      } else if (targetName === 'cn') {
        sourceUsernameType = this.USERNAMETYPE.OKTA_TO_AD;
      }
    } else if (mappingDirection === 'appToOkta' && targetName === 'login') {
      if (appName === 'saml_idp') {
        sourceUsernameType = this.USERNAMETYPE.IDP_TO_OKTA;
      } else {
        sourceUsernameType = this.USERNAMETYPE.APP_TO_OKTA;
      }
    }
    return sourceUsernameType;
  },
  isArrayDataType: function (type) {
    return _underscoreWrapper.default.contains(_underscoreWrapper.default.values(this.ARRAYDISPLAYTYPE), type);
  },
  isObjectDataType: function (type) {
    return this.DATATYPE.object === type;
  }
};
exports["default"] = SchemaUtils;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/SettingsModel.js":
/*!***************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/SettingsModel.js ***!
  \***************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ./underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _Model = _interopRequireDefault(__webpack_require__(/*! ../models/Model.js */ "./packages/@okta/courage-dist/esm/src/courage/models/Model.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @class SettingsModel
 * @extends {Okta.Model}
 * @private
 */
const props = {
  local: function () {
    const settings = window.okta && window.okta.settings || {};
    const theme = window.okta && window.okta.theme || '';
    return {
      orgId: ['string', false, settings.orgId],
      orgName: ['string', false, settings.orgName],
      serverStatus: ['string', false, settings.serverStatus],
      persona: ['string', false, settings.persona],
      isDeveloperConsole: ['boolean', false, settings.isDeveloperConsole],
      isPreview: ['boolean', false, settings.isPreview],
      permissions: ['array', true, settings.permissions || []],
      theme: ['string', false, theme]
    };
  },
  constructor: function () {
    _Model.default.apply(this, arguments);
    this.features = window._features || [];
  },
  /**
   * Checks if the user have a feature flag enabled (Based of the org level feature flag)
   * @param  {String}  feature Feature name
   * @return {Boolean}
   */
  hasFeature: function (feature) {
    return _underscoreWrapper.default.contains(this.features, feature);
  },
  /**
   * Checks if any of the given feature flags are enabled (Based of the org level feature flags)
   * @param  {Array}  featureArray Features names
   * @return {Boolean} true if any of the give features are enabled. False otherwise
   */
  hasAnyFeature: function (featureArray) {
    return _underscoreWrapper.default.some(featureArray, this.hasFeature, this);
  },
  /**
   * Checks if the user have a specific permission (based on data passed from JSP)
   * @param  {String}  permission Permission name
   * @return {Boolean}
   */
  hasPermission: function (permission) {
    return _underscoreWrapper.default.contains(this.get('permissions'), permission);
  },
  /**
   * Checks if the org has ds theme set
   * @return {Boolean}
   */
  isDsTheme: function () {
    return this.get('theme') === 'dstheme';
  }
};
var SettingsModel = _Model.default.extend(props);
exports["default"] = SettingsModel;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/StateMachine.js":
/*!**************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/StateMachine.js ***!
  \**************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ./underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _Model = _interopRequireDefault(__webpack_require__(/*! ../models/Model.js */ "./packages/@okta/courage-dist/esm/src/courage/models/Model.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @class StateMachine
 * @extends Okta.Model
 * @private
 *
 * A state object that holds the applciation state
 */
var StateMachine = _Model.default.extend({
  /**
   * Invokes a method on the applicable {@link Okta.Controller}
   *
   * ```javascript
   * state.invoke('methodName', 'param1', 'param2')
   * // Will call
   * contoller.methodName('param1', 'param2')
   * ```
   * @param {String} methodName the name of the controller method to invoke on the controller
   */
  invoke: function () {
    const args = _underscoreWrapper.default.toArray(arguments);
    args.unshift('__invoke__');
    this.trigger.apply(this, args);
  }
});
exports["default"] = StateMachine;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/StringUtil.js":
/*!************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/StringUtil.js ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _jqueryWrapper = _interopRequireDefault(__webpack_require__(/*! ./jquery-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ./underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _oktaI18nBundles = _interopRequireDefault(__webpack_require__(/*! @okta/okta-i18n-bundles */ "./src/util/Bundles.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const entityMap = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': '\'',
  '&#039;': '\'',
  '&#x2F;': '/'
};
const emailValidator = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(?!-)((\[?[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\]?)|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
/**
* Converts the locale code identifier from "${languageCode}-${countryCode}" to "${languageCode}_${countryCode}"
* Follows the ISO-639-1 language code and 2-letter ISO-3166-1-alpha-2 country code structure.
* @param {String} locale code identifier
* @return {String} converted locale code identifier
*/

const parseLocale = locale => {
  if (/-/.test(locale)) {
    const parts = locale.split('-');
    parts[1] = parts[1].toUpperCase();
    return parts.join('_');
  }
  return locale;
};
/* eslint max-len: 0*/

/**
 * Returns the user's locale as defined by window.okta.locale
 */

function getRawLocale() {
  if (window && window.okta && window.okta.locale) {
    const isEnableBcp47OktaUi = window.okta.isEnableBcp47OktaUi;
    return isEnableBcp47OktaUi ? window.okta.locale : window.okta.locale.toLowerCase();
  }
  return 'en';
}
/**
 * Returns the language bundle based on the current locale.
 * - If a locale is not provided, default to English ('en')
 * - Legacy Support: If the named language bundle does not exist, fall back to the default named bundle.
 *
 * @param {*} bundleName
 */

function getBundle(bundleName) {
  if (!bundleName) {
    return _oktaI18nBundles.default[_underscoreWrapper.default.keys(_oktaI18nBundles.default)[0]];
  }
  const locale = parseLocale(getRawLocale());
  return _oktaI18nBundles.default[`${bundleName}_${locale}`] || _oktaI18nBundles.default[bundleName];
}
/**
 *
 * CustomEvent polyfill for IE
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#polyfill
 */

function IECustomEvent(event, params) {
  params = params || {
    bubbles: false,
    cancelable: false,
    detail: null
  };
  var evt = document.createEvent('CustomEvent');
  evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
  return evt;
}
/**
 * Call the window.okta.emitL10nError function if it is defined
 * @param {String} key The i18n key
 * @param {String} bundleName The i18n bundle name
 * @param {String} reason Could be 'bundle' (Bundle not found), 'key' (Key not found) or 'parameters' (Parameters mismatch).
 */

function emitL10nError(key, bundleName, reason) {
  // CustomEvent polyfill for IE
  if (!window.CustomEvent) {
    window.CustomEvent = IECustomEvent;
  } // dispatchEvent for sentry

  if (typeof window.CustomEvent === 'function') {
    const event = new CustomEvent('okta-i18n-error', {
      detail: {
        type: 'l10n-error',
        key: key,
        bundleName: bundleName,
        reason: reason
      }
    });
    document.dispatchEvent(event);
  }
}
const StringUtil = /** @lends module:Okta.internal.util.StringUtil */
{
  /** @static */
  getRawLocale: function () {
    return getRawLocale();
  },
  /** @static */
  getParsedLocale: function () {
    return parseLocale(getRawLocale());
  },
  /** @static */
  isLocaleBundleExist: function (bundleName, locale) {
    const parsedLocale = parseLocale(locale);
    return !!_oktaI18nBundles.default[`${bundleName}_${parsedLocale}`];
  },
  /** @static */
  sprintf: function () {
    const args = Array.prototype.slice.apply(arguments);
    let value = args.shift();
    let oldValue = value;
    /* eslint max-statements: [2, 15] */

    function triggerError() {
      throw new Error('Mismatch number of variables: ' + arguments[0] + ', ' + JSON.stringify(args));
    }
    for (var i = 0, l = args.length; i < l; i++) {
      const entity = args[i];
      const regex = new RegExp('\\{' + i + '\\}', 'g');
      value = value.replace(regex, entity);
      if (entity === undefined || entity === null || value === oldValue) {
        triggerError();
      }
      oldValue = value;
    }
    if (/\{[\d+]\}/.test(value)) {
      triggerError();
    }
    return value;
  },
  /**
   * Converts a URI encoded query string into a hash map
   * @param  {String} query The query string
   * @return {Object} The map
   * @static
   * @example
   * StringUtil.parseQuery('foo=bar&baz=qux') // {foo: 'bar', baz: 'qux'}
   */
  parseQuery: function (query) {
    const params = {};
    const pairs = decodeURIComponent(query.replace(/\+/g, ' ')).split('&');
    for (var i = 0; i < pairs.length; i++) {
      const pair = pairs[i];
      const data = pair.split('=');
      params[data.shift()] = data.join('=');
    }
    return params;
  },
  /** @static */
  encodeJSObject: function (jsObj) {
    return encodeURIComponent(JSON.stringify(jsObj));
  },
  /** @static */
  decodeJSObject: function (jsObj) {
    try {
      return JSON.parse(decodeURIComponent(jsObj));
    } catch (e) {
      return null;
    }
  },
  /** @static */
  unescapeHtml: function (string) {
    return String(string).replace(/&[\w#\d]{2,};/g, function (s) {
      return entityMap[s] || s;
    });
  },
  /**
   * Get the original i18n template directly without string format with parameters
   * @param {String} key The key
   * @param {String} bundle="messages"] The name of the i18n bundle. Defaults to the first bundle in the list.
   */
  getTemplate: function (key, bundleName) {
    const bundle = getBundle(bundleName);
    if (!bundle) {
      emitL10nError(key, bundleName, 'bundle');
      return 'L10N_ERROR[' + bundleName + ']';
    }
    if (bundle[key]) {
      return bundle[key];
    } else {
      emitL10nError(key, bundleName, 'key');
      return 'L10N_ERROR[' + key + ']';
    }
  },
  /**
   * Translate a key to the localized value
   * @static
   * @param  {String} key The key
   * @param  {String} [bundle="messages"] The name of the i18n bundle. Defaults to the first bundle in the list.
   * @param  {Array} [params] A list of parameters to apply as tokens to the i18n value
   * @return {String} The localized value
   */
  localize: function (key, bundleName, params) {
    const bundle = getBundle(bundleName);
    /* eslint complexity: [2, 6] */

    if (!bundle) {
      emitL10nError(key, bundleName, 'bundle');
      return 'L10N_ERROR[' + bundleName + ']';
    }
    let value = bundle[key];
    try {
      params = params && params.slice ? params.slice(0) : [];
      params.unshift(value);
      value = StringUtil.sprintf.apply(null, params);
      if (value) {
        return value;
      } else {
        emitL10nError(key, bundleName, 'key');
        return 'L10N_ERROR[' + key + ']';
      }
    } catch (e) {
      emitL10nError(key, bundleName, 'parameters');
      return 'L10N_ERROR[' + key + ']';
    }
  },
  /**
   * Convert a string to a float if valid, otherwise return the string.
   * Valid numbers may contain a negative sign and a decimal point.
   * @static
   * @param {String} string The string to convert to a number
   * @return {String|Number} Returns a number if the string can be casted, otherwise returns the original string
   */
  parseFloat: function (string) {
    const number = +string;
    return typeof string === 'string' && number === parseFloat(string) ? number : string;
  },
  /**
   * Convert a string to an integer if valid, otherwise return the string
   * @static
   * @param {String} string The string to convert to an integer
   * @return {String|integer} Returns an integer if the string can be casted, otherwise, returns the original string
   */
  parseInt: function (string) {
    const int = +string;
    return _underscoreWrapper.default.isString(string) && int === parseInt(string, 10) ? int : string;
  },
  /**
   * Convert a string to an object if valid, otherwise return the string
   * @static
   * @param {String} string The string to convert to an object
   * @return {String|object} Returns an object if the string can be casted, otherwise, returns the original string
   */
  parseObject: function (string) {
    if (!_underscoreWrapper.default.isString(string)) {
      return string;
    }
    try {
      const object = JSON.parse(string);
      return _jqueryWrapper.default.isPlainObject(object) ? object : string;
    } catch (e) {
      return string;
    }
  },
  /**
   * Returns a random string from [a-z][A-Z][0-9] of a given length
   * @static
   * @param {Number} length The length of the random string.
   * @return {String} Returns a random string from [a-z][A-Z][0-9] of a given length
   */
  randomString: function (length) {
    const characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
    if (length === undefined) {
      length = _underscoreWrapper.default.random(characters.length);
    } else if (length === 0) {
      return '';
    }
    const stringArray = [];
    while (length--) {
      stringArray.push(characters[_underscoreWrapper.default.random(characters.length - 1)]);
    }
    return stringArray.join('');
  },
  /**
   * Returns if a str ends with another string
   * @static
   * @param {String} str The string to search
   * @param {String} ends The string it should end with
   *
   * @return {Boolean} Returns if the str ends with ends
   */
  endsWith: function (str, ends) {
    str += '';
    ends += '';
    return str.length >= ends.length && str.substring(str.length - ends.length) === ends;
  },
  /** @static */
  isEmail: function (str) {
    const target = _jqueryWrapper.default.trim(str);
    return !_underscoreWrapper.default.isEmpty(target) && emailValidator.test(target);
  }
};
exports["default"] = StringUtil;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/TemplateUtil.js":
/*!**************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/TemplateUtil.js ***!
  \**************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ./underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint @okta/okta-ui/no-specific-methods: 0 */
/**
 * @class module:Okta.internal.util.TemplateUtil
 * @hideconstructor
 */

var TemplateUtil = /** @lends module:Okta.internal.util.TemplateUtil */
{
  /**
   * Compiles a Handlebars template
   * @static
   * @method
   */
  // TODO: This will be deprecated at some point. Views should use pre-compiled templates
  tpl: _underscoreWrapper.default.memoize(function (tpl) {
    /* eslint @okta/okta-ui/no-specific-methods: 0 */
    return function (context) {
      return _handlebarsRuntime.default.compile(tpl)(context);
    };
  })
};
exports["default"] = TemplateUtil;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/Time.js":
/*!******************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/Time.js ***!
  \******************************************************************/
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var Time = {
  DEBOUNCE_DELAY: 200,
  LOADING_FADE: 400,
  UNLOADING_FADE: 400,
  ROW_EXPANDER_TRANSITION: 150,
  HIDE_ADD_MAPPING_FORM: 300
};
exports["default"] = Time;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/Util.js":
/*!******************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/Util.js ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ./underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../views/BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Util = {
  redirect: function (url) {
    window.location = url;
  },
  reloadPage: function () {
    window.location.reload();
  },
  constantError: function (errorMessage) {
    return function () {
      throw new Error(errorMessage);
    };
  },
  /**
   * Simply convert an URL query key value pair object into an URL query string.
   * Remember NOT to escape the query string when using this util.
   * example:
   * input: {userId: 123, instanceId: undefined, expand: 'schema,app'}
   * output: '?userId=123&expand=schema,app'
   */
  getUrlQueryString: function (queries) {
    _underscoreWrapper.default.isObject(queries) || (queries = {});
    const queriesString = _underscoreWrapper.default.without(_underscoreWrapper.default.map(queries, function (value, key) {
      if (value !== undefined && value !== null) {
        return key + '=' + encodeURIComponent(value);
      }
    }), undefined).join('&');
    return _underscoreWrapper.default.isEmpty(queriesString) ? '' : '?' + queriesString;
  },
  isABaseView: function (obj) {
    return obj instanceof _BaseView.default || obj.prototype instanceof _BaseView.default || obj === _BaseView.default;
  },
  isSafari: function () {
    // All native, android and iOS chrome browsers has "Safari" in their userAgent string, so this regex should
    // evaluate to true for only Safari browser and not any chrome browsers.
    // https://stackoverflow.com/questions/7944460/detect-safari-browser
    // https://stackoverflow.com/questions/13807810/ios-chrome-detection/13808053#13808053
    return /^((?!chrome|android|crios).)*safari/i.test(navigator.userAgent);
  }
};
exports["default"] = Util;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/ViewUtil.js":
/*!**********************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/ViewUtil.js ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ./underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function changeEventString(doWhen) {
  return 'change:' + _underscoreWrapper.default.keys(doWhen).join(' change:');
}
function calcDoWhen(value, key) {
  const modelValue = this.model.get(key);
  if (_underscoreWrapper.default.isFunction(value)) {
    return value.call(this, modelValue);
  } else {
    return value === modelValue;
  }
}
function _doWhen(view, doWhen, fn) {
  const toggle = _underscoreWrapper.default.bind(fn, view, view, doWhen);
  view.render = _underscoreWrapper.default.wrap(view.render, function (render) {
    const val = render.call(view);
    toggle({
      animate: false
    });
    return val;
  });
  view.listenTo(view.model, changeEventString(doWhen), function () {
    toggle({
      animate: true
    });
  });
}
var ViewUtil = {
  applyDoWhen: function (view, doWhen, fn) {
    if (!(view.model && _underscoreWrapper.default.isObject(doWhen) && _underscoreWrapper.default.size(doWhen) && _underscoreWrapper.default.isFunction(fn))) {
      return;
    }
    _doWhen(view, doWhen, function (view, doWhen, options) {
      const result = _underscoreWrapper.default.every(_underscoreWrapper.default.map(doWhen, calcDoWhen, view));
      fn.call(view, result, options);
    });
  }
};
exports["default"] = ViewUtil;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/handlebars/handle-url.js":
/*!***********************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/handlebars/handle-url.js ***!
  \***********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function () {
    return _handlebarsRuntime.default;
  }
}));
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const clonedEscapeExpression = _handlebarsRuntime.default.Utils.escapeExpression;
_handlebarsRuntime.default.Utils.escapeExpression = function (string) {
  return clonedEscapeExpression(string).replace(/&#x3D;/g, '=');
};
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/handlebars/helper-i18n.js":
/*!************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/handlebars/helper-i18n.js ***!
  \************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function () {
    return _handlebarsRuntime.default;
  }
}));
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _Logger = _interopRequireDefault(__webpack_require__(/*! ../Logger.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Logger.js"));
var _StringUtil = _interopRequireDefault(__webpack_require__(/*! ../StringUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/StringUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint @okta/okta-ui/no-specific-modules: 0 */
const hbsEscape = _handlebarsRuntime.default.Utils.escapeExpression;
function trim(str) {
  return str && str.replace(/^\s+|\s+$/g, '');
}
function replaceTagsWithPlaceholders(source, tag, tagValue) {
  const escapedBeginningTag = hbsEscape(`<${tag}>`);
  const escapedEndTag = hbsEscape(`</${tag}>`);
  const [beginningTag, endTag] = tagValue.split(tag);
  if (!source.includes(escapedBeginningTag) && !source.includes(escapedEndTag)) {
    throw Error(`Parsed tag "${tag}" is not present in "${source}"`);
  } else if (!tagValue.includes(tag)) {
    throw Error(`Parsed tag "${tag}" is not present in "${tagValue}"`);
  } else if (!beginningTag || !endTag) {
    throw Error(`Template value "${tagValue}" must contain beginning and closing tags`);
  }
  return source.replace(escapedBeginningTag, beginningTag).replace(escapedEndTag, endTag);
}
/* eslint max-statements: [2, 18] */

_handlebarsRuntime.default.registerHelper('i18n', function i18n(options) {
  let params;
  const key = trim(options.hash.code);
  const bundle = trim(options.hash.bundle);
  const args = trim(options.hash.arguments);
  const tags = Object.keys(options.hash).filter(prop => prop.match(/^\$\d+/)).map(prop => ({
    tag: prop,
    value: options.hash[prop]
  }));
  if (args) {
    params = _underscoreWrapper.default.map(trim(args).split(';'), function mapParam(param) {
      param = trim(param);
      let val;
      /*
       * the context(data) may be a deep object, ex {user: {name: 'John', gender: 'M'}}
       * arguments may be 'user.name'
       * return data['user']['name']
       */

      _underscoreWrapper.default.each(param.split('.'), p => {
        val = val ? val[p] : this[p];
      });
      return val;
    }, this);
  }
  const localizedValue = _StringUtil.default.localize(key, bundle, params);
  if (tags.length < 1) {
    // No HTML tags provided - return the localized and escaped string
    return localizedValue;
  }
  let escapedString = hbsEscape(localizedValue);
  try {
    tags.forEach(tag => {
      escapedString = replaceTagsWithPlaceholders(escapedString, tag.tag, tag.value);
    });
    return new _handlebarsRuntime.default.SafeString(escapedString);
  } catch (err) {
    _Logger.default.error(err.toString());
    return localizedValue;
  }
});
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js":
/*!****************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _jquery = _interopRequireDefault(__webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint-disable @okta/okta-ui/enforce-requirejs-names, @okta/okta-ui/no-specific-modules */
_jquery.default.ajaxSetup({
  beforeSend: function (xhr) {
    xhr.setRequestHeader('X-Okta-XsrfToken', (0, _jquery.default)('#_xsrfToken').text());
  },
  converters: {
    'text secureJSON': function (str) {
      if (str.substring(0, 11) === 'while(1){};') {
        str = str.substring(11);
      }
      return JSON.parse(str);
    }
  }
}); // Selenium Hook
// Widget such as autocomplete and autosuggest needs to be triggered from the running version of jQuery.
// We have 2 versions of jQuery running in parallel and they don't share the same events bus

const oktaJQueryStatic = _jquery.default;
exports["default"] = oktaJQueryStatic;
window.jQueryCourage = oktaJQueryStatic;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js":
/*!********************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js ***!
  \********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _underscoreMin = _interopRequireDefault(__webpack_require__(/*! ../../../lib/underscore/underscore-min.js */ "./packages/@okta/courage-dist/esm/lib/underscore/underscore-min.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint @okta/okta-ui/no-specific-methods: 0, @okta/okta-ui/no-specific-modules: 0 */

_underscoreMin.default.mixin({
  resultCtx: function (object, property, context, defaultValue) {
    let value = _underscoreMin.default.isObject(object) ? object[property] : void 0;
    if (_underscoreMin.default.isFunction(value)) {
      value = value.call(context || object);
    }
    if (value) {
      return value;
    } else {
      return !_underscoreMin.default.isUndefined(defaultValue) ? defaultValue : value;
    }
  },
  isInteger: function (x) {
    return _underscoreMin.default.isNumber(x) && x % 1 === 0;
  },
  // TODO: This will be deprecated at some point. Views should use precompiled templates
  // eslint-disable-next-line @okta/okta-ui/no-bare-templates
  template: function (source, data) {
    const template = _handlebarsRuntime.default.compile(source);
    if (data) {
      return template(data);
    }
    const fn = function (data) {
      return template(data);
    };
    fn.source = ''; // to conform with "CompiledTemplate" type definition

    return fn;
  }
});
const oktaUnderscore = _underscoreMin.default;
exports["default"] = oktaUnderscore;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js":
/*!****************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _commonjsHelpers = __webpack_require__(/*! ../../../../_virtual/_commonjsHelpers.js */ "./packages/@okta/courage-dist/esm/_virtual/_commonjsHelpers.js");
var _backbone = __webpack_require__(/*! ../../../../_virtual/backbone.js */ "./packages/@okta/courage-dist/esm/_virtual/backbone.js");
var _jquery = _interopRequireDefault(__webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js"));
__webpack_require__(/*! ../../../../lib/underscore/underscore-min.js */ "./packages/@okta/courage-dist/esm/lib/underscore/underscore-min.js");
var _underscoreMin2 = __webpack_require__(/*! ../../../../_virtual/underscore-min.js */ "./packages/@okta/courage-dist/esm/_virtual/underscore-min.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(function (module, exports) {
  //     Backbone.js 1.4.0
  //     (c) 2010-2019 Jeremy Ashkenas and DocumentCloud
  //     Backbone may be freely distributed under the MIT license.
  //     For all details and documentation:
  //     http://backbonejs.org
  const jQuery = _jquery.default;
  (function (factory) {
    // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
    // We use `self` instead of `window` for `WebWorker` support.
    var root = typeof self == 'object' && self.self === self && self || typeof _commonjsHelpers.commonjsGlobal == 'object' && _commonjsHelpers.commonjsGlobal.global === _commonjsHelpers.commonjsGlobal && _commonjsHelpers.commonjsGlobal; // Set up Backbone appropriately for the environment. Start with AMD.

    {
      var _ = _underscoreMin2.u.exports,
        $;
      try {
        $ = jQuery;
      } catch (e) {}
      factory(root, exports, _, $); // Finally, as a browser global.
    }
  })(function (root, Backbone, _, $) {
    // Initial Setup
    // -------------
    // Save the previous value of the `Backbone` variable, so that it can be
    // restored later on, if `noConflict` is used.
    var previousBackbone = root.Backbone; // Create a local reference to a common array method we'll want to use later.

    var slice = Array.prototype.slice; // Current version of the library. Keep in sync with `package.json`.

    Backbone.VERSION = '1.4.0'; // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
    // the `$` variable.

    Backbone.$ = $; // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
    // to its previous owner. Returns a reference to this Backbone object.

    Backbone.noConflict = function () {
      root.Backbone = previousBackbone;
      return this;
    }; // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
    // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
    // set a `X-Http-Method-Override` header.

    Backbone.emulateHTTP = false; // Turn on `emulateJSON` to support legacy servers that can't deal with direct
    // `application/json` requests ... this will encode the body as
    // `application/x-www-form-urlencoded` instead and will send the model in a
    // form param named `model`.

    Backbone.emulateJSON = false; // Backbone.Events
    // ---------------
    // A module that can be mixed in to *any object* in order to provide it with
    // a custom event channel. You may bind a callback to an event with `on` or
    // remove with `off`; `trigger`-ing an event fires all callbacks in
    // succession.
    //
    //     var object = {};
    //     _.extend(object, Backbone.Events);
    //     object.on('expand', function(){ alert('expanded'); });
    //     object.trigger('expand');
    //

    var Events = Backbone.Events = {}; // Regular expression used to split event strings.

    var eventSplitter = /\s+/; // A private global variable to share between listeners and listenees.

    var _listening; // Iterates over the standard `event, callback` (as well as the fancy multiple
    // space-separated events `"change blur", callback` and jQuery-style event
    // maps `{event: callback}`).

    var eventsApi = function (iteratee, events, name, callback, opts) {
      var i = 0,
        names;
      if (name && typeof name === 'object') {
        // Handle event maps.
        if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
        for (names = _.keys(name); i < names.length; i++) {
          events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
        }
      } else if (name && eventSplitter.test(name)) {
        // Handle space-separated event names by delegating them individually.
        for (names = name.split(eventSplitter); i < names.length; i++) {
          events = iteratee(events, names[i], callback, opts);
        }
      } else {
        // Finally, standard events.
        events = iteratee(events, name, callback, opts);
      }
      return events;
    }; // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.

    Events.on = function (name, callback, context) {
      this._events = eventsApi(onApi, this._events || {}, name, callback, {
        context: context,
        ctx: this,
        listening: _listening
      });
      if (_listening) {
        var listeners = this._listeners || (this._listeners = {});
        listeners[_listening.id] = _listening; // Allow the listening to use a counter, instead of tracking
        // callbacks for library interop

        _listening.interop = false;
      }
      return this;
    }; // Inversion-of-control versions of `on`. Tell *this* object to listen to
    // an event in another object... keeping track of what it's listening to
    // for easier unbinding later.

    Events.listenTo = function (obj, name, callback) {
      if (!obj) return this;
      var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
      var listeningTo = this._listeningTo || (this._listeningTo = {});
      var listening = _listening = listeningTo[id]; // This object is not listening to any other events on `obj` yet.
      // Setup the necessary references to track the listening callbacks.

      if (!listening) {
        this._listenId || (this._listenId = _.uniqueId('l'));
        listening = _listening = listeningTo[id] = new Listening(this, obj);
      } // Bind callbacks on obj.

      var error = tryCatchOn(obj, name, callback, this);
      _listening = void 0;
      if (error) throw error; // If the target obj is not Backbone.Events, track events manually.

      if (listening.interop) listening.on(name, callback);
      return this;
    }; // The reducing API that adds a callback to the `events` object.

    var onApi = function (events, name, callback, options) {
      if (callback) {
        var handlers = events[name] || (events[name] = []);
        var context = options.context,
          ctx = options.ctx,
          listening = options.listening;
        if (listening) listening.count++;
        handlers.push({
          callback: callback,
          context: context,
          ctx: context || ctx,
          listening: listening
        });
      }
      return events;
    }; // An try-catch guarded #on function, to prevent poisoning the global
    // `_listening` variable.

    var tryCatchOn = function (obj, name, callback, context) {
      try {
        obj.on(name, callback, context);
      } catch (e) {
        return e;
      }
    }; // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.

    Events.off = function (name, callback, context) {
      if (!this._events) return this;
      this._events = eventsApi(offApi, this._events, name, callback, {
        context: context,
        listeners: this._listeners
      });
      return this;
    }; // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.

    Events.stopListening = function (obj, name, callback) {
      var listeningTo = this._listeningTo;
      if (!listeningTo) return this;
      var ids = obj ? [obj._listenId] : _.keys(listeningTo);
      for (var i = 0; i < ids.length; i++) {
        var listening = listeningTo[ids[i]]; // If listening doesn't exist, this object is not currently
        // listening to obj. Break out early.

        if (!listening) break;
        listening.obj.off(name, callback, this);
        if (listening.interop) listening.off(name, callback);
      }
      if (_.isEmpty(listeningTo)) this._listeningTo = void 0;
      return this;
    }; // The reducing API that removes a callback from the `events` object.

    var offApi = function (events, name, callback, options) {
      if (!events) return;
      var context = options.context,
        listeners = options.listeners;
      var i = 0,
        names; // Delete all event listeners and "drop" events.

      if (!name && !context && !callback) {
        for (names = _.keys(listeners); i < names.length; i++) {
          listeners[names[i]].cleanup();
        }
        return;
      }
      names = name ? [name] : _.keys(events);
      for (; i < names.length; i++) {
        name = names[i];
        var handlers = events[name]; // Bail out if there are no events stored.

        if (!handlers) break; // Find any remaining events.

        var remaining = [];
        for (var j = 0; j < handlers.length; j++) {
          var handler = handlers[j];
          if (callback && callback !== handler.callback && callback !== handler.callback._callback || context && context !== handler.context) {
            remaining.push(handler);
          } else {
            var listening = handler.listening;
            if (listening) listening.off(name, callback);
          }
        } // Replace events if there are any remaining.  Otherwise, clean up.

        if (remaining.length) {
          events[name] = remaining;
        } else {
          delete events[name];
        }
      }
      return events;
    }; // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, its listener will be removed. If multiple events
    // are passed in using the space-separated syntax, the handler will fire
    // once for each event, not once for a combination of all events.

    Events.once = function (name, callback, context) {
      // Map the event into a `{event: once}` object.
      var events = eventsApi(onceMap, {}, name, callback, this.off.bind(this));
      if (typeof name === 'string' && context == null) callback = void 0;
      return this.on(events, callback, context);
    }; // Inversion-of-control versions of `once`.

    Events.listenToOnce = function (obj, name, callback) {
      // Map the event into a `{event: once}` object.
      var events = eventsApi(onceMap, {}, name, callback, this.stopListening.bind(this, obj));
      return this.listenTo(obj, events);
    }; // Reduces the event callbacks into a map of `{event: onceWrapper}`.
    // `offer` unbinds the `onceWrapper` after it has been called.

    var onceMap = function (map, name, callback, offer) {
      if (callback) {
        var once = map[name] = _.once(function () {
          offer(name, once);
          callback.apply(this, arguments);
        });
        once._callback = callback;
      }
      return map;
    }; // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).

    Events.trigger = function (name) {
      if (!this._events) return this;
      var length = Math.max(0, arguments.length - 1);
      var args = Array(length);
      for (var i = 0; i < length; i++) args[i] = arguments[i + 1];
      eventsApi(triggerApi, this._events, name, void 0, args);
      return this;
    }; // Handles triggering the appropriate event callbacks.

    var triggerApi = function (objEvents, name, callback, args) {
      if (objEvents) {
        var events = objEvents[name];
        var allEvents = objEvents.all;
        if (events && allEvents) allEvents = allEvents.slice();
        if (events) triggerEvents(events, args);
        if (allEvents) triggerEvents(allEvents, [name].concat(args));
      }
      return objEvents;
    }; // A difficult-to-believe, but optimized internal dispatch function for
    // triggering events. Tries to keep the usual cases speedy (most internal
    // Backbone events have 3 arguments).

    var triggerEvents = function (events, args) {
      var ev,
        i = -1,
        l = events.length,
        a1 = args[0],
        a2 = args[1],
        a3 = args[2];
      switch (args.length) {
        case 0:
          while (++i < l) (ev = events[i]).callback.call(ev.ctx);
          return;
        case 1:
          while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1);
          return;
        case 2:
          while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2);
          return;
        case 3:
          while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3);
          return;
        default:
          while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
          return;
      }
    }; // A listening class that tracks and cleans up memory bindings
    // when all callbacks have been offed.

    var Listening = function (listener, obj) {
      this.id = listener._listenId;
      this.listener = listener;
      this.obj = obj;
      this.interop = true;
      this.count = 0;
      this._events = void 0;
    };
    Listening.prototype.on = Events.on; // Offs a callback (or several).
    // Uses an optimized counter if the listenee uses Backbone.Events.
    // Otherwise, falls back to manual tracking to support events
    // library interop.

    Listening.prototype.off = function (name, callback) {
      var cleanup;
      if (this.interop) {
        this._events = eventsApi(offApi, this._events, name, callback, {
          context: void 0,
          listeners: void 0
        });
        cleanup = !this._events;
      } else {
        this.count--;
        cleanup = this.count === 0;
      }
      if (cleanup) this.cleanup();
    }; // Cleans up memory bindings between the listener and the listenee.

    Listening.prototype.cleanup = function () {
      delete this.listener._listeningTo[this.obj._listenId];
      if (!this.interop) delete this.obj._listeners[this.id];
    }; // Aliases for backwards compatibility.

    Events.bind = Events.on;
    Events.unbind = Events.off; // Allow the `Backbone` object to serve as a global event bus, for folks who
    // want global "pubsub" in a convenient place.

    _.extend(Backbone, Events); // Backbone.Model
    // --------------
    // Backbone **Models** are the basic data object in the framework --
    // frequently representing a row in a table in a database on your server.
    // A discrete chunk of data and a bunch of useful, related methods for
    // performing computations and transformations on that data.
    // Create a new model with the specified attributes. A client id (`cid`)
    // is automatically generated and assigned for you.

    var Model = Backbone.Model = function (attributes, options) {
      var attrs = attributes || {};
      options || (options = {});
      this.preinitialize.apply(this, arguments);
      this.cid = _.uniqueId(this.cidPrefix);
      this.attributes = {};
      if (options.collection) this.collection = options.collection;
      if (options.parse) attrs = this.parse(attrs, options) || {};
      var defaults = _.result(this, 'defaults');
      attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
      this.set(attrs, options);
      this.changed = {};
      this.initialize.apply(this, arguments);
    }; // Attach all inheritable methods to the Model prototype.

    _.extend(Model.prototype, Events, {
      // A hash of attributes whose current and previous value differ.
      changed: null,
      // The value returned during the last failed validation.
      validationError: null,
      // The default name for the JSON `id` attribute is `"id"`. MongoDB and
      // CouchDB users may want to set this to `"_id"`.
      idAttribute: 'id',
      // The prefix is used to create the client id which is used to identify models locally.
      // You may want to override this if you're experiencing name clashes with model ids.
      cidPrefix: 'c',
      // preinitialize is an empty function by default. You can override it with a function
      // or object.  preinitialize will run before any instantiation logic is run in the Model.
      preinitialize: function () {},
      // Initialize is an empty function by default. Override it with your own
      // initialization logic.
      initialize: function () {},
      // Return a copy of the model's `attributes` object.
      toJSON: function (options) {
        return _.clone(this.attributes);
      },
      // Proxy `Backbone.sync` by default -- but override this if you need
      // custom syncing semantics for *this* particular model.
      sync: function () {
        return Backbone.sync.apply(this, arguments);
      },
      // Get the value of an attribute.
      get: function (attr) {
        return this.attributes[attr];
      },
      // Get the HTML-escaped value of an attribute.
      escape: function (attr) {
        return _.escape(this.get(attr));
      },
      // Returns `true` if the attribute contains a value that is not null
      // or undefined.
      has: function (attr) {
        return this.get(attr) != null;
      },
      // Special-cased proxy to underscore's `_.matches` method.
      matches: function (attrs) {
        return !!_.iteratee(attrs, this)(this.attributes);
      },
      // Set a hash of model attributes on the object, firing `"change"`. This is
      // the core primitive operation of a model, updating the data and notifying
      // anyone who needs to know about the change in state. The heart of the beast.
      set: function (key, val, options) {
        if (key == null) return this; // Handle both `"key", value` and `{key: value}` -style arguments.

        var attrs;
        if (typeof key === 'object') {
          attrs = key;
          options = val;
        } else {
          (attrs = {})[key] = val;
        }
        options || (options = {}); // Run validation.

        if (!this._validate(attrs, options)) return false; // Extract attributes and options.

        var unset = options.unset;
        var silent = options.silent;
        var changes = [];
        var changing = this._changing;
        this._changing = true;
        if (!changing) {
          this._previousAttributes = _.clone(this.attributes);
          this.changed = {};
        }
        var current = this.attributes;
        var changed = this.changed;
        var prev = this._previousAttributes; // For each `set` attribute, update or delete the current value.

        for (var attr in attrs) {
          val = attrs[attr];
          if (!_.isEqual(current[attr], val)) changes.push(attr);
          if (!_.isEqual(prev[attr], val)) {
            changed[attr] = val;
          } else {
            delete changed[attr];
          }
          unset ? delete current[attr] : current[attr] = val;
        } // Update the `id`.

        if (this.idAttribute in attrs) this.id = this.get(this.idAttribute); // Trigger all relevant attribute changes.

        if (!silent) {
          if (changes.length) this._pending = options;
          for (var i = 0; i < changes.length; i++) {
            this.trigger('change:' + changes[i], this, current[changes[i]], options);
          }
        } // You might be wondering why there's a `while` loop here. Changes can
        // be recursively nested within `"change"` events.

        if (changing) return this;
        if (!silent) {
          while (this._pending) {
            options = this._pending;
            this._pending = false;
            this.trigger('change', this, options);
          }
        }
        this._pending = false;
        this._changing = false;
        return this;
      },
      // Remove an attribute from the model, firing `"change"`. `unset` is a noop
      // if the attribute doesn't exist.
      unset: function (attr, options) {
        return this.set(attr, void 0, _.extend({}, options, {
          unset: true
        }));
      },
      // Clear all attributes on the model, firing `"change"`.
      clear: function (options) {
        var attrs = {};
        for (var key in this.attributes) attrs[key] = void 0;
        return this.set(attrs, _.extend({}, options, {
          unset: true
        }));
      },
      // Determine if the model has changed since the last `"change"` event.
      // If you specify an attribute name, determine if that attribute has changed.
      hasChanged: function (attr) {
        if (attr == null) return !_.isEmpty(this.changed);
        return _.has(this.changed, attr);
      },
      // Return an object containing all the attributes that have changed, or
      // false if there are no changed attributes. Useful for determining what
      // parts of a view need to be updated and/or what attributes need to be
      // persisted to the server. Unset attributes will be set to undefined.
      // You can also pass an attributes object to diff against the model,
      // determining if there *would be* a change.
      changedAttributes: function (diff) {
        if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
        var old = this._changing ? this._previousAttributes : this.attributes;
        var changed = {};
        var hasChanged;
        for (var attr in diff) {
          var val = diff[attr];
          if (_.isEqual(old[attr], val)) continue;
          changed[attr] = val;
          hasChanged = true;
        }
        return hasChanged ? changed : false;
      },
      // Get the previous value of an attribute, recorded at the time the last
      // `"change"` event was fired.
      previous: function (attr) {
        if (attr == null || !this._previousAttributes) return null;
        return this._previousAttributes[attr];
      },
      // Get all of the attributes of the model at the time of the previous
      // `"change"` event.
      previousAttributes: function () {
        return _.clone(this._previousAttributes);
      },
      // Fetch the model from the server, merging the response with the model's
      // local attributes. Any changed attributes will trigger a "change" event.
      fetch: function (options) {
        options = _.extend({
          parse: true
        }, options);
        var model = this;
        var success = options.success;
        options.success = function (resp) {
          var serverAttrs = options.parse ? model.parse(resp, options) : resp;
          if (!model.set(serverAttrs, options)) return false;
          if (success) success.call(options.context, model, resp, options);
          model.trigger('sync', model, resp, options);
        };
        wrapError(this, options);
        return this.sync('read', this, options);
      },
      // Set a hash of model attributes, and sync the model to the server.
      // If the server returns an attributes hash that differs, the model's
      // state will be `set` again.
      save: function (key, val, options) {
        // Handle both `"key", value` and `{key: value}` -style arguments.
        var attrs;
        if (key == null || typeof key === 'object') {
          attrs = key;
          options = val;
        } else {
          (attrs = {})[key] = val;
        }
        options = _.extend({
          validate: true,
          parse: true
        }, options);
        var wait = options.wait; // If we're not waiting and attributes exist, save acts as
        // `set(attr).save(null, opts)` with validation. Otherwise, check if
        // the model will be valid when the attributes, if any, are set.

        if (attrs && !wait) {
          if (!this.set(attrs, options)) return false;
        } else if (!this._validate(attrs, options)) {
          return false;
        } // After a successful server-side save, the client is (optionally)
        // updated with the server-side state.

        var model = this;
        var success = options.success;
        var attributes = this.attributes;
        options.success = function (resp) {
          // Ensure attributes are restored during synchronous saves.
          model.attributes = attributes;
          var serverAttrs = options.parse ? model.parse(resp, options) : resp;
          if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
          if (serverAttrs && !model.set(serverAttrs, options)) return false;
          if (success) success.call(options.context, model, resp, options);
          model.trigger('sync', model, resp, options);
        };
        wrapError(this, options); // Set temporary attributes if `{wait: true}` to properly find new ids.

        if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);
        var method = this.isNew() ? 'create' : options.patch ? 'patch' : 'update';
        if (method === 'patch' && !options.attrs) options.attrs = attrs;
        var xhr = this.sync(method, this, options); // Restore attributes.

        this.attributes = attributes;
        return xhr;
      },
      // Destroy this model on the server if it was already persisted.
      // Optimistically removes the model from its collection, if it has one.
      // If `wait: true` is passed, waits for the server to respond before removal.
      destroy: function (options) {
        options = options ? _.clone(options) : {};
        var model = this;
        var success = options.success;
        var wait = options.wait;
        var destroy = function () {
          model.stopListening();
          model.trigger('destroy', model, model.collection, options);
        };
        options.success = function (resp) {
          if (wait) destroy();
          if (success) success.call(options.context, model, resp, options);
          if (!model.isNew()) model.trigger('sync', model, resp, options);
        };
        var xhr = false;
        if (this.isNew()) {
          _.defer(options.success);
        } else {
          wrapError(this, options);
          xhr = this.sync('delete', this, options);
        }
        if (!wait) destroy();
        return xhr;
      },
      // Default URL for the model's representation on the server -- if you're
      // using Backbone's restful methods, override this to change the endpoint
      // that will be called.
      url: function () {
        var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
        if (this.isNew()) return base;
        var id = this.get(this.idAttribute);
        return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
      },
      // **parse** converts a response into the hash of attributes to be `set` on
      // the model. The default implementation is just to pass the response along.
      parse: function (resp, options) {
        return resp;
      },
      // Create a new model with identical attributes to this one.
      clone: function () {
        return new this.constructor(this.attributes);
      },
      // A model is new if it has never been saved to the server, and lacks an id.
      isNew: function () {
        return !this.has(this.idAttribute);
      },
      // Check if the model is currently in a valid state.
      isValid: function (options) {
        return this._validate({}, _.extend({}, options, {
          validate: true
        }));
      },
      // Run validation against the next complete set of model attributes,
      // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
      _validate: function (attrs, options) {
        if (!options.validate || !this.validate) return true;
        attrs = _.extend({}, this.attributes, attrs);
        var error = this.validationError = this.validate(attrs, options) || null;
        if (!error) return true;
        this.trigger('invalid', this, error, _.extend(options, {
          validationError: error
        }));
        return false;
      }
    }); // Backbone.Collection
    // -------------------
    // If models tend to represent a single row of data, a Backbone Collection is
    // more analogous to a table full of data ... or a small slice or page of that
    // table, or a collection of rows that belong together for a particular reason
    // -- all of the messages in this particular folder, all of the documents
    // belonging to this particular author, and so on. Collections maintain
    // indexes of their models, both in order, and for lookup by `id`.
    // Create a new **Collection**, perhaps to contain a specific type of `model`.
    // If a `comparator` is specified, the Collection will maintain
    // its models in sort order, as they're added and removed.

    var Collection = Backbone.Collection = function (models, options) {
      options || (options = {});
      this.preinitialize.apply(this, arguments);
      if (options.model) this.model = options.model;
      if (options.comparator !== void 0) this.comparator = options.comparator;
      this._reset();
      this.initialize.apply(this, arguments);
      if (models) this.reset(models, _.extend({
        silent: true
      }, options));
    }; // Default options for `Collection#set`.

    var setOptions = {
      add: true,
      remove: true,
      merge: true
    };
    var addOptions = {
      add: true,
      remove: false
    }; // Splices `insert` into `array` at index `at`.

    var splice = function (array, insert, at) {
      at = Math.min(Math.max(at, 0), array.length);
      var tail = Array(array.length - at);
      var length = insert.length;
      var i;
      for (i = 0; i < tail.length; i++) tail[i] = array[i + at];
      for (i = 0; i < length; i++) array[i + at] = insert[i];
      for (i = 0; i < tail.length; i++) array[i + length + at] = tail[i];
    }; // Define the Collection's inheritable methods.

    _.extend(Collection.prototype, Events, {
      // The default model for a collection is just a **Backbone.Model**.
      // This should be overridden in most cases.
      model: Model,
      // preinitialize is an empty function by default. You can override it with a function
      // or object.  preinitialize will run before any instantiation logic is run in the Collection.
      preinitialize: function () {},
      // Initialize is an empty function by default. Override it with your own
      // initialization logic.
      initialize: function () {},
      // The JSON representation of a Collection is an array of the
      // models' attributes.
      toJSON: function (options) {
        return this.map(function (model) {
          return model.toJSON(options);
        });
      },
      // Proxy `Backbone.sync` by default.
      sync: function () {
        return Backbone.sync.apply(this, arguments);
      },
      // Add a model, or list of models to the set. `models` may be Backbone
      // Models or raw JavaScript objects to be converted to Models, or any
      // combination of the two.
      add: function (models, options) {
        return this.set(models, _.extend({
          merge: false
        }, options, addOptions));
      },
      // Remove a model, or a list of models from the set.
      remove: function (models, options) {
        options = _.extend({}, options);
        var singular = !_.isArray(models);
        models = singular ? [models] : models.slice();
        var removed = this._removeModels(models, options);
        if (!options.silent && removed.length) {
          options.changes = {
            added: [],
            merged: [],
            removed: removed
          };
          this.trigger('update', this, options);
        }
        return singular ? removed[0] : removed;
      },
      // Update a collection by `set`-ing a new list of models, adding new ones,
      // removing models that are no longer present, and merging models that
      // already exist in the collection, as necessary. Similar to **Model#set**,
      // the core operation for updating the data contained by the collection.
      set: function (models, options) {
        if (models == null) return;
        options = _.extend({}, setOptions, options);
        if (options.parse && !this._isModel(models)) {
          models = this.parse(models, options) || [];
        }
        var singular = !_.isArray(models);
        models = singular ? [models] : models.slice();
        var at = options.at;
        if (at != null) at = +at;
        if (at > this.length) at = this.length;
        if (at < 0) at += this.length + 1;
        var set = [];
        var toAdd = [];
        var toMerge = [];
        var toRemove = [];
        var modelMap = {};
        var add = options.add;
        var merge = options.merge;
        var remove = options.remove;
        var sort = false;
        var sortable = this.comparator && at == null && options.sort !== false;
        var sortAttr = _.isString(this.comparator) ? this.comparator : null; // Turn bare objects into model references, and prevent invalid models
        // from being added.

        var model, i;
        for (i = 0; i < models.length; i++) {
          model = models[i]; // If a duplicate is found, prevent it from being added and
          // optionally merge it into the existing model.

          var existing = this.get(model);
          if (existing) {
            if (merge && model !== existing) {
              var attrs = this._isModel(model) ? model.attributes : model;
              if (options.parse) attrs = existing.parse(attrs, options);
              existing.set(attrs, options);
              toMerge.push(existing);
              if (sortable && !sort) sort = existing.hasChanged(sortAttr);
            }
            if (!modelMap[existing.cid]) {
              modelMap[existing.cid] = true;
              set.push(existing);
            }
            models[i] = existing; // If this is a new, valid model, push it to the `toAdd` list.
          } else if (add) {
            model = models[i] = this._prepareModel(model, options);
            if (model) {
              toAdd.push(model);
              this._addReference(model, options);
              modelMap[model.cid] = true;
              set.push(model);
            }
          }
        } // Remove stale models.

        if (remove) {
          for (i = 0; i < this.length; i++) {
            model = this.models[i];
            if (!modelMap[model.cid]) toRemove.push(model);
          }
          if (toRemove.length) this._removeModels(toRemove, options);
        } // See if sorting is needed, update `length` and splice in new models.

        var orderChanged = false;
        var replace = !sortable && add && remove;
        if (set.length && replace) {
          orderChanged = this.length !== set.length || _.some(this.models, function (m, index) {
            return m !== set[index];
          });
          this.models.length = 0;
          splice(this.models, set, 0);
          this.length = this.models.length;
        } else if (toAdd.length) {
          if (sortable) sort = true;
          splice(this.models, toAdd, at == null ? this.length : at);
          this.length = this.models.length;
        } // Silently sort the collection if appropriate.

        if (sort) this.sort({
          silent: true
        }); // Unless silenced, it's time to fire all appropriate add/sort/update events.

        if (!options.silent) {
          for (i = 0; i < toAdd.length; i++) {
            if (at != null) options.index = at + i;
            model = toAdd[i];
            model.trigger('add', model, this, options);
          }
          if (sort || orderChanged) this.trigger('sort', this, options);
          if (toAdd.length || toRemove.length || toMerge.length) {
            options.changes = {
              added: toAdd,
              removed: toRemove,
              merged: toMerge
            };
            this.trigger('update', this, options);
          }
        } // Return the added (or merged) model (or models).

        return singular ? models[0] : models;
      },
      // When you have more items than you want to add or remove individually,
      // you can reset the entire set with a new list of models, without firing
      // any granular `add` or `remove` events. Fires `reset` when finished.
      // Useful for bulk operations and optimizations.
      reset: function (models, options) {
        options = options ? _.clone(options) : {};
        for (var i = 0; i < this.models.length; i++) {
          this._removeReference(this.models[i], options);
        }
        options.previousModels = this.models;
        this._reset();
        models = this.add(models, _.extend({
          silent: true
        }, options));
        if (!options.silent) this.trigger('reset', this, options);
        return models;
      },
      // Add a model to the end of the collection.
      push: function (model, options) {
        return this.add(model, _.extend({
          at: this.length
        }, options));
      },
      // Remove a model from the end of the collection.
      pop: function (options) {
        var model = this.at(this.length - 1);
        return this.remove(model, options);
      },
      // Add a model to the beginning of the collection.
      unshift: function (model, options) {
        return this.add(model, _.extend({
          at: 0
        }, options));
      },
      // Remove a model from the beginning of the collection.
      shift: function (options) {
        var model = this.at(0);
        return this.remove(model, options);
      },
      // Slice out a sub-array of models from the collection.
      slice: function () {
        return slice.apply(this.models, arguments);
      },
      // Get a model from the set by id, cid, model object with id or cid
      // properties, or an attributes object that is transformed through modelId.
      get: function (obj) {
        if (obj == null) return void 0;
        return this._byId[obj] || this._byId[this.modelId(this._isModel(obj) ? obj.attributes : obj)] || obj.cid && this._byId[obj.cid];
      },
      // Returns `true` if the model is in the collection.
      has: function (obj) {
        return this.get(obj) != null;
      },
      // Get the model at the given index.
      at: function (index) {
        if (index < 0) index += this.length;
        return this.models[index];
      },
      // Return models with matching attributes. Useful for simple cases of
      // `filter`.
      where: function (attrs, first) {
        return this[first ? 'find' : 'filter'](attrs);
      },
      // Return the first model with matching attributes. Useful for simple cases
      // of `find`.
      findWhere: function (attrs) {
        return this.where(attrs, true);
      },
      // Force the collection to re-sort itself. You don't need to call this under
      // normal circumstances, as the set will maintain sort order as each item
      // is added.
      sort: function (options) {
        var comparator = this.comparator;
        if (!comparator) throw new Error('Cannot sort a set without a comparator');
        options || (options = {});
        var length = comparator.length;
        if (_.isFunction(comparator)) comparator = comparator.bind(this); // Run sort based on type of `comparator`.

        if (length === 1 || _.isString(comparator)) {
          this.models = this.sortBy(comparator);
        } else {
          this.models.sort(comparator);
        }
        if (!options.silent) this.trigger('sort', this, options);
        return this;
      },
      // Pluck an attribute from each model in the collection.
      pluck: function (attr) {
        return this.map(attr + '');
      },
      // Fetch the default set of models for this collection, resetting the
      // collection when they arrive. If `reset: true` is passed, the response
      // data will be passed through the `reset` method instead of `set`.
      fetch: function (options) {
        options = _.extend({
          parse: true
        }, options);
        var success = options.success;
        var collection = this;
        options.success = function (resp) {
          var method = options.reset ? 'reset' : 'set';
          collection[method](resp, options);
          if (success) success.call(options.context, collection, resp, options);
          collection.trigger('sync', collection, resp, options);
        };
        wrapError(this, options);
        return this.sync('read', this, options);
      },
      // Create a new instance of a model in this collection. Add the model to the
      // collection immediately, unless `wait: true` is passed, in which case we
      // wait for the server to agree.
      create: function (model, options) {
        options = options ? _.clone(options) : {};
        var wait = options.wait;
        model = this._prepareModel(model, options);
        if (!model) return false;
        if (!wait) this.add(model, options);
        var collection = this;
        var success = options.success;
        options.success = function (m, resp, callbackOpts) {
          if (wait) collection.add(m, callbackOpts);
          if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
        };
        model.save(null, options);
        return model;
      },
      // **parse** converts a response into a list of models to be added to the
      // collection. The default implementation is just to pass it through.
      parse: function (resp, options) {
        return resp;
      },
      // Create a new collection with an identical list of models as this one.
      clone: function () {
        return new this.constructor(this.models, {
          model: this.model,
          comparator: this.comparator
        });
      },
      // Define how to uniquely identify models in the collection.
      modelId: function (attrs) {
        return attrs[this.model.prototype.idAttribute || 'id'];
      },
      // Get an iterator of all models in this collection.
      values: function () {
        return new CollectionIterator(this, ITERATOR_VALUES);
      },
      // Get an iterator of all model IDs in this collection.
      keys: function () {
        return new CollectionIterator(this, ITERATOR_KEYS);
      },
      // Get an iterator of all [ID, model] tuples in this collection.
      entries: function () {
        return new CollectionIterator(this, ITERATOR_KEYSVALUES);
      },
      // Private method to reset all internal state. Called when the collection
      // is first initialized or reset.
      _reset: function () {
        this.length = 0;
        this.models = [];
        this._byId = {};
      },
      // Prepare a hash of attributes (or other model) to be added to this
      // collection.
      _prepareModel: function (attrs, options) {
        if (this._isModel(attrs)) {
          if (!attrs.collection) attrs.collection = this;
          return attrs;
        }
        options = options ? _.clone(options) : {};
        options.collection = this;
        var model = new this.model(attrs, options);
        if (!model.validationError) return model;
        this.trigger('invalid', this, model.validationError, options);
        return false;
      },
      // Internal method called by both remove and set.
      _removeModels: function (models, options) {
        var removed = [];
        for (var i = 0; i < models.length; i++) {
          var model = this.get(models[i]);
          if (!model) continue;
          var index = this.indexOf(model);
          this.models.splice(index, 1);
          this.length--; // Remove references before triggering 'remove' event to prevent an
          // infinite loop. #3693

          delete this._byId[model.cid];
          var id = this.modelId(model.attributes);
          if (id != null) delete this._byId[id];
          if (!options.silent) {
            options.index = index;
            model.trigger('remove', model, this, options);
          }
          removed.push(model);
          this._removeReference(model, options);
        }
        return removed;
      },
      // Method for checking whether an object should be considered a model for
      // the purposes of adding to the collection.
      _isModel: function (model) {
        return model instanceof Model;
      },
      // Internal method to create a model's ties to a collection.
      _addReference: function (model, options) {
        this._byId[model.cid] = model;
        var id = this.modelId(model.attributes);
        if (id != null) this._byId[id] = model;
        model.on('all', this._onModelEvent, this);
      },
      // Internal method to sever a model's ties to a collection.
      _removeReference: function (model, options) {
        delete this._byId[model.cid];
        var id = this.modelId(model.attributes);
        if (id != null) delete this._byId[id];
        if (this === model.collection) delete model.collection;
        model.off('all', this._onModelEvent, this);
      },
      // Internal method called every time a model in the set fires an event.
      // Sets need to update their indexes when models change ids. All other
      // events simply proxy through. "add" and "remove" events that originate
      // in other collections are ignored.
      _onModelEvent: function (event, model, collection, options) {
        if (model) {
          if ((event === 'add' || event === 'remove') && collection !== this) return;
          if (event === 'destroy') this.remove(model, options);
          if (event === 'change') {
            var prevId = this.modelId(model.previousAttributes());
            var id = this.modelId(model.attributes);
            if (prevId !== id) {
              if (prevId != null) delete this._byId[prevId];
              if (id != null) this._byId[id] = model;
            }
          }
        }
        this.trigger.apply(this, arguments);
      }
    }); // Defining an @@iterator method implements JavaScript's Iterable protocol.
    // In modern ES2015 browsers, this value is found at Symbol.iterator.

    /* global Symbol */

    var $$iterator = typeof Symbol === 'function' && Symbol.iterator;
    if ($$iterator) {
      Collection.prototype[$$iterator] = Collection.prototype.values;
    } // CollectionIterator
    // ------------------
    // A CollectionIterator implements JavaScript's Iterator protocol, allowing the
    // use of `for of` loops in modern browsers and interoperation between
    // Backbone.Collection and other JavaScript functions and third-party libraries
    // which can operate on Iterables.

    var CollectionIterator = function (collection, kind) {
      this._collection = collection;
      this._kind = kind;
      this._index = 0;
    }; // This "enum" defines the three possible kinds of values which can be emitted
    // by a CollectionIterator that correspond to the values(), keys() and entries()
    // methods on Collection, respectively.

    var ITERATOR_VALUES = 1;
    var ITERATOR_KEYS = 2;
    var ITERATOR_KEYSVALUES = 3; // All Iterators should themselves be Iterable.

    if ($$iterator) {
      CollectionIterator.prototype[$$iterator] = function () {
        return this;
      };
    }
    CollectionIterator.prototype.next = function () {
      if (this._collection) {
        // Only continue iterating if the iterated collection is long enough.
        if (this._index < this._collection.length) {
          var model = this._collection.at(this._index);
          this._index++; // Construct a value depending on what kind of values should be iterated.

          var value;
          if (this._kind === ITERATOR_VALUES) {
            value = model;
          } else {
            var id = this._collection.modelId(model.attributes);
            if (this._kind === ITERATOR_KEYS) {
              value = id;
            } else {
              // ITERATOR_KEYSVALUES
              value = [id, model];
            }
          }
          return {
            value: value,
            done: false
          };
        } // Once exhausted, remove the reference to the collection so future
        // calls to the next method always return done.

        this._collection = void 0;
      }
      return {
        value: void 0,
        done: true
      };
    }; // Backbone.View
    // -------------
    // Backbone Views are almost more convention than they are actual code. A View
    // is simply a JavaScript object that represents a logical chunk of UI in the
    // DOM. This might be a single item, an entire list, a sidebar or panel, or
    // even the surrounding frame which wraps your whole app. Defining a chunk of
    // UI as a **View** allows you to define your DOM events declaratively, without
    // having to worry about render order ... and makes it easy for the view to
    // react to specific changes in the state of your models.
    // Creating a Backbone.View creates its initial element outside of the DOM,
    // if an existing element is not provided...

    var View = Backbone.View = function (options) {
      this.cid = _.uniqueId('view');
      this.preinitialize.apply(this, arguments);
      _.extend(this, _.pick(options, viewOptions));
      this._ensureElement();
      this.initialize.apply(this, arguments);
    }; // Cached regex to split keys for `delegate`.

    var delegateEventSplitter = /^(\S+)\s*(.*)$/; // List of view options to be set as properties.

    var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events']; // Set up all inheritable **Backbone.View** properties and methods.

    _.extend(View.prototype, Events, {
      // The default `tagName` of a View's element is `"div"`.
      tagName: 'div',
      // jQuery delegate for element lookup, scoped to DOM elements within the
      // current view. This should be preferred to global lookups where possible.
      $: function (selector) {
        return this.$el.find(selector);
      },
      // preinitialize is an empty function by default. You can override it with a function
      // or object.  preinitialize will run before any instantiation logic is run in the View
      preinitialize: function () {},
      // Initialize is an empty function by default. Override it with your own
      // initialization logic.
      initialize: function () {},
      // **render** is the core function that your view should override, in order
      // to populate its element (`this.el`), with the appropriate HTML. The
      // convention is for **render** to always return `this`.
      render: function () {
        return this;
      },
      // Remove this view by taking the element out of the DOM, and removing any
      // applicable Backbone.Events listeners.
      remove: function () {
        this._removeElement();
        this.stopListening();
        return this;
      },
      // Remove this view's element from the document and all event listeners
      // attached to it. Exposed for subclasses using an alternative DOM
      // manipulation API.
      _removeElement: function () {
        this.$el.remove();
      },
      // Change the view's element (`this.el` property) and re-delegate the
      // view's events on the new element.
      setElement: function (element) {
        this.undelegateEvents();
        this._setElement(element);
        this.delegateEvents();
        return this;
      },
      // Creates the `this.el` and `this.$el` references for this view using the
      // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
      // context or an element. Subclasses can override this to utilize an
      // alternative DOM manipulation API and are only required to set the
      // `this.el` property.
      _setElement: function (el) {
        this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
        this.el = this.$el[0];
      },
      // Set callbacks, where `this.events` is a hash of
      //
      // *{"event selector": "callback"}*
      //
      //     {
      //       'mousedown .title':  'edit',
      //       'click .button':     'save',
      //       'click .open':       function(e) { ... }
      //     }
      //
      // pairs. Callbacks will be bound to the view, with `this` set properly.
      // Uses event delegation for efficiency.
      // Omitting the selector binds the event to `this.el`.
      delegateEvents: function (events) {
        events || (events = _.result(this, 'events'));
        if (!events) return this;
        this.undelegateEvents();
        for (var key in events) {
          var method = events[key];
          if (!_.isFunction(method)) method = this[method];
          if (!method) continue;
          var match = key.match(delegateEventSplitter);
          this.delegate(match[1], match[2], method.bind(this));
        }
        return this;
      },
      // Add a single event listener to the view's element (or a child element
      // using `selector`). This only works for delegate-able events: not `focus`,
      // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
      delegate: function (eventName, selector, listener) {
        this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
        return this;
      },
      // Clears all callbacks previously bound to the view by `delegateEvents`.
      // You usually don't need to use this, but may wish to if you have multiple
      // Backbone views attached to the same DOM element.
      undelegateEvents: function () {
        if (this.$el) this.$el.off('.delegateEvents' + this.cid);
        return this;
      },
      // A finer-grained `undelegateEvents` for removing a single delegated event.
      // `selector` and `listener` are both optional.
      undelegate: function (eventName, selector, listener) {
        this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
        return this;
      },
      // Produces a DOM element to be assigned to your view. Exposed for
      // subclasses using an alternative DOM manipulation API.
      _createElement: function (tagName) {
        return document.createElement(tagName);
      },
      // Ensure that the View has a DOM element to render into.
      // If `this.el` is a string, pass it through `$()`, take the first
      // matching element, and re-assign it to `el`. Otherwise, create
      // an element from the `id`, `className` and `tagName` properties.
      _ensureElement: function () {
        if (!this.el) {
          var attrs = _.extend({}, _.result(this, 'attributes'));
          if (this.id) attrs.id = _.result(this, 'id');
          if (this.className) attrs['class'] = _.result(this, 'className');
          this.setElement(this._createElement(_.result(this, 'tagName')));
          this._setAttributes(attrs);
        } else {
          this.setElement(_.result(this, 'el'));
        }
      },
      // Set attributes from a hash on this view's element.  Exposed for
      // subclasses using an alternative DOM manipulation API.
      _setAttributes: function (attributes) {
        this.$el.attr(attributes);
      }
    }); // Proxy Backbone class methods to Underscore functions, wrapping the model's
    // `attributes` object or collection's `models` array behind the scenes.
    //
    // collection.filter(function(model) { return model.get('age') > 10 });
    // collection.each(this.addView);
    //
    // `Function#apply` can be slow so we use the method's arg count, if we know it.

    var addMethod = function (base, length, method, attribute) {
      switch (length) {
        case 1:
          return function () {
            return base[method](this[attribute]);
          };
        case 2:
          return function (value) {
            return base[method](this[attribute], value);
          };
        case 3:
          return function (iteratee, context) {
            return base[method](this[attribute], cb(iteratee, this), context);
          };
        case 4:
          return function (iteratee, defaultVal, context) {
            return base[method](this[attribute], cb(iteratee, this), defaultVal, context);
          };
        default:
          return function () {
            var args = slice.call(arguments);
            args.unshift(this[attribute]);
            return base[method].apply(base, args);
          };
      }
    };
    var addUnderscoreMethods = function (Class, base, methods, attribute) {
      _.each(methods, function (length, method) {
        if (base[method]) Class.prototype[method] = addMethod(base, length, method, attribute);
      });
    }; // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.

    var cb = function (iteratee, instance) {
      if (_.isFunction(iteratee)) return iteratee;
      if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
      if (_.isString(iteratee)) return function (model) {
        return model.get(iteratee);
      };
      return iteratee;
    };
    var modelMatcher = function (attrs) {
      var matcher = _.matches(attrs);
      return function (model) {
        return matcher(model.attributes);
      };
    }; // Underscore methods that we want to implement on the Collection.
    // 90% of the core usefulness of Backbone Collections is actually implemented
    // right here:

    var collectionMethods = {
      forEach: 3,
      each: 3,
      map: 3,
      collect: 3,
      reduce: 0,
      foldl: 0,
      inject: 0,
      reduceRight: 0,
      foldr: 0,
      find: 3,
      detect: 3,
      filter: 3,
      select: 3,
      reject: 3,
      every: 3,
      all: 3,
      some: 3,
      any: 3,
      include: 3,
      includes: 3,
      contains: 3,
      invoke: 0,
      max: 3,
      min: 3,
      toArray: 1,
      size: 1,
      first: 3,
      head: 3,
      take: 3,
      initial: 3,
      rest: 3,
      tail: 3,
      drop: 3,
      last: 3,
      without: 0,
      difference: 0,
      indexOf: 3,
      shuffle: 1,
      lastIndexOf: 3,
      isEmpty: 1,
      chain: 1,
      sample: 3,
      partition: 3,
      groupBy: 3,
      countBy: 3,
      sortBy: 3,
      indexBy: 3,
      findIndex: 3,
      findLastIndex: 3
    }; // Underscore methods that we want to implement on the Model, mapped to the
    // number of arguments they take.

    var modelMethods = {
      keys: 1,
      values: 1,
      pairs: 1,
      invert: 1,
      pick: 0,
      omit: 0,
      chain: 1,
      isEmpty: 1
    }; // Mix in each Underscore method as a proxy to `Collection#models`.

    _.each([[Collection, collectionMethods, 'models'], [Model, modelMethods, 'attributes']], function (config) {
      var Base = config[0],
        methods = config[1],
        attribute = config[2];
      Base.mixin = function (obj) {
        var mappings = _.reduce(_.functions(obj), function (memo, name) {
          memo[name] = 0;
          return memo;
        }, {});
        addUnderscoreMethods(Base, obj, mappings, attribute);
      };
      addUnderscoreMethods(Base, _, methods, attribute);
    }); // Backbone.sync
    // -------------
    // Override this function to change the manner in which Backbone persists
    // models to the server. You will be passed the type of request, and the
    // model in question. By default, makes a RESTful Ajax request
    // to the model's `url()`. Some possible customizations could be:
    //
    // * Use `setTimeout` to batch rapid-fire updates into a single request.
    // * Send up the models as XML instead of JSON.
    // * Persist models via WebSockets instead of Ajax.
    //
    // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
    // as `POST`, with a `_method` parameter containing the true HTTP method,
    // as well as all requests with the body as `application/x-www-form-urlencoded`
    // instead of `application/json` with the model in a param named `model`.
    // Useful when interfacing with server-side languages like **PHP** that make
    // it difficult to read the body of `PUT` requests.

    Backbone.sync = function (method, model, options) {
      var type = methodMap[method]; // Default options, unless specified.

      _.defaults(options || (options = {}), {
        emulateHTTP: Backbone.emulateHTTP,
        emulateJSON: Backbone.emulateJSON
      }); // Default JSON-request options.

      var params = {
        type: type,
        dataType: 'json'
      }; // Ensure that we have a URL.

      if (!options.url) {
        params.url = _.result(model, 'url') || urlError();
      } // Ensure that we have the appropriate request data.

      if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
        params.contentType = 'application/json';
        params.data = JSON.stringify(options.attrs || model.toJSON(options));
      } // For older servers, emulate JSON by encoding the request into an HTML-form.

      if (options.emulateJSON) {
        params.contentType = 'application/x-www-form-urlencoded';
        params.data = params.data ? {
          model: params.data
        } : {};
      } // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
      // And an `X-HTTP-Method-Override` header.

      if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
        params.type = 'POST';
        if (options.emulateJSON) params.data._method = type;
        var beforeSend = options.beforeSend;
        options.beforeSend = function (xhr) {
          xhr.setRequestHeader('X-HTTP-Method-Override', type);
          if (beforeSend) return beforeSend.apply(this, arguments);
        };
      } // Don't process data on a non-GET request.

      if (params.type !== 'GET' && !options.emulateJSON) {
        params.processData = false;
      } // Pass along `textStatus` and `errorThrown` from jQuery.

      var error = options.error;
      options.error = function (xhr, textStatus, errorThrown) {
        options.textStatus = textStatus;
        options.errorThrown = errorThrown;
        if (error) error.call(options.context, xhr, textStatus, errorThrown);
      }; // Make the request, allowing the user to override any Ajax options.

      var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
      model.trigger('request', model, xhr, options);
      return xhr;
    }; // Map from CRUD to HTTP for our default `Backbone.sync` implementation.

    var methodMap = {
      create: 'POST',
      update: 'PUT',
      patch: 'PATCH',
      delete: 'DELETE',
      read: 'GET'
    }; // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
    // Override this if you'd like to use a different library.

    Backbone.ajax = function () {
      return Backbone.$.ajax.apply(Backbone.$, arguments);
    }; // Backbone.Router
    // ---------------
    // Routers map faux-URLs to actions, and fire events when routes are
    // matched. Creating a new one sets its `routes` hash, if not set statically.

    var Router = Backbone.Router = function (options) {
      options || (options = {});
      this.preinitialize.apply(this, arguments);
      if (options.routes) this.routes = options.routes;
      this._bindRoutes();
      this.initialize.apply(this, arguments);
    }; // Cached regular expressions for matching named param parts and splatted
    // parts of route strings.

    var optionalParam = /\((.*?)\)/g;
    var namedParam = /(\(\?)?:\w+/g;
    var splatParam = /\*\w+/g;
    var escapeRegExp = /[\-{}\[\]+?.,\\\^$|#\s]/g; // Set up all inheritable **Backbone.Router** properties and methods.

    _.extend(Router.prototype, Events, {
      // preinitialize is an empty function by default. You can override it with a function
      // or object.  preinitialize will run before any instantiation logic is run in the Router.
      preinitialize: function () {},
      // Initialize is an empty function by default. Override it with your own
      // initialization logic.
      initialize: function () {},
      // Manually bind a single named route to a callback. For example:
      //
      //     this.route('search/:query/p:num', 'search', function(query, num) {
      //       ...
      //     });
      //
      route: function (route, name, callback) {
        if (!_.isRegExp(route)) route = this._routeToRegExp(route);
        if (_.isFunction(name)) {
          callback = name;
          name = '';
        }
        if (!callback) callback = this[name];
        var router = this;
        Backbone.history.route(route, function (fragment) {
          var args = router._extractParameters(route, fragment);
          if (router.execute(callback, args, name) !== false) {
            router.trigger.apply(router, ['route:' + name].concat(args));
            router.trigger('route', name, args);
            Backbone.history.trigger('route', router, name, args);
          }
        });
        return this;
      },
      // Execute a route handler with the provided parameters.  This is an
      // excellent place to do pre-route setup or post-route cleanup.
      execute: function (callback, args, name) {
        if (callback) callback.apply(this, args);
      },
      // Simple proxy to `Backbone.history` to save a fragment into the history.
      navigate: function (fragment, options) {
        Backbone.history.navigate(fragment, options);
        return this;
      },
      // Bind all defined routes to `Backbone.history`. We have to reverse the
      // order of the routes here to support behavior where the most general
      // routes can be defined at the bottom of the route map.
      _bindRoutes: function () {
        if (!this.routes) return;
        this.routes = _.result(this, 'routes');
        var route,
          routes = _.keys(this.routes);
        while ((route = routes.pop()) != null) {
          this.route(route, this.routes[route]);
        }
      },
      // Convert a route string into a regular expression, suitable for matching
      // against the current location hash.
      _routeToRegExp: function (route) {
        route = route.replace(escapeRegExp, '\\$&').replace(optionalParam, '(?:$1)?').replace(namedParam, function (match, optional) {
          return optional ? match : '([^/?]+)';
        }).replace(splatParam, '([^?]*?)');
        return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
      },
      // Given a route, and a URL fragment that it matches, return the array of
      // extracted decoded parameters. Empty or unmatched parameters will be
      // treated as `null` to normalize cross-browser behavior.
      _extractParameters: function (route, fragment) {
        var params = route.exec(fragment).slice(1);
        return _.map(params, function (param, i) {
          // Don't decode the search params.
          if (i === params.length - 1) return param || null;
          return param ? decodeURIComponent(param) : null;
        });
      }
    }); // Backbone.History
    // ----------------
    // Handles cross-browser history management, based on either
    // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
    // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
    // and URL fragments. If the browser supports neither (old IE, natch),
    // falls back to polling.

    var History = Backbone.History = function () {
      this.handlers = [];
      this.checkUrl = this.checkUrl.bind(this); // Ensure that `History` can be used outside of the browser.

      if (typeof window !== 'undefined') {
        this.location = window.location;
        this.history = window.history;
      }
    }; // Cached regex for stripping a leading hash/slash and trailing space.

    var routeStripper = /^[#\/]|\s+$/g; // Cached regex for stripping leading and trailing slashes.

    var rootStripper = /^\/+|\/+$/g; // Cached regex for stripping urls of hash.

    var pathStripper = /#.*$/; // Has the history handling already been started?

    History.started = false; // Set up all inheritable **Backbone.History** properties and methods.

    _.extend(History.prototype, Events, {
      // The default interval to poll for hash changes, if necessary, is
      // twenty times a second.
      interval: 50,
      // Are we at the app root?
      atRoot: function () {
        var path = this.location.pathname.replace(/[^\/]$/, '$&/');
        return path === this.root && !this.getSearch();
      },
      // Does the pathname match the root?
      matchRoot: function () {
        var path = this.decodeFragment(this.location.pathname);
        var rootPath = path.slice(0, this.root.length - 1) + '/';
        return rootPath === this.root;
      },
      // Unicode characters in `location.pathname` are percent encoded so they're
      // decoded for comparison. `%25` should not be decoded since it may be part
      // of an encoded parameter.
      decodeFragment: function (fragment) {
        return decodeURI(fragment.replace(/%25/g, '%2525'));
      },
      // In IE6, the hash fragment and search params are incorrect if the
      // fragment contains `?`.
      getSearch: function () {
        var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
        return match ? match[0] : '';
      },
      // Gets the true hash value. Cannot use location.hash directly due to bug
      // in Firefox where location.hash will always be decoded.
      getHash: function (window) {
        var match = (window || this).location.href.match(/#(.*)$/);
        return match ? match[1] : '';
      },
      // Get the pathname and search params, without the root.
      getPath: function () {
        var path = this.decodeFragment(this.location.pathname + this.getSearch()).slice(this.root.length - 1);
        return path.charAt(0) === '/' ? path.slice(1) : path;
      },
      // Get the cross-browser normalized URL fragment from the path or hash.
      getFragment: function (fragment) {
        if (fragment == null) {
          if (this._usePushState || !this._wantsHashChange) {
            fragment = this.getPath();
          } else {
            fragment = this.getHash();
          }
        }
        return fragment.replace(routeStripper, '');
      },
      // Start the hash change handling, returning `true` if the current URL matches
      // an existing route, and `false` otherwise.
      start: function (options) {
        if (History.started) throw new Error('Backbone.history has already been started');
        History.started = true; // Figure out the initial configuration. Do we need an iframe?
        // Is pushState desired ... is it available?

        this.options = _.extend({
          root: '/'
        }, this.options, options);
        this.root = this.options.root;
        this._wantsHashChange = this.options.hashChange !== false;
        this._hasHashChange = 'onhashchange' in window && (document.documentMode === void 0 || document.documentMode > 7);
        this._useHashChange = this._wantsHashChange && this._hasHashChange;
        this._wantsPushState = !!this.options.pushState;
        this._hasPushState = !!(this.history && this.history.pushState);
        this._usePushState = this._wantsPushState && this._hasPushState;
        this.fragment = this.getFragment(); // Normalize root to always include a leading and trailing slash.

        this.root = ('/' + this.root + '/').replace(rootStripper, '/'); // Transition from hashChange to pushState or vice versa if both are
        // requested.

        if (this._wantsHashChange && this._wantsPushState) {
          // If we've started off with a route from a `pushState`-enabled
          // browser, but we're currently in a browser that doesn't support it...
          if (!this._hasPushState && !this.atRoot()) {
            var rootPath = this.root.slice(0, -1) || '/';
            this.location.replace(rootPath + '#' + this.getPath()); // Return immediately as browser will do redirect to new url

            return true; // Or if we've started out with a hash-based route, but we're currently
            // in a browser where it could be `pushState`-based instead...
          } else if (this._hasPushState && this.atRoot()) {
            this.navigate(this.getHash(), {
              replace: true
            });
          }
        } // Proxy an iframe to handle location events if the browser doesn't
        // support the `hashchange` event, HTML5 history, or the user wants
        // `hashChange` but not `pushState`.

        if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
          this.iframe = document.createElement('iframe');
          this.iframe.src = 'javascript:0';
          this.iframe.style.display = 'none';
          this.iframe.tabIndex = -1;
          var body = document.body; // Using `appendChild` will throw on IE < 9 if the document is not ready.

          var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
          iWindow.document.open();
          iWindow.document.close();
          iWindow.location.hash = '#' + this.fragment;
        } // Add a cross-platform `addEventListener` shim for older browsers.

        var addEventListener = window.addEventListener || function (eventName, listener) {
          return attachEvent('on' + eventName, listener);
        }; // Depending on whether we're using pushState or hashes, and whether
        // 'onhashchange' is supported, determine how we check the URL state.

        if (this._usePushState) {
          addEventListener('popstate', this.checkUrl, false);
        } else if (this._useHashChange && !this.iframe) {
          addEventListener('hashchange', this.checkUrl, false);
        } else if (this._wantsHashChange) {
          this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
        }
        if (!this.options.silent) return this.loadUrl();
      },
      // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
      // but possibly useful for unit testing Routers.
      stop: function () {
        // Add a cross-platform `removeEventListener` shim for older browsers.
        var removeEventListener = window.removeEventListener || function (eventName, listener) {
          return detachEvent('on' + eventName, listener);
        }; // Remove window listeners.

        if (this._usePushState) {
          removeEventListener('popstate', this.checkUrl, false);
        } else if (this._useHashChange && !this.iframe) {
          removeEventListener('hashchange', this.checkUrl, false);
        } // Clean up the iframe if necessary.

        if (this.iframe) {
          document.body.removeChild(this.iframe);
          this.iframe = null;
        } // Some environments will throw when clearing an undefined interval.

        if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
        History.started = false;
      },
      // Add a route to be tested when the fragment changes. Routes added later
      // may override previous routes.
      route: function (route, callback) {
        this.handlers.unshift({
          route: route,
          callback: callback
        });
      },
      // Checks the current URL to see if it has changed, and if it has,
      // calls `loadUrl`, normalizing across the hidden iframe.
      checkUrl: function (e) {
        var current = this.getFragment(); // If the user pressed the back button, the iframe's hash will have
        // changed and we should use that for comparison.

        if (current === this.fragment && this.iframe) {
          current = this.getHash(this.iframe.contentWindow);
        }
        if (current === this.fragment) return false;
        if (this.iframe) this.navigate(current);
        this.loadUrl();
      },
      // Attempt to load the current URL fragment. If a route succeeds with a
      // match, returns `true`. If no defined routes matches the fragment,
      // returns `false`.
      loadUrl: function (fragment) {
        // If the root doesn't match, no routes can match either.
        if (!this.matchRoot()) return false;
        fragment = this.fragment = this.getFragment(fragment);
        return _.some(this.handlers, function (handler) {
          if (handler.route.test(fragment)) {
            handler.callback(fragment);
            return true;
          }
        });
      },
      // Save a fragment into the hash history, or replace the URL state if the
      // 'replace' option is passed. You are responsible for properly URL-encoding
      // the fragment in advance.
      //
      // The options object can contain `trigger: true` if you wish to have the
      // route callback be fired (not usually desirable), or `replace: true`, if
      // you wish to modify the current URL without adding an entry to the history.
      navigate: function (fragment, options) {
        if (!History.started) return false;
        if (!options || options === true) options = {
          trigger: !!options
        }; // Normalize the fragment.

        fragment = this.getFragment(fragment || ''); // Don't include a trailing slash on the root.

        var rootPath = this.root;
        if (fragment === '' || fragment.charAt(0) === '?') {
          rootPath = rootPath.slice(0, -1) || '/';
        }
        var url = rootPath + fragment; // Strip the fragment of the query and hash for matching.

        fragment = fragment.replace(pathStripper, ''); // Decode for matching.

        var decodedFragment = this.decodeFragment(fragment);
        if (this.fragment === decodedFragment) return;
        this.fragment = decodedFragment; // If pushState is available, we use it to set the fragment as a real URL.

        if (this._usePushState) {
          this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url); // If hash changes haven't been explicitly disabled, update the hash
          // fragment to store history.
        } else if (this._wantsHashChange) {
          this._updateHash(this.location, fragment, options.replace);
          if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
            var iWindow = this.iframe.contentWindow; // Opening and closing the iframe tricks IE7 and earlier to push a
            // history entry on hash-tag change.  When replace is true, we don't
            // want this.

            if (!options.replace) {
              iWindow.document.open();
              iWindow.document.close();
            }
            this._updateHash(iWindow.location, fragment, options.replace);
          } // If you've told us that you explicitly don't want fallback hashchange-
          // based history, then `navigate` becomes a page refresh.
        } else {
          return this.location.assign(url);
        }
        if (options.trigger) return this.loadUrl(fragment);
      },
      // Update the hash location, either replacing the current entry, or adding
      // a new one to the browser history.
      _updateHash: function (location, fragment, replace) {
        if (replace) {
          var href = location.href.replace(/(javascript:|#).*$/, '');
          location.replace(href + '#' + fragment);
        } else {
          // Some browsers require that `hash` contains a leading #.
          location.hash = '#' + fragment;
        }
      }
    }); // Create the default Backbone.history.

    Backbone.history = new History(); // Helpers
    // -------
    // Helper function to correctly set up the prototype chain for subclasses.
    // Similar to `goog.inherits`, but uses a hash of prototype properties and
    // class properties to be extended.

    var extend = function (protoProps, staticProps) {
      var parent = this;
      var child; // The constructor function for the new subclass is either defined by you
      // (the "constructor" property in your `extend` definition), or defaulted
      // by us to simply call the parent constructor.

      if (protoProps && _.has(protoProps, 'constructor')) {
        child = protoProps.constructor;
      } else {
        child = function () {
          return parent.apply(this, arguments);
        };
      } // Add static properties to the constructor function, if supplied.

      _.extend(child, parent, staticProps); // Set the prototype chain to inherit from `parent`, without calling
      // `parent`'s constructor function and add the prototype properties.

      child.prototype = _.create(parent.prototype, protoProps);
      child.prototype.constructor = child; // Set a convenience property in case the parent's prototype is needed
      // later.

      child.__super__ = parent.prototype;
      return child;
    }; // Set up inheritance for the model, collection, router, view and history.

    Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend; // Throw an error when a URL is needed, and none is supplied.

    var urlError = function () {
      throw new Error('A "url" property or function must be specified');
    }; // Wrap an optional error callback with a fallback error event.

    var wrapError = function (model, options) {
      var error = options.error;
      options.error = function (resp) {
        if (error) error.call(options.context, model, resp, options);
        model.trigger('error', model, resp, options);
      };
    };
    return Backbone;
  });
})(_backbone.b, _backbone.b.exports);
var Backbone = _backbone.b.exports;
exports["default"] = Backbone;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/vendor/lib/js.cookie.js":
/*!*****************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/vendor/lib/js.cookie.js ***!
  \*****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _jsCookie = __webpack_require__(/*! ../../../../_virtual/js.cookie.js */ "./packages/@okta/courage-dist/esm/_virtual/js.cookie.js");
/*!
 * JavaScript Cookie v2.1.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */

(function (module, exports) {
  (function (factory) {
    {
      module.exports = factory();
    }
  })(function () {
    function extend() {
      var i = 0;
      var result = {};
      for (; i < arguments.length; i++) {
        var attributes = arguments[i];
        for (var key in attributes) {
          result[key] = attributes[key];
        }
      }
      return result;
    }
    function init(converter) {
      function api(key, value, attributes) {
        var result; // Write

        if (arguments.length > 1) {
          attributes = extend({
            path: '/'
          }, api.defaults, attributes);
          if (typeof attributes.expires === 'number') {
            var expires = new Date();
            expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
            attributes.expires = expires;
          }
          try {
            result = JSON.stringify(value);
            if (/^[\{\[]/.test(result)) {
              value = result;
            }
          } catch (e) {}
          if (!converter.write) {
            value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
          } else {
            value = converter.write(value, key);
          }
          key = encodeURIComponent(String(key));
          key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
          key = key.replace(/[\(\)]/g, escape);
          return document.cookie = [key, '=', value, attributes.expires && '; expires=' + attributes.expires.toUTCString(),
          // use expires attribute, max-age is not supported by IE
          attributes.path && '; path=' + attributes.path, attributes.domain && '; domain=' + attributes.domain, attributes.secure ? '; secure' : ''].join('');
        } // Read

        if (!key) {
          result = {};
        } // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all. Also prevents odd result when
        // calling "get()"

        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var rdecode = /(%[0-9A-Z]{2})+/g;
        var i = 0;
        for (; i < cookies.length; i++) {
          var parts = cookies[i].split('=');
          var name = parts[0].replace(rdecode, decodeURIComponent);
          var cookie = parts.slice(1).join('=');
          if (cookie.charAt(0) === '"') {
            cookie = cookie.slice(1, -1);
          }
          try {
            cookie = converter.read ? converter.read(cookie, name) : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);
            if (this.json) {
              try {
                cookie = JSON.parse(cookie);
              } catch (e) {}
            }
            if (key === name) {
              result = cookie;
              break;
            }
            if (!key) {
              result[name] = cookie;
            }
          } catch (e) {}
        }
        return result;
      }
      api.get = api.set = api;
      api.getJSON = function () {
        return api.apply({
          json: true
        }, [].slice.call(arguments));
      };
      api.defaults = {};
      api.remove = function (key, attributes) {
        api(key, '', extend(attributes, {
          expires: -1
        }));
      };
      api.withConverter = init;
      return api;
    }
    return init(function () {});
  });
})(_jsCookie.j);
var Cookie = _jsCookie.j.exports;
exports["default"] = Cookie;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/vendor/plugins/chosen.jquery.js":
/*!*************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/vendor/plugins/chosen.jquery.js ***!
  \*************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _jquery = _interopRequireDefault(__webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(function () {
  var SelectParser;
  SelectParser = function () {
    function SelectParser() {
      this.options_index = 0;
      this.parsed = [];
    }
    SelectParser.prototype.add_node = function (child) {
      if (child.nodeName.toUpperCase() === "OPTGROUP") {
        return this.add_group(child);
      } else {
        return this.add_option(child);
      }
    };
    SelectParser.prototype.add_group = function (group) {
      var group_position, option, _i, _len, _ref, _results;
      group_position = this.parsed.length;
      this.parsed.push({
        array_index: group_position,
        group: true,
        label: group.label,
        children: 0,
        disabled: group.disabled
      });
      _ref = group.childNodes;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        _results.push(this.add_option(option, group_position, group.disabled));
      }
      return _results;
    };
    SelectParser.prototype.add_option = function (option, group_position, group_disabled) {
      if (option.nodeName.toUpperCase() === "OPTION") {
        if (option.text !== "") {
          if (group_position != null) {
            this.parsed[group_position].children += 1;
          }
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            value: option.value,
            text: option.text,
            html: option.innerHTML,
            selected: option.selected,
            disabled: group_disabled === true ? group_disabled : option.disabled,
            group_array_index: group_position,
            classes: option.className,
            style: option.style.cssText
          });
        } else {
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            empty: true
          });
        }
        return this.options_index += 1;
      }
    };
    return SelectParser;
  }();
  SelectParser.select_to_array = function (select) {
    var child, parser, _i, _len, _ref;
    parser = new SelectParser();
    _ref = select.childNodes;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      child = _ref[_i];
      parser.add_node(child);
    }
    return parser.parsed;
  };
  this.SelectParser = SelectParser;
}).call(_jquery.default);
(function () {
  var AbstractChosen, root;
  root = this;
  AbstractChosen = function () {
    function AbstractChosen(form_field, options) {
      this.form_field = form_field;
      this.options = options != null ? options : {};
      if (!AbstractChosen.browser_is_supported()) {
        return;
      }
      this.is_multiple = this.form_field.multiple;
      this.set_default_text();
      this.set_default_values();
      this.setup();
      this.set_up_html();
      this.register_observers();
      this.finish_setup();
    }
    AbstractChosen.prototype.set_default_values = function () {
      var _this = this;
      this.click_test_action = function (evt) {
        return _this.test_active_click(evt);
      };
      this.activate_action = function (evt) {
        return _this.activate_field(evt);
      };
      this.active_field = false;
      this.mouse_on_container = false;
      this.results_showing = false;
      this.result_highlighted = null;
      this.result_single_selected = null;
      this.allow_single_deselect = this.options.allow_single_deselect != null && this.form_field.options[0] != null && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
      this.disable_search_threshold = this.options.disable_search_threshold || 0;
      this.disable_search = this.options.disable_search || false;
      this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
      this.search_contains = this.options.search_contains || false;
      this.single_backstroke_delete = this.options.single_backstroke_delete || false;
      this.max_selected_options = this.options.max_selected_options || Infinity;
      return this.inherit_select_classes = this.options.inherit_select_classes || false;
    };
    AbstractChosen.prototype.set_default_text = function () {
      if (this.form_field.getAttribute("data-placeholder")) {
        this.default_text = this.form_field.getAttribute("data-placeholder");
      } else if (this.is_multiple) {
        this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
      } else {
        this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
      }
      return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
    };
    AbstractChosen.prototype.mouse_enter = function () {
      return this.mouse_on_container = true;
    };
    AbstractChosen.prototype.mouse_leave = function () {
      return this.mouse_on_container = false;
    };
    AbstractChosen.prototype.input_focus = function (evt) {
      var _this = this;
      if (this.is_multiple) {
        if (!this.active_field) {
          return setTimeout(function () {
            return _this.container_mousedown();
          }, 50);
        }
      } else {
        if (!this.active_field) {
          return this.activate_field();
        }
      }
    };
    AbstractChosen.prototype.input_blur = function (evt) {
      var _this = this;
      if (!this.mouse_on_container) {
        this.active_field = false;
        return setTimeout(function () {
          return _this.blur_test();
        }, 100);
      }
    };
    AbstractChosen.prototype.result_add_option = function (option) {
      var classes, style;
      option.dom_id = this.container_id + "_o_" + option.array_index;
      classes = [];
      if (!option.disabled && !(option.selected && this.is_multiple)) {
        classes.push("active-result");
      }
      if (option.disabled && !(option.selected && this.is_multiple)) {
        classes.push("disabled-result");
      }
      if (option.selected) {
        classes.push("result-selected");
      }
      if (option.group_array_index != null) {
        classes.push("group-option");
      }
      if (option.classes !== "") {
        classes.push(option.classes);
      }
      style = option.style.cssText !== "" && option.style !== "" ? " style=\"" + option.style + "\"" : "";
      return "<li id=\"" + option.dom_id + "\" class=\"" + classes.join(" ") + "\"" + style + ">" + option.html + "</li>";
    };
    AbstractChosen.prototype.results_update_field = function () {
      this.set_default_text();
      if (!this.is_multiple) {
        this.results_reset_cleanup();
      }
      this.result_clear_highlight();
      this.result_single_selected = null;
      return this.results_build();
    };
    AbstractChosen.prototype.results_toggle = function () {
      if (this.results_showing) {
        return this.results_hide();
      } else {
        return this.results_show();
      }
    };
    AbstractChosen.prototype.results_search = function (evt) {
      if (this.results_showing) {
        return this.winnow_results();
      } else {
        return this.results_show();
      }
    };
    AbstractChosen.prototype.choices_count = function () {
      var option, _i, _len, _ref;
      if (this.selected_option_count != null) {
        return this.selected_option_count;
      }
      this.selected_option_count = 0;
      _ref = this.form_field.options;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        if (option.selected) {
          this.selected_option_count += 1;
        }
      }
      return this.selected_option_count;
    };
    AbstractChosen.prototype.choices_click = function (evt) {
      evt.preventDefault();
      if (!(this.results_showing || this.is_disabled)) {
        return this.results_show();
      }
    };
    AbstractChosen.prototype.keyup_checker = function (evt) {
      var stroke, _ref;
      stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
      this.search_field_scale();
      switch (stroke) {
        case 8:
          if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
            return this.keydown_backstroke();
          } else if (!this.pending_backstroke) {
            this.result_clear_highlight();
            return this.results_search();
          }
          break;
        case 13:
          evt.preventDefault();
          if (this.results_showing) {
            return this.result_select(evt);
          }
          break;
        case 27:
          if (this.results_showing) {
            this.results_hide();
          }
          return true;
        case 9:
        case 38:
        case 40:
        case 16:
        case 91:
        case 17:
          break;
        default:
          return this.results_search();
      }
    };
    AbstractChosen.prototype.generate_field_id = function () {
      var new_id;
      new_id = this.generate_random_id();
      this.form_field.id = new_id;
      return new_id;
    };
    AbstractChosen.prototype.generate_random_char = function () {
      var chars, rand;
      chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      rand = Math.floor(Math.random() * chars.length);
      return chars.substring(rand, rand + 1);
    };
    AbstractChosen.prototype.container_width = function () {
      if (this.options.width != null) {
        return this.options.width;
      } else {
        return "" + this.form_field.offsetWidth + "px";
      }
    };
    AbstractChosen.browser_is_supported = function () {
      var _ref;
      if (window.navigator.appName === "Microsoft Internet Explorer") {
        return null !== (_ref = document.documentMode) && _ref >= 8;
      }
      return true;
    };
    AbstractChosen.default_multiple_text = "Select Some Options";
    AbstractChosen.default_single_text = "Select an Option";
    AbstractChosen.default_no_result_text = "No results match";
    return AbstractChosen;
  }();
  root.AbstractChosen = AbstractChosen;
}).call(_jquery.default);
(function () {
  var $$1,
    Chosen,
    root,
    _ref,
    __hasProp = {}.hasOwnProperty,
    __extends = function (child, parent) {
      for (var key in parent) {
        if (__hasProp.call(parent, key)) child[key] = parent[key];
      }
      function ctor() {
        this.constructor = child;
      }
      ctor.prototype = parent.prototype;
      child.prototype = new ctor();
      child.__super__ = parent.prototype;
      return child;
    };
  root = this;
  var AbstractChosen = root.AbstractChosen;
  $$1 = _jquery.default;
  $$1.fn.extend({
    chosen: function (options) {
      if (!AbstractChosen.browser_is_supported()) {
        return this;
      }
      return this.each(function (input_field) {
        var $this;
        $this = $$1(this);
        if (!$this.hasClass("chzn-done")) {
          return $this.data("chosen", new Chosen(this, options));
        }
      });
    }
  });
  Chosen = function (_super) {
    __extends(Chosen, _super);
    function Chosen() {
      _ref = Chosen.__super__.constructor.apply(this, arguments);
      return _ref;
    }
    Chosen.prototype.setup = function () {
      this.form_field_jq = $$1(this.form_field);
      this.current_selectedIndex = this.form_field.selectedIndex;
      return this.is_rtl = this.form_field_jq.hasClass("chzn-rtl");
    };
    Chosen.prototype.finish_setup = function () {
      return this.form_field_jq.addClass("chzn-done");
    };
    Chosen.prototype.set_up_html = function () {
      var container_classes, container_props;
      this.container_id = this.form_field.id.length ? this.form_field.id.replace(/[^\w]/g, "_") : this.generate_field_id();
      this.container_id += "_chzn";
      container_classes = ["chzn-container"];
      container_classes.push("chzn-container-" + (this.is_multiple ? "multi" : "single"));
      if (this.inherit_select_classes && this.form_field.className) {
        container_classes.push(this.form_field.className);
      }
      if (this.is_rtl) {
        container_classes.push("chzn-rtl");
      }
      container_props = {
        "id": this.container_id,
        "class": container_classes.join(" "),
        "title": this.form_field.title
      };
      this.container = $$1("<div></div>", container_props);
      this.container[0].style.width = this.container_width();
      if (this.is_multiple) {
        this.container.html("<ul class=\"chzn-choices\"><li class=\"search-field\"><input type=\"text\" value=\"" + this.default_text + "\" class=\"default\" autocomplete=\"off\" style=\"width:25px;\" /></li></ul><div class=\"chzn-drop\"><ul class=\"chzn-results\"></ul></div>");
      } else {
        this.container.html("<a href=\"#\" class=\"chzn-single chzn-default\" tabindex=\"-1\"><span>" + this.default_text + "</span><div><b></b></div></a><div class=\"chzn-drop\"><div class=\"chzn-search\"><input type=\"text\" autocomplete=\"off\" /></div><ul class=\"chzn-results\"></ul></div>");
      }
      this.form_field_jq.hide().after(this.container);
      this.dropdown = this.container.find("div.chzn-drop").first();
      this.search_field = this.container.find("input").first();
      this.search_results = this.container.find("ul.chzn-results").first();
      this.search_field_scale();
      this.search_no_results = this.container.find("li.no-results").first();
      if (this.is_multiple) {
        this.search_choices = this.container.find("ul.chzn-choices").first();
        this.search_container = this.container.find("li.search-field").first();
      } else {
        this.search_container = this.container.find("div.chzn-search").first();
        this.selected_item = this.container.find(".chzn-single").first();
      }
      this.results_build();
      this.set_tab_index();
      this.set_label_behavior();
      return this.form_field_jq.trigger("liszt:ready", {
        chosen: this
      });
    };
    Chosen.prototype.register_observers = function () {
      var _this = this;
      this.container.mousedown(function (evt) {
        _this.container_mousedown(evt);
      });
      this.container.mouseup(function (evt) {
        _this.container_mouseup(evt);
      });
      this.container.mouseenter(function (evt) {
        _this.mouse_enter(evt);
      });
      this.container.mouseleave(function (evt) {
        _this.mouse_leave(evt);
      });
      this.search_results.mouseup(function (evt) {
        _this.search_results_mouseup(evt);
      });
      this.search_results.mouseover(function (evt) {
        _this.search_results_mouseover(evt);
      });
      this.search_results.mouseout(function (evt) {
        _this.search_results_mouseout(evt);
      });
      this.search_results.bind("mousewheel DOMMouseScroll", function (evt) {
        _this.search_results_mousewheel(evt);
      });
      this.form_field_jq.bind("liszt:updated", function (evt) {
        _this.results_update_field(evt);
      });
      this.form_field_jq.bind("liszt:activate", function (evt) {
        _this.activate_field(evt);
      });
      this.form_field_jq.bind("liszt:open", function (evt) {
        _this.container_mousedown(evt);
      });
      this.search_field.blur(function (evt) {
        _this.input_blur(evt);
      });
      this.search_field.keyup(function (evt) {
        _this.keyup_checker(evt);
      });
      this.search_field.keydown(function (evt) {
        _this.keydown_checker(evt);
      });
      this.search_field.focus(function (evt) {
        _this.input_focus(evt);
      });
      if (this.is_multiple) {
        return this.search_choices.click(function (evt) {
          _this.choices_click(evt);
        });
      } else {
        return this.container.click(function (evt) {
          evt.preventDefault();
        });
      }
    };
    Chosen.prototype.search_field_disabled = function () {
      this.is_disabled = this.form_field_jq[0].disabled;
      if (this.is_disabled) {
        this.container.addClass("chzn-disabled");
        this.search_field[0].disabled = true;
        if (!this.is_multiple) {
          this.selected_item.unbind("focus", this.activate_action);
        }
        return this.close_field();
      } else {
        this.container.removeClass("chzn-disabled");
        this.search_field[0].disabled = false;
        if (!this.is_multiple) {
          return this.selected_item.bind("focus", this.activate_action);
        }
      }
    };
    Chosen.prototype.container_mousedown = function (evt) {
      if (!this.is_disabled) {
        if (evt && evt.type === "mousedown" && !this.results_showing) {
          evt.preventDefault();
        }
        if (!(evt != null && $$1(evt.target).hasClass("search-choice-close"))) {
          if (!this.active_field) {
            if (this.is_multiple) {
              this.search_field.val("");
            }
            $$1(document).click(this.click_test_action);
            this.results_show();
          } else if (!this.is_multiple && evt && ($$1(evt.target)[0] === this.selected_item[0] || $$1(evt.target).parents("a.chzn-single").length)) {
            evt.preventDefault();
            this.results_toggle();
          }
          return this.activate_field();
        }
      }
    };
    Chosen.prototype.container_mouseup = function (evt) {
      if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
        return this.results_reset(evt);
      }
    };
    Chosen.prototype.search_results_mousewheel = function (evt) {
      var delta, _ref1, _ref2;
      delta = -((_ref1 = evt.originalEvent) != null ? _ref1.wheelDelta : void 0) || ((_ref2 = evt.originialEvent) != null ? _ref2.detail : void 0);
      if (delta != null) {
        evt.preventDefault();
        if (evt.type === "DOMMouseScroll") {
          delta = delta * 40;
        }
        return this.search_results.scrollTop(delta + this.search_results.scrollTop());
      }
    };
    Chosen.prototype.blur_test = function (evt) {
      if (!this.active_field && this.container.hasClass("chzn-container-active")) {
        return this.close_field();
      }
    };
    Chosen.prototype.close_field = function () {
      $$1(document).unbind("click", this.click_test_action);
      this.active_field = false;
      this.results_hide();
      this.container.removeClass("chzn-container-active");
      this.clear_backstroke();
      this.show_search_field_default();
      return this.search_field_scale();
    };
    Chosen.prototype.activate_field = function () {
      this.container.addClass("chzn-container-active");
      this.active_field = true;
      this.search_field.val(this.search_field.val());
      return this.search_field.focus();
    };
    Chosen.prototype.test_active_click = function (evt) {
      if ($$1(evt.target).parents("#" + this.container_id).length) {
        return this.active_field = true;
      } else {
        return this.close_field();
      }
    };
    Chosen.prototype.results_build = function () {
      var content, data, _i, _len, _ref1;
      this.parsing = true;
      this.selected_option_count = null;
      this.results_data = root.SelectParser.select_to_array(this.form_field);
      if (this.is_multiple) {
        this.search_choices.find("li.search-choice").remove();
      } else if (!this.is_multiple) {
        this.selected_item.addClass("chzn-default").find("span").text(this.default_text);
        if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
          this.search_field[0].readOnly = true;
          this.container.addClass("chzn-container-single-nosearch");
        } else {
          this.search_field[0].readOnly = false;
          this.container.removeClass("chzn-container-single-nosearch");
        }
      }
      content = "";
      _ref1 = this.results_data;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        data = _ref1[_i];
        if (data.group) {
          content += this.result_add_group(data);
        } else if (!data.empty) {
          content += this.result_add_option(data);
          if (data.selected && this.is_multiple) {
            this.choice_build(data);
          } else if (data.selected && !this.is_multiple) {
            this.selected_item.removeClass("chzn-default").find("span").text(data.text);
            if (this.allow_single_deselect) {
              this.single_deselect_control_build();
            }
          }
        }
      }
      this.search_field_disabled();
      this.show_search_field_default();
      this.search_field_scale();
      this.search_results.html(content);
      return this.parsing = false;
    };
    Chosen.prototype.result_add_group = function (group) {
      group.dom_id = this.container_id + "_g_" + group.array_index;
      return "<li id=\"" + group.dom_id + "\" class=\"group-result\">" + $$1("<div></div>").text(group.label).html() + "</li>";
    };
    Chosen.prototype.result_do_highlight = function (el) {
      var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
      if (el.length) {
        this.result_clear_highlight();
        this.result_highlight = el;
        this.result_highlight.addClass("highlighted");
        maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
        visible_top = this.search_results.scrollTop();
        visible_bottom = maxHeight + visible_top;
        high_top = this.result_highlight.position().top + this.search_results.scrollTop();
        high_bottom = high_top + this.result_highlight.outerHeight();
        if (high_bottom >= visible_bottom) {
          return this.search_results.scrollTop(high_bottom - maxHeight > 0 ? high_bottom - maxHeight : 0);
        } else if (high_top < visible_top) {
          return this.search_results.scrollTop(high_top);
        }
      }
    };
    Chosen.prototype.result_clear_highlight = function () {
      if (this.result_highlight) {
        this.result_highlight.removeClass("highlighted");
      }
      return this.result_highlight = null;
    };
    Chosen.prototype.results_show = function () {
      if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
        this.form_field_jq.trigger("liszt:maxselected", {
          chosen: this
        });
        return false;
      }
      this.container.addClass("chzn-with-drop");
      this.form_field_jq.trigger("liszt:showing_dropdown", {
        chosen: this
      });
      this.results_showing = true;
      this.search_field.focus();
      this.search_field.val(this.search_field.val());
      return this.winnow_results();
    };
    Chosen.prototype.results_hide = function () {
      if (this.results_showing) {
        this.result_clear_highlight();
        this.container.removeClass("chzn-with-drop");
        this.form_field_jq.trigger("liszt:hiding_dropdown", {
          chosen: this
        });
      }
      return this.results_showing = false;
    };
    Chosen.prototype.set_tab_index = function (el) {
      var ti;
      if (this.form_field_jq.attr("tabindex")) {
        ti = this.form_field_jq.attr("tabindex");
        this.form_field_jq.attr("tabindex", -1);
        return this.search_field.attr("tabindex", ti);
      }
    };
    Chosen.prototype.set_label_behavior = function () {
      var _this = this;
      this.form_field_label = this.form_field_jq.parents("label");
      if (!this.form_field_label.length && this.form_field.id.length) {
        this.form_field_label = $$1("label[for='" + this.form_field.id + "']");
      }
      if (this.form_field_label.length > 0) {
        return this.form_field_label.click(function (evt) {
          if (_this.is_multiple) {
            return _this.container_mousedown(evt);
          } else {
            return _this.activate_field();
          }
        });
      }
    };
    Chosen.prototype.show_search_field_default = function () {
      if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
        this.search_field.val(this.default_text);
        return this.search_field.addClass("default");
      } else {
        this.search_field.val("");
        return this.search_field.removeClass("default");
      }
    };
    Chosen.prototype.search_results_mouseup = function (evt) {
      var target;
      target = $$1(evt.target).hasClass("active-result") ? $$1(evt.target) : $$1(evt.target).parents(".active-result").first();
      if (target.length) {
        this.result_highlight = target;
        this.result_select(evt);
        return this.search_field.focus();
      }
    };
    Chosen.prototype.search_results_mouseover = function (evt) {
      var target;
      target = $$1(evt.target).hasClass("active-result") ? $$1(evt.target) : $$1(evt.target).parents(".active-result").first();
      if (target) {
        return this.result_do_highlight(target);
      }
    };
    Chosen.prototype.search_results_mouseout = function (evt) {
      if ($$1(evt.target).hasClass("active-result")) {
        return this.result_clear_highlight();
      }
    };
    Chosen.prototype.choice_build = function (item) {
      var choice,
        close_link,
        _this = this;
      choice = $$1("<li></li>", {
        "class": "search-choice"
      }).html("<span>" + item.html + "</span>");
      if (item.disabled) {
        choice.addClass("search-choice-disabled");
      } else {
        close_link = $$1("<a></a>", {
          href: "#",
          "class": "search-choice-close",
          rel: item.array_index
        });
        close_link.click(function (evt) {
          return _this.choice_destroy_link_click(evt);
        });
        choice.append(close_link);
      }
      return this.search_container.before(choice);
    };
    Chosen.prototype.choice_destroy_link_click = function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (!this.is_disabled) {
        return this.choice_destroy($$1(evt.target));
      }
    };
    Chosen.prototype.choice_destroy = function (link) {
      if (this.result_deselect(link.attr("rel"))) {
        this.show_search_field_default();
        if (this.is_multiple && this.choices_count() > 0 && this.search_field.val().length < 1) {
          this.results_hide();
        }
        link.parents("li").first().remove();
        return this.search_field_scale();
      }
    };
    Chosen.prototype.results_reset = function () {
      this.form_field.options[0].selected = true;
      this.selected_option_count = null;
      this.selected_item.find("span").text(this.default_text);
      if (!this.is_multiple) {
        this.selected_item.addClass("chzn-default");
      }
      this.show_search_field_default();
      this.results_reset_cleanup();
      this.form_field_jq.trigger("change");
      if (this.active_field) {
        return this.results_hide();
      }
    };
    Chosen.prototype.results_reset_cleanup = function () {
      this.current_selectedIndex = this.form_field.selectedIndex;
      return this.selected_item.find("abbr").remove();
    };
    Chosen.prototype.result_select = function (evt) {
      var high, high_id, item, position;
      if (this.result_highlight) {
        high = this.result_highlight;
        high_id = high.attr("id");
        this.result_clear_highlight();
        if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
          this.form_field_jq.trigger("liszt:maxselected", {
            chosen: this
          });
          return false;
        }
        if (this.is_multiple) {
          high.removeClass("active-result");
        } else {
          this.search_results.find(".result-selected").removeClass("result-selected");
          this.result_single_selected = high;
          this.selected_item.removeClass("chzn-default");
        }
        high.addClass("result-selected");
        position = high_id.substr(high_id.lastIndexOf("_") + 1);
        item = this.results_data[position];
        item.selected = true;
        this.form_field.options[item.options_index].selected = true;
        this.selected_option_count = null;
        if (this.is_multiple) {
          this.choice_build(item);
        } else {
          this.selected_item.find("span").first().text(item.text);
          if (this.allow_single_deselect) {
            this.single_deselect_control_build();
          }
        }
        if (!((evt.metaKey || evt.ctrlKey) && this.is_multiple)) {
          this.results_hide();
        }
        this.search_field.val("");
        if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
          this.form_field_jq.trigger("change", {
            "selected": this.form_field.options[item.options_index].value
          });
        }
        this.current_selectedIndex = this.form_field.selectedIndex;
        return this.search_field_scale();
      }
    };
    Chosen.prototype.result_activate = function (el, option) {
      if (option.disabled) {
        return el.addClass("disabled-result");
      } else if (this.is_multiple && option.selected) {
        return el.addClass("result-selected");
      } else {
        return el.addClass("active-result");
      }
    };
    Chosen.prototype.result_deactivate = function (el) {
      return el.removeClass("active-result result-selected disabled-result");
    };
    Chosen.prototype.result_deselect = function (pos) {
      var result, result_data;
      result_data = this.results_data[pos];
      if (!this.form_field.options[result_data.options_index].disabled) {
        result_data.selected = false;
        this.form_field.options[result_data.options_index].selected = false;
        this.selected_option_count = null;
        result = $$1("#" + this.container_id + "_o_" + pos);
        result.removeClass("result-selected").addClass("active-result").show();
        this.result_clear_highlight();
        this.winnow_results();
        this.form_field_jq.trigger("change", {
          deselected: this.form_field.options[result_data.options_index].value
        });
        this.search_field_scale();
        return true;
      } else {
        return false;
      }
    };
    Chosen.prototype.single_deselect_control_build = function () {
      if (!this.allow_single_deselect) {
        return;
      }
      if (!this.selected_item.find("abbr").length) {
        this.selected_item.find("span").first().after("<abbr class=\"search-choice-close\"></abbr>");
      }
      return this.selected_item.addClass("chzn-single-with-deselect");
    };
    Chosen.prototype.winnow_results = function () {
      var found, option, part, parts, regex, regexAnchor, result, result_id, results, searchText, startpos, text, zregex, _i, _j, _len, _len1, _ref1;
      this.no_results_clear();
      results = 0;
      searchText = this.search_field.val() === this.default_text ? "" : $$1("<div></div>").text($$1.trim(this.search_field.val())).html();
      regexAnchor = this.search_contains ? "" : "^";
      regex = new RegExp(regexAnchor + searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), "i");
      zregex = new RegExp(searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), "i");
      _ref1 = this.results_data;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        option = _ref1[_i];
        if (!option.empty) {
          if (option.group) {
            $$1("#" + option.dom_id).css("display", "none");
          } else {
            found = false;
            result_id = option.dom_id;
            result = $$1("#" + result_id);
            if (regex.test(option.html)) {
              found = true;
              results += 1;
            } else if (this.enable_split_word_search && (option.html.indexOf(" ") >= 0 || option.html.indexOf("[") === 0)) {
              parts = option.html.replace(/\[|\]/g, "").split(" ");
              if (parts.length) {
                for (_j = 0, _len1 = parts.length; _j < _len1; _j++) {
                  part = parts[_j];
                  if (regex.test(part)) {
                    found = true;
                    results += 1;
                  }
                }
              }
            }
            if (found) {
              if (searchText.length) {
                startpos = option.html.search(zregex);
                text = option.html.substr(0, startpos + searchText.length) + "</em>" + option.html.substr(startpos + searchText.length);
                text = text.substr(0, startpos) + "<em>" + text.substr(startpos);
              } else {
                text = option.html;
              }
              result.html(text);
              this.result_activate(result, option);
              if (option.group_array_index != null) {
                $$1("#" + this.results_data[option.group_array_index].dom_id).css("display", "list-item");
              }
            } else {
              if (this.result_highlight && result_id === this.result_highlight.attr("id")) {
                this.result_clear_highlight();
              }
              this.result_deactivate(result);
            }
          }
        }
      }
      if (results < 1 && searchText.length) {
        return this.no_results(searchText);
      } else {
        return this.winnow_results_set_highlight();
      }
    };
    Chosen.prototype.winnow_results_set_highlight = function () {
      var do_high, selected_results;
      if (!this.result_highlight) {
        selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
        do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();
        if (do_high != null) {
          return this.result_do_highlight(do_high);
        }
      }
    };
    Chosen.prototype.no_results = function (terms) {
      var no_results_html;
      no_results_html = $$1("<li class=\"no-results\">" + this.results_none_found + " \"<span></span>\"</li>");
      no_results_html.find("span").first().html(terms);
      return this.search_results.append(no_results_html);
    };
    Chosen.prototype.no_results_clear = function () {
      return this.search_results.find(".no-results").remove();
    };
    Chosen.prototype.keydown_arrow = function () {
      var next_sib;
      if (this.results_showing && this.result_highlight) {
        next_sib = this.result_highlight.nextAll("li.active-result").first();
        if (next_sib) {
          return this.result_do_highlight(next_sib);
        }
      } else {
        return this.results_show();
      }
    };
    Chosen.prototype.keyup_arrow = function () {
      var prev_sibs;
      if (!this.results_showing && !this.is_multiple) {
        return this.results_show();
      } else if (this.result_highlight) {
        prev_sibs = this.result_highlight.prevAll("li.active-result");
        if (prev_sibs.length) {
          return this.result_do_highlight(prev_sibs.first());
        } else {
          if (this.choices_count() > 0) {
            this.results_hide();
          }
          return this.result_clear_highlight();
        }
      }
    };
    Chosen.prototype.keydown_backstroke = function () {
      var next_available_destroy;
      if (this.pending_backstroke) {
        this.choice_destroy(this.pending_backstroke.find("a").first());
        return this.clear_backstroke();
      } else {
        next_available_destroy = this.search_container.siblings("li.search-choice").last();
        if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
          this.pending_backstroke = next_available_destroy;
          if (this.single_backstroke_delete) {
            return this.keydown_backstroke();
          } else {
            return this.pending_backstroke.addClass("search-choice-focus");
          }
        }
      }
    };
    Chosen.prototype.clear_backstroke = function () {
      if (this.pending_backstroke) {
        this.pending_backstroke.removeClass("search-choice-focus");
      }
      return this.pending_backstroke = null;
    };
    Chosen.prototype.keydown_checker = function (evt) {
      var stroke, _ref1;
      stroke = (_ref1 = evt.which) != null ? _ref1 : evt.keyCode;
      this.search_field_scale();
      if (stroke !== 8 && this.pending_backstroke) {
        this.clear_backstroke();
      }
      switch (stroke) {
        case 8:
          this.backstroke_length = this.search_field.val().length;
          break;
        case 9:
          if (this.results_showing && !this.is_multiple) {
            this.result_select(evt);
          }
          this.mouse_on_container = false;
          break;
        case 13:
          evt.preventDefault();
          break;
        case 38:
          evt.preventDefault();
          this.keyup_arrow();
          break;
        case 40:
          evt.preventDefault();
          this.keydown_arrow();
          break;
      }
    };
    Chosen.prototype.search_field_scale = function () {
      var div, style, style_block, styles, w, _i, _len;
      if (this.is_multiple) {
        w = 0;
        style_block = "position:absolute; left: -1000px; top: -1000px; display:none;";
        styles = ["font-size", "font-style", "font-weight", "font-family", "line-height", "text-transform", "letter-spacing"];
        for (_i = 0, _len = styles.length; _i < _len; _i++) {
          style = styles[_i];
          style_block += style + ":" + this.search_field.css(style) + ";";
        }
        div = $$1("<div></div>", {
          "style": style_block
        });
        div.text(this.search_field.val());
        $$1("body").append(div);
        w = div.width() + 25;
        div.remove();
        if (!this.f_width) {
          this.f_width = this.container.outerWidth();
        }
        if (w > this.f_width - 10) {
          w = this.f_width - 10;
        }
        return this.search_field.css({
          "width": w + "px"
        });
      }
    };
    Chosen.prototype.generate_random_id = function () {
      var string;
      string = "sel" + this.generate_random_char() + this.generate_random_char() + this.generate_random_char();
      while ($$1("#" + string).length > 0) {
        string += this.generate_random_char();
      }
      return string;
    };
    return Chosen;
  }(AbstractChosen);
  root.Chosen = Chosen;
}).call(_jquery.default);

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/vendor/plugins/jquery.custominput.js":
/*!******************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/vendor/plugins/jquery.custominput.js ***!
  \******************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _jquery = _interopRequireDefault(__webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * There are following local modifications:
 * - Author: Uzi Kilon ukilon@okta.com
 *   Bug: OKTA-20830 - solves the conflict when there are multiple labels
 */

/**
 * --------------------------------------------------------------------
 * jQuery customInput plugin
 * Author: Maggie Costello Wachs maggie@filamentgroup.com, Scott Jehl, scott@filamentgroup.com
 * Copyright (c) 2009 Filament Group
 * licensed under MIT (filamentgroup.com/examples/mit-license.txt)
 * --------------------------------------------------------------------
*/
(function () {
  var jQuery = _jquery.default;
  var $$1 = jQuery;
  jQuery.fn.customInput = function () {
    return $$1(this).each(function () {
      if ($$1(this).is('[type=checkbox],[type=radio]')) {
        var input = $$1(this); // get the associated label using the input's id

        var label = input.siblings('label[for="' + input.attr('id') + '"]:first');
        if (!label.length) {
          label = input.closest('label[for="' + input.attr('id') + '"]:first');
        } // wrap the input + label in a div

        input.add(label).wrapAll('<div class="custom-' + input.attr('type') + '"></div>'); // necessary for browsers that don't support the :hover pseudo class on labels

        label.hover(function () {
          $$1(this).addClass('hover');
        }, function () {
          $$1(this).removeClass('hover');
        }); //bind custom event, trigger it, bind click,focus,blur events

        input.bind('updateState', function () {
          input.is(':checked') ? label.addClass('checked') : label.removeClass('checked checkedHover checkedFocus');
        }).trigger('updateState').click(function () {
          $$1('input[name="' + $$1(this).attr('name') + '"]').trigger('updateState');
        }).focus(function () {
          label.addClass('focus');
          if (input.is(':checked')) {
            $$1(this).addClass('checkedFocus');
          }
        }).blur(function () {
          label.removeClass('focus checkedFocus');
        });
      }
    });
  };
})();

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/vendor/plugins/jquery.placeholder.js":
/*!******************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/vendor/plugins/jquery.placeholder.js ***!
  \******************************************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _jquery = _interopRequireDefault(__webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*! http://mths.be/placeholder v2.0.7 by @mathias */

(function () {
  var $$1 = _jquery.default;
  var isInputSupported = ('placeholder' in document.createElement('input')),
    isTextareaSupported = ('placeholder' in document.createElement('textarea')),
    prototype = $$1.fn,
    valHooks = $$1.valHooks,
    hooks,
    placeholder;
  if (isInputSupported && isTextareaSupported) {
    placeholder = prototype.placeholder = function () {
      return this;
    };
    placeholder.input = placeholder.textarea = true;
  } else {
    placeholder = prototype.placeholder = function () {
      var $this = this;
      $this.filter((isInputSupported ? 'textarea' : ':input') + '[placeholder]').not('.placeholder').bind({
        'focus.placeholder': clearPlaceholder,
        'blur.placeholder': setPlaceholder
      }).data('placeholder-enabled', true).trigger('blur.placeholder');
      return $this;
    };
    placeholder.input = isInputSupported;
    placeholder.textarea = isTextareaSupported;
    hooks = {
      'get': function (element) {
        var $element = $$1(element);
        return $element.data('placeholder-enabled') && $element.hasClass('placeholder') ? '' : element.value;
      },
      'set': function (element, value) {
        var $element = $$1(element);
        if (!$element.data('placeholder-enabled')) {
          return element.value = value;
        }
        if (value == '') {
          element.value = value; // Issue #56: Setting the placeholder causes problems if the element continues to have focus.

          if (element != document.activeElement) {
            // We can't use `triggerHandler` here because of dummy text/password inputs :(
            setPlaceholder.call(element);
          }
        } else if ($element.hasClass('placeholder')) {
          clearPlaceholder.call(element, true, value) || (element.value = value);
        } else {
          element.value = value;
        } // `set` can not return `undefined`; see http://jsapi.info/jquery/1.7.1/val#L2363

        return $element;
      }
    };
    isInputSupported || (valHooks.input = hooks);
    isTextareaSupported || (valHooks.textarea = hooks);
    $$1(function () {
      // Look for forms
      $$1(document).delegate('form', 'submit.placeholder', function () {
        // Clear the placeholder values so they don't get submitted
        var $inputs = $$1('.placeholder', this).each(clearPlaceholder);
        setTimeout(function () {
          $inputs.each(setPlaceholder);
        }, 10);
      });
    }); // Clear placeholder values upon page reload

    $$1(window).bind('beforeunload.placeholder', function () {
      $$1('.placeholder').each(function () {
        this.value = '';
      });
    });
  }
  function args(elem) {
    // Return an object of element attributes
    var newAttrs = {},
      rinlinejQuery = /^jQuery\d+$/;
    $$1.each(elem.attributes, function (i, attr) {
      if (attr.specified && !rinlinejQuery.test(attr.name)) {
        newAttrs[attr.name] = attr.value;
      }
    });
    return newAttrs;
  }
  function clearPlaceholder(event, value) {
    var input = this,
      $input = $$1(input);
    if (input.value == $input.attr('placeholder') && $input.hasClass('placeholder')) {
      if ($input.data('placeholder-password')) {
        $input = $input.hide().next().show().attr('id', $input.removeAttr('id').data('placeholder-id')); // If `clearPlaceholder` was called from `$.valHooks.input.set`

        if (event === true) {
          return $input[0].value = value;
        }
        $input.focus();
      } else {
        input.value = '';
        $input.removeClass('placeholder');
        input == document.activeElement && input.select();
      }
    }
  }
  function setPlaceholder() {
    var $replacement,
      input = this,
      $input = $$1(input),
      id = this.id;
    if (input.value == '') {
      if (input.type == 'password') {
        if (!$input.data('placeholder-textinput')) {
          try {
            $replacement = $input.clone().attr({
              'type': 'text'
            });
          } catch (e) {
            $replacement = $$1('<input>').attr($$1.extend(args(this), {
              'type': 'text'
            }));
          }
          $replacement.removeAttr('name').data({
            'placeholder-password': true,
            'placeholder-id': id
          }).bind('focus.placeholder', clearPlaceholder);
          $input.data({
            'placeholder-textinput': $replacement,
            'placeholder-id': id
          }).before($replacement);
        }
        $input = $input.removeAttr('id').hide().prev().attr('id', id).show(); // Note: `$input[0] != input` now!
      }

      $input.addClass('placeholder');
      $input[0].value = $input.attr('placeholder');
    } else {
      $input.removeClass('placeholder');
    }
  }
})();

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js":
/*!********************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js ***!
  \********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _ListView = _interopRequireDefault(__webpack_require__(/*! ../framework/ListView.js */ "./packages/@okta/courage-dist/esm/src/courage/framework/ListView.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ./BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * See {@link src/framework/ListView} for more detail and examples from the base class.
 * @class module:Okta.ListView
 * @extends src/framework/ListView
 * @mixes module:Okta.View
 */

var Backbone_ListView = _BaseView.default.decorate(_ListView.default);
exports["default"] = Backbone_ListView;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js":
/*!***********************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _backbone = _interopRequireDefault(__webpack_require__(/*! ../vendor/lib/backbone.js */ "./packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _View = _interopRequireDefault(__webpack_require__(/*! ../framework/View.js */ "./packages/@okta/courage-dist/esm/src/courage/framework/View.js"));
var _TemplateUtil = _interopRequireDefault(__webpack_require__(/*! ../util/TemplateUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/TemplateUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const eventBus = _underscoreWrapper.default.clone(_backbone.default.Events); // add `broadcast` and `listen` functionality to all views
// We use one event emitter per all views
// This means we need to be very careful with event names

const proto = {
  constructor: function (options, ...rest) {
    _View.default.call(this, options, ...rest);
    this.module && this.$el.attr('data-view', this.module.id);
  },
  /**
   * @deprecated Use {@link #removeChildren}
   */
  empty: function () {
    return this.removeChildren();
  },
  compileTemplate: _TemplateUtil.default.tpl,
  /**
   *
   * Broadcasts a global event that all views and controllers can subscribe to
   * for framework use only - prefer using a shared model
   *
   * @param {String} eventName A unique identifier for the event
   * @param {...String} param Parameter to pass with the event (can pass more than one parameter)
   * @deprecated For internal use only
   * @private
   */
  broadcast: function () {
    eventBus.trigger.apply(eventBus, arguments);
    return this;
  },
  /**
   * Subscribe to broadcast events
   * for framework use only - prefer using a shared model
   *
   * @param {String} eventName The event identifier to subscribe
   * @param {Function} fn The callback function to invoke
   * @deprecated For internal use only
   * @private
   */
  listen: function (name, fn) {
    eventBus.off(name, fn);
    this.listenTo(eventBus, name, fn);
    return this;
  },
  /**
   * Shows a notification box
   * @param {String} level success / warning / error
   * @param {String} message The message to display
   * @param {Object} [options]
   * @param {Number} [options.width] Set a custom width
   * @param {String} [options.title] Set a custom title
   * @param {Boolean} [options.hide=true] Do we want to auto-hide this notification?
   * @param {Boolean} [options.dismissable] Show a dismiss button
   * @example
   * view.notify('success', 'Group created successfully');
   */
  notify: function (level, message, options) {
    this.broadcast('notification', _underscoreWrapper.default.defaults({
      message: message,
      level: level
    }, options));
    return this;
  },
  /**
   * Shows a confirmation dialog
   *
   * Uses https://www.ericmmartin.com/projects/simplemodal/.
   * If you want to configure the simplemodal options use ConfirmationDialog instead.
   *
   * The main difference between this and the native javascript `confirm` method
   * Is this method is non blocking (note the callback pattern).
   *
   * The callback function will run in the context (`this`) of the invoking view.
   *
   * @param {String} [title] The title of the confirmation dialog
   * @param {String} [message] The message of the confirmation dialog
   * @param {Function} [okfn] The callback to run when the user hits "OK" (runs in the context of the invoking view)
   * @param {Function} [cancelfn] The callback to run when the user hits "Cancel"
   *        (runs in the context of the invoking view)
   * @example
   * view.confirm('Delete Group', 'Are you sure you want to delete the selected group?', function () {
   *   model.destroy();
   * });
   *
   * // title will be auto-set to "Okta"
   * view.confirm('Are you sure you want to delete the selected group?', function () {
   *   model.destroy();
   * });
   *
   * view.confirm({
   *   title: 'Delete Group', //=> Modal title
   *   subtitle: 'Are you sure you want to delete the selected group?', //=> Modal subtitle
   *   content: '<h3 color="red">THIS WILL DELETE THE GROUP!</h3>', //=> A template or a view to add to the modal
   *   save: 'Delete Group', //=> Button label
   *   ok: _.bind(model.save, model) // Callback function on hitting "ok" button
   *   cancel: 'Cancel', //=> Button label
   *   cancelFn: _.bind(model.destroy, model) // Callback function on hitting "cancel" button
   * });
   */
  confirm: function (title, message, okfn, cancelfn) {
    let options;
    /* eslint max-statements: [2, 12] */

    if (typeof title === 'object') {
      options = title;
    } else {
      // eslint-disable-next-line no-lonely-if
      if (arguments.length === 2 && _underscoreWrapper.default.isFunction(message)) {
        options = {
          title: 'Okta',
          // eslint-disable-line @okta/okta/no-unlocalized-text
          subtitle: title,
          ok: message
        };
      } else {
        options = {
          title: title,
          subtitle: message,
          ok: okfn,
          cancelFn: cancelfn
        };
      }
    }
    if (_underscoreWrapper.default.isFunction(options.ok)) {
      options.ok = _underscoreWrapper.default.bind(options.ok, this);
    }
    if (_underscoreWrapper.default.isFunction(options.cancelFn)) {
      options.cancelFn = _underscoreWrapper.default.bind(options.cancelFn, this);
    }
    this.broadcast('confirmation', options);
    return this;
  },
  /**
   * Shows an alert box
   *
   * The main difference between this and the native javascript `alert` method
   * Is this method is non blocking.
   *
   * @param {String} message The message
   * @example
   * view.alert('Mission complete');
   */
  alert: function (params) {
    if (_underscoreWrapper.default.isString(params)) {
      params = {
        subtitle: params
      };
    }
    this.confirm(_underscoreWrapper.default.extend({}, params, {
      noCancelButton: true
    }));
    return this;
  }
};
/**
 * See {@link src/framework/View} for more detail and examples from the base class.
 * @class module:Okta.View
 * @extends src/framework/View
 */

/** @lends module:Okta.View.prototype */

var BaseView = _View.default.extend(proto, /** @lends View.prototype */
{
  /** @method */
  decorate: function (TargetView) {
    const BaseViewView = TargetView.extend({});
    _underscoreWrapper.default.defaults(BaseViewView.prototype, proto);
    return BaseViewView;
  }
});
exports["default"] = BaseView;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/components/BaseButtonLink.js":
/*!****************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/components/BaseButtonLink.js ***!
  \****************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _ViewUtil = _interopRequireDefault(__webpack_require__(/*! ../../util/ViewUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/ViewUtil.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const disabledEvents = {
  click: function (e) {
    e.preventDefault();
    e.stopPropagation();
  }
};
/**
 * A configurable button
 * @class module:Okta.internal.views.components.BaseButtonLink
 * @extends module:Okta.View
 * @example
 * var View = BaseButtonLink.extend({
 *   title: 'Click Me',
 *   icon: 'help-text'
 * })
 */

var BaseButtonLink = _BaseView.default.extend( /** @lends module:Okta.internal.views.components.BaseButtonLink.prototype */
{
  attributes: function () {
    const defaultAttrs = {
      'data-se': 'button'
    };
    const additionalAttr = this.__getAttribute('attrs');
    return _underscoreWrapper.default.extend(defaultAttrs, additionalAttr);
  },
  /**
   * The main text for the button
   * @name title
   * @memberof module:Okta.internal.views.components.BaseButtonLink
   * @type {(String|Function)}
   * @instance
   */

  /**
   * The link for the button
   * @name href
   * @memberof module:Okta.internal.views.components.BaseButtonLink
   * @type {(String|Function)}
   * @instance
   */

  /**
   * CSS class for the icon to display. See [Style guide](http://rain.okta1.com:1802/su/dev/style-guide#icons)
   * @name icon
   * @memberof module:Okta.internal.views.components.BaseButtonLink
   * @type {(String|Function)}
   * @instance
   */

  /**
   * A [Backbone events](http://backbonejs.org/#View-delegateEvents) hash
   * @name events
   * @memberof module:Okta.internal.views.components.BaseButtonLink
   * @type {Object}
   * @instance
   */
  tagName: 'a',
  template: _handlebarsRuntime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<span class=\"icon " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "icon") || (depth0 != null ? lookupProperty(depth0, "icon") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "icon",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 30
          },
          "end": {
            "line": 1,
            "column": 38
          }
        }
      }) : helper)) + "\"></span>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 67
          },
          "end": {
            "line": 1,
            "column": 76
          }
        }
      }) : helper));
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "icon") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 54
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 54
          },
          "end": {
            "line": 1,
            "column": 83
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  /**
   * Make this button visible, default to true.
   * @type {(Boolean|Function)}
   * @default true
   */
  visible: true,
  /**
   * Make this button enabled, default to true.
   * @type {(Boolean|Function)}
   * @default true
   */
  enabled: true,
  /**
   * The setting to determine when the button is enabled, default to {} and
   * enabled takes a higher priority.
   * @type {(Object|Function)}
   * @default {}
   */
  enableWhen: {},
  /**
   * The setting to determine when the button is visible, default to {} and
   * visible takes a higher priority.
   * @type {(Object|Function)}
   * @default {}
   */
  showWhen: {},
  constructor: function (options) {
    this.options = options || {};
    const data = this.getTemplateData();
    this.disabled = false;
    _BaseView.default.apply(this, arguments);
    this.$el.addClass('link-button');
    if (data.icon) {
      this.$el.addClass('link-button-icon');
      if (!data.title) {
        this.$el.addClass('icon-only');
      }
    }
  },
  getTemplateData: function () {
    return {
      href: this.__getAttribute('href'),
      title: this.__getAttribute('title'),
      icon: this.__getAttribute('icon')
    };
  },
  initialize: function () {
    _ViewUtil.default.applyDoWhen(this, _underscoreWrapper.default.resultCtx(this, 'enableWhen', this), this.toggle);
    _ViewUtil.default.applyDoWhen(this, _underscoreWrapper.default.resultCtx(this, 'showWhen', this), this.toggleVisible);
  },
  render: function () {
    _BaseView.default.prototype.render.apply(this, arguments);
    if (!_underscoreWrapper.default.result(this, 'enabled')) {
      this.toggle(false);
    }
    if (!_underscoreWrapper.default.result(this, 'visible')) {
      this.toggleVisible(false);
    }
    const data = this.getTemplateData();
    this.$el.attr('href', data.href || '#');
    return this;
  },
  __getAttribute: function (name, defaultValue) {
    let value = _underscoreWrapper.default.resultCtx(this.options, name, this);
    if (_underscoreWrapper.default.isUndefined(value)) {
      value = _underscoreWrapper.default.result(this, name);
    }
    return !_underscoreWrapper.default.isUndefined(value) ? value : defaultValue;
  },
  enable: function () {
    this.toggle(true);
  },
  disable: function () {
    this.toggle(false);
  },
  show: function () {
    this.toggleVisible(true);
  },
  hide: function () {
    this.toggleVisible(false);
  },
  toggle: function (enable) {
    const bool = !!enable && _underscoreWrapper.default.result(this, 'enabled'); //this is to toggle the enability

    this.disabled = !bool;
    this.$el.toggleClass('link-button-disabled btn-disabled disabled', this.disabled);
    this.delegateEvents(this.disabled ? disabledEvents : null);
  },
  toggleVisible: function (visible) {
    const hidden = !visible || !_underscoreWrapper.default.result(this, 'visible');
    this.$el.toggleClass('hide', hidden);
  }
});
exports["default"] = BaseButtonLink;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/components/BaseDropDown.js":
/*!**************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/components/BaseDropDown.js ***!
  \**************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _jqueryWrapper = _interopRequireDefault(__webpack_require__(/*! ../../util/jquery-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const optionsTemplate = _handlebarsRuntime.default.template({
  "1": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<span class=\"icon " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "icon") || (depth0 != null ? lookupProperty(depth0, "icon") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "icon",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 96
        },
        "end": {
          "line": 1,
          "column": 104
        }
      }
    }) : helper)) + "\"></span>";
  },
  "3": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "title",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 133
        },
        "end": {
          "line": 1,
          "column": 142
        }
      }
    }) : helper));
  },
  "5": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<p class=\"option-subtitle\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "subtitle",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 192
        },
        "end": {
          "line": 1,
          "column": 204
        }
      }
    }) : helper)) + "</p>";
  },
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var stack1,
      helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      alias2 = container.hooks.helperMissing,
      alias3 = "function",
      alias4 = container.escapeExpression,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<a href=\"\" class=\"icon-16 " + alias4((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "className",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 26
        },
        "end": {
          "line": 1,
          "column": 39
        }
      }
    }) : helper)) + "\" data-se=\"" + alias4((helper = (helper = lookupProperty(helpers, "seleniumId") || (depth0 != null ? lookupProperty(depth0, "seleniumId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "seleniumId",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 50
        },
        "end": {
          "line": 1,
          "column": 64
        }
      }
    }) : helper)) + "\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "icon") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(1, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 66
        },
        "end": {
          "line": 1,
          "column": 120
        }
      }
    })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(3, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 120
        },
        "end": {
          "line": 1,
          "column": 149
        }
      }
    })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "subtitle") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(5, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 149
        },
        "end": {
          "line": 1,
          "column": 215
        }
      }
    })) != null ? stack1 : "") + "</a>";
  },
  "useData": true
});
const BaseDropDownDropDownOption = _BaseView.default.extend({
  tagName: 'li',
  events: {
    click: function (e) {
      e.preventDefault();
      this.action && this.action.call(this);
    }
  },
  constructor: function () {
    _BaseView.default.apply(this, arguments);
    this.$el.addClass('okta-dropdown-option option');
  },
  render: function () {
    this.$el.html(optionsTemplate({
      icon: _underscoreWrapper.default.result(this, 'icon'),
      className: _underscoreWrapper.default.result(this, 'className') || '',
      title: _underscoreWrapper.default.result(this, 'title'),
      subtitle: _underscoreWrapper.default.result(this, 'subtitle'),
      seleniumId: _underscoreWrapper.default.result(this, 'seleniumId')
    }));
    if (_underscoreWrapper.default.result(this, 'disabled')) {
      this.disable();
    }
    return this;
  },
  disable: function () {
    this.$el.addClass('option-disabled');
    this.$el.find('a').attr('tabindex', '-1');
  }
});
var BaseDropDown = _BaseView.default.extend({
  events: {
    'click a.option-selected': function (e) {
      e.preventDefault();
      if (_underscoreWrapper.default.result(this, 'disabled')) {
        e.stopPropagation();
      }
    },
    'click .dropdown-disabled': function (e) {
      e.preventDefault();
      e.stopPropagation();
    }
  },
  items: [],
  constructor: function () {
    const className = this.className; // In this very specific case we want to NOT append className to $el
    // but to the <a> tag in the template
    // so we want to disable backbone default functionality.

    this.className = null;
    _BaseView.default.apply(this, arguments);
    this.className = className;
    this.$el.addClass('dropdown more-actions float-l');
    _underscoreWrapper.default.each(_underscoreWrapper.default.result(this, 'items'), function (option) {
      this.addOption(option, this.options);
    }, this);
  },
  template: _handlebarsRuntime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<span class=\"icon " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "icon") || (depth0 != null ? lookupProperty(depth0, "icon") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "icon",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 176
          },
          "end": {
            "line": 1,
            "column": 184
          }
        }
      }) : helper)) + "\"></span>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<span class=\"off-screen\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "screenReaderText") || (depth0 != null ? lookupProperty(depth0, "screenReaderText") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "screenReaderText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 249
          },
          "end": {
            "line": 1,
            "column": 269
          }
        }
      }) : helper)) + "</span>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<a href=\"#\" class=\"link-button " + alias4((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "className",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 31
          },
          "end": {
            "line": 1,
            "column": 44
          }
        }
      }) : helper)) + " link-button-icon option-selected center\" aria-expanded=\"false\" aria-controls=\"okta-dropdown-options\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "icon") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 146
          },
          "end": {
            "line": 1,
            "column": 200
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "screenReaderText") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 200
          },
          "end": {
            "line": 1,
            "column": 283
          }
        }
      })) != null ? stack1 : "") + "<span class=\"option-selected-text\">" + alias4((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 318
          },
          "end": {
            "line": 1,
            "column": 327
          }
        }
      }) : helper)) + "</span><span class=\"icon-dm\"></span></a><div id=\"okta-dropdown-options\" class=\"options clearfix\"><ul class=\"okta-dropdown-list options-wrap clearfix\"></ul></div>";
    },
    "useData": true
  }),
  getTemplateData: function () {
    const className = [_underscoreWrapper.default.result(this, 'className') || '', _underscoreWrapper.default.result(this, 'disabled') ? 'dropdown-disabled' : ''];
    return {
      icon: _underscoreWrapper.default.result(this, 'icon'),
      className: _jqueryWrapper.default.trim(className.join(' ')),
      title: _underscoreWrapper.default.result(this, 'title'),
      screenReaderText: _underscoreWrapper.default.result(this, 'screenReaderText')
    };
  },
  addOption: function (proto, options) {
    this.add(BaseDropDownDropDownOption.extend(proto), 'ul.options-wrap', {
      options: options || {}
    });
  }
});
exports["default"] = BaseDropDown;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/components/Callout.js":
/*!*********************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/components/Callout.js ***!
  \*********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _Time = _interopRequireDefault(__webpack_require__(/*! ../../util/Time.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Time.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function getOption(callout, option) {
  return _underscoreWrapper.default.resultCtx(callout.options, option, callout) || _underscoreWrapper.default.result(callout, option);
}
function getTopClass(callout) {
  let klass = 'infobox clearfix infobox-' + getOption(callout, 'type');
  switch (getOption(callout, 'size')) {
    case 'standard':
      klass += '';
      break;
    case 'slim':
      klass += ' infobox-slim';
      break;
    case 'compact':
      klass += ' infobox-compact';
      break;
    case 'large':
      klass += ' infobox-md';
      break;
  }
  if (getOption(callout, 'dismissible')) {
    klass += ' infobox-dismiss';
  }
  return klass;
}
const events = {
  'click .infobox-dismiss-link': function (e) {
    e.preventDefault();
    this.$el.fadeOut(_Time.default.UNLOADING_FADE, () => {
      this.trigger('dismissed');
      this.remove();
    });
  }
};
const template = _handlebarsRuntime.default.template({
  "1": function (container, depth0, helpers, partials, data) {
    var lookupProperty = container.lookupProperty || function (parent, propertyName) {
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return parent[propertyName];
      }
      return undefined;
    };
    return "<a data-se=\"dismiss-link\" class=\"infobox-dismiss-link\" title=\"" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "i18n",
      "hash": {
        "bundle": "courage",
        "code": "component.dismiss"
      },
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 81
        },
        "end": {
          "line": 1,
          "column": 131
        }
      }
    })) + "\" href=\"#\"><span data-se=\"icon\" class=\"dismiss-icon\"></span></a>";
  },
  "3": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<h3 data-se=\"header\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "title",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 286
        },
        "end": {
          "line": 1,
          "column": 295
        }
      }
    }) : helper)) + "</h3>";
  },
  "5": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<p data-se=\"sub-header\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "subtitle",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 347
        },
        "end": {
          "line": 1,
          "column": 359
        }
      }
    }) : helper)) + "</p>";
  },
  "7": function (container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<ul data-se=\"list\" class=\"bullets\">" + ((stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "bullets") : depth0, {
      "name": "each",
      "hash": {},
      "fn": container.program(8, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 420
        },
        "end": {
          "line": 1,
          "column": 483
        }
      }
    })) != null ? stack1 : "") + "</ul>";
  },
  "8": function (container, depth0, helpers, partials, data) {
    return "<li data-se=\"list-item\">" + container.escapeExpression(container.lambda(depth0, depth0)) + "</li>";
  },
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var stack1,
      helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "dismissible") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(1, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 0
        },
        "end": {
          "line": 1,
          "column": 202
        }
      }
    })) != null ? stack1 : "") + "<span data-se=\"icon\" class=\"icon " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "icon") || (depth0 != null ? lookupProperty(depth0, "icon") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
      "name": "icon",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 235
        },
        "end": {
          "line": 1,
          "column": 243
        }
      }
    }) : helper)) + "\"></span>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(3, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 252
        },
        "end": {
          "line": 1,
          "column": 307
        }
      }
    })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "subtitle") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(5, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 307
        },
        "end": {
          "line": 1,
          "column": 370
        }
      }
    })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "bullets") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(7, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 370
        },
        "end": {
          "line": 1,
          "column": 495
        }
      }
    })) != null ? stack1 : "");
  },
  "useData": true
});
const CalloutCallout = _BaseView.default.extend( /** @lends src/views/components/Callout.prototype */
{
  attributes: {
    'data-se': 'callout'
  },
  /**
   * Custom HTML or view to inject to the callout
   * @type {String|Okta.View}
   */
  content: null,
  /**
   * Size of icon. options are standard, large, compact
   * @type {String}
   */
  size: 'standard',
  /**
   * Type of the callout. Valid values are: info, success, warning, error, tip
   * @type {String}
   */
  type: 'info',
  /**
   * Can the callout be dismissed
   * @type {Boolean}
   */
  dismissible: false,
  /**
   * Callout title
   * @type {String}
   */
  title: null,
  /**
   * Callout subtitle
   * @type {String}
   */
  subtitle: null,
  /**
   * Array of strings to render as bullet points
   * @type {Array}
   */
  bullets: null,
  /**
   * Fired after the callout is dismised - applies when
   * {@link module:Okta.internal.views.components.Callout|dismissible} is set to true
   * @event src/views/components/Callout#dismissed
   */
  constructor: function () {
    this.events = _underscoreWrapper.default.defaults(this.events || {}, events);
    _BaseView.default.apply(this, arguments);
    this.$el.addClass(getTopClass(this));
    this.template = template;
    const content = getOption(this, 'content');
    if (content) {
      this.add(content);
    }
  },
  getTemplateData: function () {
    let icon = getOption(this, 'type');
    const size = getOption(this, 'size');
    if (icon === 'tip') {
      // css is inconsistent
      icon = 'light-bulb';
    }
    switch (size) {
      case 'slim':
        icon = '';
        break;
      case 'large':
        icon = [icon, '-', '24'].join('');
        break;
      default:
        icon = [icon, '-', '16'].join('');
    }
    return {
      icon: icon,
      title: getOption(this, 'title'),
      subtitle: getOption(this, 'subtitle'),
      bullets: getOption(this, 'bullets'),
      dismissible: getOption(this, 'dismissible')
    };
  }
});
/**
 * @class src/views/components/Callout
 * @extends module:Okta.View
 */

/**
 * @class module:Okta.internal.views.components.Callout
 */

var Callout = /** @lends module:Okta.internal.views.components.Callout */
{
  /**
   * Creates a {@link src/views/components/Callout|Callout}.
   * @static
   * @param {Object} options
   * @param {String|Function} [options.size] Size of icon. options are standard, large, compact, slim
   * @param {String|Okta.View} [options.content] Custom HTML or view to inject to the callout
   * @param {String|Function} [options.title] Callout title
   * @param {String|Function} [options.subtitle] Callout subtitle
   * @param {Array|Function} [options.bullets] Array of strings to render as bullet points
   * @param {Boolean|Function} [options.dismissible] Can the callout be dismissed
   * @param {String|Function} [options.type] Callout type. Valid values are: info, success, warning, error, tip
   *
   * @return {src/views/components/Callout}
   */
  create: function (options) {
    return new CalloutCallout(options);
  }
};
exports["default"] = Callout;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/components/Notification.js":
/*!**************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/components/Notification.js ***!
  \**************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
var _StringUtil = _interopRequireDefault(__webpack_require__(/*! ../../util/StringUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/StringUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const defaults = {
  level: 'success',
  hide: true,
  fade: 400,
  delay: 3000,
  width: 0,
  dismissable: false
};
var Notification = _BaseView.default.extend({
  className: 'infobox infobox-confirm infobox-confirm-fixed',
  events: {
    'click .infobox-dismiss-link': function (e) {
      e.preventDefault();
      this.fadeOut();
    }
  },
  template: _handlebarsRuntime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<a class=\"infobox-dismiss-link\" title=\"" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "courage",
          "code": "component.dismiss"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 108
          }
        }
      })) + "\" href=\"#\"><span class=\"dismiss-icon\"></span></a>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<h3>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 220
          },
          "end": {
            "line": 1,
            "column": 229
          }
        }
      }) : helper)) + "</h3>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "dismissable") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 164
          }
        }
      })) != null ? stack1 : "") + "<span class=\"icon " + alias4((helper = (helper = lookupProperty(helpers, "level") || (depth0 != null ? lookupProperty(depth0, "level") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "level",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 182
          },
          "end": {
            "line": 1,
            "column": 191
          }
        }
      }) : helper)) + "-16\"></span>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 203
          },
          "end": {
            "line": 1,
            "column": 241
          }
        }
      })) != null ? stack1 : "") + "<p>" + alias4((helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "message",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 244
          },
          "end": {
            "line": 1,
            "column": 255
          }
        }
      }) : helper)) + "</p>";
    },
    "useData": true
  }),
  initialize: function () {
    this.options = _underscoreWrapper.default.defaults({}, this.options, defaults);
    if (!this.options.message) {
      switch (this.options.level) {
        case 'success':
          this.options.message = _StringUtil.default.localize('notification.default.message.success', 'courage');
          break;
        case 'error':
          this.options.message = _StringUtil.default.localize('notification.default.message.error', 'courage');
          break;
        case 'warning':
          this.options.message = _StringUtil.default.localize('notification.default.message.warning', 'courage');
          break;
      }
    }
    this.$el.addClass('infobox-' + this.options.level);
    if (this.options.width) {
      this.$el.width(this.options.width);
    }
  },
  getTemplateData: function () {
    return _underscoreWrapper.default.extend(_underscoreWrapper.default.pick(this.options, 'level', 'message', 'title'), {
      dismissable: this.options.hide === false || this.options.dismissable === true
    });
  },
  postRender: function () {
    if (this.options.hide) {
      _underscoreWrapper.default.delay(_underscoreWrapper.default.bind(this.fadeOut, this), this.options.delay);
    }
  },
  fadeOut: function () {
    this.$el.fadeOut(this.options.fade, _underscoreWrapper.default.bind(this.remove, this));
  }
});
exports["default"] = Notification;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/BaseForm.js":
/*!*****************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/BaseForm.js ***!
  \*****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _jqueryWrapper = _interopRequireDefault(__webpack_require__(/*! ../../util/jquery-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _StringUtil = _interopRequireDefault(__webpack_require__(/*! ../../util/StringUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/StringUtil.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
var _ReadModeBar = _interopRequireDefault(__webpack_require__(/*! ./components/ReadModeBar.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/components/ReadModeBar.js"));
var _Toolbar = _interopRequireDefault(__webpack_require__(/*! ./components/Toolbar.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/components/Toolbar.js"));
var _ErrorBanner = _interopRequireDefault(__webpack_require__(/*! ./helpers/ErrorBanner.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/ErrorBanner.js"));
var _ErrorParser = _interopRequireDefault(__webpack_require__(/*! ./helpers/ErrorParser.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/ErrorParser.js"));
var _FormUtil = _interopRequireDefault(__webpack_require__(/*! ./helpers/FormUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/FormUtil.js"));
var _InputContainer = _interopRequireDefault(__webpack_require__(/*! ./helpers/InputContainer.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/InputContainer.js"));
var _InputFactory = _interopRequireDefault(__webpack_require__(/*! ./helpers/InputFactory.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/InputFactory.js"));
var _InputLabel = _interopRequireDefault(__webpack_require__(/*! ./helpers/InputLabel.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/InputLabel.js"));
var _InputWrapper = _interopRequireDefault(__webpack_require__(/*! ./helpers/InputWrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/InputWrapper.js"));
var _SettingsModel = _interopRequireDefault(__webpack_require__(/*! ../../util/SettingsModel.js */ "./packages/@okta/courage-dist/esm/src/courage/util/SettingsModel.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const template = _handlebarsRuntime.default.template({
  "1": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<h2 class=\"o-form-title-bar\" data-se=\"o-form-title-bar\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "title",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 75
        },
        "end": {
          "line": 1,
          "column": 84
        }
      }
    }) : helper)) + "</h2>";
  },
  "3": function (container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(4, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 192
        },
        "end": {
          "line": 1,
          "column": 288
        }
      }
    })) != null ? stack1 : "";
  },
  "4": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<h2 data-se=\"o-form-head\" class=\"okta-form-title o-form-head\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "title",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 267
        },
        "end": {
          "line": 1,
          "column": 276
        }
      }
    }) : helper)) + "</h2>";
  },
  "6": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<p class=\"okta-form-subtitle o-form-explain\" data-se=\"o-form-explain\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "subtitle",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 385
        },
        "end": {
          "line": 1,
          "column": 397
        }
      }
    }) : helper)) + "</p>";
  },
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var stack1,
      helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "hasReadMode") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(1, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 0
        },
        "end": {
          "line": 1,
          "column": 96
        }
      }
    })) != null ? stack1 : "") + "<div data-se=\"o-form-content\" class=\"o-form-content " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "layout") || (depth0 != null ? lookupProperty(depth0, "layout") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
      "name": "layout",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 148
        },
        "end": {
          "line": 1,
          "column": 158
        }
      }
    }) : helper)) + " clearfix\">" + ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "hasReadMode") : depth0, {
      "name": "unless",
      "hash": {},
      "fn": container.program(3, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 169
        },
        "end": {
          "line": 1,
          "column": 299
        }
      }
    })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "subtitle") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(6, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 299
        },
        "end": {
          "line": 1,
          "column": 408
        }
      }
    })) != null ? stack1 : "") + "<div class=\"o-form-error-container\" data-se=\"o-form-error-container\"></div><div class=\"o-form-fieldset-container\" data-se=\"o-form-fieldset-container\"></div></div>";
  },
  "useData": true
});
const sectionTitleTemplate = _handlebarsRuntime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<h2 class=\"o-form-head\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "title",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 24
        },
        "end": {
          "line": 1,
          "column": 33
        }
      }
    }) : helper)) + "</h2>";
  },
  "useData": true
});
const pointerEventsSupported = (0, _jqueryWrapper.default)('<div>').css({
  'pointer-events': 'auto'
})[0].style.pointerEvents === 'auto'; // polyfill for `pointer-events: none;` in IE < 11
// Logic borrowed from https://github.com/kmewhort/pointer_events_polyfill (BSD)

function pointerEventsPolyfill(e) {
  if (!pointerEventsSupported && this.$el.hasClass('o-form-saving')) {
    const $el = (0, _jqueryWrapper.default)(e.currentTarget);
    $el.css('display', 'none');
    const underneathElem = document.elementFromPoint(e.clientX, e.clientY);
    $el.css('display', 'block');
    e.target = underneathElem;
    (0, _jqueryWrapper.default)(underneathElem).trigger(e);
    return false;
  }
}
const events = {
  submit: function (e) {
    e.preventDefault();
    this.__save();
  }
};
_underscoreWrapper.default.each(['click', 'dblclick', 'mousedown', 'mouseup'], function (event) {
  events[event + ' .o-form-input'] = pointerEventsPolyfill;
});
const attributes = function (model) {
  model || (model = {});
  const collection = model && model.collection || {};
  return {
    method: 'POST',
    action: _underscoreWrapper.default.result(model, 'urlRoot') || _underscoreWrapper.default.result(collection, 'url') || window.location.pathname,
    'data-se': 'o-form',
    slot: 'content'
  };
};
const convertSavingState = function (rawSavingStateEvent, defaultEvent) {
  rawSavingStateEvent || (rawSavingStateEvent = '');
  let savingStateEvent = [];
  if (_underscoreWrapper.default.isString(rawSavingStateEvent)) {
    savingStateEvent = rawSavingStateEvent.split(' ');
  }
  savingStateEvent = _underscoreWrapper.default.union(savingStateEvent, defaultEvent);
  return savingStateEvent.join(' ');
};
const getErrorSummary = function (responseJSON = {}) {
  if (Array.isArray(responseJSON.errorCauses) && responseJSON.errorCauses.length > 0) {
    //set errorSummary from first errorCause which is not field specific error
    return responseJSON.errorCauses[0].errorSummary;
  } else {
    //set errorSummary from top level errorSummary
    return responseJSON.errorSummary;
  }
};
/**
 * A Form utility framework
 *
 * Okta.Form is a form that operates on one flat model
 * It exposes one main factory method, {@link module:Okta.Form#addInput|addInput}, which add inputs to the form,
 * and each input operates on one field in the model, identified by the `name` field.
 *
 * See:
 * [Basic O-Form Tutorial](https://github.com/okta/courage/wiki/Basic-O-Form)
 *
 * @class module:Okta.Form
 * @extends module:Okta.View
 * @param {Object} options options hash (See {@link module:Okta.View|View})
 * @param {Object} options.model the model this form operates on
 * @param {Boolean} [options.label-top=false] position label on top of inputs
 * @param {Boolean} [options.wide=false] Use a wide input layout for all input
 */

/**
 * Fired when the "Save" button is clicked
 * @event module:Okta.Form#save
 * @param {module:Okta.Model} model Model used in the form
 */

/**
 * Fired after the model is successfully saved - applies when {@link module:Okta.Form#autoSave|autoSave}
 * is set to true
 * @event module:Okta.Form#saved
 * @param {module:Okta.Model} model Model used in the form
 */

/**
 * Fired when the model fires an invalid event or an error event;
 * @event module:Okta.Form#error
 * @param {module:Okta.Model} model Model used in the form
 */

/**
 * Fired when the form layout is likely to be resized
 * @event module:Okta.Form#resize
 * @param {module:Okta.Model} model Model used in the form
 */

/**
 * Fired when the "Cancel" button is clicked
 * @event module:Okta.Form#cancel
 */

var BaseForm = _BaseView.default.extend( /** @lends module:Okta.Form.prototype */
{
  /**
   * Specifies how to validate form:
   * - In case "local" string provided as a value of the property,
   * the form will validate only fields added as inputs to the form;
   * - In case array is provided, the validation will be performed only for fields specified in array;
   * - In case function is provided, provided function will be used as a validation function,
   * it must return an error object with the format {fieldName: 'error text'} with as many fields as you need.
   * @name validate
   * @memberof module:Okta.Form
   * @type {String|Array|Function}
   * @instance
   */
  constructor: function (options) {
    /* eslint max-statements: 0, complexity: 0 */
    options || (options = {});
    this.options = options;
    if (options.settings) {
      this.settings = options.settings;
    } else {
      this.settings = options.settings = new _SettingsModel.default();
    }
    this.id = _underscoreWrapper.default.uniqueId('form');
    this.tagName = 'form';
    _underscoreWrapper.default.defaults(this.events, events);
    _underscoreWrapper.default.defaults(this.attributes, attributes(options.model));
    this.__buttons = [];
    this.__errorFields = {};
    this.__saveModelState(options.model);
    const step = _underscoreWrapper.default.result(this, 'step');
    if (step) {
      // checking exists of `this.save` hence don't have to change to
      // `_.result(this, 'save')` which will execute the function and
      // is not the intent.
      if (!this.save) {
        const totalStep = _underscoreWrapper.default.result(this, 'totalSteps');
        this.save = !totalStep || step === totalStep ? _StringUtil.default.localize('oform.button.finish', 'courage') : _StringUtil.default.localize('oform.button.next', 'courage');
      }
      this.className = _underscoreWrapper.default.result(this, 'className') + ' wizard';
    }
    this.className = _underscoreWrapper.default.result(this, 'className') + ' o-form';
    this.__toolbar = this.__createToolbar(options);
    _BaseView.default.call(this, options);
    _underscoreWrapper.default.each(_underscoreWrapper.default.result(this, 'inputs') || [], function (input) {
      // to ingore extra argumests from `each` iteratee function
      // http://underscorejs.org/#each
      this.__addLayoutItem(input);
    }, this);
    this.add(this.__toolbar, ''); // NOTES: this.model shall be initialized after calling
    // super (BaseView.call(this, options)) above.
    //

    this.listenTo(this.model, 'change:__edit__', this.__applyMode);
    this.listenTo(this.model, 'invalid error', _underscoreWrapper.default.throttle(function (model, resp, showBanner) {
      this.__showErrors(model, resp, showBanner !== false);
    }, 100, {
      trailing: false
    }));
    this.listenTo(this.model, 'form:resize', function () {
      this.trigger('resize');
    });
    this.listenTo(this.model, 'form:cancel', _underscoreWrapper.default.throttle(this.__cancel, 100, {
      trailing: false
    }));
    this.listenTo(this.model, 'form:previous', _underscoreWrapper.default.throttle(this.__previous, 100, {
      trailing: false
    }));
    this.__save = _underscoreWrapper.default.throttle(this.__save, 200, {
      trailing: false
    });
    this.listenTo(this.model, 'form:save', function () {
      this.$el.submit();
    });
    this.listenTo(this.model, 'sync', function () {
      if (this.model.get('__edit__')) {
        this.model.set('__edit__', false, {
          silent: true
        });
      }
      this.__saveModelState(this.model);
      this.render();
    });
    let hasSavingState = this.getAttribute('hasSavingState');
    if (this.getAttribute('autoSave')) {
      this.listenTo(this, 'save', function (model) {
        const xhr = model.save();
        if (xhr && xhr.done) {
          xhr.done(() => {
            this.trigger('saved', model);
          });
        }
      });
      if (_underscoreWrapper.default.isUndefined(hasSavingState)) {
        hasSavingState = true;
      }
    }
    /*
    * Attach model event listeners
    * by default, model's request event starts the form saving state,
    * error and sync event stops it
    * you can define customized saving start and stop state, like
    * customSavingState: {start: 'requestingAdditionalInfo', stop: 'retrievedAdditionalInfo'}
    * doing this does not override the default events
    */

    if (hasSavingState) {
      const customSavingState = this.getAttribute('customSavingState', {});
      this.listenTo(this.model, convertSavingState(customSavingState.start || '', ['request']), this.__setSavingState);
      this.listenTo(this.model, convertSavingState(customSavingState.stop || '', ['error', 'sync']), this.__clearSavingState);
    }
  },
  /**
   * Create the bottom button bar
   * @param  {Object} options options h
   * @return {Okta.View} The toolbar
   * @private
   */
  __createToolbar: function (options) {
    const danger = this.getAttribute('danger');
    const saveBtnClassName = danger === true ? 'button-error' : 'button-primary';
    const step = _underscoreWrapper.default.result(this, 'step');
    const toolbar = new _Toolbar.default(_underscoreWrapper.default.extend({
      save: this.save || _StringUtil.default.localize('oform.save', 'courage'),
      saveId: this.saveId,
      saveClassName: saveBtnClassName,
      cancel: this.cancel || _StringUtil.default.localize('oform.cancel', 'courage'),
      noCancelButton: this.noCancelButton || false,
      noSubmitButton: this.noSubmitButton || false,
      buttonOrder: this.buttonOrder,
      hasPrevStep: step && step > 1
    }, options || this.options));
    _underscoreWrapper.default.each(this.__buttons, function (args) {
      toolbar.addButton.apply(toolbar, args);
    });
    return toolbar;
  },
  className: '',
  attributes: {},
  events: {},
  /**
   * An array of input configurations to render in the form
   * @type {Array}
   */
  inputs: [],
  template: null,
  /**
   * Does the form support read/edit toggle.
   * @type {Boolean|Function}
   * @default false
   */
  read: false,
  /**
   * Is the form in readOnly mode.
   * @type {Boolean|Function}
   * @default false
   */
  readOnly: false,
  /**
   * Should we not render the button bar
   * @type {Boolean|Function}
   * @default false
   */
  noButtonBar: false,
  /**
   * Should we not render a cancel button
   * @type {Boolean|Function}
   * @default false
   */
  noCancelButton: false,
  /**
   * Should we not render a save button
   * @type {Boolean}
   * @default false
   */
  noSubmitButton: false,
  /**
   * Set the order of the save, cancel and previous buttons (left to right).
   * @type {Array.<string>}
   * @default ['previous', 'save', 'cancel']
   */
  buttonOrder: ['previous', 'save', 'cancel'],
  /**
   * The text on the save button
   * @type {String}
   * @default "Save"
   */
  save: null,
  /**
   * The text on the cancel button
   * @type {String}
   * @default "Cancel"
   */
  cancel: null,
  /**
   * To use button-error to style the submit button instead of button-primary.
   * @type {Boolean|Function}
   * @default false
   */
  danger: false,
  /**
   * A layout CSS class to add to the form
   * @type {String|Function}
   * @default ""
   */
  layout: '',
  /**
   * The step this form is in the context of a wizard
   * @type {Number}
   */
  step: undefined,
  /**
   * The total numbers of steps the wizard this form is a part of has
   * @type {Number}
   */
  totalSteps: undefined,
  /**
   * The form's title
   * @type {String|Function}
   */
  title: null,
  /**
   * The form's subtitle
   * @type {String|Function}
   */
  subtitle: null,
  /**
   * Auto-save the model when hitting save. Triggers a `saved` event when done
   * @type {Boolean}
   * @default false
   */
  autoSave: false,
  /**
   * Scroll to the top of the form on error
   * @type {Boolean|Function}
   * @default true
   */
  scrollOnError: true,
  /**
   * Show the error banner upon error
   * @type {Boolean|Function}
   * @default true
   */
  showErrors: true,
  /**
   * The form's scrollable area
   * @type {String}
   * @default ".o-form-content"
   */
  resizeSelector: '.o-form-content',
  /**
   * Sets whether or not the form shows the saving state when
   * the model is saved.  Has no effect on setSavingState and clearSavingState as those are manual calls
   * to trigger/clear the saving state.
   * @name hasSavingState
   * @memberof module:Okta.Form
   * @type {Boolean}
   * @default false
   * @instance
   */

  /**
   * Get an attribute value from options or instance.
   * Prefer options value over instance value
   * @param  {String} name Name of the attribute
   * @param  {Object} defaultValue the default value to return if the attribute is not found
   * @return {Object} The value
   */
  getAttribute: function (name, defaultValue) {
    let value = _underscoreWrapper.default.resultCtx(this.options, name, this);
    if (_underscoreWrapper.default.isUndefined(value)) {
      value = _underscoreWrapper.default.result(this, name);
    }
    return !_underscoreWrapper.default.isUndefined(value) ? value : defaultValue;
  },
  /**
   * Does this form have a "read" mode
   * @return {Boolean}
   */
  hasReadMode: function () {
    return !!this.getAttribute('read');
  },
  /**
   * Is this form in "read only" mode
   * @return {Boolean}
   */
  isReadOnly: function () {
    return !!this.getAttribute('readOnly');
  },
  /**
   * Does this form have a button bar
   * @return {Boolean}
   */
  hasButtonBar: function () {
    return !(this.getAttribute('noButtonBar') || this.isReadOnly());
  },
  render: function () {
    this.__readModeBar && this.__readModeBar.remove();
    if (this.hasReadMode() && !this.isReadOnly()) {
      const readModeBar = _ReadModeBar.default.extend({
        formTitle: this.getAttribute('title', '')
      });
      this.__readModeBar = this.add(readModeBar, '.o-form-title-bar').last();
    }
    const html = template({
      layout: this.getAttribute('layout', ''),
      title: this.getAttribute('title', '', true),
      subtitle: this.getAttribute('subtitle', '', true),
      hasReadMode: this.hasReadMode()
    });
    this.$el.html(html);
    delete this.template;
    _BaseView.default.prototype.render.apply(this, arguments);
    this.__applyMode();
    return this;
  },
  /**
   * Changes form UI to indicate saving.  Disables all inputs and buttons.  Use this function if you have set
   * hasSavingState to false on the the form
   * @private
   */
  __setSavingState: function () {
    this.model.trigger('form:set-saving-state');
    this.$el.addClass('o-form-saving');
  },
  /**
   * Changes form UI back to normal from the saving state.  Use this function if you are have set hasSavingState
   * to false on the form
   * @private
   */
  __clearSavingState: function () {
    this.model.trigger('form:clear-saving-state');
    this.$el.removeClass('o-form-saving');
  },
  /**
   * Toggles the visibility of the bottom button bar
   * @private
   */
  __toggleToolbar: function () {
    this.__toolbar && this.__toolbar.remove();
    if (this.hasButtonBar() && this._editMode()) {
      this.__toolbar = this.__createToolbar();
      this.add(this.__toolbar, '');
    }
    this.trigger('resize');
  },
  /**
   * Cancels this form
   * - Reset the model to the previous state
   * - Clears all errors
   * - Triggers a `cancel` event
   * - Sets the model to read mode (if applicable)
   * @private
   * @fires cancel
   */
  __cancel: function () {
    const edit = this.model.get('__edit__');
    /* eslint max-statements: [2, 12] */

    this.model.clear({
      silent: true
    });
    let data;
    if (this.model.sanitizeAttributes) {
      data = this.model.sanitizeAttributes(this.__originalModel);
    } else {
      data = _underscoreWrapper.default.clone(this.__originalModel);
    }
    this.model.set(data, {
      silent: true
    });
    this.trigger('cancel', this.model);
    this.model.trigger('cache:clear');
    if (edit) {
      this.model.set('__edit__', false, {
        silent: true
      });
      this.model.trigger('change:__edit__', this.model, false);
    }
    this.clearErrors();
  },
  /**
   * Runs {@link module:Okta.Form#validate|validate} to check the model state.
   * Triggers an "invalid" event on the model if validation fails
   * @returns {Boolean}
   */
  isValid: function () {
    let res;
    const self = this;
    function validateArray(arr) {
      return _underscoreWrapper.default.reduce(arr, function (memo, fieldName) {
        return _underscoreWrapper.default.extend(memo, self.model.validateField(fieldName));
      }, {});
    }
    if (_underscoreWrapper.default.isUndefined(this.validate)) {
      return this.model.isValid();
    } else if (_underscoreWrapper.default.isFunction(this.validate)) {
      res = this.validate();
    } else if (_underscoreWrapper.default.isArray(this.validate)) {
      res = validateArray(this.validate);
    } else if (this.validate === 'local') {
      res = validateArray(this.getInputs().map(function (input) {
        return input.options.name;
      }));
    }
    if (!_underscoreWrapper.default.isEmpty(res)) {
      this.model.trigger('invalid', this.model, res);
      return false;
    } else {
      return true;
    }
  },
  /**
   * A throttled function that saves the form not more than once every 100 ms
   * Basically all this method does is trigger a `save` event
   * @fires save
   * @private
   */
  __save: function () {
    this.clearErrors();
    if (this.isValid()) {
      this.trigger('save', this.model);
    }
  },
  /**
   * In the context of a wizard, go to previous state
   * Technically all this method does is trigger a `previous` event
   * @param  {Event} e
   * @private
   */
  __previous: function () {
    this.trigger('previous', this.model);
  },
  /**
   * Renders the form in the correct mode based on the model.
   * @private
   */
  __applyMode: function () {
    this.clearErrors();
    this.__toggleToolbar();
    if (this._editMode()) {
      this.$el.addClass('o-form-edit-mode');
      this.$el.removeClass('o-form-read-mode');
      this.$('.o-form-content').removeClass('rounded-btm-4');
      this.focus();
    } else {
      this.$el.removeClass('o-form-edit-mode');
      this.$el.addClass('o-form-read-mode');
      this.$('.o-form-content').addClass('rounded-btm-4');
    }
  },
  /**
   * Is the form in edit mode
   * @return {Boolean}
   * @private
   */
  _editMode: function () {
    return this.model.get('__edit__') || !this.hasReadMode();
  },
  /**
   * Function can be overridden to alter top level error summary.
   * @param {Object} responseJSON
   *
   * @example
   * // responseJSON object
   * {
   *  errorCauses: [{errorSummary: "At least one of Proxy Status, Location, or ASN should be configured."}]
   *  errorSummary: "At least one of Proxy Status, Location, or ASN should be configured."
   *  errorCode: "E0000001"
   *  errorId: "oaepsrTCHrhT-eIi8XTm6KWWg"
   *  errorLink: "E0000001"
   *  errorSummary: "Api validation failed: networkZone"
   * }
   *
   * @method
   * @default _.identity
   */
  parseErrorMessage: _underscoreWrapper.default.identity,
  _handleErrorScroll: function () {
    if (!this.getAttribute('scrollOnError')) {
      return;
    }
    const $el = (0, _jqueryWrapper.default)('#' + this.id + ' .o-form-error-container');
    if ($el.length) {
      let $scrollContext = $el.scrollParent();
      let scrollTop; // scrollParent was almost awesome...
      // but it returns document if there are no other scrollable parents
      // document does not have offset, so here we have to replace with html, body
      // Additionally when the scroll context is html, body, $el.offset().top is fixed
      // versus when it has a different scroll context it's dynamic and requires the
      // calculation below.

      if ($scrollContext[0] === document) {
        $scrollContext = (0, _jqueryWrapper.default)('html, body');
        scrollTop = $el.offset().top;
      } else {
        scrollTop = $scrollContext.scrollTop() + $el.offset().top - $scrollContext.offset().top;
      }
      $scrollContext.animate({
        scrollTop: scrollTop
      }, 400);
    }
  },
  /**
   * Show an error message based on an XHR error
   * @param  {Okta.BaseModel} model the model
   * @param  {jqXHR} xhr The jQuery XmlHttpRequest Object
   * @private
   */
  __showErrors: function (model, resp, showBanner) {
    this.trigger('error', model);
    /* eslint max-statements: 0 */

    if (!this.getAttribute('showErrors')) {
      return;
    }
    let errorSummary;
    let responseJSON = _ErrorParser.default.getResponseJSON(resp);
    const validationErrors = _ErrorParser.default.parseFieldErrors(resp); // trigger events for field validation errors

    if (_underscoreWrapper.default.size(validationErrors)) {
      _underscoreWrapper.default.each(validationErrors, function (errors, field) {
        this.model.trigger('form:field-error', this.__errorFields[field] || field, _underscoreWrapper.default.map(errors, function (error) {
          return /^model\.validation/.test(error) ? _StringUtil.default.localize(error, 'courage') : error;
        }));
      }, this);
    } else {
      responseJSON = this.parseErrorMessage(responseJSON);
      errorSummary = getErrorSummary(responseJSON);
    } // show the error message

    if (showBanner) {
      this.$('.o-form-error-container').addClass('o-form-has-errors');
      this.add(_ErrorBanner.default, '.o-form-error-container', {
        options: {
          errorSummary: errorSummary
        }
      });
    } // slide to and focus on the error message

    this._handleErrorScroll();
    this.model.trigger('form:resize');
  },
  /**
   * Clears the error banner
   * @private
   */
  clearErrors: function () {
    this.$('.o-form-error-container').removeClass('o-form-has-errors');
    this.model.trigger('form:clear-errors');
    this.model.trigger('form:resize');
  },
  /**
   * Toggles between edit and read mode
   */
  toggle: function () {
    this.model.set('__edit__', !this.hasReadMode() || !this.model.get('__edit__'));
    return this;
  },
  __addLayoutItem: function (input) {
    if (_InputFactory.default.supports(input)) {
      this.addInput(input);
    } else {
      this.__addNonInputLayoutItem(input);
    }
  },
  __addNonInputLayoutItem: function (item) {
    const itemOptions = _underscoreWrapper.default.omit(item, 'type');
    switch (item.type) {
      case 'sectionTitle':
        this.addSectionTitle(item.title, _underscoreWrapper.default.omit(itemOptions, 'title'));
        break;
      case 'divider':
        this.addDivider(itemOptions);
        break;
      default:
        throw new Error('unknown input: ' + item.type);
    }
  },
  /**
   * Adds a view to the buttons tool bar
   * @param {Object} params parameterized button options
   * @param {Object} options options to send to {@link module:Okta.View#add|View.add}
   */
  addButton: function (params, options) {
    this.__toolbar && this.__toolbar.addButton(params, options);
    this.__buttons.push([params, options]);
  },
  /**
   * Adds a divider
   */
  addDivider: function (options) {
    this.add('<div class="okta-form-divider form-divider"></div>');
    _FormUtil.default.applyShowWhen(this.last(), options && options.showWhen);
    _FormUtil.default.applyToggleWhen(this.last(), options && options.toggleWhen);
    return this;
  },
  /**
   * Adds section header
   * @param {String} title
   */
  addSectionTitle: function (title, options) {
    this.add(sectionTitleTemplate({
      title: title
    }));
    _FormUtil.default.applyShowWhen(this.last(), options && options.showWhen);
    _FormUtil.default.applyToggleWhen(this.last(), options && options.toggleWhen);
    return this;
  },
  /**
   * Add a form input
   * @param {Object} options Options to describe the input
   * @param {String} options.type The input type.
   * The options are: `text`, `textarea`, `select`, `checkbox`, `radio`, `switch`,
   * `password`, `number`, `textselect`, `date`, `grouppicker`, `admingrouppicker`, `su-orgspicker`
   * `file/image`, `file/cert`, `checkboxset`, `list`, `group`, `zonepicker`
   * @param {String} options.name The name of the model field this input mutates
   * @param {String|Function} [options.label]
   * The input label text.
   * When passed as a function, will invoke the function (in the context of the {@link InputLabel})
   * on render time, and use the returned value.
   * @param {String} [options.sublabel] The input sub label text
   * @param {String} [options.tooltip] A popover tooltip to be displayed next to the label
   * @param {String} [options.placeholder] Placeholder text.
   * @param {String} [options.explain] Explanation text to render below the input
   * @param {Okta.View} [options.customExplain] A custom view to render below the input (deprecated)
   * @param {Boolean} [options.disabled=false] Make this input disabled
   * @param {Boolean} [options.wide=false] Use a wide input layout
   * @param {Boolean} [options.label-top=false] position label on top of an input
   * @param {Boolean} [options.explain-top=false] position explain on top of an input (requires label-top=true)
   * @param {Number} [options.multi] have multiple in-line inputs. useful when `input` is passed as an array of inputs
   * @param {String} [options.errorField] The API error field here that maps to this input
   * @param {Boolean} [options.inlineValidation=true] Validate input on focusout
   * @param {String} [options.ariaLabel] Used to add aria-label attribute to the input when label is not present.
   * @param {Boolean} [options.group=false] Grouping set of inputs using fieldset and legend. Mainly for radio
   * @param {Object} [options.options]
   * In the context of `radio` and `select`, a key/value set of options
   *
   * @param {Object} [options.params]
   * Widget specific parameters. Varies per input.
   *
   * @param {BaseInput|Object[]} [options.input]
   * - A custom input "class" or instance - preferably a **class**, so we can automagically assign the right
   * parameters when initializing it
   * - An array of input definition object literals (such as this one)
   *
   * @param {Object} [options.showWhen]
   * Setting to define when to show (or hide) the input. The input is visible by default.
   *
   * @param {Object} [options.bindings]
   * Bind a certain model attribute to a callback function, so the function is being called on render,
   * and any time this model field changes.
   * This is similar to `showWhen` but is not limited to toggling.
   *
   * @param {Function} [options.render]
   * A post-render hook that will run upon render on InputWrapper
   *
   * @param {String|Function} className   A className to apply on the {@link InputWrapper}
   *
   * @param {Function} [options.initialize]
   * An `initialize` function to run when initializing the {@link InputWrapper}
   * Useful for state mutation on start time, and complex state logic
   *
   * @example
   * // showhen: the field will be visible when `advanced` is set to `true`
   * // and `mode` is set to `"ON"`.
   * showWhen: {
   *   'advanced': true,
   *   'mode': function (value) {
   *     return value == 'ON'; // this is identical to this.model.get('mode') == 'ON'
   *   }
   * }
   *
   * @example
   * // bindings
   * bindings: {
   *   'status mode': function (status, mode) {
   *      var labelView = this.getLabel();
   *      if (status == 1) {
   *        labelView.options.label = 'Something';
   *      }
   *      else {
   *        labelView.options.label = mode;
   *      }
   *      labelView.render();
   *   }
   * }
   */
  addInput: function (_options) {
    _options = _underscoreWrapper.default.clone(_options);
    _FormUtil.default.validateInput(_options, this.model);
    const inputsOptions = _FormUtil.default.generateInputOptions(_options, this, this.__createInput).reverse(); // We need a local variable here to keep track
    // as addInput can be called either directy or through the inputs array.

    if (_underscoreWrapper.default.isEmpty(this.getInputs().toArray())) {
      _underscoreWrapper.default.extend(inputsOptions[0], {
        validateOnlyIfDirty: true
      });
    }
    const inputs = _underscoreWrapper.default.map(inputsOptions, this.__createInput, this);
    _underscoreWrapper.default.each(inputsOptions, function (input) {
      if (input.errorField) {
        this.__errorFields[input.errorField] = input.name;
      }
    }, this);
    const options = {
      inputId: _underscoreWrapper.default.last(inputs).options.inputId,
      input: inputs,
      multi: inputsOptions.length > 1 ? inputsOptions.length : undefined
    };
    _underscoreWrapper.default.extend(options, _underscoreWrapper.default.omit(this.options, 'input'), _underscoreWrapper.default.omit(_options, 'input'));
    const inputWrapper = this.__createWrapper(options);
    if (options.label !== false) {
      inputWrapper.add(this.__createLabel(options));
    }
    inputWrapper.add(this._createContainer(options)); // TODO: there may be a bug here.
    // options.input will always be an array, so options.input.type will always be undefined
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    /// @ts-ignore

    inputWrapper.type = options.type || options.input.type || 'custom';
    const args = [inputWrapper].concat(_underscoreWrapper.default.rest(arguments));
    return this.add.apply(this, args);
  },
  /**
   * @private
   */
  __createInput: function (options) {
    options = _underscoreWrapper.default.pick(options, _FormUtil.default.INPUT_OPTIONS);
    return _InputFactory.default.create(options);
  },
  /**
   * @private
   */
  __createWrapper: function (options) {
    options = _underscoreWrapper.default.pick(options, _FormUtil.default.WRAPPER_OPTIONS);
    return new _InputWrapper.default(options);
  },
  /**
   * @private
   */
  __createLabel: function (options) {
    options = _underscoreWrapper.default.pick(options, _FormUtil.default.LABEL_OPTIONS);
    return new _InputLabel.default(options);
  },
  /**
   * @private
   */
  _createContainer: function (options) {
    options = _underscoreWrapper.default.pick(options, _FormUtil.default.CONTAINER_OPTIONS);
    return new _InputContainer.default(options);
  },
  /**
   * Stores the current attributes of the model to a private property
   * @param  {Okta.BaseModel} model The model
   * @private
   */
  __saveModelState: function (model) {
    this.__originalModel = _jqueryWrapper.default.extend(true, {}, model.attributes);
  },
  /**
   * @override
   * @ignore
   */
  add: function (...args) {
    // sets a default element selector
    typeof args[1] === 'undefined' && (args[1] = '> div.o-form-content > .o-form-fieldset-container');
    return _BaseView.default.prototype.add.apply(this, args);
  },
  /**
   * Set the focus on the first input in the form
   */
  focus: function () {
    const first = this.getInputs().first();
    if (first && first.focus) {
      first.focus();
    }
    return this;
  },
  /**
   * Disable all inputs in the form
   * @deprecated not currently in use
   */
  disable: function () {
    this.invoke('disable');
    return this;
  },
  /**
   * Enable all inputs in the form
   * @deprecated not currently in use
   */
  enable: function () {
    this.invoke('enable');
  },
  /**
   * Set the max-height for o-form-content class container within the form if a height is provided,
   * otherwise, get its computed inner height
   * @param {Number} the height in pixel to set for class o-form-content
   * @return {Number}
   */
  contentHeight: function (height) {
    const content = this.$('.o-form-content');
    if (_underscoreWrapper.default.isNumber(height)) {
      content.css('max-height', height);
    } else {
      return content.height();
    }
  },
  /**
   * Get only the input children
   * @return {InputWrapper[]} An underscore wrapped array of {@link InputWrapper} instances
   */
  getInputs: function () {
    return (0, _underscoreWrapper.default)(this.filter(function (view) {
      return view instanceof _InputWrapper.default;
    }));
  }
});
exports["default"] = BaseForm;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/BaseInput.js":
/*!******************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/BaseInput.js ***!
  \******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _jqueryWrapper = _interopRequireDefault(__webpack_require__(/*! ../../util/jquery-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _ButtonFactory = _interopRequireDefault(__webpack_require__(/*! ../../util/ButtonFactory.js */ "./packages/@okta/courage-dist/esm/src/courage/util/ButtonFactory.js"));
var _StringUtil = _interopRequireDefault(__webpack_require__(/*! ../../util/StringUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/StringUtil.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
var _Callout = _interopRequireDefault(__webpack_require__(/*! ../components/Callout.js */ "./packages/@okta/courage-dist/esm/src/courage/views/components/Callout.js"));
var _Keys = _interopRequireDefault(__webpack_require__(/*! ../../util/Keys.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Keys.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const props = {
  tagName: 'span',
  attributes: function () {
    return {
      'data-se': 'o-form-input-' + this.getNameString()
    };
  },
  /**
   * default placeholder text when options.placeholder is not defined
   */
  defaultPlaceholder: '',
  constructor: function (options) {
    /* eslint complexity: [2, 9] */
    options = _underscoreWrapper.default.defaults(options || {}, {
      inputId: options.id || _underscoreWrapper.default.uniqueId('input'),
      placeholder: this.defaultPlaceholder,
      inlineValidation: true,
      validateOnlyIfDirty: false
    });
    delete options.id; // decorate the `enable` and `disable` and toggle the `o-form-disabled` class.
    // so we wont need to worry about this when overriding the methods

    const self = this;
    _underscoreWrapper.default.each({
      enable: 'removeClass',
      disable: 'addClass'
    }, function (method, action) {
      self[action] = _underscoreWrapper.default.wrap(self[action], function (fn) {
        fn.apply(self, arguments);
        self.$el[method]('o-form-disabled');
      });
    });
    _BaseView.default.call(this, options);
    if (_underscoreWrapper.default.result(options, 'readOnly') !== true && _underscoreWrapper.default.result(options, 'read') === true) {
      this.listenTo(this.model, 'change:__edit__', this.render);
    }
    if (_underscoreWrapper.default.isFunction(this.focus)) {
      this.focus = _underscoreWrapper.default.debounce(_underscoreWrapper.default.bind(this.focus, this), 50);
    } // Enable inline validation if this is not the first field in the form.

    if (!_underscoreWrapper.default.result(options, 'validateOnlyIfDirty')) {
      this.addInlineValidation();
    }
    this.addModelListeners();
    this.$el.addClass('o-form-input-name-' + this.getNameString());
  },
  addAriaLabel: function () {
    const ariaLabel = this.options.ariaLabel;
    if (ariaLabel) {
      this.$(':input').attr('aria-label', ariaLabel);
    }
  },
  addInlineValidation: function () {
    if (_underscoreWrapper.default.result(this.options, 'inlineValidation')) {
      this.$el.on('focusout', ':input', _underscoreWrapper.default.bind(this.validate, this));
    }
  },
  toModelValue: function () {
    let value = this.val();
    if (_underscoreWrapper.default.isFunction(this.to)) {
      value = this.to.call(this, value);
    }
    if (_underscoreWrapper.default.isFunction(this.options.to)) {
      value = this.options.to.call(this, value);
    }
    return value;
  },
  __getDependencyCalloutBtn: function (btnConfig) {
    const self = this;
    const btnOptions = _underscoreWrapper.default.clone(btnConfig);
    const originalClick = btnOptions.click || function () {}; // add onfocus listener to re-evaluate depedency when callout button is clicked

    btnOptions.click = function () {
      (0, _jqueryWrapper.default)(window).one('focus.dependency', function () {
        self.__showInputDependencies();
      });
      originalClick.call(self);
    };
    const BaseInputCalloutBtn = _BaseView.default.extend({
      children: [_ButtonFactory.default.create(btnOptions)]
    });
    return new BaseInputCalloutBtn();
  },
  getCalloutParent: function () {
    return this.$('input[value="' + this.getModelValue() + '"]').parent();
  },
  __getCalloutMsgContainer: function (calloutMsg) {
    return _BaseView.default.extend({
      template: _handlebarsRuntime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function (container, depth0, helpers, partials, data) {
          var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
          return "<span class=\"o-form-explain\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "msg") || (depth0 != null ? lookupProperty(depth0, "msg") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "msg",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 29
              },
              "end": {
                "line": 1,
                "column": 36
              }
            }
          }) : helper)) + "</span>";
        },
        "useData": true
      }),
      getTemplateData: function () {
        return {
          msg: calloutMsg
        };
      }
    });
  },
  showCallout: function (calloutConfig, dependencyResolved) {
    const callout = _underscoreWrapper.default.clone(calloutConfig);
    callout.className = 'dependency-callout';
    if (callout.btn) {
      callout.content = this.__getDependencyCalloutBtn(callout.btn);
      delete callout.btn;
    }
    const dependencyCallout = _Callout.default.create(callout);
    if (!dependencyResolved) {
      dependencyCallout.add(this.__getCalloutMsgContainer(_StringUtil.default.localize('dependency.callout.msg', 'courage')));
    }
    const calloutParent = this.getCalloutParent();
    calloutParent.append(dependencyCallout.render().el);
    if (callout.type === 'success') {
      _underscoreWrapper.default.delay(function () {
        // fade out success callout
        dependencyCallout.$el.fadeOut(800);
      }, 1000);
    }
  },
  removeCallout: function () {
    this.$el.find('.dependency-callout').remove();
  },
  __evaluateCalloutObject: function (dependencyResolved, calloutTitle) {
    let defaultCallout;
    if (dependencyResolved) {
      defaultCallout = {
        title: _StringUtil.default.localize('dependency.action.completed', 'courage'),
        size: 'large',
        type: 'success'
      };
    } else {
      defaultCallout = {
        title: _StringUtil.default.localize('dependency.action.required', 'courage', [calloutTitle]),
        size: 'large',
        type: 'warning'
      };
    }
    return defaultCallout;
  },
  __handleDependency: function (result, callout) {
    const self = this;
    const calloutConfig = _underscoreWrapper.default.isFunction(callout) ? callout(result) : _underscoreWrapper.default.extend({}, callout, self.__evaluateCalloutObject(result.resolved, callout.title)); // remove existing callouts if any

    self.removeCallout();
    self.showCallout(calloutConfig, result.resolved);
  },
  __showInputDependencies: function () {
    const self = this;
    const fieldDependency = self.options.deps[self.getModelValue()];
    if (fieldDependency && _underscoreWrapper.default.isFunction(fieldDependency.func)) {
      fieldDependency.func().done(function (data) {
        self.__handleDependency({
          resolved: true,
          data: data
        }, fieldDependency.callout);
      }).fail(function (data) {
        self.__handleDependency({
          resolved: false,
          data: data
        }, fieldDependency.callout);
      });
    } else {
      self.removeCallout();
    }
  },
  _isEdited: false,
  hasIMESupport: false,
  /**
   * updates the model with the input's value
   */
  update: function (e) {
    var _window, _window$okta;
    if (!this._isEdited && _underscoreWrapper.default.result(this.options, 'validateOnlyIfDirty')) {
      this._isEdited = true;
      this.addInlineValidation();
    }
    this.model.set(this.options.name, this.toModelValue());
    if (this.options.deps) {
      // check for dependencies
      this.__showInputDependencies();
    }
    /*
      To add IME support for more components
      - Add hasIMESupport boolean flag and compositionend and compositionstart event listeners to the component
      - Supported components: TextBox.js, TextSelect.js
      - Additionally window.okta.enableIMESupport is an org level FF to toggle IME support
    */

    if (this.hasIMESupport && (_window = window) !== null && _window !== void 0 && (_window$okta = _window.okta) !== null && _window$okta !== void 0 && _window$okta.enableIMESupport) {
      if (this.isComposing) {
        return;
      }
      if (e && _Keys.default.isEnter(e)) {
        this.model.trigger('form:save');
      }
    }
  },
  /**
   * Is the input in edit mode
   * @return {Boolean}
   */
  isEditMode: function () {
    const ret = !_underscoreWrapper.default.result(this.options, 'readOnly') && (_underscoreWrapper.default.result(this.options, 'read') !== true || this.model.get('__edit__') === true);
    return ret;
  },
  /**
   * Renders the input
   * @readonly
   */
  render: function () {
    this.preRender();
    const params = this.options.params;
    this.options.params = _underscoreWrapper.default.resultCtx(this.options, 'params', this);
    if (this.isEditMode()) {
      this.editMode();
      this.applyEnabledState();
    } else {
      this.readMode();
    }
    this.options.params = params;
    this.addAriaLabel();
    this.postRender();
    return this;
  },
  applyEnabledState: function () {
    if (_underscoreWrapper.default.resultCtx(this.options, 'disabled', this)) {
      this.disable();
    } else {
      this.enable();
    }
  },
  /**
   * checks if the current value in the model is valid for this field
   */
  validate: function () {
    if (!this.model.get('__pending__') && this.isEditMode() && _underscoreWrapper.default.isFunction(this.model.validateField)) {
      const validationError = this.model.validateField(this.options.name);
      if (validationError) {
        _underscoreWrapper.default.delay(function () {
          this.model.trigger('form:clear-error:' + this.options.name);
          this.model.trigger('invalid', this.model, validationError, false);
        }.bind(this), 100);
      }
    }
  },
  /**
   * Add model event listeners
   */
  addModelListeners: function () {
    this.listenTo(this.model, 'form:field-error', function (name) {
      if (this.options.name === name) {
        this.__markError();
      }
    });
    this.listenTo(this.model, 'form:clear-errors change:' + this.options.name, this.__clearError);
    this.listenTo(this.model, 'form:clear-error:' + this.options.name, this.__clearError);
  },
  /**
   * The value of the input
   * @return {Mixed}
   */
  val: function () {
    throw new Error('val() is an abstract method');
  },
  /**
   * Set focus on the input
   */
  focus: function () {
    throw new Error('focus() is an abstract method');
  },
  /**
   * Default value in read mode
   * When model has no value for the field
   */
  defaultValue: function () {
    return '';
  },
  /**
   * Renders the input in edit mode
   */
  editMode: function () {
    const options = _underscoreWrapper.default.extend({}, this.options, {
      value: this.getModelValue()
    });
    this.$el.html(this.template(options));
    this.options.multi && this.$el.removeClass('margin-r');
    return this;
  },
  /**
   * Renders the readable value of the input in read mode
   */
  readMode: function () {
    this.$el.text(this.getReadModeString());
    this.$el.removeClass('error-field');
    this.options.multi && this.$el.addClass('margin-r');
    return this;
  },
  getReadModeString: function () {
    const readModeStr = _underscoreWrapper.default.resultCtx(this.options, 'readModeString', this);
    if (readModeStr) {
      return readModeStr;
    }
    return this.toStringValue();
  },
  /**
   * The model value off the field associated with the input
   * @return {Mixed}
   */
  getModelValue: function () {
    let value = this.model.get(this.options.name);
    if (_underscoreWrapper.default.isFunction(this.from)) {
      value = this.from.call(this, value);
    }
    if (_underscoreWrapper.default.isFunction(this.options.from)) {
      value = this.options.from.call(this, value);
    }
    return value;
  },
  /*
  * convenience method to get the textual value from the model
  * will return the textual label rather than value in case of select/radio
  * @return {String}
  */
  toStringValue: function () {
    let value = this.getModelValue();
    if (this.options.options) {
      // dropdown or radio
      value = this.options.options[value];
    }
    if (Number.isInteger(value) || typeof value === 'boolean') {
      value = String(value);
    }
    return value || this.defaultValue();
  },
  /**
   * Triggers a form:resize event in order to tell dialogs content size has changed
   */
  resize: function () {
    this.model.trigger('form:resize');
  },
  /**
   * Disable the input
   */
  disable: function () {
    this.$(':input').prop('disabled', true);
  },
  /**
   * Enable the input
   */
  enable: function () {
    this.$(':input').prop('disabled', false);
  },
  /**
   * Change the type of the input field. (e.g., text <--> password)
   * @param type
   */
  changeType: function (type) {
    this.$(':input').prop('type', type); // Update the options so that it keeps the uptodate state

    this.options.type = type;
  },
  getNameString: function () {
    if (_underscoreWrapper.default.isArray(this.options.name)) {
      return this.options.name.join('-');
    }
    return this.options.name;
  },
  /**
   * Get parameters, computing _.result
   * @param  {[type]} options alternative options
   * @return {Object} the params
   */
  getParams: function (options) {
    const opts = options || this.options || {};
    return _underscoreWrapper.default.clone(_underscoreWrapper.default.resultCtx(opts, 'params', this) || {});
  },
  /**
   * get a parameter from options.params, compute _.result when needed.
   * @param  {String} key
   * @param  {Object} defaultValue
   * @return {Object} the params
   */
  getParam: function (key, defaultValue) {
    const result = _underscoreWrapper.default.resultCtx(this.getParams(), key, this);
    return !_underscoreWrapper.default.isUndefined(result) ? result : defaultValue;
  },
  /**
   * Get a parameter from options.params or if empty, object attribute.
   *
   * @param  {String} key
   * @return {Object} the param or attribute
   */
  getParamOrAttribute: function (key) {
    return this.getParam(key) || _underscoreWrapper.default.result(this, key);
  },
  __markError: function () {
    this.$el.addClass('o-form-has-errors');
  },
  __clearError: function () {
    this.$el.removeClass('o-form-has-errors');
  }
};
/**
 * @class BaseInput
 * @private
 * An abstract object that defines an input for {@link Okta.Form}
 *
 * BaseInputs are typically not created directly, but being passed to {@link Okta.Form#addInput}
 * @extends Okta.View
 */

var BaseInput = _BaseView.default.extend(props);
exports["default"] = BaseInput;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/components/ReadModeBar.js":
/*!*******************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/components/ReadModeBar.js ***!
  \*******************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../../BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
var _FormUtil = _interopRequireDefault(__webpack_require__(/*! ../helpers/FormUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/FormUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ReadModeBar = _BaseView.default.extend({
  el: '<span class="o-form-toggle" data-type="header-btn"></span>',
  formTitle: '',
  modelEvents: {
    'change:__edit__': 'toggle'
  },
  initialize: function () {
    this.addButton();
  },
  addButton: function () {
    if (this.model.get('__edit__')) {
      this.add(_FormUtil.default.createReadFormButton({
        type: 'cancel'
      }));
    } else {
      this.add(_FormUtil.default.createReadFormButton({
        type: 'edit',
        formTitle: this.formTitle,
        className: 'disable-in-read-only'
      }));
    }
  },
  toggle: function () {
    this.removeChildren();
    this.addButton();
  }
});
exports["default"] = ReadModeBar;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/components/Toolbar.js":
/*!***************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/components/Toolbar.js ***!
  \***************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../../BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
var _FormUtil = _interopRequireDefault(__webpack_require__(/*! ../helpers/FormUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/FormUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const proto = {
  className: function () {
    return 'o-form-button-bar';
  },
  buttonOrder: ['previous', 'save', 'cancel'],
  initialize: function (options) {
    const buttonConfigs = {
      previous: {
        type: 'previous'
      },
      save: {
        type: 'save',
        text: _underscoreWrapper.default.resultCtx(options, 'save', this),
        id: _underscoreWrapper.default.resultCtx(options, 'saveId', this),
        className: _underscoreWrapper.default.resultCtx(options, 'saveClassName', this)
      },
      cancel: {
        type: 'cancel',
        text: _underscoreWrapper.default.resultCtx(options, 'cancel', this)
      }
    };
    this.__getButtonOrder(options).forEach(buttonName => {
      this.addButton(buttonConfigs[buttonName]);
    });
  },
  /**
   * Adds a buttomn to the toolbar
   * @param {Object} params button parameters
   * @param {Object} options {@link Okta.View#add} options
   */
  addButton: function (params, options) {
    return this.add(_FormUtil.default.createButton(params), options);
  },
  __getButtonOrder: function (options) {
    const buttonOrder = _underscoreWrapper.default.resultCtx(options, 'buttonOrder', this, this.buttonOrder);
    const buttonsToSkip = [];
    if (options.noSubmitButton) {
      buttonsToSkip.push('save');
    }
    if (options.noCancelButton) {
      buttonsToSkip.push('cancel');
    }
    if (!options.hasPrevStep) {
      buttonsToSkip.push('previous');
    }
    return _underscoreWrapper.default.without(buttonOrder, ...buttonsToSkip);
  }
};
var Toolbar = _BaseView.default.extend(proto);
exports["default"] = Toolbar;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/EnumTypeHelper.js":
/*!*******************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/EnumTypeHelper.js ***!
  \*******************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _jqueryWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/jquery-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _SchemaUtil = _interopRequireDefault(__webpack_require__(/*! ../../../util/SchemaUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/SchemaUtil.js"));
var _StringUtil = _interopRequireDefault(__webpack_require__(/*! ../../../util/StringUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/StringUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint max-statements: 0 */
const NAME = 'name';
const ENUM_KEY_PREFIX = '_enum_';
/**
 * Generate Input Options in order to create an input in an Form for Enum type attribute.
 * @param {Object} config informations for creating input options
 *   config.name        schema property name
 *   config.title       schema property title
 *   config.readOnly    create an read only input?
 *   config.explain     sub-title to the input
 *   config.enumValues  list of enum values for creating input options (Dropdown/SimpleCheckBoxSet)
 *   config.displayType display type of schema property
 *
 * @return {Object} inputOptions options for create an Input view. (Dropdown/SimpleCheckBoxSet)
 *
 */

function getEnumInputOptions(config) {
  const enumOneOf = convertToOneOf(config.enumValues);
  const inputOptions = {
    name: config.name,
    label: config.title,
    readOnly: config.readOnly,
    customExplain: config.explain,
    params: {
      enumOneOf: enumOneOf
    },
    options: getDropdownOptionsFromOneOf(enumOneOf)
  }; // input type

  if (_SchemaUtil.default.isArrayDataType(config.displayType)) {
    inputOptions.type = 'checkboxset';
    inputOptions.to = valuesToEnumObjects;
    inputOptions.from = enumObjectsToValues;
  } else {
    inputOptions.type = 'select';
    inputOptions.to = valueToEnumObject;
    inputOptions.from = enumObjectToValue;
  }
  inputOptions.input = null;
  return inputOptions;
}
function getDropdownOptions(values) {
  return _underscoreWrapper.default.isArray(values) ? getDropdownOptionsFromOneOf(convertToOneOf(values)) : {};
}
function getDropdownOptionsFromOneOf(values) {
  if (!isOneOfEnumObject(values)) {
    return {};
  }
  return _underscoreWrapper.default.reduce(values, function (options, value, index) {
    options[convertIndexToEnumIndex(index)] = value.title;
    return options;
  }, {});
}
function convertToOneOf(values) {
  // assume this is a legacy enum array and convert to oneOf object
  if (!_underscoreWrapper.default.all(values, _jqueryWrapper.default.isPlainObject)) {
    return convertEnumToOneOf(values); // we assume object without const and title is an enum object which need special conversion
  } else if (!isOneOfEnumObject(values)) {
    return convertEnumObjectToOneOf(values);
  }
  return values;
}
function isOneOfEnumObject(values) {
  return _underscoreWrapper.default.isArray(values) && _underscoreWrapper.default.all(values, function (value) {
    return _underscoreWrapper.default.has(value, 'const') && _underscoreWrapper.default.has(value, 'title');
  });
}
function convertEnumToOneOf(values) {
  return _underscoreWrapper.default.map(values, function (value) {
    return {
      const: value,
      title: valueToTitle(value)
    };
  });
}
function valueToTitle(value) {
  if (_underscoreWrapper.default.isObject(value)) {
    return JSON.stringify(value);
  }
  if (_underscoreWrapper.default.isNumber(value)) {
    return value + '';
  }
  return value;
}
function convertEnumObjectToOneOf(values) {
  const findKey = _underscoreWrapper.default.partial(_underscoreWrapper.default.has, _underscoreWrapper.default, NAME); // If all object found the key NAME, use the NAME's value as display name

  if (_underscoreWrapper.default.all(values, findKey)) {
    return _underscoreWrapper.default.chain(values).filter(function (value) {
      return _jqueryWrapper.default.isPlainObject(value) && _underscoreWrapper.default.has(value, NAME);
    }).map(function (value) {
      return {
        const: value,
        title: value[NAME]
      };
    }).value();
  } // Assume a legacy object array does not need special handling and just convert to const/title enum

  return convertEnumToOneOf(values);
}
function convertIndexToEnumIndex(index) {
  return `${ENUM_KEY_PREFIX}${index}`;
}
function enumObjectToValue(obj) {
  const index = _underscoreWrapper.default.findIndex(this.options.params.enumOneOf, function (oneOfObj) {
    return _underscoreWrapper.default.isObject(obj) ? _underscoreWrapper.default.isEqual(oneOfObj.const, obj) : oneOfObj.const === obj;
  }); // Cannot rely on comparator in findIndex when compare objects so need special handling

  return index > -1 ? convertIndexToEnumIndex(index) : obj;
}
function valueToEnumObject(val) {
  if (!_underscoreWrapper.default.isString(val) || val.indexOf(ENUM_KEY_PREFIX) !== 0) {
    return val;
  }
  const index = val.replace(ENUM_KEY_PREFIX, '');
  const enumValue = this.options.params && _underscoreWrapper.default.isArray(this.options.params.enumOneOf) ? this.options.params.enumOneOf[index] : null; // @see `getEnumInputOptions` how enumValues has been set.

  return _underscoreWrapper.default.has(enumValue, 'const') ? enumValue.const : enumValue;
}
function valuesToEnumObjects(values) {
  return _underscoreWrapper.default.map(values, valueToEnumObject.bind(this));
}
function enumObjectsToValues(values) {
  return _underscoreWrapper.default.map(values, enumObjectToValue.bind(this));
}
function isStringConstraint(value) {
  return _underscoreWrapper.default.isString(value);
}
function isNumberConstraint(value) {
  return _underscoreWrapper.default.isNumber(value) || _underscoreWrapper.default.isNumber(_StringUtil.default.parseFloat(_jqueryWrapper.default.trim(value)));
}
function isIntegerConstraint(value) {
  const integer = _underscoreWrapper.default.isNumber(value) ? value : _StringUtil.default.parseInt(_jqueryWrapper.default.trim(value));
  return typeof integer === 'number' && isFinite(integer) && Math.floor(integer) === integer;
}
function isObjectConstraint(value) {
  if (_underscoreWrapper.default.isObject(value) && !_underscoreWrapper.default.isArray(value)) {
    return true;
  }
  const object = _StringUtil.default.parseObject(_jqueryWrapper.default.trim(value));
  return _underscoreWrapper.default.isObject(object) && !_underscoreWrapper.default.isArray(object);
}
function isConstraintValueMatchType(value, type) {
  switch (type) {
    case _SchemaUtil.default.STRING:
      return isStringConstraint(value);
    case _SchemaUtil.default.NUMBER:
      return isNumberConstraint(value);
    case _SchemaUtil.default.INTEGER:
      return isIntegerConstraint(value);
    case _SchemaUtil.default.OBJECT:
      return isObjectConstraint(value);
  }
}
var EnumTypeHelper = {
  getEnumInputOptions: getEnumInputOptions,
  getDropdownOptions: getDropdownOptions,
  convertToOneOf: convertToOneOf,
  isConstraintValueMatchType: isConstraintValueMatchType
};
exports["default"] = EnumTypeHelper;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/ErrorBanner.js":
/*!****************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/ErrorBanner.js ***!
  \****************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../../BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ErrorBanner = _BaseView.default.extend({
  template: _handlebarsRuntime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "errorSummary") || (depth0 != null ? lookupProperty(depth0, "errorSummary") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "errorSummary",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 130
          },
          "end": {
            "line": 1,
            "column": 146
          }
        }
      }) : helper)) + "</p>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "courage",
          "code": "oform.errorbanner.title"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 161
          },
          "end": {
            "line": 1,
            "column": 217
          }
        }
      })) + "</p>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"okta-form-infobox-error infobox infobox-error\" role=\"alert\"><span class=\"icon error-16\"></span>" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "errorSummary") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.program(3, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 107
          },
          "end": {
            "line": 1,
            "column": 228
          }
        }
      })) != null ? stack1 : "") + "</div>";
    },
    "useData": true
  }),
  modelEvents: {
    'form:clear-errors': 'remove'
  }
});
exports["default"] = ErrorBanner;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/ErrorParser.js":
/*!****************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/ErrorParser.js ***!
  \****************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _StringUtil = _interopRequireDefault(__webpack_require__(/*! ../../../util/StringUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/StringUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FIELD_REGEX = /^([\S]+): (.+)$/;
var ErrorParser = {
  /**
   * Helper function that returns the json output of an xhr objext
   * @param  {jqXhr} xhr
   * @return {Object}
   */
  getResponseJSON: function (xhr) {
    try {
      return xhr.responseJSON || JSON.parse(xhr.responseText);
    } catch (e) {// ignore error
    }
  },
  /**
   * Parses an error summary to extract a field name and an error message
   * @param  {String} errorSummary The raw error summary
   * @return {String[]} An array with two members: [field name, error message]
   */
  parseErrorSummary: function (errorSummary) {
    const matches = errorSummary.match(FIELD_REGEX); // error format is: `fieldName: The field cannot be left blank`

    if (matches) {
      return [matches[1], matches[2]];
    }
  },
  /**
   * Parses an error cause object to extract a field name from property attribute
   * and an error message form errorSummary attribute. It looks to see if there is
   * a custom override/translation for the erorrCause.reason before using the errorSummary
   * @param  {Object} errorCause object
   * @return {String[]} An array with two members: [field name, error message]
   */
  parseErrorCauseObject: function (errorCause) {
    if (errorCause.property && errorCause.errorSummary) {
      // avoid triggering sentry log for error event with no cause reason
      const localizedMsg = errorCause.reason ? _StringUtil.default.localize(errorCause.reason) : undefined;
      const apiMsg = errorCause.errorSummary;
      const field = errorCause.property;
      const errorMessage = (localizedMsg === null || localizedMsg === void 0 ? void 0 : localizedMsg.indexOf('L10N_ERROR[')) === -1 ? localizedMsg : apiMsg;
      return [field, errorMessage];
    }
  },
  parseErrors: function (resp) {
    const responseJSON = this.getResponseJSON(resp);
    return _underscoreWrapper.default.map(responseJSON && responseJSON.errorCauses || [], function (errorCause) {
      return ('' + errorCause.errorSummary).replace(FIELD_REGEX, '$2');
    });
  },
  /**
   * Parses the response for errors
   * Returns a map of field names > array or error messages
   * Example:
   * ```javascript
   * {
   *   url: ['The field cannot be left blank', 'The field has to be a valid URI'],
   *   name: ['The field cannot be left blank']
   * }
   * ```
   * @param  {Object} resp
   * @return {Object}
   */
  parseFieldErrors: function (resp) {
    const responseJSON = this.getResponseJSON(resp);
    const errors = {}; // xhr error object

    if (responseJSON) {
      /* eslint complexity: [2, 9] */
      _underscoreWrapper.default.each(responseJSON.errorCauses || [], function (cause) {
        let res = [];
        if (cause.property && cause.errorSummary) {
          res = this.parseErrorCauseObject(cause);
        } else if (cause.location && cause.errorSummary) {
          // To handle new api error format for field level errors.
          // Ignoring the reason attribute as the translation happens in the API layer and not in the client any more.
          res = [cause.location, cause.errorSummary];
        } else {
          res = this.parseErrorSummary(cause && cause.errorSummary || '');
        }
        if (res) {
          const fieldName = res[0];
          const message = res[1];
          errors[fieldName] || (errors[fieldName] = []);
          errors[fieldName].push(message);
        }
      }, this);
    } // validation key/value object
    else if (_underscoreWrapper.default.isObject(resp) && _underscoreWrapper.default.size(resp)) {
      _underscoreWrapper.default.each(resp, function (msg, field) {
        errors[field] = [msg];
      });
    }
    return _underscoreWrapper.default.size(errors) ? errors : undefined;
  }
};
exports["default"] = ErrorParser;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/FormUtil.js":
/*!*************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/FormUtil.js ***!
  \*************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _Keys = _interopRequireDefault(__webpack_require__(/*! ../../../util/Keys.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Keys.js"));
var _Logger = _interopRequireDefault(__webpack_require__(/*! ../../../util/Logger.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Logger.js"));
var _StringUtil = _interopRequireDefault(__webpack_require__(/*! ../../../util/StringUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/StringUtil.js"));
var _ViewUtil = _interopRequireDefault(__webpack_require__(/*! ../../../util/ViewUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/ViewUtil.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../../BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint max-params: [2, 6] */
const LABEL_OPTIONS = ['model', 'id', 'inputId', 'type', 'label', 'sublabel', 'tooltip', 'name', 'group'];
const CONTAINER_OPTIONS = ['wide', 'multi', 'input', 'label-top', 'explain', 'explain-top', 'customExplain', 'model', 'name', 'type', 'autoRender', 'multirowError'];
const WRAPPER_OPTIONS = ['model', 'name', 'label-top', 'readOnly', 'events', 'initialize', 'showWhen', 'bindings', 'render', 'className', 'data-se', 'toggleWhen', 'group'];
const INPUT_OPTIONS = ['model', 'name', 'inputId', 'type',
// base options
'input',
// custom input
'placeholder', 'label',
// labels
'readOnly', 'read', 'disabled', 'readModeString',
// modes
'options',
// select/radio
'deps',
// used to specify inputs that have dependencies and show a callout to user on select
'from', 'to',
// model transformers,
'autoRender',
// model attributes change event to trigger rerendering of the input
'inlineValidation',
// control inline validating against the model on focus lost
'validateOnlyIfDirty',
// check if field has been interacted with and then validate
'ariaLabel',
// 508 compliance for inputs that do not have label associated with them
'params', 'autoComplete',
// autocomplete attribute
'sortByKey'];
const OTHER_OPTIONS = ['errorField' // widgets params - for input specific widgets
];

const ALL_OPTIONS = _underscoreWrapper.default.uniq(_underscoreWrapper.default.union(LABEL_OPTIONS, CONTAINER_OPTIONS, WRAPPER_OPTIONS, INPUT_OPTIONS, OTHER_OPTIONS));
const SAVE_BUTTON_PHASES = ['•         ', '•  •      ', '•  •  •   ', '•  •  •  •', '   •  •  •', '      •  •', '         •', '          ', '          ', '          '];
function decorateDoWhen(doWhen) {
  if (doWhen && !doWhen['__edit__']) {
    return _underscoreWrapper.default.extend({
      __edit__: _underscoreWrapper.default.constant(true)
    }, doWhen);
  }
}
function createButton(options) {
  options = _underscoreWrapper.default.pick(options || {}, 'action', 'id', 'className', 'text', 'type');
  let timeoutId;
  let intervalId;
  let phaseCount;
  return _BaseView.default.extend({
    tagName: 'input',
    className: 'button',
    events: {
      click: function () {
        if (options.action && !this.disabled()) {
          options.action.call(this);
        }
      },
      keyup: function (e) {
        if (_Keys.default.isEnter(e) && options.action && !this.disabled()) {
          options.action.call(this);
        }
      }
    },
    disabled: function () {
      return this.$el.prop('disabled') === true;
    },
    disable: function () {
      this.$el.prop('disabled', true);
      this.$el.addClass('btn-disabled');
    },
    enable: function () {
      this.$el.prop('disabled', false);
      this.$el.removeClass('btn-disabled');
    },
    initialize: function () {
      const self = this;
      this.$el.attr('type', options.type === 'save' ? 'submit' : 'button');
      this.$el.val(options.text);
      if (options.id) {
        this.$el.attr('id', options.id);
      }
      if (options.className) {
        this.$el.addClass(options.className);
      }
      if (options.type) {
        this.$el.attr('data-type', options.type);
      }
      this.$el.mousedown(function () {
        self.model.set('__pending__', true);
      });
      this.$el.mouseup(function () {
        self.model.set('__pending__', false);
      });
      this.listenTo(this.model, 'form:set-saving-state', function () {
        this.disable();
        if (options.type === 'save') {
          timeoutId = setTimeout(_underscoreWrapper.default.bind(this.__changeSaveText, this), 1000);
        }
      });
      this.listenTo(this.model, 'form:clear-saving-state', function () {
        this.enable();
        if (options.type === 'save') {
          clearTimeout(timeoutId);
          clearInterval(intervalId);
          this.$el.val(options.text);
        }
      });
    },
    __changeSaveText: function () {
      phaseCount = 0;
      intervalId = setInterval(_underscoreWrapper.default.bind(this.__showLoadingText, this), 200);
    },
    __showLoadingText: function () {
      this.$el.val(SAVE_BUTTON_PHASES[phaseCount++ % SAVE_BUTTON_PHASES.length]);
    }
  });
}
function validateInput(options, model) {
  /* eslint max-statements: 0, complexity: 0 */
  options || (options = {});
  if (options.type === 'label') {
    if (!options.label) {
      _Logger.default.warn('A label input must have a "label" parameter', options);
    }
    return;
  }
  if (options.type === 'button') {
    if (!options.title && !options.icon) {
      _Logger.default.warn('A button input must have a "title" and/or an "icon" parameter', options);
    }
    if (!options.click && !options.href) {
      _Logger.default.warn('A button input must have a "click" and/or an "href" parameter', options);
    }
    return;
  }
  if (!options.name && !options.input) {
    _Logger.default.warn('Missing "name" or "input" parameters', options);
  }
  if (_underscoreWrapper.default.isArray(options.name) && _underscoreWrapper.default.isArray(options.input)) {
    throw new Error('Not allowed to have both "name" and "input" defined as array.');
  }
  if (options.type !== 'list' && options.name && model && model.allows) {
    let names = [];
    if (_underscoreWrapper.default.isArray(options.name)) {
      names = options.name;
    } else {
      names.push(options.name);
    }
    _underscoreWrapper.default.each(names, function (name) {
      if (!model.allows(name)) {
        throw new Error('field not allowed: ' + options.name);
      }
    });
  }
  if (_underscoreWrapper.default.isArray(options.input) && options.type !== 'list') {
    _underscoreWrapper.default.each(options.input, function (input) {
      validateInput(input, model);
    });
  }
  const keys = _underscoreWrapper.default.keys(options);
  const intersection = _underscoreWrapper.default.intersection(keys, ALL_OPTIONS);
  if (_underscoreWrapper.default.size(intersection) !== _underscoreWrapper.default.size(options)) {
    const fields = _underscoreWrapper.default.clone(ALL_OPTIONS);
    _Logger.default.warn('Invalid input parameters', _underscoreWrapper.default.without(keys, ...fields), options);
  }
}
function generateInputOptions(options, form, createFn) {
  options = _underscoreWrapper.default.clone(options);
  if (_underscoreWrapper.default.contains(['list', 'group'], options.type)) {
    options.params = _underscoreWrapper.default.defaults({
      create: createFn,
      inputs: _underscoreWrapper.default.map(_underscoreWrapper.default.isArray(options.input) ? options.input : [options.input], function (input) {
        return _underscoreWrapper.default.first(generateInputOptions(input, form, createFn));
      })
    }, options.params || {});
    delete options.input;
  }
  const inputs = _underscoreWrapper.default.isArray(options.input) ? _underscoreWrapper.default.clone(options.input) : [options];
  return _underscoreWrapper.default.map(inputs, function (input) {
    const target = _underscoreWrapper.default.defaults({
      model: form.model
    }, input, _underscoreWrapper.default.omit(options, 'input', 'inputs'), form.options, {
      id: _underscoreWrapper.default.uniqueId('input'),
      readOnly: form.isReadOnly(),
      read: form.hasReadMode()
    });
    if (form.isReadOnly()) {
      target.read = target.readOnly = true;
    }
    return target;
  });
}
var FormUtil = {
  LABEL_OPTIONS: LABEL_OPTIONS,
  CONTAINER_OPTIONS: CONTAINER_OPTIONS,
  WRAPPER_OPTIONS: WRAPPER_OPTIONS,
  INPUT_OPTIONS: INPUT_OPTIONS,
  generateInputOptions: generateInputOptions,
  changeEventString: function (fieldNames) {
    return 'change:' + fieldNames.join(' change:');
  },
  createReadFormButton: function (options) {
    let action;
    let text;
    let ariaLabel;
    if (options.type === 'cancel') {
      text = ariaLabel = _StringUtil.default.localize('oform.cancel', 'courage');
      action = function () {
        this.model.trigger('form:cancel');
      };
    } else {
      text = _StringUtil.default.localize('oform.edit', 'courage');
      ariaLabel = text + ' ' + options.formTitle;
      action = function () {
        this.model.set('__edit__', true);
      };
    }
    return _BaseView.default.extend({
      tagName: 'a',
      className: options.className,
      attributes: {
        href: '#',
        'aria-label': ariaLabel
      },
      // TODO: refactor to enforce precompiled templates OKTA-309852
      // eslint-disable-next-line @okta/okta-ui/no-bare-templates
      template: function () {
        return _underscoreWrapper.default.escape(text);
      },
      events: {
        click: function (e) {
          e.preventDefault();
          action.call(this);
        }
      }
    });
  },
  createButton: function (options) {
    options = _underscoreWrapper.default.clone(options);
    switch (options.type) {
      case 'save':
        _underscoreWrapper.default.defaults(options, {
          className: 'button-primary'
        });
        break;
      case 'cancel':
        _underscoreWrapper.default.defaults(options, {
          className: 'button-clear',
          text: _StringUtil.default.localize('oform.cancel', 'courage'),
          action: function () {
            this.model.trigger('form:cancel');
          }
        });
        break;
      case 'previous':
        _underscoreWrapper.default.defaults(options, {
          text: _StringUtil.default.localize('oform.previous', 'courage'),
          action: function () {
            this.model.trigger('form:previous');
          }
        });
        break;
    }
    return createButton(options);
  },
  validateInput: validateInput,
  /**
   * Applies a show-when logic on a view instance.
   * The show-when is a map of a model field name -> a boolean or a function that returns a boolean.
   * The view will toggle based on the field value.
   *
   * @param  {Okta.View} view a view instance that has a this.model attached to it
   * @param  {Object} showWhen
   */
  applyShowWhen: function (view, showWhen) {
    const toggleAndResize = function (bool) {
      return function () {
        // The `toggle` is here since an event may be triggered before the el is in the DOM
        // and in that case slide events may not function as expected.
        view.$el.toggle(bool);
        view.model.trigger('form:resize');
      };
    };
    _ViewUtil.default.applyDoWhen(view, decorateDoWhen(showWhen), function (bool, options) {
      if (!options.animate) {
        view.$el.toggle(bool);
      } else {
        view.$el['slide' + (bool ? 'Down' : 'Up')](200, toggleAndResize(bool));
      }
    });
  },
  applyToggleWhen: function (view, toggleWhen) {
    _ViewUtil.default.applyDoWhen(view, decorateDoWhen(toggleWhen), function (bool, options) {
      view.$el.toggle(bool);
      view.model.trigger('form:resize');
      if (options.animate) {
        view.render();
      }
    });
  }
};
exports["default"] = FormUtil;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/InputContainer.js":
/*!*******************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/InputContainer.js ***!
  \*******************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _Logger = _interopRequireDefault(__webpack_require__(/*! ../../../util/Logger.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Logger.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! ../../../util/Util.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Util.js"));
var _StringUtil = _interopRequireDefault(__webpack_require__(/*! ../../../util/StringUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/StringUtil.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../../BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const isABaseView = _Util.default.isABaseView;
/**
 * @class InputContainer
 * @private
 *
 * TODO: OKTA-80796
 * Attention: Please change with caution since this is used in other places
 */

var InputContainer = _BaseView.default.extend({
  attributes: function () {
    return {
      'data-se': 'o-form-input-container'
    };
  },
  className: function () {
    let className = 'o-form-input';
    if (this.options.wide) {
      className += ' o-form-wide';
    }
    if (_underscoreWrapper.default.contains([1, 2, 3, 4], this.options.multi)) {
      className += ' o-form-multi-input-' + this.options.multi;
      if (_underscoreWrapper.default.isArray(this.options.input)) {
        const inputGroup = _underscoreWrapper.default.find(this.options.input, function (input) {
          return _underscoreWrapper.default.contains(['text+select', 'select+text'], input.options.type);
        });
        inputGroup && (className += ' o-form-multi-input-group-' + this.options.multi);
      }
    }
    return className;
  },
  _getNames: function () {
    const names = _underscoreWrapper.default.isArray(this.options.name) ? this.options.name : [this.options.name];
    /*eslint complexity: 0 */

    if (this.options.type === 'group') {
      names.push.apply(names, _underscoreWrapper.default.pluck(this.options.input[0].options.params.inputs, 'name'));
    } else if (_underscoreWrapper.default.isArray(this.options.name)) {
      if (this.options.input && this.options.input.options && this.options.input.options.name) {
        names.push(this.options.input.options.name);
      }
    } else if (this.options.input) {
      if (_underscoreWrapper.default.isArray(this.options.input)) {
        _underscoreWrapper.default.each(this.options.input, function (inputItem) {
          names.push(inputItem.options.name);
        });
      } else {
        names.push(this.options.input.options.name);
      }
    }
    return _underscoreWrapper.default.uniq(_underscoreWrapper.default.compact(names));
  },
  _getInputElement: function () {
    // NOTE: this.options.input is sometimes not an array under test
    const lastInput = Array.isArray(this.options.input) ? _underscoreWrapper.default.last(this.options.input) : this.options.input; // FIXME: replace with _.get

    const id = lastInput && lastInput.options && lastInput.options.inputId;
    const el = id ? this.$('#' + id) : null;
    return el && el.length ? el : null;
  },
  constructor: function () {
    /* eslint max-statements: [2, 18] */
    _BaseView.default.apply(this, arguments);
    const explainTop = this.options['explain-top'] && this.options['label-top'];
    if (this.options.input) {
      if (_underscoreWrapper.default.isArray(this.options.input)) {
        _underscoreWrapper.default.each(this.options.input, function (inputItem) {
          this.add(inputItem, {
            prepend: !explainTop
          });
        }, this);
      } else {
        this.add(this.options.input, {
          prepend: !explainTop
        });
      }
    }
    this.__setExplain(this.options);
    const names = this._getNames();
    this.listenTo(this.model, 'form:field-error', function (name, errors) {
      if (_underscoreWrapper.default.contains(names, name)) {
        this.__setError(errors, explainTop);
      }
    });
    this.listenTo(this.model, 'form:clear-errors change:' + names.join(' change:'), this.__clearError);
    this.listenTo(this.model, 'form:clear-error:' + names.join(' form:clear-error:'), this.__clearError);
    if (_underscoreWrapper.default.resultCtx(this.options, 'autoRender', this)) {
      this.listenTo(this.model, 'change:' + this.options.name, this.render);
    }
    this.__errorState = false;
  },
  /**
   * Populates the explain on the input container (if it exists). There are
   * two ways to use this:
   * 1. Raw text - wraps in the correct html template
   * 2. Custom html
   *    - pass in a View class (preferred)
   *    - pass in an instance of a View
   * Some additional notes:
   * - You can pass a function that returns any of the above
   * - This maintains support for the deprecated "customExplain" property
   *   that was used before. This pattern is superseded by explain, so use
   *   that instead.
   * @private
   */
  __setExplain: function (options) {
    let explain; // Deprecated - if you need custom html, use explain instead

    if (options.customExplain) {
      _Logger.default.warn('Deprecated - use explain instead of customExplain');
      this.add(this.options.customExplain);
      return;
    }
    explain = options.explain;
    if (_underscoreWrapper.default.isFunction(explain) && !isABaseView(explain)) {
      explain = _underscoreWrapper.default.resultCtx(this.options, 'explain', this);
    }
    if (!explain) {
      return;
    }
    if (isABaseView(explain)) {
      this.template = _handlebarsRuntime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function (container, depth0, helpers, partials, data) {
          return "<p class=\"o-form-explain\"></p>";
        },
        "useData": true
      });
      this.add(explain, ' > .o-form-explain');
    } else {
      this.template = _handlebarsRuntime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function (container, depth0, helpers, partials, data) {
          var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
          return "<p class=\"o-form-explain\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "explain") || (depth0 != null ? lookupProperty(depth0, "explain") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "explain",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 26
              },
              "end": {
                "line": 1,
                "column": 37
              }
            }
          }) : helper)) + "</p>";
        },
        "useData": true
      });
    }
  },
  /**
   * Highlight the input as invalid (validation failed)
   * Adds an explaination message of the error
   * @private
   */
  __setError: function (errors, explainTop) {
    this.__errorState = true;
    this.$el.addClass('o-form-has-errors');
    const errorId = _underscoreWrapper.default.uniqueId('input-container-error');
    const html = this.__getHTMLForError(_underscoreWrapper.default.flatten(errors), errorId);
    const $elExplain = this.$('.o-form-explain').not('.o-form-input-error').first();
    if ($elExplain.length && !explainTop) {
      $elExplain.before(html);
    } else {
      this.$el.append(html);
    }
    const target = this._getInputElement() || this.$el;
    target.attr('aria-describedby', errorId);
    target.attr('aria-invalid', true);
  },
  __getHTMLForError: function (errors, errorId) {
    const tmpl = _handlebarsRuntime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function (container, depth0, helpers, partials, data) {
        var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }
            return undefined;
          };
        return "<p id=\"" + alias4((helper = (helper = lookupProperty(helpers, "errorId") || (depth0 != null ? lookupProperty(depth0, "errorId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
          "name": "errorId",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 7
            },
            "end": {
              "line": 1,
              "column": 18
            }
          }
        }) : helper)) + "\" class=\"okta-form-input-error o-form-input-error o-form-explain\" role=\"alert\"><span class=\"icon icon-16 error-16-small\" role=\"img\" aria-label=\"" + alias4((helper = (helper = lookupProperty(helpers, "iconLabel") || (depth0 != null ? lookupProperty(depth0, "iconLabel") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
          "name": "iconLabel",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 162
            },
            "end": {
              "line": 1,
              "column": 175
            }
          }
        }) : helper)) + "\"></span>" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
          "name": "text",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 184
            },
            "end": {
              "line": 1,
              "column": 192
            }
          }
        }) : helper)) + "</p>";
      },
      "useData": true
    });
    const iconLabel = _StringUtil.default.localize('oform.error.icon.ariaLabel', 'courage'); // 'Error'

    if (this.options.multirowError) {
      let html = '';
      errors.forEach(error => {
        html = html + tmpl({
          errorId: errorId,
          iconLabel: iconLabel,
          text: error
        });
      });
      return html;
    }
    return tmpl({
      errorId: errorId,
      iconLabel: iconLabel,
      text: errors.join(', ')
    });
  },
  /**
   * Un-highlight the input and remove explaination text
   * @private
   */
  __clearError: function () {
    if (this.__errorState) {
      this.$('.o-form-input-error').remove();
      const target = this._getInputElement() || this.$el;
      target.attr('aria-describedby', null);
      target.attr('aria-invalid', null);
      this.$el.removeClass('o-form-has-errors');
      this.__errorState = false;
      _underscoreWrapper.default.defer(() => {
        this.model.trigger('form:resize');
      });
    }
  },
  focus: function () {
    this.each(function (view) {
      if (view.focus) {
        return view.focus();
      }
    });
    return this;
  }
});
exports["default"] = InputContainer;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/InputFactory.js":
/*!*****************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/InputFactory.js ***!
  \*****************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _InputRegistry = _interopRequireDefault(__webpack_require__(/*! ./InputRegistry.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/InputRegistry.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint complexity: 0, max-statements: 0 */

function createInput(Input, options) {
  if (_InputRegistry.default.isBaseInput(Input)) {
    return Input.prototype ? new Input(_underscoreWrapper.default.omit(options, 'input')) : Input;
  } else {
    return Input;
  }
}
function create(options) {
  options = _underscoreWrapper.default.clone(options);
  if (options.input) {
    return createInput(options.input, options);
  }
  const Input = _InputRegistry.default.get(options);
  if (!Input) {
    throw new Error('unknown input: ' + options.type);
  }
  return createInput(Input, options);
}
function supports(options) {
  return !!options.input || !!_InputRegistry.default.get(options);
}
var InputFactory = {
  create: create,
  supports: supports
};
exports["default"] = InputFactory;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/InputLabel.js":
/*!***************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/InputLabel.js ***!
  \***************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
__webpack_require__(/*! @okta/qtip */ "./packages/@okta/qtip2/dist/jquery.qtip.js");
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../../BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @class InputLabel
 * @extends {Okta.View}
 * @private
 * The input's label.
 */
var InputLabel = _BaseView.default.extend({
  className: 'okta-form-label o-form-label',
  attributes: {
    'data-se': 'o-form-label'
  },
  /**
   * @constructor
   * @param  {Object} options options hash
   * @param  {String} [options.type] Input type
   * @param  {String|Function} [options.label] Label text
   * @param  {String|Function} [options.sublabel] Sub label text
   * @param  {String|Function} [options.tooltip] Tooltip text
   * @param  {String|Function} [options.inputId] Id of the inputs
   * @param  {String|Function} [options.id] Id of the inputs
   */
  constructor: function (options) {
    /* eslint max-statements: [2, 16] complexity: [2, 7]*/
    _underscoreWrapper.default.defaults(options, {
      inputId: options.id
    });
    delete options.id;
    _BaseView.default.apply(this, arguments);
  },
  // standardLabel: space added in the end of the label to avoid selecting label text with double click in read mode
  template: _handlebarsRuntime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      return "<legend>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<label for=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "inputId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 61
          },
          "end": {
            "line": 1,
            "column": 72
          }
        }
      }) : helper)) + "\"></label>";
    },
    "5": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 116
          },
          "end": {
            "line": 1,
            "column": 125
          }
        }
      }) : helper));
    },
    "7": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<label for=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "inputId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 167
          },
          "end": {
            "line": 1,
            "column": 178
          }
        }
      }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 180
          },
          "end": {
            "line": 1,
            "column": 189
          }
        }
      }) : helper)) + "&nbsp;</label>";
    },
    "9": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<span class=\"o-form-explain\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "sublabel") || (depth0 != null ? lookupProperty(depth0, "sublabel") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "sublabel",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 256
          },
          "end": {
            "line": 1,
            "column": 268
          }
        }
      }) : helper)) + "</span>";
    },
    "11": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<span class=\"o-form-tooltip icon-16 icon-only form-help-16\" title=\"" + container.escapeExpression(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "tooltip") : depth0) != null ? lookupProperty(stack1, "text") : stack1, depth0)) + "\"></span>";
    },
    "13": function (container, depth0, helpers, partials, data) {
      return "</legend>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "group") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 28
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "_isLabelView") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 28
          },
          "end": {
            "line": 1,
            "column": 89
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "_isRadioOrCheckbox") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(5, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 89
          },
          "end": {
            "line": 1,
            "column": 132
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "_standardLabel") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(7, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 132
          },
          "end": {
            "line": 1,
            "column": 210
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "sublabel") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(9, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 210
          },
          "end": {
            "line": 1,
            "column": 282
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "tooltip") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(11, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 282
          },
          "end": {
            "line": 1,
            "column": 397
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "group") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(13, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 397
          },
          "end": {
            "line": 1,
            "column": 426
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  getTemplateData: function () {
    const options = {
      label: ''
    };
    _underscoreWrapper.default.each(['inputId', 'label', 'sublabel', 'tooltip', 'group'], function (option) {
      options[option] = _underscoreWrapper.default.resultCtx(this.options, option, this);
    }, this);
    if (this._isLabelView(options.label)) {
      options._isLabelView = true;
    } else if (_underscoreWrapper.default.contains(['radio', 'checkbox'], this.options.type) || !options.label) {
      options._isRadioOrCheckbox = true;
    } else {
      options._standardLabel = true;
    }
    if (options.tooltip) {
      if (_underscoreWrapper.default.isString(options.tooltip)) {
        options.tooltip = {
          text: options.tooltip
        };
      }
    }
    return options;
  },
  _isLabelView: function (label) {
    return !_underscoreWrapper.default.isUndefined(label) && label instanceof _BaseView.default;
  },
  postRender: function () {
    const options = this.getTemplateData();
    if (this._isLabelView(options.label)) {
      this.removeChildren();
      this.add(options.label, 'label');
    }
    if (options.tooltip) {
      this.$('.o-form-tooltip').qtip(_underscoreWrapper.default.extend({
        style: {
          classes: 'qtip-custom qtip-shadow'
        },
        position: {
          my: window.okta && window.okta.theme === 'dstheme' ? 'bottom center' : 'bottom left',
          at: 'top center'
        },
        hide: {
          fixed: true
        },
        show: {
          delay: 0
        }
      }, options.tooltip.options));
    }
  }
});
exports["default"] = InputLabel;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/InputRegistry.js":
/*!******************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/InputRegistry.js ***!
  \******************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const registry = {};
function isBaseInput(input) {
  if (_underscoreWrapper.default.isFunction(input)) {
    return _underscoreWrapper.default.isFunction(input.prototype.editMode) && _underscoreWrapper.default.isFunction(input.prototype.readMode);
  } else {
    return _underscoreWrapper.default.isObject(input) && _underscoreWrapper.default.isFunction(input.editMode) && _underscoreWrapper.default.isFunction(input.readMode);
  }
}
/**
 * @class module:Okta.internal.views.forms.helpers.InputRegistry
 */

var InputRegistry = /** @lends module:Okta.internal.views.forms.helpers.InputRegistry */
{
  isBaseInput: isBaseInput,
  /**
   * Register a form input
   * @param {String} type string identifier for the input
   * @param {BaseInput} input the input to register
   * @return {void}
   */
  register: function (type, input) {
    registry[type] = input;
  },
  /**
   * Get a form input by type
   * @param {Object} options input definition
   * @param {String} options.type string identifier for the input
   * @return {BaseInput} a matching input
   */
  get: function (options) {
    const input = registry[options.type];
    return input && (isBaseInput(input) ? input : input(options));
  },
  /**
   * Unregister an input type
   * @param {String} type
   */
  unregister: function (type) {
    delete registry[type];
  }
};
exports["default"] = InputRegistry;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/InputWrapper.js":
/*!*****************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/InputWrapper.js ***!
  \*****************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../../BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
var _FormUtil = _interopRequireDefault(__webpack_require__(/*! ./FormUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/FormUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function runCallback(callback, field) {
  callback.apply(this, _underscoreWrapper.default.map(field.split(/\s+/), function (field) {
    return this.model.get(field);
  }, this));
}
function runIf(fn, ctx) {
  if (_underscoreWrapper.default.isFunction(fn)) {
    fn.call(ctx);
  }
}
/**
 * @class InputWrapper
 * @extends Okta.View
 * @private
 * The outer wrapper that warps the label and the input container
 */

var InputWrapper = _BaseView.default.extend({
  tagName: function () {
    if (this.options.group) {
      return 'fieldset';
    }
    return 'div';
  },
  className: function () {
    let className = 'o-form-fieldset';
    if (this.options['label-top']) {
      className += ' o-form-label-top';
    }
    if (this.options.readOnly) {
      className += ' o-form-read-mode';
    }
    return className;
  },
  attributes: function () {
    return {
      'data-se': this.options['data-se'] || 'o-form-fieldset'
    };
  },
  /**
   * @constructor
   * @param  {Object} options options hash
   * @param  {Object} [options.events]
   * @param  {Object} [options.bindings]
   * @param  {Object} [options.showWhen]
   * @param  {Function} [options.initialize] post initialize callback
   * @param  {Function} [options.render] post render callback
   */
  constructor: function (options) {
    if (options.className) {
      this.inputWrapperClassName = this.className;
      this.optionsClassName = options.className;
      options.className = function () {
        return _underscoreWrapper.default.result(this, 'inputWrapperClassName', '') + ' ' + _underscoreWrapper.default.result(this, 'optionsClassName');
      };
    }
    _BaseView.default.apply(this, arguments);
    _underscoreWrapper.default.each(options.events || {}, function (callback, event) {
      this.listenTo(this.model, event, callback);
    }, this);
    _underscoreWrapper.default.each(options.bindings || {}, function (callback, field) {
      this.listenTo(this.model, _FormUtil.default.changeEventString(field.split(/\s+/)), _underscoreWrapper.default.bind(runCallback, this, callback, field));
    }, this);
    _FormUtil.default.applyShowWhen(this, options.showWhen);
    _FormUtil.default.applyToggleWhen(this, options.toggleWhen);
    runIf(options.initialize, this);
  },
  postRender: function () {
    _underscoreWrapper.default.each(this.options.bindings || {}, runCallback, this);
    runIf(this.options.render, this);
  },
  /**
   * @return {InputLabel}
   */
  getLabel: function () {
    return this.size() > 1 ? this.at(0) : null;
  },
  /**
   * @deprecated ambiguous naming, use {@link #getInputContainer}
   */
  getInput: function () {
    return this.getInputContainer();
  },
  /**
   * @return {InputContainer}
   */
  getInputContainer: function () {
    return this.at(this.size() > 1 ? 1 : 0);
  },
  /**
   * @return {BaseInput[]}
   */
  getInputs: function () {
    return this.getInputContainer().toArray();
  },
  focus: function () {
    return this.getInput().focus();
  }
});
exports["default"] = InputWrapper;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/SchemaFormFactory.js":
/*!**********************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/SchemaFormFactory.js ***!
  \**********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _StringUtil = _interopRequireDefault(__webpack_require__(/*! ../../../util/StringUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/StringUtil.js"));
var _BooleanSelect = _interopRequireDefault(__webpack_require__(/*! ../inputs/BooleanSelect.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/BooleanSelect.js"));
var _TextBoxSet = _interopRequireDefault(__webpack_require__(/*! ../inputs/TextBoxSet.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/TextBoxSet.js"));
var _EnumTypeHelper = _interopRequireDefault(__webpack_require__(/*! ./EnumTypeHelper.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/helpers/EnumTypeHelper.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint max-statements: 0, max-params: 0 */

function convertStringToNumber(string) {
  const number = _StringUtil.default.parseFloat(string);
  return string === '' ? null : number;
} // converts possibleValues to choices
// [a, b, c] => {a: a, b: b, c: c}

function getChoices(values) {
  return _underscoreWrapper.default.object(values, values);
}
function isArray(type) {
  return type && type.indexOf('array') >= 0;
} // A schema property may have an objectName either
// at the root level or nested in the items object

function getObjectName(schemaProp) {
  const items = schemaProp.get('items');
  if (items) {
    return items.objectName;
  }
  return schemaProp.get('objectName');
}
/**
 * Checks the validity of a schema property.
 *
 * @param {SchemaProperty} [schemaProp] A schema property backbone model
 * @param {Object} [values] An object of the form { key: [value1, value2]}
 * @return {Boolean} true/false
 * @private
 */

function isValidSchemaProp(schemaProp, values) {
  const objectName = getObjectName(schemaProp);
  const results = values[objectName]; // a schema property that references an empty list of values
  // Im looking at you, google apps.

  if (objectName && (0, _underscoreWrapper.default)(results).isEmpty()) {
    return false;
  }
  return true;
} // Maps each __displayType__ to a basic set of inputOptions.

function defaultOptions(property) {
  const type = property.get('__displayType__');
  const values = property.get('__possibleValues__');
  const name = property.get('name');
  const title = property.get('title');
  /* eslint complexity: [2, 24] */

  const inputOptions = {
    type: 'text',
    name: name,
    label: title || name
  }; // @see customOptions for enum complex "object" type,
  // a.k.a "object" or "arrayofobject" type has enum values defined.
  // Other cases (e.g., nested object type) are not support yet.

  switch (type) {
    case 'arrayofstring':
      inputOptions.input = _TextBoxSet.default;
      inputOptions.params = {
        itemType: 'string'
      };
      break;
    case 'arrayofnumber':
      inputOptions.input = _TextBoxSet.default;
      inputOptions.params = {
        itemType: 'number'
      };
      break;
    case 'arrayofinteger':
      inputOptions.input = _TextBoxSet.default;
      inputOptions.params = {
        itemType: 'integer'
      };
      break;
    case 'arrayofobject':
      inputOptions.input = _TextBoxSet.default;
      inputOptions.params = {
        itemType: property.get('items').type
      };
      break;
    case 'arrayofref-id':
      inputOptions.input = _TextBoxSet.default;
      inputOptions.params = {
        itemType: property.get('items').format
      };
      break;
    case 'boolean':
      inputOptions.input = _BooleanSelect.default;
      break;
    case 'integer':
    case 'number':
      inputOptions.to = convertStringToNumber;
      break;
    case 'reference':
      inputOptions.type = 'select';
      inputOptions.options = getChoices(values);
      break;
    case 'image':
      inputOptions.readOnly = true;
      inputOptions.from = function (value) {
        return _underscoreWrapper.default.isEmpty(value) ? '' : _StringUtil.default.localize('user.profile.image.image_set', 'courage'); // TODO
      };

      break;
    case 'password':
      inputOptions.type = 'password';
      break;
    case 'date':
      inputOptions.type = 'date';
      break;
    case 'uri':
    case 'country-code':
    case 'country_code':
    case 'language-code':
    case 'language_code':
    case 'email':
    case 'locale':
    case 'timezone':
    case 'string':
    case 'object':
      // default input options
      break;
    default:
      throw new Error(`unknown type: ${type}`);
  }
  return inputOptions;
} // Sets nonbasic inputOptions, such as an array with possible values

function customOptions(property) {
  let inputOptions = {};
  const name = property.get('name');
  const type = property.get('__displayType__');
  const values = property.get('__possibleValues__');
  const prefix = property.get('__fieldNamePrefix__');
  if (prefix) {
    inputOptions.name = prefix + name;
    inputOptions.errorField = name;
  }
  if (property.isEnumType()) {
    const configs = {
      displayType: type,
      title: property.get('title'),
      enumValues: property.getEnumValues()
    };
    inputOptions = _underscoreWrapper.default.extend({}, _EnumTypeHelper.default.getEnumInputOptions(configs), inputOptions);
  } else if (isArray(type) && values) {
    inputOptions.type = 'checkboxset';
    inputOptions.input = null;
    inputOptions.options = getChoices(values);
  }
  return inputOptions;
}
function augmentSchemaProp(schemaProp, possibleValues, profile) {
  const name = schemaProp.get('name');
  const prefix = profile.__nestedProperty__;
  let defaultValues = possibleValues[name];
  const userValues = profile.get(name);
  let values; // If API responds with a field name that differs from the form-field name
  // example: Model's 'profile.username' vs. server's 'username'

  if (prefix) {
    schemaProp.set('__fieldNamePrefix__', prefix);
  } // case 1: objectName - fixed list of values are set for the input

  const fixedValues = possibleValues[getObjectName(schemaProp)]; // case 2: name only - default list of values are provided, user can add more
  // TODO: this case does not yet exist, so it is not tested

  if (defaultValues && userValues) {
    defaultValues = _underscoreWrapper.default.union(defaultValues, userValues);
  } // If both fixed and default values exist,
  // take the fixed values unless they are empty

  if (fixedValues && fixedValues.length) {
    values = fixedValues;
  } else if (defaultValues && defaultValues.length) {
    values = defaultValues;
  }
  schemaProp.set('__possibleValues__', values);
}
function augmentSchemaProps(schemaProps, possibleValues, profile) {
  schemaProps.each(function (schemaProp) {
    augmentSchemaProp(schemaProp, possibleValues, profile);
  });
  return schemaProps;
}
/**
 * Remove invalid schema properties from a collection
 *
 * @param {SchemaProperties Collection} [properties] A collection of schema properties
 * @param {Object} [values] An object of the form { key: [value1, value2]}
 * @return {Array} An array of valid schema models, this can be used to reset
 * a schema properties collection for example.
 * @private
 */

function cleanSchema(properties, values) {
  return properties.filter(function (schema) {
    return isValidSchemaProp(schema, values);
  });
}
var SchemaFormFactory = {
  /**
   * Creates the options hash for BaseForm.addInput from a prepared schema
   * property.
   *
   * @param {Okta.Model} [preparedSchemaProp] A schema property backbone model
   * that has been standardized by the prepareSchema method.
   * @return {Object} An object containing all of the options needed by
   * BaseForm's addInput()
   */
  createInputOptions: function (preparedSchemaProp) {
    const custom = customOptions(preparedSchemaProp);
    const standard = defaultOptions(preparedSchemaProp); // underscore did not support nested extend
    // https://github.com/jashkenas/underscore/issues/162

    if (custom.params && standard.params) {
      custom.params = _underscoreWrapper.default.defaults(custom.params, standard.params);
    }
    return _underscoreWrapper.default.defaults(custom, standard);
  },
  hasValidSchemaProps: function (schemaProps, possibleValues) {
    if (_underscoreWrapper.default.isEmpty(schemaProps)) {
      return false;
    }
    const validSchema = cleanSchema(schemaProps, possibleValues);
    return !!validSchema.length;
  },
  /**
   * This method is responsible for preparing a collection for the form
   * factory to use by putting all of the information to create an input
   * into the schema property and removing invalid properties.
   * The typical UD form takes 3 models:
   * The data model has the input values.
   * The schema model describes which input to use, such as a textbox or a checkbox.
   * The possible values model provide a list of default options to display, for example in a drop down menu.
   *
   * @param {SchemaProperty Collection} [schemaProps] A schema property backbone model.
   * @param {Object} [possibleValues] An object of the form { key: [value1, value2]}
   * @param {Okta.Model} [profile] A backbone model containing the property described by the schema property.
   * @return {SchemaProperty Collection} A schema property collection with standardized models.
   * The standard schema model adds a couple of additional private properties to
   * allow the form factory to reference lookup values or name prefixes without going to a second model.
   */
  prepareSchema: function (schemaProps, possibleValues, profile) {
    schemaProps.reset(cleanSchema(schemaProps, possibleValues));
    return augmentSchemaProps(schemaProps, possibleValues, profile);
  },
  /**
   * `prepareSchema` will reset the property list which may not be necessary at some case.
   * like when setting default value for schema properties.
   * (more detail about such case @see wiki UX, App+Entitlements+for+Provisioning)
   *
   * @param { }
   * @return {String}
   */
  augmentSchemaProps: augmentSchemaProps,
  augmentSchemaProp: augmentSchemaProp
};
exports["default"] = SchemaFormFactory;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/BooleanSelect.js":
/*!*****************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/BooleanSelect.js ***!
  \*****************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _Select = _interopRequireDefault(__webpack_require__(/*! ./Select.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/Select.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const options = {
  undefined: 'undefined',
  true: 'true',
  false: 'false'
};
const from = function (val) {
  if (val) {
    return 'true';
  }
  if (val === false) {
    return 'false';
  }
  return 'undefined';
};
const to = function (val) {
  switch (val) {
    case 'undefined':
      return null;
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      return null;
  }
};
var BooleanSelect = _Select.default.extend({
  initialize: function () {
    this.options.options = options;
    this.options.from = from;
    this.options.to = to;
  }
});
exports["default"] = BooleanSelect;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/CheckBox.js":
/*!************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/CheckBox.js ***!
  \************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _Keys = _interopRequireDefault(__webpack_require__(/*! ../../../util/Keys.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Keys.js"));
__webpack_require__(/*! ../../../vendor/plugins/jquery.custominput.js */ "./packages/@okta/courage-dist/esm/src/courage/vendor/plugins/jquery.custominput.js");
var _BaseInput = _interopRequireDefault(__webpack_require__(/*! ../BaseInput.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/BaseInput.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CheckBox = _BaseInput.default.extend({
  template: _handlebarsRuntime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<input type=\"checkbox\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 29
          },
          "end": {
            "line": 1,
            "column": 37
          }
        }
      }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "inputId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 43
          },
          "end": {
            "line": 1,
            "column": 54
          }
        }
      }) : helper)) + "\"/><label for=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "inputId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 69
          },
          "end": {
            "line": 1,
            "column": 80
          }
        }
      }) : helper)) + "\" data-se-for-name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 100
          },
          "end": {
            "line": 1,
            "column": 108
          }
        }
      }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "placeholder",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 110
          },
          "end": {
            "line": 1,
            "column": 125
          }
        }
      }) : helper)) + "</label>";
    },
    "useData": true
  }),
  /**
   * @Override
   */
  events: {
    'change :checkbox': 'update',
    keyup: function (e) {
      e.preventDefault();
      if (_Keys.default.isSpaceBar(e)) {
        this.$(':checkbox').click();
      } else if (_Keys.default.isEnter(e)) {
        this.model.trigger('form:save');
      }
    }
  },
  /**
   * @Override
   */
  editMode: function () {
    let placeholder = _underscoreWrapper.default.resultCtx(this.options, 'placeholder', this);
    if (placeholder === '') {
      placeholder = _underscoreWrapper.default.resultCtx(this.options, 'label', this);
    } else if (placeholder === false) {
      placeholder = '';
    }
    this.$el.html(this.template(_underscoreWrapper.default.extend(_underscoreWrapper.default.omit(this.options, 'placeholder'), {
      placeholder: placeholder
    })));
    const $input = this.$(':checkbox');
    $input.prop('checked', this.getModelValue() || false);
    this.$('input').customInput();
    this.model.trigger('form:resize');
    return this;
  },
  /**
   * @Override
   */
  readMode: function () {
    this.editMode();
    this.$(':checkbox').prop('disabled', true);
    return this;
  },
  /**
   * @Override
   */
  val: function () {
    return this.$(':checkbox').prop('checked');
  },
  /**
   * @Override
   */
  focus: function () {
    return this.$(':checkbox').focus();
  }
});
exports["default"] = CheckBox;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/DeletableBox.js":
/*!****************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/DeletableBox.js ***!
  \****************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _SchemaUtil = _interopRequireDefault(__webpack_require__(/*! ../../../util/SchemaUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/SchemaUtil.js"));
var _StringUtil = _interopRequireDefault(__webpack_require__(/*! ../../../util/StringUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/StringUtil.js"));
var _Time = _interopRequireDefault(__webpack_require__(/*! ../../../util/Time.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Time.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../../BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const template = _handlebarsRuntime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      alias2 = container.hooks.helperMissing,
      alias3 = "function",
      alias4 = container.escapeExpression,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<div class=\"o-form-input-group-controls\"><span class=\"input-fix o-form-control\"><input type=\"text\" class=\"o-form-text\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "key") || (depth0 != null ? lookupProperty(depth0, "key") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "key",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 125
        },
        "end": {
          "line": 1,
          "column": 132
        }
      }
    }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "key") || (depth0 != null ? lookupProperty(depth0, "key") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "key",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 138
        },
        "end": {
          "line": 1,
          "column": 145
        }
      }
    }) : helper)) + "\" value=\"" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "value",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 154
        },
        "end": {
          "line": 1,
          "column": 163
        }
      }
    }) : helper)) + "\" placeholder=\"" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "placeholder",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 178
        },
        "end": {
          "line": 1,
          "column": 193
        }
      }
    }) : helper)) + "\"/></span><a href=\"#\" class=\"link-button link-button-icon icon-only\"><span class=\"icon clear-input-16 \"></span></a></div><p class=\"o-form-input-error o-form-explain\"><span class=\"icon icon-16 error-16-small\"></span>" + alias4((helper = (helper = lookupProperty(helpers, "errorExplain") || (depth0 != null ? lookupProperty(depth0, "errorExplain") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "errorExplain",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 408
        },
        "end": {
          "line": 1,
          "column": 424
        }
      }
    }) : helper)) + "</p>";
  },
  "useData": true
});
const errorClass = 'o-form-has-errors';
const updateArrayEvent = 'updateArray';
var DeletableBox = _BaseView.default.extend({
  tagName: 'div',
  className: 'o-form-input-group',
  events: {
    'click a': function (e) {
      e.preventDefault();
      this.remove();
    },
    'keyup input': function () {
      this.update();
    }
  },
  isEditMode: function () {
    return !this.options.readOnly && (this.options.read !== true || this.model.get('__edit__') === true);
  },
  initialize: function () {
    this.template = template(_underscoreWrapper.default.extend(this.options, {
      placeholder: this.getPlaceholderText(),
      errorExplain: this.getErrorExplainText()
    }));
    this.update = _underscoreWrapper.default.debounce(this.update, this.options.debounceDelay || _Time.default.DEBOUNCE_DELAY);
  },
  render: function () {
    if (this.isEditMode()) {
      this.$el.html(this.template);
    } else {
      this.$el.text(this.options.value);
      this.$('a').hide();
    }
    return this;
  },
  remove: function () {
    this.trigger(updateArrayEvent, null);
    this.$el.slideUp(() => {
      _BaseView.default.prototype.remove.call(this, arguments);
    });
  },
  update: function () {
    let updatedValue = this.$('input').val();
    const parseFunc = _underscoreWrapper.default.object([_SchemaUtil.default.DATATYPE.number, _SchemaUtil.default.DATATYPE.integer], [_StringUtil.default.parseFloat, this.parseInt]);
    if (_underscoreWrapper.default.has(parseFunc, this.options.itemType)) {
      updatedValue = parseFunc[this.options.itemType](updatedValue);
      !_underscoreWrapper.default.isNumber(updatedValue) ? this.markInvalid() : this.clearInvalid();
    }
    this.trigger(updateArrayEvent, updatedValue);
  },
  markInvalid: function () {
    this.$el.addClass(errorClass);
  },
  clearInvalid: function () {
    this.$el.removeClass(errorClass);
  },
  getPlaceholderText: function () {
    let placeholderText;
    switch (this.options.itemType.toLowerCase()) {
      // TODO fix lint and add the spaces/indent
      case 'string':
        placeholderText = _StringUtil.default.localize('placeholder.text.string', 'courage');
        break;
      case 'number':
        placeholderText = _StringUtil.default.localize('placeholder.text.number', 'courage');
        break;
      case 'integer':
        placeholderText = _StringUtil.default.localize('placeholder.text.integer', 'courage');
        break;
      default:
        placeholderText = '';
    }
    return placeholderText;
  },
  getErrorExplainText: function () {
    let itemTypeMismatchMessages;
    switch (this.options.itemType.toLowerCase()) {
      // TODO fix lint and add the spaces/indent
      case 'string':
        itemTypeMismatchMessages = _StringUtil.default.localize('string.item.type.error.message', 'courage');
        break;
      case 'number':
        itemTypeMismatchMessages = _StringUtil.default.localize('number.item.type.error.message', 'courage');
        break;
      case 'integer':
        itemTypeMismatchMessages = _StringUtil.default.localize('integer.item.type.error.message', 'courage');
        break;
      default:
        itemTypeMismatchMessages = '';
    }
    return itemTypeMismatchMessages;
  },
  parseInt: function (string) {
    // native javascript parseInt is aggressive
    // there're cases we don't want a string to be parsed even though it is convertable
    // so that we don't convert a string silently before warning a user the potential error
    // this is to make sure the string is in an integer format before we parse it
    if (/^-?\d+$/.test(string)) {
      const num = parseInt(string, 10);
      return !_underscoreWrapper.default.isNaN(num) ? num : string;
    }
    return string;
  }
});
exports["default"] = DeletableBox;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/InputGroup.js":
/*!**************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/InputGroup.js ***!
  \**************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _ButtonFactory = _interopRequireDefault(__webpack_require__(/*! ../../../util/ButtonFactory.js */ "./packages/@okta/courage-dist/esm/src/courage/util/ButtonFactory.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../../BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
var _BaseInput = _interopRequireDefault(__webpack_require__(/*! ../BaseInput.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/BaseInput.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function countInputs(inputs) {
  return _underscoreWrapper.default.filter(inputs || [], function (input) {
    return !_underscoreWrapper.default.contains(['label', 'button', 'select'], input.type);
  }).length;
}
const InputGroupLabelInput = _BaseInput.default.extend({
  tagName: 'span',
  initialize: function () {
    this.$el.text(this.getModelValue());
  },
  editMode: function () {
    this.toggle(true);
  },
  readMode: function () {
    this.toggle(false);
  },
  getModelValue: function () {
    return this.options.label;
  },
  toggle: function (isEditMode) {
    this.$el.toggleClass('o-form-label-inline', isEditMode);
    this.$el.toggleClass('o-form-control', !isEditMode);
  },
  focus: _underscoreWrapper.default.noop
});
function createButtonInput(options) {
  return _ButtonFactory.default.create(_underscoreWrapper.default.defaults({
    getReadModeString: _underscoreWrapper.default.constant(' '),
    focus: _underscoreWrapper.default.noop
  }, _underscoreWrapper.default.pick(options, 'click', 'title', 'href', 'icon')));
}
const InputGroupInputGroupView = _BaseView.default.extend({
  getParams: _BaseInput.default.prototype.getParams,
  getParam: _BaseInput.default.prototype.getParam,
  className: function () {
    let className; // Allows views to group multiple inputs under one label without any of the other
    // styling/rendering changes that come with using a group input

    if (this.getParam('noBaseClasses')) {
      return '';
    }
    if (this.getParam('display') === 'text') {
      className = 'o-form-input-group-subtle';
    } else {
      className = 'o-form-input-group';
    }
    if (countInputs(this.getParam('inputs')) > 1) {
      className += ' o-form-input-group-2';
    }
    return className;
  },
  initialize: function () {
    _underscoreWrapper.default.each(this.getParam('inputs'), function (input) {
      switch (input.type) {
        case 'label':
          this.add(InputGroupLabelInput, {
            options: input
          });
          break;
        case 'button':
          this.add(createButtonInput(input));
          break;
        default:
          input = _underscoreWrapper.default.defaults({
            model: this.model,
            params: _underscoreWrapper.default.extend({
              autoWidth: true
            }, input.params || {})
          }, input);
          this.add(this.getParams().create(input));
      }
    }, this);
  },
  focus: function () {
    this.first().focus();
  }
});
var InputGroup = _BaseInput.default.extend({
  constructor: function (options) {
    this.inputGroupView = new InputGroupInputGroupView(options);
    _BaseInput.default.apply(this, arguments);
  },
  editMode: function () {
    this.inputGroupView.remove();
    this.inputGroupView = new InputGroupInputGroupView(this.options);
    this.$el.html(this.inputGroupView.render().el);
  },
  readMode: function () {
    // Allows the user to use to the default "read mode" of the child inputs instead of
    // rendering a single read mode string for all the child inputs
    if (this.getParam('useChildInputsReadMode')) {
      this.editMode();
    } else {
      _BaseInput.default.prototype.readMode.apply(this, arguments);
    }
  },
  toStringValue: function () {
    const strings = this.inputGroupView.map(function (input) {
      return input.getReadModeString();
    });
    return strings.length && _underscoreWrapper.default.every(strings) ? strings.join(' ') : ' ';
  },
  focus: function () {
    this.inputGroupView.focus();
  }
}, {
  // test hooks
  LabelInput: InputGroupLabelInput,
  InputGroupView: InputGroupInputGroupView
});
exports["default"] = InputGroup;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/PasswordBox.js":
/*!***************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/PasswordBox.js ***!
  \***************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! ./TextBox.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const toggleTemplate = _handlebarsRuntime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    return "<span class=\"password-toggle\"><span class=\"eyeicon visibility-16 button-show\"></span><span class=\"eyeicon visibility-off-16 button-hide\"></span></span>";
  },
  "useData": true
});
const toggleTimeout = 30000;
var PasswordBox = _TextBox.default.extend({
  initialize: function () {
    if (this.__showPasswordToggle()) {
      this.events['click .password-toggle .button-show'] = '__showPassword';
      this.events['click .password-toggle .button-hide'] = '__hidePassword';
    }
    this.delegateEvents();
  },
  postRender: function () {
    if (this.isEditMode() && this.__showPasswordToggle()) {
      this.$el.append(toggleTemplate);
      this.$el.find('input[type="password"]').addClass('password-with-toggle');
    }
    _TextBox.default.prototype.postRender.apply(this, arguments);
  },
  /**
   * @Override
   * Overrides the default val method in order to avoid whitespace trimming
   */
  val: function () {
    return this.$('input[type="' + this.options.type + '"]').val();
  },
  __showPasswordToggle: function () {
    return this.options.params && this.options.params.showPasswordToggle;
  },
  __showPassword: function () {
    // Turn off the spellcheck if the user decides to switch to regular input
    // in order to prevent sending passwords to third party spellcheckers
    this.$('input').attr('spellcheck', false);
    _TextBox.default.prototype.changeType.apply(this, ['text']);
    this.$('.password-toggle .button-show').hide();
    this.$('.password-toggle .button-hide').show();
    this.passwordToggleTimer = _underscoreWrapper.default.delay(() => {
      this.__hidePassword();
    }, toggleTimeout);
  },
  __hidePassword: function () {
    _TextBox.default.prototype.changeType.apply(this, ['password']);
    this.$('.password-toggle .button-show').show();
    this.$('.password-toggle .button-hide').hide(); // clear timeout

    if (this.passwordToggleTimer) {
      clearTimeout(this.passwordToggleTimer);
    }
  }
});
exports["default"] = PasswordBox;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/Radio.js":
/*!*********************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/Radio.js ***!
  \*********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _jqueryWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/jquery-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _Keys = _interopRequireDefault(__webpack_require__(/*! ../../../util/Keys.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Keys.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! ../../../util/Util.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Util.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ../../BaseView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/BaseView.js"));
__webpack_require__(/*! ../../../vendor/plugins/jquery.custominput.js */ "./packages/@okta/courage-dist/esm/src/courage/vendor/plugins/jquery.custominput.js");
var _BaseInput = _interopRequireDefault(__webpack_require__(/*! ../BaseInput.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/BaseInput.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const isABaseView = _Util.default.isABaseView;
const RadioRadioOption = _BaseView.default.extend({
  template: _handlebarsRuntime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<input type=\"radio\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 26
          },
          "end": {
            "line": 1,
            "column": 34
          }
        }
      }) : helper)) + "\" data-se-name=\"" + alias4((helper = (helper = lookupProperty(helpers, "realName") || (depth0 != null ? lookupProperty(depth0, "realName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "realName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 50
          },
          "end": {
            "line": 1,
            "column": 62
          }
        }
      }) : helper)) + "\" value=\"" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "value",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 71
          },
          "end": {
            "line": 1,
            "column": 80
          }
        }
      }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "optionId") || (depth0 != null ? lookupProperty(depth0, "optionId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "optionId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 86
          },
          "end": {
            "line": 1,
            "column": 98
          }
        }
      }) : helper)) + "\"><label for=\"" + alias4((helper = (helper = lookupProperty(helpers, "optionId") || (depth0 != null ? lookupProperty(depth0, "optionId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "optionId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 112
          },
          "end": {
            "line": 1,
            "column": 124
          }
        }
      }) : helper)) + "\" data-se-for-name=\"" + alias4((helper = (helper = lookupProperty(helpers, "realName") || (depth0 != null ? lookupProperty(depth0, "realName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "realName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 144
          },
          "end": {
            "line": 1,
            "column": 156
          }
        }
      }) : helper)) + "\" class=\"radio-label\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 178
          },
          "end": {
            "line": 1,
            "column": 187
          }
        }
      }) : helper)) + "</label>";
    },
    "useData": true
  }),
  initialize: function (options) {
    let explain;
    explain = options.explain;
    if (_underscoreWrapper.default.isFunction(explain) && !isABaseView(explain)) {
      explain = _underscoreWrapper.default.resultCtx(this.options, 'explain', this);
    }
    if (!explain) {
      return;
    }
    if (isABaseView(explain)) {
      this.add('<p class="o-form-explain"></p>', '.radio-label');
      this.add(explain, '.o-form-explain');
    } else {
      this.add(_BaseView.default.extend({
        className: 'o-form-explain',
        tagName: 'p',
        template: _handlebarsRuntime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var helper,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }
                return undefined;
              };
            return container.escapeExpression((helper = (helper = lookupProperty(helpers, "explain") || (depth0 != null ? lookupProperty(depth0, "explain") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "explain",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 11
                }
              }
            }) : helper));
          },
          "useData": true
        })
      }), '.radio-label');
    }
  }
});
var Radio = _BaseInput.default.extend({
  /**
   * @Override
   */
  events: {
    'change :radio': 'update',
    keyup: function (e) {
      if (_Keys.default.isSpaceBar(e)) {
        (0, _jqueryWrapper.default)(e.target).click();
      } else if (_Keys.default.isEnter(e)) {
        this.model.trigger('form:save');
      }
    }
  },
  /**
   * @Override
   */
  editMode: function () {
    const templates = [];
    this.$el.empty();
    _underscoreWrapper.default.each(this.options.options, function (value, key) {
      const options = {
        optionId: _underscoreWrapper.default.uniqueId('option'),
        name: this.options.inputId,
        realName: this.options.name,
        value: key
      };
      if (!_underscoreWrapper.default.isObject(value)) {
        value = {
          label: value
        };
      }
      _underscoreWrapper.default.extend(options, value);
      templates.push(new RadioRadioOption(options).render().el);
    }, this);
    this.$el.append(templates);
    let value = this.getModelValue();
    if (value) {
      this.$(':radio[value=' + value + ']').prop('checked', true);
    }
    this.$('input').customInput();
    this.model.trigger('form:resize');
    if (this.getParam('inline') === true) {
      this.$('div.custom-radio').addClass('inline');
    }
    return this;
  },
  /**
   * @Override
   */
  readMode: function () {
    this.editMode();
    this.$(':radio').prop('disabled', true);
    return this;
  },
  /**
   * @Override
   */
  val: function () {
    return this.$(':radio:checked').val();
  },
  /**
   * @Override
   */
  focus: function () {
    return this.$('label:eq(0)').focus();
  }
});
exports["default"] = Radio;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/Select.js":
/*!**********************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/Select.js ***!
  \**********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _jqueryWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/jquery-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _Keys = _interopRequireDefault(__webpack_require__(/*! ../../../util/Keys.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Keys.js"));
__webpack_require__(/*! ../../../vendor/plugins/chosen.jquery.js */ "./packages/@okta/courage-dist/esm/src/courage/vendor/plugins/chosen.jquery.js");
var _BaseInput = _interopRequireDefault(__webpack_require__(/*! ../BaseInput.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/BaseInput.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! ../../../util/Util.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Util.js"));
var _StringUtil = _interopRequireDefault(__webpack_require__(/*! ../../../util/StringUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/StringUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const template = _handlebarsRuntime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      alias2 = container.hooks.helperMissing,
      alias3 = "function",
      alias4 = container.escapeExpression,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<select id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "inputId",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 12
        },
        "end": {
          "line": 1,
          "column": 23
        }
      }
    }) : helper)) + "\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "name",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 31
        },
        "end": {
          "line": 1,
          "column": 39
        }
      }
    }) : helper)) + "\"></select>";
  },
  "useData": true
});
const option = _handlebarsRuntime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      alias2 = container.hooks.helperMissing,
      alias3 = "function",
      alias4 = container.escapeExpression,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<option value=\"" + alias4((helper = (helper = lookupProperty(helpers, "key") || (depth0 != null ? lookupProperty(depth0, "key") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "key",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 15
        },
        "end": {
          "line": 1,
          "column": 22
        }
      }
    }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "value",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 24
        },
        "end": {
          "line": 1,
          "column": 33
        }
      }
    }) : helper)) + "</option>";
  },
  "useData": true
});
const CHOSEN_WINDOW_MARGIN = 20;
const isSafari = _Util.default.isSafari; // Chosen has known problems when it's at the bottom of a container that has
// overflow:hidden set. Because it attaches to the parent container, its
// dropdown will be cut off in the UI. Any modal with a chosen select element
// at the bottom will manifest this behavior.
//
// The fix (aside from replacing Chosen) is to change Chosen's behavior -
// use the existing styles, but attach it to 'body' and position it correctly
// so that it is not affected by a parent overflow.
//
// More details can be found in OKTA-46489, OKTA-83570

const CHOSEN_MAX_HEIGHT = 240;
const CHOSEN_Z_INDEX = 50000;
function defer(fn) {
  if (this.params.autoWidth) {
    return fn.call(this);
  } else {
    return _underscoreWrapper.default.defer(_underscoreWrapper.default.bind(fn, this));
  }
}
function findSelectWidth(self) {
  self.$select.hide();
  const select = (0, _jqueryWrapper.default)(self.$select[0]).hide();
  (0, _jqueryWrapper.default)('body').append(select);
  const width = self.params.width = select.width() * 1.2 + 'px';
  self.$el.append(select.show());
  return width;
}
function recalculateChosen($chosen, $results, $clone) {
  const offset = $clone.offset();
  $chosen.css({
    left: offset.left,
    top: offset.top
  }); // Update the max-height to fit within the constraints of the window. This
  // is especially important for modals because page scrolling is disabled.

  const $win = (0, _jqueryWrapper.default)(window);
  const rHeight = $results.outerHeight();
  const rBottom = rHeight + $results.offset().top - $win.scrollTop();
  const wHeight = $win.height() - CHOSEN_WINDOW_MARGIN;
  const maxHeight = Math.min(rHeight + wHeight - rBottom, CHOSEN_MAX_HEIGHT);
  $results.css('max-height', maxHeight);
}
function handleKeyUpEvent($select, $chosen, $results) {
  const $highlightedOption = $results.find('.active-result.highlighted');
  $chosen.find('#' + $select.attr('id') + '_txt').attr('aria-activedescendant', $highlightedOption.attr('id')); // change the old selected item aria-selected to false
  // and add add it to new item.

  $results.find('[aria-selected=true]').attr('aria-selected', 'false');
  $highlightedOption.attr('aria-selected', 'true'); // In case of Safari, add message to aria-live node to be read by screenreader.
  // We need to do this special handling for Safari due to falkiness with aria-activedescendant
  // handling. https://bit.ly/3z45IZF

  if (isSafari()) {
    // message read by screenReader i.e optionValue selected(United States selected)
    const message = _StringUtil.default.localize('oform.selectInput.country', 'courage', [$highlightedOption.text()]);
    const elementId = $select.attr('id');
    if (message !== '') {
      (0, _jqueryWrapper.default)(`#${elementId}_aria_div_id`).text(message);
    }
  }
  const noResult = $results.find('li.no-results');
  if (noResult.length) {
    noResult.attr('role', 'alert');
  }
}
function fixChosenModal($select, textPlaceholder) {
  const $chosen = $select.next('.chzn-container');
  const $clone = $chosen.clone();
  const $results = $chosen.find('.chzn-results');
  const $searchInput = $chosen.find('.chzn-search input[type=text]');
  $searchInput.on('keyup', () => {
    handleKeyUpEvent($select, $chosen, $results);
  });
  $chosen.addClass('closed'); // Will be used in SIW to fix screen reader focus.
  // Use a hidden clone to maintain layout and calculate offset. This is
  // necessary for more complex layouts (like adding a group rule) where
  // the chosen element is floated.

  $clone.css('visibility', 'hidden');
  $clone.removeAttr('id');
  $clone.find('li').removeAttr('id'); // Save the original styles - we'll revert to them when the select closes

  const baseStyles = {
    left: $chosen.css('left'),
    top: $chosen.css('top'),
    position: $chosen.css('position'),
    float: $chosen.css('float'),
    'z-index': $chosen.css('z-index')
  };
  $results.hide(); // Handler for any resize events that happen when the results list is open

  const resizeHandler = _underscoreWrapper.default.debounce(function () {
    recalculateChosen($chosen, $results, $clone);
  }, 10); // When the dropdown opens, attach it to body, with the correct absolute
  // position coordinates

  $select.off('.fixChosen'); // Remove events we could have added before

  $select.on('liszt:showing_dropdown.fixChosen', function () {
    $chosen.width($chosen.width());
    $select.after($clone); // .chzn-container can trigger the vertical scrollbar if it causes scrollHeight > window height after append to
    // the body. Force top -999999 to avoid the scrollbar so $chosen can find the right offset for relocation.

    $chosen.css({
      position: 'absolute',
      float: 'none',
      'z-index': CHOSEN_Z_INDEX,
      top: -999999
    });
    (0, _jqueryWrapper.default)('body').append($chosen);
    (0, _jqueryWrapper.default)('.chzn-search > :text').prop('placeholder', textPlaceholder);
    $results.show();
    recalculateChosen($chosen, $results, $clone); // Capture scroll events:
    // - for forms that use fixed positioning (like editing attributes in
    //   Profile Editor) - window scroll
    // - for forms that are too long for the modal - o-form-content scroll

    $select.parents().scroll(resizeHandler);
    (0, _jqueryWrapper.default)(window).on('resize scroll', resizeHandler);
  });
  $select.on('liszt:showing_dropdown', function () {
    $chosen.removeClass('closed');
  }); // When the dropdown closes or the element is removed, revert to the
  // original styles and reattach it to its original placement in the dom.

  $select.on('liszt:hiding_dropdown.fixChosen remove.fixChosen', function () {
    $select.parents().off('scroll', resizeHandler);
    (0, _jqueryWrapper.default)(window).off('resize scroll', resizeHandler);
    $chosen.css(baseStyles);
    $results.hide();
    $chosen.addClass('closed');
    $results.css('max-height', CHOSEN_MAX_HEIGHT);
    $clone.remove();
    $select.after($chosen);
  }); // Do not change the order of event listeners. This event must execute after 
  // "liszt:hiding_dropdown.fixChosen remove.fixChosen"

  $select.on('liszt:hiding_dropdown.fixChosen', function () {
    $searchInput.focus(); // set focus back to input only when the dropdown is closed
  });
}

var Select = _BaseInput.default.extend({
  className: 'o-form-select',
  /**
   * @Override
   */
  events: {
    'change select': 'update',
    'keyup .chzn-search > :text': function (e) {
      if (_Keys.default.isEsc(e)) {
        this.$('.chzn-search > :text').val('');
        e.stopPropagation();
      }
    }
  },
  constructor: function () {
    this.template = template;
    this.option = this.option || option;
    _BaseInput.default.apply(this, arguments);
    this.params = this.options.params || {};
  },
  /**
   * @Override
   */
  editMode: function () {
    /* eslint max-statements: [2, 17] */
    this.$el.html(template(this.options));
    this.$select = this.$('select');
    this.appendOptions(); // Fix a regression in jQuery 1.x on Firefox
    // jQuery.val(value) prepends an empty option to the dropdown
    // if value doesnt exist in the dropdown.
    // http://bugs.jquery.com/ticket/13514

    const value = this.getModelValue();
    if (value) {
      this.$select.val(value);
    } else {
      this.$('option:first-child').prop('selected', true);
    }
    this.$el.addClass('o-form-control');
    if (this.params.chosen !== false) {
      this.__applyChosen();
    }
    return this;
  },
  appendOptions: function () {
    if (!this.getOptions()) {
      return;
    }
    const options = this.getOptions();
    const keys = Object.keys(options);
    this.applySortByKey(keys);
    keys.forEach(key => {
      this.$select.append(this.option({
        key: key,
        value: options[key]
      }));
    });
  },
  applySortByKey: function (keys) {
    const sortByKey = this.options.sortByKey;
    if (!sortByKey) {
      return;
    }
    if (sortByKey instanceof Function) {
      keys.sort(sortByKey);
    }
    if (sortByKey === 'asc') {
      keys.sort();
    }
    if (sortByKey === 'desc') {
      keys.sort();
      keys.reverse();
    }
  },
  __applyChosen: function (update) {
    let width = this.options.wide ? '100%' : this.params.width || '62%';
    if (this.params.autoWidth) {
      width = findSelectWidth(this);
    }
    defer.call(this, function () {
      const searchThreshold = this.getParam('searchThreshold', 10);
      if (!_underscoreWrapper.default.result(this.options, 'autoRender') && update !== false) {
        this.update();
      }
      this.$select.chosen({
        width: width,
        disable_search_threshold: searchThreshold,
        //eslint-disable-line camelcase
        placeholder_text: this.options['placeholder'],
        //eslint-disable-line camelcase
        search_contains: true //eslint-disable-line camelcase
      }); //if options are more than search threshold, consider it as a combobox

      const isComboBox = this.options && this.options.options && Object.keys(this.options.options).length > searchThreshold;
      this.accessibilityUpdate(isComboBox, this.params);
      fixChosenModal(this.$select, this.searchPlaceholder);
      if (this.params.autoWidth) {
        // fix a chosen css bug
        this.$el.width(0);
      }
      this.model.trigger('form:resize');
    });
  },
  /**
   * @Override
   */
  val: function () {
    return this.$select && this.$select.val();
  },
  /**
   * @Override
   */
  focus: function () {
    if (this.$select) {
      return this.$select.focus();
    }
  },
  /**
   * @Override
   */
  toStringValue: function () {
    const selectedOption = this.getModelValue();
    let displayString = selectedOption;
    const options = this.getOptions();
    if (!_underscoreWrapper.default.isEmpty(options)) {
      displayString = options[selectedOption];
    }
    if (_underscoreWrapper.default.isUndefined(displayString)) {
      displayString = this.defaultValue();
    }
    return displayString || '';
  },
  /**
   * Convert options to an object
   * support input options that is a
   * 1. a static object such as {key1: val1, key2: val2...}
   * 2. a function to be called to return a static object
   * will return an object with key-value pairs or with empty content
   * @return {Object} The value
   */
  getOptions: function () {
    let options = this.options.options;
    if (_underscoreWrapper.default.isFunction(options)) {
      options = options.call(this);
    }
    return _underscoreWrapper.default.isObject(options) ? options : {};
  },
  remove: function () {
    if (this.$select) {
      this.$select.trigger('remove');
    }
    return _BaseInput.default.prototype.remove.apply(this, arguments);
  },
  /**
   * @param ariaDivId id for div element
   * Create a div element and add it to chosen container.
   */
  createAriaLiveNode: function (ariaDivId) {
    const $chosen = this.$select.next('.chzn-container'); // set this to off-screen such that no user will see this and only screenReaders will pick this up.
    // we should announce to user only on additions and not on removals.

    const $node = (0, _jqueryWrapper.default)('<div></div>').attr('role', 'log').attr('aria-live', 'polite').attr('id', ariaDivId).attr('aria-relevant', 'additions').attr('aria-atomic', 'false').attr('class', 'off-screen');
    $node.insertAfter($chosen);
  },
  /**
   * Code to make the select/combobox component accessible with screen readers.
   *
   * @param {boolean} isComboBox - Is the select a combobox?
   * @param {object} params - params like aria label
   */
  // eslint-disable-next-line max-statements
  accessibilityUpdate: function (isComboBox, params) {
    const txtBoxId = this.$select.attr('id') + '_txt';
    const ariaDivId = this.$select.attr('id') + '_aria_div_id';
    const ulTagId = this.$select.attr('id') + '_ul'; // this is to fix(OKTA-506711) the accessibility issue due to partial support of aria-activedescendant
    // by Safari. Make use of aria-live to make screenReader announce the option selected by user as a workaround.

    if (isSafari()) {
      this.createAriaLiveNode(ariaDivId);
    }
    this.$('ul[class=chzn-results]').attr('role', 'listbox').attr('id', ulTagId);
    if (isComboBox) {
      this.$('input[type=text]').attr('id', txtBoxId).attr('aria-autocomplete', 'list').attr('aria-activedescendant', '').attr('role', 'combobox').attr('aria-expanded', 'true').attr('aria-controls', ulTagId);
    } else {
      this.$('input[type=text]').attr('id', txtBoxId).attr('role', 'listbox');
    }
    if (params && params.aria && params.aria.label) {
      const ariaLabel = params.aria.label.trim();
      this.$('input[type=text]').attr('id', txtBoxId).attr('aria-label', ariaLabel);
      this.$('ul[class=chzn-results]').attr('aria-label', ariaLabel);
    } else {
      const ariaLabel = this.$el.parent().prev('.o-form-label').find('label').text().trim();
      this.$('input[type=text]').attr('id', txtBoxId).attr('aria-label', ariaLabel);
      this.$('ul[class=chzn-results]').attr('aria-label', ariaLabel);
    }
    this.$('.chzn-results .active-result').attr('role', 'option').attr('aria-selected', 'false');
  }
});
exports["default"] = Select;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/TextBox.js":
/*!***********************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/TextBox.js ***!
  \***********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _jqueryWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/jquery-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js"));
__webpack_require__(/*! @okta/qtip */ "./packages/@okta/qtip2/dist/jquery.qtip.js");
var _Keys = _interopRequireDefault(__webpack_require__(/*! ../../../util/Keys.js */ "./packages/@okta/courage-dist/esm/src/courage/util/Keys.js"));
__webpack_require__(/*! ../../../vendor/plugins/jquery.placeholder.js */ "./packages/@okta/courage-dist/esm/src/courage/vendor/plugins/jquery.placeholder.js");
var _BaseInput = _interopRequireDefault(__webpack_require__(/*! ../BaseInput.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/BaseInput.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const className = 'okta-form-input-field input-fix';
function hasTitleAndText(options) {
  const title = options.title;
  const text = options.text;
  return title && text && title !== text;
} // options may be a string or an object.

function createQtipContent(options) {
  if (hasTitleAndText(options)) {
    return options;
  }
  return {
    text: options.text || options
  };
}
var TextBox = _BaseInput.default.extend({
  template: _handlebarsRuntime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      return "<span class=\"input-tooltip icon form-help-16\"></span>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<span class=\"icon input-icon " + container.escapeExpression(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "params") : depth0) != null ? lookupProperty(stack1, "icon") : stack1, depth0)) + "\"></span>";
    },
    "5": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return container.escapeExpression((helper = (helper = lookupProperty(helpers, "autoComplete") || (depth0 != null ? lookupProperty(depth0, "autoComplete") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "autoComplete",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 333
          },
          "end": {
            "line": 1,
            "column": 349
          }
        }
      }) : helper));
    },
    "7": function (container, depth0, helpers, partials, data) {
      return "off";
    },
    "9": function (container, depth0, helpers, partials, data) {
      return "<span class=\"input-icon-divider\"></span>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "params") : depth0) != null ? lookupProperty(stack1, "innerTooltip") : stack1, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 87
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "params") : depth0) != null ? lookupProperty(stack1, "icon") : stack1, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 87
          },
          "end": {
            "line": 1,
            "column": 166
          }
        }
      })) != null ? stack1 : "") + "<input type=\"" + alias4((helper = (helper = lookupProperty(helpers, "type") || (depth0 != null ? lookupProperty(depth0, "type") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "type",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 179
          },
          "end": {
            "line": 1,
            "column": 187
          }
        }
      }) : helper)) + "\" placeholder=\"" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "placeholder",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 202
          },
          "end": {
            "line": 1,
            "column": 217
          }
        }
      }) : helper)) + "\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 225
          },
          "end": {
            "line": 1,
            "column": 233
          }
        }
      }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "inputId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 239
          },
          "end": {
            "line": 1,
            "column": 250
          }
        }
      }) : helper)) + "\" value=\"" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "value",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 259
          },
          "end": {
            "line": 1,
            "column": 268
          }
        }
      }) : helper)) + "\" aria-label=\"" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "placeholder",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 282
          },
          "end": {
            "line": 1,
            "column": 297
          }
        }
      }) : helper)) + "\" autocomplete=\"" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "autoComplete") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(5, data, 0),
        "inverse": container.program(7, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 313
          },
          "end": {
            "line": 1,
            "column": 367
          }
        }
      })) != null ? stack1 : "") + "\" />" + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "params") : depth0) != null ? lookupProperty(stack1, "iconDivider") : stack1, {
        "name": "if",
        "hash": {},
        "fn": container.program(9, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 371
          },
          "end": {
            "line": 1,
            "column": 444
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  /**
   * @Override
   */
  events: {
    'input input': 'update',
    'change input': 'update',
    'keydown input': 'update',
    'compositionend input': function () {
      this.isComposing = false;
    },
    'compositionstart input': function () {
      this.isComposing = true;
    },
    'keyup input': function (e) {
      if (_Keys.default.isEnter(e) && !(window.okta && window.okta.enableIMESupport)) {
        this.model.trigger('form:save');
      } else if (_Keys.default.isEsc(e)) {
        this.model.trigger('form:cancel');
      }
    }
  },
  hasIMESupport: true,
  constructor: function () {
    _BaseInput.default.apply(this, arguments);
    this.$el.addClass('o-form-control');
  },
  /**
   * @Override
   */
  editMode: function () {
    this.$el.addClass(className);
    _BaseInput.default.prototype.editMode.apply(this, arguments);
    this.$('input').placeholder();
  },
  /**
   * @Override
   */
  readMode: function () {
    _BaseInput.default.prototype.readMode.apply(this, arguments);
    this.$el.addClass('no-translate');
    if (this.options.type === 'password') {
      this.$el.text('********');
    }
    this.$el.removeClass(className);
  },
  /**
   * @Override
   */
  val: function () {
    let inputValue = this.$('input[type="' + this.options.type + '"]').val(); //IE will only read clear text pw if type="password" is explicitly in selector

    if (this.options.type !== 'password') {
      inputValue = _jqueryWrapper.default.trim(inputValue);
    }
    return inputValue;
  },
  /**
   * @Override
   */
  focus: function () {
    return this.$('input').focus();
  },
  postRender: function () {
    const {
      params: params
    } = this.options;
    if (params && params.innerTooltip) {
      const content = createQtipContent(params.innerTooltip);
      this.$('.input-tooltip').qtip({
        content: content,
        style: {
          classes: 'okta-tooltip qtip-custom qtip-shadow'
        },
        position: {
          my: 'bottom left',
          // Note: qTip2 has a known issue calculating the tooltip offset when:
          // 1. A container element has both:
          //    a) position: relative/absolute
          //    b) overlay: value other than 'visible'
          // 2. The page is scrolled
          //
          // We set position:relative and overlay:auto on the body element,
          // where both are required for:
          // - Positioning the footer correctly
          // - Displaying long pages in embedded browsers
          //
          // The original design called for a fixed position relative to the
          // tooltip icon - this has been switched to "relative to mouse, and
          // update position when mouse moves" because of this constraint.
          target: 'mouse',
          adjust: {
            method: 'flip',
            mouse: true,
            y: -5,
            x: 5
          },
          viewport: (0, _jqueryWrapper.default)('body')
        }
      });
    }
  }
});
exports["default"] = TextBox;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/TextBoxSet.js":
/*!**************************************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/TextBoxSet.js ***!
  \**************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../../../../../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ../../../util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _SchemaUtil = _interopRequireDefault(__webpack_require__(/*! ../../../util/SchemaUtil.js */ "./packages/@okta/courage-dist/esm/src/courage/util/SchemaUtil.js"));
var _BaseInput = _interopRequireDefault(__webpack_require__(/*! ../BaseInput.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/BaseInput.js"));
var _DeletableBox = _interopRequireDefault(__webpack_require__(/*! ./DeletableBox.js */ "./packages/@okta/courage-dist/esm/src/courage/views/forms/inputs/DeletableBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TextBoxSet = _BaseInput.default.extend({
  className: 'array-input',
  template: _handlebarsRuntime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<a href=\"#\" class=\"array-inputs-button link-button\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "courage",
          "code": "oform.add.another"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 52
          },
          "end": {
            "line": 1,
            "column": 102
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  params: {
    itemType: 'string'
  },
  events: {
    'click .array-inputs-button': function (e) {
      e.preventDefault();
      if (this.isEditMode()) {
        this.addNewElement();
      }
    }
  },
  initialize: function (options) {
    options || (options = {});
    this.params = _underscoreWrapper.default.defaults(options.params || {}, this.params);
    this.uniqueIdPrefix = 'array';
  },
  // api returns null for an array that does not have value
  // convert it to an empty array
  from: function (val) {
    if (!_underscoreWrapper.default.isArray(val)) {
      return [];
    }
    return val;
  },
  // @Override
  editMode: function () {
    this._setArrayObject();
    this.$el.html(this.template);
    _underscoreWrapper.default.each(this.arrayObject, _underscoreWrapper.default.bind(this._addDeletableBox, this));
    return this;
  },
  // @Override
  readMode: function () {
    this.editMode();
    this.$('.array-inputs-button').addClass('link-button-disabled');
  },
  // @Override
  // converts arrayObject to a plain array
  // for string type array, returns all values
  // for number/integer type array, returns values in number type
  val: function () {
    let values = _underscoreWrapper.default.values(this.arrayObject);
    if (_underscoreWrapper.default.contains([_SchemaUtil.default.DATATYPE.number, _SchemaUtil.default.DATATYPE.integer], this.params.itemType)) {
      values = _underscoreWrapper.default.filter(values, _underscoreWrapper.default.isNumber);
    }
    return values;
  },
  focus: function () {},
  addNewElement: function () {
    const value = '';
    const key = _underscoreWrapper.default.uniqueId(this.uniqueIdPrefix);
    this.arrayObject[key] = value;
    this._addDeletableBox(value, key); // update is called to make sure an empty string value is added for string type array

    this.update();
  },
  _addDeletableBox: function (value, key) {
    const deletableBox = new _DeletableBox.default(_underscoreWrapper.default.extend(_underscoreWrapper.default.pick(this.options, 'read', 'readOnly', 'model'), {
      key: key,
      value: value,
      itemType: this.params.itemType
    }));
    this.listenTo(deletableBox, 'updateArray', function (updatedValue) {
      if (_underscoreWrapper.default.isNull(updatedValue)) {
        delete this.arrayObject[key];
        this.stopListening(deletableBox);
      } else {
        this.arrayObject[key] = updatedValue;
      }
      this.update();
    });
    deletableBox.render().$el.hide();
    this.$('.array-inputs-button').before(deletableBox.el);
    deletableBox.$el.slideDown();
    return deletableBox;
  },
  _setArrayObject: function () {
    const array = this.model.get(this.options.name);
    this.arrayObject = {};
    if (_underscoreWrapper.default.isArray(array) && !_underscoreWrapper.default.isEmpty(array)) {
      const keys = [];
      const self = this;
      (0, _underscoreWrapper.default)(array.length).times(function () {
        keys.push(_underscoreWrapper.default.uniqueId(self.uniqueIdPrefix));
      });
      this.arrayObject = _underscoreWrapper.default.object(keys, array);
    }
  }
});
exports["default"] = TextBoxSet;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/empty.js":
/*!******************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/empty.js ***!
  \******************************************************/
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
// TODO: maybe replaced by
// https://github.com/Calvein/empty-module
// https://github.com/crimx/empty-module-loader
var ConfirmationDialog = {
  extend: () => {}
};
exports["default"] = ConfirmationDialog;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/index.js":
/*!******************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/index.js ***!
  \******************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "$", ({
  enumerable: true,
  get: function () {
    return _jqueryWrapper.default;
  }
}));
Object.defineProperty(exports, "Backbone", ({
  enumerable: true,
  get: function () {
    return _backbone.default;
  }
}));
Object.defineProperty(exports, "BaseModel", ({
  enumerable: true,
  get: function () {
    return _BaseModel.default;
  }
}));
Object.defineProperty(exports, "Collection", ({
  enumerable: true,
  get: function () {
    return _CourageForSigninWidget.Collection;
  }
}));
Object.defineProperty(exports, "Controller", ({
  enumerable: true,
  get: function () {
    return _CourageForSigninWidget.Controller;
  }
}));
Object.defineProperty(exports, "Form", ({
  enumerable: true,
  get: function () {
    return _CourageForSigninWidget.Form;
  }
}));
Object.defineProperty(exports, "FrameworkView", ({
  enumerable: true,
  get: function () {
    return _View.default;
  }
}));
Object.defineProperty(exports, "Handlebars", ({
  enumerable: true,
  get: function () {
    return _handlebarsRuntime.default;
  }
}));
Object.defineProperty(exports, "ListView", ({
  enumerable: true,
  get: function () {
    return _BackboneListView.default;
  }
}));
Object.defineProperty(exports, "Model", ({
  enumerable: true,
  get: function () {
    return _Model2.default;
  }
}));
Object.defineProperty(exports, "Router", ({
  enumerable: true,
  get: function () {
    return _CourageForSigninWidget.Router;
  }
}));
Object.defineProperty(exports, "View", ({
  enumerable: true,
  get: function () {
    return _CourageForSigninWidget.View;
  }
}));
Object.defineProperty(exports, "_", ({
  enumerable: true,
  get: function () {
    return _underscoreWrapper.default;
  }
}));
Object.defineProperty(exports, "createButton", ({
  enumerable: true,
  get: function () {
    return _CourageForSigninWidget.createButton;
  }
}));
Object.defineProperty(exports, "createCallout", ({
  enumerable: true,
  get: function () {
    return _CourageForSigninWidget.createCallout;
  }
}));
Object.defineProperty(exports, "internal", ({
  enumerable: true,
  get: function () {
    return _CourageForSigninWidget.internal;
  }
}));
Object.defineProperty(exports, "isModelPropertySchema", ({
  enumerable: true,
  get: function () {
    return _Model.isModelPropertySchema;
  }
}));
Object.defineProperty(exports, "loc", ({
  enumerable: true,
  get: function () {
    return _CourageForSigninWidget.loc;
  }
}));
Object.defineProperty(exports, "registerInput", ({
  enumerable: true,
  get: function () {
    return _CourageForSigninWidget.registerInput;
  }
}));
var _CourageForSigninWidget = __webpack_require__(/*! ./CourageForSigninWidget.js */ "./packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js");
var _Model = __webpack_require__(/*! ./courage/framework/Model.js */ "./packages/@okta/courage-dist/esm/src/courage/framework/Model.js");
var _backbone = _interopRequireDefault(__webpack_require__(/*! ./courage/vendor/lib/backbone.js */ "./packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js"));
var _jqueryWrapper = _interopRequireDefault(__webpack_require__(/*! ./courage/util/jquery-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js"));
var _underscoreWrapper = _interopRequireDefault(__webpack_require__(/*! ./courage/util/underscore-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js"));
var _handlebarsRuntime = _interopRequireDefault(__webpack_require__(/*! ../lib/handlebars/dist/cjs/handlebars.runtime.js */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _Model2 = _interopRequireDefault(__webpack_require__(/*! ./courage/models/Model.js */ "./packages/@okta/courage-dist/esm/src/courage/models/Model.js"));
var _BaseModel = _interopRequireDefault(__webpack_require__(/*! ./courage/models/BaseModel.js */ "./packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js"));
var _View = _interopRequireDefault(__webpack_require__(/*! ./courage/framework/View.js */ "./packages/@okta/courage-dist/esm/src/courage/framework/View.js"));
var _BackboneListView = _interopRequireDefault(__webpack_require__(/*! ./courage/views/Backbone.ListView.js */ "./packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./packages/@okta/courage-dist/esm/src/util/scrollParent.js":
/*!******************************************************************!*\
  !*** ./packages/@okta/courage-dist/esm/src/util/scrollParent.js ***!
  \******************************************************************/
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _jqueryWrapper = _interopRequireDefault(__webpack_require__(/*! ../courage/util/jquery-wrapper.js */ "./packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * jQuery UI Scroll Parent @VERSION
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * Modifications Copyright 2021 Okta, Inc.
 */
// This is required because SIW doesn't want to include jqueryui even though it's an external dependency of courage

_jqueryWrapper.default.fn.scrollParent = function (includeHidden) {
  const position = this.css("position"),
    excludeStaticParent = position === "absolute",
    overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
    scrollParent = this.parents().filter(function () {
      const parent = (0, _jqueryWrapper.default)(this);
      if (excludeStaticParent && parent.css("position") === "static") {
        return false;
      }
      return overflowRegex.test(parent.css("overflow") + parent.css("overflow-y") + parent.css("overflow-x"));
    }).eq(0);
  return position === "fixed" || !scrollParent.length ? (0, _jqueryWrapper.default)(this[0].ownerDocument || document) : scrollParent;
};

/***/ }),

/***/ "./packages/vendor/TypingDnaRecorder-JavaScript/typingdna.js":
/*!*******************************************************************!*\
  !*** ./packages/vendor/TypingDnaRecorder-JavaScript/typingdna.js ***!
  \*******************************************************************/
/***/ (function(module) {

/*
 * Checking in as there is no npm module to consume. 
 * Current version is 2.15.
 * Repo - https://github.com/TypingDNA/TypingDnaRecorder-JavaScript
 */

/**
 * TypingDNA - Typing Biometrics JavaScript API
 * https://api.typingdna.com/scripts/typingdna.js
 * https://typingdna.com/scripts/typingdna.js (alternative)
 *
 * @version 2.15
 * @author Raul Popa
 * @copyright SC TypingDNA SRL, http://typingdna.com
 * @license http://www.apache.org/licenses/LICENSE-2.0
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Typical usage:
 * var tdna = new TypingDNA(); // creates a new TypingDNA object and starts recording
 * var typingPattern = tdna.getTypingPattern({type=1, text="Hello5g21?*"});
 * returns a type 1 typing pattern (and continues recording afterwards)
 *
 * Optional:
 * tdna.stop(); // ends recording and clears history stack (returns recording flag: false)
 * tdna.start(); // restarts the recording after a stop (returns recording flag: true)
 * tdna.reset(); // restarts the recording anytime, clears history stack and starts from scratch (returns nothing)
 * var typingPatternQuality = TypingDNA.getQuality(typingPattern); //returns the quality/strength of any typing pattern
 * (there is no need to initialize the class to do pattern quality checking)
 */

/**
 * Creates a single instance (or a reference) of the TypingDNA class
 * @return {Object} Returns the single instance of the TypingDNA class.
 * @example var tdna = new TypingDNA();
 */
module.exports = function TypingDNA() {
  if (TypingDNA.initialized != true) {
    TypingDNA.prototype.start = function () {
      return TypingDNA.start.apply(this, arguments);
    };
    TypingDNA.prototype.stop = function () {
      return TypingDNA.stop.apply(this, arguments);
    };
    TypingDNA.prototype.reset = function () {
      return TypingDNA.reset.apply(this, arguments);
    };
    TypingDNA.prototype.addTarget = function () {
      return TypingDNA.addTarget.apply(this, arguments);
    };
    TypingDNA.prototype.removeTarget = function () {
      return TypingDNA.removeTarget.apply(this, arguments);
    };
    TypingDNA.prototype.getTypingPattern = function () {
      return TypingDNA.getTypingPattern.apply(this, arguments);
    };
    TypingDNA.prototype.get = function () {
      // still works but will be deprecated in favor of getTypignPattern()
      return TypingDNA.get.apply(this, arguments);
    };
    TypingDNA.prototype.startDiagram = function () {
      // deprecated in favor of start()
      //return TypingDNA.startDiagram.apply(this, arguments);
    };
    TypingDNA.prototype.stopDiagram = function () {
      // deprecated in favor of stop()
      //return TypingDNA.stopDiagram.apply(this, arguments);
    };
    TypingDNA.prototype.getDiagram = function () {
      // still works but will be deprecated in favor of getTypignPattern()
      return TypingDNA.getDiagram.apply(this, arguments);
    };
    TypingDNA.prototype.getExtendedDiagram = function () {
      // still works but will be deprecated in favor of getTypignPattern()
      return TypingDNA.getExtendedDiagram.apply(this, arguments);
    };
    TypingDNA.prototype.getMouseDiagram = function () {
      return TypingDNA.getMouseDiagram.apply(this, arguments);
    };
    TypingDNA.prototype.startMouse = function () {
      return TypingDNA.startMouse.apply(this, arguments);
    };
    TypingDNA.prototype.stopMouse = function () {
      return TypingDNA.stopMouse.apply(this, arguments);
    };
    TypingDNA.prototype.getQuality = function () {
      return TypingDNA.getQuality.apply(this, arguments);
    };
    TypingDNA.prototype.getLength = function () {
      return TypingDNA.getLength.apply(this, arguments);
    };
    TypingDNA.prototype.isMobile = function () {
      return TypingDNA.isMobile.apply(this, arguments);
    };
    TypingDNA.prototype.getTextId = function () {
      return TypingDNA.getTextId.apply(this, arguments);
    };
    TypingDNA.initialized = true;
    TypingDNA.prototype.maxHistoryLength = TypingDNA.maxHistoryLength;
    TypingDNA.prototype.defaultHistoryLength = TypingDNA.defaultHistoryLength;
    TypingDNA.prototype.maxSeekTime = TypingDNA.maxSeekTime;
    TypingDNA.prototype.maxPressTime = TypingDNA.maxPressTime;
    TypingDNA.version = 2.15;
    TypingDNA.flags = 0;
    TypingDNA.instance = this;
    TypingDNA.document = document;
    TypingDNA.maxHistoryLength = 2000;
    TypingDNA.maxSeekTime = 1500;
    TypingDNA.maxPressTime = 300;
    TypingDNA.defaultHistoryLength = 160;
    TypingDNA.spKeyCodes = [8, 13, 32];
    TypingDNA.spKeyCodesObj = {
      8: 1,
      13: 1,
      32: 1
    };
    TypingDNA.keyCodes = [65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 32, 222, 188, 190, 186, 187, 189, 191, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
    TypingDNA.keyCodesObj = {};
    for (var i in TypingDNA.keyCodes) {
      TypingDNA.keyCodesObj[TypingDNA.keyCodes[i]] = 1;
    }
    TypingDNA.pt1 = TypingDNA.ut1 = new Date().getTime();
    TypingDNA.wfk = [];
    TypingDNA.sti = [];
    TypingDNA.skt = [];
    TypingDNA.recording = true;
    TypingDNA.mouseRecording = true;
    TypingDNA.mouseMoveRecording = false;
    TypingDNA.spKeyRecording = true;
    TypingDNA.diagramRecording = true;
    TypingDNA.dwfk = [];
    TypingDNA.dsti = [];
    TypingDNA.dskt = [];
    TypingDNA.drkc = [];
    TypingDNA.dlastDownKey;
    TypingDNA.prevKeyCode = 0;
    TypingDNA.maxMoveDeltaTime = 600;
    TypingDNA.maxScrollDeltaTime = 800;
    TypingDNA.maxStopTime = 1500;
    TypingDNA.maxClickTime = 600;
    TypingDNA.maxMouseHistoryLength = 500;
    TypingDNA.lastMouseMoveTime = TypingDNA.lastMouseDownTime = new Date().getTime();
    TypingDNA.stopTimes = [];
    TypingDNA.clickTimes = [];
    TypingDNA.lastMouseStop = true;
    TypingDNA.zl = 0.0000001;
    TypingDNA.isAndroidChrome = false;
    TypingDNA.ACLastTime = new Date().getTime();
    TypingDNA.ACSeekTime = 0;
    TypingDNA.ACPressTime = 0;
    TypingDNA.ACLastCharCode = 0;
    TypingDNA.ACLastKeyCode = 0;
    TypingDNA.ACInputLengths = {
      inputs: [],
      lastLength: []
    };
    TypingDNA.ACPreviousKeyCode = 0;
    TypingDNA.targetIds = [];
    TypingDNA.lastTarget = "";
    TypingDNA.lastTargetFound = false;
    TypingDNA.replaceMissingKeys = true;
    TypingDNA.replaceMissingKeysPerc = 7;
    TypingDNA.keyDown = function (e) {
      if (!TypingDNA.recording && !TypingDNA.diagramRecording) {
        return;
      }
      if (!TypingDNA.isTarget(e.target.id)) {
        return;
      }
      var keyCode = e.keyCode;
      if (TypingDNA.wfk[keyCode] == 1 || TypingDNA.dwfk[keyCode] == 1) {
        //return;
      }
      if (keyCode == 229 && TypingDNA.isMobile() && !TypingDNA.isAndroidChrome) {
        TypingDNA.isAndroidChrome = true;
        TypingDNA.ACSeekTime = new Date().getTime() - TypingDNA.ACLastTime;
        TypingDNA.ACLastTime = new Date().getTime();
        TypingDNA.document.removeEventListener("keydown", TypingDNA.keyDown);
        TypingDNA.document.removeEventListener("keyup", TypingDNA.keyUp);
        TypingDNA.document.removeEventListener("keypress", TypingDNA.keyPress);

        // if android
        TypingDNA.document.addEventListener("keydown", TypingDNA.ACKeyDown);
        TypingDNA.document.addEventListener("keyup", TypingDNA.ACKeyUp);
      } else {
        var t0 = TypingDNA.pt1;
        TypingDNA.pt1 = new Date().getTime();
        var seekTotal = TypingDNA.pt1 - t0;
        var startTime = TypingDNA.pt1;
        if (TypingDNA.recording == true || TypingDNA.spKeyCodesObj[keyCode] && TypingDNA.spKeyRecording == true) {
          if (!e.shiftKey || TypingDNA.isMobile()) {
            TypingDNA.wfk[keyCode] = 1;
            TypingDNA.skt[keyCode] = seekTotal;
            TypingDNA.sti[keyCode] = startTime;
          }
        }
        if (TypingDNA.diagramRecording == true) {
          TypingDNA.dwfk[keyCode] = 1;
          TypingDNA.dskt[keyCode] = seekTotal;
          TypingDNA.dsti[keyCode] = startTime;
          TypingDNA.dlastDownKey = keyCode;
        }
      }
    };
    TypingDNA.keyPress = function (e) {
      if (!TypingDNA.recording && !TypingDNA.diagramRecording) {
        return;
      }
      if (!TypingDNA.isTarget(e.target.id)) {
        return;
      }
      if (TypingDNA.diagramRecording == true) {
        var keyCode = TypingDNA.dlastDownKey;
        TypingDNA.drkc[keyCode] = e.charCode;
      }
    };
    TypingDNA.keyUp = function (e) {
      if (!TypingDNA.recording && !TypingDNA.diagramRecording) {
        return;
      }
      if (!TypingDNA.isTarget(e.target.id)) {
        return;
      }
      var ut = new Date().getTime();
      var keyCode = e.keyCode;
      if (TypingDNA.recording == true || TypingDNA.spKeyCodesObj[keyCode] && TypingDNA.spKeyRecording == true) {
        if (!e.shiftKey || TypingDNA.isMobile()) {
          if (TypingDNA.wfk[keyCode] == 1) {
            var pressTime = ut - TypingDNA.sti[keyCode];
            var seekTime = TypingDNA.skt[keyCode];
            var arr = [keyCode, seekTime, pressTime, TypingDNA.prevKeyCode, ut, e.target.id];
            TypingDNA.history.add(arr);
            TypingDNA.prevKeyCode = keyCode;
          }
        }
        TypingDNA.wfk[keyCode] = 0;
      }
      if (TypingDNA.diagramRecording == true) {
        if (TypingDNA.drkc[keyCode] != undefined && TypingDNA.drkc[keyCode] != 0) {
          if (TypingDNA.dwfk[keyCode] == 1) {
            var pressTime = ut - TypingDNA.dsti[keyCode];
            var seekTime = TypingDNA.dskt[keyCode];
            var realKeyCode = TypingDNA.drkc[keyCode];
            var arrD = [keyCode, seekTime, pressTime, realKeyCode, ut, e.target.id];
            TypingDNA.history.addDiagram(arrD);
          }
        }
        TypingDNA.dwfk[keyCode] = 0;
      }
    };
    TypingDNA.mouseScroll = function (e) {
      if (TypingDNA.mouseRecording == true) {
        if (TypingDNA.mouseMoveRecording == true) {
          if (TypingDNA.mouse.scrollStarted == true) {
            var currentTime = new Date().getTime();
            TypingDNA.mouse.scrollTimes.push(currentTime);
            TypingDNA.mouse.scrollTopArr.push(TypingDNA.document.body.scrollTop);
            clearInterval(TypingDNA.scrollInterval);
            TypingDNA.scrollInterval = setInterval(TypingDNA.mouse.checkScroll, TypingDNA.maxScrollDeltaTime);
          } else {
            TypingDNA.mouse.scrollStarted = true;
          }
        }
      }
    };
    TypingDNA.mouseMove = function (e) {
      if (TypingDNA.mouseRecording == true) {
        var currentTime = new Date().getTime();
        if (TypingDNA.mouseMoveRecording == true) {
          if (TypingDNA.mouse.started == true) {
            TypingDNA.mouse.times.push(currentTime);
            TypingDNA.mouse.xPositions.push(e.screenX);
            TypingDNA.mouse.yPositions.push(e.screenY);
            clearInterval(TypingDNA.moveInterval);
            TypingDNA.moveInterval = setInterval(TypingDNA.mouse.checkMove, TypingDNA.maxMoveDeltaTime);
          } else {
            TypingDNA.mouse.started = true;
          }
        }
        TypingDNA.lastMouseMoveTime = currentTime;
      }
    };
    TypingDNA.mouseDown = function (e) {
      if (TypingDNA.mouseRecording == true) {
        TypingDNA.mouse.checkMove();
        TypingDNA.mouse.checkScroll();
        if (e.which == 1) {
          TypingDNA.lastMouseDownTime = new Date().getTime();
          var stopTime = TypingDNA.lastMouseDownTime - TypingDNA.lastMouseMoveTime;
          if (stopTime < TypingDNA.maxStopTime && TypingDNA.lastMouseStop == false) {
            TypingDNA.stopTimes.push(stopTime);
            if (TypingDNA.mouseMoveRecording == true) {
              var eventType = 3;
              var arr = [eventType, stopTime];
              TypingDNA.mouse.history.add(arr);
              TypingDNA.lastMouseStop = true;
            }
          }
        }
      }
    };
    TypingDNA.mouseUp = function (e) {
      if (TypingDNA.mouseRecording == true) {
        if (e.which == 1) {
          var clickTime = new Date().getTime() - TypingDNA.lastMouseDownTime;
          if (clickTime < TypingDNA.maxClickTime && TypingDNA.lastMouseDownTime > TypingDNA.lastMouseMoveTime) {
            TypingDNA.clickTimes.push(clickTime);
            if (TypingDNA.mouseMoveRecording == true) {
              var eventType = 4;
              var arr = [eventType, clickTime];
              TypingDNA.mouse.history.add(arr);
            }
          }
        }
      }
    };
    TypingDNA.ACKeyDown = function (e) {
      if (!TypingDNA.recording && !TypingDNA.diagramRecording) {
        return;
      }
      TypingDNA.ACSeekTime = new Date().getTime() - TypingDNA.ACLastTime;
      TypingDNA.ACLastTime = new Date().getTime();
      if (!TypingDNA.isTarget(e.target.id)) {
        return;
      }
      if (TypingDNA.ACInputLengths.inputs.indexOf(e.target) === -1) {
        TypingDNA.ACInputLengths.inputs.push(e.target);
        TypingDNA.ACInputLengths.lastLength.push(0);
      }
    };
    TypingDNA.ACKeyUp = function (e) {
      if (!TypingDNA.recording && !TypingDNA.diagramRecording) {
        return;
      }
      TypingDNA.ACPressTime = new Date().getTime() - TypingDNA.ACLastTime;
      TypingDNA.ACLastTime = new Date().getTime();
      if (!TypingDNA.isTarget(e.target.id)) {
        return;
      }
      var keyCode = e.keyCode;
      var targetIndex = TypingDNA.ACInputLengths.inputs.indexOf(e.target);
      if (targetIndex === -1) {
        TypingDNA.ACInputLengths.inputs.push(e.target);
        TypingDNA.ACInputLengths.lastLength.push(0);
        targetIndex = TypingDNA.ACInputLengths.inputs.indexOf(e.target);
      }
      if (keyCode == 229 && e.target.value.length >= TypingDNA.ACInputLengths.lastLength[targetIndex]) {
        var char = e.target.value.substr(e.target.selectionStart - 1 || 0, 1);
        keyCode = char.toUpperCase().charCodeAt(0);
        TypingDNA.ACLastCharCode = char.charCodeAt(0);
        TypingDNA.ACLastKeyCode = char.toUpperCase().charCodeAt(0);
      }
      TypingDNA.ACInputLengths.lastLength[targetIndex] = e.target.value.length;
      var arr = [keyCode, TypingDNA.ACSeekTime, TypingDNA.ACPressTime, TypingDNA.ACPreviousKeyCode, TypingDNA.ACLastTime];
      TypingDNA.history.add(arr);
      TypingDNA.ACPreviousKeyCode = keyCode;
      if (TypingDNA.diagramRecording == true) {
        var arrD = [keyCode, TypingDNA.ACSeekTime, TypingDNA.ACPressTime, TypingDNA.ACLastCharCode];
        TypingDNA.history.addDiagram(arrD);
      }
    };
    TypingDNA.isTarget = function (target) {
      if (TypingDNA.lastTarget == target && TypingDNA.lastTargetFound) {
        return true;
      } else {
        var targetLength = TypingDNA.targetIds.length;
        var targetFound = false;
        if (targetLength > 0) {
          for (var i = 0; i < targetLength; i++) {
            if (TypingDNA.targetIds[i] == target) {
              targetFound = true;
              break;
            }
          }
          TypingDNA.lastTarget = target;
          TypingDNA.lastTargetFound = targetFound;
          return targetFound;
        } else {
          TypingDNA.lastTarget = target;
          TypingDNA.lastTargetFound = true;
          return true;
        }
      }
    };
    if (TypingDNA.document.addEventListener) {
      TypingDNA.document.addEventListener("keydown", TypingDNA.keyDown);
      TypingDNA.document.addEventListener("keyup", TypingDNA.keyUp);
      TypingDNA.document.addEventListener("keypress", TypingDNA.keyPress);
      TypingDNA.document.addEventListener("mousemove", TypingDNA.mouseMove);
      TypingDNA.document.addEventListener("mousedown", TypingDNA.mouseDown);
      TypingDNA.document.addEventListener("mouseup", TypingDNA.mouseUp);
      TypingDNA.document.addEventListener("scroll", TypingDNA.mouseScroll);
    } else if (TypingDNA.document.attachEvent) {
      TypingDNA.document.attachEvent("onkeydown", TypingDNA.keyDown);
      TypingDNA.document.attachEvent("onkeyup", TypingDNA.keyUp);
      TypingDNA.document.attachEvent("onkeypress", TypingDNA.keyPress);
      TypingDNA.document.attachEvent("onmousemove", TypingDNA.mouseMove);
      TypingDNA.document.attachEvent("onmousedown", TypingDNA.mouseDown);
      TypingDNA.document.attachEvent("onmouseup", TypingDNA.mouseUp);
      TypingDNA.document.attachEvent("onscroll", TypingDNA.mouseScroll);
    } else {
      console.log("browser not supported");
    }
    TypingDNA.mouse = {};
    TypingDNA.mouse.times = [];
    TypingDNA.mouse.xPositions = [];
    TypingDNA.mouse.yPositions = [];
    TypingDNA.mouse.scrollTimes = [];
    TypingDNA.mouse.scrollTopArr = [];
    TypingDNA.mouse.history = {};
    TypingDNA.mouse.history.stack = [];
    TypingDNA.mouse.getDistance = function (a, b) {
      return Math.sqrt(a * a + b * b);
    };
    TypingDNA.mouse.getTotalDistance = function (xPositions, yPositions) {
      var totalDistance = 0;
      var length = xPositions.length;
      for (i = 1; i < length - 1; i++) {
        var a = xPositions[i] - xPositions[i - 1];
        var b = yPositions[i] - yPositions[i - 1];
        totalDistance += TypingDNA.mouse.getDistance(a, b);
      }
      return totalDistance;
    };
    TypingDNA.mouse.getAngle = function (xPosDelta, yPosDelta) {
      var angle = 0;
      var leftRight = xPosDelta >= 0; // 1 if left, 0 if right
      var downUp = yPosDelta < 0; // 1 if down, 0 if up
      if (leftRight) {
        if (downUp) {
          angle = 180 + Math.round(Math.atan(Math.abs(xPosDelta) / (Math.abs(yPosDelta) + 0.0000001)) / 0.01745329251); // 0.01745329251 = pi/180
        } else {
          angle = 270 + (90 - Math.round(Math.atan(Math.abs(xPosDelta) / (Math.abs(yPosDelta) + 0.0000001)) / 0.01745329251));
        }
      } else {
        if (downUp) {
          angle = 90 + (90 - Math.round(Math.atan(Math.abs(xPosDelta) / (Math.abs(yPosDelta) + 0.0000001)) / 0.01745329251));
        } else {
          angle = Math.round(Math.atan(Math.abs(xPosDelta) / (Math.abs(yPosDelta) + 0.0000001)) / 0.01745329251);
        }
      }
      return angle;
    };
    TypingDNA.mouse.recordMoveAction = function () {
      var length = TypingDNA.mouse.times.length;
      if (length < 3) {
        return;
      }
      var deltaTime = TypingDNA.mouse.times[length - 1] - TypingDNA.mouse.times[0];
      var xPosDelta = TypingDNA.mouse.xPositions[length - 1] - TypingDNA.mouse.xPositions[0];
      var yPosDelta = TypingDNA.mouse.yPositions[length - 1] - TypingDNA.mouse.yPositions[0];
      var directDistance = Math.round(TypingDNA.mouse.getDistance(xPosDelta, yPosDelta));
      var totalDistance = Math.round(TypingDNA.mouse.getTotalDistance(TypingDNA.mouse.xPositions, TypingDNA.mouse.yPositions));
      var ratioDistance = Math.round(totalDistance * 100 / directDistance);
      var speed = Math.round(directDistance * 100 / deltaTime);
      var angle = TypingDNA.mouse.getAngle(xPosDelta, yPosDelta);
      var eventType = 1;
      var arr = [eventType, deltaTime, directDistance, speed, angle, ratioDistance];
      for (i in arr) {
        if (isNaN(arr[i])) {
          return;
        }
      }
      TypingDNA.mouse.history.add(arr);
      TypingDNA.lastMouseStop = false;
    };
    TypingDNA.mouse.recordScrollAction = function () {
      var length = TypingDNA.mouse.scrollTimes.length;
      if (length < 2) {
        return;
      }
      var deltaTime = TypingDNA.mouse.scrollTimes[length - 1] - TypingDNA.mouse.scrollTimes[0];
      var directDistance = TypingDNA.mouse.scrollTopArr[length - 1] - TypingDNA.mouse.scrollTopArr[0];
      var speed = Math.round(directDistance * 100 / deltaTime);
      var eventType = 2;
      var arr = [eventType, deltaTime, directDistance, speed];
      for (i in arr) {
        if (isNaN(arr[i]) && !isFinite(arr[i])) {
          return;
        }
      }
      TypingDNA.mouse.history.add(arr);
    };
    TypingDNA.mouse.history.add = function (arr) {
      this.stack.push(arr);
      if (this.stack.length > TypingDNA.maxMouseHistoryLength) {
        this.stack.shift();
      }
    };
    TypingDNA.mouse.history.getDiagram = function () {
      var mouseDiagram = this.stack.join("|");
      return [String(TypingDNA.isMobile()) + "," + String(TypingDNA.version), mouseDiagram].join("|");
    };
    TypingDNA.mouse.clearLastMove = function () {
      TypingDNA.mouse.times = [];
      TypingDNA.mouse.xPositions = [];
      TypingDNA.mouse.yPositions = [];
    };
    TypingDNA.mouse.checkMove = function () {
      clearInterval(TypingDNA.moveInterval);
      if (TypingDNA.mouse.started == true) {
        TypingDNA.mouse.started = false;
        TypingDNA.mouse.recordMoveAction();
        TypingDNA.mouse.clearLastMove();
      }
    };
    TypingDNA.mouse.clearLastScroll = function () {
      TypingDNA.mouse.scrollTimes = [];
      TypingDNA.mouse.scrollTopArr = [];
    };
    TypingDNA.mouse.checkScroll = function () {
      clearInterval(TypingDNA.scrollInterval);
      if (TypingDNA.mouse.scrollStarted == true) {
        TypingDNA.mouse.scrollStarted = false;
        TypingDNA.mouse.recordScrollAction();
        TypingDNA.mouse.clearLastScroll();
      }
    };

    /**
     * Adds a target to the targetIds array.
     */
    TypingDNA.addTarget = function (target) {
      var targetLength = TypingDNA.targetIds.length;
      var targetFound = false;
      if (targetLength > 0) {
        for (var i = 0; i < targetLength; i++) {
          if (TypingDNA.targetIds[i] == target) {
            targetFound = true;
            break;
          }
        }
        if (!targetFound) {
          TypingDNA.targetIds.push(target);
        }
      } else {
        TypingDNA.targetIds.push(target);
      }
    };

    /**
     * Adds a target to the targetIds array.
     */
    TypingDNA.removeTarget = function (target) {
      var targetLength = TypingDNA.targetIds.length;
      if (targetLength > 0) {
        for (var i = 0; i < targetLength; i++) {
          if (TypingDNA.targetIds[i] == target) {
            TypingDNA.targetIds.splice(i, 1);
            break;
          }
        }
      }
    };

    /**
     * Resets the history stack
     */
    TypingDNA.reset = function (all) {
      TypingDNA.history.stack = [];
      TypingDNA.history.stackDiagram = [];
      TypingDNA.clickTimes = [];
      TypingDNA.stopTimes = [];
      TypingDNA.ACInputLengths = {
        inputs: [],
        lastLength: []
      };
      if (all == true) {
        TypingDNA.mouse.history.stack = [];
      }
    };

    /**
     * Automatically called at initilization. It starts the recording of keystrokes.
     */
    TypingDNA.start = function () {
      TypingDNA.diagramRecording = true;
      return TypingDNA.recording = true;
    };

    /**
     * Ends the recording of further keystrokes. To restart recording afterwards you can
     * either call TypingDNA.start() or create a new TypingDNA object again, not recommended.
     */
    TypingDNA.stop = function () {
      TypingDNA.diagramRecording = false;
      return TypingDNA.recording = false;
    };

    /**
     * Starts the recording of mouse activity.
     */
    TypingDNA.startMouse = function () {
      return TypingDNA.mouseRecording = TypingDNA.mouseMoveRecording = true;
    };

    /**
     * Stops the recording of mouse activity.
     */
    TypingDNA.stopMouse = function () {
      return TypingDNA.mouseRecording = TypingDNA.mouseMoveRecording = false;
    };

    /**
     * This is the main function that outputs the typing pattern as a String
     * {type:Number, text:String, textId:Number, length: Number, targetId:String, caseSensitive:Boolean}
     * @param {Object} obj an object with the following properties
     * * * @param {String} type 0 for anytext pattern, 1 for sametext pattern (also called diagram pattern)
     * * * and 2 for extended pattern (most versatile, can replace both anytext and sametext patterns)
     * * * @param {Number} length (Optional) the length of the text in the history for which you want
     * * * the typing pattern. length is ignored when text or targetId is set (or both).
     * * * @param {String} text  (Only for type 1 and type 2) a typed string that you want the typing pattern for
     * * * @param {Number} textId (Optional, only for type 1 and type 2) a personalized id for the typed text
     * * * @param {String} targetId (Optional) specifies if pattern is obtain only from text typed in a certain target
     * * * @param {Boolean} caseSensitive (Optional, default: false) Used if you pass a text for type 1 or type 2
     * * * DEPRECATED * * * in favor of type = 2 * * *
     * * * @param {Boolean} extended (Only for type 1) specifies if full information about what was typed is produced,
     * * * including the actual key pressed, if false, only the order of pressed keys is kept (no actual content)
     * @return {String} A typing pattern in string form
     * @example var typingPattern = tdna.getTypingPattern({type=0, length=180});
     * @example var typingPattern = tdna.getTypingPattern({type=1, text="Hello5g21?*"});
     * @example var typingPattern = tdna.getTypingPattern({type=2, text="example@mail.com"});
     */
    TypingDNA.getTypingPattern = function (obj) {
      if (typeof obj === 'object') {
        switch (obj.type) {
          case 0:
            return TypingDNA.get(obj.length, obj.targetId);
            break;
          case 1:
            var str = obj.text != undefined ? obj.text : obj.length;
            return TypingDNA.history.getDiagram(obj.extended, str, obj.textId, obj.targetId, obj.caseSensitive);
            break;
          case 2:
            var str = obj.text != undefined ? obj.text : obj.length;
            return TypingDNA.history.getDiagram(true, str, obj.textId, obj.targetId, obj.caseSensitive);
            break;
          default:
            return TypingDNA.get(obj.length);
            break;
        }
      } else {
        return TypingDNA.get();
      }
    };
    TypingDNA.getDiagram = function (str, textId) {
      return TypingDNA.history.getDiagram(false, str, textId, undefined, false);
    };
    TypingDNA.getExtendedDiagram = function (str, textId) {
      return TypingDNA.history.getDiagram(true, str, textId, undefined, false);
    };
    TypingDNA.getMouseDiagram = function () {
      return TypingDNA.mouse.history.getDiagram();
    };
    TypingDNA.get = function (length, targetId) {
      var historyTotalLength = TypingDNA.history.stack.length;
      if (length == undefined || length == 0) {
        length = TypingDNA.defaultHistoryLength;
      }
      if (length > historyTotalLength) {
        length = historyTotalLength;
      }
      var obj = {};
      [obj.arr, targetLength] = TypingDNA.history.get(length, "", targetId);
      if (targetId != undefined && targetId != "") {
        length = targetLength;
      }
      var zl = TypingDNA.zl;
      var histRev = length;
      var histSktF = TypingDNA.math.fo(TypingDNA.history.get(length, "seek", targetId));
      var histPrtF = TypingDNA.math.fo(TypingDNA.history.get(length, "press", targetId));
      var pressHistMean = Math.round(TypingDNA.math.avg(histPrtF));
      var seekHistMean = Math.round(TypingDNA.math.avg(histSktF));
      var pressHistSD = Math.round(TypingDNA.math.sd(histPrtF));
      var seekHistSD = Math.round(TypingDNA.math.sd(histSktF));
      var charMeanTime = seekHistMean + pressHistMean;
      var pressRatio = TypingDNA.math.rd((pressHistMean + zl) / (charMeanTime + zl), 4);
      var seekToPressRatio = TypingDNA.math.rd((1 - pressRatio) / pressRatio, 4);
      var pressSDToPressRatio = TypingDNA.math.rd((pressHistSD + zl) / (pressHistMean + zl), 4);
      var seekSDToPressRatio = TypingDNA.math.rd((seekHistSD + zl) / (pressHistMean + zl), 4);
      var cpm = Math.round(6E4 / (charMeanTime + zl));
      if (histRev == 0) {
        cpm = 0;
      }
      for (var i in obj.arr) {
        var rev = obj.arr[i][1].length;
        var seekMean = 0;
        var pressMean = 0;
        var postMean = 0;
        var seekSD = 0;
        var pressSD = 0;
        var postSD = 0;
        switch (obj.arr[i][0].length) {
          case 0:
            break;
          case 1:
            var seekMean = TypingDNA.math.rd((obj.arr[i][0][0] + zl) / (seekHistMean + zl), 4);
            break;
          default:
            var arr = TypingDNA.math.fo(obj.arr[i][0]);
            seekMean = TypingDNA.math.rd((TypingDNA.math.avg(arr) + zl) / (seekHistMean + zl), 4);
            seekSD = TypingDNA.math.rd((TypingDNA.math.sd(arr) + zl) / (seekHistSD + zl), 4);
        }
        switch (obj.arr[i][1].length) {
          case 0:
            break;
          case 1:
            var pressMean = TypingDNA.math.rd((obj.arr[i][1][0] + zl) / (pressHistMean + zl), 4);
            break;
          default:
            var arr = TypingDNA.math.fo(obj.arr[i][1]);
            pressMean = TypingDNA.math.rd((TypingDNA.math.avg(arr) + zl) / (pressHistMean + zl), 4);
            pressSD = TypingDNA.math.rd((TypingDNA.math.sd(arr) + zl) / (pressHistSD + zl), 4);
        }
        switch (obj.arr[i][2].length) {
          case 0:
            break;
          case 1:
            var postMean = TypingDNA.math.rd((obj.arr[i][2][0] + zl) / (seekHistMean + zl), 4);
            break;
          default:
            var arr = TypingDNA.math.fo(obj.arr[i][2]);
            postMean = TypingDNA.math.rd((TypingDNA.math.avg(arr) + zl) / (seekHistMean + zl), 4);
            postSD = TypingDNA.math.rd((TypingDNA.math.sd(arr) + zl) / (seekHistSD + zl), 4);
        }
        delete obj.arr[i][2];
        delete obj.arr[i][1];
        delete obj.arr[i][0];
        obj.arr[i][0] = rev;
        obj.arr[i][1] = seekMean;
        obj.arr[i][2] = pressMean;
        obj.arr[i][3] = postMean;
        obj.arr[i][4] = seekSD;
        obj.arr[i][5] = pressSD;
        obj.arr[i][6] = postSD;
      }
      var arr = [];
      TypingDNA.apu(arr, histRev);
      TypingDNA.apu(arr, cpm);
      TypingDNA.apu(arr, charMeanTime);
      TypingDNA.apu(arr, pressRatio);
      TypingDNA.apu(arr, seekToPressRatio);
      TypingDNA.apu(arr, pressSDToPressRatio);
      TypingDNA.apu(arr, seekSDToPressRatio);
      TypingDNA.apu(arr, pressHistMean);
      TypingDNA.apu(arr, seekHistMean);
      TypingDNA.apu(arr, pressHistSD);
      TypingDNA.apu(arr, seekHistSD);
      for (var c = 0; c <= 6; c++) {
        for (var i = 0; i < 44; i++) {
          var keyCode = TypingDNA.keyCodes[i];
          var val = obj.arr[keyCode][c];
          if (val == 0 && c > 0) {
            val = 1;
          }
          TypingDNA.apu(arr, val);
        }
      }
      TypingDNA.apu(arr, TypingDNA.isMobile());
      TypingDNA.apu(arr, TypingDNA.version);
      TypingDNA.apu(arr, TypingDNA.flags);
      arr.push(TypingDNA.history.getSpecialKeys());
      return arr.join(",");
    };
    TypingDNA.apu = function (arr, val) {
      "NaN" == String(val) && (val = 0);
      arr.push(val);
    };
    TypingDNA.math = {};
    TypingDNA.math.rd = function (val, dec) {
      return Number(val.toFixed(dec));
    };
    TypingDNA.math.avg = function (arr) {
      var len = arr.length;
      if (len > 0) {
        var sum = 0;
        for (var i = 0; i < len; i++) {
          sum += arr[i];
        }
        return this.rd(sum / len, 4);
      } else {
        return 0;
      }
    };
    TypingDNA.math.sd = function (arr) {
      var len = arr.length;
      if (len < 2) {
        return 0;
      } else {
        var sumVS = 0;
        var mean = this.avg(arr);
        for (var i = 0; i < len; i++) {
          sumVS += (arr[i] - mean) * (arr[i] - mean);
        }
        var sd = Math.sqrt(sumVS / len);
        return sd;
      }
    };
    TypingDNA.math.fo = function (arr) {
      if (arr.length > 1) {
        var values = arr.concat();
        var len = arr.length;
        values.sort(function (a, b) {
          return a - b;
        });
        var asd = this.sd(values);
        var aMean = values[Math.ceil(arr.length / 2)];
        var multiplier = 2;
        var maxVal = aMean + multiplier * asd;
        var minVal = aMean - multiplier * asd;
        if (len < 20) {
          minVal = 0;
        }
        var fVal = [];
        for (var i = 0; i < len; i++) {
          var tempval = values[i];
          if (tempval < maxVal && tempval > minVal) {
            fVal.push(tempval);
          }
        }
        return fVal;
      } else {
        return arr;
      }
    };

    // Calculate a 32 bit FNV-1a hash
    TypingDNA.math.fnv1aHash = function (str) {
      if (str == undefined && typeof str !== 'string') {
        return 0;
      }
      str = str.toLowerCase();
      var i, l;
      var hval = 0x721b5ad4;
      for (i = 0, l = str.length; i < l; i++) {
        hval ^= str.charCodeAt(i);
        hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
      }
      return hval >>> 0;
    };
    TypingDNA.history = {};
    TypingDNA.history.stack = [];
    TypingDNA.history.stackDiagram = [];
    TypingDNA.history.add = function (arr) {
      this.stack.push(arr);
      if (this.stack.length > TypingDNA.maxHistoryLength) {
        this.stack.shift();
      }
    };
    TypingDNA.history.addDiagram = function (arr) {
      this.stackDiagram.push(arr);
    };
    TypingDNA.history.getDiagram = function (extended, str, textId, targetId, caseSensitive) {
      var caseSensitive = caseSensitive != undefined ? caseSensitive : str == undefined || str == "";
      var returnArr = [];
      var diagramType = extended == true ? 1 : 0;
      var stackDiagram = this.stackDiagram;
      if (targetId != undefined && targetId != "" && stackDiagram.length > 0) {
        stackDiagram = TypingDNA.sliceStackByTargetId(stackDiagram, targetId);
        if (str == undefined || str == "") {
          var element = TypingDNA.document.getElementById(targetId);
          if (element != null) {
            str = element.value;
          }
        }
      } else {
        var targetLength = TypingDNA.targetIds.length;
        if (str == undefined || str == "") {
          if (targetLength > 0) {
            str = "";
            for (var i = 0; i < targetLength; i++) {
              var element = TypingDNA.document.getElementById(TypingDNA.targetIds[i]);
              if (element != null) {
                str += element.value;
              }
            }
          } else {
            if (!extended) {
              console.log("Please use extended pattern OR provide a fixed string param OR use the addTarget method.");
            }
          }
        }
      }
      var missingCount = 0;
      var diagramHistoryLength = stackDiagram.length;
      var strLength = diagramHistoryLength;
      if (typeof str === 'string') {
        strLength = str.length;
      } else if (typeof str === 'number' && str < diagramHistoryLength) {
        strLength = str;
      }
      var returnTextId = 0;
      if (textId != undefined) {
        if (isNaN(parseInt(textId))) {
          returnTextId = TypingDNA.math.fnv1aHash(textId);
        } else {
          returnTextId = parseInt(textId);
        }
      } else {
        if (typeof str === 'string') {
          returnTextId = TypingDNA.math.fnv1aHash(str);
        }
      }
      returnArr.push([TypingDNA.isMobile(), TypingDNA.version, TypingDNA.flags, diagramType, strLength, returnTextId, TypingDNA.history.getSpecialKeys()]);
      if (str != undefined && str.length > 0 && typeof str === 'string') {
        var strLower = str.toLowerCase();
        var strUpper = str.toUpperCase();
        var lastFoundPos = [];
        var lastPos = 0;
        var strUpperCharCode;
        var currentSensitiveCharCode;
        for (var i = 0; i < str.length; i++) {
          var currentCharCode = str.charCodeAt(i);
          if (!caseSensitive) {
            strUpperCharCode = strUpper.charCodeAt(i);
            currentSensitiveCharCode = strUpperCharCode != currentCharCode ? strUpperCharCode : strLower.charCodeAt(i);
          }
          var startPos = lastPos;
          var finishPos = diagramHistoryLength;
          var found = false;
          while (found == false) {
            for (var j = startPos; j < finishPos; j++) {
              var arr = stackDiagram[j];
              var charCode = arr[3];
              if (charCode == currentCharCode || !caseSensitive && charCode == currentSensitiveCharCode) {
                found = true;
                if (j == lastPos) {
                  lastPos++;
                  lastFoundPos = [];
                } else {
                  lastFoundPos.push(j);
                  var len = lastFoundPos.length;
                  if (len > 1 && lastFoundPos[len - 1] == lastFoundPos[len - 2] + 1) {
                    lastPos = j + 1;
                    lastFoundPos = [];
                  }
                }
                var keyCode = arr[0];
                var seekTime = arr[1];
                var pressTime = arr[2];
                if (extended) {
                  returnArr.push([charCode, seekTime, pressTime, keyCode]);
                } else {
                  returnArr.push([seekTime, pressTime]);
                }
                break;
              }
            }
            if (found == false) {
              if (startPos != 0) {
                startPos = 0;
                finishPos = lastPos;
              } else {
                found = true;
                if (TypingDNA.replaceMissingKeys) {
                  missingCount++;
                  if (typeof TypingDNA.savedMissingAvgValues !== 'object' || TypingDNA.savedMissingAvgValues.historyLength != diagramHistoryLength) {
                    var histSktF = TypingDNA.math.fo(TypingDNA.history.get(0, "seek"));
                    var histPrtF = TypingDNA.math.fo(TypingDNA.history.get(0, "press"));
                    var seekTime = Math.round(TypingDNA.math.avg(histSktF));
                    var pressTime = Math.round(TypingDNA.math.avg(histPrtF));
                    TypingDNA.savedMissingAvgValues = {
                      seekTime: seekTime,
                      pressTime: pressTime,
                      historyLength: diagramHistoryLength
                    };
                  } else {
                    var seekTime = TypingDNA.savedMissingAvgValues.seekTime;
                    var pressTime = TypingDNA.savedMissingAvgValues.pressTime;
                  }
                  var missing = 1;
                  if (extended) {
                    returnArr.push([currentCharCode, seekTime, pressTime, currentCharCode, missing]);
                  } else {
                    returnArr.push([seekTime, pressTime, missing]);
                  }
                  break;
                }
              }
            }
          }
          if (TypingDNA.replaceMissingKeysPerc < missingCount * 100 / strLength) {
            return null;
          }
        }
      } else {
        var startCount = 0;
        if (typeof str === 'number') {
          startCount = diagramHistoryLength - str;
        }
        if (startCount < 0) {
          startCount = 0;
        }
        for (var i = startCount; i < diagramHistoryLength; i++) {
          var arr = stackDiagram[i];
          var keyCode = arr[0];
          var seekTime = arr[1];
          var pressTime = arr[2];
          if (extended) {
            var charCode = arr[3];
            returnArr.push([charCode, seekTime, pressTime, keyCode]);
          } else {
            returnArr.push([seekTime, pressTime]);
          }
        }
      }
      return returnArr.join("|");
    };
    TypingDNA.sliceStackByTargetId = function (stack, targetId) {
      var length = stack.length;
      var newStack = [];
      for (i = 0; i < length; i++) {
        var arr = stack[i];
        if (arr[5] == targetId) {
          newStack.push(arr);
        }
      }
      return newStack;
    };
    TypingDNA.history.get = function (length, type, targetId) {
      var stack = this.stack;
      if (targetId != undefined && targetId != "" && stack.length > 0) {
        stack = TypingDNA.sliceStackByTargetId(stack, targetId);
      }
      var historyTotalLength = stack.length;
      if (length == 0 || length == undefined) {
        length = TypingDNA.defaultHistoryLength;
      }
      if (length > historyTotalLength) {
        length = historyTotalLength;
      }
      switch (type) {
        case "seek":
          var seekArr = [];
          for (i = 1; i <= length; i++) {
            var seekTime = stack[historyTotalLength - i][1];
            if (seekTime <= TypingDNA.maxSeekTime) {
              seekArr.push(seekTime);
            }
          }
          ;
          return seekArr;
          break;
        case "press":
          var pressArr = [];
          for (i = 1; i <= length; i++) {
            var pressTime = stack[historyTotalLength - i][2];
            if (pressTime <= TypingDNA.maxPressTime) {
              pressArr.push(pressTime);
            }
          }
          ;
          return pressArr;
          break;
        default:
          var historyStackObj = {};
          for (var i in TypingDNA.keyCodes) {
            historyStackObj[TypingDNA.keyCodes[i]] = [[], [], []];
          }
          for (i = 1; i <= length; i++) {
            var arr = stack[historyTotalLength - i];
            var keyCode = arr[0];
            var seekTime = arr[1];
            var pressTime = arr[2];
            var prevKeyCode = arr[3];
            if (TypingDNA.keyCodesObj[keyCode]) {
              if (seekTime <= TypingDNA.maxSeekTime) {
                historyStackObj[keyCode][0].push(seekTime);
                if (prevKeyCode != 0 && TypingDNA.keyCodesObj[prevKeyCode]) {
                  historyStackObj[prevKeyCode][2].push(seekTime);
                }
              }
              if (pressTime <= TypingDNA.maxPressTime) {
                historyStackObj[keyCode][1].push(pressTime);
              }
            }
          }
          ;
          return [historyStackObj, length];
      }
    };
    TypingDNA.history.getSpecialKeys = function () {
      var returnArr = [];
      var length = this.stack.length;
      var historyStackObj = {};
      for (var i in TypingDNA.spKeyCodes) {
        historyStackObj[TypingDNA.spKeyCodes[i]] = [[]];
      }
      for (i = 1; i <= length; i++) {
        var arr = this.stack[length - i];
        if (TypingDNA.spKeyCodesObj[arr[0]]) {
          var keyCode = arr[0];
          var pressTime = arr[2];
          if (pressTime <= TypingDNA.maxPressTime) {
            historyStackObj[keyCode][0].push(pressTime);
          }
        }
      }
      for (var i in TypingDNA.spKeyCodes) {
        var arr = TypingDNA.math.fo(historyStackObj[TypingDNA.spKeyCodes[i]][0]);
        var arrLen = arr.length;
        returnArr.push(arrLen);
        if (arrLen > 1) {
          returnArr.push(Math.round(TypingDNA.math.avg(arr)));
          returnArr.push(Math.round(TypingDNA.math.sd(arr)));
        } else if (arrLen == 1) {
          returnArr.push([arr[0], -1]);
        } else {
          returnArr.push([-1, -1]);
        }
      }
      var clicksArrLen = TypingDNA.clickTimes.length;
      returnArr.push(clicksArrLen);
      if (clicksArrLen > 1) {
        returnArr.push(Math.round(TypingDNA.math.avg(TypingDNA.clickTimes)));
        returnArr.push(Math.round(TypingDNA.math.sd(TypingDNA.clickTimes)));
      } else if (clicksArrLen == 1) {
        returnArr.push(TypingDNA.clickTimes[0], -1);
      } else {
        returnArr.push([-1, -1]);
      }
      var stopArrLen = TypingDNA.stopTimes.length;
      returnArr.push(stopArrLen);
      if (stopArrLen > 1) {
        returnArr.push(Math.round(TypingDNA.math.avg(TypingDNA.stopTimes)));
        returnArr.push(Math.round(TypingDNA.math.sd(TypingDNA.stopTimes)));
      } else if (stopArrLen == 1) {
        returnArr.push(TypingDNA.stopTimes[0], -1);
      } else {
        returnArr.push([-1, -1]);
      }
      return returnArr;
    };

    /**
     * Checks the quality of a typing pattern, how well it is revelated, how useful the
     * information will be for matching applications. It returns a value between 0 and 1.
     * Values over 0.3 are acceptable, however a value over 0.7 shows good pattern strength.
     * @param  {String} typingPattern The typing pattern string returned by the get() function.
     * @return {Number} A real number between 0 and 1. A close to 1 value means a stronger pattern.
     * @example var quality = tdna.getQuality(typingPattern);
     */
    TypingDNA.getQuality = function (typingPattern) {
      var obj = typingPattern.split(",");
      for (i = 0; i < obj.length; i++) {
        obj[i] = Number(obj[i]);
      }
      var totalEvents = obj[0];
      var acc = rec = avgAcc = 0;
      var avg = TypingDNA.math.avg(obj);
      var revs = obj.slice(11, 55);
      for (var i in revs) {
        rec += Number(revs[i] > 0);
        acc += Number(revs[i] > 4);
        avgAcc += Number(revs[i] > avg);
      }
      var tReturn = Math.sqrt(rec * acc * avgAcc) / 80;
      return tReturn > 1 ? 1 : tReturn;
    };

    /**
     * Checks the validity of a typing pattern if recorded on mobile.
     * @param  {String} typingPattern The typing pattern string returned by the get() function.
     * @return {Number} A real number between 0 and 1. A number larger than 0.7 usually means a valid pattern.
     * @example var quality = tdna.checkMobileValidity(typingPattern);
     */
    TypingDNA.checkMobileValidity = function (typingPattern) {
      var obj = typingPattern.split(",");
      var totalEvents = obj[0];
      if (totalEvents == 0) {
        return 0;
      }
      var rec = 0;
      var revs = obj.slice(11, 55);
      for (var i in revs) {
        rec += Number(revs[i]);
      }
      return rec / totalEvents;
    };
    TypingDNA.getLength = function (typingPattern) {
      return Number(typingPattern.split(",")[1]);
    };
    TypingDNA.isMobile = function () {
      if (TypingDNA.mobile != undefined) {
        return TypingDNA.mobile;
      } else {
        var check = 0;
        (function (a) {
          if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = 1;
          }
        })(navigator.userAgent || navigator.vendor || window.opera);
        TypingDNA.mobile = check;
        return check;
      }
    };
    TypingDNA.getTextId = function (str) {
      return TypingDNA.math.fnv1aHash(str);
    };
  } else {
    // TypingDNA is a static class, currently doesn't support actual multiple instances (Singleton implementation)
    return TypingDNA.instance;
  }
};

/***/ }),

/***/ "./packages/vendor/duo_web_sdk/index.js":
/*!**********************************************!*\
  !*** ./packages/vendor/duo_web_sdk/index.js ***!
  \**********************************************/
/***/ (function(module) {

/**
 * 
 * This file has been modified to override doPostBack
 * Check out the doPostBack function below for more details.
 * Override the doPostBack function when upgrading.
 * Unable to make a wrapper because it is invoked using an internal name within 
 * this library.
 * 
 * Current Verison = https://github.com/duosecurity/duo_web_sdk/blob/7aec8dd895ea4bd4549069e76076850eccfe07f2/index.js
 * PS: they dont seem to version correctly hence using commit.
 */

/**
 * Duo Web SDK v2
 * Copyright 2019, Duo Security
 */

// Modified to remove AMD and support ESM transform - OKTA-369648
(function (root, factory) {
  module.exports = factory();
})(this, function () {
  var DUO_MESSAGE_FORMAT = /^(?:AUTH|ENROLL)+\|[A-Za-z0-9\+\/=]+\|[A-Za-z0-9\+\/=]+$/;
  var DUO_ERROR_FORMAT = /^ERR\|[\w\s\.\(\)]+$/;
  var DUO_OPEN_WINDOW_FORMAT = /^DUO_OPEN_WINDOW\|/;
  var VALID_OPEN_WINDOW_DOMAINS = ['duo.com', 'duosecurity.com', 'duomobile.s3-us-west-1.amazonaws.com'];
  var postAction, postArgument, host, sigRequest, duoSig, appSig, iframe, submitCallback;

  // We use this function instead of setting initial values in the var
  // declarations to make sure the initial values and subsequent
  // re-initializations are always the same.
  initializeStatefulVariables();

  /**
   * Set local variables to whatever they should be before you call init().
   */
  function initializeStatefulVariables() {
    postAction = '';
    postArgument = 'sig_response';
    host = undefined;
    sigRequest = undefined;
    duoSig = undefined;
    appSig = undefined;
    iframe = undefined;
    submitCallback = undefined;
  }
  function throwError(message, givenUrl) {
    var url = givenUrl || 'https://www.duosecurity.com/docs/duoweb#3.-show-the-iframe';
    throw new Error('Duo Web SDK error: ' + message + (url ? '\n' + 'See ' + url + ' for more information' : ''));
  }
  function hyphenize(str) {
    return str.replace(/([a-z])([A-Z])/, '$1-$2').toLowerCase();
  }

  // cross-browser data attributes
  function getDataAttribute(element, name) {
    if ('dataset' in element) {
      return element.dataset[name];
    } else {
      return element.getAttribute('data-' + hyphenize(name));
    }
  }

  // cross-browser event binding/unbinding
  function on(context, event, fallbackEvent, callback) {
    if ('addEventListener' in window) {
      context.addEventListener(event, callback, false);
    } else {
      context.attachEvent(fallbackEvent, callback);
    }
  }
  function off(context, event, fallbackEvent, callback) {
    if ('removeEventListener' in window) {
      context.removeEventListener(event, callback, false);
    } else {
      context.detachEvent(fallbackEvent, callback);
    }
  }
  function onReady(callback) {
    on(document, 'DOMContentLoaded', 'onreadystatechange', callback);
  }
  function offReady(callback) {
    off(document, 'DOMContentLoaded', 'onreadystatechange', callback);
  }
  function onMessage(callback) {
    on(window, 'message', 'onmessage', callback);
  }
  function offMessage(callback) {
    off(window, 'message', 'onmessage', callback);
  }

  /**
   * Parse the sig_request parameter, throwing errors if the token contains
   * a server error or if the token is invalid.
   *
   * @param {String} sig Request token
   */
  function parseSigRequest(sig) {
    if (!sig) {
      // nothing to do
      return;
    }

    // see if the token contains an error, throwing it if it does
    if (sig.indexOf('ERR|') === 0) {
      throwError(sig.split('|')[1]);
    }

    // validate the token
    if (sig.indexOf(':') === -1 || sig.split(':').length !== 2) {
      throwError('Duo was given a bad token.  This might indicate a configuration ' + 'problem with one of Duo\'s client libraries.');
    }
    var sigParts = sig.split(':');

    // hang on to the token, and the parsed duo and app sigs
    sigRequest = sig;
    duoSig = sigParts[0];
    appSig = sigParts[1];
    return {
      sigRequest: sig,
      duoSig: sigParts[0],
      appSig: sigParts[1]
    };
  }

  /**
   * Validate that a MessageEvent came from the Duo service, and that it
   * is a properly formatted payload.
   *
   * The Google Chrome sign-in page injects some JS into pages that also
   * make use of postMessage, so we need to do additional validation above
   * and beyond the origin.
   *
   * @param {MessageEvent} event Message received via postMessage
   */
  function isDuoMessage(event) {
    return Boolean(event.origin === 'https://' + host && typeof event.data === 'string' && (event.data.match(DUO_MESSAGE_FORMAT) || event.data.match(DUO_ERROR_FORMAT) || event.data.match(DUO_OPEN_WINDOW_FORMAT)));
  }

  /**
   * Validate the request token and prepare for the iframe to become ready.
   *
   * All options below can be passed into an options hash to `Duo.init`, or
   * specified on the iframe using `data-` attributes.
   *
   * Options specified using the options hash will take precedence over
   * `data-` attributes.
   *
   * Example using options hash:
   * ```javascript
   * Duo.init({
   *     iframe: "some_other_id",
   *     host: "api-main.duo.test",
   *     sig_request: "...",
   *     post_action: "/auth",
   *     post_argument: "resp"
   * });
   * ```
   *
   * Example using `data-` attributes:
   * ```html
   * <iframe id="duo_iframe"
   *         data-host="api-main.duo.test"
   *         data-sig-request="..."
   *         data-post-action="/auth"
   *         data-post-argument="resp"
   *         >
   * </iframe>
   * ```
   *
   * Some browsers (especially embedded browsers) don't like it when the Duo
   * Web SDK changes the `src` attribute on the iframe. To prevent this, there
   * is an alternative way to use the Duo Web SDK:
   *
   * Add a div (or any other container element) instead of an iframe to the
   * DOM with an id of "duo_iframe", or pass that element to the
   * `iframeContainer` parameter of `Duo.init`. An iframe will be created and
   * inserted into that container element, preventing `src` change related
   * bugs. WARNING: All other elements in the container will be deleted.
   *
   * The `iframeAttributes` parameter of `Duo.init` is available to set any
   * attributes on the inserted iframe if the Duo Web SDK is inserting the
   * iframe. For details, see the parameter documentation below.
   *
   * @param {Object} options
   * @param {String} options.host - Hostname for the Duo Prompt.
   * @param {String} options.sig_request - Request token.
   * @param {String|HTMLElement} [options.iframe] - The iframe, or id of an
   *     iframe that will be used for the Duo Prompt. If you don't provide
   *     this or the `iframeContainer` parameter the Duo Web SDK will default
   *     to using whatever element has an id of "duo_iframe".
   * @param {String|HTMLElement} [options.iframeContainer] - The element you
   *     want the Duo Prompt inserted into, or the id of that element.
   *     Anything inside this element will be deleted and replaced with an
   *     iframe hosting the Duo prompt. If you don't provide this or the
   *     `iframe` parameter the Duo Web SDK will default to using whatever
   *     element has an id of "duo_iframe".
   * @param {Object} [options.iframeAttributes] - Object with  names and
   *     values coresponding to attributes you want added to the  Duo Prompt
   *     iframe, like `title`, `width` and `allow`. WARNING: this parameter
   *     only works if you use the `iframeContainer` parameter or add an id
   *     of "duo_iframe" to an element that isn't an iframe. If you have
   *     added an iframe to the DOM yourself, you should set those attributes
   *     directly on the iframe.
   * @param {String} [options.post_action=''] - URL to POST back to after a
   *     successful auth.
   * @param {String} [options.post_argument='sig_response'] - Parameter name
   *     to use for response token.
   * @param {Function} [options.submit_callback] - If provided, the Duo Web
   *     SDK will not submit the form. Instead it will execute this callback
   *     function passing in a reference to the "duo_form" form object.
   *     `submit_callback`` can be used to prevent the webpage from reloading.
   */
  function init(options) {
    // If init() is called more than once we have to reset all the local
    // variables to ensure init() will work the same way every time. This
    // helps people making single page applications. SPAs may periodically
    // remove the iframe and add a new one that has to be initialized.
    initializeStatefulVariables();
    if (options) {
      if (options.host) {
        host = options.host;
      }
      if (options.sig_request) {
        parseSigRequest(options.sig_request);
      }
      if (options.post_action) {
        postAction = options.post_action;
      }
      if (options.post_argument) {
        postArgument = options.post_argument;
      }
      if (typeof options.submit_callback === 'function') {
        submitCallback = options.submit_callback;
      }
    }
    var promptElement = getPromptElement(options);
    if (promptElement) {
      // If we can get the element that will host the prompt, set it.
      ready(promptElement, options.iframeAttributes || {});
    } else {
      // If the element that will host the prompt isn't available yet, set
      // it up after the DOM finishes loading.
      asyncReady(options);
    }

    // always clean up after yourself!
    offReady(init);
  }

  /**
   * Given the options from init(), get the iframe or iframe container that
   * should be used for the Duo Prompt. Returns `null` if nothing was found.
   */
  function getPromptElement(options) {
    var result;
    if (options.iframe && options.iframeContainer) {
      throwError('Passing both `iframe` and `iframeContainer` arguments at the' + ' same time is not allowed.');
    } else if (options.iframe) {
      // If we are getting an iframe, try to get it and raise if the
      // element we find is NOT an iframe.
      result = getUserDefinedElement(options.iframe);
      validateIframe(result);
    } else if (options.iframeContainer) {
      result = getUserDefinedElement(options.iframeContainer);
      validateIframeContainer(result);
    } else {
      result = document.getElementById('duo_iframe');
    }
    return result;
  }

  /**
   * When given an HTMLElement, return it. When given a string, get an element
   * with that id, else return null.
   */
  function getUserDefinedElement(object) {
    if (object.tagName) {
      return object;
    } else if (typeof object == 'string') {
      return document.getElementById(object);
    }
    return null;
  }

  /**
   * Check if the given thing is an iframe.
   */
  function isIframe(element) {
    return element && element.tagName && element.tagName.toLowerCase() === 'iframe';
  }

  /**
   * Throw an error if we are given an element that is NOT an iframe.
   */
  function validateIframe(element) {
    if (element && !isIframe(element)) {
      throwError('`iframe` only accepts an iframe element or the id of an' + ' iframe. To use a non-iframe element, use the' + ' `iframeContainer` argument.');
    }
  }

  /**
   * Throw an error if we are given an element that IS an iframe instead of an
   * element that we can insert an iframe into.
   */
  function validateIframeContainer(element) {
    if (element && isIframe(element)) {
      throwError('`iframeContainer` only accepts a non-iframe element or the' + ' id of a non-iframe. To use a non-iframe element, use the' + ' `iframeContainer` argument on Duo.init().');
    }
  }

  /**
   * Generate the URL that goes to the Duo Prompt.
   */
  function generateIframeSrc() {
    return ['https://', host, '/frame/web/v1/auth?tx=', duoSig, '&parent=', encodeURIComponent(document.location.href), '&v=2.8'].join('');
  }

  /**
   * This function is called when a message was received from another domain
   * using the `postMessage` API.  Check that the event came from the Duo
   * service domain, and that the message is a properly formatted payload,
   * then perform the post back to the primary service.
   *
   * @param event Event object (contains origin and data)
   */
  function onReceivedMessage(event) {
    if (isDuoMessage(event)) {
      if (event.data.match(DUO_OPEN_WINDOW_FORMAT)) {
        var url = event.data.substring("DUO_OPEN_WINDOW|".length);
        if (isValidUrlToOpen(url)) {
          // Open the URL that comes after the DUO_WINDOW_OPEN token.
          window.open(url, "_self");
        }
      } else {
        // the event came from duo, do the post back
        doPostBack(event.data);

        // always clean up after yourself!
        offMessage(onReceivedMessage);
      }
    }
  }

  /**
   * Validate that this passed in URL is one that we will actually allow to
   * be opened.
   * @param url String URL that the message poster wants to open
   * @returns {boolean} true if we allow this url to be opened in the window
   */
  function isValidUrlToOpen(url) {
    if (!url) {
      return false;
    }
    var parser = document.createElement('a');
    parser.href = url;
    if (parser.protocol === "duotrustedendpoints:") {
      return true;
    } else if (parser.protocol !== "https:") {
      return false;
    }
    for (var i = 0; i < VALID_OPEN_WINDOW_DOMAINS.length; i++) {
      if (parser.hostname.endsWith("." + VALID_OPEN_WINDOW_DOMAINS[i]) || parser.hostname === VALID_OPEN_WINDOW_DOMAINS[i]) {
        return true;
      }
    }
    return false;
  }

  /**
   * Register a callback to call ready() after the DOM has loaded.
   */
  function asyncReady(options) {
    var callback = function () {
      var promptElement = getPromptElement(options);
      if (!promptElement) {
        throwError('This page does not contain an iframe for Duo to use.' + ' Add an element like' + ' <iframe id="duo_iframe"></iframe> to this page.');
      }
      ready(promptElement, options.iframeAttributes || {});

      // Always clean up after yourself.
      offReady(callback);
    };
    onReady(callback);
  }

  /**
   * Point the iframe at Duo, then wait for it to postMessage back to us.
   */
  function ready(promptElement, iframeAttributes) {
    if (!host) {
      host = getDataAttribute(promptElement, 'host');
      if (!host) {
        throwError('No API hostname is given for Duo to use.  Be sure to pass ' + 'a `host` parameter to Duo.init, or through the `data-host` ' + 'attribute on the iframe element.');
      }
    }
    if (!duoSig || !appSig) {
      parseSigRequest(getDataAttribute(promptElement, 'sigRequest'));
      if (!duoSig || !appSig) {
        throwError('No valid signed request is given.  Be sure to give the ' + '`sig_request` parameter to Duo.init, or use the ' + '`data-sig-request` attribute on the iframe element.');
      }
    }

    // if postAction/Argument are defaults, see if they are specified
    // as data attributes on the iframe
    if (postAction === '') {
      postAction = getDataAttribute(promptElement, 'postAction') || postAction;
    }
    if (postArgument === 'sig_response') {
      postArgument = getDataAttribute(promptElement, 'postArgument') || postArgument;
    }
    if (isIframe(promptElement)) {
      iframe = promptElement;
      iframe.src = generateIframeSrc();
    } else {
      // If given a container to put an iframe in, clean out any children
      // child elements in case `init()` was called more than once.
      while (promptElement.firstChild) {
        // We call `removeChild()` instead of doing `innerHTML = ""`
        // to make sure we unbind any events.
        promptElement.removeChild(promptElement.firstChild);
      }
      iframe = document.createElement('iframe');

      // Set the src and all other attributes on the new iframe.
      iframeAttributes['src'] = generateIframeSrc();
      for (var name in iframeAttributes) {
        iframe.setAttribute(name, iframeAttributes[name]);
      }
      promptElement.appendChild(iframe);
    }

    // listen for the 'message' event
    onMessage(onReceivedMessage);
  }

  /**
   * We received a postMessage from Duo.  POST back to the primary service
   * with the response token, and any additional user-supplied parameters
   * given in form#duo_form.
   */
  // function doPostBack(response) {
  //     // create a hidden input to contain the response token
  //     var input = document.createElement('input');
  //     input.type = 'hidden';
  //     input.name = postArgument;
  //     input.value = response + ':' + appSig;

  //     // user may supply their own form with additional inputs
  //     var form = document.getElementById('duo_form');

  //     // if the form doesn't exist, create one
  //     if (!form) {
  //         form = document.createElement('form');

  //         // insert the new form after the iframe
  //         iframe.parentElement.insertBefore(form, iframe.nextSibling);
  //     }

  //     // make sure we are actually posting to the right place
  //     form.method = 'POST';
  //     form.action = postAction;

  //     // add the response token input to the form
  //     form.appendChild(input);

  //     // away we go!
  //     if (typeof submitCallback === "function") {
  //         submitCallback.call(null, form);
  //     } else {
  //         form.submit();
  //     }
  // }

  // OKTA: Overriding their doPostBack logic because we want to submit this
  // through ajax, not a postBack
  function doPostBack(response) {
    postAction(response + ':' + appSig);
  }
  return {
    init: init,
    _onReady: onReady,
    _parseSigRequest: parseSigRequest,
    _isDuoMessage: isDuoMessage,
    _doPostBack: doPostBack
  };
});

/***/ }),

/***/ "./src/util/Animations.js":
/*!********************************!*\
  !*** ./src/util/Animations.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
var _Enums = _interopRequireDefault(__webpack_require__(/*! ./Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-statements: [2, 16] */

const SWAP_PAGE_TIME = 200;
const fn = {};
function zoom($el, start, finish) {
  const deferred = _q.default.defer();
  $el.animate({
    'text-indent': 1
  }, {
    duration: 200,
    easing: 'swing',
    step: function (now, fx) {
      fx.start = start;
      fx.end = finish;
      $el.css('transform', 'scale(' + now + ', ' + now + ')');
    },
    always: function () {
      deferred.resolve($el);
    }
  });
  return deferred.promise;
}
function rotate($el, start, finish) {
  const deferred = _q.default.defer();
  $el.animate({
    'text-indent': 1
  }, {
    duration: 150,
    easing: 'swing',
    step: function (now, fx) {
      fx.start = start;
      fx.end = finish;
      $el.css('transform', 'rotate(' + now + 'deg)');
    },
    always: function () {
      deferred.resolve($el);
    }
  });
  return deferred.promise;
}

// Note: It is necessary to pass in a success callback because we must
// remove the old dom node (and controller) in the same tick of the event
// loop. Waiting for "then" results in a glitchy animation.
fn.swapPages = function (options) {
  const deferred = _q.default.defer();
  const $parent = options.$parent;
  const $oldRoot = options.$oldRoot;
  const $newRoot = options.$newRoot;
  const success = options.success;
  const ctx = options.ctx;
  let directionClassName = 'transition-from-right';
  if (options.dir && options.dir === _Enums.default.DIRECTION_BACK) {
    directionClassName = 'transition-from-left';
  }
  $newRoot.addClass(directionClassName);
  $parent.append($newRoot);
  $parent.addClass('animation-container-overflow');
  const newRootAnimations = {
    left: '0px',
    top: '0px',
    opacity: 1
  };
  $newRoot.animate(newRootAnimations, SWAP_PAGE_TIME, function () {
    $parent.removeClass('animation-container-overflow');
    $newRoot.removeClass(directionClassName);
    const clearStyles = Object.keys(newRootAnimations).reduce((styles, attr) => ({
      ...styles,
      [attr]: ''
    }), {});
    $newRoot.css(clearStyles);
    success.call(ctx);
    deferred.resolve();
  });
  $oldRoot.animate({
    height: $newRoot.height(),
    opacity: 0
  }, SWAP_PAGE_TIME * 0.8);
  return deferred.promise;
};
fn.swapBeacons = function (options) {
  const $el = options.$el;
  const swap = options.swap;
  const ctx = options.ctx;
  return this.implode($el).then(function () {
    swap.call(ctx);
    return $el;
  }).then(this.explode);
};
fn.explode = function ($el) {
  return zoom($el, 0, 1); //zoom in
};

fn.implode = function ($el) {
  return zoom($el, 1, 0); //zoom out
};

fn.radialProgressBar = function (options) {
  const radialProgressBar = options.$el;
  const swap = options.swap;
  const circles = radialProgressBar.children();
  return rotate(circles, 0, 180).then(function () {
    radialProgressBar.css({
      clip: 'auto'
    });
  }).then(function () {
    const leftHalf = circles.eq(0);
    swap();
    return rotate(leftHalf, 180, 360);
  }).then(function () {
    //reset values to initial state
    radialProgressBar.css({
      clip: 'rect(0px, 96px, 96px, 48px)'
    });
    circles.css({
      transform: 'rotate(0deg)',
      'text-indent': '1px'
    });
  });
};
var _default = fn;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/ColorsUtil.js":
/*!********************************!*\
  !*** ./src/util/ColorsUtil.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const fn = {};
const template = function (colors) {
  return `
#okta-sign-in.auth-container .button-primary,
#okta-sign-in.auth-container .button-primary:active,
#okta-sign-in.auth-container .button-primary:focus { background: ${colors.brand}; }
#okta-sign-in.auth-container .button-primary:hover { background: ${fn.lighten(colors.brand, 0.05)}; }
#okta-sign-in.auth-container .button.button-primary.link-button-disabled {
  background: ${colors.brand};
  opacity: 0.5;
}
    `;
};

// visible for testing
fn.lighten = function (hex, lum) {
  lum = lum || 0;
  hex = hex.substr(1);
  let newHex = '#';
  for (var i = 0; i < 3; i++) {
    let c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    newHex += ('00' + c).substr(c.length);
  }
  return newHex;
};
fn.addStyle = function (colors, cspNonce) {
  const css = template(colors);
  const main = document.getElementById(_Enums.default.WIDGET_CONTAINER_ID);
  const style = document.createElement('style');
  style.id = _Enums.default.WIDGET_CONFIG_COLORS_ID;
  style.type = 'text/css';
  if (cspNonce) {
    style.nonce = cspNonce;
  }
  style.appendChild(document.createTextNode(css));
  main.appendChild(style);
};
fn.isLoaded = function () {
  return !!document.getElementById(_Enums.default.WIDGET_CONFIG_COLORS_ID);
};
var _default = fn;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/CookieUtil.js":
/*!********************************!*\
  !*** ./src/util/CookieUtil.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const Cookie = _courage.internal.util.Cookie;
const LAST_USERNAME_COOKIE_NAME = 'ln';
const DAYS_SAVE_REMEMBER = 365;
const fn = {};
fn.getCookieUsername = function () {
  return Cookie.getCookie(LAST_USERNAME_COOKIE_NAME);
};
fn.setUsernameCookie = function (username) {
  Cookie.setCookie(LAST_USERNAME_COOKIE_NAME, username, {
    expires: DAYS_SAVE_REMEMBER,
    path: '/'
  });
};
fn.removeUsernameCookie = function () {
  Cookie.removeCookie(LAST_USERNAME_COOKIE_NAME, {
    path: '/'
  });
};
var _default = fn;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/CountryUtil.js":
/*!*********************************!*\
  !*** ./src/util/CountryUtil.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscore = _interopRequireDefault(__webpack_require__(/*! underscore */ "./node_modules/underscore/underscore-umd.js"));
var _loc = __webpack_require__(/*! ./loc */ "./src/util/loc.ts");
var _Bundles = _interopRequireDefault(__webpack_require__(/*! ./Bundles */ "./src/util/Bundles.ts"));
var _countryCallingCodes = _interopRequireDefault(__webpack_require__(/*! ./countryCallingCodes */ "./src/util/countryCallingCodes.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const fn = {};

// () => [{ countryCode: countryName }], sorted by countryName
fn.getCountries = function () {
  const countries = _underscore.default.omit(_Bundles.default.country, 'HM', 'BV', 'TF');
  // HM, BV, and TF do not have phone prefixes, so don't give the
  // user the option to choose these countries. FYI it appears that these
  // countries do not have calling codes because they are ~~uninhabited~~

  let collection = _underscore.default.map(countries, function (name, code) {
    return {
      name: name,
      code: code
    };
  });

  // Sort it; figure out if there is a better way to do this (best would
  // be to sort it in the properties file!!)

  collection = _underscore.default.sortBy(collection, 'name');
  const sorted = {};
  _underscore.default.each(collection, function (country) {
    sorted[country.code] = country.name;
  });
  return sorted;
};
fn.getCountryCode = function () {
  const countries = _underscore.default.omit(_Bundles.default.country, 'HM', 'BV', 'TF');
  // HM, BV, and TF do not have phone prefixes, so don't give the
  // user the option to choose these countries. FYI it appears that these
  // countries do not have calling codes because they are ~~uninhabited~~

  let collection = _underscore.default.map(countries, function (name, code) {
    return {
      name: name,
      code: code
    };
  });
  collection = _underscore.default.sortBy(collection, 'name');
  const sorted = {};
  _underscore.default.each(collection, function (country) {
    sorted[country.code] = (0, _loc.loc)('country.option.label', 'login', [country.name, country.code]);
  });
  return sorted;
};
fn.getCallingCodeForCountry = function (countryCode) {
  return _countryCallingCodes.default[countryCode];
};
var _default = fn;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/CryptoUtil.js":
/*!********************************!*\
  !*** ./src/util/CryptoUtil.js ***!
  \********************************/
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* global Uint8Array, atob, btoa */

const fn = {};

/**
 * Light weight hashing algorithm that hashes string into an integer between 0 and 4294967295
 * Not recommended for data set of size greater than 10000
 * https://www.npmjs.com/package/string-hash
 *
 * @param str the string to be hashed
 * @returns string hash of integer type
 */
fn.getStringHash = function (str) {
  let hash = 5381;
  let i = str.length;
  while (i) {
    hash = hash * 33 ^ str.charCodeAt(--i);
  }
  return hash >>> 0;
};

/**
 * Converts any url safe characters in a base64 string to regular base64 characters
 * @param str base64 string that might contain url safe characters
 * @returns base64 formatted string
 */
fn.base64UrlSafeToBase64 = function (str) {
  return str.replace(new RegExp('_', 'g'), '/').replace(new RegExp('-', 'g'), '+');
};

/**
 * Converts an ArrayBuffer object that contains binary data to base64 encoded string
 * @param bin ArrayBuffer object
 * @returns base64 encoded string
 */
fn.binToStr = function (bin) {
  return btoa(new Uint8Array(bin).reduce((s, byte) => s + String.fromCharCode(byte), ''));
};

/**
 * Converts base64 string to binary data view
 * @param str in base64 or base64UrlSafe format
 * @returns converted Uint8Array view of binary data
 */
fn.strToBin = function (str) {
  return Uint8Array.from(atob(this.base64UrlSafeToBase64(str)), c => c.charCodeAt(0));
};
var _default = fn;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/Enums.js":
/*!***************************!*\
  !*** ./src/util/Enums.js ***!
  \***************************/
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = {
  API_RATE_LIMIT: 30000,
  //milliseconds

  WIDGET_LOGIN_CONTAINER_ID: 'okta-login-container',
  WIDGET_CONTAINER_ID: 'okta-sign-in',
  WIDGET_CONFIG_COLORS_ID: 'okta-sign-in-config-colors',
  DIRECTION_BACK: 'DIRECTION_BACK',
  RECOVERY_TYPE_PASSWORD: 'PASSWORD',
  RECOVERY_TYPE_UNLOCK: 'UNLOCK',
  RECOVERY_FACTOR_TYPE_SMS: 'SMS',
  RECOVERY_FACTOR_TYPE_EMAIL: 'EMAIL',
  RECOVERY_FACTOR_TYPE_CALL: 'CALL',
  IOS: 'ios',
  ANDROID: 'android',
  ODA: 'oda',
  MDM: 'mdm',
  WS1: 'ws1',
  // Global success messages
  SUCCESS: 'SUCCESS',
  FORGOT_PASSWORD_EMAIL_SENT: 'FORGOT_PASSWORD_EMAIL_SENT',
  UNLOCK_ACCOUNT_EMAIL_SENT: 'UNLOCK_ACCOUNT_EMAIL_SENT',
  // Global error messages
  CONFIG_ERROR: 'CONFIG_ERROR',
  UNSUPPORTED_BROWSER_ERROR: 'UNSUPPORTED_BROWSER_ERROR',
  OAUTH_ERROR: 'OAUTH_ERROR',
  AUTH_STOP_POLL_INITIATION_ERROR: 'AUTH_STOP_POLL_INITIATION_ERROR',
  U2F_ERROR: 'U2F_ERROR',
  WEB_AUTHN_ERROR: 'WEB_AUTHN_ERROR',
  WEBAUTHN_ABORT_ERROR: 'WEBAUTHN_ABORT_ERROR',
  CONFIGURED_FLOW_ERROR: 'CONFIGURED_FLOW_ERROR',
  // Enroll choice page types
  ALL_OPTIONAL_NONE_ENROLLED: 'ALL_OPTIONAL_NONE_ENROLLED',
  ALL_OPTIONAL_SOME_ENROLLED: 'ALL_OPTIONAL_SOME_ENROLLED',
  HAS_REQUIRED_NONE_ENROLLED: 'HAS_REQUIRED_NONE_ENROLLED',
  HAS_REQUIRED_SOME_REQUIRED_ENROLLED: 'HAS_REQUIRED_SOME_REQUIRED_ENROLLED',
  HAS_REQUIRED_ALL_REQUIRED_ENROLLED: 'HAS_REQUIRED_ALL_REQUIRED_ENROLLED',
  // Operations
  PRIMARY_AUTH: 'PRIMARY_AUTH',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  UNLOCK_ACCOUNT: 'UNLOCK_ACCOUNT',
  // Auth Types
  SESSION_SSO: 'SESSION_SSO',
  SESSION_STEP_UP: 'SESSION_STEP_UP',
  //Registration
  ACTIVATION_EMAIL_SENT: 'ACTIVATION_EMAIL_SENT',
  REGISTRATION_COMPLETE: 'REGISTRATION_COMPLETE',
  REGISTRATION_FAILED: 'REGISTRATION_FAILED',
  //IDP Discovery
  IDP_DISCOVERY: 'IDP_DISCOVERY',
  //App Store Links
  OKTA_VERIFY_APPLE_APP_STORE_URL: 'https://apps.apple.com/us/app/okta-verify/id490179405',
  OKTA_VERIFY_GOOGLE_PLAY_STORE_URL: 'https://play.google.com/store/apps/details?id=com.okta.android.auth',
  // Device Challenge Method
  LOOPBACK_CHALLENGE: 'LOOPBACK',
  CUSTOM_URI_CHALLENGE: 'CUSTOM_URI',
  UNIVERSAL_LINK_CHALLENGE: 'UNIVERSAL_LINK',
  APP_LINK_CHALLENGE: 'APP_LINK',
  CHROME_DTC: 'CHROME_DTC'
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/ErrorCodes.js":
/*!********************************!*\
  !*** ./src/util/ErrorCodes.js ***!
  \********************************/
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = {
  INVALID_TOKEN_EXCEPTION: 'E0000011'
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/FactorUtil.js":
/*!********************************!*\
  !*** ./src/util/FactorUtil.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscore = _interopRequireDefault(__webpack_require__(/*! underscore */ "./node_modules/underscore/underscore-umd.js"));
var _loc = __webpack_require__(/*! ./loc */ "./src/util/loc.ts");
var _TimeUtil = _interopRequireDefault(__webpack_require__(/*! util/TimeUtil */ "./src/util/TimeUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 38], max-statements: [2, 38] */

const fn = {};
const factorData = {
  OKTA_VERIFY: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.totpSoft.oktaVerify',
    description: 'factor.totpSoft.description',
    iconClassName: 'mfa-okta-verify',
    sortOrder: 1
  },
  OKTA_VERIFY_PUSH: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.oktaVerifyPush',
    description: 'factor.push.description',
    iconClassName: 'mfa-okta-verify',
    sortOrder: 1
  },
  U2F: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.u2f',
    description: brandName => {
      return brandName ? 'factor.u2f.description.specific' : 'factor.u2f.description.generic';
    },
    iconClassName: 'mfa-u2f',
    sortOrder: 2
  },
  WEBAUTHN: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.webauthn.biometric',
    description: 'factor.webauthn.biometric.description',
    iconClassName: 'mfa-webauthn',
    sortOrder: 2
  },
  WINDOWS_HELLO: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.windowsHello',
    description: brandName => {
      return brandName ? 'factor.windowsHello.signin.description.specific' : 'factor.windowsHello.signin.description.generic';
    },
    iconClassName: 'mfa-windows-hello',
    sortOrder: 3
  },
  YUBIKEY: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.totpHard.yubikey',
    description: 'factor.totpHard.yubikey.description',
    iconClassName: 'mfa-yubikey',
    sortOrder: 4
  },
  GOOGLE_AUTH: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.totpSoft.googleAuthenticator',
    description: 'factor.totpSoft.description',
    iconClassName: 'mfa-google-auth',
    sortOrder: 5
  },
  CUSTOM_HOTP: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: '',
    description: 'factor.hotp.description',
    iconClassName: 'mfa-hotp',
    sortOrder: 6
  },
  SMS: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.sms',
    description: 'factor.sms.description',
    iconClassName: 'mfa-okta-sms',
    sortOrder: 7
  },
  CALL: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.call',
    description: 'factor.call.description',
    iconClassName: 'mfa-okta-call',
    sortOrder: 8
  },
  EMAIL: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.email',
    description: 'factor.email.description',
    iconClassName: 'mfa-okta-email',
    sortOrder: 9
  },
  QUESTION: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.securityQuestion',
    description: 'factor.securityQuestion.description',
    iconClassName: 'mfa-okta-security-question',
    sortOrder: 10
  },
  DUO: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.duo',
    description: 'factor.duo.description',
    iconClassName: 'mfa-duo',
    sortOrder: 11
  },
  SYMANTEC_VIP: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.totpHard.symantecVip',
    description: 'factor.totpHard.description',
    iconClassName: 'mfa-symantec',
    sortOrder: 12
  },
  RSA_SECURID: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.totpHard.rsaSecurId',
    description: 'factor.totpHard.description',
    iconClassName: 'mfa-rsa',
    sortOrder: 13
  },
  ON_PREM: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: '',
    description: 'factor.totpHard.description',
    iconClassName: 'mfa-onprem',
    sortOrder: 14
  },
  PASSWORD: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: 'factor.password',
    description: '',
    iconClassName: 'mfa-okta-password',
    sortOrder: 15
  },
  CUSTOM_CLAIMS: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: '',
    description: 'factor.customFactor.description',
    iconClassName: 'mfa-custom-factor',
    sortOrder: 16
  },
  GENERIC_SAML: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: '',
    description: brandName => {
      return brandName ? 'factor.customFactor.description.specific' : 'factor.customFactor.description.generic';
    },
    iconClassName: 'mfa-custom-factor',
    sortOrder: 17
  },
  GENERIC_OIDC: {
    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
    label: '',
    description: brandName => {
      return brandName ? 'factor.customFactor.description.specific' : 'factor.customFactor.description.generic';
    },
    iconClassName: 'mfa-custom-factor',
    sortOrder: 18
  }
};
const getPasswordComplexityRequirementsAsArray = function (policy, i18nKeys) {
  const setExcludeAttributes = function (policyComplexity) {
    const excludeAttributes = policyComplexity.excludeAttributes;
    policyComplexity.excludeFirstName = _underscore.default.contains(excludeAttributes, 'firstName');
    policyComplexity.excludeLastName = _underscore.default.contains(excludeAttributes, 'lastName');
    return _underscore.default.omit(policyComplexity, 'excludeAttributes');
  };
  if (policy.complexity) {
    const complexityFields = i18nKeys.complexity;
    const policyComplexity = setExcludeAttributes(policy.complexity);
    let filteredPolicyComplexity = policyComplexity;

    // If useADComplexityRequirements is true, ignore casing, number, and symbol rules since
    // AD validator handles those requirements
    if (policyComplexity.useADComplexityRequirements) {
      const allowed = ['minLength', 'useADComplexityRequirements', 'excludeUsername', 'excludeFirstName', 'excludeLastName', 'excludeAttributes'];
      filteredPolicyComplexity = _underscore.default.pick(policyComplexity, allowed);
    }
    const requirements = _underscore.default.map(filteredPolicyComplexity, function (complexityValue, complexityType) {
      if (complexityValue <= 0) {
        // to skip 0 and -1
        return;
      }
      const params = complexityFields[complexityType];
      return params.args ? (0, _loc.loc)(params.i18n, 'login', [complexityValue]) : (0, _loc.loc)(params.i18n, 'login');
    });
    return _underscore.default.compact(requirements);
  }
  return [];
};
const getPasswordHistoryRequirementDescription = function (policy, i18nKeys, isUpdatedPasswordRequirementsText) {
  if (policy.age && policy.age.historyCount > 0) {
    if (isUpdatedPasswordRequirementsText) {
      return policy.age.historyCount === 1 ? (0, _loc.loc)(i18nKeys.history.one.i18n, 'login') : (0, _loc.loc)(i18nKeys.history.many.i18n, 'login', [policy.age.historyCount]);
    } else {
      return (0, _loc.loc)(i18nKeys.history.i18n, 'login', [policy.age.historyCount]);
    }
  }
  return null;
};
const getPasswordAgeRequirementDescription = function (policy, i18nKeys) {
  const getPasswordAgeRequirement = function (displayableTime) {
    let propertiesString;
    switch (displayableTime.unit) {
      case 'DAY':
        propertiesString = i18nKeys.age.days.i18n;
        break;
      case 'HOUR':
        propertiesString = i18nKeys.age.hours.i18n;
        break;
      case 'MINUTE':
        propertiesString = i18nKeys.age.minutes.i18n;
    }
    return (0, _loc.loc)(propertiesString, 'login', [displayableTime.time]);
  };
  if (policy.age && policy.age.minAgeMinutes > 0) {
    const displayableTime = _TimeUtil.default.getTimeInHighestRelevantUnit(policy.age.minAgeMinutes, 'MINUTE');
    return getPasswordAgeRequirement(displayableTime);
  }
  return null;
};
const getPasswordRequirements = function (policy, i18nKeys, isUpdatedPasswordRequirementsText) {
  const passwordRequirements = {
    complexity: [],
    history: [],
    age: []
  };
  passwordRequirements.complexity = getPasswordComplexityRequirementsAsArray(policy, i18nKeys);
  const historyRequirement = getPasswordHistoryRequirementDescription(policy, i18nKeys, isUpdatedPasswordRequirementsText);
  if (historyRequirement) {
    passwordRequirements.history.push(historyRequirement);
  }
  const ageRequirement = getPasswordAgeRequirementDescription(policy, i18nKeys);
  if (ageRequirement) {
    passwordRequirements.age.push(ageRequirement);
  }
  return passwordRequirements;
};
fn.getFactorName = function (provider, factorType) {
  if (provider === 'OKTA' && factorType === 'token:software:totp') {
    return 'OKTA_VERIFY';
  }
  if (provider === 'OKTA' && factorType === 'push') {
    return 'OKTA_VERIFY_PUSH';
  }
  if (provider === 'GOOGLE') {
    return 'GOOGLE_AUTH';
  }
  if (provider === 'SYMANTEC' && factorType === 'token') {
    return 'SYMANTEC_VIP';
  }
  if (provider === 'RSA' && factorType === 'token') {
    return 'RSA_SECURID';
  }
  if (provider === 'DEL_OATH' && factorType === 'token') {
    return 'ON_PREM';
  }
  if (provider === 'DUO' && factorType === 'web') {
    return 'DUO';
  }
  if (provider === 'YUBICO' && factorType === 'token:hardware') {
    return 'YUBIKEY';
  }
  if (provider === 'OKTA' && factorType === 'sms') {
    return 'SMS';
  }
  if (provider === 'OKTA' && factorType === 'call') {
    return 'CALL';
  }
  if (provider === 'OKTA' && factorType === 'question') {
    return 'QUESTION';
  }
  if (provider === 'OKTA' && factorType === 'email') {
    return 'EMAIL';
  }
  if (provider === 'OKTA' && factorType === 'password') {
    return 'PASSWORD';
  }
  if (provider === 'GENERIC_SAML' && factorType === 'assertion:saml2') {
    return 'GENERIC_SAML';
  }
  if (provider === 'GENERIC_OIDC' && factorType === 'assertion:oidc') {
    return 'GENERIC_OIDC';
  }
  return fn.getFactorNameForFactorType.call(this, factorType);
};
fn.getFactorNameForFactorType = function (factorType) {
  if (factorType === 'u2f') {
    return 'U2F';
  }
  if (factorType === 'token:software:totp') {
    return 'OKTA_VERIFY';
  }
  if (factorType === 'webauthn') {
    if (this.settings.get('features.webauthn')) {
      return 'WEBAUTHN';
    } else {
      return 'WINDOWS_HELLO';
    }
  }
  if (factorType === 'token:hotp') {
    return 'CUSTOM_HOTP';
  }
  if (factorType === 'claims_provider') {
    return 'CUSTOM_CLAIMS';
  }
};
fn.isOktaVerify = function (provider, factorType) {
  return provider === 'OKTA' && (factorType === 'token:software:totp' || factorType === 'push');
};
fn.getFactorLabel = function (provider, factorType) {
  const key = factorData[fn.getFactorName.apply(this, [provider, factorType])].label;
  return (0, _loc.loc)(key, 'login');
};
fn.getFactorDescription = function (provider, factorType) {
  const descriptionKey = factorData[fn.getFactorName.apply(this, [provider, factorType])].description;
  if (_underscore.default.isFunction(descriptionKey)) {
    const brandName = this.settings.get('brandName');
    const key = descriptionKey(brandName);
    return brandName ? (0, _loc.loc)(key, 'login', [brandName]) : (0, _loc.loc)(key, 'login');
  } else {
    return descriptionKey ? (0, _loc.loc)(descriptionKey, 'login') : '';
  }
};
fn.getFactorIconClassName = function (provider, factorType) {
  return factorData[fn.getFactorName.apply(this, [provider, factorType])].iconClassName;
};
fn.getFactorSortOrder = function (provider, factorType) {
  return factorData[fn.getFactorName.apply(this, [provider, factorType])].sortOrder;
};
fn.getRememberDeviceValue = function (appState) {
  return appState && appState.get('rememberDeviceByDefault');
};
fn.getSecurityQuestionLabel = function (questionObj) {
  const localizedQuestion = (0, _loc.loc)('security.' + questionObj.question);
  return localizedQuestion.indexOf('L10N_ERROR') < 0 ? localizedQuestion : questionObj.questionText;
};
fn.removeRequirementsFromError = function (responseJSON, policy) {
  const passwordRequirementsAsString = this.getPasswordComplexityDescription(policy);
  if (responseJSON.errorCauses && responseJSON.errorCauses.length > 0 && _underscore.default.isString(responseJSON.errorCauses[0].errorSummary)) {
    responseJSON.errorCauses[0].errorSummary = responseJSON.errorCauses[0].errorSummary.replace(passwordRequirementsAsString, '').trim();
  }
  return responseJSON;
};
fn.getPasswordComplexityDescriptionForHtmlList = function (policy) {
  const passwordRequirementHtmlI18nKeys = {
    complexity: {
      minLength: {
        i18n: 'password.complexity.length.description',
        args: true
      },
      minLowerCase: {
        i18n: 'password.complexity.lowercase.description'
      },
      minUpperCase: {
        i18n: 'password.complexity.uppercase.description'
      },
      minNumber: {
        i18n: 'password.complexity.number.description'
      },
      minSymbol: {
        i18n: 'password.complexity.symbol.description'
      },
      excludeUsername: {
        i18n: 'password.complexity.no_username.description'
      },
      excludeFirstName: {
        i18n: 'password.complexity.no_first_name.description'
      },
      excludeLastName: {
        i18n: 'password.complexity.no_last_name.description'
      },
      useADComplexityRequirements: {
        i18n: 'password.complexity.adRequirements.description'
      }
    },
    history: {
      one: {
        i18n: 'password.complexity.history.one.description'
      },
      many: {
        i18n: 'password.complexity.history.description'
      }
    },
    age: {
      minutes: {
        i18n: 'password.complexity.minAgeMinutes.description'
      },
      hours: {
        i18n: 'password.complexity.minAgeHours.description'
      },
      days: {
        i18n: 'password.complexity.minAgeDays.description'
      }
    }
  };
  const passwordRequirements = getPasswordRequirements(policy, passwordRequirementHtmlI18nKeys, true);
  return _underscore.default.union(passwordRequirements.complexity, passwordRequirements.history, passwordRequirements.age);
};
fn.getPasswordComplexityDescription = function (policy) {
  const passwordRequirementI18nKeys = {
    complexity: {
      minLength: {
        i18n: 'password.complexity.length',
        args: true
      },
      minLowerCase: {
        i18n: 'password.complexity.lowercase'
      },
      minUpperCase: {
        i18n: 'password.complexity.uppercase'
      },
      minNumber: {
        i18n: 'password.complexity.number'
      },
      minSymbol: {
        i18n: 'password.complexity.symbol'
      },
      excludeUsername: {
        i18n: 'password.complexity.no_username'
      },
      excludeFirstName: {
        i18n: 'password.complexity.no_first_name'
      },
      excludeLastName: {
        i18n: 'password.complexity.no_last_name'
      },
      useADComplexityRequirements: {
        i18n: 'password.complexity.adRequirements'
      }
    },
    history: {
      i18n: 'password.complexity.history'
    },
    age: {
      minutes: {
        i18n: 'password.complexity.minAgeMinutes'
      },
      hours: {
        i18n: 'password.complexity.minAgeHours'
      },
      days: {
        i18n: 'password.complexity.minAgeDays'
      }
    }
  };
  const result = [];
  const passwordRequirements = getPasswordRequirements(policy, passwordRequirementI18nKeys, false);
  let requirements = passwordRequirements.complexity;

  // Generate and add complexity string to result
  if (requirements.length > 0) {
    requirements = _underscore.default.reduce(requirements, function (result, requirement) {
      return result ? result + (0, _loc.loc)('password.complexity.list.element', 'login', [requirement]) : requirement;
    });
    result.push((0, _loc.loc)('password.complexity.requirements', 'login', [requirements]));
  }

  // Only 1 value expected in history and age for now
  result.push(passwordRequirements.history[0]);
  result.push(passwordRequirements.age[0]);
  return _underscore.default.compact(result).join(' ');
};
fn.getCardinalityText = function (enrolled, required, cardinality) {
  if (cardinality) {
    if (enrolled) {
      return cardinality.enrolled === 1 ? '' : (0, _loc.loc)('enroll.choices.cardinality.setup', 'login', [cardinality.enrolled]);
    } else if (required && cardinality.maximum > 1) {
      return (0, _loc.loc)('enroll.choices.cardinality.setup.remaining', 'login', [cardinality.enrolled, cardinality.minimum]);
    }
  }
  return '';
};
fn.findFactorInFactorsArray = function (factors, provider, factorType) {
  let factor = factors.findWhere({
    provider: provider,
    factorType: factorType
  });
  if (factor === undefined) {
    //for factors that support cardinality and only have factorType
    factor = factors.findWhere({
      factorType: factorType
    });
  }
  return factor;
};
var _default = fn;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/FidoUtil.js":
/*!******************************!*\
  !*** ./src/util/FidoUtil.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _loc = __webpack_require__(/*! ./loc */ "./src/util/loc.ts");
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity:[2, 9] */

const fn = {};
fn.getU2fEnrollErrorMessageKeyByCode = function (errorCode) {
  switch (errorCode) {
    default:
    case 1:
      return 'u2f.error.other';
    case 2:
    case 3:
      return 'u2f.error.badRequest';
    case 4:
      return 'u2f.error.unsupported';
    case 5:
      return 'u2f.error.timeout';
  }
};
fn.getU2fVerifyErrorMessageKeyByCode = function (errorCode, isOneFactor) {
  switch (errorCode) {
    case 1:
      // OTHER_ERROR
      return isOneFactor ? 'u2f.error.other.oneFactor' : 'u2f.error.other';
    case 2: // BAD_REQUEST
    case 3:
      // CONFIGURATION_UNSUPPORTED
      return isOneFactor ? 'u2f.error.badRequest.oneFactor' : 'u2f.error.badRequest';
    case 4:
      // DEVICE_INELIGIBLE
      return isOneFactor ? 'u2f.error.unsupported.oneFactor' : 'u2f.error.unsupported';
    case 5:
      // TIMEOUT
      return 'u2f.error.timeout';
  }
};
fn.getU2fEnrollErrorMessageByCode = function (errorCode) {
  return (0, _loc.loc)(fn.getU2fEnrollErrorMessageKeyByCode(errorCode), 'login');
};
fn.getU2fVerifyErrorMessageByCode = function (errorCode, isOneFactor) {
  return (0, _loc.loc)(fn.getU2fVerifyErrorMessageKeyByCode(errorCode, isOneFactor), 'login');
};
fn.getU2fVersion = function () {
  return 'U2F_V2';
};
fn.isU2fAvailable = function () {
  return Object.prototype.hasOwnProperty.call(window, 'u2f');
};
var _default = fn;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/Hooks.js":
/*!***************************!*\
  !*** ./src/util/Hooks.js ***!
  \***************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.executeHookFunctions = executeHookFunctions;
exports.executeHooksAfter = executeHooksAfter;
exports.executeHooksBefore = executeHooksBefore;
exports.mergeHook = mergeHook;
/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

async function executeHookFunctions(functions) {
  for (let i = 0; i < functions.length; i++) {
    await functions[i]();
  }
}
async function executeHooksBefore(hook) {
  if (!hook || !hook.before || !hook.before.length) {
    return;
  }
  await executeHookFunctions(hook.before);
}
async function executeHooksAfter(hook) {
  if (!hook || !hook.after || !hook.after.length) {
    return;
  }
  await executeHookFunctions(hook.after);
}
function mergeHook(hooks, formName, hookToMerge) {
  const existingHook = hooks[formName] = hooks[formName] || {
    before: [],
    after: []
  };
  if (hookToMerge.before) {
    existingHook.before = (existingHook.before || []).concat(hookToMerge.before);
  }
  if (hookToMerge.after) {
    existingHook.after = (existingHook.after || []).concat(hookToMerge.after);
  }
}

/***/ }),

/***/ "./src/util/IDP.js":
/*!*************************!*\
  !*** ./src/util/IDP.js ***!
  \*************************/
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
const SUPPORTED_SOCIAL_IDPS = ['facebook', 'google', 'linkedin', 'microsoft', 'apple', 'github', 'gitlab', 'yahoo', 'line', 'paypal', 'paypal_sandbox', 'salesforce', 'amazon', 'yahoojp', 'discord', 'adobe', 'orcid', 'spotify', 'xero', 'quickbooks'];
var _default = {
  SUPPORTED_SOCIAL_IDPS
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/LanguageUtil.js":
/*!**********************************!*\
  !*** ./src/util/LanguageUtil.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _Bundles = _interopRequireDefault(__webpack_require__(/*! util/Bundles */ "./src/util/Bundles.ts"));
var _config = _interopRequireDefault(__webpack_require__(/*! config/config.json */ "./src/config/config.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function loadLanguage(appState, settings) {
  const languageCode = appState.get('languageCode') || settings.get('languageCode') || _config.default.defaultLanguage;
  const i18n = settings.get('i18n');
  const assetBaseUrl = settings.get('assets.baseUrl');
  const assetRewrite = settings.get('assets.rewrite');
  const supportedLanguages = settings.get('supportedLanguages');
  const timeout = setTimeout(function () {
    // Trigger a spinner if we're waiting on a request for a new language.
    appState.trigger('loading', true);
  }, 200);
  return _Bundles.default.loadLanguage(languageCode, i18n, {
    baseUrl: assetBaseUrl,
    rewrite: assetRewrite
  }, supportedLanguages).then(function () {
    clearTimeout(timeout);
    appState.trigger('loading', false);
  });
  // TODO: what if load language error?
}
var _default = {
  loadLanguage
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/Logger.js":
/*!****************************!*\
  !*** ./src/util/Logger.js ***!
  \****************************/
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

function log(level, args) {
  var _window, _window$OktaSignInDeb, _window$OktaSignInDeb2;
  // Only log statements in development mode
  //  or if throwing an error through console.error
  //  or if debugger is enabled
  if (true) {
    window.console[level].apply(window.console, args);
  }
}

/**
 * Utility library of logging functions.
 */
var _default = {
  trace: function () {
    return log('trace', arguments);
  },
  dir: function () {
    return log('dir', arguments);
  },
  time: function () {
    return log('time', arguments);
  },
  timeEnd: function () {
    return log('timeEnd', arguments);
  },
  group: function () {
    return log('group', arguments);
  },
  groupEnd: function () {
    return log('groupEnd', arguments);
  },
  assert: function () {
    return log('assert', arguments);
  },
  log: function () {
    return log('log', arguments);
  },
  info: function () {
    return log('info', arguments);
  },
  warn: function () {
    return log('warn', arguments);
  },
  error: function () {
    return log('error', arguments);
  },
  deprecate: function (msg) {
    return log('warn', ['[okta-signin-widget] DEPRECATED:', msg]);
  }
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/OAuth2Util.js":
/*!********************************!*\
  !*** ./src/util/OAuth2Util.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscore = _interopRequireDefault(__webpack_require__(/*! underscore */ "./node_modules/underscore/underscore-umd.js"));
var _loc = __webpack_require__(/*! ./loc */ "./src/util/loc.ts");
var _Enums = _interopRequireDefault(__webpack_require__(/*! ./Enums */ "./src/util/Enums.js"));
var _OAuthErrors = __webpack_require__(/*! ./OAuthErrors */ "./src/util/OAuthErrors.ts");
var _Util = _interopRequireDefault(__webpack_require__(/*! ./Util */ "./src/util/Util.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const util = {};

// https://github.com/okta/okta-auth-js#authorize-options
const AUTH_PARAMS = ['responseType', 'scopes', 'state', 'nonce', 'idp', 'idpScope', 'display', 'prompt', 'maxAge', 'loginHint'];
util.AUTH_PARAMS = AUTH_PARAMS;

/**
 * Get the tokens in the OIDC/OAUTH flows
 *
 * @param settings - settings model object
 * @param params - {idp: 'xxx'} for social auth
 *                 {sessionToken: 'xxx'} for okta idp
 */
util.getTokens = function (settings, params, controller) {
  function success(result) {
    settings.callGlobalSuccess(_Enums.default.SUCCESS, result);
  }
  function error(error) {
    const typedError = (0, _OAuthErrors.getTypedOAuthError)(error);
    if (typedError.is('terminal')) {
      controller.model.appState.set('flashError', typedError);
      controller.model.appState.trigger('navigate', 'signin/error');
    } else if (typedError.is('inline')) {
      controller.model.trigger('error', controller.model, {
        responseJSON: {
          errorSummary: typedError.errorDetails.errorSummary
        }
      });
      controller.model.appState.trigger('removeLoading');
    }
    if (!typedError.is('terminal')) {
      _Util.default.triggerAfterError(controller, typedError, settings);
    }
    if (typedError instanceof _OAuthErrors.NonRecoverableError) {
      settings.callGlobalError(typedError);
    }
  }
  const authClient = settings.getAuthClient();
  const isAuthorizationCodeFlow = authClient.isAuthorizationCodeFlow() && !authClient.isPKCE();
  const options = settings.toJSON({
    verbose: true
  });
  const getTokenOptions = {};
  _underscore.default.extend(getTokenOptions, _underscore.default.pick(options, 'clientId', 'redirectUri'), _underscore.default.pick(options.authParams, AUTH_PARAMS), params);

  // Extra Options for Social Idp popup window title and id_token response timeout
  getTokenOptions.popupTitle = (0, _loc.loc)('socialauth.popup.title', 'login');
  getTokenOptions.timeout = options.oAuthTimeout;

  // Redirect flow - this can be used when logging into an external IDP, or
  // converting the Okta sessionToken to an access_token, id_token, and/or
  // authorization code. Note: The authorization code flow will always redirect.
  if (options.redirect === 'always' || isAuthorizationCodeFlow) {
    authClient.token.getWithRedirect(getTokenOptions).catch(error);
  } else if (getTokenOptions.sessionToken) {
    // Default flow if logging in with Okta as the IDP - convert sessionToken to
    // tokens in a hidden iframe. Used in Single Page Apps where the app does
    // not want to redirect away from the page to convert the token.
    authClient.token.getWithoutPrompt(getTokenOptions).then(success).catch(error);
  } else {
    // Default flow if logging in with an external IDP - opens a popup and
    // gets the token from a postMessage response.
    authClient.token.getWithPopup(getTokenOptions).then(success).catch(error);
  }
};
var _default = util;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/TimeUtil.js":
/*!******************************!*\
  !*** ./src/util/TimeUtil.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _toMilliseconds = _interopRequireDefault(__webpack_require__(/*! @sindresorhus/to-milliseconds */ "./node_modules/@sindresorhus/to-milliseconds/index.js"));
var _parseMs = _interopRequireDefault(__webpack_require__(/*! parse-ms */ "./node_modules/parse-ms/index.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MOMENT_UNIT = {
  MILLISECOND: 'milliseconds',
  SECOND: 'seconds',
  MINUTE: 'minutes',
  HOUR: 'hours',
  DAY: 'days'
};
const MOMENT_UNIT_KEYS = Object.keys(MOMENT_UNIT);

/**
 * @method convertMomentUnits
 * Conversion between moment's units and our units internally
 *
 * @param {String} momentUnit The units that val is in
 * @return {String} The key in the MOMENT_UNIT hash
 */
const convertMomentUnits = function (momentUnit) {
  const entry = MOMENT_UNIT_KEYS.filter(k => MOMENT_UNIT[k] === momentUnit);
  return entry.length === 1 ? entry[0] : momentUnit;
};
var _default = {
  /**
   * @method getTimeInHighestRelevantUnit
   * Will return a number in the units of the highest relevant time unit.
   * Only checks milliseconds, seconds, minutes, hours, and days.
   * E.g.
   *   15 MINUTE  -> 15 MINUTE
   *   15 minutes -> 15 MINUTE
   *   60 minutes ->  1 HOUR
   *   90 minutes -> 90 MINUTE
   *   24 HOUR    ->  1 DAY
   *   24 hours   ->  1 DAY
   *   30 DAY     -> 30 DAY
   *
   * @typedef { "MILLISECOND" | "SECOND" | "MINUTE" | "HOUR" | "DAY" } TimeUnit
   *
   * @typedef { "MILLISECOND" | "SECOND" | "MINUTE" | "HOUR" | "DAY" |
   *            "milliseconds" | "seconds" | "minutes" | "hours" | "days"
   *          } FlexibleTimeUnit
   *
   * @typedef TimeAndUnit
   * @property {number} time the consolidated time
   * @property {TimeUnit} unit the unit of the time
   *
   * @param {FlexibleTimeUnit} unit The time unit
   * @return {TimeAndUnit} An object containing the amount of time and the unit
   */
  getTimeInHighestRelevantUnit: function (val, unit) {
    const defaultTimeObj = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0
    };
    const normalizedUnit = MOMENT_UNIT[unit] || unit;
    let timeObj;
    try {
      const ms = (0, _toMilliseconds.default)(Object.assign(defaultTimeObj, {
        [normalizedUnit]: val
      }));
      timeObj = (0, _parseMs.default)(ms);
    } catch (error) {
      timeObj = {};
    }
    const duration = Object.keys(timeObj).reduce((init, k) => {
      if (timeObj[k] !== 0) {
        init[k] = timeObj[k];
      }
      return init;
    }, {});
    let highestUnit;
    let time;
    if (Object.keys(duration).length === 1) {
      Object.keys(duration).forEach(k => {
        time = duration[k];
        highestUnit = k;
      });
    } else {
      time = val;
      highestUnit = normalizedUnit;
    }
    return {
      time: time,
      unit: convertMomentUnits(highestUnit)
    };
  }
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/Util.js":
/*!**************************!*\
  !*** ./src/util/Util.js ***!
  \**************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscore = _interopRequireDefault(__webpack_require__(/*! underscore */ "./node_modules/underscore/underscore-umd.js"));
var _loc = __webpack_require__(/*! ./loc */ "./src/util/loc.ts");
var _Enums = _interopRequireDefault(__webpack_require__(/*! ./Enums */ "./src/util/Enums.js"));
var _Logger = _interopRequireDefault(__webpack_require__(/*! ./Logger */ "./src/util/Logger.js"));
var _BrowserFeatures = _interopRequireDefault(__webpack_require__(/*! ./BrowserFeatures */ "./src/util/BrowserFeatures.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint-disable max-statements */
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 13], max-depth: [2, 3] */

const Util = {};
const ovDeepLink = 'redirect_uri=https://login.okta.com/oauth/callback';
const buildInputForParameter = function (name, value) {
  const input = document.createElement('input');
  input.name = name;
  input.value = decodeURIComponent(value);
  input.type = 'hidden';
  return input;
};
const buildSubmitInput = function () {
  const input = document.createElement('input');
  input.type = 'submit';
  return input;
};
const buildDynamicForm = function (url = '', method) {
  const splitOnFragment = url.split('#');
  const fragment = splitOnFragment[1];
  const splitOnQuery = (splitOnFragment[0] || '').split('?');
  const query = splitOnQuery[1];
  let targetUrl = splitOnQuery[0];
  if (fragment) {
    targetUrl += '#' + fragment;
  }
  const form = document.createElement('form');
  form.method = method;
  form.style.display = 'none';
  form.action = targetUrl;
  if (query && query.length) {
    const queryParts = query.split('&');
    queryParts.forEach(queryPart => {
      const parameterParts = queryPart.split('=');
      const input = buildInputForParameter(parameterParts[0], parameterParts[1]);
      form.appendChild(input);
    });
  }
  form.appendChild(buildSubmitInput());
  return form;
};

// eslint-disable-next-line complexity
Util.transformErrorXHR = function (xhr) {
  // Handle network connection error
  if (xhr.status === 0 && _underscore.default.isEmpty(xhr.responseJSON)) {
    xhr.responseJSON = {
      errorSummary: (0, _loc.loc)('error.network.connection', 'login')
    };
    return xhr;
  }
  if (!xhr.responseJSON) {
    if (!xhr.responseText) {
      // Empty server response
      xhr.responseJSON = {
        errorSummary: (0, _loc.loc)('error.unsupported.response', 'login')
      };
      return xhr;
    }
    if (typeof xhr.responseText === 'string') {
      try {
        xhr.responseJSON = JSON.parse(xhr.responseText);
      } catch (e) {
        // Malformed server response
        xhr.responseJSON = {
          errorSummary: (0, _loc.loc)('error.unsupported.response', 'login')
        };
        return xhr;
      }
    } else if (typeof xhr.responseText === 'object') {
      xhr.responseJSON = xhr.responseText;
    }
  }
  // Temporary solution to display field errors
  // Assuming there is only one field error in a response
  if (xhr.responseJSON && xhr.responseJSON.errorCauses && xhr.responseJSON.errorCauses.length) {
    xhr.responseJSON.errorSummary = xhr.responseJSON.errorCauses[0].errorSummary;
  }
  // Replace error messages
  if (!_underscore.default.isEmpty(xhr.responseJSON)) {
    const {
      errorCode
    } = xhr.responseJSON;
    const untranslatedErrorCodes = [
    // API already provides localized and factor specific error message in errorCauses
    'E0000068',
    // API provides localized error message for password requirements in errorCauses
    'E0000014'];
    const errorMsg = errorCode && !untranslatedErrorCodes.includes(errorCode)
    // We don't pass parameters to the `loc()` util
    // However some i18n keys like `errors.E0000001` require one parameter
    // Don't dispatch custom 'okta-i18n-error' event in this case
    ? (0, _loc.loc)('errors.' + errorCode, 'login', [], true) : undefined;
    if ((errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.indexOf('L10N_ERROR[')) === -1) {
      xhr.responseJSON.errorSummary = errorMsg;
      if (xhr.responseJSON && xhr.responseJSON.errorCauses && xhr.responseJSON.errorCauses.length) {
        // BaseForm will consume errorCauses before errorSummary if it is an array,
        // so, we have to make sure to remove it when we have a valid error code
        delete xhr.responseJSON.errorCauses;
      }
    }
  }
  return xhr;
};

// Simple helper function to lowercase all strings in the given array
Util.toLower = function (strings) {
  return _underscore.default.map(strings, function (str) {
    return str.toLowerCase();
  });
};

// A languageCode can be composed of multiple parts, i.e:
// {{language}}-{{region}}-{{dialect}}
//
// In these cases, it's necessary to generate a list of other possible
// combinations that we might support (in preferred order).
//
// For example:
// en-US -> [en-US, en]
// de-DE-bavarian -> [de-DE-bavarian, de-DE, de]
function expandLanguage(language) {
  const expanded = [language];
  const parts = language.split('-');
  while (parts.pop() && parts.length > 0) {
    expanded.push(parts.join('-'));
  }
  return expanded;
}

// Following the rules of expanding one language, this will generate
// all potential languages in the given order (where higher priority is
// given to expanded languages over other downstream languages).
Util.expandLanguages = function (languages) {
  return _underscore.default.chain(languages).map(expandLanguage).flatten().uniq().value();
};

//helper to call setTimeout
Util.callAfterTimeout = function (callback, time) {
  return setTimeout(callback, time);
};

// Helper function to provide consistent formatting of template literals
// that are logged when in development mode.
Util.debugMessage = function (message) {
  _Logger.default.warn(`\n${message.replace(/^(\s)+/gm, '')}`);
};
Util.logConsoleError = function (message) {
  _Logger.default.error(message);
};

// Trigger an afterError event
Util.triggerAfterError = function (controller, err = {}) {
  if (!err.statusCode && err.xhr && err.xhr.status) {
    // Bring the statusCode to the top-level of the Error
    err.statusCode = err.xhr.status;
  }
  // Some controllers return the className as a function - process it here:
  const className = _underscore.default.isFunction(controller.className) ? controller.className() : controller.className;
  const error = _underscore.default.pick(err, 'name', 'message', 'statusCode', 'xhr');
  controller.trigger('afterError', {
    controller: className
  }, error);
  // Logs to console only in dev mode
  _Logger.default.warn('controller: ' + className + ', error: ' + error);
};
Util.redirect = function (url, win = window, isAppLink = false) {
  if (_BrowserFeatures.default.isAndroid() && !isAppLink) {
    Util.redirectWithFormGet(url);
  } else {
    Util.changeLocation(url, win);
  }
};
Util.changeLocation = function (url, win = window) {
  if (!url) {
    _Logger.default.error(`Cannot redirect to empty URL: (${url})`);
    return;
  }
  win.location.href = url;
};
Util.executeOnVisiblePage = function (cb) {
  if (document.visibilityState === 'hidden') {
    const visibilityChangeHandler = () => {
      if (document.visibilityState === 'visible') {
        document.removeEventListener('visibilitychange', visibilityChangeHandler);
        cb();
      }
    };
    document.addEventListener('visibilitychange', visibilityChangeHandler);
  } else {
    cb();
  }
};
Util.isAndroidOVEnrollment = function () {
  const ovEnrollment = decodeURIComponent(window.location.href).includes(ovDeepLink);
  return _BrowserFeatures.default.isAndroid() && ovEnrollment;
};

/**
 * Why redirect via Form get rather using `window.location.href`?
 * At the time of writing, Chrome (<72) in Android would block window location change
 * at following case
 * 1. An AJAX is trigger because of user action.
 * 2. 5+ seconds passed without any further user interaction.
 * 3. User takes an action results in window location change.
 *
 * Luckily we discovered that uses Form submit would work around this problem
 * even though it changed window location.
 *
 * Check the commit history for more details.
 */
Util.redirectWithFormGet = function (url) {
  Util.redirectWithForm(url, 'get');
};
Util.redirectWithForm = function (url, method = 'post') {
  if (!url) {
    _Logger.default.error(`Cannot redirect to empty URL: (${url})`);
    return;
  }
  const mainContainer = document.getElementById(_Enums.default.WIDGET_CONTAINER_ID);
  if (!mainContainer) {
    _Logger.default.error('Cannot find okta-sign-in container append to which a form');
    return;
  }
  const form = buildDynamicForm(url, method);
  mainContainer.appendChild(form);
  form.querySelector('input[type="submit"]').click();
};

/**
 * When we want to show an explain text, we need to check if this is different from
 * the label text, to not have an explain that look like a duplicated label.
 * okta-signin-widget gives the possibility to customize every i18n, so we cannot
 * know ahead if these two are equal or different, we need to call this function everytime.
 */
Util.createInputExplain = function (explainKey, labelKey, bundleName, explainParams, labelParams) {
  const explain = explainParams ? (0, _loc.loc)(explainKey, bundleName, explainParams) : (0, _loc.loc)(explainKey, bundleName);
  const label = labelParams ? (0, _loc.loc)(labelKey, bundleName, labelParams) : (0, _loc.loc)(labelKey, bundleName);
  if (explain === label) {
    return false;
  }
  return explain;
};
Util.isV1StateToken = function (token) {
  return !!(token && _underscore.default.isString(token) && token.startsWith('00'));
};
Util.getAutocompleteValue = function (settings, defaultValue) {
  const shouldDisableAutocomplete = settings === null || settings === void 0 ? void 0 : settings.get('features.disableAutocomplete');
  if (shouldDisableAutocomplete) {
    return 'off';
  }
  return defaultValue;
};

/**
 * Equivalent of `new URLSearchParams(params).toString()` with broadest browser support.
 * Does not include params with nullish values.
 */
Util.searchParamsToString = function (params) {
  return Object.keys(params).filter(key => {
    const val = params[key];
    return val !== undefined && val !== null;
  }).map(key => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
  }).join('&');
};
var _default = Util;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/countryCallingCodes.js":
/*!*****************************************!*\
  !*** ./src/util/countryCallingCodes.js ***!
  \*****************************************/
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
/* eslint max-len:0 */
var _default = {
  US: '1',
  AG: '1',
  AI: '1',
  AS: '1',
  BB: '1',
  BM: '1',
  BS: '1',
  CA: '1',
  DM: '1',
  DO: '1',
  GD: '1',
  GU: '1',
  JM: '1',
  KN: '1',
  KY: '1',
  LC: '1',
  MP: '1',
  MS: '1',
  PR: '1',
  SX: '1',
  TC: '1',
  TT: '1',
  VC: '1',
  VG: '1',
  VI: '1',
  RU: '7',
  KZ: '7',
  EG: '20',
  ZA: '27',
  GR: '30',
  NL: '31',
  BE: '32',
  FR: '33',
  ES: '34',
  HU: '36',
  IT: '39',
  VA: '39',
  RO: '40',
  CH: '41',
  AT: '43',
  GB: '44',
  GG: '44',
  IM: '44',
  JE: '44',
  DK: '45',
  SE: '46',
  NO: '47',
  SJ: '47',
  PL: '48',
  DE: '49',
  PE: '51',
  MX: '52',
  CU: '53',
  AR: '54',
  BR: '55',
  CL: '56',
  CO: '57',
  VE: '58',
  MY: '60',
  AU: '61',
  CC: '61',
  CX: '61',
  ID: '62',
  PH: '63',
  NZ: '64',
  SG: '65',
  TH: '66',
  JP: '81',
  KR: '82',
  VN: '84',
  CN: '86',
  TR: '90',
  IN: '91',
  PK: '92',
  AF: '93',
  LK: '94',
  MM: '95',
  IR: '98',
  SS: '211',
  MA: '212',
  EH: '212',
  DZ: '213',
  TN: '216',
  LY: '218',
  GM: '220',
  SN: '221',
  MR: '222',
  ML: '223',
  GN: '224',
  CI: '225',
  BF: '226',
  NE: '227',
  TG: '228',
  BJ: '229',
  MU: '230',
  LR: '231',
  SL: '232',
  GH: '233',
  NG: '234',
  TD: '235',
  CF: '236',
  CM: '237',
  CV: '238',
  ST: '239',
  GQ: '240',
  GA: '241',
  CG: '242',
  CD: '243',
  AO: '244',
  GW: '245',
  IO: '246',
  AC: '247',
  SC: '248',
  SD: '249',
  RW: '250',
  ET: '251',
  SO: '252',
  DJ: '253',
  KE: '254',
  TZ: '255',
  UG: '256',
  BI: '257',
  MZ: '258',
  ZM: '260',
  MG: '261',
  RE: '262',
  YT: '262',
  ZW: '263',
  NA: '264',
  MW: '265',
  LS: '266',
  BW: '267',
  SZ: '268',
  KM: '269',
  SH: '290',
  TA: '290',
  ER: '291',
  AW: '297',
  FO: '298',
  GL: '299',
  GI: '350',
  PT: '351',
  LU: '352',
  IE: '353',
  IS: '354',
  AL: '355',
  MT: '356',
  CY: '357',
  FI: '358',
  AX: '358',
  BG: '359',
  LT: '370',
  LV: '371',
  EE: '372',
  MD: '373',
  AM: '374',
  BY: '375',
  AD: '376',
  MC: '377',
  SM: '378',
  UA: '380',
  RS: '381',
  ME: '382',
  XK: '383',
  HR: '385',
  SI: '386',
  BA: '387',
  MK: '389',
  CZ: '420',
  SK: '421',
  LI: '423',
  FK: '500',
  BZ: '501',
  GT: '502',
  SV: '503',
  HN: '504',
  NI: '505',
  CR: '506',
  PA: '507',
  PM: '508',
  HT: '509',
  GP: '590',
  BL: '590',
  MF: '590',
  BO: '591',
  GY: '592',
  EC: '593',
  GF: '594',
  PY: '595',
  MQ: '596',
  SR: '597',
  UY: '598',
  CW: '599',
  BQ: '599',
  TL: '670',
  NF: '672',
  BN: '673',
  NR: '674',
  PG: '675',
  TO: '676',
  SB: '677',
  VU: '678',
  FJ: '679',
  PW: '680',
  WF: '681',
  CK: '682',
  NU: '683',
  WS: '685',
  KI: '686',
  NC: '687',
  TV: '688',
  PF: '689',
  TK: '690',
  FM: '691',
  MH: '692',
  '001': '979',
  KP: '850',
  HK: '852',
  MO: '853',
  KH: '855',
  LA: '856',
  BD: '880',
  TW: '886',
  MV: '960',
  LB: '961',
  JO: '962',
  SY: '963',
  IQ: '964',
  KW: '965',
  SA: '966',
  YE: '967',
  OM: '968',
  PS: '970',
  AE: '971',
  IL: '972',
  BH: '973',
  QA: '974',
  BT: '975',
  MN: '976',
  NP: '977',
  TJ: '992',
  TM: '993',
  AZ: '994',
  GE: '995',
  KG: '996',
  UZ: '998',
  GS: '500',
  PN: '64',
  AQ: '672',
  UM: '1',
  AN: '599'
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/webauthn.js":
/*!******************************!*\
  !*** ./src/util/webauthn.js ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
var _FidoUtil = _interopRequireDefault(__webpack_require__(/*! util/FidoUtil */ "./src/util/FidoUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

function adaptToOkta(promise) {
  return new _q.default(promise);
}
function makeCredential(accountInfo, cryptoParams, challenge) {
  cryptoParams = cryptoParams.map(function (param) {
    return {
      type: 'FIDO_2_0',
      algorithm: param.algorithm
    };
  });
  const promise = window.msCredentials.makeCredential(accountInfo, cryptoParams, challenge).then(function (cred) {
    return Object.freeze({
      credential: {
        id: cred.id
      },
      publicKey: JSON.parse(cred.publicKey),
      attestation: cred.attestation
    });
  });
  return adaptToOkta(promise);
}
function getAssertion(challenge, allowList) {
  const accept = allowList.map(function (item) {
    return {
      type: 'FIDO_2_0',
      id: item.id
    };
  });
  const filters = {
    accept: accept
  };
  const promise = window.msCredentials.getAssertion(challenge, filters).then(function (attestation) {
    const signature = attestation.signature;
    return Object.freeze({
      credential: {
        id: attestation.id
      },
      clientData: signature.clientData,
      authenticatorData: signature.authnrData,
      signature: signature.signature
    });
  });
  return adaptToOkta(promise);
}
function processWebAuthnResponse(inputFunction, context) {
  if (typeof inputFunction === 'undefined') {
    return null;
  }
  const responseValue = inputFunction.apply(context);
  if (responseValue === undefined || responseValue === null) {
    return null;
  }
  return JSON.stringify(responseValue);
}
var _default = {
  makeCredential: makeCredential,
  getAssertion: getAssertion,
  processWebAuthnResponse: processWebAuthnResponse,
  isAvailable: function () {
    return Object.prototype.hasOwnProperty.call(window, 'msCredentials');
  },
  isNewApiAvailable: function () {
    // navigator.credentials is not supported in IE11
    // eslint-disable-next-line compat/compat
    return navigator && navigator.credentials && navigator.credentials.create;
  },
  isWebauthnOrU2fAvailable: function () {
    return this.isNewApiAvailable() || _FidoUtil.default.isU2fAvailable();
  }
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/BaseLoginRouter.js":
/*!***********************************!*\
  !*** ./src/v1/BaseLoginRouter.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _AppState = _interopRequireDefault(__webpack_require__(/*! v1/models/AppState */ "./src/v1/models/AppState.js"));
var _Settings = _interopRequireDefault(__webpack_require__(/*! models/Settings */ "./src/models/Settings.ts"));
var _Bundles = _interopRequireDefault(__webpack_require__(/*! util/Bundles */ "./src/util/Bundles.ts"));
var _Logger = _interopRequireDefault(__webpack_require__(/*! util/Logger */ "./src/util/Logger.js"));
var _AuthContainer = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/AuthContainer */ "./src/v1/views/shared/AuthContainer.js"));
var _Header = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/Header */ "./src/v1/views/shared/Header.ts"));
var _SecurityBeacon = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/SecurityBeacon */ "./src/v1/views/shared/SecurityBeacon.js"));
var _Animations = _interopRequireDefault(__webpack_require__(/*! util/Animations */ "./src/util/Animations.js"));
var _BrowserFeatures = _interopRequireDefault(__webpack_require__(/*! util/BrowserFeatures */ "./src/util/BrowserFeatures.ts"));
var _ColorsUtil = _interopRequireDefault(__webpack_require__(/*! util/ColorsUtil */ "./src/util/ColorsUtil.js"));
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _RouterUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/RouterUtil */ "./src/v1/util/RouterUtil.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _LanguageUtil = _interopRequireDefault(__webpack_require__(/*! util/LanguageUtil */ "./src/util/LanguageUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-params: [2, 16], max-statements: [2, 20] */
// BaseLoginRouter contains the more complicated router logic - rendering/
// transition, etc. Most router changes should happen in LoginRouter (which is
// responsible for adding new routes)

function isStateLessRouteHandler(router, fn) {
  return _courage._.find(router.stateLessRouteHandlers, function (routeName) {
    return fn === router[routeName];
  });
}
function beaconIsAvailable(Beacon, settings) {
  if (!Beacon) {
    return false;
  }
  if (Beacon === _SecurityBeacon.default) {
    return settings.get('features.securityImage');
  }
  return true;
}
var _default = _courage.Router.extend({
  Events: _courage.Backbone.Events,
  initialize: function (options) {
    // Create a default success and/or error handler if
    // one is not provided.
    if (!options.globalSuccessFn) {
      options.globalSuccessFn = function () {};
    }
    if (!options.globalErrorFn) {
      options.globalErrorFn = function (err) {
        _Logger.default.error(err);
      };
    }
    this.settings = new _Settings.default(_courage._.omit(options, 'el'), {
      parse: true
    });
    if (!options.el) {
      this.settings.callGlobalError(new _Errors.ConfigError((0, _courage.loc)('error.required.el')));
    }
    (0, _courage.$)('body > div').on('click', function () {
      // OKTA-69769 Tooltip wont close on iPhone/iPad
      // Registering a click handler on the first div
      // allows a tap that falls outside the tooltip
      // to be registered as a tap by iOS
      // and then the open tooltip will lose focus and close.
    });
    this.appState = new _AppState.default({
      baseUrl: this.settings.get('baseUrl'),
      settings: this.settings
    }, {
      parse: true
    });
    const wrapper = new _AuthContainer.default({
      appState: this.appState
    });
    (0, _courage.$)(options.el).append(wrapper.render().$el);
    this.el = `#${_Enums.default.WIDGET_CONTAINER_ID}`;
    this.header = new _Header.default({
      el: this.el,
      appState: this.appState,
      settings: this.settings
    });

    // Hide until unitial render
    this.hide();
    this.listenTo(this.appState, 'change:transactionError', function (appState, err) {
      _RouterUtil.default.routeAfterAuthStatusChangeError(this, err);
    });
    this.listenTo(this.appState, 'change:transaction', function (appState, trans) {
      _RouterUtil.default.routeAfterAuthStatusChange(this, trans.data);
    });
    this.listenTo(this.appState, 'navigate', function (url) {
      this.navigate(url, {
        trigger: true
      });
    });
  },
  execute: function (cb, args) {
    const recoveryToken = this.settings.get('recoveryToken');
    // Recovery flow with a token passed through widget settings

    if (recoveryToken) {
      this.settings.unset('recoveryToken');
      this.navigate(_RouterUtil.default.createRecoveryUrl(recoveryToken), {
        trigger: true
      });
      return;
    }

    // Refresh flow with a stateToken passed through widget settings
    const stateToken = this.settings.get('stateToken');
    if (stateToken) {
      this.settings.unset('stateToken');
      this.navigate(_RouterUtil.default.createRefreshUrl(stateToken), {
        trigger: true
      });
      return;
    }

    // Normal flow - we've either navigated to a stateless page, or are
    // in the middle of an auth flow
    const trans = this.appState.get('transaction');
    if (trans && trans.data || isStateLessRouteHandler(this, cb)) {
      cb.apply(this, args);
      return;
    }

    // StateToken cookie exists on page load, and we are on a stateful url
    if (this.settings.getAuthClient().tx.exists()) {
      this.navigate(_RouterUtil.default.createRefreshUrl(), {
        trigger: true
      });
      return;
    }

    // We've hit a page that requires state, but have no stateToken - redirect
    // back to primary auth
    this.navigate('', {
      trigger: true
    });
  },
  // Overriding the default navigate method to allow the widget consumer
  // to "turn off" routing - if features.router is false, the browser
  // location bar will not update when the router navigates
  navigate: function (fragment, options) {
    if (this.settings.get('features.router')) {
      return _courage.Router.prototype.navigate.apply(this, arguments);
    }
    if (options && options.trigger) {
      return _courage.Backbone.history.loadUrl(fragment);
    }
  },
  render: function (Controller, options) {
    options || (options = {});
    let Beacon = options.Beacon;
    const controllerOptions = _courage._.extend({
      settings: this.settings,
      appState: this.appState
    }, _courage._.omit(options, 'Beacon'));

    // Since we have a wrapper view, render our wrapper and use its content
    // element as our new el.
    // Note: Render it here because we know dom is ready at this point
    if (!this.header.rendered()) {
      this.el = this.header.render().getContentEl();
    }

    // If we need to load a language (or apply custom i18n overrides), do
    // this now and re-run render after it's finished.
    if (!_Bundles.default.isLoaded(this.appState.get('languageCode'))) {
      return _LanguageUtil.default.loadLanguage(this.appState, this.settings).then(_courage._.bind(this.render, this, Controller, options));
    }

    // Load the custom colors only on the first render
    if (this.settings.get('colors.brand') && !_ColorsUtil.default.isLoaded()) {
      const colors = {
        brand: this.settings.get('colors.brand')
      };
      const cspNonce = this.settings.get('cspNonce');
      _ColorsUtil.default.addStyle(colors, cspNonce);
    }
    const oldController = this.controller;
    this.controller = new Controller(controllerOptions);

    // Bubble up all controller events
    this.listenTo(this.controller, 'all', this.trigger);

    // First run fetchInitialData, in case the next controller needs data
    // before it's initial render. This will leave the current page in a
    // loading state.
    return this.controller.fetchInitialData().then(() => {
      // Beacon transition occurs in parallel to page swap
      if (!beaconIsAvailable(Beacon, this.settings)) {
        Beacon = null;
      }
      this.header.setBeacon(Beacon, controllerOptions);

      // Show before initial render
      this.show();
      this.controller.render();
      if (!oldController) {
        this.el.append(this.controller.el);
        this.controller.postRenderAnimation();
        return;
      }
      return _Animations.default.swapPages({
        $parent: this.el,
        $oldRoot: oldController.$el,
        $newRoot: this.controller.$el,
        dir: oldController.state.get('navigateDir'),
        ctx: this,
        success: function () {
          const flashError = this.appState.get('flashError');
          const model = this.controller.model;
          oldController.remove();
          oldController.$el.remove();
          this.controller.postRenderAnimation();
          if (flashError) {
            let errorSummary;
            const isTerminalError = flashError.is && flashError.is('terminal');
            if (isTerminalError) {
              errorSummary = flashError.errorDetails.errorSummary;
            } else {
              errorSummary = (0, _courage.loc)(this.settings.get('features.mfaOnlyFlow') ? 'error.mfa.only.expired.session' : 'error.expired.session');
            }
            model.trigger('error', model, {
              responseJSON: {
                errorSummary
              }
            });
            this.appState.unset('flashError');
            _Util.default.triggerAfterError(this.controller, flashError);
          }
        }
      });
    }).catch(function () {
      // OKTA-69665 - if an error occurs in fetchInitialData, we're left in
      // a state with two active controllers. Therefore, we clean up the
      // old one. Note: This explicitly handles the invalid token case -
      // if we get some other type of error which doesn't force a redirect,
      // we will probably be left in a bad state. I.e. old controller is
      // dropped and new controller is not rendered.
      if (oldController) {
        oldController.remove();
        oldController.$el.remove();
      }
    });
  },
  start: function () {
    let pushState = false;

    // Support for browser's back button.
    if (window.addEventListener && this.settings.get('features.router')) {
      window.addEventListener('popstate', e => {
        if (this.controller.back) {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.controller.back();
        }
      });
      pushState = _BrowserFeatures.default.supportsPushState();
    }
    _courage.Router.prototype.start.call(this, {
      pushState: pushState
    });
  },
  hide: function () {
    this.header.$el.hide();
  },
  show: function () {
    this.header.$el.show();
  },
  remove: function () {
    if (this.controller) {
      this.controller.remove();
    }
    this.header.$el.remove();
    _Bundles.default.remove();
    _courage.Backbone.history.stop();
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/AccountUnlockedController.js":
/*!*********************************************************!*\
  !*** ./src/v1/controllers/AccountUnlockedController.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'account-unlocked',
  Model: function () {
    return {
      local: {
        userFullName: ['string', false, this.options.appState.get('userFullName')]
      }
    };
  },
  Form: {
    title: _courage._.partial(_courage.loc, 'account.unlock.unlocked.title', 'login'),
    subtitle: _courage._.partial(_courage.loc, 'account.unlock.unlocked.desc', 'login'),
    noButtonBar: true,
    attributes: {
      'data-se': 'account-unlocked'
    },
    formChildren: function () {
      return [_FormType.default.Button({
        title: (0, _courage.loc)('goback', 'login'),
        className: 'button button-primary button-wide',
        attributes: {
          'data-se': 'back-button'
        },
        click: function () {
          this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
          this.options.appState.trigger('navigate', '');
        }
      })];
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/ActivateTotpController.js":
/*!******************************************************!*\
  !*** ./src/v1/controllers/ActivateTotpController.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _EnterPasscodeForm = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/EnterPasscodeForm */ "./src/v1/views/enroll-factors/EnterPasscodeForm.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'activate-totp',
  Model: function () {
    return {
      props: {
        factorId: ['string', true, this.options.appState.get('activatedFactorId')],
        passCode: ['string', true]
      },
      local: {
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      },
      save: function () {
        return this.doTransaction(function (transaction) {
          return transaction.activate({
            passCode: this.get('passCode')
          });
        });
      }
    };
  },
  Form: _EnterPasscodeForm.default,
  Footer: _Footer.default
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/AdminConsentRequiredController.js":
/*!**************************************************************!*\
  !*** ./src/v1/controllers/AdminConsentRequiredController.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _ScopeList = _interopRequireDefault(__webpack_require__(/*! v1/views/admin-consent/ScopeList */ "./src/v1/views/admin-consent/ScopeList.js"));
var _consentLogoHeaderTemplate = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/templates/consentLogoHeaderTemplate */ "./src/v1/views/shared/templates/consentLogoHeaderTemplate.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const ConsentModel = {
  props: {
    scopes: ['array', true]
  },
  save: function () {
    return this.doTransaction(function (transaction) {
      return transaction.consent({
        consent: {
          scopes: _courage._.pluck(this.get('scopes'), 'name')
        }
      });
    });
  },
  cancel: function () {
    var self = this;
    return this.doTransaction(function (transaction) {
      return transaction.cancel();
    }).then(function () {
      var consentCancelFn = self.settings.get('consent.cancel');
      if (_courage._.isFunction(consentCancelFn)) {
        consentCancelFn();
      }
    });
  }
};
const ConsentHeader = _courage.View.extend({
  className: 'consent-title detail-row',
  template: _consentLogoHeaderTemplate.default,
  getTemplateData: function () {
    var appState = this.options.appState;
    return {
      appName: appState.escape('targetLabel'),
      customLogo: appState.get('targetLogo') && appState.get('targetLogo').href,
      defaultLogo: appState.get('defaultAppLogo'),
      clientURI: appState.get('targetClientURI') && appState.get('targetClientURI').href,
      issuer: appState.get('issuer')
    };
  }
});
const ConsentForm = {
  noCancelButton: false,
  buttonOrder: ['cancel', 'save'],
  autoSave: true,
  save: _courage._.partial(_courage.loc, 'consent.required.consentButton', 'login'),
  cancel: _courage._.partial(_courage.loc, 'consent.required.cancelButton', 'login'),
  formChildren: [_FormType.default.View({
    View: ConsentHeader
  }), _FormType.default.View({
    View: _ScopeList.default
  })]
};
const AdminConsentRequiredController = _FormController.default.extend({
  Model: ConsentModel,
  Form: ConsentForm,
  className: 'admin-consent-required',
  initialize: function () {
    this.model.set('scopes', this.options.appState.get('scopes'));
    this.listenTo(this.form, 'cancel', () => {
      this.model.cancel();
    });
  }
});
var _default = AdminConsentRequiredController;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/BarcodePushController.js":
/*!*****************************************************!*\
  !*** ./src/v1/controllers/BarcodePushController.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _BarcodeView = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/BarcodeView */ "./src/v1/views/enroll-factors/BarcodeView.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const PUSH_INTERVAL = 6000;

// Note: Keep-alive is set to 5 seconds - using 5 seconds here will result
// in network connection lost errors in Safari and IE.
var _default = _FormController.default.extend({
  className: 'barcode-push',
  Model: function () {
    return {
      local: {
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      }
    };
  },
  Form: {
    title: function () {
      const factorName = _FactorUtil.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
      return (0, _courage.loc)('enroll.totp.title', 'login', [factorName]);
    },
    noButtonBar: true,
    attributes: {
      'data-se': 'step-scan'
    },
    className: 'barcode-scan',
    initialize: function () {
      this.listenTo(this.model, 'error errors:clear', function () {
        this.clearErrors();
      });
    },
    formChildren: [_FormType.default.View({
      View: _BarcodeView.default
    })]
  },
  Footer: _Footer.default,
  initialize: function () {
    this.pollForEnrollment().catch(() => {
      // Ignoring the errors for now. 
      // clean up will be done based on OKTA-324849
    });
  },
  pollForEnrollment: function () {
    return this.model.doTransaction(function (transaction) {
      return transaction.poll(PUSH_INTERVAL);
    });
  },
  trapAuthResponse: function () {
    if (this.options.appState.get('isMfaEnrollActivate')) {
      return true;
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/BarcodeTotpController.js":
/*!*****************************************************!*\
  !*** ./src/v1/controllers/BarcodeTotpController.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _RouterUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/RouterUtil */ "./src/v1/util/RouterUtil.js"));
var _BarcodeView = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/BarcodeView */ "./src/v1/views/enroll-factors/BarcodeView.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'barcode-totp',
  Model: function () {
    return {
      local: {
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      }
    };
  },
  Form: {
    title: function () {
      const factorName = _FactorUtil.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
      return (0, _courage.loc)('enroll.totp.title', 'login', [factorName]);
    },
    save: _courage._.partial(_courage.loc, 'oform.next', 'login'),
    noCancelButton: true,
    attributes: {
      'data-se': 'step-scan'
    },
    className: 'barcode-scan',
    formChildren: [_FormType.default.View({
      View: _BarcodeView.default
    })]
  },
  Footer: _Footer.default,
  initialize: function () {
    this.listenTo(this.form, 'save', function () {
      const url = _RouterUtil.default.createActivateFactorUrl(this.model.get('__provider__'), this.model.get('__factorType__'), 'activate');
      this.options.appState.trigger('navigate', url);
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/ConsentRequiredController.js":
/*!*********************************************************!*\
  !*** ./src/v1/controllers/ConsentRequiredController.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _ScopeList = _interopRequireDefault(__webpack_require__(/*! v1/views/consent/ScopeList */ "./src/v1/views/consent/ScopeList.js"));
var _ScopeCheckBox = _interopRequireDefault(__webpack_require__(/*! v1/views/consent/ScopeCheckBox */ "./src/v1/views/consent/ScopeCheckBox.js"));
var _SkipLink = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/SkipLink */ "./src/v1/views/shared/SkipLink.js"));
var _consentLogoHeaderTemplate = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/templates/consentLogoHeaderTemplate */ "./src/v1/views/shared/templates/consentLogoHeaderTemplate.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-len: [2, 160] */

const granularConsentHeaderTemplate = _runtime.default.template({
  "1": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<a href=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "clientURI") || (depth0 != null ? lookupProperty(depth0, "clientURI") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "clientURI",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 26
        },
        "end": {
          "line": 1,
          "column": 39
        }
      }
    }) : helper)) + "\" class=\"client-logo-link\" target=\"_blank\">";
  },
  "3": function (container, depth0, helpers, partials, data) {
    var helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      alias2 = container.hooks.helperMissing,
      alias3 = container.escapeExpression,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<img class=\"client-logo custom-logo\" src=\"" + alias3((helper = (helper = lookupProperty(helpers, "customLogo") || (depth0 != null ? lookupProperty(depth0, "customLogo") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
      "name": "customLogo",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 149
        },
        "end": {
          "line": 1,
          "column": 163
        }
      }
    }) : helper)) + "\" alt=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
      "name": "i18n",
      "hash": {
        "bundle": "login",
        "code": "common.logo.alt"
      },
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 170
        },
        "end": {
          "line": 1,
          "column": 216
        }
      }
    })) + "\" aria-hidden=\"true\" />";
  },
  "5": function (container, depth0, helpers, partials, data) {
    var helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      alias2 = container.hooks.helperMissing,
      alias3 = container.escapeExpression,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<img class=\"client-logo default-logo\" src=\"" + alias3((helper = (helper = lookupProperty(helpers, "defaultLogo") || (depth0 != null ? lookupProperty(depth0, "defaultLogo") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
      "name": "defaultLogo",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 290
        },
        "end": {
          "line": 1,
          "column": 305
        }
      }
    }) : helper)) + "\" alt=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
      "name": "i18n",
      "hash": {
        "bundle": "login",
        "code": "common.logo.alt"
      },
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 312
        },
        "end": {
          "line": 1,
          "column": 358
        }
      }
    })) + "\" aria-hidden=\"true\" />";
  },
  "7": function (container, depth0, helpers, partials, data) {
    return "</a>";
  },
  "9": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<div class=\"issuer\"><span>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "issuer") || (depth0 != null ? lookupProperty(depth0, "issuer") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "issuer",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 624
        },
        "end": {
          "line": 1,
          "column": 634
        }
      }
    }) : helper)) + "</span></div>";
  },
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var stack1,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(1, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 0
        },
        "end": {
          "line": 1,
          "column": 89
        }
      }
    })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "customLogo") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(3, data, 0),
      "inverse": container.program(5, data, 0),
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 89
        },
        "end": {
          "line": 1,
          "column": 388
        }
      }
    })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(7, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 388
        },
        "end": {
          "line": 1,
          "column": 416
        }
      }
    })) != null ? stack1 : "") + "<h1><span class=\"title-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
      "name": "i18n",
      "hash": {
        "$2": "<p>$2</p>",
        "$1": "<b class='no-translate'>$1</b>",
        "arguments": "appName",
        "bundle": "login",
        "code": "granular.consent.scopes.title"
      },
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 445
        },
        "end": {
          "line": 1,
          "column": 577
        }
      }
    })) + "</span>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "issuer") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(9, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 584
        },
        "end": {
          "line": 1,
          "column": 654
        }
      }
    })) != null ? stack1 : "") + "</h1>";
  },
  "useData": true
});
const getConsentHeader = template => _FormType.default.View({
  View: _courage.View.extend({
    className: 'consent-title detail-row',
    template,
    getTemplateData: function () {
      const appState = this.options.appState;
      return {
        appName: appState.escape('targetLabel'),
        customLogo: appState.get('targetLogo') && appState.get('targetLogo').href,
        defaultLogo: appState.get('defaultAppLogo'),
        clientURI: appState.get('targetClientURI') && appState.get('targetClientURI').href
      };
    }
  })
});
const consentRequiredDescription = _FormType.default.View({
  View: _courage.View.extend({
    className: 'consent-description detail-row',
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function (container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
        return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "consent.required.description"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 3
            },
            "end": {
              "line": 1,
              "column": 62
            }
          }
        })) + "</p>";
      },
      "useData": true
    })
  })
});
const granularConsentDescription = _FormType.default.View({
  View: _courage.View.extend({
    className: 'consent-description',
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function (container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
        return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "granular.consent.scopes.description"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 3
            },
            "end": {
              "line": 1,
              "column": 69
            }
          }
        })) + "</p>";
      },
      "useData": true
    })
  })
});
const getScopeCheckBoxes = scopes => {
  const sortedScopes = scopes.slice().sort((scope1, scope2) => scope2.optional - scope1.optional);
  return _courage._.map(sortedScopes, ({
    name,
    displayName,
    description,
    optional,
    isCustomized
  }) => _FormType.default.Input({
    name: name,
    input: _ScopeCheckBox.default,
    placeholder: displayName,
    label: false,
    modelType: 'boolean',
    required: true,
    options: {
      description,
      optional,
      isCustomized
    }
  }));
};
const isGranularConsent = appState => {
  return 'optional' in appState.get('scopes')[0];
};
var _default = _FormController.default.extend({
  className: 'consent-required',
  initialize: function () {
    this.model.set('expiresAt', this.options.appState.get('expiresAt'));
    this.model.set('scopes', this.options.appState.get('scopes'));
    this.listenTo(this.form, 'cancel', _courage._.bind(this.model.cancel, this.model));

    // add Skip to main content link
    const skipLink = new _SkipLink.default();
    (0, _courage.$)(`#${_Enums.default.WIDGET_LOGIN_CONTAINER_ID}`).prepend(skipLink.render().$el);
    if (isGranularConsent(this.options.appState)) {
      this.$el.addClass('granular-consent').removeClass('consent-required');
      this.form.cancel = _courage._.partial(_courage.loc, 'oform.cancel', 'login');
      _courage._.forEach(this.options.appState.get('scopes'), scope => {
        this.model.set(scope.name, true);
      });
    }
  },
  postRender: function () {
    _FormController.default.prototype.postRender.apply(this, arguments);

    // Update the "don't allow" and "allow access" buttons to be neutral by changing "allow button" to be gray.
    this.$('.o-form-button-bar .button-primary').removeClass('button-primary');
  },
  Model: {
    props: {
      expiresAt: ['string', true],
      scopes: ['array', true]
    },
    save: function () {
      return this.doTransaction(function (transaction) {
        let scopeNames = _courage._.pluck(this.get('scopes'), 'name');
        let consent = {
          expiresAt: this.get('expiresAt')
        };
        if (isGranularConsent(this)) {
          consent['optedScopes'] = _courage._.reduce(scopeNames, (optedScopes, scope) => {
            optedScopes[scope] = this.get(scope);
            return optedScopes;
          }, {});
        } else {
          consent['scopes'] = scopeNames;
        }
        return transaction.consent({
          consent
        });
      });
    },
    cancel: function () {
      const self = this;
      return this.doTransaction(function (transaction) {
        return transaction.cancel();
      }).then(function () {
        const consentCancelFn = self.settings.get('consent.cancel');
        if (_courage._.isFunction(consentCancelFn)) {
          consentCancelFn();
        }
      });
    }
  },
  Form: {
    noCancelButton: false,
    buttonOrder: ['cancel', 'save'],
    autoSave: true,
    save: _courage._.partial(_courage.loc, 'consent.required.consentButton', 'login'),
    cancel: _courage._.partial(_courage.loc, 'consent.required.cancelButton', 'login'),
    formChildren: function () {
      if (isGranularConsent(this.options.appState)) {
        return [getConsentHeader(granularConsentHeaderTemplate), granularConsentDescription].concat(getScopeCheckBoxes(this.options.appState.get('scopes')));
      } else {
        return [getConsentHeader(_consentLogoHeaderTemplate.default), _FormType.default.View({
          View: new _ScopeList.default({
            model: this.model
          })
        }), consentRequiredDescription];
      }
    }
  },
  Footer: _courage.View.extend({
    className: 'consent-footer',
    template: _runtime.default.template({
      "1": function (container, depth0, helpers, partials, data) {
        var stack1,
          helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }
            return undefined;
          };
        return "<a class=\"terms-of-service\" href=\"" + alias3((helper = (helper = lookupProperty(helpers, "termsOfService") || (depth0 != null ? lookupProperty(depth0, "termsOfService") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
          "name": "termsOfService",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 56
            },
            "end": {
              "line": 1,
              "column": 74
            }
          }
        }) : helper)) + "\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "consent.required.termsOfService"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 92
            },
            "end": {
              "line": 1,
              "column": 154
            }
          }
        })) + "</a>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(2, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 158
            },
            "end": {
              "line": 1,
              "column": 194
            }
          }
        })) != null ? stack1 : "");
      },
      "2": function (container, depth0, helpers, partials, data) {
        return " &#8226 ";
      },
      "4": function (container, depth0, helpers, partials, data) {
        var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }
            return undefined;
          };
        return "<a class=\"privacy-policy\" href=\"" + alias3((helper = (helper = lookupProperty(helpers, "privacyPolicy") || (depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
          "name": "privacyPolicy",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 254
            },
            "end": {
              "line": 1,
              "column": 271
            }
          }
        }) : helper)) + "\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "consent.required.privacyPolicy"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 289
            },
            "end": {
              "line": 1,
              "column": 350
            }
          }
        })) + "</a>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function (container, depth0, helpers, partials, data) {
        var stack1,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }
            return undefined;
          };
        return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "termsOfService") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 0
            },
            "end": {
              "line": 1,
              "column": 201
            }
          }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(4, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 201
            },
            "end": {
              "line": 1,
              "column": 361
            }
          }
        })) != null ? stack1 : "");
      },
      "useData": true
    }),
    getTemplateData: function () {
      const appState = this.options.appState;
      return {
        termsOfService: appState.get('targetTermsOfService') && appState.get('targetTermsOfService').href,
        privacyPolicy: appState.get('targetPrivacyPolicy') && appState.get('targetPrivacyPolicy').href
      };
    }
  })
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/CustomPasswordExpiredController.js":
/*!***************************************************************!*\
  !*** ./src/v1/controllers/CustomPasswordExpiredController.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/expired-password/Footer */ "./src/v1/views/expired-password/Footer.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const {
  Util
} = _courage.internal.util;
var _default = _FormController.default.extend({
  className: 'custom-password-expired',
  Model: {},
  Form: {
    noButtonBar: true,
    title: function () {
      const expiringSoon = this.options.appState.get('isPwdExpiringSoon');
      const numDays = this.options.appState.get('passwordExpireDays');
      if (expiringSoon && numDays > 0) {
        return (0, _courage.loc)('password.expiring.title', 'login', [numDays]);
      } else if (expiringSoon && numDays === 0) {
        return (0, _courage.loc)('password.expiring.today', 'login');
      } else if (expiringSoon) {
        return (0, _courage.loc)('password.expiring.soon', 'login');
      } else {
        return this.settings.get('brandName') ? (0, _courage.loc)('password.expired.title.specific', 'login', [this.settings.get('brandName')]) : (0, _courage.loc)('password.expired.title.generic', 'login');
      }
    },
    subtitle: function () {
      if (this.options.appState.get('isPwdExpiringSoon')) {
        return this.settings.get('brandName') ? (0, _courage.loc)('password.expiring.soon.subtitle.specific', 'login', [this.settings.get('brandName')]) : (0, _courage.loc)('password.expiring.soon.subtitle.generic', 'login');
      }
      return (0, _courage.loc)('password.expired.custom.subtitle', 'login');
    },
    formChildren: function () {
      return [_FormType.default.Button({
        title: _courage._.partial(_courage.loc, 'password.expired.custom.submit', 'login', [this.options.appState.get('passwordExpiredWebsiteName')]),
        className: 'button button-primary button-wide',
        attributes: {
          'data-se': 'custom-button'
        },
        click: function () {
          Util.redirect(this.options.appState.get('passwordExpiredLinkUrl'));
        }
      })];
    }
  },
  Footer: _Footer.default
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/DeviceActivateController.js":
/*!********************************************************!*\
  !*** ./src/v1/controllers/DeviceActivateController.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-len: [2, 160] */

const InvalidUserCodeErrorView = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<div class=\"okta-form-infobox-error infobox infobox-error\" role=\"alert\"><span class=\"icon error-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "api.authn.error.PASSCODE_INVALID"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 110
          },
          "end": {
            "line": 1,
            "column": 173
          }
        }
      })) + "</p></div>";
    },
    "useData": true
  })
});
var _default = _FormController.default.extend({
  className: 'device-code-activate',
  Model: function () {
    var _this$options, _this$options$appStat;
    return {
      props: {
        userCode: ['string', true, (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$appStat = _this$options.appState) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.get('userCode')],
        stateToken: 'string'
      },
      save: function () {
        const self = this;
        return this.doTransaction(function (transaction) {
          return transaction.deviceActivate({
            userCode: self.get('userCode')
          });
        });
      }
    };
  },
  Form: {
    noCancelButton: true,
    autoSave: true,
    save: function () {
      return (0, _courage.loc)('oform.next', 'login');
    },
    title: function () {
      return (0, _courage.loc)('device.code.activate.title', 'login');
    },
    subtitle() {
      return (0, _courage.loc)('device.code.activate.subtitle', 'login');
    },
    formChildren: function () {
      if (this.options.appState.get('deviceActivationStatus') === 'INVALID_USER_CODE') {
        this.add(InvalidUserCodeErrorView, '.o-form-error-container');
      }
      return [_FormType.default.Input({
        label: (0, _courage.loc)('device.code.activate.label', 'login'),
        'label-top': true,
        name: 'userCode',
        input: _TextBox.default,
        inputId: 'user-code',
        type: 'text',
        inlineValidation: false
      })];
    },
    events: {
      'keyup input[name="userCode"]': function (e) {
        e.preventDefault();
        this.addHyphen(e);
      }
    },
    addHyphen(evt) {
      const currentVal = evt.target.value;
      // add hyphen after 4th character
      if (currentVal && currentVal.length === 4 && !['Backspace', 'Delete', '-'].includes(evt.key)) {
        evt.target.value = currentVal.concat('-');
      }
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/DeviceActivateTerminalController.js":
/*!****************************************************************!*\
  !*** ./src/v1/controllers/DeviceActivateTerminalController.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-len: [2, 160] */

const DEVICE_ACTIVATED = 'DEVICE_ACTIVATED';
const DEVICE_NOT_ACTIVATED_CONSENT_DENIED = 'DEVICE_NOT_ACTIVATED_CONSENT_DENIED';
const DEVICE_NOT_ACTIVATED = 'DEVICE_NOT_ACTIVATED';
const DEVICE_CODE_ERROR_KEYS = [DEVICE_NOT_ACTIVATED_CONSENT_DENIED, DEVICE_NOT_ACTIVATED];
var _default = _FormController.default.extend({
  className: 'device-code-terminal',
  postRender: function () {
    _FormController.default.prototype.postRender.apply(this, arguments);

    // show device code terminal icons
    const iconClass = this.options.appState.get('deviceActivationStatus') === DEVICE_ACTIVATED ? 'success-24-green' : 'error-24-red';
    this.$('.o-form-head').before('<div class="device-code-terminal--icon-container">' + '<span class="device-code-terminal--icon ' + iconClass + '"></span>' + '</div>');
  },
  Model: {},
  Form: {
    noCancelButton: true,
    noButtonBar: true,
    title: function () {
      const deviceActivationStatus = this.options.appState.get('deviceActivationStatus');
      if (deviceActivationStatus === DEVICE_ACTIVATED) {
        return (0, _courage.loc)('device.code.activated.success.title', 'login');
      }
      if (_courage._.contains(DEVICE_CODE_ERROR_KEYS, deviceActivationStatus)) {
        return (0, _courage.loc)('device.code.activated.error.title', 'login');
      }
    },
    subtitle: function () {
      const deviceActivationStatus = this.options.appState.get('deviceActivationStatus');
      if (deviceActivationStatus === DEVICE_ACTIVATED) {
        return (0, _courage.loc)('idx.device.activated', 'login');
      }
      if (deviceActivationStatus === DEVICE_NOT_ACTIVATED_CONSENT_DENIED) {
        return (0, _courage.loc)('idx.device.not.activated.consent.denied', 'login');
      }
      if (deviceActivationStatus === DEVICE_NOT_ACTIVATED) {
        return (0, _courage.loc)('idx.device.not.activated.internal.error', 'login');
      }
    },
    formChildren: function () {
      return [_FormType.default.View({
        View: _courage.View.extend({
          template: _runtime.default.template({
            "1": function (container, depth0, helpers, partials, data) {
              var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }
                return undefined;
              };
              return "<a href=\"/activate\" class=\"button button-primary text-align-c retry-button\" data-se=\"try-again\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                  "bundle": "login",
                  "code": "oie.try.again"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 121
                  },
                  "end": {
                    "line": 1,
                    "column": 165
                  }
                }
              })) + "</a>";
            },
            "compiler": [8, ">= 4.3.0"],
            "main": function (container, depth0, helpers, partials, data) {
              var stack1,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }
                  return undefined;
                };
              return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "isDeviceCodeError") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 0
                  },
                  "end": {
                    "line": 1,
                    "column": 176
                  }
                }
              })) != null ? stack1 : "";
            },
            "useData": true
          }),
          getTemplateData: function () {
            return {
              isDeviceCodeError: _courage._.contains(DEVICE_CODE_ERROR_KEYS, this.options.appState.get('deviceActivationStatus'))
            };
          }
        })
      })];
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollActivateCustomFactorController.js":
/*!********************************************************************!*\
  !*** ./src/v1/controllers/EnrollActivateCustomFactorController.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _EnrollCustomFactorController = _interopRequireDefault(__webpack_require__(/*! ./EnrollCustomFactorController */ "./src/v1/controllers/EnrollCustomFactorController.js"));
var _Factor = _interopRequireDefault(__webpack_require__(/*! v1/models/Factor */ "./src/v1/models/Factor.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/HtmlErrorMessageView */ "./src/v1/views/mfa-verify/HtmlErrorMessageView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2019-2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const {
  Util
} = _courage.internal.util;
var _default = _EnrollCustomFactorController.default.extend({
  Model: {
    local: {
      provider: 'string',
      factorType: 'string'
    },
    save: function () {
      return this.manageTransaction(() => {
        const url = this.appState.get('enrollCustomFactorRedirectUrl');
        if (url !== null) {
          Util.redirect(url);
        }
      });
    }
  },
  Form: function () {
    const factor = new _Factor.default.Model(this.options.appState.get('factor'), this.toJSON());
    const vendorName = factor.get('vendorName');
    const subtitle = (0, _courage.loc)('enroll.customFactor.subtitle', 'login', [vendorName]);
    const saveText = (0, _courage.loc)('enroll.customFactor.save', 'login');
    return {
      autoSave: true,
      title: vendorName,
      subtitle: subtitle,
      save: saveText,
      formChildren: function () {
        const result = [];
        if (this.options.appState.get('isFactorResultFailed')) {
          result.push(_FormType.default.View({
            View: new _HtmlErrorMessageView.default({
              message: this.options.appState.get('factorResultErrorMessage')
            })
          }, {
            selector: '.o-form-error-container'
          }));
        }
        return result;
      }
    };
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollActivateEmailController.js":
/*!*************************************************************!*\
  !*** ./src/v1/controllers/EnrollActivateEmailController.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _ResendEmailView = _interopRequireDefault(__webpack_require__(/*! v1/views/ResendEmailView */ "./src/v1/views/ResendEmailView.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const Model = {
  props: {
    passCode: 'string'
  },
  resend: function () {
    this.trigger('form:clear-errors');
    return this.doTransaction(function (transaction) {
      // authn support multiple `resend` hence has to specify name.
      return transaction.resend('email');
    });
  },
  save: function () {
    this.trigger('save');
    const formData = this.toJSON();
    return this.doTransaction(function (transaction) {
      return transaction.activate(formData);
    });
  }
};
const Form = function () {
  return {
    title: _courage._.partial(_courage.loc, 'email.enroll.title', 'login'),
    noButtonBar: false,
    autoSave: true,
    save: _courage._.partial(_courage.loc, 'oform.verify', 'login'),
    // TODO: deprecated by mfa.challenge.verify
    formChildren: [
    // message
    _FormType.default.View({
      View: _courage.View.extend({
        className: 'enroll-activate-email-content',
        attributes: {
          'data-se': 'enroll-activate-email-content'
        },
        // Why use `{{{` for the description?
        // - factorEmail is actually an HTML fragment which
        //   is created via another handlebar template and used for bold the email address.
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var stack1,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }
                return undefined;
              };
            return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "arguments": "factorEmail",
                "bundle": "login",
                "code": "email.mfa.email.sent.description"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 89
                }
              }
            })) != null ? stack1 : "";
          },
          "useData": true
        }),
        getTemplateData: function () {
          const factor = this.options.appState.get('factor');
          const factorEmailVal = factor && factor.profile ? factor.profile.email : '';
          const factorEmail = _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function (container, depth0, helpers, partials, data) {
              var helper,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }
                  return undefined;
                };
              return "<span class=\"mask-email\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "email") || (depth0 != null ? lookupProperty(depth0, "email") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "email",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 25
                  },
                  "end": {
                    "line": 1,
                    "column": 34
                  }
                }
              }) : helper)) + "</span>";
            },
            "useData": true
          })({
            email: factorEmailVal
          });
          return {
            factorEmail
          };
        }
      })
    }),
    // send again callout message and link button
    _FormType.default.View({
      View: _ResendEmailView.default
    }),
    // passcode input
    _FormType.default.Input({
      label: (0, _courage.loc)('email.code.label', 'login'),
      'label-top': true,
      name: 'passCode',
      type: 'text',
      wide: true
    })]
  };
};
var _default = _FormController.default.extend({
  className: 'enroll-activate-email',
  Model: Model,
  Form: Form,
  Footer: _Footer.default
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollCallAndSmsController.js":
/*!**********************************************************!*\
  !*** ./src/v1/controllers/EnrollCallAndSmsController.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _CountryUtil = _interopRequireDefault(__webpack_require__(/*! util/CountryUtil */ "./src/util/CountryUtil.js"));
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
var _PhoneTextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/PhoneTextBox */ "./src/v1/views/enroll-factors/PhoneTextBox.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 8] */

let {
  Keys
} = _courage.internal.util;
const EnrollCallAndSmsControllerwarningTemplate = _courage.View.extend({
  className: 'okta-form-infobox-warning infobox infobox-warning login-timeout-warning',
  attributes: {
    'aria-live': 'polite'
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<span class=\"icon warning-16\"></span><p>" + ((stack1 = (helper = (helper = lookupProperty(helpers, "warning") || (depth0 != null ? lookupProperty(depth0, "warning") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "warning",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 40
          },
          "end": {
            "line": 1,
            "column": 53
          }
        }
      }) : helper)) != null ? stack1 : "") + "</p>";
    },
    "useData": true
  })
});
const factorIdIsDefined = {
  factorId: function (val) {
    return !_courage._.isUndefined(val);
  }
};
function isCallFactor(factorType) {
  return factorType === 'call';
}
function getClassName(factorType) {
  return isCallFactor(factorType) ? 'enroll-call' : 'enroll-sms';
}
function sendCode(e) {
  if (Keys.isEnter(e)) {
    e.stopPropagation();
    e.preventDefault();
    if (e.type === 'keyup' && e.data && e.data.model) {
      e.data.model.sendCode();
    }
  }
}
var _default = _FormController.default.extend({
  className: function () {
    return getClassName(this.options.factorType);
  },
  Model: function () {
    return {
      props: {
        phoneNumber: ['string', true],
        phoneExtension: ['string', false],
        lastEnrolledPhoneNumber: 'string',
        passCode: ['string', true],
        factorId: 'string'
      },
      local: {
        countryCode: ['string', false, this.options.appState.get('userCountryCode')],
        hasExistingPhones: 'boolean',
        trapEnrollment: 'boolean',
        ableToResend: 'boolean',
        factorType: 'string',
        skipPhoneValidation: 'boolean'
      },
      derived: {
        countryCallingCode: {
          deps: ['countryCode'],
          fn: function (countryCode) {
            return '+' + _CountryUtil.default.getCallingCodeForCountry(countryCode);
          }
        },
        fullPhoneNumber: {
          deps: ['countryCallingCode', 'phoneNumber'],
          fn: function (countryCallingCode, phoneNumber) {
            return phoneNumber ? countryCallingCode + phoneNumber : '';
          }
        },
        enrolled: {
          deps: ['lastEnrolledPhoneNumber', 'fullPhoneNumber'],
          fn: function (lastEnrolled, current) {
            return lastEnrolled === current;
          }
        }
      },
      limitResending: function () {
        this.set({
          ableToResend: false
        });
        _courage._.delay(_courage._.bind(this.set, this), _Enums.default.API_RATE_LIMIT, {
          ableToResend: true
        });
      },
      sendCode: function () {
        const self = this;
        const phoneNumber = this.get('fullPhoneNumber');
        const phoneExtension = this.get('phoneExtension');
        self.trigger('errors:clear');
        if (!phoneNumber.length) {
          self.trigger('invalid', self, {
            phoneNumber: 'model.validation.field.blank'
          });
          return;
        }
        return this.doTransaction(function (transaction) {
          const isMfaEnroll = transaction.status === 'MFA_ENROLL' || transaction.status === 'FACTOR_ENROLL';
          const profileData = {
            phoneNumber: phoneNumber,
            updatePhone: isMfaEnroll ? self.get('hasExistingPhones') : true
          };
          if (isCallFactor(self.get('factorType'))) {
            profileData['phoneExtension'] = phoneExtension;
          }
          if (self.get('skipPhoneValidation')) {
            profileData['validatePhone'] = false;
          }
          const doEnroll = function (trans) {
            const factor = _courage._.findWhere(trans.factors, {
              factorType: self.get('factorType'),
              provider: 'OKTA'
            });
            return factor.enroll({
              profile: profileData
            }).catch(function (error) {
              if (error.errorCode === 'E0000098') {
                // E0000098: "This phone number is invalid."
                self.set('skipPhoneValidation', true);
                error.xhr.responseJSON.errorSummary = (0, _courage.loc)('enroll.sms.try_again', 'login');
              }
              throw error;
            });
          };
          if (isMfaEnroll) {
            return doEnroll(transaction);
          } else {
            // We must transition to MfaEnroll before updating the phone number
            self.set('trapEnrollment', true);
            return transaction.prev().then(doEnroll).then(function (trans) {
              self.set('trapEnrollment', false);
              return trans;
            });
          }
          // Rethrow errors so we can change state
          // AFTER setting the new transaction
        }, true).then(function () {
          self.set('lastEnrolledPhoneNumber', phoneNumber);
          self.limitResending();
        }).catch(function () {
          self.set('trapEnrollment', false);
        });
      },
      resendCode: function () {
        this.trigger('errors:clear');
        this.limitResending();
        return this.doTransaction(function (transaction) {
          return transaction.resend(this.get('factorType'));
        });
      },
      save: function () {
        return this.doTransaction(function (transaction) {
          return transaction.activate({
            passCode: this.get('passCode')
          });
        });
      }
    };
  },
  Form: function () {
    const factorType = this.options.factorType;
    const isCall = isCallFactor(factorType);
    const formTitle = (0, _courage.loc)(isCall ? 'enroll.call.setup' : 'enroll.sms.setup', 'login');
    const formSubmit = (0, _courage.loc)(isCall ? 'mfa.call' : 'mfa.sendCode', 'login');
    const formRetry = (0, _courage.loc)(isCall ? 'mfa.redial' : 'mfa.resendCode', 'login');
    const formSubmitted = (0, _courage.loc)(isCall ? 'mfa.calling' : 'mfa.sent', 'login');
    const numberFieldClassName = isCall ? 'enroll-call-phone' : 'enroll-sms-phone';
    const buttonClassName = isCall ? 'call-request-button' : 'sms-request-button';
    const formChildren = [_FormType.default.Input({
      name: 'countryCode',
      type: 'select',
      wide: true,
      options: _CountryUtil.default.getCountries()
    }), _FormType.default.Input({
      label: (0, _courage.loc)('mfa.phoneNumber.placeholder', 'login'),
      'label-top': true,
      className: numberFieldClassName,
      name: 'phoneNumber',
      input: _PhoneTextBox.default,
      type: 'text',
      render: function () {
        this.$('input[name="phoneNumber"]').off('keydown keyup', sendCode).keydown(sendCode).keyup({
          model: this.model
        }, sendCode);
      }
    })];
    if (isCall) {
      formChildren.push(_FormType.default.Input({
        label: (0, _courage.loc)('mfa.phoneNumber.ext.placeholder', 'login'),
        'label-top': true,
        className: 'enroll-call-extension',
        name: 'phoneExtension',
        input: _TextBox.default,
        type: 'text'
      }));
    }
    formChildren.push(_FormType.default.Button({
      title: formSubmit,
      attributes: {
        'data-se': buttonClassName
      },
      className: 'button button-primary js-enroll-phone margin-top-30 ' + buttonClassName,
      click: function () {
        this.model.sendCode();
      }
    }), _FormType.default.Button({
      title: formRetry,
      attributes: {
        'data-se': buttonClassName
      },
      className: 'button js-enroll-phone margin-top-30 ' + buttonClassName,
      click: function () {
        this.model.resendCode();
      },
      initialize: function () {
        this.$el.css({
          display: 'none'
        });
        this.listenTo(this.model, 'change:ableToResend', function (model, ableToResend) {
          if (ableToResend) {
            this.options.title = formRetry;
            this.enable();
          } else {
            this.options.title = formSubmitted;
            this.disable();
          }
          this.render();
        });
      }
    }), _FormType.default.Divider({
      showWhen: factorIdIsDefined
    }), _FormType.default.Input({
      label: (0, _courage.loc)('mfa.challenge.enterCode.placeholder', 'login'),
      'label-top': true,
      explain: _Util.default.createInputExplain('mfa.challenge.enterCode.tooltip', 'mfa.challenge.enterCode.placeholder', 'login'),
      'explain-top': true,
      name: 'passCode',
      input: _TextBox.default,
      type: 'tel',
      showWhen: factorIdIsDefined
    }), _FormType.default.Toolbar({
      noCancelButton: true,
      save: (0, _courage.loc)('mfa.challenge.verify', 'login'),
      showWhen: factorIdIsDefined
    }));
    return {
      title: formTitle,
      noButtonBar: true,
      autoSave: true,
      className: getClassName(factorType),
      showWarning: function (msg) {
        this.clearWarnings();
        this.add(EnrollCallAndSmsControllerwarningTemplate, '.o-form-error-container', {
          options: {
            warning: msg
          }
        });
      },
      clearWarnings: function () {
        this.$('.okta-form-infobox-warning').remove();
      },
      initialize: function () {
        const callTimeWarning = _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "$1": "<b>$1</b>",
                "bundle": "login",
                "code": "factor.call.time.warning"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 71
                }
              }
            }));
          },
          "useData": true
        });
        const smsTimeWarning = _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "$1": "<b>$1</b>",
                "bundle": "login",
                "code": "factor.sms.time.warning"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 70
                }
              }
            }));
          },
          "useData": true
        });
        this.listenTo(this.model, 'change:ableToResend', function (model, ableToResend) {
          if (ableToResend) {
            this.showWarning(isCall ? callTimeWarning : smsTimeWarning);
          } else {
            this.clearWarnings();
          }
        });
        this.listenTo(this.model, 'error errors:clear', function () {
          this.clearWarnings();
          this.clearErrors();
        });
        this.listenTo(this.model, 'change:enrolled', function () {
          this.$('.js-enroll-phone').toggle();
        });
      },
      formChildren: formChildren
    };
  },
  Footer: _Footer.default,
  trapAuthResponse: function () {
    if (this.options.appState.get('isMfaEnrollActivate')) {
      this.model.set('factorId', this.options.appState.get('activatedFactorId'));
      return true;
    }
    if (this.options.appState.get('isMfaEnroll') && this.model.get('trapEnrollment')) {
      return true;
    }
  },
  initialize: function () {
    if (isCallFactor(this.options.factorType)) {
      this.model.set('hasExistingPhones', this.options.appState.get('hasExistingPhonesForCall'));
    } else {
      this.model.set('hasExistingPhones', this.options.appState.get('hasExistingPhones'));
    }
    this.model.set('factorType', this.options.factorType);
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollChoicesController.js":
/*!*******************************************************!*\
  !*** ./src/v1/controllers/EnrollChoicesController.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FactorList = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-choices/FactorList */ "./src/v1/views/enroll-choices/FactorList.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-choices/Footer */ "./src/v1/views/enroll-choices/Footer.js"));
var _RequiredFactorList = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-choices/RequiredFactorList */ "./src/v1/views/enroll-choices/RequiredFactorList.js"));
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _RouterUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/RouterUtil */ "./src/v1/util/RouterUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 13] */

const subtitleTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var stack1,
      helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<span>" + ((stack1 = (helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "subtitle",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 6
        },
        "end": {
          "line": 1,
          "column": 20
        }
      }
    }) : helper)) != null ? stack1 : "") + "</span>";
  },
  "useData": true
});
var _default = _FormController.default.extend({
  className: 'enroll-choices',
  state: {
    pageType: null
  },
  Model: {},
  Form: {
    noCancelButton: true,
    title: _courage._.partial(_courage.loc, 'enroll.choices.title', 'login'),
    noButtonBar: function () {
      return this.state.get('pageType') === _Enums.default.ALL_OPTIONAL_NONE_ENROLLED;
    },
    subtitle: ' ',
    getSubtitle: function () {
      switch (this.state.get('pageType')) {
        case _Enums.default.ALL_OPTIONAL_SOME_ENROLLED:
        case _Enums.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
          return (0, _courage.loc)('enroll.choices.optional', 'login');
        case _Enums.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
          {
            const remainingDays = this.options.appState.get('gracePeriodRemainingDays');

            // remainingDays is null if there is no grace period, 0 if we are still in grace period
            return remainingDays !== null && remainingDays >= 0 ? this.getGracePeriodSubtitle(remainingDays) : this.getDefaultSubtitle();
          }
        default:
          return this.getDefaultSubtitle();
      }
    },
    getDefaultSubtitle: function () {
      return this.settings.get('brandName') ? (0, _courage.loc)('enroll.choices.description.specific', 'login', [this.settings.get('brandName')]) : (0, _courage.loc)('enroll.choices.description.generic', 'login');
    },
    getGracePeriodSubtitle: function (remainingDays) {
      return remainingDays >= 1 ? (0, _courage.loc)('enroll.choices.description.gracePeriod.bold', 'login', [remainingDays]) : (0, _courage.loc)('enroll.choices.description.gracePeriod.oneDay.bold', 'login');
    },
    save: function () {
      switch (this.state.get('pageType')) {
        case _Enums.default.ALL_OPTIONAL_SOME_ENROLLED:
        case _Enums.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
          return (0, _courage.loc)('enroll.choices.submit.finish', 'login');
        case _Enums.default.HAS_REQUIRED_NONE_ENROLLED:
          return (0, _courage.loc)('enroll.choices.submit.configure', 'login');
        case _Enums.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
          return (0, _courage.loc)('enroll.choices.submit.next', 'login');
        default:
          return '';
      }
    },
    initialize: function (options) {
      this.listenTo(this, 'save', function () {
        let current;
        switch (this.state.get('pageType')) {
          case _Enums.default.HAS_REQUIRED_NONE_ENROLLED:
          case _Enums.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
            current = options.appState.get('factors').getFirstUnenrolledRequiredFactor();
            options.appState.trigger('navigate', _RouterUtil.default.createEnrollFactorUrl(current.get('provider'), current.get('factorType')));
            break;
          default:
            return this.model.doTransaction(function (transaction) {
              return transaction.skip();
            });
        }
      });
    },
    preRender: function () {
      // form subtitle does not support unescaped strings, and we need some html elements
      // in the subtitle for this form. So instead of a regular subtitle, we add a <span>
      // with the text we need
      this.add(subtitleTpl({
        subtitle: this.getSubtitle()
      }), 'p.okta-form-subtitle');
      const factors = this.options.appState.get('factors');
      switch (this.state.get('pageType')) {
        case _Enums.default.HAS_REQUIRED_NONE_ENROLLED:
        case _Enums.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
          this.add(new _RequiredFactorList.default({
            minimize: true,
            collection: new _courage.Collection(factors.where({
              required: true
            })),
            appState: this.options.appState
          }));
          break;
        case _Enums.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
        case _Enums.default.ALL_OPTIONAL_SOME_ENROLLED:
        case _Enums.default.ALL_OPTIONAL_NONE_ENROLLED:
          {
            const enrolled = factors.where({
              enrolled: true
            });
            const notEnrolled = factors.filter(function (factor) {
              // pick factors that are not enrolled or have additional enrollments
              return !factor.get('enrolled') || factor.get('additionalEnrollment');
            });
            let notEnrolledListTitle;
            if (enrolled.length > 0) {
              notEnrolledListTitle = (0, _courage.loc)('enroll.choices.list.optional', 'login');
              this.add(new _FactorList.default({
                listTitle: (0, _courage.loc)('enroll.choices.list.enrolled', 'login'),
                minimize: true,
                collection: new _courage.Collection(enrolled),
                appState: this.options.appState
              }));
            }
            this.add(new _FactorList.default({
              listTitle: notEnrolledListTitle,
              collection: new _courage.Collection(notEnrolled),
              appState: this.options.appState,
              showInlineSetupButton: true
            }));
            break;
          }
      }
    }
  },
  initialize: function (options) {
    let numRequiredEnrolled = 0;
    let numRequiredNotEnrolled = 0;
    let numOptionalEnrolled = 0;
    let numOptionalNotEnrolled = 0;
    let hasRequired;
    let pageType;
    options.appState.get('factors').each(function (factor) {
      const required = factor.get('required');
      const enrolled = factor.get('enrolled');
      const additionalEnrollment = factor.get('additionalEnrollment');
      if (required && enrolled) {
        numRequiredEnrolled++;
      } else if (required && !enrolled) {
        numRequiredNotEnrolled++;
      } else if (!required && enrolled) {
        numOptionalEnrolled++;
      } else if (!required && !enrolled) {
        numOptionalNotEnrolled++;
      }
      // If a factor has multiple instances and
      // additional optional enrollments
      if (enrolled && additionalEnrollment) {
        numOptionalNotEnrolled++;
      }
    });
    hasRequired = numRequiredEnrolled > 0 || numRequiredNotEnrolled > 0;

    // There are 5 possible states this screen can be in:

    // 1. Has required, but none have been enrolled. Wizard start page.
    if (hasRequired && numRequiredEnrolled === 0) {
      pageType = _Enums.default.HAS_REQUIRED_NONE_ENROLLED;
    } else if (hasRequired && numRequiredNotEnrolled > 0) {
      // 2. Has required, and have enrolled at least one. The page layout
      //    to configure the remaining required factors.
      pageType = _Enums.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED;
    } else if (hasRequired && numOptionalNotEnrolled > 0) {
      // 3. Has required, and finished enrolling all required factors. The
      //    page layout you see to configure any optional factors or skip.
      pageType = _Enums.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED;
    } else if (numOptionalEnrolled === 0 && numOptionalNotEnrolled > 0) {
      // 4. Factors are all optional, no factors enrolled.
      pageType = _Enums.default.ALL_OPTIONAL_NONE_ENROLLED;
    } else if (numOptionalNotEnrolled > 0) {
      // 5. Factors are all optional, some factors have already been
      //    enrolled (can either enroll more or skip).
      pageType = _Enums.default.ALL_OPTIONAL_SOME_ENROLLED;
    } else {
      // 6. Factors are all optional, all factors have already been
      //    enrolled, among them there is OktaVerify with Push enrolled as totp
      //    (API return OktaVerify push factor as unenrolled in this case and as we always merge
      //    push and totp in UI so we redirect to skip link here).
      this.model.doTransaction(function (transaction) {
        return transaction.skip();
      });
    }
    this.state.set('pageType', pageType);
    if (this.options.appState.get('skipLink') && pageType === _Enums.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED) {
      this.add(new _Footer.default(this.toJSON()));
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollCustomFactorController.js":
/*!************************************************************!*\
  !*** ./src/v1/controllers/EnrollCustomFactorController.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2018-2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const {
  Util
} = _courage.internal.util;
var _default = _FormController.default.extend({
  className: 'enroll-custom-factor',
  Model: {
    local: {
      provider: 'string',
      factorType: 'string'
    },
    save: function () {
      return this.manageTransaction((transaction, setTransaction) => {
        const factor = _courage._.findWhere(transaction.factors, {
          provider: this.get('provider'),
          factorType: this.get('factorType')
        });
        return factor.enroll().then(trans => {
          setTransaction(trans);
          const url = this.appState.get('enrollCustomFactorRedirectUrl');
          if (url !== null) {
            Util.redirect(url);
          }
        }).catch(function (err) {
          throw err;
        });
      });
    }
  },
  Form: function () {
    const factors = this.options.appState.get('factors');
    const factor = factors.findWhere({
      provider: this.options.provider,
      factorType: this.options.factorType
    });
    const vendorName = factor.get('vendorName');
    const subtitle = (0, _courage.loc)('enroll.customFactor.subtitle', 'login', [vendorName]);
    const saveText = (0, _courage.loc)('enroll.customFactor.save', 'login');
    return {
      autoSave: true,
      title: vendorName,
      subtitle: subtitle,
      save: saveText
    };
  },
  trapAuthResponse: function () {
    if (this.options.appState.get('isMfaEnrollActivate')) {
      return true;
    }
  },
  initialize: function () {
    this.model.set('provider', this.options.provider);
    this.model.set('factorType', this.options.factorType);
  },
  Footer: _Footer.default
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollDuoController.js":
/*!***************************************************!*\
  !*** ./src/v1/controllers/EnrollDuoController.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _duo = _interopRequireDefault(__webpack_require__(/*! @okta/duo */ "./packages/vendor/duo_web_sdk/index.js"));
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
/* eslint camelcase: 0*/
var _default = _FormController.default.extend({
  className: 'enroll-duo duo-form',
  Model: {
    props: {
      host: 'string',
      signature: 'string',
      postAction: 'string',
      factorId: 'string',
      stateToken: 'string'
    },
    getInitOptions: function () {
      return this.doTransaction(function (transaction) {
        const factor = _courage._.findWhere(transaction.factors, {
          factorType: 'web',
          provider: 'DUO'
        });
        return factor.enroll();
      });
    },
    activate: function (signedResponse) {
      const url = this.get('postAction');
      const factorId = this.get('factorId');
      const self = this;
      const data = {
        id: factorId,
        stateToken: this.get('stateToken'),
        sig_response: signedResponse
      };
      // Note: We should be doing this in OktaAuth! Fix when it's updated.

      // We don't actually use authClient.post() here (unlike all the other cases in the
      // sign-in widget) since the endpoint is wired to accept serialized form post instead
      // of a JSON post ($.post() is different from authClient.post() in that in $.post(),
      // jquery decides the Content-Type instead of it being a JSON type). Enroll/Verify DUO
      // are the only two places where we actually do this.
      // NOTE - If we ever decide to change this, we should test this very carefully.
      return (0, _q.default)(_courage.$.post(url, data)).then(function () {
        return self.doTransaction(function (transaction) {
          return transaction.poll();
        });
      }).catch(function (err) {
        self.trigger('error', self, err.xhr);
      });
    }
  },
  Form: {
    autoSave: true,
    noButtonBar: true,
    title: _courage._.partial(_courage.loc, 'enroll.duo.title', 'login'),
    postRender: function () {
      this.add('<iframe frameborder="0" title="' + this.title() + '"></iframe>');
      _duo.default.init({
        host: this.model.get('host'),
        sig_request: this.model.get('signature'),
        iframe: this.$('iframe').get(0),
        post_action: _courage._.bind(this.model.activate, this.model)
      });
    }
  },
  Footer: _Footer.default,
  fetchInitialData: function () {
    const self = this;
    return this.model.getInitOptions(this.options.appState).then(function (trans) {
      const res = trans.data;
      if (!res || !res._embedded || !res._embedded.factor || !res._embedded.factor._embedded || !res._embedded.factor._embedded.activation) {
        throw new Error('Response does not have duo activation options');
      }
      const factor = res._embedded.factor;
      const activation = factor._embedded.activation;
      self.model.set({
        host: activation.host,
        signature: activation.signature,
        postAction: activation._links.complete.href,
        factorId: factor.id,
        stateToken: res.stateToken
      });
    });
  },
  trapAuthResponse: function () {
    if (this.options.appState.get('isMfaEnrollActivate')) {
      return true;
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollEmailController.js":
/*!*****************************************************!*\
  !*** ./src/v1/controllers/EnrollEmailController.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const Model = {
  local: {
    factorType: 'string',
    provider: 'string'
  },
  save: function () {
    this.trigger('save');
    const factorOpt = this.pick('factorType', 'provider');
    return this.doTransaction(function (transaction) {
      const factor = _courage._.findWhere(transaction.factors, factorOpt);
      return factor.enroll();
    });
  }
};
const Form = function () {
  return {
    title: _courage._.partial(_courage.loc, 'email.enroll.title', 'login'),
    noButtonBar: false,
    autoSave: true,
    save: _courage._.partial(_courage.loc, 'email.button.send', 'login'),
    formChildren: [_FormType.default.View({
      View: _courage.View.extend({
        attributes: {
          'data-se': 'enroll-email-content'
        },
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "email.enroll.description"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 55
                }
              }
            }));
          },
          "useData": true
        })
      })
    })]
  };
};
var _default = _FormController.default.extend({
  className: 'enroll-email',
  Model: Model,
  Form: Form,
  Footer: _Footer.default,
  initialize: function () {
    this.model.set(_courage._.pick(this.options, 'factorType', 'provider'));
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollHotpController.js":
/*!****************************************************!*\
  !*** ./src/v1/controllers/EnrollHotpController.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/HtmlErrorMessageView */ "./src/v1/views/mfa-verify/HtmlErrorMessageView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'enroll-hotp',
  Model: function () {
    return {
      local: {
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      }
    };
  },
  Form: {
    title: function () {
      const factors = this.options.appState.get('factors');
      const hotpFactor = factors.findWhere({
        provider: this.model.get('__provider__'),
        factorType: this.model.get('__factorType__')
      });
      return (0, _courage.loc)('enroll.totp.title', 'login', [hotpFactor.get('factorLabel')]);
    },
    noButtonBar: true,
    attributes: {
      'data-se': 'restrict-enroll'
    },
    formChildren: function () {
      const children = [_FormType.default.View({
        View: new _HtmlErrorMessageView.default({
          message: (0, _courage.loc)('enroll.hotp.restricted', 'login')
        })
      })];
      return children;
    }
  },
  Footer: _Footer.default
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollOnPremController.js":
/*!******************************************************!*\
  !*** ./src/v1/controllers/EnrollOnPremController.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isRSA(provider) {
  return provider === 'RSA';
}
function getClassName(provider) {
  return isRSA(provider) ? 'enroll-rsa' : 'enroll-onprem';
}
var _default = _FormController.default.extend({
  className: function () {
    return getClassName(this.options.provider);
  },
  Model: function () {
    const provider = this.options.provider;
    const factors = this.options.appState.get('factors');
    const factor = factors.findWhere(_courage._.pick(this.options, 'provider', 'factorType'));
    const profile = factor.get('profile');
    const credentialId = profile && profile.credentialId ? profile.credentialId : '';
    return {
      props: {
        credentialId: ['string', true, credentialId],
        passCode: ['string', true],
        factorId: 'string'
      },
      save: function () {
        return this.doTransaction(function (transaction) {
          const factor = _courage._.findWhere(transaction.factors, {
            factorType: 'token',
            provider: provider
          });
          return factor.enroll({
            passCode: this.get('passCode'),
            profile: {
              credentialId: this.get('credentialId')
            }
          });
        });
      }
    };
  },
  Form: function () {
    const provider = this.options.provider;
    const factors = this.options.appState.get('factors');
    const factor = factors.findWhere(_courage._.pick(this.options, 'provider', 'factorType'));
    const vendorName = factor.get('vendorName');
    const title = isRSA(provider) ? (0, _courage.loc)('factor.totpHard.rsaSecurId', 'login') : vendorName;
    return {
      title: title,
      noButtonBar: true,
      autoSave: true,
      className: getClassName(provider),
      initialize: function () {
        this.listenTo(this.model, 'error', (source, error) => {
          if (error && error.status === 409) {
            // 409 means we are in change pin, so we should clear out answer input
            this.$('.o-form-input-name-passCode input').val('');
            this.$('.o-form-input-name-passCode input').trigger('change');
            this.$('.o-form-input-name-passCode input').focus();
          }
        });
      },
      formChildren: [_FormType.default.Input({
        label: (0, _courage.loc)('enroll.onprem.username.placeholder', 'login', [vendorName]),
        'label-top': true,
        explain: _Util.default.createInputExplain('enroll.onprem.username.tooltip', 'enroll.onprem.username.placeholder', 'login', [vendorName], [vendorName]),
        'explain-top': true,
        name: 'credentialId',
        input: _TextBox.default,
        type: 'text'
      }), _FormType.default.Input({
        label: (0, _courage.loc)('enroll.onprem.passcode.placeholder', 'login', [vendorName]),
        'label-top': true,
        explain: _Util.default.createInputExplain('enroll.onprem.passcode.tooltip', 'enroll.onprem.passcode.placeholder', 'login', [vendorName], [vendorName]),
        'explain-top': true,
        name: 'passCode',
        input: _TextBox.default,
        type: 'password'
      }), _FormType.default.Toolbar({
        noCancelButton: true,
        save: (0, _courage.loc)('mfa.challenge.verify', 'login')
      })]
    };
  },
  Footer: _Footer.default
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollPasswordController.js":
/*!********************************************************!*\
  !*** ./src/v1/controllers/EnrollPasswordController.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _ValidationUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/ValidationUtil */ "./src/v1/util/ValidationUtil.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'enroll-password',
  Model: {
    props: {
      password: ['string', true],
      confirmPassword: ['string', true]
    },
    validate: function () {
      return _ValidationUtil.default.validateFieldsMatch(this, 'password', 'confirmPassword', (0, _courage.loc)('password.enroll.error.match', 'login'));
    },
    save: function () {
      return this.doTransaction(function (transaction) {
        const factor = _courage._.findWhere(transaction.factors, {
          factorType: 'password',
          provider: 'OKTA'
        });
        return factor.enroll({
          profile: {
            password: this.get('password')
          }
        });
      });
    }
  },
  Form: {
    autoSave: true,
    title: _courage._.partial(_courage.loc, 'enroll.password.setup', 'login'),
    inputs: function () {
      return [{
        label: (0, _courage.loc)('mfa.challenge.password.placeholder', 'login'),
        'label-top': true,
        className: 'o-form-fieldset o-form-label-top auth-passcode',
        name: 'password',
        input: _TextBox.default,
        type: 'password'
      }, {
        label: (0, _courage.loc)('password.confirmPassword.placeholder', 'login'),
        'label-top': true,
        className: 'o-form-fieldset o-form-label-top auth-passcode',
        name: 'confirmPassword',
        input: _TextBox.default,
        type: 'password'
      }];
    }
  },
  Footer: _Footer.default
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollQuestionController.js":
/*!********************************************************!*\
  !*** ./src/v1/controllers/EnrollQuestionController.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'enroll-question',
  Model: {
    props: {
      question: 'string',
      answer: ['string', true]
    },
    local: {
      securityQuestions: 'object'
    },
    save: function () {
      return this.doTransaction(function (transaction) {
        const factor = _courage._.findWhere(transaction.factors, {
          factorType: 'question',
          provider: 'OKTA'
        });
        return factor.enroll({
          profile: {
            question: this.get('question'),
            answer: this.get('answer')
          }
        });
      });
    }
  },
  Form: {
    autoSave: true,
    title: _courage._.partial(_courage.loc, 'enroll.securityQuestion.setup', 'login'),
    inputs: function () {
      return [{
        label: false,
        'label-top': true,
        name: 'question',
        type: 'select',
        wide: true,
        options: function () {
          return this.model.get('securityQuestions');
        },
        params: {
          searchThreshold: 25
        }
      }, {
        label: (0, _courage.loc)('mfa.challenge.answer.placeholder', 'login'),
        'label-top': true,
        explain: _Util.default.createInputExplain('mfa.challenge.answer.tooltip', 'mfa.challenge.answer.placeholder', 'login'),
        'explain-top': true,
        className: 'o-form-fieldset o-form-label-top auth-passcode',
        name: 'answer',
        input: _TextBox.default,
        type: 'text'
      }];
    }
  },
  Footer: _Footer.default,
  fetchInitialData: function () {
    const self = this;
    return this.model.manageTransaction(function (transaction) {
      const factor = _courage._.findWhere(transaction.factors, {
        factorType: 'question',
        provider: 'OKTA'
      });
      return factor.questions();
    }).then(function (questionsRes) {
      const questions = {};
      _courage._.each(questionsRes, function (question) {
        questions[question.question] = _FactorUtil.default.getSecurityQuestionLabel(question);
      });
      self.model.set('securityQuestions', questions);
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollSymantecVipController.js":
/*!***********************************************************!*\
  !*** ./src/v1/controllers/EnrollSymantecVipController.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'enroll-symantec',
  Model: {
    props: {
      credentialId: ['string', true],
      passCode: ['string', true],
      nextPassCode: ['string', true],
      factorId: 'string'
    },
    save: function () {
      return this.doTransaction(function (transaction) {
        const factor = _courage._.findWhere(transaction.factors, {
          factorType: 'token',
          provider: 'SYMANTEC'
        });
        return factor.enroll({
          passCode: this.get('passCode'),
          nextPassCode: this.get('nextPassCode'),
          profile: {
            credentialId: this.get('credentialId')
          }
        });
      });
    }
  },
  Form: {
    title: _courage._.partial(_courage.loc, 'factor.totpHard.symantecVip', 'login'),
    subtitle: _courage._.partial(_courage.loc, 'enroll.symantecVip.subtitle', 'login'),
    noButtonBar: true,
    autoSave: true,
    className: 'enroll-symantec',
    formChildren: function () {
      return [_FormType.default.Input({
        label: (0, _courage.loc)('enroll.symantecVip.credentialId.placeholder', 'login'),
        'label-top': true,
        explain: _Util.default.createInputExplain('enroll.symantecVip.credentialId.tooltip', 'enroll.symantecVip.credentialId.placeholder', 'login'),
        'explain-top': true,
        name: 'credentialId',
        input: _TextBox.default,
        type: 'text'
      }), _FormType.default.Input({
        label: (0, _courage.loc)('enroll.symantecVip.passcode1.placeholder', 'login'),
        'label-top': true,
        explain: _Util.default.createInputExplain('enroll.symantecVip.passcode1.tooltip', 'enroll.symantecVip.passcode1.placeholder', 'login'),
        'explain-top': true,
        name: 'passCode',
        input: _TextBox.default,
        type: 'text'
      }), _FormType.default.Input({
        label: (0, _courage.loc)('enroll.symantecVip.passcode2.placeholder', 'login'),
        'label-top': true,
        explain: _Util.default.createInputExplain('enroll.symantecVip.passcode2.tooltip', 'enroll.symantecVip.passcode2.placeholder', 'login'),
        'explain-top': true,
        name: 'nextPassCode',
        input: _TextBox.default,
        type: 'text'
      }), _FormType.default.Toolbar({
        noCancelButton: true,
        save: (0, _courage.loc)('mfa.challenge.verify', 'login')
      })];
    }
  },
  Footer: _Footer.default
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollTotpController.js":
/*!****************************************************!*\
  !*** ./src/v1/controllers/EnrollTotpController.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _StoreLinks = _interopRequireDefault(__webpack_require__(/*! v1/util/StoreLinks */ "./src/v1/util/StoreLinks.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const showWhenDeviceTypeSelected = {
  __deviceType__: function (val) {
    return val !== undefined;
  }
};
const EnrollTotpControllerAppDownloadInstructionsView = _courage.View.extend({
  attributes: {
    'data-se': 'app-download-instructions'
  },
  className: 'app-download-instructions',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<span class=\"app-logo " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "appIcon") || (depth0 != null ? lookupProperty(depth0, "appIcon") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "appIcon",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 22
          },
          "end": {
            "line": 1,
            "column": 33
          }
        }
      }) : helper)) + "\"></span><p class=\"instructions\">" + ((stack1 = (helper = (helper = lookupProperty(helpers, "appStoreLinkText") || (depth0 != null ? lookupProperty(depth0, "appStoreLinkText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "appStoreLinkText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 66
          },
          "end": {
            "line": 1,
            "column": 88
          }
        }
      }) : helper)) != null ? stack1 : "") + "</p>";
    },
    "useData": true
  }),
  initialize: function () {
    this.listenTo(this.model, 'change:__deviceType__', this.render);
  },
  postRender: function () {
    const link = this.$el.find('.instructions a');
    if (link.length) {
      link[0].setAttribute('target', '_blank');
      link[0].setAttribute('rel', 'noreferer noopener');
    }
  },
  getTemplateData: function () {
    let appStoreLink;
    let appIcon;
    let appStoreName;
    const factorName = _FactorUtil.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
    appStoreName = _StoreLinks.default.STORE[this.model.get('__deviceType__')];
    if (this.model.get('__provider__') === 'GOOGLE') {
      appStoreLink = _StoreLinks.default.GOOGLE[this.model.get('__deviceType__')];
      appIcon = 'google-auth-38';
    } else {
      appStoreLink = _StoreLinks.default.OKTA[this.model.get('__deviceType__')];
      appIcon = 'okta-verify-download-icon';
    }
    const appStoreLinkText = appStoreName ? (0, _courage.loc)('enroll.totp.downloadApp', 'login', [appStoreLink, factorName, appStoreName]) : null;
    return {
      appStoreLinkText: appStoreLinkText,
      appIcon: appIcon
    };
  }
});
const EnrollTotpControllerEnrollTotpController = _FormController.default.extend({
  className: 'enroll-totp',
  Model: function () {
    return {
      local: {
        __deviceType__: 'string',
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      },
      save: function () {
        return this.doTransaction(function (transaction) {
          const factor = _courage._.findWhere(transaction.factors, {
            factorType: this.get('__factorType__'),
            provider: this.get('__provider__')
          });
          return factor.enroll();
        });
      }
    };
  },
  Form: {
    title: function () {
      const factorName = _FactorUtil.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
      return (0, _courage.loc)('enroll.totp.title', 'login', [factorName]);
    },
    noButtonBar: true,
    attributes: {
      'data-se': 'step-device-type'
    },
    formChildren: function () {
      const inputOptions = {
        APPLE: (0, _courage.loc)('iphone', 'login'),
        ANDROID: (0, _courage.loc)('android', 'login')
      };
      const children = [_FormType.default.Input({
        name: '__deviceType__',
        type: 'radio',
        options: inputOptions,
        group: true,
        label: _courage._.partial(_courage.loc, 'enroll.totp.selectDevice', 'login')
      }), _FormType.default.Divider({
        showWhen: showWhenDeviceTypeSelected
      }), _FormType.default.View({
        View: EnrollTotpControllerAppDownloadInstructionsView,
        showWhen: showWhenDeviceTypeSelected
      }), _FormType.default.Button({
        title: (0, _courage.loc)('oform.next', 'login'),
        attributes: {
          'data-type': 'save'
        },
        className: 'button button-primary default-custom-button',
        click: function () {
          this.model.save();
        },
        showWhen: showWhenDeviceTypeSelected
      })];
      return children;
    }
  },
  Footer: _Footer.default
});
var _default = EnrollTotpControllerEnrollTotpController;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollU2FController.js":
/*!***************************************************!*\
  !*** ./src/v1/controllers/EnrollU2FController.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
__webpack_require__(/*! u2f-api-polyfill */ "./node_modules/u2f-api-polyfill/u2f-api-polyfill.js");
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _FidoUtil = _interopRequireDefault(__webpack_require__(/*! util/FidoUtil */ "./src/util/FidoUtil.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/HtmlErrorMessageView */ "./src/v1/views/mfa-verify/HtmlErrorMessageView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
/* global u2f */
var _default = _FormController.default.extend({
  className: 'enroll-u2f',
  Model: {
    local: {
      __enrolled__: 'boolean'
    },
    save: function () {
      this.trigger('request');
      if (this.get('__enrolled__')) {
        return this.activate();
      }
      return this.doTransaction(function (transaction) {
        const factor = _courage._.findWhere(transaction.factors, {
          factorType: 'u2f',
          provider: 'FIDO'
        });
        return factor.enroll();
      });
    },
    activate: function () {
      this.set('__enrolled__', true);
      this.trigger('errors:clear');
      return this.doTransaction(function (transaction) {
        const activation = transaction.factor.activation;
        const appId = activation.appId;
        const registerRequests = [{
          version: _FidoUtil.default.getU2fVersion(),
          challenge: activation.nonce
        }];
        const self = this;
        const deferred = _q.default.defer();
        u2f.register(appId, registerRequests, [], function (data) {
          self.trigger('errors:clear');
          if (data.errorCode && data.errorCode !== 0) {
            deferred.reject(new _Errors.U2FError({
              xhr: {
                responseJSON: {
                  errorSummary: _FidoUtil.default.getU2fEnrollErrorMessageByCode(data.errorCode)
                }
              }
            }));
          } else {
            deferred.resolve(transaction.activate({
              registrationData: data.registrationData,
              version: data.version,
              challenge: data.challenge,
              clientData: data.clientData
            }));
          }
        });
        return deferred.promise;
      });
    }
  },
  Form: {
    title: _courage._.partial(_courage.loc, 'enroll.u2f.title', 'login'),
    save: _courage._.partial(_courage.loc, 'enroll.u2f.save', 'login'),
    noCancelButton: true,
    hasSavingState: false,
    autoSave: true,
    className: 'enroll-u2f-form',
    noButtonBar: function () {
      return !_FidoUtil.default.isU2fAvailable();
    },
    modelEvents: {
      request: '_startEnrollment',
      error: '_stopEnrollment'
    },
    formChildren: function () {
      const result = [];
      if (!_FidoUtil.default.isU2fAvailable()) {
        let errorMessageKey = 'u2f.error.factorNotSupported';
        if (this.options.appState.get('factors').length === 1) {
          errorMessageKey = 'u2f.error.factorNotSupported.oneFactor';
        }
        result.push(_FormType.default.View({
          View: new _HtmlErrorMessageView.default({
            message: (0, _courage.loc)(errorMessageKey, 'login')
          })
        }, {
          selector: '.o-form-error-container'
        }));
      } else {
        //There is html in enroll.u2f.general2 in our properties file, reason why is unescaped
        result.push(_FormType.default.View({
          View: _courage.View.extend({
            template: _runtime.default.template({
              "compiler": [8, ">= 4.3.0"],
              "main": function (container, depth0, helpers, partials, data) {
                var stack1,
                  alias1 = depth0 != null ? depth0 : container.nullContext || {},
                  alias2 = container.hooks.helperMissing,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }
                    return undefined;
                  };
                return "<div class=\"u2f-instructions\"><ol><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "enroll.u2f.general2"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 38
                    },
                    "end": {
                      "line": 1,
                      "column": 90
                    }
                  }
                })) != null ? stack1 : "") + "</li><li>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "enroll.u2f.general3"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 99
                    },
                    "end": {
                      "line": 1,
                      "column": 149
                    }
                  }
                })) + "</li></ol></div>";
              },
              "useData": true
            })
          })
        }));
        result.push(_FormType.default.View({
          View: _courage.View.extend({
            template: _runtime.default.template({
              "compiler": [8, ">= 4.3.0"],
              "main": function (container, depth0, helpers, partials, data) {
                var alias1 = depth0 != null ? depth0 : container.nullContext || {},
                  alias2 = container.hooks.helperMissing,
                  alias3 = container.escapeExpression,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }
                    return undefined;
                  };
                return "<div class=\"u2f-enroll-text hide\"><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "enroll.u2f.instructions"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 37
                    },
                    "end": {
                      "line": 1,
                      "column": 91
                    }
                  }
                })) + "</p><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "enroll.u2f.instructionsBluetooth"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 98
                    },
                    "end": {
                      "line": 1,
                      "column": 161
                    }
                  }
                })) + "</p><div data-se=\"u2f-devices\" class=\"u2f-devices-images\"><div class=\"u2f-usb\"></div><div class=\"u2f-bluetooth\"></div></div><div data-se=\"u2f-waiting\" class=\"okta-waiting-spinner\"></div></div>";
              },
              "useData": true
            })
          })
        }));
      }
      return result;
    },
    _startEnrollment: function () {
      this.$('.u2f-instructions').addClass('hide');
      this.$('.u2f-enroll-text').removeClass('hide');
      this.$('.o-form-button-bar').hide();
    },
    _stopEnrollment: function () {
      this.$('.u2f-instructions').removeClass('hide');
      this.$('.u2f-enroll-text').addClass('hide');
      this.$('.o-form-button-bar').show();
    }
  },
  Footer: _Footer.default,
  trapAuthResponse: function () {
    if (this.options.appState.get('isMfaEnrollActivate')) {
      this.model.activate();
      return true;
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollUserController.js":
/*!****************************************************!*\
  !*** ./src/v1/controllers/EnrollUserController.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _EnrollUser = _interopRequireDefault(__webpack_require__(/*! v1/models/EnrollUser */ "./src/v1/models/EnrollUser.js"));
var _BaseLoginController = _interopRequireDefault(__webpack_require__(/*! v1/util/BaseLoginController */ "./src/v1/util/BaseLoginController.js"));
var _EnrollUserForm = _interopRequireDefault(__webpack_require__(/*! v1/views/enrollUser/EnrollUserForm */ "./src/v1/views/enrollUser/EnrollUserForm.js"));
var _FooterWithBackLink = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/FooterWithBackLink */ "./src/v1/views/shared/FooterWithBackLink.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _BaseLoginController.default.extend({
  className: 'enroll-user',
  initialize: function (options) {
    this.options = options || {};
    // create model
    this.model = new _EnrollUser.default(this.options);
  },
  fetchInitialData: function () {
    // If user is unauthenticated and starts enroll flow make a post call to transition state to PROFILE_REQUIRED
    if (this.options.appState.get('isUnauthenticated')) {
      return this.model.getEnrollFormData();
    } else {
      return _BaseLoginController.default.prototype.fetchInitialData.call();
    }
  },
  trapAuthResponse: function () {
    if (this.options.appState.get('isProfileRequired')) {
      return true;
    }
  },
  postRender: function () {
    const form = new _EnrollUserForm.default(this.toJSON());
    this.add(form);
    this.add(new _FooterWithBackLink.default(this.toJSON()));
    this.addListeners();
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollWebauthnController.js":
/*!********************************************************!*\
  !*** ./src/v1/controllers/EnrollWebauthnController.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
var _BrowserFeatures = _interopRequireDefault(__webpack_require__(/*! util/BrowserFeatures */ "./src/util/BrowserFeatures.ts"));
var _CryptoUtil = _interopRequireDefault(__webpack_require__(/*! util/CryptoUtil */ "./src/util/CryptoUtil.js"));
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _webauthn = _interopRequireDefault(__webpack_require__(/*! util/webauthn */ "./src/util/webauthn.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/HtmlErrorMessageView */ "./src/v1/views/mfa-verify/HtmlErrorMessageView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

function getExcludeCredentials(credentials) {
  const excludeCredentials = [];
  _courage._.each(credentials, function (credential) {
    excludeCredentials.push({
      type: 'public-key',
      id: _CryptoUtil.default.strToBin(credential.id)
    });
  });
  return excludeCredentials;
}
var _default = _FormController.default.extend({
  className: 'enroll-webauthn',
  Model: {
    local: {
      __enrolled__: 'boolean'
    },
    save: function () {
      this.trigger('request');
      if (this.get('__enrolled__')) {
        return this.activate();
      }
      return this.doTransaction(function (transaction) {
        const factor = _courage._.findWhere(transaction.factors, {
          factorType: 'webauthn',
          provider: 'FIDO'
        });
        return factor.enroll();
      });
    },
    activate: function () {
      this.set('__enrolled__', true);
      this.trigger('errors:clear');
      this.appState.on('backToFactors', () => {
        if (this.webauthnAbortController) {
          this.webauthnAbortController.abort();
          this.webauthnAbortController = null;
        }
      });
      return this.doTransaction(function (transaction) {
        const activation = transaction.factor.activation;
        // enroll via browser webauthn js

        const self = this;
        if (_webauthn.default.isNewApiAvailable()) {
          const options = _courage._.extend({}, activation, {
            challenge: _CryptoUtil.default.strToBin(activation.challenge),
            user: {
              id: _CryptoUtil.default.strToBin(activation.user.id),
              name: activation.user.name,
              displayName: activation.user.displayName
            },
            excludeCredentials: getExcludeCredentials(activation.excludeCredentials)
          });

          // AbortController is not supported in IE11
          if (typeof AbortController !== 'undefined') {
            self.webauthnAbortController = new AbortController();
          }
          return new _q.default(navigator.credentials.create({
            publicKey: options,
            signal: self.webauthnAbortController && self.webauthnAbortController.signal
          })).then(function (newCredential) {
            return transaction.activate({
              attestation: _CryptoUtil.default.binToStr(newCredential.response.attestationObject),
              clientData: _CryptoUtil.default.binToStr(newCredential.response.clientDataJSON),
              // example data: ["nfc", "usb"]
              transports: _webauthn.default.processWebAuthnResponse(newCredential.response.getTransports, newCredential.response),
              // example data: {"credProps":{"rk":true}}
              clientExtensions: _webauthn.default.processWebAuthnResponse(newCredential.getClientExtensionResults, newCredential)
            });
          }).catch(function (error) {
            self.trigger('errors:clear');
            // Do not display if it is abort error triggered by code when switching.
            // self.webauthnAbortController would be null if abort was triggered by code.
            if (!self.webauthnAbortController) {
              throw new _Errors.WebauthnAbortError();
            } else {
              throw new _Errors.WebAuthnError({
                xhr: {
                  responseJSON: {
                    errorSummary: error.message
                  }
                }
              });
            }
          }).finally(function () {
            // unset webauthnAbortController on successful authentication or error
            self.webauthnAbortController = null;
          });
        }
      });
    }
  },
  Form: {
    title: _courage._.partial(_courage.loc, 'enroll.webauthn.biometric.title', 'login'),
    save: _courage._.partial(_courage.loc, 'enroll.webauthn.save', 'login'),
    noCancelButton: true,
    hasSavingState: false,
    autoSave: true,
    className: 'enroll-webauthn-form',
    noButtonBar: function () {
      return !_webauthn.default.isNewApiAvailable();
    },
    modelEvents: {
      request: '_startEnrollment',
      error: '_stopEnrollment'
    },
    formChildren: function () {
      const children = [];
      if (_webauthn.default.isNewApiAvailable()) {
        //enroll.webauthn.biometric.instructions.edge is unescaped because it contains html
        children.push(_FormType.default.View({
          View: _courage.View.extend({
            className: 'webauthn-enroll-text',
            template: _runtime.default.template({
              "1": function (container, depth0, helpers, partials, data) {
                var stack1,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }
                    return undefined;
                  };
                return "<div class=\"webauthn-edge-text\"><p>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "enroll.webauthn.biometric.instructions.edge"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 173
                    },
                    "end": {
                      "line": 1,
                      "column": 249
                    }
                  }
                })) != null ? stack1 : "") + "</p></div>";
              },
              "3": function (container, depth0, helpers, partials, data) {
                var stack1,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }
                    return undefined;
                  };
                return "<div class=\"webauthn-restrictions-text\"><p>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "enroll.webauthn.instructions.noSupportForBiometric"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 340
                    },
                    "end": {
                      "line": 1,
                      "column": 423
                    }
                  }
                })) != null ? stack1 : "") + "</p></div>";
              },
              "compiler": [8, ">= 4.3.0"],
              "main": function (container, depth0, helpers, partials, data) {
                var stack1,
                  alias1 = depth0 != null ? depth0 : container.nullContext || {},
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }
                    return undefined;
                  };
                return "<div class=\"webauthn-enroll-instructions\"><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "enroll.webauthn.biometric.instructions"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 45
                    },
                    "end": {
                      "line": 1,
                      "column": 114
                    }
                  }
                })) + "</p></div>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isEdge") : depth0, {
                  "name": "if",
                  "hash": {},
                  "fn": container.program(1, data, 0),
                  "inverse": container.noop,
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 124
                    },
                    "end": {
                      "line": 1,
                      "column": 266
                    }
                  }
                })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "onlySupportsSecurityKey") : depth0, {
                  "name": "if",
                  "hash": {},
                  "fn": container.program(3, data, 0),
                  "inverse": container.noop,
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 266
                    },
                    "end": {
                      "line": 1,
                      "column": 440
                    }
                  }
                })) != null ? stack1 : "") + "<div data-se=\"webauthn-waiting\" class=\"okta-waiting-spinner hide\"></div>";
              },
              "useData": true
            }),
            getTemplateData: function () {
              return {
                isEdge: _BrowserFeatures.default.isEdge(),
                onlySupportsSecurityKey: (_BrowserFeatures.default.isFirefox() || _BrowserFeatures.default.isSafari()) && _BrowserFeatures.default.isMac()
              };
            }
          })
        }));
      } else {
        let errorMessageKey = 'webauthn.biometric.error.factorNotSupported';
        if (this.options.appState.get('factors').length === 1) {
          errorMessageKey = 'webauthn.biometric.error.factorNotSupported.oneFactor';
        }
        children.push(_FormType.default.View({
          View: new _HtmlErrorMessageView.default({
            message: (0, _courage.loc)(errorMessageKey, 'login')
          })
        }, {
          selector: '.o-form-error-container'
        }));
      }
      return children;
    },
    _startEnrollment: function () {
      this.$('.okta-waiting-spinner').show();
      this.$('.o-form-button-bar').hide();
    },
    _stopEnrollment: function () {
      this.$('.okta-waiting-spinner').hide();
      this.$('.o-form-button-bar').show();
    }
  },
  Footer: _Footer.default,
  trapAuthResponse: function () {
    if (this.options.appState.get('isMfaEnrollActivate')) {
      this.model.activate();
      return true;
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollWindowsHelloController.js":
/*!************************************************************!*\
  !*** ./src/v1/controllers/EnrollWindowsHelloController.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _webauthn = _interopRequireDefault(__webpack_require__(/*! util/webauthn */ "./src/util/webauthn.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/HtmlErrorMessageView */ "./src/v1/views/mfa-verify/HtmlErrorMessageView.js"));
var _Spinner = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/Spinner */ "./src/v1/views/shared/Spinner.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'enroll-windows-hello',
  Model: {
    local: {
      __isEnrolled__: 'boolean'
    },
    save: function () {
      if (!_webauthn.default.isAvailable()) {
        return;
      }
      this.trigger('request');
      if (this.get('__isEnrolled__')) {
        return this.activate();
      }
      return this.doTransaction(function (transaction) {
        return this._enroll(transaction);
      });
    },
    _enroll: function (transaction) {
      const factor = _courage._.findWhere(transaction.factors, {
        factorType: 'webauthn',
        provider: 'FIDO'
      });
      return factor.enroll();
    },
    activate: function () {
      this.set('__isEnrolled__', true);
      return this.doTransaction(function (transaction) {
        const activation = transaction.factor.activation;
        const user = transaction.user;
        const model = this;
        const accountInfo = {
          rpDisplayName: activation.rpDisplayName,
          userDisplayName: user.profile.displayName,
          accountName: user.profile.login,
          userId: user.id
        };
        const cryptoParams = [{
          algorithm: activation.algorithm
        }];
        const challenge = activation.nonce;
        return _webauthn.default.makeCredential(accountInfo, cryptoParams, challenge).then(function (creds) {
          return transaction.activate({
            credentialId: creds.credential.id,
            publicKey: creds.publicKey,
            attestation: null
          });
        }).catch(function (error) {
          switch (error.message) {
            case 'AbortError':
            case 'NotFoundError':
            case 'NotSupportedError':
              model.trigger('abort', error.message);
              return transaction;
          }
          throw error;
        });
      });
    }
  },
  Form: {
    autoSave: true,
    hasSavingState: false,
    title: _courage._.partial(_courage.loc, 'enroll.windowsHello.title', 'login'),
    subtitle: function () {
      return _webauthn.default.isAvailable() ? (0, _courage.loc)('enroll.windowsHello.subtitle', 'login') : '';
    },
    save: _courage._.partial(_courage.loc, 'enroll.windowsHello.save', 'login'),
    customSavingState: {
      stop: 'abort'
    },
    modelEvents: function () {
      if (!_webauthn.default.isAvailable()) {
        return {};
      }
      return {
        request: '_startEnrollment',
        error: '_stopEnrollment',
        abort: '_stopEnrollment'
      };
    },
    noButtonBar: function () {
      return !_webauthn.default.isAvailable();
    },
    formChildren: function () {
      const result = [];
      if (!_webauthn.default.isAvailable()) {
        result.push(_FormType.default.View({
          View: new _HtmlErrorMessageView.default({
            message: (0, _courage.loc)('enroll.windowsHello.error.notWindows', 'login')
          })
        }, {
          selector: '.o-form-error-container'
        }));
      }
      result.push(_FormType.default.View({
        View: new _Spinner.default({
          model: this.model,
          visible: false
        })
      }));
      return result;
    },
    _startEnrollment: function () {
      this.subtitle = (0, _courage.loc)('enroll.windowsHello.subtitle.loading', 'login');
      this.model.trigger('spinner:show');
      this._resetErrorMessage();
      this.render();
      this.$('.o-form-button-bar').addClass('hide');
    },
    _stopEnrollment: function (errorMessage) {
      this.subtitle = (0, _courage.loc)('enroll.windowsHello.subtitle', 'login');
      this.model.trigger('spinner:hide');
      let message;
      switch (errorMessage) {
        case 'NotSupportedError':
          message = (0, _courage.loc)('enroll.windowsHello.error.notConfiguredHtml', 'login');
          break;
      }
      this._resetErrorMessage();
      if (message) {
        const messageView = new _HtmlErrorMessageView.default({
          message: message
        });
        this.$('.o-form-error-container').addClass('o-form-has-errors');
        this.add(messageView, {
          selector: '.o-form-error-container'
        });
        this._errorMessageView = this.last();
      }
      this.render();
      this.$('.o-form-button-bar').removeClass('hide');
    },
    _resetErrorMessage: function () {
      this._errorMessageView && this._errorMessageView.remove();
      this._errorMessageView = undefined;
      this.clearErrors();
    }
  },
  Footer: _Footer.default,
  trapAuthResponse: function () {
    if (this.options.appState.get('isMfaEnrollActivate')) {
      this.model.activate();
      return true;
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollYubikeyController.js":
/*!*******************************************************!*\
  !*** ./src/v1/controllers/EnrollYubikeyController.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/Footer */ "./src/v1/views/enroll-factors/Footer.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'enroll-yubikey',
  Model: {
    props: {
      passCode: ['string', true],
      factorId: 'string'
    },
    save: function () {
      return this.doTransaction(function (transaction) {
        const factor = _courage._.findWhere(transaction.factors, {
          factorType: 'token:hardware',
          provider: 'YUBICO'
        });
        return factor.enroll({
          passCode: this.get('passCode')
        });
      });
    }
  },
  Form: {
    title: _courage._.partial(_courage.loc, 'enroll.yubikey.title', 'login'),
    subtitle: _courage._.partial(_courage.loc, 'enroll.yubikey.subtitle', 'login'),
    noCancelButton: true,
    save: _courage._.partial(_courage.loc, 'mfa.challenge.verify', 'login'),
    autoSave: true,
    className: 'enroll-yubikey',
    formChildren: [_FormType.default.View({
      View: '<div class="yubikey-demo" data-type="yubikey-example"></div>'
    }), _FormType.default.Input({
      name: 'passCode',
      input: _TextBox.default,
      type: 'password'
    })]
  },
  Footer: _Footer.default
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnrollmentLinkSentController.js":
/*!************************************************************!*\
  !*** ./src/v1/controllers/EnrollmentLinkSentController.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _CountryUtil = _interopRequireDefault(__webpack_require__(/*! util/CountryUtil */ "./src/util/CountryUtil.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _RouterUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/RouterUtil */ "./src/v1/util/RouterUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const PUSH_INTERVAL = 6000;

// Note: Keep-alive is set to 5 seconds - using 5 seconds here will result
// in network connection lost errors in Safari and IE.

const EnrollmentLinkSentControllerFooter = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oform.back"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 99
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .js-back': function (e) {
      e.preventDefault();
      this.back();
    }
  },
  back: function () {
    const url = _RouterUtil.default.createActivateFactorUrl(this.options.appState.get('activatedFactorProvider'), this.options.appState.get('activatedFactorType'), 'manual');
    this.options.appState.trigger('navigate', url);
  }
});
const emailSentForm = {
  title: _courage._.partial(_courage.loc, 'enroll.totp.enrollViaEmail.title', 'login'),
  noButtonBar: true,
  attributes: {
    'data-se': 'sent-email-activation-link'
  },
  formChildren: [_FormType.default.View({
    View: _courage.View.extend({
      template: _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function (container, depth0, helpers, partials, data) {
          var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
          return "<p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
            "name": "i18n",
            "hash": {
              "bundle": "login",
              "code": "enroll.totp.enrollViaEmail.msg"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 3
              },
              "end": {
                "line": 1,
                "column": 64
              }
            }
          })) + "</p><p class=\"email-address\">" + alias3((helper = (helper = lookupProperty(helpers, "email") || (depth0 != null ? lookupProperty(depth0, "email") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
            "name": "email",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 93
              },
              "end": {
                "line": 1,
                "column": 102
              }
            }
          }) : helper)) + "</p>";
        },
        "useData": true
      }),
      getTemplateData: function () {
        return {
          email: this.options.appState.get('userEmail')
        };
      }
    })
  })]
};
const smsSentForm = {
  title: _courage._.partial(_courage.loc, 'enroll.totp.enrollViaSms.title', 'login'),
  noButtonBar: true,
  attributes: {
    'data-se': 'sent-sms-activation-link'
  },
  formChildren: [_FormType.default.View({
    View: _courage.View.extend({
      template: _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function (container, depth0, helpers, partials, data) {
          var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
          return "<p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
            "name": "i18n",
            "hash": {
              "bundle": "login",
              "code": "enroll.totp.enrollViaSms.msg"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 3
              },
              "end": {
                "line": 1,
                "column": 62
              }
            }
          })) + "</p><p class=\"phone-number\">" + alias3((helper = (helper = lookupProperty(helpers, "phoneNumber") || (depth0 != null ? lookupProperty(depth0, "phoneNumber") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
            "name": "phoneNumber",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 90
              },
              "end": {
                "line": 1,
                "column": 105
              }
            }
          }) : helper)) + "</p>";
        },
        "useData": true
      }),
      getTemplateData: function () {
        return {
          phoneNumber: this.model.get('fullPhoneNumber')
        };
      }
    })
  })]
};
var _default = _FormController.default.extend({
  className: 'enroll-activation-link-sent',
  Model: function () {
    return {
      local: {
        countryCode: ['string', false, this.options.appState.get('userCountryCode')],
        phoneNumber: ['string', false, this.options.appState.get('userPhoneNumber')],
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      },
      derived: {
        countryCallingCode: {
          deps: ['countryCode'],
          fn: function (countryCode) {
            return '+' + _CountryUtil.default.getCallingCodeForCountry(countryCode);
          }
        },
        fullPhoneNumber: {
          deps: ['countryCallingCode', 'phoneNumber'],
          fn: function (countryCallingCode, phoneNumber) {
            return countryCallingCode + phoneNumber;
          }
        }
      }
    };
  },
  Form: function () {
    const activationType = this.options.appState.get('factorActivationType');
    switch (activationType) {
      case 'SMS':
        return smsSentForm;
      case 'EMAIL':
        return emailSentForm;
      default:
        throw new Error('Unknown activation option: ' + activationType);
    }
  },
  Footer: EnrollmentLinkSentControllerFooter,
  initialize: function () {
    this.pollForEnrollment();
  },
  remove: function () {
    return _FormController.default.prototype.remove.apply(this, arguments);
  },
  pollForEnrollment: function () {
    return this.model.doTransaction(function (transaction) {
      return transaction.poll(PUSH_INTERVAL);
    });
  },
  trapAuthResponse: function () {
    if (this.options.appState.get('isWaitingForActivation')) {
      this.pollForEnrollment();
      return true;
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/EnterPasscodePushFlowController.js":
/*!***************************************************************!*\
  !*** ./src/v1/controllers/EnterPasscodePushFlowController.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _RouterUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/RouterUtil */ "./src/v1/util/RouterUtil.js"));
var _EnterPasscodeForm = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/EnterPasscodeForm */ "./src/v1/views/enroll-factors/EnterPasscodeForm.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const EnterPasscodePushFlowControllerFooter = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oform.back"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 99
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .js-back': function (e) {
      e.preventDefault();
      this.back();
    }
  },
  back: function () {
    const url = _RouterUtil.default.createActivateFactorUrl(this.options.appState.get('activatedFactorProvider'), 'push', 'manual');
    this.options.appState.trigger('navigate', url);
  }
});
var _default = _FormController.default.extend({
  className: 'activate-push',
  Model: function () {
    return {
      props: {
        factorId: ['string', true, this.options.appState.get('activatedFactorId')],
        passCode: ['string', true]
      },
      local: {
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      },
      save: function () {
        return this.doTransaction(function (transaction) {
          return transaction.activate({
            passCode: this.get('passCode')
          });
        });
      }
    };
  },
  Form: _EnterPasscodeForm.default,
  Footer: EnterPasscodePushFlowControllerFooter
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/ErrorStateController.js":
/*!****************************************************!*\
  !*** ./src/v1/controllers/ErrorStateController.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FooterWithBackLinkOnError = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/FooterWithBackLinkOnError */ "./src/v1/views/shared/FooterWithBackLinkOnError.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'error-state',
  Model: {},
  Form: {
    noButtonBar: true
  },
  Footer: _FooterWithBackLinkOnError.default
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/ForceIDPDiscoveryController.js":
/*!***********************************************************!*\
  !*** ./src/v1/controllers/ForceIDPDiscoveryController.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _Spinner = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/Spinner */ "./src/v1/views/shared/Spinner.js"));
var _BaseLoginController = _interopRequireDefault(__webpack_require__(/*! v1/util/BaseLoginController */ "./src/v1/util/BaseLoginController.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _BaseLoginController.default.extend({
  className: 'force-idp-discovery',
  View: _Spinner.default,
  Model: {},
  initialize: function () {
    const OKTA_IDP_TYPE = 'OKTA';
    const RESOURCE = 'okta:acct:';
    const options = this.options;
    const lastAuthResponse = options.appState.get('lastAuthResponse');
    const stateToken = lastAuthResponse && (lastAuthResponse === null || lastAuthResponse === void 0 ? void 0 : lastAuthResponse.stateToken);
    const webfingerArgs = {
      resource: RESOURCE,
      requestContext: stateToken
    };
    options.appState.settings.getAuthClient().webfinger(webfingerArgs).then(res => {
      if (res !== null && res !== void 0 && res.links && res.links[0]) {
        if (res.links[0].properties['okta:idp:type'] !== OKTA_IDP_TYPE && res.links[0].href) {
          const redirectFn = res.links[0].href.includes('OKTA_INVALID_SESSION_REPOST%3Dtrue') ? _Util.default.redirectWithFormGet.bind(_Util.default) : this.settings.get('redirectUtilFn');
          //override redirectFn to only use Util.redirectWithFormGet if OKTA_INVALID_SESSION_REPOST is included
          //it will be encoded since it will be included in the encoded fromURI

          redirectFn(res.links[0].href);
          return;
        }
      }
      options.appState.trigger('navigate', '');
    }).catch(() => {
      // TODO: OKTA-436775 Show error instead of navigating to default route
      options.appState.trigger('navigate', '');
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/ForgotPasswordController.js":
/*!********************************************************!*\
  !*** ./src/v1/controllers/ForgotPasswordController.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _ValidationUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/ValidationUtil */ "./src/v1/util/ValidationUtil.js"));
var _ContactSupport = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/ContactSupport */ "./src/v1/views/shared/ContactSupport.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const ForgotPasswordControllernoFactorsError = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<div class=\"okta-form-infobox-error infobox infobox-error\" role=\"alert\"><span class=\"icon error-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "password.forgot.noFactorsEnabled"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 110
          },
          "end": {
            "line": 1,
            "column": 173
          }
        }
      })) + "</p></div>";
    },
    "useData": true
  })
});
const ForgotPasswordControllerFooter = _courage.View.extend({
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "goback"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 94
          },
          "end": {
            "line": 1,
            "column": 131
          }
        }
      })) + "</a>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<a href=\"#\" class=\"link goto js-contact-support\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "mfa.noAccessToEmail"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 220
          },
          "end": {
            "line": 1,
            "column": 270
          }
        }
      })) + "</a>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "hideBackToSignInForReset") : depth0, {
        "name": "unless",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 146
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "helpSupportNumber") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 146
          },
          "end": {
            "line": 1,
            "column": 281
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .js-back': function (e) {
      e.preventDefault();
      this.back();
    },
    'click .js-contact-support': function (e) {
      e.preventDefault();
      this.state.trigger('contactSupport');
      this.$('.js-contact-support').hide();
    }
  },
  getTemplateData: function () {
    return {
      hideBackToSignInForReset: this.settings.get('features.hideBackToSignInForReset'),
      helpSupportNumber: this.settings.get('helpSupportNumber')
    };
  },
  back: function () {
    this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
    this.options.appState.trigger('navigate', '');
  }
});
var _default = _FormController.default.extend({
  className: 'forgot-password',
  Model: {
    props: {
      username: ['string', true],
      factorType: ['string', true]
    },
    validate: function () {
      return _ValidationUtil.default.validateUsername(this);
    },
    save: function () {
      const self = this;
      const relayState = this.settings.get('relayState');
      this.startTransaction(function (authClient) {
        return authClient.forgotPassword({
          username: self.settings.transformUsername(self.get('username'), _Enums.default.FORGOT_PASSWORD),
          factorType: self.get('factorType'),
          relayState: relayState
        });
      }).catch(function () {
        //need empty fail handler on model to display errors on form
      });
    }
  },
  Form: {
    noButtonBar: true,
    title: _courage._.partial(_courage.loc, 'password.reset', 'login'),
    formChildren: function () {
      const smsEnabled = this.settings.get('features.smsRecovery');
      /*eslint complexity: [2, 9] max-statements: [2, 23] */

      const callEnabled = this.settings.get('features.callRecovery');
      const emailEnabled = this.settings.get('features.emailRecovery');
      const noFactorsEnabled = !(smsEnabled || callEnabled || emailEnabled);
      const formChildren = [];
      if (noFactorsEnabled) {
        this.add(ForgotPasswordControllernoFactorsError, '.o-form-error-container');
      } else {
        formChildren.push(_FormType.default.Input({
          label: (0, _courage.loc)('password.forgot.email.or.username.placeholder', 'login'),
          'label-top': true,
          explain: _Util.default.createInputExplain('password.forgot.email.or.username.tooltip', 'password.forgot.email.or.username.placeholder', 'login'),
          'explain-top': true,
          name: 'username',
          input: _TextBox.default,
          inputId: 'account-recovery-username',
          autoComplete: _Util.default.getAutocompleteValue(this.settings, 'username'),
          type: 'text',
          inlineValidation: false
        }));
        if (smsEnabled || callEnabled) {
          formChildren.push(_FormType.default.View({
            View: _courage.View.extend({
              template: _runtime.default.template({
                "compiler": [8, ">= 4.3.0"],
                "main": function (container, depth0, helpers, partials, data) {
                  var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }
                    return undefined;
                  };
                  return "<p class=\"mobile-recovery-hint\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                    "name": "i18n",
                    "hash": {
                      "arguments": "mobileFactors",
                      "bundle": "login",
                      "code": "recovery.mobile.hint"
                    },
                    "data": data,
                    "loc": {
                      "start": {
                        "line": 1,
                        "column": 32
                      },
                      "end": {
                        "line": 1,
                        "column": 109
                      }
                    }
                  })) + "</p>";
                },
                "useData": true
              }),
              getTemplateData: function () {
                let mobileFactors;
                if (smsEnabled && callEnabled) {
                  mobileFactors = (0, _courage.loc)('recovery.smsOrCall');
                } else if (callEnabled) {
                  mobileFactors = (0, _courage.loc)('recovery.call');
                } else {
                  mobileFactors = (0, _courage.loc)('recovery.sms');
                }
                return {
                  mobileFactors: mobileFactors
                };
              }
            })
          }));
        }
        if (smsEnabled) {
          this.$el.addClass('forgot-password-sms-enabled');
          formChildren.push(this.createRecoveryFactorButton('sms-button', 'password.forgot.sendText', _Enums.default.RECOVERY_FACTOR_TYPE_SMS, this));
          this.setDefaultFactorType(_Enums.default.RECOVERY_FACTOR_TYPE_SMS);
        }
        if (callEnabled) {
          this.$el.addClass('forgot-password-call-enabled');
          formChildren.push(this.createRecoveryFactorButton('call-button', 'password.forgot.call', _Enums.default.RECOVERY_FACTOR_TYPE_CALL, this));
          this.setDefaultFactorType(_Enums.default.RECOVERY_FACTOR_TYPE_CALL);
        }
        if (emailEnabled) {
          this.$el.addClass('forgot-password-email-enabled');
          formChildren.push(this.createRecoveryFactorButton('email-button', 'password.forgot.sendEmail', _Enums.default.RECOVERY_FACTOR_TYPE_EMAIL, this));
          this.setDefaultFactorType(_Enums.default.RECOVERY_FACTOR_TYPE_EMAIL);
        }
      }
      return formChildren;
    },
    initialize: function () {
      this.listenTo(this.state, 'contactSupport', function () {
        this.add(_ContactSupport.default, '.o-form-error-container');
      });
      this.listenTo(this, 'save', function () {
        this.options.appState.set('username', this.model.get('username'));
        this.model.save();
      });
    },
    setDefaultFactorType: function (factorType) {
      if (_courage._.isEmpty(this.model.get('factorType'))) {
        this.model.set('factorType', factorType);
      }
    },
    createRecoveryFactorButton: function (className, labelCode, factorType, form) {
      return _FormType.default.Button({
        attributes: {
          'data-se': className
        },
        className: 'button button-primary button-wide ' + className,
        title: (0, _courage.loc)(labelCode, 'login'),
        click: function () {
          form.clearErrors();
          if (this.model.isValid()) {
            this.model.set('factorType', factorType);
            form.trigger('save', this.model);
          }
        }
      });
    }
  },
  Footer: ForgotPasswordControllerFooter,
  initialize: function () {
    this.options.appState.unset('username');
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/IDPDiscoveryController.js":
/*!******************************************************!*\
  !*** ./src/v1/controllers/IDPDiscoveryController.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _PrimaryAuthController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/PrimaryAuthController */ "./src/v1/controllers/PrimaryAuthController.js"));
var _IDPDiscovery = _interopRequireDefault(__webpack_require__(/*! v1/models/IDPDiscovery */ "./src/v1/models/IDPDiscovery.js"));
var _PrimaryAuth = _interopRequireDefault(__webpack_require__(/*! v1/models/PrimaryAuth */ "./src/v1/models/PrimaryAuth.js"));
var _BaseLoginController = _interopRequireDefault(__webpack_require__(/*! v1/util/BaseLoginController */ "./src/v1/util/BaseLoginController.js"));
var _IDPDiscoveryForm = _interopRequireDefault(__webpack_require__(/*! v1/views/idp-discovery/IDPDiscoveryForm */ "./src/v1/views/idp-discovery/IDPDiscoveryForm.js"));
var _CustomButtons = _interopRequireDefault(__webpack_require__(/*! v1/views/primary-auth/CustomButtons */ "./src/v1/views/primary-auth/CustomButtons.js"));
var _DeviceFingerprint = _interopRequireDefault(__webpack_require__(/*! v1/util/DeviceFingerprint */ "./src/v1/util/DeviceFingerprint.js"));
var _RouterUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/RouterUtil */ "./src/v1/util/RouterUtil.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _PrimaryAuthController.default.extend({
  className: 'idp-discovery',
  View: _IDPDiscoveryForm.default,
  constructor: function (options) {
    options.appState.unset('username');
    let requestContext = options.settings.get('idpDiscovery.requestContext');
    const lastAuthResponse = options.appState.get('lastAuthResponse');
    const stateToken = lastAuthResponse && (lastAuthResponse === null || lastAuthResponse === void 0 ? void 0 : lastAuthResponse.stateToken);

    //Update requestContext with last stateToken, if the context was stateToken and not a fromUri
    if (_Util.default.isV1StateToken(requestContext)) {
      requestContext = stateToken;
    }
    this.model = new _IDPDiscovery.default({
      requestContext: requestContext,
      settings: options.settings,
      appState: options.appState
    }, {
      parse: true
    });
    _BaseLoginController.default.apply(this, arguments);
    this.addListeners();

    // If social auth is configured, 'socialAuthPositionTop' will determine
    // the order in which the social auth and primary auth are shown on the screen.
    if (options.settings.get('hasConfiguredButtons')) {
      this.add(_CustomButtons.default, {
        prepend: options.settings.get('socialAuthPositionTop'),
        options: {
          // To trigger an afterError event, we require the current controller
          currentController: this
        }
      });
    }
    this.addFooter(options);
    this.setUsername();
  },
  initialize: function () {
    _PrimaryAuthController.default.prototype.initialize.apply(this);
    this.listenTo(this.model, 'goToPrimaryAuth', function () {
      this.settings.set('username', this.model.get('username'));
      const self = this;
      if (this.settings.get('features.deviceFingerprinting')) {
        _DeviceFingerprint.default.generateDeviceFingerprint(this.settings.get('baseUrl'), this.$el).then(function (fingerprint) {
          self.options.appState.set('deviceFingerprint', fingerprint);
          self.options.appState.set('username', self.model.get('username'));
        }).catch(function () {
          // Keep going even if device fingerprint fails
          self.options.appState.set('username', self.model.get('username'));
        }).finally(function () {
          self.doPrimaryAuth();
        });
      } else {
        self.doPrimaryAuth();
      }
    });
  },
  doPrimaryAuth: function () {
    if (this.settings.get('features.passwordlessAuth')) {
      const primaryAuthModel = new _PrimaryAuth.default({
        username: this.model.get('username'),
        multiOptionalFactorEnroll: this.options.settings.get('features.multiOptionalFactorEnroll'),
        settings: this.options.settings,
        appState: this.options.appState
      }, {
        parse: true
      });

      // Events to set the transaction attributes on the app state.
      this.listenTo(primaryAuthModel, 'error', function (src, errObj) {
        this.toggleButtonState(false);
        this.model.trigger('error', this.model, errObj);
      });
      this.addModelListeners(primaryAuthModel);
      // Make the primary auth request
      primaryAuthModel.save();
    } else {
      this.options.appState.set('disableUsername', true);
      const url = _RouterUtil.default.createSigninUrl(this.settings.get('features.prefillUsernameFromIdpDiscovery') && this.model.get('username'));
      this.options.appState.trigger('navigate', url);
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/ManualSetupPushController.js":
/*!*********************************************************!*\
  !*** ./src/v1/controllers/ManualSetupPushController.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _CountryUtil = _interopRequireDefault(__webpack_require__(/*! util/CountryUtil */ "./src/util/CountryUtil.js"));
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _RouterUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/RouterUtil */ "./src/v1/util/RouterUtil.js"));
var _ManualSetupPushFooter = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/ManualSetupPushFooter */ "./src/v1/views/enroll-factors/ManualSetupPushFooter.js"));
var _PhoneTextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/PhoneTextBox */ "./src/v1/views/enroll-factors/PhoneTextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

function goToFactorActivation(view, step) {
  const url = _RouterUtil.default.createActivateFactorUrl(view.options.appState.get('activatedFactorProvider'), view.options.appState.get('activatedFactorType'), step);
  view.options.appState.trigger('navigate', url);
}
function setStateValues(view) {
  let userPhoneNumber;
  let userCountryCode;
  if (view.model.get('activationType') === 'SMS') {
    userCountryCode = view.model.get('countryCode');
    userPhoneNumber = view.model.get('phoneNumber');
  }
  view.options.appState.set({
    factorActivationType: view.model.get('activationType'),
    userCountryCode: userCountryCode,
    userPhoneNumber: userPhoneNumber
  });
}
function enrollFactor(view, factorType) {
  return view.model.doTransaction(function (transaction) {
    return transaction.prev().then(function (trans) {
      const factor = _courage._.findWhere(trans.factors, {
        factorType: factorType,
        provider: 'OKTA'
      });
      return factor.enroll();
    }).then(function (trans) {
      let textActivationLinkUrl;
      let emailActivationLinkUrl;
      let sharedSecret;
      const res = trans.data;
      if (res && res._embedded && res._embedded.factor && res._embedded.factor._embedded && res._embedded.factor._embedded.activation) {
        const factor = res._embedded.factor;

        // Shared secret
        sharedSecret = factor._embedded.activation.sharedSecret;
        if (factor._embedded.activation._links && factor._embedded.activation._links.send) {
          const activationSendLinks = factor._embedded.activation._links.send;
          const smsItem = _courage._.findWhere(activationSendLinks, {
            name: 'sms'
          });

          // SMS activation url

          textActivationLinkUrl = smsItem ? smsItem.href : null;

          // Email activation url

          const emailItem = _courage._.findWhere(activationSendLinks, {
            name: 'email'
          });
          emailActivationLinkUrl = emailItem ? emailItem.href : null;
        }
      }
      view.model.set({
        SMS: textActivationLinkUrl,
        EMAIL: emailActivationLinkUrl,
        sharedSecret: sharedSecret
      });
      return trans;
    });
  });
}
var _default = _FormController.default.extend({
  className: 'enroll-manual-push',
  Model: function () {
    return {
      local: {
        activationType: ['string', true, this.options.appState.get('factorActivationType') || 'SMS'],
        countryCode: ['string', false, this.options.appState.get('userCountryCode')],
        phoneNumber: 'string',
        SMS: ['string', false, this.options.appState.get('textActivationLinkUrl')],
        EMAIL: ['string', false, this.options.appState.get('emailActivationLinkUrl')],
        sharedSecret: ['string', false, this.options.appState.get('sharedSecret')],
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      },
      derived: {
        countryCallingCode: {
          deps: ['countryCode'],
          fn: function (countryCode) {
            return '+' + _CountryUtil.default.getCallingCodeForCountry(countryCode);
          }
        },
        fullPhoneNumber: {
          deps: ['countryCallingCode', 'phoneNumber'],
          fn: function (countryCallingCode, phoneNumber) {
            return countryCallingCode + phoneNumber;
          }
        }
      }
    };
  },
  Form: {
    title: function () {
      const factorName = _FactorUtil.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
      return (0, _courage.loc)('enroll.totp.title', 'login', [factorName]);
    },
    subtitle: _courage._.partial(_courage.loc, 'enroll.totp.cannotScanBarcode', 'login'),
    noButtonBar: true,
    attributes: {
      'data-se': 'step-manual-setup'
    },
    formChildren: function () {
      const instructions = this.settings.get('brandName') ? (0, _courage.loc)('enroll.totp.sharedSecretInstructions.specific', 'login', [this.settings.get('brandName')]) : (0, _courage.loc)('enroll.totp.sharedSecretInstructions.generic', 'login');
      const children = [_FormType.default.Input({
        name: 'activationType',
        label: (0, _courage.loc)('mfa.setupOptions', 'login'),
        type: 'select',
        wide: true,
        options: {
          SMS: (0, _courage.loc)('enroll.totp.sendSms', 'login'),
          EMAIL: (0, _courage.loc)('enroll.totp.sendEmail', 'login'),
          MANUAL: (0, _courage.loc)('enroll.totp.setupManually', 'login')
        }
      }), _FormType.default.Input({
        label: (0, _courage.loc)('mfa.country', 'login'),
        name: 'countryCode',
        type: 'select',
        wide: true,
        options: _CountryUtil.default.getCountries(),
        showWhen: {
          activationType: 'SMS'
        }
      }), _FormType.default.Input({
        label: (0, _courage.loc)('mfa.phoneNumber.placeholder', 'login'),
        'label-top': true,
        className: 'enroll-sms-phone',
        name: 'phoneNumber',
        input: _PhoneTextBox.default,
        type: 'text',
        showWhen: {
          activationType: 'SMS'
        }
      }), _FormType.default.View({
        View: _courage.View.extend({
          className: 'secret-key-instructions',
          attributes: {
            'data-se': 'secret-key-instructions'
          },
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function (container, depth0, helpers, partials, data) {
              var helper,
                alias1 = depth0 != null ? depth0 : container.nullContext || {},
                alias2 = container.hooks.helperMissing,
                alias3 = "function",
                alias4 = container.escapeExpression,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }
                  return undefined;
                };
              return "<section aria-live=\"assertive\"><p class=\"okta-form-subtitle o-form-explain text-align-c\">" + alias4((helper = (helper = lookupProperty(helpers, "instructions") || (depth0 != null ? lookupProperty(depth0, "instructions") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "instructions",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 89
                  },
                  "end": {
                    "line": 1,
                    "column": 105
                  }
                }
              }) : helper)) + "</p><p class=\"shared-key margin-top-10\" tabindex=0 aria-label=\"" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                  "arguments": "sharedSecretKey",
                  "bundle": "login",
                  "code": "enroll.totp.sharedSecretInstructions.aria.secretKey"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 168
                  },
                  "end": {
                    "line": 1,
                    "column": 278
                  }
                }
              })) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "sharedSecretKey") || (depth0 != null ? lookupProperty(depth0, "sharedSecretKey") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "sharedSecretKey",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 280
                  },
                  "end": {
                    "line": 1,
                    "column": 299
                  }
                }
              }) : helper)) + "</p></section>";
            },
            "useData": true
          }),
          initialize: function () {
            this.listenTo(this.model, 'change:sharedSecret', this.render);
          },
          getTemplateData: function () {
            return {
              instructions: instructions,
              sharedSecretKey: this.model.get('sharedSecret')
            };
          }
        }),
        showWhen: {
          activationType: 'MANUAL'
        }
      }), _FormType.default.View({
        View: _courage.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function (container, depth0, helpers, partials, data) {
              return "<div data-type=\"next-button-wrap\"></div>";
            },
            "useData": true
          })
        }),
        showWhen: {
          activationType: 'MANUAL'
        }
      }), _FormType.default.Button({
        title: (0, _courage.loc)('oform.next', 'login'),
        className: 'button button-primary button-wide button-next',
        attributes: {
          'data-se': 'next-button'
        },
        click: () => {
          setStateValues(this);
          goToFactorActivation(this, 'passcode');
        }
      }, '[data-type="next-button-wrap"]'), _FormType.default.Toolbar({
        noCancelButton: true,
        save: (0, _courage.loc)('oform.send', 'login'),
        showWhen: {
          activationType: function (val) {
            return val === 'SMS' || val === 'EMAIL';
          }
        }
      })];
      return children;
    }
  },
  Footer: _ManualSetupPushFooter.default,
  initialize: function () {
    this.setInitialModel();
    // Move this logic to a model when AuthClient supports sending email and sms
    this.listenTo(this.form, 'save', function () {
      const self = this;
      this.model.doTransaction(function (transaction) {
        const activationType = this.get('activationType').toLowerCase();
        const opts = {};
        if (activationType === 'sms') {
          opts.profile = {
            phoneNumber: this.get('fullPhoneNumber')
          };
        }
        return transaction.factor.activation.send(activationType, opts).then(function (trans) {
          setStateValues(self);
          // Note: Need to defer because OktaAuth calls our router success
          // handler on the next tick - if we immediately called, appState would
          // still be populated with the last response
          _courage._.defer(function () {
            goToFactorActivation(self, 'sent');
          });
          return trans;
        });
      });
    });
    this.listenTo(this.model, 'change:activationType', function (model, value) {
      this.form.clearErrors();
      if (value === 'MANUAL' && this.options.appState.get('activatedFactorType') !== 'token:software:totp') {
        enrollFactor(this, 'token:software:totp');
      } else if (this.options.appState.get('activatedFactorType') !== 'push') {
        enrollFactor(this, 'push');
      }
    });
  },
  setInitialModel: function () {
    if (this.options.appState.get('factorActivationType') === 'SMS') {
      this.model.set({
        countryCode: this.options.appState.get('userCountryCode') || 'US',
        phoneNumber: this.options.appState.get('userPhoneNumber')
      });
    }
  },
  trapAuthResponse: function () {
    if (this.options.appState.get('isMfaEnrollActivate') || this.options.appState.get('isMfaEnroll')) {
      return true;
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/ManualSetupTotpController.js":
/*!*********************************************************!*\
  !*** ./src/v1/controllers/ManualSetupTotpController.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _RouterUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/RouterUtil */ "./src/v1/util/RouterUtil.js"));
var _ManualSetupFooter = _interopRequireDefault(__webpack_require__(/*! v1/views/enroll-factors/ManualSetupFooter */ "./src/v1/views/enroll-factors/ManualSetupFooter.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'enroll-manual-totp',
  Model: function () {
    return {
      local: {
        sharedSecret: ['string', false, this.options.appState.get('sharedSecret')],
        __factorType__: ['string', false, this.options.factorType],
        __provider__: ['string', false, this.options.provider]
      }
    };
  },
  Form: {
    title: function () {
      const factorName = _FactorUtil.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
      return (0, _courage.loc)('enroll.totp.title', 'login', [factorName]);
    },
    subtitle: _courage._.partial(_courage.loc, 'enroll.totp.cannotScanBarcode', 'login'),
    noButtonBar: true,
    attributes: {
      'data-se': 'step-manual-setup'
    },
    formChildren: function () {
      const instructions = this.settings.get('brandName') ? (0, _courage.loc)('enroll.totp.manualSetupInstructions.specific', 'login', [this.settings.get('brandName')]) : (0, _courage.loc)('enroll.totp.manualSetupInstructions.generic', 'login');
      return [_FormType.default.View({
        View: _courage.View.extend({
          className: 'secret-key-instructions',
          attributes: {
            'data-se': 'secret-key-instructions'
          },
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function (container, depth0, helpers, partials, data) {
              var helper,
                alias1 = depth0 != null ? depth0 : container.nullContext || {},
                alias2 = container.hooks.helperMissing,
                alias3 = "function",
                alias4 = container.escapeExpression,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }
                  return undefined;
                };
              return "<section aria-live=\"assertive\"><p class=\"okta-form-subtitle o-form-explain text-align-c\">" + alias4((helper = (helper = lookupProperty(helpers, "instructions") || (depth0 != null ? lookupProperty(depth0, "instructions") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "instructions",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 89
                  },
                  "end": {
                    "line": 1,
                    "column": 105
                  }
                }
              }) : helper)) + "</p><p class=\"shared-key margin-top-10\" tabindex=0 aria-label=\"" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                  "arguments": "sharedSecretKey",
                  "bundle": "login",
                  "code": "enroll.totp.sharedSecretInstructions.aria.secretKey"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 168
                  },
                  "end": {
                    "line": 1,
                    "column": 278
                  }
                }
              })) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "sharedSecretKey") || (depth0 != null ? lookupProperty(depth0, "sharedSecretKey") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "sharedSecretKey",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 280
                  },
                  "end": {
                    "line": 1,
                    "column": 299
                  }
                }
              }) : helper)) + "</p></section>";
            },
            "useData": true
          }),
          initialize: function () {
            this.listenTo(this.model, 'change:sharedSecret', this.render);
          },
          getTemplateData: function () {
            return {
              instructions: instructions,
              sharedSecretKey: this.model.get('sharedSecret')
            };
          }
        })
      }), _FormType.default.Toolbar({
        noCancelButton: true,
        save: (0, _courage.loc)('oform.next', 'login')
      })];
    }
  },
  Footer: _ManualSetupFooter.default,
  initialize: function () {
    this.listenTo(this.form, 'save', function () {
      const url = _RouterUtil.default.createActivateFactorUrl(this.model.get('__provider__'), this.model.get('__factorType__'), 'activate');
      this.options.appState.trigger('navigate', url);
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/MfaVerifyController.js":
/*!***************************************************!*\
  !*** ./src/v1/controllers/MfaVerifyController.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _BaseLoginController = _interopRequireDefault(__webpack_require__(/*! v1/util/BaseLoginController */ "./src/v1/util/BaseLoginController.js"));
var _EmailMagicLinkForm = _interopRequireDefault(__webpack_require__(/*! v1/views/factor-verify/EmailMagicLinkForm */ "./src/v1/views/factor-verify/EmailMagicLinkForm.js"));
var _InlineTOTPForm = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/InlineTOTPForm */ "./src/v1/views/mfa-verify/InlineTOTPForm.js"));
var _PassCodeForm = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/PassCodeForm */ "./src/v1/views/mfa-verify/PassCodeForm.js"));
var _PasswordForm = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/PasswordForm */ "./src/v1/views/mfa-verify/PasswordForm.js"));
var _PushForm = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/PushForm */ "./src/v1/views/mfa-verify/PushForm.js"));
var _SecurityQuestionForm = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/SecurityQuestionForm */ "./src/v1/views/mfa-verify/SecurityQuestionForm.js"));
var _SendEmailAndVerifyCodeForm = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/SendEmailAndVerifyCodeForm */ "./src/v1/views/mfa-verify/SendEmailAndVerifyCodeForm.js"));
var _TOTPForm = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/TOTPForm */ "./src/v1/views/mfa-verify/TOTPForm.js"));
var _YubikeyForm = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/YubikeyForm */ "./src/v1/views/mfa-verify/YubikeyForm.js"));
var _FooterMFA = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/FooterMFA */ "./src/v1/views/shared/FooterMFA.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 21] max-statements: [2, 25] max-params: 0 */

let {
  CheckBox
} = _courage.internal.views.forms.inputs;
var _default = _BaseLoginController.default.extend({
  className: 'mfa-verify',
  initialize: function (options) {
    const factorType = options.factorType;
    let View;
    switch (factorType) {
      case 'question':
        View = _SecurityQuestionForm.default;
        break;
      case 'email':
        if (this.options.appState.get('isIdxStateToken')) {
          View = _EmailMagicLinkForm.default;
        } else {
          View = _SendEmailAndVerifyCodeForm.default;
        }
        break;
      case 'sms':
      case 'call':
        View = _PassCodeForm.default;
        break;
      case 'token':
      case 'token:software:totp':
      case 'token:hotp':
        View = _TOTPForm.default;
        break;
      case 'token:hardware':
        View = _YubikeyForm.default;
        break;
      case 'push':
        View = _PushForm.default;
        break;
      case 'password':
        View = _PasswordForm.default;
        break;
      default:
        throw new Error('Unrecognized factor type');
    }
    this.model = this.findModel(factorType, options);
    if (!this.model) {
      // TODO: recover from this more gracefully - probably to redirect
      // to default factor
      throw new Error('Unrecognized factor/provider');
    }
    this.addListeners();
    this.add(new View(this.toJSON()));

    // If Okta Verify Push and Okta Verify totp are both enabled,
    // then we show Push first, and totp is the "backup" factor,
    // which is rendered in an additional InlineTOTPForm
    if (factorType === 'push' && this.model.get('isOktaFactor')) {
      if (this.model.get('backupFactor')) {
        this.inlineTotpForm = this.add(_InlineTOTPForm.default, {
          options: {
            model: this.model.get('backupFactor')
          }
        }).last();
      }
      if (this.settings.get('features.autoPush')) {
        this.autoPushCheckBox = this.add(CheckBox, {
          options: {
            model: this.model,
            name: 'autoPush',
            placeholder: (0, _courage.loc)('autoPush', 'login'),
            label: false,
            'label-top': false,
            className: 'margin-btm-0'
          }
        }).last();
      }

      // Remember Device checkbox resides outside of the Push and TOTP forms.
      if (this.options.appState.get('allowRememberDevice')) {
        this.rememberDeviceCheckbox = this.add(CheckBox, {
          options: {
            model: this.model,
            name: 'rememberDevice',
            placeholder: this.options.appState.get('rememberDeviceLabel'),
            label: false,
            'label-top': true,
            className: 'margin-btm-0'
          }
        }).last();
      }
      // Set rememberDevice on the backup factor (totp) if available
      if (this.model.get('backupFactor')) {
        this.listenTo(this.model, 'change:rememberDevice', function (model, rememberDevice) {
          model.get('backupFactor').set('rememberDevice', rememberDevice);
        });
      }
    }
    this.listenTo(this.options.appState, 'change:isWaitingForNumberChallenge', function (state, isWaitingForNumberChallenge) {
      if (isWaitingForNumberChallenge || this.options.appState.get('lastAuthResponse').status === 'SUCCESS') {
        this.autoPushCheckBox && this.autoPushCheckBox.$el.hide();
        this.rememberDeviceCheckbox && this.rememberDeviceCheckbox.$el.hide();
        this.inlineTotpForm && this.inlineTotpForm.$el.hide();
      } else {
        this.autoPushCheckBox && this.autoPushCheckBox.$el.show();
        this.rememberDeviceCheckbox && this.rememberDeviceCheckbox.$el.show();
        this.inlineTotpForm && this.inlineTotpForm.$el.show();
      }
    });
    this.add(new _FooterMFA.default(this.toJSON()));
  },
  findModel: function (factorType, options) {
    const factors = options.appState.get('factors');
    const provider = options.provider;
    const factorIndex = options.factorIndex;
    if (!provider) {
      return factors.findWhere({
        factorType: factorType,
        isFactorTypeVerification: true
      });
    } else if (factors.hasMultipleFactorsOfSameType(factorType) && factorIndex) {
      return factors.getFactorByTypeAndIndex(factorType, factorIndex);
    } else {
      return factors.findWhere({
        provider: provider,
        factorType: factorType
      });
    }
  },
  trapAuthResponse: function () {
    if (this.options.appState.get('isMfaRequired') && this.options.appState.get('trapMfaRequiredResponse') || this.options.appState.get('isMfaChallenge')) {
      this.options.appState.set('trapMfaRequiredResponse', false);
      return true;
    }
    return false;
  },
  back: function () {
    // Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/PasswordExpiredController.js":
/*!*********************************************************!*\
  !*** ./src/v1/controllers/PasswordExpiredController.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _ValidationUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/ValidationUtil */ "./src/v1/util/ValidationUtil.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/expired-password/Footer */ "./src/v1/views/expired-password/Footer.js"));
var _PasswordRequirements = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/PasswordRequirements */ "./src/v1/views/shared/PasswordRequirements.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'password-expired',
  Model: {
    props: {
      oldPassword: ['string', true],
      newPassword: ['string', true],
      confirmPassword: ['string', true]
    },
    validate: function () {
      return _ValidationUtil.default.validatePasswordMatch(this);
    },
    save: function () {
      this.trigger('save');
      return this.doTransaction(function (transaction) {
        return transaction.changePassword({
          oldPassword: this.get('oldPassword'),
          newPassword: this.get('newPassword')
        });
      });
    }
  },
  Form: {
    save: _courage._.partial(_courage.loc, 'password.expired.submit', 'login'),
    title: function () {
      const expiringSoon = this.options.appState.get('isPwdExpiringSoon');
      const numDays = this.options.appState.get('passwordExpireDays');
      if (expiringSoon && numDays > 0) {
        return (0, _courage.loc)('password.expiring.title', 'login', [numDays]);
      } else if (expiringSoon && numDays === 0) {
        return (0, _courage.loc)('password.expiring.today', 'login');
      } else if (expiringSoon) {
        return (0, _courage.loc)('password.expiring.soon', 'login');
      } else {
        return this.settings.get('brandName') ? (0, _courage.loc)('password.expired.title.specific', 'login', [this.settings.get('brandName')]) : (0, _courage.loc)('password.expired.title.generic', 'login');
      }
    },
    subtitle: function () {
      if (this.options.appState.get('isPwdExpiringSoon')) {
        return this.settings.get('brandName') ? (0, _courage.loc)('password.expiring.subtitle.specific', 'login', [this.settings.get('brandName')]) : (0, _courage.loc)('password.expiring.subtitle.generic', 'login');
      }
      const policy = this.options.appState.get('policy');
      if (!policy || this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
        return;
      }
      return _FactorUtil.default.getPasswordComplexityDescription(policy);
    },
    parseErrorMessage: function (responseJSON) {
      const policy = this.options.appState.get('policy');
      if (!!policy && this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
        /*
          - This is a specific case where don't want to repeat the requirements again in the error message, since this
            is already shown in the description. The description as bullet-points itself should give an indication
            of the requirements.
          - We cannot check for error code this in this case, as the error code is shared between
            requirements not met message, common password message, etc. So error summary is the only differentiating
            factor. Replace the password requirements string with empty string in this case.
        */
        responseJSON = _FactorUtil.default.removeRequirementsFromError(responseJSON, policy);
      }
      return responseJSON;
    },
    formChildren: function () {
      let children = [];
      if (this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
        children.push(_FormType.default.View({
          View: new _PasswordRequirements.default({
            policy: this.options.appState.get('policy')
          })
        }));
      }
      children = children.concat([_FormType.default.Input({
        'label-top': true,
        label: (0, _courage.loc)('password.oldPassword.placeholder', 'login'),
        explain: _Util.default.createInputExplain('password.oldPassword.tooltip', 'password.oldPassword.placeholder', 'login'),
        'explain-top': true,
        name: 'oldPassword',
        input: _TextBox.default,
        type: 'password'
      }), _FormType.default.Divider(), _FormType.default.Input({
        className: 'margin-btm-5',
        'label-top': true,
        label: (0, _courage.loc)('password.newPassword.placeholder', 'login'),
        explain: _Util.default.createInputExplain('password.newPassword.tooltip', 'password.newPassword.placeholder', 'login'),
        'explain-top': true,
        name: 'newPassword',
        input: _TextBox.default,
        type: 'password'
      }), _FormType.default.Input({
        'label-top': true,
        label: (0, _courage.loc)('password.confirmPassword.placeholder', 'login'),
        explain: _Util.default.createInputExplain('password.confirmPassword.tooltip', 'password.confirmPassword.placeholder', 'login'),
        'explain-top': true,
        name: 'confirmPassword',
        input: _TextBox.default,
        type: 'password'
      })]);
      return children;
    }
  },
  Footer: _Footer.default,
  initialize: function () {
    this.listenTo(this.form, 'save', function () {
      const creds = {
        username: this.options.appState.get('userEmail'),
        password: this.model.get('newPassword')
      };
      this.settings.processCreds(creds).then(_courage._.bind(this.model.save, this.model));
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/PasswordResetController.js":
/*!*******************************************************!*\
  !*** ./src/v1/controllers/PasswordResetController.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _ValidationUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/ValidationUtil */ "./src/v1/util/ValidationUtil.js"));
var _FooterSignout = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/FooterSignout */ "./src/v1/views/shared/FooterSignout.js"));
var _PasswordRequirements = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/PasswordRequirements */ "./src/v1/views/shared/PasswordRequirements.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

let {
  CheckBox
} = _courage.internal.views.forms.inputs;
var _default = _FormController.default.extend({
  className: 'password-reset',
  Model: {
    props: {
      newPassword: ['string', true],
      confirmPassword: ['string', true],
      revokeSessions: ['boolean', false]
    },
    validate: function () {
      return _ValidationUtil.default.validatePasswordMatch(this);
    },
    save: function () {
      this.trigger('save');
      const self = this;
      return this.doTransaction(function (transaction) {
        const payload = {
          newPassword: self.get('newPassword')
        };
        if (self.settings.get('features.showSessionRevocation')) {
          payload.revokeSessions = self.get('revokeSessions');
        }
        return transaction.resetPassword(payload);
      });
    }
  },
  Form: {
    save: _courage._.partial(_courage.loc, 'password.reset', 'login'),
    title: function () {
      return this.settings.get('brandName') ? (0, _courage.loc)('password.reset.title.specific', 'login', [this.settings.get('brandName')]) : (0, _courage.loc)('password.reset.title.generic', 'login');
    },
    subtitle: function () {
      const policy = this.options.appState.get('policy');
      if (!policy || this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
        return;
      }
      return _FactorUtil.default.getPasswordComplexityDescription(policy);
    },
    parseErrorMessage: function (responseJSON) {
      const policy = this.options.appState.get('policy');
      if (!!policy && this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
        /*
          - This is a specific case where don't want to repeat the requirements again in the error message, since this
            is already shown in the description. The description as bullet-points itself should give an indication
            of the requirements.
          - We cannot check for error code this in this case, as the error code is shared between
            requirements not met message, common password message, etc. So error summary is the only differentiating
            factor. Replace the password requirements string with empty string in this case.
        */
        responseJSON = _FactorUtil.default.removeRequirementsFromError(responseJSON, policy);
      }
      return responseJSON;
    },
    formChildren: function () {
      let children = [];
      if (this.settings.get('features.showPasswordRequirementsAsHtmlList')) {
        children.push(_FormType.default.View({
          View: new _PasswordRequirements.default({
            policy: this.options.appState.get('policy')
          })
        }));
      }
      children = children.concat([_FormType.default.Input({
        className: 'margin-btm-5',
        label: (0, _courage.loc)('password.newPassword.placeholder', 'login'),
        'label-top': true,
        explain: _Util.default.createInputExplain('password.newPassword.tooltip', 'password.newPassword.placeholder', 'login'),
        'explain-top': true,
        name: 'newPassword',
        input: _TextBox.default,
        type: 'password',
        autoComplete: _Util.default.getAutocompleteValue(this.settings, 'new-password')
      }), _FormType.default.Input({
        label: (0, _courage.loc)('password.confirmPassword.placeholder', 'login'),
        'label-top': true,
        explain: _Util.default.createInputExplain('password.confirmPassword.tooltip', 'password.confirmPassword.placeholder', 'login'),
        'explain-top': true,
        name: 'confirmPassword',
        input: _TextBox.default,
        type: 'password',
        autoComplete: _Util.default.getAutocompleteValue(this.settings, 'new-password')
      })]);
      if (this.settings.get('features.showSessionRevocation')) {
        children = children.concat([_FormType.default.Input({
          placeholder: (0, _courage.loc)('password.reset.revokeSessions', 'login'),
          name: 'revokeSessions',
          input: CheckBox,
          type: 'checkbox'
        })]);
      }
      return children;
    }
  },
  initialize: function () {
    this.listenTo(this.form, 'save', function () {
      const creds = {
        username: this.options.appState.get('userEmail'),
        password: this.model.get('newPassword')
      };
      this.settings.processCreds(creds).then(_courage._.bind(this.model.save, this.model));
    });
    if (!this.settings.get('features.hideBackToSignInForReset')) {
      this.addFooter(_FooterSignout.default);
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/PollController.js":
/*!**********************************************!*\
  !*** ./src/v1/controllers/PollController.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'poll',
  Model: {
    save: function () {
      this.trigger('cancelRequest');
      return this.appState.get('transaction').cancel().then(() => {
        this.options.appState.trigger('navigate', '');
      }).catch(() => {
        this._stopCountDown();
      });
    }
  },
  Form: {
    autoSave: true,
    hasSavingState: false,
    title: function () {
      return this.title;
    },
    className: 'poll-controller',
    noCancelButton: true,
    save: (0, _courage.loc)('oform.cancel', 'login'),
    modelEvents: {
      cancelRequest: '_stopCountDown'
    },
    formChildren: [_FormType.default.View({
      View: '<div >\
               <div data-se="poll-waiting" class="hide okta-waiting-spinner"></div>\
             </div>'
    })],
    _checkStatus: function () {
      // start polling request
      this.transactionObject.poll().then(resp => {
        if (resp.data && resp.status !== 'POLL') {
          this.options.appState.set('transaction', resp);
          return;
        }
        this.$('.okta-waiting-spinner').hide();
        let factorPollingIntervalSeconds = Math.ceil(resp.transaction.profile.refresh / 1000);
        this._startCountDown(factorPollingIntervalSeconds);
      }).catch(() => {
        this._stopCountDown();
      });
    },
    _startCountDown: function (factorPollingIntervalSeconds) {
      // start one second countdown for next poll request
      this.countDown = setInterval(() => {
        // update title after every second and check if countdown == 1 to poll again
        this._updateTitle(factorPollingIntervalSeconds);
        if (factorPollingIntervalSeconds === 0) {
          /* when countdown hits 0
                       - stop current poll
                       - show spinner
                       - check status
                      */
          this._stopCountDown();
          this.$('.okta-waiting-spinner').show();
          // start after a small delay so that the spinner does not get hidden too soon
          this.checkStatusTimeout = setTimeout(() => {
            this._checkStatus();
          }, 200);
        } else {
          // reduce countdown after every second
          factorPollingIntervalSeconds = factorPollingIntervalSeconds - 1;
        }
      }, 1000);
    },
    _updateTitle: function (factorPollingIntervalSeconds) {
      this.title = (0, _courage.loc)('polling.title', 'login', [factorPollingIntervalSeconds]);
      this.$el.find('.okta-form-title').text(this.title);
    },
    _stopCountDown: function () {
      // clear countdown setInterval
      if (this.countDown) {
        clearInterval(this.countDown);
      }
      // clear checkstatus setTimeout
      if (this.checkStatusTimeout) {
        clearInterval(this.checkStatusTimeout);
      }
    },
    initialize: function (options) {
      this.transactionObject = options.appState.get('transaction');
      this.factorPollingIntervalSeconds = Math.ceil(this.transactionObject.transaction.profile.refresh / 1000);
      this._updateTitle(this.factorPollingIntervalSeconds);
      this._startCountDown(this.factorPollingIntervalSeconds);
    }
  },
  back: function () {
    // Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
  },
  remove: function () {
    this.form._stopCountDown();
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/PrimaryAuthController.js":
/*!*****************************************************!*\
  !*** ./src/v1/controllers/PrimaryAuthController.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _PrimaryAuth = _interopRequireDefault(__webpack_require__(/*! v1/models/PrimaryAuth */ "./src/v1/models/PrimaryAuth.js"));
var _BaseLoginController = _interopRequireDefault(__webpack_require__(/*! v1/util/BaseLoginController */ "./src/v1/util/BaseLoginController.js"));
var _DeviceFingerprint = _interopRequireDefault(__webpack_require__(/*! v1/util/DeviceFingerprint */ "./src/v1/util/DeviceFingerprint.js"));
var _CustomButtons = _interopRequireDefault(__webpack_require__(/*! v1/views/primary-auth/CustomButtons */ "./src/v1/views/primary-auth/CustomButtons.js"));
var _PrimaryAuthForm = _interopRequireDefault(__webpack_require__(/*! v1/views/primary-auth/PrimaryAuthForm */ "./src/v1/views/primary-auth/PrimaryAuthForm.js"));
var _Footer = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/Footer */ "./src/v1/views/shared/Footer.js"));
var _FooterRegistration = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/FooterRegistration */ "./src/v1/views/shared/FooterRegistration.js"));
var _FooterWithBackLink = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/FooterWithBackLink */ "./src/v1/views/shared/FooterWithBackLink.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _BaseLoginController.default.extend({
  className: 'primary-auth',
  state: {
    enabled: true
  },
  View: _PrimaryAuthForm.default,
  constructor: function (options) {
    options.appState.unset('username');
    this.model = new _PrimaryAuth.default({
      multiOptionalFactorEnroll: options.settings.get('features.multiOptionalFactorEnroll'),
      settings: options.settings,
      appState: options.appState
    }, {
      parse: true
    });
    _BaseLoginController.default.apply(this, arguments);
    this.addListeners();

    // If social auth is configured, 'socialAuthPositionTop' will determine
    // the order in which the social auth and primary auth are shown on the screen.
    if (options.settings.get('hasConfiguredButtons')) {
      this.add(_CustomButtons.default, {
        prepend: options.settings.get('socialAuthPositionTop'),
        options: {
          // To trigger an afterError event, we require the current controller
          currentController: this
        }
      });
    }
    this.addFooter(options);
    if (this.options.appState.get('disableUsername')) {
      this.addFooterWithBackLink(this.options);
    }
    this.setUsername();
  },
  addFooter: function (options) {
    this.add(new _Footer.default(this.toJSON({
      appState: options.appState
    })));
    if (options.settings.get('features.registration') || options.appState.get('isIdxStateToken')) {
      this.add(new _FooterRegistration.default({
        settings: this.settings,
        appState: options.appState
      }));
    }
  },
  addFooterWithBackLink: function (options) {
    if (!this.$el.find('.footer-back-link').length) {
      this.add(new _FooterWithBackLink.default(this.toJSON({
        appState: options.appState,
        className: 'auth-footer footer-back-link'
      })));
    }
  },
  setUsername: function () {
    const username = this.model.get('username');
    if (username) {
      this.options.appState.set('username', username);
    }
  },
  setUsernameFromIdpDiscovery: function () {
    const username = this.options.username;
    if (username) {
      this.model.set('username', username);
      this.options.appState.set('disableUsername', true);
    }
  },
  events: {
    'focusout input[name=username]': function () {
      if (this.shouldComputeDeviceFingerprint() && this.model.get('username')) {
        const self = this;
        this.options.appState.trigger('loading', true);
        _DeviceFingerprint.default.generateDeviceFingerprint(this.settings.get('baseUrl'), this.$el).then(function (fingerprint) {
          self.options.appState.set('deviceFingerprint', fingerprint);
          self.options.appState.set('username', self.model.get('username'));
        }).catch(function () {
          // Keep going even if device fingerprint fails
          self.options.appState.set('username', self.model.get('username'));
        }).finally(function () {
          self.options.appState.trigger('loading', false);
        });
      } else {
        this.options.appState.set('username', this.model.get('username'));
      }
    },
    'focusin input': function (e) {
      (0, _courage.$)(e.target.parentElement).addClass('focused-input');
    },
    'focusout input': function (e) {
      (0, _courage.$)(e.target.parentElement).removeClass('focused-input');
    }
  },
  // This model and the AppState both have a username property.
  // The controller updates the AppState's username when the user is
  // done editing (on blur) or deletes the username (see below).
  initialize: function () {
    this.options.appState.unset('deviceFingerprint');
    if (this.settings.get('features.prefillUsernameFromIdpDiscovery')) {
      this.setUsernameFromIdpDiscovery();
    }
    this.listenTo(this.model, 'change:username', function (model, value) {
      if (!value) {
        // reset AppState to an undefined user.
        this.options.appState.set('username', '');
      }
    });
    this.listenTo(this.model, 'save', function () {
      this.state.set('enabled', false);
    });
    this.listenTo(this.model, 'error', function () {
      this.state.set('enabled', true);
      if (this.options.appState.get('disableUsername')) {
        this.state.set('disableUsername', true);
        this.addFooterWithBackLink(this.options);
      }
    });
    this.listenTo(this.state, 'togglePrimaryAuthButton', function (buttonState) {
      this.toggleButtonState(buttonState);
    });
  },
  shouldComputeDeviceFingerprint: function () {
    return this.settings.get('features.securityImage') && this.settings.get('features.deviceFingerprinting') && this.settings.get('features.useDeviceFingerprintForSecurityImage');
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/PwdResetEmailSentController.js":
/*!***********************************************************!*\
  !*** ./src/v1/controllers/PwdResetEmailSentController.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'password-reset-email-sent',
  Model: function () {
    return {
      local: {
        userFullName: ['string', false, this.options.appState.get('userFullName')]
      }
    };
  },
  Form: {
    title: _courage._.partial(_courage.loc, 'password.forgot.emailSent.title', 'login'),
    subtitle: function () {
      const username = this.options.appState.get('username');
      return (0, _courage.loc)('password.forgot.emailSent.desc', 'login', [username]);
    },
    noButtonBar: true,
    attributes: {
      'data-se': 'pwd-reset-email-sent'
    },
    formChildren: function () {
      let children = [_FormType.default.View({
        View: _courage.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function (container, depth0, helpers, partials, data) {
              var helper,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }
                  return undefined;
                };
              return "<span class=\"accessibility-text\" role=\"status\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "alert") || (depth0 != null ? lookupProperty(depth0, "alert") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "alert",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 47
                  },
                  "end": {
                    "line": 1,
                    "column": 56
                  }
                }
              }) : helper)) + "</span>";
            },
            "useData": true
          }),
          getTemplateData: function () {
            return {
              alert: (0, _courage.loc)('password.forgot.emailSent.title', 'login')
            };
          }
        })
      })];
      if (!this.settings.get('features.hideBackToSignInForReset')) {
        children.push(_FormType.default.Button({
          title: (0, _courage.loc)('goback', 'login'),
          className: 'button button-primary button-wide',
          attributes: {
            'data-se': 'back-button'
          },
          click: function () {
            const self = this;
            return this.model.doTransaction(function (transaction) {
              return transaction.cancel();
            }).then(function () {
              self.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
              self.options.appState.trigger('navigate', '');
            });
          }
        }));
      }
      return children;
    }
  },
  initialize: function (options) {
    this.settings.callGlobalSuccess(_Enums.default.FORGOT_PASSWORD_EMAIL_SENT, {
      username: options.appState.get('username')
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/RecoveryChallengeController.js":
/*!***********************************************************!*\
  !*** ./src/v1/controllers/RecoveryChallengeController.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _FooterSignout = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/FooterSignout */ "./src/v1/views/shared/FooterSignout.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'recovery-challenge',
  Model: {
    props: {
      passCode: ['string', true]
    },
    local: {
      ableToResend: 'boolean'
    },
    resendCode: function () {
      // Note: This does not require a trapAuthResponse because Backbone's
      // router will not navigate if the url path is the same
      this.limitResending();
      return this.doTransaction(function (transaction) {
        return transaction.resend();
      });
    },
    limitResending: function () {
      this.set({
        ableToResend: false
      });
      _courage._.delay(_courage._.bind(this.set, this), _Enums.default.API_RATE_LIMIT, {
        ableToResend: true
      });
    },
    save: function () {
      return this.doTransaction(function (transaction) {
        return transaction.verify({
          passCode: this.get('passCode')
        });
      });
    }
  },
  Form: {
    autoSave: true,
    save: _courage._.partial(_courage.loc, 'mfa.challenge.verify', 'login'),
    title: function () {
      if (this.options.appState.get('factorType') === _Enums.default.RECOVERY_FACTOR_TYPE_CALL) {
        return (0, _courage.loc)('recoveryChallenge.call.title', 'login');
      } else {
        return (0, _courage.loc)('recoveryChallenge.sms.title', 'login');
      }
    },
    className: 'recovery-challenge',
    initialize: function () {
      this.listenTo(this.model, 'error', function () {
        this.clearErrors();
      });
    },
    formChildren: function () {
      return [_FormType.default.Button({
        title: (0, _courage.loc)('mfa.resendCode', 'login'),
        attributes: {
          'data-se': 'resend-button'
        },
        className: 'button sms-request-button margin-top-30',
        click: function () {
          this.model.resendCode();
        },
        initialize: function () {
          this.listenTo(this.model, 'change:ableToResend', function (model, ableToResend) {
            if (ableToResend) {
              this.options.title = (0, _courage.loc)('mfa.resendCode', 'login');
              this.enable();
              this.render();
            } else {
              this.options.title = (0, _courage.loc)('mfa.sent', 'login');
              this.disable();
              this.render();
            }
          });
        }
      }), _FormType.default.Input({
        label: (0, _courage.loc)('mfa.challenge.enterCode.placeholder', 'login'),
        'label-top': true,
        className: 'enroll-sms-phone',
        name: 'passCode',
        input: _TextBox.default,
        type: 'text'
      })];
    }
  },
  events: {
    'click .send-email-link': function (e) {
      e.preventDefault();
      const settings = this.model.settings;
      const username = this.options.appState.get('username');
      const recoveryType = this.options.appState.get('recoveryType');
      this.model.startTransaction(function (authClient) {
        // The user could have landed here via the Forgot Password/Unlock Account flow
        switch (recoveryType) {
          case _Enums.default.RECOVERY_TYPE_PASSWORD:
            return authClient.forgotPassword({
              username: settings.transformUsername(username, _Enums.default.FORGOT_PASSWORD),
              factorType: _Enums.default.RECOVERY_FACTOR_TYPE_EMAIL
            });
          case _Enums.default.RECOVERY_TYPE_UNLOCK:
            return authClient.unlockAccount({
              username: settings.transformUsername(username, _Enums.default.UNLOCK_ACCOUNT),
              factorType: _Enums.default.RECOVERY_FACTOR_TYPE_EMAIL
            });
          default:
            return;
        }
      }).catch(() => {});
    }
  },
  initialize: function () {
    const recoveryType = this.options.appState.get('recoveryType');
    let sendEmailLink;
    switch (recoveryType) {
      case _Enums.default.RECOVERY_TYPE_PASSWORD:
        sendEmailLink = _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "password.forgot.code.notReceived"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 63
                }
              }
            }));
          },
          "useData": true
        });
        break;
      case _Enums.default.RECOVERY_TYPE_UNLOCK:
        sendEmailLink = _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "account.unlock.code.notReceived"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 62
                }
              }
            }));
          },
          "useData": true
        });
        break;
      default:
        break;
    }
    if (sendEmailLink && this.settings.get('features.emailRecovery')) {
      this.add(_courage.View.extend({
        className: 'link send-email-link',
        tagName: 'a',
        attributes: {
          href: '#',
          'data-se': 'send-email-link'
        },
        template: sendEmailLink
      }));
    }
    if (!this.settings.get('features.hideBackToSignInForReset')) {
      this.addFooter(_FooterSignout.default);
    }
  },
  postRender: function () {
    this.model.limitResending();
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/RecoveryLoadingController.js":
/*!*********************************************************!*\
  !*** ./src/v1/controllers/RecoveryLoadingController.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'recovery-loading',
  Model: {},
  Form: {
    noButtonBar: true
  },
  initialize: function (options) {
    const self = this;
    return this.model.startTransaction(function (authClient) {
      return authClient.verifyRecoveryToken({
        recoveryToken: options.token
      });
    }).catch(function () {
      self.options.appState.trigger('loading', false);
      self.options.appState.trigger('removeLoading');
    });
  },
  preRender: function () {
    this.options.appState.trigger('loading', true);
  },
  trapAuthResponse: function () {
    this.options.appState.trigger('loading', false);
    return false;
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/RecoveryQuestionController.js":
/*!**********************************************************!*\
  !*** ./src/v1/controllers/RecoveryQuestionController.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _FooterSignout = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/FooterSignout */ "./src/v1/views/shared/FooterSignout.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'recovery-question',
  Model: {
    props: {
      answer: ['string', true],
      showAnswer: 'boolean'
    },
    save: function () {
      return this.doTransaction(function (transaction) {
        return transaction.answer({
          answer: this.get('answer')
        });
      });
    }
  },
  Form: {
    autoSave: true,
    save: function () {
      switch (this.options.appState.get('recoveryType')) {
        case 'PASSWORD':
          return (0, _courage.loc)('password.forgot.question.submit', 'login');
        case 'UNLOCK':
          return (0, _courage.loc)('account.unlock.question.submit', 'login');
        default:
          return (0, _courage.loc)('mfa.challenge.verify', 'login');
      }
    },
    title: function () {
      switch (this.options.appState.get('recoveryType')) {
        case 'PASSWORD':
          return (0, _courage.loc)('password.forgot.question.title', 'login');
        case 'UNLOCK':
          return (0, _courage.loc)('account.unlock.question.title', 'login');
        default:
          return '';
      }
    },
    formChildren: function () {
      return [_FormType.default.Input({
        label: this.options.appState.get('recoveryQuestion'),
        placeholder: (0, _courage.loc)('mfa.challenge.answer.placeholder', 'login'),
        name: 'answer',
        input: _TextBox.default,
        type: 'password',
        initialize: function () {
          this.listenTo(this.model, 'change:showAnswer', function () {
            const type = this.model.get('showAnswer') ? 'text' : 'password';
            this.getInputs()[0].changeType(type);
          });
        }
      }), _FormType.default.Input({
        label: false,
        'label-top': true,
        placeholder: (0, _courage.loc)('mfa.challenge.answer.showAnswer', 'login'),
        className: 'recovery-question-show margin-btm-0',
        name: 'showAnswer',
        type: 'checkbox'
      })];
    }
  },
  initialize: function () {
    if (!this.settings.get('features.hideBackToSignInForReset')) {
      this.addFooter(_FooterSignout.default);
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/RefreshAuthStateController.js":
/*!**********************************************************!*\
  !*** ./src/v1/controllers/RefreshAuthStateController.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint-disable max-depth */
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'refresh-auth-state',
  Model: {},
  Form: {
    noButtonBar: true
  },
  preRender: function () {
    const appState = this.options.appState;
    const token = this.options.token;
    this.model.startTransaction(function (authClient) {
      appState.trigger('loading', true);
      if (token) {
        return authClient.tx.introspect({
          stateToken: token
        });
      }

      // get stateToken from cookie
      // currently only applies to old pipeline
      if (authClient.tx.exists()) {
        return authClient.tx.resume();
      }
      appState.trigger('navigate', '');
    });
  },
  remove: function () {
    this.options.appState.trigger('loading', false);
    return _FormController.default.prototype.remove.apply(this, arguments);
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/RegistrationCompleteController.js":
/*!**************************************************************!*\
  !*** ./src/v1/controllers/RegistrationCompleteController.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  events: {
    'click .back-btn': function (e) {
      e.preventDefault();
      this.back();
    }
  },
  back: function () {
    this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
    this.options.appState.trigger('navigate', '');
  },
  className: 'registration-complete',
  Model: function () {},
  initialize: function () {
    this.settings.callGlobalSuccess(_Enums.default.ACTIVATION_EMAIL_SENT, {
      username: this.options.appState.get('username')
    });
  },
  Form: {
    noButtonBar: true,
    formChildren: function () {
      return [_FormType.default.View({
        View: _courage.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function (container, depth0, helpers, partials, data) {
              var helper,
                alias1 = depth0 != null ? depth0 : container.nullContext || {},
                alias2 = container.hooks.helperMissing,
                alias3 = "function",
                alias4 = container.escapeExpression,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }
                  return undefined;
                };
              return "<div class=\"container\"><span class=\"title-icon icon icon-16 confirm-16-green\"></span><h2 class=\"title\">" + alias4((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "title",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 103
                  },
                  "end": {
                    "line": 1,
                    "column": 112
                  }
                }
              }) : helper)) + "</h2><div class=\"desc\">" + alias4((helper = (helper = lookupProperty(helpers, "desc") || (depth0 != null ? lookupProperty(depth0, "desc") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "desc",
                "hash": {},
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 135
                  },
                  "end": {
                    "line": 1,
                    "column": 143
                  }
                }
              }) : helper)) + "</div></div><a href=\"#\" class=\"back-btn\" data-se=\"back-link\">" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                  "bundle": "login",
                  "code": "goback"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 204
                  },
                  "end": {
                    "line": 1,
                    "column": 241
                  }
                }
              })) + "</a>";
            },
            "useData": true
          }),
          getTemplateData: function () {
            return {
              desc: (0, _courage.loc)('registration.complete.confirm.text', 'login'),
              title: (0, _courage.loc)('registration.complete.title', 'login')
            };
          }
        })
      })];
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/RegistrationController.js":
/*!******************************************************!*\
  !*** ./src/v1/controllers/RegistrationController.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _LoginModel = _interopRequireDefault(__webpack_require__(/*! v1/models/LoginModel */ "./src/v1/models/LoginModel.js"));
var _RegistrationSchema = _interopRequireDefault(__webpack_require__(/*! v1/models/RegistrationSchema */ "./src/v1/models/RegistrationSchema.js"));
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
var _BaseLoginController = _interopRequireDefault(__webpack_require__(/*! v1/util/BaseLoginController */ "./src/v1/util/BaseLoginController.js"));
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _RegistrationFormFactory = _interopRequireDefault(__webpack_require__(/*! v1/util/RegistrationFormFactory */ "./src/v1/util/RegistrationFormFactory.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _SubSchema = _interopRequireDefault(__webpack_require__(/*! v1/views/registration/SubSchema */ "./src/v1/views/registration/SubSchema.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const RegistrationControllerFooter = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<a href=\"#\" class=\"link help\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "goback"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 50
          },
          "end": {
            "line": 1,
            "column": 87
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .help': function (e) {
      e.preventDefault();
      this.back();
    }
  },
  back: function () {
    this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
    this.options.appState.trigger('navigate', '');
  }
});
var _default = _BaseLoginController.default.extend({
  className: 'registration',
  initialize: function () {
    const RegistrationControllerSchema = _RegistrationSchema.default.extend({
      settings: this.options.settings,
      url: this.options.settings.get('baseUrl') + '/api/v1/registration/form'
    });
    // setup schema

    const schema = new RegistrationControllerSchema();
    this.state.set('schema', schema);
  },
  getRegistrationApiUrl: function () {
    const defaultPolicyId = this.settings.get('defaultPolicyId');
    // default policyId

    const orgPolicyId = this.options.settings.get('policyId');
    // org policyId

    const apiUrl = defaultPolicyId ? this.getRegistrationPolicyApi(defaultPolicyId) : this.getRegistrationPolicyApi(orgPolicyId);
    return apiUrl;
  },
  getRegistrationPolicyApi: function (policyId) {
    return this.options.settings.get('baseUrl') + '/api/v1/registration/' + policyId;
  },
  doPostSubmit: function () {
    if (this.model.get('activationToken')) {
      const self = this;
      // register via activation token

      self.settings.callGlobalSuccess(_Enums.default.REGISTRATION_COMPLETE, {
        activationToken: this.model.get('activationToken')
      });
      const loginModel = new _LoginModel.default({
        settings: self.model.appState.settings
      });
      loginModel.loginWithActivationToken(this.model.get('activationToken')).then(function (transaction) {
        self.model.trigger('setTransaction', transaction);
      });
    } else {
      // register via activation email
      this.model.appState.set('username', this.model.get('email'));
      this.model.appState.trigger('navigate', 'signin/register-complete');
    }
  },
  registerUser: function (postData) {
    const self = this;
    Object.keys(postData).forEach(k => (_courage._.isNull(postData[k]) || _courage._.isUndefined(postData[k]) || postData[k] === '') && delete postData[k]);
    this.model.attributes = postData;
    // Model.save returns a jqXHR
    _courage.Backbone.Model.prototype.save.call(this.model).then(function () {
      self.model.trigger('startSaving');
      const activationToken = self.model.get('activationToken');
      const postSubmitData = activationToken ? activationToken : self.model.get('email');
      self.settings.postRegistrationSubmit(postSubmitData, function () {
        self.doPostSubmit();
      }, function (errors) {
        self.showErrors(errors);
      });
    }).fail(err => {
      const responseJSON = err.responseJSON;
      if (responseJSON && responseJSON.errorCauses.length) {
        const {
          errorCode,
          errorCauses
        } = responseJSON;
        const {
          errorSummary,
          reason,
          location
        } = errorCauses[0];
        const isNotUniqueValue = errorCode === 'E0000001' && reason === 'UNIQUE_CONSTRAINT';
        if (isNotUniqueValue) {
          this.renderIsNotUniqueError(responseJSON);
        }
        this.renderLegacyLocationErrorIfNeeded(location, errorSummary);
        _Util.default.triggerAfterError(this, new _Errors.RegistrationError(errorSummary));
      }
    });
  },
  renderIsNotUniqueError: function (error) {
    const {
      location
    } = error.errorCauses[0];
    const errorSummary = (0, _courage.loc)('registration.error.userName.notUniqueWithinOrg', 'login', [location]);
    // replace generic error message with more specific one
    // without using backbone events because there was a race condition
    // between clearing and triggering errors
    this.$el.find('.okta-form-infobox-error p').text(errorSummary);
  },
  renderLegacyLocationErrorIfNeeded: function (location, errorSummary) {
    // replace generic error message with errorSummary for v1 SIW
    // this makes sure that with legacy location that starts with `data.userProfile`
    // we still see the errorSummary in the error banner instead of only a generic error
    // See example in https://developer.okta.com/docs/reference/registration-hook/#sample-json-payload-of-request
    if (location && /^data\.userProfile.*/.test(location)) {
      this.$el.find('.okta-form-infobox-error p').text(errorSummary);
    }
  },
  createRegistrationModel: function (modelProperties) {
    const self = this;
    const RegistrationControllerModel = _courage.Model.extend({
      url: self.getRegistrationApiUrl() + '/register',
      settings: this.settings,
      appState: this.options.appState,
      props: modelProperties,
      local: {
        activationToken: 'string'
      },
      toJSON: function () {
        const data = _courage.Model.prototype.toJSON.apply(this, arguments);
        return {
          userProfile: data,
          relayState: this.settings.get('relayState')
        };
      },
      parse: function (resp) {
        this.set('activationToken', resp.activationToken);
        delete resp.activationToken;
        return resp;
      },
      save: function () {
        this.settings.preRegistrationSubmit(this.attributes, function (postData) {
          self.registerUser(postData);
        }, function (errors) {
          self.showErrors(errors);
        });
      }
    });
    return new RegistrationControllerModel();
  },
  showErrors: function (error, hideRegisterButton) {
    //for parseSchema error hide form and show error at form level
    if (error.callback === 'parseRegistrationSchema' && error.errorCauses) {
      error.errorSummary = _courage._.clone(error.errorCauses[0].errorSummary);
      delete error.errorCauses;
    }
    //show error on form
    this.model.trigger('error', this.model, {
      responseJSON: error
    });

    //throw registration error
    const errMsg = error.callback ? error.callback + ':' + error.errorSummary : error.errorSummary;
    _Util.default.triggerAfterError(this, new _Errors.RegistrationError(errMsg));
    if (hideRegisterButton) {
      this.$el.find('.button-primary').hide();
    }
  },
  fetchInitialData: function () {
    const self = this;

    // register parse complete event listener
    self.state.get('schema').on('parseComplete', function (updatedSchema) {
      const modelProperties = updatedSchema.properties.createModelProperties();
      self.settings.set('defaultPolicyId', updatedSchema.properties.defaultPolicyId);

      // create model
      self.model = self.createRegistrationModel(modelProperties);
      // create form
      const RegistrationControllerForm = _courage.Form.extend({
        layout: 'o-form-theme',
        autoSave: true,
        noCancelButton: true,
        title: (0, _courage.loc)('registration.form.title', 'login'),
        save: (0, _courage.loc)('registration.form.submit', 'login'),
        modelEvents: {
          'invalid': 'modifyErrors'
        },
        hasSavingState: true,
        customSavingState: {
          start: 'startSaving',
          stop: 'stopSaving'
        },
        modifyErrors: function (model, errorResp) {
          // overwrite courage errorResp object to show custom error message
          for (let formFieldName in errorResp) {
            if (errorResp[formFieldName] === 'model.validation.field.string.minLength') {
              errorResp[formFieldName] = (0, _courage.loc)('registration.model.validation.field.string.too.short', 'login', [model.props[formFieldName].minLength]);
            } else if (errorResp[formFieldName] === 'model.validation.field.string.maxLength') {
              errorResp[formFieldName] = (0, _courage.loc)('registration.model.validation.field.string.too.long', 'login', [model.props[formFieldName].maxLength + 1]);
            }
          }
        }
      });
      const form = new RegistrationControllerForm(self.toJSON());

      // add form
      self.add(form);
      // add footer
      self.footer = new self.Footer(self.toJSON());
      self.add(self.footer);
      self.addListeners();
      if (updatedSchema.error) {
        self.showErrors(updatedSchema.error, true);
      } else {
        // add fields
        updatedSchema.properties.each(function (schemaProperty) {
          const inputOptions = _RegistrationFormFactory.default.createInputOptions(schemaProperty);
          const subSchemas = schemaProperty.get('subSchemas');
          const name = schemaProperty.get('name');
          form.addInput(inputOptions);
          if (name === 'password' && subSchemas) {
            form.add(_SubSchema.default.extend({
              id: 'subschemas-' + name,
              subSchemas: subSchemas
            }));
          }
        });
        const requiredFieldsLabel = _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var helper,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }
                return undefined;
              };
            return "<span class=\"required-fields-label\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "label",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 36
                },
                "end": {
                  "line": 1,
                  "column": 45
                }
              }
            }) : helper)) + "</span>";
          },
          "useData": true
        })({
          label: (0, _courage.loc)('registration.required.fields.label', 'login')
        });
        form.add(requiredFieldsLabel);
      }
    });
    // fetch schema from API, returns a jqXHR. Wrap it in a Q
    return (0, _q.default)(this.state.get('schema').fetch());
  },
  Footer: RegistrationControllerFooter
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/UnlockAccountController.js":
/*!*******************************************************!*\
  !*** ./src/v1/controllers/UnlockAccountController.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _ValidationUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/ValidationUtil */ "./src/v1/util/ValidationUtil.js"));
var _ContactSupport = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/ContactSupport */ "./src/v1/views/shared/ContactSupport.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const UnlockAccountControllernoFactorsError = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<div class=\"okta-form-infobox-error infobox infobox-error\" role=\"alert\"><span class=\"icon error-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "account.unlock.noFactorsEnabled"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 110
          },
          "end": {
            "line": 1,
            "column": 172
          }
        }
      })) + "</p></div>";
    },
    "useData": true
  })
});
const UnlockAccountControllerFooter = _courage.View.extend({
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<a href=\"#\" class=\"link goto js-contact-support\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "mfa.noAccessToEmail"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 173
          },
          "end": {
            "line": 1,
            "column": 223
          }
        }
      })) + "</a>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "goback"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 95
          }
        }
      })) + "</a>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "helpSupportNumber") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 99
          },
          "end": {
            "line": 1,
            "column": 234
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .js-back': function (e) {
      e.preventDefault();
      this.back();
    },
    'click .js-contact-support': function (e) {
      e.preventDefault();
      this.state.trigger('contactSupport');
      this.$('.js-contact-support').hide();
    }
  },
  getTemplateData: function () {
    return this.settings.pick('helpSupportNumber');
  },
  back: function () {
    this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
    this.options.appState.trigger('navigate', '');
  }
});
var _default = _FormController.default.extend({
  className: 'account-unlock',
  Model: {
    props: {
      username: ['string', true],
      factorType: ['string', true]
    },
    validate: function () {
      return _ValidationUtil.default.validateUsername(this);
    },
    save: function () {
      const self = this;
      return this.startTransaction(function (authClient) {
        return authClient.unlockAccount({
          username: self.settings.transformUsername(self.get('username'), _Enums.default.UNLOCK_ACCOUNT),
          factorType: self.get('factorType')
        });
      }).catch(function () {
        //need empty fail handler on model to display errors on form
      });
    }
  },
  Form: {
    noButtonBar: true,
    title: _courage._.partial(_courage.loc, 'account.unlock.title', 'login'),
    formChildren: function () {
      const smsEnabled = this.settings.get('features.smsRecovery');
      /*eslint complexity: [2, 9] max-statements: [2, 24] */

      const callEnabled = this.settings.get('features.callRecovery');
      const emailEnabled = this.settings.get('features.emailRecovery');
      const noFactorsEnabled = !(smsEnabled || callEnabled || emailEnabled);
      const formChildren = [];
      const form = this;
      if (noFactorsEnabled) {
        this.add(UnlockAccountControllernoFactorsError, '.o-form-error-container');
      } else {
        formChildren.push(_FormType.default.Input({
          label: (0, _courage.loc)('account.unlock.email.or.username.placeholder', 'login'),
          'label-top': true,
          explain: _Util.default.createInputExplain('account.unlock.email.or.username.tooltip', 'account.unlock.email.or.username.placeholder', 'login'),
          'explain-top': true,
          name: 'username',
          input: _TextBox.default,
          inputId: 'account-recovery-username',
          type: 'text',
          inlineValidation: false
        }));
        if (smsEnabled || callEnabled) {
          formChildren.push(_FormType.default.View({
            View: _courage.View.extend({
              template: _runtime.default.template({
                "compiler": [8, ">= 4.3.0"],
                "main": function (container, depth0, helpers, partials, data) {
                  var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }
                    return undefined;
                  };
                  return "<p class=\"mobile-recovery-hint\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                    "name": "i18n",
                    "hash": {
                      "arguments": "mobileFactors",
                      "bundle": "login",
                      "code": "recovery.mobile.hint"
                    },
                    "data": data,
                    "loc": {
                      "start": {
                        "line": 1,
                        "column": 32
                      },
                      "end": {
                        "line": 1,
                        "column": 109
                      }
                    }
                  })) + "</p>";
                },
                "useData": true
              }),
              getTemplateData: function () {
                let mobileFactors;
                if (smsEnabled && callEnabled) {
                  mobileFactors = (0, _courage.loc)('recovery.smsOrCall');
                } else if (callEnabled) {
                  mobileFactors = (0, _courage.loc)('recovery.call');
                } else {
                  mobileFactors = (0, _courage.loc)('recovery.sms');
                }
                return {
                  mobileFactors: mobileFactors
                };
              }
            })
          }));
        }
        if (smsEnabled) {
          this.$el.addClass('forgot-password-sms-enabled');
          formChildren.push(this.createRecoveryFactorButton('sms-button', 'account.unlock.sendText', _Enums.default.RECOVERY_FACTOR_TYPE_SMS, form));
          this.setDefaultFactorType(_Enums.default.RECOVERY_FACTOR_TYPE_SMS);
        }
        if (callEnabled) {
          this.$el.addClass('forgot-password-call-enabled');
          formChildren.push(this.createRecoveryFactorButton('call-button', 'account.unlock.voiceCall', _Enums.default.RECOVERY_FACTOR_TYPE_CALL, form));
          this.setDefaultFactorType(_Enums.default.RECOVERY_FACTOR_TYPE_CALL);
        }
        if (emailEnabled) {
          this.$el.addClass('forgot-password-email-enabled');
          formChildren.push(this.createRecoveryFactorButton('email-button', 'account.unlock.sendEmail', _Enums.default.RECOVERY_FACTOR_TYPE_EMAIL, form));
          this.setDefaultFactorType(_Enums.default.RECOVERY_FACTOR_TYPE_EMAIL);
        }
      }
      return formChildren;
    },
    initialize: function () {
      this.listenTo(this, 'save', function () {
        this.options.appState.set('username', this.model.get('username'));
        this.model.save();
      });
      this.listenTo(this.state, 'contactSupport', function () {
        this.add(_ContactSupport.default, '.o-form-error-container');
      });
    },
    setDefaultFactorType: function (factorType) {
      if (_courage._.isEmpty(this.model.get('factorType'))) {
        this.model.set('factorType', factorType);
      }
    },
    createRecoveryFactorButton: function (className, labelCode, factorType, form) {
      return _FormType.default.Button({
        attributes: {
          'data-se': className
        },
        className: 'button button-primary button-wide ' + className,
        title: (0, _courage.loc)(labelCode, 'login'),
        click: function () {
          form.clearErrors();
          if (this.model.isValid()) {
            this.model.set('factorType', factorType);
            form.trigger('save', this.model);
          }
        }
      });
    }
  },
  Footer: UnlockAccountControllerFooter
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/UnlockEmailSentController.js":
/*!*********************************************************!*\
  !*** ./src/v1/controllers/UnlockEmailSentController.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'account-unlock-email-sent',
  Model: function () {
    return {
      local: {
        userFullName: ['string', false, this.options.appState.get('userFullName')]
      }
    };
  },
  Form: {
    title: _courage._.partial(_courage.loc, 'account.unlock.emailSent.title', 'login'),
    subtitle: function () {
      const username = this.options.appState.get('username');
      return (0, _courage.loc)('account.unlock.emailSent.desc', 'login', [username]);
    },
    noButtonBar: true,
    attributes: {
      'data-se': 'unlock-email-sent'
    },
    formChildren: function () {
      return [_FormType.default.Button({
        title: (0, _courage.loc)('goback', 'login'),
        className: 'button button-primary button-wide',
        attributes: {
          'data-se': 'back-button'
        },
        click: function () {
          this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
          this.options.appState.trigger('navigate', '');
        }
      })];
    }
  },
  initialize: function (options) {
    this.settings.callGlobalSuccess(_Enums.default.UNLOCK_ACCOUNT_EMAIL_SENT, {
      username: options.appState.get('username')
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/VerifyCustomFactorController.js":
/*!************************************************************!*\
  !*** ./src/v1/controllers/VerifyCustomFactorController.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/HtmlErrorMessageView */ "./src/v1/views/mfa-verify/HtmlErrorMessageView.js"));
var _FooterMFA = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/FooterMFA */ "./src/v1/views/shared/FooterMFA.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2018-2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const {
  Util
} = _courage.internal.util;
var _default = _FormController.default.extend({
  className: 'verify-custom-factor custom-factor-form',
  Model: {
    props: {
      rememberDevice: 'boolean'
    },
    initialize: function () {
      const rememberDevice = _FactorUtil.default.getRememberDeviceValue(this.appState);

      // set the initial value for remember device (Cannot do this while defining the
      // local property because this.settings would not be initialized there yet).
      this.set('rememberDevice', rememberDevice);
      if (this.settings.get('features.skipIdpFactorVerificationBtn') && !this.appState.get('lastFailedChallengeFactorData')) {
        this.set('provider', 'CUSTOM');
        this.set('factorType', 'claims_provider');
        this.save();
      }
    },
    save: function () {
      const rememberDevice = !!this.get('rememberDevice');
      return this.manageTransaction((transaction, setTransaction) => {
        const data = {
          rememberDevice: rememberDevice
        };
        const factor = _courage._.findWhere(transaction.factors, {
          provider: this.get('provider'),
          factorType: this.get('factorType')
        });
        return factor.verify(data).then(trans => {
          setTransaction(trans);
          const url = this.appState.get('verifyCustomFactorRedirectUrl');
          if (url !== null) {
            Util.redirect(url);
          }
        }).catch(function (err) {
          throw err;
        });
      });
    }
  },
  Form: function () {
    const factors = this.options.appState.get('factors');
    const factor = factors.findWhere({
      provider: this.options.provider,
      factorType: this.options.factorType
    });
    const vendorName = factor.get('vendorName');
    const saveText = (0, _courage.loc)('mfa.challenge.verify', 'login');
    const lastFailedChallengeFactorData = this.options.appState.get('lastFailedChallengeFactorData');
    let subtitle = (0, _courage.loc)('verify.customFactor.subtitle', 'login', [vendorName]);
    if (this.settings.get('features.skipIdpFactorVerificationBtn') && !lastFailedChallengeFactorData) {
      subtitle = (0, _courage.loc)('verify.customFactor.subtitle.redirect', 'login', [vendorName]);
      this.listenTo(this.model, 'error', () => {
        subtitle = (0, _courage.loc)('verify.customFactor.subtitle', 'login', [vendorName]);
        this.$('.o-form-explain').text(subtitle);
      });
    }
    return {
      autoSave: true,
      title: vendorName,
      save: saveText,
      subtitle: subtitle,
      attributes: {
        'data-se': 'factor-custom'
      },
      initialize: function () {
        if (this.options.appState.get('allowRememberDevice')) {
          this.addInput({
            label: false,
            'label-top': true,
            placeholder: this.options.appState.get('rememberDeviceLabel'),
            className: 'margin-btm-0',
            name: 'rememberDevice',
            type: 'checkbox'
          });
        }
      },
      formChildren: function () {
        const result = [];
        const lastFailedChallengeFactorData = this.options.appState.get('lastFailedChallengeFactorData');
        if (this.settings.get('features.skipIdpFactorVerificationBtn') && !lastFailedChallengeFactorData) {
          result.push(_FormType.default.View({
            View: '<div data-se="custom-factor-waiting" class="okta-waiting-spinner"></div>'
          }));
        }
        if (lastFailedChallengeFactorData) {
          result.push(_FormType.default.View({
            View: new _HtmlErrorMessageView.default({
              message: lastFailedChallengeFactorData.errorMessage
            })
          }, {
            selector: '.o-form-error-container'
          }));
        }
        return result;
      }
    };
  },
  postRender() {
    if (this.settings.get('features.skipIdpFactorVerificationBtn') && !this.options.appState.get('lastFailedChallengeFactorData')) {
      this.$('.o-form-button-bar').hide();
      this.$('.okta-waiting-spinner').show();
    }
  },
  trapAuthResponse: function () {
    if (this.options.appState.get('isMfaChallenge')) {
      return true;
    }
  },
  back: function () {
    // Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
  },
  initialize: function () {
    this.model.set('provider', this.options.provider);
    this.model.set('factorType', this.options.factorType);
    if (this.settings.get('features.skipIdpFactorVerificationBtn')) {
      this.listenTo(this.model, 'error', () => {
        this.$('.okta-waiting-spinner').hide();
        this.$('.o-form-button-bar').show();
      });
    }
    this.addFooter(_FooterMFA.default);
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/VerifyDuoController.js":
/*!***************************************************!*\
  !*** ./src/v1/controllers/VerifyDuoController.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _duo = _interopRequireDefault(__webpack_require__(/*! @okta/duo */ "./packages/vendor/duo_web_sdk/index.js"));
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FooterMFA = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/FooterMFA */ "./src/v1/views/shared/FooterMFA.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
/* eslint camelcase: 0 */
var _default = _FormController.default.extend({
  className: 'mfa-verify-duo duo-form',
  Model: {
    props: {
      host: 'string',
      signature: 'string',
      postAction: 'string',
      factorId: 'string',
      stateToken: 'string',
      rememberDevice: 'boolean'
    },
    initialize: function () {
      const rememberDevice = _FactorUtil.default.getRememberDeviceValue(this.appState);

      // set the initial value for remember device (Cannot do this while defining the
      // local property because this.settings would not be initialized there yet).
      this.set('rememberDevice', rememberDevice);
    },
    getInitOptions: function () {
      const rememberDevice = !!this.get('rememberDevice');
      return this.doTransaction(function (transaction) {
        const data = {
          rememberDevice: rememberDevice
        };
        const factor = _courage._.findWhere(transaction.factors, {
          provider: 'DUO',
          factorType: 'web'
        });
        return factor.verify(data).catch(function (err) {
          // Clean up the cookie on failure.
          throw err;
        });
      }, true /* rethrow errors */);
    },

    verify: function (signedResponse) {
      const url = this.get('postAction');
      const factorId = this.get('factorId');
      const self = this;
      let data = {
        id: factorId,
        stateToken: this.get('stateToken'),
        sig_response: signedResponse
      };
      // Note: We should be doing this in OktaAuth! Fix when it's updated.

      const rememberDevice = this.get('rememberDevice');
      // We don't actually use authClient.post() here (unlike all the other cases in the
      // sign-in widget) since the endpoint is wired to accept serialized form post instead
      // of a JSON post ($.post() is different from authClient.post() in that in $.post(),
      // jquery decides the Content-Type instead of it being a JSON type). Enroll/Verify DUO
      // are the only two places where we actually do this.
      // NOTE - If we ever decide to change this, we should test this very carefully.

      return (0, _q.default)(_courage.$.post(url, data)).then(function () {
        return self.doTransaction(function (transaction) {
          let data;
          if (rememberDevice) {
            data = {
              rememberDevice: rememberDevice
            };
          }
          return transaction.poll(data);
        });
      }).catch(function (err) {
        self.trigger('error', self, err.xhr);
      });
    }
  },
  Form: {
    autoSave: true,
    noButtonBar: true,
    title: _courage._.partial(_courage.loc, 'factor.duo'),
    attributes: {
      'data-se': 'factor-duo'
    },
    postRender: function () {
      this.add('<iframe frameborder="0" title="' + this.title() + '"></iframe>');
      if (this.options.appState.get('allowRememberDevice')) {
        this.addInput({
          label: false,
          'label-top': true,
          placeholder: this.options.appState.get('rememberDeviceLabel'),
          className: 'margin-btm-0',
          name: 'rememberDevice',
          type: 'checkbox'
        });
      }
      _duo.default.init({
        host: this.model.get('host'),
        sig_request: this.model.get('signature'),
        iframe: this.$('iframe').get(0),
        post_action: _courage._.bind(this.model.verify, this.model)
      });
    }
  },
  fetchInitialData: function () {
    const self = this;
    return this.model.getInitOptions().then(function (trans) {
      const res = trans.data;
      if (!res._embedded || !res._embedded.factor || !res._embedded.factor._embedded || !res._embedded.factor._embedded.verification) {
        throw new Error('Response does not have duo verification options');
      }
      const verification = res._embedded.factor._embedded.verification;
      self.model.set({
        host: verification.host,
        signature: verification.signature,
        postAction: verification._links.complete.href,
        factorId: res._embedded.factor.id,
        stateToken: res.stateToken
      });
    });
  },
  trapAuthResponse: function () {
    if (this.options.appState.get('isMfaChallenge')) {
      return true;
    }
  },
  back: function () {
    // Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
  },
  Footer: _FooterMFA.default
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/VerifyPIVController.js":
/*!***************************************************!*\
  !*** ./src/v1/controllers/VerifyPIVController.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _FooterWithBackLink = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/FooterWithBackLink */ "./src/v1/views/shared/FooterWithBackLink.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity:[2, 10], max-params: [2, 11] */

let {
  Util
} = _courage.internal.util;
var _default = _FormController.default.extend({
  className: 'piv-cac-card',
  Model: {
    save: async function () {
      this.trigger('request');
      const self = this;
      const pivConfig = this.settings.get('piv');
      const data = {
        fromURI: this.settings.get('relayState'),
        isCustomDomain: pivConfig.isCustomDomain,
        customDomain: pivConfig.customDomain
      };
      try {
        await this.getCert(pivConfig.certAuthUrl);
        const res = await this.postCert(pivConfig.certAuthUrl, data);
        Util.redirect(res.redirectUrl);
      } catch (err) {
        if (_courage._.isEmpty(err.responseJSON) && !err.responseText) {
          err.responseJSON = {
            errorSummary: (0, _courage.loc)('piv.cac.error', 'login')
          };
        }
        self.trigger('error', self, err);
      }
    },
    getCert: function (certAuthUrl) {
      return _courage.$.get({
        url: certAuthUrl,
        xhrFields: {
          withCredentials: true
        },
        beforeSend: function () {
          // overriding this function to prevent our jquery-wrapper from
          // setting headers. Need to keep this a simple request in order for
          // PIV / CAC to work in IE.
        }
      });
    },
    postCert: function (certAuthUrl, data) {
      return _courage.$.post({
        url: certAuthUrl,
        xhrFields: {
          withCredentials: true
        },
        data: JSON.stringify(data),
        contentType: 'text/plain',
        beforeSend: function () {
          // overriding this function to prevent our jquery-wrapper from
          // setting headers. Need to keep this a simple request in order for
          // PIV / CAC to work in IE.
        }
      });
    }
  },
  Form: {
    autoSave: true,
    hasSavingState: false,
    title: _courage._.partial(_courage.loc, 'piv.cac.title', 'login'),
    className: 'piv-cac-card',
    noCancelButton: true,
    save: _courage._.partial(_courage.loc, 'retry', 'login'),
    modelEvents: {
      request: '_startEnrollment',
      error: '_stopEnrollment'
    },
    formChildren: [_FormType.default.View({
      View: _courage.View.extend({
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
            return "<div class=\"piv-verify-text\"><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "piv.cac.card.insert"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 32
                },
                "end": {
                  "line": 1,
                  "column": 82
                }
              }
            })) + "</p><div data-se=\"piv-waiting\" class=\"okta-waiting-spinner\"></div></div>";
          },
          "useData": true
        })
      })
    })],
    _startEnrollment: function () {
      this.$('.okta-waiting-spinner').show();
      this.$('.o-form-button-bar').hide();
    },
    _stopEnrollment: function () {
      this.$('.okta-waiting-spinner').hide();
      this.$('.o-form-button-bar').show();
    },
    postRender: function () {
      _courage._.defer(() => {
        this.model.save();
      });
    }
  },
  back: function () {
    // Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
  },
  Footer: _FooterWithBackLink.default
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/VerifyU2FController.js":
/*!***************************************************!*\
  !*** ./src/v1/controllers/VerifyU2FController.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
__webpack_require__(/*! u2f-api-polyfill */ "./node_modules/u2f-api-polyfill/u2f-api-polyfill.js");
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _FidoUtil = _interopRequireDefault(__webpack_require__(/*! util/FidoUtil */ "./src/util/FidoUtil.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/HtmlErrorMessageView */ "./src/v1/views/mfa-verify/HtmlErrorMessageView.js"));
var _FooterMFA = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/FooterMFA */ "./src/v1/views/shared/FooterMFA.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* global u2f */

function getRegisteredKeysSequence(factors) {
  const keys = [];
  _courage._.each(factors, function (factor) {
    keys.push({
      version: factor.profile.version,
      keyHandle: factor.profile.credentialId
    });
  });
  return keys;
}
var _default = _FormController.default.extend({
  className: 'mfa-verify verify-u2f',
  Model: {
    props: {
      rememberDevice: 'boolean'
    },
    initialize: function () {
      const rememberDevice = _FactorUtil.default.getRememberDeviceValue(this.appState);

      // set the initial value for remember device (Cannot do this while defining the
      // local property because this.settings would not be initialized there yet).
      this.set('rememberDevice', rememberDevice);
    },
    save: function () {
      this.trigger('request');
      return this.doTransaction(function (transaction) {
        let factor;
        if (transaction.factorTypes) {
          factor = _courage._.findWhere(transaction.factorTypes, {
            factorType: 'u2f'
          });
        } else {
          factor = _courage._.findWhere(transaction.factors, {
            factorType: 'u2f',
            provider: 'FIDO'
          });
        }
        const self = this;
        return factor.verify().then(function (transaction) {
          let registeredKeys;
          let appId;
          let nonce;
          if (transaction.factors) {
            const factors = transaction.factors;
            appId = factors[0]['profile']['appId'];
            nonce = transaction.challenge.nonce;
            registeredKeys = getRegisteredKeysSequence(factors);
          } else {
            const factorData = transaction.factor;
            appId = factorData.profile.appId;
            nonce = factorData.challenge.nonce;
            registeredKeys = [{
              version: _FidoUtil.default.getU2fVersion(),
              keyHandle: factorData.profile.credentialId
            }];
          }
          self.trigger('request');
          const deferred = _q.default.defer();
          u2f.sign(appId, nonce, registeredKeys, function (data) {
            self.trigger('errors:clear');
            if (data.errorCode && data.errorCode !== 0) {
              const isOneFactor = self.options.appState.get('factors').length === 1;
              deferred.reject(new _Errors.U2FError({
                xhr: {
                  responseJSON: {
                    errorSummary: _FidoUtil.default.getU2fVerifyErrorMessageByCode(data.errorCode, isOneFactor)
                  }
                }
              }));
            } else {
              const rememberDevice = !!self.get('rememberDevice');
              return factor.verify({
                clientData: data.clientData,
                signatureData: data.signatureData,
                rememberDevice: rememberDevice
              }).then(deferred.resolve);
            }
          });
          return deferred.promise;
        });
      }).catch(() => {});
    }
  },
  Form: {
    autoSave: true,
    hasSavingState: false,
    title: _courage._.partial(_courage.loc, 'factor.u2f', 'login'),
    className: 'verify-u2f-form',
    noCancelButton: true,
    save: _courage._.partial(_courage.loc, 'verify.u2f.retry', 'login'),
    noButtonBar: function () {
      return !_FidoUtil.default.isU2fAvailable();
    },
    modelEvents: {
      request: '_startEnrollment',
      error: '_stopEnrollment'
    },
    formChildren: function () {
      const result = [];
      if (!_FidoUtil.default.isU2fAvailable()) {
        let errorMessageKey = 'u2f.error.factorNotSupported';
        if (this.options.appState.get('factors').length === 1) {
          errorMessageKey = 'u2f.error.factorNotSupported.oneFactor';
        }
        result.push(_FormType.default.View({
          View: new _HtmlErrorMessageView.default({
            message: (0, _courage.loc)(errorMessageKey, 'login')
          })
        }, {
          selector: '.o-form-error-container'
        }));
      } else {
        result.push(_FormType.default.View({
          View: _courage.View.extend({
            template: _runtime.default.template({
              "compiler": [8, ">= 4.3.0"],
              "main": function (container, depth0, helpers, partials, data) {
                var alias1 = depth0 != null ? depth0 : container.nullContext || {},
                  alias2 = container.hooks.helperMissing,
                  alias3 = container.escapeExpression,
                  lookupProperty = container.lookupProperty || function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                      return parent[propertyName];
                    }
                    return undefined;
                  };
                return "<div class=\"u2f-verify-text\"><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "verify.u2f.instructions"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 32
                    },
                    "end": {
                      "line": 1,
                      "column": 86
                    }
                  }
                })) + "</p><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "verify.u2f.instructionsBluetooth"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 93
                    },
                    "end": {
                      "line": 1,
                      "column": 156
                    }
                  }
                })) + "</p><div data-se=\"u2f-waiting\" class=\"okta-waiting-spinner\"></div></div>";
              },
              "useData": true
            })
          })
        }));
      }
      if (this.options.appState.get('allowRememberDevice')) {
        result.push(_FormType.default.Input({
          label: false,
          'label-top': true,
          placeholder: this.options.appState.get('rememberDeviceLabel'),
          className: 'margin-btm-0',
          name: 'rememberDevice',
          type: 'checkbox'
        }));
      }
      return result;
    },
    postRender: function () {
      _courage._.defer(() => {
        if (_FidoUtil.default.isU2fAvailable()) {
          this.model.save();
        } else {
          this.$('[data-se="u2f-waiting"]').addClass('hide');
        }
      });
    },
    _startEnrollment: function () {
      this.$('.okta-waiting-spinner').removeClass('hide');
      this.$('.o-form-button-bar').hide();
    },
    _stopEnrollment: function () {
      this.$('.okta-waiting-spinner').addClass('hide');
      this.$('.o-form-button-bar').show();
    }
  },
  back: function () {
    // Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
  },
  Footer: _FooterMFA.default
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/VerifyWebauthnController.js":
/*!********************************************************!*\
  !*** ./src/v1/controllers/VerifyWebauthnController.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
var _CryptoUtil = _interopRequireDefault(__webpack_require__(/*! util/CryptoUtil */ "./src/util/CryptoUtil.js"));
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _webauthn = _interopRequireDefault(__webpack_require__(/*! util/webauthn */ "./src/util/webauthn.js"));
var _BrowserFeatures = _interopRequireDefault(__webpack_require__(/*! util/BrowserFeatures */ "./src/util/BrowserFeatures.ts"));
var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/HtmlErrorMessageView */ "./src/v1/views/mfa-verify/HtmlErrorMessageView.js"));
var _FooterMFA = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/FooterMFA */ "./src/v1/views/shared/FooterMFA.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity:[2, 10], max-params: [2, 11] */

function getAllowCredentials(factors) {
  const allowCredentials = [];
  _courage._.each(factors, function (factor) {
    allowCredentials.push({
      type: 'public-key',
      id: _CryptoUtil.default.strToBin(factor.profile.credentialId)
    });
  });
  return allowCredentials;
}
var _default = _FormController.default.extend({
  className: 'mfa-verify verify-webauthn',
  Model: {
    props: {
      rememberDevice: 'boolean'
    },
    initialize: function () {
      const rememberDevice = _FactorUtil.default.getRememberDeviceValue(this.appState);

      // set the initial value for remember device (Cannot do this while defining the
      // local property because this.settings would not be initialized there yet).
      this.set('rememberDevice', rememberDevice);
      this.appState.on('factorSwitched signOut', () => {
        if (this.webauthnAbortController) {
          this.webauthnAbortController.abort();
          this.webauthnAbortController = null;
        }
      });
    },
    save: function () {
      this.trigger('request');
      return this.doTransaction(function (transaction) {
        let factor;
        if (transaction.factorTypes) {
          factor = _courage._.findWhere(transaction.factorTypes, {
            factorType: 'webauthn'
          });
        } else {
          factor = _courage._.findWhere(transaction.factors, {
            factorType: 'webauthn',
            provider: 'FIDO'
          });
        }
        const self = this;
        return factor.verify().then(function (transaction) {
          let allowCredentials;
          let challenge;
          if (transaction.factors) {
            const factors = transaction.factors;
            challenge = transaction.challenge;
            allowCredentials = getAllowCredentials(factors);
          } else {
            const factorData = transaction.factor;
            challenge = factorData.challenge;
            allowCredentials = getAllowCredentials([factorData]);
          }
          self.trigger('request');
          // verify via browser webauthn js

          const options = _courage._.extend({}, challenge, {
            allowCredentials: allowCredentials,
            challenge: _CryptoUtil.default.strToBin(challenge.challenge)
          });

          // AbortController is not supported in IE11
          if (typeof AbortController !== 'undefined') {
            self.webauthnAbortController = new AbortController();
          }
          return new _q.default(
          // navigator.credentials is not supported in IE11
          // eslint-disable-next-line compat/compat
          navigator.credentials.get({
            publicKey: options,
            signal: self.webauthnAbortController && self.webauthnAbortController.signal
          })).then(function (assertion) {
            const rememberDevice = !!self.get('rememberDevice');
            return factor.verify({
              clientData: _CryptoUtil.default.binToStr(assertion.response.clientDataJSON),
              authenticatorData: _CryptoUtil.default.binToStr(assertion.response.authenticatorData),
              signatureData: _CryptoUtil.default.binToStr(assertion.response.signature),
              rememberDevice: rememberDevice
            });
          }).catch(function (error) {
            self.trigger('errors:clear');
            // Do not display if it is abort error triggered by code when switching.
            // self.webauthnAbortController would be null if abort was triggered by code.
            if (!self.webauthnAbortController) {
              throw new _Errors.WebauthnAbortError();
            } else {
              throw new _Errors.WebAuthnError({
                xhr: {
                  responseJSON: {
                    errorSummary: error.message
                  }
                }
              });
            }
          }).finally(function () {
            // unset webauthnAbortController on successful authentication or error
            self.webauthnAbortController = null;
          });
        });
      }).catch(() => {});
    }
  },
  Form: {
    autoSave: true,
    hasSavingState: false,
    title: _courage._.partial(_courage.loc, 'factor.webauthn.biometric', 'login'),
    className: 'verify-webauthn-form',
    noCancelButton: true,
    save: _courage._.partial(_courage.loc, 'mfa.challenge.verify', 'login'),
    noButtonBar: function () {
      return !_webauthn.default.isNewApiAvailable();
    },
    modelEvents: {
      request: '_startEnrollment',
      error: '_stopEnrollment'
    },
    formChildren: function () {
      const children = [];
      if (_webauthn.default.isNewApiAvailable()) {
        children.push(_FormType.default.View({
          View: _courage.View.extend({
            template: _runtime.default.template({
              "compiler": [8, ">= 4.3.0"],
              "main": function (container, depth0, helpers, partials, data) {
                var lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }
                  return undefined;
                };
                return "<div class=\"webauthn-verify-text\"><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                  "name": "i18n",
                  "hash": {
                    "bundle": "login",
                    "code": "verify.webauthn.biometric.instructions"
                  },
                  "data": data,
                  "loc": {
                    "start": {
                      "line": 1,
                      "column": 37
                    },
                    "end": {
                      "line": 1,
                      "column": 106
                    }
                  }
                })) + "</p><div data-se=\"webauthn-waiting\" class=\"okta-waiting-spinner\"></div></div>";
              },
              "useData": true
            })
          })
        }));
      } else {
        let errorMessageKey = 'webauthn.biometric.error.factorNotSupported';
        if (this.options.appState.get('factors').length === 1) {
          errorMessageKey = 'webauthn.biometric.error.factorNotSupported.oneFactor';
        }
        children.push(_FormType.default.View({
          View: new _HtmlErrorMessageView.default({
            message: (0, _courage.loc)(errorMessageKey, 'login')
          })
        }, {
          selector: '.o-form-error-container'
        }));
      }
      if (this.options.appState.get('allowRememberDevice')) {
        children.push(_FormType.default.Input({
          label: false,
          'label-top': true,
          placeholder: this.options.appState.get('rememberDeviceLabel'),
          className: 'margin-btm-0',
          name: 'rememberDevice',
          type: 'checkbox'
        }));
      }
      return children;
    },
    _startEnrollment: function () {
      this.$('.okta-waiting-spinner').show();
      this.$('.o-form-button-bar').hide();
    },
    _stopEnrollment: function () {
      this.$('.okta-waiting-spinner').hide();
      this.$('.o-form-button-bar [type="submit"]')[0].value = (0, _courage.loc)('verify.u2f.retry', 'login');
      this.$('.o-form-button-bar').show();
    }
  },
  postRender: function () {
    _courage._.defer(() => {
      // Trigger browser prompt automatically for other browsers for better UX.
      if (_webauthn.default.isNewApiAvailable() && !_BrowserFeatures.default.isSafari()) {
        this.model.save();
      }
    });
  },
  back: function () {
    // Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
  },
  Footer: _FooterMFA.default
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/controllers/VerifyWindowsHelloController.js":
/*!************************************************************!*\
  !*** ./src/v1/controllers/VerifyWindowsHelloController.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FormController = _interopRequireDefault(__webpack_require__(/*! v1/util/FormController */ "./src/v1/util/FormController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _webauthn = _interopRequireDefault(__webpack_require__(/*! util/webauthn */ "./src/util/webauthn.js"));
var _HtmlErrorMessageView = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/HtmlErrorMessageView */ "./src/v1/views/mfa-verify/HtmlErrorMessageView.js"));
var _FooterMFA = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/FooterMFA */ "./src/v1/views/shared/FooterMFA.js"));
var _Spinner = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/Spinner */ "./src/v1/views/shared/Spinner.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FormController.default.extend({
  className: 'mfa-verify verify-windows-hello',
  Model: {
    local: {
      __autoTriggered__: 'boolean'
    },
    save: function () {
      if (!_webauthn.default.isAvailable()) {
        return;
      }
      this.trigger('request');
      const model = this;
      return this.doTransaction(function (transaction) {
        const factor = _courage._.findWhere(transaction.factors, {
          factorType: 'webauthn',
          provider: 'FIDO'
        });
        return factor.verify().then(function (verifyData) {
          const factorData = verifyData.factor;
          return _webauthn.default.getAssertion(factorData.challenge.nonce, [{
            id: factorData.profile.credentialId
          }]).then(function (assertion) {
            return factor.verify({
              authenticatorData: assertion.authenticatorData,
              clientData: assertion.clientData,
              signatureData: assertion.signature
            });
          }).then(function (data) {
            model.trigger('sync');
            model.trigger('signIn');
            return data;
          }).catch(function (error) {
            switch (error.message) {
              case 'AbortError':
              case 'NotFoundError':
              case 'NotSupportedError':
                model.trigger('abort', error.message);
                return transaction;
            }
            throw error;
          });
        });
      });
    }
  },
  Form: {
    autoSave: true,
    hasSavingState: false,
    title: _courage._.partial(_courage.loc, 'factor.windowsHello', 'login'),
    subtitle: function () {
      return _webauthn.default.isAvailable() ? (0, _courage.loc)('verify.windowsHello.subtitle', 'login') : '';
    },
    save: _courage._.partial(_courage.loc, 'verify.windowsHello.save', 'login'),
    customSavingState: {
      stop: 'abort'
    },
    modelEvents: function () {
      if (!_webauthn.default.isAvailable()) {
        return {};
      }
      return {
        request: '_startEnrollment',
        error: '_stopEnrollment',
        abort: '_stopEnrollment',
        signIn: '_successEnrollment'
      };
    },
    noButtonBar: function () {
      return !_webauthn.default.isAvailable();
    },
    formChildren: function () {
      const result = [];
      if (!_webauthn.default.isAvailable()) {
        result.push(_FormType.default.View({
          View: new _HtmlErrorMessageView.default({
            message: (0, _courage.loc)('enroll.windowsHello.error.notWindows', 'login')
          })
        }, {
          selector: '.o-form-error-container'
        }));
      }
      result.push(_FormType.default.View({
        View: new _Spinner.default({
          model: this.model,
          visible: false
        })
      }));
      return result;
    },
    postRender: function () {
      if (this.options.appState.get('factors').length === 1 && !this.model.get('__autoTriggered__')) {
        this.model.set('__autoTriggered__', true);
        this.model.save();
      }
    },
    _startEnrollment: function () {
      this.subtitle = (0, _courage.loc)('verify.windowsHello.subtitle.loading', 'login');
      this.model.trigger('spinner:show');
      this._resetErrorMessage();
      this.render();
      this.$('.o-form-button-bar').addClass('hide');
    },
    _stopEnrollment: function (errorMessage) {
      this.subtitle = (0, _courage.loc)('verify.windowsHello.subtitle', 'login');
      this.model.trigger('spinner:hide');
      this.$('.o-form-button-bar').removeClass('hide');
      let message;
      switch (errorMessage) {
        case 'NotFoundError':
          message = this.options.appState.get('factors').length > 1 ? (0, _courage.loc)('verify.windowsHello.error.notFound.selectAnother', 'login') : (0, _courage.loc)('verify.windowsHello.error.notFound', 'login');
          break;
        case 'NotSupportedError':
          message = (0, _courage.loc)('enroll.windowsHello.error.notConfiguredHtml', 'login');
          break;
      }
      this._resetErrorMessage();
      if (message) {
        const messageView = new _HtmlErrorMessageView.default({
          message: message
        });
        this.$('.o-form-error-container').addClass('o-form-has-errors');
        this.add(messageView, {
          selector: '.o-form-error-container'
        });
        this._errorMessageView = this.last();
      }
      this.render();
    },
    _successEnrollment: function () {
      this.subtitle = this.settings.get('brandName') ? (0, _courage.loc)('verify.windowsHello.subtitle.signingIn.specific', 'login', [this.settings.get('brandName')]) : (0, _courage.loc)('verify.windowsHello.subtitle.signingIn.generic', 'login');
      this.render();
      this.$('.o-form-button-bar').addClass('hide');
    },
    _resetErrorMessage: function () {
      this._errorMessageView && this._errorMessageView.remove();
      this._errorMessageView = undefined;
      this.clearErrors();
    }
  },
  back: function () {
    // Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
  },
  Footer: _FooterMFA.default
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/models/AppState.js":
/*!***********************************!*\
  !*** ./src/v1/models/AppState.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Factor = _interopRequireDefault(__webpack_require__(/*! v1/models/Factor */ "./src/v1/models/Factor.js"));
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
var _BrowserFeatures = _interopRequireDefault(__webpack_require__(/*! util/BrowserFeatures */ "./src/util/BrowserFeatures.ts"));
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const DEFAULT_APP_LOGO = '/img/logos/default.png';

// Keep track of stateMachine with this special model. Some reasons to not
// keep it generic:
// 1. We know exactly what we're using appState for by requiring props
// 2. Can have some derived functions to help us translate the lastAuthRes

const USER_NOT_SEEN_ON_DEVICE = '/img/security/unknown.png';
const UNDEFINED_USER = '/img/security/default.png';
const NEW_USER = '/img/security/unknown-device.png';
const NEW_USER_IMAGE_DESCRIPTION = '';
const UNDEFINED_USER_IMAGE_DESCRIPTION = '';
const UNKNOWN_IMAGE_DESCRIPTION = '';
const securityImageUrlTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      alias2 = container.hooks.helperMissing,
      alias3 = "function",
      alias4 = container.escapeExpression,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return alias4((helper = (helper = lookupProperty(helpers, "baseUrl") || (depth0 != null ? lookupProperty(depth0, "baseUrl") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "baseUrl",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 0
        },
        "end": {
          "line": 1,
          "column": 11
        }
      }
    }) : helper)) + "/login/getimage?username=" + alias4((helper = (helper = lookupProperty(helpers, "username") || (depth0 != null ? lookupProperty(depth0, "username") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "username",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 36
        },
        "end": {
          "line": 1,
          "column": 48
        }
      }
    }) : helper));
  },
  "useData": true
});
function getSecurityImage(baseUrl, username, deviceFingerprint) {
  // When the username is empty, we want to show the default image.
  if (_courage._.isEmpty(username) || _courage._.isUndefined(username)) {
    return (0, _q.default)({
      securityImage: UNDEFINED_USER,
      securityImageDescription: UNDEFINED_USER_IMAGE_DESCRIPTION
    });
  }

  // Reserved characters in the username must be escaped before the query can be safely executed
  username = encodeURIComponent(username);
  const url = securityImageUrlTpl({
    baseUrl: baseUrl,
    username: username
  });
  const data = {
    url: url,
    dataType: 'json'
  };
  if (deviceFingerprint) {
    data['headers'] = {
      'X-Device-Fingerprint': deviceFingerprint
    };
  }
  return (0, _q.default)(_courage.$.ajax(data)).then(function (res) {
    if (res.pwdImg === USER_NOT_SEEN_ON_DEVICE) {
      // When we get an unknown.png security image from OKTA,
      // we want to show the unknown-device security image.
      // We are mapping the server's img url to a new one because
      // we still need to support the original login page.
      return {
        securityImage: NEW_USER,
        securityImageDescription: NEW_USER_IMAGE_DESCRIPTION
      };
    }
    return {
      securityImage: res.pwdImg,
      securityImageDescription: res.imageDescription || UNKNOWN_IMAGE_DESCRIPTION
    };
  });
}
function getMinutesString(factorLifetimeInMinutes) {
  if (factorLifetimeInMinutes > 60 && factorLifetimeInMinutes <= 1440) {
    const lifetimeInHours = factorLifetimeInMinutes / 60;
    return (0, _courage.loc)('hours', 'login', [lifetimeInHours]);
  } else if (factorLifetimeInMinutes > 1440) {
    const lifetimeInDays = factorLifetimeInMinutes / 1440;
    return (0, _courage.loc)('days', 'login', [lifetimeInDays]);
  }
  //Use minutes as the time unit by default
  if (factorLifetimeInMinutes === 1) {
    return (0, _courage.loc)('minutes.oneMinute', 'login');
  }
  return (0, _courage.loc)('minutes', 'login', [factorLifetimeInMinutes]);
}
function getGracePeriodRemainingDays(gracePeriodEndDate) {
  const endDate = new Date(gracePeriodEndDate).getTime();
  const remainingDays = Math.floor((endDate - new Date().getTime()) / (1000 * 3600 * 24));
  return remainingDays;
}
function combineFactorsObjects(factorTypes, factors) {
  const addedFactorTypes = [];
  const combinedFactors = [];
  _courage._.each(factors, function (factor) {
    const factorType = factor.factorType;
    if (!_courage._.contains(addedFactorTypes, factorType)) {
      const factorTypeObj = _courage._.findWhere(factorTypes, {
        factorType: factorType
      });
      if (factorTypeObj) {
        addedFactorTypes.push(factorType);
        combinedFactors.push(factorTypeObj);
      } else {
        combinedFactors.push(factor);
      }
    }
  });
  return combinedFactors;
}
var _default = _courage.Model.extend({
  initialize: function () {
    // Handle this in initialize (as opposed to a derived property) because
    // the operation is asynchronous
    if (this.settings.get('features.securityImage')) {
      const self = this;
      this.listenTo(this, 'change:username', function (model, username) {
        getSecurityImage(this.get('baseUrl'), username, this.get('deviceFingerprint')).then(function (image) {
          model.set('securityImage', image.securityImage);
          model.set('securityImageDescription', image.securityImageDescription);
          model.unset('deviceFingerprint'); //Fingerprint can only be used once
        }).fail(function (jqXhr) {
          // Only notify the consumer on a CORS error
          if (_BrowserFeatures.default.corsIsNotEnabled(jqXhr)) {
            self.settings.callGlobalError(new _Errors.UnsupportedBrowserError((0, _courage.loc)('error.enabled.cors')));
          } else {
            throw jqXhr;
          }
        }).done();
      });
    }
  },
  local: {
    baseUrl: 'string',
    lastAuthResponse: ['object', true, {}],
    transaction: 'object',
    transactionError: 'object',
    username: 'string',
    factors: 'object',
    policy: 'object',
    securityImage: ['string', true, UNDEFINED_USER],
    securityImageDescription: ['string', true, UNDEFINED_USER_IMAGE_DESCRIPTION],
    userCountryCode: 'string',
    userPhoneNumber: 'string',
    factorActivationType: 'string',
    flashError: 'object',
    beaconType: 'string',
    deviceFingerprint: 'string',
    // valid only once
    typingPattern: 'string',
    // Note: languageCode is special in that it is shared between Settings
    // and AppState. Settings is the *configured* language, and is static.
    // AppState is the dynamic language state - it can be changed via a
    // language picker, etc.
    // Note: this is conceptial feasible but not yet being implemented.
    languageCode: ['string', true],
    disableUsername: ['boolean', false, false],
    trapMfaRequiredResponse: ['boolean', false, false],
    lastFailedChallengeFactorData: ['object', false]
  },
  setAuthResponse: function (res) {
    // Because of MFA_CHALLENGE (i.e. DUO), we need to remember factors
    // across auth responses. Not doing this, for example, results in being
    // unable to switch away from the duo factor dropdown.
    if (res._embedded && res._embedded.policy) {
      this.set('policy', res._embedded.policy);
    }
    if (res._embedded && res._embedded.factors) {
      let factors = res._embedded.factors;
      if (res._embedded.factorTypes) {
        factors = combineFactorsObjects(res._embedded.factorTypes, factors);
      }
      const factorsObject = _courage._.map(factors, factor => {
        factor.settings = this.settings;
        factor.appState = this;
        return factor;
      });
      this.set('factors', new _Factor.default.Collection(factorsObject, {
        parse: true
      }));
    }
    this.set('lastAuthResponse', res);
  },
  clearLastAuthResponse: function () {
    this.set('lastAuthResponse', {});
  },
  setLastFailedChallengeFactorData: function () {
    this.set('lastFailedChallengeFactorData', {
      factor: this.get('factor'),
      errorMessage: this.get('factorResultErrorMessage')
    });
  },
  clearLastFailedChallengeFactorData: function () {
    this.unset('lastFailedChallengeFactorData');
  },
  getUser: function () {
    return this.get('user');
  },
  derived: {
    isSuccessResponse: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        return res.status === 'SUCCESS';
      }
    },
    isMfaRequired: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        return res.status === 'MFA_REQUIRED' || res.status === 'FACTOR_REQUIRED';
      }
    },
    isProfileRequired: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        return res.status === 'PROFILE_REQUIRED';
      }
    },
    isMfaEnroll: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        return res.status === 'MFA_ENROLL' || res.status === 'FACTOR_ENROLL';
      }
    },
    isMfaChallenge: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        return res.status === 'MFA_CHALLENGE' || res.status === 'FACTOR_CHALLENGE';
      }
    },
    isSMSPasswordRecovery: {
      deps: ['lastAuthResponse'],
      fn: function ({
        status,
        factorType,
        recoveryType
      }) {
        return status === 'RECOVERY_CHALLENGE' && (factorType === null || factorType === void 0 ? void 0 : factorType.toLowerCase()) === 'sms' && (recoveryType === null || recoveryType === void 0 ? void 0 : recoveryType.toLowerCase()) === 'password';
      }
    },
    isUnauthenticated: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        return res.status === 'UNAUTHENTICATED';
      }
    },
    isMfaRejected: {
      // MFA failures are usually error responses
      // except in the case of Okta Push, when a
      // user clicks 'deny' on his phone or OV app
      // version is below a required version no.
      deps: ['lastAuthResponse'],
      fn: function (res) {
        return res.factorResult === 'REJECTED';
      }
    },
    isMfaTimeout: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        return res.factorResult === 'TIMEOUT';
      }
    },
    isMfaEnrollActivate: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        return res.status === 'MFA_ENROLL_ACTIVATE' || res.status === 'FACTOR_ENROLL_ACTIVATE';
      }
    },
    isWaitingForActivation: {
      deps: ['isMfaEnrollActivate', 'lastAuthResponse'],
      fn: function (isMfaEnrollActivate, res) {
        return isMfaEnrollActivate && res.factorResult === 'WAITING';
      }
    },
    isWaitingForNumberChallenge: {
      deps: ['lastAuthResponse', 'isMfaChallenge'],
      fn: function (res, isMfaChallenge) {
        if (isMfaChallenge && res && res.factorResult === 'WAITING' && res._embedded && res._embedded.factor && res._embedded.factor._embedded && res._embedded.factor._embedded.challenge) {
          return true;
        }
        return false;
      }
    },
    hasMultipleFactorsAvailable: {
      deps: ['factors', 'isMfaRequired', 'isMfaChallenge', 'isUnauthenticated'],
      fn: function (factors, isMfaRequired, isMfaChallenge, isUnauthenticated) {
        if (!isMfaRequired && !isMfaChallenge && !isUnauthenticated) {
          return false;
        }
        return factors && factors.length > 1;
      }
    },
    promptForFactorInUnauthenticated: {
      deps: ['lastAuthResponse', 'factors'],
      fn: function (res, factors) {
        if (res.status !== 'UNAUTHENTICATED') {
          return false;
        }
        return factors && factors.length > 0;
      }
    },
    userId: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        if (!res._embedded || !res._embedded.user) {
          return null;
        }
        return res._embedded.user.id;
      }
    },
    isIdxStateToken: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        return res && _courage._.isString(res.stateToken) && res.stateToken.startsWith('01');
      }
    },
    isPwdExpiringSoon: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        return res.status === 'PASSWORD_WARN';
      }
    },
    passwordExpireDays: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        if (!res._embedded || !res._embedded.policy || !res._embedded.policy.expiration) {
          return null;
        }
        return res._embedded.policy.expiration.passwordExpireDays;
      }
    },
    isPwdManagedByOkta: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        if (!res._links || !res._links.next || !res._links.next.title) {
          return true;
        }
        return false;
      }
    },
    passwordExpiredWebsiteName: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        if (!res._links || !res._links.next || !res._links.next.title) {
          return null;
        }
        return res._links.next.title;
      }
    },
    passwordExpiredLinkUrl: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        if (!res._links || !res._links.next || !res._links.next.title || !res._links.next.href) {
          return null;
        }
        return res._links.next.href;
      }
    },
    recoveryType: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        return res.recoveryType;
      }
    },
    factorType: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        return res.factorType;
      }
    },
    factor: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        if (!res._embedded || !res._embedded.factor) {
          return null;
        }
        return res._embedded.factor;
      }
    },
    activatedFactorId: {
      deps: ['factor'],
      fn: function (factor) {
        return factor ? factor.id : null;
      }
    },
    activatedFactorType: {
      deps: ['factor'],
      fn: function (factor) {
        return factor ? factor.factorType : null;
      }
    },
    activatedFactorProvider: {
      deps: ['factor'],
      fn: function (factor) {
        return factor ? factor.provider : null;
      }
    },
    qrcode: {
      deps: ['factor'],
      fn: function (factor) {
        try {
          return factor._embedded.activation._links.qrcode.href;
        } catch (err) {
          return null;
        }
      }
    },
    activationSendLinks: {
      deps: ['factor'],
      fn: function (factor) {
        let sendLinks;
        try {
          sendLinks = factor._embedded.activation._links.send;
        } catch (err) {
          sendLinks = [];
        }
        return sendLinks;
      }
    },
    textActivationLinkUrl: {
      deps: ['activationSendLinks'],
      fn: function (activationSendLinks) {
        const item = _courage._.findWhere(activationSendLinks, {
          name: 'sms'
        });
        return item ? item.href : null;
      }
    },
    emailActivationLinkUrl: {
      deps: ['activationSendLinks'],
      fn: function (activationSendLinks) {
        const item = _courage._.findWhere(activationSendLinks, {
          name: 'email'
        });
        return item ? item.href : null;
      }
    },
    sharedSecret: {
      deps: ['factor'],
      fn: function (factor) {
        try {
          return factor._embedded.activation.sharedSecret;
        } catch (err) {
          return null;
        }
      }
    },
    duoEnrollActivation: {
      deps: ['factor'],
      fn: function (factor) {
        if (!factor || !factor._embedded || !factor._embedded.activation) {
          return null;
        }
        return factor._embedded.activation;
      }
    },
    prevLink: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        if (res._links && res._links.prev) {
          return res._links.prev.href;
        }
        return null;
      }
    },
    skipLink: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        if (res._links && res._links.skip) {
          return res._links.skip.href;
        }
        return null;
      }
    },
    gracePeriodRemainingDays: {
      deps: ['policy'],
      fn: function (policy) {
        if (policy && policy.gracePeriod && policy.gracePeriod.endDate) {
          return getGracePeriodRemainingDays(policy.gracePeriod.endDate);
        }
        return null;
      }
    },
    user: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        if (!res._embedded || !res._embedded.user) {
          return null;
        }
        return res._embedded.user;
      }
    },
    recoveryQuestion: {
      deps: ['user'],
      fn: function (user) {
        if (!user || !user.recovery_question) {
          return null;
        }
        return user.recovery_question.question;
      }
    },
    userProfile: {
      deps: ['user'],
      fn: function (user) {
        if (!user || !user.profile) {
          return null;
        }
        return user.profile;
      }
    },
    userConsentName: {
      deps: ['userProfile', 'username'],
      fn: function (userProfile, username) {
        if (!userProfile || _courage._.isEmpty(userProfile.firstName)) {
          return username;
        }
        if (_courage._.isEmpty(userProfile.lastName)) {
          return userProfile.firstName;
        }
        return userProfile.firstName + ' ' + userProfile.lastName.charAt(0) + '.';
      }
    },
    userEmail: {
      deps: ['userProfile'],
      fn: function (userProfile) {
        if (!userProfile || !userProfile.login) {
          return null;
        }
        return userProfile.login;
      }
    },
    userFullName: {
      deps: ['userProfile'],
      fn: function (userProfile) {
        if (!userProfile || !userProfile.firstName && !userProfile.lastName) {
          return '';
        }
        return userProfile.firstName + ' ' + userProfile.lastName;
      }
    },
    defaultAppLogo: {
      deps: ['baseUrl'],
      fn: function (baseUrl) {
        return baseUrl + DEFAULT_APP_LOGO;
      }
    },
    expiresAt: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        return res.expiresAt;
      }
    },
    target: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        if (!res._embedded) {
          return null;
        }
        return res._embedded.target;
      }
    },
    targetLabel: {
      deps: ['target'],
      fn: function (target) {
        if (!target) {
          return null;
        }
        return target.label;
      }
    },
    targetLogo: {
      deps: ['target'],
      fn: function (target) {
        if (!target || !target._links) {
          return null;
        }
        return target._links.logo;
      }
    },
    targetTermsOfService: {
      deps: ['target'],
      fn: function (target) {
        if (!target || !target._links) {
          return null;
        }
        return target._links['terms-of-service'];
      }
    },
    targetPrivacyPolicy: {
      deps: ['target'],
      fn: function (target) {
        if (!target || !target._links) {
          return null;
        }
        return target._links['privacy-policy'];
      }
    },
    targetClientURI: {
      deps: ['target'],
      fn: function (target) {
        if (!target || !target._links) {
          return null;
        }
        return target._links['client-uri'];
      }
    },
    scopes: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        if (!res._embedded) {
          return null;
        }
        return res._embedded.scopes;
      }
    },
    issuer: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        var _res$_embedded, _res$_embedded$authen, _res$_embedded$authen2;
        return res === null || res === void 0 ? void 0 : (_res$_embedded = res._embedded) === null || _res$_embedded === void 0 ? void 0 : (_res$_embedded$authen = _res$_embedded.authentication) === null || _res$_embedded$authen === void 0 ? void 0 : (_res$_embedded$authen2 = _res$_embedded$authen.issuer) === null || _res$_embedded$authen2 === void 0 ? void 0 : _res$_embedded$authen2.uri;
      }
    },
    hasExistingPhones: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        if (!res._embedded || !res._embedded.factors) {
          return false;
        }
        const factors = res._embedded.factors;
        const factor = _courage._.findWhere(factors, {
          factorType: 'sms',
          provider: 'OKTA'
        });
        if (!factor || !factor._embedded) {
          return false;
        }
        return !!factor._embedded.phones.length;
      }
    },
    hasExistingPhonesForCall: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        if (!res._embedded || !res._embedded.factors) {
          return false;
        }
        const factors = res._embedded.factors;
        const factor = _courage._.findWhere(factors, {
          factorType: 'call',
          provider: 'OKTA'
        });
        if (!factor || !factor._embedded) {
          return false;
        }
        return !!factor._embedded.phones.length;
      }
    },
    isUndefinedUser: {
      deps: ['securityImage'],
      fn: function (securityImage) {
        return securityImage === UNDEFINED_USER;
      }
    },
    isNewUser: {
      deps: ['securityImage'],
      fn: function (securityImage) {
        return securityImage === NEW_USER;
      }
    },
    allowRememberDevice: {
      deps: ['policy'],
      fn: function (policy) {
        return policy && policy.allowRememberDevice;
      }
    },
    rememberDeviceLabel: {
      deps: ['policy'],
      fn: function (policy) {
        if (policy && policy.rememberDeviceLifetimeInMinutes > 0) {
          const timeString = getMinutesString(policy.rememberDeviceLifetimeInMinutes);
          return (0, _courage.loc)('rememberDevice.timebased', 'login', [timeString]);
        } else if (policy && policy.rememberDeviceLifetimeInMinutes === 0) {
          return (0, _courage.loc)('rememberDevice.devicebased', 'login');
        }
        return (0, _courage.loc)('rememberDevice', 'login');
      }
    },
    rememberDeviceByDefault: {
      deps: ['policy'],
      fn: function (policy) {
        return policy && policy.rememberDeviceByDefault;
      }
    },
    factorsPolicyInfo: {
      deps: ['policy'],
      fn: function (policy) {
        return policy && policy.factorsPolicyInfo ? policy.factorsPolicyInfo : null;
      }
    },
    verifyCustomFactorRedirectUrl: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        if (!res._links || !res._links.next || res._links.next.name !== 'redirect' || !res._links.next.href) {
          return null;
        }
        return res._links.next.href;
      }
    },
    enrollCustomFactorRedirectUrl: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        if (!res._links || !res._links.next || res._links.next.name !== 'activate' || !res._links.next.href) {
          return null;
        }
        return res._links.next.href;
      }
    },
    isFactorResultFailed: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        return res.factorResult === 'FAILED';
      }
    },
    factorResultErrorMessage: {
      deps: ['lastAuthResponse', 'isFactorResultFailed'],
      fn: function (res, isFactorResultFailed) {
        if (isFactorResultFailed) {
          return res.factorResultMessage || (0, _courage.loc)('oform.error.unexpected', 'login');
        }
        return null;
      }
    },
    deviceActivationStatus: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        if (!res._embedded) {
          return null;
        }
        return res._embedded.deviceActivationStatus;
      }
    },
    usingDeviceFlow: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        return !!(res._embedded && res._embedded.usingDeviceFlow);
      }
    },
    userCode: {
      deps: ['lastAuthResponse'],
      fn: function (res) {
        var _res$_embedded2;
        return res === null || res === void 0 ? void 0 : (_res$_embedded2 = res._embedded) === null || _res$_embedded2 === void 0 ? void 0 : _res$_embedded2.userCode;
      }
    }
  },
  parse: function (options) {
    this.settings = options.settings;
    return _courage._.extend(_courage._.omit(options, 'settings'), {
      languageCode: this.settings.get('languageCode'),
      userCountryCode: this.settings.get('countryCode')
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/models/BaseLoginModel.js":
/*!*****************************************!*\
  !*** ./src/v1/models/BaseLoginModel.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const KNOWN_ERRORS = ['OAuthError', 'AuthSdkError', 'AuthPollStopError', 'AuthApiError'];
var _default = _courage.Model.extend({
  // May return either a "standard" promise or a Q promise
  doTransaction: function (fn, rethrow) {
    const self = this;
    return fn.call(this, this.appState.get('transaction')).then(function (trans) {
      self.trigger('setTransaction', trans);
      return trans;
    }).catch(function (err) {
      // Q may still consider AuthPollStopError to be unhandled
      if (err.name === 'AuthPollStopError' || err.name === _Enums.default.AUTH_STOP_POLL_INITIATION_ERROR || err.name === _Enums.default.WEBAUTHN_ABORT_ERROR) {
        return;
      }
      self.trigger('error', self, err.xhr);
      self.trigger('setTransactionError', err);
      if (rethrow || _courage._.indexOf(KNOWN_ERRORS, err.name) === -1) {
        throw err;
      }
    });
  },
  manageTransaction: function (fn) {
    const self = this;
    const res = fn.call(this, this.appState.get('transaction'), _courage._.bind(this.setTransaction, this));

    // If it's a promise, listen for failures
    if (_q.default.isPromiseAlike(res)) {
      return res.catch(function (err) {
        if (err.name === 'AuthPollStopError' || err.name === _Enums.default.AUTH_STOP_POLL_INITIATION_ERROR || err.name === _Enums.default.WEBAUTHN_ABORT_ERROR) {
          return;
        }
        self.trigger('error', self, err.xhr);
        self.trigger('setTransactionError', err);
      });
    }
    return _q.default.resolve(res);
  },
  startTransaction: function (fn) {
    const self = this;
    const res = fn.call(this, this.settings.getAuthClient());

    // If it's a promise, then chain to it
    if (_q.default.isPromiseAlike(res)) {
      return res.then(function (trans) {
        self.trigger('setTransaction', trans);
        return trans;
      }).catch(function (err) {
        self.trigger('error', self, err.xhr);
        self.trigger('setTransactionError', err);
        throw err;
      });
    }
    return _q.default.resolve(res);
  },
  setTransaction: function (trans) {
    this.appState.set('transaction', trans);
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/models/EnrollUser.js":
/*!*************************************!*\
  !*** ./src/v1/models/EnrollUser.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _BaseLoginModel = _interopRequireDefault(__webpack_require__(/*! ./BaseLoginModel */ "./src/v1/models/BaseLoginModel.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the 'License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _BaseLoginModel.default.extend({
  initialize: function (options) {
    this.options = options || {};
    this.appState = this.options.appState;
  },
  constructPostData: function (profileAttributes) {
    const postData = {
      registration: {
        profile: profileAttributes
      }
    };

    // send createNewAccount flag for new user creation
    if (this.appState.get('policy').registration.createNewAccount) {
      postData.registration['createNewAccount'] = true;
    }
    return postData;
  },
  getEnrollFormData: function () {
    return this.manageTransaction(function (transaction, setTransaction) {
      return transaction.enroll().then(function (trans) {
        setTransaction(trans);
      });
    });
  },
  save: function () {
    let data = _BaseLoginModel.default.prototype.toJSON.apply(this, arguments);
    data = _courage._.omit(data, ['appState', 'settings', 'createNewAccount']);
    if (_courage._.isEmpty(data)) {
      const error = {
        errorSummary: (0, _courage.loc)('oform.errorbanner.title', 'login')
      };
      this.trigger('error', this, {
        responseJSON: error
      });
    } else {
      return this.manageTransaction(function (transaction, setTransaction) {
        transaction.enroll(this.constructPostData(data)).then(function (trans) {
          setTransaction(trans);
        });
      });
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/models/Factor.js":
/*!*********************************!*\
  !*** ./src/v1/models/Factor.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _BaseLoginModel = _interopRequireDefault(__webpack_require__(/*! ./BaseLoginModel */ "./src/v1/models/BaseLoginModel.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
/* eslint complexity: [2, 13] */

const PUSH_INTERVAL = 4000;

// Avoid setting interval to same value as keep-alive time (5 seconds) because it
// caused an occasional issue with network connection lost errors in Safari and IE

const FactorFactor = _BaseLoginModel.default.extend({
  extraProperties: true,
  flat: false,
  props: {
    id: 'string',
    factorType: {
      type: 'string',
      values: ['sms', 'call', 'email', 'token', 'token:software:totp', 'token:hotp', 'token:hardware', 'question', 'push', 'u2f', 'password', 'assertion:saml2', 'assertion:oidc', 'claims_provider', 'webauthn']
    },
    provider: {
      type: 'string',
      values: ['OKTA', 'RSA', 'DEL_OATH', 'SYMANTEC', 'GOOGLE', 'YUBICO', 'FIDO', 'CUSTOM', 'GENERIC_SAML', 'GENERIC_OIDC']
    },
    enrollment: {
      type: 'string',
      values: ['OPTIONAL', 'REQUIRED']
    },
    status: {
      type: 'string',
      values: ['NOT_SETUP', 'ACTIVE']
    },
    profile: ['object'],
    vendorName: 'string',
    policy: ['object'],
    profiles: ['object']
  },
  local: {
    answer: 'string',
    password: 'string',
    backupFactor: 'object',
    showAnswer: 'boolean',
    rememberDevice: 'boolean',
    autoPush: ['boolean', true, false]
  },
  derived: {
    isOktaFactor: {
      deps: ['provider'],
      fn: function (provider) {
        return provider === 'OKTA';
      }
    },
    factorName: {
      deps: ['provider', 'factorType'],
      fn: _FactorUtil.default.getFactorName
    },
    factorLabel: {
      deps: ['provider', 'factorType', 'vendorName'],
      fn: function (provider, factorType, vendorName) {
        if (_courage._.contains(['DEL_OATH', 'GENERIC_SAML', 'GENERIC_OIDC', 'CUSTOM'], provider)) {
          return vendorName;
        }
        return _FactorUtil.default.getFactorLabel.apply(this, [provider, factorType]);
      }
    },
    factorDescription: {
      deps: ['provider', 'factorType'],
      fn: _FactorUtil.default.getFactorDescription
    },
    sortOrder: {
      deps: ['provider', 'factorType'],
      fn: _FactorUtil.default.getFactorSortOrder
    },
    iconClassName: {
      deps: ['provider', 'factorType'],
      fn: _FactorUtil.default.getFactorIconClassName
    },
    securityQuestion: {
      deps: ['profile', 'factorType'],
      fn: function (profile, factorType) {
        if (factorType !== 'question') {
          return null;
        }
        return profile && _FactorUtil.default.getSecurityQuestionLabel(profile);
      }
    },
    phoneNumber: {
      deps: ['profile', 'factorType'],
      fn: function (profile, factorType) {
        if (_courage._.contains(['sms', 'call'], factorType)) {
          return profile && profile.phoneNumber;
        }
        return null;
      }
    },
    email: {
      deps: ['profile', 'factorType'],
      fn: function (profile, factorType) {
        if (factorType === 'email') {
          return profile && profile.email;
        }
        return null;
      }
    },
    deviceName: {
      deps: ['profile', 'factorType'],
      fn: function (profile, factorType) {
        if (factorType !== 'push') {
          return null;
        }
        return profile && profile.name;
      }
    },
    enrolled: {
      deps: ['status'],
      fn: function (status) {
        return status === 'ACTIVE';
      }
    },
    cardinality: {
      deps: ['policy', 'profiles'],
      fn: function (policy, profiles) {
        if (profiles && profiles.length > 0) {
          const profile = profiles[0];
          //assume for now we only get one profile (multiple profiles are not supported yet)

          const enrolled = profile._embedded.enrolledFactors.length;
          const adoption = _courage._.findWhere(profile._embedded.features, {
            type: 'adoption'
          });
          if (adoption && adoption.cardinality) {
            return {
              enrolled: enrolled,
              minimum: adoption.cardinality.min,
              maximum: adoption.cardinality.max
            };
          }
          return false;
        } else if (policy && policy.enrollment) {
          return policy.enrollment;
        } else {
          return false;
        }
      }
    },
    additionalEnrollment: {
      deps: ['cardinality'],
      fn: function (cardinality) {
        if (cardinality) {
          return cardinality.enrolled !== 0 && cardinality.enrolled < cardinality.maximum;
        } else {
          return false;
        }
      }
    },
    required: {
      deps: ['enrollment'],
      fn: function (enrollment) {
        return enrollment === 'REQUIRED';
      }
    },
    canUseResend: {
      deps: ['provider', 'factorType'],
      fn: function (provider, factorType) {
        // Only push, sms and call have resend links.
        return provider === 'OKTA' && _courage._.contains(['push', 'sms', 'call', 'email'], factorType);
      }
    },
    isAnswerRequired: {
      deps: ['factorType'],
      fn: function (factorType) {
        return _courage._.contains(['sms', 'call', 'email', 'token', 'token:software:totp', 'question'], factorType);
      }
    },
    isFactorTypeVerification: {
      deps: ['provider', 'id'],
      fn: function (provider, id) {
        return provider === undefined && id === undefined;
      }
    }
  },
  parse: function (attributes) {
    this.settings = attributes.settings;
    this.appState = attributes.appState;
    // set the initial value for remember device.
    attributes.rememberDevice = _FactorUtil.default.getRememberDeviceValue(this.appState);

    // Add vendorname for custom totp enroll
    this.setCustomHotpVendorName(attributes);
    return _courage._.omit(attributes, ['settings', 'appState']);
  },
  validate: function () {
    if (this.get('isAnswerRequired') && !this.get('answer')) {
      return {
        answer: (0, _courage.loc)('model.validation.field.blank')
      };
    } else if (this.get('factorType') === 'password' && !this.get('password')) {
      return {
        password: (0, _courage.loc)('error.password.required')
      };
    }
  },
  needsPasscode: function () {
    // we don't need passcode for email with magic link flow
    return !(this.options.appState.get('isIdxStateToken') && this.get('factorType') === 'email');
  },
  resend: function () {
    this.trigger('form:clear-errors');
    return this.manageTransaction(function (transaction) {
      const firstLink = transaction.data._links.resend[0];
      return transaction.resend(firstLink.name);
    });
  },
  save: function () {
    const rememberDevice = !!this.get('rememberDevice');
    const self = this;
    // Set/Remove the remember device cookie based on the remember device input.

    return this.manageTransaction(function (transaction, setTransaction) {
      const data = {
        rememberDevice: rememberDevice
      };
      if (this.get('factorType') === 'question') {
        data.answer = this.get('answer');
      } else if (this.get('factorType') === 'password') {
        data.password = this.get('password');
      } else if (this.needsPasscode()) {
        data.passCode = this.get('answer');
      }
      if (this.pushFactorHasAutoPush()) {
        data.autoPush = this.get('autoPush');
      }
      let promise;

      // MFA_REQUIRED, FACTOR_REQUIRED or UNAUTHENTICATED with factors (passwordlessAuth)
      if (transaction.status === 'MFA_REQUIRED' || transaction.status === 'FACTOR_REQUIRED' || this.appState.get('promptForFactorInUnauthenticated')) {
        const factor = this._findFactor(transaction);
        promise = factor.verify(data);
      } else if (this.get('canUseResend') && !this.get('answer') && transaction.resend) {
        // MFA_CHALLENGE/ FACTOR_CHALLENGE
        const firstLink = transaction.data._links.resend[0];
        promise = transaction.resend(firstLink.name);
      } else {
        promise = transaction.verify(data);
      }
      //the 'save' event here is triggered and used in the BaseLoginController
      //to disable the primary button on the factor form
      this.trigger('save');
      return promise.then(function (trans) {
        const options = {
          delay: PUSH_INTERVAL,
          transactionCallBack: transaction => {
            self.options.appState.set('lastAuthResponse', transaction);
          }
        };
        setTransaction(trans);
        // In Okta verify case we initiate poll.
        if (trans.status === 'MFA_CHALLENGE' && trans.poll || trans.status === 'FACTOR_CHALLENGE' && trans.poll) {
          const deferred = _q.default.defer();
          const initiatePollTimout = _Util.default.callAfterTimeout(deferred.resolve, PUSH_INTERVAL);
          self.listenToOnce(self.options.appState, 'factorSwitched', () => {
            clearTimeout(initiatePollTimout);
            deferred.reject(new _Errors.AuthStopPollInitiationError());
          });
          return deferred.promise.then(function () {
            // Stop listening if factor was not switched before poll.
            self.stopListening(self.options.appState, 'factorSwitched');
            if (self.pushFactorHasAutoPush()) {
              options.autoPush = function () {
                return self.get('autoPush');
              };
              options.rememberDevice = function () {
                return self.get('rememberDevice');
              };
            }
            return trans.poll(options).then(function (trans) {
              self.options.appState.set('lastAuthResponse', trans.data);
              setTransaction(trans);
            });
          });
        }
      });
    });
  },
  _findFactor: function (transaction) {
    let factor;
    if (transaction.factorTypes) {
      factor = _courage._.findWhere(transaction.factorTypes, {
        factorType: this.get('factorType')
      });
    }
    if (!factor) {
      factor = _courage._.findWhere(transaction.factors, {
        id: this.get('id')
      });
    }
    return factor;
  },
  pushFactorHasAutoPush: function () {
    return this.settings.get('features.autoPush') && this.get('factorType') === 'push';
  },
  setCustomHotpVendorName: function (attributes) {
    // If factor is token:hotp and not enrolled, we assume the first profile is the default.
    // If factor is enrolled, we only support one profile to be enrolled, so find that one
    // and display as enrolled profile. We do this by populating profile name in vendorName.
    if (attributes.factorType === 'token:hotp' && attributes.profiles) {
      if (attributes.status === 'NOT_SETUP') {
        attributes.vendorName = attributes.profiles[0].name;
      } else if (attributes.status === 'ACTIVE') {
        const enrolledProfiles = attributes.profiles.filter(profile => {
          return profile._embedded.enrolledFactors.length > 0;
        });
        attributes.vendorName = enrolledProfiles[0].name;
      }
    }
    return attributes;
  }
});
const FactorFactors = _courage.Collection.extend({
  model: FactorFactor,
  comparator: 'sortOrder',
  // One override necessary here - When Okta Verify OTP and Push are in the list,
  // they are presented in the view as one factor - in the beacon menu,
  // there's only one option (Okta Verify), and we show a form with Push
  // with an inline totp option. What we need to do is to add totp
  // as a "backupFactor" for push
  parse: function (factors) {
    // Keep a track of the last used factor, since
    // we need it to determine the default factor.
    this.lastUsedFactor = factors[0];
    const oktaPushFactor = _courage._.findWhere(factors, {
      provider: 'OKTA',
      factorType: 'push'
    });
    let totpFactor;
    if (_courage._.where(factors, {
      factorType: 'push'
    }).length > 1) {
      totpFactor = _courage._.findWhere(factors, {
        factorType: 'token:software:totp'
      });
    } else {
      totpFactor = _courage._.findWhere(factors, {
        provider: 'OKTA',
        factorType: 'token:software:totp'
      });
    }
    if (!oktaPushFactor || !totpFactor) {
      return factors;
    }
    const isTotpFirst = totpFactor === factors[0];
    const parsedFactors = _courage._.reduce(factors, function (memo, factor) {
      const isOkta = factor.provider === 'OKTA';
      const isOktaTotp = isOkta && factor.factorType === 'token:software:totp';
      const isOktaPush = isOkta && factor.factorType === 'push';
      const notEnrolled = factor.status !== 'ACTIVE';
      const hideOktaTotp = isOktaTotp && (notEnrolled || oktaPushFactor.status === 'ACTIVE');
      const hideOktaPush = isOktaPush && notEnrolled && totpFactor.status === 'ACTIVE';
      if (hideOktaTotp || hideOktaPush) {
        return memo;
      }
      if (isOktaPush) {
        factor.backupFactor = new FactorFactor(totpFactor, {
          parse: true
        });
      }
      memo.push(factor);
      return memo;
    }, []);

    // Use push factor instead of TOTP, if TOTP is first in the list
    // (since it is stored as backupFactor for push).
    if (isTotpFirst) {
      this.lastUsedFactor = oktaPushFactor;
    }
    return parsedFactors;
  },
  // Will need to update this to use HAL link to get last used factor:
  // https://oktainc.atlassian.net/browse/OKTA-58380
  // However, current code returns last used factor as first factor in list.
  // Also, will need to add priority - i.e. if they do not have a last used
  // factor, should try Okta Verify, then Okta SMS, etc.
  getDefaultFactor: function () {
    const factor = _courage._.pick(this.lastUsedFactor, 'factorType', 'provider');
    return this.findWhere(factor);
  },
  getFirstUnenrolledRequiredFactor: function () {
    return this.findWhere({
      required: true,
      enrolled: false
    });
  },
  _getFactorsOfType: function (factorType) {
    return this.where({
      factorType: factorType
    });
  },
  getFactorIndex: function (factorType, factorId) {
    return this._getFactorsOfType(factorType).findIndex(function (factor) {
      return factor.get('id') === factorId;
    });
  },
  hasMultipleFactorsOfSameType: function (factorType) {
    return this._getFactorsOfType(factorType).length > 1;
  },
  getFactorByTypeAndIndex: function (factorType, factorIndex) {
    return this._getFactorsOfType(factorType)[factorIndex];
  }
});
var _default = {
  Model: FactorFactor,
  Collection: FactorFactors
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/models/IDPDiscovery.js":
/*!***************************************!*\
  !*** ./src/v1/models/IDPDiscovery.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _PrimaryAuth = _interopRequireDefault(__webpack_require__(/*! v1/models/PrimaryAuth */ "./src/v1/models/PrimaryAuth.js"));
var _CookieUtil = _interopRequireDefault(__webpack_require__(/*! util/CookieUtil */ "./src/util/CookieUtil.js"));
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _PrimaryAuth.default.extend({
  props: function () {
    const cookieUsername = _CookieUtil.default.getCookieUsername();
    const properties = this.getUsernameAndRemember(cookieUsername);
    return {
      username: ['string', true, properties.username],
      lastUsername: ['string', false, cookieUsername],
      context: ['object', false],
      remember: ['boolean', true, properties.remember]
    };
  },
  local: {},
  save: function () {
    const username = this.settings.transformUsername(this.get('username'), _Enums.default.IDP_DISCOVERY);
    const remember = this.get('remember');
    const lastUsername = this.get('lastUsername');
    const resource = 'okta:acct:' + username;
    const requestContext = this.get('requestContext');
    this.setUsernameCookie(username, remember, lastUsername);

    //the 'save' event here is triggered and used in the BaseLoginController
    //to disable the primary button
    this.trigger('save');
    this.appState.trigger('loading', true);
    const webfingerArgs = {
      resource: resource,
      requestContext: requestContext
    };
    const authClient = this.appState.settings.getAuthClient();
    authClient.webfinger(webfingerArgs).then(res => {
      if (res && res.links && res.links[0]) {
        if (res.links[0].properties['okta:idp:type'] === 'OKTA') {
          this.trigger('goToPrimaryAuth');
        } else if (res.links[0].href) {
          const redirectFn = res.links[0].href.includes('OKTA_INVALID_SESSION_REPOST%3Dtrue') ? _Util.default.redirectWithFormGet.bind(_Util.default) : this.settings.get('redirectUtilFn');
          //override redirectFn to only use Util.redirectWithFormGet if OKTA_INVALID_SESSION_REPOST is included
          //it will be encoded since it will be included in the encoded fromURI

          redirectFn(res.links[0].href);
        }
      }
    }).catch(() => {
      // webfinger request might fail when corporate proxy checks if request is 'authenticated' using cookies
      const error = {
        errorSummary: (0, _courage.loc)('oform.error.webfinger', 'login')
      };
      this.trigger('error', this, {
        responseJSON: error
      });
      // Specific event handled by the Header for the case where the security image is not
      // enabled and we want to show a spinner. (Triggered only here and handled only by Header).
      this.appState.trigger('removeLoading');
      _CookieUtil.default.removeUsernameCookie();
    }).finally(() => {
      this.appState.trigger('loading', false);
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/models/LoginModel.js":
/*!*************************************!*\
  !*** ./src/v1/models/LoginModel.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _BaseLoginModel = _interopRequireDefault(__webpack_require__(/*! ./BaseLoginModel */ "./src/v1/models/BaseLoginModel.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _BaseLoginModel.default.extend({
  constructor: function (options) {
    this.settings = options && options.settings;
    _courage.Model.apply(this, arguments);
  },
  loginWithActivationToken: function (activationToken) {
    return this.startTransaction(function (authClient) {
      return authClient.signInWithCredentials({
        token: activationToken
      });
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/models/PrimaryAuth.js":
/*!**************************************!*\
  !*** ./src/v1/models/PrimaryAuth.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _CookieUtil = _interopRequireDefault(__webpack_require__(/*! util/CookieUtil */ "./src/util/CookieUtil.js"));
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _BaseLoginModel = _interopRequireDefault(__webpack_require__(/*! ./BaseLoginModel */ "./src/v1/models/BaseLoginModel.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _BaseLoginModel.default.extend({
  props: function () {
    const cookieUsername = _CookieUtil.default.getCookieUsername();
    const properties = this.getUsernameAndRemember(cookieUsername);
    const props = {
      username: {
        type: 'string',
        validate: function (value) {
          if (_courage._.isEmpty(value)) {
            return (0, _courage.loc)('error.username.required', 'login');
          }
        },
        value: properties.username
      },
      lastUsername: ['string', false, cookieUsername],
      context: ['object', false],
      remember: ['boolean', true, properties.remember],
      multiOptionalFactorEnroll: ['boolean', true]
    };
    if (!(this.settings && this.settings.get('features.passwordlessAuth'))) {
      props.password = {
        type: 'string',
        validate: function (value) {
          if (_courage._.isEmpty(value)) {
            return (0, _courage.loc)('error.password.required', 'login');
          }
        }
      };
    }
    return props;
  },
  getUsernameAndRemember: function (cookieUsername) {
    const settingsUsername = this.settings && this.settings.get('username');
    const rememberMeEnabled = this.settings && this.settings.get('features.rememberMe');
    let remember = false;
    let username;
    if (settingsUsername) {
      username = settingsUsername;
      remember = rememberMeEnabled && username === cookieUsername;
    } else if (rememberMeEnabled && cookieUsername) {
      // Only respect the cookie if the feature is enabled.
      // Allows us to force prompting when necessary, e.g. SAML ForceAuthn
      username = cookieUsername;
      remember = true;
    }
    return {
      username: username,
      remember: remember
    };
  },
  constructor: function (options) {
    this.settings = options && options.settings;
    this.appState = options && options.appState;
    _courage.Model.apply(this, arguments);
    this.listenTo(this, 'change:username', function (model, username) {
      this.set({
        remember: username === this.get('lastUsername')
      });
    });
  },
  parse: function (options) {
    return _courage._.omit(options, ['settings', 'appState']);
  },
  save: function () {
    const username = this.settings.transformUsername(this.get('username'), _Enums.default.PRIMARY_AUTH);
    const remember = this.get('remember');
    const lastUsername = this.get('lastUsername');
    this.setUsernameCookie(username, remember, lastUsername);

    //the 'save' event here is triggered and used in the BaseLoginController
    //to disable the primary button on the primary auth form
    this.trigger('save');
    this.appState.trigger('loading', true);
    const signInArgs = this.getSignInArgs(username);
    let primaryAuthPromise;
    if (this.appState.get('isUnauthenticated')) {
      const authClient = this.appState.settings.getAuthClient();

      // bootstrapped with stateToken
      if (this.appState.get('isIdxStateToken')) {
        // if its an idx stateToken, we send the parameter as identifier to login API
        primaryAuthPromise = this.doTransaction(function (transaction) {
          return this.doPrimaryAuth(authClient, signInArgs, transaction.login);
        });
      } else {
        primaryAuthPromise = this.doTransaction(function (transaction) {
          return this.doPrimaryAuth(authClient, signInArgs, transaction.authenticate);
        }, true);
      }
    } else {
      //normal username/password flow without stateToken
      primaryAuthPromise = this.startTransaction(function (authClient) {
        return this.doPrimaryAuth(authClient, signInArgs, _courage._.bind(authClient.signInWithCredentials, authClient));
      });
    }
    return primaryAuthPromise.catch(() => {
      // Specific event handled by the Header for the case where the security image is not
      // enabled and we want to show a spinner. (Triggered only here and handled only by Header).
      this.appState.trigger('removeLoading');
      _CookieUtil.default.removeUsernameCookie();
    }).finally(() => {
      this.appState.trigger('loading', false);
    });
  },
  getSignInArgs: function (username) {
    const multiOptionalFactorEnroll = this.get('multiOptionalFactorEnroll');
    const signInArgs = {};
    if (!this.settings.get('features.passwordlessAuth')) {
      signInArgs.password = this.get('password');
    }

    // if its an idx stateToken, we send the parameter as identifier to login API
    if (this.appState.get('isIdxStateToken')) {
      signInArgs.identifier = username;
    } else {
      //only post options param for non-idx flows
      signInArgs.username = username;
      signInArgs.options = {
        warnBeforePasswordExpired: true,
        multiOptionalFactorEnroll: multiOptionalFactorEnroll
      };
    }
    return signInArgs;
  },
  setUsernameCookie: function (username, remember, lastUsername) {
    // Do not modify the cookie when feature is disabled, relevant for SAML ForceAuthn prompts
    if (this.settings.get('features.rememberMe')) {
      // Only delete the cookie if its owner says so. This allows other
      // users to log in on a one-off basis.
      if (!remember && lastUsername === username) {
        _CookieUtil.default.removeUsernameCookie();
      } else if (remember) {
        _CookieUtil.default.setUsernameCookie(username);
      }
    }
  },
  doPrimaryAuth: function (authClient, signInArgs, func) {
    const deviceFingerprintEnabled = this.settings.get('features.deviceFingerprinting');
    const typingPatternEnabled = this.settings.get('features.trackTypingPattern');

    // Add the custom header for fingerprint, typing pattern if needed, and then remove it afterwards
    // Since we only need to send it for primary auth
    if (deviceFingerprintEnabled && this.appState.get('deviceFingerprint')) {
      authClient.http.setRequestHeader('X-Device-Fingerprint', this.appState.get('deviceFingerprint'));
    }
    if (typingPatternEnabled && this.appState.get('typingPattern')) {
      authClient.http.setRequestHeader('X-Typing-Pattern', this.appState.get('typingPattern'));
    }
    const self = this;
    return func(signInArgs).finally(function () {
      if (deviceFingerprintEnabled) {
        authClient.http.setRequestHeader('X-Device-Fingerprint', undefined);
        self.appState.unset('deviceFingerprint'); //Fingerprint can only be used once
      }

      if (typingPatternEnabled) {
        authClient.http.setRequestHeader('X-Typing-Pattern', undefined);
        self.appState.unset('typingPattern');
      }
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/models/ProfileSchema.js":
/*!****************************************!*\
  !*** ./src/v1/models/ProfileSchema.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

let {
  BaseSchema
} = _courage.internal.models;
var _default = BaseSchema.Model.extend({
  expand: ['schema'],
  setFieldPlaceholder: function (formFields) {
    _courage._.each(formFields, function (formField) {
      formField.title = formField.label;
    });
    return formFields;
  },
  initialize: function (options) {
    let profileAttributes = options.profileSchemaAttributes;
    profileAttributes = this.setFieldPlaceholder(profileAttributes);
    if (profileAttributes) {
      const userProfileSchema = {
        properties: {}
      };
      for (var i = 0; i < profileAttributes.length; i++) {
        const profileAttributeObject = profileAttributes[i];
        userProfileSchema.properties[profileAttributeObject.name] = profileAttributeObject;
      }
      this.parse.apply(this, [{
        schema: userProfileSchema
      }]);
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/models/RegistrationSchema.js":
/*!*********************************************!*\
  !*** ./src/v1/models/RegistrationSchema.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

let {
  BaseSchema,
  SchemaProperty
} = _courage.internal.models;
const RegistrationSchemaRegistrationSchemaPropertyCollection = SchemaProperty.Collection.extend({
  createModelProperties: function () {
    const modelProperties = SchemaProperty.Collection.prototype.createModelProperties.apply(this);
    _courage._.each(modelProperties, function (modelProperty, name) {
      modelProperty.required = !!this.get(name).get('required');
    }, this);
    return modelProperties;
  }
});
var _default = BaseSchema.Model.extend({
  expand: ['schema'],
  constructor: function () {
    this.properties = new RegistrationSchemaRegistrationSchemaPropertyCollection();
    _courage.BaseModel.apply(this, arguments);
  },
  parse: function (resp) {
    const parseResponseData = resp => {
      const requireFields = resp.schema.required;
      if (_courage._.isArray(requireFields)) {
        _courage._.each(requireFields, function (requireField) {
          const field = this.properties.get(requireField);
          if (field) {
            field.set('required', true);
          }
        }, this);
      }
      const fieldOrderIds = resp.schema.fieldOrder;
      if (_courage._.isArray(fieldOrderIds)) {
        _courage._.each(fieldOrderIds, function (fieldOrderId, sortOrder) {
          const field = this.properties.get(fieldOrderId);
          if (field) {
            field.set('sortOrder', sortOrder);
          }
        }, this);
        this.properties.comparator = 'sortOrder';
        this.properties.sort();
      }
      this.properties.defaultPolicyId = resp.policyId;
      return resp;
    };
    const self = this;
    this.settings.parseRegistrationSchema(resp, function (resp) {
      if (resp.profileSchema) {
        resp.schema = resp.profileSchema;
        BaseSchema.Model.prototype.parse.apply(self, [resp]);
        resp = parseResponseData(resp);
      }
      self.trigger('parseComplete', {
        properties: self.properties
      });
    }, function (error) {
      self.trigger('parseComplete', {
        properties: self.properties,
        error: error
      });
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/util/BaseLoginController.js":
/*!********************************************!*\
  !*** ./src/v1/util/BaseLoginController.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

function getForm(controller) {
  return _courage._.find(controller.getChildren(), function (item) {
    return item instanceof _courage.Form;
  });
}
var _default = _courage.Controller.extend({
  // Ideally we should be attaching the listeners in the constructor, but because of the way
  // we construct the FormController (this.model is generated after the BaseLoginController's
  // constructor is called), this.model is undefined in when try to attach the events and
  // therefore we don't listen to events for such forms. And changing the order in which we call
  // the constructor doesn't help either (JS errors etc.). This at least guarantees that we
  // are listening to the model events.
  // Note - Figure out a way to call the constructor in the right order.
  addListeners: function () {
    // Events to enable/disable the primary button on the forms
    this.listenTo(this.model, 'save', function () {
      const form = getForm(this);
      //disable the submit button on forms while making the request
      //to prevent users from hitting rate limiting exceptions of
      //1 per second on the auth api

      const disableSubmitButton = form.disableSubmitButton;
      if (disableSubmitButton && !form.disableSubmitButton()) {
        return;
      }
      this.toggleButtonState(true);
    });
    this.listenTo(this.model, 'error', function () {
      this.toggleButtonState(false);
    });
    this.addModelListeners(this.model);
  },
  addModelListeners: function (model) {
    const setTransactionHandler = transaction => {
      this.options.appState.set('transaction', transaction);
    };
    const transactionErrorHandler = err => {
      this.options.appState.set('transactionError', err);
    };

    // Events to set the transaction attributes on the app state.
    this.listenTo(model, 'setTransaction', setTransactionHandler);
    this.listenTo(model, 'setTransactionError', transactionErrorHandler);

    // For TOTP factor model
    // TOTP model is special, its model will not be attached to a controller, but will
    // tag along with the push factor model. We need to listen to the transaction
    // changes on this as well (in case of the push+totp form).
    const totpModel = model.get('backupFactor');
    if (totpModel) {
      this.listenTo(totpModel, 'setTransaction', setTransactionHandler);
      this.listenTo(totpModel, 'setTransactionError', transactionErrorHandler);
    }
  },
  // Override this method to delay switching to this screen until return
  // promise is resolved. This is useful for cases like enrolling a security
  // question, which requires an additional request to fetch the question
  // list.
  fetchInitialData: function () {
    return (0, _q.default)();
  },
  // Override this method to prevent route navigation. This is useful for
  // intermediate status changes that do not trigger a full refresh of the
  // page, like MFA_ENROLL_ACTIVATE and MFA_CHALLENGE.
  trapAuthResponse: function () {
    return false;
  },
  toJSON: function () {
    const data = _courage.Controller.prototype.toJSON.apply(this, arguments);
    return _courage._.extend(_courage._.pick(this.options, 'appState'), data);
  },
  toggleButtonState: function (state) {
    const button = this.$el.find('.button');
    button.toggleClass('link-button-disabled', state).prop('disabled', state);
  },
  postRenderAnimation: function () {
    // Event triggered after a page is rendered along with the classname to identify the page
    // TODO: Deprecate this event in the next major version in favor of 'afterRender'
    this.trigger('pageRendered', {
      page: this.className
    });
    this.trigger('afterRender', {
      controller: this.className
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/util/DeviceFingerprint.js":
/*!******************************************!*\
  !*** ./src/v1/util/DeviceFingerprint.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = {
  getUserAgent: function () {
    return navigator.userAgent;
  },
  isMessageFromCorrectSource: function ($iframe, event) {
    return event.source === $iframe[0].contentWindow;
  },
  generateDeviceFingerprint: function (oktaDomainUrl, element) {
    const userAgent = this.getUserAgent();
    if (!userAgent) {
      return _q.default.reject('user agent is not defined');
    } else if (isWindowsPhone(userAgent)) {
      return _q.default.reject('device fingerprint is not supported on Windows phones');
    }
    const deferred = _q.default.defer();
    const self = this;
    let $iframe;
    let iFrameTimeout;
    function isWindowsPhone(userAgent) {
      return userAgent.match(/windows phone|iemobile|wpdesktop/i);
    }
    function removeIframe() {
      $iframe.off();
      $iframe.remove();
      window.removeEventListener('message', onMessageReceivedFromOkta, false);
    }
    function handleError(reason) {
      removeIframe();
      deferred.reject(reason);
    }
    function onMessageReceivedFromOkta(event) {
      if (!self.isMessageFromCorrectSource($iframe, event)) {
        return;
      }
      // deviceFingerprint service is available, clear timeout
      clearTimeout(iFrameTimeout);
      if (!event || !event.data || event.origin !== oktaDomainUrl) {
        handleError('no data');
        return;
      }
      try {
        const message = JSON.parse(event.data);
        if (message && message.type === 'FingerprintServiceReady') {
          sendMessageToOkta({
            type: 'GetFingerprint'
          });
        } else if (message && message.type === 'FingerprintAvailable') {
          removeIframe();
          deferred.resolve(message.fingerprint);
        } else {
          handleError('no data');
        }
      } catch (error) {
        //Ignore any errors since we could get other messages too
      }
    }
    function sendMessageToOkta(message) {
      const win = $iframe[0].contentWindow;
      if (win) {
        win.postMessage(JSON.stringify(message), oktaDomainUrl);
      }
    }

    // Attach listener
    window.addEventListener('message', onMessageReceivedFromOkta, false);
    // Create and Load devicefingerprint page inside the iframe
    $iframe = (0, _courage.$)('<iframe>', {
      css: {
        display: 'none'
      },
      src: oktaDomainUrl + '/auth/services/devicefingerprint'
    });
    element.append($iframe);
    iFrameTimeout = setTimeout(() => {
      // If the iFrame does not load, throw an error
      handleError('service not available');
    }, 2000);
    return deferred.promise;
  }
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/util/FormController.js":
/*!***************************************!*\
  !*** ./src/v1/util/FormController.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _BaseLoginModel = _interopRequireDefault(__webpack_require__(/*! v1/models/BaseLoginModel */ "./src/v1/models/BaseLoginModel.js"));
var _BaseLoginController = _interopRequireDefault(__webpack_require__(/*! ./BaseLoginController */ "./src/v1/util/BaseLoginController.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! ./FormType */ "./src/v1/util/FormType.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

let {
  Toolbar
} = _courage.internal.views.forms.components;
let {
  FormUtil
} = _courage.internal.views.forms.helpers;
const FormControllerSimpleForm = _courage.Form.extend({
  layout: 'o-form-theme',
  noCancelButton: true,
  constructor: function (options) {
    _courage.Form.call(this, options);
    _courage._.each(_courage._.result(this, 'formChildren') || [], function (child) {
      switch (child.type) {
        case _FormType.default.INPUT:
          this.addInput(_courage._.extend({
            label: false,
            'label-top': true
          }, child.viewOptions));
          break;
        case _FormType.default.BUTTON:
          this.add((0, _courage.createButton)(_courage._.extend({
            model: this.model
          }, child.viewOptions)), child.addOptions);
          FormUtil.applyShowWhen(this.last(), child.viewOptions && child.viewOptions.showWhen);
          break;
        case _FormType.default.DIVIDER:
          this.addDivider(child.viewOptions);
          break;
        case _FormType.default.TOOLBAR:
          this.add(Toolbar, {
            options: child.viewOptions
          });
          FormUtil.applyShowWhen(this.last(), child.viewOptions && child.viewOptions.showWhen);
          break;
        case _FormType.default.VIEW:
          this.add(child.viewOptions.View, child.addOptions);
          FormUtil.applyShowWhen(this.last(), child.viewOptions.showWhen);
          break;
        default:
          throw new Error('Unrecognized child type: ' + child.type);
      }
    }, this);
  }
});
var _default = _BaseLoginController.default.extend({
  constructor: function () {
    const initialize = this.initialize;
    this.initialize = function () {};
    _BaseLoginController.default.apply(this, arguments);
    if (this.Model && this.Form) {
      const Model = _BaseLoginModel.default.extend(_courage._.extend({
        parse: function (attributes) {
          this.settings = attributes.settings;
          this.appState = attributes.appState;
          return _courage._.omit(attributes, ['settings', 'appState']);
        }
      }, _courage._.result(this, 'Model')));
      this.model = new Model({
        settings: this.settings,
        appState: this.options.appState
      }, {
        parse: true
      });
      const Form = FormControllerSimpleForm.extend(_courage._.result(this, 'Form', this));
      this.form = new Form(this.toJSON());
      this.add(this.form);
    }
    if (this.Footer) {
      this.addFooter(this.Footer);
    }
    this.addListeners();
    initialize.apply(this, arguments);
  },
  addFooter: function (Footer, args) {
    this.footer = new Footer(_courage._.extend(this.toJSON(), args || {}));
    this.add(this.footer);
  },
  toJSON: function () {
    const data = _BaseLoginController.default.prototype.toJSON.apply(this, arguments);
    return _courage._.extend(_courage._.pick(this.options, 'appState'), data);
  },
  back: function () {
    if (this.footer && this.footer.back) {
      this.footer.back();
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/util/FormType.js":
/*!*********************************!*\
  !*** ./src/v1/util/FormType.js ***!
  \*********************************/
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const INPUT = 'INPUT';

// Syntactic sugar to provide some structure to SimpleForm inputs - Just
// wraps options with { type: type, viewOptions: viewOptions, addOptions: addOptions }

const BUTTON = 'BUTTON';
const DIVIDER = 'DIVIDER';
const TOOLBAR = 'TOOLBAR';
const VIEW = 'VIEW';
function wrap(type) {
  return function (viewOptions, addOptions) {
    return {
      type: type,
      viewOptions: viewOptions,
      addOptions: addOptions
    };
  };
}
var _default = {
  Input: wrap(INPUT),
  Button: wrap(BUTTON),
  Divider: wrap(DIVIDER),
  Toolbar: wrap(TOOLBAR),
  View: wrap(VIEW),
  INPUT: INPUT,
  BUTTON: BUTTON,
  DIVIDER: DIVIDER,
  TOOLBAR: TOOLBAR,
  VIEW: VIEW
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/util/RegistrationFormFactory.js":
/*!************************************************!*\
  !*** ./src/v1/util/RegistrationFormFactory.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint max-statements: [2, 23],  max-depth: [2, 3], complexity: [2, 13] */
/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

let {
  SchemaFormFactory
} = _courage.internal.views.forms.helpers;
const getParts = function (username) {
  const usernameArr = username.split('');
  const minPartsLength = 4;
  const userNameParts = [];
  const delimiters = [',', '.', '-', '_', '#', '@'];
  let userNamePart = '';
  _courage._.each(usernameArr, function (part) {
    if (delimiters.indexOf(part) === -1) {
      userNamePart += part;
    } else {
      if (userNamePart.length >= minPartsLength) {
        userNameParts.push(_courage._.clone(userNamePart));
      }
      userNamePart = '';
    }
  });
  if (userNamePart.length >= minPartsLength) {
    userNameParts.push(_courage._.clone(userNamePart));
  }
  return userNameParts.filter(Boolean);
};
const passwordContainsFormField = function (formField, password) {
  if (!formField) {
    return false;
  }
  formField = formField.toLowerCase();
  password = password.toLowerCase();
  const formFieldArr = getParts(formField);

  //check if each formField part contains password
  for (var i = 0; i < formFieldArr.length; i++) {
    const formFieldPart = formFieldArr[i];
    if (password.indexOf(formFieldPart) !== -1) {
      return true;
    }
  }
  return false;
};
const checkSubSchema = function (subSchema, value, model) {
  const minLength = subSchema.get('minLength');
  const maxLength = subSchema.get('maxLength');
  const regex = subSchema.get('format');
  if (_courage._.isNumber(minLength)) {
    if (value.length < minLength) {
      return false;
    }
  }
  if (_courage._.isNumber(maxLength)) {
    if (value.length > maxLength) {
      return false;
    }
  }
  const password = value;
  if (_courage._.isString(regex)) {
    // call passwordContainsFormField if regex is userName, firstName, lastName
    if (regex === '^[#/userName]' || regex === '^[#/firstName]' || regex === '^[#/lastName]') {
      const fieldName = regex.split('^[#/')[1].split(']')[0];
      let fieldValue = model.get(fieldName);
      if (fieldName === 'userName') {
        // with email as login enabled, we only have email populated
        // Therefore we fallback and run validation with email attribute.
        fieldValue = model.has('userName') ? model.get('userName') : model.get('email');
      }
      return !passwordContainsFormField(fieldValue, password);
    } else {
      if (!new RegExp(regex).test(value)) {
        return false;
      }
    }
  }
  return true;
};
const checkSubSchemas = function (fieldName, model, subSchemas, showError) {
  const value = model.get(fieldName);
  if (!_courage._.isString(value)) {
    return;
  }
  subSchemas.each(function (subSchema, index) {
    const ele = (0, _courage.$)('#subschemas-' + fieldName + ' .subschema-' + index);

    //hide password complexity if no password
    if (value) {
      ele.children('p').removeClass('default-schema');
    } else {
      ele.children('p').addClass('default-schema');
    }

    // clear aria role and live-region for re-validation
    ele.children('p').removeAttr('role').removeAttr('aria-live');

    // reset errors
    ele.removeClass('subschema-satisfied subschema-unsatisfied subschema-error');

    // validate
    if (checkSubSchema(subSchema, value, model)) {
      // passed
      ele.addClass('subschema-satisfied');
      ele.find('p span').removeClass('error error-16-small');
      ele.find('p span').addClass('confirm-16');
    } else {
      // failed
      if (showError) {
        ele.find('p span').removeClass('confirm-16');
        ele.find('p span').addClass('error error-16-small');
        ele.addClass('subschema-error subschema-unsatisfied');
        ele.find('p')
        // set role="alert" so the password requirement is read by
        // screen-readers
        .attr('role', 'alert')
        // set aria-live="polite" so it will "debounce" and wait to read the
        // message between keystrokes
        .attr('aria-live', 'polite');
      }
    }
  });
};
const fnCreateInputOptions = function (schemaProperty) {
  let inputOptions = SchemaFormFactory.createInputOptions(schemaProperty);
  if (inputOptions.type === 'select') {
    inputOptions = _courage._.extend(inputOptions, {
      label: schemaProperty.get('title')
    });
  } else {
    let placeholder = schemaProperty.get('title');
    if (schemaProperty.get('required')) {
      placeholder += ' *';
    }
    inputOptions = _courage._.extend(inputOptions, {
      label: false,
      'label-top': true,
      placeholder: placeholder
    });
  }
  const fieldName = schemaProperty.get('name');
  switch (fieldName) {
    case 'userName':
      inputOptions.input = _TextBox.default;
      inputOptions.params = {
        icon: 'person-16-gray'
      };
      break;
    case 'password':
      inputOptions.type = 'password';
      inputOptions.input = _TextBox.default;
      inputOptions.params = {
        icon: 'remote-lock-16'
      };
  }
  const subSchemas = schemaProperty.get('subSchemas');
  if (subSchemas) {
    inputOptions.events = {
      input: function () {
        checkSubSchemas(fieldName, this.model, subSchemas, true);
      },
      focusout: function () {
        checkSubSchemas(fieldName, this.model, subSchemas, true);
      },
      'change:userName': function () {
        checkSubSchemas(fieldName, this.model, subSchemas, true);
      },
      'change:firstName': function () {
        checkSubSchemas(fieldName, this.model, subSchemas, true);
      },
      'change:lastName': function () {
        checkSubSchemas(fieldName, this.model, subSchemas, true);
      },
      'change:email': function () {
        checkSubSchemas(fieldName, this.model, subSchemas, true);
      }
    };
  }
  return inputOptions;
};
var _default = {
  createInputOptions: fnCreateInputOptions,
  getUsernameParts: getParts,
  passwordContainsFormField: passwordContainsFormField
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/util/RouterUtil.js":
/*!***********************************!*\
  !*** ./src/v1/util/RouterUtil.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _BrowserFeatures = _interopRequireDefault(__webpack_require__(/*! util/BrowserFeatures */ "./src/util/BrowserFeatures.ts"));
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _ErrorCodes = _interopRequireDefault(__webpack_require__(/*! util/ErrorCodes */ "./src/util/ErrorCodes.js"));
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _OAuth2Util = _interopRequireDefault(__webpack_require__(/*! util/OAuth2Util */ "./src/util/OAuth2Util.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 47], max-statements: [2, 63] */

const fn = {};
const verifyUrlTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      alias2 = container.hooks.helperMissing,
      alias3 = "function",
      alias4 = container.escapeExpression,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "signin/verify/" + alias4((helper = (helper = lookupProperty(helpers, "provider") || (depth0 != null ? lookupProperty(depth0, "provider") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "provider",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 14
        },
        "end": {
          "line": 1,
          "column": 26
        }
      }
    }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "factorType",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 27
        },
        "end": {
          "line": 1,
          "column": 41
        }
      }
    }) : helper));
  },
  "useData": true
});
const verifyUrlMultipleTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      alias2 = container.hooks.helperMissing,
      alias3 = "function",
      alias4 = container.escapeExpression,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "signin/verify/" + alias4((helper = (helper = lookupProperty(helpers, "provider") || (depth0 != null ? lookupProperty(depth0, "provider") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "provider",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 14
        },
        "end": {
          "line": 1,
          "column": 26
        }
      }
    }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "factorType",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 27
        },
        "end": {
          "line": 1,
          "column": 41
        }
      }
    }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorIndex") || (depth0 != null ? lookupProperty(depth0, "factorIndex") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "factorIndex",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 42
        },
        "end": {
          "line": 1,
          "column": 57
        }
      }
    }) : helper));
  },
  "useData": true
});
const verifyUrlNoProviderTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "signin/verify/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "factorType",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 14
        },
        "end": {
          "line": 1,
          "column": 28
        }
      }
    }) : helper));
  },
  "useData": true
});
const enrollFactorUrlTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      alias2 = container.hooks.helperMissing,
      alias3 = "function",
      alias4 = container.escapeExpression,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "signin/enroll/" + alias4((helper = (helper = lookupProperty(helpers, "provider") || (depth0 != null ? lookupProperty(depth0, "provider") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "provider",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 14
        },
        "end": {
          "line": 1,
          "column": 26
        }
      }
    }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "factorType",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 27
        },
        "end": {
          "line": 1,
          "column": 41
        }
      }
    }) : helper));
  },
  "useData": true
});
const activateFactorUrlTpl = _runtime.default.template({
  "1": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "step") || (depth0 != null ? lookupProperty(depth0, "step") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "step",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 63
        },
        "end": {
          "line": 1,
          "column": 71
        }
      }
    }) : helper));
  },
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var stack1,
      helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      alias2 = container.hooks.helperMissing,
      alias3 = "function",
      alias4 = container.escapeExpression,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "signin/enroll-activate/" + alias4((helper = (helper = lookupProperty(helpers, "provider") || (depth0 != null ? lookupProperty(depth0, "provider") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "provider",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 23
        },
        "end": {
          "line": 1,
          "column": 35
        }
      }
    }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "factorType",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 36
        },
        "end": {
          "line": 1,
          "column": 50
        }
      }
    }) : helper)) + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "step") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(1, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 50
        },
        "end": {
          "line": 1,
          "column": 78
        }
      }
    })) != null ? stack1 : "");
  },
  "useData": true
});
const recoveryUrlTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "signin/recovery/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "recoveryToken") || (depth0 != null ? lookupProperty(depth0, "recoveryToken") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "recoveryToken",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 16
        },
        "end": {
          "line": 1,
          "column": 33
        }
      }
    }) : helper));
  },
  "useData": true
});
const refreshUrlTpl = _runtime.default.template({
  "1": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "token") || (depth0 != null ? lookupProperty(depth0, "token") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "token",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 39
        },
        "end": {
          "line": 1,
          "column": 48
        }
      }
    }) : helper));
  },
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "signin/refresh-auth-state" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "token") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(1, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 25
        },
        "end": {
          "line": 1,
          "column": 55
        }
      }
    })) != null ? stack1 : "");
  },
  "useData": true
});
const signinWithUsernameUrlTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "signin/okta/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "username") || (depth0 != null ? lookupProperty(depth0, "username") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "username",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 12
        },
        "end": {
          "line": 1,
          "column": 24
        }
      }
    }) : helper));
  },
  "useData": true
});
const sessionCookieRedirectTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var stack1,
      helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      alias2 = container.hooks.helperMissing,
      alias3 = "function",
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return container.escapeExpression((helper = (helper = lookupProperty(helpers, "baseUrl") || (depth0 != null ? lookupProperty(depth0, "baseUrl") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "baseUrl",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 0
        },
        "end": {
          "line": 1,
          "column": 11
        }
      }
    }) : helper)) + "/login/sessionCookieRedirect?checkAccountSetupComplete=true&token=" + ((stack1 = (helper = (helper = lookupProperty(helpers, "token") || (depth0 != null ? lookupProperty(depth0, "token") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "token",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 77
        },
        "end": {
          "line": 1,
          "column": 88
        }
      }
    }) : helper)) != null ? stack1 : "") + "&redirectUrl=" + ((stack1 = (helper = (helper = lookupProperty(helpers, "redirectUrl") || (depth0 != null ? lookupProperty(depth0, "redirectUrl") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "redirectUrl",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 101
        },
        "end": {
          "line": 1,
          "column": 118
        }
      }
    }) : helper)) != null ? stack1 : "");
  },
  "useData": true
});
const deviceActivationStatuses = ['DEVICE_ACTIVATED', 'DEVICE_NOT_ACTIVATED_CONSENT_DENIED', 'DEVICE_NOT_ACTIVATED'];
fn.isHostBackgroundChromeTab = function () {
  // Checks if the SIW is loaded in a chrome webview and
  // it is in an app that is in background.
  if (navigator.userAgent.match(/Android/) && navigator.userAgent.match(/Chrome/) && document.hidden) {
    return true;
  } else {
    return false;
  }
};
fn.isDocumentVisible = function () {
  return document.visibilityState === 'visible';
};
fn.createVerifyUrl = function (provider, factorType, factorIndex) {
  if (provider && factorIndex) {
    return verifyUrlMultipleTpl({
      provider: encodeURIComponent(provider.toLowerCase()),
      factorType: encodeURIComponent(factorType),
      factorIndex: encodeURIComponent(factorIndex)
    });
  } else if (provider) {
    return verifyUrlTpl({
      provider: encodeURIComponent(provider.toLowerCase()),
      factorType: encodeURIComponent(factorType)
    });
  } else {
    return verifyUrlNoProviderTpl({
      factorType: encodeURIComponent(factorType)
    });
  }
};
fn.createEnrollFactorUrl = function (provider, factorType) {
  return enrollFactorUrlTpl({
    provider: encodeURIComponent(provider.toLowerCase()),
    factorType: encodeURIComponent(factorType)
  });
};
fn.createActivateFactorUrl = function (provider, factorType, step) {
  return activateFactorUrlTpl({
    provider: encodeURIComponent(provider.toLowerCase()),
    factorType: encodeURIComponent(factorType),
    step: step ? encodeURIComponent(step) : false
  });
};
fn.createRecoveryUrl = function (recoveryToken) {
  return recoveryUrlTpl({
    recoveryToken: encodeURIComponent(recoveryToken)
  });
};
fn.createRefreshUrl = function (stateToken) {
  const token = stateToken ? encodeURIComponent(stateToken) : null;
  return refreshUrlTpl({
    token: token
  });
};
fn.createSigninUrl = function (username) {
  return username ? signinWithUsernameUrlTpl({
    username: encodeURIComponent(username)
  }) : 'signin';
};
fn.routeAfterAuthStatusChangeError = function (router, err) {
  if (!err) {
    return;
  }

  // Global error handling for CORS enabled errors
  if (err.xhr && _BrowserFeatures.default.corsIsNotEnabled(err.xhr)) {
    router.settings.callGlobalError(new _Errors.UnsupportedBrowserError((0, _courage.loc)('error.enabled.cors')));
    return;
  }

  // Token has expired - no longer valid. Navigate back to primary auth.
  if (err.errorCode === _ErrorCodes.default.INVALID_TOKEN_EXCEPTION) {
    router.appState.set('flashError', err);
    router.controller.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
    if (router.settings.get('features.mfaOnlyFlow')) {
      router.navigate('signin/error', {
        trigger: true
      });
    } else {
      router.navigate('', {
        trigger: true
      });
    }
    return;
  }
  _Util.default.triggerAfterError(router.controller, err);
};
fn.routeAfterAuthStatusChange = function (router, res) {
  // Other errors are handled by the function making the authClient request
  if (!res || !res.status) {
    router.appState.clearLastAuthResponse();
    return;
  }
  router.appState.setAuthResponse(res);
  if (router.controller && router.controller.trapAuthResponse(res)) {
    return;
  }
  fn.handleResponseStatus(router, res);
};
fn.handleResponseStatus = function (router, res) {
  switch (res.status) {
    case 'SUCCESS':
      {
        handleSuccessResponseStatus(router, res);
        return;
      }
    case 'ADMIN_CONSENT_REQUIRED':
      router.navigate('signin/admin-consent', {
        trigger: true
      });
      return;
    case 'CONSENT_REQUIRED':
      router.navigate('signin/consent', {
        trigger: true
      });
      return;
    case 'DEVICE_ACTIVATE':
      router.navigate('signin/device-activate', {
        trigger: true
      });
      return;
    // We want the same view for FACTOR_REQUIRED & FACTOR_CHALLENGE
    // In the new idx pipeline FACTOR_CHALLENGE API response does not contain a prev link
    case 'FACTOR_REQUIRED':
    case 'FACTOR_CHALLENGE':
    case 'MFA_REQUIRED':
      {
        const lastFailedChallengeFactorData = router.appState.get('lastFailedChallengeFactorData');
        // When the widget is bootstrapped with an error in MFA_CHALLENGE state, we pass the
        // lastFailedChallengeFactorData to MFA_REQUIRED, in order to show the error message
        // on the correct factor view

        if (lastFailedChallengeFactorData && lastFailedChallengeFactorData.factor) {
          router.appState.get('factors').lastUsedFactor = lastFailedChallengeFactorData.factor;
        }
        const factor = router.appState.get('factors').getDefaultFactor();
        const url = fn.createVerifyUrl(factor.get('provider'), factor.get('factorType'));
        router.navigate(url, {
          trigger: true
        });
        router.appState.clearLastFailedChallengeFactorData();
        return;
      }
    case 'POLL':
      {
        const pollUrl = 'signin/poll';
        router.navigate(pollUrl, {
          trigger: true
        });
        return;
      }
    case 'MFA_CHALLENGE':
      // Since we normally trap MFA_CHALLENGE, this will only get called on a
      // page refresh or when an error is returned on verification with an IdP.
      // We need to return to MFA_REQUIRED to initialize the
      // page correctly (i.e. factors dropdown, etc)
      if (router.appState.get('isFactorResultFailed')) {
        router.appState.setLastFailedChallengeFactorData();
      }
      router.appState.get('transaction').prev().then(function (trans) {
        router.appState.set('transaction', trans);
      });
      // TODO: catch/handle error here?
      return;
    case 'MFA_ENROLL':
    case 'FACTOR_ENROLL':
      router.navigate('signin/enroll', {
        trigger: true
      });
      return;
    case 'MFA_ENROLL_ACTIVATE':
    case 'FACTOR_ENROLL_ACTIVATE':
      {
        const activateUrl = fn.createActivateFactorUrl(router.appState.get('activatedFactorProvider'), router.appState.get('activatedFactorType'));
        router.navigate(activateUrl, {
          trigger: true
        });
        return;
      }
    case 'PASSWORD_WARN':
    case 'PASSWORD_EXPIRED':
      if (router.settings.get('features.customExpiredPassword') && !router.appState.get('isPwdManagedByOkta')) {
        router.navigate('signin/custom-password-expired', {
          trigger: true
        });
      } else {
        router.navigate('signin/password-expired', {
          trigger: true
        });
      }
      return;
    case 'RECOVERY_CHALLENGE':
      {
        const fromEmail = res.factorType.toLowerCase() === _Enums.default.RECOVERY_FACTOR_TYPE_EMAIL.toLowerCase();
        const isForgotPassword = res.recoveryType === _Enums.default.RECOVERY_TYPE_PASSWORD;
        const isUnlock = res.recoveryType === _Enums.default.RECOVERY_TYPE_UNLOCK;
        // Will use this workaround (lowercasing response) until OKTA-69083 is resolved

        if (isForgotPassword && fromEmail) {
          router.navigate('signin/recovery-emailed', {
            trigger: true
          });
        } else if (isUnlock && fromEmail) {
          router.navigate('signin/unlock-emailed', {
            trigger: true
          });
        } else {
          router.navigate('signin/recovery-challenge', {
            trigger: true
          });
        }
        return;
      }
    case 'RECOVERY':
      router.navigate('signin/recovery-question', {
        trigger: true
      });
      return;
    case 'PASSWORD_RESET':
      router.navigate('signin/password-reset', {
        trigger: true
      });
      return;
    case 'LOCKED_OUT':
      {
        if (router.settings.get('features.selfServiceUnlock')) {
          router.navigate('signin/unlock', {
            trigger: true
          });
        } else {
          const errorMessage = (0, _courage.loc)('error.auth.lockedOut', 'login');
          const resError = {
            responseJSON: {
              errorCauses: [],
              errorSummary: errorMessage,
              errorCode: 'E0000119'
            }
          };
          const err = {
            name: 'AuthApiError',
            message: errorMessage,
            xhr: resError
          };
          router.controller.model.appState.trigger('removeLoading');
          router.controller.model.trigger('error', router.controller.model, resError);
          _Util.default.triggerAfterError(router.controller, err);
        }
        return;
      }
    case 'PROFILE_REQUIRED':
      router.navigate('signin/enroll-user', {
        trigger: true
      });
      return;
    case 'UNAUTHENTICATED':
      // Either we have factors and we are in passwordlessAuth mode
      if (router.appState.get('promptForFactorInUnauthenticated')) {
        const defaultFactor = router.appState.get('factors').getDefaultFactor();
        const factorURL = fn.createVerifyUrl(defaultFactor.get('provider'), defaultFactor.get('factorType'));
        router.navigate(factorURL, {
          trigger: true
        });
        return;
      }
      // Or we're in device flow and we need to force idp discovery check
      if (router.appState.get('usingDeviceFlow')) {
        router.navigate('signin/idp-discovery-check', {
          trigger: true
        });
        return;
      }
      // Or we don't have anything and we need to show the login page
      router.navigate('', {
        trigger: true
      });
      return;
    default:
      throw new Error('Unknown status: ' + res.status);
  }
};
function handleSuccessResponseStatus(router, res) {
  var _res$_embedded, _res$_links, _res$_links$original, _res$_links2, _res$_links2$next;
  if (res.recoveryType === _Enums.default.RECOVERY_TYPE_UNLOCK) {
    router.navigate('signin/account-unlocked', {
      trigger: true
    });
    return;
  }
  if (_courage._.contains(deviceActivationStatuses, (_res$_embedded = res._embedded) === null || _res$_embedded === void 0 ? void 0 : _res$_embedded.deviceActivationStatus)) {
    router.navigate('signin/device-activate-complete', {
      trigger: true
    });
    return;
  }

  // If the desired end result object needs to have idToken (and not sessionToken),
  // get the id token from session token before calling the global success function.
  if (router.settings.get('oauth2Enabled')) {
    _OAuth2Util.default.getTokens(router.settings, {
      sessionToken: res.sessionToken
    }, router.controller);
    return;
  }
  const successData = {
    user: res._embedded.user,
    type: res.type || _Enums.default.SESSION_SSO
  };
  if (res.relayState) {
    successData.relayState = res.relayState;
  }
  const redirectFn = router.settings.get('redirectUtilFn');
  const nextUrl = (res === null || res === void 0 ? void 0 : (_res$_links = res._links) === null || _res$_links === void 0 ? void 0 : (_res$_links$original = _res$_links.original) === null || _res$_links$original === void 0 ? void 0 : _res$_links$original.href) || (res === null || res === void 0 ? void 0 : (_res$_links2 = res._links) === null || _res$_links2 === void 0 ? void 0 : (_res$_links2$next = _res$_links2.next) === null || _res$_links2$next === void 0 ? void 0 : _res$_links2$next.href);
  if (res.type === _Enums.default.SESSION_STEP_UP) {
    var _res$_links3, _res$_links3$next;
    const targetUrl = res === null || res === void 0 ? void 0 : (_res$_links3 = res._links) === null || _res$_links3 === void 0 ? void 0 : (_res$_links3$next = _res$_links3.next) === null || _res$_links3$next === void 0 ? void 0 : _res$_links3$next.href;
    successData.stepUp = {
      url: targetUrl,
      finish: function () {
        redirectFn(targetUrl);
      }
    };
  } else {
    if (nextUrl) {
      successData.next = function () {
        redirectFn(nextUrl);
      };
    } else {
      // Add the type for now until the API returns it.
      successData.type = _Enums.default.SESSION_SSO;
    }
    if (res.sessionToken) {
      successData.session = {
        token: res.sessionToken,
        setCookieAndRedirect: function (redirectUri) {
          if (redirectUri) {
            _Util.default.debugMessage(`
              Passing a "redirectUri" to "setCookieAndRedirect" is strongly discouraged.
              It is recommended to set a "redirectUri" option in the config object passed to the widget constructor.
            `);
          }
          redirectUri = redirectUri || router.settings.get('redirectUri');
          if (!redirectUri) {
            throw new _Errors.ConfigError('"redirectUri" is required');
          }
          redirectFn(sessionCookieRedirectTpl({
            baseUrl: router.settings.get('baseUrl'),
            token: encodeURIComponent(res.sessionToken),
            redirectUrl: encodeURIComponent(redirectUri)
          }));
        }
      };
    }
  }

  // Check if we need to wait for redirect based on host.
  if (fn.isHostBackgroundChromeTab()) {
    document.addEventListener('visibilitychange', function checkVisibilityAndCallSuccess() {
      if (fn.isDocumentVisible()) {
        document.removeEventListener('visibilitychange', checkVisibilityAndCallSuccess);
        router.settings.callGlobalSuccess(_Enums.default.SUCCESS, successData);
      }
    });
  } else {
    router.settings.callGlobalSuccess(_Enums.default.SUCCESS, successData);
  }
}
var _default = fn;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/util/StoreLinks.js":
/*!***********************************!*\
  !*** ./src/v1/util/StoreLinks.js ***!
  \***********************************/
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = {
  OKTA: {
    APPLE: 'https://itunes.apple.com/us/app/okta-verify/id490179405',
    ANDROID: 'https://play.google.com/store/apps/details?id=com.okta.android.auth'
  },
  GOOGLE: {
    APPLE: 'https://itunes.apple.com/us/app/google-authenticator/id388497605',
    ANDROID: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
  },
  STORE: {
    APPLE: 'App Store',
    ANDROID: 'Google Play Store'
  }
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/util/TypingUtil.js":
/*!***********************************!*\
  !*** ./src/v1/util/TypingUtil.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _typingdna = _interopRequireDefault(__webpack_require__(/*! @okta/typingdna */ "./packages/vendor/TypingDnaRecorder-JavaScript/typingdna.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

let tdna;
var _default = {
  track: function (selectorId) {
    try {
      tdna = new _typingdna.default();
      tdna.addTarget(selectorId);
      tdna.start();
    } catch (e) {
      // Issues in typing should not stop Primary auth.
    }
  },
  getTypingPattern: function () {
    try {
      return tdna.getTypingPattern({
        type: 1
      });
    } catch (e) {
      return null;
    }
  }
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/util/ValidationUtil.js":
/*!***************************************!*\
  !*** ./src/v1/util/ValidationUtil.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const fn = {};

// Validate the 'username' field on the model.
fn.validateUsername = function (model) {
  const username = model.get('username');
  if (username && username.length > 256) {
    return {
      username: (0, _courage.loc)('model.validation.field.username', 'login')
    };
  }
};

// Validate that the field1 and field2 fields on the model are a match.
fn.validateFieldsMatch = function (model, field1, field2, message) {
  if (model.get(field1) !== model.get(field2)) {
    const ret = {};
    ret[field2] = message;
    return ret;
  }
};

// Validate that the 'newPassword' and 'confirmPassword' fields on the model are a match.
fn.validatePasswordMatch = function (model) {
  return fn.validateFieldsMatch(model, 'newPassword', 'confirmPassword', (0, _courage.loc)('password.error.match', 'login'));
};
var _default = fn;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/ResendEmailView.js":
/*!*****************************************!*\
  !*** ./src/v1/views/ResendEmailView.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  className: 'hide resend-email-infobox',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"infobox infobox-warning\" aria-live=\"polite\"><span class=\"icon warning-16\"></span><p><span>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "email.code.not.received"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 102
          },
          "end": {
            "line": 1,
            "column": 156
          }
        }
      })) + "</span><a href=\"#\" class=\"resend-email-btn\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "email.button.resend"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 200
          },
          "end": {
            "line": 1,
            "column": 250
          }
        }
      })) + "</a></p></div>";
    },
    "useData": true
  }),
  events: {
    'click .resend-email-btn': 'resendEmail'
  },
  postRender: function () {
    this.showResendCallout();
  },
  showResendCallout: function () {
    _courage._.delay(() => {
      this.$el.removeClass('hide');
    }, _Enums.default.API_RATE_LIMIT);
  },
  hideResendCallout: function () {
    this.$el.addClass('hide');
  },
  resendEmail: function (e) {
    e.preventDefault();
    this.hideResendCallout();
    this.model.resend().finally(this.showResendCallout.bind(this));
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/admin-consent/ScopeItem.js":
/*!*************************************************!*\
  !*** ./src/v1/views/admin-consent/ScopeItem.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
__webpack_require__(/*! @okta/qtip */ "./packages/@okta/qtip2/dist/jquery.qtip.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  className: 'scope-item',
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      return "<span class=\"scope-item-tooltip icon form-help-16\" />";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p class=\"scope-item-text no-translate\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 40
          },
          "end": {
            "line": 1,
            "column": 48
          }
        }
      }) : helper)) + "</p>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 52
          },
          "end": {
            "line": 1,
            "column": 131
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  postRender: function () {
    this.$('.scope-item-tooltip').qtip({
      content: {
        text: _courage._.escape(this.options.description)
      },
      style: {
        classes: 'okta-tooltip qtip-custom qtip-shadow'
      },
      position: {
        my: 'bottom left',
        target: 'mouse'
      }
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/admin-consent/ScopeList.js":
/*!*************************************************!*\
  !*** ./src/v1/views/admin-consent/ScopeList.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _ScopeItem = _interopRequireDefault(__webpack_require__(/*! ./ScopeItem */ "./src/v1/views/admin-consent/ScopeItem.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
/* eslint max-len: [2, 131] */

const SCOPE_N_GROUP_CONFIG = {
  groups: 'user',
  myAccount: 'user',
  users: 'user',
  apps: 'resource',
  authenticators: 'resource',
  authorizationServers: 'resource',
  clients: 'resource',
  domains: 'resource',
  factors: 'resource',
  idps: 'resource',
  linkedObjects: 'resource',
  policies: 'resource',
  templates: 'resource',
  eventHooks: 'hook',
  inlineHooks: 'hook',
  events: 'system',
  logs: 'system',
  orgs: 'system',
  roles: 'system',
  schemas: 'system',
  sessions: 'system',
  trustedOrigins: 'system'
};
const DEFAULT_GROUP = 'system';
const findScopeGroupKey = ({
  name = ''
}) => {
  const xs = name.split('.');
  const groupType = xs[1];
  return SCOPE_N_GROUP_CONFIG[groupType] || DEFAULT_GROUP;
};
const ScopeGroupHeaderView = _courage.View.extend({
  className: 'scope-group',
  events: {
    'click': 'expandScopes'
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"scope-group--header\"><h3>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "groupName") || (depth0 != null ? lookupProperty(depth0, "groupName") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "groupName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 37
          },
          "end": {
            "line": 1,
            "column": 50
          }
        }
      }) : helper)) + "</h3><span class=\"scope-group--toggle\"><svg class=\"caret\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"path\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.99967 4.66663L10.2663 8.66663L11.333 7.66663L5.99967 2.66663L0.666342 7.73636L1.73301 8.66663L5.99967 4.66663Z\" fill=\"#A0A7AC\"></path></svg></span></div>";
    },
    "useData": true
  }),
  expandScopes() {
    this.$el.toggleClass('scope-group--is-expanded');
    this.$('.caret').toggleClass('caret--is-rotated');
  },
  preRender() {
    _courage._.chain(this.options.scopes).sortBy(({
      name
    }) => name).each(({
      name,
      displayName,
      description
    }) => {
      this.add(_ScopeItem.default, {
        options: {
          name: displayName || name,
          description
        }
      });
    });
  }
});
var _default = _courage.View.extend({
  className: 'scope-list detail-row',
  postRender: function () {
    const allScopes = this.model.get('scopes');
    const scopesWithGroup = _courage._.groupBy(allScopes, findScopeGroupKey);
    const SCOPE_GROUP_NAMES_CONFIG = {
      'user': (0, _courage.loc)('admin.consent.group.user.group', 'login'),
      'resource': (0, _courage.loc)('admin.consent.group.resource.policy', 'login'),
      'hook': (0, _courage.loc)('admin.consent.group.hook', 'login'),
      'system': (0, _courage.loc)('admin.consent.group.system', 'login')
    };

    // loop through SCOPE_GROUP_NAMES_CONFIG to keep group order consistent in UI.
    _courage._.each(SCOPE_GROUP_NAMES_CONFIG, (groupName, groupKey) => {
      const scopes = scopesWithGroup[groupKey];
      if (!Array.isArray(scopes)) {
        return;
      }
      // add scope group header and scopes
      this.add(ScopeGroupHeaderView, {
        options: {
          groupName,
          scopes
        }
      });
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/consent/ScopeCheckBox.js":
/*!***********************************************!*\
  !*** ./src/v1/views/consent/ScopeCheckBox.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CheckBox = _courage.internal.views.forms.inputs.CheckBox;
var _default = CheckBox.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<input type=\"checkbox\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 29
          },
          "end": {
            "line": 1,
            "column": 37
          }
        }
      }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "inputId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 43
          },
          "end": {
            "line": 1,
            "column": 54
          }
        }
      }) : helper)) + "\"/><label for=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "inputId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 69
          },
          "end": {
            "line": 1,
            "column": 80
          }
        }
      }) : helper)) + "\" data-se-for-name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 100
          },
          "end": {
            "line": 1,
            "column": 108
          }
        }
      }) : helper)) + "\"><b>" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "placeholder",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 113
          },
          "end": {
            "line": 1,
            "column": 128
          }
        }
      }) : helper)) + "</b><p>" + alias4((helper = (helper = lookupProperty(helpers, "desc") || (depth0 != null ? lookupProperty(depth0, "desc") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "desc",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 135
          },
          "end": {
            "line": 1,
            "column": 143
          }
        }
      }) : helper)) + "</p></label>";
    },
    "useData": true
  }),
  /**
     * @Override
     */
  enable: function () {
    if (this.options.options.optional) {
      this.$(':input').prop('disabled', false);
    }
  },
  /**
     * @Override
     */
  editMode: function () {
    this.$el.html(this.template(_courage._.extend(_courage._.omit(this.options, 'placeholder'), {
      placeholder: this.options.placeholder || this.options.name,
      desc: this.options.options.description
    })));
    this.$(':checkbox').prop('checked', this.getModelValue() || false);
    this.$('input').customInput();
    this.model.trigger('form:resize');
    if (!this.options.options.optional) {
      const input = this.$('input').get(0);
      this.$(input.parentElement).addClass('o-form-read-mode');
      this.$(':checkbox').prop('disabled', true);
    }
    if (this.options.name === 'openid' || this.options.options.isCustomized) {
      this.$('label > b').addClass('no-translate');
      if (this.options.options.isCustomized) {
        this.$('label > p').addClass('no-translate');
      }
    }
    return this;
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/consent/ScopeItem.js":
/*!*******************************************!*\
  !*** ./src/v1/views/consent/ScopeItem.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
__webpack_require__(/*! @okta/qtip */ "./packages/@okta/qtip2/dist/jquery.qtip.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  className: 'scope-item',
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      return "<span class=\"scope-item-tooltip icon form-help-16\"></span>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"" + alias4((helper = (helper = lookupProperty(helpers, "classNames") || (depth0 != null ? lookupProperty(depth0, "classNames") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "classNames",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 12
          },
          "end": {
            "line": 1,
            "column": 26
          }
        }
      }) : helper)) + "\"><p>" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 31
          },
          "end": {
            "line": 1,
            "column": 39
          }
        }
      }) : helper)) + "</p></div>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 49
          },
          "end": {
            "line": 1,
            "column": 133
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  getTemplateData() {
    const {
      name,
      description,
      isCustomized
    } = this.options;
    const baseClass = 'scope-item-text';
    const classNames = name === 'openid' || isCustomized ? `${baseClass} no-translate` : baseClass;
    return {
      classNames,
      name,
      description
    };
  },
  postRender: function () {
    this.$('.scope-item-tooltip').qtip({
      content: {
        text: _courage._.escape(this.options.description)
      },
      style: {
        classes: 'okta-tooltip qtip-custom qtip-shadow'
      },
      position: {
        my: 'bottom right',
        target: 'mouse'
      }
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/consent/ScopeList.js":
/*!*******************************************!*\
  !*** ./src/v1/views/consent/ScopeList.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _ScopeItem = _interopRequireDefault(__webpack_require__(/*! ./ScopeItem */ "./src/v1/views/consent/ScopeItem.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  className: 'scope-list detail-row',
  postRender: function () {
    this.model.get('scopes').forEach(scope => {
      this.add(_ScopeItem.default, {
        options: {
          name: scope.displayName || scope.name,
          description: scope.description,
          isCustomized: scope.isCustomized
        }
      });
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/enroll-choices/FactorList.js":
/*!***************************************************!*\
  !*** ./src/v1/views/enroll-choices/FactorList.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _RouterUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/RouterUtil */ "./src/v1/util/RouterUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const cardinalityTextTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<span class=\"factor-cardinality\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "cardinalityText") || (depth0 != null ? lookupProperty(depth0, "cardinalityText") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "cardinalityText",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 33
        },
        "end": {
          "line": 1,
          "column": 52
        }
      }
    }) : helper)) + "</span>";
  },
  "useData": true
});
const FactorListFactorRow = _courage.View.extend({
  tagName: 'li',
  className: 'enroll-factor-row clearfix',
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "factorDescription") || (depth0 != null ? lookupProperty(depth0, "factorDescription") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "factorDescription",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 235
          },
          "end": {
            "line": 1,
            "column": 256
          }
        }
      }) : helper)) + "</p>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"enroll-factor-icon-container\"><div class=\"factor-icon enroll-factor-icon " + alias4((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "iconClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 85
          },
          "end": {
            "line": 1,
            "column": 102
          }
        }
      }) : helper)) + "\"></div></div><div class=\"enroll-factor-description\"><h3 class=\"enroll-factor-label\">" + alias4((helper = (helper = lookupProperty(helpers, "factorLabel") || (depth0 != null ? lookupProperty(depth0, "factorLabel") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "factorLabel",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 187
          },
          "end": {
            "line": 1,
            "column": 202
          }
        }
      }) : helper)) + "</h3>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "factorDescription") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 207
          },
          "end": {
            "line": 1,
            "column": 267
          }
        }
      })) != null ? stack1 : "") + "<div class=\"enroll-factor-button\"></div></div>";
    },
    "useData": true
  }),
  attributes: function () {
    return {
      'data-se': this.model.get('factorName')
    };
  },
  children: function () {
    const children = [];
    const enrolled = this.model.get('enrolled');
    const required = this.model.get('required');
    const cardinality = this.model.get('cardinality');
    if (this.options.showInlineSetupButton) {
      return [[(0, _courage.createButton)({
        className: 'button',
        title: this.getSetupButtonText(),
        click: function () {
          this.options.appState.trigger('navigate', _RouterUtil.default.createEnrollFactorUrl(this.model.get('provider'), this.model.get('factorType')));
        }
      }), '.enroll-factor-button']];
    } else if (enrolled) {
      children.push(['<span class="icon success-16-green"></span>', '.enroll-factor-label']);
    } else if (required) {
      children.push(['<span class="icon success-16-gray"></span>', '.enroll-factor-label']);
    }
    const cardinalityText = _FactorUtil.default.getCardinalityText(enrolled, required, cardinality);
    if (cardinalityText) {
      children.push([cardinalityTextTpl({
        cardinalityText: cardinalityText
      }), '.enroll-factor-description']);
    }
    return children;
  },
  minimize: function () {
    this.$el.addClass('enroll-factor-row-min');
  },
  maximize: function () {
    this.$el.removeClass('enroll-factor-row-min');
  },
  getSetupButtonText: function () {
    return this.model.get('additionalEnrollment') ? (0, _courage.loc)('enroll.choices.setup.another', 'login') : (0, _courage.loc)('enroll.choices.setup', 'login');
  }
});
var _default = _courage.ListView.extend({
  className: 'enroll-factor-list',
  item: FactorListFactorRow,
  itemSelector: '.list-content',
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<h3 class=\"list-title\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "listTitle") || (depth0 != null ? lookupProperty(depth0, "listTitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "listTitle",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 40
          },
          "end": {
            "line": 1,
            "column": 53
          }
        }
      }) : helper)) + "</h3>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "listTitle") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 65
          }
        }
      })) != null ? stack1 : "") + "<ul class=\"list-content\"></ul>";
    },
    "useData": true
  }),
  getTemplateData: function () {
    const json = _courage.ListView.prototype.getTemplateData.call(this);
    _courage._.extend(json, this);
    return json;
  },
  postRender: function () {
    if (this.options.minimize) {
      this.invoke('minimize');
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/enroll-choices/Footer.js":
/*!***********************************************!*\
  !*** ./src/v1/views/enroll-choices/Footer.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<a href=\"#\" class=\"link goto js-skip\" data-se=\"skip-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.choices.setup.skip"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 114
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer clearfix',
  events: {
    'click .js-skip': function (e) {
      e.preventDefault();
      this.model.doTransaction(function (transaction) {
        return transaction.skip();
      });
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/enroll-choices/RequiredFactorList.js":
/*!***********************************************************!*\
  !*** ./src/v1/views/enroll-choices/RequiredFactorList.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FactorList = _interopRequireDefault(__webpack_require__(/*! ./FactorList */ "./src/v1/views/enroll-choices/FactorList.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FactorList.default.extend({
  listTitle: _courage._.partial(_courage.loc, 'enroll.choices.list.setup', 'login'),
  className: function () {
    return _FactorList.default.prototype.className + ' enroll-required-factor-list';
  },
  postRender: function () {
    let currentModel;
    let currentRow;
    _FactorList.default.prototype.postRender.apply(this, arguments);
    currentModel = this.options.appState.get('factors').getFirstUnenrolledRequiredFactor();
    currentRow = this.find(function (view) {
      return view.model === currentModel;
    });
    currentRow.maximize();
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/enroll-factors/BarcodeView.js":
/*!****************************************************!*\
  !*** ./src/v1/views/enroll-factors/BarcodeView.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _RouterUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/RouterUtil */ "./src/v1/util/RouterUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  className: 'scan-instructions clearfix',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"scan-instructions-details-wrapper\"><div class=\"scan-instructions-details\"><p>" + alias4((helper = (helper = lookupProperty(helpers, "instructions") || (depth0 != null ? lookupProperty(depth0, "instructions") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "instructions",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 89
          },
          "end": {
            "line": 1,
            "column": 105
          }
        }
      }) : helper)) + "</p></div></div><div class=\"scan-instructions-qrcode-wrapper\"><div class=\"qrcode-wrap\"><img data-se=\"qrcode\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "altQRCode") || (depth0 != null ? lookupProperty(depth0, "altQRCode") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "altQRCode",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 219
          },
          "end": {
            "line": 1,
            "column": 232
          }
        }
      }) : helper)) + "\" class=\"qrcode-image\" src=\"" + alias4((helper = (helper = lookupProperty(helpers, "qrcode") || (depth0 != null ? lookupProperty(depth0, "qrcode") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "qrcode",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 260
          },
          "end": {
            "line": 1,
            "column": 270
          }
        }
      }) : helper)) + "\"><div data-se=\"qrcode-success\" class=\"qrcode-success\"></div><div data-se=\"qrcode-error\" class=\"qrcode-error\"></div></div><a href=\"#\" data-type=\"manual-setup\" data-se=\"manual-setup\" class=\"link manual-setup\" aria-label=\"" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.totp.aria.cannotScan"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 490
          },
          "end": {
            "line": 1,
            "column": 549
          }
        }
      })) + "\">" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.totp.cannotScan"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 551
          },
          "end": {
            "line": 1,
            "column": 604
          }
        }
      })) + "</a><a href=\"#\" data-type=\"refresh-qrcode\" data-se=\"refresh-qrcode\" class=\"link refresh-qrcode\">" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.totp.refreshBarcode"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 700
          },
          "end": {
            "line": 1,
            "column": 757
          }
        }
      })) + "</a></div>";
    },
    "useData": true
  }),
  events: {
    'click [data-type="manual-setup"]': function (e) {
      e.preventDefault();
      const url = _RouterUtil.default.createActivateFactorUrl(this.model.get('__provider__'), this.model.get('__factorType__'), 'manual');
      if (this.model.get('__factorType__') === 'push') {
        // cancel the poll and navigate to manual setup.
        this.model.doTransaction(function (transaction) {
          return transaction.prev().then(function (trans) {
            const factor = _courage._.findWhere(trans.factors, {
              factorType: 'push',
              provider: 'OKTA'
            });
            return factor.enroll();
          });
        }).then(() => {
          this.options.appState.trigger('navigate', url);
        });
      } else {
        this.options.appState.trigger('navigate', url);
      }
    },
    'click [data-type="refresh-qrcode"]': function (e) {
      e.preventDefault();
      this.model.trigger('errors:clear');
      const self = this;
      this.model.doTransaction(function (transaction) {
        if (this.appState.get('isWaitingForActivation')) {
          return transaction.poll();
        } else {
          return transaction.activate();
        }
      }).then(function (trans) {
        const res = trans.data;
        if ((res.status === 'MFA_ENROLL_ACTIVATE' || res.status === 'FACTOR_ENROLL_ACTIVATE') && res.factorResult === 'WAITING') {
          // defer the render here to have a lastResponse set in AppState
          // so that we get new QRcode rendered
          _courage._.defer(_courage._.bind(self.render, self));
        }
      });
    }
  },
  initialize: function () {
    this.listenTo(this.options.appState, 'change:lastAuthResponse', function () {
      if (this.options.appState.get('isMfaEnrollActivate')) {
        this.$el.toggleClass('qrcode-expired', !this.options.appState.get('isWaitingForActivation'));
      } else if (this.options.appState.get('isSuccessResponse')) {
        this.$el.addClass('qrcode-success');
      }
    });
    this.listenTo(this.model, 'error', function () {
      if (this.options.appState.get('isMfaEnrollActivate')) {
        this.$el.toggleClass('qrcode-expired', true);
      }
    });
  },
  getTemplateData: function () {
    const factorName = _FactorUtil.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
    let instructions;
    if (this.model.get('__provider__') === 'GOOGLE') {
      instructions = (0, _courage.loc)('enroll.totp.setupGoogleAuthApp', 'login', [factorName]);
    } else {
      instructions = (0, _courage.loc)('enroll.totp.setupApp', 'login', [factorName]);
    }
    return {
      instructions: instructions,
      qrcode: this.options.appState.get('qrcode'),
      altQRCode: (0, _courage.loc)('mfa.altQrCode', 'login')
    };
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/enroll-factors/EnterPasscodeForm.js":
/*!**********************************************************!*\
  !*** ./src/v1/views/enroll-factors/EnterPasscodeForm.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _FormType = _interopRequireDefault(__webpack_require__(/*! v1/util/FormType */ "./src/v1/util/FormType.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const form = {
  title: function () {
    const factorName = _FactorUtil.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
    return (0, _courage.loc)('enroll.totp.title', 'login', [factorName]);
  },
  subtitle: _courage._.partial(_courage.loc, 'enroll.totp.enterCode', 'login'),
  autoSave: true,
  noButtonBar: true,
  attributes: {
    'data-se': 'step-sendcode'
  },
  formChildren: function () {
    return [_FormType.default.Input({
      label: (0, _courage.loc)('mfa.challenge.enterCode.placeholder', 'login'),
      'label-top': true,
      explain: _Util.default.createInputExplain('mfa.challenge.enterCode.tooltip', 'mfa.challenge.enterCode.placeholder', 'login'),
      'explain-top': true,
      name: 'passCode',
      input: _TextBox.default,
      type: 'tel'
    }), _FormType.default.Toolbar({
      noCancelButton: true,
      save: (0, _courage.loc)('oform.verify', 'login') // TODO: deprecated by mfa.challenge.verify
    })];
  }
};
var _default = form;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/enroll-factors/Footer.js":
/*!***********************************************!*\
  !*** ./src/v1/views/enroll-factors/Footer.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "mfa.backToFactors"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 106
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .js-back': function (e) {
      e.preventDefault();
      this.options.appState.trigger('backToFactors');
      this.back();
    }
  },
  back: function () {
    this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
    if (this.options.appState.get('prevLink')) {
      // Once we are in the MFA_ENROLL_ACTIVATE, we need to reset to the
      // correct state. Fortunately, this means that the router will
      // handle navigation once the request is finished.
      this.model.doTransaction(function (transaction) {
        return transaction.prev();
      });
    } else {
      this.options.appState.trigger('navigate', 'signin/enroll');
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/enroll-factors/ManualSetupFooter.js":
/*!**********************************************************!*\
  !*** ./src/v1/views/enroll-factors/ManualSetupFooter.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "mfa.backToFactors"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 106
          }
        }
      })) + "</a><a href=\"#\" class=\"link help goto js-goto\" data-se=\"goto-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "mfa.scanBarcode"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 173
          },
          "end": {
            "line": 1,
            "column": 219
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .js-back': function (e) {
      e.preventDefault();
      this.back();
    },
    'click .js-goto': function (e) {
      e.preventDefault();
      // go to a different screen with current auth status:
      // refresh the latest response
      this.model.startTransaction(function (authClient) {
        return authClient.tx.resume();
      });
    }
  },
  back: function () {
    this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
    if (this.options.appState.get('prevLink')) {
      // Once we are in the MFA_ENROLL_ACTIVATE, we need to reset to the
      // correct state. Fortunately, this means that the router will
      // handle navigation once the request is finished.
      this.model.doTransaction(function (transaction) {
        return transaction.prev();
      });
    } else {
      this.options.appState.trigger('navigate', 'signin/enroll');
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/enroll-factors/ManualSetupPushFooter.js":
/*!**************************************************************!*\
  !*** ./src/v1/views/enroll-factors/ManualSetupPushFooter.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _RouterUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/RouterUtil */ "./src/v1/util/RouterUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

function goToFactorActivation(appState) {
  const url = _RouterUtil.default.createActivateFactorUrl(appState.get('activatedFactorProvider'), appState.get('activatedFactorType'));
  appState.trigger('navigate', url);
}
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "mfa.backToFactors"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 106
          }
        }
      })) + "</a><a href=\"#\" class=\"link help goto js-goto\" data-se=\"goto-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "mfa.scanBarcode"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 173
          },
          "end": {
            "line": 1,
            "column": 219
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .js-back': function (e) {
      e.preventDefault();
      this.back();
    },
    'click .js-goto': function (e) {
      e.preventDefault();
      const goToFactor = _courage._.partial(goToFactorActivation, this.options.appState);
      this.options.appState.unset('factorActivationType');
      this.model.doTransaction(function (transaction) {
        return transaction.prev().then(function (trans) {
          const factor = _courage._.findWhere(trans.factors, {
            factorType: 'push',
            provider: 'OKTA'
          });
          return factor.enroll();
        });
      }).then(goToFactor);
    }
  },
  back: function () {
    const self = this;
    self.options.appState.unset('factorActivationType');
    if (self.options.appState.get('prevLink')) {
      this.model.doTransaction(function (transaction) {
        return transaction.prev();
      }).then(function () {
        // we trap 'MFA_ENROLL' response that's why we need to trigger navigation from here
        self.options.appState.trigger('navigate', 'signin/enroll');
      });
    } else {
      self.options.appState.trigger('navigate', 'signin/enroll');
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/enroll-factors/PhoneTextBox.js":
/*!*****************************************************!*\
  !*** ./src/v1/views/enroll-factors/PhoneTextBox.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

let {
  TextBox
} = _courage.internal.views.forms.inputs;
var _default = TextBox.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<span class=\"okta-form-label-inline o-form-label-inline\">" + alias4((helper = (helper = lookupProperty(helpers, "countryCallingCode") || (depth0 != null ? lookupProperty(depth0, "countryCallingCode") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "countryCallingCode",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 57
          },
          "end": {
            "line": 1,
            "column": 79
          }
        }
      }) : helper)) + "</span><span class=\"okta-form-input-field input-fix o-form-control\"><input type=\"" + alias4((helper = (helper = lookupProperty(helpers, "type") || (depth0 != null ? lookupProperty(depth0, "type") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "type",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 160
          },
          "end": {
            "line": 1,
            "column": 168
          }
        }
      }) : helper)) + "\" placeholder=\"" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "placeholder",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 183
          },
          "end": {
            "line": 1,
            "column": 198
          }
        }
      }) : helper)) + "\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 206
          },
          "end": {
            "line": 1,
            "column": 214
          }
        }
      }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "inputId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 220
          },
          "end": {
            "line": 1,
            "column": 231
          }
        }
      }) : helper)) + "\" value=\"" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "value",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 240
          },
          "end": {
            "line": 1,
            "column": 249
          }
        }
      }) : helper)) + "\" autocomplete=\"" + alias4((helper = (helper = lookupProperty(helpers, "autocomplete") || (depth0 != null ? lookupProperty(depth0, "autocomplete") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "autocomplete",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 265
          },
          "end": {
            "line": 1,
            "column": 281
          }
        }
      }) : helper)) + "\"></span>";
    },
    "useData": true
  }),
  initialize: function () {
    this.listenTo(this.model, 'change:countryCallingCode', function () {
      this.$('.o-form-label-inline').text(this.model.get('countryCallingCode'));
    });
  },
  preRender: function () {
    this.options.countryCallingCode = this.model.get('countryCallingCode');
    this.options.autocomplete = _Util.default.getAutocompleteValue(this.options.model.settings, 'tel');
  },
  postRender: function () {
    // This is a hack - once inputGroups are done, get rid of it!!
    this.$el.removeClass('input-fix o-form-control');
    _courage._.defer(() => {
      this.$el.parent().addClass('o-form-input-group');
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/enrollUser/EnrollUserForm.js":
/*!***************************************************!*\
  !*** ./src/v1/views/enrollUser/EnrollUserForm.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _ProfileSchema = _interopRequireDefault(__webpack_require__(/*! v1/models/ProfileSchema */ "./src/v1/models/ProfileSchema.js"));
var _RegistrationFormFactory = _interopRequireDefault(__webpack_require__(/*! v1/util/RegistrationFormFactory */ "./src/v1/util/RegistrationFormFactory.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
/* eslint max-len: [2, 130] */
var _default = _courage.Form.extend({
  layout: 'o-form-theme',
  autoSave: true,
  noCancelButton: true,
  title() {
    return (0, _courage.loc)('registration.form.title', 'login');
  },
  save() {
    return (0, _courage.loc)('registration.form.submit', 'login');
  },
  initialize: function (options) {
    this.options = options || {};
    this.schema = new _ProfileSchema.default({
      profileSchemaAttributes: this.options.appState.get('policy').registration.profile
    });
    this.schema.properties.each(schemaProperty => {
      const inputOptions = _RegistrationFormFactory.default.createInputOptions(schemaProperty);
      this.addInput(inputOptions);
    });
    const requiredFieldsLabel = _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function (container, depth0, helpers, partials, data) {
        var helper,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }
            return undefined;
          };
        return "<span class=\"required-fields-label\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "label",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 36
            },
            "end": {
              "line": 1,
              "column": 45
            }
          }
        }) : helper)) + "</span>";
      },
      "useData": true
    })({
      label: (0, _courage.loc)('registration.required.fields.label', 'login')
    });
    this.add(requiredFieldsLabel);
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/expired-password/Footer.js":
/*!*************************************************!*\
  !*** ./src/v1/views/expired-password/Footer.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const {
  Util
} = _courage.internal.util;
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<a href=\"#\" class=\"link help js-skip\" data-se=\"skip-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "password.expiring.later"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 78
          },
          "end": {
            "line": 1,
            "column": 132
          }
        }
      })) + "</a>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "passwordWarn") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 143
          }
        }
      })) != null ? stack1 : "") + "<a href=\"#\" class=\"link help goto js-signout\" data-se=\"signout-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "signout"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 212
          },
          "end": {
            "line": 1,
            "column": 250
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer clearfix',
  events: {
    'click .js-signout': function (e) {
      e.preventDefault();
      const self = this;
      const authClient = self.settings.getAuthClient();
      this.model.doTransaction(function (transaction) {
        return transaction.cancel();
      }).then(function () {
        return authClient.session.exists();
      }).then(function (sessionExists) {
        if (sessionExists) {
          return authClient.closeSession().catch(() => {});
        }
      }).then(function () {
        if (self.settings.get('backToSignInUri')) {
          Util.redirect(self.settings.get('backToSignInUri'));
        } else {
          self.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
          self.options.appState.trigger('navigate', '');
        }
      });
    },
    'click .js-skip': function (e) {
      e.preventDefault();
      this.model.doTransaction(function (transaction) {
        return transaction.skip();
      });
    }
  },
  getTemplateData: function () {
    return {
      passwordWarn: this.options.appState.get('isPwdExpiringSoon')
    };
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/factor-verify/EmailMagicLinkForm.js":
/*!**********************************************************!*\
  !*** ./src/v1/views/factor-verify/EmailMagicLinkForm.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
/* eslint complexity: [2, 7] */
var _default = _courage.Form.extend({
  layout: 'o-form-theme',
  className: 'factor-verify-magiclink',
  autoSave: true,
  noCancelButton: true,
  initialize: function () {
    const form = this;
    // for FACTOR_REQUIRED with email magic link we dont need to show otp code input field and verify button

    this.title = this.model.get('factorLabel');
    //TODO: OKTA-211618 Temp fix for demo. FACTOR_REQUIRED after sign up is missing the profile object in API response

    const email = this.model.get('email') || this.options.appState.get('lastAuthResponse')._embedded.user.profile.login;
    this.subtitle = '(' + email + ')';
    this.add((0, _courage.createButton)({
      attributes: {
        'data-se': 'email-send-code'
      },
      className: 'button email-request-button',
      title: (0, _courage.loc)('mfa.sendEmail', 'login'),
      click: function () {
        form.clearErrors();
        this.disable();
        this.options.title = (0, _courage.loc)('mfa.sent', 'login');
        this.render();
        this.model.save().then(() => {
          return _q.default.delay(_Enums.default.API_RATE_LIMIT);
        }).then(() => {
          this.options.title = (0, _courage.loc)('mfa.resendEmail', 'login');
          this.enable();
          this.render();
        });
      }
    }));
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/idp-discovery/IDPDiscoveryForm.js":
/*!********************************************************!*\
  !*** ./src/v1/views/idp-discovery/IDPDiscoveryForm.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _PrimaryAuthForm = _interopRequireDefault(__webpack_require__(/*! v1/views/primary-auth/PrimaryAuthForm */ "./src/v1/views/primary-auth/PrimaryAuthForm.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _PrimaryAuthForm.default.extend({
  className: 'idp-discovery-form',
  save: function () {
    return (0, _courage.loc)('oform.next', 'login');
  },
  saveId: 'idp-discovery-submit',
  initialize: function () {
    this.listenTo(this, 'save', _courage._.bind(this.model.save, this.model));
    this.stateEnableChange();
  },
  inputs: function () {
    const inputs = [];
    const usernameProps = {
      className: 'margin-btm-30',
      label: (0, _courage.loc)('primaryauth.username.placeholder', 'login'),
      inputId: 'idp-discovery-username',
      disabled: false
    };
    inputs.push(_courage._.extend(this.getUsernameField(), usernameProps));
    if (this.settings.get('features.rememberMe')) {
      inputs.push(this.getRemeberMeCheckbox());
    }
    return inputs;
  },
  focus: function () {
    if (!this.model.get('username')) {
      this.getInputs().first().focus();
    } else if (this.getInputs().toArray()[1]) {
      this.getInputs().toArray()[1].focus();
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/mfa-verify/HtmlErrorMessageView.js":
/*!*********************************************************!*\
  !*** ./src/v1/views/mfa-verify/HtmlErrorMessageView.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const template = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var stack1,
      helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<span class=\"icon error-24\"></span><h4><strong>" + ((stack1 = (helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "message",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 47
        },
        "end": {
          "line": 1,
          "column": 60
        }
      }
    }) : helper)) != null ? stack1 : "") + "</strong></h4>";
  },
  "useData": true
});

// Have to be unescaped for the html in enroll.windowsHello.error.notConfiguredHtml
var _default = _courage.View.extend({
  template: template,
  className: 'okta-infobox-error infobox infobox-error infobox-md margin-btm-25',
  attributes: {
    'data-se': 'o-form-error-html'
  },
  message: '',
  initialize: function (options) {
    if (options && options.message) {
      this.message = options.message;
    }
  },
  getTemplateData: function () {
    return {
      message: this.message
    };
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/mfa-verify/InlineTOTPForm.js":
/*!***************************************************!*\
  !*** ./src/v1/views/mfa-verify/InlineTOTPForm.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

function addInlineTotp(form) {
  form.addDivider();
  form.addInput({
    label: (0, _courage.loc)('mfa.challenge.enterCode.placeholder', 'login'),
    'label-top': true,
    className: 'o-form-fieldset o-form-label-top inline-input auth-passcode',
    name: 'answer',
    input: _TextBox.default,
    type: 'tel'
  });
  form.add((0, _courage.createButton)({
    attributes: {
      'data-se': 'inline-totp-verify'
    },
    className: 'button inline-totp-verify margin-top-30',
    title: (0, _courage.loc)('mfa.challenge.verify', 'login'),
    click: function () {
      form.clearErrors();
      if (!form.isValid()) {
        return;
      }
      form.model.manageTransaction(function (transaction, setTransaction) {
        // This is the case where we enter the TOTP code and verify while there is an
        // active Push request (or polling) running. We need to invoke previous() on authClient
        // and then call model.save(). If not, we would still be in MFA_CHALLENGE state and
        // verify would result in a wrong request (push verify instead of a TOTP verify).
        if (transaction.status === 'MFA_CHALLENGE' && transaction.prev) {
          form.options.appState.set('trapMfaRequiredResponse', true);
          return transaction.prev().then(function (trans) {
            setTransaction(trans);
            form.model.save();
          });
        } else {
          // Push is not active and we enter the code to verify.
          form.model.save();
        }
      });
    }
  }));
  form.at(1).focus();
}
var _default = _courage.Form.extend({
  autoSave: true,
  noButtonBar: true,
  scrollOnError: false,
  layout: 'o-form-theme',
  className: 'mfa-verify-totp-inline',
  attributes: {
    'data-se': 'factor-inline-totp'
  },
  initialize: function () {
    const form = this;
    this.listenTo(this.model, 'error', function () {
      this.clearErrors();
    });
    this.add((0, _courage.createButton)({
      className: 'link',
      attributes: {
        'data-se': 'inline-totp-add'
      },
      title: (0, _courage.loc)('mfa.challenge.orEnterCode', 'login'),
      click: function () {
        this.remove();
        addInlineTotp(form);
      }
    }));
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/mfa-verify/NumberChallengeView.js":
/*!********************************************************!*\
  !*** ./src/v1/views/mfa-verify/NumberChallengeView.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  className: 'number-challenge-view',
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p data-se=\"number-challenge-instruction\">" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "arguments": "number",
          "bundle": "login",
          "code": "oktaverify.numberchallenge.instruction"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 73
          },
          "end": {
            "line": 1,
            "column": 163
          }
        }
      })) != null ? stack1 : "") + "</p>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "number") : depth0, {
        "name": "if",
        "hash": {
          "includeZero": true
        },
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 174
          }
        }
      })) != null ? stack1 : "") + "<div class=\"phone\"><div class=\"phone--body\"><div class=\"phone--screen\"><span class=\"phone--number\" data-se=\"challenge-number\">" + alias3((helper = (helper = lookupProperty(helpers, "number") || (depth0 != null ? lookupProperty(depth0, "number") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "number",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 300
          },
          "end": {
            "line": 1,
            "column": 310
          }
        }
      }) : helper)) + "</span></div><div class=\"phone--home-button\"></div></div></div><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oktaverify.numberchallenge.explain"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 376
          },
          "end": {
            "line": 1,
            "column": 441
          }
        }
      })) + "</p>";
    },
    "useData": true
  }),
  initialize() {
    this.listenTo(this.options.appState, 'change:isWaitingForNumberChallenge', () => {
      if (this.options.appState.get('lastAuthResponse').status !== 'SUCCESS') {
        this.render();
      }
    });
  },
  getTemplateData() {
    const lastAuthResponse = this.options.appState.get('lastAuthResponse');
    if (!this.options.appState.get('isWaitingForNumberChallenge')) {
      return {
        number: null
      };
    }
    return {
      number: lastAuthResponse._embedded.factor._embedded.challenge.correctAnswer
    };
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/mfa-verify/PassCodeForm.js":
/*!*************************************************!*\
  !*** ./src/v1/views/mfa-verify/PassCodeForm.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint complexity: [2, 7] */

const subtitleTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "(" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "subtitle",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 1
        },
        "end": {
          "line": 1,
          "column": 13
        }
      }
    }) : helper)) + ")";
  },
  "useData": true
});
const PassCodeFormwarningTemplate = _courage.View.extend({
  className: 'okta-form-infobox-warning infobox infobox-warning login-timeout-warning',
  attributes: {
    'aria-live': 'polite'
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<span class=\"icon warning-16\"></span><p>" + ((stack1 = (helper = (helper = lookupProperty(helpers, "warning") || (depth0 != null ? lookupProperty(depth0, "warning") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "warning",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 40
          },
          "end": {
            "line": 1,
            "column": 53
          }
        }
      }) : helper)) != null ? stack1 : "") + "</p>";
    },
    "useData": true
  })
});
function getFormAndButtonDetails(factorType) {
  switch (factorType) {
    case 'sms':
      return {
        buttonDataSe: 'sms-send-code',
        buttonClassName: 'sms-request-button',
        formSubmit: (0, _courage.loc)('mfa.sendCode', 'login'),
        formRetry: (0, _courage.loc)('mfa.resendCode', 'login'),
        formSubmitted: (0, _courage.loc)('mfa.sent', 'login'),
        subtitle: subtitleTpl({
          subtitle: this.model.get('phoneNumber')
        }),
        warning: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "$1": "<b>$1</b>",
                "bundle": "login",
                "code": "factor.sms.time.warning"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 70
                }
              }
            }));
          },
          "useData": true
        })
      };
    case 'call':
      return {
        buttonDataSe: 'make-call',
        buttonClassName: 'call-request-button',
        formSubmit: (0, _courage.loc)('mfa.call', 'login'),
        formRetry: (0, _courage.loc)('mfa.redial', 'login'),
        formSubmitted: (0, _courage.loc)('mfa.calling', 'login'),
        subtitle: subtitleTpl({
          subtitle: this.model.get('phoneNumber')
        }),
        warning: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "$1": "<b>$1</b>",
                "bundle": "login",
                "code": "factor.call.time.warning"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 71
                }
              }
            }));
          },
          "useData": true
        })
      };
    case 'email':
      return {
        buttonDataSe: 'email-send-code',
        buttonClassName: 'email-request-button',
        formSubmit: (0, _courage.loc)('mfa.sendEmail', 'login'),
        formRetry: (0, _courage.loc)('mfa.resendEmail', 'login'),
        formSubmitted: (0, _courage.loc)('mfa.sent', 'login'),
        subtitle: subtitleTpl({
          subtitle: this.model.get('email')
        })
      };
    default:
      return {
        buttonDataSe: '',
        buttonClassName: '',
        formSubmit: '',
        formRetry: '',
        formSubmitted: ''
      };
  }
}
var _default = _courage.Form.extend({
  className: 'mfa-verify-passcode',
  autoSave: true,
  noCancelButton: true,
  save: _courage._.partial(_courage.loc, 'mfa.challenge.verify', 'login'),
  scrollOnError: false,
  layout: 'o-form-theme',
  disableSubmitButton: function () {
    return this.model.appState.get('isMfaChallenge') && this.model.get('answer');
  },
  showWarning: function (msg) {
    this.clearWarnings();
    this.add(PassCodeFormwarningTemplate, '.o-form-error-container', {
      options: {
        warning: msg
      }
    });
  },
  clearWarnings: function () {
    this.$('.okta-form-infobox-warning').remove();
  },
  initialize: function () {
    const form = this;
    this.title = this.model.get('factorLabel');
    const factorType = this.model.get('factorType');
    const formAndButtonDetails = getFormAndButtonDetails.call(this, factorType);
    const warningDetails = formAndButtonDetails.warning;
    this.$el.attr('data-se', 'factor-' + factorType);
    this.subtitle = formAndButtonDetails.subtitle;
    this.listenTo(this.model, 'error', function () {
      this.clearErrors();
    });
    this.addInput({
      label: (0, _courage.loc)('mfa.challenge.enterCode.placeholder', 'login'),
      'label-top': true,
      className: 'o-form-fieldset o-form-label-top auth-passcode',
      name: 'answer',
      input: _TextBox.default,
      type: 'tel'
    });
    this.add((0, _courage.createButton)({
      attributes: {
        'data-se': formAndButtonDetails.buttonDataSe
      },
      className: 'button ' + formAndButtonDetails.buttonClassName,
      title: formAndButtonDetails.formSubmit,
      click: function () {
        form.clearErrors();
        this.disable();
        form.clearWarnings();
        this.options.title = formAndButtonDetails.formSubmitted;
        this.render();
        // To send an OTP to the device, make the same request but use
        // an empty passCode
        this.model.set('answer', '');
        this.model.save().then(function () {
          // render and focus on the passcode input field.
          form.getInputs().first().render().focus();
          return _q.default.delay(_Enums.default.API_RATE_LIMIT);
        }).then(() => {
          this.options.title = formAndButtonDetails.formRetry;
          this.enable();
          if (factorType === 'call' || factorType === 'sms') {
            form.showWarning(warningDetails);
          }
          this.render();
        });
      }
    }));
    if (this.options.appState.get('allowRememberDevice')) {
      this.addInput({
        label: false,
        'label-top': true,
        placeholder: this.options.appState.get('rememberDeviceLabel'),
        className: 'margin-btm-0',
        name: 'rememberDevice',
        type: 'checkbox'
      });
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/mfa-verify/PasswordForm.js":
/*!*************************************************!*\
  !*** ./src/v1/views/mfa-verify/PasswordForm.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
/*!
 * Copyright (c) 2016-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.Form.extend({
  className: 'mfa-verify-password',
  autoSave: true,
  noCancelButton: true,
  save: _courage._.partial(_courage.loc, 'mfa.challenge.verify', 'login'),
  scrollOnError: false,
  layout: 'o-form-theme',
  attributes: {
    'data-se': 'factor-password'
  },
  initialize: function () {
    this.title = this.model.get('factorLabel');
    this.addInput({
      label: (0, _courage.loc)('mfa.challenge.password.placeholder', 'login'),
      'label-top': true,
      className: 'auth-passcode',
      name: 'password',
      type: 'password',
      params: {
        showPasswordToggle: true
      }
    });
    if (this.options.appState.get('allowRememberDevice')) {
      this.addInput({
        label: false,
        'label-top': true,
        placeholder: this.options.appState.get('rememberDeviceLabel'),
        className: 'margin-btm-0',
        name: 'rememberDevice',
        type: 'checkbox'
      });
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/mfa-verify/PushForm.js":
/*!*********************************************!*\
  !*** ./src/v1/views/mfa-verify/PushForm.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _NumberChallengeView = _interopRequireDefault(__webpack_require__(/*! ./NumberChallengeView */ "./src/v1/views/mfa-verify/NumberChallengeView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const titleTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var stack1,
      helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      alias2 = container.hooks.helperMissing,
      alias3 = "function",
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return container.escapeExpression((helper = (helper = lookupProperty(helpers, "factorName") || (depth0 != null ? lookupProperty(depth0, "factorName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "factorName",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 0
        },
        "end": {
          "line": 1,
          "column": 14
        }
      }
    }) : helper)) + " (" + ((stack1 = (helper = (helper = lookupProperty(helpers, "deviceName") || (depth0 != null ? lookupProperty(depth0, "deviceName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "deviceName",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 16
        },
        "end": {
          "line": 1,
          "column": 32
        }
      }
    }) : helper)) != null ? stack1 : "") + ")";
  },
  "useData": true
});
// deviceName is escaped on BaseForm (see BaseForm's template)

const WARNING_TIMEOUT = 30000; // milliseconds
const PushFormwarningTemplate = _courage.View.extend({
  className: 'okta-form-infobox-warning infobox infobox-warning',
  attributes: {
    'aria-live': 'polite'
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<span class=\"icon warning-16\"></span><p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "warning") || (depth0 != null ? lookupProperty(depth0, "warning") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "warning",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 40
          },
          "end": {
            "line": 1,
            "column": 51
          }
        }
      }) : helper)) + "</p>";
    },
    "useData": true
  })
});
var _default = _courage.Form.extend({
  className: 'mfa-verify-push',
  autoSave: true,
  noCancelButton: true,
  save: _courage._.partial(_courage.loc, 'oktaverify.send', 'login'),
  scrollOnError: false,
  layout: 'o-form-theme',
  attributes: {
    'data-se': 'factor-push'
  },
  events: {
    submit: 'submit'
  },
  initialize: function () {
    this.enabled = true;
    this.listenTo(this.options.appState, 'change:isMfaRejected', this.handleRejectStateChange);
    this.numberChallengeView = this.add(_NumberChallengeView.default).last();
    this.listenTo(this.options.appState, 'change:isWaitingForNumberChallenge', function (state, isWaitingForNumberChallenge) {
      if (isWaitingForNumberChallenge || this.options.appState.get('lastAuthResponse').status === 'SUCCESS') {
        this.clearWarnings();
        this.$el.find('.button').hide();
        this.numberChallengeView.$el.show();
      } else {
        this.numberChallengeView.$el.hide();
        this.$el.find('.button').show();
      }
    });
    this.listenTo(this.options.appState, 'change:isMfaTimeout', function (state, isMfaTimeout) {
      this.setSubmitState(isMfaTimeout);
      if (isMfaTimeout) {
        this.showError((0, _courage.loc)('oktaverify.timeout', 'login'));
      }
    });
    this.listenTo(this.options.appState, 'change:isMfaRequired', function (state, isMfaRequired) {
      if (isMfaRequired) {
        this.clearErrors();
        this.clearWarnings();
      }
    });
    this.title = titleTpl({
      factorName: this.model.get('factorLabel'),
      deviceName: this.model.get('deviceName')
    });
  },
  setSubmitState: function (ableToSubmit) {
    const button = this.$el.find('.button');
    const a11ySpan = this.$el.find('.accessibility-text');
    this.enabled = ableToSubmit;
    if (ableToSubmit) {
      button.removeClass('link-button-disabled');
      button.prop('value', (0, _courage.loc)('oktaverify.send', 'login'));
      button.prop('disabled', false);
      if (a11ySpan) {
        a11ySpan.remove();
      }
    } else {
      button.addClass('link-button-disabled');
      button.prop('value', (0, _courage.loc)('oktaverify.sent', 'login'));
      button.prop('disabled', true);
      this.add(`<span class='accessibility-text' role='alert'>${(0, _courage.loc)('oktaverify.sent', 'login')}</span>`);
    }
  },
  submit: function (e) {
    if (e !== undefined) {
      e.preventDefault();
    }
    if (this.enabled) {
      this.setSubmitState(false);
      this.doSave();
    }
  },
  postRender: function () {
    const factorsPolicyInfo = this.options.appState.get('factorsPolicyInfo');
    const id = this.model.get('id');
    const isAutoPushEnabled = this.settings.get('features.autoPush') && factorsPolicyInfo && factorsPolicyInfo[id] ? factorsPolicyInfo[id]['autoPushEnabled'] : false;
    if (isAutoPushEnabled) {
      this.model.set('autoPush', true);
      // bind after $el has been rendered, and trigger push once DOM is fully loaded
      _courage._.defer(_courage._.bind(this.submit, this));
    }
  },
  doSave: function () {
    let warningTimeout;
    this.clearErrors();
    this.clearWarnings();
    if (this.model.isValid()) {
      this.listenToOnce(this.model, 'error', function () {
        this.setSubmitState(true);
        this.clearWarnings();
        clearTimeout(warningTimeout);
      });
      this.trigger('save', this.model);
      warningTimeout = _Util.default.callAfterTimeout(() => {
        if (!this.options.appState.get('isWaitingForNumberChallenge')) {
          this.showWarning((0, _courage.loc)('oktaverify.warning', 'login'));
        }
      }, WARNING_TIMEOUT);
    }
  },
  showError: function (msg) {
    this.clearWarnings();
    this.model.trigger('error', this.model, {
      responseJSON: {
        errorSummary: msg
      }
    });
  },
  showWarning: function (msg) {
    this.clearWarnings();
    this.add(PushFormwarningTemplate, '.o-form-error-container', {
      options: {
        warning: msg
      }
    });
  },
  clearWarnings: function () {
    this.$('.okta-form-infobox-warning').remove();
  },
  handleRejectStateChange: function (state, isMfaRejected) {
    if (isMfaRejected) {
      this.setSubmitState(isMfaRejected);
      this.setRejectedErrorMessage();
    }
  },
  setRejectedErrorMessage: function () {
    // If rejection is due to outdated app, show error message per platform
    // else show user rejected message.
    if (this.options.appState.get('lastAuthResponse').factorResultMessage === 'OKTA_VERIFY_UPGRADE_REQUIRED') {
      if (this.options.appState.get('factor').profile.platform === 'IOS') {
        this.showError((0, _courage.loc)('oktaverify.rejected.upgradeRequired.ios', 'login'));
      } else {
        this.showError((0, _courage.loc)('oktaverify.rejected.upgradeRequired.android', 'login'));
      }
    } else {
      this.showError((0, _courage.loc)('oktaverify.rejected', 'login'));
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/mfa-verify/SecurityQuestionForm.js":
/*!*********************************************************!*\
  !*** ./src/v1/views/mfa-verify/SecurityQuestionForm.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.Form.extend({
  className: 'mfa-verify-question',
  autoSave: true,
  noCancelButton: true,
  save: _courage._.partial(_courage.loc, 'mfa.challenge.verify', 'login'),
  scrollOnError: false,
  layout: 'o-form-theme',
  attributes: {
    'data-se': 'factor-question'
  },
  initialize: function () {
    this.title = this.model.get('factorLabel');
    this.addInput({
      label: this.model.get('securityQuestion'),
      'label-top': true,
      placeholder: (0, _courage.loc)('mfa.challenge.answer.placeholder', 'login'),
      className: 'auth-passcode',
      name: 'answer',
      type: 'password',
      params: {
        showPasswordToggle: true
      }
    });
    if (this.options.appState.get('allowRememberDevice')) {
      this.addInput({
        label: false,
        'label-top': true,
        placeholder: this.options.appState.get('rememberDeviceLabel'),
        className: 'margin-btm-0',
        name: 'rememberDevice',
        type: 'checkbox'
      });
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/mfa-verify/SendEmailAndVerifyCodeForm.js":
/*!***************************************************************!*\
  !*** ./src/v1/views/mfa-verify/SendEmailAndVerifyCodeForm.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _ResendEmailView = _interopRequireDefault(__webpack_require__(/*! v1/views/ResendEmailView */ "./src/v1/views/ResendEmailView.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const createEmailMaskElement = function () {
  const email = this.model.get('email');
  const emailTpl = _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<span class=\"mask-email\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "email") || (depth0 != null ? lookupProperty(depth0, "email") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "email",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 25
          },
          "end": {
            "line": 1,
            "column": 34
          }
        }
      }) : helper)) + "</span>";
    },
    "useData": true
  });
  return {
    factorEmail: emailTpl({
      email
    })
  };
};
const SendEmailAndVerifyCodeFormVerifyEmailCodeForm = _courage.Form.extend({
  layout: 'o-form-theme',
  className: 'mfa-verify-email',
  title: _courage._.partial(_courage.loc, 'email.mfa.title', 'login'),
  noButtonBar: false,
  autoSave: true,
  noCancelButton: true,
  attributes: {
    'data-se': 'factor-email'
  },
  save: function () {
    return this.options.appState.get('isMfaChallenge') ? (0, _courage.loc)('mfa.challenge.verify', 'login') : (0, _courage.loc)('email.button.send', 'login');
  },
  events: Object.assign({}, _courage.Form.prototype.events, {
    submit: function (e) {
      e.preventDefault();
      this.handleSubmit();
    }
  }),
  handleSubmit() {
    this.clearErrors();
    if (this.options.appState.get('isMfaChallenge')) {
      if (this.isValid()) {
        this.model.save();
      }
    } else {
      // Send email and switch to verification view
      this.model.set('answer', '');
      this.model.save().then(this.renderChallengView.bind(this));
    }
  },
  initialize: function () {
    _courage.Form.prototype.initialize.apply(this, arguments);

    // render 'Send Email' page at first place
    this.add(_courage.View.extend({
      attributes: {
        'data-se': 'mfa-send-email-content'
      },
      className: 'mfa-send-email-content',
      template: _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function (container, depth0, helpers, partials, data) {
          var stack1,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
          return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "i18n",
            "hash": {
              "arguments": "factorEmail",
              "bundle": "login",
              "code": "email.mfa.description"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 0
              },
              "end": {
                "line": 1,
                "column": 78
              }
            }
          })) != null ? stack1 : "";
        },
        "useData": true
      }),
      getTemplateData: createEmailMaskElement
    }));
  },
  renderChallengView: function () {
    this.removeChildren();
    this.add(_courage.View.extend({
      className: 'mfa-email-sent-content',
      attributes: {
        'data-se': 'mfa-email-sent-content'
      },
      // Why use `{{{` for the description?
      // - factorEmail is actually an HTML fragment which
      //   is created via another handlebar template and used for bold the email address.
      template: _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function (container, depth0, helpers, partials, data) {
          var stack1,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
          return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "i18n",
            "hash": {
              "arguments": "factorEmail",
              "bundle": "login",
              "code": "email.mfa.email.sent.description"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 0
              },
              "end": {
                "line": 1,
                "column": 89
              }
            }
          })) != null ? stack1 : "";
        },
        "useData": true
      }),
      getTemplateData: createEmailMaskElement
    }));
    this.add(_ResendEmailView.default);
    this.addInput({
      label: (0, _courage.loc)('email.code.label', 'login'),
      'label-top': true,
      name: 'answer',
      input: _TextBox.default,
      wide: true,
      type: 'tel'
    });
    if (this.options.appState.get('allowRememberDevice')) {
      this.addInput({
        label: false,
        'label-top': true,
        placeholder: this.options.appState.get('rememberDeviceLabel'),
        className: 'margin-btm-0',
        name: 'rememberDevice',
        type: 'checkbox'
      });
    }
    this.render();
  }
});
var _default = SendEmailAndVerifyCodeFormVerifyEmailCodeForm;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/mfa-verify/TOTPForm.js":
/*!*********************************************!*\
  !*** ./src/v1/views/mfa-verify/TOTPForm.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.Form.extend({
  className: 'mfa-verify-totp',
  autoSave: true,
  noCancelButton: true,
  save: _courage._.partial(_courage.loc, 'mfa.challenge.verify', 'login'),
  scrollOnError: false,
  layout: 'o-form-theme',
  attributes: {
    'data-se': 'factor-totp'
  },
  initialize: function () {
    const factorName = this.model.get('factorLabel');
    const maskPasswordField = this.model.get('provider') === 'RSA' || this.model.get('provider') === 'DEL_OATH';
    this.title = factorName;
    if (this.model.get('isFactorTypeVerification')) {
      this.subtitle = (0, _courage.loc)('mfa.challenge.totp.subtitle.multiple', 'login', [factorName]);
    } else {
      this.subtitle = (0, _courage.loc)('mfa.challenge.title', 'login', [factorName]);
    }
    this.addInput({
      label: (0, _courage.loc)('mfa.challenge.enterCode.placeholder', 'login'),
      'label-top': true,
      className: 'o-form-fieldset o-form-label-top auth-passcode',
      name: 'answer',
      input: _TextBox.default,
      type: maskPasswordField ? 'password' : 'tel'
    });
    if (this.options.appState.get('allowRememberDevice')) {
      this.addInput({
        label: false,
        'label-top': true,
        placeholder: this.options.appState.get('rememberDeviceLabel'),
        className: 'margin-btm-0',
        name: 'rememberDevice',
        type: 'checkbox'
      });
    }
    if (this.model.get('provider') === 'RSA' || this.model.get('provider') === 'DEL_OATH') {
      this.listenTo(this.model, 'error', (source, error) => {
        if (error && error.status === 409) {
          // 409 means we are in change pin, so we should clear out answer input
          this.$('.auth-passcode input').val('');
          this.$('.auth-passcode input').trigger('change');
          this.$('.auth-passcode input').focus();
        }
      });
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/mfa-verify/YubikeyForm.js":
/*!************************************************!*\
  !*** ./src/v1/views/mfa-verify/YubikeyForm.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.Form.extend({
  className: 'mfa-verify-yubikey',
  autoSave: true,
  noCancelButton: true,
  save: _courage._.partial(_courage.loc, 'mfa.challenge.verify', 'login'),
  scrollOnError: false,
  layout: 'o-form-theme',
  attributes: {
    'data-se': 'factor-yubikey'
  },
  initialize: function () {
    const factorName = this.model.get('factorLabel');
    this.title = factorName;
    this.subtitle = (0, _courage.loc)('factor.totpHard.yubikey.description', 'login');
    this.addInput({
      label: (0, _courage.loc)('factor.totpHard.yubikey.placeholder', 'login'),
      'label-top': true,
      className: 'o-form-fieldset o-form-label-top auth-passcode',
      name: 'answer',
      input: _TextBox.default,
      inputId: 'mfa-answer',
      type: 'password'
    });
    if (this.options.appState.get('allowRememberDevice')) {
      this.addInput({
        label: false,
        'label-top': true,
        className: 'margin-btm-0',
        placeholder: this.options.appState.get('rememberDeviceLabel'),
        name: 'rememberDevice',
        type: 'checkbox'
      });
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/mfa-verify/dropdown/FactorsDropDown.js":
/*!*************************************************************!*\
  !*** ./src/v1/views/mfa-verify/dropdown/FactorsDropDown.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _Factor = _interopRequireDefault(__webpack_require__(/*! v1//models/Factor */ "./src/v1/models/Factor.js"));
var _FactorsDropDownOptions = _interopRequireDefault(__webpack_require__(/*! ./FactorsDropDownOptions */ "./src/v1/views/mfa-verify/dropdown/FactorsDropDownOptions.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const {
  BaseDropDown
} = _courage.internal.views.components;
(0, _courage.$)(document).click(function (e) {
  const $target = (0, _courage.$)(e.target);
  const isDropdown = $target.closest('.option-selected').length > 0 && $target.closest('.dropdown').length > 0;
  if (!isDropdown) {
    (0, _courage.$)('.dropdown .options').hide();
    (0, _courage.$)('.dropdown a.option-selected').attr('aria-expanded', false);
  }
});
var _default = BaseDropDown.extend({
  className: 'bg-helper icon-button',
  screenReaderText: function () {
    const factors = this.options.appState.get('factors');
    let factor;
    let factorLabel;
    if (factors) {
      factor = _FactorUtil.default.findFactorInFactorsArray(factors, this.options.provider, this.options.factorType);
    } else {
      factor = new _Factor.default.Model(this.options.appState.get('factor'), this.toJSON());
    }
    factorLabel = factor.get('factorLabel');
    return (0, _courage.loc)('mfa.factors.dropdown.sr.text', 'login', [factorLabel]);
  },
  events: {
    'click a.option-selected': function (e) {
      e.preventDefault();
      if (_courage._.result(this, 'disabled')) {
        e.stopPropagation();
      } else {
        const expanded = this.$('.options').toggle().is(':visible');
        this.$('a.option-selected').attr('aria-expanded', expanded);
        if (expanded) {
          this.$('#okta-dropdown-options').find('li.factor-option:first a').focus();
        }
      }
    },
    'click .dropdown-disabled': function (e) {
      e.preventDefault();
      e.stopPropagation();
    }
  },
  initialize: function () {
    this.addOption(_FactorsDropDownOptions.default.getDropdownOption('TITLE'));
    const factorsList = this.options.appState.get('factors');
    const multiplePushFactors = factorsList.hasMultipleFactorsOfSameType('push');
    factorsList.each(function (factor) {
      // Do not add okta totp if there are multiple okta push (each push will have an inline totp)
      if (!(factor.get('factorType') === 'token:software:totp' && multiplePushFactors)) {
        this.addOption(_FactorsDropDownOptions.default.getDropdownOption(factor.get('factorName')), {
          model: factor
        });
        this.listenTo(this.last(), 'options:toggle', function () {
          this.$('.options').hide();
          this.$('a.option-selected').attr('aria-expanded', false);
        });
      }
    }, this);
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/mfa-verify/dropdown/FactorsDropDownOptions.js":
/*!********************************************************************!*\
  !*** ./src/v1/views/mfa-verify/dropdown/FactorsDropDownOptions.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _RouterUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/RouterUtil */ "./src/v1/util/RouterUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-statements: [2, 16], complexity: [2, 10] */

const pushTitleTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var stack1,
      helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      alias2 = container.hooks.helperMissing,
      alias3 = "function",
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return container.escapeExpression((helper = (helper = lookupProperty(helpers, "factorName") || (depth0 != null ? lookupProperty(depth0, "factorName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "factorName",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 0
        },
        "end": {
          "line": 1,
          "column": 14
        }
      }
    }) : helper)) + " (" + ((stack1 = (helper = (helper = lookupProperty(helpers, "deviceName") || (depth0 != null ? lookupProperty(depth0, "deviceName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
      "name": "deviceName",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 16
        },
        "end": {
          "line": 1,
          "column": 32
        }
      }
    }) : helper)) != null ? stack1 : "") + ")";
  },
  "useData": true
});

// deviceName is escaped on BaseForm (see BaseForm's template)

const action = function (model) {
  let factorIndex;
  const factorType = model.get('factorType');
  const factorsList = this.options.appState.get('factors');
  if (factorsList.hasMultipleFactorsOfSameType(factorType)) {
    factorIndex = factorsList.getFactorIndex(factorType, model.get('id'));
  }
  const url = _RouterUtil.default.createVerifyUrl(model.get('provider'), factorType, factorIndex);
  const self = this;
  this.options.appState.trigger('factorSwitched');
  this.model.manageTransaction(function (transaction, setTransaction) {
    // FACTOR_CHALLENGE does not have a prev link
    if (transaction.status === 'FACTOR_CHALLENGE') {
      this.options.appState.set('trapMfaRequiredResponse', true);
    }
    if (transaction.status === 'MFA_CHALLENGE' && transaction.prev) {
      this.options.appState.set('trapMfaRequiredResponse', true);
      return transaction.prev().then(function (trans) {
        self.trigger('options:toggle');
        setTransaction(trans);
        self.options.appState.trigger('navigate', url);
      });
    } else {
      self.trigger('options:toggle');
      self.options.appState.trigger('navigate', url);
    }
  });
};
const dropdownOptions = {
  TITLE: {
    title: _courage._.partial(_courage.loc, 'mfa.factors.dropdown.title', 'login'),
    className: 'dropdown-list-title',
    disabled: true
  },
  OKTA_VERIFY: {
    icon: 'factor-icon mfa-okta-verify-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  OKTA_VERIFY_PUSH: {
    icon: 'factor-icon mfa-okta-verify-30',
    className: 'factor-option',
    title: function () {
      return pushTitleTpl({
        factorName: this.model.get('factorLabel'),
        deviceName: this.model.get('deviceName')
      });
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  GOOGLE_AUTH: {
    icon: 'factor-icon mfa-google-auth-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  CUSTOM_HOTP: {
    icon: 'factor-icon mfa-hotp-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  SYMANTEC_VIP: {
    icon: 'factor-icon mfa-symantec-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  RSA_SECURID: {
    icon: 'factor-icon mfa-rsa-30',
    className: 'factor-option',
    title: _courage._.partial(_courage.loc, 'factor.totpHard.rsaSecurId', 'login'),
    action: function () {
      action.call(this, this.model);
    }
  },
  ON_PREM: {
    icon: 'factor-icon mfa-onprem-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  DUO: {
    icon: 'factor-icon mfa-duo-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  DUO_PUSH: {
    icon: 'duo-push-16',
    className: 'suboption factor-option',
    // TODO: add phone number here
    title: _courage._.partial(_courage.loc, 'mfa.duoSecurity.push', 'login', ['XXX-XXX-7890'])
  },
  DUO_SMS: {
    icon: 'duo-sms-16',
    className: 'suboption factor-option',
    // TODO: add phone number here
    title: _courage._.partial(_courage.loc, 'mfa.duoSecurity.sms', 'login', ['XXX-XXX-7890'])
  },
  DUO_CALL: {
    icon: 'duo-call-16',
    className: 'suboption factor-option',
    // TODO: add phone number here
    title: _courage._.partial(_courage.loc, 'mfa.duoSecurity.call', 'login', ['XXX-XXX-7890'])
  },
  YUBIKEY: {
    icon: 'factor-icon mfa-yubikey-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  SMS: {
    icon: 'factor-icon mfa-sms-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  CALL: {
    icon: 'factor-icon mfa-call-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  QUESTION: {
    icon: 'factor-icon mfa-question-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  PASSWORD: {
    icon: 'factor-icon mfa-password-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  WINDOWS_HELLO: {
    icon: 'factor-icon mfa-windows-hello-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  U2F: {
    icon: 'factor-icon mfa-u2f-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  WEBAUTHN: {
    icon: 'factor-icon mfa-webauthn-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  EMAIL: {
    icon: 'factor-icon mfa-email-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  GENERIC_SAML: {
    icon: 'factor-icon mfa-custom-factor-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  GENERIC_OIDC: {
    icon: 'factor-icon mfa-custom-factor-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  },
  CUSTOM_CLAIMS: {
    icon: 'factor-icon mfa-custom-factor-30',
    className: 'factor-option',
    title: function () {
      return this.model.get('factorLabel');
    },
    action: function () {
      action.call(this, this.model);
    }
  }
};
var _default = {
  getDropdownOption: function (factorName) {
    return dropdownOptions[factorName];
  }
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/primary-auth/CustomButtons.js":
/*!****************************************************!*\
  !*** ./src/v1/views/primary-auth/CustomButtons.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _OAuth2Util = _interopRequireDefault(__webpack_require__(/*! util/OAuth2Util */ "./src/util/OAuth2Util.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const SharedUtil = _courage.internal.util.Util;
const dividerTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<div class=\"auth-divider\"><span class=\"auth-divider-text\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "text",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 58
        },
        "end": {
          "line": 1,
          "column": 66
        }
      }
    }) : helper)) + "</span></div>";
  },
  "useData": true
});
const formTitleTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<h2 data-se=\"o-form-head\" class=\"okta-form-title o-form-head\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "title",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 62
        },
        "end": {
          "line": 1,
          "column": 71
        }
      }
    }) : helper)) + "</h2>";
  },
  "useData": true
});
var _default = _courage.View.extend({
  className: 'primary-auth-container',
  children: function () {
    const children = [];
    const socialIdpButtons = this.settings.get('configuredSocialIdps');
    const pivButton = this.settings.get('piv');
    const customButtons = this.settings.get('customButtons');
    const divider = dividerTpl({
      text: (0, _courage.loc)('socialauth.divider.text', 'login')
    });
    if (this.settings.get('hasPivCard')) {
      children.push(this._createPivButton(pivButton));
    }
    _courage._.each(socialIdpButtons, function (button) {
      children.push(this._createSocialIdpButton(button));
    }, this);
    _courage._.each(customButtons, function (button) {
      children.push(this._createCustomButton(button));
    }, this);

    // If the social auth buttons have to be above the Okta form, the title moves from
    // primary auth form to the social auth (above the buttons) and the divider goes below
    // the buttons (in between social auth and primary auth). If social auth needs to go below
    // Okta form, just add the divider at the top of the social auth container. The title still
    // lives in primary auth form.
    if (this.settings.get('socialAuthPositionTop')) {
      children.unshift(formTitleTpl({
        title: (0, _courage.loc)('primaryauth.title', 'login')
      }));
      // Divider between Primary Auth and the Social Auth
      children.push(divider);
    } else {
      children.unshift(divider);
    }
    return children;
  },
  _createSocialIdpButton: function (options) {
    return (0, _courage.createButton)({
      attributes: {
        'data-se': options.dataAttr
      },
      className: options.className,
      title: function () {
        return options.text || (0, _courage.loc)(options.i18nKey);
      },
      click: function (e) {
        e.preventDefault();
        if (this.settings.get('oauth2Enabled')) {
          _OAuth2Util.default.getTokens(this.settings, {
            idp: options.id
          }, this.options.currentController);
        } else {
          const baseUrl = this.settings.get('baseUrl');
          let params;
          const lastAuthResponse = this.options.appState.get('lastAuthResponse');
          if (this.options.appState.get('usingDeviceFlow')) {
            params = _courage.$.param({
              stateToken: lastAuthResponse === null || lastAuthResponse === void 0 ? void 0 : lastAuthResponse.stateToken
            });
          } else {
            params = _courage.$.param({
              fromURI: this.settings.get('relayState')
            });
          }
          const targetUri = `${baseUrl}/sso/idps/${options.id}?${params}`;
          SharedUtil.redirect(targetUri);
        }
      }
    });
  },
  _createPivButton: function (options) {
    let className = options.className || '';
    return (0, _courage.createButton)({
      attributes: {
        'data-se': 'piv-card-button'
      },
      className: className + ' piv-button',
      title: options.text || (0, _courage.loc)('piv.cac.card', 'login'),
      click: function (e) {
        e.preventDefault();
        this.options.appState.trigger('navigate', 'signin/verify/piv');
      }
    });
  },
  _createCustomButton: function (options) {
    return (0, _courage.createButton)({
      attributes: {
        'data-se': options.dataAttr
      },
      className: options.className + ' default-custom-button',
      title: function () {
        return options.title || (0, _courage.loc)(options.i18nKey);
      },
      click: options.click
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/primary-auth/PrimaryAuthForm.js":
/*!******************************************************!*\
  !*** ./src/v1/views/primary-auth/PrimaryAuthForm.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _DeviceFingerprint = _interopRequireDefault(__webpack_require__(/*! v1/util/DeviceFingerprint */ "./src/v1/util/DeviceFingerprint.js"));
var _TypingUtil = _interopRequireDefault(__webpack_require__(/*! v1/util/TypingUtil */ "./src/v1/util/TypingUtil.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _TextBox = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/TextBox */ "./src/v1/views/shared/TextBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.Form.extend({
  className: 'primary-auth-form',
  noCancelButton: true,
  attributes: {
    novalidate: 'novalidate'
  },
  save: function () {
    if (this.settings.get('features.passwordlessAuth')) {
      return (0, _courage.loc)('oform.next', 'login');
    }
    return (0, _courage.loc)('primaryauth.submit', 'login');
  },
  saveId: 'okta-signin-submit',
  layout: 'o-form-theme',
  // If socialAuth is configured, the title moves from the form to
  // the top of the container (and is rendered in socialAuth).
  title: function () {
    let formTitle = (0, _courage.loc)('primaryauth.title', 'login');
    if (this.settings.get('socialAuthPositionTop')) {
      formTitle = '';
    }
    return formTitle;
  },
  initialize: function () {
    const trackTypingPattern = this.settings.get('features.trackTypingPattern');
    this.listenTo(this, 'save', async function () {
      const {
        appState
      } = this.options;
      if (trackTypingPattern) {
        const typingPattern = _TypingUtil.default.getTypingPattern();
        appState.set('typingPattern', typingPattern);
      }
      const creds = {
        username: this.model.get('username')
      };
      if (!this.settings.get('features.passwordlessAuth')) {
        creds.password = this.model.get('password');
      }

      // show loading spinner and disable submit button before processCreds hook runs
      appState.trigger('loading', true);
      this.state.trigger('togglePrimaryAuthButton', true);
      await this.settings.processCreds(creds);
      if (this.settings.get('features.deviceFingerprinting')) {
        try {
          const fingerprint = await _DeviceFingerprint.default.generateDeviceFingerprint(this.settings.get('baseUrl'), this.$el);
          appState.set('deviceFingerprint', fingerprint);
        } catch {
          // Keep going even if device fingerprint fails
        }
      }
      this.model.save();
    });
    this.stateEnableChange();
    this.stateUsernameChange();
  },
  stateEnableChange: function () {
    this.listenTo(this.state, 'change:enabled', function (model, enable) {
      if (enable) {
        this.enable();
      } else {
        this.disable();
      }
    });
  },
  stateUsernameChange: function () {
    this.listenTo(this.state, 'change:disableUsername', function (model, disable) {
      if (disable) {
        this.$el.find('#okta-signin-username').attr('disabled', true);
      } else {
        this.$el.find('#okta-signin-username').removeAttr('disabled');
      }
    });
  },
  inputs: function () {
    const inputs = [];
    inputs.push(this.getUsernameField());
    if (!this.settings.get('features.passwordlessAuth')) {
      inputs.push(this.getPasswordField());
    }
    if (this.settings.get('features.rememberMe')) {
      inputs.push(this.getRemeberMeCheckbox());
    }
    return inputs;
  },
  getUsernameField: function () {
    const userNameFieldObject = {
      className: 'margin-btm-5',
      label: (0, _courage.loc)('primaryauth.username.placeholder', 'login'),
      'label-top': true,
      explain: () => {
        if (!this.isCustomized('primaryauth.username.tooltip')) {
          return false;
        }
        return _Util.default.createInputExplain('primaryauth.username.tooltip', 'primaryauth.username.placeholder', 'login');
      },
      'explain-top': true,
      name: 'username',
      input: _TextBox.default,
      inputId: 'okta-signin-username',
      type: 'text',
      disabled: this.options.appState.get('disableUsername'),
      autoComplete: _Util.default.getAutocompleteValue(this.settings, 'username'),
      // TODO: support a11y attrs in Courage - OKTA-279025
      render: function () {
        const that = this;
        function clearAriaInvalid() {
          that.$(this).removeAttr('aria-invalid').off('focusout', clearAriaInvalid).off('change', clearAriaInvalid);
        }
        this.$(`input[name=${this.options.name}]`)
        // OKTA-430928: to prevent NVDA and JAWS screen readers from
        // announcing "required invalid entry" before the user has a chance to
        // complete the field, aria-invalid is set to "false" initially and
        // removed on focusout or change using clearAriaInvalid()
        .attr({
          'aria-invalid': 'false',
          'aria-required': 'true'
        }).prop({
          required: true
        }).focusout(clearAriaInvalid).change(clearAriaInvalid);
      }
    };
    return userNameFieldObject;
  },
  getPasswordField: function () {
    const passwordFieldObject = {
      className: 'margin-btm-30',
      label: (0, _courage.loc)('primaryauth.password.placeholder', 'login'),
      'label-top': true,
      explain: () => {
        if (!this.isCustomized('primaryauth.password.tooltip')) {
          return false;
        }
        return _Util.default.createInputExplain('primaryauth.password.tooltip', 'primaryauth.password.placeholder', 'login');
      },
      'explain-top': true,
      name: 'password',
      inputId: 'okta-signin-password',
      validateOnlyIfDirty: true,
      type: 'password',
      autoComplete: _Util.default.getAutocompleteValue(this.settings, 'current-password'),
      // TODO: support a11y attrs in Courage - OKTA-279025
      render: function () {
        const that = this;
        function clearAriaInvalid() {
          that.$(this).removeAttr('aria-invalid').off('focusout', clearAriaInvalid).off('change', clearAriaInvalid);
        }
        this.$(`input[name=${this.options.name}]`)
        // OKTA-430928: to prevent NVDA and JAWS screen readers from
        // announcing "required invalid entry" before the user has a chance to
        // complete the field, aria-invalid is set to "false" initially and
        // removed on focusout or change using clearAriaInvalid()
        .attr({
          'aria-invalid': 'false',
          'aria-required': 'true'
        }).prop({
          required: true
        }).focusout(clearAriaInvalid).change(clearAriaInvalid);
      }
    };
    if (this.settings.get('features.showPasswordToggleOnSignInPage')) {
      passwordFieldObject.params = {};
      passwordFieldObject.params.showPasswordToggle = true;
    }
    return passwordFieldObject;
  },
  isCustomized: function (property) {
    const language = this.settings.get('language');
    const i18n = this.settings.get('i18n');
    const customizedProperty = i18n && i18n[language] && i18n[language][property];
    return !!customizedProperty;
  },
  // TODO fix method name typo
  getRemeberMeCheckbox: function () {
    return {
      label: false,
      placeholder: (0, _courage.loc)('remember', 'login'),
      name: 'remember',
      type: 'checkbox',
      'label-top': true,
      className: 'margin-btm-0',
      initialize: function () {
        this.listenTo(this.model, 'change:remember', function (model, val) {
          // OKTA-98946: We normally re-render on changes to model values,
          // but in this case we will manually update the checkbox due to
          // iOS Safari and how it handles autofill - it will autofill the
          // form anytime the dom elements are re-rendered, which prevents
          // the user from editing their username.
          this.$(':checkbox').prop('checked', val).trigger('updateState');
        });
      }
    };
  },
  focus: function () {
    if (!this.model.get('username')) {
      this.getInputs().first().focus();
    } else if (!this.settings.get('features.passwordlessAuth')) {
      this.getInputs().toArray()[1].focus();
    }
    if (this.settings.get('features.trackTypingPattern')) {
      _TypingUtil.default.track('okta-signin-username');
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/registration/SubSchema.js":
/*!************************************************!*\
  !*** ./src/v1/views/registration/SubSchema.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const SubSchemaSubSchema = _courage.View.extend({
  index: '',
  message: '',
  class: function () {
    return;
  },
  className: function () {
    return 'subschema-unsatisfied subschema-' + this.index;
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p class=\"default-schema\"><span class=\"icon icon-16\"></span>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "message",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 60
          },
          "end": {
            "line": 1,
            "column": 71
          }
        }
      }) : helper)) + "</p>";
    },
    "useData": true
  }),
  getTemplateData: function () {
    return {
      message: this.message
    };
  }
});
var _default = _courage.View.extend({
  className: 'subschema',
  children: function () {
    return this.subSchemas.map(function (subSchema, index) {
      const description = subSchema.get('description');
      const message = description;
      // TODO API should send translated strings instead of i18n code inside description
      // or send param with i18n code

      return SubSchemaSubSchema.extend({
        index: index,
        message: message
      });
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/AuthContainer.js":
/*!**********************************************!*\
  !*** ./src/v1/views/shared/AuthContainer.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const CAN_REMOVE_BEACON_CLS = 'can-remove-beacon';
var _default = _courage.View.extend({
  tagName: 'main',
  className: 'auth-container main-container',
  id: _Enums.default.WIDGET_CONTAINER_ID,
  attributes: {
    'data-se': 'auth-container',
    tabindex: '-1'
  },
  initialize: function (options) {
    this.listenTo(options.appState, 'change:beaconType', function (model, type) {
      this.$el.toggleClass(CAN_REMOVE_BEACON_CLS, type === 'security');
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/ContactSupport.js":
/*!***********************************************!*\
  !*** ./src/v1/views/shared/ContactSupport.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<div class=\"infobox\"><span class=\"icon info-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "arguments": "helpSupportNumber",
          "bundle": "login",
          "code": "contact.support"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 134
          }
        }
      })) + "</p></div>";
    },
    "useData": true
  }),
  className: 'contact-support',
  getTemplateData: function () {
    return this.settings.pick('helpSupportNumber');
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/FactorBeacon.js":
/*!*********************************************!*\
  !*** ./src/v1/views/shared/FactorBeacon.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Factor = _interopRequireDefault(__webpack_require__(/*! v1/models/Factor */ "./src/v1/models/Factor.js"));
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _FactorsDropDown = _interopRequireDefault(__webpack_require__(/*! v1/views/mfa-verify/dropdown/FactorsDropDown */ "./src/v1/views/mfa-verify/dropdown/FactorsDropDown.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
/* eslint complexity: [2, 8] */
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"beacon-blank auth-beacon\"><div class=\"beacon-blank js-blank-beacon-border auth-beacon-border\"></div></div><div class=\"bg-helper auth-beacon auth-beacon-factor " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "className",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 171
          },
          "end": {
            "line": 1,
            "column": 184
          }
        }
      }) : helper)) + "\" data-se=\"factor-beacon\"><div class=\"okta-sign-in-beacon-border auth-beacon-border\"></div></div><div data-type=\"factor-types-dropdown\" class=\"factors-dropdown-wrap\"></div>";
    },
    "useData": true
  }),
  events: {
    'click .auth-beacon-factor': function (e) {
      e.preventDefault();
      e.stopPropagation();
      const expanded = this.$('.dropdown .options').toggle().is(':visible');
      this.$('a.option-selected').attr('aria-expanded', expanded);
      if (expanded) {
        this.$('#okta-dropdown-options').find('li.factor-option:first a').focus();
      }
    }
  },
  initialize: function () {
    this.options.appState.set('beaconType', 'factor');
  },
  getTemplateData: function () {
    const factors = this.options.appState.get('factors');
    let factor;
    let className;
    if (factors) {
      factor = _FactorUtil.default.findFactorInFactorsArray(factors, this.options.provider, this.options.factorType);
    } else {
      factor = new _Factor.default.Model(this.options.appState.get('factor'));
    }
    className = factor.get('iconClassName');
    return {
      className: className || ''
    };
  },
  postRender: function () {
    if (this.options.animate) {
      this.$('.auth-beacon-factor').fadeIn(200);
    }
    const appState = this.options.appState;
    if (appState.get('hasMultipleFactorsAvailable')) {
      this.add(_FactorsDropDown.default, '[data-type="factor-types-dropdown"]');
    }
  },
  fadeOut: function () {
    const deferred = _q.default.defer();
    this.$('.auth-beacon-factor').fadeOut(200, function () {
      deferred.resolve();
    });
    return deferred.promise;
  },
  equals: function (Beacon, options) {
    return Beacon && this instanceof Beacon && options.provider === this.options.provider && (options.factorType === this.options.factorType || _FactorUtil.default.isOktaVerify(options.provider, options.factorType) && _FactorUtil.default.isOktaVerify(this.options.provider, this.options.factorType));
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/Footer.js":
/*!***************************************!*\
  !*** ./src/v1/views/shared/Footer.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const {
  Util
} = _courage.internal.util;
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<li><a href=\"#\" data-se=\"unlock\" class=\"link js-unlock\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "unlockaccount"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 440
          },
          "end": {
            "line": 1,
            "column": 484
          }
        }
      })) + "</a></li>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<li><a href=\"" + alias4((helper = (helper = lookupProperty(helpers, "href") || (depth0 != null ? lookupProperty(depth0, "href") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "href",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 539
          },
          "end": {
            "line": 1,
            "column": 547
          }
        }
      }) : helper)) + "\" class=\"link js-custom\" rel=\"noopener noreferrer\" " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "target") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(4, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 598
          },
          "end": {
            "line": 1,
            "column": 638
          }
        }
      })) != null ? stack1 : "") + ">" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "text",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 639
          },
          "end": {
            "line": 1,
            "column": 647
          }
        }
      }) : helper)) + "</a></li>";
    },
    "4": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "target=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "target") || (depth0 != null ? lookupProperty(depth0, "target") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "target",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 620
          },
          "end": {
            "line": 1,
            "column": 630
          }
        }
      }) : helper)) + "\"";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<a href=\"#\" data-se=\"needhelp\" aria-expanded=\"false\" aria-controls=\"help-links-container\" class=\"link help js-help\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "needhelp"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 116
          },
          "end": {
            "line": 1,
            "column": 155
          }
        }
      })) + "</a><ul class=\"help-links js-help-links\" id=\"help-links-container\"><li><a href=\"#\" data-se=\"forgot-password\" class=\"link js-forgot-password\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "forgotpassword"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 296
          },
          "end": {
            "line": 1,
            "column": 341
          }
        }
      })) + "</a></li>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "features") : depth0) != null ? lookupProperty(stack1, "selfServiceUnlock") : stack1, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 350
          },
          "end": {
            "line": 1,
            "column": 500
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "each").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "helpLinks") : depth0) != null ? lookupProperty(stack1, "custom") : stack1, {
        "name": "each",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 500
          },
          "end": {
            "line": 1,
            "column": 665
          }
        }
      })) != null ? stack1 : "") + "<li><a href=\"" + alias3((helper = (helper = lookupProperty(helpers, "helpLinkUrl") || (depth0 != null ? lookupProperty(depth0, "helpLinkUrl") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "helpLinkUrl",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 678
          },
          "end": {
            "line": 1,
            "column": 693
          }
        }
      }) : helper)) + "\" data-se=\"help-link\" class=\"link js-help-link\" rel=\"noopener noreferrer\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "help"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 783
          },
          "end": {
            "line": 1,
            "column": 818
          }
        }
      })) + "</a></li></ul>";
    },
    "useData": true
  }),
  className: 'auth-footer',
  initialize: function () {
    this.listenTo(this.state, 'change:enabled', function (model, enable) {
      this.$('.link').toggleClass('o-form-disabled', !enable);
    });
  },
  getTemplateData: function () {
    let helpLinkUrl;
    const customHelpPage = this.settings.get('helpLinks.help');
    if (customHelpPage) {
      helpLinkUrl = customHelpPage;
    } else {
      helpLinkUrl = _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function (container, depth0, helpers, partials, data) {
          var helper,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
          return container.escapeExpression((helper = (helper = lookupProperty(helpers, "baseUrl") || (depth0 != null ? lookupProperty(depth0, "baseUrl") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "baseUrl",
            "hash": {},
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 0
              },
              "end": {
                "line": 1,
                "column": 11
              }
            }
          }) : helper)) + "/help/login";
        },
        "useData": true
      })({
        baseUrl: this.settings.get('baseUrl')
      });
    }
    return _courage._.extend(this.settings.toJSON({
      verbose: true
    }), {
      helpLinkUrl: helpLinkUrl
    });
  },
  postRender: function () {
    this.$('.js-help-links').hide();
  },
  toggleLinks: function (e) {
    e.preventDefault();
    this.$('.js-help-links').slideToggle(200, () => {
      this.$('.js-help').attr('aria-expanded', this.$('.js-help-links').is(':visible'));
    });
  },
  events: {
    'click .js-help': function (e) {
      e.preventDefault();
      if (!this.state.get('enabled')) {
        return;
      }
      this.toggleLinks(e);
    },
    'click .js-forgot-password': function (e) {
      e.preventDefault();
      if (!this.state.get('enabled')) {
        return;
      }
      const customResetPasswordPage = this.settings.get('helpLinks.forgotPassword');
      if (customResetPasswordPage) {
        Util.redirect(customResetPasswordPage);
      } else {
        this.options.appState.trigger('navigate', 'signin/forgot-password');
      }
    },
    'click .js-unlock': function (e) {
      e.preventDefault();
      if (!this.state.get('enabled')) {
        return;
      }
      const customUnlockPage = this.settings.get('helpLinks.unlock');
      if (customUnlockPage) {
        Util.redirect(customUnlockPage);
      } else {
        this.options.appState.trigger('navigate', 'signin/unlock');
      }
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/FooterMFA.js":
/*!******************************************!*\
  !*** ./src/v1/views/shared/FooterMFA.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _FooterSignout = _interopRequireDefault(__webpack_require__(/*! ./FooterSignout */ "./src/v1/views/shared/FooterSignout.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _FooterSignout.default.extend({
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<a href=\"" + alias4((helper = (helper = lookupProperty(helpers, "factorPageCustomLinkHref") || (depth0 != null ? lookupProperty(depth0, "factorPageCustomLinkHref") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "factorPageCustomLinkHref",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 40
          },
          "end": {
            "line": 1,
            "column": 68
          }
        }
      }) : helper)) + "\" data-se=\"factor-page-custom-link\" class=\"link js-factor-page-custom-link\" rel=\"noopener noreferrer\" target=\"_blank\">" + alias4((helper = (helper = lookupProperty(helpers, "factorPageCustomLinkText") || (depth0 != null ? lookupProperty(depth0, "factorPageCustomLinkText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "factorPageCustomLinkText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 186
          },
          "end": {
            "line": 1,
            "column": 214
          }
        }
      }) : helper)) + "</a>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<a href=\"#\" class=\"link " + alias4((helper = (helper = lookupProperty(helpers, "linkClassName") || (depth0 != null ? lookupProperty(depth0, "linkClassName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "linkClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 265
          },
          "end": {
            "line": 1,
            "column": 282
          }
        }
      }) : helper)) + "\" data-se=\"signout-link\">" + alias4((helper = (helper = lookupProperty(helpers, "linkText") || (depth0 != null ? lookupProperty(depth0, "linkText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "linkText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 307
          },
          "end": {
            "line": 1,
            "column": 319
          }
        }
      }) : helper)) + "</a>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "hasFactorPageCustomLink") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 225
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "showLink") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 225
          },
          "end": {
            "line": 1,
            "column": 330
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  className: 'auth-footer clearfix',
  getTemplateData: function () {
    const signoutTemplateData = _FooterSignout.default.prototype.getTemplateData.apply(this, arguments);
    const factorPageCustomLinkHref = this.settings.get('helpLinks.factorPage.href');
    const factorPageCustomLinkText = this.settings.get('helpLinks.factorPage.text');
    const showLink = !this.settings.get('features.hideSignOutLinkInMFA') && !this.settings.get('features.mfaOnlyFlow');
    return Object.assign({}, signoutTemplateData, {
      hasFactorPageCustomLink: factorPageCustomLinkText && factorPageCustomLinkHref,
      factorPageCustomLinkHref,
      factorPageCustomLinkText,
      showLink
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/FooterRegistration.js":
/*!***************************************************!*\
  !*** ./src/v1/views/shared/FooterRegistration.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2016-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"content-container\"><span class=\"registration-label\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 64
          },
          "end": {
            "line": 1,
            "column": 73
          }
        }
      }) : helper)) + "</span><a title=\"" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "text",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 90
          },
          "end": {
            "line": 1,
            "column": 98
          }
        }
      }) : helper)) + "\" aria-label=\"" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "text",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 112
          },
          "end": {
            "line": 1,
            "column": 120
          }
        }
      }) : helper)) + "\" class=\"registration-link\" href=\"#\">" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "text",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 157
          },
          "end": {
            "line": 1,
            "column": 165
          }
        }
      }) : helper)) + "</a></div>";
    },
    "useData": true
  }),
  className: 'registration-container',
  events: {
    'click a.registration-link': 'handleClickEvent'
  },
  handleClickEvent: function (e) {
    e.preventDefault();
    const clickHandler = this.settings.get('registration.click');
    if (clickHandler) {
      clickHandler();
    } else if (this.options.appState.get('isIdxStateToken')) {
      this.options.appState.trigger('navigate', 'signin/enroll-user');
    } else {
      this.options.appState.trigger('navigate', 'signin/register');
    }
  },
  getTemplateData: function () {
    const templateData = {
      label: (0, _courage.loc)('registration.signup.label', 'login'),
      text: (0, _courage.loc)('registration.signup.text', 'login')
    };
    return templateData;
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/FooterSignout.js":
/*!**********************************************!*\
  !*** ./src/v1/views/shared/FooterSignout.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const {
  Util
} = _courage.internal.util;
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<a href=\"#\" class=\"link " + alias4((helper = (helper = lookupProperty(helpers, "linkClassName") || (depth0 != null ? lookupProperty(depth0, "linkClassName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "linkClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 24
          },
          "end": {
            "line": 1,
            "column": 41
          }
        }
      }) : helper)) + "\" data-se=\"signout-link\">" + alias4((helper = (helper = lookupProperty(helpers, "linkText") || (depth0 != null ? lookupProperty(depth0, "linkText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "linkText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 66
          },
          "end": {
            "line": 1,
            "column": 78
          }
        }
      }) : helper)) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer clearfix',
  events: {
    'click a[data-se="signout-link"]': 'handleSignout'
  },
  handleSignout: function (e) {
    e.preventDefault();
    const appState = this.options.appState;
    appState.trigger('signOut');
    const isSMSPasswordRecovery = appState.get('isSMSPasswordRecovery');
    this.model.doTransaction(function (transaction) {
      // `clearTransactionData` was added as a temporary fix for the issue reported in OKTA-487220
      // OKTA-515889 was created to address the underlying issue on the `transaction.cancel` level
      // and this temporary fix will be removed after that ticket is done
      return transaction.cancel().then(clearTransactionData);
    }).then(() => {
      if (this.settings.get('backToSignInUri') && !isSMSPasswordRecovery) {
        Util.redirect(this.settings.get('backToSignInUri'));
      } else {
        this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
        appState.trigger('navigate', '');
      }
    });
  },
  getTemplateData: function () {
    return {
      linkClassName: _courage._.isUndefined(this.options.linkClassName) ? 'goto' : this.options.linkClassName,
      linkText: this.options.linkText || (0, _courage.loc)('goback', 'login')
    };
  }
}); // TODO: remove after OKTA-515889 is done
exports["default"] = _default;
function clearTransactionData(transaction) {
  return {
    ...transaction,
    data: null
  };
}
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/FooterWithBackLink.js":
/*!***************************************************!*\
  !*** ./src/v1/views/shared/FooterWithBackLink.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<a href=\"#\" class=\"link help\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "goback"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 50
          },
          "end": {
            "line": 1,
            "column": 87
          }
        }
      })) + "</a>";
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .help': function (e) {
      e.preventDefault();
      this.back();
    }
  },
  back: function () {
    this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
    this.options.appState.trigger('navigate', '');
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/FooterWithBackLinkOnError.js":
/*!**********************************************************!*\
  !*** ./src/v1/views/shared/FooterWithBackLinkOnError.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<a href=\"#\" class=\"link help\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "goback"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 66
          },
          "end": {
            "line": 1,
            "column": 103
          }
        }
      })) + "</a>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "showLink") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 114
          }
        }
      })) != null ? stack1 : "";
    },
    "useData": true
  }),
  className: 'auth-footer',
  events: {
    'click .help': function (e) {
      e.preventDefault();
      this.back();
    }
  },
  back: function () {
    this.state.set('navigateDir', _Enums.default.DIRECTION_BACK);
    this.options.appState.trigger('navigate', '');
  },
  getTemplateData: function () {
    const error = this.model.appState.get('flashError');
    const showLink = error.is && error.is('terminal');
    return {
      showLink: showLink
    };
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/LoadingBeacon.js":
/*!**********************************************!*\
  !*** ./src/v1/views/shared/LoadingBeacon.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      return "<div class=\"beacon-blank\"></div><div class=\"bg-helper auth-beacon auth-beacon-security\" data-se=\"loading-beacon\"><div class=\"okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border\"></div></div>";
    },
    "useData": true
  }),
  equals: function (Beacon) {
    return Beacon && this instanceof Beacon;
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/PIVBeacon.js":
/*!******************************************!*\
  !*** ./src/v1/views/shared/PIVBeacon.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  className: 'piv-beacon',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      return "<div class=\"beacon-blank auth-beacon\"><div class=\"beacon-blank js-blank-beacon-border auth-beacon-border\"></div></div><div class=\"bg-helper auth-beacon smartcard\" data-se=\"piv-beacon\"><div class=\"okta-sign-in-beacon-border auth-beacon-border\"></div></div>";
    },
    "useData": true
  }),
  equals: function (Beacon) {
    return Beacon && this instanceof Beacon;
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/PasswordRequirements.js":
/*!*****************************************************!*\
  !*** ./src/v1/views/shared/PasswordRequirements.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"password-requirements--header\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "password.complexity.requirements.header"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 63
          },
          "end": {
            "line": 1,
            "column": 133
          }
        }
      })) + "</div><ul class=\"password-requirements--list\">" + ((stack1 = lookupProperty(helpers, "each").call(alias1, depth0 != null ? lookupProperty(depth0, "requirements") : depth0, {
        "name": "each",
        "hash": {},
        "fn": container.program(2, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 179
          },
          "end": {
            "line": 1,
            "column": 268
          }
        }
      })) != null ? stack1 : "") + "</ul>";
    },
    "2": function (container, depth0, helpers, partials, data) {
      return "<li class=\"password-requirements--list-item\">" + container.escapeExpression(container.lambda(depth0, depth0)) + "</li>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "requirements") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 280
          }
        }
      })) != null ? stack1 : "";
    },
    "useData": true
  }),
  attributes: {
    'data-se': 'password-requirements-html'
  },
  allRequirements: [],
  initialize: function (options) {
    const policy = options.policy;
    if (!policy) {
      return;
    }
    this.allRequirements = _FactorUtil.default.getPasswordComplexityDescriptionForHtmlList(policy);
  },
  getTemplateData: function () {
    return {
      requirements: this.allRequirements
    };
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/SecurityBeacon.js":
/*!***********************************************!*\
  !*** ./src/v1/views/shared/SecurityBeacon.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Animations = _interopRequireDefault(__webpack_require__(/*! util/Animations */ "./src/util/Animations.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

function setBackgroundImage(el, appState) {
  const imgSrc = appState.get('securityImage');
  const imgDescription = appState.get('securityImageDescription');
  const isUndefinedUser = appState.get('isUndefinedUser');
  const isNewUser = appState.get('isNewUser');
  const isSecurityImage = !isUndefinedUser && !isNewUser;
  // NOTE: The imgSrc is returned by the server so that every
  // user has a unique image. However new and undefined user states
  // are hard coded into the css and the value returned by the server
  // is ignored.

  el.css('background-image', '');
  el.removeClass('new-user undefined-user');
  if (isNewUser) {
    el.addClass('new-user');
    return;
  }
  if (isUndefinedUser) {
    el.addClass('undefined-user');
    return;
  }
  if (isSecurityImage) {
    // TODO: Newer versions of qtip will remove aria-describedby on their own when destroy() is called.
    el.removeAttr('aria-describedby');
    el.find('.accessibility-text').text(imgDescription);
    el.css('background-image', 'url(' + _courage._.escape(imgSrc) + ')');
    return;
  }
}
function antiPhishingMessage(image, host) {
  (0, _courage.$)(window).on('resize.securityBeaconQtip', _courage._.debounce(function () {
    if (image.is(':visible')) {
      image.qtip('show');
    }
  }, 300));

  // Show the message that the user has not logged in from this device before.
  image.qtip({
    prerender: true,
    content: {
      text: (0, _courage.loc)('primaryauth.newUser.tooltip', 'login', [_courage._.escape(host)]),
      button: (0, _courage.loc)('primaryauth.newUser.tooltip.close', 'login')
    },
    style: {
      classes: 'okta-security-image-tooltip security-image-qtip qtip-custom qtip-shadow qtip-rounded',
      tip: {
        height: 12,
        width: 16
      }
    },
    position: {
      my: 'top center',
      at: 'center',
      target: (0, _courage.$)('.auth-beacon-security'),
      adjust: {
        method: 'flip',
        scroll: false,
        resize: true
      },
      effect: false
    },
    hide: {
      event: false,
      fixed: true
    },
    show: {
      event: false,
      delay: 200
    },
    events: {
      move: function (event, api) {
        if (!api.elements.target.is(':visible')) {
          // Have to hide it immediately, with no effect
          api.set('hide.effect', false);
          api.hide();
          api.set('hide.effect', true);
        }
      }
    }
  });

  // It is necessary to delay toggle to the next render cycle, since qtip internally defers some setup tasks.
  setTimeout(() => {
    image.qtip('toggle', image.is(':visible'));
  }, 0);
}
function destroyAntiPhishingMessage(image) {
  image.qtip('destroy');
  (0, _courage.$)(window).off('resize.securityBeaconQtip');
}
async function updateSecurityImage($el, appState, animate) {
  const image = $el.find('.auth-beacon-security');
  const border = $el.find('.js-auth-beacon-border');
  const hasBorder = !appState.get('isUndefinedUser');
  const hasAntiPhishing = appState.get('isNewUser');
  const radialProgressBar = $el.find('.radial-progress-bar');
  const host = appState.get('baseUrl').match(/https?:\/\/(.[^/]+)/)[1];
  const duration = 200;
  if (!animate) {
    // Do not animate the security beacon
    // This occurs when initializing the form
    setBackgroundImage(image, appState);
    border.toggleClass('auth-beacon-border', hasBorder);
    return;
  }
  destroyAntiPhishingMessage(image);

  // Animate loading the security beacon
  if (!hasBorder) {
    // This occurs when appState username is blank
    // we do not yet know if the user is recognized
    image.fadeOut(duration, function () {
      setBackgroundImage(image, appState);
      border.removeClass('auth-beacon-border');
      image.fadeIn(duration);
    });
  } else {
    // Animate loading the security beacon with a loading bar for the border
    // This occurs when the username has been checked against Okta.
    border.removeClass('auth-beacon-border');
    await _Animations.default.radialProgressBar({
      $el: radialProgressBar,
      swap() {
        image.fadeOut(duration, () => {
          setBackgroundImage(image, appState);
          image.fadeIn(duration);
        });
      }
    });
    border.addClass('auth-beacon-border');
    if (hasAntiPhishing) {
      antiPhishingMessage(image, host);
    }
  }
}
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      return "<div class=\"beacon-blank\"><div class=\"radial-progress-bar\"><div class=\"circle left\"></div><div class=\"circle right\"></div></div></div><div aria-live=\"polite\" role=\"img\" class=\"bg-helper auth-beacon auth-beacon-security\" data-se=\"security-beacon\"><span class=\"accessibility-text\"></span><div class=\"okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border\"></div></div>";
    },
    "useData": true
  }),
  className: 'js-security-beacon',
  initialize: function (options) {
    this.update = _courage._.partial(updateSecurityImage, this.$el, options.appState);
    this.listenTo(options.appState, 'change:securityImage', this.update);
    this.listenTo(options.appState, 'loading', function (isLoading) {
      this.$el.toggleClass('beacon-loading', isLoading);
      this.removeAntiPhishingMessage();
    });
    this.options.appState.set('beaconType', 'security');
    this.listenTo(options.appState, 'navigate', this.removeAntiPhishingMessage);
  },
  postRender: function () {
    this.update(false);
  },
  equals: function (Beacon) {
    return Beacon && this instanceof Beacon;
  },
  removeAntiPhishingMessage: function () {
    const image = this.$el.find('.auth-beacon-security');
    image.qtip('destroy');
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/SkipLink.js":
/*!*****************************************!*\
  !*** ./src/v1/views/shared/SkipLink.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _courage.View.extend({
  tagName: 'a',
  className: 'skip-to-content-link',
  attributes: {
    href: `#${_Enums.default.WIDGET_CONTAINER_ID}`
  },
  initialize: function initialize() {
    this.$el.append((0, _courage.loc)('skip.to.main.content', 'login'));
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/Spinner.js":
/*!****************************************!*\
  !*** ./src/v1/views/shared/Spinner.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  className: 'okta-waiting-spinner',
  attributes: {
    'data-se': 'o-form-okta-waiting-spinner'
  },
  modelEvents: {
    'spinner:show': 'show',
    'spinner:hide': 'hide'
  },
  initialize: function (options) {
    if (options && options.visible === false) {
      this.hide();
    }
  },
  show: function () {
    this.$el.removeClass('hide');
  },
  hide: function () {
    this.$el.addClass('hide');
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/TextBox.js":
/*!****************************************!*\
  !*** ./src/v1/views/shared/TextBox.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
__webpack_require__(/*! @okta/qtip */ "./packages/@okta/qtip2/dist/jquery.qtip.js");
var _BrowserFeatures = _interopRequireDefault(__webpack_require__(/*! util/BrowserFeatures */ "./src/util/BrowserFeatures.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

//note: not including Okta here and explicitly including jquery and Handlebars
//because we want to be explicit about which TextBox we are extending here
//and want to avoid the cirucular dependency that occurs if we
//include Okta

const {
  TextBox
} = _courage.internal.views.forms.inputs;
var _default = TextBox.extend({
  postRender: function () {
    if (this.options.type === 'number') {
      const input = this.$('input');
      input.attr({
        pattern: '[0-9]*',
        inputmode: 'numeric'
      });
    }
    TextBox.prototype.postRender.apply(this, arguments);
  },
  // Override the focus() to ignore focus in IE. IE (8-11) has a known bug where
  // the placeholder text disappears when the input field is focused.
  focus: function () {
    if (_BrowserFeatures.default.isIE()) {
      return;
    }
    return TextBox.prototype.focus.apply(this, arguments);
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/templates/consentLogoHeaderTemplate.js":
/*!********************************************************************!*\
  !*** ./src/v1/views/shared/templates/consentLogoHeaderTemplate.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const consentLogoHeaderTemplate = _runtime.default.template({
  "1": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<a href=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "clientURI") || (depth0 != null ? lookupProperty(depth0, "clientURI") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "clientURI",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 26
        },
        "end": {
          "line": 1,
          "column": 39
        }
      }
    }) : helper)) + "\" class=\"client-logo-link\" target=\"_blank\">";
  },
  "3": function (container, depth0, helpers, partials, data) {
    var helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      alias2 = container.hooks.helperMissing,
      alias3 = container.escapeExpression,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<img class=\"client-logo custom-logo\" src=\"" + alias3((helper = (helper = lookupProperty(helpers, "customLogo") || (depth0 != null ? lookupProperty(depth0, "customLogo") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
      "name": "customLogo",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 149
        },
        "end": {
          "line": 1,
          "column": 163
        }
      }
    }) : helper)) + "\" alt=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
      "name": "i18n",
      "hash": {
        "bundle": "login",
        "code": "common.logo.alt"
      },
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 170
        },
        "end": {
          "line": 1,
          "column": 216
        }
      }
    })) + "\" aria-hidden=\"true\" />";
  },
  "5": function (container, depth0, helpers, partials, data) {
    var helper,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      alias2 = container.hooks.helperMissing,
      alias3 = container.escapeExpression,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<img class=\"client-logo default-logo\" src=\"" + alias3((helper = (helper = lookupProperty(helpers, "defaultLogo") || (depth0 != null ? lookupProperty(depth0, "defaultLogo") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
      "name": "defaultLogo",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 290
        },
        "end": {
          "line": 1,
          "column": 305
        }
      }
    }) : helper)) + "\" alt=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
      "name": "i18n",
      "hash": {
        "bundle": "login",
        "code": "common.logo.alt"
      },
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 312
        },
        "end": {
          "line": 1,
          "column": 358
        }
      }
    })) + "\" aria-hidden=\"true\" />";
  },
  "7": function (container, depth0, helpers, partials, data) {
    return "</a>";
  },
  "9": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<div class=\"issuer\"><span>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "issuer") || (depth0 != null ? lookupProperty(depth0, "issuer") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "issuer",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 566
        },
        "end": {
          "line": 1,
          "column": 576
        }
      }
    }) : helper)) + "</span></div>";
  },
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var stack1,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(1, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 0
        },
        "end": {
          "line": 1,
          "column": 89
        }
      }
    })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "customLogo") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(3, data, 0),
      "inverse": container.program(5, data, 0),
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 89
        },
        "end": {
          "line": 1,
          "column": 388
        }
      }
    })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(7, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 388
        },
        "end": {
          "line": 1,
          "column": 416
        }
      }
    })) != null ? stack1 : "") + "<h1><span class=\"title-text\">" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
      "name": "i18n",
      "hash": {
        "arguments": "appName",
        "bundle": "login",
        "code": "consent.required.text"
      },
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 445
        },
        "end": {
          "line": 1,
          "column": 519
        }
      }
    })) != null ? stack1 : "") + "</span>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "issuer") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(9, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 526
        },
        "end": {
          "line": 1,
          "column": 596
        }
      }
    })) != null ? stack1 : "") + "</h1>";
  },
  "useData": true
});
var _default = consentLogoHeaderTemplate;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/client/constants.js":
/*!************************************!*\
  !*** ./src/v2/client/constants.js ***!
  \************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CONFIGURED_FLOW = void 0;
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const CONFIGURED_FLOW = {
  DEFAULT: 'default',
  PROCEED: 'proceed',
  LOGIN: 'login',
  REGISTRATION: 'signup',
  RESET_PASSWORD: 'resetPassword',
  UNLOCK_ACCOUNT: 'unlockAccount'
};
exports.CONFIGURED_FLOW = CONFIGURED_FLOW;

/***/ }),

/***/ "./src/v2/client/handleConfiguredFlow.js":
/*!***********************************************!*\
  !*** ./src/v2/client/handleConfiguredFlow.js ***!
  \***********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.handleConfiguredFlow = handleConfiguredFlow;
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _Logger = _interopRequireDefault(__webpack_require__(/*! util/Logger */ "./src/util/Logger.js"));
var _RemediationConstants = __webpack_require__(/*! ../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _constants = __webpack_require__(/*! ./constants */ "./src/v2/client/constants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

// This file attempts to mimic the behavior of a popular hack of the V1 Router, which allowed for the widget to be
// initialized into a specific form/flow (like Register or Reset Password). To achieve this, an attempt is made to
// call `idxState.proceed()` with a known remediation depending on the `flow` configuration to "step" the widget
// (and the server's state) to the desired flow/form. The remediation is not guaranteed to be available 
// and will default to the original idx response otherwise. This depends on the Org configurations

// checks if "desired" remeidation is available before calling `.proceed`
// if not available, returns original idxResponse (and logs warning)
async function proceedIfAvailable(idxState, remediation, flow) {
  const rem = idxState.neededToProceed.find(item => item.name === remediation);
  if (!rem) {
    _Logger.default.warn('Expected remediation not found, Org may be misconfigured for this flow');
    return idxState;
  }
  try {
    const nextIdxState = await idxState.proceed(remediation);
    return nextIdxState;
  } catch (err) {
    // catches and handles `Unknown remediation` errors thrown okta-idx-js
    if (typeof err === 'string' && err.startsWith('Unknown remediation choice')) {
      _Logger.default.warn(`flow [${flow}] not valid with current Org configurations`);
      return idxState;
    } else {
      // do not catch non-`Unknown remediation` errors here
      throw err;
    }
  }
}

// attempts to "step into" a specific flow by calling `.proceed` with a specific remeidation (or calls an action)
// the "desired" remeidation is not guaranteed to be available, depends upon Org configurations
async function stepIntoSpecificIdxFlow(idxState, flow = 'default') {
  switch (flow) {
    case _constants.CONFIGURED_FLOW.DEFAULT:
    case _constants.CONFIGURED_FLOW.PROCEED:
    case _constants.CONFIGURED_FLOW.LOGIN:
      // default IDX response from interact is "Login" page/flow. Do nothing
      return idxState;

    // step logic is handled by auth-js
    case _constants.CONFIGURED_FLOW.REGISTRATION:
    case _constants.CONFIGURED_FLOW.RESET_PASSWORD:
      return idxState;
    case _constants.CONFIGURED_FLOW.UNLOCK_ACCOUNT:
      // requires: introspect -> identify-recovery -> select-authenticator-unlock-account
      return await proceedIfAvailable(idxState, _RemediationConstants.FORMS.UNLOCK_ACCOUNT, flow);
    default:
      _Logger.default.warn(`Unknown \`flow\` value: ${flow}`);
      throw new _Errors.ConfigError('Invalid "flow" configuration');
  }
}

// ensures the `flow` stored in the transaction meta matches the flow configuration
// if they do not match, abandon the current (meta) flow and start a new (configured) flow
async function handleConfiguredFlow(originalResp, settings) {
  const authClient = settings.getAuthClient();
  const configuredFlow = authClient.idx.getFlow();

  // attempts to step into the desired flow
  const idxState = await stepIntoSpecificIdxFlow(originalResp, configuredFlow);
  return idxState;
}

/***/ }),

/***/ "./src/v2/client/index.js":
/*!********************************!*\
  !*** ./src/v2/client/index.js ***!
  \********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _interactionCodeFlow = __webpack_require__(/*! ./interactionCodeFlow */ "./src/v2/client/interactionCodeFlow.js");
Object.keys(_interactionCodeFlow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _interactionCodeFlow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _interactionCodeFlow[key];
    }
  });
});
var _startLoginFlow = __webpack_require__(/*! ./startLoginFlow */ "./src/v2/client/startLoginFlow.ts");
Object.keys(_startLoginFlow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _startLoginFlow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _startLoginFlow[key];
    }
  });
});
var _handleConfiguredFlow = __webpack_require__(/*! ./handleConfiguredFlow */ "./src/v2/client/handleConfiguredFlow.js");
Object.keys(_handleConfiguredFlow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _handleConfiguredFlow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _handleConfiguredFlow[key];
    }
  });
});
var _constants = __webpack_require__(/*! ./constants */ "./src/v2/client/constants.js");
Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _constants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constants[key];
    }
  });
});
var _updateAppState = __webpack_require__(/*! ./updateAppState */ "./src/v2/client/updateAppState.ts");
Object.keys(_updateAppState).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updateAppState[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _updateAppState[key];
    }
  });
});

/***/ }),

/***/ "./src/v2/client/interactionCodeFlow.js":
/*!**********************************************!*\
  !*** ./src/v2/client/interactionCodeFlow.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.interactionCodeFlow = interactionCodeFlow;
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _oktaAuthJs = __webpack_require__(/*! @okta/okta-auth-js */ "./node_modules/@okta/okta-auth-js/umd/default.js");
var _OAuthErrors = __webpack_require__(/*! util/OAuthErrors */ "./src/util/OAuthErrors.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

// eslint-disable-next-line max-statements
async function interactionCodeFlow(settings, idxResponse) {
  const {
    interactionCode
  } = idxResponse;
  const authClient = settings.getAuthClient();
  const transactionMeta = await authClient.idx.getSavedTransactionMeta();
  const state = authClient.options.state || (transactionMeta === null || transactionMeta === void 0 ? void 0 : transactionMeta.state);

  // In remediation mode the transaction is owned by another client.
  const isRemediationMode = settings.get('mode') === 'remediation';
  if (isRemediationMode) {
    authClient.idx.clearTransactionMeta();
  }

  // server-side applications will want to received interaction_code as a query parameter
  // this option can also be used to force a redirect for client-side/SPA applications
  const shouldRedirect = settings.get('redirect') === 'always';
  if (shouldRedirect) {
    const redirectUri = settings.get('redirectUri');
    if (!redirectUri) {
      throw new _Errors.ConfigError('"redirectUri" is required');
    }
    const qs = (0, _oktaAuthJs.toQueryString)({
      'interaction_code': interactionCode,
      state
    });
    window.location.assign(redirectUri + qs);
    return;
  }

  // Return a promise (or call success callback) to client-side apps in remediation mode.
  if (isRemediationMode) {
    settings.callGlobalSuccess(_Enums.default.SUCCESS, {
      'interaction_code': interactionCode,
      state
    });
    return;
  }

  // Operating in "relying-party" mode. The widget owns this transaction.
  // Complete the transaction client-side and call success/resolve promise
  if (!transactionMeta) {
    throw new _Errors.ConfigError('Could not load transaction data from storage');
  }
  const {
    codeVerifier
  } = transactionMeta;
  return authClient.token.exchangeCodeForTokens({
    codeVerifier,
    interactionCode
  }).then(({
    tokens
  }) => {
    settings.callGlobalSuccess(_Enums.default.SUCCESS, {
      tokens
    });
  }).catch(err => {
    const typedError = (0, _OAuthErrors.getTypedOAuthError)(err);
    if (typedError instanceof _OAuthErrors.RecoverableError && typedError.is('terminal')) {
      throw typedError;
    }
    settings.callGlobalError(err);
  }).finally(() => {
    // clear all meta related to this transaction
    authClient.idx.clearTransactionMeta();
  });
}

/***/ }),

/***/ "./src/v2/client/sessionStorageHelper.js":
/*!***********************************************!*\
  !*** ./src/v2/client/sessionStorageHelper.js ***!
  \***********************************************/
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const STATE_HANDLE_SESSION_STORAGE_KEY = 'osw-oie-state-handle';
const LAST_INITIATED_LOGIN_URL_SESSION_STORAGE_KEY = 'osw-oie-last-initiated-login-url';
const RESEND_TIMESTAMP_SESSION_STORAGE_KEY = 'osw-oie-resend-timestamp';
const removeStateHandle = () => {
  sessionStorage.removeItem(STATE_HANDLE_SESSION_STORAGE_KEY);
  sessionStorage.removeItem(LAST_INITIATED_LOGIN_URL_SESSION_STORAGE_KEY);
};
const setStateHandle = token => {
  sessionStorage.setItem(STATE_HANDLE_SESSION_STORAGE_KEY, token);
  sessionStorage.setItem(LAST_INITIATED_LOGIN_URL_SESSION_STORAGE_KEY, window.location.href);
};
const getStateHandle = () => {
  return sessionStorage.getItem(STATE_HANDLE_SESSION_STORAGE_KEY);
};
const getLastInitiatedLoginUrl = () => {
  return sessionStorage.getItem(LAST_INITIATED_LOGIN_URL_SESSION_STORAGE_KEY);
};
const removeResendTimestamp = () => {
  sessionStorage.removeItem(RESEND_TIMESTAMP_SESSION_STORAGE_KEY);
};
const setResendTimestamp = token => {
  sessionStorage.setItem(RESEND_TIMESTAMP_SESSION_STORAGE_KEY, token);
};
const getResendTimestamp = () => {
  return sessionStorage.getItem(RESEND_TIMESTAMP_SESSION_STORAGE_KEY);
};
var _default = {
  removeStateHandle,
  setStateHandle,
  getStateHandle,
  getLastInitiatedLoginUrl,
  removeResendTimestamp,
  setResendTimestamp,
  getResendTimestamp
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/ion/IonResponseHelper.js":
/*!*****************************************!*\
  !*** ./src/v2/ion/IonResponseHelper.js ***!
  \*****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _underscore = _interopRequireDefault(__webpack_require__(/*! underscore */ "./node_modules/underscore/underscore-umd.js"));
var _i18nUtils = __webpack_require__(/*! ./i18nUtils */ "./src/v2/ion/i18nUtils.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const convertErrorMessageToErrorSummary = (formName, remediationValues = []) => {
  return _underscore.default.chain(remediationValues).filter(field => {
    var _field$messages;
    return Array.isArray((_field$messages = field.messages) === null || _field$messages === void 0 ? void 0 : _field$messages.value) && field.messages.value.length;
  }).map(field => {
    return {
      property: formName ? `${formName}.${field.name}` : field.name,
      errorSummary: field.messages.value.map(_i18nUtils.getMessage),
      errorKey: field.messages.value.map(_i18nUtils.getMessageKey)
    };
  }).value();
};

/**
 * Although time complexity is O(n^2),
 * the `array` is actually very small (size < 5),
 * hence performance doesn't matter.
 */
const uniqWith = (array, comparator) => {
  if (!Array.isArray(array)) {
    return [];
  }
  if (!_underscore.default.isFunction(comparator) || array.length === 1) {
    return array;
  }
  const result = [];
  for (let i = 0; i < array.length; i++) {
    let seen = false;
    for (let j = i + 1; j < array.length; j++) {
      /* eslint max-depth: [2, 3] */
      if (comparator(array[i], array[j])) {
        seen = true;
        break;
      }
    }
    if (!seen) {
      result.push(array[i]);
    }
  }
  return result;
};

/**
 * returns errors
 * @example
 * errors = [
 *   {property : fieldName1, errorSummary: [errorMessage1]},
 *   {property : fieldName2, errorSummary: [errorMessage2]}
 *   {property : fieldName3, errorSummary: [errorMessage31, errorMessage32]}
 * ]
 */
const getRemediationErrors = res => {
  let errors = [];
  if (!res.remediation || !Array.isArray(res.remediation.value) || res.remediation.value.length === 0) {
    return errors;
  }
  let remediationFormFields = res.remediation.value[0].value;
  if (!Array.isArray(remediationFormFields)) {
    return errors;
  }

  // error at field
  errors.push(convertErrorMessageToErrorSummary(null, remediationFormFields));
  _underscore.default.each(remediationFormFields, remediationForm => {
    var _remediationForm$form;
    const formName = remediationForm.name;

    // error at form.value
    if (Array.isArray((_remediationForm$form = remediationForm.form) === null || _remediationForm$form === void 0 ? void 0 : _remediationForm$form.value)) {
      errors.push(convertErrorMessageToErrorSummary(formName, remediationForm.form.value));
    }

    // error at option.value.form.value
    if (Array.isArray(remediationForm.options)) {
      _underscore.default.each(remediationForm.options, option => {
        var _option$value, _option$value$form;
        if (Array.isArray((_option$value = option.value) === null || _option$value === void 0 ? void 0 : (_option$value$form = _option$value.form) === null || _option$value$form === void 0 ? void 0 : _option$value$form.value)) {
          errors.push(convertErrorMessageToErrorSummary(formName, option.value.form.value));
        }
      });
    }
  });

  // API may return identical error on same field
  // thus run through `uniqWith`.
  // Check unit test for details.
  return uniqWith(_underscore.default.flatten(errors), _underscore.default.isEqual);
};

/**
 * return global error summary combined into one string
 * allErrors = 'error string1. error string2'
 */
const getGlobalErrors = res => {
  var _res$messages;
  let allErrors = [];
  if (Array.isArray((_res$messages = res.messages) === null || _res$messages === void 0 ? void 0 : _res$messages.value)) {
    allErrors = res.messages.value.map(_i18nUtils.getMessage);
  }
  return allErrors.join('. ');
};

/**
 * return array of error keys
 */
const getGlobalErrorKeys = res => {
  var _res$messages2;
  let allKeys = [];
  if (Array.isArray((_res$messages2 = res.messages) === null || _res$messages2 === void 0 ? void 0 : _res$messages2.value)) {
    allKeys = res.messages.value.map(_i18nUtils.getMessageKey);
  }
  return allKeys;
};
const convertFormErrors = response => {
  let errors = {
    errorCauses: getRemediationErrors(response),
    errorSummary: getGlobalErrors(response),
    errorSummaryKeys: getGlobalErrorKeys(response),
    errorIntent: response.intent
  };
  return {
    responseJSON: errors
  };
};
const isIonErrorResponse = (response = {}) => {
  // check if error format is an ION response by looking for version attribute.
  // a little sloppy.
  return response.version;
};
const isIdxSessionExpiredError = response => {
  var _response$context, _response$context$mes, _response$context$mes2, _response$context$mes3;
  const errorI18NKey = response === null || response === void 0 ? void 0 : (_response$context = response.context) === null || _response$context === void 0 ? void 0 : (_response$context$mes = _response$context.messages) === null || _response$context$mes === void 0 ? void 0 : (_response$context$mes2 = _response$context$mes.value[0]) === null || _response$context$mes2 === void 0 ? void 0 : (_response$context$mes3 = _response$context$mes2.i18n) === null || _response$context$mes3 === void 0 ? void 0 : _response$context$mes3.key;
  return errorI18NKey && errorI18NKey === 'idx.session.expired';
};
var _default = {
  convertFormErrors,
  isIonErrorResponse,
  isIdxSessionExpiredError
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/ion/RemediationConstants.js":
/*!********************************************!*\
  !*** ./src/v2/ion/RemediationConstants.js ***!
  \********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TERMINAL_FORMS = exports.ORG_PASSWORD_RECOVERY_LINK = exports.INTERSTITIAL_REDIRECT_VIEW = exports.IDP_FORM_TYPE = exports.HINTS = exports.FORM_NAME_TO_OPERATION_MAP = exports.FORMS_WITH_STATIC_BACK_LINK = exports.FORMS_WITHOUT_SIGNOUT = exports.FORMS_FOR_VERIFICATION = exports.FORMS = exports.AUTHENTICATOR_METHODS = exports.AUTHENTICATOR_KEY = exports.ATTR_FORMAT = exports.ACTIONS = void 0;
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Structure of FORMS object:
 * { [CONSTANT]: remediationForm.name }
 */
const FORMS = {
  IDENTIFY: 'identify',
  SELECT_IDENTIFY: 'select-identify',
  IDENTIFY_RECOVERY: 'identify-recovery',
  SELECT_ENROLL_PROFILE: 'select-enroll-profile',
  ENROLL_PROFILE: 'enroll-profile',
  ENROLL_PROFILE_UPDATE: 'profile-update',
  UNLOCK_ACCOUNT: 'unlock-account',
  REQUEST_ACTIVATION: 'request-activation-email',
  CONSENT_ADMIN: 'admin-consent',
  CONSENT_ENDUSER: 'consent',
  CONSENT_GRANULAR: 'granular-consent',
  CONSENT_EMAIL_CHALLENGE: 'email-challenge-consent',
  SELECT_AUTHENTICATOR_AUTHENTICATE: 'select-authenticator-authenticate',
  SELECT_AUTHENTICATOR_UNLOCK: 'select-authenticator-unlock-account',
  AUTHENTICATOR_VERIFICATION_DATA: 'authenticator-verification-data',
  CHALLENGE_AUTHENTICATOR: 'challenge-authenticator',
  CHALLENGE_POLL: 'challenge-poll',
  RESEND: 'resend',
  SELECT_AUTHENTICATOR_ENROLL: 'select-authenticator-enroll',
  SELECT_AUTHENTICATOR_ENROLL_DATA: 'select-authenticator-enroll-data',
  AUTHENTICATOR_ENROLLMENT_DATA: 'authenticator-enrollment-data',
  ENROLL_AUTHENTICATOR: 'enroll-authenticator',
  SELECT_ENROLLMENT_CHANNEL: 'select-enrollment-channel',
  ENROLLMENT_CHANNEL_DATA: 'enrollment-channel-data',
  ENROLL_POLL: 'enroll-poll',
  REENROLL_AUTHENTICATOR: 'reenroll-authenticator',
  REENROLL_AUTHENTICATOR_WARNING: 'reenroll-authenticator-warning',
  REENROLL_CUSTOM_PASSWORD_EXPIRY: 'reenroll-custom-password-expiry',
  REENROLL_CUSTOM_PASSWORD_EXPIRY_WARNING: 'reenroll-custom-password-expiry-warning',
  RESET_AUTHENTICATOR: 'reset-authenticator',
  SKIP: 'skip',
  POLL: 'poll',
  FAILURE_REDIRECT: 'failure-redirect',
  SUCCESS_REDIRECT: 'success-redirect',
  REDIRECT_IDP: 'redirect-idp',
  PIV_IDP: 'piv-idp',
  DEVICE_CHALLENGE_POLL: 'device-challenge-poll',
  DEVICE_APPLE_SSO_EXTENSION: 'device-apple-sso-extension',
  CANCEL_TRANSACTION: 'cancel-transaction',
  LAUNCH_AUTHENTICATOR: 'launch-authenticator',
  LAUNCH_WEBAUTHN_AUTHENTICATOR: 'launch-webauthn-authenticator',
  ENROLL_WEBAUTHN_RESIDENTKEY: 'enroll-webauthn-residentkey',
  DEVICE_ENROLLMENT_TERMINAL: 'device-enrollment-terminal',
  USER_CODE: 'user-code',
  KEEP_ME_SIGNED_IN: 'keep-me-signed-in',
  // 'terminal` is not ION Form name but only coined in widget
  // for rendering a page that user has nothing to remediate.
  TERMINAL: 'terminal'
};
// Forms added here do not show the Sign out link
exports.FORMS = FORMS;
const FORMS_WITHOUT_SIGNOUT = [FORMS.IDENTIFY, FORMS.SUCCESS_REDIRECT, FORMS.ENROLL_PROFILE, FORMS.DEVICE_ENROLLMENT_TERMINAL, FORMS.CONSENT_ADMIN, FORMS.CONSENT_ENDUSER, FORMS.CONSENT_GRANULAR, FORMS.CONSENT_EMAIL_CHALLENGE, FORMS.USER_CODE, FORMS.KEEP_ME_SIGNED_IN];
exports.FORMS_WITHOUT_SIGNOUT = FORMS_WITHOUT_SIGNOUT;
const FORMS_WITH_STATIC_BACK_LINK = [FORMS.SELECT_AUTHENTICATOR_ENROLL, FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE];
exports.FORMS_WITH_STATIC_BACK_LINK = FORMS_WITH_STATIC_BACK_LINK;
const FORMS_FOR_VERIFICATION = [FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE, FORMS.CHALLENGE_AUTHENTICATOR, FORMS.CHALLENGE_POLL, FORMS.RESEND];
exports.FORMS_FOR_VERIFICATION = FORMS_FOR_VERIFICATION;
const AUTHENTICATOR_KEY = {
  EMAIL: 'okta_email',
  PASSWORD: 'okta_password',
  PHONE: 'phone_number',
  WEBAUTHN: 'webauthn',
  SECURITY_QUESTION: 'security_question',
  OV: 'okta_verify',
  GOOGLE_OTP: 'google_otp',
  ON_PREM: 'onprem_mfa',
  RSA: 'rsa_token',
  DUO: 'duo',
  IDP: 'external_idp',
  CUSTOM_OTP: 'custom_otp',
  SYMANTEC_VIP: 'symantec_vip',
  YUBIKEY: 'yubikey_token',
  CUSTOM_APP: 'custom_app',
  SMARTCARD: 'smart_card_idp'
};
exports.AUTHENTICATOR_KEY = AUTHENTICATOR_KEY;
const AUTHENTICATOR_METHODS = {
  PUSH: 'push'
};
exports.AUTHENTICATOR_METHODS = AUTHENTICATOR_METHODS;
const FORM_NAME_TO_OPERATION_MAP = {
  [FORMS.SELECT_AUTHENTICATOR_UNLOCK]: _Enums.default.UNLOCK_ACCOUNT,
  [FORMS.IDENTIFY]: _Enums.default.PRIMARY_AUTH,
  [FORMS.IDENTIFY_RECOVERY]: _Enums.default.FORGOT_PASSWORD
};
exports.FORM_NAME_TO_OPERATION_MAP = FORM_NAME_TO_OPERATION_MAP;
const ENROLLED_PASSWORD_RECOVERY_LINK = 'currentAuthenticatorEnrollment-recover';
const ORG_PASSWORD_RECOVERY_LINK = 'currentAuthenticator-recover';
exports.ORG_PASSWORD_RECOVERY_LINK = ORG_PASSWORD_RECOVERY_LINK;
const ACTIONS = {
  ENROLLED_PASSWORD_RECOVERY_LINK,
  ORG_PASSWORD_RECOVERY_LINK
};

// Possible Remediation Form Field Hints
exports.ACTIONS = ACTIONS;
const HINTS = {
  CAPTCHA: 'captcha'
};
exports.HINTS = HINTS;
const TERMINAL_FORMS = [FORMS.TERMINAL, FORMS.DEVICE_ENROLLMENT_TERMINAL];
exports.TERMINAL_FORMS = TERMINAL_FORMS;
const IDP_FORM_TYPE = {
  X509: 'X509'
};

// Possible options for the SIW interstitial redirect view
exports.IDP_FORM_TYPE = IDP_FORM_TYPE;
const INTERSTITIAL_REDIRECT_VIEW = {
  DEFAULT: 'DEFAULT',
  NONE: 'NONE'
};
exports.INTERSTITIAL_REDIRECT_VIEW = INTERSTITIAL_REDIRECT_VIEW;
const ATTR_FORMAT = {
  COUNTRY_CODE: 'country-code'
};
exports.ATTR_FORMAT = ATTR_FORMAT;

/***/ }),

/***/ "./src/v2/ion/ViewClassNamesFactory.js":
/*!*********************************************!*\
  !*** ./src/v2/ion/ViewClassNamesFactory.js ***!
  \*********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getV1ClassName = exports.getClassNameMapping = void 0;
var _RemediationConstants = __webpack_require__(/*! ./RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
/* eslint complexity: [2, 25] */

const FORMNAME_CLASSNAME_MAPPINGS = {
  [_RemediationConstants.FORMS.IDENTIFY]: {
    [_RemediationConstants.FORMS.IDENTIFY]: 'primary-auth',
    [_RemediationConstants.AUTHENTICATOR_KEY.PASSWORD]: 'primary-auth'
  },
  [_RemediationConstants.FORMS.IDENTIFY_RECOVERY]: {
    [_RemediationConstants.FORMS.IDENTIFY_RECOVERY]: 'forgot-password'
  },
  [_RemediationConstants.FORMS.ENROLL_PROFILE]: {
    [_RemediationConstants.FORMS.ENROLL_PROFILE]: 'registration'
  },
  [_RemediationConstants.FORMS.CHALLENGE_AUTHENTICATOR]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.EMAIL]: 'mfa-verify-passcode',
    [_RemediationConstants.AUTHENTICATOR_KEY.PASSWORD]: 'mfa-verify-password',
    sms: 'mfa-verify-passcode',
    voice: 'mfa-verify-passcode',
    [_RemediationConstants.AUTHENTICATOR_KEY.SECURITY_QUESTION]: 'mfa-verify-question',
    [_RemediationConstants.AUTHENTICATOR_KEY.WEBAUTHN]: 'mfa-verify-webauthn',
    [_RemediationConstants.AUTHENTICATOR_KEY.ON_PREM]: 'mfa-verify-totp',
    [_RemediationConstants.AUTHENTICATOR_KEY.RSA]: 'mfa-verify-totp',
    [_RemediationConstants.AUTHENTICATOR_KEY.OV]: 'mfa-verify',
    [_RemediationConstants.AUTHENTICATOR_KEY.GOOGLE_OTP]: 'mfa-verify',
    [_RemediationConstants.AUTHENTICATOR_KEY.DUO]: 'mfa-verify-duo',
    [_RemediationConstants.AUTHENTICATOR_KEY.SYMANTEC_VIP]: 'mfa-verify',
    [_RemediationConstants.AUTHENTICATOR_KEY.YUBIKEY]: 'mfa-verify',
    [_RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_APP]: 'mfa-verify'
  },
  [_RemediationConstants.FORMS.CHALLENGE_POLL]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.OV]: 'mfa-verify',
    [_RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_APP]: 'mfa-verify'
  },
  [_RemediationConstants.FORMS.RESEND_PUSH]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.OV]: 'mfa-verify',
    [_RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_APP]: 'mfa-verify'
  },
  [_RemediationConstants.FORMS.ENROLL_AUTHENTICATOR]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.EMAIL]: 'enroll-email',
    [_RemediationConstants.AUTHENTICATOR_KEY.PASSWORD]: 'enroll-password',
    sms: 'enroll-sms',
    voice: 'enroll-call',
    [_RemediationConstants.AUTHENTICATOR_KEY.SECURITY_QUESTION]: 'enroll-question',
    [_RemediationConstants.AUTHENTICATOR_KEY.WEBAUTHN]: 'enroll-webauthn',
    [_RemediationConstants.AUTHENTICATOR_KEY.ON_PREM]: 'enroll-onprem',
    [_RemediationConstants.AUTHENTICATOR_KEY.RSA]: 'enroll-rsa',
    [_RemediationConstants.AUTHENTICATOR_KEY.DUO]: 'enroll-duo',
    [_RemediationConstants.AUTHENTICATOR_KEY.SYMANTEC_VIP]: 'enroll-symantec',
    [_RemediationConstants.AUTHENTICATOR_KEY.YUBIKEY]: 'enroll-yubikey'
  },
  [_RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL]: {
    'select-authenticator-enroll': 'enroll-choices'
  },
  [_RemediationConstants.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.PASSWORD]: 'forgot-password'
  },
  [_RemediationConstants.FORMS.REENROLL_AUTHENTICATOR]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.PASSWORD]: 'password-expired'
  },
  [_RemediationConstants.FORMS.REENROLL_CUSTOM_PASSWORD_EXPIRY]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.PASSWORD]: 'custom-password-expired'
  },
  [_RemediationConstants.FORMS.REENROLL_CUSTOM_PASSWORD_EXPIRY_WARNING]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.PASSWORD]: 'custom-password-expiry-warning'
  },
  [_RemediationConstants.FORMS.RESET_AUTHENTICATOR]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.PASSWORD]: 'forgot-password'
  },
  [_RemediationConstants.FORMS.CONSENT_ADMIN]: {
    [_RemediationConstants.FORMS.CONSENT_ADMIN]: 'admin-consent-required'
  },
  [_RemediationConstants.FORMS.CONSENT_ENDUSER]: {
    [_RemediationConstants.FORMS.CONSENT_ENDUSER]: 'consent-required'
  }
};
const getV1ClassName = (formName, authenticatorKey, methodType, isPasswordRecoveryFlow) => {
  // if password reset flow from identifier page with recoveryAuthenticator add forgot-password class
  if (isPasswordRecoveryFlow && formName === _RemediationConstants.FORMS.IDENTIFY) {
    return 'forgot-password';
  } else {
    let key = formName;
    if (authenticatorKey === _RemediationConstants.AUTHENTICATOR_KEY.PHONE) {
      // Both sms and call have same type phone
      // currentAuthenticatorEnrollment is during verify and currentAuthenticator during enroll flows
      key = `${methodType}`;
    } else if (authenticatorKey) {
      key = `${authenticatorKey}`;
    }
    if (FORMNAME_CLASSNAME_MAPPINGS[formName] && FORMNAME_CLASSNAME_MAPPINGS[formName][key]) {
      return FORMNAME_CLASSNAME_MAPPINGS[formName][key];
    } else {
      return null;
    }
  }
};
exports.getV1ClassName = getV1ClassName;
const getClassNameMapping = (formName, authenticatorKey, methodType, isPasswordRecoveryFlow) => {
  // 1. Generates V2 class name
  // If we have a type which is authenticatorType/methodType use that to generate a V2 className
  // Otherwise just use formName
  let v2ClassName = formName;
  if (authenticatorKey) {
    v2ClassName = v2ClassName + '--' + authenticatorKey;
  }

  // 2. do a lookup for any V1 classNames and concat
  let v1ClassName = getV1ClassName(formName, authenticatorKey, methodType, isPasswordRecoveryFlow);
  const result = [v2ClassName];
  if (v1ClassName) {
    result.push(v1ClassName);
  }
  return result;
};
exports.getClassNameMapping = getClassNameMapping;

/***/ }),

/***/ "./src/v2/ion/i18nTransformer.js":
/*!***************************************!*\
  !*** ./src/v2/ion/i18nTransformer.js ***!
  \***************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _exportNames = {};
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Logger = _interopRequireDefault(__webpack_require__(/*! util/Logger */ "./src/util/Logger.js"));
var _RemediationConstants = __webpack_require__(/*! ./RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _i18nUtils = __webpack_require__(/*! ./i18nUtils */ "./src/v2/ion/i18nUtils.js");
Object.keys(_i18nUtils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _i18nUtils[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _i18nUtils[key];
    }
  });
});
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint-disable max-len */
/* eslint max-statements: [2, 25], complexity: [2, 15] */

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

///////////////////////////////////////////////////////////////////////////////
//                                  How this transformer work?               //
//
// ## For Labels inside remediation forms
// 1. Figure out Path for all Labels (for normal field, or options) or Placeholder (for checkbox),e.g.
//   - `identify.identifier`, this is the label for user name at identify page
//   - `select-authenticator-enroll.authenticator.email`,
//      this is for label for email authenticator at `select-authenticator-enroll` page
// 2. Define a mapping between the path and i18n key. see `I18N_OVERRIDE_MAPPINGS`
//   - This mapping is subject to change when API starts sending i18n key along with label.
//     It probably becomes a mapping between API's i18n key and key in login.properties
//     in order to be backward compatible.
// 3. Now find i18n value using such route: `i18n Path -> i18n key -> login.properties`
//    If found an i18n value, replace label by this i18n value.
//
// ## For top level messages
// 1. Overwrite `message.message` if `message.i18n.key` exists in `login.properties`
//
// ## How to override mappings in I18N_OVERRIDE_MAPPINGS for localization?
// Step 1. First search the string in login.properties and see if already exists or not
// Step 2. Find idx response path, for eg. select-authenticator-enroll.authenticator.email
// Step 3. Make that path a key and add it to I18N_OVERRIDE_MAPPINGS if doesn't exist already
// Step 4. If you find a key in Step 1 that already exists, use it as value of key created in Step 3, 
//          else create a new label `oie.your.new.label` and add it.
// Step 5. If you create a new label then add that to login.properties file with proper string
//         oie.your.new.label = Your new string
///////////////////////////////////////////////////////////////////////////////

const updateLabelForUiSchema = (remediation, uiSchema) => {
  var _remediation$relatesT, _remediation$relatesT2;
  if (uiSchema.mutable === false && uiSchema.name.indexOf('questionKey') < 0) {
    return;
  }
  _Logger.default.info('i18n label transformer');
  _Logger.default.info('\t remediationName: ', remediation.name);
  _Logger.default.info('\t uiSchema: ', JSON.stringify(uiSchema));
  const authenticatorKey = (_remediation$relatesT = remediation.relatesTo) === null || _remediation$relatesT === void 0 ? void 0 : (_remediation$relatesT2 = _remediation$relatesT.value) === null || _remediation$relatesT2 === void 0 ? void 0 : _remediation$relatesT2.key;
  const authenticatorKeyPath = authenticatorKey ? `.${remediation.relatesTo.value.key}` : '';
  const i18nPrefix = `${remediation.name}${authenticatorKeyPath}.`;
  let i18nPath = `${i18nPrefix}${uiSchema.name}`;
  if (uiSchema.type === 'text' && uiSchema.name.indexOf('questionKey') >= 0 && uiSchema.value !== 'custom') {
    i18nPath = `${i18nPath}.${uiSchema.value}`;
  }
  if (uiSchema.type === 'checkbox' && uiSchema.placeholder) {
    _Logger.default.info('\t 1: ', i18nPath);
    uiSchema.placeholder = (0, _i18nUtils.getI18NValue)(i18nPath, uiSchema.placeholder);
  }
  if (uiSchema.label) {
    _Logger.default.info('\t 2: ', i18nPath);
    const params = (0, _i18nUtils.getI18NParams)(remediation, authenticatorKey);
    uiSchema.label = uiSchema.customLabel ? uiSchema.label : (0, _i18nUtils.getI18NValue)(i18nPath, uiSchema.label, params);
  }
  if (_courage.$.isPlainObject(uiSchema.options)) {
    uiSchema.options = _courage._.mapObject(uiSchema.options, (value, key) => {
      const i18nPathOption = `${i18nPath}.${key}`;
      _Logger.default.info('\t 3: ', i18nPathOption);
      return (0, _i18nUtils.getI18NValue)(i18nPathOption, value);
    });
  }
  if (Array.isArray(uiSchema.options)) {
    uiSchema.options.forEach(o => {
      if (!o.label) {
        return;
      }
      let i18nPathOption;
      if (o.authenticatorKey) {
        var _o$value;
        i18nPathOption = `${i18nPath}.${o.authenticatorKey}`;
        const methodType = (_o$value = o.value) === null || _o$value === void 0 ? void 0 : _o$value.methodType;
        if (o.authenticatorKey === _RemediationConstants.AUTHENTICATOR_KEY.OV && methodType) {
          i18nPathOption = `${i18nPathOption}.${methodType}`;
        }
      } else if (typeof o.value === 'string' || typeof o.value === 'number') {
        // value could be string, number, object or undefined.
        i18nPathOption = `${i18nPath}.${o.value}`;
      } else {
        i18nPathOption = i18nPath;
      }
      _Logger.default.info('\t 4: ', i18nPathOption);
      o.label = (0, _i18nUtils.getI18NValue)(i18nPathOption, o.label);
    });
  }
  if (Array.isArray(uiSchema.optionsUiSchemas)) {
    uiSchema.optionsUiSchemas.forEach(optionsUiSchema => {
      optionsUiSchema.forEach(uiSchema => updateLabelForUiSchema(remediation, uiSchema));
    });
  }
};
var _default = transformedResp => {
  var _transformedResp$mess;
  // Try to override label using i18n value
  if (Array.isArray(transformedResp.remediations)) {
    transformedResp.remediations.filter(remediation => Array.isArray(remediation.uiSchema) && remediation.uiSchema.length).forEach(remediation => {
      remediation.uiSchema.forEach(uiSchema => updateLabelForUiSchema(remediation, uiSchema));
    });
  }

  // Try to override `messages` using i18n value.
  // 1. This is only handling top level `messages` object when response status is 200.
  // 2. See `IonResponseHelper.js` where handle `messages` object when none 200 response.
  // 3. Handling `messages` in remediation forms on 200 response is not considered yet.
  //    Is that possible?
  if (Array.isArray((_transformedResp$mess = transformedResp.messages) === null || _transformedResp$mess === void 0 ? void 0 : _transformedResp$mess.value)) {
    transformedResp.messages.value.forEach(message => {
      message.message = (0, _i18nUtils.getMessage)(message);
    });
  }
  return transformedResp;
};
exports["default"] = _default;

/***/ }),

/***/ "./src/v2/ion/i18nUtils.js":
/*!*********************************!*\
  !*** ./src/v2/ion/i18nUtils.js ***!
  \*********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isCustomizedI18nKey = exports.getMessageKey = exports.getMessageFromBrowserError = exports.getMessage = exports.getI18nKey = exports.getI18NValue = exports.getI18NParams = exports.doesI18NKeyExist = void 0;
var _Bundles = _interopRequireDefault(__webpack_require__(/*! util/Bundles */ "./src/util/Bundles.ts"));
var _Logger = _interopRequireDefault(__webpack_require__(/*! util/Logger */ "./src/util/Logger.js"));
var _loc = __webpack_require__(/*! ../../util/loc */ "./src/util/loc.ts");
var _AuthenticatorUtil = __webpack_require__(/*! ../view-builder/utils/AuthenticatorUtil */ "./src/v2/view-builder/utils/AuthenticatorUtil.js");
var _RemediationConstants = __webpack_require__(/*! ./RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _i18nBaseAttributeMappings = __webpack_require__(/*! ../view-builder/views/enroll-profile/i18nBaseAttributeMappings */ "./src/v2/view-builder/views/enroll-profile/i18nBaseAttributeMappings.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint-disable max-len */
/* eslint max-statements: [2, 25], complexity: [2, 15] */

/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const WEBAUTHN_API_GENERIC_ERROR_KEY = 'authfactor.webauthn.error';
const SECURITY_QUESTION_PREFIXES = ['enroll-authenticator.security_question.credentials.questionKey.', 'challenge-authenticator.security_question.credentials.questionKey.'];
const I18N_OVERRIDE_MAPPINGS = {
  'identify.identifier': 'primaryauth.username.placeholder',
  'select-authenticator-unlock-account.identifier': 'primaryauth.username.placeholder',
  'unlock-account.identifier': 'primaryauth.username.placeholder',
  'identify.credentials.passcode': 'primaryauth.password.placeholder',
  'identify.rememberMe': 'oie.remember',
  'enroll-profile.userProfile.rememberMe': 'oie.remember',
  'identify-recovery.identifier': 'password.forgot.email.or.username.placeholder',
  'select-authenticator-enroll.authenticator.duo': 'factor.duo',
  'select-authenticator-enroll.authenticator.google_otp': 'oie.google_authenticator.label',
  'select-authenticator-enroll.authenticator.okta_email': 'oie.email.label',
  'select-authenticator-enroll.authenticator.okta_password': 'oie.password.label',
  'select-authenticator-enroll.authenticator.okta_verify': 'oie.okta_verify.label',
  'select-authenticator-enroll.authenticator.phone_number': 'oie.phone.label',
  'select-authenticator-enroll.authenticator.rsa_token': 'factor.totpHard.rsaSecurId',
  'select-authenticator-enroll.authenticator.security_question': 'oie.security.question.label',
  'select-authenticator-enroll.authenticator.symantec_vip': 'factor.totpHard.symantecVip',
  'select-authenticator-enroll.authenticator.webauthn': 'oie.webauthn.label',
  'select-authenticator-enroll.authenticator.yubikey_token': 'oie.yubikey.label',
  'select-authenticator-authenticate.authenticator.duo': 'factor.duo',
  'select-authenticator-authenticate.authenticator.google_otp': 'oie.google_authenticator.label',
  'select-authenticator-authenticate.authenticator.okta_email': 'oie.email.label',
  'select-authenticator-authenticate.authenticator.okta_password': 'oie.password.label',
  'select-authenticator-authenticate.authenticator.okta_verify.push': 'oie.okta_verify.push.title',
  'select-authenticator-authenticate.authenticator.okta_verify.signed_nonce': 'oie.okta_verify.signed_nonce.label',
  'select-authenticator-authenticate.authenticator.okta_verify.totp': 'oie.okta_verify.totp.title',
  'select-authenticator-authenticate.authenticator.phone_number': 'oie.phone.label',
  'select-authenticator-authenticate.authenticator.rsa_token': 'factor.totpHard.rsaSecurId',
  'select-authenticator-authenticate.authenticator.security_question': 'oie.security.question.label',
  'select-authenticator-authenticate.authenticator.symantec_vip': 'factor.totpHard.symantecVip',
  'select-authenticator-authenticate.authenticator.webauthn': 'oie.webauthn.label',
  'select-authenticator-authenticate.authenticator.yubikey_token': 'oie.yubikey.label',
  'select-authenticator-authenticate.authenticator.custom_app': 'oie.custom.app.authenticator.title',
  'select-authenticator-unlock-account.authenticator.okta_email': 'oie.email.label',
  'select-authenticator-unlock-account.authenticator.phone_number': 'oie.phone.label',
  'select-authenticator-unlock-account.authenticator.okta_verify.push': 'oie.okta_verify.push.title',
  'authenticator-verification-data.okta_verify.authenticator.methodType.signed_nonce': 'oie.okta_verify.signed_nonce.label',
  'authenticator-verification-data.okta_verify.authenticator.methodType.push': 'oie.okta_verify.push.title',
  'authenticator-verification-data.okta_verify.authenticator.methodType.totp': 'oie.okta_verify.totp.title',
  'authenticator-enrollment-data.phone_number.authenticator.phoneNumber': 'mfa.phoneNumber.placeholder',
  'authenticator-enrollment-data.phone_number.authenticator.methodType.sms': 'oie.phone.enroll.sms.label',
  'authenticator-enrollment-data.phone_number.authenticator.methodType.voice': 'oie.phone.enroll.voice.label',
  'enroll-authenticator.okta_password.credentials.passcode': 'oie.password.passwordLabel',
  'enroll-authenticator.okta_email.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
  'enroll-authenticator.phone_number.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
  'enroll-authenticator.security_question.sub_schema_local_credentials.0': 'oie.security.question.questionKey.label',
  'enroll-authenticator.security_question.sub_schema_local_credentials.1': 'oie.security.question.createQuestion.label',
  'enroll-authenticator.security_question.credentials.answer': 'mfa.challenge.answer.placeholder',
  'enroll-authenticator.security_question.credentials.question': 'oie.security.question.createQuestion.label',
  'enroll-authenticator.security_question.credentials.questionKey': 'oie.security.question.questionKey.label',
  'enroll-authenticator.google_otp.credentials.passcode': 'oie.google_authenticator.otp.enterCodeText',
  'enroll-authenticator.onprem_mfa.credentials.clientData': 'enroll.onprem.username.placeholder',
  'enroll-authenticator.onprem_mfa.credentials.passcode': 'enroll.onprem.passcode.placeholder',
  'enroll-authenticator.rsa_token.credentials.clientData': 'enroll.onprem.username.placeholder',
  'enroll-authenticator.rsa_token.credentials.passcode': 'enroll.onprem.passcode.placeholder',
  'enroll-authenticator.symantec_vip.credentials.credentialId': 'enroll.symantecVip.credentialId.placeholder',
  'enroll-authenticator.symantec_vip.credentials.passcode': 'enroll.symantecVip.passcode1.placeholder',
  'enroll-authenticator.symantec_vip.credentials.nextPasscode': 'enroll.symantecVip.passcode2.placeholder',
  'enroll-authenticator.yubikey_token.credentials.passcode': 'oie.yubikey.passcode.label',
  'enrollment-channel-data.email': 'oie.enroll.okta_verify.channel.email.label',
  'enrollment-channel-data.phoneNumber': 'mfa.phoneNumber.placeholder',
  'select-enrollment-channel.authenticator.channel.qrcode': 'oie.enroll.okta_verify.select.channel.qrcode.label',
  'select-enrollment-channel.authenticator.channel.email': 'oie.enroll.okta_verify.select.channel.email.label',
  'select-enrollment-channel.authenticator.channel.sms': 'oie.enroll.okta_verify.select.channel.sms.label',
  'challenge-authenticator.okta_email.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
  'challenge-authenticator.okta_password.credentials.passcode': 'mfa.challenge.password.placeholder',
  'challenge-authenticator.phone_number.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
  'challenge-authenticator.security_question.credentials.answer': 'mfa.challenge.answer.placeholder',
  'challenge-authenticator.okta_verify.credentials.totp': 'oie.okta_verify.totp.enterCodeText',
  'challenge-authenticator.google_otp.credentials.passcode': 'oie.google_authenticator.otp.enterCodeText',
  'challenge-authenticator.onprem_mfa.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
  'challenge-authenticator.rsa_token.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
  'challenge-authenticator.custom_otp.credentials.passcode': 'oie.custom_otp.verify.passcode.label',
  'challenge-authenticator.symantec_vip.credentials.passcode': 'oie.symantecVip.verify.passcode.label',
  'challenge-authenticator.yubikey_token.credentials.passcode': 'oie.yubikey.passcode.label',
  'challenge-authenticator.credentials.passcode': 'oie.password.label',
  'reset-authenticator.okta_password.credentials.passcode': 'oie.password.newPasswordLabel',
  'reset-authenticator.okta_password.confirmPassword': 'oie.password.confirmPasswordLabel',
  'reset-authenticator.okta_password.credentials.revokeSessions': 'password.reset.revokeSessions',
  'reenroll-authenticator.okta_password.credentials.passcode': 'oie.password.newPasswordLabel',
  'reenroll-authenticator.okta_password.confirmPassword': 'oie.password.confirmPasswordLabel',
  'reenroll-authenticator.okta_password.credentials.revokeSessions': 'password.reset.revokeSessions',
  'reenroll-authenticator-warning.okta_password.credentials.passcode': 'oie.password.newPasswordLabel',
  'reenroll-authenticator-warning.okta_password.confirmPassword': 'oie.password.confirmPasswordLabel',
  'reenroll-authenticator-warning.okta_password.credentials.revokeSessions': 'password.reset.revokeSessions',
  'enroll-authenticator.okta_password.confirmPassword': 'oie.password.confirmPasswordLabel',
  'enroll-authenticator.okta_password.credentials.revokeSessions': 'password.reset.revokeSessions',
  'incorrectPassword': 'oie.password.incorrect.message',
  'profile-update.userProfile.secondEmail': 'oie.user.profile.secondary.email',
  'user-code.userCode': 'device.code.activate.label',
  // Remap authn API errors to OIE
  'api.authn.poll.error.push_rejected': 'oktaverify.rejected',
  // Remap duo API errors to OIE
  'oie.authenticator.duo.method.duo.verification_timeout': 'oie.authenticator.duo.error',
  'oie.authenticator.duo.method.duo.verification_failed': 'oie.authenticator.duo.error',
  'idx.email.verification.required': 'registration.complete.confirm.text',
  'tooManyRequests': 'oie.tooManyRequests',
  'api.users.auth.error.POST_PASSWORD_UPDATE_AUTH_FAILURE': 'oie.post.password.update.auth.failure.error',
  'security.access_denied': 'errors.E0000006',
  'E0000009': 'errors.E0000009',
  'E0000020': 'errors.E0000020',
  'api.factors.error.sms.invalid_phone': 'oie.phone.invalid',
  'app.ldap.password.reset.failed': 'errors.E0000017',
  'oie.selfservice.unlock_user.challenge.failed.permissions': 'errors.E0000006',
  'core.auth.factor.signedNonce.error.invalidEnrollment': 'core.auth.factor.signedNonce.error',
  'core.auth.factor.signedNonce.error.invalidFactor': 'core.auth.factor.signedNonce.error',
  'core.auth.factor.signedNonce.error.deletedDevice': 'core.auth.factor.signedNonce.error',
  'core.auth.factor.signedNonce.error.invalidDeviceStatus': 'core.auth.factor.signedNonce.error.invalidDevice',
  // re-map autoPush: "Send push automatically"
  'challenge-poll.custom_app.autoChallenge': 'autoPush',
  // authenticator-verification-custom-app-push-autochallenge
  'challenge-poll.okta_verify.autoChallenge': 'autoPush',
  // authenticator-verification-okta-verify-push-autoChallenge-on
  'authenticator-verification-data.authenticator.autoChallenge': 'autoPush',
  // authenticator-verification-data-okta-verify-push-autoChallenge-off.json
  'authenticator-verification-data.okta_verify.authenticator.autoChallenge': 'autoPush',
  'authenticator-verification-data.custom_app.authenticator.autoChallenge': 'autoPush',
  // Existing overrides
  ..._i18nBaseAttributeMappings.I18N_BASE_ATTRIBUTE_ENROLL_PROFILE_MAPPINGS //enroll-profile strings
};

const I18N_PARAMS_MAPPING = {
  [_RemediationConstants.FORMS.ENROLL_AUTHENTICATOR]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.ON_PREM]: {
      getParam: _AuthenticatorUtil.getAuthenticatorDisplayName
    },
    [_RemediationConstants.AUTHENTICATOR_KEY.RSA]: {
      getParam: _AuthenticatorUtil.getAuthenticatorDisplayName
    }
  }
};

/**
 * For i18n keys that require string interpolation using values from "params".
 * {baseKey} : {params}
 */
const I18N_OVERRIDE_WITH_PARAMS_MAP = {
  'registration.error.invalidLoginEmail': {
    Email: 'Email'
  },
  'registration.error.doesNotMatchPattern': {
    Email: 'Email'
  },
  'registration.error.notUniqueWithinOrg': {
    Email: 'Email'
  }
};

/**
 * For messages that need to be interpolated with param values.
 *
 * Enumerate each possible param interpolation and hardcode that into properties file.
 * This is to ensure proper translation.
 *
 * Example - a known param:
 *
 * input =
 *  "i18n": {
      "key": "registration.error.doesNotMatchPattern",
      "params": [
        "Email"
      ]
    }
 * output = registration.error.doesNotMatchPattern.Email
 *
 * Example - an unknown param:
 *
 * input =
 *  "i18n": {
      "key": "registration.error.doesNotMatchPattern",
      "params": [
        "Custom Property"
      ]
    }
 * output = registration.error.doesNotMatchPattern.custom
 *
 * @param {String} key
 * @param {String} param
 * @returns {String}
 */
const getI8nKeyUsingParams = (key, param) => {
  let i18nKey = key;
  if (I18N_OVERRIDE_WITH_PARAMS_MAP[i18nKey][param]) {
    i18nKey += `.${param}`;
  } else {
    i18nKey += '.custom';
  }
  return i18nKey;
};
const getI18NParams = (remediation, authenticatorKey) => {
  const params = [];
  const formName = remediation.name;
  if (I18N_PARAMS_MAPPING[formName] && I18N_PARAMS_MAPPING[formName][authenticatorKey]) {
    const config = I18N_PARAMS_MAPPING[formName][authenticatorKey];
    const param = config.getParam(remediation);
    params.push(param);
  }
  return params;
};
exports.getI18NParams = getI18NParams;
const getI18nKey = i18nPath => {
  let i18nKey;
  // Extract security question value from i18nPath
  SECURITY_QUESTION_PREFIXES.forEach(prefix => {
    if (i18nPath.indexOf(prefix) === 0) {
      const securityQuestionValue = i18nPath.replace(prefix, '');
      i18nKey = `security.${securityQuestionValue}`;
    }
  });
  if (I18N_OVERRIDE_MAPPINGS[i18nPath]) {
    i18nKey = I18N_OVERRIDE_MAPPINGS[i18nPath];
  }
  if (i18nKey && !_Bundles.default.login[i18nKey]) {
    _Logger.default.warn(`expect i18n key ${i18nKey} for ${i18nPath} but not found in 'login' bundle.`);
    i18nKey = null;
  }
  return i18nKey;
};
exports.getI18nKey = getI18nKey;
const doesI18NKeyExist = i18nKey => {
  return !!_Bundles.default.login[i18nKey];
};

/**
 * Find i18n value using {@code i18nPath} if it exists.
 * Otherwise return {@code defaultValue}.
 *
 * @param {string} i18nPath
 * @param {string} defaultValue
 * @param {string[]} params
 */
exports.doesI18NKeyExist = doesI18NKeyExist;
const getI18NValue = (i18nPath, defaultValue, params = []) => {
  const i18nKey = getI18nKey(i18nPath);
  if (i18nKey) {
    return (0, _loc.loc)(i18nKey, 'login', params);
  } else {
    _Logger.default.warn(`Avoid rendering unlocalized text sent from the API: ${defaultValue}`);
    return defaultValue;
  }
};
exports.getI18NValue = getI18NValue;
const isWebAuthnAPIError = i18nKey => i18nKey.startsWith(WEBAUTHN_API_GENERIC_ERROR_KEY);

/**
 * @typedef {Object} Message
 * @property {string} message
 * @property {Object=} i18n
 * @property {string} i18n.key
 * @property {string[]} i18n.params
 */
/**
 * - If `message.i18n.key` exists and has a value in 'login.properties'
 *   through the given key or via I18N_OVERRIDE_MAPPINGS, return the value.
 *
 * - returns `message.message` otherwise
 *
 * @param {Message} message
 */
const getMessage = message => {
  var _message$i18n;
  if ((_message$i18n = message.i18n) !== null && _message$i18n !== void 0 && _message$i18n.key) {
    var _message$i18n2;
    let i18nKey = message.i18n.key;
    let i18nParams = message.i18n.params || [];

    // TODO - remove this block once API fix is done - OKTA-398080
    // Sometimes API sends params: [""] an array with empty string.
    // example - error-authenticator-enroll-password-common mock
    if (i18nParams.length === 1 && i18nParams[0] === '') {
      i18nParams = [];
    }
    if (I18N_OVERRIDE_MAPPINGS[(_message$i18n2 = message.i18n) === null || _message$i18n2 === void 0 ? void 0 : _message$i18n2.key]) {
      var _message$i18n3;
      i18nKey = I18N_OVERRIDE_MAPPINGS[(_message$i18n3 = message.i18n) === null || _message$i18n3 === void 0 ? void 0 : _message$i18n3.key];
    } else if (I18N_OVERRIDE_WITH_PARAMS_MAP[i18nKey]) {
      var _message$i18n$params;
      const param = (_message$i18n$params = message.i18n.params) === null || _message$i18n$params === void 0 ? void 0 : _message$i18n$params[0];
      i18nKey = getI8nKeyUsingParams(i18nKey, param);
      i18nParams = i18nKey.endsWith('custom') ? [param] : [];
    }
    if (_Bundles.default.login[i18nKey]) {
      _Logger.default.info(`Override messages using i18n key ${i18nKey}`);
      // expect user config i18n properly.
      // e.g. the i18n value shall have placeholders like `{0}`, when params is not empty.
      return (0, _loc.loc)(i18nKey, 'login', i18nParams);
    }
    if (isWebAuthnAPIError(i18nKey)) {
      // The WebAuthn api error doesn't make much sense to a typical end user, but useful for developer.
      // So keep the api message in response, but show a generic error message on UI.
      return (0, _loc.loc)(WEBAUTHN_API_GENERIC_ERROR_KEY, 'login');
    }
  }
  _Logger.default.warn(`Avoid rendering unlocalized text sent from the API: ${message.message}`);
  return message.message;
};

/**
 * @param {Object} error
 */
exports.getMessage = getMessage;
const getMessageFromBrowserError = error => {
  if (error.name) {
    const key = `oie.browser.error.${error.name}`;
    if (_Bundles.default.login[key]) {
      _Logger.default.info(`Override messages using i18n key ${key}`);
      // expect user config i18n properly.
      return (0, _loc.loc)(key, 'login');
    }
  }
  return error.message;
};

/**
 * - iff `message.i18n.key` exists return the key.
 *
 * @param {Message} message
 */
exports.getMessageFromBrowserError = getMessageFromBrowserError;
const getMessageKey = message => {
  var _message$i18n4;
  return (message === null || message === void 0 ? void 0 : (_message$i18n4 = message.i18n) === null || _message$i18n4 === void 0 ? void 0 : _message$i18n4.key) || '';
};

/**
 * Has this i18n key been overridden for customization?
 * @param {String} i18nKey
 * @param {Object} settings
 * @returns Boolean
 */
exports.getMessageKey = getMessageKey;
const isCustomizedI18nKey = (i18nKey, settings) => {
  const language = settings.get('languageCode');
  const i18n = settings.get('i18n');
  const customizedProperty = i18n && i18n[language] && i18n[language][i18nKey];
  return !!customizedProperty;
};
exports.isCustomizedI18nKey = isCustomizedI18nKey;

/***/ }),

/***/ "./src/v2/ion/payloadTransformer.js":
/*!******************************************!*\
  !*** ./src/v2/ion/payloadTransformer.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _RemediationConstants = __webpack_require__(/*! ./RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const flattenObj = obj => {
  let result = {};
  Object.keys(obj).forEach(key => {
    if (typeof obj[key] !== 'object') {
      result[key] = obj[key];
      return;
    }
    const tempObj = flattenObj(obj[key]);
    Object.keys(tempObj).forEach(j => {
      result[key + '.' + j] = tempObj[j];
    });
  });
  return result;
};

/**
 * This function is for the Granular Consent remediation, scopes within the optedScopes
 * property can include a singular value or n values delimited by a "."
 * When they are delimited, BackBone's toJSON function will create a nested object, however,
 * these should not be nested and the delimited key names should stay as is. So this function will
 * flatten those nested proeprties to format it how the backend expects it. 
 * i.e. { optedScopes: { some: { scope: true }}} = { optedScopes: { 'some.scope': true }}
 * Currently, this is only used when the Granular Consent view form is saved see:
 * src/v2/view-builder/views/consent/GranularConsentView.js
 * 
 * @param {JSON} modelJSON JSON Equivalent of the Backbone Model's attributes/fields
 * @returns If the JSON contains the optedScopes Property, we will flatten the fields from
 * a nested object into K/V pair with dot notation for nested key names. Otherwise, we will return
 * the JSON as is.
 */
const transformOptedScopes = modelJSON => {
  if (modelJSON.optedScopes && typeof modelJSON.optedScopes !== 'string') {
    const data = {
      ...modelJSON,
      optedScopes: flattenObj(modelJSON.optedScopes)
    };
    return data;
  }
  return modelJSON;
};
const FormNameToTransformerHandler = {
  [_RemediationConstants.FORMS.CONSENT_GRANULAR]: transformOptedScopes
};

/**
 * The purpose of this function is the transform the
 * Backbone Model's attributes/fields into a JSON equivalent before sending to IDX,
 * since the Model fields are all flattend when the UI Schema is transformed on consumption.
 * 
 * @param {string} formName Form name of the current remediation
 * @param {Model} model Backbone Model Class
 * @returns JSON equivalent of the Model
 */
const transformPayload = (formName, model) => {
  const modelJSON = model.toJSON();
  const transformHandler = FormNameToTransformerHandler[formName];
  if (typeof transformHandler === 'undefined') {
    return modelJSON;
  }
  return transformHandler(modelJSON);
};
var _default = transformPayload;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/ion/responseTransformer.js":
/*!*******************************************!*\
  !*** ./src/v2/ion/responseTransformer.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _RemediationConstants = __webpack_require__(/*! ./RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Transform the ion spec response into canonical format.
 */

/**
 * Authn V2 response
 * @typedef {Object} AuthnResponse
 */

/**
 * @typedef {Object} AuthnResult
 * @property {Object=} user
 * @property {Object=} authenticator
 */

const isObject = x => _courage._.isObject(x);
const isError = response => !!response.messages;

/**
 * Flatten first level objects from response
 */
const getFirstLevelObjects = resp => {
  const result = {};
  _courage._.each(resp, (val = {}, key) => {
    // if key is remediation we don't do any transformation
    if (key === 'remediation') {
      return;
    }

    // for arrays we just want it as a top level object
    // Example authenticators array in select-authenticator form
    if (val.type === 'array') {
      result[key] = {
        value: val.value
      };
    }

    // for handling attributes with type object
    if (val.type === 'object') {
      result[key] = val.value;
    }
  });
  return result;
};
const getRemediationValues = idx => {
  const remediationValues = [];
  const hasSkipRemediationOnly = idx.neededToProceed.length === 1 && idx.neededToProceed[0].name === 'skip';
  if (_courage._.isEmpty(idx.neededToProceed) || hasSkipRemediationOnly) {
    // no remediation or only skip remediation with success
    if (idx.context.success) {
      remediationValues.push({
        name: idx.context.success.name,
        href: idx.context.success.href,
        value: []
      });
    } else if (idx.context.messages) {
      // no remediation or only skip remediation with messages
      remediationValues.push({
        name: _RemediationConstants.FORMS.TERMINAL,
        // Using `value` is unnecessary as `messages` will be display via `TerminalView.showMessages`,
        // even though might sound a little counterintuitive.
        // The reason being is there is `BaseForm.showMessages` that is intended to handle
        // messages generically.
        value: []
      });
    } else if (idx.context.deviceEnrollment) {
      // no remediation or only skip remediation with messages for device enrollment state
      // and the state is meant to be terminal state with different UI than the regular terminal view
      remediationValues.push({
        name: _RemediationConstants.FORMS.DEVICE_ENROLLMENT_TERMINAL,
        value: []
      });
    }
  }
  return {
    remediations: [...remediationValues, ...idx.neededToProceed]
  };
};

/**
 * To support `idps` configuration in OIE.
 * https://github.com/okta/okta-signin-widget#openid-connect
 */
const injectIdPConfigButtonToRemediation = (settings, idxResp) => {
  const widgetRemedations = idxResp.remediations;
  const hasIdentifyRemedation = widgetRemedations.filter(r => r.name === 'identify');
  if (hasIdentifyRemedation.length === 0) {
    return idxResp;
  }
  const idpsConfig = settings.get('idps');
  if (Array.isArray(idpsConfig)) {
    const existsRedirectIdpIds = {};
    widgetRemedations.forEach(r => {
      if (r.name === _RemediationConstants.FORMS.REDIRECT_IDP && r.idp) {
        existsRedirectIdpIds[r.idp.id] = true;
      }
    });
    const baseUrl = settings.get('baseUrl');
    const stateHandle = idxResp.idx.context.stateHandle;
    const redirectIdpRemedations = idpsConfig.filter(c => !existsRedirectIdpIds[c.id]) // omit idps that are already in remediation.
    .map(idpConfig => {
      const idp = {
        id: idpConfig.id,
        name: idpConfig.text
      };
      const redirectUri = `${baseUrl}/sso/idps/${idpConfig.id}?stateToken=${stateHandle}`;
      if (idpConfig.className) {
        idp.className = idpConfig.className;
      }
      return {
        name: _RemediationConstants.FORMS.REDIRECT_IDP,
        type: idpConfig.type,
        idp,
        href: redirectUri
      };
    });
    idxResp.remediations = widgetRemedations.concat(redirectIdpRemedations);
  }
  return idxResp;
};

/**
 * IFF there is one `redirect-idp` remediation form, widget will automatically redirect to `redirect-idp.href`.
 *
 * The idea now is to reuse `success-redirect` thus converts `redirect-idp` to `success-redirect` form.
 */
const convertRedirectIdPToSuccessRedirectIffOneIdp = (settings, result, lastResult) => {
  if (Array.isArray(result.remediations)) {
    const redirectIdpRemediations = result.remediations.filter(idp => idp.name === _RemediationConstants.FORMS.REDIRECT_IDP);
    if (redirectIdpRemediations.length !== 1 || result.remediations.length !== 1) {
      return;
    }

    // Direct auth clients should not redirect on the initial response
    const isDirectAuth = settings.get('oauth2Enabled');
    if (isDirectAuth && !lastResult) {
      return;
    }
    const successRedirect = {
      name: _RemediationConstants.FORMS.SUCCESS_REDIRECT,
      href: redirectIdpRemediations[0].href,
      value: []
    };
    result.remediations = [successRedirect];
  }
};

/**
 * API reuses `redirect-idp` remediation form for PIV IdP and IdP Authenticator.
 * IdP Authenticator becomes outlier comparing with other Authenticators in terms of
 * using `challenge-authenticator` and `enroll-authenticator` remediation form.
 * The UX for PIV IdP is different from other idps in terms of the PIV
 * instructions view that needs to be rendered before we redirect to mtls.
 *
 * This function changes `redirect-idp` to `challenge-authenticator` or `enroll-authenticator`
 * for IdP Authenticator and changes `redirect-idp` to `piv-idp` for PIV IdP.
 */
const modifyFormNameForIdP = result => {
  if (Array.isArray(result.remediations)) {
    result.remediations.forEach(remediation => {
      var _remediation$relatesT, _remediation$relatesT2;
      if (remediation.name === _RemediationConstants.FORMS.REDIRECT_IDP && (remediation === null || remediation === void 0 ? void 0 : (_remediation$relatesT = remediation.relatesTo) === null || _remediation$relatesT === void 0 ? void 0 : (_remediation$relatesT2 = _remediation$relatesT.value) === null || _remediation$relatesT2 === void 0 ? void 0 : _remediation$relatesT2.key) === _RemediationConstants.AUTHENTICATOR_KEY.IDP) {
        // idp authenticator
        const isVerifyFlow = Object.prototype.hasOwnProperty.call(result, 'currentAuthenticatorEnrollment');
        remediation.name = isVerifyFlow ? 'challenge-authenticator' : 'enroll-authenticator';
      }
      if (remediation.name === _RemediationConstants.FORMS.REDIRECT_IDP && remediation.type === _RemediationConstants.IDP_FORM_TYPE.X509) {
        // piv idp
        remediation.name = _RemediationConstants.FORMS.PIV_IDP;
      }
    });
  }
};
const isFailureRedirect = result => {
  const context = result.idx.context;
  return context.failure && context.failure.name === 'failure-redirect';
};
const handleFailureRedirect = (settings, result) => {
  const context = result.idx.context;

  // Direct auth clients will usually prefer to display the error instead of redirecting
  const isDirectAuth = settings.get('oauth2Enabled');
  const alwaysRedirect = settings.get('redirect') === 'always'; // redirect option overrides default behavior
  if (isDirectAuth && !alwaysRedirect) {
    return;
  }
  const failureRedirect = {
    name: _RemediationConstants.FORMS.FAILURE_REDIRECT,
    href: context.failure.href,
    value: []
  };
  result.remediations = [failureRedirect];
};

/**
 * @param {Models.Settings} user configuration
 * @param {idx} idx object
 * @returns {} transformed object with flattened firstlevel objects, idx and remediations array
 * Example: {
 *  idx: {
 *    proceed: ƒ(),
 *    neededToProceed: [],
 *    actions: {cancel: ƒ()},
 *    context: {},
 *  },
 *  remediations: [],
 *  authenticators: {},
 *  authenticator: {},
 *  messages: {},
 *  deviceEnrollment: {},
 * }
 */
const convert = (settings, idx = {}, lastResult = null) => {
  if (!isObject(idx.rawIdxState)) {
    return null;
  }

  // build result object
  const firstLevelObjects = getFirstLevelObjects(idx.rawIdxState);
  const remediationValues = getRemediationValues(idx);
  const result = Object.assign({}, firstLevelObjects, remediationValues, {
    idx
  });

  // transform result object
  if (isError(result) && isFailureRedirect(result)) {
    handleFailureRedirect(settings, result);
  }

  // Override the `result` to handle custom IdP login buttons
  // and update the form for IdP Authenticators.
  injectIdPConfigButtonToRemediation(settings, result);
  modifyFormNameForIdP(result);
  if (!isError(result)) {
    // Only redirect to the IdP if we are not in an error flow
    convertRedirectIdPToSuccessRedirectIffOneIdp(settings, result, lastResult);
  }
  return result;
};
var _default = convert;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/ion/transformIdxResponse.js":
/*!********************************************!*\
  !*** ./src/v2/ion/transformIdxResponse.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = transformIdxResponse;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _responseTransformer = _interopRequireDefault(__webpack_require__(/*! ./responseTransformer */ "./src/v2/ion/responseTransformer.js"));
var _uiSchemaTransformer = _interopRequireDefault(__webpack_require__(/*! ./uiSchemaTransformer */ "./src/v2/ion/uiSchemaTransformer.js"));
var _i18nTransformer = _interopRequireDefault(__webpack_require__(/*! ./i18nTransformer */ "./src/v2/ion/i18nTransformer.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

// Transforms an IDX response to an ION response
function transformIdxResponse(settings, curResponse, lastResponse) {
  const ionResponse = _courage._.compose(_i18nTransformer.default, _uiSchemaTransformer.default.bind({}, settings), _responseTransformer.default.bind({}, settings))(curResponse, lastResponse);
  return ionResponse;
}
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/ion/ui-schema/ion-boolean-handler.js":
/*!*****************************************************!*\
  !*** ./src/v2/ion/ui-schema/ion-boolean-handler.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _RemediationConstants = __webpack_require__(/*! ../RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const getCheckboxUiSchema = ({
  label,
  type,
  required
}) => ({
  // For Remember Me checkbox, we need the label only on the right side of it.
  placeholder: label,
  label: false,
  // Separating prop type for Backbone.Model
  // from html input type
  modelType: type,
  // uiSchema type is the html input type desired.
  type: 'checkbox',
  required: required || false
});
const getRadioUiSchema = ({
  label,
  required,
  options
}) => ({
  displayName: label,
  type: 'radio',
  required: required,
  options: options[0].value.value.options,
  sublabel: required ? null : (0, _courage.loc)('oie.form.field.optional', 'login')
});
const getCheckboxUiSchemaWithDefaultValue = ({
  label,
  type
}) => ({
  placeholder: label,
  label: false,
  modelType: type,
  type: 'checkbox',
  // set required true so default value can be passed to optional attributes as well
  required: true,
  value: false
});
const createUiSchemaForBoolean = (ionFormField, remediationForm) => {
  var _ionFormField$options, _ionFormField$options2, _ionFormField$options3, _ionFormField$options4, _ionFormField$options5, _ionFormField$options6;
  if ([_RemediationConstants.FORMS.CONSENT_ENDUSER, _RemediationConstants.FORMS.CONSENT_ADMIN].includes(remediationForm.name)) {
    const scopes = remediationForm.scopes.map(({
      name,
      label,
      desc
    }) => {
      return {
        name,
        displayName: label,
        description: desc
      };
    });

    // setting 'type' here to add a specific View in FormInputFactory.create
    const type = remediationForm.name;
    return {
      type,
      scopes,
      options: ionFormField.options
    };
  } else if (Array.isArray(ionFormField.options) && ((_ionFormField$options = ionFormField.options[0]) === null || _ionFormField$options === void 0 ? void 0 : (_ionFormField$options2 = _ionFormField$options.value) === null || _ionFormField$options2 === void 0 ? void 0 : (_ionFormField$options3 = _ionFormField$options2.value) === null || _ionFormField$options3 === void 0 ? void 0 : _ionFormField$options3.inputType) === 'radio') {
    return getRadioUiSchema(ionFormField);
  } else if (Array.isArray(ionFormField.options) && ((_ionFormField$options4 = ionFormField.options[0]) === null || _ionFormField$options4 === void 0 ? void 0 : (_ionFormField$options5 = _ionFormField$options4.value) === null || _ionFormField$options5 === void 0 ? void 0 : (_ionFormField$options6 = _ionFormField$options5.value) === null || _ionFormField$options6 === void 0 ? void 0 : _ionFormField$options6.inputType) === 'checkbox') {
    return getCheckboxUiSchemaWithDefaultValue(ionFormField);
  } else {
    return getCheckboxUiSchema(ionFormField);
  }
};
var _default = createUiSchemaForBoolean;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/ion/ui-schema/ion-object-handler.js":
/*!****************************************************!*\
  !*** ./src/v2/ion/ui-schema/ion-object-handler.js ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createOVOptions = createOVOptions;
exports["default"] = createUiSchemaForObject;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _RemediationConstants = __webpack_require__(/*! ../RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Example of the option like
 * @param {AuthenticatorOption[]} options
 * @param {( AuthenticatorEnrollment[] || Authenticator[] )} authenticators
 */
function createOVOptions(options = []) {
  var _ovItem$value, _ovItem$value$form, _ovItem$value$form$va;
  // Split OV into individual entries for verification (one for each method).
  const ovItem = options.find(option => option.relatesTo.key === _RemediationConstants.AUTHENTICATOR_KEY.OV);
  const methodTypeObj = ovItem === null || ovItem === void 0 ? void 0 : (_ovItem$value = ovItem.value) === null || _ovItem$value === void 0 ? void 0 : (_ovItem$value$form = _ovItem$value.form) === null || _ovItem$value$form === void 0 ? void 0 : (_ovItem$value$form$va = _ovItem$value$form.value) === null || _ovItem$value$form$va === void 0 ? void 0 : _ovItem$value$form$va.find(v => v.name === 'methodType');
  const methodOptions = methodTypeObj === null || methodTypeObj === void 0 ? void 0 : methodTypeObj.options;
  let signedNonceOption;
  if (methodOptions) {
    const ovOptions = [];
    methodOptions.forEach(method => {
      // get value object from the ov item
      const value = [...ovItem.value.form.value];
      // get index of the methodType object within the value object
      const methodTypeIndex = ovItem.value.form.value.findIndex(v => v.name === 'methodType');
      // create a new methodType object that removes the options array and
      // has a value of the current method
      const newMethodTypeObj = Object.assign(_courage._.omit(methodTypeObj, 'options'), method);
      // set the methodType field to be required and immutable in our UI,
      // so it is always sent to the backend.
      newMethodTypeObj.required = true;
      newMethodTypeObj.mutable = false;
      // replace old methodType object with the new one
      value.splice(methodTypeIndex, 1, newMethodTypeObj);
      // return a new ov item for a specific method
      const newItem = Object.assign({}, ovItem, {
        label: method.label,
        value: {
          form: {
            value
          }
        }
      });
      if (method.value === 'signed_nonce') {
        signedNonceOption = newItem;
      } else {
        ovOptions.push(newItem);
      }
    });
    const ovIndex = options.findIndex(option => option.relatesTo.key === _RemediationConstants.AUTHENTICATOR_KEY.OV);
    options.splice(ovIndex, 1, ...ovOptions);

    // ReArrange fastpass in options based on deviceKnown
    if (signedNonceOption) {
      ovItem.relatesTo.deviceKnown ? options.unshift(signedNonceOption) : options.push(signedNonceOption);
    }
  }
}
function createAuthenticatorOptions(options = []) {
  createOVOptions(options);
  return options.map(option => {
    var _option$value, _option$value$form, _option$relatesTo;
    const value = ((_option$value = option.value) === null || _option$value === void 0 ? void 0 : (_option$value$form = _option$value.form) === null || _option$value$form === void 0 ? void 0 : _option$value$form.value) || [];

    // Each authenticator option has list of ION field.
    // Currently we only support merely selecting one of options
    // rather than pop up another page to collect extra data
    // (in order to fill value for `mutable: true; value: null` fields).
    // The only reason of such design is to simplify widget implementation
    // but could subject to change in later releases.
    // Thus only surface up fields that are `required: true; mutable: false`
    // which implies it already has `value`.
    const valueObject = value.filter(v => v.required === true && v.mutable === false).reduce((init, v) => {
      return Object.assign(init, {
        [v.name]: v.value
      });
    }, {});
    return {
      label: option.label,
      value: valueObject,
      relatesTo: option.relatesTo,
      authenticatorKey: (_option$relatesTo = option.relatesTo) === null || _option$relatesTo === void 0 ? void 0 : _option$relatesTo.key
    };
  });
}
function getAuthenticatorsEnrollUiSchema({
  options
}) {
  return {
    type: 'authenticatorEnrollSelect',
    options: createAuthenticatorOptions(options)
  };
}
function getAuthenticatorsVerifyUiSchema({
  options
}) {
  return {
    type: 'authenticatorVerifySelect',
    options: createAuthenticatorOptions(options)
  };
}

/**
  * Create ui schema for ION field that has type 'object'.
  */
function createUiSchemaForObject(ionFormField, remediationForm, transformedResp, createUISchema, settings) {
  const uiSchema = {};
  if (ionFormField.name === 'authenticator' && (remediationForm.name === 'select-authenticator-authenticate' || remediationForm.name === 'select-authenticator-unlock-account')) {
    // 1. when `select-authenticator-authenticator`,
    // create customize type so that display authenticator list as selectable list
    Object.assign(uiSchema, getAuthenticatorsVerifyUiSchema(ionFormField));
  } else if (ionFormField.name === 'authenticator' && remediationForm.name === 'select-authenticator-enroll') {
    // 2. when `select-authenticator-enroll`,
    // create customize type so that display authenticator list as selectable list
    Object.assign(uiSchema, getAuthenticatorsEnrollUiSchema(ionFormField));
  } else if (Array.isArray(ionFormField.options)) {
    // 3. For other cases, create ui schema for each `option` in order to render
    // different view for each option.
    //
    // e.g. { "name": "credentials", "type": "object", options: [ {value: {form: value:[]} ]
    uiSchema.optionsUiSchemas = ionFormField.options.map(opt => {
      return createUISchema(transformedResp, {
        value: [{
          name: ionFormField.name,
          value: opt.value
        }]
      }, settings);
    });
    uiSchema.options = ionFormField.options.map((opt, index) => {
      return {
        label: opt.label,
        value: index
      };
    });
    // assume (default to) use radio buttons to switch sub-schema.
    uiSchema.type = 'radio';
    uiSchema.value = '0';
    uiSchema.name = `sub_schema_local_${ionFormField.name}`;
  }
  return uiSchema;
}

/***/ }),

/***/ "./src/v2/ion/ui-schema/ion-string-handler.js":
/*!****************************************************!*\
  !*** ./src/v2/ion/ui-schema/ion-string-handler.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _RemediationConstants = __webpack_require__(/*! ../RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _CountryUtil = _interopRequireDefault(__webpack_require__(/*! util/CountryUtil */ "./src/util/CountryUtil.js"));
var _TimeZone = _interopRequireDefault(__webpack_require__(/*! ../../view-builder/utils/TimeZone */ "./src/v2/view-builder/utils/TimeZone.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/* eslint max-depth: [2, 3] */
/* eslint complexity: [2, 20] */

const ionOptionsToUiOptions = options => {
  const result = {};
  options.forEach(({
    value,
    label
  }) => {
    result[value] = label;
  });
  return result;
};
const getPasswordUiSchema = settings => ({
  type: 'password',
  params: {
    showPasswordToggle: settings.get('showPasswordToggle')
  }
});
const getCaptchaUiSchema = () => {
  return {
    type: 'captcha'
  };
};
const timezoneUISchema = {
  type: 'select',
  wide: true
};
const shouldRenderAsRadio = name => name.indexOf('methodType') >= 0 || name.indexOf('channel') >= 0;
const optionalType = ['text', 'radio', 'select'];
const populateUISchemaForDisplay = (uiSchema, ionField) => {
  var _ionField$value;
  const display = ionField === null || ionField === void 0 ? void 0 : (_ionField$value = ionField.value) === null || _ionField$value === void 0 ? void 0 : _ionField$value.value;
  uiSchema.type = display.inputType;
  if (display.inputType === 'radio') {
    uiSchema.options = display.options;
  } else if (display.inputType === 'select') {
    uiSchema.wide = true;
    if (display.format === _RemediationConstants.ATTR_FORMAT.COUNTRY_CODE) {
      uiSchema.options = Object.assign({
        '': ''
      }, _CountryUtil.default.getCountryCode());
    } else {
      //it will create a placeholder for dropdowns, by default it will show 'Select an Option'
      uiSchema.options = Object.assign({
        '': ''
      }, ionOptionsToUiOptions(display.options));
    }
  }
};
const populateUISchemaForRadio = (uiSchema, ionFormField) => {
  // e.g. { name: 'methodType', options: [ {label: 'sms'} ], type: 'string' | null }
  uiSchema.type = 'radio';
  // set the default value to the first value.
  ionFormField.value = ionFormField.options[0].value;
};
const createUiSchemaForString = (ionFormField, remediationForm, transformedResp, createUISchema, settings) => {
  const uiSchema = {
    type: 'text'
  };

  // e.g. { name: 'password', secret: true }
  if (ionFormField.secret === true) {
    Object.assign(uiSchema, getPasswordUiSchema(settings));
  }
  if (ionFormField.hint === _RemediationConstants.HINTS.CAPTCHA) {
    Object.assign(uiSchema, getCaptchaUiSchema());
  }
  if (ionFormField.name === 'userProfile.timezone') {
    Object.assign(uiSchema, timezoneUISchema);
    uiSchema.options = Object.assign({
      '': ''
    }, _TimeZone.default);
  }
  if (Array.isArray(ionFormField.options) && ionFormField.options[0] && ionFormField.options[0].value) {
    const ionField = ionFormField.options[0];
    if (ionField.label === 'display') {
      populateUISchemaForDisplay(uiSchema, ionField);
    } else if (shouldRenderAsRadio(ionFormField.name)) {
      populateUISchemaForRadio(uiSchema, ionFormField);
    } else {
      // default to select (dropdown). no particular reason (certainly can default to radio.)
      // e.g. { name: 'questionKey', options: [], type: 'string' | null }
      uiSchema.type = 'select';
      uiSchema.wide = true;
      uiSchema.options = ionOptionsToUiOptions(ionFormField.options);
    }
  }

  // set a label as 'Optional' for supported optional element types
  if (ionFormField.required === false && optionalType.includes(uiSchema.type)) {
    uiSchema.sublabel = (0, _courage.loc)('oie.form.field.optional', 'login');
  }
  return uiSchema;
};
var _default = createUiSchemaForString;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/ion/uiSchemaTransformer.js":
/*!*******************************************!*\
  !*** ./src/v2/ion/uiSchemaTransformer.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _ionBooleanHandler = _interopRequireDefault(__webpack_require__(/*! ./ui-schema/ion-boolean-handler */ "./src/v2/ion/ui-schema/ion-boolean-handler.js"));
var _ionObjectHandler = _interopRequireDefault(__webpack_require__(/*! ./ui-schema/ion-object-handler */ "./src/v2/ion/ui-schema/ion-object-handler.js"));
var _ionStringHandler = _interopRequireDefault(__webpack_require__(/*! ./ui-schema/ion-string-handler */ "./src/v2/ion/ui-schema/ion-string-handler.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

/**
 * Create UI Schema into remedation object base on remediation values
 */

const UISchemaHandlers = {
  string: _ionStringHandler.default,
  boolean: _ionBooleanHandler.default,
  object: _ionObjectHandler.default
};

/**
 *
 * @param {AuthResult} transformedResp
 * @param {IONForm} remeditationForm
 */
const createUISchema = (transformedResp, remediationForm, settings) => {
  // For cases where field itself is a form, it has a formname and we are appending the formname to each field.
  // Sort of flat the structure in order to align Courage flatten Model. The flatten structure will be converted
  // back to object hierarchy through `Model.toJSON`.
  // For simplicity we are assuming that when field itself is a form its only one level deep.
  const remediationValue = _courage._.chain(remediationForm.value || []).filter(v => v.visible !== false).map(v => {
    var _v$value;
    let nestedForm;
    if (v.form) {
      nestedForm = v.form;
    } else if ((_v$value = v.value) !== null && _v$value !== void 0 && _v$value.form) {
      nestedForm = v.value.form;
    }
    if (nestedForm) {
      const inputGroupName = v.name;
      return nestedForm.value.map(input => {
        return Object.assign({}, input, {
          name: inputGroupName + '.' + input.name
        });
      });
    } else {
      return v;
    }
  }).flatten().value();
  return remediationValue.map(ionFormField => {
    const uiSchemaDefaultConfig = {
      'label-top': true,
      'multirowError': true,
      'data-se': `o-form-fieldset-${ionFormField.name}`
    };
    const fieldType = ionFormField.type || 'string';
    const uiSchemaHandler = UISchemaHandlers[fieldType];
    const uiSchemaResult = uiSchemaHandler(ionFormField, remediationForm, transformedResp, createUISchema, settings);
    return Object.assign({}, ionFormField, uiSchemaDefaultConfig, uiSchemaResult);
  });
};

/**
 *
 * @param {AuthResult} transformedResp
 */
const insertUISchema = (settings, transformedResp) => {
  if (transformedResp) {
    transformedResp.remediations = transformedResp.remediations.map(obj => {
      obj.uiSchema = createUISchema(transformedResp, obj, settings);
      return obj;
    });
  }
  return transformedResp;
};
var _default = insertUISchema;
/**
 * @typedef {Object} Authenticator
 * @property {string} label
 * @property {AuthenticatorValue} value
 */
/**
 * @typedef {Object} AuthenticatorValue
 * @property {string} type Authenticator Type
 * @property {string} id Authenticator Org Authenticator ID
 * @property {AuthenticatorMethod[]} methods
 */
/**
 * @typedef {Object} AuthenticatorEnrollment
 * @property {string} label
 * @property {AuthenticatorEnrollmentValue} value
 */
/**
 * @typedef {Object} AuthenticatorEnrollmentValue
 * @property {string} authenticatorId Org Authenticator ID
 * @property {string} type Authenticator Type
 * @property {string} id Authenticator Enrollment ID
 * @property {AuthenticatorMethod[]} methods
 */
/**
 * @typedef {Object} AuthenticatorMethod
 * @property {string} type Authenticator method type
 */
/**
 * @typedef {Object} AuthenticatorOption
 * @property {string} label
 * @property {Object} form
 * @property {AuthenticatorOption[]} form.value
 */
/**
 * @typedef {Object} AuthenticatorOptionValue
 * @property {string} name
 * @property {boolean} required
 * @property {string} value
 * @property {boolean} mutable
 */
/**
 * @typedef {Object} IONForm
 * @property {string} name
 * @property {string[]} rel
 * @property {string} method
 * @property {string} href
 * @property {string} accepts
 * @property {IONFormField[]} value
 */
/**
 * @typedef {Object} IONFormField
 * @property {string} name
 * @property {string=} type
 * @property {string=} required
 * @property {string=} secret
 * @property {string=} label
 * @property {Object[]} options
 * @property {Object=} form
 * @property {IONFormField[]} form.value
 */
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/components/AuthenticatorEnrollOptions.js":
/*!**********************************************************************!*\
  !*** ./src/v2/view-builder/components/AuthenticatorEnrollOptions.js ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _RemediationConstants = __webpack_require__(/*! ../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _SkipOptionalEnrollmentButton = _interopRequireDefault(__webpack_require__(/*! ./SkipOptionalEnrollmentButton */ "./src/v2/view-builder/components/SkipOptionalEnrollmentButton.js"));
var _Constants = __webpack_require__(/*! ../utils/Constants */ "./src/v2/view-builder/utils/Constants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const AuthenticatorRow = _courage.View.extend({
  className: 'authenticator-row clearfix',
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"factor-icon authenticator-icon " + alias3((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "iconClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 100
          },
          "end": {
            "line": 1,
            "column": 117
          }
        }
      }) : helper)) + " custom-app-logo\" role=\"img\" aria-label=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.auth.logo.aria.label"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 158
          },
          "end": {
            "line": 1,
            "column": 213
          }
        }
      })) + "\"></div>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"factor-icon authenticator-icon " + alias3((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "iconClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 272
          },
          "end": {
            "line": 1,
            "column": 289
          }
        }
      }) : helper)) + "\" role=\"img\" aria-label=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.auth.logo.aria.label"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 314
          },
          "end": {
            "line": 1,
            "column": 369
          }
        }
      })) + "\"></div>";
    },
    "5": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p class=\"authenticator-description--text\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "description") || (depth0 != null ? lookupProperty(depth0, "description") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "description",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 550
          },
          "end": {
            "line": 1,
            "column": 565
          }
        }
      }) : helper)) + "</p>";
    },
    "7": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p class=\"authenticator-usage-text\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "authenticatorUsageText") || (depth0 != null ? lookupProperty(depth0, "authenticatorUsageText") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "authenticatorUsageText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 642
          },
          "end": {
            "line": 1,
            "column": 668
          }
        }
      }) : helper)) + "</p>";
    },
    "9": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "data-se=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "buttonDataSeAttr") || (depth0 != null ? lookupProperty(depth0, "buttonDataSeAttr") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "buttonDataSeAttr",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 746
          },
          "end": {
            "line": 1,
            "column": 766
          }
        }
      }) : helper)) + "\"";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"authenticator-icon-container\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "logoUri") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.program(3, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 42
          },
          "end": {
            "line": 1,
            "column": 384
          }
        }
      })) != null ? stack1 : "") + "</div><div class=\"authenticator-description\"><h3 class=\"authenticator-label no-translate\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 474
          },
          "end": {
            "line": 1,
            "column": 483
          }
        }
      }) : helper)) + "</h3>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(5, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 488
          },
          "end": {
            "line": 1,
            "column": 576
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "authenticatorUsageText") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(7, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 576
          },
          "end": {
            "line": 1,
            "column": 679
          }
        }
      })) != null ? stack1 : "") + "<div class=\"authenticator-button\" " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "buttonDataSeAttr") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(9, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 713
          },
          "end": {
            "line": 1,
            "column": 774
          }
        }
      })) != null ? stack1 : "") + "></div></div>";
    },
    "useData": true
  }),
  postRender: function () {
    _courage.View.prototype.postRender.apply(this, arguments);
    if (this.model.get('logoUri')) {
      this.el.querySelector('.custom-app-logo').style.backgroundImage = `url(${this.model.get('logoUri')})`;
    }
  },
  children: function () {
    return [[(0, _courage.createButton)({
      className: 'button select-factor',
      title: function () {
        return (0, _courage.loc)('oie.enroll.authenticator.button.text', 'login');
      },
      attributes: {
        'aria-label': this.model.get('ariaLabel')
      },
      click: function () {
        this.model.trigger('selectAuthenticator', this.model.get('value'));
      }
    }), '.authenticator-button']];
  },
  minimize: function () {
    this.$el.addClass('authenticator-row-min');
  },
  getTemplateData() {
    let authenticatorUsageText;
    const allowedFor = this.model.get('relatesTo').allowedFor;
    if (allowedFor) {
      switch (allowedFor) {
        case _Constants.AUTHENTICATOR_ALLOWED_FOR_OPTIONS.ANY:
          authenticatorUsageText = (0, _courage.loc)('oie.enroll.authenticator.usage.text.access.recovery', 'login');
          break;
        case _Constants.AUTHENTICATOR_ALLOWED_FOR_OPTIONS.RECOVERY:
          authenticatorUsageText = (0, _courage.loc)('oie.enroll.authenticator.usage.text.recovery', 'login');
          break;
        case _Constants.AUTHENTICATOR_ALLOWED_FOR_OPTIONS.SSO:
          authenticatorUsageText = (0, _courage.loc)('oie.enroll.authenticator.usage.text.access', 'login');
          break;
      }
    }
    const data = _courage.View.prototype.getTemplateData.apply(this, arguments);
    data.authenticatorUsageText = authenticatorUsageText;
    return data;
  }
});
var _default = _courage.ListView.extend({
  className: 'authenticator-enroll-list authenticator-list',
  item: AuthenticatorRow,
  itemSelector: '.list-content',
  initialize: function () {
    this.listenTo(this.collection, 'selectAuthenticator', function (data) {
      this.model.set(this.options.name, data);
      this.options.appState.trigger('saveForm', this.model);
    });
    this.hasOptionalFactors = this.options.appState.hasRemediationObject(_RemediationConstants.FORMS.SKIP);
    if (this.hasOptionalFactors) {
      this.add(_SkipOptionalEnrollmentButton.default);
    }
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"list-content\"><div class=\"authenticator-list-title\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 64
          },
          "end": {
            "line": 1,
            "column": 73
          }
        }
      }) : helper)) + "</div></div>";
    },
    "useData": true
  }),
  getTemplateData() {
    // presence of the skip remediation form tells us that the authenticators are all optional
    const title = this.hasOptionalFactors ? (0, _courage.loc)('oie.setup.optional', 'login') : (0, _courage.loc)('oie.setup.required', 'login');
    return {
      title
    };
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/components/AuthenticatorFooter.js":
/*!***************************************************************!*\
  !*** ./src/v2/view-builder/components/AuthenticatorFooter.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _internals = __webpack_require__(/*! ../internals */ "./src/v2/view-builder/internals/index.js");
var _LinksUtil = __webpack_require__(/*! ../utils/LinksUtil */ "./src/v2/view-builder/utils/LinksUtil.js");
var _default = _internals.BaseFooter.extend({
  links() {
    return (0, _LinksUtil.getFactorPageCustomLink)(this.options.appState, this.options.settings).concat((0, _LinksUtil.getSwitchAuthenticatorLink)(this.options.appState));
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/components/AuthenticatorVerifyOptions.js":
/*!**********************************************************************!*\
  !*** ./src/v2/view-builder/components/AuthenticatorVerifyOptions.js ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const AuthenticatorRow = _courage.View.extend({
  className: 'authenticator-row clearfix',
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"factor-icon authenticator-icon " + alias3((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "iconClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 100
          },
          "end": {
            "line": 1,
            "column": 117
          }
        }
      }) : helper)) + " custom-logo\" role=\"img\" aria-label=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.auth.logo.aria.label"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 154
          },
          "end": {
            "line": 1,
            "column": 209
          }
        }
      })) + "\"></div>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"factor-icon authenticator-icon " + alias3((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "iconClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 268
          },
          "end": {
            "line": 1,
            "column": 285
          }
        }
      }) : helper)) + "\" role=\"img\" aria-label=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.auth.logo.aria.label"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 310
          },
          "end": {
            "line": 1,
            "column": 365
          }
        }
      })) + "\"></div>";
    },
    "5": function (container, depth0, helpers, partials, data) {
      return "authenticator-label--small";
    },
    "7": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p class=\"authenticator-description--text " + alias4((helper = (helper = lookupProperty(helpers, "noTranslateClassName") || (depth0 != null ? lookupProperty(depth0, "noTranslateClassName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "noTranslateClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 603
          },
          "end": {
            "line": 1,
            "column": 627
          }
        }
      }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "description") || (depth0 != null ? lookupProperty(depth0, "description") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "description",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 629
          },
          "end": {
            "line": 1,
            "column": 644
          }
        }
      }) : helper)) + "</p>";
    },
    "9": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p class=\"authenticator-enrollment-nickname " + alias4((helper = (helper = lookupProperty(helpers, "noTranslateClassName") || (depth0 != null ? lookupProperty(depth0, "noTranslateClassName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "noTranslateClassName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 715
          },
          "end": {
            "line": 1,
            "column": 739
          }
        }
      }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "nickname") || (depth0 != null ? lookupProperty(depth0, "nickname") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "nickname",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 741
          },
          "end": {
            "line": 1,
            "column": 753
          }
        }
      }) : helper)) + "</p>";
    },
    "11": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "data-se=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "buttonDataSeAttr") || (depth0 != null ? lookupProperty(depth0, "buttonDataSeAttr") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "buttonDataSeAttr",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 837
          },
          "end": {
            "line": 1,
            "column": 857
          }
        }
      }) : helper)) + "\"";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"authenticator-icon-container\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "logoUri") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.program(3, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 42
          },
          "end": {
            "line": 1,
            "column": 380
          }
        }
      })) != null ? stack1 : "") + "</div><div class=\"authenticator-description\"><div><h3 class=\"authenticator-label no-translate " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(5, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 474
          },
          "end": {
            "line": 1,
            "column": 526
          }
        }
      })) != null ? stack1 : "") + "\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 528
          },
          "end": {
            "line": 1,
            "column": 537
          }
        }
      }) : helper)) + "</h3>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(7, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 542
          },
          "end": {
            "line": 1,
            "column": 655
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "nickname") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(9, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 655
          },
          "end": {
            "line": 1,
            "column": 764
          }
        }
      })) != null ? stack1 : "") + "</div><div class=\"authenticator-button\" " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "buttonDataSeAttr") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(11, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 804
          },
          "end": {
            "line": 1,
            "column": 865
          }
        }
      })) != null ? stack1 : "") + "></div></div>";
    },
    "useData": true
  }),
  postRender: function () {
    _courage.View.prototype.postRender.apply(this, arguments);
    const logoUri = this.model.get('logoUri');
    if (logoUri) {
      this.el.querySelector('.custom-logo').style.backgroundImage = `url(${logoUri})`;
    }
  },
  children: function () {
    return [[(0, _courage.createButton)({
      className: 'button select-factor',
      title: function () {
        return (0, _courage.loc)('oie.verify.authenticator.button.text', 'login');
      },
      attributes: {
        'aria-label': this.model.get('ariaLabel')
      },
      click: function () {
        this.model.trigger('selectAuthenticator', this.model.get('value'));
      }
    }), '.authenticator-button']];
  },
  minimize: function () {
    this.$el.addClass('authenticator-row-min');
  }
});
var _default = _courage.ListView.extend({
  className: 'authenticator-verify-list authenticator-list',
  item: AuthenticatorRow,
  itemSelector: '.list-content',
  initialize: function () {
    this.listenTo(this.collection, 'selectAuthenticator', this.handleSelect);
    this.listenTo(this.model, 'invalid', this.handleModelInvalid);
  },
  handleModelInvalid(data, error) {
    if (this.options.name in error && !this.model.get(this.options.name)) {
      this.showAuthenticatorRequiredError();
    }
  },
  showAuthenticatorRequiredError() {
    const errorSummary = this.collection.length > 1 ? (0, _courage.loc)('account.unlock.authenticatorRequired.multiple', 'login') : (0, _courage.loc)('account.unlock.authenticatorRequired.single', 'login');
    this.model.trigger('error', this.model, {
      responseJSON: {
        errorSummary
      }
    });
  },
  handleSelect(data) {
    var _this$model$getProper;
    //If schema contains a required identifier to fill first then validate the form
    const validationError = this.model.validateField('identifier');
    this.model.trigger('clearFormError');
    if ((_this$model$getProper = this.model.getPropertySchema('identifier')) !== null && _this$model$getProper !== void 0 && _this$model$getProper.required && validationError) {
      this.model.trigger('invalid', this.model, validationError);
    } else {
      this.model.set(this.options.name, data);
      this.options.appState.trigger('saveForm', this.model);
    }
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      return "<div class=\"list-content\"></div>";
    },
    "useData": true
  })
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/components/BaseAuthenticatorView.js":
/*!*****************************************************************!*\
  !*** ./src/v2/view-builder/components/BaseAuthenticatorView.js ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.BaseAuthenticatorBeacon = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../internals */ "./src/v2/view-builder/internals/index.js");
var _AuthenticatorFooter = _interopRequireDefault(__webpack_require__(/*! ./AuthenticatorFooter */ "./src/v2/view-builder/components/AuthenticatorFooter.js"));
var _HeaderBeacon = _interopRequireDefault(__webpack_require__(/*! ./HeaderBeacon */ "./src/v2/view-builder/components/HeaderBeacon.js"));
var _AuthenticatorUtil = __webpack_require__(/*! ../utils/AuthenticatorUtil */ "./src/v2/view-builder/utils/AuthenticatorUtil.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BaseAuthenticatorBeacon = _HeaderBeacon.default.extend({
  authenticatorKey() {
    return this.options.appState.get('authenticatorKey');
  },
  getBeaconClassName: function () {
    const authenticatorKey = _courage._.result(this, 'authenticatorKey');
    return (0, _AuthenticatorUtil.getIconClassNameForBeacon)(authenticatorKey);
  }
});
exports.BaseAuthenticatorBeacon = BaseAuthenticatorBeacon;
var _default = _internals.BaseView.extend({
  Header: _internals.BaseHeader.extend({
    HeaderBeacon: BaseAuthenticatorBeacon
  }),
  Footer: _AuthenticatorFooter.default
});
exports["default"] = _default;

/***/ }),

/***/ "./src/v2/view-builder/components/ChallengeWebauthnFooter.js":
/*!*******************************************************************!*\
  !*** ./src/v2/view-builder/components/ChallengeWebauthnFooter.js ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _AuthenticatorFooter = _interopRequireDefault(__webpack_require__(/*! ./AuthenticatorFooter */ "./src/v2/view-builder/components/AuthenticatorFooter.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const OKTA_AUTHENTICATOR = 'Okta_Authenticator';
const CantVerifyInfoVerifyFlowView = _courage.View.extend({
  id: 'help-description-container',
  className: 'help-description js-help-description',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<h3>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.biometric.authenticator.title"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 4
          },
          "end": {
            "line": 1,
            "column": 96
          }
        }
      })) + "</h3><br><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.biometric.authenticator.description1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 108
          },
          "end": {
            "line": 1,
            "column": 207
          }
        }
      })) + "</p><br><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.biometric.authenticator.description2"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 218
          },
          "end": {
            "line": 1,
            "column": 317
          }
        }
      })) + "</p><br><h3>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.security.key.title"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 329
          },
          "end": {
            "line": 1,
            "column": 410
          }
        }
      })) + "</h3><br><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.security.key.description"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 422
          },
          "end": {
            "line": 1,
            "column": 509
          }
        }
      })) + "</p><br>";
    },
    "useData": true
  })
});
const CantVerifyInfoOVEnrollmentFlowView = _courage.View.extend({
  id: 'help-description-container',
  className: 'help-description js-help-description',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<ol class=\"ov-enrollment-info\"><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.enrollment.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 35
          },
          "end": {
            "line": 1,
            "column": 114
          }
        }
      })) + "</li><br><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.enrollment.step2"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 127
          },
          "end": {
            "line": 1,
            "column": 206
          }
        }
      })) + "</li><br><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.enrollment.step3"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 219
          },
          "end": {
            "line": 1,
            "column": 298
          }
        }
      })) + "</li><br><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.cant.verify.enrollment.step4"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 311
          },
          "end": {
            "line": 1,
            "column": 390
          }
        }
      })) + "</><br></ol>";
    },
    "useData": true
  })
});
var _default = _AuthenticatorFooter.default.extend({
  links: function () {
    const links = _AuthenticatorFooter.default.prototype.links.apply(this, arguments);
    const cantVerifyInfoView = this.options.appState.get('app') && this.options.appState.get('app').name === OKTA_AUTHENTICATOR ? CantVerifyInfoOVEnrollmentFlowView : CantVerifyInfoVerifyFlowView;
    links.unshift({
      'label': (0, _courage.loc)('oie.verify.webauthn.cant.verify', 'login'),
      'name': 'cant-verify',
      'aria-controls': 'help-description-container',
      'class': 'link help js-help',
      'type': 'toggle-text-link',
      'additionalOptions': {
        view: cantVerifyInfoView,
        selector: '.js-help-description'
      }
    });
    return links;
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/components/EmailAuthenticatorHeader.js":
/*!********************************************************************!*\
  !*** ./src/v2/view-builder/components/EmailAuthenticatorHeader.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _internals = __webpack_require__(/*! ../internals */ "./src/v2/view-builder/internals/index.js");
var _RemediationConstants = __webpack_require__(/*! ../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _BaseAuthenticatorView = __webpack_require__(/*! ./BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js");
var _default = _internals.BaseHeader.extend({
  HeaderBeacon: _BaseAuthenticatorView.BaseAuthenticatorBeacon.extend({
    authenticatorKey: _RemediationConstants.AUTHENTICATOR_KEY.EMAIL
  })
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/components/HeaderBeacon.js":
/*!********************************************************!*\
  !*** ./src/v2/view-builder/components/HeaderBeacon.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"bg-helper auth-beacon auth-beacon-factor " + alias3((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "className",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 245
          },
          "end": {
            "line": 1,
            "column": 258
          }
        }
      }) : helper)) + " custom-app-logo\" data-se=\"factor-beacon\" role=\"img\" aria-label=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.auth.logo.aria.label"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 323
          },
          "end": {
            "line": 1,
            "column": 378
          }
        }
      })) + "\">";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"bg-helper auth-beacon auth-beacon-factor " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "className",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 441
          },
          "end": {
            "line": 1,
            "column": 454
          }
        }
      }) : helper)) + "\" data-se=\"factor-beacon\">";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div data-type=\"beacon-container\" class=\"beacon-container\"><div class=\"beacon-blank auth-beacon\"><div class=\"beacon-blank js-blank-beacon-border auth-beacon-border\"></div></div>" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "logoUri") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.program(3, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 177
          },
          "end": {
            "line": 1,
            "column": 487
          }
        }
      })) != null ? stack1 : "") + "<div class=\"okta-sign-in-beacon-border auth-beacon-border\"></div></div></div >";
    },
    "useData": true
  }),
  postRender: function () {
    _courage.View.prototype.postRender.apply(this, arguments);
    const data = this.getTemplateData();
    if (data.logoUri) {
      this.el.querySelector('.custom-app-logo').style.backgroundImage = `url(${data.logoUri})`;
    }
  },
  getTemplateData: function () {
    var _this$options, _appState$get, _appState$get2;
    const appState = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.appState;
    return {
      className: this.getBeaconClassName() || '',
      logoUri: (appState === null || appState === void 0 ? void 0 : (_appState$get = appState.get('currentAuthenticator')) === null || _appState$get === void 0 ? void 0 : _appState$get.logoUri) || (appState === null || appState === void 0 ? void 0 : (_appState$get2 = appState.get('currentAuthenticatorEnrollment')) === null || _appState$get2 === void 0 ? void 0 : _appState$get2.logoUri)
    };
  },
  getBeaconClassName() {
    return 'undefined-user';
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/components/IdentifierFooter.js":
/*!************************************************************!*\
  !*** ./src/v2/view-builder/components/IdentifierFooter.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../internals */ "./src/v2/view-builder/internals/index.js");
var _RemediationConstants = __webpack_require__(/*! ../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _LinksUtil = __webpack_require__(/*! ../utils/LinksUtil */ "./src/v2/view-builder/utils/LinksUtil.js");
var _Link = _interopRequireDefault(__webpack_require__(/*! ./Link */ "./src/v2/view-builder/components/Link.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _internals.BaseFooter.extend({
  showForgotPasswordLink() {
    return !this.options.appState.isIdentifierOnlyView();
  },
  footerInfo() {
    const signUpLinkData = (0, _LinksUtil.getSignUpLink)(this.options.appState, this.options.settings);
    let SignUpLinkWithText;
    //Build sign up link view appended with a text. Link class can only build anchor tags
    if (signUpLinkData.length) {
      SignUpLinkWithText = _courage.View.extend({
        className: 'signup-info',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
            return "<span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "registration.signup.label"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 6
                },
                "end": {
                  "line": 1,
                  "column": 62
                }
              }
            })) + "</span><span class=\"signup-link\"></span>";
          },
          "useData": true
        }),
        initialize() {
          this.add(_Link.default, '.signup-link', {
            options: signUpLinkData[0]
          });
        }
      });
    }
    return SignUpLinkWithText;
  },
  links() {
    const {
      appState,
      settings
    } = this.options;
    let helpLinkHref;
    if (settings.get('helpLinks.help')) {
      helpLinkHref = settings.get('helpLinks.help');
    } else {
      const baseUrl = settings.get('baseUrl');
      helpLinkHref = baseUrl + '/help/login';
    }
    const helpLink = [{
      'name': 'help',
      'label': (0, _courage.loc)('help', 'login'),
      'href': helpLinkHref
    }];
    let forgotPasswordLink = [];
    if (this.showForgotPasswordLink()) {
      forgotPasswordLink = (0, _LinksUtil.getForgotPasswordLink)(appState, settings);
    }
    const customHelpLinks = [];
    if (settings.get('helpLinks.custom')) {
      //add custom helpLinks
      settings.get('helpLinks.custom').forEach(customHelpLink => {
        customHelpLink.name = 'custom';
        customHelpLink.label = customHelpLink.text;
        customHelpLinks.push(customHelpLink);
      });
    }
    const unlockAccountLink = [];
    if (settings.get('helpLinks.unlock')) {
      unlockAccountLink.push({
        'type': 'link',
        'label': (0, _courage.loc)('unlockaccount', 'login'),
        'name': 'unlock',
        'href': settings.get('helpLinks.unlock')
      });
    } else if (appState.hasRemediationObject(_RemediationConstants.FORMS.UNLOCK_ACCOUNT)) {
      unlockAccountLink.push({
        'type': 'link',
        'label': (0, _courage.loc)('unlockaccount', 'login'),
        'name': 'unlock',
        'actionPath': _RemediationConstants.FORMS.UNLOCK_ACCOUNT
      });
    }
    return forgotPasswordLink.concat(unlockAccountLink).concat(helpLink).concat(customHelpLinks);
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/components/Link.js":
/*!************************************************!*\
  !*** ./src/v2/view-builder/components/Link.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 9
          }
        }
      }) : helper));
    },
    "useData": true
  }),
  tagName: 'a',
  attributes() {
    let href = this.options.href || '#';
    return {
      'data-se': this.options.name,
      href: href,
      target: this.options.target
    };
  },
  className() {
    const names = ['link'];
    if (this.options.name) {
      const nameToClass = this.options.name.replace(/[ ]/g, '-');
      names.push(`js-${nameToClass}`);
    }
    return names.join(' ');
  },
  postRender() {
    // TODO OKTA-245224: create sub class of Link to dispatch following if/else logic.
    if (!this.options.href) {
      this.$el.click(event => {
        event.preventDefault();
        const {
          appState,
          formName,
          actionPath,
          clickHandler
        } = this.options;
        if (clickHandler) {
          clickHandler();
        } else if (formName) {
          appState.trigger('switchForm', formName);
        } else if (actionPath) {
          appState.trigger('invokeAction', actionPath);
        }
      });
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/components/MdmOktaVerifyTerminalView.js":
/*!*********************************************************************!*\
  !*** ./src/v2/view-builder/components/MdmOktaVerifyTerminalView.js ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const {
  Notification
} = _courage.internal.views.components;
const {
  Clipboard
} = _courage.internal.util;
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.explanation.mdm"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 5
          },
          "end": {
            "line": 1,
            "column": 58
          }
        }
      })) + "</div><ol><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.mdm.step.copyLink"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 72
          },
          "end": {
            "line": 1,
            "column": 127
          }
        }
      })) + "<a data-clipboard-text=\"" + alias3((helper = (helper = lookupProperty(helpers, "enrollmentLink") || (depth0 != null ? lookupProperty(depth0, "enrollmentLink") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "enrollmentLink",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 151
          },
          "end": {
            "line": 1,
            "column": 169
          }
        }
      }) : helper)) + "\" class=\"button link-button copy-clipboard-button\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.mdm.copyLink"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 220
          },
          "end": {
            "line": 1,
            "column": 270
          }
        }
      })) + "</a></li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.mdm.step.pasteLink"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 283
          },
          "end": {
            "line": 1,
            "column": 339
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='semi-strong'>$1</span>",
          "arguments": "vendor",
          "bundle": "login",
          "code": "enroll.mdm.step.followInstructions"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 348
          },
          "end": {
            "line": 1,
            "column": 473
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.mdm.step.relogin"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 482
          },
          "end": {
            "line": 1,
            "column": 536
          }
        }
      })) + "</li></ol>";
    },
    "useData": true
  }),
  getTemplateData() {
    return this.options.appState.get('deviceEnrollment');
  },
  postRender: function () {
    // Attach each button to the respective 'data-clipboard-text'
    Clipboard.attach('.copy-clipboard-button').done(() => {
      let notification = new Notification({
        message: (0, _courage.loc)('enroll.mdm.copyLink.success', 'login'),
        level: 'success'
      });
      this.el.prepend(notification.render().el);
      return false;
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/components/OdaOktaVerifyTerminalView.js":
/*!*********************************************************************!*\
  !*** ./src/v2/view-builder/components/OdaOktaVerifyTerminalView.js ***!
  \*********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDeviceEnrollmentContext = exports.IosAndAndroidLoopbackOdaTerminalView = exports.AndroidAppLinkWithoutAccountOdaTerminalView = exports.AndroidAppLinkWithAccountOdaTerminalView = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const {
  Notification
} = _courage.internal.views.components;
const {
  Clipboard
} = _courage.internal.util;
const getDeviceEnrollmentContext = deviceEnrollment => {
  const platform = (deviceEnrollment.platform || '').toLowerCase();
  const challengeMethod = deviceEnrollment.challengeMethod;
  const enrollmentType = deviceEnrollment.name;
  const isIOS = platform === _Enums.default.IOS;
  const isAndroidAppLink = platform === _Enums.default.ANDROID && challengeMethod === 'APP_LINK';
  const isAndroidLoopback = platform === _Enums.default.ANDROID && challengeMethod === 'LOOPBACK';
  return {
    signInUrl: deviceEnrollment.signInUrl,
    isIOS,
    enrollmentType,
    isAndroidLoopback,
    isAndroidAppLink,
    appStoreLink: isIOS ? _Enums.default.OKTA_VERIFY_APPLE_APP_STORE_URL : _Enums.default.OKTA_VERIFY_GOOGLE_PLAY_STORE_URL,
    orgName: deviceEnrollment.orgName
  };
};
exports.getDeviceEnrollmentContext = getDeviceEnrollmentContext;
const BaseOdaOktaVerifyTerminalView = _courage.View.extend({
  getTemplateData() {
    const deviceEnrollment = this.options.appState.get('deviceEnrollment');
    return getDeviceEnrollmentContext(deviceEnrollment);
  }
});
const IosAndAndroidLoopbackOdaTerminalView = BaseOdaOktaVerifyTerminalView.extend({
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.mdm.step.copyLink"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 120
          },
          "end": {
            "line": 1,
            "column": 175
          }
        }
      })) + "<a data-clipboard-text=\"" + alias3((helper = (helper = lookupProperty(helpers, "appStoreLink") || (depth0 != null ? lookupProperty(depth0, "appStoreLink") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "appStoreLink",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 199
          },
          "end": {
            "line": 1,
            "column": 215
          }
        }
      }) : helper)) + "\" class=\"button link-button copy-clipboard-button\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.mdm.copyLink"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 266
          },
          "end": {
            "line": 1,
            "column": 316
          }
        }
      })) + "</a></li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.mdm.step.pasteLink"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 329
          },
          "end": {
            "line": 1,
            "column": 385
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.step3"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 394
          },
          "end": {
            "line": 1,
            "column": 441
          }
        }
      })) + "</li>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<li>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.android.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 482
          },
          "end": {
            "line": 1,
            "column": 537
          }
        }
      })) + "</li>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        alias4 = "function",
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p class=\"explanation\" data-se=\"subheader\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.explanation.p1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 43
          },
          "end": {
            "line": 1,
            "column": 95
          }
        }
      })) + "</p><ol>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isIOS") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 103
          },
          "end": {
            "line": 1,
            "column": 453
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isAndroidLoopback") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 453
          },
          "end": {
            "line": 1,
            "column": 549
          }
        }
      })) != null ? stack1 : "") + "<li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 553
          },
          "end": {
            "line": 1,
            "column": 600
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.step2"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 609
          },
          "end": {
            "line": 1,
            "column": 656
          }
        }
      })) + "<p class=\"org-signin-link\"><span class=\"no-translate\">" + alias3((helper = (helper = lookupProperty(helpers, "signInUrl") || (depth0 != null ? lookupProperty(depth0, "signInUrl") : depth0)) != null ? helper : alias2, typeof helper === alias4 ? helper.call(alias1, {
        "name": "signInUrl",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 710
          },
          "end": {
            "line": 1,
            "column": 723
          }
        }
      }) : helper)) + "</span></p><a data-clipboard-text=\"" + alias3((helper = (helper = lookupProperty(helpers, "signInUrl") || (depth0 != null ? lookupProperty(depth0, "signInUrl") : depth0)) != null ? helper : alias2, typeof helper === alias4 ? helper.call(alias1, {
        "name": "signInUrl",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 758
          },
          "end": {
            "line": 1,
            "column": 771
          }
        }
      }) : helper)) + "\" class=\"button link-button copy-org-clipboard-button\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.org.copyLink"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 826
          },
          "end": {
            "line": 1,
            "column": 880
          }
        }
      })) + "</a></li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.step6"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 893
          },
          "end": {
            "line": 1,
            "column": 940
          }
        }
      })) + "</li></ol>";
    },
    "useData": true
  }),
  postRender: function () {
    // Attach each button to the respective 'data-clipboard-text'
    Clipboard.attach('.copy-clipboard-button').done(() => {
      let notification = new Notification({
        message: (0, _courage.loc)('enroll.mdm.copyLink.success', 'login'),
        level: 'success'
      });
      this.el.prepend(notification.render().el);
      return false;
    });
    Clipboard.attach('.copy-org-clipboard-button').done(() => {
      let notification = new Notification({
        message: (0, _courage.loc)('enroll.oda.org.copyLink.success', 'login'),
        level: 'success'
      });
      this.el.prepend(notification.render().el);
      return false;
    });
  }
});
exports.IosAndAndroidLoopbackOdaTerminalView = IosAndAndroidLoopbackOdaTerminalView;
const AndroidAppLinkWithAccountOdaTerminalView = BaseOdaOktaVerifyTerminalView.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p class=\"explanation\" data-se=\"subheader\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.with.account.explanation"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 43
          },
          "end": {
            "line": 1,
            "column": 109
          }
        }
      })) + "</p><p class=\"subtitle\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.with.account.subtitile1 "
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 133
          },
          "end": {
            "line": 1,
            "column": 199
          }
        }
      })) + "</p><ul><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.with.account.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 211
          },
          "end": {
            "line": 1,
            "column": 271
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.with.account.step2"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 280
          },
          "end": {
            "line": 1,
            "column": 340
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.with.account.step3"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 349
          },
          "end": {
            "line": 1,
            "column": 409
          }
        }
      })) + "</li></ul><p class=\"subtitle\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.with.account.subtitile2 "
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 439
          },
          "end": {
            "line": 1,
            "column": 505
          }
        }
      })) + "</p><ol><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.with.account.step4"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 517
          },
          "end": {
            "line": 1,
            "column": 577
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "arguments": "signInUrl",
          "bundle": "login",
          "code": "enroll.oda.with.account.step5"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 586
          },
          "end": {
            "line": 1,
            "column": 668
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.with.account.step6"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 677
          },
          "end": {
            "line": 1,
            "column": 737
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.with.account.step7"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 746
          },
          "end": {
            "line": 1,
            "column": 806
          }
        }
      })) + "</li></ol>";
    },
    "useData": true
  })
});
exports.AndroidAppLinkWithAccountOdaTerminalView = AndroidAppLinkWithAccountOdaTerminalView;
const AndroidAppLinkWithoutAccountOdaTerminalView = BaseOdaOktaVerifyTerminalView.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        alias4 = "function",
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p class=\"explanation\" data-se=\"subheader\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.without.account.explanation"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 43
          },
          "end": {
            "line": 1,
            "column": 112
          }
        }
      })) + "</p><ol><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "arguments": "appStoreLink",
          "bundle": "login",
          "code": "enroll.oda.without.account.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 124
          },
          "end": {
            "line": 1,
            "column": 214
          }
        }
      })) != null ? stack1 : "") + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 223
          },
          "end": {
            "line": 1,
            "column": 270
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.step2"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 279
          },
          "end": {
            "line": 1,
            "column": 326
          }
        }
      })) + "<p class=\"org-signin-link\"><span class=\"no-translate\">" + alias3((helper = (helper = lookupProperty(helpers, "signInUrl") || (depth0 != null ? lookupProperty(depth0, "signInUrl") : depth0)) != null ? helper : alias2, typeof helper === alias4 ? helper.call(alias1, {
        "name": "signInUrl",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 380
          },
          "end": {
            "line": 1,
            "column": 393
          }
        }
      }) : helper)) + "</span></p><a data-clipboard-text=\"" + alias3((helper = (helper = lookupProperty(helpers, "signInUrl") || (depth0 != null ? lookupProperty(depth0, "signInUrl") : depth0)) != null ? helper : alias2, typeof helper === alias4 ? helper.call(alias1, {
        "name": "signInUrl",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 428
          },
          "end": {
            "line": 1,
            "column": 441
          }
        }
      }) : helper)) + "\" class=\"button link-button copy-org-clipboard-button\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.org.copyLink"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 496
          },
          "end": {
            "line": 1,
            "column": 550
          }
        }
      })) + "</a></li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.without.account.step4"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 563
          },
          "end": {
            "line": 1,
            "column": 626
          }
        }
      })) + "</li></ol>";
    },
    "useData": true
  }),
  postRender: function () {
    // Attach each button to the respective 'data-clipboard-text'
    Clipboard.attach('.copy-org-clipboard-button').done(() => {
      let notification = new Notification({
        message: (0, _courage.loc)('enroll.oda.org.copyLink.success', 'login'),
        level: 'success'
      });
      this.el.prepend(notification.render().el);
      return false;
    });
  }
});
exports.AndroidAppLinkWithoutAccountOdaTerminalView = AndroidAppLinkWithoutAccountOdaTerminalView;

/***/ }),

/***/ "./src/v2/view-builder/components/OktaVerifyAuthenticatorHeader.js":
/*!*************************************************************************!*\
  !*** ./src/v2/view-builder/components/OktaVerifyAuthenticatorHeader.js ***!
  \*************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _internals = __webpack_require__(/*! ../internals */ "./src/v2/view-builder/internals/index.js");
var _RemediationConstants = __webpack_require__(/*! ../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _BaseAuthenticatorView = __webpack_require__(/*! ./BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js");
var _default = _internals.BaseHeader.extend({
  HeaderBeacon: _BaseAuthenticatorView.BaseAuthenticatorBeacon.extend({
    authenticatorKey: _RemediationConstants.AUTHENTICATOR_KEY.OV
  })
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/components/ScopeCheckBox.js":
/*!*********************************************************!*\
  !*** ./src/v2/view-builder/components/ScopeCheckBox.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _i18nTransformer = __webpack_require__(/*! v2/ion/i18nTransformer */ "./src/v2/ion/i18nTransformer.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CheckBox = _courage.internal.views.forms.inputs.CheckBox;
var _default = CheckBox.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<input type=\"checkbox\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 29
          },
          "end": {
            "line": 1,
            "column": 37
          }
        }
      }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "inputId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 43
          },
          "end": {
            "line": 1,
            "column": 54
          }
        }
      }) : helper)) + "\"/><label for=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "inputId",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 69
          },
          "end": {
            "line": 1,
            "column": 80
          }
        }
      }) : helper)) + "\" data-se-for-name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "name",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 100
          },
          "end": {
            "line": 1,
            "column": 108
          }
        }
      }) : helper)) + "\"><b>" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "placeholder",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 113
          },
          "end": {
            "line": 1,
            "column": 128
          }
        }
      }) : helper)) + "</b><p>" + alias4((helper = (helper = lookupProperty(helpers, "desc") || (depth0 != null ? lookupProperty(depth0, "desc") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "desc",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 135
          },
          "end": {
            "line": 1,
            "column": 143
          }
        }
      }) : helper)) + "</p></label>";
    },
    "useData": true
  }),
  getLocalizedLabel: function () {
    const key = `consent.scopes.${this.options.options.scopeName}.label`;
    return (0, _i18nTransformer.doesI18NKeyExist)(key) ? (0, _courage.loc)(key, 'login') : this.options.placeholder || this.options.options.scopeName;
  },
  getLocalizedDesc: function () {
    const key = `consent.scopes.${this.options.options.scopeName}.desc`;
    return (0, _i18nTransformer.doesI18NKeyExist)(key) ? (0, _courage.loc)(key, 'login') : this.options.options.desc;
  },
  isCustomizedScope: function () {
    return !(0, _i18nTransformer.doesI18NKeyExist)(`consent.scopes.${this.options.options.scopeName}.label`);
  },
  /**
   * @Override
   */
  enable: function () {
    if (this.options.options.mutable) {
      this.$(':input').prop('disabled', false);
    }
  },
  /**
   * @Override
   */
  editMode: function () {
    this.$el.html(this.template(_courage._.extend(_courage._.omit(this.options, 'placeholder'), {
      placeholder: this.getLocalizedLabel(),
      desc: this.getLocalizedDesc()
    })));
    this.$(':checkbox').prop('checked', this.getModelValue() || false);
    this.$('input').customInput();
    this.model.trigger('form:resize');
    if (!this.options.options.mutable) {
      const input = this.$('input').get(0);
      this.$(input.parentElement).addClass('o-form-read-mode');
      this.$(':checkbox').prop('disabled', true);
    }
    if (this.options.options.scopeName === 'openid' || this.isCustomizedScope()) {
      this.$('label > b').addClass('no-translate');
      if (this.isCustomizedScope()) {
        this.$('label > p').addClass('no-translate');
      }
    }
    return this;
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/components/SkipOptionalEnrollmentButton.js":
/*!************************************************************************!*\
  !*** ./src/v2/view-builder/components/SkipOptionalEnrollmentButton.js ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _RemediationConstants = __webpack_require__(/*! ../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
const skipAll = (0, _courage.createButton)({
  className: 'button-primary button skip-all',
  title: function () {
    return (0, _courage.loc)('oie.optional.authenticator.button.title', 'login');
  },
  click: function () {
    this.options.appState.trigger('invokeAction', _RemediationConstants.FORMS.SKIP);
  }
});
var _default = skipAll;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/components/ToggleTextLink.js":
/*!**********************************************************!*\
  !*** ./src/v2/view-builder/components/ToggleTextLink.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Link = _interopRequireDefault(__webpack_require__(/*! ./Link */ "./src/v2/view-builder/components/Link.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.View.extend({
  initialize() {
    _courage.View.prototype.initialize.apply(this, arguments);
    const textViewOptions = this.options.additionalOptions;
    const linkName = this.options.name;
    const linkOptions = Object.assign({}, this.options, {
      'type': 'link',
      'aria-expanded': false,
      'clickHandler': function () {
        (0, _courage.$)(textViewOptions.selector).slideToggle(200, () => {
          (0, _courage.$)(`.js-${linkName}`).attr('aria-expanded', (0, _courage.$)(textViewOptions.selector).is(':visible'));
        });
      }
    });
    this.add(_Link.default, {
      options: linkOptions
    });
    this.add(textViewOptions.view);
  },
  postRender() {
    const textViewOptions = this.options.additionalOptions;
    this.$(textViewOptions.selector).hide();
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/internals/BaseFooter.js":
/*!*****************************************************!*\
  !*** ./src/v2/view-builder/internals/BaseFooter.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Link = _interopRequireDefault(__webpack_require__(/*! ../components/Link */ "./src/v2/view-builder/components/Link.js"));
var _ToggleTextLink = _interopRequireDefault(__webpack_require__(/*! ../components/ToggleTextLink */ "./src/v2/view-builder/components/ToggleTextLink.js"));
var _LinksUtil = __webpack_require__(/*! ../utils/LinksUtil */ "./src/v2/view-builder/utils/LinksUtil.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * When `href` is present, the Link behaviors as normal link (anchor element).
 * When `actionPath` is present, the Link behaviors as link button
 *   on which user clicks, will trigger the action `actionPath`.
 * When `formName` is present, the link behaviors as link button
 *   on which user clicks, will submit a remediation form.
 *
 * @typedef {Object} Link
 * @property {string} label
 * @property {string} name
 * @property {string=} href
 * @property {string=} actionPath
 * @property {string=} formName
 */
var _default = _courage.View.extend({
  className: 'auth-footer',
  /**
   * {Link[]} links
   */
  links: [],
  /**
   * View
   * adds any view to the footer in footer info section
   */
  footerInfo: null,
  /**
   * Boolean
   * If false then 'Back to sign in' does not get added to the view
   */
  hasBackToSignInLink: true,
  initialize() {
    let links = _courage._.resultCtx(this, 'links', this);
    const footerInfo = _courage._.resultCtx(this, 'footerInfo', this);
    const hasBackToSignInLink = _courage._.resultCtx(this, 'hasBackToSignInLink', this);

    // safe check
    // 1. avoid none array from override
    // 2. ignore any none plain object arguments
    if (!Array.isArray(links)) {
      links = [];
    } else {
      links = links.filter(l => _courage.$.isPlainObject(l));
    }

    // add 'back to sign in' link if the form qualifies for it by default.
    // Previously called cancel/Sign Out links
    if (this.options.appState.shouldShowSignOutLinkInCurrentForm(this.options.settings.get('features.hideSignOutLinkInMFA') || this.settings.get('features.mfaOnlyFlow')) && hasBackToSignInLink) {
      links = links.concat((0, _LinksUtil.getSignOutLink)(this.options.settings));
    }
    links.forEach(link => {
      let LinkView = _Link.default;
      if (link.type === 'toggle-text-link') {
        LinkView = _ToggleTextLink.default;
      }
      this.add(LinkView, {
        options: link
      });
    });
    if (footerInfo) {
      this.add(_courage.View.extend({
        className: 'footer-info'
      }));
      this.add(footerInfo, '.footer-info');
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/internals/BaseFormWithPolling.js":
/*!**************************************************************!*\
  !*** ./src/v2/view-builder/internals/BaseFormWithPolling.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _polling = _interopRequireDefault(__webpack_require__(/*! ../views/shared/polling */ "./src/v2/view-builder/views/shared/polling.js"));
var _BaseForm = _interopRequireDefault(__webpack_require__(/*! ./BaseForm */ "./src/v2/view-builder/internals/BaseForm.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _BaseForm.default.extend(Object.assign({
  initialize() {
    _BaseForm.default.prototype.initialize.apply(this, arguments);
    this.listenTo(this.options.appState, 'change:dynamicRefreshInterval', this.updateRefreshInterval);
  },
  updateRefreshInterval() {
    if (this.polling) {
      this.stopPolling();
      this.startPolling(this.options.appState.get('dynamicRefreshInterval'));
    }
  }
}, _polling.default));
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/internals/BaseHeader.js":
/*!*****************************************************!*\
  !*** ./src/v2/view-builder/internals/BaseHeader.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Animations = _interopRequireDefault(__webpack_require__(/*! util/Animations */ "./src/util/Animations.js"));
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _courage.View.extend({
  HeaderBeacon: null,
  initialize() {
    if (this.HeaderBeacon) {
      this.add(this.HeaderBeacon);
    }
  },
  postRender() {
    const mainContentContainer = (0, _courage.$)(`#${_Enums.default.WIDGET_CONTAINER_ID}`);
    if (this.HeaderBeacon) {
      mainContentContainer.removeClass('no-beacon');

      // animate beacon
      const beaconContainer = this.$el.find('[data-type="beacon-container"]');
      _Animations.default.explode(beaconContainer);
    } else {
      mainContentContainer.addClass('no-beacon');
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/internals/BaseModel.js":
/*!****************************************************!*\
  !*** ./src/v2/view-builder/internals/BaseModel.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const convertUiSchemaFieldToProp = uiSchemaField => {
  const config = Object.assign({}, _courage._.chain(uiSchemaField).pick('minLength', 'maxLength', 'required', 'value').defaults({
    type: 'string',
    required: true
  }).value());
  if (uiSchemaField.modelType) {
    config.type = uiSchemaField.modelType;
  }
  return {
    [uiSchemaField.name]: config
  };
};
const createPropsAndLocals = function (remediation = {}, optionUiSchemaConfig = {}, props = {}, local = {}) {
  const uiSchemas = remediation.uiSchema || [];
  uiSchemas.forEach(schema => {
    if (Array.isArray(schema.optionsUiSchemas)) {
      let optionUiSchemaIndex;
      let optionUiSchemaValue = {};
      if (Number(schema.value) >= 0) {
        optionUiSchemaIndex = schema.value;
      }
      if (optionUiSchemaConfig[schema.name]) {
        optionUiSchemaValue = {
          value: optionUiSchemaConfig[schema.name]
        };
        optionUiSchemaIndex = Number(optionUiSchemaValue.value);
      }
      Object.assign(local, convertUiSchemaFieldToProp(Object.assign({}, schema, optionUiSchemaValue)));
      if (optionUiSchemaIndex) {
        createPropsAndLocals({
          uiSchema: schema.optionsUiSchemas[optionUiSchemaIndex]
        }, optionUiSchemaConfig, props, local);
      }
    } else {
      Object.assign(props, convertUiSchemaFieldToProp(schema));
    }
  });
};
const create = function (remediation = {}, optionUiSchemaConfig = {}) {
  const props = {};
  const local = {
    // current remediation form name
    formName: 'string',
    // use full page redirect instead of AJAX
    useRedirect: 'boolean'
  };
  createPropsAndLocals(remediation, optionUiSchemaConfig, props, local);
  const BaseModel = _courage.Model.extend({
    props,
    local
  });
  return BaseModel;
};
var _default = {
  create
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/internals/BaseOktaVerifyChallengeView.js":
/*!**********************************************************************!*\
  !*** ./src/v2/view-builder/internals/BaseOktaVerifyChallengeView.js ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../internals */ "./src/v2/view-builder/internals/index.js");
var _Logger = _interopRequireDefault(__webpack_require__(/*! util/Logger */ "./src/util/Logger.js"));
var _Constants = __webpack_require__(/*! ../utils/Constants */ "./src/v2/view-builder/utils/Constants.js");
var _BrowserFeatures = _interopRequireDefault(__webpack_require__(/*! util/BrowserFeatures */ "./src/util/BrowserFeatures.ts"));
var _ChallengeViewUtil = __webpack_require__(/*! ../utils/ChallengeViewUtil */ "./src/v2/view-builder/utils/ChallengeViewUtil.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint max-statements: [2, 22] */

const request = opts => {
  const ajaxOptions = Object.assign({
    method: 'GET',
    contentType: 'application/json'
  }, opts);
  return _courage.$.ajax(ajaxOptions);
};
const Body = _internals.BaseFormWithPolling.extend({
  noButtonBar: true,
  className: 'ion-form device-challenge-poll',
  events: {
    'click #launch-ov': function (e) {
      e.preventDefault();
      this.doCustomURI();
    }
  },
  pollingCancelAction: _Constants.AUTHENTICATOR_CANCEL_ACTION,
  initialize() {
    _internals.BaseFormWithPolling.prototype.initialize.apply(this, arguments);
    this.listenTo(this.model, 'error', this.onPollingFail);
    this.doChallenge();
    this.startPolling();
  },
  doChallenge() {
    (0, _ChallengeViewUtil.doChallenge)(this);
  },
  onPollingFail() {
    this.$('.spinner').hide();
    this.stopPolling();
  },
  remove() {
    _internals.BaseFormWithPolling.prototype.remove.apply(this, arguments);
    this.stopProbing();
    this.stopPolling();
  },
  getDeviceChallengePayload() {
    throw new Error('getDeviceChallengePayload needs to be implemented');
  },
  doLoopback(deviceChallenge) {
    let authenticatorDomainUrl = deviceChallenge.domain !== undefined ? deviceChallenge.domain : '';
    let authenticatorHttpsDomainUrl = deviceChallenge.httpsDomain !== undefined ? deviceChallenge.httpsDomain : '';
    let ports = deviceChallenge.ports !== undefined ? deviceChallenge.ports : [];
    let maxNumberOfPorts = ports.length;
    let challengeRequest = deviceChallenge.challengeRequest !== undefined ? deviceChallenge.challengeRequest : '';
    let probeTimeoutMillis = deviceChallenge.probeTimeoutMillis !== undefined ? deviceChallenge.probeTimeoutMillis : 100;
    let currentPort;
    let foundPort = false;
    let ovFailed = false;
    let countFailedPorts = 0;
    const getAuthenticatorUrl = (path, domainUrl) => {
      return `${domainUrl}:${currentPort}/${path}`;
    };
    const checkPort = url => {
      return request({
        url: url,
        /*
        OKTA-278573 in loopback server, SSL handshake sometimes takes more than 100ms and thus needs additional
        timeout however, increasing timeout is a temporary solution since user will need to wait much longer in
        worst case.
        TODO: Android timeout is temporarily set to 3000ms and needs optimization post-Beta.
        OKTA-365427 introduces probeTimeoutMillis; but we should also consider probeTimeoutMillisHTTPS for
        customizing timeouts in the more costly Android and other (keyless) HTTPS scenarios.
        */
        timeout: _BrowserFeatures.default.isAndroid() ? 3000 : probeTimeoutMillis
      });
    };
    const onPortFound = url => {
      return request({
        url: url,
        method: 'POST',
        data: JSON.stringify({
          challengeRequest
        }),
        timeout: _Constants.CHALLENGE_TIMEOUT // authenticator should respond within 5 min (300000ms) for challenge request
      });
    };

    const onFailure = () => {
      _Logger.default.error(`Something unexpected happened while we were checking port ${currentPort}.`);
    };
    const doProbing = domainUrl => {
      return checkPort(getAuthenticatorUrl('probe', domainUrl)).done(() => {
        return onPortFound(getAuthenticatorUrl('challenge', domainUrl)).done(() => {
          foundPort = true;
          if (deviceChallenge.enhancedPollingEnabled !== false) {
            // this way we can gurantee that
            // 1. the polling is triggered right away (1ms interval)
            // 2. Only one polling queue
            // 3. follwoing polling will continue with refresh interval from previous polling response
            // NOTE: technically, there could still be concurrency issue where when we called stopPolling,
            // there is already a polling triggered and hasn't completed yet
            // but the possibility would be much smaller than previous concurrency issue
            // this is a best effort change
            this.stopPolling();
            this.startPolling(1);
            return;
          }
          // once the OV challenge succeeds,
          // triggers another polling right away without waiting for the next ongoing polling to be triggered
          // to make the authentication flow goes faster 
          return this.trigger('save', this.model);
        }).fail(xhr => {
          countFailedPorts++;
          // Windows and MacOS return status code 503 when 
          // there are multiple profiles on the device and
          // the wrong OS profile responds to the challenge request
          if (xhr.status !== 503) {
            // when challenge responds with other errors,
            // - stop the remaining probing
            ovFailed = true;
            // - cancel polling right away
            (0, _ChallengeViewUtil.cancelPollingWithParams)(this.options.appState, this.pollingCancelAction, _Constants.AUTHENTICATION_CANCEL_REASONS.OV_ERROR, xhr.status);
          } else if (countFailedPorts === maxNumberOfPorts) {
            // when challenge is responded by the wrong OS profile and
            // all the ports are exhausted,
            // cancel the polling like the probing has failed
            (0, _ChallengeViewUtil.cancelPollingWithParams)(this.options.appState, this.pollingCancelAction, _Constants.AUTHENTICATION_CANCEL_REASONS.LOOPBACK_FAILURE, null);
          }
        });
      }).fail(onFailure);
    };
    let probeChain = Promise.resolve();
    const handlePortProbing = (port, baseUrl, checkPortMaxFailure) => {
      probeChain = probeChain.then(() => {
        if (!(foundPort || ovFailed)) {
          currentPort = port;
          return doProbing(baseUrl);
        }
      }).catch(() => {
        countFailedPorts++;
        _Logger.default.error(`Authenticator is not listening on port ${currentPort}.`);
        if (checkPortMaxFailure && countFailedPorts === maxNumberOfPorts) {
          _Logger.default.error('No available ports. Loopback server failed and polling is cancelled.');
          // When no port is found, cancel the polling as well
          // This is to avoid concurrency issue where /poll/cancel takes long time to complete
          // and SIW will receive 400 error if the polling continues
          this.stopPolling();
          (0, _ChallengeViewUtil.cancelPollingWithParams)(this.options.appState, this.pollingCancelAction, _Constants.AUTHENTICATION_CANCEL_REASONS.LOOPBACK_FAILURE, null);
        }
      });
    };

    // If https domain exists, do https domain probe first
    // This only applies to MacOS for now
    if (authenticatorHttpsDomainUrl) {
      // if https domain are included, max number of ports to be probed should be doubled
      _Logger.default.info('httpsDomain enabled, will probe and challenge https first');
      maxNumberOfPorts += maxNumberOfPorts;
      ports.forEach(port => {
        handlePortProbing(port, authenticatorHttpsDomainUrl, false);
      });
    }

    // Always do probe on regular domain
    ports.forEach(port => {
      handlePortProbing(port, authenticatorDomainUrl, true);
    });
  },
  doCustomURI() {
    this.ulDom && this.ulDom.remove();
    const IframeView = createInvisibleIFrame('custom-uri-container', this.customURI);
    this.ulDom = this.add(IframeView).last();
  },
  doChromeDTC(deviceChallenge) {
    this.ulDom && this.ulDom.remove();
    const IframeView = createInvisibleIFrame('chrome-dtc-container', deviceChallenge.href);
    this.ulDom = this.add(IframeView).last();
  },
  stopProbing() {
    this.checkPortXhr && this.checkPortXhr.abort();
    this.probingXhr && this.probingXhr.abort();
  }
});
function createInvisibleIFrame(iFrameId, iFrameSrc) {
  const iFrameView = _courage.View.extend({
    tagName: 'iframe',
    id: iFrameId,
    attributes: {
      src: iFrameSrc
    },
    initialize() {
      this.el.style.display = 'none';
    }
  });
  return iFrameView;
}
var _default = Body;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/internals/BaseView.js":
/*!***************************************************!*\
  !*** ./src/v2/view-builder/internals/BaseView.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _BaseHeader = _interopRequireDefault(__webpack_require__(/*! ./BaseHeader */ "./src/v2/view-builder/internals/BaseHeader.js"));
var _BaseForm = _interopRequireDefault(__webpack_require__(/*! ./BaseForm */ "./src/v2/view-builder/internals/BaseForm.ts"));
var _BaseModel = _interopRequireDefault(__webpack_require__(/*! ./BaseModel */ "./src/v2/view-builder/internals/BaseModel.js"));
var _BaseFooter = _interopRequireDefault(__webpack_require__(/*! ./BaseFooter */ "./src/v2/view-builder/internals/BaseFooter.js"));
var _ViewClassNamesFactory = __webpack_require__(/*! ../../ion/ViewClassNamesFactory */ "./src/v2/ion/ViewClassNamesFactory.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _courage.View.extend({
  Header: _BaseHeader.default,
  Body: _BaseForm.default,
  Footer: _BaseFooter.default,
  className() {
    const appState = this.options.appState;
    const formName = appState.get('currentFormName');
    const authenticatorKey = appState.get('authenticatorKey');
    const methodType = appState.get('authenticatorMethodType');
    const isPasswordRecoveryFlow = appState.get('isPasswordRecoveryFlow');
    const additionalClassNames = (0, _ViewClassNamesFactory.getClassNameMapping)(formName, authenticatorKey, methodType, isPasswordRecoveryFlow);
    const classNames = ['siw-main-view'].concat(additionalClassNames);
    return classNames.join(' ');
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      return "<div class=\"siw-main-header\"></div><div class=\"siw-main-body\"></div><div class=\"siw-main-footer\"></div>";
    },
    "useData": true
  }),
  preRender() {
    _courage.View.prototype.preRender.apply(this, arguments);
    // Add Views
    if (this.Header !== null) {
      this.add(this.Header, {
        selector: '.siw-main-header',
        options: this.options
      });
    }
    this.renderForm();
    this.add(this.Footer, {
      selector: '.siw-main-footer',
      options: this.options
    });
  },
  renderForm() {
    let optionUiSchemaConfig;
    if (this.form) {
      this.form.remove();
      optionUiSchemaConfig = this.form.model.toJSON({
        verbose: true
      });
    }

    // Create Model
    const IonModel = this.createModelClass(this.options.currentViewState, optionUiSchemaConfig, this.settings);
    const model = new IonModel({
      formName: this.options.currentViewState.name
    });
    if (!optionUiSchemaConfig) {
      optionUiSchemaConfig = model.toJSON({
        verbose: true
      });
    }
    this.model = model;
    this.form = this.add(this.Body, {
      selector: '.siw-main-body',
      options: Object.assign({}, this.options, {
        model,
        optionUiSchemaConfig
      })
    }).last();
    _courage._.each(model.attributes, (value, key) => {
      if (key.match(/sub_schema_local_[^ ]+/)) {
        // in order to render different sub-schema
        this.listenTo(model, `change:${key}`, () => {
          this.renderForm();
        });
      }
    });
  },
  createModelClass(currentViewState, optionUiSchemaConfig = {}) {
    return _BaseModel.default.create(currentViewState, optionUiSchemaConfig);
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/internals/index.js":
/*!************************************************!*\
  !*** ./src/v2/view-builder/internals/index.js ***!
  \************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "BaseFooter", ({
  enumerable: true,
  get: function () {
    return _BaseFooter.default;
  }
}));
Object.defineProperty(exports, "BaseForm", ({
  enumerable: true,
  get: function () {
    return _BaseForm.default;
  }
}));
Object.defineProperty(exports, "BaseFormWithPolling", ({
  enumerable: true,
  get: function () {
    return _BaseFormWithPolling.default;
  }
}));
Object.defineProperty(exports, "BaseHeader", ({
  enumerable: true,
  get: function () {
    return _BaseHeader.default;
  }
}));
Object.defineProperty(exports, "BaseModel", ({
  enumerable: true,
  get: function () {
    return _BaseModel.default;
  }
}));
Object.defineProperty(exports, "BaseOktaVerifyChallengeView", ({
  enumerable: true,
  get: function () {
    return _BaseOktaVerifyChallengeView.default;
  }
}));
Object.defineProperty(exports, "BaseView", ({
  enumerable: true,
  get: function () {
    return _BaseView.default;
  }
}));
Object.defineProperty(exports, "addCustomButton", ({
  enumerable: true,
  get: function () {
    return _FormInputFactory.addCustomButton;
  }
}));
Object.defineProperty(exports, "createCustomButtons", ({
  enumerable: true,
  get: function () {
    return _FormInputFactory.createCustomButtons;
  }
}));
Object.defineProperty(exports, "createIdpButtons", ({
  enumerable: true,
  get: function () {
    return _FormInputFactory.createIdpButtons;
  }
}));
var _BaseHeader = _interopRequireDefault(__webpack_require__(/*! ./BaseHeader */ "./src/v2/view-builder/internals/BaseHeader.js"));
var _BaseFooter = _interopRequireDefault(__webpack_require__(/*! ./BaseFooter */ "./src/v2/view-builder/internals/BaseFooter.js"));
var _BaseForm = _interopRequireDefault(__webpack_require__(/*! ./BaseForm */ "./src/v2/view-builder/internals/BaseForm.ts"));
var _BaseFormWithPolling = _interopRequireDefault(__webpack_require__(/*! ./BaseFormWithPolling */ "./src/v2/view-builder/internals/BaseFormWithPolling.js"));
var _BaseOktaVerifyChallengeView = _interopRequireDefault(__webpack_require__(/*! ./BaseOktaVerifyChallengeView */ "./src/v2/view-builder/internals/BaseOktaVerifyChallengeView.js"));
var _BaseModel = _interopRequireDefault(__webpack_require__(/*! ./BaseModel */ "./src/v2/view-builder/internals/BaseModel.js"));
var _BaseView = _interopRequireDefault(__webpack_require__(/*! ./BaseView */ "./src/v2/view-builder/internals/BaseView.js"));
var _FormInputFactory = __webpack_require__(/*! ./FormInputFactory */ "./src/v2/view-builder/internals/FormInputFactory.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./src/v2/view-builder/utils/AuthenticatorUtil.js":
/*!********************************************************!*\
  !*** ./src/v2/view-builder/utils/AuthenticatorUtil.js ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getAuthenticatorDataForEnroll = getAuthenticatorDataForEnroll;
exports.getAuthenticatorDataForVerification = getAuthenticatorDataForVerification;
exports.getAuthenticatorDisplayName = getAuthenticatorDisplayName;
exports.getIconClassNameForBeacon = getIconClassNameForBeacon;
exports.getOktaVerifyAriaLabel = getOktaVerifyAriaLabel;
exports.getPasswordComplexityDescriptionForHtmlList = void 0;
exports.getVerifyEmailAriaLabel = getVerifyEmailAriaLabel;
exports.getVerifyPhoneAriaLabel = getVerifyPhoneAriaLabel;
exports.removeRequirementsFromError = removeRequirementsFromError;
var _underscore = _interopRequireDefault(__webpack_require__(/*! underscore */ "./node_modules/underscore/underscore-umd.js"));
var _loc = __webpack_require__(/*! ../../../util/loc */ "./src/util/loc.ts");
var _FactorUtil = _interopRequireDefault(__webpack_require__(/*! util/FactorUtil */ "./src/util/FactorUtil.js"));
var _RemediationConstants = __webpack_require__(/*! ../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const {
  getPasswordComplexityDescriptionForHtmlList
} = _FactorUtil.default;
exports.getPasswordComplexityDescriptionForHtmlList = getPasswordComplexityDescriptionForHtmlList;
const getButtonDataSeAttr = function (authenticator) {
  if (authenticator.authenticatorKey) {
    var _authenticator$value, _authenticator$value2;
    const method = (_authenticator$value = authenticator.value) !== null && _authenticator$value !== void 0 && _authenticator$value.methodType ? '-' + ((_authenticator$value2 = authenticator.value) === null || _authenticator$value2 === void 0 ? void 0 : _authenticator$value2.methodType) : '';
    return authenticator.authenticatorKey + method;
  }
  return '';
};

/* eslint complexity: [0, 0], max-statements: [2, 25] */
const getAuthenticatorData = function (authenticator, isVerifyAuthenticator) {
  var _authenticator$relate, _authenticator$relate2, _authenticator$relate3, _authenticator$relate4, _authenticator$relate5, _authenticator$relate6, _authenticator$relate7, _authenticator$relate8, _authenticator$relate9, _authenticator$value3;
  const authenticatorKey = authenticator.authenticatorKey;
  const key = _underscore.default.isString(authenticatorKey) ? authenticatorKey.toLowerCase() : '';
  let authenticatorData = {};
  let nicknameText = isVerifyAuthenticator ? (_authenticator$relate = authenticator.relatesTo) === null || _authenticator$relate === void 0 ? void 0 : _authenticator$relate.nickname : undefined;
  switch (key) {
    case _RemediationConstants.AUTHENTICATOR_KEY.EMAIL:
      Object.assign(authenticatorData, {
        description: isVerifyAuthenticator ? ((_authenticator$relate2 = authenticator.relatesTo) === null || _authenticator$relate2 === void 0 ? void 0 : (_authenticator$relate3 = _authenticator$relate2.profile) === null || _authenticator$relate3 === void 0 ? void 0 : _authenticator$relate3.email) || '' : (0, _loc.loc)('oie.email.authenticator.description', 'login'),
        iconClassName: 'mfa-okta-email',
        noTranslateClassName: isVerifyAuthenticator ? 'no-translate' : '',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator),
        ariaLabel: isVerifyAuthenticator ? getVerifyEmailAriaLabel((_authenticator$relate4 = authenticator.relatesTo) === null || _authenticator$relate4 === void 0 ? void 0 : (_authenticator$relate5 = _authenticator$relate4.profile) === null || _authenticator$relate5 === void 0 ? void 0 : _authenticator$relate5.email) : (0, _loc.loc)('oie.select.authenticator.enroll.email.label', 'login')
      });
      break;
    case _RemediationConstants.AUTHENTICATOR_KEY.PASSWORD:
      Object.assign(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _loc.loc)('oie.password.authenticator.description', 'login'),
        iconClassName: 'mfa-okta-password',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator),
        ariaLabel: isVerifyAuthenticator ? (0, _loc.loc)('oie.select.authenticator.verify.password.label', 'login') : (0, _loc.loc)('oie.select.authenticator.enroll.password.label', 'login')
      });
      break;
    case _RemediationConstants.AUTHENTICATOR_KEY.PHONE:
      Object.assign(authenticatorData, {
        nickname: nicknameText,
        description: isVerifyAuthenticator ? (_authenticator$relate6 = authenticator.relatesTo) === null || _authenticator$relate6 === void 0 ? void 0 : (_authenticator$relate7 = _authenticator$relate6.profile) === null || _authenticator$relate7 === void 0 ? void 0 : _authenticator$relate7.phoneNumber : (0, _loc.loc)('oie.phone.authenticator.description', 'login'),
        iconClassName: 'mfa-okta-phone',
        noTranslateClassName: isVerifyAuthenticator ? 'no-translate' : '',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator),
        ariaLabel: isVerifyAuthenticator ? getVerifyPhoneAriaLabel((_authenticator$relate8 = authenticator.relatesTo) === null || _authenticator$relate8 === void 0 ? void 0 : (_authenticator$relate9 = _authenticator$relate8.profile) === null || _authenticator$relate9 === void 0 ? void 0 : _authenticator$relate9.phoneNumber) : (0, _loc.loc)('oie.select.authenticator.enroll.phone.label', 'login')
      });
      break;
    case _RemediationConstants.AUTHENTICATOR_KEY.SECURITY_QUESTION:
      Object.assign(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _loc.loc)('oie.security.question.authenticator.description', 'login'),
        iconClassName: 'mfa-okta-security-question',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator),
        ariaLabel: isVerifyAuthenticator ? (0, _loc.loc)('oie.select.authenticator.verify.security.question.label', 'login') : (0, _loc.loc)('oie.select.authenticator.enroll.security.question.label', 'login')
      });
      break;
    case _RemediationConstants.AUTHENTICATOR_KEY.WEBAUTHN:
      Object.assign(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _loc.loc)('oie.webauthn.description', 'login'),
        iconClassName: 'mfa-webauthn',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator),
        ariaLabel: isVerifyAuthenticator ? (0, _loc.loc)('oie.select.authenticator.verify.webauthn.label', 'login') : (0, _loc.loc)('oie.select.authenticator.enroll.webauthn.label', 'login')
      });
      break;
    case _RemediationConstants.AUTHENTICATOR_KEY.OV:
      Object.assign(authenticatorData, {
        description: isVerifyAuthenticator ? (0, _loc.loc)('oie.okta_verify.label', 'login') : (0, _loc.loc)('oie.okta_verify.authenticator.description', 'login'),
        iconClassName: 'mfa-okta-verify',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator),
        ariaLabel: getOktaVerifyAriaLabel(isVerifyAuthenticator, authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$value3 = authenticator.value) === null || _authenticator$value3 === void 0 ? void 0 : _authenticator$value3.methodType)
      });
      break;
    case _RemediationConstants.AUTHENTICATOR_KEY.GOOGLE_OTP:
      Object.assign(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _loc.loc)('oie.google_authenticator.authenticator.description', 'login'),
        iconClassName: 'mfa-google-auth',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator),
        ariaLabel: isVerifyAuthenticator ? (0, _loc.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [authenticator.label]) : (0, _loc.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [authenticator.label])
      });
      break;
    case _RemediationConstants.AUTHENTICATOR_KEY.ON_PREM:
      {
        var _authenticator$relate10;
        const vendorName = ((_authenticator$relate10 = authenticator.relatesTo) === null || _authenticator$relate10 === void 0 ? void 0 : _authenticator$relate10.displayName) || (0, _loc.loc)('oie.on_prem.authenticator.default.vendorName', 'login');
        Object.assign(authenticatorData, {
          description: isVerifyAuthenticator ? '' : (0, _loc.loc)('oie.on_prem.authenticator.description', 'login', [vendorName]),
          iconClassName: 'mfa-onprem',
          buttonDataSeAttr: getButtonDataSeAttr(authenticator),
          ariaLabel: isVerifyAuthenticator ? (0, _loc.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [authenticator.label]) : (0, _loc.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [authenticator.label])
        });
        break;
      }
    case _RemediationConstants.AUTHENTICATOR_KEY.RSA:
      Object.assign(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _loc.loc)('oie.rsa.authenticator.description', 'login'),
        iconClassName: 'mfa-rsa',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator),
        ariaLabel: isVerifyAuthenticator ? (0, _loc.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [authenticator.label]) : (0, _loc.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [authenticator.label])
      });
      break;
    case _RemediationConstants.AUTHENTICATOR_KEY.DUO:
      Object.assign(authenticatorData, {
        description: isVerifyAuthenticator ? '' : (0, _loc.loc)('oie.duo.authenticator.description', 'login'),
        iconClassName: 'mfa-duo',
        buttonDataSeAttr: getButtonDataSeAttr(authenticator),
        ariaLabel: isVerifyAuthenticator ? (0, _loc.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [authenticator.label]) : (0, _loc.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [authenticator.label])
      });
      break;
    case _RemediationConstants.AUTHENTICATOR_KEY.IDP:
      {
        var _authenticator$relate11, _authenticator$relate12;
        const idpName = (_authenticator$relate11 = authenticator.relatesTo) === null || _authenticator$relate11 === void 0 ? void 0 : _authenticator$relate11.displayName;
        Object.assign(authenticatorData, {
          description: isVerifyAuthenticator ? '' : (0, _loc.loc)('oie.idp.authenticator.description', 'login', [idpName]),
          iconClassName: 'mfa-custom-factor',
          buttonDataSeAttr: getButtonDataSeAttr(authenticator),
          logoUri: (authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$relate12 = authenticator.relatesTo) === null || _authenticator$relate12 === void 0 ? void 0 : _authenticator$relate12.logoUri) || '',
          ariaLabel: isVerifyAuthenticator ? (0, _loc.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [authenticator.label]) : (0, _loc.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [authenticator.label])
        });
        break;
      }
    case _RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_OTP:
      {
        Object.assign(authenticatorData, {
          description: isVerifyAuthenticator ? '' : (0, _loc.loc)('oie.custom_otp.description', 'login'),
          iconClassName: 'mfa-hotp',
          buttonDataSeAttr: getButtonDataSeAttr(authenticator),
          ariaLabel: isVerifyAuthenticator ? (0, _loc.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [authenticator.label]) : (0, _loc.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [authenticator.label])
        });
        break;
      }
    case _RemediationConstants.AUTHENTICATOR_KEY.SYMANTEC_VIP:
      {
        var _authenticator$relate13;
        const appName = (_authenticator$relate13 = authenticator.relatesTo) === null || _authenticator$relate13 === void 0 ? void 0 : _authenticator$relate13.displayName;
        Object.assign(authenticatorData, {
          description: isVerifyAuthenticator ? '' : (0, _loc.loc)('oie.symantecVip.authenticator.description', 'login', [appName]),
          iconClassName: 'mfa-symantec',
          buttonDataSeAttr: getButtonDataSeAttr(authenticator),
          ariaLabel: isVerifyAuthenticator ? (0, _loc.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [authenticator.label]) : (0, _loc.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [authenticator.label])
        });
        break;
      }
    case _RemediationConstants.AUTHENTICATOR_KEY.YUBIKEY:
      {
        Object.assign(authenticatorData, {
          description: isVerifyAuthenticator ? '' : (0, _loc.loc)('oie.yubikey.authenticator.description', 'login'),
          iconClassName: 'mfa-yubikey',
          buttonDataSeAttr: getButtonDataSeAttr(authenticator),
          ariaLabel: isVerifyAuthenticator ? (0, _loc.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [authenticator.label]) : (0, _loc.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [authenticator.label])
        });
        break;
      }
    case _RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_APP:
      {
        var _authenticator$relate14, _authenticator$relate15, _authenticator$relate16;
        Object.assign(authenticatorData, {
          description: isVerifyAuthenticator ? authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$relate14 = authenticator.relatesTo) === null || _authenticator$relate14 === void 0 ? void 0 : _authenticator$relate14.displayName : (0, _loc.loc)('oie.custom.app.authenticator.description', 'login', [authenticator.label]),
          noTranslateClassName: isVerifyAuthenticator ? 'no-translate' : '',
          buttonDataSeAttr: getButtonDataSeAttr(authenticator),
          iconClassName: 'mfa-custom-app-logo',
          logoUri: (authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$relate15 = authenticator.relatesTo) === null || _authenticator$relate15 === void 0 ? void 0 : _authenticator$relate15.logoUri) || '',
          ariaLabel: isVerifyAuthenticator ? (0, _loc.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$relate16 = authenticator.relatesTo) === null || _authenticator$relate16 === void 0 ? void 0 : _authenticator$relate16.displayName]) : (0, _loc.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [authenticator.label])
        });
        break;
      }
    case _RemediationConstants.AUTHENTICATOR_KEY.SMARTCARD:
      {
        Object.assign(authenticatorData, {
          description: isVerifyAuthenticator ? '' : (0, _loc.loc)('oie.smartcard.authenticator.description', 'login'),
          iconClassName: 'mfa-smartcard',
          buttonDataSeAttr: getButtonDataSeAttr(authenticator),
          ariaLabel: isVerifyAuthenticator ? (0, _loc.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [authenticator.label]) : (0, _loc.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [authenticator.label])
        });
        break;
      }
  }
  return authenticatorData;
};
function getVerifyEmailAriaLabel(email) {
  return email ? (0, _loc.loc)('oie.select.authenticator.verify.email.with.email.label', 'login', [email]) : (0, _loc.loc)('oie.select.authenticator.verify.email.label', 'login');
}
function getVerifyPhoneAriaLabel(phone) {
  return phone ? (0, _loc.loc)('oie.select.authenticator.verify.phone.with.phone.label', 'login', [phone]) : (0, _loc.loc)('oie.select.authenticator.verify.phone.label', 'login');
}
function getOktaVerifyAriaLabel(isVerify, methodType) {
  if (!isVerify) {
    return (0, _loc.loc)('oie.select.authenticator.enroll.okta_verify.authenticator.label', 'login');
  }
  const defaultLabel = (0, _loc.loc)('oie.select.authenticator.verify.okta_verify.label', 'login');
  if (typeof methodType === 'undefined') {
    return defaultLabel;
  }
  const methodTypeLabelMap = {
    push: (0, _loc.loc)('oie.select.authenticator.okta_verify.push.label', 'login'),
    totp: (0, _loc.loc)('oie.select.authenticator.okta_verify.totp.label', 'login'),
    'signed_nonce': (0, _loc.loc)('oie.select.authenticator.okta_verify.signed_nonce.label', 'login')
  };
  return methodTypeLabelMap[methodType] || defaultLabel;
}
function getAuthenticatorDataForEnroll(authenticator) {
  return getAuthenticatorData(authenticator);
}
function getAuthenticatorDataForVerification(authenticator) {
  return getAuthenticatorData(authenticator, true);
}
function getIconClassNameForBeacon(authenticatorKey) {
  return getAuthenticatorData({
    authenticatorKey
  }).iconClassName;
}
function removeRequirementsFromError(errorJSON) {
  var _errorJSON$errorCause;
  if (((_errorJSON$errorCause = errorJSON.errorCauses) === null || _errorJSON$errorCause === void 0 ? void 0 : _errorJSON$errorCause.length) > 0 && Array.isArray(errorJSON.errorCauses[0].errorSummary) && errorJSON.errorCauses[0].errorSummary.length > 0) {
    var _errorJSON$errorCause2;
    // Change from Array to string for all errors.
    errorJSON.errorCauses[0].errorSummary = errorJSON.errorCauses[0].errorSummary[0];

    // Overrides for particular error messages.
    const errorKey = ((_errorJSON$errorCause2 = errorJSON.errorCauses[0].errorKey) === null || _errorJSON$errorCause2 === void 0 ? void 0 : _errorJSON$errorCause2.length) > 0 && errorJSON.errorCauses[0].errorKey[0];
    // Remove the requirements string only if this is requirements were not met error.
    if (errorKey === 'password.passwordRequirementsNotMet') {
      errorJSON.errorCauses[0].errorSummary = (0, _loc.loc)('registration.error.password.passwordRequirementsNotMet', 'login');
    }
  }
  return errorJSON;
}

/**
 * Get authenticator display name from {@code remediation}.
 *
 * @param {Object} remediation
 */
function getAuthenticatorDisplayName(remediation) {
  var _remediation$relatesT, _remediation$relatesT2;
  return (_remediation$relatesT = remediation.relatesTo) === null || _remediation$relatesT === void 0 ? void 0 : (_remediation$relatesT2 = _remediation$relatesT.value) === null || _remediation$relatesT2 === void 0 ? void 0 : _remediation$relatesT2.displayName;
}

// Re-export function from FactorUtil

/***/ }),

/***/ "./src/v2/view-builder/utils/AutoRedirectUtil.js":
/*!*******************************************************!*\
  !*** ./src/v2/view-builder/utils/AutoRedirectUtil.js ***!
  \*******************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getHeader = getHeader;
var _Util = _interopRequireDefault(__webpack_require__(/*! ../../../util/Util */ "./src/util/Util.js"));
var _internals = __webpack_require__(/*! ../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = __webpack_require__(/*! ../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js");
var _RemediationConstants = __webpack_require__(/*! ../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function getHeader() {
  if (_Util.default.isAndroidOVEnrollment()) {
    return _internals.BaseHeader.extend({
      HeaderBeacon: _BaseAuthenticatorView.BaseAuthenticatorBeacon.extend({
        authenticatorKey: _RemediationConstants.AUTHENTICATOR_KEY.OV
      })
    });
  } else {
    return _internals.BaseHeader;
  }
}

/***/ }),

/***/ "./src/v2/view-builder/utils/ChallengeViewUtil.js":
/*!********************************************************!*\
  !*** ./src/v2/view-builder/utils/ChallengeViewUtil.js ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.appendLoginHint = appendLoginHint;
exports.cancelPollingWithParams = cancelPollingWithParams;
exports.doChallenge = doChallenge;
exports.getBiometricsErrorOptions = getBiometricsErrorOptions;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _Constants = __webpack_require__(/*! ../utils/Constants */ "./src/v2/view-builder/utils/Constants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

function appendLoginHint(deviceChallengeUrl, loginHint) {
  if (deviceChallengeUrl && loginHint) {
    deviceChallengeUrl += '&login_hint=' + loginHint;
  }
  return deviceChallengeUrl;
}
function doChallenge(view, fromView) {
  var _view$options, _view$options$setting;
  const deviceChallenge = view.getDeviceChallengePayload();
  const loginHint = (_view$options = view.options) === null || _view$options === void 0 ? void 0 : (_view$options$setting = _view$options.settings) === null || _view$options$setting === void 0 ? void 0 : _view$options$setting.get('identifier');
  const HIDE_CLASS = 'hide';
  switch (deviceChallenge.challengeMethod) {
    case _Enums.default.LOOPBACK_CHALLENGE:
      view.title = (0, _courage.loc)('deviceTrust.sso.redirectText', 'login');
      view.add(_courage.View.extend({
        className: 'loopback-content',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            return "<div class=\"spinner\"></div>";
          },
          "useData": true
        })
      }));
      view.doLoopback(deviceChallenge);
      break;
    case _Enums.default.CUSTOM_URI_CHALLENGE:
      view.title = (0, _courage.loc)('customUri.title', 'login');
      view.add(_courage.View.extend({
        className: 'skinny-content',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
            return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "customUri.required.content.prompt"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 3
                },
                "end": {
                  "line": 1,
                  "column": 67
                }
              }
            })) + "</p>";
          },
          "useData": true
        })
      }));
      view.add((0, _courage.createButton)({
        className: 'ul-button button button-wide button-primary',
        title: (0, _courage.loc)('oktaVerify.open.button', 'login'),
        id: 'launch-ov',
        click: () => {
          view.doCustomURI();
        }
      }));
      view.add(_courage.View.extend({
        className: 'skinny-content',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var helper,
              alias1 = depth0 != null ? depth0 : container.nullContext || {},
              alias2 = container.hooks.helperMissing,
              alias3 = container.escapeExpression,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }
                return undefined;
              };
            return "<p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "customUri.required.content.download.title"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 3
                },
                "end": {
                  "line": 1,
                  "column": 75
                }
              }
            })) + "</p><p><a href=\"" + alias3((helper = (helper = lookupProperty(helpers, "downloadOVLink") || (depth0 != null ? lookupProperty(depth0, "downloadOVLink") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
              "name": "downloadOVLink",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 91
                },
                "end": {
                  "line": 1,
                  "column": 109
                }
              }
            }) : helper)) + "\" target=\"_blank\" id=\"download-ov\" class=\"link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "customUri.required.content.download.linkText"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 157
                },
                "end": {
                  "line": 1,
                  "column": 232
                }
              }
            })) + "</a></p>";
          },
          "useData": true
        }),
        getTemplateData() {
          return {
            downloadOVLink: deviceChallenge.downloadHref
          };
        }
      }));
      view.customURI = appendLoginHint(deviceChallenge.href, loginHint);
      view.doCustomURI();
      break;
    case _Enums.default.UNIVERSAL_LINK_CHALLENGE:
      view.title = (0, _courage.loc)('universalLink.title', 'login');
      view.add(_courage.View.extend({
        className: 'universal-link-content',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
            return "<div class=\"spinner\"></div>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "universalLink.content"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 27
                },
                "end": {
                  "line": 1,
                  "column": 79
                }
              }
            }));
          },
          "useData": true
        })
      }));
      view.add((0, _courage.createButton)({
        className: 'ul-button button button-wide button-primary',
        title: (0, _courage.loc)('oktaVerify.open.button', 'login'),
        click: () => {
          // only window.location.href can open universal link in iOS/MacOS
          // other methods won't do, ex, AJAX get or form get (Util.redirectWithFormGet)
          let deviceChallengeUrl = appendLoginHint(deviceChallenge.href, loginHint);
          _Util.default.redirect(deviceChallengeUrl);
        }
      }));
      break;
    case _Enums.default.APP_LINK_CHALLENGE:
      view.title = (0, _courage.loc)('appLink.title', 'login');
      view.add(_courage.View.extend({
        className: 'app-link-content',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var helper,
              alias1 = depth0 != null ? depth0 : container.nullContext || {},
              alias2 = container.hooks.helperMissing,
              alias3 = "function",
              alias4 = container.escapeExpression,
              lookupProperty = container.lookupProperty || function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                  return parent[propertyName];
                }
                return undefined;
              };
            return "<div class=\"spinner " + alias4((helper = (helper = lookupProperty(helpers, "hideClass") || (depth0 != null ? lookupProperty(depth0, "hideClass") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
              "name": "hideClass",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 20
                },
                "end": {
                  "line": 1,
                  "column": 33
                }
              }
            }) : helper)) + "\"></div><div class=\"appLinkContent " + alias4((helper = (helper = lookupProperty(helpers, "hideClass") || (depth0 != null ? lookupProperty(depth0, "hideClass") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
              "name": "hideClass",
              "hash": {},
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 68
                },
                "end": {
                  "line": 1,
                  "column": 81
                }
              }
            }) : helper)) + "\">" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "appLink.content"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 83
                },
                "end": {
                  "line": 1,
                  "column": 129
                }
              }
            })) + "</div>";
          },
          "useData": true
        }),
        getTemplateData() {
          return {
            hideClass: HIDE_CLASS
          };
        },
        postRender() {
          if (fromView === _Constants.IDENTIFIER_FLOW) {
            this.$('.spinner').removeClass(HIDE_CLASS);
            setTimeout(_courage._.bind(() => {
              const data = {
                label: (0, _courage.loc)('goback', 'login')
              };
              this.options.appState.trigger('updateFooterLink', data);
              this.$('.spinner').addClass(HIDE_CLASS);
              this.$('.appLinkContent').removeClass(HIDE_CLASS);
            }, this), _Constants.FASTPASS_FALLBACK_SPINNER_TIMEOUT);
          } else {
            this.$('.appLinkContent').removeClass(HIDE_CLASS);
          }
        }
      }));
      view.add((0, _courage.createButton)({
        className: `${HIDE_CLASS} al-button button button-wide button-primary`,
        title: (0, _courage.loc)('oktaVerify.open.button', 'login'),
        click: () => {
          // only window.location.href can open app link in Android
          // other methods won't do, ex, AJAX get or form get (Util.redirectWithFormGet)
          let deviceChallengeUrl = appendLoginHint(deviceChallenge.href, loginHint);
          _Util.default.redirect(deviceChallengeUrl, window, true);
        },
        postRender() {
          if (fromView === _Constants.IDENTIFIER_FLOW) {
            setTimeout(_courage._.bind(() => {
              this.$el.removeClass(HIDE_CLASS);
            }, this), _Constants.FASTPASS_FALLBACK_SPINNER_TIMEOUT);
          } else {
            this.$el.removeClass(HIDE_CLASS);
          }
        }
      }));
      break;
    case _Enums.default.CHROME_DTC:
      // reusing the existing message for Chrome DTC
      view.title = (0, _courage.loc)('deviceTrust.sso.redirectText', 'login');
      view.add(_courage.View.extend({
        className: 'chrome-dtc-content',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            return "<div class=\"spinner\"></div>";
          },
          "useData": true
        })
      }));
      view.doChromeDTC(deviceChallenge);
      break;
  }
}
function cancelPollingWithParams(appState, pollingCancelAction, cancelReason, statusCode) {
  const actionParams = {};
  actionParams[_Constants.REQUEST_PARAM_AUTHENTICATION_CANCEL_REASON] = cancelReason;
  actionParams[_Constants.LOOPBACK_RESPONSE_STATUS_CODE] = statusCode;
  appState.trigger('invokeAction', pollingCancelAction, actionParams);
}
function getBiometricsErrorOptions(error, isMessageObj) {
  let errorSummaryKeys;
  if (isMessageObj) {
    var _error$value$;
    errorSummaryKeys = Object.values(error === null || error === void 0 ? void 0 : (_error$value$ = error.value[0]) === null || _error$value$ === void 0 ? void 0 : _error$value$.i18n);
  } else {
    var _error$responseJSON;
    errorSummaryKeys = error === null || error === void 0 ? void 0 : (_error$responseJSON = error.responseJSON) === null || _error$responseJSON === void 0 ? void 0 : _error$responseJSON.errorSummaryKeys;
  }
  const isBiometricsRequiredMobile = errorSummaryKeys && errorSummaryKeys.includes(_Constants.OV_UV_ENABLE_BIOMETRICS_FASTPASS_MOBILE);
  const isBiometricsRequiredDesktop = errorSummaryKeys && errorSummaryKeys.includes(_Constants.OV_UV_ENABLE_BIOMETRICS_FASTPASS_DESKTOP);
  let options = [];
  if (!isBiometricsRequiredMobile && !isBiometricsRequiredDesktop) {
    return options;
  }
  const bulletPoints = [(0, _courage.loc)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point1', 'login'), (0, _courage.loc)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point2', 'login'), (0, _courage.loc)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point3', 'login')];

  // Add an additional bullet point for desktop devices
  if (isBiometricsRequiredDesktop) {
    bulletPoints.push((0, _courage.loc)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point4', 'login'));
  }
  options = {
    type: 'error',
    className: 'okta-verify-uv-callout-content',
    title: (0, _courage.loc)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.title', 'login'),
    subtitle: (0, _courage.loc)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.description', 'login'),
    bullets: bulletPoints
  };
  return options;
}

/***/ }),

/***/ "./src/v2/view-builder/utils/Constants.js":
/*!************************************************!*\
  !*** ./src/v2/view-builder/utils/Constants.js ***!
  \************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.WIDGET_FOOTER_CLASS = exports.WARNING_TIMEOUT = exports.UNIVERSAL_LINK_POST_DELAY = exports.SHOW_RESEND_TIMEOUT = exports.REQUEST_PARAM_AUTHENTICATION_CANCEL_REASON = exports.OV_UV_ENABLE_BIOMETRICS_FASTPASS_MOBILE = exports.OV_UV_ENABLE_BIOMETRICS_FASTPASS_DESKTOP = exports.MS_PER_SEC = exports.LOOPBACK_RESPONSE_STATUS_CODE = exports.IDENTIFIER_FLOW = exports.FASTPASS_FALLBACK_SPINNER_TIMEOUT = exports.CHALLENGE_TIMEOUT = exports.CANCEL_POLLING_ACTION = exports.AUTHENTICATOR_CANCEL_ACTION = exports.AUTHENTICATOR_ALLOWED_FOR_OPTIONS = exports.AUTHENTICATION_CANCEL_REASONS = void 0;
const SHOW_RESEND_TIMEOUT = 30000;
exports.SHOW_RESEND_TIMEOUT = SHOW_RESEND_TIMEOUT;
const WARNING_TIMEOUT = 30000;
exports.WARNING_TIMEOUT = WARNING_TIMEOUT;
const CHALLENGE_TIMEOUT = 300000;
exports.CHALLENGE_TIMEOUT = CHALLENGE_TIMEOUT;
const MS_PER_SEC = 1000;
exports.MS_PER_SEC = MS_PER_SEC;
const UNIVERSAL_LINK_POST_DELAY = 500;
exports.UNIVERSAL_LINK_POST_DELAY = UNIVERSAL_LINK_POST_DELAY;
const CANCEL_POLLING_ACTION = 'authenticatorChallenge-cancel';
exports.CANCEL_POLLING_ACTION = CANCEL_POLLING_ACTION;
const AUTHENTICATOR_CANCEL_ACTION = 'currentAuthenticator-cancel';
exports.AUTHENTICATOR_CANCEL_ACTION = AUTHENTICATOR_CANCEL_ACTION;
const WIDGET_FOOTER_CLASS = 'siw-main-footer';
exports.WIDGET_FOOTER_CLASS = WIDGET_FOOTER_CLASS;
const FASTPASS_FALLBACK_SPINNER_TIMEOUT = 4000;
exports.FASTPASS_FALLBACK_SPINNER_TIMEOUT = FASTPASS_FALLBACK_SPINNER_TIMEOUT;
const IDENTIFIER_FLOW = 'IDENTIFIER';
exports.IDENTIFIER_FLOW = IDENTIFIER_FLOW;
const OV_UV_ENABLE_BIOMETRICS_FASTPASS_DESKTOP = 'oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.desktop';
exports.OV_UV_ENABLE_BIOMETRICS_FASTPASS_DESKTOP = OV_UV_ENABLE_BIOMETRICS_FASTPASS_DESKTOP;
const OV_UV_ENABLE_BIOMETRICS_FASTPASS_MOBILE = 'oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.mobile';
exports.OV_UV_ENABLE_BIOMETRICS_FASTPASS_MOBILE = OV_UV_ENABLE_BIOMETRICS_FASTPASS_MOBILE;
const AUTHENTICATOR_ALLOWED_FOR_OPTIONS = {
  ANY: 'any',
  SSO: 'sso',
  RECOVERY: 'recovery'
};
exports.AUTHENTICATOR_ALLOWED_FOR_OPTIONS = AUTHENTICATOR_ALLOWED_FOR_OPTIONS;
const REQUEST_PARAM_AUTHENTICATION_CANCEL_REASON = 'reason';
exports.REQUEST_PARAM_AUTHENTICATION_CANCEL_REASON = REQUEST_PARAM_AUTHENTICATION_CANCEL_REASON;
const LOOPBACK_RESPONSE_STATUS_CODE = 'statusCode';
exports.LOOPBACK_RESPONSE_STATUS_CODE = LOOPBACK_RESPONSE_STATUS_CODE;
const AUTHENTICATION_CANCEL_REASONS = {
  LOOPBACK_FAILURE: 'OV_UNREACHABLE_BY_LOOPBACK',
  OV_ERROR: 'OV_RETURNED_ERROR',
  USER_CANCELED: 'USER_CANCELED'
};
exports.AUTHENTICATION_CANCEL_REASONS = AUTHENTICATION_CANCEL_REASONS;

/***/ }),

/***/ "./src/v2/view-builder/utils/DeviceFingerprinting.js":
/*!***********************************************************!*\
  !*** ./src/v2/view-builder/utils/DeviceFingerprinting.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

// TODO: Use AuthJS for device fingerprinting: OKTA-418160

function getUserAgent() {
  return navigator.userAgent;
}
function isWindowsPhone(userAgent) {
  return userAgent.match(/windows phone|iemobile|wpdesktop/i);
}
var _default = {
  isMessageFromCorrectSource($iframe, event) {
    return event.source === $iframe[0].contentWindow;
  },
  // NOTE: This utility is similar to the DeviceFingerprint.js file used for V1 authentication flows.
  generateDeviceFingerprint(fingerprintData) {
    return new Promise((resolve, reject) => {
      const userAgent = getUserAgent();
      if (!userAgent) {
        return reject('user agent is not defined');
      } else if (isWindowsPhone(userAgent)) {
        return reject('device fingerprint is not supported on Windows phones');
      }
      let $iframe;
      let iFrameTimeout;
      const self = this; // Needed for mocking

      function removeIframe() {
        $iframe.off();
        $iframe.remove();
        window.removeEventListener('message', onMessageReceivedFromOkta, false);
      }
      function handleError(reason) {
        removeIframe();
        reject(reason);
      }
      function onMessageReceivedFromOkta(event) {
        if (!self.isMessageFromCorrectSource($iframe, event)) {
          return;
        }
        // deviceFingerprint service is available, clear timeout
        clearTimeout(iFrameTimeout);
        if (!event || !event.data || event.origin !== fingerprintData.oktaDomainUrl) {
          handleError('no data');
          return;
        }
        try {
          const message = JSON.parse(event.data);
          if (message && message.type === 'FingerprintServiceReady') {
            sendMessageToOkta({
              type: 'GetFingerprint'
            });
          } else if (message && message.type === 'FingerprintAvailable') {
            removeIframe();
            resolve(message.fingerprint);
          } else {
            handleError('no data');
          }
        } catch (error) {
          //Ignore any errors since we could get other messages too
        }
      }
      function sendMessageToOkta(message) {
        const win = $iframe[0].contentWindow;
        if (win) {
          win.postMessage(JSON.stringify(message), fingerprintData.oktaDomainUrl);
        }
      }

      // Attach listener
      window.addEventListener('message', onMessageReceivedFromOkta, false);
      // Create and Load devicefingerprint page inside the iframe
      $iframe = (0, _courage.$)('<iframe>', {
        css: {
          display: 'none'
        },
        src: fingerprintData.oktaDomainUrl + '/auth/services/devicefingerprint'
      });
      fingerprintData.element.append($iframe);
      iFrameTimeout = setTimeout(() => {
        // If the iFrame does not load or there is a slow connection, throw an error
        handleError('service not available');
      }, 2000);
    });
  }
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/utils/LinksUtil.js":
/*!************************************************!*\
  !*** ./src/v2/view-builder/utils/LinksUtil.js ***!
  \************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.goBackLink = exports.getSwitchAuthenticatorLink = exports.getSkipSetupLink = exports.getSignUpLink = exports.getSignOutLink = exports.getReloadPageButtonLink = exports.getForgotPasswordLink = exports.getFactorPageCustomLink = exports.getBackToSignInLink = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _RemediationConstants = __webpack_require__(/*! ../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
const {
  ENROLLED_PASSWORD_RECOVERY_LINK,
  ORG_PASSWORD_RECOVERY_LINK
} = _RemediationConstants.ACTIONS;
const getSwitchAuthenticatorLink = appState => {
  if (appState.getRemediationAuthenticationOptions(_RemediationConstants.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE).length > 1) {
    return [{
      'type': 'link',
      'label': (0, _courage.loc)('oie.verification.switch.authenticator', 'login'),
      'name': 'switchAuthenticator',
      'formName': _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE
    }];
  }
  if (appState.getRemediationAuthenticationOptions(_RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL).length >= 1) {
    return [{
      'type': 'link',
      'label': (0, _courage.loc)('oie.enroll.switch.authenticator', 'login'),
      'name': 'switchAuthenticator',
      'formName': _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL
    }];
  }
  return [];
};
exports.getSwitchAuthenticatorLink = getSwitchAuthenticatorLink;
const getForgotPasswordLink = (appState, settings) => {
  const forgotPasswordLink = {
    'type': 'link',
    'label': (0, _courage.loc)('forgotpassword', 'login'),
    'name': 'forgot-password'
  };
  const customForgotPasswordHref = settings.get('helpLinks.forgotPassword');
  if (customForgotPasswordHref) {
    return [Object.assign({}, {
      'href': customForgotPasswordHref,
      'label': (0, _courage.loc)('forgotpassword', 'login'),
      'name': 'forgot-password'
    })];
  }

  // at identify page when only Org Authenticator Password may be available
  else if (appState.getActionByPath(ORG_PASSWORD_RECOVERY_LINK)) {
    return [Object.assign({}, forgotPasswordLink, {
      actionPath: ORG_PASSWORD_RECOVERY_LINK
    })];
  }

  // at password verify page
  else if (appState.getActionByPath(ENROLLED_PASSWORD_RECOVERY_LINK)) {
    return [Object.assign({}, forgotPasswordLink, {
      actionPath: ENROLLED_PASSWORD_RECOVERY_LINK
    })];
  }
  return [];
};
exports.getForgotPasswordLink = getForgotPasswordLink;
const goBackLink = appState => {
  if (appState.hasRemediationObject(_RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL)) {
    return [{
      'type': 'link',
      'label': (0, _courage.loc)('oie.go.back', 'login'),
      'name': 'go-back',
      'formName': _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL
    }];
  }
  return [];
};
exports.goBackLink = goBackLink;
const getSkipSetupLink = (appState, linkName) => {
  if (appState.hasRemediationObject(_RemediationConstants.FORMS.SKIP)) {
    return [{
      'type': 'link',
      'label': linkName ?? (0, _courage.loc)('oie.enroll.skip.setup', 'login'),
      'name': 'skip-setup',
      'actionPath': _RemediationConstants.FORMS.SKIP
    }];
  }
  return [];
};

// When there is a 'cancel' object in remediation
exports.getSkipSetupLink = getSkipSetupLink;
const getSignOutLink = (settings, options = {}) => {
  if (settings !== null && settings !== void 0 && settings.get('backToSignInUri')) {
    return [{
      'label': (0, _courage.loc)('goback', 'login'),
      'name': 'cancel',
      'href': settings.get('backToSignInUri')
    }];
  }
  return [{
    'actionPath': 'cancel',
    'label': !options.label ? (0, _courage.loc)('goback', 'login') : options.label,
    'name': 'cancel',
    'type': 'link'
  }];
};

// Use it to create a widget configured link in the absence of `cancel` object in remediation
exports.getSignOutLink = getSignOutLink;
const getBackToSignInLink = ({
  settings,
  appState
}) => {
  const link = {};

  // If backToSignInLink is set, use this value for all scenarios
  if (settings !== null && settings !== void 0 && settings.get('backToSignInUri')) {
    link.href = settings.get('backToSignInUri');
  }
  // fallback for embedded scenarios
  else if (settings !== null && settings !== void 0 && settings.get('oauth2Enabled')) {
    link.clickHandler = () => {
      appState.trigger('restartLoginFlow');
    };
  }
  // fallback for okta-hosted scenarios (backend should set signOutLink or backToSignOutLink)
  else {
    link.href = settings === null || settings === void 0 ? void 0 : settings.get('baseUrl');
  }
  return [{
    'type': 'link',
    'label': (0, _courage.loc)('goback', 'login'),
    'name': 'go-back',
    ...link
  }];
};
exports.getBackToSignInLink = getBackToSignInLink;
const getReloadPageButtonLink = () => {
  return [{
    'type': 'link',
    'label': (0, _courage.loc)('oie.try.again', 'login'),
    'name': 'try-again',
    'href': window.location,
    'className': 'button button-primary text-align-c'
  }];
};
exports.getReloadPageButtonLink = getReloadPageButtonLink;
const getSignUpLink = (appState, settings) => {
  const signupLink = [];
  if (appState.hasRemediationObject(_RemediationConstants.FORMS.SELECT_ENROLL_PROFILE)) {
    const signupLinkData = {
      'type': 'link',
      'label': (0, _courage.loc)('oie.registration.form.title', 'login'),
      'name': 'enroll'
    };
    if (_courage._.isFunction(settings.get('registration.click'))) {
      signupLinkData.clickHandler = settings.get('registration.click');
    } else {
      signupLinkData.actionPath = _RemediationConstants.FORMS.SELECT_ENROLL_PROFILE;
    }
    signupLink.push(signupLinkData);
  }
  return signupLink;
};
exports.getSignUpLink = getSignUpLink;
const getFactorPageCustomLink = (appState, settings) => {
  const factorPageCustomLink = [];
  const formsNeedFactorPageCustomLink = [_RemediationConstants.FORMS.CHALLENGE_AUTHENTICATOR, _RemediationConstants.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE, _RemediationConstants.FORMS.CHALLENGE_POLL, _RemediationConstants.FORMS.AUTHENTICATOR_VERIFICATION_DATA];
  if (!appState.get('isPasswordRecovery') && formsNeedFactorPageCustomLink.includes(appState.get('currentFormName'))) {
    const helpLinksFactorPageLabel = settings.get('helpLinks.factorPage.text');
    const helpLinksFactorPageHref = settings.get('helpLinks.factorPage.href');
    if (helpLinksFactorPageLabel && helpLinksFactorPageHref) {
      factorPageCustomLink.push({
        type: 'link',
        label: helpLinksFactorPageLabel,
        name: 'factorPageHelpLink',
        href: helpLinksFactorPageHref,
        target: '_blank'
      });
    }
  }
  return factorPageCustomLink;
};
exports.getFactorPageCustomLink = getFactorPageCustomLink;

/***/ }),

/***/ "./src/v2/view-builder/utils/TimeZone.js":
/*!***********************************************!*\
  !*** ./src/v2/view-builder/utils/TimeZone.js ***!
  \***********************************************/
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _default = {
  GMT: 'UTC',
  WET: 'WET',
  CET: 'CET',
  MET: 'CET',
  ECT: 'CET',
  EET: 'EET',
  MIT: 'Pacific/Apia',
  HST: 'Pacific/Honolulu',
  AST: 'America/Anchorage',
  PST: 'America/Los_Angeles',
  MST: 'America/Denver',
  PNT: 'America/Phoenix',
  CST: 'America/Chicago',
  EST: 'America/New_York',
  IET: 'America/Indiana/Indianapolis',
  PRT: 'America/Puerto_Rico',
  CNT: 'America/St_Johns',
  AGT: 'America/Argentina/Buenos_Aires',
  BET: 'America/Sao_Paulo',
  ART: 'Africa/Cairo',
  CAT: 'Africa/Harare',
  EAT: 'Africa/Addis_Ababa',
  NET: 'Asia/Yerevan',
  PLT: 'Asia/Karachi',
  IST: 'Asia/Kolkata',
  BST: 'Asia/Dhaka',
  VST: 'Asia/Ho_Chi_Minh',
  CTT: 'Asia/Shanghai',
  JST: 'Asia/Tokyo',
  ACT: 'Australia/Darwin',
  AET: 'Australia/Sydney',
  SST: 'Pacific/Guadalcanal',
  NST: 'Pacific/Auckland'
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/AutoRedirectView.js":
/*!*******************************************************!*\
  !*** ./src/v2/view-builder/views/AutoRedirectView.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../internals */ "./src/v2/view-builder/internals/index.js");
var _RemediationConstants = __webpack_require__(/*! ../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _CustomAccessDeniedErrorMessage = _interopRequireDefault(__webpack_require__(/*! ../views/shared/CustomAccessDeniedErrorMessage */ "./src/v2/view-builder/views/shared/CustomAccessDeniedErrorMessage.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _AutoRedirectUtil = __webpack_require__(/*! ../utils/AutoRedirectUtil */ "./src/v2/view-builder/utils/AutoRedirectUtil.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CUSTOM_ACCESS_DENIED_KEY = 'security.access_denied_custom_message';
const UNLOCK_USER_SUCCESS_MESSAGE = 'oie.selfservice.unlock_user.landing.to.app.success.message';
const Body = _internals.BaseForm.extend({
  /* eslint complexity: [2, 16] */
  title() {
    let titleString = (0, _courage.loc)('oie.success.text.signingIn', 'login');
    // For more info on the API response available in appState, see IdxResponseBuilder.java
    const app = this.options.appState.get('app');
    const user = this.options.appState.get('user');

    // OKTA-635926: add user gesture for ov enrollment on android
    if (_Util.default.isAndroidOVEnrollment()) {
      titleString = (0, _courage.loc)('oie.success.text.signingIn.with.appName.android.ov.enrollment', 'login');
      return titleString;
    }

    // If the option is not set, we treat that as being the case where we don't render the spinner.
    // This is to account for the customer hosted scenario, because by default okta-core will pass in
    // the correct value as set by the option in the Admin UI (which by default is "DEFAULT").
    if (!this.redirectView || this.redirectView === _RemediationConstants.INTERSTITIAL_REDIRECT_VIEW.NONE) {
      titleString = (0, _courage.loc)('oie.success.text.signingIn.with.ellipsis', 'login');
      return titleString;
    }
    if (_courage._.isEmpty(app)) {
      return titleString;
    }
    const {
      label: appInstanceName,
      name: appDisplayName
    } = app;
    const {
      identifier: userEmail
    } = user || {};
    const appName = appInstanceName ? appInstanceName : appDisplayName;
    if (appName && userEmail && !this.settings.get('features.showIdentifier')) {
      titleString = (0, _courage.loc)('oie.success.text.signingIn.with.appName.and.identifier', 'login', [appName, userEmail]);
    } else if (appName) {
      titleString = (0, _courage.loc)('oie.success.text.signingIn.with.appName', 'login', [appName]);
    }
    return titleString;
  },
  showMessages() {
    if (this.isUnlockSuccess()) {
      const container = '.o-form-error-container';
      const text = (0, _courage.loc)('oie.selfservice.unlock_user.landing.to.app.signing.in.message', 'login');
      this.add(`<div class="ion-messages-container"><p>${text}</p></div>`, container);
      return;
    } else if (this.options.appState.containsMessageStartingWithI18nKey(CUSTOM_ACCESS_DENIED_KEY)) {
      const {
        message,
        links
      } = this.options.appState.get('messages').value.find(msg => msg.i18n.key === CUSTOM_ACCESS_DENIED_KEY);
      this.add((0, _courage.createCallout)({
        type: 'error',
        content: new _CustomAccessDeniedErrorMessage.default({
          message,
          links
        })
      }));
      return;
    }
    _internals.BaseForm.prototype.showMessages.call(this);
  },
  isUnlockSuccess() {
    return this.options.appState.containsMessageWithI18nKey(UNLOCK_USER_SUCCESS_MESSAGE);
  },
  noButtonBar: true,
  initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    this.redirectView = this.settings.get('interstitialBeforeLoginRedirect');
    this.model.set('useRedirect', true);
    this.trigger('save', this.model);
  },
  render() {
    _internals.BaseForm.prototype.render.apply(this, arguments);
    if (_Util.default.isAndroidOVEnrollment()) {
      const currentViewState = this.options.appState.getCurrentViewState();
      this.add((0, _courage.createButton)({
        className: 'ul-button button button-wide button-primary hide-underline',
        title: (0, _courage.loc)('oktaVerify.open.button', 'login'),
        id: 'launch-enrollment-ov',
        click: () => {
          _Util.default.redirectWithFormGet(currentViewState.href);
        }
      }));
    } else if (this.redirectView === _RemediationConstants.INTERSTITIAL_REDIRECT_VIEW.DEFAULT) {
      this.add('<div class="okta-waiting-spinner"></div>');
    }
  }
});
var _default = _internals.BaseView.extend({
  Header: (0, _AutoRedirectUtil.getHeader)(),
  Body: Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/EnrollProfileUpdateView.js":
/*!**************************************************************!*\
  !*** ./src/v2/view-builder/views/EnrollProfileUpdateView.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../internals */ "./src/v2/view-builder/internals/index.js");
var _LinksUtil = __webpack_require__(/*! ../utils/LinksUtil */ "./src/v2/view-builder/utils/LinksUtil.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend({
  className: 'profile-update',
  title() {
    return (0, _courage.loc)('oie.profile.additional.title', 'login');
  },
  save() {
    return (0, _courage.loc)('enroll.choices.submit.finish', 'login');
  },
  getUISchema() {
    const uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);
    uiSchemas.forEach(input => {
      if (input.name === 'userProfile.secondEmail') {
        input.explain = _courage.View.extend({
          template: _runtime.default.template({
            "compiler": [8, ">= 4.3.0"],
            "main": function (container, depth0, helpers, partials, data) {
              var stack1,
                lookupProperty = container.lookupProperty || function (parent, propertyName) {
                  if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                  }
                  return undefined;
                };
              return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                  "$1": "<span class='strong'>$1</span>",
                  "bundle": "login",
                  "code": "oie.profile.additional.secondemail.subtitle"
                },
                "data": data,
                "loc": {
                  "start": {
                    "line": 1,
                    "column": 0
                  },
                  "end": {
                    "line": 1,
                    "column": 112
                  }
                }
              })) != null ? stack1 : "";
            },
            "useData": true
          })
        });
      }
    });
    return uiSchemas;
  },
  initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
  }
});
const Footer = _internals.BaseFooter.extend({
  className: 'auth-footer side-by-side-links',
  links: function () {
    const {
      uiSchema
    } = this.options.currentViewState;
    const optionalParams = uiSchema.filter(item => item.required === false);
    if (uiSchema.length === optionalParams.length) {
      return (0, _LinksUtil.getSkipSetupLink)(this.options.appState, (0, _courage.loc)('oie.enroll.skip.profile', 'login'));
    } else {
      this.$el.removeClass('.side-by-side-links');
    }
  }
});
var _default = _internals.BaseView.extend({
  Body,
  Footer,
  postRender() {
    _internals.BaseView.prototype.postRender.apply(this, arguments);
    /**
     * As per requirement of this flow set secondEmail default to empty string, if exists in remediation
     * ideally server should have passed default string in remediation
     */
    if (this.options.appState.getSchemaByName('userProfile.secondEmail')) {
      this.model.set('userProfile.secondEmail', '');
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/EnrollProfileView.js":
/*!********************************************************!*\
  !*** ./src/v2/view-builder/views/EnrollProfileView.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../internals */ "./src/v2/view-builder/internals/index.js");
var _RemediationConstants = __webpack_require__(/*! ../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _AuthenticatorUtil = __webpack_require__(/*! ../utils/AuthenticatorUtil */ "./src/v2/view-builder/utils/AuthenticatorUtil.js");
var _PasswordPolicyUtil = __webpack_require__(/*! ./password/PasswordPolicyUtil */ "./src/v2/view-builder/views/password/PasswordPolicyUtil.js");
var _SignInWithIdps = _interopRequireDefault(__webpack_require__(/*! ./signin/SignInWithIdps */ "./src/v2/view-builder/views/signin/SignInWithIdps.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend({
  title() {
    if (this.options.appState.getCurrentViewState().href.endsWith('idp/idx/enroll/update')) {
      var _attributes$uiDisplay;
      const attributes = this.options.appState.attributes;
      if (attributes !== null && attributes !== void 0 && (_attributes$uiDisplay = attributes.uiDisplay) !== null && _attributes$uiDisplay !== void 0 && _attributes$uiDisplay.label) {
        return (0, _courage.loc)('oie.registration.form.customize.label', 'login', [attributes.uiDisplay.label]);
      } else {
        return (0, _courage.loc)('oie.primaryauth.submit', 'login');
      }
    }
    return (0, _courage.loc)('oie.registration.form.title', 'login');
  },
  save() {
    if (this.options.appState.getCurrentViewState().href.endsWith('idp/idx/enroll/update')) {
      var _attributes$uiDisplay2;
      const attributes = this.options.appState.attributes;
      if (attributes !== null && attributes !== void 0 && (_attributes$uiDisplay2 = attributes.uiDisplay) !== null && _attributes$uiDisplay2 !== void 0 && _attributes$uiDisplay2.buttonLabel) {
        return (0, _courage.loc)('oie.registration.form.customize.buttonLabel', 'login', [attributes.uiDisplay.buttonLabel]);
      } else {
        return (0, _courage.loc)('oie.registration.form.update.submit', 'login');
      }
    }
    return (0, _courage.loc)('oie.registration.form.submit', 'login');
  },
  initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    this.model.set('userProfile.email', this.options.appState.get('lastIdentifier'));
  },
  saveForm() {
    // SIW customization hook for registration
    this.settings.preRegistrationSubmit(this.model.toJSON(), postData => {
      this.model.attributes = {
        ...this.model.attributes,
        ...this.model.parse(postData)
      };
      _internals.BaseForm.prototype.saveForm.call(this, this.model);
    }, error => this.model.trigger('error', this.model, {
      responseJSON: error
    }));
  },
  triggerAfterError(model, error) {
    var _error$responseJSON;
    // render errors to view
    const hasErrors = (error === null || error === void 0 ? void 0 : (_error$responseJSON = error.responseJSON) === null || _error$responseJSON === void 0 ? void 0 : _error$responseJSON.errorCauses) && Array.isArray(error.responseJSON.errorCauses);
    if (hasErrors) {
      error.responseJSON.errorCauses.forEach(err => {
        var _err$errorKey;
        // only do this for invalid password for password with SSR
        if ((_err$errorKey = err.errorKey) !== null && _err$errorKey !== void 0 && _err$errorKey.includes('password.passwordRequirementsNotMet')) {
          err.errorSummary = (0, _courage.loc)('registration.error.password.passwordRequirementsNotMet', 'login');
        }
      });
    }
    this.options.appState.trigger('afterError', error);
  }
});
const Footer = _internals.BaseFooter.extend({
  links() {
    const links = [];
    if (this.options.appState.hasRemediationObject(_RemediationConstants.FORMS.SELECT_IDENTIFY)) {
      links.push({
        'type': 'link',
        'label': (0, _courage.loc)('haveaccount', 'login'),
        'name': 'back',
        'actionPath': _RemediationConstants.FORMS.SELECT_IDENTIFY
      });
    }
    return links;
  }
});
var _default = _internals.BaseView.extend({
  Body,
  Footer,
  createModelClass(currentViewState, optionUiSchemaConfig, settings) {
    const currentSchema = JSON.parse(JSON.stringify(currentViewState.uiSchema));
    let ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments, currentViewState);
    ModelClass = ModelClass.extend({
      toJSON: function () {
        const modelJSON = _courage.Model.prototype.toJSON.call(this, arguments, currentViewState);
        // delete optional attributes if they are empty and not required
        if (modelJSON.userProfile) {
          const uiSchema = currentViewState.uiSchema;
          const userProfile = modelJSON.userProfile;
          _courage._.each(userProfile, (value, name) => {
            if (_courage._.isEmpty(value)) {
              const uiSchemaProperty = uiSchema.find(schema => schema.name === `userProfile.${name}`);
              if (!_courage._.isUndefined(uiSchemaProperty) && !uiSchemaProperty.required) {
                delete userProfile[name];
              }
            }
          });
        }
        return modelJSON;
      }
    });
    settings.parseRegistrationSchema(currentSchema, schema => {
      if (!_courage._.isEqual(schema, currentViewState.uiSchema)) {
        currentViewState.uiSchema = schema;
        ModelClass = _internals.BaseView.prototype.createModelClass.call(this, currentViewState, optionUiSchemaConfig);
      }
    }, error => {
      ModelClass = ModelClass.extend({
        local: {
          parseSchemaError: {
            value: error,
            type: 'object'
          },
          ...ModelClass.prototype.local
        }
      });
    });
    return ModelClass;
  },
  postRender() {
    _internals.BaseView.prototype.postRender.apply(this, arguments);
    const modelError = this.model.get('parseSchemaError');
    if (modelError) {
      this.model.trigger('error', this.model, {
        responseJSON: modelError
      });
    }

    // Prompt for password w/ SSR if enabled (credentials object in remediation)
    this.renderPasswordPolicySettings();
    const idpButtons = (0, _internals.createIdpButtons)(this.options);
    if (Array.isArray(idpButtons) && idpButtons.length) {
      this._addIdpView(idpButtons);
    }
  },
  renderPasswordPolicySettings() {
    var _credentials$form;
    // retrieve password policy from "credentials" object in remediation
    const currentViewState = this.options.currentViewState.value;
    const credentials = currentViewState.filter(obj => {
      return obj.name === 'credentials';
    })[0];

    // if "passcode" is present in "credentials", render password rules
    const form = credentials === null || credentials === void 0 ? void 0 : (_credentials$form = credentials.form) === null || _credentials$form === void 0 ? void 0 : _credentials$form.value;
    if (form && form.filter(obj => {
      return obj.name === 'passcode';
    })) {
      var _credentials$relatesT, _credentials$relatesT2;
      (0, _PasswordPolicyUtil.generatePasswordPolicyHtml)(this, (0, _AuthenticatorUtil.getPasswordComplexityDescriptionForHtmlList)(credentials === null || credentials === void 0 ? void 0 : (_credentials$relatesT = credentials.relatesTo) === null || _credentials$relatesT === void 0 ? void 0 : (_credentials$relatesT2 = _credentials$relatesT.value) === null || _credentials$relatesT2 === void 0 ? void 0 : _credentials$relatesT2.settings), false);
    }
  },
  _addIdpView(idpButtons) {
    // We check the 'idpDisplay' option config to determine whether to render the idp buttons 
    // above or below the login fields
    const idpDisplay = this.options.settings.get('idpDisplay');
    const isPrimaryIdpDisplay = idpDisplay && idpDisplay.toUpperCase() === 'PRIMARY';
    this.add(_SignInWithIdps.default, {
      prepend: isPrimaryIdpDisplay,
      selector: isPrimaryIdpDisplay ? '.o-form-fieldset-container' : '.o-form-button-bar',
      options: {
        idpButtons,
        isPrimaryIdpDisplay
      }
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/IdentifierView.js":
/*!*****************************************************!*\
  !*** ./src/v2/view-builder/views/IdentifierView.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _RemediationConstants = __webpack_require__(/*! ../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _internals = __webpack_require__(/*! ../internals */ "./src/v2/view-builder/internals/index.js");
var _DeviceFingerprinting = _interopRequireDefault(__webpack_require__(/*! ../utils/DeviceFingerprinting */ "./src/v2/view-builder/utils/DeviceFingerprinting.js"));
var _IdentifierFooter = _interopRequireDefault(__webpack_require__(/*! ../components/IdentifierFooter */ "./src/v2/view-builder/components/IdentifierFooter.js"));
var _Link = _interopRequireDefault(__webpack_require__(/*! ../components/Link */ "./src/v2/view-builder/components/Link.js"));
var _SignInWithIdps = _interopRequireDefault(__webpack_require__(/*! ./signin/SignInWithIdps */ "./src/v2/view-builder/views/signin/SignInWithIdps.js"));
var _CustomButtons = _interopRequireDefault(__webpack_require__(/*! ./signin/CustomButtons */ "./src/v2/view-builder/views/signin/CustomButtons.js"));
var _SignInWithDeviceOption = _interopRequireDefault(__webpack_require__(/*! ./signin/SignInWithDeviceOption */ "./src/v2/view-builder/views/signin/SignInWithDeviceOption.js"));
var _SignInWithWebAuthn = _interopRequireDefault(__webpack_require__(/*! ./signin/SignInWithWebAuthn */ "./src/v2/view-builder/views/signin/SignInWithWebAuthn.js"));
var _i18nTransformer = __webpack_require__(/*! ../../ion/i18nTransformer */ "./src/v2/ion/i18nTransformer.js");
var _LinksUtil = __webpack_require__(/*! ../utils/LinksUtil */ "./src/v2/view-builder/utils/LinksUtil.js");
var _CookieUtil = _interopRequireDefault(__webpack_require__(/*! util/CookieUtil */ "./src/util/CookieUtil.js"));
var _CustomAccessDeniedErrorMessage = _interopRequireDefault(__webpack_require__(/*! ./shared/CustomAccessDeniedErrorMessage */ "./src/v2/view-builder/views/shared/CustomAccessDeniedErrorMessage.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CUSTOM_ACCESS_DENIED_KEY = 'security.access_denied_custom_message';
const Body = _internals.BaseForm.extend({
  title() {
    return (0, _courage.loc)('primaryauth.title', 'login');
  },
  save() {
    return (0, _courage.loc)('oform.next', 'login');
  },
  initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    const uiSchema = this.getUISchema();
    if (uiSchema.find(schema => schema.name === 'credentials.passcode')) {
      this.save = (0, _courage.loc)('oie.primaryauth.submit', 'login');
    }

    // Precedence for pre-filling identifier field:
    // 1. Use username/identifier from the config.
    // 2. Use identifier value returned in remediation response (model will have this attr set if it's there)
    // 3. Use value from the "remember my username" cookie.
    if (this._shouldAddUsername(uiSchema)) {
      // Set username/identifier from the config (i.e. config.username)
      this.model.set('identifier', this.settings.get('username'));
    } else if (!this.model.get('identifier') && this._shouldApplyRememberMyUsername(uiSchema)) {
      // Use value from cookie if the remediation did not return identifier value.
      this._applyRememberMyUsername();
    }
  },
  saveForm() {
    // Ideally this can be added to a "preSaveForm" handler - but keeping this here for now.
    if (!this.settings.get('features.deviceFingerprinting')) {
      _internals.BaseForm.prototype.saveForm.apply(this, arguments);
      return;
    }

    // Before the XHR is made for "identify", we'll generate this one-time use fingerprint via
    // a hidden-iframe (similar to authn/v1 flows)
    const fingerprintData = {
      oktaDomainUrl: this.settings.get('baseUrl'),
      element: this.$el
    };

    // Toggle Form saving status (e.g. disabling save button, etc)
    this.model.trigger('request');

    // For certain flows, we need to generate a device fingerprint
    // to determine if we need to send a "New Device Sign-on Notification".
    // In the future, this should be handled completely by okta-auth-js OKTA-418160
    _DeviceFingerprinting.default.generateDeviceFingerprint(fingerprintData).then(fingerprint => {
      this.options.appState.set('deviceFingerprint', fingerprint);
    }).catch(() => {/* Keep going even if device fingerprint fails */}).finally(() => {
      _internals.BaseForm.prototype.saveForm.apply(this, arguments);
    });
  },
  render() {
    _internals.BaseForm.prototype.render.apply(this, arguments);

    // Launch Device Authenticator
    if (this.options.appState.hasRemediationObject(_RemediationConstants.FORMS.LAUNCH_AUTHENTICATOR)) {
      this.add(_SignInWithDeviceOption.default, '.o-form-fieldset-container', false, true, {
        isRequired: false
      });
    }
    if (this.options.appState.hasRemediationObject(_RemediationConstants.FORMS.LAUNCH_WEBAUTHN_AUTHENTICATOR)) {
      this.add(_SignInWithWebAuthn.default, '.o-form-fieldset-container', false, true, {
        isRequired: false
      });
    }

    // add forgot password link and external idps buttons if needed
    const idpButtons = (0, _internals.createIdpButtons)(this.options);
    if (Array.isArray(idpButtons) && idpButtons.length) {
      // Add the forgot password link before the buttons for multiple IDPs
      this._addForgotPasswordView();
      this._addIdpView(idpButtons);
    }
    const customButtons = (0, _internals.createCustomButtons)(this.options.settings);
    if (Array.isArray(customButtons) && customButtons.length) {
      this.add(_CustomButtons.default, {
        selector: '.o-form-button-bar',
        options: {
          customButtons,
          addSeparateLine: true
        }
      });
    }
  },
  postRender() {
    _internals.BaseForm.prototype.postRender.apply(this, arguments);
    // When a user enters invalid credentials, /introspect returns an error,
    // along with a user object containing the identifier entered by the user.
    this.$el.find('.identifier-container').remove();
  },
  /**
   * Update UI schemas for customization from .widgetrc.js or Admin Customization settings page.
   * @returns Array
   */
  getUISchema() {
    const schemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);
    const {
      settings
    } = this.options;
    const identifierExplainLabeli18nKey = 'primaryauth.username.tooltip';
    const passwordExplainLabeli18nKey = 'primaryauth.password.tooltip';
    let newSchemas = schemas.map(schema => {
      let newSchema = {
        ...schema
      };
      if (schema.name === 'identifier') {
        if ((0, _i18nTransformer.isCustomizedI18nKey)(identifierExplainLabeli18nKey, settings)) {
          newSchema = {
            ...newSchema,
            explain: (0, _courage.loc)(identifierExplainLabeli18nKey, 'login'),
            'explain-top': true
          };
        }

        // We enable the browser's autocomplete for the identifier input
        // because we want to allow the user to choose from previously used identifiers.
        newSchema = {
          ...newSchema,
          autoComplete: _Util.default.getAutocompleteValue(this.options.settings, 'username')
        };
      } else if (schema.name === 'credentials.passcode') {
        newSchema = {
          ...newSchema,
          autoComplete: _Util.default.getAutocompleteValue(this.options.settings, 'current-password')
        };
        if ((0, _i18nTransformer.isCustomizedI18nKey)(passwordExplainLabeli18nKey, settings)) {
          newSchema = {
            ...newSchema,
            explain: (0, _courage.loc)(passwordExplainLabeli18nKey, 'login'),
            'explain-top': true
          };
        }
      }
      return newSchema;
    });

    // If showKeepMeSignedIn is explicitly set to false, we ensure we don't display
    // the "Keep me signed in" checkbox
    if (this.settings.get('features.showKeepMeSignedIn') === false) {
      newSchemas = newSchemas.filter(schema => schema.name !== 'rememberMe');
    }
    return newSchemas;
  },
  showCustomFormErrorCallout(error, messages) {
    var _error$responseJSON, _error$responseJSON$e;
    if (!(error !== null && error !== void 0 && (_error$responseJSON = error.responseJSON) !== null && _error$responseJSON !== void 0 && (_error$responseJSON$e = _error$responseJSON.errorSummaryKeys) !== null && _error$responseJSON$e !== void 0 && _error$responseJSON$e.includes(CUSTOM_ACCESS_DENIED_KEY))) {
      return false;
    }
    const message = messages === null || messages === void 0 ? void 0 : messages.find(message => message.i18n.key === CUSTOM_ACCESS_DENIED_KEY);
    if (!message) {
      return false;
    }
    const {
      errorSummary
    } = error.responseJSON;
    const options = {
      type: 'error',
      content: new _CustomAccessDeniedErrorMessage.default({
        message: errorSummary,
        links: message.links
      })
    };
    this.showMessages((0, _courage.createCallout)(options));
    return true;
  },
  _addForgotPasswordView() {
    const forgotPasswordLink = (0, _LinksUtil.getForgotPasswordLink)(this.options.appState, this.options.settings);
    if (forgotPasswordLink.length) {
      this.add('<div class="links-primary"></div>', {
        selector: '.o-form-button-bar'
      });
      this.add(_Link.default, {
        selector: '.links-primary',
        options: forgotPasswordLink[0]
      });
    }
  },
  _addIdpView(idpButtons) {
    // We check the 'idpDisplay' option config to determine whether to render the idp buttons
    // above or below the login fields
    const idpDisplay = this.options.settings.get('idpDisplay');
    const isPrimaryIdpDisplay = idpDisplay && idpDisplay.toUpperCase() === 'PRIMARY';
    this.add(_SignInWithIdps.default, {
      prepend: isPrimaryIdpDisplay,
      selector: isPrimaryIdpDisplay ? '.o-form-fieldset-container' : '.o-form-button-bar',
      options: {
        idpButtons,
        isPrimaryIdpDisplay
      }
    });
  },
  _shouldAddUsername(uiSchema) {
    // We pre-populate the identifier/username field only if we're in an identifier
    // form and if the option is passed in.
    return uiSchema.find(schema => schema.name === 'identifier') && this.settings.get('username');
  },
  _shouldApplyRememberMyUsername(uiSchema) {
    return uiSchema.find(schema => schema.name === 'identifier') && this.settings.get('features.rememberMe');
  },
  /**
   * When "Remember My Username" is enabled, we pre-fill the identifier
   * field with the saved userName cookie. The cookie would have been originally
   * saved when submitting the form previously.
   */
  _applyRememberMyUsername() {
    const cookieUsername = _CookieUtil.default.getCookieUsername();
    if (cookieUsername) {
      this.model.set('identifier', cookieUsername);
    }
  }
});
var _default = _internals.BaseView.extend({
  Body,
  createModelClass() {
    const ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments);

    // customize pre-submit form validation inline error messages
    const identifierRequiredi18nKey = 'error.username.required';
    const passwordRequiredi18nKey = 'error.password.required';
    const props = ModelClass.prototype.props;
    const validate = attr => {
      const inlineErrors = {};
      const isEmptyIdentifier = props['identifier'] && !(attr !== null && attr !== void 0 && attr['identifier']);
      const isEmptyPassword = props['credentials.passcode'] && !(attr !== null && attr !== void 0 && attr['credentials.passcode']);
      if (isEmptyIdentifier && (0, _i18nTransformer.isCustomizedI18nKey)(identifierRequiredi18nKey, this.settings)) {
        inlineErrors['identifier'] = (0, _courage.loc)(identifierRequiredi18nKey, 'login');
      }
      if (isEmptyPassword && (0, _i18nTransformer.isCustomizedI18nKey)(passwordRequiredi18nKey, this.settings)) {
        inlineErrors['credentials.passcode'] = (0, _courage.loc)(passwordRequiredi18nKey, 'login');
      }
      return inlineErrors;
    };
    return ModelClass.extend({
      validate
    });
  },
  initialize() {
    // Override Footer by overriding showForgotPasswordLink method
    this.Footer = _IdentifierFooter.default.extend({
      showForgotPasswordLink: () => {
        // We don't add the forgot password link in the footer if SIW renders multi IDPs,
        // instead in that case we add it before the IDP buttons in IdentifierView as primary links.
        const idpButtons = (0, _internals.createIdpButtons)(this.options);
        return !this.options.appState.isIdentifierOnlyView() && (!Array.isArray(idpButtons) || idpButtons.length === 0);
      }
    });
  },
  postRender() {
    _internals.BaseView.prototype.postRender.apply(this, arguments);

    // If user entered identifier is not found, API sends back a message with a link to sign up
    // This is the click handler for that link
    const appState = this.options.appState;
    this.$el.find('.js-sign-up').click(function () {
      appState.trigger('invokeAction', _RemediationConstants.FORMS.SELECT_ENROLL_PROFILE);
      return false;
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/IdentifyRecoveryView.js":
/*!***********************************************************!*\
  !*** ./src/v2/view-builder/views/IdentifyRecoveryView.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../internals */ "./src/v2/view-builder/internals/index.js");
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend({
  title() {
    return (0, _courage.loc)('password.reset.title.generic', 'login');
  },
  save() {
    return (0, _courage.loc)('oform.next', 'login');
  },
  initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    const identifier = this.options.appState.get('lastIdentifier');
    if (identifier) {
      this.model.set('identifier', identifier);
      // Toggle Form saving status (e.g. disabling save button, etc)
      this.model.trigger('request');
      // Auto submit
      this.trigger('save', this.model);
    }
  },
  getUISchema() {
    const schemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);
    let newSchemas = schemas.map(schema => {
      let newSchema = {
        ...schema
      };
      if (schema.name === 'identifier') {
        // We enable the browser's autocomplete for the identifier input
        // because we want to allow the user to choose from previously used identifiers.
        newSchema = {
          ...newSchema,
          autoComplete: _Util.default.getAutocompleteValue(this.options.settings, 'username')
        };
      }
      return newSchema;
    });
    return newSchemas;
  }
});
var _default = _internals.BaseView.extend({
  Body,
  Footer: _internals.BaseFooter
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/PollView.js":
/*!***********************************************!*\
  !*** ./src/v2/view-builder/views/PollView.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../internals */ "./src/v2/view-builder/internals/index.js");
var _Constants = __webpack_require__(/*! ../utils/Constants */ "./src/v2/view-builder/utils/Constants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PollMessageView = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<div class=\"ion-messages-container\"><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='strong'>$1</span>",
          "arguments": "countDownCounterValue",
          "bundle": "login",
          "code": "poll.form.message"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 39
          },
          "end": {
            "line": 1,
            "column": 157
          }
        }
      })) + "</p></div><div class=\"hide okta-waiting-spinner\"></div>";
    },
    "useData": true
  }),
  getTemplateData() {
    const countDownCounterValue = this.options;
    return {
      countDownCounterValue
    };
  }
});
const Body = _internals.BaseForm.extend(Object.assign({
  title() {
    return (0, _courage.loc)('poll.form.title', 'login');
  },
  noButtonBar: true,
  initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    const refreshInterval = this.options.appState.getCurrentViewState().refresh;
    this.refreshTimeout = setTimeout(() => {
      this.$el.find('.okta-waiting-spinner').show();
      // start after a small delay so that the spinner does not get hidden too soon
      setTimeout(() => this.saveForm(this.model), 200);
    }, refreshInterval);
  },
  render() {
    _internals.BaseForm.prototype.render.apply(this, arguments);
    this.countDownCounterValue = Math.ceil(this.options.appState.getCurrentViewState().refresh / _Constants.MS_PER_SEC);
    this.add(new PollMessageView(this.countDownCounterValue));
    this.startCountDown('.ion-messages-container span', _Constants.MS_PER_SEC);
  },
  remove() {
    _internals.BaseForm.prototype.remove.apply(this, arguments);
    clearTimeout(this.refreshTimeout);
  },
  triggerAfterError() {
    _internals.BaseForm.prototype.triggerAfterError.apply(this, arguments);
    clearTimeout(this.refreshTimeout);
    this.stopCountDown();
    this.$el.find('.o-form-fieldset-container').empty();
  },
  startCountDown(selector, interval) {
    if (this.countDown) {
      clearInterval(this.countDown);
    }
    this.counterEl = this.$el.find(selector);
    this.countDown = setInterval(() => {
      if (this.counterEl.text() !== '0') {
        this.counterEl.text(this.counterEl.text() - 1);
      }
    }, interval, this);
  },
  stopCountDown() {
    if (this.countDown) {
      clearInterval(this.countDown);
    }
  }
}));
var _default = _internals.BaseView.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/RedirectIdPView.js":
/*!******************************************************!*\
  !*** ./src/v2/view-builder/views/RedirectIdPView.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _IdentifierView = _interopRequireDefault(__webpack_require__(/*! ./IdentifierView */ "./src/v2/view-builder/views/IdentifierView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _IdentifierView.default.extend({
  render() {
    _IdentifierView.default.prototype.render.apply(this, arguments);
    this.$el.find('.sign-in-with-idp .separation-line').hide();
    this.$el.find('.button-primary').hide();
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/SelectAuthenticatorEnrollView.js":
/*!********************************************************************!*\
  !*** ./src/v2/view-builder/views/SelectAuthenticatorEnrollView.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _internals = __webpack_require__(/*! ../internals */ "./src/v2/view-builder/internals/index.js");
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
const Body = _internals.BaseForm.extend({
  title: function () {
    return (0, _courage.loc)('oie.select.authenticators.enroll.title', 'login');
  },
  subtitle: function () {
    const subtitle = this.options.settings.get('brandName') ? (0, _courage.loc)('oie.select.authenticators.enroll.subtitle.custom', 'login', [this.options.settings.get('brandName')]) : (0, _courage.loc)('oie.select.authenticators.enroll.subtitle', 'login');
    return subtitle;
  },
  noButtonBar: true
});
var _default = _internals.BaseView.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/SelectAuthenticatorVerifyView.js":
/*!********************************************************************!*\
  !*** ./src/v2/view-builder/views/SelectAuthenticatorVerifyView.js ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.Body = void 0;
var _internals = __webpack_require__(/*! ../internals */ "./src/v2/view-builder/internals/index.js");
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _BaseFooter = _interopRequireDefault(__webpack_require__(/*! ../internals/BaseFooter */ "./src/v2/view-builder/internals/BaseFooter.js"));
var _LinksUtil = __webpack_require__(/*! ../utils/LinksUtil */ "./src/v2/view-builder/utils/LinksUtil.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const UNLOCK_USER_SUCCESS_MESSAGE = 'oie.selfservice.unlock_user.landing.to.app.success.message';
const Body = _internals.BaseForm.extend({
  title: function () {
    if (this.isPasswordRecoveryFlow()) {
      return (0, _courage.loc)('password.reset.title.generic', 'login');
    }
    return (0, _courage.loc)('oie.select.authenticators.verify.title', 'login');
  },
  subtitle: function () {
    if (this.isPasswordRecoveryFlow()) {
      return (0, _courage.loc)('oie.password.reset.verification', 'login');
    }
    if (this.isUnlockSuccess()) {
      const container = '.o-form-error-container';
      const text = (0, _courage.loc)('oie.select.authenticators.verify.subtitle', 'login');
      this.add(`<div class="ion-messages-container"><p>${text}</p></div>`, container);
      return;
    }
    return (0, _courage.loc)('oie.select.authenticators.verify.subtitle', 'login');
  },
  isPasswordRecoveryFlow() {
    return this.options.appState.get('isPasswordRecovery');
  },
  noButtonBar: true,
  showMessages() {
    if (this.isUnlockSuccess()) {
      let options = {};
      options.subtitle = (0, _courage.loc)('oie.selfservice.unlock_user.landing.to.app.success.message', 'login');
      options.type = 'success';
      options = (0, _courage.createCallout)(options);
      _internals.BaseForm.prototype.showMessages.call(this, options);
      return;
    }
    _internals.BaseForm.prototype.showMessages.call(this);
  },
  isUnlockSuccess() {
    return this.options.appState.containsMessageWithI18nKey(UNLOCK_USER_SUCCESS_MESSAGE);
  }
});
exports.Body = Body;
var _default = _internals.BaseView.extend({
  Body,
  Footer: _BaseFooter.default.extend({
    links() {
      return (0, _LinksUtil.getFactorPageCustomLink)(this.options.appState, this.options.settings);
    }
  })
});
exports["default"] = _default;

/***/ }),

/***/ "./src/v2/view-builder/views/TerminalView.js":
/*!***************************************************!*\
  !*** ./src/v2/view-builder/views/TerminalView.js ***!
  \***************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.REGISTRATION_NOT_ENABLED = exports.FORGOT_PASSWORD_NOT_ENABLED = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../internals */ "./src/v2/view-builder/internals/index.js");
var _LinksUtil = __webpack_require__(/*! ../utils/LinksUtil */ "./src/v2/view-builder/utils/LinksUtil.js");
var _EmailAuthenticatorHeader = _interopRequireDefault(__webpack_require__(/*! ../components/EmailAuthenticatorHeader */ "./src/v2/view-builder/components/EmailAuthenticatorHeader.js"));
var _EmailMagicLinkOTPTerminalView = __webpack_require__(/*! ./consent/EmailMagicLinkOTPTerminalView */ "./src/v2/view-builder/views/consent/EmailMagicLinkOTPTerminalView.js");
var _CustomAccessDeniedErrorMessage = _interopRequireDefault(__webpack_require__(/*! ./shared/CustomAccessDeniedErrorMessage */ "./src/v2/view-builder/views/shared/CustomAccessDeniedErrorMessage.js"));
var _EndUserRemediationTerminalMessage = _interopRequireDefault(__webpack_require__(/*! ./end-user-remediation/EndUserRemediationTerminalMessage */ "./src/v2/view-builder/views/end-user-remediation/EndUserRemediationTerminalMessage.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const RETURN_LINK_EXPIRED_KEY = 'idx.return.link.expired';
const IDX_RETURN_LINK_OTP_ONLY = 'idx.enter.otp.in.original.tab';
const SAFE_MODE_KEY_PREFIX = 'idx.error.server.safe.mode';
const UNLOCK_ACCOUNT_TERMINAL_KEY = 'oie.selfservice.unlock_user.success.message';
const UNLOCK_ACCOUNT_FAILED_PERMISSIONS = 'oie.selfservice.unlock_user.challenge.failed.permissions';
const RESET_PASSWORD_NOT_ALLOWED = 'oie.selfservice.reset.password.not.allowed';
const RETURN_TO_ORIGINAL_TAB_KEY = 'idx.return.to.original.tab';
const OPERATION_CANCELED_ON_OTHER_DEVICE_KEY = 'idx.operation.cancelled.on.other.device';
const OPERATION_CANCELED_BY_USER_KEY = 'idx.operation.cancelled.by.user';
const DEVICE_ACTIVATED = 'idx.device.activated';
const DEVICE_NOT_ACTIVATED_CONSENT_DENIED = 'idx.device.not.activated.consent.denied';
const DEVICE_NOT_ACTIVATED_INTERNAL_ERROR = 'idx.device.not.activated.internal.error';
const FLOW_CONTINUE_IN_NEW_TAB = 'idx.transferred.to.new.tab';
const EMAIL_LINK_OUT_OF_DATE = 'idx.return.stale';
const EMAIL_LINK_CANT_BE_PROCESSED = 'idx.return.error';
const EMAIL_VERIFICATION_REQUIRED = 'idx.email.verification.required';
const END_USER_REMEDIATION_KEY_PREFIX = 'idx.error.code.access_denied.device_assurance.remediation.';
const EMAIL_ACTIVATION_EMAIL_EXPIRE = 'idx.expired.activation.token';
const EMAIL_ACTIVATION_EMAIL_INVALID = 'idx.missing.activation.token';
const EMAIL_ACTIVATION_EMAIL_SUBMITTED = 'idx.request.activation.email';
const EMAIL_ACTIVATION_EMAIL_SUSPENDED = 'idx.activating.inactive.user';
const CUSTOM_ACCESS_DENIED_KEY = 'security.access_denied_custom_message';
const REGISTRATION_NOT_ENABLED = 'oie.registration.is.not.enabled';
exports.REGISTRATION_NOT_ENABLED = REGISTRATION_NOT_ENABLED;
const FORGOT_PASSWORD_NOT_ENABLED = 'oie.forgot.password.is.not.enabled';
exports.FORGOT_PASSWORD_NOT_ENABLED = FORGOT_PASSWORD_NOT_ENABLED;
const EMAIL_AUTHENTICATOR_TERMINAL_KEYS = [FLOW_CONTINUE_IN_NEW_TAB, EMAIL_LINK_OUT_OF_DATE, EMAIL_LINK_CANT_BE_PROCESSED, EMAIL_VERIFICATION_REQUIRED, RETURN_TO_ORIGINAL_TAB_KEY, RETURN_LINK_EXPIRED_KEY, OPERATION_CANCELED_ON_OTHER_DEVICE_KEY, OPERATION_CANCELED_BY_USER_KEY, IDX_RETURN_LINK_OTP_ONLY];
const DEVICE_CODE_ERROR_KEYS = [DEVICE_NOT_ACTIVATED_CONSENT_DENIED, DEVICE_NOT_ACTIVATED_INTERNAL_ERROR];
const DEVICE_CODE_FLOW_TERMINAL_KEYS = [DEVICE_ACTIVATED, ...DEVICE_CODE_ERROR_KEYS];

// These terminal views build their own links, basically they have cancel remediation in error response
// Or doesn't require a Back to Sign in link because the flow didn't start from login screen
const NO_BACKTOSIGNIN_LINK_VIEWS = [UNLOCK_ACCOUNT_TERMINAL_KEY, RETURN_TO_ORIGINAL_TAB_KEY, FLOW_CONTINUE_IN_NEW_TAB, OPERATION_CANCELED_ON_OTHER_DEVICE_KEY, ...DEVICE_CODE_FLOW_TERMINAL_KEYS, UNLOCK_ACCOUNT_FAILED_PERMISSIONS, RESET_PASSWORD_NOT_ALLOWED, IDX_RETURN_LINK_OTP_ONLY];

// Key map to transform terminal view titles {ApiKey : WidgetKey}  
const terminalViewTitles = {
  [RETURN_LINK_EXPIRED_KEY]: 'oie.email.return.link.expired.title',
  [UNLOCK_ACCOUNT_TERMINAL_KEY]: 'account.unlock.unlocked.title',
  [DEVICE_ACTIVATED]: 'device.code.activated.success.title',
  [REGISTRATION_NOT_ENABLED]: 'oie.registration.form.title',
  [FORGOT_PASSWORD_NOT_ENABLED]: 'password.reset.title.generic',
  [EMAIL_ACTIVATION_EMAIL_EXPIRE]: 'oie.activation.request.email.title.expire',
  [EMAIL_ACTIVATION_EMAIL_SUBMITTED]: 'oie.activation.request.email.title.submitted',
  [EMAIL_ACTIVATION_EMAIL_SUSPENDED]: 'oie.activation.request.email.title.suspended',
  [EMAIL_ACTIVATION_EMAIL_INVALID]: 'oie.activation.request.email.title.invalid',
  [DEVICE_NOT_ACTIVATED_CONSENT_DENIED]: 'device.code.activated.error.title',
  [DEVICE_NOT_ACTIVATED_INTERNAL_ERROR]: 'device.code.activated.error.title',
  [RETURN_TO_ORIGINAL_TAB_KEY]: 'oie.consent.enduser.email.allow.title',
  [IDX_RETURN_LINK_OTP_ONLY]: 'idx.return.link.otponly.your.verification.code'
};
const Body = _internals.BaseForm.extend({
  noButtonBar: true,
  postRender() {
    _internals.BaseForm.prototype.postRender.apply(this, arguments);
    this.$el.addClass('terminal-state');

    // show device code terminal icons
    if (this.options.appState.containsMessageWithI18nKey(DEVICE_CODE_FLOW_TERMINAL_KEYS)) {
      const iconClass = this.options.appState.containsMessageWithI18nKey(DEVICE_ACTIVATED) ? 'success-24-green' : 'error-24-red';
      this.$('.o-form-head').before('<div class="device-code-terminal--icon-container">' + '<span class="device-code-terminal--icon ' + iconClass + '"></span>' + '</div>');
    }
  },
  title() {
    return this.getTerminalViewTitle();
  },
  getTerminalViewTitle() {
    if (this.options.appState.containsMessageStartingWithI18nKey(SAFE_MODE_KEY_PREFIX)) {
      return (0, _courage.loc)('oie.safe.mode.title', 'login');
    }
    const apiKeys = Object.keys(terminalViewTitles);
    const key = apiKeys.find(key => this.options.appState.containsMessageWithI18nKey(key));
    if (key) {
      return (0, _courage.loc)(terminalViewTitles[key], 'login');
    }
  },
  prepareMessageForCustomView(messagesObjs) {
    let hasCustomView = false;
    if (this.options.appState.containsMessageWithI18nKey(IDX_RETURN_LINK_OTP_ONLY)) {
      this.add(_EmailMagicLinkOTPTerminalView.OTPInformationTerminalView);
      hasCustomView = true;
    } else if (this.options.appState.containsMessageStartingWithI18nKey(CUSTOM_ACCESS_DENIED_KEY)) {
      this.add((0, _courage.createCallout)({
        type: 'error',
        content: new _CustomAccessDeniedErrorMessage.default({
          message: messagesObjs.value[0].message,
          links: messagesObjs.value[0].links
        })
      }));
      hasCustomView = true;
    } else if (this.options.appState.containsMessageStartingWithI18nKey(END_USER_REMEDIATION_KEY_PREFIX)) {
      this.add((0, _courage.createCallout)({
        type: 'error',
        content: new _EndUserRemediationTerminalMessage.default({
          messages: messagesObjs
        })
      }));
      hasCustomView = true;
    }
    return hasCustomView;
  },
  showMessages() {
    const messagesObjs = this.options.appState.get('messages');
    let hasCustomView = false;
    let description;
    if (this.options.appState.containsMessageWithI18nKey(OPERATION_CANCELED_ON_OTHER_DEVICE_KEY)) {
      description = (0, _courage.loc)('idx.operation.cancelled.on.other.device', 'login');
      messagesObjs.value.push({
        message: (0, _courage.loc)('oie.consent.enduser.deny.description', 'login')
      });
    } else if (this.options.appState.containsMessageWithI18nKey(RETURN_TO_ORIGINAL_TAB_KEY)) {
      description = (0, _courage.loc)('oie.consent.enduser.email.allow.description', 'login');
      messagesObjs.value.push({
        message: (0, _courage.loc)('oie.return.to.original.tab', 'login')
      });
    } else if (this.options.appState.containsMessageWithI18nKey('tooManyRequests')) {
      description = (0, _courage.loc)('oie.tooManyRequests', 'login');
    } else if (this.options.appState.containsMessageWithI18nKey(RETURN_LINK_EXPIRED_KEY)) {
      messagesObjs.value[0].class = 'ERROR';
    } else {
      hasCustomView = this.prepareMessageForCustomView(messagesObjs);
    }
    if (description && Array.isArray(messagesObjs === null || messagesObjs === void 0 ? void 0 : messagesObjs.value)) {
      messagesObjs.value[0].message = description;
    }
    this.options.appState.set('messages', messagesObjs);
    if (!hasCustomView) {
      _internals.BaseForm.prototype.showMessages.call(this);
    }
  }
});
const Footer = _internals.BaseFooter.extend({
  // All terminal views should have Back to sign in link either widget configured or server configured.
  links: function () {
    if (this.options.appState.containsMessageStartingWithI18nKey(SAFE_MODE_KEY_PREFIX)) {
      return (0, _LinksUtil.getSkipSetupLink)(this.options.appState);
    }
    if (this.options.appState.containsMessageWithI18nKey(DEVICE_CODE_ERROR_KEYS)) {
      return (0, _LinksUtil.getReloadPageButtonLink)();
    }
    // If cancel object exists idx response then view would take care of rendering back to sign in link
    const shouldShowBackToSignInLink = !this.options.appState.hasActionObject('cancel') && !this.options.appState.containsMessageWithI18nKey(NO_BACKTOSIGNIN_LINK_VIEWS) && !this.options.settings.get('features.hideSignOutLinkInMFA') && !this.options.settings.get('features.mfaOnlyFlow');
    if (shouldShowBackToSignInLink) {
      // TODO OKTA-432869 "back to sign in" links to org baseUrl, does not work correctly with embedded widget
      return (0, _LinksUtil.getBackToSignInLink)(this.options);
    }
  }
});
var _default = _internals.BaseView.extend({
  initialize() {
    _internals.BaseView.prototype.initialize.apply(this, arguments);
    if (this.options.appState.containsMessageWithI18nKey(EMAIL_AUTHENTICATOR_TERMINAL_KEYS)) {
      this.Header = _EmailAuthenticatorHeader.default;
    }
  },
  Body,
  Footer
});
exports["default"] = _default;

/***/ }),

/***/ "./src/v2/view-builder/views/activation/RequestActivationEmailView.js":
/*!****************************************************************************!*\
  !*** ./src/v2/view-builder/views/activation/RequestActivationEmailView.js ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
const Body = _internals.BaseForm.extend({
  title() {
    return (0, _courage.loc)('oie.activation.request.email.title.expire', 'login');
  },
  save() {
    return (0, _courage.loc)('oie.activation.request.email.button', 'login');
  }
});
var _default = _internals.BaseView.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/authenticator/SelectAuthenticatorUnlockAccountView.js":
/*!*****************************************************************************************!*\
  !*** ./src/v2/view-builder/views/authenticator/SelectAuthenticatorUnlockAccountView.js ***!
  \*****************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
const Body = _internals.BaseForm.extend({
  noButtonBar: true,
  title: function () {
    return (0, _courage.loc)('oie.select.authenticators.verify.title', 'login');
  },
  subtitle: function () {
    return (0, _courage.loc)('oie.select.authenticators.verify.subtitle', 'login');
  }
});
var _default = _internals.BaseView.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/authenticator/UnlockAccountView.js":
/*!**********************************************************************!*\
  !*** ./src/v2/view-builder/views/authenticator/UnlockAccountView.js ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
const UnlockAccountView = _internals.BaseForm.extend({
  title: () => {
    return (0, _courage.loc)('account.unlock.title', 'login');
  }
});
var _default = _internals.BaseView.extend({
  initialize() {
    _internals.BaseView.prototype.initialize.apply(this, arguments);
    this.Body = UnlockAccountView;
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/captcha/CaptchaView.js":
/*!**********************************************************!*\
  !*** ./src/v2/view-builder/views/captcha/CaptchaView.js ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _Constants = __webpack_require__(/*! ../../utils/Constants */ "./src/v2/view-builder/utils/Constants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const OktaSignInWidgetOnCaptchaLoadedCallback = 'OktaSignInWidgetOnCaptchaLoaded';
const OktaSignInWidgetOnCaptchaSolvedCallback = 'OktaSignInWidgetOnCaptchaSolved';
const HCAPTCHA_URL = 'https://hcaptcha.com/1/api.js';
const RECAPTCHAV2_URL = 'https://www.google.com/recaptcha/api.js';
var _default = _courage.View.extend({
  className: 'captcha-view',
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div id =\"captcha-container\" class=\"" + alias4((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "className",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 63
          },
          "end": {
            "line": 1,
            "column": 76
          }
        }
      }) : helper)) + "\" data-sitekey=\"" + alias4((helper = (helper = lookupProperty(helpers, "siteKey") || (depth0 != null ? lookupProperty(depth0, "siteKey") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "siteKey",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 92
          },
          "end": {
            "line": 1,
            "column": 103
          }
        }
      }) : helper)) + "\" data-callback=\"" + alias4((helper = (helper = lookupProperty(helpers, "onCaptchaSolvedCallback") || (depth0 != null ? lookupProperty(depth0, "onCaptchaSolvedCallback") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "onCaptchaSolvedCallback",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 120
          },
          "end": {
            "line": 1,
            "column": 147
          }
        }
      }) : helper)) + "\" data-size=\"invisible\"></div>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "isCaptchaConfigured") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 184
          }
        }
      })) != null ? stack1 : "";
    },
    "useData": true
  }),
  getTemplateData: function () {
    if (this.captchaConfig) {
      const className = this.captchaConfig.type === 'HCAPTCHA' ? 'h-captcha' : 'g-recaptcha';
      return {
        siteKey: this.captchaConfig.siteKey,
        isCaptchaConfigured: true,
        onCaptchaSolvedCallback: OktaSignInWidgetOnCaptchaSolvedCallback,
        className
      };
    } else {
      return {};
    }
  },
  initialize() {
    if (this.options.appState.get('captcha')) {
      this.captchaConfig = this.options.appState.get('captcha');
      this._addCaptcha();
    }
  },
  remove: function () {
    _courage.View.prototype.remove.apply(this, arguments);

    // Cleanup global Captcha references
    if (this.captchaConfig.type === 'HCAPTCHA') {
      window.hcaptcha = undefined;
    } else if (this.captchaConfig.type === 'RECAPTCHA_V2') {
      window.grecaptcha = undefined;
    }
  },
  /**
   *  Load the CAPTCHA lib dynamically (either HCAPTCHA or RECAPTCHAV2). Once loaded, trigger an event to inform
   *  the parent form to actually render the CAPTCHA.
  * */
  _addCaptcha() {
    // Callback invoked when CAPTCHA is solved.
    const onCaptchaSolved = token => {
      const captchaObject = this._getCaptchaOject();

      // We reset the Captcha. We need to reset because every time the 
      // Captcha resolves back with a token and say we have a server side error, 
      // if we submit the form again it won't work otherwise. The Captcha 
      // has to be reset for it to work again in that scenario.
      const captchaId = this.$el.find('#captcha-container').attr('data-captcha-id');
      captchaObject.reset(captchaId);

      // Set the token in the model
      const fieldName = this.options.name;
      this.model.set(fieldName, token);
      this.options.appState.trigger('saveForm', this.model);
    };

    // Callback when CAPTCHA lib is loaded
    const onCaptchaLoaded = () => {
      // This is just a safeguard to ensure we don't bind Captcha to an already bound element.
      // It shouldn't happen in practice.
      if (this.$el.find('#captcha-container').attr('data-captcha-id')) {
        return;
      }
      const captchaObject = this._getCaptchaOject();

      // We set a temporary token for Captcha because this is a required field for the form and is normally set
      // at a later time. In order to prevent client-side validation errors because of this, we have to set a 
      // dummy value. We then overwrite this with the proper token in the onCaptchaSolved callback.
      this.model.set(this.options.name, 'tempToken');
      const captchaId = captchaObject.render('captcha-container', {
        sitekey: this.captchaConfig.siteKey,
        callback: onCaptchaSolved
      });
      this.$el.find('#captcha-container').attr('data-captcha-id', captchaId);

      // Let the Baseform know that Captcha is loaded.
      this.options.appState.trigger('onCaptchaLoaded', captchaObject);

      // Render the HCAPTCHA footer - we need to do this manually since the HCAPTCHA lib doesn't do it
      if (this.captchaConfig.type === 'HCAPTCHA') {
        this._addHCaptchaFooter();
      }
    };

    // Attaching the callback to the window object so that the CAPTCHA script that we dynamically render
    // can have access to it since it won't have access to this view's scope.
    window[OktaSignInWidgetOnCaptchaLoadedCallback] = onCaptchaLoaded;

    // Attaching the Captcha solved callback to the window object because we reference it in our template under
    // the 'data-callback' attribute which the Captcha library uses to invoke the callback.
    window[OktaSignInWidgetOnCaptchaSolvedCallback] = onCaptchaSolved;
    if (this.captchaConfig.type === 'HCAPTCHA') {
      this._loadCaptchaLib(this._getCaptchaUrl(HCAPTCHA_URL, 'hcaptcha'));
    } else if (this.captchaConfig.type === 'RECAPTCHA_V2') {
      this._loadCaptchaLib(this._getCaptchaUrl(RECAPTCHAV2_URL, 'recaptcha'));
    }
  },
  /**
   *  We dynamically inject <script> tag into our login container because in case the customer is hosting
   *  the SIW, we need to ensure we don't go out of scope when injecting the script.
  * */
  _loadCaptchaLib(url) {
    let scriptTag = document.createElement('script');
    scriptTag.src = url;
    scriptTag.async = true;
    scriptTag.defer = true;
    document.getElementById(_Enums.default.WIDGET_CONTAINER_ID).appendChild(scriptTag);
  },
  _addHCaptchaFooter() {
    // NOTE: insetAdjacentHTML() is supported in all major browsers: 
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentHTML#browser_compatibility
    const footerContainer = document.getElementsByClassName(_Constants.WIDGET_FOOTER_CLASS);
    if (footerContainer.length) {
      const template = _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function (container, depth0, helpers, partials, data) {
          var lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }
            return undefined;
          };
          return "<div class=\"captcha-footer\"><span class=\"footer-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "i18n",
            "hash": {
              "$2": "<a href='https://hcaptcha.com/terms' target='_blank'>$2</a>",
              "$1": "<a href='https://hcaptcha.com/privacy' target='_blank'>$1</a>",
              "bundle": "login",
              "code": "hcaptcha.footer.label"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 54
              },
              "end": {
                "line": 1,
                "column": 238
              }
            }
          })) + "</span></div>";
        },
        "useData": true
      });
      footerContainer[0].insertAdjacentHTML('beforeend', template());
    }
  },
  _getCaptchaOject() {
    const captchaObject = this.captchaConfig.type === 'HCAPTCHA' ? window.hcaptcha : window.grecaptcha;
    return captchaObject;
  },
  /**
   *  Supported params for hCaptcha script:
   *   https://github.com/hCaptcha/hcaptcha-loader#props
   *   (starting from 'apihost')
   *  Supported params for reCAPTCHA script:
   *   https://developers.google.com/recaptcha/docs/display#javascript_resource_apijs_parameters
  * */
  _getCaptchaUrl(defaultBaseUrl, settingsKey) {
    const locale = this.options.settings.get('language');
    const scriptSource = this.options.settings.get(`${settingsKey}.scriptSource`);
    const scriptParams = this.options.settings.get(`${settingsKey}.scriptParams`);
    const baseUrl = scriptSource || defaultBaseUrl;
    const params = {
      ...scriptParams,
      onload: OktaSignInWidgetOnCaptchaLoadedCallback,
      render: 'explicit',
      hl: locale || navigator.language
    };
    const query = _Util.default.searchParamsToString(params);
    return baseUrl + '?' + query;
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/consent/AdminConsentView.js":
/*!***************************************************************!*\
  !*** ./src/v2/view-builder/views/consent/AdminConsentView.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _AdminConsentViewHeader = _interopRequireDefault(__webpack_require__(/*! ./AdminConsentViewHeader */ "./src/v2/view-builder/views/consent/AdminConsentViewHeader.js"));
var _ConsentViewForm = _interopRequireDefault(__webpack_require__(/*! ./ConsentViewForm */ "./src/v2/view-builder/views/consent/ConsentViewForm.js"));
var _i18nTransformer = __webpack_require__(/*! ../../../ion/i18nTransformer */ "./src/v2/ion/i18nTransformer.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _internals.BaseView.extend({
  Header: _AdminConsentViewHeader.default,
  Body: _ConsentViewForm.default,
  createModelClass(currentViewState) {
    const ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments);
    const {
      uiSchema
    } = currentViewState;
    const {
      scopes
    } = uiSchema[0];
    const i18nKeyPrefix = 'consent.scopes';
    const localizedScopes = scopes.map(({
      name,
      displayName,
      description
    }) => {
      const scopeKey = `${i18nKeyPrefix}.${name}`;
      const labelKey = `${scopeKey}.label`;
      const descKey = `${scopeKey}.desc`;
      const doesLabelExist = (0, _i18nTransformer.doesI18NKeyExist)(labelKey);
      const doesDescExist = (0, _i18nTransformer.doesI18NKeyExist)(descKey);
      const i18nDisplayName = doesLabelExist ? (0, _courage.loc)(labelKey, 'login') : displayName;
      const i18nDescription = doesDescExist ? (0, _courage.loc)(descKey, 'login') : description;
      return {
        name,
        displayName: i18nDisplayName,
        description: i18nDescription,
        isCustomized: !doesLabelExist
      };
    });
    return ModelClass.extend({
      props: {
        scopes: {
          type: 'array',
          value: localizedScopes
        }
      },
      local: {
        consent: {
          type: 'boolean',
          value: false
        }
      },
      toJSON: function () {
        return {
          consent: this.get('consent')
        };
      }
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/consent/AdminConsentViewHeader.js":
/*!*********************************************************************!*\
  !*** ./src/v2/view-builder/views/consent/AdminConsentViewHeader.js ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const defaultLogo = '/img/logos/default.png';
const AdminConsentViewHeader = _courage.View.extend({
  className: 'consent-title detail-row',
  titleText: () => (0, _courage.loc)('oie.consent.scopes.admin.title', 'login'),
  hasIssuer: true,
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<a href=\"" + alias4((helper = (helper = lookupProperty(helpers, "clientURI") || (depth0 != null ? lookupProperty(depth0, "clientURI") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "clientURI",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 26
          },
          "end": {
            "line": 1,
            "column": 39
          }
        }
      }) : helper)) + "\" class=\"client-logo-link\" title=\"" + alias4((helper = (helper = lookupProperty(helpers, "altText") || (depth0 != null ? lookupProperty(depth0, "altText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "altText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 73
          },
          "end": {
            "line": 1,
            "column": 84
          }
        }
      }) : helper)) + "\" target=\"_blank\">";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<img class=\"client-logo custom-logo\" src=\"" + alias4((helper = (helper = lookupProperty(helpers, "customLogo") || (depth0 != null ? lookupProperty(depth0, "customLogo") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "customLogo",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 169
          },
          "end": {
            "line": 1,
            "column": 183
          }
        }
      }) : helper)) + "\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "altText") || (depth0 != null ? lookupProperty(depth0, "altText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "altText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 190
          },
          "end": {
            "line": 1,
            "column": 201
          }
        }
      }) : helper)) + "\" aria-hidden=\"true\" />";
    },
    "5": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<img class=\"client-logo default-logo\" src=\"" + alias4((helper = (helper = lookupProperty(helpers, "defaultLogo") || (depth0 != null ? lookupProperty(depth0, "defaultLogo") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "defaultLogo",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 275
          },
          "end": {
            "line": 1,
            "column": 290
          }
        }
      }) : helper)) + "\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "altText") || (depth0 != null ? lookupProperty(depth0, "altText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "altText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 297
          },
          "end": {
            "line": 1,
            "column": 308
          }
        }
      }) : helper)) + "\" aria-hidden=\"true\" />";
    },
    "7": function (container, depth0, helpers, partials, data) {
      return "</a>";
    },
    "9": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"issuer no-translate\"><span>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "issuer") || (depth0 != null ? lookupProperty(depth0, "issuer") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "issuer",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 513
          },
          "end": {
            "line": 1,
            "column": 523
          }
        }
      }) : helper)) + "</span></div>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 109
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "customLogo") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.program(5, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 109
          },
          "end": {
            "line": 1,
            "column": 338
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(7, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 338
          },
          "end": {
            "line": 1,
            "column": 366
          }
        }
      })) != null ? stack1 : "") + "<h1><span class=\"title-text\"><b class=\"no-translate\">" + alias4((helper = (helper = lookupProperty(helpers, "appName") || (depth0 != null ? lookupProperty(depth0, "appName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "appName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 419
          },
          "end": {
            "line": 1,
            "column": 430
          }
        }
      }) : helper)) + "</b>&nbsp;" + alias4((helper = (helper = lookupProperty(helpers, "titleText") || (depth0 != null ? lookupProperty(depth0, "titleText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "titleText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 440
          },
          "end": {
            "line": 1,
            "column": 453
          }
        }
      }) : helper)) + "</span>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "issuer") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(9, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 460
          },
          "end": {
            "line": 1,
            "column": 543
          }
        }
      })) != null ? stack1 : "") + "</h1>";
    },
    "useData": true
  }),
  getTemplateData: function () {
    const {
      appState
    } = this.options;
    const {
      label,
      clientUri,
      logo
    } = appState.get('app');
    const {
      issuer: issuerObj
    } = appState.get('authentication');
    const customLogo = logo === null || logo === void 0 ? void 0 : logo.href;
    const altText = (0, _courage.loc)('logo.for.the.app.alt.text', 'login');
    const appName = _courage._.escape(label);
    const clientURI = clientUri === null || clientUri === void 0 ? void 0 : clientUri.href;
    const issuer = this.hasIssuer ? issuerObj === null || issuerObj === void 0 ? void 0 : issuerObj.uri : null;
    const titleText = this.titleText();
    return {
      customLogo,
      defaultLogo,
      clientURI,
      issuer,
      altText,
      appName,
      titleText
    };
  }
});
var _default = AdminConsentViewHeader;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/consent/ConsentViewForm.js":
/*!**************************************************************!*\
  !*** ./src/v2/view-builder/views/consent/ConsentViewForm.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _default = _internals.BaseForm.extend({
  noButtonBar: false,
  noCancelButton: false,
  buttonOrder: ['cancel', 'save'],
  save: () => (0, _courage.loc)('consent.required.consentButton', 'login'),
  cancel: () => (0, _courage.loc)('consent.required.cancelButton', 'login'),
  title: false,
  events: {
    'click input[data-type="save"]': function () {
      this.setConsent(true);
    }
  },
  setConsent(bool) {
    this.model.set('consent', bool);
  },
  cancelForm() {
    // override BaseForm.prototype.cancelForm which cancels auth flow
    this.setConsent(false);
    this.options.appState.trigger('saveForm', this.model);
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/consent/EmailMagicLinkOTPTerminalView.js":
/*!****************************************************************************!*\
  !*** ./src/v2/view-builder/views/consent/EmailMagicLinkOTPTerminalView.js ***!
  \****************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.OTPInformationTerminalView = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const generateGeolocationString = (location = {}) => {
  if (!location.city && !location.country) {
    return null;
  }
  // Use 1 of 2 formats based on presence of 'state' in response:
  // 1. City, State, Country
  // 2. City, Country
  return location.state ? (0, _courage.loc)('geolocation.formatting.all', 'login', [location.city, location.state, location.country]) : (0, _courage.loc)('geolocation.formatting.partial', 'login', [location.city, location.country]);
};

// A map from FactorTransactionIntent in okta-core to customer-facing flow name
const challengeIntentToI18nKeyMap = {
  'AUTHENTICATION': 'idx.return.link.otponly.enter.code.on.sign.in.page',
  'RECOVERY': 'idx.return.link.otponly.enter.code.on.password.reset.page',
  'UNLOCK_ACCOUNT': 'idx.return.link.otponly.enter.code.on.account.unlock.page',
  'ENROLLMENT': 'idx.return.link.otponly.enter.code.on.sign.up.page'
};
const getTerminalOtpEmailMagicLinkContext = (settings, appState) => {
  var _appState$get, _appState$get$context;
  const app = appState.get('app');
  const client = appState.get('client');
  const challengeIntentContentKey = challengeIntentToI18nKeyMap[appState.get('idx').context.intent];
  const enterCodeOnFlowPage = challengeIntentContentKey ? (0, _courage.loc)(challengeIntentContentKey, 'login') : (0, _courage.loc)('idx.enter.otp.in.original.tab', 'login');
  let appName, browserOnOsString, isMobileDevice, geolocation;
  if (app !== null && app !== void 0 && app.label) {
    appName = (0, _courage.loc)('idx.return.link.otponly.app', 'login', [app.label]);
  }
  if (client) {
    browserOnOsString = (0, _courage.loc)('idx.return.link.otponly.browser.on.os', 'login', [client.browser, client.os]);
    isMobileDevice = browserOnOsString.includes('Android') || browserOnOsString.includes('iOS');
    geolocation = generateGeolocationString(client.location);
  }
  const otp = settings.get('otp') || ((_appState$get = appState.get('currentAuthenticator')) === null || _appState$get === void 0 ? void 0 : (_appState$get$context = _appState$get.contextualData) === null || _appState$get$context === void 0 ? void 0 : _appState$get$context.otp);
  return {
    showRequestInfo: appName || browserOnOsString || geolocation,
    appName,
    browserOnOsString,
    isMobileDevice,
    geolocation,
    otp,
    enterCodeOnFlowPage
  };
};
const BaseEmailMagicLinkOTPTerminalView = _courage.View.extend({
  getTemplateData() {
    return getTerminalOtpEmailMagicLinkContext(this.options.settings, this.options.appState);
  }
});
const OTPInformationTerminalView = BaseEmailMagicLinkOTPTerminalView.extend({
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<div class=\"enduser-email-otp-only--info\"><div class=\"okta-form-label\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "idx.return.link.otponly.request"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 198
          },
          "end": {
            "line": 1,
            "column": 260
          }
        }
      })) + "</div></div>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"enduser-email-otp-only--info\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isMobileDevice") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(4, data, 0),
        "inverse": container.program(6, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 346
          },
          "end": {
            "line": 1,
            "column": 540
          }
        }
      })) != null ? stack1 : "") + "<div data-se=\"otp-browser-os\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "browserOnOsString") || (depth0 != null ? lookupProperty(depth0, "browserOnOsString") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
        "name": "browserOnOsString",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 570
          },
          "end": {
            "line": 1,
            "column": 591
          }
        }
      }) : helper)) + "</div></div>";
    },
    "4": function (container, depth0, helpers, partials, data) {
      return "<i class=\"enduser-email-otp-only--icon icon--smartphone\" aria-hidden=\"true\"></i>";
    },
    "6": function (container, depth0, helpers, partials, data) {
      return "<i class=\"enduser-email-otp-only--icon icon--desktop\" aria-hidden=\"true\"></i>";
    },
    "8": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"enduser-email-otp-only--info\"><i class=\"enduser-email-otp-only--icon icon--app\" aria-hidden=\"true\"></i><div data-se=\"otp-app\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "appName") || (depth0 != null ? lookupProperty(depth0, "appName") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "appName",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 763
          },
          "end": {
            "line": 1,
            "column": 774
          }
        }
      }) : helper)) + "</div></div>";
    },
    "10": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"enduser-email-otp-only--info\"><i class=\"enduser-email-otp-only--icon icon--location\" aria-hidden=\"true\"></i><div data-se=\"otp-geolocation\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "geolocation") || (depth0 != null ? lookupProperty(depth0, "geolocation") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "geolocation",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 963
          },
          "end": {
            "line": 1,
            "column": 978
          }
        }
      }) : helper)) + "</div></div>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p class=\"enter-code-on-page\">" + alias4((helper = (helper = lookupProperty(helpers, "enterCodeOnFlowPage") || (depth0 != null ? lookupProperty(depth0, "enterCodeOnFlowPage") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "enterCodeOnFlowPage",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 30
          },
          "end": {
            "line": 1,
            "column": 53
          }
        }
      }) : helper)) + "</p><h1 class='otp-value no-translate'>" + alias4((helper = (helper = lookupProperty(helpers, "otp") || (depth0 != null ? lookupProperty(depth0, "otp") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "otp",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 92
          },
          "end": {
            "line": 1,
            "column": 99
          }
        }
      }) : helper)) + "</h1>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "showRequestInfo") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 104
          },
          "end": {
            "line": 1,
            "column": 279
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "browserOnOsString") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 279
          },
          "end": {
            "line": 1,
            "column": 610
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "appName") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(8, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 610
          },
          "end": {
            "line": 1,
            "column": 793
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "geolocation") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(10, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 793
          },
          "end": {
            "line": 1,
            "column": 997
          }
        }
      })) != null ? stack1 : "") + "<br><p class='otp-warning'>" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "idx.return.link.otponly.warning.text"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1024
          },
          "end": {
            "line": 1,
            "column": 1091
          }
        }
      })) + "</p>";
    },
    "useData": true
  })
});
exports.OTPInformationTerminalView = OTPInformationTerminalView;

/***/ }),

/***/ "./src/v2/view-builder/views/consent/EnduserConsentAgreementText.js":
/*!**************************************************************************!*\
  !*** ./src/v2/view-builder/views/consent/EnduserConsentAgreementText.js ***!
  \**************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _courage.View.extend({
  className: 'consent-description detail-row',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "consent.required.description"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3
          },
          "end": {
            "line": 1,
            "column": 62
          }
        }
      })) + "</p>";
    },
    "useData": true
  })
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/consent/EnduserConsentView.js":
/*!*****************************************************************!*\
  !*** ./src/v2/view-builder/views/consent/EnduserConsentView.js ***!
  \*****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _AdminConsentView = _interopRequireDefault(__webpack_require__(/*! ./AdminConsentView */ "./src/v2/view-builder/views/consent/AdminConsentView.js"));
var _EnduserConsentViewFooter = _interopRequireDefault(__webpack_require__(/*! ./EnduserConsentViewFooter */ "./src/v2/view-builder/views/consent/EnduserConsentViewFooter.js"));
var _EnduserConsentViewHeader = _interopRequireDefault(__webpack_require__(/*! ./EnduserConsentViewHeader */ "./src/v2/view-builder/views/consent/EnduserConsentViewHeader.js"));
var _EnduserConsentAgreementText = _interopRequireDefault(__webpack_require__(/*! ./EnduserConsentAgreementText */ "./src/v2/view-builder/views/consent/EnduserConsentAgreementText.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _AdminConsentView.default.extend({
  Header: _EnduserConsentViewHeader.default,
  Footer: _EnduserConsentViewFooter.default,
  postRender() {
    const scopeList = this.$el.find('.scope-list');
    const consentAgreementText = new _EnduserConsentAgreementText.default().render().el;
    scopeList.after(consentAgreementText);
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/consent/EnduserConsentViewFooter.js":
/*!***********************************************************************!*\
  !*** ./src/v2/view-builder/views/consent/EnduserConsentViewFooter.js ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ConsentViewFooter = _courage.View.extend({
  className: 'consent-footer',
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<a class=\"terms-of-service\" href=\"" + alias3((helper = (helper = lookupProperty(helpers, "termsOfService") || (depth0 != null ? lookupProperty(depth0, "termsOfService") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "termsOfService",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 56
          },
          "end": {
            "line": 1,
            "column": 74
          }
        }
      }) : helper)) + "\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "consent.required.termsOfService"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 92
          },
          "end": {
            "line": 1,
            "column": 154
          }
        }
      })) + "</a>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(2, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 158
          },
          "end": {
            "line": 1,
            "column": 226
          }
        }
      })) != null ? stack1 : "");
    },
    "2": function (container, depth0, helpers, partials, data) {
      return "<span class=\"no-translate\">&#8226</span>";
    },
    "4": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<a class=\"privacy-policy\" href=\"" + alias3((helper = (helper = lookupProperty(helpers, "privacyPolicy") || (depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "privacyPolicy",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 286
          },
          "end": {
            "line": 1,
            "column": 303
          }
        }
      }) : helper)) + "\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "consent.required.privacyPolicy"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 321
          },
          "end": {
            "line": 1,
            "column": 382
          }
        }
      })) + "</a>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "termsOfService") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 233
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(4, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 233
          },
          "end": {
            "line": 1,
            "column": 393
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  getTemplateData: function () {
    const appState = this.options.appState;
    const app = appState.get('app');
    return {
      termsOfService: app.termsOfService && app.termsOfService.href,
      privacyPolicy: app.privacyPolicy && app.privacyPolicy.href
    };
  }
});
var _default = ConsentViewFooter;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/consent/EnduserConsentViewHeader.js":
/*!***********************************************************************!*\
  !*** ./src/v2/view-builder/views/consent/EnduserConsentViewHeader.js ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _AdminConsentViewHeader = _interopRequireDefault(__webpack_require__(/*! ./AdminConsentViewHeader */ "./src/v2/view-builder/views/consent/AdminConsentViewHeader.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _AdminConsentViewHeader.default.extend({
  titleText: () => (0, _courage.loc)('oie.consent.scopes.enduser.title', 'login'),
  hasIssuer: false
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/consent/EnduserEmailConsentView.js":
/*!**********************************************************************!*\
  !*** ./src/v2/view-builder/views/consent/EnduserEmailConsentView.js ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _ConsentViewForm = _interopRequireDefault(__webpack_require__(/*! ./ConsentViewForm */ "./src/v2/view-builder/views/consent/ConsentViewForm.js"));
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _EmailAuthenticatorHeader = _interopRequireDefault(__webpack_require__(/*! ../../components/EmailAuthenticatorHeader */ "./src/v2/view-builder/components/EmailAuthenticatorHeader.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const getInfo = _runtime.default.template({
  "1": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<div class=\"enduser-email-consent--info no-translate\"><i class=\"enduser-email-consent--icon icon--desktop\"></i><div>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "browser") || (depth0 != null ? lookupProperty(depth0, "browser") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "browser",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 131
        },
        "end": {
          "line": 1,
          "column": 142
        }
      }
    }) : helper)) + "</div></div>";
  },
  "3": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "<div class=\"enduser-email-consent--info no-translate\"><i class=\"enduser-email-consent--icon icon--app\"></i><div>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "app") || (depth0 != null ? lookupProperty(depth0, "app") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "app",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 284
        },
        "end": {
          "line": 1,
          "column": 291
        }
      }
    }) : helper)) + "</div></div>";
  },
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var stack1,
      alias1 = depth0 != null ? depth0 : container.nullContext || {},
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "browser") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(1, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 0
        },
        "end": {
          "line": 1,
          "column": 161
        }
      }
    })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "app") : depth0, {
      "name": "if",
      "hash": {},
      "fn": container.program(3, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 161
        },
        "end": {
          "line": 1,
          "column": 310
        }
      }
    })) != null ? stack1 : "");
  },
  "useData": true
});
const enduserEmailConsentViewBody = _ConsentViewForm.default.extend({
  className: 'enduser-email-consent',
  title() {
    return (0, _courage.loc)('oie.consent.enduser.title', 'login');
  },
  save() {
    return (0, _courage.loc)('oie.consent.enduser.accept.label', 'login');
  },
  cancel() {
    return (0, _courage.loc)('oie.consent.enduser.deny.label', 'login');
  },
  initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    const info = getInfo(this.model.pick('browser', 'app'));
    this.add(info);
  },
  getUISchema() {
    const uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);
    return uiSchemas.filter(uiSchema => uiSchema.name !== 'consent');
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Header: _EmailAuthenticatorHeader.default,
  buttonOrder: ['cancel', 'save'],
  postRender() {
    const buttonContainer = this.$el.find('.o-form-button-bar');
    buttonContainer.find('.button-primary').removeClass('button-primary');
  },
  Body: enduserEmailConsentViewBody,
  createModelClass({
    requestInfo
  }) {
    const ModelClass = _BaseAuthenticatorView.default.prototype.createModelClass.apply(this, arguments);
    const browser = requestInfo.find(({
      name
    }) => name === 'browser');
    const app = requestInfo.find(({
      name
    }) => name === 'appName');
    const local = Object.assign({
      browser: {
        type: 'string',
        value: browser === null || browser === void 0 ? void 0 : browser.value
      },
      app: {
        type: 'string',
        value: app === null || app === void 0 ? void 0 : app.value
      }
    }, ModelClass.prototype.local);
    return ModelClass.extend({
      local,
      toJSON() {
        return {
          consent: this.get('consent')
        };
      }
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/consent/GranularConsentView.js":
/*!******************************************************************!*\
  !*** ./src/v2/view-builder/views/consent/GranularConsentView.js ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _ConsentViewForm = _interopRequireDefault(__webpack_require__(/*! ./ConsentViewForm */ "./src/v2/view-builder/views/consent/ConsentViewForm.js"));
var _AdminConsentViewHeader = _interopRequireDefault(__webpack_require__(/*! ./AdminConsentViewHeader */ "./src/v2/view-builder/views/consent/AdminConsentViewHeader.js"));
var _EnduserConsentViewFooter = _interopRequireDefault(__webpack_require__(/*! ./EnduserConsentViewFooter */ "./src/v2/view-builder/views/consent/EnduserConsentViewFooter.js"));
var _ScopeCheckBox = _interopRequireDefault(__webpack_require__(/*! ../../components/ScopeCheckBox */ "./src/v2/view-builder/components/ScopeCheckBox.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const granularConsentViewHeader = _AdminConsentViewHeader.default.extend({
  hasIssuer: false,
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<a href=\"" + alias4((helper = (helper = lookupProperty(helpers, "clientURI") || (depth0 != null ? lookupProperty(depth0, "clientURI") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "clientURI",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 26
          },
          "end": {
            "line": 1,
            "column": 39
          }
        }
      }) : helper)) + "\" class=\"client-logo-link\" title=\"" + alias4((helper = (helper = lookupProperty(helpers, "altText") || (depth0 != null ? lookupProperty(depth0, "altText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "altText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 73
          },
          "end": {
            "line": 1,
            "column": 84
          }
        }
      }) : helper)) + "\" target=\"_blank\">";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<img class=\"client-logo custom-logo\" src=\"" + alias4((helper = (helper = lookupProperty(helpers, "customLogo") || (depth0 != null ? lookupProperty(depth0, "customLogo") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "customLogo",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 169
          },
          "end": {
            "line": 1,
            "column": 183
          }
        }
      }) : helper)) + "\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "altText") || (depth0 != null ? lookupProperty(depth0, "altText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "altText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 190
          },
          "end": {
            "line": 1,
            "column": 201
          }
        }
      }) : helper)) + "\" aria-hidden />";
    },
    "5": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<img class=\"client-logo default-logo\" src=\"" + alias4((helper = (helper = lookupProperty(helpers, "defaultLogo") || (depth0 != null ? lookupProperty(depth0, "defaultLogo") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "defaultLogo",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 268
          },
          "end": {
            "line": 1,
            "column": 283
          }
        }
      }) : helper)) + "\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "altText") || (depth0 != null ? lookupProperty(depth0, "altText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "altText",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 290
          },
          "end": {
            "line": 1,
            "column": 301
          }
        }
      }) : helper)) + "\" aria-hidden />";
    },
    "7": function (container, depth0, helpers, partials, data) {
      return "</a>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 109
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "customLogo") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.program(5, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 109
          },
          "end": {
            "line": 1,
            "column": 324
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(7, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 324
          },
          "end": {
            "line": 1,
            "column": 352
          }
        }
      })) != null ? stack1 : "") + "<h1><span class=\"title-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
        "name": "i18n",
        "hash": {
          "$2": "<p>$2</p>",
          "$1": "<b class='no-translate'>$1</b>",
          "arguments": "appName",
          "bundle": "login",
          "code": "oie.consent.scopes.granular.title"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 381
          },
          "end": {
            "line": 1,
            "column": 517
          }
        }
      })) + "</span></h1>";
    },
    "useData": true
  })
});
const granularConsentViewForm = _ConsentViewForm.default.extend({
  cancel: _internals.BaseForm.prototype.cancel,
  getUISchema() {
    const uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);
    uiSchemas.forEach(schema => {
      if (schema.type === 'checkbox') {
        _courage._.assign(schema, {
          input: _ScopeCheckBox.default,
          options: {
            desc: schema.desc,
            mutable: schema.mutable,
            // need to extract scope name because it is in a subform (optedScopes.name)
            scopeName: schema.name.substring(schema.name.indexOf('.') + 1)
          }
        });
      }
    });
    return uiSchemas;
  }
});
const GranularConsentAgreementText = _courage.View.extend({
  className: 'consent-description',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.consent.scopes.granular.description"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3
          },
          "end": {
            "line": 1,
            "column": 73
          }
        }
      })) + "</p>";
    },
    "useData": true
  })
});
var _default = _internals.BaseView.extend({
  Header: granularConsentViewHeader,
  Body: granularConsentViewForm,
  Footer: _EnduserConsentViewFooter.default,
  postRender() {
    const scopeList = this.$el.find('.o-form-fieldset-container');

    // Show consent agreement text
    scopeList.before(new GranularConsentAgreementText().render().el);

    // Re-order scopes so mandatory ones are on bottom
    this.$(':disabled').each(function () {
      scopeList.append((0, _courage.$)(this).closest('.o-form-fieldset'));
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/custom-app/ChallengeCustomAppResendPushView.js":
/*!**********************************************************************************!*\
  !*** ./src/v2/view-builder/views/custom-app/ChallengeCustomAppResendPushView.js ***!
  \**********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CUSTOM_APP_UV_ENABLE_BIOMETRIC_SERVER_KEY = 'oie.authenticator.custom_app.method.push.verify.enable.biometrics';
const Body = _internals.BaseForm.extend(Object.assign({
  className: 'custom-app-verify-resend-push',
  title() {
    return (0, _courage.loc)('oie.verify.custom_app.title', 'login', [this.options.appState.getAuthenticatorDisplayName()]);
  },
  save() {
    return (0, _courage.loc)('oie.custom_app.push.resend', 'login');
  },
  showMessages() {
    let options = {};
    if (this.options.appState.containsMessageWithI18nKey(CUSTOM_APP_UV_ENABLE_BIOMETRIC_SERVER_KEY)) {
      // add a title, subtitle, and bullet-points for 
      // Custom App enable biometrics message during verification
      options.content = null;
      options.className = 'okta-verify-uv-callout-content';
      options.title = (0, _courage.loc)('oie.authenticator.custom_app.method.push.verify.enable.biometrics.title', 'login', [this.options.appState.getAuthenticatorDisplayName()]);
      options.subtitle = (0, _courage.loc)('oie.authenticator.custom_app.method.push.verify.enable.biometrics.description', 'login');
      options.type = 'error';
      options.bullets = [(0, _courage.loc)('oie.authenticator.custom_app.method.push.verify.enable.biometrics.point1', 'login'), (0, _courage.loc)('oie.authenticator.custom_app.method.push.verify.enable.biometrics.point2', 'login', [this.options.appState.getAuthenticatorDisplayName()]), (0, _courage.loc)('oie.authenticator.custom_app.method.push.verify.enable.biometrics.point3', 'login', [this.options.appState.getAuthenticatorDisplayName()])];
      options = (0, _courage.createCallout)(options);
    }
    _internals.BaseForm.prototype.showMessages.call(this, options);
  }
}));
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/custom-otp/ChallengeCustomOTPAuthenticatorView.js":
/*!*************************************************************************************!*\
  !*** ./src/v2/view-builder/views/custom-otp/ChallengeCustomOTPAuthenticatorView.js ***!
  \*************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend(Object.assign({
  className: 'mfa-verify-custom-otp',
  title() {
    const vendorName = this.options.appState.getAuthenticatorDisplayName() || (0, _courage.loc)('oie.custom_otp.authenticator.default.vendorName', 'login');
    return (0, _courage.loc)('oie.verify.custom_otp.title', 'login', [vendorName]);
  },
  subtitle() {
    return (0, _courage.loc)('oie.verify.custom_otp.description', 'login');
  },
  save() {
    return (0, _courage.loc)('mfa.challenge.verify', 'login');
  }
}));
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/custom-password/ReEnrollCustomPasswordExpiryView.js":
/*!***************************************************************************************!*\
  !*** ./src/v2/view-builder/views/custom-password/ReEnrollCustomPasswordExpiryView.js ***!
  \***************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _Util = _interopRequireDefault(__webpack_require__(/*! ../../../../util/Util */ "./src/util/Util.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend({
  title() {
    return (0, _courage.loc)('password.expired.title.generic', 'login');
  },
  subtitle() {
    return (0, _courage.loc)('password.expired.custom.subtitle', 'login');
  },
  noSubmitButton: true,
  initialize() {
    const {
      customExpiredPasswordName,
      customExpiredPasswordURL
    } = this.options.currentViewState;
    this.add((0, _courage.createButton)({
      className: 'button button-primary button-wide',
      title: _courage._.partial(_courage.loc, 'password.expired.custom.submit', 'login', [customExpiredPasswordName]),
      click: () => {
        _Util.default.redirect(customExpiredPasswordURL);
      }
    }));
  }
});
var _default = _internals.BaseView.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/custom-password/ReEnrollCustomPasswordExpiryWarningView.js":
/*!**********************************************************************************************!*\
  !*** ./src/v2/view-builder/views/custom-password/ReEnrollCustomPasswordExpiryWarningView.js ***!
  \**********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _Util = _interopRequireDefault(__webpack_require__(/*! ../../../../util/Util */ "./src/util/Util.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend({
  className: 'password-authenticator',
  subtitle() {
    return this.settings.get('brandName') ? (0, _courage.loc)('password.expiring.soon.subtitle.specific', 'login', [this.settings.get('brandName')]) : (0, _courage.loc)('password.expiring.soon.subtitle.generic', 'login');
  },
  title() {
    var _this$options$appStat;
    const passwordPolicy = (_this$options$appStat = this.options.appState.get('currentAuthenticator')) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.settings;
    const daysToExpiry = passwordPolicy.daysToExpiry;
    if (daysToExpiry > 0) {
      return (0, _courage.loc)('password.expiring.title', 'login', [daysToExpiry]);
    } else if (daysToExpiry === 0) {
      return (0, _courage.loc)('password.expiring.today', 'login');
    } else {
      return (0, _courage.loc)('password.expiring.soon', 'login');
    }
  },
  noSubmitButton: true,
  initialize() {
    const {
      customExpiredPasswordName,
      customExpiredPasswordURL
    } = this.options.currentViewState;
    this.add((0, _courage.createButton)({
      className: 'button button-primary button-wide',
      title: _courage._.partial(_courage.loc, 'password.expired.custom.submit', 'login', [customExpiredPasswordName]),
      click: () => {
        _Util.default.redirect(customExpiredPasswordURL);
      }
    }));
  }
});
const Footer = _internals.BaseFooter.extend({
  links() {
    const links = [];
    if (this.options.appState.hasRemediationObject('skip')) {
      links.push({
        'type': 'link',
        'label': (0, _courage.loc)('password.expiring.later', 'login'),
        'name': 'skip',
        'actionPath': 'skip'
      });
    }
    return links;
  }
});
var _default = _internals.BaseView.extend({
  Body,
  Footer
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/device/DeviceChallengePollView.js":
/*!*********************************************************************!*\
  !*** ./src/v2/view-builder/views/device/DeviceChallengePollView.js ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! ../../../../util/Enums */ "./src/util/Enums.js"));
var _Constants = __webpack_require__(/*! ../../utils/Constants */ "./src/v2/view-builder/utils/Constants.js");
var _Link = _interopRequireDefault(__webpack_require__(/*! ../../components/Link */ "./src/v2/view-builder/components/Link.js"));
var _ChallengeViewUtil = __webpack_require__(/*! ../../utils/ChallengeViewUtil */ "./src/v2/view-builder/utils/ChallengeViewUtil.js");
var _OktaVerifyAuthenticatorHeader = _interopRequireDefault(__webpack_require__(/*! ../../components/OktaVerifyAuthenticatorHeader */ "./src/v2/view-builder/components/OktaVerifyAuthenticatorHeader.js"));
var _LinksUtil = __webpack_require__(/*! ../../utils/LinksUtil */ "./src/v2/view-builder/utils/LinksUtil.js");
var _CustomAccessDeniedErrorMessage = _interopRequireDefault(__webpack_require__(/*! ../shared/CustomAccessDeniedErrorMessage */ "./src/v2/view-builder/views/shared/CustomAccessDeniedErrorMessage.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CUSTOM_ACCESS_DENIED_KEY = 'security.access_denied_custom_message';
const Body = _internals.BaseOktaVerifyChallengeView.extend({
  pollingCancelAction: _Constants.CANCEL_POLLING_ACTION,
  getDeviceChallengePayload() {
    return this.options.currentViewState.relatesTo.value;
  },
  doChallenge() {
    (0, _ChallengeViewUtil.doChallenge)(this, _Constants.IDENTIFIER_FLOW);
  },
  onPollingFail() {
    _internals.BaseOktaVerifyChallengeView.prototype.onPollingFail.apply(this, arguments);
    // When SIW receives form error, polling is already stopped
    // SIW needs to update footer link from /poll/cancel to /idp/idx/cancel
    const data = {
      label: (0, _courage.loc)('loopback.polling.cancel.link.with.form.error', 'login')
    };
    this.options.appState.trigger('updateFooterLink', data);
  },
  showCustomFormErrorCallout(error, messages) {
    const responseJSON = error.responseJSON;
    let options = {
      type: 'error',
      className: 'okta-verify-uv-callout-content',
      subtitle: responseJSON.errorSummary
    };
    const containsSignedNonceError = responseJSON.errorSummaryKeys && responseJSON.errorSummaryKeys.some(key => key.includes('auth.factor.signedNonce.error'));
    if (containsSignedNonceError) {
      options.title = (0, _courage.loc)('user.fail.verifyIdentity', 'login');
    }
    const containsCustomAccessDeniedError = responseJSON.errorSummaryKeys && responseJSON.errorSummaryKeys.some(key => key.includes('security.access_denied_custom_message'));
    if (containsCustomAccessDeniedError) {
      const message = messages === null || messages === void 0 ? void 0 : messages.find(message => message.i18n.key === CUSTOM_ACCESS_DENIED_KEY);
      if (!message) {
        return false;
      }
      options = {
        type: 'error',
        content: new _CustomAccessDeniedErrorMessage.default({
          message: responseJSON.errorSummary,
          links: message.links
        })
      };
    }
    this.showMessages((0, _courage.createCallout)(options));
    return true;
  }
});
const Footer = _internals.BaseFooter.extend({
  initialize() {
    this.listenTo(this.options.appState, 'updateFooterLink', this.handleUpdateFooterLink);
    if (this.isFallbackApproach() && !this.isFallbackDelayed()) {
      _internals.BaseFooter.prototype.initialize.apply(this, arguments);
    } else {
      this.backLink = this.add(_Link.default, {
        options: {
          name: 'cancel-authenticator-challenge',
          label: (0, _courage.loc)('loopback.polling.cancel.link', 'login'),
          clickHandler: () => {
            (0, _ChallengeViewUtil.cancelPollingWithParams)(this.options.appState, _Constants.CANCEL_POLLING_ACTION, _Constants.AUTHENTICATION_CANCEL_REASONS.USER_CANCELED, null);
          }
        }
      }).last();
    }
  },
  handleUpdateFooterLink(data) {
    // only update link for loopback
    if (!this.isFallbackApproach() || this.isFallbackDelayed()) {
      this.backLink && this.backLink.remove();
      this.backLink = this.add(_Link.default, {
        options: (0, _LinksUtil.getSignOutLink)(this.options.settings, data)[0]
      }).last();
    }
  },
  isFallbackApproach() {
    return [_Enums.default.CUSTOM_URI_CHALLENGE, _Enums.default.UNIVERSAL_LINK_CHALLENGE, _Enums.default.APP_LINK_CHALLENGE].includes(this.options.currentViewState.relatesTo.value.challengeMethod);
  },
  isFallbackDelayed() {
    // only delay showing the reopen Okta Verify button for the app link approach for now
    // until we have more data shows other approaches have the slow cold start problem of the Okta Verify app as well
    return this.options.currentViewState.relatesTo.value.challengeMethod === _Enums.default.APP_LINK_CHALLENGE;
  }
});
var _default = _internals.BaseView.extend({
  Header: _OktaVerifyAuthenticatorHeader.default,
  Body,
  Footer
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/device/DeviceCodeActivateView.js":
/*!********************************************************************!*\
  !*** ./src/v2/view-builder/views/device/DeviceCodeActivateView.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
const Body = _internals.BaseForm.extend({
  title() {
    return (0, _courage.loc)('device.code.activate.title', 'login');
  },
  subtitle() {
    return (0, _courage.loc)('device.code.activate.subtitle', 'login');
  },
  events: {
    'keyup input[name="userCode"]': function (e) {
      e.preventDefault();
      this.addHyphen(e);
    }
  },
  addHyphen(evt) {
    const currentVal = evt.target.value;
    // add hyphen after 4th character
    if (currentVal && currentVal.length === 4 && !['Backspace', 'Delete', '-'].includes(evt.key)) {
      evt.target.value = currentVal.concat('-');
    }
  }
});
var _default = _internals.BaseView.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/device/DeviceEnrollmentTerminalView.js":
/*!**************************************************************************!*\
  !*** ./src/v2/view-builder/views/device/DeviceEnrollmentTerminalView.js ***!
  \**************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _OdaOktaVerifyTerminalView = __webpack_require__(/*! ../../components/OdaOktaVerifyTerminalView */ "./src/v2/view-builder/components/OdaOktaVerifyTerminalView.js");
var _MdmOktaVerifyTerminalView = _interopRequireDefault(__webpack_require__(/*! ../../components/MdmOktaVerifyTerminalView */ "./src/v2/view-builder/components/MdmOktaVerifyTerminalView.js"));
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _OktaVerifyAuthenticatorHeader = _interopRequireDefault(__webpack_require__(/*! ../../components/OktaVerifyAuthenticatorHeader */ "./src/v2/view-builder/components/OktaVerifyAuthenticatorHeader.js"));
var _Link = _interopRequireDefault(__webpack_require__(/*! ../../components/Link */ "./src/v2/view-builder/components/Link.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BaseDeviceEnrollTerminalForm = _internals.BaseForm.extend({
  noButtonBar: true,
  className: 'device-enrollment-terminal'
});
const AndroidAppLinkPreselectForm = _internals.BaseForm.extend({
  attributes: {
    'data-se': 'android-app-link-setup-options-terminal'
  },
  title() {
    return (0, _courage.loc)('enroll.title.oda.with.account', 'login');
  },
  initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    const deviceEnrollmentContext = (0, _OdaOktaVerifyTerminalView.getDeviceEnrollmentContext)(this.options.appState.get('deviceEnrollment'));
    this.model.set('hasOVAccount', 'no');
    this.addInput({
      label: () => (0, _courage.loc)('enroll.subtitle.fastpass', 'login', [deviceEnrollmentContext.orgName]),
      'label-top': true,
      options: {
        'no': (0, _courage.loc)('enroll.option.noaccount.fastpass', 'login'),
        'yes': (0, _courage.loc)('enroll.option.account.fastpass', 'login')
      },
      name: 'hasOVAccount',
      type: 'radio'
    });
  },
  saveForm() {
    //remove any existing warnings or messages before saving form
    this.$el.find('.o-form-error-container').empty();
    this.options.appState.trigger('updateDeviceEnrollmentView', this.model.get('hasOVAccount') === 'yes');
  }
});
const AndroidAppLinkWithAccountOdaTerminalForm = BaseDeviceEnrollTerminalForm.extend({
  attributes: {
    'data-se': 'android-oda-app-link-with-ov-account-terminal'
  },
  title() {
    return (0, _courage.loc)('enroll.title.oda.with.account', 'login');
  },
  initialize() {
    BaseDeviceEnrollTerminalForm.prototype.initialize.apply(this, arguments);
    this.add(_OdaOktaVerifyTerminalView.AndroidAppLinkWithAccountOdaTerminalView);
  }
});
const AndroidAppLinkWithoutAccountOdaTerminalForm = BaseDeviceEnrollTerminalForm.extend({
  attributes: {
    'data-se': 'android-oda-app-link-without-ov-account-terminal'
  },
  title() {
    return (0, _courage.loc)('enroll.title.oda.without.account', 'login');
  },
  initialize() {
    BaseDeviceEnrollTerminalForm.prototype.initialize.apply(this, arguments);
    this.add(_OdaOktaVerifyTerminalView.AndroidAppLinkWithoutAccountOdaTerminalView);
  }
});
const IosAndAndroidLoopbackOdaTerminalForm = BaseDeviceEnrollTerminalForm.extend({
  attributes: {
    'data-se': 'loopback-terminal'
  },
  title() {
    return (0, _courage.loc)('enroll.title.oda', 'login');
  },
  initialize() {
    BaseDeviceEnrollTerminalForm.prototype.initialize.apply(this, arguments);
    this.add(_OdaOktaVerifyTerminalView.IosAndAndroidLoopbackOdaTerminalView);
  }
});
const MdmTerminalForm = BaseDeviceEnrollTerminalForm.extend({
  attributes: {
    'data-se': 'mdm-terminal'
  },
  title() {
    return (0, _courage.loc)('enroll.title.mdm', 'login');
  },
  initialize() {
    BaseDeviceEnrollTerminalForm.prototype.initialize.apply(this, arguments);
    this.add(_MdmOktaVerifyTerminalView.default);
  }
});
const AndroidAppLinkTerminalViewFooter = _Link.default.extend({
  postRender() {
    this.$el.click(event => {
      event.preventDefault();
      this.options.appState.trigger('switchBackToPreselect');
    });
  }
});
var _default = _internals.BaseView.extend({
  initialize() {
    _internals.BaseView.prototype.initialize.apply(this, arguments);
    this.listenTo(this.options.appState, 'updateDeviceEnrollmentView', this.handleUpdateDeviceEnrollmentView);
    this.listenTo(this.options.appState, 'switchBackToPreselect', this.handleSwitchBackToPreselect);
    const deviceEnrollmentContext = (0, _OdaOktaVerifyTerminalView.getDeviceEnrollmentContext)(this.options.appState.get('deviceEnrollment'));
    this.enrollmentType = (deviceEnrollmentContext.enrollmentType || '').toLowerCase(); // oda/mdm

    switch (this.enrollmentType) {
      case _Enums.default.ODA:
        this.Header = _OktaVerifyAuthenticatorHeader.default;
        this.Body = deviceEnrollmentContext.isAndroidAppLink ? AndroidAppLinkPreselectForm : IosAndAndroidLoopbackOdaTerminalForm;
        break;
      case _Enums.default.MDM:
        this.Body = MdmTerminalForm;
        break;
      case _Enums.default.WS1:
        this.Body = MdmTerminalForm;
    }
  },
  handleUpdateDeviceEnrollmentView(withAccount) {
    this.Body = withAccount ? AndroidAppLinkWithAccountOdaTerminalForm : AndroidAppLinkWithoutAccountOdaTerminalForm;
    this.backLink = this.add(AndroidAppLinkTerminalViewFooter, {
      options: {
        name: 'back-to-preselect',
        label: (0, _courage.loc)('oform.back', 'login')
      }
    }).last();
    this.renderForm();
  },
  handleSwitchBackToPreselect() {
    this.Body = AndroidAppLinkPreselectForm;
    this.backLink && this.backLink.remove();
    this.render();
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/device/SSOExtensionView.js":
/*!**************************************************************!*\
  !*** ./src/v2/view-builder/views/device/SSOExtensionView.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
// for BETA,
// redirect is needed for Apple SSO Extension to intercept the request, because
// - XHR request is not interceptable
// - form post is interceptable, but some app (Outlook) closes the app after
// We may have a different approach/UX for EA
const Body = _internals.BaseForm.extend({
  noButtonBar: true,
  className: 'ion-form device-challenge-poll',
  title() {
    return (0, _courage.loc)('deviceTrust.sso.redirectText', 'login');
  },
  initialize() {
    var _this$options$current, _this$options$current2;
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    this.listenTo(this.model, 'error', () => {
      this.$('.spinner').hide();
    });
    this.add('<div class="spinner"></div>');
    const isGetMethod = ((_this$options$current = this.options.currentViewState) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.method) === null || _this$options$current2 === void 0 ? void 0 : _this$options$current2.toLowerCase()) === 'get';
    this.model.set('useRedirect', isGetMethod);
    this.trigger('save', this.model);
  }
});
var _default = _internals.BaseView.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/device/SignInDeviceView.js":
/*!**************************************************************!*\
  !*** ./src/v2/view-builder/views/device/SignInDeviceView.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _IdentifierFooter = _interopRequireDefault(__webpack_require__(/*! ../../components/IdentifierFooter */ "./src/v2/view-builder/components/IdentifierFooter.js"));
var _SignInWithDeviceOption = _interopRequireDefault(__webpack_require__(/*! ../signin/SignInWithDeviceOption */ "./src/v2/view-builder/views/signin/SignInWithDeviceOption.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend({
  title() {
    return (0, _courage.loc)('primaryauth.title', 'login');
  },
  noButtonBar: true,
  initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    this.add(_SignInWithDeviceOption.default, {
      selector: '.o-form-fieldset-container',
      bubble: false,
      prepend: true,
      options: {
        isRequired: true
      }
    });
  }
});

// override the footer to add all the supported links except the sign out link
// no session is granted at this point
const Footer = _IdentifierFooter.default.extend({
  hasBackToSignInLink: false
});
var _default = _internals.BaseView.extend({
  Body,
  Footer: Footer
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/duo/BaseDuoAuthenticatorForm.js":
/*!*******************************************************************!*\
  !*** ./src/v2/view-builder/views/duo/BaseDuoAuthenticatorForm.js ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _duo = _interopRequireDefault(__webpack_require__(/*! @okta/duo */ "./packages/vendor/duo_web_sdk/index.js"));
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _internals.BaseForm.extend({
  noButtonBar: true,
  postRender: function () {
    const contextualData = this.getContextualData();
    // This is the place to check contextualData.integrationType once we support more types
    // Currently we only support IFRAME
    const duoFrame = this.add(`<iframe frameborder="0" title="'${this.title()}'"></iframe>`).last();
    try {
      _duo.default.init({
        host: contextualData.host,
        sig_request: contextualData.signedToken,
        // eslint-disable-line camelcase
        iframe: duoFrame.el,
        post_action: signedData => {
          // eslint-disable-line camelcase
          this.model.set('credentials.signatureData', signedData);
          this.saveForm(this.model);
        }
      });
    } catch (e) {
      duoFrame.remove();
      this.add((0, _courage.createCallout)({
        type: 'error',
        subtitle: (0, _courage.loc)('oie.duo.iFrameError', 'login')
      }), '.o-form-error-container');
      console.error(e); // eslint-disable-line no-console
    }
  },

  getContextualData() {
    // to be overriden
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/duo/ChallengeDuoAuthenticatorView.js":
/*!************************************************************************!*\
  !*** ./src/v2/view-builder/views/duo/ChallengeDuoAuthenticatorView.js ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _BaseDuoAuthenticatorForm = _interopRequireDefault(__webpack_require__(/*! ./BaseDuoAuthenticatorForm */ "./src/v2/view-builder/views/duo/BaseDuoAuthenticatorForm.js"));
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _BaseDuoAuthenticatorForm.default.extend({
  title() {
    return (0, _courage.loc)('oie.duo.verify.title', 'login');
  },
  getContextualData() {
    return this.options.appState.get('currentAuthenticatorEnrollment').contextualData;
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/duo/EnrollDuoAuthenticatorView.js":
/*!*********************************************************************!*\
  !*** ./src/v2/view-builder/views/duo/EnrollDuoAuthenticatorView.js ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _BaseDuoAuthenticatorForm = _interopRequireDefault(__webpack_require__(/*! ./BaseDuoAuthenticatorForm */ "./src/v2/view-builder/views/duo/BaseDuoAuthenticatorForm.js"));
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _BaseDuoAuthenticatorForm.default.extend({
  title() {
    return (0, _courage.loc)('oie.duo.enroll.title', 'login');
  },
  getContextualData() {
    return this.options.appState.get('currentAuthenticator').contextualData;
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/email/AuthenticatorEmailViewUtil.js":
/*!***********************************************************************!*\
  !*** ./src/v2/view-builder/views/email/AuthenticatorEmailViewUtil.js ***!
  \***********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getCheckYourEmailEnrollTitle = getCheckYourEmailEnrollTitle;
exports.getCheckYourEmailTitle = getCheckYourEmailTitle;
exports.getEnterCodeLink = getEnterCodeLink;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Courage doesn't support HTML, hence creating a subtitle here.
const CheckYourEmailTitle = _courage.View.extend({
  className: 'okta-form-subtitle',
  attributes: {
    'data-se': 'o-form-explain'
  },
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "secondaryEmail") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(2, data, 0),
        "inverse": container.program(4, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 13
          },
          "end": {
            "line": 1,
            "column": 433
          }
        }
      })) != null ? stack1 : "";
    },
    "2": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$2": "<span class='strong no-translate'>$2</span>",
          "$1": "<span class='strong no-translate'>$1</span>",
          "arguments": "email;secondaryEmail",
          "bundle": "login",
          "code": "oie.email.verify.alternate.magicLinkToEmailAddress.with.secondary.email"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 35
          },
          "end": {
            "line": 1,
            "column": 269
          }
        }
      }));
    },
    "4": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='strong no-translate'>$1</span>",
          "arguments": "email",
          "bundle": "login",
          "code": "oie.email.verify.alternate.magicLinkToEmailAddress"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 277
          },
          "end": {
            "line": 1,
            "column": 426
          }
        }
      }));
    },
    "6": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.email.verify.alternate.magicLinkToYourEmail"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 441
          },
          "end": {
            "line": 1,
            "column": 520
          }
        }
      }));
    },
    "8": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.email.verify.alternate.instructions"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 557
          },
          "end": {
            "line": 1,
            "column": 628
          }
        }
      }));
    },
    "10": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.email.verify.alternate.verificationCode.instructions"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 636
          },
          "end": {
            "line": 1,
            "column": 724
          }
        }
      }));
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "email") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.program(6, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 527
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "useEmailMagicLinkValue") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(8, data, 0),
        "inverse": container.program(10, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 527
          },
          "end": {
            "line": 1,
            "column": 731
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  getTemplateData() {
    return this.options;
  }
});
const CheckYourEmailEnrollTitle = _courage.View.extend({
  className: 'okta-form-subtitle',
  attributes: {
    'data-se': 'o-form-explain'
  },
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.email.enroll.subtitle"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 56
          }
        }
      }));
    },
    "useData": true
  })
});
const EnterCodeLink = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<button class=\"button-link enter-auth-code-instead-link\" >" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "code": "oie.email.verify.alternate.show.verificationCode.text"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 127
          }
        }
      })) + "</button>";
    },
    "useData": true
  })
});
function getCheckYourEmailTitle() {
  return CheckYourEmailTitle;
}
function getCheckYourEmailEnrollTitle() {
  return CheckYourEmailEnrollTitle;
}
function getEnterCodeLink() {
  return EnterCodeLink;
}

/***/ }),

/***/ "./src/v2/view-builder/views/email/BaseAuthenticatorEmailView.js":
/*!***********************************************************************!*\
  !*** ./src/v2/view-builder/views/email/BaseAuthenticatorEmailView.js ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _email = _interopRequireDefault(__webpack_require__(/*! ../shared/email */ "./src/v2/view-builder/views/shared/email.js"));
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _BaseResendView = _interopRequireDefault(__webpack_require__(/*! ../shared/BaseResendView */ "./src/v2/view-builder/views/shared/BaseResendView.js"));
var _BaseFormWithPolling = _interopRequireDefault(__webpack_require__(/*! ../../internals/BaseFormWithPolling */ "./src/v2/view-builder/internals/BaseFormWithPolling.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ResendView = _BaseResendView.default.extend({
  className: 'hide resend-email-view',
  events: {
    'click a.resend-link': 'handelResendLink'
  },
  initialize() {
    this.add((0, _courage.createCallout)({
      content: `${(0, _courage.loc)('email.code.not.received', 'login')}
        <a class='resend-link'>${(0, _courage.loc)('email.button.resend', 'login')}</a>`,
      type: 'warning'
    }));
  },
  handelResendLink() {
    this.options.appState.trigger('invokeAction', this.options.resendEmailAction);
    // Hide warning, but reinitiate to show warning again after some threshold of polling
    if (!this.$el.hasClass('hide')) {
      this.$el.addClass('hide');
    }
    this.showCalloutAfterTimeout();
  }
});
const Body = _BaseFormWithPolling.default.extend(Object.assign({
  save() {
    return (0, _courage.loc)('mfa.challenge.verify', 'login');
  },
  initialize() {
    _BaseFormWithPolling.default.prototype.initialize.apply(this, arguments);
    this.startPolling();
  },
  postRender() {
    _internals.BaseForm.prototype.postRender.apply(this, arguments);

    // Add 1 instance of resend view
    if (!this.$el.find('.resend-email-view').length) {
      this.add(ResendView, {
        selector: '.o-form-error-container',
        prepend: true,
        options: {
          resendEmailAction: this.resendEmailAction
        }
      });
    }
  },
  saveForm() {
    _internals.BaseForm.prototype.saveForm.apply(this, arguments);
    this.stopPolling();
  },
  remove() {
    _internals.BaseForm.prototype.remove.apply(this, arguments);
    this.stopPolling();
  },
  triggerAfterError(model, error) {
    var _error$responseJSON, _error$responseJSON$e;
    _internals.BaseForm.prototype.triggerAfterError.apply(this, arguments);
    const isFormPolling = !!this.polling;
    this.stopPolling();
    if ((_error$responseJSON = error.responseJSON) !== null && _error$responseJSON !== void 0 && (_error$responseJSON$e = _error$responseJSON.errorSummaryKeys) !== null && _error$responseJSON$e !== void 0 && _error$responseJSON$e.includes('idx.session.expired')) {
      // Do NOT resume polling since session is invalid and polling is already stopped
      return;
    }
    if (this.isRateLimitError(error)) {
      // When polling encounter rate limit error, wait 60 sec for rate limit bucket to reset
      // before polling again & hide error message
      if (isFormPolling) {
        setTimeout(() => {
          model.trigger('clearFormError');
        }, 0);
      }
      this.startPolling(60000);
    } else {
      this.startPolling(this.options.appState.get('dynamicRefreshInterval'));
    }
  },
  isRateLimitError(error) {
    var _error$responseJSON2, _error$responseJSON2$, _error$responseJSON3, _error$responseJSON4;
    return ((_error$responseJSON2 = error.responseJSON) === null || _error$responseJSON2 === void 0 ? void 0 : (_error$responseJSON2$ = _error$responseJSON2.errorSummaryKeys) === null || _error$responseJSON2$ === void 0 ? void 0 : _error$responseJSON2$.includes('tooManyRequests') // IDX API error
    ) || ((_error$responseJSON3 = error.responseJSON) === null || _error$responseJSON3 === void 0 ? void 0 : _error$responseJSON3.errorCode) === 'E0000047' && !((_error$responseJSON4 = error.responseJSON) !== null && _error$responseJSON4 !== void 0 && _error$responseJSON4.errorIntent); // Standard API error
  }
}, _email.default));
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/email/ChallengeAuthenticatorDataEmailView.js":
/*!********************************************************************************!*\
  !*** ./src/v2/view-builder/views/email/ChallengeAuthenticatorDataEmailView.js ***!
  \********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BaseAuthenticatorEmailForm = _BaseAuthenticatorView.default.prototype.Body;
const SubtitleView = _courage.View.extend({
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "secondaryEmail") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(2, data, 0),
        "inverse": container.program(4, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 70
          },
          "end": {
            "line": 1,
            "column": 471
          }
        }
      })) != null ? stack1 : "";
    },
    "2": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$2": "<span class='strong no-translate'>$2</span>",
          "$1": "<span class='strong no-translate'>$1</span>",
          "arguments": "email;secondaryEmail",
          "bundle": "login",
          "code": "oie.email.verify.subtitle.text.with.email.and.secondary.email"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 92
          },
          "end": {
            "line": 1,
            "column": 316
          }
        }
      }));
    },
    "4": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='strong no-translate'>$1</span>",
          "arguments": "email",
          "bundle": "login",
          "code": "oie.email.verify.subtitle.text.with.email"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 324
          },
          "end": {
            "line": 1,
            "column": 464
          }
        }
      }));
    },
    "6": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.email.verify.subtitle.text.without.email"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 479
          },
          "end": {
            "line": 1,
            "column": 555
          }
        }
      }));
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"okta-form-subtitle\" data-se=\"o-form-explain\">" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "email") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.program(6, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 57
          },
          "end": {
            "line": 1,
            "column": 562
          }
        }
      })) != null ? stack1 : "") + "</div>";
    },
    "useData": true
  }),
  getTemplateData() {
    var _this$options$appStat, _this$options$appStat2, _this$options$appStat3, _this$options$appStat4;
    const email = (_this$options$appStat = this.options.appState.get('currentAuthenticatorEnrollment')) === null || _this$options$appStat === void 0 ? void 0 : (_this$options$appStat2 = _this$options$appStat.profile) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.email;
    const secondaryEmail = (_this$options$appStat3 = this.options.appState.get('currentAuthenticatorEnrollment')) === null || _this$options$appStat3 === void 0 ? void 0 : (_this$options$appStat4 = _this$options$appStat3.profile) === null || _this$options$appStat4 === void 0 ? void 0 : _this$options$appStat4.secondaryEmail;
    return {
      email,
      secondaryEmail
    };
  }
});
const Body = BaseAuthenticatorEmailForm.extend({
  title() {
    return (0, _courage.loc)('oie.email.challenge.mfa.title', 'login');
  },
  save() {
    return (0, _courage.loc)('oie.email.verify.primaryButton', 'login');
  },
  postRender() {
    BaseAuthenticatorEmailForm.prototype.postRender.apply(this, arguments);
    this.add(SubtitleView, {
      prepend: true,
      selector: '.o-form-info-container'
    });
  },
  getUISchema() {
    // Prevent from displaying radio buttons on the UI
    const uiSchemas = BaseAuthenticatorEmailForm.prototype.getUISchema.apply(this, arguments);
    return uiSchemas.filter(schema => schema.name !== 'authenticator.methodType');
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/email/ChallengeAuthenticatorEmailView.js":
/*!****************************************************************************!*\
  !*** ./src/v2/view-builder/views/email/ChallengeAuthenticatorEmailView.js ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _BaseAuthenticatorEmailView = _interopRequireDefault(__webpack_require__(/*! ./BaseAuthenticatorEmailView */ "./src/v2/view-builder/views/email/BaseAuthenticatorEmailView.js"));
var _AuthenticatorEmailViewUtil = __webpack_require__(/*! ./AuthenticatorEmailViewUtil */ "./src/v2/view-builder/views/email/AuthenticatorEmailViewUtil.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BaseAuthenticatorEmailForm = _BaseAuthenticatorEmailView.default.prototype.Body;
const Body = BaseAuthenticatorEmailForm.extend(Object.assign({
  noButtonBar: true,
  resendEmailAction: 'currentAuthenticatorEnrollment-resend',
  events: {
    'click .enter-auth-code-instead-link': 'showAuthCodeEntry'
  },
  initialize() {
    var _this$options$current, _this$options$current2;
    BaseAuthenticatorEmailForm.prototype.initialize.apply(this, arguments);
    const {
      email,
      secondaryEmail
    } = ((_this$options$current = this.options.currentViewState.relatesTo) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.value) === null || _this$options$current2 === void 0 ? void 0 : _this$options$current2.profile) || {};
    const useEmailMagicLinkValue = this.isUseEmailMagicLink();
    if (useEmailMagicLinkValue) {
      this.add((0, _AuthenticatorEmailViewUtil.getEnterCodeLink)(), {
        prepend: true,
        selector: '.o-form-error-container'
      });
    }
    this.add((0, _AuthenticatorEmailViewUtil.getCheckYourEmailTitle)(), {
      prepend: true,
      selector: '.o-form-error-container',
      options: {
        email,
        secondaryEmail,
        useEmailMagicLinkValue
      }
    });
  },
  postRender() {
    BaseAuthenticatorEmailForm.prototype.postRender.apply(this, arguments);
    if (this.isUseEmailMagicLink()) {
      this.showCodeEntryField(false);
    } else {
      this.noButtonBar = false;
    }
  },
  isUseEmailMagicLink() {
    var _this$options$appStat, _this$options$appStat2;
    const useEmailMagicLink = (_this$options$appStat = this.options.appState.get('currentAuthenticatorEnrollment')) === null || _this$options$appStat === void 0 ? void 0 : (_this$options$appStat2 = _this$options$appStat.contextualData) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.useEmailMagicLink;
    return useEmailMagicLink !== undefined ? useEmailMagicLink : true;
  },
  showAuthCodeEntry() {
    this.noButtonBar = false;
    this.render();
    this.showCodeEntryField(true);
    this.removeEnterAuthCodeInsteadLink();
  },
  showCodeEntryField(show = true) {
    const $textField = this.$el.find('.o-form-fieldset-container');
    $textField.toggle(show);
  },
  removeEnterAuthCodeInsteadLink() {
    this.$el.find('.enter-auth-code-instead-link').remove();
  }
}));
var _default = _BaseAuthenticatorEmailView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/email/EnrollAuthenticatorEmailView.js":
/*!*************************************************************************!*\
  !*** ./src/v2/view-builder/views/email/EnrollAuthenticatorEmailView.js ***!
  \*************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _BaseAuthenticatorEmailView = _interopRequireDefault(__webpack_require__(/*! ./BaseAuthenticatorEmailView */ "./src/v2/view-builder/views/email/BaseAuthenticatorEmailView.js"));
var _AuthenticatorEmailViewUtil = __webpack_require__(/*! ./AuthenticatorEmailViewUtil */ "./src/v2/view-builder/views/email/AuthenticatorEmailViewUtil.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BaseAuthenticatorEmailForm = _BaseAuthenticatorEmailView.default.prototype.Body;
const Body = BaseAuthenticatorEmailForm.extend(Object.assign({
  resendEmailAction: 'currentAuthenticator-resend',
  initialize() {
    var _this$options$appStat, _this$options$appStat2, _this$options$appStat3;
    BaseAuthenticatorEmailForm.prototype.initialize.apply(this, arguments);
    const email = ((_this$options$appStat = this.options.appState.get('user')) === null || _this$options$appStat === void 0 ? void 0 : (_this$options$appStat2 = _this$options$appStat.profile) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.email) || ((_this$options$appStat3 = this.options.appState.get('user')) === null || _this$options$appStat3 === void 0 ? void 0 : _this$options$appStat3.identifier) || {};
    const useEmailMagicLinkValue = this.isUseEmailMagicLink();
    if (useEmailMagicLinkValue !== undefined) {
      this.noButtonBar = true;
      this.events['click .enter-auth-code-instead-link'] = 'showAuthCodeEntry';
      if (useEmailMagicLinkValue) {
        this.add((0, _AuthenticatorEmailViewUtil.getEnterCodeLink)(), {
          prepend: true,
          selector: '.o-form-error-container'
        });
      }
      this.add((0, _AuthenticatorEmailViewUtil.getCheckYourEmailTitle)(), {
        prepend: true,
        selector: '.o-form-error-container',
        options: {
          email,
          useEmailMagicLinkValue
        }
      });
    } else {
      this.add((0, _AuthenticatorEmailViewUtil.getCheckYourEmailEnrollTitle)(), {
        prepend: true,
        selector: '.o-form-error-container'
      });
    }
  },
  postRender() {
    BaseAuthenticatorEmailForm.prototype.postRender.apply(this, arguments);
    if (this.isUseEmailMagicLink() !== undefined) {
      if (this.isUseEmailMagicLink()) {
        this.showCodeEntryField(false);
      } else {
        this.noButtonBar = false;
      }
    }
  },
  isUseEmailMagicLink() {
    var _this$options$appStat4, _this$options$appStat5;
    return (_this$options$appStat4 = this.options.appState.get('currentAuthenticator')) === null || _this$options$appStat4 === void 0 ? void 0 : (_this$options$appStat5 = _this$options$appStat4.contextualData) === null || _this$options$appStat5 === void 0 ? void 0 : _this$options$appStat5.useEmailMagicLink;
  },
  showAuthCodeEntry() {
    this.noButtonBar = false;
    this.render();
    this.showCodeEntryField(true);
    this.removeEnterAuthCodeInsteadLink();
  },
  showCodeEntryField(show = true) {
    const $textField = this.$el.find('.o-form-fieldset-container');
    $textField.toggle(show);
  },
  removeEnterAuthCodeInsteadLink() {
    this.$el.find('.enter-auth-code-instead-link').remove();
  }
}));
var _default = _BaseAuthenticatorEmailView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/end-user-remediation/EndUserRemediationTerminalMessage.js":
/*!*********************************************************************************************!*\
  !*** ./src/v2/view-builder/views/end-user-remediation/EndUserRemediationTerminalMessage.js ***!
  \*********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _i18nTransformer = __webpack_require__(/*! ../../../ion/i18nTransformer */ "./src/v2/ion/i18nTransformer.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const I18N_KEY_PREFIX = 'idx.error.code.access_denied.device_assurance.remediation';
const HELP_AND_CONTACT_KEY_PREFIX = `${I18N_KEY_PREFIX}.additional_help_`;
const CUSTOM_URL_ADDITIONAL_HELP_KEY = `${I18N_KEY_PREFIX}.additional_help_custom`;
const REMEDIATION_OPTION_INDEX_KEY = `${I18N_KEY_PREFIX}.option_index`;
const TITLE_KEY = `${I18N_KEY_PREFIX}.title`;
const EXPLANATION_KEY_PREFIX = `${I18N_KEY_PREFIX}.explanation_`;
function buildRemediationOptionBlockMessage(message) {
  let link = null;
  if (message.links && message.links[0] && message.links[0].url) {
    link = message.links[0].url;
  }
  return {
    message: (0, _i18nTransformer.getMessage)(message),
    link,
    className: message.i18n.key === REMEDIATION_OPTION_INDEX_KEY ? 'end-user-remediation-option' : 'end-user-remediation-action'
  };
}
var _default = _courage.View.extend({
  className: 'end-user-remediation-terminal-view',
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"end-user-remediation-title\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "title",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 53
          },
          "end": {
            "line": 1,
            "column": 62
          }
        }
      }) : helper)) + "</div>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"end-user-remediation-explanation\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "explanation") || (depth0 != null ? lookupProperty(depth0, "explanation") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "explanation",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 140
          },
          "end": {
            "line": 1,
            "column": 155
          }
        }
      }) : helper)) + "</div>";
    },
    "5": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"end-user-remediation-options\">" + ((stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "remediationOptions") : depth0, {
        "name": "each",
        "hash": {},
        "fn": container.program(6, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 236
          },
          "end": {
            "line": 1,
            "column": 420
          }
        }
      })) != null ? stack1 : "") + "</div>";
    },
    "6": function (container, depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
        "name": "className",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 276
          },
          "end": {
            "line": 1,
            "column": 289
          }
        }
      }) : helper)) + "\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "link") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(7, data, 0),
        "inverse": container.program(9, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 291
          },
          "end": {
            "line": 1,
            "column": 405
          }
        }
      })) != null ? stack1 : "") + "</div>";
    },
    "7": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<a href=\"" + alias4((helper = (helper = lookupProperty(helpers, "link") || (depth0 != null ? lookupProperty(depth0, "link") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "link",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 312
          },
          "end": {
            "line": 1,
            "column": 320
          }
        }
      }) : helper)) + "\" target=\"_blank\" rel=\"noopener noreferrer\">" + alias4((helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "message",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 364
          },
          "end": {
            "line": 1,
            "column": 375
          }
        }
      }) : helper)) + "</a>";
    },
    "9": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return container.escapeExpression((helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "message",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 387
          },
          "end": {
            "line": 1,
            "column": 398
          }
        }
      }) : helper));
    },
    "11": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<a href='#' target='_blank' rel='noopener noreferrer' class='additional-help'>$1</a>",
          "bundle": "login",
          "code": "idx.error.code.access_denied.device_assurance.remediation.additional_help_custom"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 510
          },
          "end": {
            "line": 1,
            "column": 712
          }
        }
      }));
    },
    "13": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<a href='#' target='_blank' rel='noopener noreferrer' class='additional-help'>$1</a>",
          "bundle": "login",
          "code": "idx.error.code.access_denied.device_assurance.remediation.additional_help_default"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 720
          },
          "end": {
            "line": 1,
            "column": 923
          }
        }
      }));
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 75
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "explanation") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 75
          },
          "end": {
            "line": 1,
            "column": 168
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "remediationOptions") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(5, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 168
          },
          "end": {
            "line": 1,
            "column": 433
          }
        }
      })) != null ? stack1 : "") + "<div class=\"end-user-remediation-help-and-contact\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "useCustomHelpText") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(11, data, 0),
        "inverse": container.program(13, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 484
          },
          "end": {
            "line": 1,
            "column": 930
          }
        }
      })) != null ? stack1 : "") + "</div>";
    },
    "useData": true
  }),
  getTemplateData() {
    const messages = this.options.messages.value;
    const remediationOptions = [];
    let title = null;
    let explanation = null;
    let useCustomHelpText = false;
    messages.forEach(message => {
      if (message.i18n.key === TITLE_KEY) {
        title = (0, _i18nTransformer.getMessage)(message);
      } else if (message.i18n.key.startsWith(EXPLANATION_KEY_PREFIX)) {
        explanation = (0, _i18nTransformer.getMessage)(message);
      } else if (message.i18n.key.startsWith(HELP_AND_CONTACT_KEY_PREFIX)) {
        useCustomHelpText = message.i18n.key === CUSTOM_URL_ADDITIONAL_HELP_KEY;
        if (message.links && message.links[0] && message.links[0].url) {
          this.additionalHelpUrl = message.links[0].url;
        }
      } else {
        remediationOptions.push(buildRemediationOptionBlockMessage(message));
      }
    });
    return {
      title,
      explanation,
      remediationOptions,
      useCustomHelpText
    };
  },
  render() {
    _courage.View.prototype.render.apply(this, arguments);
    if (this.additionalHelpUrl) {
      this.$el.find('.additional-help').attr('href', this.additionalHelpUrl);
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/enroll-profile/i18nBaseAttributeMappings.js":
/*!*******************************************************************************!*\
  !*** ./src/v2/view-builder/views/enroll-profile/i18nBaseAttributeMappings.js ***!
  \*******************************************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.I18N_BASE_ATTRIBUTE_ENROLL_PROFILE_MAPPINGS = void 0;
const I18N_BASE_ATTRIBUTE_ENROLL_PROFILE_MAPPINGS = {
  /**
   * Mapping fields in the enroll profile remediation form to their i18n label for localization.
   */
  'enroll-profile.userProfile.login': 'oie.user.profile.login',
  'enroll-profile.userProfile.lastName': 'oie.user.profile.lastname',
  'enroll-profile.userProfile.firstName': 'oie.user.profile.firstname',
  'enroll-profile.userProfile.email': 'oie.user.profile.primary.email',
  'enroll-profile.userProfile.secondEmail': 'oie.user.profile.secondary.email',
  'enroll-profile.userProfile.middleName': 'oie.user.profile.middleName',
  'enroll-profile.userProfile.honorificPrefix': 'oie.user.profile.honorificPrefix',
  'enroll-profile.userProfile.honorificSuffix': 'oie.user.profile.honorificSuffix',
  'enroll-profile.userProfile.title': 'oie.user.profile.title',
  'enroll-profile.userProfile.displayName': 'oie.user.profile.displayName',
  'enroll-profile.userProfile.nickName': 'oie.user.profile.nickName',
  'enroll-profile.userProfile.profileUrl': 'oie.user.profile.profileUrl',
  'enroll-profile.userProfile.mobilePhone': 'oie.user.profile.mobilePhone',
  'enroll-profile.userProfile.primaryPhone': 'oie.user.profile.primaryPhone',
  'enroll-profile.userProfile.streetAddress': 'oie.user.profile.streetAddress',
  'enroll-profile.userProfile.city': 'oie.user.profile.city',
  'enroll-profile.userProfile.state': 'oie.user.profile.state',
  'enroll-profile.userProfile.zipCode': 'oie.user.profile.zipCode',
  'enroll-profile.userProfile.postalCode': 'oie.user.profile.postalCode',
  'enroll-profile.userProfile.countryCode': 'oie.user.profile.countryCode',
  'enroll-profile.userProfile.postalAddress': 'oie.user.profile.postalAddress',
  'enroll-profile.userProfile.preferredLanguage': 'oie.user.profile.preferredLanguage',
  'enroll-profile.userProfile.locale': 'oie.user.profile.locale',
  'enroll-profile.userProfile.timezone': 'oie.user.profile.timezone',
  'enroll-profile.userProfile.userType': 'oie.user.profile.userType',
  'enroll-profile.userProfile.employeeNumber': 'oie.user.profile.employeeNumber',
  'enroll-profile.userProfile.costCenter': 'oie.user.profile.costCenter',
  'enroll-profile.userProfile.organization': 'oie.user.profile.organization',
  'enroll-profile.userProfile.division': 'oie.user.profile.division',
  'enroll-profile.userProfile.department': 'oie.user.profile.department',
  'enroll-profile.userProfile.managerId': 'oie.user.profile.managerId',
  'enroll-profile.userProfile.manager': 'oie.user.profile.manager',
  'enroll-profile.credentials.passcode': 'oie.password.label'
};
exports.I18N_BASE_ATTRIBUTE_ENROLL_PROFILE_MAPPINGS = I18N_BASE_ATTRIBUTE_ENROLL_PROFILE_MAPPINGS;

/***/ }),

/***/ "./src/v2/view-builder/views/google-authenticator/ChallengeGoogleAuthenticatorView.js":
/*!********************************************************************************************!*\
  !*** ./src/v2/view-builder/views/google-authenticator/ChallengeGoogleAuthenticatorView.js ***!
  \********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend(Object.assign({
  className: 'google-authenticator-challenge',
  title() {
    return (0, _courage.loc)('oie.verify.google_authenticator.otp.title', 'login');
  },
  subtitle() {
    return (0, _courage.loc)('oie.verify.google_authenticator.otp.description', 'login');
  },
  save() {
    return (0, _courage.loc)('mfa.challenge.verify', 'login');
  }
}));
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/google-authenticator/EnrollAuthenticatorGoogleAuthenticatorView.js":
/*!******************************************************************************************************!*\
  !*** ./src/v2/view-builder/views/google-authenticator/EnrollAuthenticatorGoogleAuthenticatorView.js ***!
  \******************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _EnrollGoogleAuthenticatorBarcodeView = _interopRequireDefault(__webpack_require__(/*! ./EnrollGoogleAuthenticatorBarcodeView */ "./src/v2/view-builder/views/google-authenticator/EnrollGoogleAuthenticatorBarcodeView.js"));
var _EnrollAuthenticatorManualSetupView = _interopRequireDefault(__webpack_require__(/*! ./EnrollAuthenticatorManualSetupView */ "./src/v2/view-builder/views/google-authenticator/EnrollAuthenticatorManualSetupView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const VIEW_TO_DISPLAY = 'viewToDisplay';
const viewToDisplayState = {
  BARCODE: 'barcode',
  MANUAL: 'manual',
  ENTER_CODE: 'enterCode'
};
const Body = _internals.BaseForm.extend({
  title() {
    return (0, _courage.loc)('oie.enroll.google_authenticator.setup.title', 'login');
  },
  noButtonBar: true,
  className: 'oie-enroll-google-authenticator',
  enterCodeSubtitle: _courage.View.extend({
    template: _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function (container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
        return "<div class=\"google-authenticator-setup-info-title enter-code-title\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "oie.enroll.google_authenticator.enterCode.title"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 68
            },
            "end": {
              "line": 1,
              "column": 146
            }
          }
        })) + "</div>";
      },
      "useData": true
    })
  }),
  getUISchema() {
    const schema = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);
    // https://oktainc.atlassian.net/browse/OKTA-555191
    const nextButton = (0, _internals.addCustomButton)({
      className: 'google-authenticator-next',
      title: (0, _courage.loc)('oform.next', 'login'),
      click: () => {
        this.model.set(VIEW_TO_DISPLAY, viewToDisplayState.ENTER_CODE);
      }
    });
    const verifyButton = (0, _internals.addCustomButton)({
      className: 'google-authenticator-verify',
      title: (0, _courage.loc)('oform.verify', 'login'),
      click: () => {
        this.$el.submit();
      }
    });
    schema[0].showWhen = {
      viewToDisplay: viewToDisplayState.ENTER_CODE
    };

    // Add Enter Code Subtitle
    schema.unshift({
      View: this.enterCodeSubtitle,
      selector: '.o-form-fieldset-container',
      showWhen: {
        viewToDisplay: viewToDisplayState.ENTER_CODE
      }
    });
    schema.push({
      View: _EnrollGoogleAuthenticatorBarcodeView.default,
      selector: '.o-form-fieldset-container',
      showWhen: {
        viewToDisplay: viewToDisplayState.BARCODE
      }
    }, {
      View: _EnrollAuthenticatorManualSetupView.default,
      selector: '.o-form-fieldset-container',
      showWhen: {
        viewToDisplay: viewToDisplayState.MANUAL
      }
    }, {
      label: false,
      className: 'shared-secret no-translate',
      type: 'text',
      placeholder: this.options.appState.get('currentAuthenticator').contextualData.sharedSecret,
      disabled: true,
      showWhen: {
        viewToDisplay: viewToDisplayState.MANUAL
      }
    }, {
      View: nextButton,
      showWhen: {
        viewToDisplay: val => val === viewToDisplayState.BARCODE || val === viewToDisplayState.MANUAL
      }
    }, {
      View: verifyButton,
      showWhen: {
        viewToDisplay: val => val === viewToDisplayState.ENTER_CODE
      }
    });
    return schema;
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body,
  createModelClass() {
    const ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments);
    const local = Object.assign({
      viewToDisplay: {
        value: 'barcode',
        type: 'string',
        required: true,
        values: [viewToDisplayState.BARCODE, viewToDisplayState.MANUAL, viewToDisplayState.ENTER_CODE]
      }
    }, ModelClass.prototype.local);
    return ModelClass.extend({
      local
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/google-authenticator/EnrollAuthenticatorManualSetupView.js":
/*!**********************************************************************************************!*\
  !*** ./src/v2/view-builder/views/google-authenticator/EnrollAuthenticatorManualSetupView.js ***!
  \**********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _courage.View.extend({
  className: 'oie-enroll-google-authenticator-manual-setup',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"google-authenticator-setup-info-title manual-setup-title\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.google_authenticator.cannotScanBarcode.title"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 70
          },
          "end": {
            "line": 1,
            "column": 156
          }
        }
      })) + "</div><p class=\"google-authenticator-setup-info\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.google_authenticator.manualSetupInstructions"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 205
          },
          "end": {
            "line": 1,
            "column": 291
          }
        }
      })) + "</p>";
    },
    "useData": true
  })
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/google-authenticator/EnrollGoogleAuthenticatorBarcodeView.js":
/*!************************************************************************************************!*\
  !*** ./src/v2/view-builder/views/google-authenticator/EnrollGoogleAuthenticatorBarcodeView.js ***!
  \************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _courage.View.extend({
  className: 'oie-enroll-google-authenticator-barcode',
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"google-authenticator-setup-info-title barcode-setup-title\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.google_authenticator.scanBarcode.title"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 83
          },
          "end": {
            "line": 1,
            "column": 163
          }
        }
      })) + "</div><div class=\"qrcode-info-container\"><p class=\"google-authenticator-setup-info\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.google_authenticator.scanBarcode.description"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 247
          },
          "end": {
            "line": 1,
            "column": 333
          }
        }
      })) + "</p><div class=\"qrcode-container\"><img class=\"qrcode\" src=" + alias3((helper = (helper = lookupProperty(helpers, "href") || (depth0 != null ? lookupProperty(depth0, "href") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "href",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 391
          },
          "end": {
            "line": 1,
            "column": 399
          }
        }
      }) : helper)) + " alt=\"qr code\"></img><a href=\"#\" class=\"cannot-scan-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.google_authenticator.scanBarcode.cannotScan"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 457
          },
          "end": {
            "line": 1,
            "column": 542
          }
        }
      })) + "</a></div></div>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "href") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 565
          }
        }
      })) != null ? stack1 : "";
    },
    "useData": true
  }),
  getTemplateData() {
    var _contextualData$qrcod;
    const contextualData = this.options.appState.get('currentAuthenticator').contextualData;
    return {
      href: (_contextualData$qrcod = contextualData.qrcode) === null || _contextualData$qrcod === void 0 ? void 0 : _contextualData$qrcod.href
    };
  },
  events: {
    'click .cannot-scan-link': function (e) {
      e.preventDefault();
      this.options.model.set('viewToDisplay', 'manual');
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/idp/AuthenticatorIdPEnrollView.js":
/*!*********************************************************************!*\
  !*** ./src/v2/view-builder/views/idp/AuthenticatorIdPEnrollView.js ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _BaseIdpAuthenticator = __webpack_require__(/*! ./BaseIdpAuthenticator */ "./src/v2/view-builder/views/idp/BaseIdpAuthenticator.js");
const Body = _BaseIdpAuthenticator.BaseIdPAuthenticatorBody.extend({
  title() {
    const displayName = this.options.appState.getAuthenticatorDisplayName();
    return (0, _courage.loc)('oie.idp.enroll.title', 'login', [displayName]);
  },
  subtitle() {
    const displayName = this.options.appState.getAuthenticatorDisplayName();
    return (0, _courage.loc)('oie.idp.enroll.description', 'login', [displayName]);
  },
  save() {
    return (0, _courage.loc)('mfa.enroll', 'login');
  }
});
var _default = _BaseIdpAuthenticator.BaseIdpAuthenticatorView.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/idp/AuthenticatorIdPVerifyView.js":
/*!*********************************************************************!*\
  !*** ./src/v2/view-builder/views/idp/AuthenticatorIdPVerifyView.js ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _BaseIdpAuthenticator = __webpack_require__(/*! ./BaseIdpAuthenticator */ "./src/v2/view-builder/views/idp/BaseIdpAuthenticator.js");
const Body = _BaseIdpAuthenticator.BaseIdPAuthenticatorBody.extend({
  title() {
    const displayName = this.options.appState.getAuthenticatorDisplayName();
    return (0, _courage.loc)('oie.idp.challenge.title', 'login', [displayName]);
  },
  subtitle() {
    const displayName = this.options.appState.getAuthenticatorDisplayName();
    return (0, _courage.loc)('oie.idp.challenge.description', 'login', [displayName]);
  },
  save() {
    return (0, _courage.loc)('mfa.challenge.verify', 'login');
  }
});
var _default = _BaseIdpAuthenticator.BaseIdpAuthenticatorView.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/idp/BaseIdpAuthenticator.js":
/*!***************************************************************!*\
  !*** ./src/v2/view-builder/views/idp/BaseIdpAuthenticator.js ***!
  \***************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.BaseIdpAuthenticatorView = exports.BaseIdPAuthenticatorBody = void 0;
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! v2/view-builder/components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BaseIdPAuthenticatorBody = _internals.BaseForm.extend({
  initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    this.model.set('useRedirect', true);
    this.add('<div class="okta-waiting-spinner"></div>');
  }
});
exports.BaseIdPAuthenticatorBody = BaseIdPAuthenticatorBody;
const BaseIdpAuthenticatorView = _BaseAuthenticatorView.default.extend({
  postRender() {
    _BaseAuthenticatorView.default.prototype.postRender.apply(this, arguments);
    // get the error messages
    const messages = this.options.appState.get('messages') || {};
    // In case of failure, don't auto-redirect which will result in infinite redirects.
    // so catch the error and render to the user.
    if (this.settings.get('features.skipIdpFactorVerificationBtn') && !Array.isArray(messages.value)) {
      this.$('.o-form-button-bar').hide();
      this.$('.okta-waiting-spinner').show();
      this.form.trigger('save', this.model);
    } else {
      this.$('.okta-waiting-spinner').hide();
      this.$('.o-form-button-bar').show();
    }
  }
});
exports.BaseIdpAuthenticatorView = BaseIdpAuthenticatorView;

/***/ }),

/***/ "./src/v2/view-builder/views/keep-me-signed-in/PostAuthKeepMeSignedInView.js":
/*!***********************************************************************************!*\
  !*** ./src/v2/view-builder/views/keep-me-signed-in/PostAuthKeepMeSignedInView.js ***!
  \***********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
const Body = _internals.BaseForm.extend({
  noSubmitButton: true,
  title() {
    return (0, _courage.loc)('oie.kmsi.title', 'login');
  },
  subtitle() {
    return (0, _courage.loc)('oie.kmsi.subtitle', 'login');
  },
  saveForm(isKeepMeSignedIn) {
    this.model.set('keepMeSignedIn', isKeepMeSignedIn);
    this.options.appState.trigger('saveForm', this.model);
  },
  // Overrides the default getUISchema in order to render 2 buttons instead of a checkbox
  getUISchema() {
    const form = this;
    const acceptButton = (0, _courage.createButton)({
      className: 'button button-secondary',
      title: (0, _courage.loc)('oie.kmsi.accept', 'login'),
      attributes: {
        'data-se': 'stay-signed-in-btn'
      },
      click: function () {
        form.saveForm(true);
      }
    });
    const rejectButton = (0, _courage.createButton)({
      className: 'button button-secondary',
      title: (0, _courage.loc)('oie.kmsi.reject', 'login'),
      attributes: {
        'data-se': 'do-not-stay-signed-in-btn'
      },
      click: function () {
        form.saveForm(false);
      }
    });
    return [{
      View: acceptButton
    }, {
      View: rejectButton
    }];
  }
});
var _default = _internals.BaseView.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/on-prem/ChallengeAuthenticatorOnPremView.js":
/*!*******************************************************************************!*\
  !*** ./src/v2/view-builder/views/on-prem/ChallengeAuthenticatorOnPremView.js ***!
  \*******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ON_PREM_TOKEN_CHANGE_KEY = 'errors.E0000113';
const Body = _internals.BaseForm.extend({
  className: 'on-prem-authenticator-verify',
  modelEvents: {
    'error': '_checkTokenChange'
  },
  title() {
    const vendorName = this.options.appState.getAuthenticatorDisplayName() || (0, _courage.loc)('oie.on_prem.authenticator.default.vendorName', 'login');
    return (0, _courage.loc)('oie.on_prem.verify.title', 'login', [vendorName]);
  },
  _checkTokenChange(model, convertedErrors) {
    var _convertedErrors$resp;
    const errorSummaryKeys = convertedErrors === null || convertedErrors === void 0 ? void 0 : (_convertedErrors$resp = convertedErrors.responseJSON) === null || _convertedErrors$resp === void 0 ? void 0 : _convertedErrors$resp.errorSummaryKeys;
    if (errorSummaryKeys && errorSummaryKeys.includes(ON_PREM_TOKEN_CHANGE_KEY)) {
      // this means we are in change pin, so we should clear out answer input
      this.model.set('credentials.passcode', '');
      this.render();
    }
  },
  save() {
    return (0, _courage.loc)('mfa.challenge.verify', 'login');
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/on-prem/EnrollAuthenticatorOnPremView.js":
/*!****************************************************************************!*\
  !*** ./src/v2/view-builder/views/on-prem/EnrollAuthenticatorOnPremView.js ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ON_PREM_TOKEN_CHANGE_KEY = 'errors.E0000113';
const Body = _internals.BaseForm.extend({
  className: 'on-prem-authenticator-enroll',
  modelEvents: {
    'error': '_checkTokenChange'
  },
  title() {
    const vendorName = this.options.appState.getAuthenticatorDisplayName() || (0, _courage.loc)('oie.on_prem.authenticator.default.vendorName', 'login');
    return (0, _courage.loc)('oie.on_prem.enroll.title', 'login', [vendorName]);
  },
  _checkTokenChange(model, convertedErrors) {
    var _convertedErrors$resp;
    const errorSummaryKeys = convertedErrors === null || convertedErrors === void 0 ? void 0 : (_convertedErrors$resp = convertedErrors.responseJSON) === null || _convertedErrors$resp === void 0 ? void 0 : _convertedErrors$resp.errorSummaryKeys;
    if (errorSummaryKeys && errorSummaryKeys.includes(ON_PREM_TOKEN_CHANGE_KEY)) {
      // this means we are in change pin, so we should clear out answer input
      this.model.set('credentials.passcode', '');
      this.render();
    }
  },
  save() {
    return (0, _courage.loc)('mfa.challenge.verify', 'login');
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/ov/ChallengeOktaVerifyFastPassView.js":
/*!*************************************************************************!*\
  !*** ./src/v2/view-builder/views/ov/ChallengeOktaVerifyFastPassView.js ***!
  \*************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _ChallengeViewUtil = __webpack_require__(/*! ../../utils/ChallengeViewUtil */ "./src/v2/view-builder/utils/ChallengeViewUtil.js");
const Body = _internals.BaseOktaVerifyChallengeView.extend({
  getDeviceChallengePayload() {
    return this.options.currentViewState.relatesTo.value.contextualData.challenge.value;
  },
  showCustomFormErrorCallout(error) {
    const options = (0, _ChallengeViewUtil.getBiometricsErrorOptions)(error, false);

    // If not biometrics error, just show the returned error message
    if (_courage._.isEmpty(options)) {
      return false;
    }
    this.showMessages((0, _courage.createCallout)(options));
    return true;
  }
});
var _default = Body;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/ov/ChallengeOktaVerifyResendPushView.js":
/*!***************************************************************************!*\
  !*** ./src/v2/view-builder/views/ov/ChallengeOktaVerifyResendPushView.js ***!
  \***************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const OV_NMC_FORCE_UPGRAGE_SERVER_KEY = 'oie.authenticator.app.method.push.force.upgrade.number_challenge';
const OV_UV_ENABLE_BIOMETRIC_SERVER_KEY = 'oie.authenticator.app.method.push.verify.enable.biometrics';
const Body = _internals.BaseForm.extend(Object.assign({
  className: 'okta-verify-resend-push',
  title() {
    return (0, _courage.loc)('oie.okta_verify.push.title', 'login');
  },
  save() {
    return (0, _courage.loc)('oie.okta_verify.push.resend', 'login');
  },
  showMessages() {
    let options = {};
    if (this.options.appState.containsMessageWithI18nKey(OV_NMC_FORCE_UPGRAGE_SERVER_KEY)) {
      // add a title for OV force upgrade
      options.title = (0, _courage.loc)('oie.numberchallenge.force.upgrade.title', 'login');
    } else if (this.options.appState.containsMessageWithI18nKey(OV_UV_ENABLE_BIOMETRIC_SERVER_KEY)) {
      // add a title for OV enable biometrics message during verification
      options.content = null;
      options.className = 'okta-verify-uv-callout-content';
      options.title = (0, _courage.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.title', 'login');
      options.subtitle = (0, _courage.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.description', 'login');
      options.type = 'error';
      options.bullets = [(0, _courage.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point1', 'login'), (0, _courage.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point2', 'login'), (0, _courage.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point3', 'login')];
      options = (0, _courage.createCallout)(options);
    }
    _internals.BaseForm.prototype.showMessages.call(this, options);
  }
}));
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/ov/ChallengeOktaVerifySSOExtensionView.js":
/*!*****************************************************************************!*\
  !*** ./src/v2/view-builder/views/ov/ChallengeOktaVerifySSOExtensionView.js ***!
  \*****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _ChallengeViewUtil = __webpack_require__(/*! ../../utils/ChallengeViewUtil */ "./src/v2/view-builder/utils/ChallengeViewUtil.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// for EA,
// redirect is needed for Apple SSO Extension to intercept the request, because
// - XHR request is not interceptable
// - form post is interceptable, but some app (Outlook) closes the app after
// We may have a different approach/UX for GA
const Body = _internals.BaseForm.extend({
  noButtonBar: true,
  className: 'ion-form device-challenge-poll',
  title() {
    return (0, _courage.loc)('deviceTrust.sso.redirectText', 'login');
  },
  initialize() {
    var _this$options$current, _this$options$current2;
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    this.listenTo(this.model, 'error', () => {
      this.$('.spinner').hide();
    });
    this.add('<div class="credential-sso-extension"><div class="spinner"></div></div>');
    const isGetMethod = ((_this$options$current = this.options.currentViewState) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.method) === null || _this$options$current2 === void 0 ? void 0 : _this$options$current2.toLowerCase()) === 'get';
    this.model.set('useRedirect', isGetMethod);
    this.trigger('save', this.model);
  },
  showCustomFormErrorCallout(error) {
    const options = (0, _ChallengeViewUtil.getBiometricsErrorOptions)(error, false);

    // If not biometrics error, just show the returned error message
    if (_courage._.isEmpty(options)) {
      return false;
    }
    this.showMessages((0, _courage.createCallout)(options));
    return true;
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/ov/ChallengeOktaVerifyTotpView.js":
/*!*********************************************************************!*\
  !*** ./src/v2/view-builder/views/ov/ChallengeOktaVerifyTotpView.js ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const OV_UV_ENABLE_BIOMETRIC_SERVER_KEY = 'oie.authenticator.oktaverify.method.totp.verify.enable.biometrics';
const Body = _internals.BaseForm.extend(Object.assign({
  className: 'okta-verify-totp-challenge',
  title() {
    return (0, _courage.loc)('oie.okta_verify.totp.title', 'login');
  },
  save() {
    return (0, _courage.loc)('mfa.challenge.verify', 'login');
  },
  showCustomFormErrorCallout(error) {
    var _error$responseJSON;
    const errorSummaryKeys = error === null || error === void 0 ? void 0 : (_error$responseJSON = error.responseJSON) === null || _error$responseJSON === void 0 ? void 0 : _error$responseJSON.errorSummaryKeys;
    let options;
    if (errorSummaryKeys && errorSummaryKeys.includes(OV_UV_ENABLE_BIOMETRIC_SERVER_KEY)) {
      options = {
        type: 'error',
        className: 'okta-verify-uv-callout-content',
        title: (0, _courage.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.title', 'login'),
        subtitle: (0, _courage.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.description', 'login'),
        bullets: [(0, _courage.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point1', 'login'), (0, _courage.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point2', 'login'), (0, _courage.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point3', 'login')]
      };
      this.showMessages((0, _courage.createCallout)(options));
      return true;
    }
  }
}));
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/ov/ChallengeOktaVerifyView.js":
/*!*****************************************************************!*\
  !*** ./src/v2/view-builder/views/ov/ChallengeOktaVerifyView.js ***!
  \*****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _ChallengePushView = __webpack_require__(/*! ../shared/ChallengePushView */ "./src/v2/view-builder/views/shared/ChallengePushView.js");
var _ChallengeOktaVerifyFastPassView = _interopRequireDefault(__webpack_require__(/*! ./ChallengeOktaVerifyFastPassView */ "./src/v2/view-builder/views/ov/ChallengeOktaVerifyFastPassView.js"));
var _NumberChallengePushView = _interopRequireDefault(__webpack_require__(/*! ./NumberChallengePushView */ "./src/v2/view-builder/views/ov/NumberChallengePushView.js"));
var _RemediationConstants = __webpack_require__(/*! ../../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _BaseAuthenticatorView.default.extend({
  initialize() {
    var _this$options, _this$options$appStat, _currentAuthenticator;
    _BaseAuthenticatorView.default.prototype.initialize.apply(this, arguments);
    const currentAuthenticator = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$appStat = _this$options.appState) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.get('currentAuthenticator');
    const selectedMethod = currentAuthenticator === null || currentAuthenticator === void 0 ? void 0 : currentAuthenticator.methods[0];
    if ((selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.type) === _RemediationConstants.AUTHENTICATOR_METHODS.PUSH && currentAuthenticator !== null && currentAuthenticator !== void 0 && (_currentAuthenticator = currentAuthenticator.contextualData) !== null && _currentAuthenticator !== void 0 && _currentAuthenticator.correctAnswer) {
      this.Body = _NumberChallengePushView.default;
    } else if ((selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.type) === _RemediationConstants.AUTHENTICATOR_METHODS.PUSH) {
      this.Body = _ChallengePushView.Body;
    } else {
      this.Body = _ChallengeOktaVerifyFastPassView.default;
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/ov/EnrollChannelPollDescriptionView.js":
/*!**************************************************************************!*\
  !*** ./src/v2/view-builder/views/ov/EnrollChannelPollDescriptionView.js ***!
  \**************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _RemediationConstants = __webpack_require__(/*! ../../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const {
  Notification
} = _courage.internal.views.components;
const {
  Clipboard
} = _courage.internal.util;
var _default = _courage.View.extend({
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<ol class=\"qrcode-info ov-info\"><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.qrcode.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 48
          },
          "end": {
            "line": 1,
            "column": 114
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.qrcode.step2"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 123
          },
          "end": {
            "line": 1,
            "column": 189
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.qrcode.step3"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 198
          },
          "end": {
            "line": 1,
            "column": 264
          }
        }
      })) + "</li></ol><div class=\"qrcode-container\"><img class=\"qrcode\" src=" + alias3((helper = (helper = lookupProperty(helpers, "href") || (depth0 != null ? lookupProperty(depth0, "href") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "href",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 328
          },
          "end": {
            "line": 1,
            "column": 336
          }
        }
      }) : helper)) + " alt=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "mfa.altQrCode"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 342
          },
          "end": {
            "line": 1,
            "column": 387
          }
        }
      })) + "\"></img></div>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<ul class=\"email-info ov-info\"><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "arguments": "email",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.email.info"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 456
          },
          "end": {
            "line": 1,
            "column": 540
          }
        }
      })) != null ? stack1 : "") + "</li><li class=\"switch-channel-content\"></li></ul>";
    },
    "5": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<ul class=\"sms-info ov-info\"><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "arguments": "phoneNumber",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.sms.info"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 649
          },
          "end": {
            "line": 1,
            "column": 737
          }
        }
      })) != null ? stack1 : "") + "</li><li class=\"switch-channel-content\"></li></ul>";
    },
    "7": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"sameDevice-setup" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(8, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 850
          },
          "end": {
            "line": 1,
            "column": 916
          }
        }
      })) != null ? stack1 : "") + "\"><p class=\"explanation\" data-se=\"subheader\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "isDesktop") : stack1, {
        "name": "if",
        "hash": {},
        "fn": container.program(10, data, 0),
        "inverse": container.program(17, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 961
          },
          "end": {
            "line": 1,
            "column": 1734
          }
        }
      })) != null ? stack1 : "") + "</p><ol class=\"ov-info\">" + ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
        "name": "unless",
        "hash": {},
        "fn": container.program(19, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1758
          },
          "end": {
            "line": 1,
            "column": 2172
          }
        }
      })) != null ? stack1 : "") + "<li><a href=\"" + alias2(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "setupOVUrl") : stack1, depth0)) + "\" class=\"button button-primary setup-button\">" + alias2((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.title"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2254
          },
          "end": {
            "line": 1,
            "column": 2319
          }
        }
      })) + "</a></li>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(22, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2328
          },
          "end": {
            "line": 1,
            "column": 2644
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "showAnotherDeviceLink") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(24, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2644
          },
          "end": {
            "line": 1,
            "column": 2983
          }
        }
      })) != null ? stack1 : "") + "</ol></div>";
    },
    "8": function (container, depth0, helpers, partials, data) {
      return " ov-enrollment-enabled";
    },
    "10": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"desktop-instructions ov-info\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='semi-strong'>$1</span>",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.customUri.prompt"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1030
          },
          "end": {
            "line": 1,
            "column": 1147
          }
        }
      })) + "</div><div class=\"desktop-instructions\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(11, data, 0),
        "inverse": container.program(13, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1187
          },
          "end": {
            "line": 1,
            "column": 1443
          }
        }
      })) != null ? stack1 : "") + "</div>" + ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
        "name": "unless",
        "hash": {},
        "fn": container.program(15, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1449
          },
          "end": {
            "line": 1,
            "column": 1625
          }
        }
      })) != null ? stack1 : "");
    },
    "11": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<span>$1</span>",
          "bundle": "login",
          "code": "customUri.required.content.prompt"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1224
          },
          "end": {
            "line": 1,
            "column": 1309
          }
        }
      }));
    },
    "13": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='semi-strong'>$1</span>",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.customUri.noPrompt"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1317
          },
          "end": {
            "line": 1,
            "column": 1436
          }
        }
      }));
    },
    "15": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<div class=\"desktop-instructions\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.customUri.makeSureHaveOV"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1524
          },
          "end": {
            "line": 1,
            "column": 1608
          }
        }
      })) + "</div>";
    },
    "17": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.customUri.makeSureHaveOVToContinue"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1633
          },
          "end": {
            "line": 1,
            "column": 1727
          }
        }
      }));
    },
    "19": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "platformLC") : stack1, {
        "name": "if",
        "hash": {},
        "fn": container.program(20, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1799
          },
          "end": {
            "line": 1,
            "column": 2036
          }
        }
      })) != null ? stack1 : "") + "<li>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='semi-strong'>$1</span>",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.customUri.setup"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2040
          },
          "end": {
            "line": 1,
            "column": 2156
          }
        }
      })) + "</li>";
    },
    "20": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = container.escapeExpression,
        alias2 = container.lambda,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<li><a aria-label='" + alias1((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "customUri.required.content.download.linkText"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 1846
          },
          "end": {
            "line": 1,
            "column": 1921
          }
        }
      })) + "' href=\"" + alias1(alias2((stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "downloadHref") : stack1, depth0)) + "\" class=\"app-store-logo " + alias1(alias2((stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "platformLC") : stack1, depth0)) + "-app-store-logo\"></a></li>";
    },
    "22": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<li><span>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "customUri.required.content.download.title"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2375
          },
          "end": {
            "line": 1,
            "column": 2447
          }
        }
      })) + "</span>&nbsp;<a href=\"" + alias3(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "downloadHref") : stack1, depth0)) + "\" target=\"_blank\" id=\"download-ov\" class=\"orOnMobileLink\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "customUri.required.content.download.linkText"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2553
          },
          "end": {
            "line": 1,
            "column": 2628
          }
        }
      })) + "</a></li>";
    },
    "24": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<li>" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "isDesktop") : stack1, {
        "name": "if",
        "hash": {},
        "fn": container.program(25, data, 0),
        "inverse": container.program(27, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2677
          },
          "end": {
            "line": 1,
            "column": 2971
          }
        }
      })) != null ? stack1 : "") + "</li>";
    },
    "25": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<a class='orOnMobileLink' href='#'>$1</a>",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.customUri.orOnMobile"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2704
          },
          "end": {
            "line": 1,
            "column": 2831
          }
        }
      }));
    },
    "27": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<a class='orOnMobileLink' href='#'>$1</a>",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.customUri.orMobile"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 2839
          },
          "end": {
            "line": 1,
            "column": 2964
          }
        }
      }));
    },
    "29": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDevice") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(30, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3002
          },
          "end": {
            "line": 1,
            "column": 3879
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "deviceBootstrap") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(32, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3879
          },
          "end": {
            "line": 1,
            "column": 4660
          }
        }
      })) != null ? stack1 : "");
    },
    "30": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        alias4 = container.lambda,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p class=\"explanation\" data-se=\"subheader\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.subtitle "
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3063
          },
          "end": {
            "line": 1,
            "column": 3132
          }
        }
      })) + "</p><ol class=\"sameDevice-info ov-info\"><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "arguments": "sameDevice.downloadHref",
          "bundle": "login",
          "code": "enroll.oda.without.account.step1"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3176
          },
          "end": {
            "line": 1,
            "column": 3277
          }
        }
      })) != null ? stack1 : "") + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.openOv"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3286
          },
          "end": {
            "line": 1,
            "column": 3352
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.signInUrl"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3361
          },
          "end": {
            "line": 1,
            "column": 3430
          }
        }
      })) + "<br><br/><span class='semi-strong no-translate'>" + alias3(alias4((stack1 = depth0 != null ? lookupProperty(depth0, "sameDevice") : depth0) != null ? lookupProperty(stack1, "orgUrl") : stack1, depth0)) + "</span><a data-clipboard-text=\"" + alias3(alias4((stack1 = depth0 != null ? lookupProperty(depth0, "sameDevice") : depth0) != null ? lookupProperty(stack1, "orgUrl") : stack1, depth0)) + "\" class=\"button link-button copy-org-clipboard-button\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.oda.org.copyLink"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3606
          },
          "end": {
            "line": 1,
            "column": 3660
          }
        }
      })) + "</a></li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.skipAuth.followInstruction"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3673
          },
          "end": {
            "line": 1,
            "column": 3759
          }
        }
      })) + "</li></ol><p class=\"closing\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.skipAuth.canBeClosed"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3788
          },
          "end": {
            "line": 1,
            "column": 3868
          }
        }
      })) + "</p>";
    },
    "32": function (container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p class=\"explanation\" data-se=\"subheader\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.skipAuth.subtitle"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3945
          },
          "end": {
            "line": 1,
            "column": 4022
          }
        }
      })) + "</p><ol class=\"deviceBootstrap-info ov-info\"><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='semi-strong'>$1</span>",
          "arguments": "enrolledDeviceName",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.skipAuth.openOv.suchAs"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 4071
          },
          "end": {
            "line": 1,
            "column": 4225
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.skipAuth.selectAccount"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 4234
          },
          "end": {
            "line": 1,
            "column": 4316
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='semi-strong'>$1</span>",
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.skipAuth.addAccount"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 4325
          },
          "end": {
            "line": 1,
            "column": 4445
          }
        }
      })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.skipAuth.followInstruction"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 4454
          },
          "end": {
            "line": 1,
            "column": 4540
          }
        }
      })) + "</li></ol><p class=\"closing\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.setup.skipAuth.canBeClosed"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 4569
          },
          "end": {
            "line": 1,
            "column": 4649
          }
        }
      })) + "</p>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "href") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 408
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "email") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 408
          },
          "end": {
            "line": 1,
            "column": 597
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "phoneNumber") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(5, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 597
          },
          "end": {
            "line": 1,
            "column": 794
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "setupOVUrl") : stack1, {
        "name": "if",
        "hash": {},
        "fn": container.program(7, data, 0),
        "inverse": container.program(29, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 794
          },
          "end": {
            "line": 1,
            "column": 4667
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  /* eslint complexity: [2, 20] */
  getTemplateData() {
    var _contextualData$qrcod;
    const contextualData = this.options.appState.get('currentAuthenticator').contextualData;
    let enrolledDeviceName = '';
    let deviceMap = {};
    let showAnotherDeviceLink = false;
    if (contextualData) {
      var _contextualData$samed, _contextualData$devic;
      if (contextualData !== null && contextualData !== void 0 && contextualData.devicebootstrap && contextualData !== null && contextualData !== void 0 && contextualData.devicebootstrap.enrolledDevices) {
        const enrolledDevices = contextualData === null || contextualData === void 0 ? void 0 : contextualData.devicebootstrap.enrolledDevices;
        enrolledDeviceName = Array.isArray(enrolledDevices) && !_courage._.isEmpty(enrolledDevices) ? enrolledDevices[0] : enrolledDevices;
      }
      if (contextualData.samedevice && (_contextualData$samed = contextualData.samedevice) !== null && _contextualData$samed !== void 0 && _contextualData$samed.setupOVUrl) {
        deviceMap = contextualData.samedevice;
      } else if (contextualData.devicebootstrap && (_contextualData$devic = contextualData.devicebootstrap) !== null && _contextualData$devic !== void 0 && _contextualData$devic.setupOVUrl) {
        deviceMap = contextualData.devicebootstrap;
      }
    }
    if (deviceMap.platform) {
      deviceMap.platformLC = deviceMap.platform.toLowerCase();
      deviceMap.isDesktop = !(deviceMap.platformLC === 'ios' || deviceMap.platformLC === 'android');
    }
    if (deviceMap.securityLevel && deviceMap.securityLevel === 'ANY') {
      showAnotherDeviceLink = true;
    }
    const sameDeviceOVEnrollmentEnabled = this.options.settings.get('features.sameDeviceOVEnrollmentEnabled');
    return {
      href: (_contextualData$qrcod = contextualData.qrcode) === null || _contextualData$qrcod === void 0 ? void 0 : _contextualData$qrcod.href,
      email: _courage._.escape(contextualData === null || contextualData === void 0 ? void 0 : contextualData.email),
      phoneNumber: _courage._.escape(contextualData === null || contextualData === void 0 ? void 0 : contextualData.phoneNumber),
      sameDevice: contextualData === null || contextualData === void 0 ? void 0 : contextualData.samedevice,
      deviceBootstrap: contextualData === null || contextualData === void 0 ? void 0 : contextualData.devicebootstrap,
      enrolledDeviceName: enrolledDeviceName,
      deviceMap: deviceMap,
      showAnotherDeviceLink: showAnotherDeviceLink,
      sameDeviceOVEnrollmentEnabled
    };
  },
  postRender: function () {
    const appState = this.options && this.options.appState;
    const model = this.model;
    this.$('.orOnMobileLink').click(function () {
      var _qrChannelField$optio;
      if (!appState || !model) {
        return;
      }
      const qrChannel = 'qrcode';
      const remediations = appState.get('remediations');
      const selectEnrollmentChannelRemediation = remediations.find(remediation => {
        return remediation.name === _RemediationConstants.FORMS.SELECT_ENROLLMENT_CHANNEL;
      });
      if (!selectEnrollmentChannelRemediation) {
        return;
      }
      const idField = _courage._.find(selectEnrollmentChannelRemediation.uiSchema, schema => schema.name === 'authenticator.id');
      if (!idField) {
        return;
      }
      // filter selected channel
      const qrChannelField = _courage._.find(selectEnrollmentChannelRemediation.uiSchema, schema => schema.name === 'authenticator.channel');
      if (!qrChannelField) {
        return;
      }
      qrChannelField.options = _courage._.filter(qrChannelField === null || qrChannelField === void 0 ? void 0 : qrChannelField.options, option => option.value === qrChannel);
      qrChannelField.value = ((_qrChannelField$optio = qrChannelField.options[0]) === null || _qrChannelField$optio === void 0 ? void 0 : _qrChannelField$optio.value) || qrChannel;
      qrChannelField.sublabel = null;
      model.set('authenticator.channel', qrChannelField.value);
      model.set('authenticator.id', idField.value);
      model.set('formName', selectEnrollmentChannelRemediation.name);
      appState.trigger('saveForm', model);
    });
    Clipboard.attach('.copy-org-clipboard-button').done(() => {
      let notification = new Notification({
        message: (0, _courage.loc)('enroll.oda.org.copyLink.success', 'login'),
        level: 'success'
      });
      this.el.prepend(notification.render().el);
      return false;
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/ov/EnrollPollOktaVerifyView.js":
/*!******************************************************************!*\
  !*** ./src/v2/view-builder/views/ov/EnrollPollOktaVerifyView.js ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _polling = _interopRequireDefault(__webpack_require__(/*! ../shared/polling */ "./src/v2/view-builder/views/shared/polling.js"));
var _OVResendView = _interopRequireDefault(__webpack_require__(/*! ./OVResendView */ "./src/v2/view-builder/views/ov/OVResendView.js"));
var _SwitchEnrollChannelLinkView = _interopRequireDefault(__webpack_require__(/*! ./SwitchEnrollChannelLinkView */ "./src/v2/view-builder/views/ov/SwitchEnrollChannelLinkView.js"));
var _EnrollChannelPollDescriptionView = _interopRequireDefault(__webpack_require__(/*! ./EnrollChannelPollDescriptionView */ "./src/v2/view-builder/views/ov/EnrollChannelPollDescriptionView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const OV_FORCE_FIPS_COMPLIANCE_UPGRAGE_KEY_IOS = 'oie.authenticator.app.non_fips_compliant_enrollment_device_incompatible';
const OV_FORCE_FIPS_COMPLIANCE_UPGRAGE_KEY_NON_IOS = 'oie.authenticator.app.non_fips_compliant_enrollment_app_update_required';
const OV_QR_ENROLL_ENABLE_BIOMETRICS_KEY = 'oie.authenticator.app.method.push.enroll.enable.biometrics';
let shouldStartPolling = true;
const Body = _internals.BaseFormWithPolling.extend(Object.assign({
  title() {
    const selectedChannel = this.options.appState.get('currentAuthenticator').contextualData.selectedChannel;
    let title;
    switch (selectedChannel) {
      case 'email':
        title = (0, _courage.loc)('oie.enroll.okta_verify.setup.email.title', 'login');
        break;
      case 'sms':
        title = (0, _courage.loc)('oie.enroll.okta_verify.setup.sms.title', 'login');
        break;
      default:
        title = (0, _courage.loc)('oie.enroll.okta_verify.setup.title', 'login');
    }
    return title;
  },
  className: 'oie-enroll-ov-poll',
  noButtonBar: true,
  initialize() {
    _internals.BaseFormWithPolling.prototype.initialize.apply(this, arguments);
    this.listenTo(this.model, 'error', this.stopPolling);
    if (shouldStartPolling) {
      this.startPolling();
    }
  },
  showMessages() {
    // override showMessages to display custom callout
    const calloutOptions = {};
    if (this.options.appState.containsMessageWithI18nKey(OV_FORCE_FIPS_COMPLIANCE_UPGRAGE_KEY_IOS) || this.options.appState.containsMessageWithI18nKey(OV_FORCE_FIPS_COMPLIANCE_UPGRAGE_KEY_NON_IOS)) {
      // add a title for ov force upgrade
      calloutOptions.title = (0, _courage.loc)('oie.okta_verify.enroll.force.upgrade.title', 'login');
    } else if (this.options.appState.containsMessageWithI18nKey(OV_QR_ENROLL_ENABLE_BIOMETRICS_KEY)) {
      // add a title for OV enable biometrics message during enrollment
      calloutOptions.title = (0, _courage.loc)('oie.authenticator.app.method.push.enroll.enable.biometrics.title', 'login');
    }
    _internals.BaseFormWithPolling.prototype.showMessages.call(this, calloutOptions);
  },
  getUISchema() {
    const schema = [];
    const contextualData = this.options.appState.get('currentAuthenticator').contextualData;
    const selectedChannel = contextualData.selectedChannel;
    let selector;
    if (selectedChannel === 'qrcode') {
      selector = '.qrcode-container';
      shouldStartPolling = true;
    } else if (['email', 'sms'].includes(selectedChannel)) {
      selector = '.switch-channel-content';
      shouldStartPolling = true;
    } else if (['samedevice', 'devicebootstrap'].includes(selectedChannel)) {
      // no selector if the channel is same device or device bootstrap
      // additionally, stop polling as it should be a terminal page
      shouldStartPolling = false;
    }
    schema.push({
      View: _EnrollChannelPollDescriptionView.default
    });
    schema.push({
      View: _SwitchEnrollChannelLinkView.default,
      options: {
        selectedChannel
      },
      selector: selector
    });
    if (['email', 'sms'].includes(selectedChannel)) {
      schema.push({
        View: _OVResendView.default,
        selector: '.o-form-error-container'
      });
    }
    return schema;
  },
  remove() {
    _internals.BaseFormWithPolling.prototype.remove.apply(this, arguments);
    this.stopPolling();
  }
}, _polling.default));
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/ov/EnrollementChannelDataOktaVerifyView.js":
/*!******************************************************************************!*\
  !*** ./src/v2/view-builder/views/ov/EnrollementChannelDataOktaVerifyView.js ***!
  \******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _CountryUtil = _interopRequireDefault(__webpack_require__(/*! ../../../../util/CountryUtil */ "./src/util/CountryUtil.js"));
var _SwitchEnrollChannelLinkView = _interopRequireDefault(__webpack_require__(/*! ./SwitchEnrollChannelLinkView */ "./src/v2/view-builder/views/ov/SwitchEnrollChannelLinkView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend({
  className: 'oie-enroll-ov-data',
  title() {
    return this.options.appState.get('currentAuthenticator').contextualData.selectedChannel === 'email' ? (0, _courage.loc)('oie.enroll.okta_verify.enroll.channel.email.title', 'login') : (0, _courage.loc)('oie.enroll.okta_verify.enroll.channel.sms.title', 'login');
  },
  save() {
    return (0, _courage.loc)('oie.enroll.okta_verify.setupLink', 'login');
  },
  getUISchema() {
    const uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);
    const phoneNumberUISchema = _courage._.find(uiSchemas, ({
      name
    }) => name === 'phoneNumber');
    const phoneNumberUISchemaIndex = _courage._.findIndex(uiSchemas, ({
      name
    }) => name === 'phoneNumber');
    const countryUISchema = {
      'label-top': true,
      label: (0, _courage.loc)('mfa.country', 'login'),
      type: 'select',
      options: _CountryUtil.default.getCountries(),
      name: 'country',
      wide: true
    };

    // Create an input group - serves as a display wrapper
    const phoneNumberWithCodeUISchema = {
      label: (0, _courage.loc)('mfa.phoneNumber.placeholder', 'login'),
      type: 'group',
      modelType: 'string',
      'label-top': true,
      name: 'phoneCode',
      input: [{
        type: 'label',
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
        label: `+${this.model.get('phoneCode')}`,
        className: 'country-code-label no-translate'
      }, Object.assign({}, phoneNumberUISchema)]
    };
    if (phoneNumberUISchemaIndex !== -1) {
      // Replace phoneNumberUISchema and add countryUISchema before phone.
      uiSchemas.splice(phoneNumberUISchemaIndex, 1, countryUISchema, phoneNumberWithCodeUISchema);
    }
    const description = {
      View: this.options.appState.get('currentAuthenticator').contextualData.selectedChannel === 'email' ? (0, _courage.loc)('oie.enroll.okta_verify.channel.email.description', 'login') : (0, _courage.loc)('oie.enroll.okta_verify.channel.sms.description', 'login'),
      selector: '.o-form-fieldset-container'
    };
    uiSchemas.push(description);
    return uiSchemas;
  },
  handlePhoneCodeChange() {
    const countryCodeField = this.el.querySelector('.country-code-label');
    countryCodeField.innerText = `+${this.model.get('phoneCode')}`;
  },
  initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    if (this.options.appState.get('currentAuthenticator').contextualData.selectedChannel === 'sms') {
      this.listenTo(this.model, 'change:phoneCode', this.handlePhoneCodeChange.bind(this));
    }
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body,
  createModelClass() {
    const ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments);
    if (this.options.appState.get('currentAuthenticator').contextualData.selectedChannel !== 'sms') {
      return ModelClass;
    }
    const local = Object.assign({
      country: {
        // Set default country to "US"
        'value': this.settings.get('defaultCountryCode'),
        'type': 'string'
      }
    }, ModelClass.prototype.local);
    const derived = Object.assign({
      phoneCode: {
        deps: ['country'],
        fn: function (country) {
          return _CountryUtil.default.getCallingCodeForCountry(country);
        }
      }
    }, ModelClass.prototype.derived);
    return ModelClass.extend({
      local,
      derived,
      toJSON: function () {
        const modelJSON = _courage.Model.prototype.toJSON.call(this, arguments);
        const phoneCode = this.get('phoneCode');

        // Add country code..
        let formattedPhoneNumber = `+${phoneCode}${modelJSON.phoneNumber}`;

        // Override phone with formatted number..
        modelJSON.phoneNumber = formattedPhoneNumber;
        return modelJSON;
      }
    });
  },
  postRender() {
    if (!this.settings.get('features.sameDeviceOVEnrollmentEnabled')) {
      this.add(_SwitchEnrollChannelLinkView.default, 'form');
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/ov/NumberChallengePhoneView.js":
/*!******************************************************************!*\
  !*** ./src/v2/view-builder/views/ov/NumberChallengePhoneView.js ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const NumberChallengePhoneView = _courage.View.extend({
  className: 'number-challenge-section',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "$1": "<span class='strong'>$1</span>",
          "arguments": "correctAnswer",
          "bundle": "login",
          "code": "oie.numberchallenge.instruction"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 3
          },
          "end": {
            "line": 1,
            "column": 127
          }
        }
      })) + "</p><div class=\"phone no-translate\"><div class=\"phone--body\"><div class=\"phone--screen\"><span class=\"phone--number\" data-se=\"challenge-number\">" + alias3((helper = (helper = lookupProperty(helpers, "correctAnswer") || (depth0 != null ? lookupProperty(depth0, "correctAnswer") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
        "name": "correctAnswer",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 270
          },
          "end": {
            "line": 1,
            "column": 287
          }
        }
      }) : helper)) + "</span></div><div class=\"phone--home-button\"></div></div></div>";
    },
    "useData": true
  }),
  getTemplateData() {
    var _this$options$appStat, _this$options$appStat2;
    const correctAnswer = (_this$options$appStat = this.options.appState.get('currentAuthenticator')) === null || _this$options$appStat === void 0 ? void 0 : (_this$options$appStat2 = _this$options$appStat.contextualData) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.correctAnswer;
    return {
      correctAnswer
    };
  }
});
var _default = NumberChallengePhoneView;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/ov/NumberChallengePushView.js":
/*!*****************************************************************!*\
  !*** ./src/v2/view-builder/views/ov/NumberChallengePushView.js ***!
  \*****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _polling = _interopRequireDefault(__webpack_require__(/*! ../shared/polling */ "./src/v2/view-builder/views/shared/polling.js"));
var _ResendNumberChallengeView = _interopRequireDefault(__webpack_require__(/*! ./ResendNumberChallengeView */ "./src/v2/view-builder/views/ov/ResendNumberChallengeView.js"));
var _NumberChallengePhoneView = _interopRequireDefault(__webpack_require__(/*! ./NumberChallengePhoneView */ "./src/v2/view-builder/views/ov/NumberChallengePhoneView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseFormWithPolling.extend(Object.assign({
  noButtonBar: true,
  className: 'okta-verify-number-challenge',
  events: {
    'click a.resend-number-challenge': 'handleResendNumberChallenge'
  },
  handleResendNumberChallenge() {
    this.options.appState.trigger('invokeAction', 'currentAuthenticator-resend');
    // hide the warning
    this.options.appState.trigger('hideNumberChallengeWarning');
  },
  title() {
    return (0, _courage.loc)('oie.okta_verify.push.sent', 'login');
  },
  initialize() {
    _internals.BaseFormWithPolling.prototype.initialize.apply(this, arguments);
    this.add(_NumberChallengePhoneView.default);
  },
  triggerAfterError() {
    _internals.BaseFormWithPolling.prototype.triggerAfterError.apply(this, arguments);
    this.stopPolling();
    this.$el.find('.o-form-fieldset-container').empty();
  },
  postRender() {
    _internals.BaseFormWithPolling.prototype.postRender.apply(this, arguments);
    this.startPoll();
  },
  startPoll() {
    this.startPolling();
    this.addWarning();
  },
  stopPoll() {
    this.stopPolling();
  },
  addWarning() {
    this.add(_ResendNumberChallengeView.default, '.o-form-error-container');
    this.options.appState.trigger('showNumberChallengeWarning');
  },
  remove() {
    _internals.BaseFormWithPolling.prototype.remove.apply(this, arguments);
    this.stopPolling();
  }
}, _polling.default));
var _default = Body;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/ov/OVResendView.js":
/*!******************************************************!*\
  !*** ./src/v2/view-builder/views/ov/OVResendView.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _BaseResendView = _interopRequireDefault(__webpack_require__(/*! ../shared/BaseResendView */ "./src/v2/view-builder/views/shared/BaseResendView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _BaseResendView.default.extend({
  //only show after certain threshold of polling
  className: 'hide resend-ov-link-view',
  events: {
    'click a.resend-link': 'handelResendLink'
  },
  initialize() {
    const selectedChannel = this.options.appState.get('currentAuthenticator').contextualData.selectedChannel;
    this.add((0, _courage.createCallout)({
      content: selectedChannel === 'email' ? _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function (container, depth0, helpers, partials, data) {
          var stack1,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
          return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "i18n",
            "hash": {
              "bundle": "login",
              "code": "oie.enroll.okta_verify.email.notReceived"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 0
              },
              "end": {
                "line": 1,
                "column": 73
              }
            }
          })) != null ? stack1 : "";
        },
        "useData": true
      }) : _runtime.default.template({
        "compiler": [8, ">= 4.3.0"],
        "main": function (container, depth0, helpers, partials, data) {
          var stack1,
            lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
          return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "i18n",
            "hash": {
              "bundle": "login",
              "code": "oie.enroll.okta_verify.sms.notReceived"
            },
            "data": data,
            "loc": {
              "start": {
                "line": 1,
                "column": 0
              },
              "end": {
                "line": 1,
                "column": 71
              }
            }
          })) != null ? stack1 : "";
        },
        "useData": true
      }),
      type: 'warning'
    }));
  },
  handelResendLink() {
    this.options.appState.trigger('invokeAction', 'currentAuthenticator-resend');
    //hide warning, but reinitiate to show warning again after some threshold of polling
    this.$el.addClass('hide');
    this.showCalloutAfterTimeout();
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/ov/ResendNumberChallengeView.js":
/*!*******************************************************************!*\
  !*** ./src/v2/view-builder/views/ov/ResendNumberChallengeView.js ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Constants = __webpack_require__(/*! ../../utils/Constants */ "./src/v2/view-builder/utils/Constants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ResendNumberChallengeView = _courage.View.extend({
  initialize() {
    this.listenTo(this.options.appState, 'showNumberChallengeWarning', () => {
      this.startWarningTimeout();
    });
    this.listenTo(this.options.appState, 'hideNumberChallengeWarning', () => {
      this.clearWarning();
    });
  },
  className: 'resend-number-challenge-warning hide',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<div class=\"okta-form-infobox-warning infobox infobox-warning\"><span class=\"icon warning-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "$1": "<a href='#' class='resend-number-challenge'>$1</a>",
          "bundle": "login",
          "code": "oie.numberchallenge.warning"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 103
          },
          "end": {
            "line": 1,
            "column": 217
          }
        }
      })) + "</p></div>";
    },
    "useData": true
  }),
  showWarning() {
    this.$el.removeClass('hide');
  },
  clearWarning() {
    this.$el.addClass('hide');
    clearTimeout(this.warningTimeout);
    this.startWarningTimeout();
  },
  startWarningTimeout() {
    this.warningTimeout = setTimeout(_courage._.bind(function () {
      this.showWarning();
    }, this), _Constants.WARNING_TIMEOUT);
  }
});
var _default = ResendNumberChallengeView;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/ov/SelectEnrollmentChannelOktaVerifyView.js":
/*!*******************************************************************************!*\
  !*** ./src/v2/view-builder/views/ov/SelectEnrollmentChannelOktaVerifyView.js ***!
  \*******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _BrowserFeatures = _interopRequireDefault(__webpack_require__(/*! ../../../../util/BrowserFeatures */ "./src/util/BrowserFeatures.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend({
  title() {
    return _BrowserFeatures.default.isAndroid() || _BrowserFeatures.default.isIOS() ? (0, _courage.loc)('oie.enroll.okta_verify.setup.title', 'login') : (0, _courage.loc)('oie.enroll.okta_verify.select.channel.title', 'login');
  },
  getUISchema() {
    var _channelField$options;
    const schemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);
    // filter selected channel
    const channelField = _courage._.find(schemas, schema => schema.name === 'authenticator.channel');
    channelField.options = _courage._.filter(channelField === null || channelField === void 0 ? void 0 : channelField.options, option => {
      var _this$options$appStat, _this$options$appStat2;
      return option.value !== ((_this$options$appStat = this.options.appState.get('currentAuthenticator')) === null || _this$options$appStat === void 0 ? void 0 : (_this$options$appStat2 = _this$options$appStat.contextualData) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.selectedChannel);
    });
    channelField.value = (_channelField$options = channelField.options[0]) === null || _channelField$options === void 0 ? void 0 : _channelField$options.value;
    channelField.sublabel = null;
    this.model.set('authenticator.channel', channelField.value);
    const description = {
      View: (0, _courage.loc)('oie.enroll.okta_verify.select.channel.description', 'login'),
      selector: '.o-form-fieldset-container'
    };
    return [description, ...schemas];
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/ov/SwitchEnrollChannelLinkView.js":
/*!*********************************************************************!*\
  !*** ./src/v2/view-builder/views/ov/SwitchEnrollChannelLinkView.js ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _RemediationConstants = __webpack_require__(/*! ../../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _courage.View.extend({
  className: 'switch-channel-text',
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(2, data, 0),
        "inverse": container.program(4, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 23
          },
          "end": {
            "line": 1,
            "column": 325
          }
        }
      })) != null ? stack1 : "";
    },
    "2": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.okta_verify.switch.channel.link.text"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 60
          },
          "end": {
            "line": 1,
            "column": 140
          }
        }
      })) != null ? stack1 : "";
    },
    "4": function (container, depth0, helpers, partials, data) {
      var alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<a href=\"#\" class=\"switch-channel-link\" aria-label=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.totp.aria.cannotScan"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 200
          },
          "end": {
            "line": 1,
            "column": 259
          }
        }
      })) + "\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "enroll.totp.cannotScan"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 261
          },
          "end": {
            "line": 1,
            "column": 314
          }
        }
      })) + "</a>";
    },
    "6": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "isSameDeviceChannel") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(7, data, 0),
        "inverse": container.program(9, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 325
          },
          "end": {
            "line": 1,
            "column": 480
          }
        }
      })) != null ? stack1 : "";
    },
    "7": function (container, depth0, helpers, partials, data) {
      return "";
    },
    "9": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "isDeviceBootstrapChannel") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(7, data, 0),
        "inverse": container.program(2, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 356
          },
          "end": {
            "line": 1,
            "column": 480
          }
        }
      })) != null ? stack1 : "";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "isQRcodeChannel") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.program(6, data, 0),
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 487
          }
        }
      })) != null ? stack1 : "";
    },
    "useData": true
  }),
  getTemplateData() {
    const selectedChannel = this.options.appState.get('currentAuthenticator').contextualData.selectedChannel;
    return {
      sameDeviceOVEnrollmentEnabled: this.settings.get('features.sameDeviceOVEnrollmentEnabled'),
      isQRcodeChannel: selectedChannel === 'qrcode',
      // Do not show switch channel link for sameDevice or deviceBootstrap
      isSameDeviceChannel: selectedChannel === 'samedevice',
      isDeviceBootstrapChannel: selectedChannel === 'devicebootstrap'
    };
  },
  postRender() {
    this.$el.find('.switch-channel-link').on('click', event => {
      const appState = this.options.appState;
      event.preventDefault();
      appState.trigger('switchForm', _RemediationConstants.FORMS.SELECT_ENROLLMENT_CHANNEL);
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/password/ChallengeAuthenticatorPasswordView.js":
/*!**********************************************************************************!*\
  !*** ./src/v2/view-builder/views/password/ChallengeAuthenticatorPasswordView.js ***!
  \**********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _AuthenticatorFooter = _interopRequireDefault(__webpack_require__(/*! ../../components/AuthenticatorFooter */ "./src/v2/view-builder/components/AuthenticatorFooter.js"));
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _LinksUtil = __webpack_require__(/*! ../../utils/LinksUtil */ "./src/v2/view-builder/utils/LinksUtil.js");
var _i18nTransformer = __webpack_require__(/*! ../../../ion/i18nTransformer */ "./src/v2/ion/i18nTransformer.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend({
  title: function () {
    return (0, _courage.loc)('oie.password.challenge.title', 'login');
  },
  save: function () {
    return (0, _courage.loc)('mfa.challenge.verify', 'login');
  },
  /**
   * Update UI schemas for customization from .widgetrc.js or Admin Customization settings page.
   * @returns Array
   */
  getUISchema() {
    const schemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);
    const {
      settings
    } = this.options;
    const passwordExplainLabeli18nKey = 'primaryauth.password.tooltip';
    const passwordSchema = schemas.find(({
      name
    }) => name === 'credentials.passcode');
    if (passwordSchema && (0, _i18nTransformer.isCustomizedI18nKey)(passwordExplainLabeli18nKey, settings)) {
      passwordSchema.explain = (0, _courage.loc)(passwordExplainLabeli18nKey, 'login');
      passwordSchema['explain-top'] = true;
    }
    return schemas;
  }
});
const Footer = _AuthenticatorFooter.default.extend({
  links: function () {
    let links = _AuthenticatorFooter.default.prototype.links.apply(this, arguments);
    links = (0, _LinksUtil.getForgotPasswordLink)(this.options.appState, this.options.settings).concat(links);
    return links;
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body,
  Footer
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/password/EnrollAuthenticatorPasswordView.js":
/*!*******************************************************************************!*\
  !*** ./src/v2/view-builder/views/password/EnrollAuthenticatorPasswordView.js ***!
  \*******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _AuthenticatorUtil = __webpack_require__(/*! ../../utils/AuthenticatorUtil */ "./src/v2/view-builder/utils/AuthenticatorUtil.js");
var _PasswordPolicyUtil = __webpack_require__(/*! ./PasswordPolicyUtil */ "./src/v2/view-builder/views/password/PasswordPolicyUtil.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend({
  title() {
    return (0, _courage.loc)('oie.password.enroll.title', 'login');
  },
  save() {
    return (0, _courage.loc)('oform.next', 'login');
  },
  initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    const policy = this.getPasswordPolicySettings();
    this.displayPasswordPolicy(policy);
  },
  displayPasswordPolicy(policy) {
    if (policy) {
      const rulesList = (0, _AuthenticatorUtil.getPasswordComplexityDescriptionForHtmlList)(policy);
      (0, _PasswordPolicyUtil.generatePasswordPolicyHtml)(this, rulesList, true);
    }
  },
  triggerAfterError(model, error) {
    error.responseJSON = (0, _AuthenticatorUtil.removeRequirementsFromError)(error.responseJSON);
    this.options.appState.trigger('afterError', error);
  },
  getPasswordPolicySettings() {
    var _relatesToObject$valu;
    // This will be overridden by following scenario since the policies could be different for those.
    // - password reset (`ReEnrollAuthenticatorPasswordView.js`)
    //
    const relatesToObject = this.options.currentViewState.relatesTo;
    return relatesToObject === null || relatesToObject === void 0 ? void 0 : (_relatesToObject$valu = relatesToObject.value) === null || _relatesToObject$valu === void 0 ? void 0 : _relatesToObject$valu.settings;
  },
  getUISchema() {
    const uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);
    const confirmPassword = {
      name: 'confirmPassword',
      label: (0, _courage.loc)('oie.password.confirmPasswordLabel', 'login'),
      type: 'password',
      'label-top': true,
      params: {
        showPasswordToggle: this.settings.get('showPasswordToggle')
      }
    };
    const updatedSchema = [];
    for (let field of uiSchemas) {
      updatedSchema.push(field);
      if (field.name === 'credentials.passcode') {
        updatedSchema.push(confirmPassword);
      }
    }
    return updatedSchema;
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body,
  createModelClass() {
    const ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments);
    const local = Object.assign({
      confirmPassword: {
        type: 'string',
        required: true
      }
    }, ModelClass.prototype.local);
    return ModelClass.extend({
      local,
      validate() {
        if (this.get('credentials.passcode') !== this.get('confirmPassword') && this.get('credential.value') !== this.get('confirmPassword')) {
          const errors = {
            'confirmPassword': (0, _courage.loc)('password.error.match', 'login')
          };
          return errors;
        } else {
          return null;
        }
      }
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/password/PasswordPolicyUtil.js":
/*!******************************************************************!*\
  !*** ./src/v2/view-builder/views/password/PasswordPolicyUtil.js ***!
  \******************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.generatePasswordPolicyHtml = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const generatePasswordPolicyHtml = function (form, rulesList, prepend) {
  form.add(_courage.View.extend({
    tagName: 'section',
    template: _runtime.default.template({
      "1": function (container, depth0, helpers, partials, data) {
        return "<li>" + container.escapeExpression(container.lambda(depth0, depth0)) + "</li>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function (container, depth0, helpers, partials, data) {
        var stack1,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }
            return undefined;
          };
        return "<div class=\"password-authenticator--heading\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
          "name": "i18n",
          "hash": {
            "bundle": "login",
            "code": "password.complexity.requirements.header"
          },
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 45
            },
            "end": {
              "line": 1,
              "column": 115
            }
          }
        })) + "</div><ul class=\"password-authenticator--list\">" + ((stack1 = lookupProperty(helpers, "each").call(alias1, depth0 != null ? lookupProperty(depth0, "rulesList") : depth0, {
          "name": "each",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 162
            },
            "end": {
              "line": 1,
              "column": 207
            }
          }
        })) != null ? stack1 : "") + "</ul>";
      },
      "useData": true
    }),
    getTemplateData: () => ({
      rulesList
    }),
    attributes: {
      'data-se': 'password-authenticator--rules'
    }
  }), {
    prepend,
    selector: '.o-form-fieldset-container'
  });
};
exports.generatePasswordPolicyHtml = generatePasswordPolicyHtml;

/***/ }),

/***/ "./src/v2/view-builder/views/password/ReEnrollAuthenticatorPasswordView.js":
/*!*********************************************************************************!*\
  !*** ./src/v2/view-builder/views/password/ReEnrollAuthenticatorPasswordView.js ***!
  \*********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _EnrollAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(/*! ./EnrollAuthenticatorPasswordView */ "./src/v2/view-builder/views/password/EnrollAuthenticatorPasswordView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _EnrollAuthenticatorPasswordView.default.prototype.Body.extend({
  className: 'password-authenticator',
  title() {
    const title = this.options.settings.get('brandName') ? (0, _courage.loc)('password.expired.title.specific', 'login', [this.options.settings.get('brandName')]) : (0, _courage.loc)('password.expired.title.generic', 'login');
    return title;
  },
  save() {
    return (0, _courage.loc)('password.expired.submit', 'login');
  },
  getPasswordPolicySettings() {
    var _this$options$appStat, _this$options$appStat2;
    return ((_this$options$appStat = this.options.appState.get('recoveryAuthenticator')) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.settings) || ((_this$options$appStat2 = this.options.appState.get('enrollmentAuthenticator')) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.settings);
  }
});
var _default = _EnrollAuthenticatorPasswordView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/password/ReEnrollAuthenticatorWarningPasswordView.js":
/*!****************************************************************************************!*\
  !*** ./src/v2/view-builder/views/password/ReEnrollAuthenticatorWarningPasswordView.js ***!
  \****************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _EnrollAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(/*! ./EnrollAuthenticatorPasswordView */ "./src/v2/view-builder/views/password/EnrollAuthenticatorPasswordView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _EnrollAuthenticatorPasswordView.default.prototype.Body.extend({
  className: 'password-authenticator',
  subtitle() {
    if (this.options.settings.get('brandName')) {
      return (0, _courage.loc)('password.expiring.subtitle.specific', 'login', [this.options.settings.get('brandName')]);
    }
  },
  title() {
    const passwordPolicy = this.getPasswordPolicySettings() || {};
    const daysToExpiry = passwordPolicy.daysToExpiry;
    if (daysToExpiry > 0) {
      return (0, _courage.loc)('password.expiring.title', 'login', [daysToExpiry]);
    } else if (daysToExpiry === 0) {
      return (0, _courage.loc)('password.expiring.today', 'login');
    } else {
      return (0, _courage.loc)('password.expiring.soon', 'login');
    }
  },
  save() {
    return (0, _courage.loc)('password.expired.submit', 'login');
  },
  showMessages() {
    // if brandName is configured and messages is present, render as subtitle with brandName in context
    if (this.options.settings.get('brandName')) {
      return null;
    }
    // else if brandName is not set, render messages object sent from server as text
    _EnrollAuthenticatorPasswordView.default.prototype.Body.prototype.showMessages.apply(this, arguments);
  }
});
const Footer = _internals.BaseFooter.extend({
  links() {
    const links = [];
    if (this.options.appState.hasRemediationObject('skip')) {
      links.push({
        'type': 'link',
        'label': (0, _courage.loc)('password.expiring.later', 'login'),
        'name': 'skip',
        'actionPath': 'skip'
      });
    }
    return links;
  }
});
var _default = _EnrollAuthenticatorPasswordView.default.extend({
  Body,
  Footer
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/password/ResetAuthenticatorPasswordView.js":
/*!******************************************************************************!*\
  !*** ./src/v2/view-builder/views/password/ResetAuthenticatorPasswordView.js ***!
  \******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _EnrollAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(/*! ./EnrollAuthenticatorPasswordView */ "./src/v2/view-builder/views/password/EnrollAuthenticatorPasswordView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _EnrollAuthenticatorPasswordView.default.prototype.Body.extend({
  className: 'password-authenticator',
  title() {
    const title = this.options.settings.get('brandName') ? (0, _courage.loc)('password.reset.title.specific', 'login', [this.options.settings.get('brandName')]) : (0, _courage.loc)('password.reset.title.generic', 'login');
    return title;
  },
  save() {
    return (0, _courage.loc)('password.reset', 'login');
  }
});
var _default = _EnrollAuthenticatorPasswordView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/phone/ChallengeAuthenticatorDataPhoneView.js":
/*!********************************************************************************!*\
  !*** ./src/v2/view-builder/views/phone/ChallengeAuthenticatorDataPhoneView.js ***!
  \********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend({
  className: 'phone-authenticator-challenge',
  events: {
    'click a.phone-authenticator-challenge__link': 'handleSecondaryLinkClick'
  },
  title() {
    return (0, _courage.loc)('oie.phone.verify.title', 'login');
  },
  save() {
    return this.model.get('primaryMode') === 'sms' ? (0, _courage.loc)('oie.phone.sms.primaryButton', 'login') : (0, _courage.loc)('oie.phone.call.primaryButton', 'login');
  },
  handleSecondaryLinkClick(e) {
    e.preventDefault();
    // Call the API to send a code via secondary mode
    const secondaryMode = this.model.get('secondaryMode');
    this.model.set('authenticator.methodType', secondaryMode);
    this.saveForm(this.model);
  },
  initialize() {
    // This is needed when user clicks on secondary (say voice) and call fails with ratelimit server-side error.
    // Then the user clicks primary button (say sms) and right methodType needs to be sent.
    this.model.on('error', () => this.model.set('authenticator.methodType', this.model.get('primaryMode')));
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    const sendText = this.model.get('primaryMode') === 'sms' ? (0, _courage.loc)('oie.phone.verify.sms.sendText', 'login') : (0, _courage.loc)('oie.phone.verify.call.sendText', 'login');
    const carrierChargesText = (0, _courage.loc)('oie.phone.carrier.charges', 'login');
    const isPhoneNumberAvailable = this.model.get('phoneNumber') !== (0, _courage.loc)('oie.phone.alternate.title', 'login');
    const extraCssClasses = isPhoneNumberAvailable ? 'strong no-translate nowrap' : '';
    let nicknameText = isPhoneNumberAvailable ? this.model.get('nickname') : '';
    let extraNicknameCssClasses = '';
    if (nicknameText !== '') {
      nicknameText = ' (' + nicknameText + ')';
      extraNicknameCssClasses = 'strong no-translate authenticator-verify-nickname';
    }
    const nicknameTemplate = nicknameText ? `<span ${extraNicknameCssClasses ? 'class="' + extraNicknameCssClasses + '"' : ''}>
      ${nicknameText}.</span>` : '<span class="no-translate">.</span>';
    // Courage doesn't support HTML, hence creating a subtitle here.
    this.add(`<div class="okta-form-subtitle" data-se="o-form-explain">${sendText}
        <span ${extraCssClasses ? 'class="' + extraCssClasses + '"' : ''}>
        ${this.model.escape('phoneNumber')}</span>${nicknameTemplate}
        <p>${carrierChargesText}</p>
      </div>`);
  },
  getUISchema() {
    // Change the UI schema to not display radios here.
    const uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);
    return uiSchemas.filter(schema => schema.name !== 'authenticator.methodType');
  },
  render() {
    _internals.BaseForm.prototype.render.apply(this, arguments);
    const secondaryMode = this.model.get('secondaryMode');
    if (secondaryMode) {
      const secondaryButtonTitle = secondaryMode === 'sms' ? (0, _courage.loc)('oie.phone.sms.secondaryButton', 'login') : (0, _courage.loc)('oie.phone.call.secondaryButton', 'login');
      this.add(`<a href="#"
            class="link phone-authenticator-challenge__link"
            data-se="phone-authenticator-challenge__link">${secondaryButtonTitle}</a>`, '.o-form-button-bar');
    }
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body,
  createModelClass({
    uiSchema
  }) {
    // It is important to get methods from here to maintain single source of truth.
    const {
      options: methods
    } = _courage._.find(uiSchema, schema => schema.name === 'authenticator.methodType');
    const relatesToObject = this.options.currentViewState.relatesTo;
    const {
      profile,
      nickname
    } = (relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value) || {};
    const ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments);
    const local = Object.assign({
      primaryMode: {
        'value': methods[0].value,
        'type': 'string'
      },
      secondaryMode: {
        'value': methods[1] && methods[1].value,
        'type': 'string'
      },
      phoneNumber: {
        'value': profile !== null && profile !== void 0 && profile.phoneNumber ? profile.phoneNumber : (0, _courage.loc)('oie.phone.alternate.title', 'login'),
        'type': 'string'
      },
      nickname: {
        'value': nickname ? nickname : '',
        'type': 'string'
      }
    }, ModelClass.prototype.local);
    return ModelClass.extend({
      local
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/phone/ChallengeAuthenticatorPhoneView.js":
/*!****************************************************************************!*\
  !*** ./src/v2/view-builder/views/phone/ChallengeAuthenticatorPhoneView.js ***!
  \****************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.ResendView = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _BaseResendView = _interopRequireDefault(__webpack_require__(/*! ../shared/BaseResendView */ "./src/v2/view-builder/views/shared/BaseResendView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ResendView = _BaseResendView.default.extend({
  // To be shown after a timeout
  className: 'phone-authenticator-challenge__resend-warning hide',
  events: {
    'click a.resend-link': 'handleResendLink'
  },
  // Override this to change the resend action location from response
  resendActionKey: 'currentAuthenticatorEnrollment-resend',
  initialize() {
    const resendText = this.model.get('mode') === 'sms' ? (0, _courage.loc)('oie.phone.verify.sms.resendText', 'login') : (0, _courage.loc)('oie.phone.verify.call.resendText', 'login');
    const linkText = this.model.get('mode') === 'sms' ? (0, _courage.loc)('oie.phone.verify.sms.resendLinkText', 'login') : (0, _courage.loc)('oie.phone.verify.call.resendLinkText', 'login');
    this.add((0, _courage.createCallout)({
      content: `${resendText}&nbsp;<a class='resend-link'>${linkText}</a>`,
      type: 'warning'
    }));
  },
  handleResendLink() {
    this.options.appState.trigger('invokeAction', this.resendActionKey);
    // Hide warning, but start a timeout again..
    if (!this.el.classList.contains('hide')) {
      this.el.classList.add('hide');
    }
    this.showCalloutAfterTimeout();
  }
});
exports.ResendView = ResendView;
const Body = _internals.BaseForm.extend(Object.assign({
  className: 'phone-authenticator-challenge',
  title() {
    return (0, _courage.loc)('oie.phone.verify.title', 'login');
  },
  save() {
    return (0, _courage.loc)('mfa.challenge.verify', 'login');
  },
  initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    const sendText = this.model.get('mode') === 'sms' ? (0, _courage.loc)('oie.phone.verify.sms.codeSentText', 'login') : (0, _courage.loc)('mfa.calling', 'login');
    const enterCodeText = (0, _courage.loc)('oie.phone.verify.enterCodeText', 'login');
    const carrierChargesText = (0, _courage.loc)('oie.phone.carrier.charges', 'login');
    const isPhoneNumberAvailable = this.model.get('phoneNumber') !== (0, _courage.loc)('oie.phone.alternate.title', 'login');
    let nicknameText = isPhoneNumberAvailable ? this.model.get('nickname') : '';
    let extraNicknameCssClasses = '';
    if (nicknameText !== '') {
      nicknameText = ' (' + nicknameText + ')';
      extraNicknameCssClasses = 'no-translate authenticator-verify-nickname';
    }
    const nicknameTemplate = nicknameText ? `<span ${extraNicknameCssClasses ? 'class="' + extraNicknameCssClasses + '"' : ''}>
      ${nicknameText}.</span>` : '<span class="no-translate">.</span>';
    const strongClass = this.model.get('phoneNumber') !== (0, _courage.loc)('oie.phone.alternate.title', 'login') ? 'strong no-translate nowrap' : '';
    // Courage doesn't support HTML, hence creating a subtitle here.
    this.add(`<div class="okta-form-subtitle" data-se="o-form-explain">
        ${sendText}&nbsp;<span class='${strongClass}'>${this.model.escape('phoneNumber')}</span>
        ${nicknameTemplate}
        &nbsp;${enterCodeText}
        <p>${carrierChargesText}</p>
        </div>`, {
      prepend: true,
      selector: '.o-form-fieldset-container'
    });
  },
  postRender() {
    _internals.BaseForm.prototype.postRender.apply(this, arguments);
    this.add(ResendView, {
      selector: '.o-form-info-container',
      prepend: true
    });
  }
}));
var _default = _BaseAuthenticatorView.default.extend({
  Body,
  createModelClass() {
    const relatesToObject = this.options.currentViewState.relatesTo;
    const {
      methods,
      profile,
      nickname
    } = (relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value) || {};
    const ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments);
    const local = Object.assign({
      mode: {
        'value': methods[0].type,
        'type': 'string'
      },
      phoneNumber: {
        'value': profile !== null && profile !== void 0 && profile.phoneNumber ? profile.phoneNumber : (0, _courage.loc)('oie.phone.alternate.title', 'login'),
        'type': 'string'
      },
      nickname: {
        'value': nickname ? nickname : '',
        'type': 'string'
      }
    }, ModelClass.prototype.local);
    return ModelClass.extend({
      local
    });
  }
});
exports["default"] = _default;

/***/ }),

/***/ "./src/v2/view-builder/views/phone/EnrollAuthenticatorDataPhoneView.js":
/*!*****************************************************************************!*\
  !*** ./src/v2/view-builder/views/phone/EnrollAuthenticatorDataPhoneView.js ***!
  \*****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _CountryUtil = _interopRequireDefault(__webpack_require__(/*! ../../../../util/CountryUtil */ "./src/util/CountryUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend({
  className: 'phone-authenticator-enroll',
  title() {
    return (0, _courage.loc)('oie.phone.enroll.title', 'login');
  },
  subtitle() {
    return this.model.get('authenticator.methodType') === 'voice' ? (0, _courage.loc)('oie.phone.enroll.call.subtitle', 'login') : (0, _courage.loc)('oie.phone.enroll.sms.subtitle', 'login');
  },
  render() {
    _internals.BaseForm.prototype.render.apply(this, arguments);
    const selectedMethod = this.model.get('authenticator.methodType');
    const phoneField = this.el.querySelector('.phone-authenticator-enroll__phone');
    const extensionField = this.el.querySelector('.phone-authenticator-enroll__phone-ext');
    if (selectedMethod === 'voice') {
      if (!phoneField.classList.contains('phone-authenticator-enroll__phone--small')) {
        phoneField.classList.add('phone-authenticator-enroll__phone--small');
      }
      extensionField.classList.remove('hide');
    }
    if (selectedMethod === 'sms') {
      phoneField.classList.remove('phone-authenticator-enroll__phone--small');
      if (!extensionField.classList.contains('hide')) {
        extensionField.classList.add('hide');
      }
    }
    this.el.querySelector('.phone-authenticator-enroll__phone-code').innerText = `+${this.model.get('phoneCode')}`;
  },
  handlePhoneCodeChange() {
    const countryCodeField = this.el.querySelector('.phone-authenticator-enroll__phone-code');
    countryCodeField.innerText = `+${this.model.get('phoneCode')}`;
  },
  save() {
    return this.model.get('authenticator.methodType') === 'voice' ? (0, _courage.loc)('oie.phone.call.primaryButton', 'login') : (0, _courage.loc)('oie.phone.sms.primaryButton', 'login');
  },
  getUISchema() {
    const uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);

    // TODO: Using underscore to support IE, replace with Array.prototype methods (find, findIndex) when IE
    // support is removed
    const phoneNumberUISchemaIndex = _courage._.findIndex(uiSchemas, ({
      name
    }) => name === 'authenticator.phoneNumber');
    const countryUISchema = {
      'label-top': true,
      label: (0, _courage.loc)('mfa.country', 'login'),
      type: 'select',
      options: _CountryUtil.default.getCountries(),
      name: 'country',
      wide: true
    };
    const inputId = 'okta-phone-number-input';

    // Create an input group - serves as a display wrapper
    const phoneNumberWithCodeUISchema = {
      label: (0, _courage.loc)('mfa.phoneNumber.placeholder', 'login'),
      inputId,
      type: 'group',
      modelType: 'string',
      'label-top': true,
      name: 'phoneCode',
      className: 'phone-authenticator-enroll__phone',
      input: [{
        type: 'label',
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */
        label: `+${this.model.get('phoneCode')}`,
        className: 'phone-authenticator-enroll__phone-code no-translate'
      }, Object.assign({
        inputId
      }, uiSchemas[phoneNumberUISchemaIndex])]
    };
    const extensionUISchema = {
      label: (0, _courage.loc)('phone.extention.label', 'login'),
      type: 'text',
      // Need to manually hide and show
      // - toggleWhen puts display: block on the element when it unhides hence can't be used.
      //   Because in this case, the element needs to be rendered as an inline-block.
      // - showWhen has an animation on the element when unhiding
      //   The animation makes the element look weird because of the way it is positioned,
      //   hence can't be used
      className: 'phone-authenticator-enroll__phone-ext hide',
      'label-top': true,
      name: 'extension'
    };
    if (phoneNumberUISchemaIndex !== -1) {
      // Replace phoneNumberUISchema..
      uiSchemas.splice(phoneNumberUISchemaIndex, 1, phoneNumberWithCodeUISchema);
      // Add countryUISchema before & extensionUISchema after phone..
      uiSchemas.splice(phoneNumberUISchemaIndex, 0, countryUISchema);
      uiSchemas.splice(phoneNumberUISchemaIndex + 2, 0, extensionUISchema);
    }
    const methodType = _courage._.find(uiSchemas, ({
      name
    }) => name === 'authenticator.methodType');
    if (methodType && methodType.options.length === 1) {
      methodType.className = 'hide';
    }
    return uiSchemas;
  },
  initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    this.listenTo(this.model, 'change:authenticator.methodType', this.render.bind(this));
    this.listenTo(this.model, 'change:phoneCode', this.handlePhoneCodeChange.bind(this));
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body,
  createModelClass() {
    const ModelClass = _internals.BaseView.prototype.createModelClass.apply(this, arguments);
    const local = Object.assign({
      country: {
        'value': this.settings.get('defaultCountryCode'),
        'type': 'string'
      },
      extension: {
        'type': 'string'
      }
    }, ModelClass.prototype.local);
    const derived = Object.assign({
      phoneCode: {
        deps: ['country'],
        fn: function (country) {
          return _CountryUtil.default.getCallingCodeForCountry(country);
        }
      }
    }, ModelClass.prototype.derived);
    return ModelClass.extend({
      local,
      derived,
      toJSON: function () {
        const modelJSON = _courage.Model.prototype.toJSON.call(this, arguments);
        const extension = this.get('extension');
        const phoneCode = this.get('phoneCode');

        // Add country code..
        let formattedPhoneNumber = `+${phoneCode}${modelJSON.authenticator.phoneNumber}`;

        // Add extension if present..
        if (modelJSON.authenticator.methodType === 'voice' && extension !== null && extension !== void 0 && extension.trim().length) {
          formattedPhoneNumber = `${formattedPhoneNumber}x${extension}`;
        }
        // Override phone with formatted number..
        modelJSON.authenticator.phoneNumber = formattedPhoneNumber;
        return modelJSON;
      }
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/phone/EnrollAuthenticatorPhoneView.js":
/*!*************************************************************************!*\
  !*** ./src/v2/view-builder/views/phone/EnrollAuthenticatorPhoneView.js ***!
  \*************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _ChallengeAuthenticatorPhoneView = _interopRequireWildcard(__webpack_require__(/*! ./ChallengeAuthenticatorPhoneView */ "./src/v2/view-builder/views/phone/ChallengeAuthenticatorPhoneView.js"));
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const EnrollResendView = _ChallengeAuthenticatorPhoneView.ResendView.extend({
  // To be shown after a timeout
  className: 'phone-authenticator-enroll--warning hide',
  resendActionKey: 'currentAuthenticator-resend'
});
const Body = _ChallengeAuthenticatorPhoneView.default.prototype.Body.extend({
  className: 'phone-authenticator-enroll',
  title() {
    return (0, _courage.loc)('oie.phone.enroll.title', 'login');
  },
  postRender() {
    _internals.BaseForm.prototype.postRender.apply(this, arguments);
    this.add(EnrollResendView, {
      selector: '.o-form-info-container',
      prepend: true
    });
  }
});
var _default = _ChallengeAuthenticatorPhoneView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/piv/ChallengePIVView.js":
/*!***********************************************************!*\
  !*** ./src/v2/view-builder/views/piv/ChallengePIVView.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _PIVHeader = _interopRequireDefault(__webpack_require__(/*! ./PIVHeader */ "./src/v2/view-builder/views/piv/PIVHeader.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend({
  className: 'piv-cac-card',
  modelEvents: {
    request: 'startAuthentication',
    error: 'stopAuthentication'
  },
  initialize() {
    _internals.BaseForm.prototype.initialize.apply(this, arguments);
    this.model.set('useRedirect', true);
    this.addInstructions();
  },
  title() {
    return (0, _courage.loc)('piv.cac.title', 'login');
  },
  save() {
    return (0, _courage.loc)('retry', 'login');
  },
  addInstructions() {
    this.add(`<div class='piv-verify-text'>
        <p>${(0, _courage.loc)('piv.cac.card.insert', 'login')}</p>
        <div data-se='piv-waiting' class='okta-waiting-spinner'></div>
      </div>`);
  },
  startAuthentication: function () {
    this.$('.okta-waiting-spinner').show();
    this.$('.o-form-button-bar').hide();
  },
  stopAuthentication: function () {
    this.$('.okta-waiting-spinner').hide();
    this.$('.o-form-button-bar').show();
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Header: _PIVHeader.default,
  Body,
  postRender() {
    _BaseAuthenticatorView.default.prototype.postRender.apply(this, arguments);
    const messages = this.options.appState.get('messages') || {};
    // if piv view has errors, show errors and stop authentication.
    // otherwise trigger authentication on page load
    if (Array.isArray(messages.value)) {
      this.form.stopAuthentication();
    } else {
      this.form.startAuthentication();
      this.form.trigger('save', this.model);
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/piv/PIVHeader.js":
/*!****************************************************!*\
  !*** ./src/v2/view-builder/views/piv/PIVHeader.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _HeaderBeacon = _interopRequireDefault(__webpack_require__(/*! ../../components/HeaderBeacon */ "./src/v2/view-builder/components/HeaderBeacon.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _internals.BaseHeader.extend({
  HeaderBeacon: _HeaderBeacon.default.extend({
    getBeaconClassName: function () {
      return 'smartcard';
    }
  })
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/security-question/ChallengeAuthenticatorSecurityQuestion.js":
/*!***********************************************************************************************!*\
  !*** ./src/v2/view-builder/views/security-question/ChallengeAuthenticatorSecurityQuestion.js ***!
  \***********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend({
  title() {
    return (0, _courage.loc)('oie.security.question.challenge.title', 'login');
  },
  save() {
    return (0, _courage.loc)('mfa.challenge.verify', 'login');
  },
  getUISchema() {
    const uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);
    const questionKey = uiSchemas.filter(s => s.name.indexOf('questionKey') >= 0);
    const answer = uiSchemas.filter(s => s.name.indexOf('answer') >= 0);

    /**
     * At verify SQ case,
     * 'questionKey' is read-only hence it won't show up in UI anyway.
     * 'answer' has label 'answer' but apparently UI want to display the
     * actual question (label of `questionKey`) as better user experience.
     */
    if (questionKey.length === 1 && answer.length === 1) {
      answer[0].label = questionKey[0].label;
    }
    return uiSchemas;
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/security-question/EnrollAuthenticatorSecurityQuestionView.js":
/*!************************************************************************************************!*\
  !*** ./src/v2/view-builder/views/security-question/EnrollAuthenticatorSecurityQuestionView.js ***!
  \************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend({
  title() {
    return (0, _courage.loc)('oie.security.question.enroll.title', 'login');
  },
  save() {
    return (0, _courage.loc)('mfa.challenge.verify', 'login');
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/shared/BaseResendView.js":
/*!************************************************************!*\
  !*** ./src/v2/view-builder/views/shared/BaseResendView.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Constants = __webpack_require__(/*! ../../utils/Constants */ "./src/v2/view-builder/utils/Constants.js");
var _sessionStorageHelper = _interopRequireDefault(__webpack_require__(/*! ../../../client/sessionStorageHelper */ "./src/v2/client/sessionStorageHelper.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _courage.View.extend({
  postRender() {
    this.showCalloutAfterTimeout();
  },
  showCalloutAfterTimeout() {
    const timeStamp = _sessionStorageHelper.default.getResendTimestamp();
    if (!timeStamp) {
      _sessionStorageHelper.default.setResendTimestamp(Date.now());
    }

    // We keep track of a 'global' timestamp in sessionStorage because if the SIW does a re-render,
    // we don't want to force the user to wait another 30s again to see the resend link. With this
    // the user will wait AT MOST 30s until they see the resend link.
    this.showMeInterval = setInterval(() => {
      const start = _sessionStorageHelper.default.getResendTimestamp();
      const now = Date.now();
      if (now - start >= _Constants.SHOW_RESEND_TIMEOUT) {
        this.$el.removeClass('hide');
        clearInterval(this.showMeInterval);
        _sessionStorageHelper.default.removeResendTimestamp();
      }
    }, 250);
  },
  remove() {
    var _this$options$appStat, _this$options$appStat2;
    _courage.View.prototype.remove.apply(this, arguments);
    clearInterval(this.showMeInterval);
    const formName = this.options.appState.get('currentFormName');
    const resendContext = ((_this$options$appStat = this.options.appState.get('currentAuthenticator')) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.resend) || ((_this$options$appStat2 = this.options.appState.get('currentAuthenticatorEnrollment')) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.resend);
    const didFormNameChange = this.options.model.get('formName') !== formName;

    // Clear resend timeStamp whenever we change views (this means we're navigating away from the resend view)
    if (_sessionStorageHelper.default.getResendTimestamp() && (!resendContext || didFormNameChange)) {
      _sessionStorageHelper.default.removeResendTimestamp();
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/shared/ChallengeOktaVerifyCustomAppDataView.js":
/*!**********************************************************************************!*\
  !*** ./src/v2/view-builder/views/shared/ChallengeOktaVerifyCustomAppDataView.js ***!
  \**********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _ChallengeOktaVerifyCustomAppPushOnlyFormView = _interopRequireDefault(__webpack_require__(/*! ./ChallengeOktaVerifyCustomAppPushOnlyFormView */ "./src/v2/view-builder/views/shared/ChallengeOktaVerifyCustomAppPushOnlyFormView.js"));
var _ChallengeOktaVerifyCustomAppFormView = _interopRequireDefault(__webpack_require__(/*! ./ChallengeOktaVerifyCustomAppFormView */ "./src/v2/view-builder/views/shared/ChallengeOktaVerifyCustomAppFormView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Common view for OV push and custom app.
var _default = _BaseAuthenticatorView.default.extend({
  initialize() {
    _BaseAuthenticatorView.default.prototype.initialize.apply(this, arguments);
    if (this.isPushOnlyWithAutoChallengeFlow()) {
      this.Body = _ChallengeOktaVerifyCustomAppPushOnlyFormView.default;
    } else {
      this.Body = _ChallengeOktaVerifyCustomAppFormView.default;
      this.Footer = _internals.BaseFooter;
    }
  },
  isPushOnlyWithAutoChallengeFlow() {
    const methodType = this.options.appState.getSchemaByName('authenticator.methodType');
    const hasAutoChallengeSchema = this.options.appState.getSchemaByName('authenticator.autoChallenge');
    const methodTypeOptions = methodType === null || methodType === void 0 ? void 0 : methodType.options;
    return hasAutoChallengeSchema && methodTypeOptions.length === 1 && methodTypeOptions[0].value === 'push';
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/shared/ChallengeOktaVerifyCustomAppFormView.js":
/*!**********************************************************************************!*\
  !*** ./src/v2/view-builder/views/shared/ChallengeOktaVerifyCustomAppFormView.js ***!
  \**********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _AuthenticatorVerifyOptions = _interopRequireDefault(__webpack_require__(/*! ../../components/AuthenticatorVerifyOptions */ "./src/v2/view-builder/components/AuthenticatorVerifyOptions.js"));
var _AuthenticatorUtil = __webpack_require__(/*! ../../utils/AuthenticatorUtil */ "./src/v2/view-builder/utils/AuthenticatorUtil.js");
var _SelectAuthenticatorVerifyView = __webpack_require__(/*! ../SelectAuthenticatorVerifyView */ "./src/v2/view-builder/views/SelectAuthenticatorVerifyView.js");
var _RemediationConstants = __webpack_require__(/*! ../../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Common view for OV push and custom app.

const Body = _SelectAuthenticatorVerifyView.Body.extend({
  getUISchema() {
    // Change the UI schema to not display radios here.
    const uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);
    const methodsSchema = uiSchemas.find(schema => schema.name === 'authenticator.methodType');
    this._sortMethodOptionsIfDeviceKnown(methodsSchema.options);
    const methodOptions = methodsSchema.options.map(option => {
      return Object.assign({}, option, (0, _AuthenticatorUtil.getAuthenticatorDataForVerification)({
        authenticatorKey: this.isOV() ? _RemediationConstants.AUTHENTICATOR_KEY.OV : _RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_APP,
        value: {
          methodType: option.value
        }
      }));
    });
    return [{
      View: _AuthenticatorVerifyOptions.default,
      options: {
        name: methodsSchema.name,
        collection: new _courage.Collection(methodOptions)
      }
    }];
  },
  // If the `deviceKnown` attribute is true, we should put the signed_nonce method to the top of authenticator list.
  // This is in sync with v2/ion/ui-schema/ion-object-handler.js - createOVOptions
  _sortMethodOptionsIfDeviceKnown(methodOptions) {
    var _this$options, _this$options$current, _this$options$current2, _this$options$current3;
    // Check if the `deviceKnown` attribute is true
    const deviceKnown = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$current = _this$options.currentViewState) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.relatesTo) === null || _this$options$current2 === void 0 ? void 0 : (_this$options$current3 = _this$options$current2.value) === null || _this$options$current3 === void 0 ? void 0 : _this$options$current3.deviceKnown;
    if (deviceKnown) {
      const signedNonceIndex = methodOptions.findIndex(e => e.value === 'signed_nonce');
      if (signedNonceIndex > 0) {
        const signedNonceModel = methodOptions[signedNonceIndex];

        // Put the 'signed_nonce' option to the top of the list
        methodOptions.splice(signedNonceIndex, 1);
        methodOptions.unshift(signedNonceModel);
      }
    }
  },
  isOV() {
    return this.options.appState.get('authenticatorKey') === _RemediationConstants.AUTHENTICATOR_KEY.OV;
  }
});
var _default = Body;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/shared/ChallengeOktaVerifyCustomAppPushOnlyFormView.js":
/*!******************************************************************************************!*\
  !*** ./src/v2/view-builder/views/shared/ChallengeOktaVerifyCustomAppPushOnlyFormView.js ***!
  \******************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _RemediationConstants = __webpack_require__(/*! v2/ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
// Common view for OV push and custom app.

const Body = _internals.BaseForm.extend(Object.assign({
  className: function () {
    return this.isOV() ? 'okta-verify-send-push-form' : 'custom-app-send-push-form';
  },
  save() {
    return this.options.appState.get('authenticatorKey') === _RemediationConstants.AUTHENTICATOR_KEY.OV ? (0, _courage.loc)('oie.okta_verify.sendPushButton', 'login') : (0, _courage.loc)('oie.custom_app.sendPushButton', 'login');
  },
  title() {
    return this.isOV() ? (0, _courage.loc)('oie.okta_verify.push.title', 'login') : (0, _courage.loc)('oie.custom_app.push.title', 'login');
  },
  render() {
    _internals.BaseForm.prototype.render.apply(this, arguments);
    // Move checkbox below the button
    // Checkbox is rendered by BaseForm using remediation response and 
    // hence by default always gets added above buttons.
    const checkbox = this.$el.find('[data-se="o-form-fieldset-authenticator.autoChallenge"]');
    checkbox.length && this.$el.find('.o-form-button-bar').after(checkbox);
  },
  getUISchema() {
    const uiSchemas = _internals.BaseForm.prototype.getUISchema.apply(this, arguments);
    return uiSchemas.filter(schema => schema.name !== 'authenticator.methodType');
  },
  isOV() {
    return this.options.appState.get('authenticatorKey') === _RemediationConstants.AUTHENTICATOR_KEY.OV;
  }
}));
var _default = Body;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/shared/ChallengePushView.js":
/*!***************************************************************!*\
  !*** ./src/v2/view-builder/views/shared/ChallengePushView.js ***!
  \***************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.Body = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _polling = _interopRequireDefault(__webpack_require__(/*! ../shared/polling */ "./src/v2/view-builder/views/shared/polling.js"));
var _Constants = __webpack_require__(/*! ../../utils/Constants */ "./src/v2/view-builder/utils/Constants.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _RemediationConstants = __webpack_require__(/*! ../../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Common view for OV push and custom push.

const warningTemplate = _courage.View.extend({
  className: 'okta-form-infobox-warning infobox infobox-warning',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<span class=\"icon warning-16\"></span><p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "warning") || (depth0 != null ? lookupProperty(depth0, "warning") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "warning",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 40
          },
          "end": {
            "line": 1,
            "column": 51
          }
        }
      }) : helper)) + "</p>";
    },
    "useData": true
  })
});
const Body = _internals.BaseFormWithPolling.extend(Object.assign({
  noButtonBar: true,
  title() {
    return this.isOV() ? (0, _courage.loc)('oie.okta_verify.push.title', 'login') : (0, _courage.loc)('oie.verify.custom_app.title', 'login', [this.options.appState.getAuthenticatorDisplayName()]);
  },
  initialize() {
    _internals.BaseFormWithPolling.prototype.initialize.apply(this, arguments);
    // 'hasSavingState' would be true by default.
    // Setting it to false when auth key is okta_verify or custom_app with autochallenge schema
    // So that 'o-form-saving' css class is not added while polling and checkbox remains enabled.
    if ((this.isOV() || this.isCustomApp()) && this.isAutoChallengeSupported()) {
      this.hasSavingState = false;
    }
    this.listenTo(this.model, 'error', this.stopPoll);
    this.addView();
  },
  addView() {
    this.add((0, _courage.createButton)({
      className: 'button button-wide button-primary send-push link-button-disabled',
      title: this.isOV() ? (0, _courage.loc)('oie.okta_verify.push.sent', 'login') : (0, _courage.loc)('oie.custom_app.push.sent', 'login'),
      click: e => {
        e.preventDefault();
      }
    }));
    this.add(`<span class='accessibility-text' role='alert'>
        ${this.isOV() ? (0, _courage.loc)('oie.okta_verify.push.sent', 'login') : (0, _courage.loc)('oie.custom_app.push.sent', 'login')}</span>`);
  },
  render() {
    _internals.BaseFormWithPolling.prototype.render.apply(this, arguments);
    const checkbox = this.$el.find('[data-se="o-form-fieldset-autoChallenge"]');
    if (!this.isAutoChallengeSupported()) {
      checkbox.length && checkbox.hide();
    } else if (this.isOV() || this.isCustomApp()) {
      // Move checkbox below the button
      // Checkbox is rendered by BaseForm using remediation response and
      // hence by default always gets added above buttons.
      checkbox.length && this.$el.find('.o-form-fieldset-container').append(checkbox);
    }
  },
  postRender() {
    _internals.BaseFormWithPolling.prototype.postRender.apply(this, arguments);
    const className = this.isOV() ? 'okta-verify-push-challenge' : ' custom-app-push-challenge';
    this.$el.addClass(className);
    this.startPoll();
  },
  startPoll() {
    this.startPolling();
    this.warningTimeout = setTimeout(() => {
      const warningText = this.isOV() ? (0, _courage.loc)('oktaverify.warning', 'login') : (0, _courage.loc)('oie.custom_app.push.warning', 'login', [this.options.appState.getAuthenticatorDisplayName()]);
      this.showWarning(warningText);
    }, _Constants.WARNING_TIMEOUT);
  },
  stopPoll() {
    this.stopPolling();
    this.clearWarning();
  },
  showWarning(msg) {
    this.clearWarning();
    this.add(warningTemplate, '.o-form-error-container', {
      options: {
        warning: msg
      }
    });
  },
  clearWarning() {
    if (this.$('.o-form-error-container div').hasClass('okta-form-infobox-warning')) {
      this.$('.okta-form-infobox-warning').remove();
    }
    clearTimeout(this.warningTimeout);
  },
  remove() {
    _internals.BaseFormWithPolling.prototype.remove.apply(this, arguments);
    this.stopPoll();
  },
  isOV() {
    return this.options.appState.get('authenticatorKey') === _RemediationConstants.AUTHENTICATOR_KEY.OV;
  },
  isCustomApp() {
    return this.options.appState.get('authenticatorKey') === _RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_APP;
  },
  isAutoChallengeSupported() {
    return this.options.appState.getSchemaByName('autoChallenge') !== null && this.options.appState.getSchemaByName('autoChallenge') !== undefined;
  }
}, _polling.default));
exports.Body = Body;
const AuthenticatorView = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = AuthenticatorView;

/***/ }),

/***/ "./src/v2/view-builder/views/shared/CustomAccessDeniedErrorMessage.js":
/*!****************************************************************************!*\
  !*** ./src/v2/view-builder/views/shared/CustomAccessDeniedErrorMessage.js ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _courage.View.extend({
  className: 'custom-access-denied-error-message',
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var helper,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "message",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 18
          },
          "end": {
            "line": 1,
            "column": 29
          }
        }
      }) : helper)) + "</p>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<ul class=\"custom-links\">" + ((stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "links") : depth0, {
        "name": "each",
        "hash": {},
        "fn": container.program(4, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 78
          },
          "end": {
            "line": 1,
            "column": 182
          }
        }
      })) != null ? stack1 : "") + "</ul>";
    },
    "4": function (container, depth0, helpers, partials, data) {
      var helper,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        alias2 = container.hooks.helperMissing,
        alias3 = "function",
        alias4 = container.escapeExpression,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<li><a href=" + alias4((helper = (helper = lookupProperty(helpers, "url") || (depth0 != null ? lookupProperty(depth0, "url") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "url",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 105
          },
          "end": {
            "line": 1,
            "column": 112
          }
        }
      }) : helper)) + " target=\"_blank\" rel=\"noopener noreferrer\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
        "name": "label",
        "hash": {},
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 155
          },
          "end": {
            "line": 1,
            "column": 164
          }
        }
      }) : helper)) + "</a></li>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "message") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 40
          }
        }
      })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "links") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 40
          },
          "end": {
            "line": 1,
            "column": 194
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  getTemplateData() {
    return {
      message: this.options.message,
      links: this.options.links
    };
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/shared/email.js":
/*!***************************************************!*\
  !*** ./src/v2/view-builder/views/shared/email.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _default = {
  title() {
    return (0, _courage.loc)('oie.email.mfa.title', 'login');
  }
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/shared/polling.js":
/*!*****************************************************!*\
  !*** ./src/v2/view-builder/views/shared/polling.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Constants = __webpack_require__(/*! ../../utils/Constants */ "./src/v2/view-builder/utils/Constants.js");
var _default = {
  startPolling(newRefreshInterval) {
    this.fixedPollingInterval = this.options.currentViewState.refresh;
    this.dynamicPollingInterval = newRefreshInterval;
    this.countDownCounterValue = Math.ceil(this.pollingInterval / _Constants.MS_PER_SEC);
    // Poll is present in remediation form
    if (this.fixedPollingInterval) {
      this._startRemediationPolling();
    } else {
      // Poll is present in authenticator/ authenticator Enrollment obj.
      // Authenticator won't co-exists hence it's safe to trigger both.
      this._startAuthenticatorPolling();
    }
  },
  _startAuthenticatorPolling() {
    // Authenticator won't co-exists hence it's safe to trigger both.
    ['currentAuthenticator', 'currentAuthenticatorEnrollment'].some(responseKey => {
      if (this.options.appState.has(responseKey)) {
        var _authenticator$poll;
        const authenticator = this.options.appState.get(responseKey);
        const authenticatorPollAction = `${responseKey}-poll`;
        const pollInterval = this.dynamicPollingInterval || (authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$poll = authenticator.poll) === null || _authenticator$poll === void 0 ? void 0 : _authenticator$poll.refresh);
        if (_courage._.isNumber(pollInterval)) {
          this.polling = setTimeout(() => {
            this.options.appState.trigger('invokeAction', authenticatorPollAction);
          }, pollInterval);
        }
        return true;
      } else {
        return false;
      }
    });
  },
  _startRemediationPolling() {
    const pollInterval = this.dynamicPollingInterval || this.fixedPollingInterval;
    if (_courage._.isNumber(pollInterval)) {
      this.polling = setTimeout(() => {
        this.options.appState.trigger('saveForm', this.model);
      }, pollInterval);
    }
  },
  stopPolling() {
    if (this.polling) {
      clearTimeout(this.polling);
      this.polling = null;
    }
  }
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/signin/CustomButtons.js":
/*!***********************************************************!*\
  !*** ./src/v2/view-builder/views/signin/CustomButtons.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _courage.View.extend({
  className: 'custom-buttons',
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<div class=\"separation-line\"><span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "socialauth.divider.text"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 58
          },
          "end": {
            "line": 1,
            "column": 112
          }
        }
      })) + "</span></div>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "addSeparateLine") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 132
          }
        }
      })) != null ? stack1 : "") + "<div class=\"okta-custom-buttons-container primary-auth-container\"></div>";
    },
    "useData": true
  }),
  initialize(options) {
    options.customButtons.forEach(idpButton => {
      this.add((0, _courage.createButton)(idpButton), '.okta-custom-buttons-container');
    });
  },
  getTemplateData() {
    const jsonData = _courage.View.prototype.getTemplateData.apply(this, arguments);
    return Object.assign(jsonData, {
      addSeparateLine: this.options.addSeparateLine
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/signin/SignInWithDeviceOption.js":
/*!********************************************************************!*\
  !*** ./src/v2/view-builder/views/signin/SignInWithDeviceOption.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Util = _interopRequireDefault(__webpack_require__(/*! ../../../../util/Util */ "./src/util/Util.js"));
var _Enums = _interopRequireDefault(__webpack_require__(/*! ../../../../util/Enums */ "./src/util/Enums.js"));
var _Constants = __webpack_require__(/*! ../../utils/Constants */ "./src/v2/view-builder/utils/Constants.js");
var _RemediationConstants = __webpack_require__(/*! ../../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _ChallengeViewUtil = __webpack_require__(/*! ../../utils/ChallengeViewUtil */ "./src/v2/view-builder/utils/ChallengeViewUtil.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _courage.View.extend({
  className: 'sign-in-with-device-option',
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      return "<div class=\"signin-with-ov-description\"></div>";
    },
    "3": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<div class=\"separation-line\"><span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "authbutton.divider.text"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 201
          },
          "end": {
            "line": 1,
            "column": 255
          }
        }
      })) + "</span></div>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div class=\"okta-verify-container\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "signInWithDeviceIsRequired") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 35
          },
          "end": {
            "line": 1,
            "column": 122
          }
        }
      })) != null ? stack1 : "") + "</div>" + ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "signInWithDeviceIsRequired") : depth0, {
        "name": "unless",
        "hash": {},
        "fn": container.program(3, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 128
          },
          "end": {
            "line": 1,
            "column": 279
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  initialize() {
    var _deviceChallengePollR;
    const appState = this.options.appState;
    const deviceChallengePollRemediation = appState.hasRemediationObject(_RemediationConstants.FORMS.LAUNCH_AUTHENTICATOR);
    const deviceChallenge = deviceChallengePollRemediation === null || deviceChallengePollRemediation === void 0 ? void 0 : (_deviceChallengePollR = deviceChallengePollRemediation.relatesTo) === null || _deviceChallengePollR === void 0 ? void 0 : _deviceChallengePollR.value;
    this.add((0, _courage.createButton)({
      className: 'button',
      icon: 'okta-verify-authenticator',
      title: (0, _courage.loc)('oktaVerify.button', 'login'),
      click() {
        if (this.model.get('identifier')) {
          this.options.settings.set('identifier', encodeURIComponent(this.model.get('identifier')));
        }
        const isUVapproach = (deviceChallenge === null || deviceChallenge === void 0 ? void 0 : deviceChallenge.challengeMethod) === _Enums.default.UNIVERSAL_LINK_CHALLENGE;
        if (isUVapproach) {
          var _this$options, _this$options$setting;
          // launch the Okta Verify app
          let deviceChallengeUrl = (0, _ChallengeViewUtil.appendLoginHint)(deviceChallenge.href, (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$setting = _this$options.settings) === null || _this$options$setting === void 0 ? void 0 : _this$options$setting.get('identifier'));
          _Util.default.redirect(deviceChallengeUrl);
        }
        const isAppLinkapproach = (deviceChallenge === null || deviceChallenge === void 0 ? void 0 : deviceChallenge.challengeMethod) === _Enums.default.APP_LINK_CHALLENGE;
        if (isAppLinkapproach) {
          var _this$options2, _this$options2$settin;
          // launch the Okta Verify app
          let deviceChallengeUrl = (0, _ChallengeViewUtil.appendLoginHint)(deviceChallenge.href, (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : (_this$options2$settin = _this$options2.settings) === null || _this$options2$settin === void 0 ? void 0 : _this$options2$settin.get('identifier'));
          _Util.default.redirect(deviceChallengeUrl, window, true);
        }

        // OKTA-350084
        // For the universal link (iOS) and app link (Android) approach,
        // we need to 1. launch the Okta Verify app
        // and 2. take the enduser to the next step right away
        // In Safari, when Okta Verify app is not installed, step 1 responds with error immediately,
        // then step 2 will respond with error.
        // To avoid showing the error right before switching to the next UI,
        // wait for 500 milliseconds before invoking step 2
        _Util.default.callAfterTimeout(() => {
          if (this.options.isRequired) {
            appState.trigger('saveForm', this.model);
          } else {
            appState.trigger('invokeAction', _RemediationConstants.FORMS.LAUNCH_AUTHENTICATOR, {
              'rememberMe': this.model.get('rememberMe')
            });
          }
        }, isUVapproach || isAppLinkapproach ? _Constants.UNIVERSAL_LINK_POST_DELAY : 0);
      }
    }), '.okta-verify-container');
  },
  getTemplateData() {
    return {
      signInWithDeviceIsRequired: !!this.options.isRequired
    };
  },
  postRender() {
    if (this.options.isRequired) {
      var _this$options$appStat, _this$options$appStat2;
      const appLabel = (_this$options$appStat = this.options.appState.attributes) === null || _this$options$appStat === void 0 ? void 0 : (_this$options$appStat2 = _this$options$appStat.app) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.label;
      const resourceLabel = appLabel ? (0, _courage.loc)('oktaVerify.appDescription', 'login', [appLabel]) : (0, _courage.loc)('oktaVerify.description', 'login');
      const ovDescContainer = this.$el.find('.signin-with-ov-description');
      ovDescContainer.text(resourceLabel);
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/signin/SignInWithIdps.js":
/*!************************************************************!*\
  !*** ./src/v2/view-builder/views/signin/SignInWithIdps.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _courage.View.extend({
  className: 'sign-in-with-idp',
  template: _runtime.default.template({
    "1": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<div class=\"separation-line\"><span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "socialauth.divider.text"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 64
          },
          "end": {
            "line": 1,
            "column": 118
          }
        }
      })) + "</span></div>";
    },
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        alias1 = depth0 != null ? depth0 : container.nullContext || {},
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isSecondaryIdpDisplay") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 0
          },
          "end": {
            "line": 1,
            "column": 138
          }
        }
      })) != null ? stack1 : "") + "<div class=\"okta-idps-container\"></div>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isPrimaryIdpDisplay") : depth0, {
        "name": "if",
        "hash": {},
        "fn": container.program(1, data, 0),
        "inverse": container.noop,
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 177
          },
          "end": {
            "line": 1,
            "column": 313
          }
        }
      })) != null ? stack1 : "");
    },
    "useData": true
  }),
  initialize() {
    this.options.idpButtons.forEach(idpButton => {
      this.add((0, _courage.createButton)(idpButton), '.okta-idps-container');
    });
  },
  getTemplateData() {
    const jsonData = _courage.View.prototype.getTemplateData.apply(this, arguments);
    const addDivider = this.options.idpButtons.length > 0;
    return Object.assign(jsonData, {
      isPrimaryIdpDisplay: addDivider && this.options.isPrimaryIdpDisplay,
      isSecondaryIdpDisplay: addDivider && !this.options.isPrimaryIdpDisplay
    });
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/signin/SignInWithWebAuthn.js":
/*!****************************************************************!*\
  !*** ./src/v2/view-builder/views/signin/SignInWithWebAuthn.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _RemediationConstants = __webpack_require__(/*! ../../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _courage.View.extend({
  className: 'sign-in-with-webauthn-option',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<div class=\"okta-webauthn-container\"></div><div class=\"separation-line\"><span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "authbutton.divider.text"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 78
          },
          "end": {
            "line": 1,
            "column": 132
          }
        }
      })) + "</span></div>";
    },
    "useData": true
  }),
  initialize() {
    this.add((0, _courage.createButton)({
      className: 'button',
      icon: 'okta-webauthn-authenticator',
      title: (0, _courage.loc)('signinWithWebAuthn.button', 'login'),
      click: () => {
        this.options.appState.trigger('invokeAction', _RemediationConstants.FORMS.LAUNCH_WEBAUTHN_AUTHENTICATOR);
      }
    }), '.okta-webauthn-container');
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/symantec/AuthenticatorSymantecView.js":
/*!*************************************************************************!*\
  !*** ./src/v2/view-builder/views/symantec/AuthenticatorSymantecView.js ***!
  \*************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _BaseForm = _interopRequireDefault(__webpack_require__(/*! ../../internals/BaseForm */ "./src/v2/view-builder/internals/BaseForm.ts"));
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _BaseForm.default.extend({
  title() {
    const displayName = this.options.appState.getAuthenticatorDisplayName();
    return this.options.appState.isAuthenticatorChallenge() ? (0, _courage.loc)('oie.symantecVip.challenge.title', 'login', [displayName]) : (0, _courage.loc)('oie.symantecVip.enroll.title', 'login', [displayName]);
  },
  subtitle() {
    const displayName = this.options.appState.getAuthenticatorDisplayName();
    return this.options.appState.isAuthenticatorChallenge() ? (0, _courage.loc)('oie.symantecVip.challenge.description', 'login', [displayName]) : (0, _courage.loc)('oie.symantecVip.enroll.description', 'login', [displayName]);
  },
  save() {
    return this.options.appState.isAuthenticatorChallenge() ? (0, _courage.loc)('mfa.challenge.verify', 'login') : (0, _courage.loc)('mfa.enroll', 'login');
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/webauthn/ChallengeWebauthnInfoView.js":
/*!*************************************************************************!*\
  !*** ./src/v2/view-builder/views/webauthn/ChallengeWebauthnInfoView.js ***!
  \*************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _courage.View.extend({
  // eslint-disable-next-line max-len
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<p class=\"idx-webauthn-verify-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.verify.webauthn.instructions"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 36
          },
          "end": {
            "line": 1,
            "column": 99
          }
        }
      })) + "</p>";
    },
    "useData": true
  }),
  initialize() {
    const relatesToObject = this.options.currentViewState.relatesTo;
    const challengeData = relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value.contextualData.challengeData;
    if (challengeData.userVerification === 'required') {
      this.add((0, _courage.createCallout)({
        className: 'uv-required-callout',
        size: 'slim',
        type: 'warning',
        subtitle: (0, _courage.loc)('oie.verify.webauthn.uv.required.instructions', 'login')
      }));
    }
    this.add('<div data-se="webauthn-waiting" class="okta-waiting-spinner"></div>');
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/webauthn/ChallengeWebauthnView.js":
/*!*********************************************************************!*\
  !*** ./src/v2/view-builder/views/webauthn/ChallengeWebauthnView.js ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _CryptoUtil = _interopRequireDefault(__webpack_require__(/*! ../../../../util/CryptoUtil */ "./src/util/CryptoUtil.js"));
var _webauthn = _interopRequireDefault(__webpack_require__(/*! ../../../../util/webauthn */ "./src/util/webauthn.js"));
var _BrowserFeatures = _interopRequireDefault(__webpack_require__(/*! ../../../../util/BrowserFeatures */ "./src/util/BrowserFeatures.ts"));
var _ChallengeWebauthnInfoView = _interopRequireDefault(__webpack_require__(/*! ./ChallengeWebauthnInfoView */ "./src/v2/view-builder/views/webauthn/ChallengeWebauthnInfoView.js"));
var _i18nTransformer = __webpack_require__(/*! ../../../ion/i18nTransformer */ "./src/v2/ion/i18nTransformer.js");
var _ChallengeWebauthnFooter = _interopRequireDefault(__webpack_require__(/*! ../../components/ChallengeWebauthnFooter */ "./src/v2/view-builder/components/ChallengeWebauthnFooter.js"));
var _RemediationConstants = __webpack_require__(/*! ../../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _EnrollWebAuthnResidentkeyLinkView = _interopRequireDefault(__webpack_require__(/*! ./EnrollWebAuthnResidentkeyLinkView */ "./src/v2/view-builder/views/webauthn/EnrollWebAuthnResidentkeyLinkView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Body = _internals.BaseForm.extend({
  title() {
    return (0, _courage.loc)('oie.verify.webauth.title', 'login');
  },
  className: 'oie-verify-webauthn',
  getUISchema() {
    const schema = [];
    // Returning custom array so no input fields are displayed for webauthn
    if (_webauthn.default.isNewApiAvailable()) {
      const retryButton = (0, _courage.createButton)({
        className: 'retry-webauthn button-primary default-custom-button',
        title: (0, _courage.loc)('mfa.challenge.verify', 'login'),
        click: () => {
          this.getCredentialsAndSave();
        }
      });
      schema.push({
        View: _ChallengeWebauthnInfoView.default
      }, {
        View: retryButton
      });
      if (this._canSetupWebAuthnResidentKey()) {
        schema.push({
          View: _EnrollWebAuthnResidentkeyLinkView.default
        });
      }
    } else {
      schema.push({
        View: (0, _courage.createCallout)({
          className: 'webauthn-not-supported',
          type: 'error',
          subtitle: (0, _courage.loc)('oie.webauthn.error.not.supported', 'login')
        })
      });
    }
    return schema;
  },
  remove() {
    _internals.BaseForm.prototype.remove.apply(this, arguments);
    if (this.webauthnAbortController) {
      this.webauthnAbortController.abort();
      this.webauthnAbortController = null;
    }
  },
  noButtonBar: true,
  modelEvents: {
    'error': '_stopVerification'
  },
  getCredentialsAndSave() {
    var _this$options$appStat;
    this.clearErrors();
    this._startVerification();
    // AbortController is not supported in IE11
    if (typeof AbortController !== 'undefined') {
      this.webauthnAbortController = new AbortController();
    }
    const relatesToObject = this.options.currentViewState.relatesTo;
    const authenticatorData = (relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value) || {};
    const allowCredentials = [];
    const authenticatorEnrollments = ((_this$options$appStat = this.options.appState.get('authenticatorEnrollments')) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.value) || [];
    authenticatorEnrollments.forEach(enrollement => {
      if (enrollement.key === 'webauthn') {
        allowCredentials.push({
          type: 'public-key',
          id: _CryptoUtil.default.strToBin(enrollement.credentialId)
        });
      }
    });
    const challengeData = authenticatorData.contextualData.challengeData;
    const options = _courage._.extend({}, challengeData, {
      allowCredentials,
      challenge: _CryptoUtil.default.strToBin(challengeData.challenge)
    });
    // navigator.credentials() is not supported in IE11
    // eslint-disable-next-line compat/compat
    navigator.credentials.get({
      publicKey: options,
      signal: this.webauthnAbortController && this.webauthnAbortController.signal
    }).then(assertion => {
      const credentials = {
        clientData: _CryptoUtil.default.binToStr(assertion.response.clientDataJSON),
        authenticatorData: _CryptoUtil.default.binToStr(assertion.response.authenticatorData),
        signatureData: _CryptoUtil.default.binToStr(assertion.response.signature)
      };
      const hasUserHandleSchema = this.options.appState.getSchemaByName('credentials.userHandle');
      if (hasUserHandleSchema) {
        _courage._.extend(credentials, {
          userHandle: _CryptoUtil.default.binToStr(assertion.response.userHandle ?? '')
        });
      }
      this.model.set({
        credentials
      });
      this.saveForm(this.model);
    }, error => {
      // Do not display if it is abort error triggered by code when switching.
      // this.webauthnAbortController would be null if abort was triggered by code.
      if (this.webauthnAbortController) {
        this.model.trigger('error', this.model, {
          responseJSON: {
            errorSummary: (0, _i18nTransformer.getMessageFromBrowserError)(error)
          }
        });
      }
    }).finally(() => {
      // unset webauthnAbortController on successful authentication or error
      this.webauthnAbortController = null;
    });
  },
  _startVerification: function () {
    this.$('.okta-waiting-spinner').show();
    this.$('.retry-webauthn').hide();
    this.$('.setup-webauthn-residentkey-text').hide();
    this.$('.retry-webauthn')[0].textContent = (0, _courage.loc)('retry', 'login');
  },
  _stopVerification: function () {
    this.$('.okta-waiting-spinner').hide();
    this.$('.retry-webauthn').show();
    this.$('.setup-webauthn-residentkey-text').show();
  },
  _canSetupWebAuthnResidentKey: function () {
    return this.options.appState.hasRemediationObject(_RemediationConstants.FORMS.ENROLL_WEBAUTHN_RESIDENTKEY);
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body,
  Footer: _ChallengeWebauthnFooter.default,
  postRender() {
    _BaseAuthenticatorView.default.prototype.postRender.apply(this, arguments);
    // Trigger browser prompt automatically for other browsers for better UX.
    if (_webauthn.default.isNewApiAvailable() && !_BrowserFeatures.default.isSafari()) {
      this.form.getCredentialsAndSave();
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/webauthn/EnrollWebAuthnResidentkeyLinkView.js":
/*!*********************************************************************************!*\
  !*** ./src/v2/view-builder/views/webauthn/EnrollWebAuthnResidentkeyLinkView.js ***!
  \*********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _RemediationConstants = __webpack_require__(/*! ../../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _courage.View.extend({
  className: 'setup-webauthn-residentkey-text',
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var stack1,
        lookupProperty = container.lookupProperty || function (parent, propertyName) {
          if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
            return parent[propertyName];
          }
          return undefined;
        };
      return "<div>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.webauthn.rk.link"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 5
          },
          "end": {
            "line": 1,
            "column": 65
          }
        }
      })) != null ? stack1 : "") + "</div>";
    },
    "useData": true
  }),
  events: {
    'click .setup-webauthn-residentkey-link': function (e) {
      e.preventDefault();
      this.options.appState.trigger('invokeAction', _RemediationConstants.FORMS.ENROLL_WEBAUTHN_RESIDENTKEY);
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/webauthn/EnrollWebauthnInfoView.js":
/*!**********************************************************************!*\
  !*** ./src/v2/view-builder/views/webauthn/EnrollWebauthnInfoView.js ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _BrowserFeatures = _interopRequireDefault(__webpack_require__(/*! util/BrowserFeatures */ "./src/util/BrowserFeatures.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _courage.View.extend({
  // eslint-disable-next-line max-len
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      var lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
      return "<p class=\"idx-webauthn-enroll-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
        "name": "i18n",
        "hash": {
          "bundle": "login",
          "code": "oie.enroll.webauthn.instructions"
        },
        "data": data,
        "loc": {
          "start": {
            "line": 1,
            "column": 36
          },
          "end": {
            "line": 1,
            "column": 99
          }
        }
      })) + "</p>";
    },
    "useData": true
  }),
  initialize() {
    const relatesToObject = this.options.currentViewState.relatesTo;
    const activationData = relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value.contextualData.activationData;
    if (_BrowserFeatures.default.isEdge()) {
      this.add(_courage.View.extend({
        tagName: 'p',
        className: 'idx-webauthn-enroll-text-edge',
        template: _runtime.default.template({
          "compiler": [8, ">= 4.3.0"],
          "main": function (container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function (parent, propertyName) {
              if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                return parent[propertyName];
              }
              return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
              "name": "i18n",
              "hash": {
                "bundle": "login",
                "code": "oie.enroll.webauthn.instructions.edge"
              },
              "data": data,
              "loc": {
                "start": {
                  "line": 1,
                  "column": 0
                },
                "end": {
                  "line": 1,
                  "column": 68
                }
              }
            }));
          },
          "useData": true
        })
      }));
    }
    if (activationData.authenticatorSelection.userVerification === 'required') {
      this.add((0, _courage.createCallout)({
        className: 'uv-required-callout',
        size: 'slim',
        type: 'warning',
        subtitle: (0, _courage.loc)('oie.enroll.webauthn.uv.required.instructions', 'login')
      }));
    }
    this.add('<div data-se="webauthn-waiting" class="okta-waiting-spinner"></div>');
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/webauthn/EnrollWebauthnView.js":
/*!******************************************************************!*\
  !*** ./src/v2/view-builder/views/webauthn/EnrollWebauthnView.js ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _internals = __webpack_require__(/*! ../../internals */ "./src/v2/view-builder/internals/index.js");
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
var _webauthn = _interopRequireDefault(__webpack_require__(/*! util/webauthn */ "./src/util/webauthn.js"));
var _CryptoUtil = _interopRequireDefault(__webpack_require__(/*! util/CryptoUtil */ "./src/util/CryptoUtil.js"));
var _EnrollWebauthnInfoView = _interopRequireDefault(__webpack_require__(/*! ./EnrollWebauthnInfoView */ "./src/v2/view-builder/views/webauthn/EnrollWebauthnInfoView.js"));
var _i18nTransformer = __webpack_require__(/*! ../../../ion/i18nTransformer */ "./src/v2/ion/i18nTransformer.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function getExcludeCredentials(authenticatorEnrollments = []) {
  const credentials = [];
  authenticatorEnrollments.forEach(enrollement => {
    if (enrollement.key === 'webauthn') {
      credentials.push({
        type: 'public-key',
        id: _CryptoUtil.default.strToBin(enrollement.credentialId)
      });
    }
  });
  return credentials;
}
const Body = _internals.BaseForm.extend({
  title() {
    return (0, _courage.loc)('oie.enroll.webauthn.title', 'login');
  },
  className: 'oie-enroll-webauthn',
  modelEvents: {
    'error': '_stopEnrollment'
  },
  getUISchema() {
    const schema = [];
    // Returning custom array so no input fields are displayed for webauthn
    if (_webauthn.default.isNewApiAvailable()) {
      schema.push({
        View: _EnrollWebauthnInfoView.default
      });
      schema.push({
        View: (0, _courage.createButton)({
          className: 'webauthn-setup button button-primary button-wide',
          title: (0, _courage.loc)('oie.enroll.webauthn.save', 'login'),
          click: () => {
            this.triggerWebauthnPrompt();
          }
        })
      });
    } else {
      schema.push({
        View: (0, _courage.createCallout)({
          className: 'webauthn-not-supported',
          type: 'error',
          subtitle: (0, _courage.loc)('oie.webauthn.error.not.supported', 'login')
        })
      });
    }
    return schema;
  },
  triggerWebauthnPrompt() {
    this.$el.find('.o-form-error-container').empty();
    this._startEnrollment();
    const relatesToObject = this.options.currentViewState.relatesTo;
    const activationData = relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value.contextualData.activationData;
    if (_webauthn.default.isNewApiAvailable()) {
      var _activationData$authe;
      const excludeCredentials = ((_activationData$authe = activationData.authenticatorSelection) === null || _activationData$authe === void 0 ? void 0 : _activationData$authe.requireResidentKey) === true ? [] : getExcludeCredentials(this.options.appState.get('authenticatorEnrollments').value);
      const options = _courage._.extend({}, activationData, {
        challenge: _CryptoUtil.default.strToBin(activationData.challenge),
        user: {
          id: _CryptoUtil.default.strToBin(activationData.user.id),
          name: activationData.user.name,
          displayName: activationData.user.displayName
        },
        excludeCredentials
      });
      // AbortController is not supported in IE11
      if (typeof AbortController !== 'undefined') {
        this.webauthnAbortController = new AbortController();
      }
      navigator.credentials.create({
        publicKey: options,
        signal: this.webauthnAbortController && this.webauthnAbortController.signal
      }).then(newCredential => {
        this.model.set({
          credentials: {
            clientData: _CryptoUtil.default.binToStr(newCredential.response.clientDataJSON),
            attestation: _CryptoUtil.default.binToStr(newCredential.response.attestationObject),
            // example data: ["nfc", "usb"]
            transports: _webauthn.default.processWebAuthnResponse(newCredential.response.getTransports, newCredential.response),
            // example data: {"credProps":{"rk":true}}
            clientExtensions: _webauthn.default.processWebAuthnResponse(newCredential.getClientExtensionResults, newCredential)
          }
        });
        this.saveForm(this.model);
      }).catch(error => {
        this.model.trigger('error', this.model, {
          responseJSON: {
            errorSummary: (0, _i18nTransformer.getMessageFromBrowserError)(error)
          }
        });
      }).finally(() => {
        this.webauthnAbortController = null;
      });
    }
  },
  _startEnrollment: function () {
    this.$('.okta-waiting-spinner').show();
    this.$('.webauthn-setup').hide();
  },
  _stopEnrollment: function () {
    this.$('.okta-waiting-spinner').hide();
    this.$('.webauthn-setup').show();
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body,
  postRender() {
    _BaseAuthenticatorView.default.prototype.postRender.apply(this, arguments);
    this.$el.find('.o-form-button-bar [type="submit"]').remove();
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/views/yubikey/AuthenticatorYubiKeyView.js":
/*!***********************************************************************!*\
  !*** ./src/v2/view-builder/views/yubikey/AuthenticatorYubiKeyView.js ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _BaseForm = _interopRequireDefault(__webpack_require__(/*! ../../internals/BaseForm */ "./src/v2/view-builder/internals/BaseForm.ts"));
var _BaseAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ../../components/BaseAuthenticatorView */ "./src/v2/view-builder/components/BaseAuthenticatorView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ExampleView = _courage.View.extend({
  template: _runtime.default.template({
    "compiler": [8, ">= 4.3.0"],
    "main": function (container, depth0, helpers, partials, data) {
      return "<div aria-hidden=\"true\" class=\"yubikey-demo\"></div>";
    },
    "useData": true
  })
});
const Body = _BaseForm.default.extend({
  title() {
    return this.options.appState.isAuthenticatorChallenge() ? (0, _courage.loc)('oie.yubikey.challenge.title', 'login') : (0, _courage.loc)('oie.yubikey.enroll.title', 'login');
  },
  subtitle() {
    return (0, _courage.loc)('oie.yubikey.description', 'login');
  },
  save() {
    return (0, _courage.loc)('mfa.challenge.verify', 'login');
  },
  getUISchema() {
    const schema = _BaseForm.default.prototype.getUISchema.apply(this, arguments);
    schema.unshift({
      View: ExampleView,
      selector: '.o-form-fieldset-container'
    });
    return schema;
  }
});
var _default = _BaseAuthenticatorView.default.extend({
  Body
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/widget/buildRenderOptions.js":
/*!******************************************!*\
  !*** ./src/widget/buildRenderOptions.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildRenderOptions;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _OAuth2Util = _interopRequireDefault(__webpack_require__(/*! util/OAuth2Util */ "./src/util/OAuth2Util.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function buildRenderOptions(widgetOptions = {}, options = {}) {
  const authParams = _courage.$.extend(true, {}, widgetOptions.authParams, _courage._.pick(options, _OAuth2Util.default.AUTH_PARAMS));
  const {
    el,
    clientId,
    redirectUri
  } = Object.assign({}, widgetOptions, options);
  const renderOptions = Object.assign({}, {
    el,
    clientId,
    redirectUri,
    authParams
  });
  if (!renderOptions.el) {
    throw new _Errors.ConfigError('"el" is required');
  }
  if (!renderOptions.clientId) {
    throw new _Errors.ConfigError('"clientId" is required');
  }
  if (!renderOptions.redirectUri) {
    throw new _Errors.ConfigError('"redirectUri" is required');
  }
  return renderOptions;
}
module.exports = exports.default;

/***/ }),

/***/ "./src/widget/createRouter.js":
/*!************************************!*\
  !*** ./src/widget/createRouter.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = createRouter;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function createRouter(Router, widgetOptions, renderOptions, authClient, successFn, errorFn, hooks) {
  let resolve;
  let reject;
  const promise = new Promise((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });
  const routerOptions = _courage.$.extend(true, {}, widgetOptions, renderOptions, {
    authClient,
    hooks,
    globalSuccessFn: res => {
      successFn && successFn(res); // call success function if provided
      if (res && res.status === _Enums.default.SUCCESS) {
        resolve(res);
      }
    },
    globalErrorFn: error => {
      errorFn && errorFn(error); // call error function if provided
      reject(error);
    }
  });
  const router = new Router(routerOptions);
  router.start();
  return {
    router,
    routerOptions,
    promise
  };
}
module.exports = exports.default;

/***/ }),

/***/ "./src/authClient/default.ts":
/*!***********************************!*\
  !*** ./src/authClient/default.ts ***!
  \***********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.OktaAuth = void 0;
var _oktaAuthJs = __webpack_require__(/*! @okta/okta-auth-js */ "./node_modules/@okta/okta-auth-js/umd/default.js");
var _oie = __webpack_require__(/*! ./oie */ "./src/authClient/oie.ts");
// Default supports both Authn and IDX pipelines

// okta-auth-js supports a mixin pattern that allows us to compose a custom version containing only the code we need
// build an AuthJS client that supports both the Classic and OIE engines

// Simply add Authn support to the IDX client
const OktaAuth = (0, _oktaAuthJs.mixinAuthn)(_oie.OktaAuth);
exports.OktaAuth = OktaAuth;

/***/ }),

/***/ "./src/authClient/oie.ts":
/*!*******************************!*\
  !*** ./src/authClient/oie.ts ***!
  \*******************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.OktaAuth = void 0;
var _oktaAuthJs = __webpack_require__(/*! @okta/okta-auth-js */ "./node_modules/@okta/okta-auth-js/umd/default.js");
// OIE supports only IDX pipeline

// okta-auth-js supports a mixin pattern that allows us to compose a custom version containing only the code we need
// build an AuthJS client that supports only the OIE engine

const OptionsConstructor = (0, _oktaAuthJs.createIdxOptionsConstructor)();
const StorageManager = (0, _oktaAuthJs.createIdxStorageManager)();
const IdxTransactionManager = (0, _oktaAuthJs.createIdxTransactionManager)();

// Start with OAuth as base
const OktaAuthOAuth = (0, _oktaAuthJs.createOktaAuthOAuth)(StorageManager, OptionsConstructor, IdxTransactionManager);

// Mixin IDX support
const OktaAuth = (0, _oktaAuthJs.mixinIdx)(OktaAuthOAuth);
exports.OktaAuth = OktaAuth;

/***/ }),

/***/ "./src/exports/cdn/default.ts":
/*!************************************!*\
  !*** ./src/exports/cdn/default.ts ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _default2 = __webpack_require__(/*! ../default */ "./src/exports/default.ts");
// CDN bundle must have a single default export
var _default = _default2.OktaSignIn;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/exports/default.ts":
/*!********************************!*\
  !*** ./src/exports/default.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _exportNames = {
  OktaSignIn: true
};
exports["default"] = exports.OktaSignIn = void 0;
var _default2 = __webpack_require__(/*! ../authClient/default */ "./src/authClient/default.ts");
var _default3 = __webpack_require__(/*! ../router/default */ "./src/router/default.ts");
var _OktaSignIn = __webpack_require__(/*! ../widget/OktaSignIn */ "./src/widget/OktaSignIn.ts");
var _types = __webpack_require__(/*! ../types */ "./src/types/index.ts");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
// Default supports both IDX and Authn pipelines

class OktaSignIn extends (0, _OktaSignIn.createOktaSignIn)(_default2.OktaAuth, _default3.routerClassFactory) {
  constructor(options) {
    super(options);
  }
}
exports.OktaSignIn = OktaSignIn;
var _default = OktaSignIn;
exports["default"] = _default;

/***/ }),

/***/ "./src/models/Hooks.ts":
/*!*****************************!*\
  !*** ./src/models/Hooks.ts ***!
  \*****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Hooks = __webpack_require__(/*! util/Hooks */ "./src/util/Hooks.js");
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

class Hooks extends _courage.Model {
  mergeHook(formName, hookToMerge) {
    const hooks = this.get('hooks') || {};
    (0, _Hooks.mergeHook)(hooks, formName, hookToMerge);
    this.set('hooks', hooks);
  }
  getHook(formName) {
    const hooks = this.get('hooks') || {};
    return hooks[formName]; // may be undefined
  }
}
exports["default"] = Hooks;
module.exports = exports.default;

/***/ }),

/***/ "./src/models/Settings.ts":
/*!********************************!*\
  !*** ./src/models/Settings.ts ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _config = _interopRequireDefault(__webpack_require__(/*! config/config.json */ "./src/config/config.json"));
var _q = _interopRequireDefault(__webpack_require__(/*! q */ "./node_modules/q/q.js"));
var _BrowserFeatures = _interopRequireDefault(__webpack_require__(/*! util/BrowserFeatures */ "./src/util/BrowserFeatures.ts"));
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _IDP = _interopRequireDefault(__webpack_require__(/*! util/IDP */ "./src/util/IDP.js"));
var _Logger = _interopRequireDefault(__webpack_require__(/*! util/Logger */ "./src/util/Logger.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _CountryUtil = _interopRequireDefault(__webpack_require__(/*! util/CountryUtil */ "./src/util/CountryUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint max-statements: [2, 22],  complexity: [2, 12] */

/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const SharedUtil = _courage.internal.util.Util;
const assetBaseUrlTpl = _runtime.default.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function (container, depth0, helpers, partials, data) {
    var helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "https://global.oktacdn.com/okta-signin-widget/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "version") || (depth0 != null ? lookupProperty(depth0, "version") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "version",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 1,
          "column": 46
        },
        "end": {
          "line": 1,
          "column": 57
        }
      }
    }) : helper));
  },
  "useData": true
});
const local = {
  authClient: ['object', false, undefined],
  baseUrl: ['string', true],
  recoveryToken: ['string', false, undefined],
  stateToken: ['string', false, undefined],
  username: ['string', false],
  relayState: ['string', false],
  // These two settings are aliases. Setting either value will set `backToSignInUri`
  signOutLink: ['string', false],
  // for backward compatibility
  backToSignInLink: ['string', false],
  // preferred setting

  redirect: {
    type: 'string',
    values: ['never', 'always', 'auto'],
    value: 'auto'
  },
  // allows bootstrapping the Widget into a specific view such
  // as register or forgot password
  flow: ['string', false, 'default'],
  // Function to transform the username before passing it to the API
  // for Primary Auth, Forgot Password and Unlock Account.
  transformUsername: ['function', false],
  // CALLBACKS
  globalSuccessFn: 'function',
  globalErrorFn: 'function',
  processCreds: 'function',
  hooks: 'object',
  // IMAGES
  logo: 'string',
  logoText: ['string', false],
  helpSupportNumber: 'string',
  // <OIE>
  // attribute to hold proxy (fake) idx response
  // to render static pages without initiating idx pipeline
  proxyIdxResponse: ['object', false],
  // <OIE>
  // By default, state handle will be saved to session storage
  // and will be clear when terminal error or success redirect.
  // Set this flag to true if you want to override this behavior.
  // a.k.a dishonor the state handle stored in session storage.
  overrideExistingStateToken: ['boolean', false, false],
  // FEATURES
  'features.router': ['boolean', true, false],
  'features.securityImage': ['boolean', true, false],
  'features.rememberMe': ['boolean', true, true],
  'features.autoPush': ['boolean', true, false],
  'features.smsRecovery': ['boolean', true, false],
  'features.callRecovery': ['boolean', true, false],
  'features.emailRecovery': ['boolean', false, true],
  'features.webauthn': ['boolean', true, false],
  'features.selfServiceUnlock': ['boolean', true, false],
  'features.multiOptionalFactorEnroll': ['boolean', true, false],
  'features.deviceFingerprinting': ['boolean', false, false],
  'features.hideSignOutLinkInMFA': ['boolean', false, false],
  'features.skipIdpFactorVerificationBtn': ['boolean', false, false],
  'features.hideBackToSignInForReset': ['boolean', false, false],
  'features.customExpiredPassword': ['boolean', true, false],
  'features.registration': ['boolean', false, false],
  'features.idpDiscovery': ['boolean', false, false],
  'features.passwordlessAuth': ['boolean', false, false],
  'features.showPasswordToggleOnSignInPage': ['boolean', false, false],
  'features.trackTypingPattern': ['boolean', false, false],
  'features.redirectByFormSubmit': ['boolean', false, false],
  'features.useDeviceFingerprintForSecurityImage': ['boolean', false, true],
  'features.showPasswordRequirementsAsHtmlList': ['boolean', false, false],
  'features.mfaOnlyFlow': ['boolean', false, false],
  'features.scrollOnError': ['boolean', false, true],
  'features.showKeepMeSignedIn': ['boolean', false, true],
  'features.showIdentifier': ['boolean', false, true],
  'features.autoFocus': ['boolean', false, true],
  'features.sameDeviceOVEnrollmentEnabled': ['boolean', false, false],
  'features.showSessionRevocation': ['boolean', false, false],
  'features.disableAutocomplete': ['boolean', false, false],
  defaultCountryCode: ['string', false, 'US'],
  // I18N
  language: ['any', false],
  // Can be a string or a function
  i18n: ['object', false],
  // ASSETS
  'assets.baseUrl': ['string', false],
  'assets.rewrite': {
    type: 'function',
    value: _courage._.identity
  },
  'assets.languages': ['array', false],
  // OAUTH2
  issuer: 'string',
  clientId: 'string',
  redirectUri: 'string',
  state: 'string',
  nonce: 'string',
  scopes: 'array',
  codeChallenge: 'string',
  codeChallengeMethod: ['string', false],
  oAuthTimeout: ['number', false],
  authScheme: ['string', false, 'OAUTH2'],
  // External IdPs
  idps: ['array', false, []],
  idpDisplay: {
    type: 'string',
    values: ['PRIMARY', 'SECONDARY'],
    value: 'SECONDARY'
  },
  // HELP LINKS
  'helpLinks.help': 'string',
  'helpLinks.forgotPassword': 'string',
  'helpLinks.unlock': 'string',
  'helpLinks.custom': 'array',
  'helpLinks.factorPage.href': 'string',
  'helpLinks.factorPage.text': 'string',
  //Custom Buttons
  customButtons: ['array', false, []],
  //Registration
  policyId: 'string',
  'registration.click': 'function',
  'registration.parseSchema': 'function',
  'registration.preSubmit': 'function',
  'registration.postSubmit': 'function',
  //Consent
  'consent.cancel': 'function',
  //IDP Discovery
  'idpDiscovery.requestContext': 'string',
  //Colors
  'colors.brand': 'string',
  //cspNonce
  'cspNonce': 'string',
  //Descriptions
  brandName: 'string',
  //PIV
  piv: ['object', false, {}],
  //Email verify callback
  otp: 'string',
  //Support classic engine
  useClassicEngine: ['boolean', false, false],
  //hCaptcha script source URI
  'hcaptcha.scriptSource': ['string', false],
  //query params for hCaptcha script source URI
  'hcaptcha.scriptParams': ['object', false, {}],
  //reCAPTCHA script source URI
  'recaptcha.scriptSource': ['string', false]
};
const derived = {
  backToSignInUri: {
    deps: ['backToSignInLink', 'signOutLink'],
    fn: function (backToSignInLink, signOutLink) {
      return backToSignInLink || signOutLink; // prefer backToSignInLink over signOutLink, but they are aliases
    }
  },

  showPasswordToggle: {
    deps: ['features.showPasswordToggleOnSignInPage'],
    fn: function () {
      var _this$options, _this$options$feature, _this$options2;
      // showPasswordToggle is for OIE only.
      // Used to default showPasswordToggleOnSignInPage to true.
      const defaultValue = true;
      const customizedValue = ((_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$feature = _this$options.features) === null || _this$options$feature === void 0 ? void 0 : _this$options$feature.showPasswordToggleOnSignInPage) ?? ((_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2['features.showPasswordToggleOnSignInPage']);
      return customizedValue ?? defaultValue;
    },
    cache: true
  },
  redirectUtilFn: {
    deps: ['features.redirectByFormSubmit'],
    fn: function (redirectByFormSubmit) {
      return redirectByFormSubmit ? _Util.default.redirectWithFormGet.bind(_Util.default) : SharedUtil.redirect.bind(SharedUtil);
    },
    cache: true
  },
  supportedLanguages: {
    deps: ['i18n', 'language', 'assets.languages'],
    fn: function (i18n, language, hostedLanguages) {
      // By default, the language be automatically detected from the browser
      // Developers can specify the language. It will be added to the supportedLanguages list.
      // Developers can also provide a list of languages with hosted assets, these replace the default list
      const supportedLanguages = hostedLanguages || _config.default.supportedLanguages;
      return _courage._.union(supportedLanguages, _courage._.keys(i18n), _courage._.isString(language) ? [language] : []);
    },
    cache: true
  },
  languageCode: {
    deps: ['language', 'supportedLanguages'],
    fn: function (language, supportedLanguages) {
      const userLanguages = _BrowserFeatures.default.getUserLanguages();

      // TODO: revisit this fix - OKTA-491150
      userLanguages.forEach((val, idx) => {
        if (val === 'nl') {
          userLanguages[idx] = 'nl-NL';
        } else if (val === 'pt') {
          userLanguages[idx] = 'pt-BR';
        }
      });
      const preferred = _courage._.clone(userLanguages);
      const supportedLowerCase = _Util.default.toLower(supportedLanguages);

      // Any developer defined "language" takes highest priority:
      // As a string, i.e. 'en', 'ja', 'zh-CN'
      if (_courage._.isString(language)) {
        preferred.unshift(language);
      } else if (_courage._.isFunction(language)) {
        // As a callback function, which is passed the list of supported
        // languages and detected user languages. This function must return
        // a languageCode, i.e. 'en', 'ja', 'zh-CN'
        preferred.unshift(language(supportedLanguages, userLanguages));
      }

      // Add default language, and expand to include any language
      // codes that do not include region, dialect, etc.
      preferred.push(_config.default.defaultLanguage);
      const expanded = _Util.default.toLower(_Util.default.expandLanguages(preferred));

      // Perform a case insensitive search - this is necessary in the case
      // of browsers like Safari
      let i;
      let supportedPos;
      for (i = 0; i < expanded.length; i++) {
        supportedPos = supportedLowerCase.indexOf(expanded[i]);
        if (supportedPos > -1) {
          return supportedLanguages[supportedPos];
        }
      }
    }
  },
  countryCode: {
    deps: ['defaultCountryCode'],
    fn: function (defaultCountryCode) {
      const countries = _CountryUtil.default.getCountries();
      return Object.keys(countries).includes(defaultCountryCode) ? defaultCountryCode : 'US';
    }
  },
  mode: {
    deps: ['codeChallenge'],
    fn: function (codeChallenge) {
      if (codeChallenge) {
        return 'remediation';
      }
      return 'relying-party';
    }
  },
  oauth2Enabled: {
    deps: ['clientId', 'authScheme', 'authClient'],
    fn: function (clientId, authScheme, authClient) {
      if (!clientId && authClient) {
        clientId = authClient.options.clientId;
      }
      return !!clientId && authScheme.toLowerCase() === 'oauth2';
    },
    cache: true
  },
  // Redirect Uri to provide in the oauth API
  oauthRedirectUri: {
    deps: ['redirectUri'],
    fn: function (redirectUri) {
      if (redirectUri) {
        return redirectUri;
      }
      let origin = window.location.origin;

      // IE8
      if (!origin) {
        const href = window.location.href;
        const path = window.location.pathname;
        if (path !== '') {
          origin = href.substring(0, href.lastIndexOf(path));
        }
      }
      return encodeURI(origin);
    }
  },
  // Adjusts the idps passed into the widget based on if they get explicit support
  configuredSocialIdps: {
    deps: ['idps'],
    fn: function (idps) {
      return _courage._.map(idps, function (idpConfig) {
        const idp = _courage._.clone(idpConfig);
        let type = idp.type && idp.type.toLowerCase();
        if (!(type && _courage._.contains(_IDP.default.SUPPORTED_SOCIAL_IDPS, type))) {
          type = 'general-idp';
          idp.text = idp.text || '{ Please provide a text value }';
        }
        idp.className = ['social-auth-button', 'social-auth-' + type + '-button ', idp.className ? idp.className : ''].join(' ');
        idp.dataAttr = 'social-auth-' + type + '-button';
        idp.i18nKey = 'socialauth.' + type + '.label';
        return idp;
      });
    },
    cache: true
  },
  // Can support piv authentication
  hasPivCard: {
    deps: ['piv'],
    fn: function (piv) {
      return piv && piv.certAuthUrl;
    },
    cache: true
  },
  // social auth buttons order - 'above'/'below' the primary auth form (boolean)
  socialAuthPositionTop: {
    deps: ['configuredSocialIdps', 'hasPivCard', 'idpDisplay'],
    fn: function (configuredSocialIdps, hasPivCard, idpDisplay) {
      return (!_courage._.isEmpty(configuredSocialIdps) || hasPivCard) && idpDisplay.toUpperCase() === 'PRIMARY';
    },
    cache: true
  },
  hasConfiguredButtons: {
    deps: ['configuredSocialIdps', 'customButtons', 'hasPivCard'],
    fn: function (configuredSocialIdps, customButtons, hasPivCard) {
      return !_courage._.isEmpty(configuredSocialIdps) || !_courage._.isEmpty(customButtons) || hasPivCard;
    },
    cache: true
  }
};
class Settings extends _courage.Model {
  constructor(attributes, options) {
    // base class constructor will call preinitialize() and initialize() and compute derived properties
    super(attributes, options);

    // apply languageCode
    this.authClient = void 0;
    const authClient = this.getAuthClient();
    this.setAcceptLanguageHeader(authClient);
  }
  get(attributeName) {
    return _courage.Model.prototype.get.call(this, attributeName);
  }
  preinitialize(...args) {
    this.local = local;
    this.derived = derived;
    _courage.Model.prototype.preinitialize.apply(this, args);
  }
  initialize(options) {
    options = options || {};
    const {
      colors,
      authClient,
      flow
    } = options;
    let {
      baseUrl
    } = options;
    if (!baseUrl) {
      // infer baseUrl from the issuer
      // favor authClient API first
      if (authClient) {
        baseUrl = authClient.getIssuerOrigin();
      } else {
        var _issuer;
        // issuer can also be passed a top-level option or exist in authParams
        const {
          authParams
        } = options;
        let {
          issuer
        } = options;
        issuer = issuer || (authParams === null || authParams === void 0 ? void 0 : authParams.issuer);
        baseUrl = (_issuer = issuer) === null || _issuer === void 0 ? void 0 : _issuer.split('/oauth2/')[0];
      }
      this.set('baseUrl', baseUrl);
    }

    // If `flow` and `authClient` instance are passed to settings, set flow in auth client
    if (authClient && flow) {
      authClient.idx.setFlow(flow);
    }
    if (!baseUrl) {
      this.callGlobalError(new _Errors.ConfigError((0, _courage.loc)('error.required.baseUrl')));
    } else if (colors && _courage._.isString(colors.brand) && !colors.brand.match(/^#[0-9A-Fa-f]{6}$/)) {
      this.callGlobalError(new _Errors.ConfigError((0, _courage.loc)('error.invalid.colors.brand')));
    } else if (_BrowserFeatures.default.corsIsNotSupported()) {
      this.callGlobalError(new _Errors.UnsupportedBrowserError((0, _courage.loc)('error.unsupported.cors')));
    }
  }
  setAcceptLanguageHeader(authClient) {
    if (authClient) {
      authClient.http.setRequestHeader('Accept-Language', this.get('languageCode'));
    }
  }
  setAuthClient(authClient) {
    this.set('authClient', authClient);
    this.setAcceptLanguageHeader(authClient);
  }
  getAuthClient() {
    return this.get('authClient');
  }
  set(...args) {
    try {
      return _courage.Model.prototype.set.apply(this, args);
    } catch (e) {
      const message = e.message ? e.message : e;
      this.callGlobalError(new _Errors.ConfigError(message));
    }
  }

  // Invokes the global success function. This should only be called on a
  // terminal part of the code (i.e. authStatus SUCCESS or after sending
  // a recovery email)
  callGlobalSuccess(status, data) {
    const res = _courage._.extend(data, {
      status: status
    });
    // Defer this to ensure that our functions have rendered completely
    // before invoking their function

    _courage._.defer(_courage._.partial(this.get('globalSuccessFn'), res));
  }

  // Invokes the global error function. This should only be called on non
  // recoverable errors (i.e. configuration errors, browser unsupported
  // errors, etc)
  callGlobalError(err) {
    const globalErrorFn = this.get('globalErrorFn') || this.options.globalErrorFn;
    // Note: Must use "this.options.globalErrorFn" when they've passed invalid
    // arguments - globalErrorFn will not have been set yet

    if (globalErrorFn) {
      globalErrorFn(err);
    } else {
      // Only throw the error if they have not registered a globalErrorFn
      throw err;
    }
  }

  // Get the username by applying the transform function if it exists.
  transformUsername(username, operation) {
    const transformFn = this.get('transformUsername');
    if (transformFn && _courage._.isFunction(transformFn)) {
      return transformFn(username, operation);
    }
    return username;
  }
  processCreds(creds) {
    const processCreds = this.get('processCreds');
    return _q.default.Promise(function (resolve) {
      if (!_courage._.isFunction(processCreds)) {
        resolve();
      } else if (processCreds.length === 2) {
        processCreds(creds, resolve);
      } else {
        processCreds(creds);
        resolve();
      }
    });
  }
  parseRegistrationSchema(schema, onSuccess, onFailure) {
    const parseSchema = this.get('registration.parseSchema');

    //check for parseSchema callback
    if (_courage._.isFunction(parseSchema)) {
      parseSchema(schema, function (schema) {
        onSuccess(schema);
      }, function (error) {
        error = error || {
          errorSummary: (0, _courage.loc)('registration.default.callbackhook.error')
        };
        error['callback'] = 'parseSchema';
        onFailure(error);
      });
    } else {
      //no callback
      onSuccess(schema);
    }
  }
  preRegistrationSubmit(postData, onSuccess, onFailure) {
    const preSubmit = this.get('registration.preSubmit');

    //check for preSubmit callback
    if (_courage._.isFunction(preSubmit)) {
      preSubmit(postData, function (postData) {
        onSuccess(postData);
      }, function (error) {
        error = error || {
          errorSummary: (0, _courage.loc)('registration.default.callbackhook.error')
        };
        error['callback'] = 'preSubmit';
        onFailure(error);
      });
    } else {
      //no callback
      onSuccess(postData);
    }
  }
  postRegistrationSubmit(response, onSuccess, onFailure) {
    const postSubmit = this.get('registration.postSubmit');

    //check for postSubmit callback
    if (_courage._.isFunction(postSubmit)) {
      postSubmit(response, function (response) {
        onSuccess(response);
      }, function (error) {
        error = error || {
          errorSummary: (0, _courage.loc)('registration.default.callbackhook.error')
        };
        error['callback'] = 'postSubmit';
        onFailure(error);
      });
    } else {
      //no callback
      onSuccess(response);
    }
  }

  // Use the parse function to transform config options to the standard
  // settings we currently support. This is a good place to deprecate old
  // option formats.
  parse(options) {
    if (options.labels || options.country) {
      _Logger.default.deprecate('Use "i18n" instead of "labels" and "country"');
      const overrides = options.labels || {};
      _courage._.each(options.country, function (val, key) {
        overrides['country.' + key] = val;
      });
      // Old behavior is to treat the override as a global override, so we
      // need to add these overrides to each language
      options.i18n = {};
      _courage._.each(_config.default.supportedLanguages, function (language) {
        options.i18n[language] = overrides;
      });
      delete options.labels;
      delete options.country;
    }

    // Default the assets.baseUrl to the cdn, or remove any trailing slashes
    if (!options.assets) {
      options.assets = {};
    }
    const abu = options.assets.baseUrl;
    if (!abu) {
      options.assets.baseUrl = assetBaseUrlTpl({
        version: _config.default.version
      });
    } else if (abu[abu.length - 1] === '/') {
      options.assets.baseUrl = abu.substring(0, abu.length - 1);
    }
    return options;
  }
  isDsTheme() {
    return false;
  }
}
exports["default"] = Settings;
module.exports = exports.default;

/***/ }),

/***/ "./src/router/default.ts":
/*!*******************************!*\
  !*** ./src/router/default.ts ***!
  \*******************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.routerClassFactory = routerClassFactory;
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _LoginRouter = _interopRequireDefault(__webpack_require__(/*! v1/LoginRouter */ "./src/v1/LoginRouter.ts"));
var _WidgetRouter = _interopRequireDefault(__webpack_require__(/*! v2/WidgetRouter */ "./src/v2/WidgetRouter.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Default router factory will detect between classic and OIE pipeline

function routerClassFactory(options) {
  let Router;

  // V1 ("classic") flow will load under these conditions:
  const v1DefaultFlow = !options.stateToken && !options.clientId && !options.proxyIdxResponse; // Default entry flow on okta-hosted login page
  const v1StateTokenFlow = options.stateToken && _Util.default.isV1StateToken(options.stateToken); // Resuming a flow on okta-hosted login page
  const v1AuthFlow = options.clientId && options.useClassicEngine === true; // Self hosted widget can set the `useClassicEngine` option to use V1Router

  if (v1DefaultFlow || v1StateTokenFlow || v1AuthFlow) {
    Router = _LoginRouter.default;
  } else {
    Router = _WidgetRouter.default;
  }
  return Router;
}

/***/ }),

/***/ "./src/types/api.ts":
/*!**************************!*\
  !*** ./src/types/api.ts ***!
  \**************************/
/***/ (function() {

"use strict";


/***/ }),

/***/ "./src/types/appState.ts":
/*!*******************************!*\
  !*** ./src/types/appState.ts ***!
  \*******************************/
/***/ (function() {



/***/ }),

/***/ "./src/types/authClient.ts":
/*!*********************************!*\
  !*** ./src/types/authClient.ts ***!
  \*********************************/
/***/ (function() {

"use strict";


/***/ }),

/***/ "./src/types/errors.ts":
/*!*****************************!*\
  !*** ./src/types/errors.ts ***!
  \*****************************/
/***/ (function() {

"use strict";


/***/ }),

/***/ "./src/types/events.ts":
/*!*****************************!*\
  !*** ./src/types/events.ts ***!
  \*****************************/
/***/ (function() {

"use strict";


/***/ }),

/***/ "./src/types/index.ts":
/*!****************************!*\
  !*** ./src/types/index.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _appState = __webpack_require__(/*! ./appState */ "./src/types/appState.ts");
Object.keys(_appState).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _appState[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _appState[key];
    }
  });
});
var _api = __webpack_require__(/*! ./api */ "./src/types/api.ts");
Object.keys(_api).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _api[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _api[key];
    }
  });
});
var _authClient = __webpack_require__(/*! ./authClient */ "./src/types/authClient.ts");
Object.keys(_authClient).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _authClient[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _authClient[key];
    }
  });
});
var _errors = __webpack_require__(/*! ./errors */ "./src/types/errors.ts");
Object.keys(_errors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _errors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _errors[key];
    }
  });
});
var _events = __webpack_require__(/*! ./events */ "./src/types/events.ts");
Object.keys(_events).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _events[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _events[key];
    }
  });
});
var _registration = __webpack_require__(/*! ./registration */ "./src/types/registration.ts");
Object.keys(_registration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _registration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _registration[key];
    }
  });
});
var _options = __webpack_require__(/*! ./options */ "./src/types/options.ts");
Object.keys(_options).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _options[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _options[key];
    }
  });
});
var _results = __webpack_require__(/*! ./results */ "./src/types/results.ts");
Object.keys(_results).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _results[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _results[key];
    }
  });
});
var _router = __webpack_require__(/*! ./router */ "./src/types/router.ts");
Object.keys(_router).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _router[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _router[key];
    }
  });
});

/***/ }),

/***/ "./src/types/options.ts":
/*!******************************!*\
  !*** ./src/types/options.ts ***!
  \******************************/
/***/ (function() {

"use strict";


/***/ }),

/***/ "./src/types/registration.ts":
/*!***********************************!*\
  !*** ./src/types/registration.ts ***!
  \***********************************/
/***/ (function() {

"use strict";


/***/ }),

/***/ "./src/types/results.ts":
/*!******************************!*\
  !*** ./src/types/results.ts ***!
  \******************************/
/***/ (function() {

"use strict";


/***/ }),

/***/ "./src/types/router.ts":
/*!*****************************!*\
  !*** ./src/types/router.ts ***!
  \*****************************/
/***/ (function() {

"use strict";


/***/ }),

/***/ "./src/util/BrowserFeatures.ts":
/*!*************************************!*\
  !*** ./src/util/BrowserFeatures.ts ***!
  \*************************************/
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

const fn = {};
const hasFullCorsSupport = ('withCredentials' in new window.XMLHttpRequest());
const hasXDomainRequest = typeof window.XDomainRequest !== 'undefined';
fn.corsIsNotSupported = function () {
  return !(hasFullCorsSupport || hasXDomainRequest);
};
fn.corsIsNotEnabled = function (jqXhr) {
  // Not a definitive check, but it's the best we've got.
  // Note: This will change when OktaAuth is updated
  return jqXhr.status === 0;
};

// This is currently not being used, but we'll keep it around for when we
// want a fallback mechanism - i.e. use localStorage if it exists, else fall
// back to cookies.
fn.localStorageIsNotSupported = function () {
  const test = 'test';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return false;
  } catch (e) {
    return true;
  }
};
fn.supportsPushState = function (win) {
  win = win || window;
  return !!(win.history && win.history.pushState);
};
fn.isIE = function () {
  return /(msie|trident)/i.test(navigator.userAgent);
};
fn.isFirefox = function () {
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
};
fn.isEdge = function () {
  // This is to just check for windows edge. Mac edge - chromium based's UA is 'edg'.
  return navigator.userAgent.toLowerCase().indexOf('edge') > -1;
};
fn.isSafari = function () {
  // Chrome has safari in its useragent string so adding this extra check.
  return navigator.userAgent.toLowerCase().indexOf('safari') > -1 && navigator.userAgent.toLowerCase().indexOf('chrome') === -1;
};
fn.isMac = function () {
  return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
};
fn.isAndroid = function () {
  // Windows Phone also contains "Android"
  return /android/i.test(navigator.userAgent) && !/windows phone/i.test(navigator.userAgent);
};
fn.isIOS = function () {
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

// Returns a list of languages the user has configured for their browser, in
// order of preference.
fn.getUserLanguages = function () {
  // Chrome, Firefox
  if (navigator.languages) {
    return [...navigator.languages];
  }
  const languages = [];
  const properties = ['language',
  // Safari, IE11
  'userLanguage',
  // IE
  'browserLanguage',
  // IE
  'systemLanguage' // IE
  ];

  properties.forEach(function (property) {
    if (navigator[property]) {
      languages.push(navigator[property]);
    }
  });
  return languages;
};
var _default = fn;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/Bundles.ts":
/*!*****************************!*\
  !*** ./src/util/Bundles.ts ***!
  \*****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _config = _interopRequireDefault(__webpack_require__(/*! config/config.json */ "./src/config/config.json"));
var _crossFetch = _interopRequireDefault(__webpack_require__(/*! cross-fetch */ "./node_modules/cross-fetch/dist/browser-ponyfill.js"));
var _country = _interopRequireDefault(__webpack_require__(/*! nls/country.json */ "./packages/@okta/i18n/src/json/country.json"));
var _login = _interopRequireDefault(__webpack_require__(/*! nls/login.json */ "./packages/@okta/i18n/src/json/login.json"));
var _underscore = _interopRequireDefault(__webpack_require__(/*! underscore */ "./node_modules/underscore/underscore-umd.js"));
var _BrowserFeatures = _interopRequireDefault(__webpack_require__(/*! util/BrowserFeatures */ "./src/util/BrowserFeatures.ts"));
var _Logger = _interopRequireDefault(__webpack_require__(/*! util/Logger */ "./src/util/Logger.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

const STORAGE_KEY = 'osw.languages';
/**
 * Converts options to our internal format, which distinguishes between
 * login and country bundles.
 *
 * Example options.i18n passed in by the developer:
 * {
 *   'en': {
 *     'needhelp': 'need help override',
 *     'primaryauth.title': 'new sign in text',
 *     'country.JP' = 'Japan, Japan'
 *   }
 * }
 *
 * Parsed:
 * {
 *  'en': {
 *    'login': {
 *      'needhelp': 'need help override',
 *      'primaryauth.title': 'new sign in text',
 *    },
 *    'country': {
 *      'JP': 'Japan, Japan'
 *    }
 *  }
 * }
 */
function parseOverrides(i18n) {
  if (!i18n) {
    return {};
  }
  const i18nWithLowerCaseKeys = {};
  _underscore.default.each(_underscore.default.keys(i18n), function (key) {
    i18nWithLowerCaseKeys[key.toLowerCase()] = i18n[key];
  });
  return _underscore.default.mapObject(i18nWithLowerCaseKeys, function (props) {
    const mapped = {
      login: {},
      country: {}
    };
    if (!_underscore.default.isObject(props)) {
      throw new Error('Invalid format for "i18n"');
    }
    _underscore.default.each(props, function (val, key) {
      const split = key.split(/^country\./);
      if (split.length > 1) {
        mapped.country[split[1]] = val;
      } else {
        mapped.login[split[0]] = val;
      }
    });
    return mapped;
  });
}

// Caching: We only bundle English by default in the Sign-In Widget. Other
// languages are loaded on demand and cached in localStorage. These languages
// are tied to the version of the widget - when it bumps, we reset the cache.

function getCachedLanguages() {
  let storage = JSON.parse(localStorage.getItem(STORAGE_KEY));
  if (!storage || storage.version !== _config.default.version) {
    storage = {
      version: _config.default.version
    };
  }
  return storage;
}
function addLanguageToCache(language, loginJson, countryJson) {
  const current = getCachedLanguages();
  current[language] = {
    login: loginJson,
    country: countryJson
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
}

// By default, the assets.bundleUrl is tied to the Okta CDN.
//
// There are two overrides available for modifying where we load the asset
// bundles from:
//
// 1. assets.baseUrl
//
//    This is the base path the OSW pulls assets from, which in this case is
//    the Okta CDN. Override this config option if you want to host the
//    files on your own domain, or if you're using a new version of the
//    widget whose language files haven't been published to the CDN yet.
//
// 2. assets.rewrite
//
//    This is a function that can be used to modify the path + fileName of
//    the bundle we're loading, relative to the baseUrl. When called, it
//    will pass the current path, and expect the new path to be returned.
//    This is useful, for example, if your build process has an extra
//    cachebusting step, i.e:
//
//    function rewrite(file) {
//      // file: /labels/json/login_ja.json
//      return file.replace('.json', '.' + md5file(file) + '.json');
//    }
//
// Note: Most developers will not need to use these overrides - the default
// is to use the Okta CDN and to use the same path + file structure the
// widget module publishes by default.
function fetchJson(bundle, language, assets) {
  // Our bundles use _ to separate country and region, i.e:
  // zh-CN -> zh_CN
  const languageCode = language.replace('-', '_');
  const path = assets.rewrite(encodeURI(`/labels/json/${bundle}_${languageCode}.json`));
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'text/plain'
  };
  const mode = 'no-cors';
  return (0, _crossFetch.default)(assets.baseUrl + path, {
    method: 'GET',
    headers,
    mode
  }).then(res => res.text()).then(txt => JSON.parse(txt));
}
async function getBundles(language, assets, supportedLanguages) {
  // Two special cases:
  // 1. Default language is already bundled with the widget
  // 2. If the language is not in our config file, it means that they've
  //    probably defined it on their own.
  if (language === _config.default.defaultLanguage || !_underscore.default.contains(supportedLanguages, language)) {
    return {};
  }

  //local storage does not work correctly with android web views (embeded browers)
  //so skip the caching and just make the request to get the local info
  const localStorageIsSupported = !_BrowserFeatures.default.localStorageIsNotSupported();
  if (localStorageIsSupported) {
    const cached = getCachedLanguages();
    if (cached[language]) {
      return cached[language];
    }
  }
  try {
    const [loginJson, countryJson] = await Promise.all([fetchJson('login', language, assets), fetchJson('country', language, assets)]);
    if (localStorageIsSupported) {
      addLanguageToCache(language, loginJson, countryJson);
    }
    return {
      login: loginJson,
      country: countryJson
    };
  } catch (_e) {
    // If there is an error, this will default to the bundled language and
    // we will no longer try to load the language this session.
    _Logger.default.warn('Unable to load language: ' + language);
    return {};
  }
}
var _default = {
  login: _login.default,
  country: _country.default,
  // Courage components within the sign in widget point to courage bundle to look
  // up i18nkeys. Since we dont have courage.properties inside the sign in widget
  // we are pointing courage bundle to login.
  courage: _login.default,
  currentLanguage: null,
  isLoaded: function (language) {
    return this.currentLanguage === language;
  },
  remove: function () {
    this.currentLanguage = null;
  },
  loadLanguage: async function (language, overrides, assets, supportedLanguages) {
    const parsedOverrides = parseOverrides(overrides);
    const lowerCaseLanguage = language.toLowerCase();
    const bundles = await getBundles(language, assets, supportedLanguages);
    // Always extend from the built in defaults in the event that some
    // properties are not translated
    this.login = _underscore.default.extend({}, _login.default, bundles.login);
    this.country = _underscore.default.extend({}, _country.default, bundles.country);
    this.courage = _underscore.default.extend({}, _login.default, bundles.login);
    if (parsedOverrides[lowerCaseLanguage]) {
      _underscore.default.extend(this.login, parsedOverrides[lowerCaseLanguage]['login']);
      _underscore.default.extend(this.country, parsedOverrides[lowerCaseLanguage]['country']);
      _underscore.default.extend(this.courage, parsedOverrides[lowerCaseLanguage]['login']);
    }
    this.currentLanguage = language;
  }
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/util/Errors.ts":
/*!****************************!*\
  !*** ./src/util/Errors.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.WebauthnAbortError = exports.WebAuthnError = exports.UnsupportedBrowserError = exports.U2FError = exports.RegistrationError = exports.OAuthError = exports.ConfiguredFlowError = exports.ConfigError = exports.AuthStopPollInitiationError = void 0;
var _loc = __webpack_require__(/*! ./loc */ "./src/util/loc.ts");
var _Enums = _interopRequireDefault(__webpack_require__(/*! ./Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

class CustomError extends Error {
  constructor(message) {
    super(message);

    // 'Error' breaks prototype chain. Need to restore it for ES5.
    // https://github.com/microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work
    // Note: no need to adjust prototype in subclasses of 'CustomError'.
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
class ConfigError extends CustomError {
  constructor(message) {
    super(message || (0, _loc.loc)('error.config'));
    this.name = _Enums.default.CONFIG_ERROR;
  }
}
exports.ConfigError = ConfigError;
class UnsupportedBrowserError extends CustomError {
  constructor(message) {
    super(message || (0, _loc.loc)('error.unsupported.browser'));
    this.name = _Enums.default.UNSUPPORTED_BROWSER_ERROR;
  }
}
exports.UnsupportedBrowserError = UnsupportedBrowserError;
class OAuthError extends CustomError {
  constructor(...args) {
    super(...args);
    this.name = _Enums.default.OAUTH_ERROR;
  }
}
exports.OAuthError = OAuthError;
class RegistrationError extends CustomError {
  constructor(...args) {
    super(...args);
    this.name = _Enums.default.REGISTRATION_FAILED;
  }
}

// Thrown when initiation of poll was cancelled.
exports.RegistrationError = RegistrationError;
class AuthStopPollInitiationError extends CustomError {
  constructor(...args) {
    super(...args);
    this.name = _Enums.default.AUTH_STOP_POLL_INITIATION_ERROR;
  }
}
exports.AuthStopPollInitiationError = AuthStopPollInitiationError;
class U2FError extends CustomError {
  constructor(err) {
    var _err$xhr, _err$xhr$responseJSON;
    super((_err$xhr = err.xhr) === null || _err$xhr === void 0 ? void 0 : (_err$xhr$responseJSON = _err$xhr.responseJSON) === null || _err$xhr$responseJSON === void 0 ? void 0 : _err$xhr$responseJSON.errorSummary);
    this.xhr = void 0;
    this.name = _Enums.default.U2F_ERROR;
    this.xhr = err.xhr;
  }
}
exports.U2FError = U2FError;
class WebAuthnError extends CustomError {
  constructor(err) {
    var _err$xhr2, _err$xhr2$responseJSO;
    super((_err$xhr2 = err.xhr) === null || _err$xhr2 === void 0 ? void 0 : (_err$xhr2$responseJSO = _err$xhr2.responseJSON) === null || _err$xhr2$responseJSO === void 0 ? void 0 : _err$xhr2$responseJSO.errorSummary);
    this.xhr = void 0;
    this.name = _Enums.default.WEB_AUTHN_ERROR;
    this.xhr = err.xhr;
  }
}

// This is triggered only when code aborts webauthn browser prompt.
exports.WebAuthnError = WebAuthnError;
class WebauthnAbortError extends CustomError {
  constructor(...args) {
    super(...args);
    this.name = _Enums.default.WEBAUTHN_ABORT_ERROR;
  }
}
exports.WebauthnAbortError = WebauthnAbortError;
class ConfiguredFlowError extends CustomError {
  constructor(message, flowSetting) {
    super(message);
    this.flowSetting = void 0;
    this.name = _Enums.default.CONFIGURED_FLOW_ERROR;
    this.flowSetting = flowSetting;
  }
}
exports.ConfiguredFlowError = ConfiguredFlowError;

/***/ }),

/***/ "./src/util/OAuthErrors.ts":
/*!*********************************!*\
  !*** ./src/util/OAuthErrors.ts ***!
  \*********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.UserNotAssignedError = exports.TypedOAuthError = exports.RecoverableError = exports.NonRecoverableError = exports.MfaRequiredError = exports.JITProfileProvisioningError = exports.ClockDriftError = void 0;
exports.getTypedOAuthError = getTypedOAuthError;
var _loc = __webpack_require__(/*! ./loc */ "./src/util/loc.ts");
var _Errors = __webpack_require__(/*! ./Errors */ "./src/util/Errors.ts");
class InlineErrorType {
  constructor() {
    this.inline = true;
  }
}
class TerminalErrorType {
  constructor() {
    this.terminal = true;
  }
}
class TypedOAuthError extends _Errors.OAuthError {
  constructor(originalError, errorTypeCtor) {
    super(originalError.message);
    this.errorType = void 0;
    this.orginalError = void 0;
    this.errorDetails = void 0;
    this.errorType = new errorTypeCtor();
    this.orginalError = originalError;
    this.errorDetails = {
      errorSummary: this.getErrorSummary(),
      errorCode: originalError.errorCode,
      errorCauses: 'errorCauses' in originalError ? originalError.errorCauses : undefined
    };
  }
  getErrorSummary() {
    return this.orginalError.errorSummary;
  }
  is(errorTrait) {
    var _Object$getOwnPropert;
    return Boolean((_Object$getOwnPropert = Object.getOwnPropertyDescriptor(this.errorType, errorTrait)) === null || _Object$getOwnPropert === void 0 ? void 0 : _Object$getOwnPropert.value);
  }
}
exports.TypedOAuthError = TypedOAuthError;
class RecoverableError extends TypedOAuthError {}
exports.RecoverableError = RecoverableError;
class NonRecoverableError extends TypedOAuthError {}
exports.NonRecoverableError = NonRecoverableError;
class ClockDriftError extends RecoverableError {
  constructor(error) {
    super(error, TerminalErrorType);
  }
  getErrorSummary() {
    return (0, _loc.loc)('error.unsynced.clock', 'login');
  }
}
exports.ClockDriftError = ClockDriftError;
class UserNotAssignedError extends RecoverableError {
  constructor(error) {
    super(error, InlineErrorType);
  }
}
exports.UserNotAssignedError = UserNotAssignedError;
class JITProfileProvisioningError extends RecoverableError {
  constructor(error) {
    super(error, InlineErrorType);
  }
  getErrorSummary() {
    return (0, _loc.loc)('error.jit_failure', 'login');
  }
}
exports.JITProfileProvisioningError = JITProfileProvisioningError;
class MfaRequiredError extends NonRecoverableError {
  constructor(error) {
    super(error, InlineErrorType);
  }
  getErrorSummary() {
    return (0, _loc.loc)('error.mfa.required', 'login');
  }
}
exports.MfaRequiredError = MfaRequiredError;
function getTypedOAuthError(error) {
  switch (error.errorCode) {
    case 'access_denied':
      return new UserNotAssignedError(error);
    case 'jit_failure_missing_fields':
    case 'jit_failure_invalid_login_format':
    case 'jit_failure_values_not_match_pattern':
    case 'jit_failure_values_too_long':
    case 'jit_failure_invalid_locale':
      return new JITProfileProvisioningError(error);
    case 'login_required':
      const mfaRequiredMsg = 'The client specified not to prompt, but the client app requires re-authentication or MFA.';
      if (error.message === mfaRequiredMsg) {
        return new MfaRequiredError(error);
      }
    case 'INTERNAL':
      const clockDriftMsg = 'The JWT was issued in the future';
      if (error.message === clockDriftMsg) {
        return new ClockDriftError(error);
      }
    default:
      return new RecoverableError(error, Object);
  }
}

/***/ }),

/***/ "./src/util/loc.ts":
/*!*************************!*\
  !*** ./src/util/loc.ts ***!
  \*************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.loc = void 0;
var _oktaI18nBundles = _interopRequireDefault(__webpack_require__(/*! @okta/okta-i18n-bundles */ "./src/util/Bundles.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

// Source code was copied from @okta/courage
//  (src/courage/util/StringUtil.js)
//  and should be kept in sync with @okta/courage

const bundleNames = ['login', 'country', 'courage'];
/**
 * Translate a key to the localized value
 * @param  {String} key The key
 * @param  {String} [bundle="login"] The name of the i18n bundle. Defaults to "login".
 * @param  {Array} [params] A list of parameters to apply as tokens to the i18n value
 * @param  {Boolean} [ignoreIncorrectParams] If true, a custom 'okta-i18n-error' event would not be dispatched
 * @return {String} The localized value
 */
const loc = function (key, bundleName = 'login', params = [], ignoreIncorrectParams = false) {
  const bundle = getBundle(bundleName);
  /* eslint complexity: [2, 7] */

  if (!bundle) {
    emitL10nError(key, bundleName, 'bundle');
    return 'L10N_ERROR[' + bundleName + ']';
  }
  let value = bundle[key];
  try {
    params = params && params.slice ? params.slice(0) : [];
    value = sprintf(value, params);
    if (value) {
      return value;
    } else {
      emitL10nError(key, bundleName, 'key');
      return 'L10N_ERROR[' + key + ']';
    }
  } catch (e) {
    if (!ignoreIncorrectParams) {
      emitL10nError(key, bundleName, 'parameters');
    }
    return 'L10N_ERROR[' + key + ']';
  }
};

/**
* Converts the locale code identifier from "${languageCode}-${countryCode}" to "${languageCode}_${countryCode}"
* Follows the ISO-639-1 language code and 2-letter ISO-3166-1-alpha-2 country code structure.
* @param {String} locale code identifier
* @return {String} converted locale code identifier
*/
exports.loc = loc;
const parseLocale = locale => {
  if (/-/.test(locale)) {
    const parts = locale.split('-');
    parts[1] = parts[1].toUpperCase();
    return parts.join('_');
  }
  return locale;
};

/**
 * Returns the language bundle based on the current locale.
 * - If a locale is not provided, default to English ('en')
 * - Legacy Support: If the named language bundle does not exist, fall back to the default named bundle.
 *
 * @param {*} bundleName
 */
function getBundle(bundleName) {
  if (!bundleName) {
    const key = Object.keys(_oktaI18nBundles.default).filter(k => typeof k === 'object')[0];
    return _oktaI18nBundles.default[key];
  }
  const locale = parseLocale(getRawLocale());
  return _oktaI18nBundles.default[`${bundleName}_${locale}`] || _oktaI18nBundles.default[bundleName];
}

/**
 * Returns the user's locale as defined by window.okta.locale
 */
function getRawLocale() {
  var _window, _window$okta;
  return ((_window = window) === null || _window === void 0 ? void 0 : (_window$okta = _window.okta) === null || _window$okta === void 0 ? void 0 : _window$okta.locale) || 'en';
}

/**
 * Dispatch custom 'okta-i18n-error' event
 * @param {String} key The i18n key
 * @param {String} bundleName The i18n bundle name
 * @param {String} reason Could be 'bundle' (Bundle not found), 'key' (Key not found) or 'parameters' (Parameters mismatch).
 */
function emitL10nError(key, bundleName, reason) {
  const event = createCustomEvent('okta-i18n-error', {
    detail: {
      type: 'l10n-error',
      key: key,
      bundleName: bundleName,
      reason: reason
    }
  });
  if (event) {
    document.dispatchEvent(event);
  }
}
const createCustomEvent = function (event, params) {
  if (typeof window.CustomEvent === 'function') {
    return new CustomEvent(event, params);
  } else if (!window.CustomEvent) {
    /**
     * CustomEvent polyfill for IE
     * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#polyfill
     */
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: null
    };
    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }
};

/**
 * Format tempalte string with parameters
 * @param {String} value Template string, eg. "Reset via {0}"
 * @param  {Array} [params] A list of parameters to apply as tokens to the template string, eg. ["SMS"]
 * @return {String} Formatted string value, eg. "Reset via SMS"
 */
function sprintf(value, params) {
  /* eslint max-statements: [2, 15] */

  function triggerError() {
    throw new Error('Mismatch number of variables: ' + value + ', ' + JSON.stringify(params));
  }
  let oldValue = value,
    newValue = value;
  for (let i = 0, l = params.length; i < l; i++) {
    const entity = String(params[i]);
    const regex = new RegExp('\\{' + i + '\\}', 'g');
    newValue = newValue.replace(regex, entity);
    if (entity === undefined || entity === null || newValue === oldValue) {
      triggerError();
    }
    oldValue = newValue;
  }
  if (/\{[\d+]\}/.test(newValue)) {
    triggerError();
  }
  return newValue;
}

/***/ }),

/***/ "./src/v1/LoginRouter.ts":
/*!*******************************!*\
  !*** ./src/v1/LoginRouter.ts ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _AccountUnlockedController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/AccountUnlockedController */ "./src/v1/controllers/AccountUnlockedController.js"));
var _ActivateTotpController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/ActivateTotpController */ "./src/v1/controllers/ActivateTotpController.js"));
var _AdminConsentRequiredController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/AdminConsentRequiredController */ "./src/v1/controllers/AdminConsentRequiredController.js"));
var _BarcodePushController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/BarcodePushController */ "./src/v1/controllers/BarcodePushController.js"));
var _BarcodeTotpController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/BarcodeTotpController */ "./src/v1/controllers/BarcodeTotpController.js"));
var _ConsentRequiredController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/ConsentRequiredController */ "./src/v1/controllers/ConsentRequiredController.js"));
var _CustomPasswordExpiredController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/CustomPasswordExpiredController */ "./src/v1/controllers/CustomPasswordExpiredController.js"));
var _DeviceActivateController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/DeviceActivateController */ "./src/v1/controllers/DeviceActivateController.js"));
var _DeviceActivateTerminalController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/DeviceActivateTerminalController */ "./src/v1/controllers/DeviceActivateTerminalController.js"));
var _EnrollActivateCustomFactorController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollActivateCustomFactorController */ "./src/v1/controllers/EnrollActivateCustomFactorController.js"));
var _EnrollActivateEmailController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollActivateEmailController */ "./src/v1/controllers/EnrollActivateEmailController.js"));
var _EnrollCallAndSmsController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollCallAndSmsController */ "./src/v1/controllers/EnrollCallAndSmsController.js"));
var _EnrollChoicesController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollChoicesController */ "./src/v1/controllers/EnrollChoicesController.js"));
var _EnrollCustomFactorController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollCustomFactorController */ "./src/v1/controllers/EnrollCustomFactorController.js"));
var _EnrollDuoController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollDuoController */ "./src/v1/controllers/EnrollDuoController.js"));
var _EnrollEmailController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollEmailController */ "./src/v1/controllers/EnrollEmailController.js"));
var _EnrollHotpController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollHotpController */ "./src/v1/controllers/EnrollHotpController.js"));
var _EnrollOnPremController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollOnPremController */ "./src/v1/controllers/EnrollOnPremController.js"));
var _EnrollPasswordController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollPasswordController */ "./src/v1/controllers/EnrollPasswordController.js"));
var _EnrollQuestionController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollQuestionController */ "./src/v1/controllers/EnrollQuestionController.js"));
var _EnrollSymantecVipController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollSymantecVipController */ "./src/v1/controllers/EnrollSymantecVipController.js"));
var _EnrollTotpController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollTotpController */ "./src/v1/controllers/EnrollTotpController.js"));
var _EnrollU2FController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollU2FController */ "./src/v1/controllers/EnrollU2FController.js"));
var _EnrollUserController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollUserController */ "./src/v1/controllers/EnrollUserController.js"));
var _EnrollWebauthnController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollWebauthnController */ "./src/v1/controllers/EnrollWebauthnController.js"));
var _EnrollWindowsHelloController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollWindowsHelloController */ "./src/v1/controllers/EnrollWindowsHelloController.js"));
var _EnrollYubikeyController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollYubikeyController */ "./src/v1/controllers/EnrollYubikeyController.js"));
var _EnrollmentLinkSentController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnrollmentLinkSentController */ "./src/v1/controllers/EnrollmentLinkSentController.js"));
var _EnterPasscodePushFlowController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/EnterPasscodePushFlowController */ "./src/v1/controllers/EnterPasscodePushFlowController.js"));
var _ForgotPasswordController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/ForgotPasswordController */ "./src/v1/controllers/ForgotPasswordController.js"));
var _IDPDiscoveryController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/IDPDiscoveryController */ "./src/v1/controllers/IDPDiscoveryController.js"));
var _ForceIDPDiscoveryController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/ForceIDPDiscoveryController */ "./src/v1/controllers/ForceIDPDiscoveryController.js"));
var _ManualSetupPushController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/ManualSetupPushController */ "./src/v1/controllers/ManualSetupPushController.js"));
var _ManualSetupTotpController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/ManualSetupTotpController */ "./src/v1/controllers/ManualSetupTotpController.js"));
var _MfaVerifyController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/MfaVerifyController */ "./src/v1/controllers/MfaVerifyController.js"));
var _PasswordExpiredController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/PasswordExpiredController */ "./src/v1/controllers/PasswordExpiredController.js"));
var _PasswordResetController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/PasswordResetController */ "./src/v1/controllers/PasswordResetController.js"));
var _PollController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/PollController */ "./src/v1/controllers/PollController.js"));
var _PrimaryAuthController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/PrimaryAuthController */ "./src/v1/controllers/PrimaryAuthController.js"));
var _PwdResetEmailSentController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/PwdResetEmailSentController */ "./src/v1/controllers/PwdResetEmailSentController.js"));
var _RecoveryChallengeController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/RecoveryChallengeController */ "./src/v1/controllers/RecoveryChallengeController.js"));
var _RecoveryLoadingController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/RecoveryLoadingController */ "./src/v1/controllers/RecoveryLoadingController.js"));
var _RecoveryQuestionController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/RecoveryQuestionController */ "./src/v1/controllers/RecoveryQuestionController.js"));
var _RefreshAuthStateController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/RefreshAuthStateController */ "./src/v1/controllers/RefreshAuthStateController.js"));
var _RegistrationCompleteController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/RegistrationCompleteController */ "./src/v1/controllers/RegistrationCompleteController.js"));
var _RegistrationController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/RegistrationController */ "./src/v1/controllers/RegistrationController.js"));
var _UnlockAccountController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/UnlockAccountController */ "./src/v1/controllers/UnlockAccountController.js"));
var _UnlockEmailSentController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/UnlockEmailSentController */ "./src/v1/controllers/UnlockEmailSentController.js"));
var _VerifyCustomFactorController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/VerifyCustomFactorController */ "./src/v1/controllers/VerifyCustomFactorController.js"));
var _VerifyDuoController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/VerifyDuoController */ "./src/v1/controllers/VerifyDuoController.js"));
var _VerifyPIVController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/VerifyPIVController */ "./src/v1/controllers/VerifyPIVController.js"));
var _VerifyU2FController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/VerifyU2FController */ "./src/v1/controllers/VerifyU2FController.js"));
var _VerifyWebauthnController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/VerifyWebauthnController */ "./src/v1/controllers/VerifyWebauthnController.js"));
var _VerifyWindowsHelloController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/VerifyWindowsHelloController */ "./src/v1/controllers/VerifyWindowsHelloController.js"));
var _ErrorStateController = _interopRequireDefault(__webpack_require__(/*! v1/controllers/ErrorStateController */ "./src/v1/controllers/ErrorStateController.js"));
var _BaseLoginRouter = _interopRequireDefault(__webpack_require__(/*! v1/BaseLoginRouter */ "./src/v1/BaseLoginRouter.js"));
var _FactorBeacon = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/FactorBeacon */ "./src/v1/views/shared/FactorBeacon.js"));
var _PIVBeacon = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/PIVBeacon */ "./src/v1/views/shared/PIVBeacon.js"));
var _SecurityBeacon = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/SecurityBeacon */ "./src/v1/views/shared/SecurityBeacon.js"));
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
/* eslint max-params: 0 */
var _default = _BaseLoginRouter.default.extend({
  routes: {
    '': 'defaultAuth',
    signin: 'primaryAuth',
    'signin/okta/:username': 'primaryAuth',
    'signin/verify/duo/web': 'verifyDuo',
    'signin/verify/piv': 'verifyPIV',
    'signin/poll': 'poll',
    'signin/verify/fido/webauthn': 'verifyWebauthn',
    'signin/verify/webauthn': 'verifyWebauthn',
    'signin/verify/fido/u2f': 'verifyU2F',
    'signin/verify/u2f': 'verifyU2F',
    'signin/verify/generic_saml/assertion:saml2': 'verifySAMLFactor',
    'signin/verify/generic_oidc/assertion:oidc': 'verifyOIDCFactor',
    'signin/verify/custom/claims_provider': 'verifyClaimsFactor',
    'signin/verify/:factorType': 'verifyNoProvider',
    'signin/verify/:provider/:factorType(/:factorIndex)': 'verify',
    'signin/enroll': 'enrollChoices',
    'signin/enroll/duo/web': 'enrollDuo',
    'signin/enroll/okta/question': 'enrollQuestion',
    'signin/enroll/okta/password': 'enrollPassword',
    'signin/enroll/okta/sms': 'enrollSms',
    'signin/enroll/okta/call': 'enrollCall',
    'signin/enroll/okta/email': 'enrollEmail',
    'signin/enroll-activate/okta/sms': 'enrollSms',
    'signin/enroll-activate/okta/call': 'enrollCall',
    'signin/enroll/rsa/token': 'enrollRsa',
    'signin/enroll/del_oath/token': 'enrollOnPrem',
    'signin/enroll/symantec/token': 'enrollSymantecVip',
    'signin/enroll/yubico/token:hardware': 'enrollYubikey',
    'signin/enroll/fido/webauthn': 'enrollWebauthn',
    'signin/enroll/fido/u2f': 'enrollU2F',
    'signin/enroll/generic_saml/assertion:saml2': 'enrollSAMLFactor',
    'signin/enroll/generic_oidc/assertion:oidc': 'enrollOIDCFactor',
    'signin/enroll/custom/claims_provider': 'enrollClaimsFactor',
    'signin/enroll/custom/token:hotp': 'enrollHotpFactor',
    'signin/enroll/:provider/:factorType': 'enrollTotpFactor',
    'signin/enroll-activate/okta/email': 'enrollActivateEmail',
    'signin/enroll-activate/okta/push': 'scanBarcodePushFactor',
    'signin/enroll-activate/okta/push/manual': 'manualSetupPushFactor',
    'signin/enroll-activate/okta/push/sent': 'activationLinkSent',
    'signin/enroll-activate/okta/token:software:totp/passcode': 'enterPasscodeInPushEnrollmentFlow',
    'signin/enroll-activate/custom/claims_provider': 'enrollActivateClaimsFactor',
    'signin/enroll-activate/:provider/:factorType': 'scanBarcodeTotpFactor',
    'signin/enroll-activate/:provider/:factorType/activate': 'activateTotpFactor',
    'signin/enroll-activate/:provider/:factorType/manual': 'manualSetupTotpFactor',
    'signin/password-expired': 'passwordExpired',
    'signin/custom-password-expired': 'customPasswordExpired',
    'signin/forgot-password': 'forgotPassword',
    'signin/recovery-challenge': 'recoveryChallenge',
    'signin/recovery-emailed': 'recoveryEmailSent',
    'signin/recovery-question': 'recoveryQuestion',
    'signin/password-reset': 'passwordReset',
    'signin/reset-password/:token': 'recoveryLoading',
    'signin/user-unlock/:token': 'recoveryLoading',
    'signin/recovery/:token': 'recoveryLoading',
    'signin/unlock-emailed': 'unlockEmailSent',
    'signin/unlock': 'unlockAccount',
    'signin/account-unlocked': 'accountUnlocked',
    'signin/refresh-auth-state(/:token)': 'refreshAuthState',
    'signin/register': 'register',
    'signin/register-complete': 'registerComplete',
    'signin/error': 'errorState',
    'signin/consent': 'consentRequired',
    'signin/admin-consent': 'adminConsentRequired',
    'signin/enroll-user': 'enrollUser',
    'signin/device-activate-complete': 'deviceActivateComplete',
    'signin/device-activate': 'deviceActivate',
    'signin/idp-discovery-check': 'idpDiscoveryCheck',
    '*wildcard': 'defaultAuth'
  },
  // Route handlers that do not require a stateToken. If the page is refreshed,
  // these functions will not require a status call to refresh the stateToken.
  stateLessRouteHandlers: ['defaultAuth', 'idpDiscovery', 'primaryAuth', 'forgotPassword', 'recoveryLoading', 'unlockAccount', 'refreshAuthState', 'register', 'registerComplete', 'errorState', 'verifyPIV'],
  defaultAuth: function () {
    if (window.location.hash === `#${_Enums.default.WIDGET_CONTAINER_ID}`) {
      document.getElementById(_Enums.default.WIDGET_CONTAINER_ID).focus();
      return;
    }
    if (this.settings.get('features.idpDiscovery')) {
      this.idpDiscovery();
    } else {
      this.primaryAuth();
    }
  },
  idpDiscoveryCheck: function () {
    this.render(_ForceIDPDiscoveryController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  idpDiscovery: function () {
    this.render(_IDPDiscoveryController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  primaryAuth: function (username) {
    this.render(_PrimaryAuthController.default, {
      Beacon: _SecurityBeacon.default,
      username
    });
  },
  verifyDuo: function () {
    this.render(_VerifyDuoController.default, {
      provider: 'DUO',
      factorType: 'web',
      Beacon: _FactorBeacon.default
    });
  },
  verifyPIV: function () {
    this.render(_VerifyPIVController.default, {
      Beacon: _PIVBeacon.default
    });
  },
  poll: function () {
    this.render(_PollController.default);
  },
  verifyWebauthn: function () {
    if (this.settings.get('features.webauthn')) {
      this.render(_VerifyWebauthnController.default, {
        provider: 'FIDO',
        factorType: 'webauthn',
        Beacon: _FactorBeacon.default
      });
    } else {
      this.render(_VerifyWindowsHelloController.default, {
        provider: 'FIDO',
        factorType: 'webauthn',
        Beacon: _FactorBeacon.default
      });
    }
  },
  verifyU2F: function () {
    this.render(_VerifyU2FController.default, {
      provider: 'FIDO',
      factorType: 'u2f',
      Beacon: _FactorBeacon.default
    });
  },
  verifySAMLFactor: function () {
    this.render(_VerifyCustomFactorController.default, {
      provider: 'GENERIC_SAML',
      factorType: 'assertion:saml2',
      Beacon: _FactorBeacon.default
    });
  },
  verifyOIDCFactor: function () {
    this.render(_VerifyCustomFactorController.default, {
      provider: 'GENERIC_OIDC',
      factorType: 'assertion:oidc',
      Beacon: _FactorBeacon.default
    });
  },
  verifyClaimsFactor: function () {
    this.render(_VerifyCustomFactorController.default, {
      provider: 'CUSTOM',
      factorType: 'claims_provider',
      Beacon: _FactorBeacon.default
    });
  },
  verify: function (provider, factorType, factorIndex) {
    this.render(_MfaVerifyController.default, {
      provider: provider.toUpperCase(),
      factorType: factorType,
      factorIndex: factorIndex,
      Beacon: _FactorBeacon.default
    });
  },
  verifyNoProvider: function (factorType) {
    this.render(_MfaVerifyController.default, {
      factorType: factorType,
      Beacon: _FactorBeacon.default
    });
  },
  enrollChoices: function () {
    this.render(_EnrollChoicesController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  enrollDuo: function () {
    this.render(_EnrollDuoController.default, {
      provider: 'DUO',
      factorType: 'web',
      Beacon: _FactorBeacon.default
    });
  },
  enrollQuestion: function () {
    this.render(_EnrollQuestionController.default, {
      provider: 'OKTA',
      factorType: 'question',
      Beacon: _FactorBeacon.default
    });
  },
  enrollPassword: function () {
    this.render(_EnrollPasswordController.default, {
      provider: 'OKTA',
      factorType: 'password',
      Beacon: _FactorBeacon.default
    });
  },
  enrollSms: function () {
    this.render(_EnrollCallAndSmsController.default, {
      provider: 'OKTA',
      factorType: 'sms',
      Beacon: _FactorBeacon.default
    });
  },
  enrollCall: function () {
    this.render(_EnrollCallAndSmsController.default, {
      provider: 'OKTA',
      factorType: 'call',
      Beacon: _FactorBeacon.default
    });
  },
  enrollEmail: function () {
    this.render(_EnrollEmailController.default, {
      provider: 'OKTA',
      factorType: 'email',
      Beacon: _FactorBeacon.default
    });
  },
  enrollActivateEmail: function () {
    this.render(_EnrollActivateEmailController.default, {
      provider: 'OKTA',
      factorType: 'email',
      Beacon: _FactorBeacon.default
    });
  },
  enrollRsa: function () {
    this.render(_EnrollOnPremController.default, {
      provider: 'RSA',
      factorType: 'token',
      Beacon: _FactorBeacon.default
    });
  },
  enrollOnPrem: function () {
    this.render(_EnrollOnPremController.default, {
      provider: 'DEL_OATH',
      factorType: 'token',
      Beacon: _FactorBeacon.default
    });
  },
  enrollSymantecVip: function () {
    this.render(_EnrollSymantecVipController.default, {
      provider: 'SYMANTEC',
      factorType: 'token',
      Beacon: _FactorBeacon.default
    });
  },
  enrollYubikey: function () {
    this.render(_EnrollYubikeyController.default, {
      provider: 'YUBICO',
      factorType: 'token:hardware',
      Beacon: _FactorBeacon.default
    });
  },
  enrollSAMLFactor: function () {
    this.render(_EnrollCustomFactorController.default, {
      provider: 'GENERIC_SAML',
      factorType: 'assertion:saml2',
      Beacon: _FactorBeacon.default
    });
  },
  enrollOIDCFactor: function () {
    this.render(_EnrollCustomFactorController.default, {
      provider: 'GENERIC_OIDC',
      factorType: 'assertion:oidc',
      Beacon: _FactorBeacon.default
    });
  },
  enrollClaimsFactor: function () {
    this.render(_EnrollCustomFactorController.default, {
      provider: 'CUSTOM',
      factorType: 'claims_provider',
      Beacon: _FactorBeacon.default
    });
  },
  enrollActivateClaimsFactor: function () {
    this.render(_EnrollActivateCustomFactorController.default, {
      provider: 'CUSTOM',
      factorType: 'claims_provider',
      Beacon: _FactorBeacon.default
    });
  },
  enrollTotpFactor: function (provider, factorType) {
    this.render(_EnrollTotpController.default, {
      provider: provider.toUpperCase(),
      factorType: factorType,
      Beacon: _FactorBeacon.default
    });
  },
  enrollHotpFactor: function () {
    this.render(_EnrollHotpController.default, {
      provider: 'CUSTOM',
      factorType: 'token:hotp',
      Beacon: _FactorBeacon.default
    });
  },
  enrollWebauthn: function () {
    if (this.settings.get('features.webauthn')) {
      this.render(_EnrollWebauthnController.default, {
        provider: 'FIDO',
        factorType: 'webauthn',
        Beacon: _FactorBeacon.default
      });
    } else {
      this.render(_EnrollWindowsHelloController.default, {
        provider: 'FIDO',
        factorType: 'webauthn',
        Beacon: _FactorBeacon.default
      });
    }
  },
  enrollU2F: function () {
    this.render(_EnrollU2FController.default, {
      provider: 'FIDO',
      factorType: 'u2f',
      Beacon: _FactorBeacon.default
    });
  },
  scanBarcodeTotpFactor: function (provider, factorType) {
    this.render(_BarcodeTotpController.default, {
      provider: provider.toUpperCase(),
      factorType: factorType,
      Beacon: _FactorBeacon.default
    });
  },
  scanBarcodePushFactor: function () {
    this.render(_BarcodePushController.default, {
      provider: 'OKTA',
      factorType: 'push',
      Beacon: _FactorBeacon.default
    });
  },
  activateTotpFactor: function (provider, factorType) {
    this.render(_ActivateTotpController.default, {
      provider: provider.toUpperCase(),
      factorType: factorType,
      Beacon: _FactorBeacon.default
    });
  },
  manualSetupTotpFactor: function (provider, factorType) {
    this.render(_ManualSetupTotpController.default, {
      provider: provider.toUpperCase(),
      factorType: factorType,
      Beacon: _FactorBeacon.default
    });
  },
  manualSetupPushFactor: function () {
    this.render(_ManualSetupPushController.default, {
      provider: 'OKTA',
      factorType: 'push',
      Beacon: _FactorBeacon.default
    });
  },
  activationLinkSent: function () {
    this.render(_EnrollmentLinkSentController.default, {
      provider: 'OKTA',
      factorType: 'push',
      Beacon: _FactorBeacon.default
    });
  },
  enterPasscodeInPushEnrollmentFlow: function () {
    this.render(_EnterPasscodePushFlowController.default, {
      provider: 'OKTA',
      factorType: 'token:software:totp',
      Beacon: _FactorBeacon.default
    });
  },
  passwordExpired: function () {
    this.render(_PasswordExpiredController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  customPasswordExpired: function () {
    this.render(_CustomPasswordExpiredController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  forgotPassword: function () {
    this.render(_ForgotPasswordController.default);
  },
  recoveryChallenge: function () {
    this.render(_RecoveryChallengeController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  recoveryEmailSent: function () {
    this.render(_PwdResetEmailSentController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  unlockEmailSent: function () {
    this.render(_UnlockEmailSentController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  recoveryQuestion: function () {
    this.render(_RecoveryQuestionController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  passwordReset: function () {
    this.render(_PasswordResetController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  recoveryLoading: function (token) {
    this.render(_RecoveryLoadingController.default, {
      token: token,
      Beacon: _SecurityBeacon.default
    });
  },
  unlockAccount: function () {
    this.render(_UnlockAccountController.default);
  },
  accountUnlocked: function () {
    this.render(_AccountUnlockedController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  refreshAuthState: function (token) {
    this.render(_RefreshAuthStateController.default, {
      token: token,
      Beacon: _SecurityBeacon.default
    });
  },
  register: function () {
    this.render(_RegistrationController.default);
  },
  registerComplete: function () {
    this.render(_RegistrationCompleteController.default);
  },
  errorState: function () {
    this.render(_ErrorStateController.default, {
      Beacon: _SecurityBeacon.default
    });
  },
  consentRequired: function () {
    this.render(_ConsentRequiredController.default);
  },
  adminConsentRequired: function () {
    this.render(_AdminConsentRequiredController.default);
  },
  enrollUser: function () {
    this.render(_EnrollUserController.default);
  },
  deviceActivate: function () {
    this.render(_DeviceActivateController.default);
  },
  deviceActivateComplete: function () {
    this.render(_DeviceActivateTerminalController.default);
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v1/views/shared/Header.ts":
/*!***************************************!*\
  !*** ./src/v1/views/shared/Header.ts ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Animations = _interopRequireDefault(__webpack_require__(/*! util/Animations */ "./src/util/Animations.js"));
var _LoadingBeacon = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/LoadingBeacon */ "./src/v1/views/shared/LoadingBeacon.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const NO_BEACON_CLS = 'no-beacon';
const LOADING_BEACON_CLS = 'beacon-small beacon-loading';
function isLoadingBeacon(beacon) {
  return beacon && beacon.equals(_LoadingBeacon.default);
}
function removeBeacon(view) {
  // There are some timing issues with removing beacons (i.e. the case of
  // transitioning from loadingBeacon -> loadingBeacon)
  if (!view.currentBeacon) {
    return;
  }
  view.currentBeacon.remove();
  view.currentBeacon = null;
}
function addBeacon(view, NextBeacon, selector, options) {
  view.add(NextBeacon, {
    selector: selector,
    options: options
  });
  view.currentBeacon = view.first();
}
function typeOfTransition(currentBeacon, NextBeacon, options) {
  if (!currentBeacon && !NextBeacon) {
    return 'none';
  }
  // Show Loading beacon
  if (!currentBeacon && options.loading) {
    return 'load';
  }
  // Swap/Hide Loading beacon
  if (currentBeacon && isLoadingBeacon(currentBeacon)) {
    return NextBeacon ? 'swap' : 'unload';
  }
  if (currentBeacon && currentBeacon.equals(NextBeacon, options)) {
    return 'same';
  }
  if (!currentBeacon && NextBeacon) {
    return 'add';
  }
  if (currentBeacon && !NextBeacon) {
    return 'remove';
  }
  if (currentBeacon instanceof NextBeacon) {
    return 'fade';
  }
  // If none of the above
  // then we are changing the type of beacon
  // ex. from SecurityBeacon to FactorBeacon
  return 'swap';
}
class Header extends _courage.View {
  constructor(...args) {
    super(...args);
    this.currentBeacon = void 0;
  }
  preinitialize(...args) {
    this.currentBeacon = null;
    /* eslint-disable @okta/okta/no-unlocalized-text-in-templates */
    this.template = _runtime.default.template({
      "1": function (container, depth0, helpers, partials, data) {
        var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }
            return undefined;
          };
        return "<h1><img src=\"" + alias4((helper = (helper = lookupProperty(helpers, "logo") || (depth0 != null ? lookupProperty(depth0, "logo") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
          "name": "logo",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 71
            },
            "end": {
              "line": 1,
              "column": 79
            }
          }
        }) : helper)) + "\" class=\"auth-org-logo\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "logoText") || (depth0 != null ? lookupProperty(depth0, "logoText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
          "name": "logoText",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 108
            },
            "end": {
              "line": 1,
              "column": 120
            }
          }
        }) : helper)) + " logo\" aria-label=\"" + alias4((helper = (helper = lookupProperty(helpers, "logoText") || (depth0 != null ? lookupProperty(depth0, "logoText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
          "name": "logoText",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 139
            },
            "end": {
              "line": 1,
              "column": 151
            }
          }
        }) : helper)) + " logo\"></h1>";
      },
      "compiler": [8, ">= 4.3.0"],
      "main": function (container, depth0, helpers, partials, data) {
        var stack1,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }
            return undefined;
          };
        return "<div class=\"okta-sign-in-header auth-header\">" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "logo") : depth0, {
          "name": "if",
          "hash": {},
          "fn": container.program(1, data, 0),
          "inverse": container.noop,
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 45
            },
            "end": {
              "line": 1,
              "column": 170
            }
          }
        })) != null ? stack1 : "") + "<div data-type=\"beacon-container\" class=\"beacon-container\"></div></div><div class=\"auth-content\"><div class=\"auth-content-inner\"></div></div>";
      },
      "useData": true
    });
    /* eslint-enable @okta/okta/no-unlocalized-text-in-templates */
    _courage.View.prototype.preinitialize.apply(this, args);
  }

  // Attach a 'no-beacon' class if the security image feature
  // is not passed in to prevent the beacon from jumping.
  initialize(options) {
    if (!options.settings.get('features.securityImage')) {
      this.$el.addClass(NO_BEACON_CLS);
      // To show/hide the spinner when there is no security image,
      // listen to the appState's loading/removeLoading events.
      this.listenTo(options.appState, 'loading', this.setLoadingBeacon);
      this.listenTo(options.appState, 'removeLoading', this.removeLoadingBeacon);
    }
  }

  /* eslint complexity: 0 */
  setBeacon(NextBeacon, options) {
    const selector = '[data-type="beacon-container"]';
    const container = this.$(selector);
    const transition = typeOfTransition(this.currentBeacon, NextBeacon, options);
    switch (transition) {
      case 'none':
        this.$el.addClass(NO_BEACON_CLS);
        return;
      case 'same':
        return;
      case 'add':
        this.$el.removeClass(NO_BEACON_CLS);
        addBeacon(this, NextBeacon, selector, options);
        return _Animations.default.explode(container);
      case 'remove':
        this.$el.addClass(NO_BEACON_CLS);
        return _Animations.default.implode(container).then(() => {
          removeBeacon(this);
        }).done();
      // TODO: can this be removed if Animations.implode returns standard ES6 Promise?
      case 'fade':
        // Other transitions are performed on the beacon container,
        // but this transition is on the content inside the beacon.
        // For a SecurityBeacon the username change will update the
        // AppState and trigger an transition to a new Becon
        // Since there is no url change this method is not called.
        // For a FactorBeacon a page refresh has occurred
        // so we execute the beacon's own transition method.
        if (!this.currentBeacon.fadeOut) {
          throw new Error('The current beacon is missing the "fadeOut" method');
        }
        options.animate = true;
        return this.currentBeacon.fadeOut().then(() => {
          removeBeacon(this);
          addBeacon(this, NextBeacon, selector, options);
        }).done();
      // TODO: can this be removed if fadeOut returns standard ES6 Promise?
      case 'swap':
        return _Animations.default.swapBeacons({
          $el: container,
          swap: () => {
            const isLoading = isLoadingBeacon(this.currentBeacon);

            // Order of these calls is important for -
            // loader --> security/factor beacon swap.
            removeBeacon(this);
            if (isLoading) {
              container.removeClass(LOADING_BEACON_CLS);
              this.$el.removeClass(NO_BEACON_CLS);
            }
            addBeacon(this, NextBeacon, selector, options);
          }
        }).done();
      // TODO: can this be removed if Animations.swapBeacons returns standard ES6 Promise?
      case 'load':
        // Show the loading beacon. Add a couple of classes
        // before triggering the add beacon code.
        container.addClass(LOADING_BEACON_CLS);
        addBeacon(this, NextBeacon, selector, options);
        return _Animations.default.explode(container);
      case 'unload':
        // Hide the loading beacon.
        return this.removeLoadingBeacon();
      default:
        throw new Error('the "' + transition + '" is not recognized');
    }
  }

  // Show the loading beacon when the security image feature is not enabled.
  setLoadingBeacon(isLoading) {
    if (!isLoading || isLoadingBeacon(this.currentBeacon)) {
      return;
    }
    this.setBeacon(_LoadingBeacon.default, {
      loading: true
    });
  }

  // Hide the beacon on primary auth failure. On primary auth success, setBeacon does this job.
  removeLoadingBeacon() {
    const container = this.$('[data-type="beacon-container"]');
    return _Animations.default.implode(container).then(() => {
      removeBeacon(this);
      container.removeClass(LOADING_BEACON_CLS);
    }).done(); // TODO: can this be removed if Animations.implode returns standard ES6 Promise?
  }

  getTemplateData() {
    return this.settings.toJSON({
      verbose: true
    });
  }
  getContentEl() {
    return this.$('.auth-content-inner');
  }
}
exports["default"] = Header;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/BaseLoginRouter.ts":
/*!***********************************!*\
  !*** ./src/v2/BaseLoginRouter.ts ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Settings = _interopRequireDefault(__webpack_require__(/*! models/Settings */ "./src/models/Settings.ts"));
var _Bundles = _interopRequireDefault(__webpack_require__(/*! util/Bundles */ "./src/util/Bundles.ts"));
var _BrowserFeatures = _interopRequireDefault(__webpack_require__(/*! util/BrowserFeatures */ "./src/util/BrowserFeatures.ts"));
var _ColorsUtil = _interopRequireDefault(__webpack_require__(/*! util/ColorsUtil */ "./src/util/ColorsUtil.js"));
var _Enums = _interopRequireDefault(__webpack_require__(/*! util/Enums */ "./src/util/Enums.js"));
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _Logger = _interopRequireDefault(__webpack_require__(/*! util/Logger */ "./src/util/Logger.js"));
var _LanguageUtil = _interopRequireDefault(__webpack_require__(/*! util/LanguageUtil */ "./src/util/LanguageUtil.js"));
var _AuthContainer = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/AuthContainer */ "./src/v1/views/shared/AuthContainer.js"));
var _Header = _interopRequireDefault(__webpack_require__(/*! v1/views/shared/Header */ "./src/v1/views/shared/Header.ts"));
var _AppState = _interopRequireDefault(__webpack_require__(/*! ./models/AppState */ "./src/v2/models/AppState.ts"));
var _sessionStorageHelper = _interopRequireDefault(__webpack_require__(/*! ./client/sessionStorageHelper */ "./src/v2/client/sessionStorageHelper.js"));
var _client = __webpack_require__(/*! ./client */ "./src/v2/client/index.js");
var _CookieUtil = _interopRequireDefault(__webpack_require__(/*! util/CookieUtil */ "./src/util/CookieUtil.js"));
var _formatError = __webpack_require__(/*! ./client/formatError */ "./src/v2/client/formatError.ts");
var _IonResponseHelper = _interopRequireDefault(__webpack_require__(/*! ./ion/IonResponseHelper */ "./src/v2/ion/IonResponseHelper.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint max-depth: [1,4] */
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

// BaseLoginRouter contains the more complicated router logic - rendering/
// transition, etc. Most router changes should happen in LoginRouter (which is
// responsible for adding new routes)

class BaseLoginRouter extends _courage.Router {
  // also set on prototype

  constructor(options) {
    super(options);

    // Create a default success and/or error handler if
    // one is not provided.
    this.Events = _courage.Backbone.Events;
    this.hasControllerRendered = false;
    this.settings = void 0;
    this.appState = void 0;
    this.hooks = void 0;
    this.header = void 0;
    if (!options.globalSuccessFn) {
      options.globalSuccessFn = function () {/* dummy function */};
    }
    if (!options.globalErrorFn) {
      options.globalErrorFn = function (err) {
        _Logger.default.error(err);
      };
    }
    this.settings = new _Settings.default(_courage._.omit(options, 'el', 'hooks'), {
      parse: true
    });
    if (!options.el) {
      this.settings.callGlobalError(new _Errors.ConfigError((0, _courage.loc)('error.required.el')));
    }
    (0, _courage.$)('body > div').on('click', function () {
      // OKTA-69769 Tooltip wont close on iPhone/iPad
      // Registering a click handler on the first div
      // allows a tap that falls outside the tooltip
      // to be registered as a tap by iOS
      // and then the open tooltip will lose focus and close.
    });
    this.hooks = options.hooks;
    this.appState = new _AppState.default({}, {
      settings: this.settings,
      hooks: this.hooks
    });
    const wrapper = new _AuthContainer.default({
      appState: this.appState
    });
    (0, _courage.$)(options.el).append(wrapper.render().$el);
    this.el = `#${_Enums.default.WIDGET_CONTAINER_ID}`;
    this.header = new _Header.default({
      el: this.el,
      appState: this.appState,
      settings: this.settings
    });

    // Hide until unitial render
    this.hide();
    this.listenTo(this.appState, 'change:deviceFingerprint', this.updateDeviceFingerprint);
    this.listenTo(this.appState, 'restartLoginFlow', this.restartLoginFlow);
  }
  updateDeviceFingerprint() {
    const authClient = this.settings.getAuthClient();
    const fingerprint = this.appState.get('deviceFingerprint');
    if (fingerprint) {
      authClient.http.setRequestHeader('X-Device-Fingerprint', fingerprint);
    }
  }
  async handleIdxResponseFailure(error = {
    error: 'unknown',
    details: undefined
  }) {
    // IDX errors will not call the global error handler
    error = (0, _formatError.formatError)(error);
    await (0, _client.updateAppState)(this.appState, error.details);
  }

  // Generic error handler for all exceptions
  async handleError(error = {
    error: 'unknown',
    details: undefined
  }) {
    const formattedError = (0, _formatError.formatError)({
      ...error
    }); // format the error to resemble an IDX response
    await (0, _client.updateAppState)(this.appState, formattedError.details);
  }

  /* eslint max-statements: [2, 36], complexity: [2, 16] */
  async render(Controller, options = {}) {
    // If url changes then widget assumes that user's intention was to initiate a new login flow,
    // so clear stored token to use the latest token.
    if (_sessionStorageHelper.default.getLastInitiatedLoginUrl() !== window.location.href) {
      _sessionStorageHelper.default.removeStateHandle();
    }
    // Since we have a wrapper view, render our wrapper and use its content
    // element as our new el.
    // Note: Render it here because we know dom is ready at this point
    if (!this.header.rendered()) {
      this.el = this.header.render().getContentEl();
    }

    // If we need to load a language (or apply custom i18n overrides), do
    // this now and re-run render after it's finished.
    if (!_Bundles.default.isLoaded(this.settings.get('languageCode'))) {
      await _LanguageUtil.default.loadLanguage(this.appState, this.settings);
    }
    let error;
    try {
      let idxResp = await (0, _client.startLoginFlow)(this.settings);
      if (idxResp.error) {
        await this.handleIdxResponseFailure(idxResp.error);
      } else {
        if (this.settings.get('flow') && !this.hasControllerRendered) {
          idxResp = await (0, _client.handleConfiguredFlow)(idxResp, this.settings);
        }

        // TODO: OKTA-494979 - temporary fix, remove when auth-js is upgraded to 6.6+
        if (!idxResp.requestDidSucceed && _IonResponseHelper.default.isIdxSessionExpiredError(idxResp)) {
          // clear transaction subsequent page loads do not use stale interactionHandle
          const authClient = this.settings.getAuthClient();
          authClient.transactionManager.clear();
        }
        await (0, _client.updateAppState)(this.appState, idxResp);
      }
    } catch (exception) {
      var _exception$is;
      if ((_exception$is = exception.is) !== null && _exception$is !== void 0 && _exception$is.call(exception, 'terminal')) {
        this.appState.setNonIdxError(exception);
      } else {
        error = exception;
        await this.handleError(exception);
      }
    } finally {
      // These settings should only be used one time, for initial render
      this.settings.unset('stateToken');
      this.settings.unset('proxyIdxResponse');
    }

    // Load the custom colors only on the first render
    if (this.settings.get('colors.brand') && !_ColorsUtil.default.isLoaded()) {
      const colors = {
        brand: this.settings.get('colors.brand')
      };
      const cspNonce = this.settings.get('cspNonce');
      _ColorsUtil.default.addStyle(colors, cspNonce);
    }

    // Show before initial render
    this.show();

    // render Controller
    this.unload();
    const controllerOptions = _courage._.extend({
      el: this.el,
      settings: this.settings,
      appState: this.appState
    }, options);
    this.controller = new Controller(controllerOptions);

    // Bubble up all controller events
    this.listenTo(this.controller, 'all', this.trigger);
    this.controller.render();
    this.hasControllerRendered = true;

    // This will reject the promise returned from renderEl
    if (error) {
      this.settings.callGlobalError(error);
    }

    // -- TODO: OKTA-244631 How to surface up the CORS error in IDX?
    // -- The `err` object from idx.js doesn't have XHR object
    // Global error handling for CORS enabled errors
    // if (err.xhr && BrowserFeatures.corsIsNotEnabled(err.xhr)) {
    //   this.settings.callGlobalError(new UnsupportedBrowserError(loc('error.enabled.cors')));
    //   return;
    // }
  }

  /**
    * When "Remember My Username" is enabled, we save the identifier in a cookie
    * so that the next time the user visits the SIW, the identifier field can be 
    * pre-filled with this value.
   */
  updateIdentifierCookie(idxResponse) {
    if (this.settings.get('features.rememberMe')) {
      var _idxResponse$context;
      // Update the cookie with the identifier
      const user = idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$context = idxResponse.context) === null || _idxResponse$context === void 0 ? void 0 : _idxResponse$context.user;
      const {
        identifier
      } = (user === null || user === void 0 ? void 0 : user.value) || {};
      if (identifier) {
        _CookieUtil.default.setUsernameCookie(identifier);
      }
    } else {
      // We remove the cookie explicitly if this feature is disabled.
      _CookieUtil.default.removeUsernameCookie();
    }
  }
  hasAuthenticationSucceeded(idxResponse) {
    var _idxResponse$rawIdxSt, _idxResponse$rawIdxSt2;
    // Check whether authentication has succeeded. This is done by checking the server response
    // and seeing if either the 'success' or 'successWithInteractionCode' objects are present.
    return (idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$rawIdxSt = idxResponse.rawIdxState) === null || _idxResponse$rawIdxSt === void 0 ? void 0 : _idxResponse$rawIdxSt.success) || (idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$rawIdxSt2 = idxResponse.rawIdxState) === null || _idxResponse$rawIdxSt2 === void 0 ? void 0 : _idxResponse$rawIdxSt2.successWithInteractionCode);
  }
  restartLoginFlow(flow) {
    // clear all transaction data and saved IDX response
    this.settings.getAuthClient().transactionManager.clear();
    this.appState.set('idx', undefined);

    // Clear the recoveryToken, if any
    const authClient = this.settings.getAuthClient();
    delete authClient.options['recoveryToken'];
    this.settings.unset('recoveryToken');
    // clear otp (email magic link), if any
    this.settings.unset('otp');

    // remove all event listeners from current controller instance. A new instance will be created in render().
    this.controller.stopListening();
    authClient.idx.setFlow(flow ?? this.settings.get('flow') ?? 'default');

    // Re-render the widget
    this.render(this.controller.constructor);
  }
  start() {
    const pushState = _BrowserFeatures.default.supportsPushState();
    _courage.Router.prototype.start.call(this, {
      pushState: pushState
    });
  }
  hide() {
    this.header.$el.hide();
  }
  show() {
    this.header.$el.show();
  }
  remove() {
    this.unload();
    this.header.$el.remove();
    this.stopListening(this.appState);
    this.stopListening(this.settings);
    _Bundles.default.remove();
    _courage.Backbone.history.stop();
  }
}

// Add "Events" to prototype for compatibility with existing code
BaseLoginRouter.prototype.Events = _courage.Backbone.Events;
var _default = BaseLoginRouter;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/WidgetRouter.ts":
/*!********************************!*\
  !*** ./src/v2/WidgetRouter.ts ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _BaseLoginRouter = _interopRequireDefault(__webpack_require__(/*! ./BaseLoginRouter */ "./src/v2/BaseLoginRouter.ts"));
var _FormController = _interopRequireDefault(__webpack_require__(/*! ./controllers/FormController */ "./src/v2/controllers/FormController.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const routes = {
  '': 'defaultAuth',
  '*wildcard': 'defaultAuth'
};
class WidgetRouter extends _BaseLoginRouter.default {
  constructor(options) {
    super({
      routes,
      ...options
    });
  }
  defaultAuth() {
    this.render(_FormController.default);
  }
}
exports["default"] = WidgetRouter;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/client/emailVerifyCallback.ts":
/*!**********************************************!*\
  !*** ./src/v2/client/emailVerifyCallback.ts ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.emailVerifyCallback = emailVerifyCallback;
/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

async function emailVerifyCallback(settings) {
  const authClient = settings.getAuthClient();
  const idxOptions = {
    exchangeCodeForTokens: false // we handle this in interactionCodeFlow.js
  };

  const meta = await authClient.idx.getSavedTransactionMeta(); // meta can load in another tab using state if it matches
  if (!meta || !meta.interactionHandle) {
    // Flow can not continue in this tab. Create a synthetic server response and use it to display a message to the user
    const messages = {
      type: 'array',
      value: [
      // terminal-return-otp-only-no-location.json
      {
        'message': 'Enter the OTP in your original browser or device.',
        'i18n': {
          'key': 'idx.enter.otp.in.original.tab'
        },
        'class': 'INFO'
      }]
    };
    const resp = {
      neededToProceed: [],
      // OKTA-382410 so bad that has to leverage rawIdxState
      rawIdxState: {
        messages
      },
      context: {
        messages
      }
    };
    return resp;
  }

  // Proceed using the OTP code
  const otp = settings.get('otp');
  const idxResponse = await authClient.idx.proceed({
    ...idxOptions,
    otp
  });
  return idxResponse;
}

/***/ }),

/***/ "./src/v2/client/formatError.ts":
/*!**************************************!*\
  !*** ./src/v2/client/formatError.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.formatError = formatError;
exports.formatIDXError = formatIDXError;
exports.formatInvalidActivationTokenError = formatInvalidActivationTokenError;
exports.formatInvalidRecoveryTokenError = formatInvalidRecoveryTokenError;
exports.formatOIEConfigurationError = formatOIEConfigurationError;
exports.formatOIENotEnabledError = formatOIENotEnabledError;
exports.isInvalidActivationTokenError = isInvalidActivationTokenError;
exports.isInvalidRecoveryTokenError = isInvalidRecoveryTokenError;
exports.isOIEConfigurationError = isOIEConfigurationError;
exports.isOIENotEnabledError = isOIENotEnabledError;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

function isInvalidRecoveryTokenError(error) {
  // special case: error from interact when passing an (invalid) recovery token
  return (error === null || error === void 0 ? void 0 : error.error) === 'invalid_request' && error.error_description === 'The recovery token is invalid';
}
function isInvalidActivationTokenError(error) {
  // special case: error from interact when passing an (invalid) activation token
  return (error === null || error === void 0 ? void 0 : error.error) === 'invalid_request' && error.error_description === 'The activation token is invalid';
}
function formatInvalidRecoveryTokenError(error) {
  // This error comes from `oauth2/interact` so is not an IDX error.
  // simulate an IDX-JS error response
  const idxError = formatIDXError(error);
  const {
    details
  } = idxError;
  const messages = {
    type: 'array',
    value: [{
      message: error.error_description,
      i18n: {
        key: 'oie.invalid.recovery.token'
      },
      class: 'ERROR'
    }]
  };
  details.rawIdxState.messages = messages;
  details.context.messages = messages;
  return idxError;
}
function formatInvalidActivationTokenError(error) {
  // This error comes from `oauth2/interact` so is not an IDX error.
  // simulate an IDX-JS error response
  const idxError = formatIDXError(error);
  const {
    details
  } = idxError;
  const messages = {
    type: 'array',
    value: [{
      message: error.error_description,
      i18n: {
        key: 'idx.missing.activation.token'
      },
      class: 'ERROR'
    }]
  };
  details.rawIdxState.messages = messages;
  details.context.messages = messages;
  return idxError;
}
function isOIENotEnabledError(error) {
  // special case: error from interact when the Org does not have OIE enabled
  // The response is not in IDX format. See playground/mocks/data/oauth2/error-feature-not-enabled.json
  return (error === null || error === void 0 ? void 0 : error.error) === 'access_denied' && error.error_description;
}
function formatOIENotEnabledError(error) {
  // This error comes from `oauth2/interact` so the error is in OAuth format
  // simulate an IDX-JS error response
  const idxError = formatIDXError(error);
  const {
    details
  } = idxError;
  const messages = {
    type: 'array',
    value: [{
      message: error.error_description,
      i18n: {
        key: 'oie.feature.disabled'
      },
      class: 'ERROR'
    }]
  };
  details.rawIdxState.messages = messages;
  details.context.messages = messages;
  return error;
}
function isOIEConfigurationError(error) {
  return (error === null || error === void 0 ? void 0 : error.error) && error.error_description;
}
function formatOIEConfigurationError(error) {
  // This error comes from `oauth2/interact` so the error is in OAuth format
  // simulate an IDX-JS error response
  const idxError = formatIDXError(error);
  const {
    details
  } = idxError;
  const messages = {
    type: 'array',
    value: [{
      message: (0, _courage.loc)('oie.configuration.error', 'login'),
      class: 'ERROR',
      i18n: undefined
    }]
  };
  details.rawIdxState.messages = messages;
  details.context.messages = messages;
  return error;
}
function formatIDXError(error) {
  // Make the error object resemble an IDX response
  const idxError = error;
  idxError.details = idxError.details || {};
  const {
    details
  } = idxError;
  details.rawIdxState = details.rawIdxState || {};
  details.context = details.context || {};
  details.neededToProceed = details.neededToProceed || [];

  // Populate generic error message if there isn't any.
  if (!details.rawIdxState.messages) {
    const idxMessage = {
      type: 'array',
      value: [{
        message: (0, _courage.loc)('oform.error.unexpected', 'login'),
        class: 'ERROR',
        i18n: undefined
      }]
    };
    details.rawIdxState.messages = idxMessage;
    details.context.messages = idxMessage;
  }
  return idxError;
}
function formatError(error) {
  // If the error is a string, wrap it in an Error object
  if (typeof error === 'string') {
    error = new Error(error);
  }

  // special case error handling

  // invalid reccovery token
  if (isInvalidRecoveryTokenError(error)) {
    return formatInvalidRecoveryTokenError(error);
  }

  // invalid activation token
  if (isInvalidActivationTokenError(error)) {
    return formatInvalidActivationTokenError(error);
  }

  // OIE is not enabled
  if (isOIENotEnabledError(error)) {
    return formatOIENotEnabledError(error);
  }

  // Other errors from /interact in OAuth format
  if (isOIEConfigurationError(error)) {
    return formatOIEConfigurationError(error);
  }
  error = formatIDXError(error);
  return error;
}

/***/ }),

/***/ "./src/v2/client/startLoginFlow.ts":
/*!*****************************************!*\
  !*** ./src/v2/client/startLoginFlow.ts ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.startLoginFlow = startLoginFlow;
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _emailVerifyCallback = __webpack_require__(/*! ./emailVerifyCallback */ "./src/v2/client/emailVerifyCallback.ts");
var _sessionStorageHelper = _interopRequireDefault(__webpack_require__(/*! ./sessionStorageHelper */ "./src/v2/client/sessionStorageHelper.js"));
var _constants = __webpack_require__(/*! ./constants */ "./src/v2/client/constants.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const handleProxyIdxResponse = async settings => {
  return Promise.resolve({
    rawIdxState: settings.get('proxyIdxResponse'),
    context: settings.get('proxyIdxResponse'),
    neededToProceed: []
  });
};

/* eslint max-depth: [2, 3] */
// eslint-disable-next-line complexity, max-statements
async function startLoginFlow(settings) {
  const authClient = settings.getAuthClient();
  // nonce is not a top-level auth-js option, must be passed in manually
  const {
    authParams
  } = settings.toJSON({
    verbose: true
  });
  const nonce = settings.get('nonce') || (authParams === null || authParams === void 0 ? void 0 : authParams.nonce);
  const idxOptions = {
    exchangeCodeForTokens: false,
    // we handle this in interactionCodeFlow.js
    ...(nonce && {
      nonce
    })
  };

  // Return a preset response
  if (settings.get('proxyIdxResponse')) {
    return handleProxyIdxResponse(settings);
  }
  if (settings.get('overrideExistingStateToken')) {
    _sessionStorageHelper.default.removeStateHandle();
  }
  if (settings.get('otp')) {
    return (0, _emailVerifyCallback.emailVerifyCallback)(settings);
  }
  if (settings.get('oauth2Enabled')) {
    const meta = await authClient.idx.getSavedTransactionMeta();
    if (!meta) {
      // no saved transaction
      // if the configured flow is set to `proceed`, the SIW should only continue an existing idx transaction
      // if the SIW loads from a fresh state (there is no current transaction), throw an error
      const flow = authClient.idx.getFlow();
      if (flow && flow === _constants.CONFIGURED_FLOW.PROCEED) {
        throw new _Errors.ConfiguredFlowError('Unable to proceed: saved transaction could not be loaded', flow);
      }
      // start new transaction
      return authClient.idx.start(idxOptions); // calls interact
    }

    // continue saved transaction
    return authClient.idx.proceed(idxOptions); // calls introspect
  }

  // Use stateToken from session storage if exists
  // See more details at ./docs/use-session-token-prior-to-settings.png
  const stateHandleFromSession = _sessionStorageHelper.default.getStateHandle();
  if (stateHandleFromSession) {
    try {
      var _idxResp$context, _idxResp$context$mess;
      const idxResp = await authClient.idx.start({
        ...idxOptions,
        stateHandle: stateHandleFromSession
      });
      const hasError = ((_idxResp$context = idxResp.context) === null || _idxResp$context === void 0 ? void 0 : (_idxResp$context$mess = _idxResp$context.messages) === null || _idxResp$context$mess === void 0 ? void 0 : _idxResp$context$mess.value.length) > 0;
      if (hasError) {
        throw new Error('saved stateToken is invalid'); // will be caught in this function
      }

      // 1. abandon the settings.stateHandle given session.stateHandle is still valid
      settings.set('stateToken', stateHandleFromSession);
      // 2. chain the idxResp to next handler
      return idxResp;
    } catch {
      // 1. remove session.stateHandle
      _sessionStorageHelper.default.removeStateHandle();
      // 2. start the login again in order to introspect on settings.stateHandle
      return startLoginFlow(settings);
    }
  }

  // Use stateToken from options
  const stateHandle = settings.get('stateToken');
  if (stateHandle) {
    return authClient.idx.start({
      ...idxOptions,
      stateHandle
    });
  }
  throw new _Errors.ConfigError('Invalid OIDC configuration. Set "clientId" and "redirectUri" in the widget options.');
}

/***/ }),

/***/ "./src/v2/client/updateAppState.ts":
/*!*****************************************!*\
  !*** ./src/v2/client/updateAppState.ts ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.updateAppState = updateAppState;
var _sessionStorageHelper = _interopRequireDefault(__webpack_require__(/*! ./sessionStorageHelper */ "./src/v2/client/sessionStorageHelper.js"));
var _interactionCodeFlow = __webpack_require__(/*! ./interactionCodeFlow */ "./src/v2/client/interactionCodeFlow.js");
var _RemediationConstants = __webpack_require__(/*! ../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _transformIdxResponse = _interopRequireDefault(__webpack_require__(/*! ../ion/transformIdxResponse */ "./src/v2/ion/transformIdxResponse.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
async function updateAppState(appState, idxResponse) {
  const settings = appState.settings;
  const lastResponse = appState.get('idx');
  const useInteractionCodeFlow = settings.get('oauth2Enabled');
  if (useInteractionCodeFlow) {
    if (idxResponse.interactionCode) {
      // Although session.stateHandle isn't used by interation flow,
      // it's better to clean up at the end of the flow.
      _sessionStorageHelper.default.removeStateHandle();
      // This is the end of the IDX flow, now entering OAuth
      const tokens = await (0, _interactionCodeFlow.interactionCodeFlow)(settings, idxResponse);
      // At the successful end of IDX flow `clearAppStateCache` has been called, 
      //  but `setIonResponse` is not called, so `appState` is empty.
      // In such case `FormController` is not able to render any form.
      appState.unset('currentFormName', {
        silent: true
      });
      return tokens;
    }
  } else {
    // Do not save state handle for the first page loads.
    // Because there shall be no difference between following behavior
    // 1. bootstrap widget
    //    -> save state handle to session storage
    //    -> refresh page
    //    -> introspect using sessionStorage.stateHandle
    // 2. bootstrap widget
    //    -> do not save state handle to session storage
    //    -> refresh page
    //    -> introspect using options.stateHandle
    if (lastResponse) {
      var _idxResponse$context;
      _sessionStorageHelper.default.setStateHandle(idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$context = idxResponse.context) === null || _idxResponse$context === void 0 ? void 0 : _idxResponse$context.stateHandle);
    }
    // Login flows that mimic step up (moving forward in login pipeline) via internal api calls,
    // need to clear stored stateHandles.
    // This way the flow can maintain the latest state handle. For eg. Device probe calls
    if (appState.get('currentFormName') === _RemediationConstants.FORMS.CANCEL_TRANSACTION) {
      _sessionStorageHelper.default.removeStateHandle();
    }
  }

  // transform response
  const ionResponse = (0, _transformIdxResponse.default)(settings, idxResponse, lastResponse);
  await appState.setIonResponse(ionResponse);
}

/***/ }),

/***/ "./src/v2/controllers/FormController.ts":
/*!**********************************************!*\
  !*** ./src/v2/controllers/FormController.ts ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _ViewFactory = _interopRequireDefault(__webpack_require__(/*! ../view-builder/ViewFactory */ "./src/v2/view-builder/ViewFactory.ts"));
var _IonResponseHelper = _interopRequireDefault(__webpack_require__(/*! ../ion/IonResponseHelper */ "./src/v2/ion/IonResponseHelper.js"));
var _ViewClassNamesFactory = __webpack_require__(/*! ../ion/ViewClassNamesFactory */ "./src/v2/ion/ViewClassNamesFactory.js");
var _RemediationConstants = __webpack_require__(/*! ../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _payloadTransformer = _interopRequireDefault(__webpack_require__(/*! ../ion/payloadTransformer */ "./src/v2/ion/payloadTransformer.js"));
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _sessionStorageHelper = _interopRequireDefault(__webpack_require__(/*! ../client/sessionStorageHelper */ "./src/v2/client/sessionStorageHelper.js"));
var _oktaAuthJs = __webpack_require__(/*! @okta/okta-auth-js */ "./node_modules/@okta/okta-auth-js/umd/default.js");
var _constants = __webpack_require__(/*! ../client/constants */ "./src/v2/client/constants.js");
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _client = __webpack_require__(/*! v2/client */ "./src/v2/client/index.js");
var _CookieUtil = _interopRequireDefault(__webpack_require__(/*! ../../util/CookieUtil */ "./src/util/CookieUtil.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var _default = _courage.Controller.extend({
  className: 'form-controller',
  appStateEvents: {
    'change:currentFormName': 'handleFormNameChange',
    'afterError': 'handleAfterError',
    'invokeAction': 'handleInvokeAction',
    'saveForm': 'handleSaveForm',
    'switchForm': 'handleSwitchForm'
  },
  preRender() {
    this.removeChildren();
  },
  postRender() {
    const currentViewState = this.options.appState.getCurrentViewState();
    // TODO: add comments regarding when `currentViewState` would be null?
    if (!currentViewState) {
      return;
    }
    this.clearMetadata();
    let formName = currentViewState.name;
    if (formName === 'identify' && this.options.settings.get('flow') === _constants.CONFIGURED_FLOW.RESET_PASSWORD) {
      formName = 'identify-recovery';
    }
    const TheView = _ViewFactory.default.create(formName, this.options.appState.get('authenticatorKey'));
    try {
      this.formView = this.add(TheView, {
        options: {
          currentViewState
        }
      }).last();
    } catch (error) {
      // This is the place where runtime error (NPE) happens at most of time.
      // It has been swallowed by Q.js hence add try/catch to surface up errors.
      this.options.settings.callGlobalError(error);
      return;
    }
    this.triggerAfterRenderEvent();
  },
  clearMetadata() {
    const formName = this.options.appState.get('currentFormName');
    // TODO: OKTA-392835 shall not clear state handle at terminal page
    if (_RemediationConstants.TERMINAL_FORMS.includes(formName)) {
      _sessionStorageHelper.default.removeStateHandle();
    }
  },
  triggerAfterRenderEvent() {
    const contextData = this.createAfterEventContext();
    this.trigger('afterRender', contextData);
  },
  handleFormNameChange() {
    this.render();
  },
  handleAfterError(error) {
    const contextData = this.createAfterEventContext();
    const errorContextData = {
      xhr: error,
      errorSummary: error.responseJSON && error.responseJSON.errorSummary
    };
    // TODO: need some enhancement after https://github.com/okta/okta-idx-js/pull/27
    // OKTA-318062
    this.trigger('afterError', contextData, errorContextData);
  },
  createAfterEventContext() {
    const formName = this.options.appState.get('currentFormName');
    const authenticatorKey = this.options.appState.get('authenticatorKey');
    const methodType = this.options.appState.get('authenticatorMethodType');
    const isPasswordRecoveryFlow = this.options.appState.get('isPasswordRecoveryFlow');
    const v1ControllerClassName = (0, _ViewClassNamesFactory.getV1ClassName)(formName, authenticatorKey, methodType, isPasswordRecoveryFlow);
    const eventData = {
      controller: v1ControllerClassName,
      formName
    };
    if (authenticatorKey) {
      eventData.authenticatorKey = authenticatorKey;
    }
    if (methodType) {
      eventData.methodType = methodType;
    }
    return eventData;
  },
  handleSwitchForm(formName) {
    // trigger formName change to change view
    if (this.options.appState.get('messages')) {
      // Clear messages before calling switch form.
      // If a form has errors sent form API inside messages
      // and user hits back to factors list which triggers switchForm,
      // those error will show up on another screen that gets rendered after switchForm
      this.options.appState.unset('messages');
    }
    this.options.appState.set('currentFormName', formName);
  },
  // eslint-disable-next-line max-statements
  async handleInvokeAction(actionPath = '', actionParams = {}) {
    const {
      appState,
      settings
    } = this.options;

    // For self-hosted scenario we need to start reset flow at identify page from scratch.
    //  (Reusing state handle of transaction after failed sign-in attempt for reset flow is error prone)
    // For Okta-hosted scenario we don't need to cancel/restart flow because SIW receives fresh state token
    //  from backend on page load and doesn't save state handle to session storage after error.
    if (actionPath === _RemediationConstants.ORG_PASSWORD_RECOVERY_LINK && settings.get('oauth2Enabled')) {
      appState.trigger('restartLoginFlow', 'resetPassword');
      return;
    }
    const idx = appState.get('idx');
    const {
      stateHandle
    } = idx.context;
    let invokeOptions = {
      exchangeCodeForTokens: false,
      // we handle this in interactionCodeFlow.js
      stateHandle
    };
    let error;

    // Cancel action is executes synchronously
    if (actionPath === 'cancel') {
      // TODO: resolve race conditions caused by event pattern: OKTA-490220
      settings.getAuthClient().transactionManager.clear({
        clearIdxResponse: false
      });
      _sessionStorageHelper.default.removeStateHandle();
      appState.clearAppStateCache();
      appState.unset('lastIdentifier');
      if (settings.get('oauth2Enabled')) {
        // In this case we need to restart login flow and recreate transaction meta
        // that will be used in interactionCodeFlow function
        appState.trigger('restartLoginFlow');
        return;
      }
    }

    // Build options to invoke or throw error for invalid action
    if (_RemediationConstants.FORMS.LAUNCH_AUTHENTICATOR === actionPath && actionParams) {
      //https://oktainc.atlassian.net/browse/OKTA-562885  a temp solution to send rememberMe when click the launch OV buttion.
      //will redesign to handle FastPass silent probing case where no username and rememberMe opiton at all.
      invokeOptions = {
        ...invokeOptions,
        actions: [{
          name: actionPath,
          params: actionParams
        }]
      };
    } else if (idx['neededToProceed'].find(item => item.name === actionPath)) {
      invokeOptions = {
        ...invokeOptions,
        step: actionPath
      };
    } else if (_courage._.isFunction(idx['actions'][actionPath])) {
      invokeOptions = {
        ...invokeOptions,
        actions: [{
          name: actionPath,
          params: actionParams
        }]
      };
    } else {
      error = new _Errors.ConfigError(`Invalid action selected: ${actionPath}`);
      this.options.settings.callGlobalError(error);
      await this.showFormErrors(this.formView.model, error, this.formView.form);
      return;
    }

    // action will be executed asynchronously
    await this.invokeAction(invokeOptions);
  },
  async invokeAction(invokeOptions) {
    const authClient = this.options.settings.getAuthClient();
    let resp;
    let error;
    try {
      resp = await authClient.idx.proceed(invokeOptions);
      if (resp.requestDidSucceed === false) {
        error = resp;
      }
    } catch (e) {
      error = e;
    }

    // if request did not succeed, show error on the current form
    if (error) {
      await this.showFormErrors(this.formView.model, error, this.formView.form);
      return;
    }

    // process response, may render a new form
    await this.handleIdxResponse(resp);
  },
  // eslint-disable-next-line max-statements, complexity
  async handleSaveForm(model) {
    const formName = model.get('formName');

    // Toggle Form saving status (e.g. disabling save button, etc)
    this.toggleFormButtonState(true);
    model.trigger('request');

    // Use full page redirection if necessary
    if (model.get('useRedirect')) {
      // Clear when navigates away from SIW page, e.g. success, IdP Authenticator.
      // Because SIW sort of finished its current /transaction/
      _sessionStorageHelper.default.removeStateHandle();

      // OKTA-635926: do not redirect without user gesture for ov enrollment on android
      // if Util.isAndroidOVEnrollment() returns true we use a user gesture to complete the redirect in AutoRedirectView
      if (!_Util.default.isAndroidOVEnrollment()) {
        const currentViewState = this.options.appState.getCurrentViewState();
        // OKTA-702402: redirect only if/when the page is visible
        _Util.default.executeOnVisiblePage(() => {
          _Util.default.redirectWithFormGet(currentViewState.href);
        });
      }
      return;
    }
    const payload = (0, _payloadTransformer.default)(formName, model);
    // Run hook: transform the user name (a.k.a identifier)
    const values = this.transformIdentifier(formName, payload);

    // widget rememberMe feature stores the entered identifier in a cookie, to pre-fill the form on subsequent visits to page
    if (this.options.settings.get('features.rememberMe')) {
      if (values.identifier) {
        _CookieUtil.default.setUsernameCookie(values.identifier);
      }
    } else {
      _CookieUtil.default.removeUsernameCookie();
    }

    // Error out when this is not a remediation form. Unexpected Exception.
    if (!this.options.appState.hasRemediationObject(formName)) {
      this.options.settings.callGlobalError(`Cannot find http action for "${formName}".`);
      await this.showFormErrors(this.formView.model, 'Cannot find action to proceed.', this.formView.form);
      return;
    }

    // Reset password in identity-first flow needs some help to auto-select password and begin the reset flow
    if (formName === 'identify' && this.options.settings.get('flow') === _constants.CONFIGURED_FLOW.RESET_PASSWORD) {
      values.authenticator = 'okta_password';
    }

    // Submit request to idx endpoint
    const authClient = this.options.settings.getAuthClient();
    const idxOptions = {
      exchangeCodeForTokens: false // we handle this in interactionCodeFlow.js
    };

    try {
      const idx = this.options.appState.get('idx');
      const {
        stateHandle
      } = idx.context;
      const resp = await authClient.idx.proceed({
        ...idxOptions,
        step: formName,
        stateHandle,
        ...values
      });
      if (resp.status === _oktaAuthJs.IdxStatus.FAILURE) {
        throw resp.error; // caught and handled in this function
      }
      // follow idx transaction to render terminal view for session expired error
      if (_IonResponseHelper.default.isIdxSessionExpiredError(resp)) {
        const authClient = this.settings.getAuthClient();
        authClient.transactionManager.clear();
        await this.handleIdxResponse(resp);
        return;
      }
      // If the last request did not succeed, show errors on the current form
      // Special case: Okta server responds 401 status code with WWW-Authenticate header and new remediation
      // so that the iOS/MacOS credential SSO extension (Okta Verify) can intercept
      // the response reaches here when Okta Verify is not installed
      // we need to return an idx object so that
      // the SIW can proceed to the next step without showing error
      if (resp.requestDidSucceed === false && !resp.stepUp) {
        await this.showFormErrors(model, resp, this.formView.form);
        return;
      }
      const onSuccess = this.handleIdxResponse.bind(this, resp);
      if (formName === _RemediationConstants.FORMS.ENROLL_PROFILE) {
        var _values$userProfile;
        // call registration (aka enroll profile) hook
        this.settings.postRegistrationSubmit(values === null || values === void 0 ? void 0 : (_values$userProfile = values.userProfile) === null || _values$userProfile === void 0 ? void 0 : _values$userProfile.email, onSuccess, error => {
          model.trigger('error', model, {
            responseJSON: error
          });
        });
      } else {
        await onSuccess();
      }
    } catch (error) {
      var _error$is;
      if ((_error$is = error.is) !== null && _error$is !== void 0 && _error$is.call(error, 'terminal')) {
        this.options.appState.setNonIdxError(error);
      } else {
        await this.showFormErrors(model, error, this.formView.form);
      }
    } finally {
      this.toggleFormButtonState(false);
    }
  },
  transformIdentifier(formName, modelJSON) {
    if (Object.prototype.hasOwnProperty.call(modelJSON, 'identifier')) {
      // The callback function is passed two arguments:
      // 1) username: The name entered by the user
      // 2) operation: The type of operation the user is trying to perform:
      //      - PRIMARY_AUTH
      //      - FORGOT_PASSWORD
      //      - UNLOCK_ACCOUNT
      const operation = _RemediationConstants.FORM_NAME_TO_OPERATION_MAP[formName];
      modelJSON.identifier = this.settings.transformUsername(modelJSON.identifier, operation);
    }
    return modelJSON;
  },
  /**
   * @param model current form model
   * @param error any errors after user action
   * @param form current form
   * Handle errors that get displayed right after any user action. After such form errors widget doesn't
   * reload or re-render, but updates the AppSate with latest remediation.
   */
  async showFormErrors(model, error, form) {
    var _error;
    /* eslint max-statements: [2, 24] */
    const formName = model.get('formName');
    let errorObj;
    let idxStateError;
    let showErrorBanner = true;
    model.trigger('clearFormError');
    if (!error) {
      error = 'FormController - unknown error found';
      this.options.settings.callGlobalError(error);
    }
    if ((_error = error) !== null && _error !== void 0 && _error.rawIdxState) {
      idxStateError = error;
      error = error.rawIdxState;
    }
    if (_IonResponseHelper.default.isIonErrorResponse(error)) {
      errorObj = _IonResponseHelper.default.convertFormErrors(error);
    } else if (error.errorSummary) {
      errorObj = {
        responseJSON: error
      };
    } else {
      _Util.default.logConsoleError(error);
      errorObj = {
        responseJSON: {
          errorSummary: (0, _courage.loc)('error.unsupported.response', 'login')
        }
      };
    }
    if (_courage._.isFunction(form === null || form === void 0 ? void 0 : form.showCustomFormErrorCallout)) {
      var _idxStateError;
      showErrorBanner = !form.showCustomFormErrorCallout(errorObj, (_idxStateError = idxStateError) === null || _idxStateError === void 0 ? void 0 : _idxStateError.messages);
    }

    // show error before updating app state.
    model.trigger('error', model, errorObj, showErrorBanner);
    idxStateError = Object.assign({}, idxStateError, {
      hasFormError: true
    });

    // OKTA-725716: Don't save failed IDX response to state

    // Save identifier to be auto filled on EnrollProfileView and IdentifyRecoveryView
    if (formName === _RemediationConstants.FORMS.IDENTIFY) {
      const identifier = model.get('identifier');
      this.options.appState.set('lastIdentifier', identifier);
    } else {
      this.options.appState.unset('lastIdentifier');
    }
  },
  async handleIdxResponse(idxResp) {
    await (0, _client.updateAppState)(this.options.appState, idxResp);
  },
  /**
   * SignIn widget has its own (hacky) way to customize the button disabled state:
   * adding `link-button-disabled` despite the name was intend only to disable
   * `link-button`.
   * Instead of doing decent refactor, we want to follow the convention for now.
   *
   * @param {boolean} disabled whether add extra disable CSS class.
   */
  toggleFormButtonState: function (disabled) {
    const button = this.$el.find('.o-form-button-bar .button');
    button.toggleClass('link-button-disabled', disabled);
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/mixins/mixins.ts":
/*!*********************************!*\
  !*** ./src/v2/mixins/mixins.ts ***!
  \*********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "_", ({
  enumerable: true,
  get: function () {
    return _courage._;
  }
}));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
_courage._.mixin({
  nestedOmit: function (obj, names) {
    let result = _courage._.omit(obj, names);
    if (names.includes(result.name)) {
      result = _courage._.omit(result, 'value');
    }
    _courage._.each(result, function (val, key) {
      if (Array.isArray(val)) {
        result[key] = val.map(v => {
          return _courage._.nestedOmit(v, names);
        });
      } else if (typeof val === 'object') {
        result[key] = _courage._.nestedOmit(val, names);
      }
    });
    return result;
  }
});

/***/ }),

/***/ "./src/v2/models/AppState.ts":
/*!***********************************!*\
  !*** ./src/v2/models/AppState.ts ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _Logger = _interopRequireDefault(__webpack_require__(/*! util/Logger */ "./src/util/Logger.js"));
var _RemediationConstants = __webpack_require__(/*! ../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _ionObjectHandler = __webpack_require__(/*! ../ion/ui-schema/ion-object-handler */ "./src/v2/ion/ui-schema/ion-object-handler.js");
var _mixins = __webpack_require__(/*! ../mixins/mixins */ "./src/v2/mixins/mixins.ts");
var _Hooks = __webpack_require__(/*! util/Hooks */ "./src/util/Hooks.js");
var _BrowserFeatures = _interopRequireDefault(__webpack_require__(/*! util/BrowserFeatures */ "./src/util/BrowserFeatures.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const UNKNOWN_USER_I8N_KEY = "idx.unknown.user";
/**
 * Keep track of stateMachine with this special model. Similar to `src/models/AppState.js`
 */

const local = {
  user: 'object',
  // optional
  currentFormName: 'string',
  lastIdentifier: 'string',
  idx: 'object',
  remediations: 'array',
  dynamicRefreshInterval: 'number',
  deviceFingerprint: 'string',
  hooks: 'object' // instance of models/Hooks
};

const derived = {
  authenticatorProfile: {
    deps: ['currentAuthenticator', 'currentAuthenticatorEnrollment'],
    fn(currentAuthenticator = {
      profile: undefined
    }, currentAuthenticatorEnrollment = {
      profile: undefined
    }) {
      return currentAuthenticator.profile || currentAuthenticatorEnrollment.profile || {};
    }
  },
  authenticatorKey: {
    deps: ['currentAuthenticator', 'currentAuthenticatorEnrollment'],
    fn(currentAuthenticator = {
      key: undefined
    }, currentAuthenticatorEnrollment = {
      key: undefined
    }) {
      return currentAuthenticator.key || currentAuthenticatorEnrollment.key || '';
    }
  },
  authenticatorMethodType: {
    deps: ['currentAuthenticator', 'currentAuthenticatorEnrollment'],
    fn(currentAuthenticator = {
      methods: undefined
    }, currentAuthenticatorEnrollment = {
      methods: undefined
    }) {
      return currentAuthenticator.methods && currentAuthenticator.methods[0].type || currentAuthenticatorEnrollment.methods && currentAuthenticatorEnrollment.methods[0].type || '';
    }
  },
  isPasswordRecovery: {
    deps: ['recoveryAuthenticator'],
    fn: function (recoveryAuthenticator = {
      type: undefined
    }) {
      return (recoveryAuthenticator === null || recoveryAuthenticator === void 0 ? void 0 : recoveryAuthenticator.type) === 'password';
    }
  }
};
class AppState extends _courage.Model {
  constructor(attributes, options) {
    super(attributes, options);
    this.settings = void 0;
    this.hooks = void 0;
    this.settings = options.settings;
    this.hooks = options.hooks;
  }
  get(attributeName) {
    return _courage.Model.prototype.get.call(this, attributeName);
  }
  preinitialize(...args) {
    this.local = local;
    this.derived = derived;
    _courage.Model.prototype.preinitialize.apply(this, args);
  }
  isIdentifierOnlyView() {
    var _this$get, _this$get$find, _this$get$find$uiSche;
    return !((_this$get = this.get('remediations')) !== null && _this$get !== void 0 && (_this$get$find = _this$get.find(({
      name
    }) => name === 'identify')) !== null && _this$get$find !== void 0 && (_this$get$find$uiSche = _this$get$find.uiSchema) !== null && _this$get$find$uiSche !== void 0 && _this$get$find$uiSche.find(({
      name
    }) => name === 'credentials.passcode'));
  }
  hasRemediationObject(formName) {
    return this.get('idx').neededToProceed.find(remediation => remediation.name === formName);
  }
  hasActionObject(actionName) {
    var _this$get2, _this$get2$actions;
    return !!((_this$get2 = this.get('idx')) !== null && _this$get2 !== void 0 && (_this$get2$actions = _this$get2.actions) !== null && _this$get2$actions !== void 0 && _this$get2$actions[actionName]);
  }
  getRemediationAuthenticationOptions(formName) {
    const form = this.hasRemediationObject(formName);
    if (!form) {
      return [];
    }
    const authenticator = form.value.find(value => value.name === 'authenticator');
    let authenticatorOptions = (authenticator === null || authenticator === void 0 ? void 0 : authenticator.options) || [];
    // OV is a special case, so process OV options
    authenticatorOptions = [...authenticatorOptions]; //clone it since we are changing it for OV
    (0, _ionObjectHandler.createOVOptions)(authenticatorOptions);
    return authenticatorOptions;
  }
  getActionByPath(actionPath) {
    const paths = actionPath.split('.');
    let targetObject;
    if (paths.length === 1) {
      targetObject = this.get('idx').actions;
    } else {
      targetObject = this.get(paths.shift());
    }
    // Limitation
    // At the time of writting, action only lives in first level of state objects.
    const actionName = paths.shift();
    if (targetObject && _mixins._.isFunction(targetObject[actionName])) {
      return targetObject[actionName];
    } else {
      return null;
    }
  }
  getCurrentViewState() {
    const currentFormName = this.get('currentFormName');
    if (!currentFormName) {
      return;
    }

    // didn't expect `remediations` is empty. See `setIonResponse`.
    const currentViewState = this.get('remediations').filter(r => r.name === currentFormName)[0];
    if (!currentViewState) {
      _Logger.default.error('Panic!!');
      _Logger.default.error(`\tCannot find view state for form ${currentFormName}.`);
      const allFormNames = this.get('remediations').map(r => r.name);
      _Logger.default.error(`\tAll available form names: ${allFormNames}`);
    }
    return currentViewState;
  }

  /**
   * Returns ui schema of the form field from current view state
   * @param {string} fieldName
   * @returns {}
   */
  getSchemaByName(fieldName) {
    const currentViewState = this.getCurrentViewState();
    if (currentViewState) {
      const uiSchema = currentViewState.uiSchema;
      return uiSchema.find(({
        name
      }) => name === fieldName);
    }
  }

  /**
   * Returns the displayName of the authenticator
   * @returns {string}
   */
  getAuthenticatorDisplayName() {
    const currentAuthenticator = this.get('currentAuthenticator') || {};
    const currentAuthenticatorEnrollment = this.get('currentAuthenticatorEnrollment') || {};

    // For enrollment and certain verification flows, the currentAuthenticator object will be present.
    // If not, we're likely in a traditional verify/challenge flow.
    return currentAuthenticator.displayName || currentAuthenticatorEnrollment.displayName;
  }

  /**
   * Checks to see if we're in an authenticator challenge flow.
   * @returns {boolean}
   */
  isAuthenticatorChallenge() {
    const currentFormName = this.get('currentFormName');
    return _RemediationConstants.FORMS_FOR_VERIFICATION.includes(currentFormName);
  }
  shouldReRenderView(transformedResponse) {
    var _transformedResponse$;
    if (transformedResponse !== null && transformedResponse !== void 0 && (_transformedResponse$ = transformedResponse.idx) !== null && _transformedResponse$ !== void 0 && _transformedResponse$.hasFormError) {
      return false;
    }
    const previousRawState = this.has('idx') ? this.get('idx').rawIdxState : null;
    const identicalResponse = _mixins._.isEqual(_mixins._.nestedOmit(transformedResponse.idx.rawIdxState, ['expiresAt', 'refresh', 'stateHandle', 'headers']), _mixins._.nestedOmit(previousRawState, ['expiresAt', 'refresh', 'stateHandle', 'headers']));
    if (identicalResponse) {
      this.set('dynamicRefreshInterval', this.getRefreshInterval(transformedResponse));
    }
    return this._isReRenderRequired(identicalResponse, transformedResponse, previousRawState);
  }
  getRefreshInterval(transformedResponse) {
    var _transformedResponse$2, _transformedResponse$3, _transformedResponse$4, _transformedResponse$5;
    // Only polling refresh interval has changed in the response,
    // make sure to update the correct poll view's refresh value
    const currentFormName = this.get('currentFormName');
    const currentViewState = transformedResponse.remediations.filter(r => r.name === currentFormName)[0];
    // Get new refresh interval for either: remediations, authenticator, or authenticator enrollment
    return currentViewState.refresh || ((_transformedResponse$2 = transformedResponse.currentAuthenticatorEnrollment) === null || _transformedResponse$2 === void 0 ? void 0 : (_transformedResponse$3 = _transformedResponse$2.poll) === null || _transformedResponse$3 === void 0 ? void 0 : _transformedResponse$3.refresh) || ((_transformedResponse$4 = transformedResponse.currentAuthenticator) === null || _transformedResponse$4 === void 0 ? void 0 : (_transformedResponse$5 = _transformedResponse$4.poll) === null || _transformedResponse$5 === void 0 ? void 0 : _transformedResponse$5.refresh);
  }

  // Sign Out link will be displayed in the footer of a form, unless:
  // - widget configuration set hideSignOutLinkInMFA or mfaOnlyFlow to true
  // - cancel remediation form is not present in the response
  // - form is part of our list FORMS_WITHOUT_SIGNOUT
  shouldShowSignOutLinkInCurrentForm(hideSignOutLinkInMFA) {
    const idxActions = this.get('idx') && this.get('idx').actions;
    const currentFormName = this.get('currentFormName');
    return !hideSignOutLinkInMFA && _mixins._.isFunction(idxActions === null || idxActions === void 0 ? void 0 : idxActions.cancel) && !_RemediationConstants.FORMS_WITHOUT_SIGNOUT.includes(currentFormName);
  }
  containsMessageWithI18nKey(keys) {
    if (!Array.isArray(keys)) {
      keys = [keys];
    }
    const messagesObjs = this.get('messages');
    return messagesObjs && Array.isArray(messagesObjs.value) && messagesObjs.value.some(messagesObj => {
      var _messagesObj$i18n;
      return _mixins._.contains(keys, (_messagesObj$i18n = messagesObj.i18n) === null || _messagesObj$i18n === void 0 ? void 0 : _messagesObj$i18n.key);
    });
  }
  containsMessageStartingWithI18nKey(keySubStr) {
    const messagesObjs = this.get('messages');
    return messagesObjs && Array.isArray(messagesObjs.value) && messagesObjs.value.some(messagesObj => {
      var _messagesObj$i18n2;
      return (_messagesObj$i18n2 = messagesObj.i18n) === null || _messagesObj$i18n2 === void 0 ? void 0 : _messagesObj$i18n2.key.startsWith(keySubStr);
    });
  }
  clearAppStateCache() {
    // clear appState before setting new values
    const attrs = {};
    for (const key in this.attributes) {
      if (key !== 'currentFormName' && key !== 'lastIdentifier') {
        attrs[key] = void 0;
      }
    }
    this.set(attrs, Object.assign({}, {
      unset: true,
      silent: true
    }));
    // clear cache for derived props.
    this.trigger('cache:clear');
  }
  chooseRemediation(transformedResponse) {
    var _transformedResponse$6, _transformedResponse$7;
    if (_mixins._.isEmpty(transformedResponse.remediations)) {
      return;
    }
    const firstRemediation = transformedResponse.remediations[0];

    // Special case: Okta Verify: show select enrollment channel instead of QR code on mobile
    if (firstRemediation.name === 'enroll-poll' && this.get('authenticatorKey') === _RemediationConstants.AUTHENTICATOR_KEY.OV && (_BrowserFeatures.default.isAndroid() || _BrowserFeatures.default.isIOS()) && ((_transformedResponse$6 = transformedResponse.currentAuthenticator) === null || _transformedResponse$6 === void 0 ? void 0 : (_transformedResponse$7 = _transformedResponse$6.contextualData) === null || _transformedResponse$7 === void 0 ? void 0 : _transformedResponse$7.selectedChannel) === 'qrcode') {
      return transformedResponse.remediations.find(r => r.name === 'select-enrollment-channel');
    }

    // Default case: return the first remediation in the list
    return firstRemediation;
  }
  async setIonResponse(transformedResponse) {
    const doRerender = this.shouldReRenderView(transformedResponse);
    this.clearAppStateCache();
    // set new app state properties
    this.set(transformedResponse);
    if (doRerender) {
      var _this$hooks;
      const remediation = this.chooseRemediation(transformedResponse);
      let currentFormName = null;
      if (remediation) {
        currentFormName = remediation.name;
      } else {
        _Logger.default.error('Panic!!');
        _Logger.default.error('\tNo remediation found.');
        _Logger.default.error('\tHere is the entire response');
        _Logger.default.error(JSON.stringify(transformedResponse, null, 2));
      }
      const hook = (_this$hooks = this.hooks) === null || _this$hooks === void 0 ? void 0 : _this$hooks.getHook(currentFormName); // may be undefined
      await (0, _Hooks.executeHooksBefore)(hook);
      this.unset('currentFormName', {
        silent: true
      });
      // make sure change `currentFormName` is last step.
      // change `currentFormName` will re-render FormController,
      // which may depend on other derived properties hence
      // those derived properties must be re-computed before
      // re-rendering controller.
      this.set({
        currentFormName
      });
      await (0, _Hooks.executeHooksAfter)(hook);
    }
  }
  setNonIdxError(error) {
    this.set('remediations', [{
      name: _RemediationConstants.FORMS.TERMINAL
    }]);
    this.set('messages', {
      value: [{
        message: error.errorDetails.errorSummary,
        class: 'ERROR'
      }]
    });
    this.set('currentFormName', _RemediationConstants.FORMS.TERMINAL);
  }
  getUser() {
    return this.get('user');
  }
  _isReRenderRequired(identicalResponse, transformedResponse, previousRawState) {
    var _this$get3;
    let reRender = true;
    const isPreviousStateError = (_this$get3 = this.get('idx')) === null || _this$get3 === void 0 ? void 0 : _this$get3.hasFormError;
    if (isPreviousStateError && this._isChallengeAuthenticatorPoll(transformedResponse, previousRawState)) {
      reRender = false;
    }
    if (identicalResponse) {
      /**
       * returns false: When new response is same as last.
       * usually happens during polling when pipeline doesn't proceed to next step.
       * expiresAt will be different for each response, hence compare objects without that property
       */
      reRender = false;
      if (this.get('currentFormName') === 'poll') {
        /**
         * returns true: We want to force reRender when currentForm is poll because request has to reinitiate
         * based on new refresh and UI has to reflect new timer.
         * We dont technical poll here we just make a request after the specified refresh time each time
         * we get a new response.
         */
        reRender = true;
      } else if (_RemediationConstants.FORMS_WITH_STATIC_BACK_LINK.includes(this.get('currentFormName'))) {
        /**
         * returns true: We want to force reRender if you go back to selection screen from challenge or enroll screen
         * and re-select the same authenticator for challenge. In this case also new response will be identical
         * to the old response.
         */
        reRender = true;
      } else if (this.containsMessageWithI18nKey(UNKNOWN_USER_I8N_KEY)) {
        /**
         * Need to re-render or else form will be stuck in saving mode.
         * This message is a form warning that can result in identical responses if the user enters the same
         * username as the one in the last message warning.
         */
        reRender = true;
      }
    }
    return reRender;
  }

  /**
   * This is to account for the edge case introduced by this issue: OKTA-419210. With the current idx remediations,
   * there's no good way to generalize this as the backend handles the authenticators for phone, sms and 
   * email differently. Although not ideal, we have to keep this check in for now until we find a better solution.
   */
  _isChallengeAuthenticatorPoll(transformedResponse, previousRawState) {
    var _this$get4;
    const isSameExceptMessages = _mixins._.isEqual(_mixins._.nestedOmit(transformedResponse.idx.rawIdxState, ['expiresAt', 'refresh', 'stateHandle', 'headers']), _mixins._.nestedOmit(previousRawState, ['expiresAt', 'refresh', 'stateHandle', 'messages', 'headers']));
    const isChallengeAuthenticator = this.get('currentFormName') === 'challenge-authenticator';
    const isCurrentAuthenticatorEmail = ((_this$get4 = this.get('currentAuthenticatorEnrollment')) === null || _this$get4 === void 0 ? void 0 : _this$get4.key) === _RemediationConstants.AUTHENTICATOR_KEY.EMAIL;
    return isSameExceptMessages && isChallengeAuthenticator && isCurrentAuthenticatorEmail;
  }
}
exports["default"] = AppState;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/ViewFactory.ts":
/*!********************************************!*\
  !*** ./src/v2/view-builder/ViewFactory.ts ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _Logger = _interopRequireDefault(__webpack_require__(/*! util/Logger */ "./src/util/Logger.js"));
var _RemediationConstants = __webpack_require__(/*! ../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _internals = __webpack_require__(/*! ./internals */ "./src/v2/view-builder/internals/index.js");
var _IdentifierView = _interopRequireDefault(__webpack_require__(/*! ./views/IdentifierView */ "./src/v2/view-builder/views/IdentifierView.js"));
var _RedirectIdPView = _interopRequireDefault(__webpack_require__(/*! ./views/RedirectIdPView */ "./src/v2/view-builder/views/RedirectIdPView.js"));
var _IdentifyRecoveryView = _interopRequireDefault(__webpack_require__(/*! ./views/IdentifyRecoveryView */ "./src/v2/view-builder/views/IdentifyRecoveryView.js"));
var _TerminalView = _interopRequireDefault(__webpack_require__(/*! ./views/TerminalView */ "./src/v2/view-builder/views/TerminalView.js"));
var _AutoRedirectView = _interopRequireDefault(__webpack_require__(/*! ./views/AutoRedirectView */ "./src/v2/view-builder/views/AutoRedirectView.js"));
var _PollView = _interopRequireDefault(__webpack_require__(/*! ./views/PollView */ "./src/v2/view-builder/views/PollView.js"));
var _AdminConsentView = _interopRequireDefault(__webpack_require__(/*! ./views/consent/AdminConsentView */ "./src/v2/view-builder/views/consent/AdminConsentView.js"));
var _EnduserConsentView = _interopRequireDefault(__webpack_require__(/*! ./views/consent/EnduserConsentView */ "./src/v2/view-builder/views/consent/EnduserConsentView.js"));
var _GranularConsentView = _interopRequireDefault(__webpack_require__(/*! ./views/consent/GranularConsentView */ "./src/v2/view-builder/views/consent/GranularConsentView.js"));
var _EnduserEmailConsentView = _interopRequireDefault(__webpack_require__(/*! ./views/consent/EnduserEmailConsentView */ "./src/v2/view-builder/views/consent/EnduserEmailConsentView.js"));
var _DeviceChallengePollView = _interopRequireDefault(__webpack_require__(/*! ./views/device/DeviceChallengePollView */ "./src/v2/view-builder/views/device/DeviceChallengePollView.js"));
var _SSOExtensionView = _interopRequireDefault(__webpack_require__(/*! ./views/device/SSOExtensionView */ "./src/v2/view-builder/views/device/SSOExtensionView.js"));
var _SignInDeviceView = _interopRequireDefault(__webpack_require__(/*! ./views/device/SignInDeviceView */ "./src/v2/view-builder/views/device/SignInDeviceView.js"));
var _DeviceEnrollmentTerminalView = _interopRequireDefault(__webpack_require__(/*! ./views/device/DeviceEnrollmentTerminalView */ "./src/v2/view-builder/views/device/DeviceEnrollmentTerminalView.js"));
var _EnrollProfileView = _interopRequireDefault(__webpack_require__(/*! ./views/EnrollProfileView */ "./src/v2/view-builder/views/EnrollProfileView.js"));
var _EnrollProfileUpdateView = _interopRequireDefault(__webpack_require__(/*! ./views/EnrollProfileUpdateView */ "./src/v2/view-builder/views/EnrollProfileUpdateView.js"));
var _RequestActivationEmailView = _interopRequireDefault(__webpack_require__(/*! ./views/activation/RequestActivationEmailView */ "./src/v2/view-builder/views/activation/RequestActivationEmailView.js"));
var _SelectAuthenticatorEnrollView = _interopRequireDefault(__webpack_require__(/*! ./views/SelectAuthenticatorEnrollView */ "./src/v2/view-builder/views/SelectAuthenticatorEnrollView.js"));
var _SelectAuthenticatorVerifyView = _interopRequireDefault(__webpack_require__(/*! ./views/SelectAuthenticatorVerifyView */ "./src/v2/view-builder/views/SelectAuthenticatorVerifyView.js"));
var _SelectAuthenticatorUnlockAccountView = _interopRequireDefault(__webpack_require__(/*! ./views/authenticator/SelectAuthenticatorUnlockAccountView */ "./src/v2/view-builder/views/authenticator/SelectAuthenticatorUnlockAccountView.js"));
var _EnrollAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(/*! ./views/password/EnrollAuthenticatorPasswordView */ "./src/v2/view-builder/views/password/EnrollAuthenticatorPasswordView.js"));
var _ChallengeAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(/*! ./views/password/ChallengeAuthenticatorPasswordView */ "./src/v2/view-builder/views/password/ChallengeAuthenticatorPasswordView.js"));
var _ReEnrollAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(/*! ./views/password/ReEnrollAuthenticatorPasswordView */ "./src/v2/view-builder/views/password/ReEnrollAuthenticatorPasswordView.js"));
var _ReEnrollAuthenticatorWarningPasswordView = _interopRequireDefault(__webpack_require__(/*! ./views/password/ReEnrollAuthenticatorWarningPasswordView */ "./src/v2/view-builder/views/password/ReEnrollAuthenticatorWarningPasswordView.js"));
var _ResetAuthenticatorPasswordView = _interopRequireDefault(__webpack_require__(/*! ./views/password/ResetAuthenticatorPasswordView */ "./src/v2/view-builder/views/password/ResetAuthenticatorPasswordView.js"));
var _EnrollAuthenticatorPhoneView = _interopRequireDefault(__webpack_require__(/*! ./views/phone/EnrollAuthenticatorPhoneView */ "./src/v2/view-builder/views/phone/EnrollAuthenticatorPhoneView.js"));
var _EnrollAuthenticatorDataPhoneView = _interopRequireDefault(__webpack_require__(/*! ./views/phone/EnrollAuthenticatorDataPhoneView */ "./src/v2/view-builder/views/phone/EnrollAuthenticatorDataPhoneView.js"));
var _ChallengeAuthenticatorPhoneView = _interopRequireDefault(__webpack_require__(/*! ./views/phone/ChallengeAuthenticatorPhoneView */ "./src/v2/view-builder/views/phone/ChallengeAuthenticatorPhoneView.js"));
var _ChallengeAuthenticatorDataPhoneView = _interopRequireDefault(__webpack_require__(/*! ./views/phone/ChallengeAuthenticatorDataPhoneView */ "./src/v2/view-builder/views/phone/ChallengeAuthenticatorDataPhoneView.js"));
var _EnrollAuthenticatorSecurityQuestionView = _interopRequireDefault(__webpack_require__(/*! ./views/security-question/EnrollAuthenticatorSecurityQuestionView */ "./src/v2/view-builder/views/security-question/EnrollAuthenticatorSecurityQuestionView.js"));
var _ChallengeAuthenticatorSecurityQuestion = _interopRequireDefault(__webpack_require__(/*! ./views/security-question/ChallengeAuthenticatorSecurityQuestion */ "./src/v2/view-builder/views/security-question/ChallengeAuthenticatorSecurityQuestion.js"));
var _EnrollWebauthnView = _interopRequireDefault(__webpack_require__(/*! ./views/webauthn/EnrollWebauthnView */ "./src/v2/view-builder/views/webauthn/EnrollWebauthnView.js"));
var _ChallengeWebauthnView = _interopRequireDefault(__webpack_require__(/*! ./views/webauthn/ChallengeWebauthnView */ "./src/v2/view-builder/views/webauthn/ChallengeWebauthnView.js"));
var _EnrollAuthenticatorEmailView = _interopRequireDefault(__webpack_require__(/*! ./views/email/EnrollAuthenticatorEmailView */ "./src/v2/view-builder/views/email/EnrollAuthenticatorEmailView.js"));
var _ChallengeAuthenticatorEmailView = _interopRequireDefault(__webpack_require__(/*! ./views/email/ChallengeAuthenticatorEmailView */ "./src/v2/view-builder/views/email/ChallengeAuthenticatorEmailView.js"));
var _ChallengeAuthenticatorDataEmailView = _interopRequireDefault(__webpack_require__(/*! ./views/email/ChallengeAuthenticatorDataEmailView */ "./src/v2/view-builder/views/email/ChallengeAuthenticatorDataEmailView.js"));
var _EnrollPollOktaVerifyView = _interopRequireDefault(__webpack_require__(/*! ./views/ov/EnrollPollOktaVerifyView */ "./src/v2/view-builder/views/ov/EnrollPollOktaVerifyView.js"));
var _SelectEnrollmentChannelOktaVerifyView = _interopRequireDefault(__webpack_require__(/*! ./views/ov/SelectEnrollmentChannelOktaVerifyView */ "./src/v2/view-builder/views/ov/SelectEnrollmentChannelOktaVerifyView.js"));
var _EnrollementChannelDataOktaVerifyView = _interopRequireDefault(__webpack_require__(/*! ./views/ov/EnrollementChannelDataOktaVerifyView */ "./src/v2/view-builder/views/ov/EnrollementChannelDataOktaVerifyView.js"));
var _ChallengeOktaVerifyView = _interopRequireDefault(__webpack_require__(/*! ./views/ov/ChallengeOktaVerifyView */ "./src/v2/view-builder/views/ov/ChallengeOktaVerifyView.js"));
var _ChallengeOktaVerifyTotpView = _interopRequireDefault(__webpack_require__(/*! ./views/ov/ChallengeOktaVerifyTotpView */ "./src/v2/view-builder/views/ov/ChallengeOktaVerifyTotpView.js"));
var _ChallengeOktaVerifyResendPushView = _interopRequireDefault(__webpack_require__(/*! ./views/ov/ChallengeOktaVerifyResendPushView */ "./src/v2/view-builder/views/ov/ChallengeOktaVerifyResendPushView.js"));
var _ChallengeOktaVerifyCustomAppDataView = _interopRequireDefault(__webpack_require__(/*! ./views/shared/ChallengeOktaVerifyCustomAppDataView */ "./src/v2/view-builder/views/shared/ChallengeOktaVerifyCustomAppDataView.js"));
var _ChallengeOktaVerifySSOExtensionView = _interopRequireDefault(__webpack_require__(/*! ./views/ov/ChallengeOktaVerifySSOExtensionView */ "./src/v2/view-builder/views/ov/ChallengeOktaVerifySSOExtensionView.js"));
var _EnrollAuthenticatorGoogleAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ./views/google-authenticator/EnrollAuthenticatorGoogleAuthenticatorView */ "./src/v2/view-builder/views/google-authenticator/EnrollAuthenticatorGoogleAuthenticatorView.js"));
var _ChallengeGoogleAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ./views/google-authenticator/ChallengeGoogleAuthenticatorView */ "./src/v2/view-builder/views/google-authenticator/ChallengeGoogleAuthenticatorView.js"));
var _EnrollAuthenticatorOnPremView = _interopRequireDefault(__webpack_require__(/*! ./views/on-prem/EnrollAuthenticatorOnPremView */ "./src/v2/view-builder/views/on-prem/EnrollAuthenticatorOnPremView.js"));
var _ChallengeAuthenticatorOnPremView = _interopRequireDefault(__webpack_require__(/*! ./views/on-prem/ChallengeAuthenticatorOnPremView */ "./src/v2/view-builder/views/on-prem/ChallengeAuthenticatorOnPremView.js"));
var _EnrollDuoAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ./views/duo/EnrollDuoAuthenticatorView */ "./src/v2/view-builder/views/duo/EnrollDuoAuthenticatorView.js"));
var _ChallengeDuoAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ./views/duo/ChallengeDuoAuthenticatorView */ "./src/v2/view-builder/views/duo/ChallengeDuoAuthenticatorView.js"));
var _AuthenticatorIdPVerifyView = _interopRequireDefault(__webpack_require__(/*! ./views/idp/AuthenticatorIdPVerifyView */ "./src/v2/view-builder/views/idp/AuthenticatorIdPVerifyView.js"));
var _AuthenticatorIdPEnrollView = _interopRequireDefault(__webpack_require__(/*! ./views/idp/AuthenticatorIdPEnrollView */ "./src/v2/view-builder/views/idp/AuthenticatorIdPEnrollView.js"));
var _ChallengeCustomOTPAuthenticatorView = _interopRequireDefault(__webpack_require__(/*! ./views/custom-otp/ChallengeCustomOTPAuthenticatorView */ "./src/v2/view-builder/views/custom-otp/ChallengeCustomOTPAuthenticatorView.js"));
var _AuthenticatorSymantecView = _interopRequireDefault(__webpack_require__(/*! ./views/symantec/AuthenticatorSymantecView */ "./src/v2/view-builder/views/symantec/AuthenticatorSymantecView.js"));
var _DeviceCodeActivateView = _interopRequireDefault(__webpack_require__(/*! ./views/device/DeviceCodeActivateView */ "./src/v2/view-builder/views/device/DeviceCodeActivateView.js"));
var _ChallengePIVView = _interopRequireDefault(__webpack_require__(/*! ./views/piv/ChallengePIVView */ "./src/v2/view-builder/views/piv/ChallengePIVView.js"));
var _AuthenticatorYubiKeyView = _interopRequireDefault(__webpack_require__(/*! ./views/yubikey/AuthenticatorYubiKeyView */ "./src/v2/view-builder/views/yubikey/AuthenticatorYubiKeyView.js"));
var _ChallengePushView = _interopRequireDefault(__webpack_require__(/*! ./views/shared/ChallengePushView */ "./src/v2/view-builder/views/shared/ChallengePushView.js"));
var _ChallengeCustomAppResendPushView = _interopRequireDefault(__webpack_require__(/*! ./views/custom-app/ChallengeCustomAppResendPushView */ "./src/v2/view-builder/views/custom-app/ChallengeCustomAppResendPushView.js"));
var _ReEnrollCustomPasswordExpiryView = _interopRequireDefault(__webpack_require__(/*! ./views/custom-password/ReEnrollCustomPasswordExpiryView */ "./src/v2/view-builder/views/custom-password/ReEnrollCustomPasswordExpiryView.js"));
var _ReEnrollCustomPasswordExpiryWarningView = _interopRequireDefault(__webpack_require__(/*! ./views/custom-password/ReEnrollCustomPasswordExpiryWarningView */ "./src/v2/view-builder/views/custom-password/ReEnrollCustomPasswordExpiryWarningView.js"));
var _PostAuthKeepMeSignedInView = _interopRequireDefault(__webpack_require__(/*! ./views/keep-me-signed-in/PostAuthKeepMeSignedInView */ "./src/v2/view-builder/views/keep-me-signed-in/PostAuthKeepMeSignedInView.js"));
var _UnlockAccountView = _interopRequireDefault(__webpack_require__(/*! ./views/authenticator/UnlockAccountView */ "./src/v2/view-builder/views/authenticator/UnlockAccountView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Identify

// Terminal & Auto-Redirect

// safe mode poll view

// consent

// Device (Okta Verify)

// registration

// registration update

// Email Activation

// authenticator list

// password

// phone

// security question

//webauthn

// email

// app (okta verify)

// app (google authenticator)

// on-prem mfa

// duo mfa

// idp authenticator

// custom otp

// Symantec VIP authenticator

// Device code activate view

// X509 PIV view

// YubiKey

// custom app

// custom password

// keep me signed in

// unlock account

const DEFAULT = '_';
const VIEWS_MAPPING = {
  [_RemediationConstants.FORMS.IDENTIFY]: {
    [DEFAULT]: _IdentifierView.default
  },
  [_RemediationConstants.FORMS.IDENTIFY_RECOVERY]: {
    [DEFAULT]: _IdentifyRecoveryView.default
  },
  [_RemediationConstants.FORMS.DEVICE_CHALLENGE_POLL]: {
    [DEFAULT]: _DeviceChallengePollView.default
  },
  [_RemediationConstants.FORMS.LAUNCH_AUTHENTICATOR]: {
    [DEFAULT]: _SignInDeviceView.default
  },
  [_RemediationConstants.FORMS.DEVICE_APPLE_SSO_EXTENSION]: {
    [DEFAULT]: _SSOExtensionView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.OV]: _ChallengeOktaVerifySSOExtensionView.default
  },
  [_RemediationConstants.FORMS.CANCEL_TRANSACTION]: {
    [DEFAULT]: _SSOExtensionView.default
  },
  [_RemediationConstants.FORMS.ENROLL_PROFILE]: {
    [DEFAULT]: _EnrollProfileView.default
  },
  [_RemediationConstants.FORMS.ENROLL_PROFILE_UPDATE]: {
    [DEFAULT]: _EnrollProfileUpdateView.default
  },
  [_RemediationConstants.FORMS.POLL]: {
    [DEFAULT]: _PollView.default
  },
  [_RemediationConstants.FORMS.REQUEST_ACTIVATION]: {
    [DEFAULT]: _RequestActivationEmailView.default
  },
  [_RemediationConstants.FORMS.SELECT_AUTHENTICATOR_ENROLL]: {
    [DEFAULT]: _SelectAuthenticatorEnrollView.default
  },
  [_RemediationConstants.FORMS.AUTHENTICATOR_ENROLLMENT_DATA]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.PHONE]: _EnrollAuthenticatorDataPhoneView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.EMAIL]: _ChallengeAuthenticatorDataEmailView.default
  },
  [_RemediationConstants.FORMS.CONSENT_ADMIN]: {
    [DEFAULT]: _AdminConsentView.default
  },
  [_RemediationConstants.FORMS.CONSENT_ENDUSER]: {
    [DEFAULT]: _EnduserConsentView.default
  },
  [_RemediationConstants.FORMS.CONSENT_GRANULAR]: {
    [DEFAULT]: _GranularConsentView.default
  },
  [_RemediationConstants.FORMS.CONSENT_EMAIL_CHALLENGE]: {
    [DEFAULT]: _EnduserEmailConsentView.default
  },
  [_RemediationConstants.FORMS.ENROLL_AUTHENTICATOR]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.DUO]: _EnrollDuoAuthenticatorView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.EMAIL]: _EnrollAuthenticatorEmailView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.GOOGLE_OTP]: _EnrollAuthenticatorGoogleAuthenticatorView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.IDP]: _AuthenticatorIdPEnrollView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.ON_PREM]: _EnrollAuthenticatorOnPremView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.PASSWORD]: _EnrollAuthenticatorPasswordView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.PHONE]: _EnrollAuthenticatorPhoneView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.RSA]: _EnrollAuthenticatorOnPremView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.SECURITY_QUESTION]: _EnrollAuthenticatorSecurityQuestionView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.SYMANTEC_VIP]: _AuthenticatorSymantecView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.WEBAUTHN]: _EnrollWebauthnView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.YUBIKEY]: _AuthenticatorYubiKeyView.default
  },
  [_RemediationConstants.FORMS.CHALLENGE_AUTHENTICATOR]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_OTP]: _ChallengeCustomOTPAuthenticatorView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.DUO]: _ChallengeDuoAuthenticatorView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.EMAIL]: _ChallengeAuthenticatorEmailView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.GOOGLE_OTP]: _ChallengeGoogleAuthenticatorView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.IDP]: _AuthenticatorIdPVerifyView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.ON_PREM]: _ChallengeAuthenticatorOnPremView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.OV]: _ChallengeOktaVerifyTotpView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.PASSWORD]: _ChallengeAuthenticatorPasswordView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.PHONE]: _ChallengeAuthenticatorPhoneView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.RSA]: _ChallengeAuthenticatorOnPremView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.SECURITY_QUESTION]: _ChallengeAuthenticatorSecurityQuestion.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.SYMANTEC_VIP]: _AuthenticatorSymantecView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.WEBAUTHN]: _ChallengeWebauthnView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.YUBIKEY]: _AuthenticatorYubiKeyView.default
  },
  [_RemediationConstants.FORMS.ENROLL_POLL]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.OV]: _EnrollPollOktaVerifyView.default
  },
  [_RemediationConstants.FORMS.SELECT_ENROLLMENT_CHANNEL]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.OV]: _SelectEnrollmentChannelOktaVerifyView.default
  },
  [_RemediationConstants.FORMS.ENROLLMENT_CHANNEL_DATA]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.OV]: _EnrollementChannelDataOktaVerifyView.default
  },
  // Expired scenarios for authenticators..
  [_RemediationConstants.FORMS.REENROLL_AUTHENTICATOR]: {
    // Password expired scenario..
    [_RemediationConstants.AUTHENTICATOR_KEY.PASSWORD]: _ReEnrollAuthenticatorPasswordView.default
  },
  [_RemediationConstants.FORMS.REENROLL_CUSTOM_PASSWORD_EXPIRY]: {
    // Custom password expired scenario
    [_RemediationConstants.AUTHENTICATOR_KEY.PASSWORD]: _ReEnrollCustomPasswordExpiryView.default
  },
  [_RemediationConstants.FORMS.REENROLL_CUSTOM_PASSWORD_EXPIRY_WARNING]: {
    // Custom password expiry warning scenario
    [_RemediationConstants.AUTHENTICATOR_KEY.PASSWORD]: _ReEnrollCustomPasswordExpiryWarningView.default
  },
  // Will expire soon warnings for authenticators..
  [_RemediationConstants.FORMS.REENROLL_AUTHENTICATOR_WARNING]: {
    // Password will expire soon scenario..
    [_RemediationConstants.AUTHENTICATOR_KEY.PASSWORD]: _ReEnrollAuthenticatorWarningPasswordView.default
  },
  // Reset forms for authenticators..
  [_RemediationConstants.FORMS.RESET_AUTHENTICATOR]: {
    // Admin driven password reset..
    [_RemediationConstants.AUTHENTICATOR_KEY.PASSWORD]: _ResetAuthenticatorPasswordView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.GOOGLE_OTP]: _EnrollAuthenticatorGoogleAuthenticatorView.default
  },
  [_RemediationConstants.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE]: {
    [DEFAULT]: _SelectAuthenticatorVerifyView.default
  },
  [_RemediationConstants.FORMS.SELECT_AUTHENTICATOR_UNLOCK]: {
    [DEFAULT]: _SelectAuthenticatorUnlockAccountView.default
  },
  [_RemediationConstants.FORMS.UNLOCK_ACCOUNT]: {
    [DEFAULT]: _UnlockAccountView.default
  },
  [_RemediationConstants.FORMS.CHALLENGE_POLL]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.OV]: _ChallengeOktaVerifyView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_APP]: _ChallengePushView.default
  },
  [_RemediationConstants.FORMS.RESEND]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.OV]: _ChallengeOktaVerifyResendPushView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_APP]: _ChallengeCustomAppResendPushView.default
  },
  [_RemediationConstants.FORMS.AUTHENTICATOR_VERIFICATION_DATA]: {
    [_RemediationConstants.AUTHENTICATOR_KEY.PHONE]: _ChallengeAuthenticatorDataPhoneView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.OV]: _ChallengeOktaVerifyCustomAppDataView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.EMAIL]: _ChallengeAuthenticatorDataEmailView.default,
    [_RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_APP]: _ChallengeOktaVerifyCustomAppDataView.default
  },
  [_RemediationConstants.FORMS.FAILURE_REDIRECT]: {
    [DEFAULT]: _AutoRedirectView.default
  },
  [_RemediationConstants.FORMS.SUCCESS_REDIRECT]: {
    [DEFAULT]: _AutoRedirectView.default
  },
  [_RemediationConstants.FORMS.REDIRECT_IDP]: {
    [DEFAULT]: _RedirectIdPView.default
  },
  [_RemediationConstants.FORMS.PIV_IDP]: {
    [DEFAULT]: _ChallengePIVView.default
  },
  [_RemediationConstants.FORMS.DEVICE_ENROLLMENT_TERMINAL]: {
    [DEFAULT]: _DeviceEnrollmentTerminalView.default
  },
  [_RemediationConstants.FORMS.USER_CODE]: {
    [DEFAULT]: _DeviceCodeActivateView.default
  },
  [_RemediationConstants.FORMS.KEEP_ME_SIGNED_IN]: {
    [DEFAULT]: _PostAuthKeepMeSignedInView.default
  },
  [_RemediationConstants.FORMS.TERMINAL]: {
    [DEFAULT]: _TerminalView.default
  }
};
var _default = {
  create(formName, authenticatorKey = DEFAULT) {
    const config = VIEWS_MAPPING[formName];
    if (!config) {
      _Logger.default.warn(`Cannot find customized View for ${formName}.`);
      return _internals.BaseView;
    }
    const View = config[authenticatorKey] || config[DEFAULT];
    if (!View) {
      _Logger.default.warn(`Cannot find customized View for ${formName} + ${authenticatorKey}.`);
      return _internals.BaseView;
    }
    return View;
  }
};
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/internals/BaseForm.ts":
/*!***************************************************!*\
  !*** ./src/v2/view-builder/internals/BaseForm.ts ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _runtime = _interopRequireDefault(__webpack_require__(/*! handlebars/runtime */ "./packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js"));
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var FormInputFactory = _interopRequireWildcard(__webpack_require__(/*! ./FormInputFactory */ "./src/v2/view-builder/internals/FormInputFactory.ts"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const {
  FormUtil
} = _courage.internal.views.forms.helpers;
const INFO_MESSAGE_CLASS = 'INFO';
var _default = _courage.Form.extend({
  layout: 'o-form-theme',
  className: 'ion-form',
  hasSavingState: true,
  autoSave: false,
  noCancelButton: true,
  title() {
    return (0, _courage.loc)('oform.title.authenticate', 'login');
  },
  save() {
    return (0, _courage.loc)('oform.next', 'login');
  },
  modelEvents: {
    'clearFormError': 'handleClearFormError',
    'error': 'triggerAfterError'
  },
  initialize() {
    const uiSchemas = this.getUISchema();
    const inputOptions = uiSchemas.map(FormInputFactory.create);

    //should be used before adding any other input components
    this.showMessages();

    // Render CAPTCHA if one of the form fields requires us to.
    this.listenTo(this.options.appState, 'onCaptchaLoaded', captchaObject => {
      this.captchaObject = captchaObject;
    });
    inputOptions.forEach(input => {
      this.addInputOrView(input);
    });
    this.listenTo(this, 'save', this.saveForm);
    this.listenTo(this, 'cancel', this.cancelForm);
  },
  focus(...args) {
    if (this.settings.get('features.autoFocus')) {
      _courage.Form.prototype.focus.apply(this, args);
    }
  },
  handleClearFormError() {
    const formErrorContainer = this.$('.o-form-error-container');
    formErrorContainer.empty();
    if (formErrorContainer.hasClass('o-form-has-errors')) {
      this.clearErrors();
    }
  },
  triggerAfterError(model, error) {
    this.options.appState.trigger('afterError', error);
  },
  saveForm(model) {
    //remove any existing warnings or messages before saving form
    this.$el.find('.o-form-error-container').empty();

    // Execute Captcha if enabled for this form.
    if (this.captchaObject) {
      this.captchaObject.execute();
    } else {
      this.options.appState.trigger('saveForm', model);
    }
  },
  postRender() {
    /**
     * Widget would use infoContainer to display interactive messages that should be persisted during
     * invalid form submissions. For eg resend-warning callout should not be cleared upon invalid form submit.
     * Rerender would clear infoContainer or views classes can clear it explicitly.
     */
    const infoContainer = '<div class=\'o-form-info-container\'></div>';
    this.$el.find('.o-form-error-container').attr('role', 'alert').before(infoContainer);
    this.addIdentifier();
  },
  /**
   * Render user identifier below title, or if no title, render below message.
   */
  addIdentifier() {
    const {
      identifier
    } = this.options.appState.get('user') || {};
    if (!identifier) {
      return;
    } else if (!this.settings.get('features.showIdentifier')) {
      return;
    }
    const header = this.$el.find('[data-se="o-form-head"]');
    const identifierHTMLString = _runtime.default.template({
      "compiler": [8, ">= 4.3.0"],
      "main": function (container, depth0, helpers, partials, data) {
        var helper,
          alias1 = depth0 != null ? depth0 : container.nullContext || {},
          alias2 = container.hooks.helperMissing,
          alias3 = "function",
          alias4 = container.escapeExpression,
          lookupProperty = container.lookupProperty || function (parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
              return parent[propertyName];
            }
            return undefined;
          };
        return "<div class=\"identifier-container\"><span class=\"identifier no-translate\" data-se=\"identifier\" title=\"" + alias4((helper = (helper = lookupProperty(helpers, "identifier") || (depth0 != null ? lookupProperty(depth0, "identifier") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
          "name": "identifier",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 100
            },
            "end": {
              "line": 1,
              "column": 114
            }
          }
        }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "identifier") || (depth0 != null ? lookupProperty(depth0, "identifier") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
          "name": "identifier",
          "hash": {},
          "data": data,
          "loc": {
            "start": {
              "line": 1,
              "column": 116
            },
            "end": {
              "line": 1,
              "column": 130
            }
          }
        }) : helper)) + "</span></div>";
      },
      "useData": true
    })({
      identifier
    });
    if (header.length) {
      header.after(identifierHTMLString);
    } else {
      this.$el.find('.o-form-error-container').after(identifierHTMLString);
    }
  },
  cancelForm() {
    this.options.appState.trigger('invokeAction', 'cancel');
  },
  getUISchema() {
    if (Array.isArray(this.options.currentViewState.uiSchema)) {
      return this.options.currentViewState.uiSchema;
    } else {
      return [];
    }
  },
  addInputOrView(input) {
    if (input.visible === false || input.mutable === false && input.visible !== true) {
      return;
    }
    if (input.View) {
      this.add(input.View, _courage._.omit(input, 'View', 'showWhen'));
      if (input.showWhen) {
        FormUtil.applyShowWhen(this.last(), input.showWhen);
      }
    } else {
      this.addInput(input);
    }
    if (Array.isArray(input.optionsUiSchemas)) {
      if (this.options.optionUiSchemaConfig[input.name]) {
        const optionUiSchemaIndex = Number(this.options.optionUiSchemaConfig[input.name]);
        const optionUiSchemas = input.optionsUiSchemas[optionUiSchemaIndex] || [];
        optionUiSchemas.forEach(this.addInputOrView.bind(this));
      }
    }
  },
  /*
  * Views should override this function to render custom error callouts for invalid form actions.
  * Should return true when callout is customized
  */
  showCustomFormErrorCallout: null,
  /*
   * Renders the contents of messages object (if any, on error) during initialize
   * This function is called during Form.initialize, and will display
   * messages when the form reloads.
   * Note: Any user action related form errors handled by FormController.showFormErrors
   */
  showMessages(options) {
    const messages = this.options.appState.get('messages') || {};
    const errContainer = '.o-form-error-container';
    if (Array.isArray(messages.value) && !(options instanceof _courage.View)) {
      this.add('<div class="ion-messages-container"></div>', errContainer);
      messages.value.forEach(obj => {
        if (!(obj !== null && obj !== void 0 && obj.class) || obj.class === INFO_MESSAGE_CLASS) {
          // add message as plain text
          this.add(`<p>${obj.message}</p>`, '.ion-messages-container');
        } else {
          const errorObj = {
            class: (obj === null || obj === void 0 ? void 0 : obj.class) ?? '',
            message: obj === null || obj === void 0 ? void 0 : obj.message,
            title: '',
            ...options
          };
          this.add((0, _courage.createCallout)({
            content: errorObj.message,
            type: errorObj.class.toLowerCase(),
            title: errorObj.title
          }), errContainer);
          options = null; // prevent repeating first error message
        }
      });
    } else if (options instanceof _courage.View) {
      // if callee is showCustomFormErrorCallout. show custom error views
      this.add(options, errContainer);
    }
  }
});
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/v2/view-builder/internals/FormInputFactory.ts":
/*!***********************************************************!*\
  !*** ./src/v2/view-builder/internals/FormInputFactory.ts ***!
  \***********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isTextOverflowing = exports.createIdpButtons = exports.createCustomButtons = exports.create = exports.addCustomButton = void 0;
var _courage = __webpack_require__(/*! @okta/courage */ "./packages/@okta/courage-dist/esm/src/index.js");
var _AuthenticatorEnrollOptions = _interopRequireDefault(__webpack_require__(/*! ../components/AuthenticatorEnrollOptions */ "./src/v2/view-builder/components/AuthenticatorEnrollOptions.js"));
var _AuthenticatorVerifyOptions = _interopRequireDefault(__webpack_require__(/*! ../components/AuthenticatorVerifyOptions */ "./src/v2/view-builder/components/AuthenticatorVerifyOptions.js"));
var _AuthenticatorUtil = __webpack_require__(/*! ../utils/AuthenticatorUtil */ "./src/v2/view-builder/utils/AuthenticatorUtil.js");
var _RemediationConstants = __webpack_require__(/*! ../../ion/RemediationConstants */ "./src/v2/ion/RemediationConstants.js");
var _IDP = _interopRequireDefault(__webpack_require__(/*! util/IDP */ "./src/util/IDP.js"));
var _ScopeList = _interopRequireDefault(__webpack_require__(/*! v1/views/admin-consent/ScopeList */ "./src/v1/views/admin-consent/ScopeList.js"));
var _ScopeList2 = _interopRequireDefault(__webpack_require__(/*! v1/views/consent/ScopeList */ "./src/v1/views/consent/ScopeList.js"));
var _CaptchaView = _interopRequireDefault(__webpack_require__(/*! ../views/captcha/CaptchaView */ "./src/v2/view-builder/views/captcha/CaptchaView.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const isTextOverflowing = (text, maxWidth) => {
  // Create a temporary element and attach it to the document so we can compare the client width to the 
  // max width allowed.
  const elem = document.createElement('div');
  elem.style.position = 'absolute';
  elem.style.left = '-9999px';
  elem.style.whiteSpace = 'nowrap';
  elem.innerHTML = text;
  document.body.appendChild(elem);
  const result = elem.clientWidth;
  document.body.removeChild(elem);
  return result > maxWidth;
};
exports.isTextOverflowing = isTextOverflowing;
const createAuthenticatorEnrollSelectView = opt => {
  const optionItems = (opt.options || []).map(opt => {
    return Object.assign({}, opt, (0, _AuthenticatorUtil.getAuthenticatorDataForEnroll)(opt));
  });
  return {
    View: _AuthenticatorEnrollOptions.default,
    options: {
      name: opt.name,
      collection: new _courage.Collection(optionItems)
    }
  };
};
const createAuthenticatorVerifySelectView = opt => {
  let optionItems = opt.options || [];
  // If webauthn enrollments > 1 just show one entry with a generic namne (first) so user doesnt have to select which
  // one to pick. eg) If there is yubikey5 and another unknown u2f key, user cannot identify that easily. We need to
  // do this at least  until users can give authenticator enrollments custom names.
  const authSet = new Set();
  optionItems = optionItems.filter(opt => {
    let isDuplicate;
    if (opt.authenticatorKey === _RemediationConstants.AUTHENTICATOR_KEY.WEBAUTHN) {
      isDuplicate = authSet.has(opt.authenticatorKey);
      authSet.add(opt.authenticatorKey);
    } else if (opt.authenticatorKey === _RemediationConstants.AUTHENTICATOR_KEY.CUSTOM_APP) {
      var _opt$value, _opt$value2;
      // Filter the duplicate enrollment by id for custom app. 
      isDuplicate = authSet.has(opt === null || opt === void 0 ? void 0 : (_opt$value = opt.value) === null || _opt$value === void 0 ? void 0 : _opt$value.id);
      authSet.add(opt === null || opt === void 0 ? void 0 : (_opt$value2 = opt.value) === null || _opt$value2 === void 0 ? void 0 : _opt$value2.id);
    }
    return !isDuplicate;
  });
  optionItems = optionItems.map(opt => {
    return Object.assign({}, opt, (0, _AuthenticatorUtil.getAuthenticatorDataForVerification)(opt));
  });
  return {
    View: _AuthenticatorVerifyOptions.default,
    options: {
      name: opt.name,
      collection: new _courage.Collection(optionItems)
    }
  };
};
const createAdminScopesView = () => {
  return {
    View: _ScopeList.default
  };
};
const createEnduserScopesView = () => {
  return {
    View: _ScopeList2.default
  };
};
const createCaptchaView = opt => {
  return {
    View: _CaptchaView.default,
    options: {
      name: opt.name
    }
  };
};
const inputCreationStrategy = {
  authenticatorEnrollSelect: createAuthenticatorEnrollSelectView,
  authenticatorVerifySelect: createAuthenticatorVerifySelectView,
  ['admin-consent']: createAdminScopesView,
  ['consent']: createEnduserScopesView,
  ['captcha']: createCaptchaView
};

// TODO: move logic to uiSchemaTransformer
const create = function (uiSchemaObj) {
  const strategyFn = inputCreationStrategy[uiSchemaObj.type] || _courage._.identity;
  return strategyFn(uiSchemaObj);
};
exports.create = create;
const createPIVButton = (settings, appState) => {
  const pivIdp = appState.get('remediations').filter(idp => idp.name === _RemediationConstants.FORMS.PIV_IDP);
  if (pivIdp.length < 1) {
    return [];
  }
  const pivConfig = settings.get('piv');
  const className = pivConfig.className || '';
  return [{
    attributes: {
      'data-se': 'piv-card-button'
    },
    className: className + ' piv-button',
    title: pivConfig.text || (0, _courage.loc)('piv.cac.card', 'login'),
    click: e => {
      e.preventDefault();
      appState.trigger('switchForm', _RemediationConstants.FORMS.PIV_IDP);
    }
  }];
};

/**
 * Example of `redirect-idp` remediation.
 * {
 *   "name": "redirect-idp",
 *   "type": "MICROSOFT",
 *   "idp": {
 *      "id": "0oa2szc1K1YPgz1pe0g4",
 *      "name": "Microsoft IDP"
 *    },
 *   "href": "http://localhost:3000/sso/idps/0oa2szc1K1YPgz1pe0g4?stateToken=BB...AA",
 *   "method": "GET"
 * }
 *
 */
const createIdpButtons = ({
  settings,
  appState
}) => {
  // This is the max allowable text width that we can display for IDP buttons.
  // Generated by taking the 316px width of button minus padding-left (90 px) and padding-right (50px)
  const MAX_IDP_BUTTON_WIDTH = 186;
  const redirectIdpRemediations = appState.get('remediations').filter(idp => idp.name === _RemediationConstants.FORMS.REDIRECT_IDP);
  if (!Array.isArray(redirectIdpRemediations)) {
    return [];
  }

  // create piv button
  const pivButton = createPIVButton(settings, appState);

  //add buttons from idp object
  const idpButtons = redirectIdpRemediations.map(idpObject => {
    var _idpObject$type;
    let type = (_idpObject$type = idpObject.type) === null || _idpObject$type === void 0 ? void 0 : _idpObject$type.toLowerCase();
    let displayName;
    if (!_courage._.contains(_IDP.default.SUPPORTED_SOCIAL_IDPS, type)) {
      var _idpObject$idp;
      type = 'general-idp';
      // OKTA-396684 - makes sure that custom idps always have a name
      displayName = (0, _courage.loc)('customauth.sign.in.with.label', 'login', [(_idpObject$idp = idpObject.idp) === null || _idpObject$idp === void 0 ? void 0 : _idpObject$idp.name]);
    } else {
      displayName = (0, _courage.loc)(`socialauth.${type}.label`, 'login');
    }
    const classNames = ['social-auth-button', `social-auth-${type}-button`];
    if (type === 'general-idp') {
      classNames.push('no-translate');
    }
    if (idpObject.idp.className) {
      classNames.push(idpObject.idp.className);
    }
    const button = {
      attributes: {
        'data-se': `social-auth-${type}-button`
      },
      className: classNames.join(' '),
      title: displayName,
      href: idpObject.href
    };
    if (isTextOverflowing(displayName, MAX_IDP_BUTTON_WIDTH)) {
      // We add a tooltip in case the name gets truncated if too long
      button.attributes.title = displayName;
    }
    return button;
  });
  return [...pivButton, ...idpButtons];
};
exports.createIdpButtons = createIdpButtons;
const createCustomButtons = settings => {
  const customButtons = settings.get('customButtons');
  return customButtons.map(customButton => {
    const button = {
      attributes: {
        'data-se': customButton.dataAttr
      },
      className: customButton.className + ' default-custom-button',
      title: customButton.title || (0, _courage.loc)(customButton.i18nKey, 'login'),
      click: customButton.click
    };
    return button;
  });
};
exports.createCustomButtons = createCustomButtons;
const addCustomButton = customButtonSettings => {
  return (0, _courage.createButton)({
    ...customButtonSettings,
    className: `${customButtonSettings.className} default-custom-button button-primary`
  });
};
exports.addCustomButton = addCustomButton;

/***/ }),

/***/ "./src/widget/OktaSignIn.ts":
/*!**********************************!*\
  !*** ./src/widget/OktaSignIn.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createOktaSignIn = createOktaSignIn;
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _Logger = _interopRequireDefault(__webpack_require__(/*! util/Logger */ "./src/util/Logger.js"));
var _getAuthClient = _interopRequireDefault(__webpack_require__(/*! widget/getAuthClient */ "./src/widget/getAuthClient.ts"));
var _buildRenderOptions = _interopRequireDefault(__webpack_require__(/*! widget/buildRenderOptions */ "./src/widget/buildRenderOptions.js"));
var _createRouter = _interopRequireDefault(__webpack_require__(/*! widget/createRouter */ "./src/widget/createRouter.js"));
var _Hooks = _interopRequireDefault(__webpack_require__(/*! models/Hooks */ "./src/models/Hooks.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint-disable @typescript-eslint/no-explicit-any */

const EVENTS_LIST = ['ready', 'afterError', 'afterRender'];
function createOktaSignIn(authClientConstructor, routerClassFactory) {
  return class OktaSignIn {
    // Map original event handler to wrapped one

    constructor(options) {
      this.Router = void 0;
      this.options = void 0;
      this.hooks = void 0;
      this.router = void 0;
      this.authClient = void 0;
      this._eventCallbackMap = void 0;
      _Util.default.debugMessage(`
          The Okta Sign-In Widget is running in development mode.
          When you are ready to publish your app, embed the minified version to turn on production mode.
          See: https://developer.okta.com/code/javascript/okta_sign-in_widget#cdn
        `);
      if (!options.stateToken) {
        var _window, _window$oktaData, _window$oktaData$sign;
        // need to set stateToken here vs in Settings to determine Router.
        // oktaData is only available to SIW on custom domains.
        // set stateToken in case user wipes out stateToken when overriding options.
        options.stateToken = (_window = window) === null || _window === void 0 ? void 0 : (_window$oktaData = _window.oktaData) === null || _window$oktaData === void 0 ? void 0 : (_window$oktaData$sign = _window$oktaData.signIn) === null || _window$oktaData$sign === void 0 ? void 0 : _window$oktaData$sign.stateToken;
      }
      this.options = options;
      this.authClient = (0, _getAuthClient.default)(authClientConstructor, options);

      // validate authClient configuration against widget options
      if (options.useClassicEngine !== true && this.authClient.options.clientId && this.authClient.isPKCE() === false) {
        throw new _Errors.ConfigError('OAuth2 with interaction code flow requires PKCE to be enabled on the authClient.');
      }

      // Hooks can be modified before or after render
      this.hooks = new _Hooks.default({
        hooks: options.hooks
      });
      this.Router = routerClassFactory(options);
      this._eventCallbackMap = new WeakMap();

      // Triggers the event up the chain so it is available to the consumers of the widget.
      this.Router.prototype.Events.listenTo.call(this, this.Router.prototype, 'all', this.trigger);

      // On the first afterRender event (usually when the Widget is ready) - emit a 'ready' event
      this.once('afterRender', function (context) {
        this.trigger('ready', context);
      });
    }

    /**
     * Render the sign in widget to an element. Returns a promise that will resolve on success or reject on error.
     * @param options - options for the signin widget.
     *        Must have an el or $el property to render the widget to.
     * @param success - success callback function
     * @param error - error callback function
     */
    renderEl(renderOptions, successFn, errorFn) {
      if (this.router) {
        throw new Error('An instance of the widget has already been rendered. Call remove() first.');
      }
      const res = (0, _createRouter.default)(this.Router, this.options, renderOptions, this.authClient, successFn, errorFn, this.hooks);
      this.router = res.router;
      return res.promise;
    }
    hide() {
      if (this.router) {
        this.router.hide();
      }
    }
    show() {
      if (this.router) {
        this.router.show();
      }
    }
    remove() {
      if (this.router) {
        this.router.remove();
        this.router = undefined;
      }
    }

    /**
     * Renders the Widget and returns a promise that resolves to OAuth tokens
     * @param options - options for the signin widget
     */
    showSignInToGetTokens(options) {
      const renderOptions = Object.assign((0, _buildRenderOptions.default)(this.options, options), {
        redirect: 'never'
      });
      const promise = this.renderEl(renderOptions).then(res => {
        return res.tokens;
      });
      const authClient = this.router.settings.getAuthClient();
      if (authClient.isAuthorizationCodeFlow() && !authClient.isPKCE()) {
        throw new _Errors.ConfigError('"showSignInToGetTokens()" should not be used for authorization_code flow. ' + 'Use "showSignInAndRedirect()" instead');
      }
      return promise;
    }

    /**
     * Renders the widget and redirects to the OAuth callback
     * @param options - options for the signin widget
     */
    showSignInAndRedirect(options) {
      const renderOptions = Object.assign((0, _buildRenderOptions.default)(this.options, options), {
        redirect: 'always'
      });
      return this.renderEl(renderOptions).then(() => {
        // This method should never return, it will either redirect or reject with error
        return;
      });
    }

    /**
     * Renders the widget. Either resolves the returned promise, or redirects.
     * @param options - options for the signin widget
     */
    showSignIn(options) {
      const renderOptions = Object.assign((0, _buildRenderOptions.default)(this.options, options));
      return this.renderEl(renderOptions);
    }

    // Hook convenience functions
    before(formName, callbackFn) {
      this.hooks.mergeHook(formName, {
        before: [callbackFn]
      });
    }
    after(formName, callbackFn) {
      this.hooks.mergeHook(formName, {
        after: [callbackFn]
      });
    }
    getUser() {
      var _this$router, _this$router$appState;
      return (_this$router = this.router) === null || _this$router === void 0 ? void 0 : (_this$router$appState = _this$router.appState) === null || _this$router$appState === void 0 ? void 0 : _this$router$appState.getUser();
    }

    // Events API

    on(event, callback) {
      // custom events listener on widget instance to trap third-party callback errors
      if (EVENTS_LIST.includes(event)) {
        const origCallback = callback;
        callback = function (...callbackArgs) {
          try {
            origCallback.apply(this, callbackArgs);
          } catch (err) {
            _Logger.default.error(`[okta-signin-widget] "${event}" event handler error:`, err);
          }
        };
        this._eventCallbackMap.set(origCallback, callback);
      }
      this.Router.prototype.Events.on.call(this, event, callback);
    }
    off(event, callback) {
      if (callback) {
        callback = this._eventCallbackMap.get(callback) || callback;
      }
      this.Router.prototype.Events.off.call(this, event, callback);
    }
    once(event, callback) {
      this.Router.prototype.Events.once.call(this, event, callback);
    }
    stopListening(event, callback) {
      this.Router.prototype.Events.stopListening.call(this, event, callback);
    }
    listenTo(object, event, callback) {
      this.Router.prototype.Events.listenTo.call(this, object, event, callback);
    }
    trigger(event, ...args) {
      this.Router.prototype.Events.trigger.apply(this, [event, ...args]);
    }
  };
}

/***/ }),

/***/ "./src/widget/getAuthClient.ts":
/*!*************************************!*\
  !*** ./src/widget/getAuthClient.ts ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getAuthClientInstance;
var _Errors = __webpack_require__(/*! util/Errors */ "./src/util/Errors.ts");
var _Util = _interopRequireDefault(__webpack_require__(/*! util/Util */ "./src/util/Util.js"));
var _config = _interopRequireDefault(__webpack_require__(/*! config/config.json */ "./src/config/config.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function getAuthClientInstance(OktaAuth, options = {}) {
  // if authClient is set, authParams are disregarded
  let {
    authClient,
    authParams
  } = options;
  if (!authClient) {
    // Create an authClient using widget options and optional authParams
    const {
      issuer,
      clientId,
      redirectUri,
      state,
      scopes,
      flow,
      codeChallenge,
      codeChallengeMethod,
      recoveryToken
    } = options;
    authParams = {
      issuer,
      clientId,
      redirectUri,
      state,
      scopes,
      flow,
      codeChallenge,
      codeChallengeMethod,
      transformErrorXHR: _Util.default.transformErrorXHR,
      recoveryToken,
      ...authParams
    };
    if (!authParams.issuer) {
      authParams.issuer = options.baseUrl + '/oauth2/default';
    }
    authClient = new OktaAuth(authParams);
  }

  // Add widget version to extended user agent header
  if (!authClient._oktaUserAgent) {
    throw new _Errors.ConfigError('The passed in authClient should be version 5.4.0 or above.');
  } else {
    authClient._oktaUserAgent.addEnvironment(`okta-signin-widget-${_config.default.version}`);
  }
  return authClient;
}
module.exports = exports.default;

/***/ }),

/***/ "./node_modules/@okta/okta-auth-js/umd/default.js":
/*!********************************************************!*\
  !*** ./node_modules/@okta/okta-auth-js/umd/default.js ***!
  \********************************************************/
/***/ (function(module) {

/*! For license information please see default.js.LICENSE.txt */
!function(e,t){ true?module.exports=t():0}(self,(function(){return function(){var e={9748:function(e,t,n){"use strict";n.d(t,{b:function(){return Z}});var r=n(5385),o=n(9123),i=n(1971);function a(e,t){var n={};return Object.assign(n,t),!n.stateToken&&e.stateToken&&(n.stateToken=e.stateToken),n}function u(e,t){return t=a(e,t),(0,r.v_)(e,e.getIssuerOrigin()+"/api/v1/authn",t,{withCredentials:!0})}function c(e){return!!f(e)}function s(e,t,n,o,i){return i=Object.assign({withCredentials:!0},i),(0,r.v_)(e,n,o,i).then((function(e){return t.createTransaction(e)}))}function f(e){return e.options.storageUtil.storage.get(i.STATE_TOKEN_KEY_NAME)}var l=n(3144),p=n(5671),h=n(4942),d=n(3193),v=n(4771),y=n(6718);function g(e,t,n,i,u,c){if(Array.isArray(u))return function(r,a){if(!r)throw new o.Z("Must provide a link name");var s=(0,d.sE)(u,{name:r});if(!s)throw new o.Z("No link found for that name");return g(e,t,n,i,s,c)(a)};if(u.hints&&u.hints.allow&&1===u.hints.allow.length)switch(u.hints.allow[0]){case"GET":return function(){return(0,r.U2)(e,u.href,{withCredentials:!0})};case"POST":return function(r){c&&c.isPolling&&(c.isPolling=!1);var f=a(n,r);"MFA_ENROLL"!==n.status&&"FACTOR_ENROLL"!==n.status||Object.assign(f,{factorType:i.factorType,provider:i.provider});var l={},p=f.autoPush;if(void 0!==p){if("function"==typeof p)try{l.autoPush=!!p()}catch(e){return Promise.reject(new o.Z("AutoPush resulted in an error."))}else null!==p&&(l.autoPush=!!p);f=(0,d.CE)(f,"autoPush")}var h=f.rememberDevice;if(void 0!==h){if("function"==typeof h)try{l.rememberDevice=!!h()}catch(e){return Promise.reject(new o.Z("RememberDevice resulted in an error."))}else null!==h&&(l.rememberDevice=!!h);f=(0,d.CE)(f,"rememberDevice")}else f.profile&&void 0!==f.profile.updatePhone&&(f.profile.updatePhone&&(l.updatePhone=!0),f.profile=(0,d.CE)(f.profile,"updatePhone"));var v=u.href+(0,y.UK)(l);return s(e,t,v,f)}}}var m=n(8750),b=n(6573);function k(e,t,n){return function(u){var c,s,f,l;(0,v.hj)(u)?c=u:(0,v.Kn)(u)&&(c=u.delay,s=u.rememberDevice,f=u.autoPush,l=u.transactionCallBack),c||0===c||(c=i.DEFAULT_POLLING_DELAY);var p=(0,d.Rg)(t,"next","poll");n.isPolling=!0;var h=0;return function i(){return n.isPolling?function(){var n={};if("function"==typeof f)try{n.autoPush=!!f()}catch(e){return Promise.reject(new o.Z("AutoPush resulted in an error."))}else null!=f&&(n.autoPush=!!f);if("function"==typeof s)try{n.rememberDevice=!!s()}catch(e){return Promise.reject(new o.Z("RememberDevice resulted in an error."))}else null!=s&&(n.rememberDevice=!!s);var i=p.href+(0,y.UK)(n);return(0,r.v_)(e,i,function(e){return a(e)}(t),{saveAuthnState:!1,withCredentials:!0})}().then((function(t){if(h=0,t.factorResult&&"WAITING"===t.factorResult){if(!n.isPolling)throw new b.Z;return"function"==typeof l&&l(t),(0,m.gw)(c).then(i)}return n.isPolling=!1,e.tx.createTransaction(t)})).catch((function(e){if(e.xhr&&(0===e.xhr.status||429===e.xhr.status)&&h<=4){var t=1e3*Math.pow(2,h);return h++,(0,m.gw)(t).then(i)}throw e})):Promise.reject(new b.Z)}().catch((function(e){throw n.isPolling=!1,e}))}}function w(e,t,n,r,o){if(r=r||n,r=(0,d.d9)(r),Array.isArray(r)){for(var i=[],a=0,u=r.length;a<u;a++)i.push(w(e,t,n,r[a],o));return i}var c=r._embedded||{};for(var s in c)Object.prototype.hasOwnProperty.call(c,s)&&((0,v.Kn)(c[s])||Array.isArray(c[s]))&&(c[s]=w(e,t,n,c[s],o));var f=function(e,t,n,r,o){var i={};for(var a in r._links)if(Object.prototype.hasOwnProperty.call(r._links,a)){var u=r._links[a];if("next"===a&&(a=u.name),u.type)i[a]=u;else if("poll"===a)i.poll=k(e,n,o);else{var c=g(e,t,n,r,u,o);c&&(i[a]=c)}}return i}(e,t,n,r,o);return Object.assign(c,f),r=(0,d.CE)(r,"_embedded","_links"),Object.assign(r,c),r}var O=(0,l.Z)((function e(t,n){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;(0,p.Z)(this,e),(0,h.Z)(this,"next",void 0),(0,h.Z)(this,"cancel",void 0),(0,h.Z)(this,"skip",void 0),(0,h.Z)(this,"unlock",void 0),(0,h.Z)(this,"changePassword",void 0),(0,h.Z)(this,"resetPassword",void 0),(0,h.Z)(this,"answer",void 0),(0,h.Z)(this,"recovery",void 0),(0,h.Z)(this,"verify",void 0),(0,h.Z)(this,"resend",void 0),(0,h.Z)(this,"activate",void 0),(0,h.Z)(this,"poll",void 0),(0,h.Z)(this,"prev",void 0),(0,h.Z)(this,"data",void 0),(0,h.Z)(this,"stateToken",void 0),(0,h.Z)(this,"sessionToken",void 0),(0,h.Z)(this,"status",void 0),(0,h.Z)(this,"user",void 0),(0,h.Z)(this,"factor",void 0),(0,h.Z)(this,"factors",void 0),(0,h.Z)(this,"policy",void 0),(0,h.Z)(this,"scopes",void 0),(0,h.Z)(this,"target",void 0),(0,h.Z)(this,"authentication",void 0),this.data=void 0,this.status=void 0,r&&(this.data=r,Object.assign(this,w(t,n,r,r,{})),delete this.stateToken,"RECOVERY_CHALLENGE"!==r.status||r._links||(this.cancel=function(){return Promise.resolve(n.createTransaction())}))}));function Z(e){var t={status:u.bind(null,e),resume:function(n){return function(e,t,n){if(!n||!n.stateToken){var r=f(e);if(!r)return Promise.reject(new o.Z("No transaction to resume"));n={stateToken:r}}return u(e,n).then((function(e){return t.createTransaction(e)}))}(e,t,n)},exists:c.bind(null,e),introspect:function(n){return function(e,t,n){if(!n||!n.stateToken){var i=f(e);if(!i)return Promise.reject(new o.Z("No transaction to evaluate"));n={stateToken:i}}return function(e,t){return t=a(e,t),(0,r.v_)(e,e.getIssuerOrigin()+"/api/v1/authn/introspect",t,{withCredentials:!0})}(e,n).then((function(e){return t.createTransaction(e)}))}(e,t,n)},createTransaction:function(n){return new O(e,t,n)},postToTransaction:function(n,r,o){return s(e,t,n,r,o)}};return t}},3398:function(e,t,n){"use strict";n.d(t,{b:function(){return r.b},t:function(){return o.t}});var r=n(9748),o=n(8284)},8284:function(e,t,n){"use strict";n.d(t,{t:function(){return b}});var r=n(5861),o=n(5671),i=n(3144),a=n(7326),u=n(136),c=n(2963),s=n(1120),f=n(4942),l=n(4687),p=n.n(l),h=n(3193),d=n(9123),v=n(415),y=n(4970);function g(e,t){return t=t||{},(0,v.isFingerprintSupported)()?new Promise((function(i,a){var u;(r=document.createElement("iframe")).style.display="none",o=function(t){if(t&&t.data&&t.origin===e.getIssuerOrigin()){try{var n=JSON.parse(t.data)}catch(e){return}if(n)return"FingerprintAvailable"===n.type?i(n.fingerprint):void("FingerprintServiceReady"===n.type&&t.source.postMessage(JSON.stringify({type:"GetFingerprint"}),t.origin))}},(0,y.NH)(window,"message",o),r.src=e.getIssuerOrigin()+"/auth/services/devicefingerprint",document.body.appendChild(r),n=setTimeout((function(){a(new d.Z("Fingerprinting timed out"))}),(null===(u=t)||void 0===u?void 0:u.timeout)||15e3)})).finally((function(){clearTimeout(n),(0,y.ys)(window,"message",o),document.body.contains(r)&&r.parentElement.removeChild(r)})):Promise.reject(new d.Z("Fingerprinting is not supported on this device"));var n,r,o}var m=n(9748);function b(e){return function(e){(0,u.Z)(y,e);var t,n,l,d,v=(l=y,d=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=(0,s.Z)(l);if(d){var n=(0,s.Z)(this).constructor;e=Reflect.construct(t,arguments,n)}else e=t.apply(this,arguments);return(0,c.Z)(this,e)});function y(){var e;(0,o.Z)(this,y);for(var t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];return e=v.call.apply(v,[this].concat(n)),(0,f.Z)((0,a.Z)(e),"tx",void 0),(0,f.Z)((0,a.Z)(e),"authn",void 0),(0,f.Z)((0,a.Z)(e),"fingerprint",void 0),e.authn=e.tx=(0,m.b)((0,a.Z)(e)),e.fingerprint=g.bind(null,(0,a.Z)(e)),e}return(0,i.Z)(y,[{key:"signIn",value:(n=(0,r.Z)(p().mark((function e(t){var n,r=this;return p().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=(0,h.d9)(t||{}),n=function(e){return delete t.sendFingerprint,r.tx.postToTransaction("/api/v1/authn",t,e)},t.sendFingerprint){e.next=4;break}return e.abrupt("return",n());case 4:return e.abrupt("return",this.fingerprint().then((function(e){return n({headers:{"X-Device-Fingerprint":e}})})));case 5:case"end":return e.stop()}}),e,this)}))),function(e){return n.apply(this,arguments)})},{key:"signInWithCredentials",value:(t=(0,r.Z)(p().mark((function e(t){return p().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.signIn(t));case 1:case"end":return e.stop()}}),e,this)}))),function(e){return t.apply(this,arguments)})},{key:"forgotPassword",value:function(e){return this.tx.postToTransaction("/api/v1/authn/recovery/password",e)}},{key:"unlockAccount",value:function(e){return this.tx.postToTransaction("/api/v1/authn/recovery/unlock",e)}},{key:"verifyRecoveryToken",value:function(e){return this.tx.postToTransaction("/api/v1/authn/recovery/token",e)}}]),y}(e)}},9893:function(e,t,n){"use strict";n.d(t,{a:function(){return l}});var r=n(3144),o=n(5671),i=n(4942),a=n(3193),u=n(415),c=n(1971),s=n(4279),f=n.n(s);function l(e){var t=(0,r.Z)((function t(){(0,o.Z)(this,t),(0,i.Z)(this,"options",void 0),(0,i.Z)(this,"emitter",void 0),(0,i.Z)(this,"features",void 0);var n=new e(arguments.length&&(arguments.length<=0?void 0:arguments[0])||{});this.options=(0,a.YY)(n),this.emitter=new(f()),this.features=u}));return(0,i.Z)(t,"features",u),(0,i.Z)(t,"constants",c),t.features=t.prototype.features=u,Object.assign(t,{constants:c}),t}},3306:function(e,t,n){"use strict";n.d(t,{X:function(){return o.X},a:function(){return r.a}});var r=n(9893),o=n(5093)},5093:function(e,t,n){"use strict";n.d(t,{X:function(){return a}});var r=n(3144),o=n(5671),i=n(4942);function a(){return(0,r.Z)((function e(t){(0,o.Z)(this,e),(0,i.Z)(this,"devMode",void 0),this.devMode=!!t.devMode}))}},4858:function(e,t,n){"use strict";function r(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)e[r]=n[r]}return e}n.d(t,{Z:function(){return f}});var o=function e(t,n){function o(e,o,i){if("undefined"!=typeof document){"number"==typeof(i=r({},n,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),e=encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var a="";for(var u in i)i[u]&&(a+="; "+u,!0!==i[u]&&(a+="="+i[u].split(";")[0]));return document.cookie=e+"="+t.write(o,e)+a}}return Object.create({set:o,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var n=document.cookie?document.cookie.split("; "):[],r={},o=0;o<n.length;o++){var i=n[o].split("="),a=i.slice(1).join("=");try{var u=decodeURIComponent(i[0]);if(r[u]=t.read(a,u),e===u)break}catch(e){}}return e?r[e]:r}},remove:function(e,t){o(e,"",r({},t,{expires:-1}))},withAttributes:function(t){return e(this.converter,r({},this.attributes,t))},withConverter:function(t){return e(r({},this.converter,t),this.attributes)}},{attributes:{value:Object.freeze(n)},converter:{value:Object.freeze(t)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"}),i=o,a=n(9123),u=n(146),c=n(415),s={browserHasLocalStorage:function(){try{var e=this.getLocalStorage();return this.testStorage(e)}catch(e){return!1}},browserHasSessionStorage:function(){try{var e=this.getSessionStorage();return this.testStorage(e)}catch(e){return!1}},testStorageType:function(e){var t=!1;switch(e){case"sessionStorage":t=this.browserHasSessionStorage();break;case"localStorage":t=this.browserHasLocalStorage();break;case"cookie":case"memory":t=!0;break;default:t=!1}return t},getStorageByType:function(e,t){var n;switch(e){case"sessionStorage":n=this.getSessionStorage();break;case"localStorage":n=this.getLocalStorage();break;case"cookie":n=this.getCookieStorage(t);break;case"memory":n=this.getInMemoryStorage();break;default:throw new a.Z("Unrecognized storage option: ".concat(e))}return n},findStorageType:function(e){var t,n;return t=(e=e.slice()).shift(),(n=e.length?e[0]:null)?this.testStorageType(t)?t:((0,u.ZK)("This browser doesn't support ".concat(t,". Switching to ").concat(n,".")),this.findStorageType(e)):t},getLocalStorage:function(){return(0,c.isIE11OrLess)()&&!window.onstorage&&(window.onstorage=function(){}),localStorage},getSessionStorage:function(){return sessionStorage},getCookieStorage:function(e){var t=this,n=e.secure,r=e.sameSite,o=e.sessionCookie;if(void 0===n||void 0===r)throw new a.Z('getCookieStorage: "secure" and "sameSite" options must be provided');var i={getItem:this.storage.get,setItem:function(e,i){var a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"2200-01-01T00:00:00.000Z";a=o?null:a,t.storage.set(e,i,a,{secure:n,sameSite:r})},removeItem:function(e){t.storage.delete(e)}};return e.useSeparateCookies?{getItem:function(e){var t=i.getItem(),n={};return Object.keys(t).forEach((function(r){0===r.indexOf(e)&&(n[r.replace("".concat(e,"_"),"")]=JSON.parse(t[r]))})),JSON.stringify(n)},setItem:function(e,t){var n=JSON.parse(this.getItem(e));t=JSON.parse(t),Object.keys(t).forEach((function(r){var o=e+"_"+r,a=JSON.stringify(t[r]);i.setItem(o,a),delete n[r]})),Object.keys(n).forEach((function(t){i.removeItem(e+"_"+t)}))},removeItem:function(e){var t=JSON.parse(this.getItem(e));Object.keys(t).forEach((function(t){i.removeItem(e+"_"+t)}))}}:i},inMemoryStore:{},getInMemoryStorage:function(){var e=this;return{getItem:function(t){return e.inMemoryStore[t]},setItem:function(t,n){e.inMemoryStore[t]=n}}},testStorage:function(e){var t="okta-test-storage";try{return e.setItem(t,t),e.removeItem(t),!0}catch(e){return!1}},storage:{set:function(e,t,n,r){var o=r.sameSite,u=r.secure;if(void 0===u||void 0===o)throw new a.Z('storage.set: "secure" and "sameSite" options must be provided');var c={path:r.path||"/",secure:u,sameSite:o};return Date.parse(n)&&(c.expires=new Date(n)),i.set(e,t,c),this.get(e)},get:function(e){return arguments.length?i.get(e):i.get()},delete:function(e){return i.remove(e,{path:"/"})}}},f=s},1971:function(e,t,n){"use strict";n.r(t),n.d(t,{ACCESS_TOKEN_STORAGE_KEY:function(){return d},CACHE_STORAGE_NAME:function(){return c},DEFAULT_CACHE_DURATION:function(){return a},DEFAULT_CODE_CHALLENGE_METHOD:function(){return k},DEFAULT_MAX_CLOCK_SKEW:function(){return i},DEFAULT_POLLING_DELAY:function(){return o},IDX_API_VERSION:function(){return w},IDX_RESPONSE_STORAGE_NAME:function(){return h},ID_TOKEN_STORAGE_KEY:function(){return v},MAX_VERIFIER_LENGTH:function(){return b},MIN_VERIFIER_LENGTH:function(){return m},ORIGINAL_URI_STORAGE_NAME:function(){return p},PKCE_STORAGE_NAME:function(){return s},REFERRER_PATH_STORAGE_KEY:function(){return g},REFRESH_TOKEN_STORAGE_KEY:function(){return y},SHARED_TRANSACTION_STORAGE_NAME:function(){return l},STATE_TOKEN_KEY_NAME:function(){return r},TOKEN_STORAGE_NAME:function(){return u},TRANSACTION_STORAGE_NAME:function(){return f}});var r="oktaStateToken",o=500,i=300,a=86400,u="okta-token-storage",c="okta-cache-storage",s="okta-pkce-storage",f="okta-transaction-storage",l="okta-shared-transaction-storage",p="okta-original-uri-storage",h="okta-idx-response-storage",d="accessToken",v="idToken",y="refreshToken",g="referrerPath",m=43,b=128,k="S256",w="1.0.0"},1018:function(e,t,n){"use strict";n.d(t,{E:function(){return k},a:function(){return g}});var r=n(5861),o=n(5671),i=n(3144),a=n(4942),u=n(4687),c=n.n(u),s=n(3615),f=n.n(s),l=n(9123),p=n(7088),h=n(3548),d=n(146);function v(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function y(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?v(Object(n),!0).forEach((function(t){(0,a.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):v(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var g=null,m={updateAuthStatePromise:null,canceledTimes:0},b="authStateChange",k=function(){function e(t){var n=this;if((0,o.Z)(this,e),(0,a.Z)(this,"_sdk",void 0),(0,a.Z)(this,"_pending",void 0),(0,a.Z)(this,"_authState",void 0),(0,a.Z)(this,"_prevAuthState",void 0),(0,a.Z)(this,"_logOptions",void 0),(0,a.Z)(this,"_transformQueue",void 0),!t.emitter)throw new l.Z("Emitter should be initialized before AuthStateManager");this._sdk=t,this._pending=y({},m),this._authState=g,this._logOptions={},this._prevAuthState=null,this._transformQueue=new h.b({quiet:!0}),t.tokenManager.on(p.O3,(function(e,t){n._setLogOptions({event:p.O3,key:e,token:t}),n.updateAuthState()})),t.tokenManager.on(p.FT,(function(e,t){n._setLogOptions({event:p.FT,key:e,token:t}),n.updateAuthState()}))}var t;return(0,i.Z)(e,[{key:"_setLogOptions",value:function(e){this._logOptions=e}},{key:"getAuthState",value:function(){return this._authState}},{key:"getPreviousAuthState",value:function(){return this._prevAuthState}},{key:"updateAuthState",value:(t=(0,r.Z)(c().mark((function e(){var t,n,r,o,i,a,u,s=this;return c().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=this._sdk.options,n=t.transformAuthState,r=t.devMode,o=function(e){var t=s._logOptions,n=t.event,r=t.key,o=t.token;(0,d.dr)().group("OKTA-AUTH-JS:updateAuthState: Event:".concat(n," Status:").concat(e)),(0,d.dr)().log(r,o),(0,d.dr)().log("Current authState",s._authState),(0,d.dr)().groupEnd(),s._logOptions={}},i=function(e){var t,n;n=e,(t=s._authState)&&t.isAuthenticated===n.isAuthenticated&&JSON.stringify(t.idToken)===JSON.stringify(n.idToken)&&JSON.stringify(t.accessToken)===JSON.stringify(n.accessToken)&&t.error===n.error?r&&o("unchanged"):(s._prevAuthState=s._authState,s._authState=e,s._sdk.emitter.emit(b,y({},e)),r&&o("emitted"))},a=function e(t){return s._pending.updateAuthStatePromise.then((function(){var n=s._pending.updateAuthStatePromise;return n&&n!==t?e(n):s.getAuthState()}))},!this._pending.updateAuthStatePromise){e.next=11;break}if(!(this._pending.canceledTimes>=10)){e.next=10;break}return r&&o("terminated"),e.abrupt("return",a(this._pending.updateAuthStatePromise));case 10:this._pending.updateAuthStatePromise.cancel();case 11:return u=new(f())((function(e,t,a){a.shouldReject=!1,a((function(){s._pending.updateAuthStatePromise=null,s._pending.canceledTimes=s._pending.canceledTimes+1,r&&o("canceled")}));var c=function(t){u.isCanceled?e():(i(t),e(),s._pending=y({},m))};s._sdk.isAuthenticated().then((function(){if(u.isCanceled)e();else{var t=s._sdk.tokenManager.getTokensSync(),r=t.accessToken,o=t.idToken,i=t.refreshToken,a={accessToken:r,idToken:o,refreshToken:i,isAuthenticated:!(!r||!o)};(n?s._transformQueue.push(n,null,s._sdk,a):Promise.resolve(a)).then((function(e){return c(e)})).catch((function(e){return c({accessToken:r,idToken:o,refreshToken:i,isAuthenticated:!1,error:e})}))}}))})),this._pending.updateAuthStatePromise=u,e.abrupt("return",a(u));case 14:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"subscribe",value:function(e){this._sdk.emitter.on(b,e)}},{key:"unsubscribe",value:function(e){this._sdk.emitter.off(b,e)}}]),e}()},7145:function(e,t,n){"use strict";n.d(t,{W:function(){return ge}});var r=n(885),o=n(2982),i=n(5861),a=n(5671),u=n(3144),c=n(4942),s=n(4687),f=n.n(s);Promise.resolve(!1);var l=Promise.resolve(!0),p=Promise.resolve();function h(e,t){return e||(e=0),new Promise((function(n){return setTimeout((function(){return n(t)}),e)}))}function d(){return Math.random().toString(36).substring(2)}var v=0,y=0;function g(){var e=(new Date).getTime();return e===v?1e3*e+ ++y:(v=e,y=0,1e3*e)}var m={create:function(e){var t={messagesCallback:null,bc:new BroadcastChannel(e),subFns:[]};return t.bc.onmessage=function(e){t.messagesCallback&&t.messagesCallback(e.data)},t},close:function(e){e.bc.close(),e.subFns=[]},onMessage:function(e,t){e.messagesCallback=t},postMessage:function(e,t){try{return e.bc.postMessage(t,!1),p}catch(e){return Promise.reject(e)}},canBeUsed:function(){if("undefined"==typeof window&&"undefined"==typeof self||"function"!=typeof BroadcastChannel)return!1;if(BroadcastChannel._pubkey)throw new Error("BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill");return!0},type:"native",averageResponseTime:function(){return 150},microSeconds:g},b=function(){function e(e){this.ttl=e,this.map=new Map,this._to=!1}return e.prototype.has=function(e){return this.map.has(e)},e.prototype.add=function(e){var t=this;this.map.set(e,k()),this._to||(this._to=!0,setTimeout((function(){t._to=!1,function(e){for(var t=k()-e.ttl,n=e.map[Symbol.iterator]();;){var r=n.next().value;if(!r)return;var o=r[0];if(!(r[1]<t))return;e.map.delete(o)}}(t)}),0))},e.prototype.clear=function(){this.map.clear()},e}();function k(){return(new Date).getTime()}function w(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=JSON.parse(JSON.stringify(e));return void 0===t.webWorkerSupport&&(t.webWorkerSupport=!0),t.idb||(t.idb={}),t.idb.ttl||(t.idb.ttl=45e3),t.idb.fallbackInterval||(t.idb.fallbackInterval=150),e.idb&&"function"==typeof e.idb.onclose&&(t.idb.onclose=e.idb.onclose),t.localstorage||(t.localstorage={}),t.localstorage.removeTimeout||(t.localstorage.removeTimeout=6e4),e.methods&&(t.methods=e.methods),t.node||(t.node={}),t.node.ttl||(t.node.ttl=12e4),t.node.maxParallelWrites||(t.node.maxParallelWrites=2048),void 0===t.node.useFastPath&&(t.node.useFastPath=!0),t}var O="messages",Z={durability:"relaxed"};function T(){if("undefined"!=typeof indexedDB)return indexedDB;if("undefined"!=typeof window){if(void 0!==window.mozIndexedDB)return window.mozIndexedDB;if(void 0!==window.webkitIndexedDB)return window.webkitIndexedDB;if(void 0!==window.msIndexedDB)return window.msIndexedDB}return!1}function E(e){e.commit&&e.commit()}function S(e){e.closed||P(e).then((function(){return h(e.options.idb.fallbackInterval)})).then((function(){return S(e)}))}function P(e){return e.closed?p:e.messagesCallback?function(e,t){var n=e.transaction(O,"readonly",Z),r=n.objectStore(O),o=[],i=IDBKeyRange.bound(t+1,1/0);if(r.getAll){var a=r.getAll(i);return new Promise((function(e,t){a.onerror=function(e){return t(e)},a.onsuccess=function(t){e(t.target.result)}}))}return new Promise((function(e,a){var u=function(){try{return i=IDBKeyRange.bound(t+1,1/0),r.openCursor(i)}catch(e){return r.openCursor()}}();u.onerror=function(e){return a(e)},u.onsuccess=function(r){var i=r.target.result;i?i.value.id<t+1?i.continue(t+1):(o.push(i.value),i.continue()):(E(n),e(o))}}))}(e.db,e.lastCursorId).then((function(t){var n=t.filter((function(e){return!!e})).map((function(t){return t.id>e.lastCursorId&&(e.lastCursorId=t.id),t})).filter((function(t){return function(e,t){return!(e.uuid===t.uuid||t.eMIs.has(e.id)||e.data.time<t.messagesCallbackTime)}(t,e)})).sort((function(e,t){return e.time-t.time}));return n.forEach((function(t){e.messagesCallback&&(e.eMIs.add(t.id),e.messagesCallback(t.data))})),p})):p}var x={create:function(e,t){return t=w(t),function(e){var t="pubkey.broadcast-channel-0-"+e,n=T().open(t);return n.onupgradeneeded=function(e){e.target.result.createObjectStore(O,{keyPath:"id",autoIncrement:!0})},new Promise((function(e,t){n.onerror=function(e){return t(e)},n.onsuccess=function(){e(n.result)}}))}(e).then((function(n){var r={closed:!1,lastCursorId:0,channelName:e,options:t,uuid:d(),eMIs:new b(2*t.idb.ttl),writeBlockPromise:p,messagesCallback:null,readQueuePromises:[],db:n};return n.onclose=function(){r.closed=!0,t.idb.onclose&&t.idb.onclose()},S(r),r}))},close:function(e){e.closed=!0,e.db.close()},onMessage:function(e,t,n){e.messagesCallbackTime=n,e.messagesCallback=t,P(e)},postMessage:function(e,t){return e.writeBlockPromise=e.writeBlockPromise.then((function(){return function(e,t,n){var r={uuid:t,time:(new Date).getTime(),data:n},o=e.transaction([O],"readwrite",Z);return new Promise((function(e,t){o.oncomplete=function(){return e()},o.onerror=function(e){return t(e)},o.objectStore(O).add(r),E(o)}))}(e.db,e.uuid,t)})).then((function(){0===(0,10,Math.floor(11*Math.random()+0))&&function(e){return(t=e.db,n=e.options.idb.ttl,r=(new Date).getTime()-n,o=t.transaction(O,"readonly",Z),i=o.objectStore(O),a=[],new Promise((function(e){i.openCursor().onsuccess=function(t){var n=t.target.result;if(n){var i=n.value;i.time<r?(a.push(i),n.continue()):(E(o),e(a))}else e(a)}}))).then((function(t){return function(e,t){if(e.closed)return Promise.resolve([]);var n=e.db.transaction(O,"readwrite",Z).objectStore(O);return Promise.all(t.map((function(e){var t=n.delete(e);return new Promise((function(e){t.onsuccess=function(){return e()}}))})))}(e,t.map((function(e){return e.id})))}));var t,n,r,o,i,a}(e)})),e.writeBlockPromise},canBeUsed:function(){return!!T()},type:"idb",averageResponseTime:function(e){return 2*e.idb.fallbackInterval},microSeconds:g};function A(){var e;if("undefined"==typeof window)return null;try{e=window.localStorage,e=window["ie8-eventlistener/storage"]||window.localStorage}catch(e){}return e}function _(e){return"pubkey.broadcastChannel-"+e}function R(){var e=A();if(!e)return!1;try{var t="__broadcastchannel_check";e.setItem(t,"works"),e.removeItem(t)}catch(e){return!1}return!0}var j={create:function(e,t){if(t=w(t),!R())throw new Error("BroadcastChannel: localstorage cannot be used");var n=d(),r=new b(t.localstorage.removeTimeout),o={channelName:e,uuid:n,eMIs:r};return o.listener=function(e,t){var i=_(e),a=function(e){var t;e.key===i&&(t=JSON.parse(e.newValue),o.messagesCallback&&t.uuid!==n&&t.token&&!r.has(t.token)&&(t.data.time&&t.data.time<o.messagesCallbackTime||(r.add(t.token),o.messagesCallback(t.data))))};return window.addEventListener("storage",a),a}(e),o},close:function(e){var t;t=e.listener,window.removeEventListener("storage",t)},onMessage:function(e,t,n){e.messagesCallbackTime=n,e.messagesCallback=t},postMessage:function(e,t){return new Promise((function(n){h().then((function(){var r=_(e.channelName),o={token:d(),time:(new Date).getTime(),data:t,uuid:e.uuid},i=JSON.stringify(o);A().setItem(r,i);var a=document.createEvent("Event");a.initEvent("storage",!0,!0),a.key=r,a.newValue=i,window.dispatchEvent(a),n()}))}))},canBeUsed:R,type:"localstorage",averageResponseTime:function(){var e=navigator.userAgent.toLowerCase();return e.includes("safari")&&!e.includes("chrome")?240:120},microSeconds:g},C=g,D=new Set,I={create:function(e){var t={name:e,messagesCallback:null};return D.add(t),t},close:function(e){D.delete(e)},onMessage:function(e,t){e.messagesCallback=t},postMessage:function(e,t){return new Promise((function(n){return setTimeout((function(){Array.from(D).filter((function(t){return t.name===e.name})).filter((function(t){return t!==e})).filter((function(e){return!!e.messagesCallback})).forEach((function(e){return e.messagesCallback(t)})),n()}),5)}))},canBeUsed:function(){return!0},type:"simulate",averageResponseTime:function(){return 5},microSeconds:C},M=[m,x,j],N=new Set,U=0,L=function(e,t){var n,r,o;this.id=U++,N.add(this),this.name=e,this.options=w(t),this.method=function(e){var t=[].concat(e.methods,M).filter(Boolean);if(e.type){if("simulate"===e.type)return I;var n=t.find((function(t){return t.type===e.type}));if(n)return n;throw new Error("method-type "+e.type+" not found")}e.webWorkerSupport||(t=t.filter((function(e){return"idb"!==e.type})));var r=t.find((function(e){return e.canBeUsed()}));if(r)return r;throw new Error("No usable method found in "+JSON.stringify(M.map((function(e){return e.type}))))}(this.options),this._iL=!1,this._onML=null,this._addEL={message:[],internal:[]},this._uMP=new Set,this._befC=[],this._prepP=null,(o=r=(n=this).method.create(n.name,n.options))&&"function"==typeof o.then?(n._prepP=r,r.then((function(e){n._state=e}))):n._state=r};function F(e,t,n){var r={time:e.method.microSeconds(),type:t,data:n};return(e._prepP?e._prepP:p).then((function(){var t=e.method.postMessage(e._state,r);return e._uMP.add(t),t.catch().then((function(){return e._uMP.delete(t)})),t}))}function B(e){return e._addEL.message.length>0||e._addEL.internal.length>0}function H(e,t,n){e._addEL[t].push(n),function(e){if(!e._iL&&B(e)){var t=function(t){e._addEL[t.type].forEach((function(e){var n=e.time-1e5;t.time>=n&&e.fn(t.data)}))},n=e.method.microSeconds();e._prepP?e._prepP.then((function(){e._iL=!0,e.method.onMessage(e._state,t,n)})):(e._iL=!0,e.method.onMessage(e._state,t,n))}}(e)}function K(e,t,n){e._addEL[t]=e._addEL[t].filter((function(e){return e!==n})),function(e){if(e._iL&&!B(e)){e._iL=!1;var t=e.method.microSeconds();e.method.onMessage(e._state,null,t)}}(e)}L._pubkey=!0,L.prototype={postMessage:function(e){if(this.closed)throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed "+JSON.stringify(e));return F(this,"message",e)},postInternal:function(e){return F(this,"internal",e)},set onmessage(e){var t={time:this.method.microSeconds(),fn:e};K(this,"message",this._onML),e&&"function"==typeof e?(this._onML=t,H(this,"message",t)):this._onML=null},addEventListener:function(e,t){H(this,e,{time:this.method.microSeconds(),fn:t})},removeEventListener:function(e,t){K(this,e,this._addEL[e].find((function(e){return e.fn===t})))},close:function(){var e=this;if(!this.closed){N.delete(this),this.closed=!0;var t=this._prepP?this._prepP:p;return this._onML=null,this._addEL.message=[],t.then((function(){return Promise.all(Array.from(e._uMP))})).then((function(){return Promise.all(e._befC.map((function(e){return e()})))})).then((function(){return e.method.close(e._state)}))}},get type(){return this.method.type},get isClosed(){return this.closed}};var G="[object process]"===Object.prototype.toString.call("undefined"!=typeof process?process:0)?function(e){process.on("exit",(function(){return e()})),process.on("beforeExit",(function(){return e().then((function(){return process.exit()}))})),process.on("SIGINT",(function(){return e().then((function(){return process.exit()}))})),process.on("uncaughtException",(function(t){return e().then((function(){console.trace(t),process.exit(101)}))}))}:function(e){if("function"==typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope){var t=self.close.bind(self);self.close=function(){return e(),t()}}else{if("function"!=typeof window.addEventListener)return;window.addEventListener("beforeunload",(function(){e()}),!0),window.addEventListener("unload",(function(){e()}),!0)}},V=new Set,q=!1;function W(){var e=[];return V.forEach((function(t){e.push(t()),V.delete(t)})),Promise.all(e)}function Y(e,t){var n={context:"leader",action:t,token:e.token};return e.broadcastChannel.postInternal(n)}function z(e){e.isLeader=!0,e._hasLeader=!0;var t=function(e){if(q||(q=!0,G(W)),"function"!=typeof e)throw new Error("Listener is no function");return V.add(e),{remove:function(){return V.delete(e)},run:function(){return V.delete(e),e()}}}((function(){return e.die()}));e._unl.push(t);var n=function(t){"leader"===t.context&&"apply"===t.action&&Y(e,"tell"),"leader"!==t.context||"tell"!==t.action||e._dpLC||(e._dpLC=!0,e._dpL(),Y(e,"tell"))};return e.broadcastChannel.addEventListener("internal",n),e._lstns.push(n),Y(e,"tell")}var Q=function(e,t){var n=this;this.broadcastChannel=e,e._befC.push((function(){return n.die()})),this._options=t,this.isLeader=!1,this.isDead=!1,this.token=d(),this._lstns=[],this._unl=[],this._dpL=function(){},this._dpLC=!1,this._wKMC={},this.lN="pubkey-bc||"+e.method.type+"||"+e.name};Q.prototype={hasLeader:function(){var e=this;return navigator.locks.query().then((function(t){var n=t.held?t.held.filter((function(t){return t.name===e.lN})):[];return!!(n&&n.length>0)}))},awaitLeadership:function(){var e=this;if(!this._wLMP){this._wKMC.c=new AbortController;var t=new Promise((function(t,n){e._wKMC.res=t,e._wKMC.rej=n}));this._wLMP=new Promise((function(n){navigator.locks.request(e.lN,{signal:e._wKMC.c.signal},(function(){return e._wKMC.c=void 0,z(e),n(),t})).catch((function(){}))}))}return this._wLMP},set onduplicate(e){},die:function(){var e=this;return this._lstns.forEach((function(t){return e.broadcastChannel.removeEventListener("internal",t)})),this._lstns=[],this._unl.forEach((function(e){return e.remove()})),this._unl=[],this.isLeader&&(this.isLeader=!1),this.isDead=!0,this._wKMC.res&&this._wKMC.res(),this._wKMC.c&&this._wKMC.c.abort("LeaderElectionWebLock.die() called"),Y(this,"death")}};var X=function(e,t){var n=this;this.broadcastChannel=e,this._options=t,this.isLeader=!1,this._hasLeader=!1,this.isDead=!1,this.token=d(),this._aplQ=p,this._aplQC=0,this._unl=[],this._lstns=[],this._dpL=function(){},this._dpLC=!1;var r=function(e){"leader"===e.context&&("death"===e.action&&(n._hasLeader=!1),"tell"===e.action&&(n._hasLeader=!0))};this.broadcastChannel.addEventListener("internal",r),this._lstns.push(r)};function J(e,t){if(e._leaderElector)throw new Error("BroadcastChannel already has a leader-elector");t=function(e,t){return e||(e={}),(e=JSON.parse(JSON.stringify(e))).fallbackInterval||(e.fallbackInterval=3e3),e.responseTime||(e.responseTime=t.method.averageResponseTime(t.options)),e}(t,e);var n="undefined"!=typeof navigator&&void 0!==navigator.locks&&"function"==typeof navigator.locks.request?new Q(e,t):new X(e,t);return e._befC.push((function(){return n.die()})),e._leaderElector=n,n}X.prototype={hasLeader:function(){return Promise.resolve(this._hasLeader)},applyOnce:function(e){var t=this;return this.isLeader?h(0,!0):this.isDead?h(0,!1):this._aplQC>1?this._aplQ:(this._aplQC=this._aplQC+1,this._aplQ=this._aplQ.then((function(){return function(){if(t.isLeader)return l;var n,r=!1,o=new Promise((function(e){n=function(){r=!0,e()}})),i=function(e){"leader"===e.context&&e.token!=t.token&&("apply"===e.action&&e.token>t.token&&n(),"tell"===e.action&&(n(),t._hasLeader=!0))};t.broadcastChannel.addEventListener("internal",i);var a=e?4*t._options.responseTime:t._options.responseTime;return Y(t,"apply").then((function(){return Promise.race([h(a),o.then((function(){return Promise.reject(new Error)}))])})).then((function(){return Y(t,"apply")})).then((function(){return Promise.race([h(a),o.then((function(){return Promise.reject(new Error)}))])})).catch((function(){})).then((function(){return t.broadcastChannel.removeEventListener("internal",i),!r&&z(t).then((function(){return!0}))}))}()})).then((function(){t._aplQC=t._aplQC-1})),this._aplQ.then((function(){return t.isLeader})))},awaitLeadership:function(){return this._aLP||(this._aLP=(e=this).isLeader?p:new Promise((function(t){var n=!1;function r(){n||(n=!0,e.broadcastChannel.removeEventListener("internal",o),t(!0))}e.applyOnce().then((function(){e.isLeader&&r()})),function t(){return h(e._options.fallbackInterval).then((function(){if(!e.isDead&&!n)return e.isLeader?void r():e.applyOnce(!0).then((function(){e.isLeader?r():t()}))}))}();var o=function(t){"leader"===t.context&&"death"===t.action&&(e._hasLeader=!1,e.applyOnce().then((function(){e.isLeader&&r()})))};e.broadcastChannel.addEventListener("internal",o),e._lstns.push(o)}))),this._aLP;var e},set onduplicate(e){this._dpL=e},die:function(){var e=this;return this._lstns.forEach((function(t){return e.broadcastChannel.removeEventListener("internal",t)})),this._lstns=[],this._unl.forEach((function(e){return e.remove()})),this._unl=[],this.isLeader&&(this._hasLeader=!1,this.isLeader=!1),this.isDead=!0,Y(this,"death")}};var $=n(415),ee=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(0,a.Z)(this,e),(0,c.Z)(this,"options",void 0),(0,c.Z)(this,"channel",void 0),(0,c.Z)(this,"elector",void 0),(0,c.Z)(this,"started",!1),this.options=t,this.onLeaderDuplicate=this.onLeaderDuplicate.bind(this),this.onLeader=this.onLeader.bind(this)}var t,n,r;return(0,u.Z)(e,[{key:"onLeaderDuplicate",value:function(){}},{key:"onLeader",value:(r=(0,i.Z)(f().mark((function e(){var t,n;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,null===(t=(n=this.options).onLeader)||void 0===t?void 0:t.call(n);case 2:case"end":return e.stop()}}),e,this)}))),function(){return r.apply(this,arguments)})},{key:"isLeader",value:function(){var e;return!(null===(e=this.elector)||void 0===e||!e.isLeader)}},{key:"hasLeader",value:function(){var e;return!(null===(e=this.elector)||void 0===e||!e.hasLeader)}},{key:"start",value:(n=(0,i.Z)(f().mark((function e(){var t;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:this.canStart()&&(t=this.options.electionChannelName,this.channel=new L(t),this.elector=J(this.channel),this.elector.onduplicate=this.onLeaderDuplicate,this.elector.awaitLeadership().then(this.onLeader),this.started=!0);case 1:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"stop",value:(t=(0,i.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.started){e.next=11;break}if(!this.elector){e.next=5;break}return e.next=4,this.elector.die();case 4:this.elector=void 0;case 5:if(!this.channel){e.next=10;break}return this.channel.postInternal=function(){return Promise.resolve()},e.next=9,this.channel.close();case 9:this.channel=void 0;case 10:this.started=!1;case 11:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"requiresLeadership",value:function(){return!1}},{key:"isStarted",value:function(){return this.started}},{key:"canStart",value:function(){return(0,$.isBrowser)()&&!this.started}}]),e}(),te=n(9123),ne=n(6488),re=n(7088),oe=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(0,a.Z)(this,e),(0,c.Z)(this,"tokenManager",void 0),(0,c.Z)(this,"options",void 0),(0,c.Z)(this,"renewTimeQueue",void 0),(0,c.Z)(this,"started",!1),this.tokenManager=t,this.options=n,this.renewTimeQueue=[],this.onTokenExpiredHandler=this.onTokenExpiredHandler.bind(this)}var t,n;return(0,u.Z)(e,[{key:"shouldThrottleRenew",value:function(){var e=!1;if(this.renewTimeQueue.push(Date.now()),this.renewTimeQueue.length>=10){var t=this.renewTimeQueue.shift();e=this.renewTimeQueue[this.renewTimeQueue.length-1]-t<3e4}return e}},{key:"requiresLeadership",value:function(){return!!this.options.syncStorage&&(0,$.isBrowser)()}},{key:"processExpiredTokens",value:function(){var e=this,t=this.tokenManager.getStorage().getStorage();Object.keys(t).forEach((function(n){var r=t[n];!(0,ne.z9)(r)&&e.tokenManager.hasExpired(r)&&e.onTokenExpiredHandler(n)}))}},{key:"onTokenExpiredHandler",value:function(e){if(this.options.autoRenew)if(this.shouldThrottleRenew()){var t=new te.Z("Too many token renew requests");this.tokenManager.emitError(t)}else this.tokenManager.renew(e).catch((function(){}));else this.options.autoRemove&&this.tokenManager.remove(e)}},{key:"canStart",value:function(){return!(!this.options.autoRenew&&!this.options.autoRemove||this.started)}},{key:"start",value:(n=(0,i.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:this.canStart()&&(this.tokenManager.on(re.$Y,this.onTokenExpiredHandler),this.tokenManager.isStarted()&&this.processExpiredTokens(),this.started=!0);case 1:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"stop",value:(t=(0,i.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:this.started&&(this.tokenManager.off(re.$Y,this.onTokenExpiredHandler),this.renewTimeQueue=[],this.started=!1);case 1:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"isStarted",value:function(){return this.started}}]),e}(),ie=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(0,a.Z)(this,e),(0,c.Z)(this,"tokenManager",void 0),(0,c.Z)(this,"options",void 0),(0,c.Z)(this,"channel",void 0),(0,c.Z)(this,"started",!1),(0,c.Z)(this,"enablePostMessage",!0),this.tokenManager=t,this.options=n,this.onTokenAddedHandler=this.onTokenAddedHandler.bind(this),this.onTokenRemovedHandler=this.onTokenRemovedHandler.bind(this),this.onTokenRenewedHandler=this.onTokenRenewedHandler.bind(this),this.onSetStorageHandler=this.onSetStorageHandler.bind(this),this.onSyncMessageHandler=this.onSyncMessageHandler.bind(this)}var t,n;return(0,u.Z)(e,[{key:"requiresLeadership",value:function(){return!1}},{key:"isStarted",value:function(){return this.started}},{key:"canStart",value:function(){return!!this.options.syncStorage&&(0,$.isBrowser)()&&!this.started}},{key:"start",value:(n=(0,i.Z)(f().mark((function e(){var t;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(this.canStart()){e.next=2;break}return e.abrupt("return");case 2:t=this.options.syncChannelName,e.prev=3,this.channel=new L(t),e.next=10;break;case 7:throw e.prev=7,e.t0=e.catch(3),new te.Z("SyncStorageService is not supported in current browser.");case 10:this.tokenManager.on(re.O3,this.onTokenAddedHandler),this.tokenManager.on(re.FT,this.onTokenRemovedHandler),this.tokenManager.on(re.E,this.onTokenRenewedHandler),this.tokenManager.on(re.zr,this.onSetStorageHandler),this.channel.addEventListener("message",this.onSyncMessageHandler),this.started=!0;case 16:case"end":return e.stop()}}),e,this,[[3,7]])}))),function(){return n.apply(this,arguments)})},{key:"stop",value:(t=(0,i.Z)(f().mark((function e(){var t,n;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.started){e.next=10;break}return this.tokenManager.off(re.O3,this.onTokenAddedHandler),this.tokenManager.off(re.FT,this.onTokenRemovedHandler),this.tokenManager.off(re.E,this.onTokenRenewedHandler),this.tokenManager.off(re.zr,this.onSetStorageHandler),null===(t=this.channel)||void 0===t||t.removeEventListener("message",this.onSyncMessageHandler),e.next=8,null===(n=this.channel)||void 0===n?void 0:n.close();case 8:this.channel=void 0,this.started=!1;case 10:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"onTokenAddedHandler",value:function(e,t){var n;this.enablePostMessage&&(null===(n=this.channel)||void 0===n||n.postMessage({type:re.O3,key:e,token:t}))}},{key:"onTokenRemovedHandler",value:function(e,t){var n;this.enablePostMessage&&(null===(n=this.channel)||void 0===n||n.postMessage({type:re.FT,key:e,token:t}))}},{key:"onTokenRenewedHandler",value:function(e,t,n){var r;this.enablePostMessage&&(null===(r=this.channel)||void 0===r||r.postMessage({type:re.E,key:e,token:t,oldToken:n}))}},{key:"onSetStorageHandler",value:function(e){var t;null===(t=this.channel)||void 0===t||t.postMessage({type:re.zr,storage:e})}},{key:"onSyncMessageHandler",value:function(e){switch(this.enablePostMessage=!1,e.type){case re.zr:this.tokenManager.getStorage().setStorage(e.storage);break;case re.O3:this.tokenManager.emitAdded(e.key,e.token),this.tokenManager.setExpireEventTimeout(e.key,e.token);break;case re.FT:this.tokenManager.clearExpireEventTimeout(e.key),this.tokenManager.emitRemoved(e.key,e.token);break;case re.E:this.tokenManager.emitRenewed(e.key,e.token,e.oldToken)}this.enablePostMessage=!0}}]),e}(),ae=function(){return Math.floor(Date.now()/1e3)},ue=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(0,a.Z)(this,e),(0,c.Z)(this,"tokenManager",void 0),(0,c.Z)(this,"started",!1),(0,c.Z)(this,"options",void 0),(0,c.Z)(this,"lastHidden",-1),(0,c.Z)(this,"onPageVisbilityChange",void 0),this.tokenManager=t,this.options=n,this.onPageVisbilityChange=this._onPageVisbilityChange.bind(this)}var t,n;return(0,u.Z)(e,[{key:"_onPageVisbilityChange",value:function(){if(document.hidden)this.lastHidden=ae();else if(this.lastHidden>0&&ae()-this.lastHidden>=this.options.tabInactivityDuration){var e=this.tokenManager.getTokensSync(),t=e.accessToken,n=e.idToken;if(t&&this.tokenManager.hasExpired(t)){var r=this.tokenManager.getStorageKeyByType("accessToken");this.tokenManager.renew(r).catch((function(){}))}else if(n&&this.tokenManager.hasExpired(n)){var o=this.tokenManager.getStorageKeyByType("idToken");this.tokenManager.renew(o).catch((function(){}))}}}},{key:"start",value:(n=(0,i.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:this.canStart()&&document&&(document.addEventListener("visibilitychange",this.onPageVisbilityChange),this.started=!0);case 1:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"stop",value:(t=(0,i.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:document&&(document.removeEventListener("visibilitychange",this.onPageVisbilityChange),this.started=!1);case 1:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"canStart",value:function(){return(0,$.isBrowser)()&&!!this.options.autoRenew&&!!this.options.renewOnTabActivation&&!this.started}},{key:"requiresLeadership",value:function(){return!1}},{key:"isStarted",value:function(){return this.started}}]),e}(),ce=n(3193);function se(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function fe(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?se(Object(n),!0).forEach((function(t){(0,c.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):se(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function le(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return pe(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?pe(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}function pe(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var he="autoRenew",de="syncStorage",ve="leaderElection",ye="renewOnTabActivation",ge=function(){function e(t){var n=this,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(0,a.Z)(this,e),(0,c.Z)(this,"sdk",void 0),(0,c.Z)(this,"options",void 0),(0,c.Z)(this,"services",void 0),(0,c.Z)(this,"started",void 0),this.sdk=t,this.onLeader=this.onLeader.bind(this);var o=t.tokenManager.getOptions(),i=o.autoRenew,u=o.autoRemove,s=o.syncStorage;r.electionChannelName=r.electionChannelName||r.broadcastChannelName,this.options=Object.assign({},e.defaultOptions,{autoRenew:i,autoRemove:u,syncStorage:s},{electionChannelName:"".concat(t.options.clientId,"-election"),syncChannelName:"".concat(t.options.clientId,"-sync")},(0,ce.YY)(r)),this.started=!1,this.services=new Map,e.knownServices.forEach((function(e){var t=n.createService(e);t&&n.services.set(e,t)}))}var t,n,s,l,p;return(0,u.Z)(e,[{key:"onLeader",value:(p=(0,i.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.started){e.next=3;break}return e.next=3,this.startServices();case 3:case"end":return e.stop()}}),e,this)}))),function(){return p.apply(this,arguments)})},{key:"isLeader",value:function(){var e;return null===(e=this.getService(ve))||void 0===e?void 0:e.isLeader()}},{key:"isLeaderRequired",value:function(){return(0,o.Z)(this.services.values()).some((function(e){return e.canStart()&&e.requiresLeadership()}))}},{key:"start",value:(l=(0,i.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.started){e.next=2;break}return e.abrupt("return");case 2:return e.next=4,this.startServices();case 4:this.started=!0;case 5:case"end":return e.stop()}}),e,this)}))),function(){return l.apply(this,arguments)})},{key:"stop",value:(s=(0,i.Z)(f().mark((function e(){return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.stopServices();case 2:this.started=!1;case 3:case"end":return e.stop()}}),e,this)}))),function(){return s.apply(this,arguments)})},{key:"getService",value:function(e){return this.services.get(e)}},{key:"startServices",value:(n=(0,i.Z)(f().mark((function e(){var t,n,o,i,a;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:t=le(this.services.entries()),e.prev=1,t.s();case 3:if((n=t.n()).done){e.next=10;break}if(o=(0,r.Z)(n.value,2),i=o[0],a=o[1],!this.canStartService(i,a)){e.next=8;break}return e.next=8,a.start();case 8:e.next=3;break;case 10:e.next=15;break;case 12:e.prev=12,e.t0=e.catch(1),t.e(e.t0);case 15:return e.prev=15,t.f(),e.finish(15);case 18:case"end":return e.stop()}}),e,this,[[1,12,15,18]])}))),function(){return n.apply(this,arguments)})},{key:"stopServices",value:(t=(0,i.Z)(f().mark((function e(){var t,n,r;return f().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:t=le(this.services.values()),e.prev=1,t.s();case 3:if((n=t.n()).done){e.next=9;break}return r=n.value,e.next=7,r.stop();case 7:e.next=3;break;case 9:e.next=14;break;case 11:e.prev=11,e.t0=e.catch(1),t.e(e.t0);case 14:return e.prev=14,t.f(),e.finish(14);case 17:case"end":return e.stop()}}),e,this,[[1,11,14,17]])}))),function(){return t.apply(this,arguments)})},{key:"canStartService",value:function(e,t){var n=t.canStart()&&!t.isStarted();return e===ve?n&&(n=this.isLeaderRequired()):t.requiresLeadership()&&n&&(n=this.isLeader()),n}},{key:"createService",value:function(e){var t,n=this.sdk.tokenManager;switch(e){case ve:t=new ee(fe(fe({},this.options),{},{onLeader:this.onLeader}));break;case he:t=new oe(n,fe({},this.options));break;case de:t=new ie(n,fe({},this.options));break;case ye:t=new ue(n,fe({},this.options));break;default:throw new Error("Unknown service ".concat(e))}return t}}]),e}();(0,c.Z)(ge,"knownServices",[he,de,ve,ye]),(0,c.Z)(ge,"defaultOptions",{autoRenew:!0,autoRemove:!0,syncStorage:!0,renewOnTabActivation:!0,tabInactivityDuration:1800})},6599:function(e,t,n){"use strict";n.d(t,{W:function(){return r.W}});var r=n(7145)},1578:function(e,t,n){"use strict";n.d(t,{K:function(){return s}});var r=n(9893),o=n(265),i=n(279),a=n(2724),u=n(8386),c=n(3980);function s(e,t,n){var s=(0,r.a)(t),f=(0,o.H)(s,e),l=(0,i.A)(f),p=(0,c.Z)(l),h=(0,a.J)(p,n);return(0,u.i)(h)}},3961:function(e,t,n){"use strict";n.r(t),n.d(t,{AuthStateManager:function(){return r.E},INITIAL_AUTH_STATE:function(){return r.a},ServiceManager:function(){return l.W},createCoreOptionsConstructor:function(){return o.n},createCoreStorageManager:function(){return u.a},createOktaAuthCore:function(){return i.K},mixinCore:function(){return a.i}});var r=n(1018),o=n(9133),i=n(1578),a=n(8386),u=n(2647),c=n(8553),s={};for(var f in c)["default","AuthStateManager","INITIAL_AUTH_STATE","createCoreOptionsConstructor","createOktaAuthCore","mixinCore","createCoreStorageManager"].indexOf(f)<0&&(s[f]=function(e){return c[e]}.bind(0,f));n.d(t,s);var l=n(6599)},8386:function(e,t,n){"use strict";n.d(t,{i:function(){return y}});var r=n(5861),o=n(5671),i=n(3144),a=n(7326),u=n(136),c=n(2963),s=n(1120),f=n(4942),l=n(4687),p=n.n(l),h=n(5372),d=n(1018),v=n(7145);function y(e){return function(e){(0,u.Z)(k,e);var t,n,l,y,g,m,b=(g=k,m=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=(0,s.Z)(g);if(m){var n=(0,s.Z)(this).constructor;e=Reflect.construct(t,arguments,n)}else e=t.apply(this,arguments);return(0,c.Z)(this,e)});function k(){var e;(0,o.Z)(this,k);for(var t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];return e=b.call.apply(b,[this].concat(n)),(0,f.Z)((0,a.Z)(e),"authStateManager",void 0),(0,f.Z)((0,a.Z)(e),"serviceManager",void 0),e.authStateManager=new d.E((0,a.Z)(e)),e.serviceManager=new v.W((0,a.Z)(e),e.options.services),e}return(0,i.Z)(k,[{key:"start",value:(y=(0,r.Z)(p().mark((function e(){return p().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.serviceManager.start();case 2:if(this.tokenManager.start(),this.token.isLoginRedirect()){e.next=6;break}return e.next=6,this.authStateManager.updateAuthState();case 6:case"end":return e.stop()}}),e,this)}))),function(){return y.apply(this,arguments)})},{key:"stop",value:(l=(0,r.Z)(p().mark((function e(){return p().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return this.tokenManager.stop(),e.next=3,this.serviceManager.stop();case 3:case"end":return e.stop()}}),e,this)}))),function(){return l.apply(this,arguments)})},{key:"handleRedirect",value:(n=(0,r.Z)(p().mark((function e(t){return p().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.handleLoginRedirect(void 0,t);case 2:case"end":return e.stop()}}),e,this)}))),function(e){return n.apply(this,arguments)})},{key:"handleLoginRedirect",value:(t=(0,r.Z)(p().mark((function e(t,n){var r,o,i;return p().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=this.options.state,!t){e.next=6;break}this.tokenManager.setTokens(t),n=n||this.getOriginalUri(this.options.state),e.next=25;break;case 6:if(!this.isLoginRedirect()){e.next=24;break}return e.prev=7,e.next=10,(0,h.Tp)(this,{});case 10:return o=e.sent,r=o.state,n=n||this.getOriginalUri(r),e.next=15,this.storeTokensFromRedirect();case 15:e.next=22;break;case 17:return e.prev=17,e.t0=e.catch(7),e.next=21,this.authStateManager.updateAuthState();case 21:throw e.t0;case 22:e.next=25;break;case 24:return e.abrupt("return");case 25:return e.next=27,this.authStateManager.updateAuthState();case 27:if(this.removeOriginalUri(r),!(i=this.options.restoreOriginalUri)){e.next=34;break}return e.next=32,i(this,n);case 32:e.next=35;break;case 34:n&&window.location.replace(n);case 35:case"end":return e.stop()}}),e,this,[[7,17]])}))),function(e,n){return t.apply(this,arguments)})}]),k}(e)}},9133:function(e,t,n){"use strict";n.d(t,{n:function(){return l}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),u=n(2963),c=n(1120),s=n(4942),f=n(9453);function l(){return function(e){(0,a.Z)(l,e);var t,n,f=(t=l,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function l(e){var t;return(0,o.Z)(this,l),t=f.call(this,e),(0,s.Z)((0,i.Z)(t),"services",void 0),(0,s.Z)((0,i.Z)(t),"transformAuthState",void 0),t.services=e.services,t.transformAuthState=e.transformAuthState,t}return(0,r.Z)(l)}((0,f.m)())}},2647:function(e,t,n){"use strict";n.d(t,{a:function(){return o}});var r=n(2333);function o(){return(0,r.a)()}},5675:function(){},8553:function(e,t,n){"use strict";n.r(t);var r=n(5675),o={};for(var i in r)"default"!==i&&(o[i]=function(e){return r[e]}.bind(0,i));n.d(t,o)},7987:function(e,t,n){"use strict";n.d(t,{Df:function(){return u},EL:function(){return f},NL:function(){return i},Wy:function(){return c},aR:function(){return a},dX:function(){return l},k8:function(){return s},kQ:function(){return p}});var r=n(9123),o=n(7594);function i(e){return a((0,o.r3)(e))}function a(e){return e.replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,"")}function u(e){return e.replace(/-/g,"+").replace(/_/g,"/")}function c(e){var t=u(e);switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw new r.Z("Not a valid Base64Url")}var n=(0,o.ty)(t);try{return decodeURIComponent(escape(n))}catch(e){return n}}function s(e){for(var t=new Uint8Array(e.length),n=0;n<e.length;n++)t[n]=e.charCodeAt(n);return t}function f(e){return(0,o.ty)(u(e))}function l(e){return Uint8Array.from(f(e),(function(e){return e.charCodeAt(0)}))}function p(e){return(0,o.r3)(new Uint8Array(e).reduce((function(e,t){return e+String.fromCharCode(t)}),""))}},7594:function(e,t,n){"use strict";n.d(t,{KP:function(){return i},r3:function(){return o},ty:function(){return r}});var r=function(e){return atob(e)},o=function(e){return btoa(e)},i="undefined"==typeof crypto?null:crypto},9718:function(e,t,n){"use strict";n.r(t),n.d(t,{atob:function(){return s.ty},base64ToBase64Url:function(){return r.aR},base64UrlDecode:function(){return r.EL},base64UrlToBase64:function(){return r.Df},base64UrlToBuffer:function(){return r.dX},base64UrlToString:function(){return r.Wy},btoa:function(){return s.r3},bufferToBase64Url:function(){return r.kQ},getOidcHash:function(){return o.X},stringToBase64Url:function(){return r.NL},stringToBuffer:function(){return r.k8},verifyToken:function(){return c.W},webcrypto:function(){return s.KP}});var r=n(7987),o=n(5698),i=n(6332),a={};for(var u in i)["default","base64ToBase64Url","base64UrlDecode","base64UrlToBase64","base64UrlToBuffer","base64UrlToString","bufferToBase64Url","stringToBase64Url","stringToBuffer","getOidcHash"].indexOf(u)<0&&(a[u]=function(e){return i[e]}.bind(0,u));n.d(t,a);var c=n(3154),s=n(1)},5698:function(e,t,n){"use strict";n.d(t,{X:function(){return i}});var r=n(7987),o=n(7594);function i(e){var t=(new TextEncoder).encode(e);return o.KP.subtle.digest("SHA-256",t).then((function(e){var t=new Uint8Array(e).slice(0,16),n=String.fromCharCode.apply(null,t);return(0,r.NL)(n)}))}},6332:function(){},3154:function(e,t,n){"use strict";n.d(t,{W:function(){return a}});var r=n(3193),o=n(7987),i=n(7594);function a(e,t){t=(0,r.d9)(t);var n={name:"RSASSA-PKCS1-v1_5",hash:{name:"SHA-256"}};return delete t.use,i.KP.subtle.importKey("jwk",t,n,!0,["verify"]).then((function(t){var r=e.split("."),a=(0,o.k8)(r[0]+"."+r[1]),u=(0,o.EL)(r[2]),c=(0,o.k8)(u);return i.KP.subtle.verify(n,t,c,a)}))}},1:function(e,t,n){"use strict";n.d(t,{KP:function(){return r.KP},r3:function(){return r.r3},ty:function(){return r.ty}});var r=n(7594)},3983:function(e,t,n){"use strict";n.d(t,{Z:function(){return f}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),u=n(2963),c=n(1120),s=n(4942);var f=function(e){(0,a.Z)(l,e);var t,n,f=(t=l,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function l(e,t,n){var r;(0,o.Z)(this,l);var a=e.errorSummary;return r=f.call(this,a),(0,s.Z)((0,i.Z)(r),"errorSummary",void 0),(0,s.Z)((0,i.Z)(r),"errorCode",void 0),(0,s.Z)((0,i.Z)(r),"errorLink",void 0),(0,s.Z)((0,i.Z)(r),"errorId",void 0),(0,s.Z)((0,i.Z)(r),"errorCauses",void 0),(0,s.Z)((0,i.Z)(r),"xhr",void 0),(0,s.Z)((0,i.Z)(r),"meta",void 0),r.name="AuthApiError",r.errorSummary=e.errorSummary,r.errorCode=e.errorCode,r.errorLink=e.errorLink,r.errorId=e.errorId,r.errorCauses=e.errorCauses,t&&(r.xhr=t),n&&(r.meta=n),r}return(0,r.Z)(l)}(n(6245).Z)},6573:function(e,t,n){"use strict";n.d(t,{Z:function(){return c}});var r=n(3144),o=n(5671),i=n(136),a=n(2963),u=n(1120);var c=function(e){(0,i.Z)(s,e);var t,n,c=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function s(){return(0,o.Z)(this,s),c.call(this,"The poll was stopped by the sdk")}return(0,r.Z)(s)}(n(6245).Z)},9123:function(e,t,n){"use strict";n.d(t,{Z:function(){return f}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),u=n(2963),c=n(1120),s=n(4942);var f=function(e){(0,a.Z)(l,e);var t,n,f=(t=l,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function l(e,t){var n;return(0,o.Z)(this,l),n=f.call(this,e),(0,s.Z)((0,i.Z)(n),"errorSummary",void 0),(0,s.Z)((0,i.Z)(n),"errorCode",void 0),(0,s.Z)((0,i.Z)(n),"errorLink",void 0),(0,s.Z)((0,i.Z)(n),"errorId",void 0),(0,s.Z)((0,i.Z)(n),"errorCauses",void 0),(0,s.Z)((0,i.Z)(n),"xhr",void 0),n.name="AuthSdkError",n.errorCode="INTERNAL",n.errorSummary=e,n.errorLink="INTERNAL",n.errorId="INTERNAL",n.errorCauses=[],t&&(n.xhr=t),n}return(0,r.Z)(l)}(n(6245).Z)},6245:function(e,t,n){"use strict";n.d(t,{Z:function(){return p}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),u=n(2963),c=n(1120),s=n(9611);function f(e,t,n){return f=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}()?Reflect.construct.bind():function(e,t,n){var r=[null];r.push.apply(r,t);var o=new(Function.bind.apply(e,r));return n&&(0,s.Z)(o,n.prototype),o},f.apply(null,arguments)}function l(e){var t="function"==typeof Map?new Map:void 0;return l=function(e){if(null===e||(n=e,-1===Function.toString.call(n).indexOf("[native code]")))return e;var n;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==t){if(t.has(e))return t.get(e);t.set(e,r)}function r(){return f(e,arguments,(0,c.Z)(this).constructor)}return r.prototype=Object.create(e.prototype,{constructor:{value:r,enumerable:!1,writable:!0,configurable:!0}}),(0,s.Z)(r,e)},l(e)}var p=function(e){(0,a.Z)(f,e);var t,n,s=(t=f,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function f(e){var t;return(0,o.Z)(this,f),t=s.call(this,e),Object.setPrototypeOf((0,i.Z)(t),(this instanceof f?this.constructor:void 0).prototype),t}return(0,r.Z)(f)}(l(Error))},2886:function(e,t,n){"use strict";n.d(t,{Z:function(){return f}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),u=n(2963),c=n(1120),s=n(4942);var f=function(e){(0,a.Z)(l,e);var t,n,f=(t=l,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function l(e,t,n){var r;return(0,o.Z)(this,l),r=f.call(this,t),(0,s.Z)((0,i.Z)(r),"errorCode",void 0),(0,s.Z)((0,i.Z)(r),"errorSummary",void 0),(0,s.Z)((0,i.Z)(r),"error",void 0),(0,s.Z)((0,i.Z)(r),"error_description",void 0),(0,s.Z)((0,i.Z)(r),"resp",null),r.name="OAuthError",r.errorCode=e,r.errorSummary=t,r.error=e,r.error_description=t,n&&(r.resp=n),r}return(0,r.Z)(l)}(n(6245).Z)},3114:function(e,t,n){"use strict";n.d(t,{Z:function(){return p}});var r=n(5671),o=n(3144),i=n(7326),a=n(136),u=n(2963),c=n(1120),s=n(4942),f=n(6245),l=n(4771);var p=function(e){(0,a.Z)(p,e);var t,n,f=(t=p,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function p(e,t,n){var o,a;return(0,r.Z)(this,p),a=f.call(this,null!==(o=t.error)&&void 0!==o?o:p.UNKNOWN_ERROR),(0,s.Z)((0,i.Z)(a),"scheme",void 0),(0,s.Z)((0,i.Z)(a),"parameters",void 0),(0,s.Z)((0,i.Z)(a),"name","WWWAuthError"),(0,s.Z)((0,i.Z)(a),"resp",null),a.scheme=e,a.parameters=t,n&&(a.resp=n),a}return(0,o.Z)(p,[{key:"error",get:function(){return this.parameters.error}},{key:"errorCode",get:function(){return this.error}},{key:"error_description",get:function(){return this.parameters.error_description}},{key:"errorDescription",get:function(){return this.error_description}},{key:"errorSummary",get:function(){return this.errorDescription}},{key:"realm",get:function(){return this.parameters.realm}}],[{key:"parseHeader",value:function(e){if(!e)return null;for(var t,n=/(?:,|, )?([a-zA-Z0-9!#$%&'*+\-.^_`|~]+)=(?:"([a-zA-Z0-9!#$%&'*+\-.,^_`|~ /:]+)"|([a-zA-Z0-9!#$%&'*+\-.^_`|~/:]+))/g,r=e.indexOf(" "),o=e.slice(0,r),i=e.slice(r+1),a={};null!==(t=n.exec(i));){var u;a[t[1]]=null!==(u=t[2])&&void 0!==u?u:t[3]}return new p(o,a)}},{key:"getWWWAuthenticateHeader",value:function(){var e,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return(0,l.mf)(null==t?void 0:t.get)?t.get("WWW-Authenticate"):null!==(e=t["www-authenticate"])&&void 0!==e?e:t["WWW-Authenticate"]}}]),p}(f.Z);(0,s.Z)(p,"UNKNOWN_ERROR","UNKNOWN_WWW_AUTH_ERROR")},5728:function(e,t,n){"use strict";n.r(t),n.d(t,{AuthApiError:function(){return r.Z},AuthPollStopError:function(){return o.Z},AuthSdkError:function(){return i.Z},OAuthError:function(){return a.Z},WWWAuthError:function(){return u.Z},isAuthApiError:function(){return l},isOAuthError:function(){return p},isWWWAuthError:function(){return h}});var r=n(3983),o=n(6573),i=n(9123),a=n(2886),u=n(3114),c=n(1243),s={};for(var f in c)["default","isAuthApiError","isOAuthError","isWWWAuthError","AuthApiError","AuthPollStopError","AuthSdkError","OAuthError","WWWAuthError"].indexOf(f)<0&&(s[f]=function(e){return c[e]}.bind(0,f));function l(e){return e instanceof r.Z}function p(e){return e instanceof a.Z}function h(e){return e instanceof u.Z}n.d(t,s)},1243:function(){},6736:function(e,t,n){"use strict";n.r(t),n.d(t,{ACCESS_TOKEN_STORAGE_KEY:function(){return i.ACCESS_TOKEN_STORAGE_KEY},BaseStorageManager:function(){return h.W8},CACHE_STORAGE_NAME:function(){return i.CACHE_STORAGE_NAME},DEFAULT_CACHE_DURATION:function(){return i.DEFAULT_CACHE_DURATION},DEFAULT_CODE_CHALLENGE_METHOD:function(){return i.DEFAULT_CODE_CHALLENGE_METHOD},DEFAULT_MAX_CLOCK_SKEW:function(){return i.DEFAULT_MAX_CLOCK_SKEW},DEFAULT_POLLING_DELAY:function(){return i.DEFAULT_POLLING_DELAY},IDX_API_VERSION:function(){return i.IDX_API_VERSION},IDX_RESPONSE_STORAGE_NAME:function(){return i.IDX_RESPONSE_STORAGE_NAME},ID_TOKEN_STORAGE_KEY:function(){return i.ID_TOKEN_STORAGE_KEY},MAX_VERIFIER_LENGTH:function(){return i.MAX_VERIFIER_LENGTH},MIN_VERIFIER_LENGTH:function(){return i.MIN_VERIFIER_LENGTH},ORIGINAL_URI_STORAGE_NAME:function(){return i.ORIGINAL_URI_STORAGE_NAME},OktaUserAgent:function(){return f.ed},PKCE_STORAGE_NAME:function(){return i.PKCE_STORAGE_NAME},PromiseQueue:function(){return d.bo},REFERRER_PATH_STORAGE_KEY:function(){return i.REFERRER_PATH_STORAGE_KEY},REFRESH_TOKEN_STORAGE_KEY:function(){return i.REFRESH_TOKEN_STORAGE_KEY},SHARED_TRANSACTION_STORAGE_NAME:function(){return i.SHARED_TRANSACTION_STORAGE_NAME},STATE_TOKEN_KEY_NAME:function(){return i.STATE_TOKEN_KEY_NAME},SavedObject:function(){return h._e},TOKEN_STORAGE_NAME:function(){return i.TOKEN_STORAGE_NAME},TRANSACTION_STORAGE_NAME:function(){return i.TRANSACTION_STORAGE_NAME},bind:function(){return d.ak},clone:function(){return d.d9},closeSession:function(){return p.RJ},createBaseOptionsConstructor:function(){return o.X},createHttpOptionsConstructor:function(){return f.ZM},createOktaAuthBase:function(){return o.a},createSessionApi:function(){return p.MG},createStorageOptionsConstructor:function(){return h.Tp},crypto:function(){return r},delay:function(){return d.gw},deprecate:function(){return d.Rn},deprecateWrap:function(){return d.VA},extend:function(){return d.l7},find:function(){return d.sE},genRandomString:function(){return d.uh},get:function(){return f.U2},getConsole:function(){return d.dr},getLink:function(){return d.Rg},getNativeConsole:function(){return d.sW},getSession:function(){return p.Gg},httpRequest:function(){return f.c3},isAbsoluteUrl:function(){return d.sD},isFunction:function(){return d.mf},isNumber:function(){return d.hj},isObject:function(){return d.Kn},isPromise:function(){return d.tI},isString:function(){return d.HD},isoToUTCString:function(){return d.ng},logServerSideMemoryStorageWarning:function(){return h.Vp},mixinHttp:function(){return f.Am},mixinSession:function(){return p.Zg},mixinStorage:function(){return h.Ho},omit:function(){return d.CE},post:function(){return f.v_},refreshSession:function(){return p.dx},removeNils:function(){return d.YY},removeTrailingSlash:function(){return d.Qj},sessionExists:function(){return p.sH},setCookieAndRedirect:function(){return p.OT},setRequestHeader:function(){return f.rn},split2:function(){return d.YQ},toAbsoluteUrl:function(){return d.BY},toQueryString:function(){return d.UK},toRelativeUrl:function(){return d.QN},warn:function(){return d.ZK}});var r=n(9718),o=n(3306),i=n(1971),a=n(3961),u={};for(var c in a)["default","crypto","createBaseOptionsConstructor","createOktaAuthBase","ACCESS_TOKEN_STORAGE_KEY","CACHE_STORAGE_NAME","DEFAULT_CACHE_DURATION","DEFAULT_CODE_CHALLENGE_METHOD","DEFAULT_MAX_CLOCK_SKEW","DEFAULT_POLLING_DELAY","IDX_API_VERSION","IDX_RESPONSE_STORAGE_NAME","ID_TOKEN_STORAGE_KEY","MAX_VERIFIER_LENGTH","MIN_VERIFIER_LENGTH","ORIGINAL_URI_STORAGE_NAME","PKCE_STORAGE_NAME","REFERRER_PATH_STORAGE_KEY","REFRESH_TOKEN_STORAGE_KEY","SHARED_TRANSACTION_STORAGE_NAME","STATE_TOKEN_KEY_NAME","TOKEN_STORAGE_NAME","TRANSACTION_STORAGE_NAME"].indexOf(c)<0&&(u[c]=function(e){return a[e]}.bind(0,c));n.d(t,u);var s=n(5728);for(var c in u={},s)["default","crypto","createBaseOptionsConstructor","createOktaAuthBase","ACCESS_TOKEN_STORAGE_KEY","CACHE_STORAGE_NAME","DEFAULT_CACHE_DURATION","DEFAULT_CODE_CHALLENGE_METHOD","DEFAULT_MAX_CLOCK_SKEW","DEFAULT_POLLING_DELAY","IDX_API_VERSION","IDX_RESPONSE_STORAGE_NAME","ID_TOKEN_STORAGE_KEY","MAX_VERIFIER_LENGTH","MIN_VERIFIER_LENGTH","ORIGINAL_URI_STORAGE_NAME","PKCE_STORAGE_NAME","REFERRER_PATH_STORAGE_KEY","REFRESH_TOKEN_STORAGE_KEY","SHARED_TRANSACTION_STORAGE_NAME","STATE_TOKEN_KEY_NAME","TOKEN_STORAGE_NAME","TRANSACTION_STORAGE_NAME","AuthStateManager","INITIAL_AUTH_STATE","ServiceManager","createCoreOptionsConstructor","createCoreStorageManager","createOktaAuthCore","mixinCore"].indexOf(c)<0&&(u[c]=function(e){return s[e]}.bind(0,c));n.d(t,u);var f=n(4777),l=n(9443);for(var c in u={},l)["default","crypto","createBaseOptionsConstructor","createOktaAuthBase","ACCESS_TOKEN_STORAGE_KEY","CACHE_STORAGE_NAME","DEFAULT_CACHE_DURATION","DEFAULT_CODE_CHALLENGE_METHOD","DEFAULT_MAX_CLOCK_SKEW","DEFAULT_POLLING_DELAY","IDX_API_VERSION","IDX_RESPONSE_STORAGE_NAME","ID_TOKEN_STORAGE_KEY","MAX_VERIFIER_LENGTH","MIN_VERIFIER_LENGTH","ORIGINAL_URI_STORAGE_NAME","PKCE_STORAGE_NAME","REFERRER_PATH_STORAGE_KEY","REFRESH_TOKEN_STORAGE_KEY","SHARED_TRANSACTION_STORAGE_NAME","STATE_TOKEN_KEY_NAME","TOKEN_STORAGE_NAME","TRANSACTION_STORAGE_NAME","AuthStateManager","INITIAL_AUTH_STATE","ServiceManager","createCoreOptionsConstructor","createCoreStorageManager","createOktaAuthCore","mixinCore","AuthApiError","AuthPollStopError","AuthSdkError","OAuthError","WWWAuthError","isAuthApiError","isOAuthError","isWWWAuthError","OktaUserAgent","createHttpOptionsConstructor","get","httpRequest","mixinHttp","post","setRequestHeader"].indexOf(c)<0&&(u[c]=function(e){return l[e]}.bind(0,c));n.d(t,u);var p=n(8041),h=n(9927),d=n(305)},415:function(e,t,n){"use strict";n.r(t),n.d(t,{getUserAgent:function(){return u},hasTextEncoder:function(){return p},isBrowser:function(){return i},isDPoPSupported:function(){return y},isFingerprintSupported:function(){return c},isHTTPS:function(){return d},isIE11OrLess:function(){return a},isLocalhost:function(){return v},isPKCESupported:function(){return h},isPopupPostMessageSupported:function(){return s},isTokenVerifySupported:function(){return l}});var r=n(7594),o=/windows phone|iemobile|wpdesktop/i;function i(){return"undefined"!=typeof document&&"undefined"!=typeof window}function a(){if(!i())return!1;var e=document.documentMode;return!!e&&e<=11}function u(){return navigator.userAgent}function c(){var e=u();return e&&!o.test(e)}function s(){if(!i())return!1;var e=document.documentMode,t=e&&e<10;return void 0!==window.postMessage&&!t}function f(){return void 0!==r.KP&&null!==r.KP&&void 0!==r.KP.subtle&&"undefined"!=typeof Uint8Array}function l(){return f()}function p(){return"undefined"!=typeof TextEncoder}function h(){return l()&&p()}function d(){return!!i()&&"https:"===window.location.protocol}function v(){return i()&&"localhost"===window.location.hostname}function y(){return!a()&&void 0!==window.indexedDB&&p()&&f()}},287:function(e,t,n){"use strict";n.d(t,{e:function(){return u}});var r=n(5671),o=n(3144),i=n(4942),a=n(415),u=function(){function e(){(0,r.Z)(this,e),(0,i.Z)(this,"environments",void 0),this.environments=["okta-auth-js/".concat("7.7.0")],this.maybeAddNodeEnvironment()}return(0,o.Z)(e,[{key:"addEnvironment",value:function(e){this.environments.push(e)}},{key:"getHttpHeader",value:function(){return{"X-Okta-User-Agent-Extended":this.environments.join(" ")}}},{key:"getVersion",value:function(){return"7.7.0"}},{key:"maybeAddNodeEnvironment",value:function(){if(!(0,a.isBrowser)()&&process&&process.versions){var e=process.versions.node;this.environments.push("nodejs/".concat(e))}}}]),e}()},2281:function(e,t,n){"use strict";function r(e,t,n){e.options.headers=e.options.headers||{},e.options.headers[t]=n}n.d(t,{r:function(){return r}})},4777:function(e,t,n){"use strict";n.d(t,{Am:function(){return a.A},U2:function(){return i.U2},ZM:function(){return u.Z},c3:function(){return i.c3},ed:function(){return o.e},rn:function(){return r.r},v_:function(){return i.v_}});var r=n(2281),o=n(287),i=n(5385),a=n(279),u=n(8817)},279:function(e,t,n){"use strict";n.d(t,{A:function(){return d}});var r=n(5671),o=n(3144),i=n(7326),a=n(136),u=n(2963),c=n(1120),s=n(4942),f=n(287),l=n(2281),p=n(6718),h=n(5385);function d(e){return function(e){(0,a.Z)(v,e);var t,n,d=(t=v,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function v(){var e;(0,r.Z)(this,v);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return e=d.call.apply(d,[this].concat(n)),(0,s.Z)((0,i.Z)(e),"_oktaUserAgent",void 0),(0,s.Z)((0,i.Z)(e),"http",void 0),e._oktaUserAgent=new f.e,e.http={setRequestHeader:l.r.bind(null,(0,i.Z)(e))},e}return(0,o.Z)(v,[{key:"setHeaders",value:function(e){this.options.headers=Object.assign({},this.options.headers,e)}},{key:"getIssuerOrigin",value:function(){return this.options.issuer.split("/oauth2/")[0]}},{key:"webfinger",value:function(e){var t="/.well-known/webfinger"+(0,p.UK)(e);return(0,h.U2)(this,t,{headers:{Accept:"application/jrd+json"}})}}]),v}(e)}},8817:function(e,t,n){"use strict";n.d(t,{Z:function(){return m}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),u=n(2963),c=n(1120),s=n(4942),f=n(3849),l=n(885),p=n(1002),h=n(4098),d=n.n(h);function v(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var y=/application\/\w*\+?json/,g=function(e,t,r){var o=r.data,i=r.headers||{},a=i["Content-Type"]||i["content-type"]||"";o&&"string"!=typeof o&&(y.test(a)?o=JSON.stringify(o):"application/x-www-form-urlencoded"===a&&(o=Object.entries(o).map((function(e){var t=(0,l.Z)(e,2),n=t[0],r=t[1];return"".concat(n,"=").concat(encodeURIComponent(r))})).join("&")));var u=(n.g.fetch||d())(t,{method:e,headers:r.headers,body:o,credentials:r.withCredentials?"include":"omit"});return u.finally||(u=Promise.resolve(u)),u.then((function(e){var t=!e.ok,n=e.status;return function(e){return e.headers.get("Content-Type")&&e.headers.get("Content-Type").toLowerCase().indexOf("application/json")>=0?e.json().catch((function(e){return{error:e,errorSummary:"Could not parse server response"}})):e.text()}(e).then((function(t){return function(e,t,n){var r,o="object"===(0,p.Z)(t),i={},a=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return v(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?v(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}(n.headers.entries());try{for(a.s();!(r=a.n()).done;){var u=r.value;i[u[0]]=u[1]}}catch(e){a.e(e)}finally{a.f()}var c={responseText:o?JSON.stringify(t):t,status:e,headers:i};return o&&(c.responseType="json",c.responseJSON=t),c}(n,t,e)})).then((function(e){var n;if(t||null!==(n=e.responseJSON)&&void 0!==n&&n.error)throw e;return e}))}))};function m(){return function(e){(0,a.Z)(l,e);var t,n,f=(t=l,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function l(e){var t;return(0,o.Z)(this,l),t=f.call(this,e),(0,s.Z)((0,i.Z)(t),"issuer",void 0),(0,s.Z)((0,i.Z)(t),"transformErrorXHR",void 0),(0,s.Z)((0,i.Z)(t),"headers",void 0),(0,s.Z)((0,i.Z)(t),"httpRequestClient",void 0),(0,s.Z)((0,i.Z)(t),"httpRequestInterceptors",void 0),t.issuer=e.issuer,t.transformErrorXHR=e.transformErrorXHR,t.headers=e.headers,t.httpRequestClient=e.httpRequestClient||g,t.httpRequestInterceptors=e.httpRequestInterceptors,t}return(0,r.Z)(l)}((0,f.T)())}},5385:function(e,t,n){"use strict";n.d(t,{U2:function(){return g},c3:function(){return y},v_:function(){return m}});var r=n(1002),o=n(4942),i=n(4771),a=n(3193),u=n(6718),c=n(1971),s=n(3983),f=n(3114),l=n(2886);function p(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function h(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function d(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?h(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):h(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var v=function(e,t){var n,r,o,u;if(t instanceof Error)return new s.Z({errorSummary:t.message});var c,p=t,h={};if(p.responseText&&(0,i.HD)(p.responseText))try{h=JSON.parse(p.responseText)}catch(e){h={errorSummary:"Unknown error"}}p.status>=500&&(h.errorSummary="Unknown error"),e.options.transformErrorXHR&&(p=e.options.transformErrorXHR((0,a.d9)(p)));var v=null!==(n=f.Z.getWWWAuthenticateHeader(null===(r=p)||void 0===r?void 0:r.headers))&&void 0!==n?n:"";if(c=h.error&&h.error_description?new l.Z(h.error,h.error_description,p):new s.Z(h,p,{wwwAuthHeader:v}),v&&(null===(o=p)||void 0===o?void 0:o.status)>=400&&(null===(u=p)||void 0===u?void 0:u.status)<500){var y=f.Z.parseHeader(v);if(403===p.status&&"insufficient_authentication_context"===(null==y?void 0:y.error)){var g=y.parameters,m=g.max_age,b=g.acr_values;c=new s.Z({errorSummary:y.error,errorCauses:[{errorSummary:y.errorDescription}]},p,d({max_age:+m},b&&{acr_values:b}))}else"DPoP"===(null==y?void 0:y.scheme)&&(c=y)}return c};function y(e,t){if(t=t||{},e.options.httpRequestInterceptors){var n,o=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return p(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?p(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}(e.options.httpRequestInterceptors);try{for(o.s();!(n=o.n()).done;)(0,n.value)(t)}catch(w){o.e(w)}finally{o.f()}}var u=t.url,s=t.method,f=t.args,l=t.saveAuthnState,h=t.accessToken,y=!0===t.withCredentials,g=e.options.storageUtil.storage,m=e.storageManager.getHttpCache(e.options.cookies);if(t.cacheResponse){var b=m.getStorage()[u];if(b&&Date.now()/1e3<b.expiresAt)return Promise.resolve(b.response)}var k=d({Accept:"application/json","Content-Type":"application/json"},e._oktaUserAgent.getHttpHeader());Object.assign(k,e.options.headers,t.headers),k=(0,a.YY)(k),h&&(0,i.HD)(h)&&(k.Authorization="Bearer "+h);var w,O,Z={headers:k,data:f||void 0,withCredentials:y};return e.options.httpRequestClient(s,u,Z).then((function(n){return(O=n.responseText)&&(0,i.HD)(O)&&(O=JSON.parse(O))&&"object"===(0,r.Z)(O)&&!O.headers&&(Array.isArray(O)?O.forEach((function(e){e.headers=n.headers})):O.headers=n.headers),l&&(O.stateToken||g.delete(c.STATE_TOKEN_KEY_NAME)),O&&O.stateToken&&O.expiresAt&&g.set(c.STATE_TOKEN_KEY_NAME,O.stateToken,O.expiresAt,e.options.cookies),O&&t.cacheResponse&&m.updateStorage(u,{expiresAt:Math.floor(Date.now()/1e3)+c.DEFAULT_CACHE_DURATION,response:O}),O})).catch((function(t){throw"E0000011"===(w=v(e,t)).errorCode&&g.delete(c.STATE_TOKEN_KEY_NAME),w}))}function g(e,t,n){var r={url:t=(0,u.sD)(t)?t:e.getIssuerOrigin()+t,method:"GET"};return Object.assign(r,n),y(e,r)}function m(e,t,n,r){var o={url:t=(0,u.sD)(t)?t:e.getIssuerOrigin()+t,method:"POST",args:n,saveAuthnState:!0};return Object.assign(o,r),y(e,o)}},3334:function(e,t,n){"use strict";n.d(t,{v:function(){return l}});var r=n(5671),o=n(3144),i=n(1752),a=n(136),u=n(2963),c=n(1120),s=n(1646),f=n(480);function l(){return function(e){(0,a.Z)(l,e);var t,n,s=(t=l,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function l(e){return(0,r.Z)(this,l),s.call(this,e)}return(0,o.Z)(l,[{key:"clear",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(0,i.Z)((0,c.Z)(l.prototype),"clear",this).call(this,e),!1!==e.clearIdxResponse&&this.clearIdxResponse()}},{key:"saveIdxResponse",value:function(e){if(this.saveLastResponse){var t=this.storageManager.getIdxResponseStorage();t&&t.setStorage(e)}}},{key:"loadIdxResponse",value:function(e){if(!this.saveLastResponse)return null;var t=this.storageManager.getIdxResponseStorage();if(!t)return null;var n=t.getStorage();if(!n||!(0,f.P)(n.rawIdxResponse))return null;if(e){var r=e.stateHandle,o=e.interactionHandle;if(!e.useGenericRemediator&&r&&n.stateHandle!==r)return null;if(o&&n.interactionHandle!==o)return null}return n}},{key:"clearIdxResponse",value:function(){if(this.saveLastResponse){var e=this.storageManager.getIdxResponseStorage();null==e||e.clearStorage()}}}]),l}((0,s.P)())}},1286:function(e,t,n){"use strict";n.d(t,{Y:function(){return l}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),u=n(7595),c=n(3377);function s(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function f(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?s(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function l(e){return p.apply(this,arguments)}function p(){return p=(0,o.Z)(a().mark((function e(t){var n,r=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return(n=r.length>1&&void 0!==r[1]?r[1]:{}).password&&!n.authenticator&&(n.authenticator=u.pc.OKTA_PASSWORD),e.abrupt("return",(0,c.K)(t,f(f({},n),{},{flow:"authenticate"})));case 3:case"end":return e.stop()}}),e)}))),p.apply(this,arguments)}},7644:function(e,t,n){"use strict";n.d(t,{_:function(){return a}});var r=n(3144),o=n(5671),i=n(4942),a=(0,r.Z)((function e(t){(0,o.Z)(this,e),(0,i.Z)(this,"meta",void 0),this.meta=t}))},9582:function(e,t,n){"use strict";n.d(t,{a:function(){return l}});var r=n(4942),o=n(5671),i=n(3144),a=n(136),u=n(2963),c=n(1120);function s(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function f(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?s(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var l=function(e){(0,a.Z)(s,e);var t,n,r=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function s(){return(0,o.Z)(this,s),r.apply(this,arguments)}return(0,i.Z)(s,[{key:"canVerify",value:function(e){return!!(e.credentials||e.password||e.passcode)}},{key:"mapCredentials",value:function(e){var t=e.credentials,n=e.password,r=e.passcode,o=e.revokeSessions;if(t||n||r)return t||{passcode:r||n,revokeSessions:o}}},{key:"getInputs",value:function(e){var t,n,r=[f(f({},null===(t=e.form)||void 0===t?void 0:t.value[0]),{},{name:"password",type:"string",required:e.required})];return(null===(n=e.form)||void 0===n?void 0:n.value.find((function(e){return"revokeSessions"===e.name})))&&r.push({name:"revokeSessions",type:"boolean",label:"Sign me out of all other devices",required:!1}),r}}]),s}(n(7644)._)},9344:function(e,t,n){"use strict";n.d(t,{LL:function(){return i},PN:function(){return a},h_:function(){return u}});var r=n(7595);function o(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function i(e){var t;if((0,r.H)(e))t=e;else{if("string"!=typeof e)throw new Error("Invalid format for authenticator");t={key:e}}return t}function a(e,t){return!!(e&&t&&(e.id&&t.id?e.id===t.id:e.key&&t.key&&e.key===t.key))}function u(e,t){var n,r,i=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return o(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?o(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,i=function(){};return{s:i,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:i}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,u=!0,c=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return u=e.done,e},e:function(e){c=!0,a=e},f:function(){try{u||null==n.return||n.return()}finally{if(c)throw a}}}}(e);try{var a=function(){var e=r.value;if(n=t.find((function(t){var n=t.relatesTo;return n.key&&n.key===e.key})))return"break"};for(i.s();!(r=i.n()).done&&"break"!==a(););}catch(e){i.e(e)}finally{i.f()}return n}},9192:function(e,t,n){"use strict";n.d(t,{a:function(){return l}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),u=n(3377),c=n(7738);function s(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function f(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?s(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function l(e,t){return p.apply(this,arguments)}function p(){return(p=(0,o.Z)(a().mark((function e(t,n){var r,o;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=t.transactionManager.load(),o=(0,c.s)(t,r.flow),e.abrupt("return",(0,u.K)(t,f(f(f({},n),o),{},{actions:["cancel"]})));case 3:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},7985:function(e,t,n){"use strict";n.d(t,{GA:function(){return g},Jn:function(){return b},gc:function(){return y},mo:function(){return m}});var r=n(5861),o=n(3144),i=n(5671),a=n(7326),u=n(136),c=n(2963),s=n(1120),f=n(4942),l=n(4687),p=n.n(l),h=n(6245),d=n(1969);var v=function(e){(0,u.Z)(l,e);var t,n,r=(t=l,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function l(e,t){var n;return(0,i.Z)(this,l),n=r.call(this,"Enter the OTP code in the originating client: ".concat(t)),(0,f.Z)((0,a.Z)(n),"state",void 0),(0,f.Z)((0,a.Z)(n),"otp",void 0),n.name="EmailVerifyCallbackError",n.state=e,n.otp=t,n}return(0,o.Z)(l)}(h.Z);function y(e){return"EmailVerifyCallbackError"===e.name}function g(e){return/(otp=)/i.test(e)&&/(state=)/i.test(e)}function m(e){return(0,d.v)(e)}function b(e,t){return k.apply(this,arguments)}function k(){return(k=(0,r.Z)(p().mark((function e(t,n){var r,o,i;return p().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!g(n)){e.next=9;break}if(r=m(n),o=r.state,i=r.otp,!t.idx.canProceed({state:o})){e.next=8;break}return e.next=5,t.idx.proceed({state:o,otp:i});case 5:return e.abrupt("return",e.sent);case 8:throw new v(o,i);case 9:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},2144:function(e,t,n){"use strict";n.d(t,{Y:function(){return i}});var r=n(1578),o=n(8137);function i(e,t,n){var i=(0,r.K)(e,t,n);return(0,o.B)(i)}},8717:function(e,t,n){"use strict";n.d(t,{F:function(){return K}});var r={};n.r(r),n.d(r,{AuthenticatorEnrollmentData:function(){return U.q},AuthenticatorVerificationData:function(){return N.q},ChallengeAuthenticator:function(){return E.J},ChallengePoll:function(){return S.U},EnrollAuthenticator:function(){return w.q},EnrollPoll:function(){return O.T},EnrollProfile:function(){return x.w},EnrollmentChannelData:function(){return T.t},GenericRemediator:function(){return F.P},Identify:function(){return A.h},ReEnrollAuthenticator:function(){return _.j},ReEnrollAuthenticatorWarning:function(){return R.i},RedirectIdp:function(){return j.O},Remediator:function(){return k.n},ResetAuthenticator:function(){return P.G},SelectAuthenticatorAuthenticate:function(){return C.X},SelectAuthenticatorEnroll:function(){return D.j},SelectAuthenticatorUnlockAccount:function(){return I.G},SelectEnrollProfile:function(){return M.j},SelectEnrollmentChannel:function(){return Z.V},Skip:function(){return L.h}});var o=n(8221),i=n(9912),a=n(1286),u=n(9192),c=n(7985),s=n(5021),f=n(6799),l=n(6131),p=n(2660),h=n(9310),d=n(2845),v=n(9214),y=n(8826),g=n(2473),m=n(2620),b=n(8277),k=n(3118),w=n(3857),O=n(2288),Z=n(3403),T=n(3679),E=n(4560),S=n(1104),P=n(1019),x=n(7522),A=n(8628),_=n(9024),R=n(8107),j=n(8490),C=n(7311),D=n(9865),I=n(5272),M=n(4713),N=n(5278),U=n(2541),L=n(8443),F=n(9732),B=n(7738),H=n(5031);function K(e){(0,H.TC)({remediators:r,getFlowSpecification:B.s});var t=g.Y.bind(null,e);return{interact:l.E.bind(null,e),introspect:p.L.bind(null,e),makeIdxResponse:f._T.bind(null,e),authenticate:a.Y.bind(null,e),register:y.z.bind(null,e),start:t,startTransaction:t,poll:h.$.bind(null,e),proceed:d.x.bind(null,e),cancel:u.a.bind(null,e),recoverPassword:v.M.bind(null,e),handleInteractionCodeRedirect:s.X.bind(null,e),isInteractionRequired:o.wc.bind(null,e),isInteractionRequiredError:i.Cf,handleEmailVerifyCallback:c.Jn.bind(null,e),isEmailVerifyCallback:c.GA,parseEmailVerifyCallback:c.mo,isEmailVerifyCallbackError:c.gc,getSavedTransactionMeta:m.uN.bind(null,e),createTransactionMeta:m.Xc.bind(null,e),getTransactionMeta:m.Co.bind(null,e),saveTransactionMeta:m.r0.bind(null,e),clearTransactionMeta:m.Jm.bind(null,e),isTransactionMetaValid:m.Wf,setFlow:function(t){e.options.flow=t},getFlow:function(){return e.options.flow},canProceed:d.C.bind(null,e),unlockAccount:b.l.bind(null,e)}}},7738:function(e,t,n){"use strict";n.d(t,{s:function(){return S}});var r=n(8628),o=n(7311),i=n(9865),a=n(2541),u=n(5278),c=n(3857),s=n(4560),f=n(1104),l=n(9024),p=n(8107),h=n(2288),d=n(3403),v=n(3679),y=n(8490),g=n(8443),m={identify:r.h,"select-authenticator-authenticate":o.X,"select-authenticator-enroll":i.j,"authenticator-enrollment-data":a.q,"authenticator-verification-data":u.q,"enroll-authenticator":c.q,"challenge-authenticator":s.J,"challenge-poll":f.U,"reenroll-authenticator":l.j,"reenroll-authenticator-warning":p.i,"enroll-poll":h.T,"select-enrollment-channel":d.V,"enrollment-channel-data":v.t,"redirect-idp":y.O,skip:g.h},b=n(1019),k={identify:r.h,"identify-recovery":r.h,"select-authenticator-authenticate":o.X,"select-authenticator-enroll":i.j,"challenge-authenticator":s.J,"authenticator-verification-data":u.q,"authenticator-enrollment-data":a.q,"reset-authenticator":b.G,"reenroll-authenticator":l.j,"reenroll-authenticator-warning":p.i,"enroll-poll":h.T},w=n(4713),O=n(7522),Z={"select-enroll-profile":w.j,"enroll-profile":O.w,"authenticator-enrollment-data":a.q,"select-authenticator-enroll":i.j,"enroll-poll":h.T,"select-enrollment-channel":d.V,"enrollment-channel-data":v.t,"enroll-authenticator":c.q,skip:g.h},T=n(5272),E={identify:r.h,"select-authenticator-unlock-account":T.G,"select-authenticator-authenticate":o.X,"challenge-authenticator":s.J,"challenge-poll":f.U,"authenticator-verification-data":u.q,"reenroll-authenticator-warning":p.i};function S(e){var t,n,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"default",o=!0;switch(r){case"register":case"signup":case"enrollProfile":t=Z,o=!1;break;case"recoverPassword":case"resetPassword":t=k,n=["currentAuthenticator-recover","currentAuthenticatorEnrollment-recover"],o=!1;break;case"unlockAccount":t=E,o=!1,n=["unlock-account"];break;default:t=m}return{flow:r,remediators:t,actions:n,withCredentials:o}}},5021:function(e,t,n){"use strict";n.d(t,{X:function(){return c}});var r=n(5861),o=n(4687),i=n.n(o),a=n(9123),u=n(2886);function c(e,t){return s.apply(this,arguments)}function s(){return(s=(0,r.Z)(i().mark((function e(t,n){var r,o,c,s,f,l,p,h,d,v;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=t.transactionManager.load()){e.next=3;break}throw new a.Z("No transaction data was found in storage");case 3:if(o=r.codeVerifier,c=r.state,s=new URL(n),f=s.searchParams,l=f.get("state"),p=f.get("interaction_code"),!(h=f.get("error"))){e.next=10;break}throw new u.Z(h,f.get("error_description"));case 10:if(l===c){e.next=12;break}throw new a.Z("State in redirect uri does not match with transaction state");case 12:if(p){e.next=14;break}throw new a.Z("Unable to parse interaction_code from the url");case 14:return e.next=16,t.token.exchangeCodeForTokens({interactionCode:p,codeVerifier:o});case 16:d=e.sent,v=d.tokens,t.tokenManager.setTokens(v);case 19:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},6799:function(e,t,n){"use strict";n.d(t,{_T:function(){return z},A0:function(){return Y}});var r=n(1971),o=n(5861),i=n(2982),a=n(4687),u=n.n(a),c=n(885),s=n(4942),f=n(4925),l=n(1002),p=n(5385);function h(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return d(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?d(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}function d(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var v=function(e){return!1!==e.mutable},y=function(e){var t={},n=[],r={};if(!e.value)return n.push(e),{defaultParamsForAction:t,neededParamsForAction:n,immutableParamsForAction:r};var o,i=h(e.value);try{for(i.s();!(o=i.n()).done;){var a,u,c=o.value;v(c)?(n.push(c),null!==(a=c.value)&&void 0!==a&&a&&(t[c.name]=c.value)):r[c.name]=null!==(u=c.value)&&void 0!==u?u:""}}catch(e){i.e(e)}finally{i.f()}return{defaultParamsForAction:t,neededParamsForAction:n,immutableParamsForAction:r}},g=n(3983);function m(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function b(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?m(Object(n),!0).forEach((function(t){(0,s.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):m(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var k=function(e,t){var n=t.actionDefinition,r=t.defaultParamsForAction,i=void 0===r?{}:r,a=t.immutableParamsForAction,c=void 0===a?{}:a,s=t.toPersist,f=void 0===s?{}:s,l=n.href;return(0,o.Z)(u().mark((function t(){var r,o,a,s,h,d,v,y,m,k=arguments;return u().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=k.length>0&&void 0!==k[0]?k[0]:{},o={"Content-Type":"application/json",Accept:n.accepts||"application/ion+json"},a=JSON.stringify(b(b(b({},i),r),c)),t.prev=3,t.next=6,(0,p.c3)(e,{url:l,method:n.method,headers:o,args:a,withCredentials:null===(s=null==f?void 0:f.withCredentials)||void 0===s||s});case 6:return h=t.sent,t.abrupt("return",e.idx.makeIdxResponse(b({},h),f,!0));case 10:if(t.prev=10,t.t0=t.catch(3),t.t0 instanceof g.Z&&null!==t.t0&&void 0!==t.t0&&t.t0.xhr){t.next=14;break}throw t.t0;case 14:return d=t.t0.xhr,v=d.responseJSON||JSON.parse(d.responseText),y=d.headers["WWW-Authenticate"]||d.headers["www-authenticate"],m=e.idx.makeIdxResponse(b({},v),f,!1),401===d.status&&'Oktadevicejwt realm="Okta Device"'===y&&(m.stepUp=!0),t.abrupt("return",m);case 20:case"end":return t.stop()}}),t,null,[[3,10]])})))},w=function(e,t,n){var r=k,o=function(e){var t,n=[],r={},o={},i=h(e=Array.isArray(e)?e:[e]);try{for(i.s();!(t=i.n()).done;){var a=t.value,u=y(a),c=u.defaultParamsForAction,s=u.neededParamsForAction,f=u.immutableParamsForAction;n.push(s),r[a.name]=c,o[a.name]=f}}catch(e){i.e(e)}finally{i.f()}return{defaultParams:r,neededParams:n,immutableParams:o}}(t),i=o.defaultParams,a=o.neededParams,u=o.immutableParams,c=r(e,{actionDefinition:t,defaultParamsForAction:i[t.name],immutableParamsForAction:u[t.name],toPersist:n});return c.neededParams=a,c};function O(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Z(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?O(Object(n),!0).forEach((function(t){(0,s.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):O(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function T(e){return T="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},T(e)}function E(e){return E=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)},E(e)}function S(e,t){return S=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e},S(e,t)}function P(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}function x(e,t,n){return x=P()?Reflect.construct:function(e,t,n){var r=[null];r.push.apply(r,t);var o=new(Function.bind.apply(e,r));return n&&S(o,n.prototype),o},x.apply(null,arguments)}function A(e){var t="function"==typeof Map?new Map:void 0;return A=function(e){if(null===e||(n=e,-1===Function.toString.call(n).indexOf("[native code]")))return e;var n;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==t){if(t.has(e))return t.get(e);t.set(e,r)}function r(){return x(e,arguments,E(this).constructor)}return r.prototype=Object.create(e.prototype,{constructor:{value:r,enumerable:!1,writable:!0,configurable:!0}}),S(r,e)},A(e)}function _(e){return function(e){if(Array.isArray(e))return j(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||R(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function R(e,t){if(e){if("string"==typeof e)return j(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?j(e,t):void 0}}function j(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var C=Object.prototype.hasOwnProperty;function D(e,t){return(e=e.slice()).push(t),e}function I(e,t){return(t=t.slice()).unshift(e),t}var M=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&S(e,t)}(o,e);var t,n,r=(t=o,n=P(),function(){var e,r=E(t);if(n){var o=E(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return function(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}(this,e)});function o(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,o),(t=r.call(this,'JSONPath should not be called with "new" (it prevents return of (unwrapped) scalar values)')).avoidNew=!0,t.value=e,t.name="NewError",t}return o}(A(Error));function N(e,t,n,r,o){if(!(this instanceof N))try{return new N(e,t,n,r,o)}catch(e){if(!e.avoidNew)throw e;return e.value}"string"==typeof e&&(o=r,r=n,n=t,t=e,e=null);var i=e&&"object"===T(e);if(e=e||{},this.json=e.json||n,this.path=e.path||t,this.resultType=e.resultType||"value",this.flatten=e.flatten||!1,this.wrap=!C.call(e,"wrap")||e.wrap,this.sandbox=e.sandbox||{},this.preventEval=e.preventEval||!1,this.parent=e.parent||null,this.parentProperty=e.parentProperty||null,this.callback=e.callback||r||null,this.otherTypeCallback=e.otherTypeCallback||o||function(){throw new TypeError("You must supply an otherTypeCallback callback option with the @other() operator.")},!1!==e.autostart){var a={path:i?e.path:t};i?"json"in e&&(a.json=e.json):a.json=n;var u=this.evaluate(a);if(!u||"object"!==T(u))throw new M(u);return u}}function U(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}N.prototype.evaluate=function(e,t,n,r){var o=this,i=this.parent,a=this.parentProperty,u=this.flatten,c=this.wrap;if(this.currResultType=this.resultType,this.currPreventEval=this.preventEval,this.currSandbox=this.sandbox,n=n||this.callback,this.currOtherTypeCallback=r||this.otherTypeCallback,t=t||this.json,(e=e||this.path)&&"object"===T(e)&&!Array.isArray(e)){if(!e.path&&""!==e.path)throw new TypeError('You must supply a "path" property when providing an object argument to JSONPath.evaluate().');if(!C.call(e,"json"))throw new TypeError('You must supply a "json" property when providing an object argument to JSONPath.evaluate().');t=e.json,u=C.call(e,"flatten")?e.flatten:u,this.currResultType=C.call(e,"resultType")?e.resultType:this.currResultType,this.currSandbox=C.call(e,"sandbox")?e.sandbox:this.currSandbox,c=C.call(e,"wrap")?e.wrap:c,this.currPreventEval=C.call(e,"preventEval")?e.preventEval:this.currPreventEval,n=C.call(e,"callback")?e.callback:n,this.currOtherTypeCallback=C.call(e,"otherTypeCallback")?e.otherTypeCallback:this.currOtherTypeCallback,i=C.call(e,"parent")?e.parent:i,a=C.call(e,"parentProperty")?e.parentProperty:a,e=e.path}if(i=i||null,a=a||null,Array.isArray(e)&&(e=N.toPathString(e)),(e||""===e)&&t){var s=N.toPathArray(e);"$"===s[0]&&s.length>1&&s.shift(),this._hasParentSelector=null;var f=this._trace(s,t,["$"],i,a,n).filter((function(e){return e&&!e.isParentSelector}));return f.length?c||1!==f.length||f[0].hasArrExpr?f.reduce((function(e,t){var n=o._getPreferredOutput(t);return u&&Array.isArray(n)?e=e.concat(n):e.push(n),e}),[]):this._getPreferredOutput(f[0]):c?[]:void 0}},N.prototype._getPreferredOutput=function(e){var t=this.currResultType;switch(t){case"all":var n=Array.isArray(e.path)?e.path:N.toPathArray(e.path);return e.pointer=N.toPointer(n),e.path="string"==typeof e.path?e.path:N.toPathString(e.path),e;case"value":case"parent":case"parentProperty":return e[t];case"path":return N.toPathString(e[t]);case"pointer":return N.toPointer(e.path);default:throw new TypeError("Unknown result type")}},N.prototype._handleCallback=function(e,t,n){if(t){var r=this._getPreferredOutput(e);e.path="string"==typeof e.path?e.path:N.toPathString(e.path),t(r,n,e)}},N.prototype._trace=function(e,t,n,r,o,i,a,u){var c,s=this;if(!e.length)return c={path:n,value:t,parent:r,parentProperty:o,hasArrExpr:a},this._handleCallback(c,i,"value"),c;var f=e[0],l=e.slice(1),p=[];function h(e){Array.isArray(e)?e.forEach((function(e){p.push(e)})):p.push(e)}if(("string"!=typeof f||u)&&t&&C.call(t,f))h(this._trace(l,t[f],D(n,f),t,f,i,a));else if("*"===f)this._walk(f,l,t,n,r,o,i,(function(e,t,n,r,o,i,a,u){h(s._trace(I(e,n),r,o,i,a,u,!0,!0))}));else if(".."===f)h(this._trace(l,t,n,r,o,i,a)),this._walk(f,l,t,n,r,o,i,(function(e,t,n,r,o,i,a,u){"object"===T(r[e])&&h(s._trace(I(t,n),r[e],D(o,e),r,e,u,!0))}));else{if("^"===f)return this._hasParentSelector=!0,{path:n.slice(0,-1),expr:l,isParentSelector:!0};if("~"===f)return c={path:D(n,f),value:o,parent:r,parentProperty:null},this._handleCallback(c,i,"property"),c;if("$"===f)h(this._trace(l,t,n,null,null,i,a));else if(/^(\x2D?[0-9]*):(\x2D?[0-9]*):?([0-9]*)$/.test(f))h(this._slice(f,l,t,n,r,o,i));else if(0===f.indexOf("?(")){if(this.currPreventEval)throw new Error("Eval [?(expr)] prevented in JSONPath expression.");this._walk(f,l,t,n,r,o,i,(function(e,t,n,r,o,i,a,u){s._eval(t.replace(/^\?\(((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\)$/,"$1"),r[e],e,o,i,a)&&h(s._trace(I(e,n),r,o,i,a,u,!0))}))}else if("("===f[0]){if(this.currPreventEval)throw new Error("Eval [(expr)] prevented in JSONPath expression.");h(this._trace(I(this._eval(f,t,n[n.length-1],n.slice(0,-1),r,o),l),t,n,r,o,i,a))}else if("@"===f[0]){var d=!1,v=f.slice(1,-2);switch(v){case"scalar":t&&["object","function"].includes(T(t))||(d=!0);break;case"boolean":case"string":case"undefined":case"function":T(t)===v&&(d=!0);break;case"integer":!Number.isFinite(t)||t%1||(d=!0);break;case"number":Number.isFinite(t)&&(d=!0);break;case"nonFinite":"number"!=typeof t||Number.isFinite(t)||(d=!0);break;case"object":t&&T(t)===v&&(d=!0);break;case"array":Array.isArray(t)&&(d=!0);break;case"other":d=this.currOtherTypeCallback(t,n,r,o);break;case"null":null===t&&(d=!0);break;default:throw new TypeError("Unknown value type "+v)}if(d)return c={path:n,value:t,parent:r,parentProperty:o},this._handleCallback(c,i,"value"),c}else if("`"===f[0]&&t&&C.call(t,f.slice(1))){var y=f.slice(1);h(this._trace(l,t[y],D(n,y),t,y,i,a,!0))}else if(f.includes(",")){var g,m=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=R(e))){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}(f.split(","));try{for(m.s();!(g=m.n()).done;){var b=g.value;h(this._trace(I(b,l),t,n,r,o,i,!0))}}catch(e){m.e(e)}finally{m.f()}}else!u&&t&&C.call(t,f)&&h(this._trace(l,t[f],D(n,f),t,f,i,a,!0))}if(this._hasParentSelector)for(var k=0;k<p.length;k++){var w=p[k];if(w&&w.isParentSelector){var O=this._trace(w.expr,t,w.path,r,o,i,a);if(Array.isArray(O)){p[k]=O[0];for(var Z=O.length,E=1;E<Z;E++)k++,p.splice(k,0,O[E])}else p[k]=O}}return p},N.prototype._walk=function(e,t,n,r,o,i,a,u){if(Array.isArray(n))for(var c=n.length,s=0;s<c;s++)u(s,e,t,n,r,o,i,a);else n&&"object"===T(n)&&Object.keys(n).forEach((function(c){u(c,e,t,n,r,o,i,a)}))},N.prototype._slice=function(e,t,n,r,o,i,a){if(Array.isArray(n)){var u=n.length,c=e.split(":"),s=c[2]&&Number.parseInt(c[2])||1,f=c[0]&&Number.parseInt(c[0])||0,l=c[1]&&Number.parseInt(c[1])||u;f=f<0?Math.max(0,f+u):Math.min(u,f),l=l<0?Math.max(0,l+u):Math.min(u,l);for(var p=[],h=f;h<l;h+=s)this._trace(I(h,t),n,r,o,i,a,!0).forEach((function(e){p.push(e)}));return p}},N.prototype._eval=function(e,t,n,r,o,i){e.includes("@parentProperty")&&(this.currSandbox._$_parentProperty=i,e=e.replace(/@parentProperty/g,"_$_parentProperty")),e.includes("@parent")&&(this.currSandbox._$_parent=o,e=e.replace(/@parent/g,"_$_parent")),e.includes("@property")&&(this.currSandbox._$_property=n,e=e.replace(/@property/g,"_$_property")),e.includes("@path")&&(this.currSandbox._$_path=N.toPathString(r.concat([n])),e=e.replace(/@path/g,"_$_path")),e.includes("@root")&&(this.currSandbox._$_root=this.json,e=e.replace(/@root/g,"_$_root")),/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/.test(e)&&(this.currSandbox._$_v=t,e=e.replace(/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/g,"_$_v$1"));try{return this.vm.runInNewContext(e,this.currSandbox)}catch(t){throw console.log(t),new Error("jsonPath: "+t.message+": "+e)}},N.cache={},N.toPathString=function(e){for(var t=e,n=t.length,r="$",o=1;o<n;o++)/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(t[o])||(r+=/^[\*0-9]+$/.test(t[o])?"["+t[o]+"]":"['"+t[o]+"']");return r},N.toPointer=function(e){for(var t=e,n=t.length,r="",o=1;o<n;o++)/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(t[o])||(r+="/"+t[o].toString().replace(/~/g,"~0").replace(/\//g,"~1"));return r},N.toPathArray=function(e){var t=N.cache;if(t[e])return t[e].concat();var n=[],r=e.replace(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/g,";$&;").replace(/['\[](\??\((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\))['\]]/g,(function(e,t){return"[#"+(n.push(t)-1)+"]"})).replace(/\[["']((?:(?!['\]])[\s\S])*)["']\]/g,(function(e,t){return"['"+t.replace(/\./g,"%@%").replace(/~/g,"%%@@%%")+"']"})).replace(/~/g,";~;").replace(/["']?\.["']?(?!(?:(?!\[)[\s\S])*\])|\[["']?/g,";").replace(/%@%/g,".").replace(/%%@@%%/g,"~").replace(/(?:;)?(\^+)(?:;)?/g,(function(e,t){return";"+t.split("").join(";")+";"})).replace(/;;;|;;/g,";..;").replace(/;$|'?\]|'$/g,"").split(";").map((function(e){var t=e.match(/#([0-9]+)/);return t&&t[1]?n[t[1]]:e}));return t[e]=r,t[e].concat()},N.prototype.vm={runInNewContext:function(e,t){var n=Object.keys(t),r=[];!function(e,n,r){for(var o=e.length,i=0;i<o;i++)a=e[i],"function"==typeof t[a]&&n.push(e.splice(i--,1)[0]);var a}(n,r);var o=n.map((function(e,n){return t[e]})),i=r.reduce((function(e,n){var r=t[n].toString();return/function/.test(r)||(r="function "+r),"var "+n+"="+r+";"+e}),"");/(["'])use strict\1/.test(e=i+e)||n.includes("arguments")||(e="var arguments = undefined;"+e);var a=(e=e.replace(/;[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/,"")).lastIndexOf(";"),u=a>-1?e.slice(0,a+1)+" return "+e.slice(a+1):" return "+e;return x(Function,_(n).concat([u])).apply(void 0,_(o))}};var L=n(9123),F=["value","type"];function B(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function H(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?B(Object(n),!0).forEach((function(t){(0,s.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):B(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var K={remediation:!0,context:!0},G=function e(t,n){Object.keys(n).forEach((function(r){if("relatesTo"===r){var o=Array.isArray(n[r])?n[r][0]:n[r];if("string"==typeof o){var i=(a={path:o,json:t},N(function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?U(Object(n),!0).forEach((function(t){(0,s.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):U(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({preventEval:!0},a)))[0];if(i)return void(n[r]=i);throw new L.Z("Cannot resolve relatesTo: ".concat(o))}}var a;Array.isArray(n[r])&&n[r].forEach((function(n){return e(t,n)}))}))},V=function(e,t){var n,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},o=(null===(n=t.remediation)||void 0===n?void 0:n.value)||[];o.forEach((function(e){var n;if("launch-authenticator"!==e.name||"authenticatorChallenge"!==(null==e||null===(n=e.relatesTo)||void 0===n?void 0:n[0])||null!=t&&t.authenticatorChallenge)return G(t,e);delete e.relatesTo}));var i=o.map((function(t){return function(e,t,n){if(t.rel){var r=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return t.reduce((function(t,r){return Z(Z({},t),{},(0,s.Z)({},r.name,w(e,r,n)))}),{})}(e,[t],n),o=r[t.name];return H(H({},t),{},{action:o})}return t}(e,t,r)})),a=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r={},o={};return Object.keys(t).filter((function(e){return!K[e]})).forEach((function(i){if("object"===(0,l.Z)(t[i])&&t[i])if(t[i].rel)r[t[i].name]=w(e,t[i],n);else{var a=t[i],u=a.value,s=a.type,p=(0,f.Z)(a,F);o[i]=H({type:s},p),"object"===s?(o[i].value={},Object.entries(u).forEach((function(t){var a=(0,c.Z)(t,2),u=a[0],s=a[1];s.rel?r["".concat(i,"-").concat(u.name||u)]=w(e,s,n):o[i].value[u]=s}))):o[i].value=u}else o[i]=t[i]})),{context:o,actions:r}}(e,t,r);return{remediations:i,context:a.context,actions:a.actions}},q={makeIdxState:function(e,t,n,r){var a,c,s,f,l=t,p=V(e,t,n),h=p.remediations,d=p.context,v=p.actions,y=(0,i.Z)(h),g=(f=(0,o.Z)(u().mark((function e(t){var n,r,o=arguments;return u().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=o.length>1&&void 0!==o[1]?o[1]:{},r=h.find((function(e){return e.name===t}))){e.next=4;break}return e.abrupt("return",Promise.reject("Unknown remediation choice: [".concat(t,"]")));case 4:if("function"==typeof r.action){e.next=7;break}return e.abrupt("return",Promise.reject("Current remediation cannot make form submit action: [".concat(t,"]")));case 7:return e.abrupt("return",r.action(n));case 8:case"end":return e.stop()}}),e)}))),function(e){return f.apply(this,arguments)});return{proceed:g,neededToProceed:y,actions:v,context:d,rawIdxState:l,interactionCode:null===(a=l.successWithInteractionCode)||void 0===a||null===(c=a.value)||void 0===c||null===(s=c.find((function(e){return"interaction_code"===e.name})))||void 0===s?void 0:s.value,toPersist:n,requestDidSucceed:r}}},W=function(e){switch(e){case"1.0.0":return q;case void 0:case null:throw new Error("Api version is required");default:throw new Error("Unknown api version: ".concat(e,".  Use an exact semver version."))}};function Y(e){if(!e)throw new Error("version is required");if((null!=e?e:"").replace(/[^0-9a-zA-Z._-]/,"")!==e||!e)throw new Error("invalid version supplied - version is required and uses semver syntax");W(e)}function z(e,t,n,o){var i,a=null!==(i=null==t?void 0:t.version)&&void 0!==i?i:r.IDX_API_VERSION;return Y(a),(0,W(a).makeIdxState)(e,t,n,o)}},9999:function(e,t,n){"use strict";n.d(t,{pc:function(){return B.pc},Fw:function(){return B.Fw},Qd:function(){return B.Qd},YR:function(){return r.Y},Ch:function(){return s.C},al:function(){return o.a},Jm:function(){return v.Jm},F4:function(){return y.F},SL:function(){return L.S},aT:function(){return F.a},vK:function(){return H.v},UB:function(){return N},Yn:function(){return g.Y},Xc:function(){return v.Xc},uN:function(){return v.uN},Co:function(){return v.Co},Jn:function(){return i.Jn},Xx:function(){return p.X},$0:function(){return v.$0},EW:function(){return a.E},L8:function(){return u.L},H:function(){return B.H},GA:function(){return i.GA},gc:function(){return i.gc},Wf:function(){return v.Wf},bl:function(){return v.bl},UC:function(){return v.UC},B_:function(){return U.B},mo:function(){return i.mo},$l:function(){return c.$},xc:function(){return s.x},M4:function(){return l.M},z2:function(){return f.z},r0:function(){return v.r0},Yr:function(){return h.Y},le:function(){return d.l}});var r=n(1286),o=n(9192),i=n(7985),a=n(6131),u=n(2660),c=n(9310),s=n(2845),f=n(8826),l=n(9214),p=n(5021),h=n(2473),d=n(8277),v=n(2620),y=n(8717),g=n(2144),m=n(3144),b=n(5671),k=n(7326),w=n(136),O=n(2963),Z=n(1120),T=n(4942),E=n(6799),S=n(8716);function P(e){var t;return t=function(e){(0,w.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,Z.Z)(t);if(n){var o=(0,Z.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,O.Z)(this,e)});function o(){var e,t,n;(0,b.Z)(this,o);for(var i=arguments.length,a=new Array(i),u=0;u<i;u++)a[u]=arguments[u];return e=r.call.apply(r,[this].concat(a)),(0,T.Z)((0,k.Z)(e),"idx",void 0),e.idx=(t=(0,k.Z)(e),n=h.Y.bind(null,t),{makeIdxResponse:E._T.bind(null,t),start:n,startTransaction:n,proceed:s.x.bind(null,t),canProceed:s.C.bind(null,t),getSavedTransactionMeta:v.uN.bind(null,t),createTransactionMeta:v.Xc.bind(null,t),getTransactionMeta:v.Co.bind(null,t),saveTransactionMeta:v.r0.bind(null,t),clearTransactionMeta:v.Jm.bind(null,t),isTransactionMetaValid:v.Wf}),e}return(0,m.Z)(o)}(e),(0,T.Z)(t,"webauthn",S),t}var x=n(9893),A=n(265),_=n(279),R=n(3980),j=n(1237),C=n(8707),D=n(6898),I=n(8221);function M(e,t){return function(e){(0,w.Z)(i,e);var n,r,o=(n=i,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=(0,Z.Z)(n);if(r){var o=(0,Z.Z)(this).constructor;e=Reflect.construct(t,arguments,o)}else e=t.apply(this,arguments);return(0,O.Z)(this,e)});function i(){var e,n;(0,b.Z)(this,i);for(var r=arguments.length,a=new Array(r),u=0;u<r;u++)a[u]=arguments[u];return e=o.call.apply(o,[this].concat(a)),(0,T.Z)((0,k.Z)(e),"token",void 0),(0,T.Z)((0,k.Z)(e),"transactionManager",void 0),e.transactionManager=new t(Object.assign({storageManager:e.storageManager},e.options.transactionManager)),e.token=(n=(0,k.Z)(e),{prepareTokenParams:D.wu.bind(null,n),exchangeCodeForTokens:C.r.bind(null,n),decode:j.T}),e}return(0,m.Z)(i,[{key:"isLoginRedirect",value:function(){return(0,I.gM)(this)}},{key:"isPKCE",value:function(){return!!this.options.pkce}},{key:"hasResponseType",value:function(e){return(0,I.wV)(e,this.options)}},{key:"isAuthorizationCodeFlow",value:function(){return this.hasResponseType("code")}}]),i}(e)}function N(e,t,n){var r=(0,x.a)(t),o=(0,A.H)(r,e),i=(0,_.A)(o);return P(M((0,R.Z)(i),n))}var U=n(8137),L=n(4602),F=n(4143),B=n(7595),H=n(3334)},6131:function(e,t,n){"use strict";n.d(t,{E:function(){return d}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),u=n(2620),c=n(7599),s=n(3193),f=n(5385);function l(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function p(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?l(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):l(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function h(e){return{meta:e,interactionHandle:e.interactionHandle,state:e.state}}function d(e){return v.apply(this,arguments)}function v(){return v=(0,o.Z)(a().mark((function e(t){var n,r,o,i,l,d,v,y,g,m,b,k,w,O,Z,T,E,S,P,x,A,_,R,j,C,D=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(o=D.length>1&&void 0!==D[1]?D[1]:{},o=(0,s.YY)(o),i=(0,u.uN)(t,o),null===(n=i)||void 0===n||!n.interactionHandle){e.next=5;break}return e.abrupt("return",h(i));case 5:return e.next=7,(0,u.Xc)(t,p(p({},i),o));case 7:return i=e.sent,l=(0,c.zf)(t),v=(d=i).clientId,y=d.redirectUri,g=d.state,m=d.scopes,b=d.withCredentials,k=d.codeChallenge,w=d.codeChallengeMethod,O=d.activationToken,Z=d.recoveryToken,T=d.maxAge,E=d.acrValues,S=d.nonce,P=o.clientSecret||t.options.clientSecret,b=null===(r=b)||void 0===r||r,x="".concat(l,"/v1/interact"),A=p(p(p(p(p(p({client_id:v,scope:m.join(" "),redirect_uri:y,code_challenge:k,code_challenge_method:w,state:g},O&&{activation_token:O}),Z&&{recovery_token:Z}),P&&{client_secret:P}),T&&{max_age:T}),E&&{acr_values:E}),S&&{nonce:S}),_={"Content-Type":"application/x-www-form-urlencoded"},e.next=17,(0,f.c3)(t,{method:"POST",url:x,headers:_,withCredentials:b,args:A});case 17:return R=e.sent,j=R.interaction_handle,C=p(p({},i),{},{interactionHandle:j,withCredentials:b,state:g,scopes:m,recoveryToken:Z,activationToken:O}),(0,u.r0)(t,C),e.abrupt("return",h(C));case 22:case"end":return e.stop()}}),e)}))),v.apply(this,arguments)}},2660:function(e,t,n){"use strict";n.d(t,{L:function(){return p}});var r=n(5861),o=n(4687),i=n.n(o),a=n(6799),u=n(480),c=n(7599),s=n(1971),f=n(5385),l=n(5728);function p(e){return h.apply(this,arguments)}function h(){return h=(0,r.Z)(i().mark((function e(t){var n,r,o,p,h,d,v,y,g,m,b,k,w,O,Z=arguments;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=Z.length>1&&void 0!==Z[1]?Z[1]:{},(p=t.transactionManager.loadIdxResponse(n))&&(r=p.rawIdxResponse,o=p.requestDidSucceed),r){e.next=27;break}return d=n.version||s.IDX_API_VERSION,v=(0,c.Xp)(t),y=n.interactionHandle,g=n.stateHandle,m=null===(h=n.withCredentials)||void 0===h||h,e.prev=8,o=!0,(0,a.A0)(d),b="".concat(v,"/idp/idx/introspect"),k=g?{stateToken:g}:{interactionHandle:y},w={"Content-Type":"application/ion+json; okta-version=".concat(d),Accept:"application/ion+json; okta-version=".concat(d)},e.next=16,(0,f.c3)(t,{method:"POST",url:b,headers:w,withCredentials:m,args:k});case 16:r=e.sent,e.next=27;break;case 19:if(e.prev=19,e.t0=e.catch(8),!((0,l.isAuthApiError)(e.t0)&&e.t0.xhr&&(0,u.P)(e.t0.xhr.responseJSON))){e.next=26;break}r=e.t0.xhr.responseJSON,o=!1,e.next=27;break;case 26:throw e.t0;case 27:return O=n.withCredentials,e.abrupt("return",(0,a._T)(t,r,{withCredentials:O},o));case 29:case"end":return e.stop()}}),e,null,[[8,19]])}))),h.apply(this,arguments)}},8137:function(e,t,n){"use strict";n.d(t,{B:function(){return p}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),u=n(2963),c=n(1120),s=n(4942),f=n(8717),l=n(8716);function p(e){var t;return t=function(e){(0,a.Z)(p,e);var t,n,l=(t=p,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function p(){var e;(0,o.Z)(this,p);for(var t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];return e=l.call.apply(l,[this].concat(n)),(0,s.Z)((0,i.Z)(e),"idx",void 0),e.idx=(0,f.F)((0,i.Z)(e)),e}return(0,r.Z)(p)}(e),(0,s.Z)(t,"webauthn",l),t}},4602:function(e,t,n){"use strict";n.d(t,{S:function(){return l}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),u=n(2963),c=n(1120),s=n(4942),f=n(9133);function l(){return function(e){(0,a.Z)(l,e);var t,n,f=(t=l,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function l(e){var t;return(0,o.Z)(this,l),t=f.call(this,e),(0,s.Z)((0,i.Z)(t),"flow",void 0),(0,s.Z)((0,i.Z)(t),"activationToken",void 0),(0,s.Z)((0,i.Z)(t),"recoveryToken",void 0),(0,s.Z)((0,i.Z)(t),"idx",void 0),t.flow=e.flow,t.activationToken=e.activationToken,t.recoveryToken=e.recoveryToken,t.idx=e.idx,t}return(0,r.Z)(l)}((0,f.n)())}},9310:function(e,t,n){"use strict";n.d(t,{$:function(){return s}});var r=n(5861),o=n(4687),i=n.n(o),a=n(2845),u=n(2620),c=n(146);function s(e){return f.apply(this,arguments)}function f(){return f=(0,r.Z)(i().mark((function e(t){var n,o,f,l,p,h=arguments;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=h.length>1&&void 0!==h[1]?h[1]:{},e.next=3,(0,a.x)(t,{startPolling:!0});case 3:if(f=e.sent,l=(0,u.uN)(t),null!=(p=null==l||null===(n=l.remediations)||void 0===n?void 0:n.find((function(e){return e.includes("poll")})))&&p.length||(0,c.ZK)("No polling remediations available at the current IDX flow stage"),!Number.isInteger(o.refresh)){e.next=9;break}return e.abrupt("return",new Promise((function(e,n){setTimeout((0,r.Z)(i().mark((function r(){var o,a,u;return i().wrap((function(r){for(;;)switch(r.prev=r.next){case 0:try{u=null===(o=f.nextStep)||void 0===o||null===(a=o.poll)||void 0===a?void 0:a.refresh,e(u?s(t,{refresh:u}):f)}catch(e){n(e)}case 1:case"end":return r.stop()}}),r)}))),o.refresh)})));case 9:return e.abrupt("return",f);case 10:case"end":return e.stop()}}),e)}))),f.apply(this,arguments)}},2845:function(e,t,n){"use strict";n.d(t,{C:function(){return p},x:function(){return h}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),u=n(3377),c=n(2620),s=n(9123);function f(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function l(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?f(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):f(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function p(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return!(!(0,c.uN)(e,t)&&!t.stateHandle)}function h(e){return d.apply(this,arguments)}function d(){return d=(0,o.Z)(a().mark((function e(t){var n,r,o,i,f=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(p(t,n=f.length>1&&void 0!==f[1]?f[1]:{})){e.next=3;break}throw new s.Z("Unable to proceed: saved transaction could not be loaded");case 3:return r=n.flow,o=n.state,r||(i=(0,c.uN)(t,{state:o}),r=null==i?void 0:i.flow),e.abrupt("return",(0,u.K)(t,l(l({},n),{},{flow:r})));case 6:case"end":return e.stop()}}),e)}))),d.apply(this,arguments)}},9214:function(e,t,n){"use strict";n.d(t,{M:function(){return l}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),u=n(3377),c=n(7738);function s(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function f(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?s(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function l(e){return p.apply(this,arguments)}function p(){return p=(0,o.Z)(a().mark((function e(t){var n,r,o=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=o.length>1&&void 0!==o[1]?o[1]:{},r=(0,c.s)(t,"recoverPassword"),e.abrupt("return",(0,u.K)(t,f(f({},n),r)));case 3:case"end":return e.stop()}}),e)}))),p.apply(this,arguments)}},8826:function(e,t,n){"use strict";n.d(t,{z:function(){return d}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),u=n(3377),c=n(2620),s=n(2473),f=n(9123),l=n(7595);function p(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function h(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?p(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):p(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function d(e){return v.apply(this,arguments)}function v(){return v=(0,o.Z)(a().mark((function e(t){var n,r,o,i=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=i.length>1&&void 0!==i[1]?i[1]:{},(0,c.$0)(t)){e.next=8;break}return e.next=4,(0,s.Y)(t,h(h({},n),{},{flow:"register",autoRemediate:!1}));case 4:if(r=e.sent,o=r.enabledFeatures,n.activationToken||!o||o.includes(l.Fw.REGISTRATION)){e.next=8;break}throw new f.Z("Registration is not supported based on your current org configuration.");case 8:return e.abrupt("return",(0,u.K)(t,h(h({},n),{},{flow:"register"})));case 9:case"end":return e.stop()}}),e)}))),v.apply(this,arguments)}},2541:function(e,t,n){"use strict";n.d(t,{q:function(){return d}});var r=n(5671),o=n(3144),i=n(1752),a=n(136),u=n(2963),c=n(1120),s=n(4942),f=n(4794),l=n(6064);function p(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function h(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?p(Object(n),!0).forEach((function(t){(0,s.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):p(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var d=function(e){(0,a.Z)(f,e);var t,n,s=(t=f,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function f(){return(0,r.Z)(this,f),s.apply(this,arguments)}return(0,o.Z)(f,[{key:"mapAuthenticator",value:function(){var e=this.getAuthenticatorData();return{id:(0,l.zg)(this.remediation).form.value.find((function(e){return"id"===e.name})).value,methodType:e.methodType,phoneNumber:e.phoneNumber}}},{key:"getInputAuthenticator",value:function(e){return[{name:"methodType",type:"string"},{name:"phoneNumber",label:"Phone Number",type:"string"}].map((function(t){return h(h({},e.form.value.find((function(e){return e.name===t.name}))),t)}))}},{key:"mapAuthenticatorDataFromValues",value:function(e){e=(0,i.Z)((0,c.Z)(f.prototype),"mapAuthenticatorDataFromValues",this).call(this,e);var t=this.values.phoneNumber;if(e||t)return h(h({},e&&e),t&&{phoneNumber:t})}}]),f}(f.a);(0,s.Z)(d,"remediationName","authenticator-enrollment-data")},5278:function(e,t,n){"use strict";n.d(t,{q:function(){return h}});var r=n(2982),o=n(5671),i=n(3144),a=n(1752),u=n(136),c=n(2963),s=n(1120),f=n(4942);function l(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function p(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?l(Object(n),!0).forEach((function(t){(0,f.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):l(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var h=function(e){(0,u.Z)(h,e);var t,n,l=(t=h,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function h(){return(0,o.Z)(this,h),l.apply(this,arguments)}return(0,i.Z)(h,[{key:"mapAuthenticator",value:function(){return this.getAuthenticatorData()}},{key:"getInputAuthenticator",value:function(){var e=this.getAuthenticatorFromRemediation(),t=e.form.value.find((function(e){return"methodType"===e.name}));return t&&t.options?{name:"methodType",type:"string",required:!0,options:t.options}:(0,r.Z)(e.form.value)}},{key:"getValuesAfterProceed",value:function(){var e=this;return this.values=(0,a.Z)((0,s.Z)(h.prototype),"getValuesAfterProceed",this).call(this),Object.keys(this.values).filter((function(e){return"authenticator"!==e})).reduce((function(t,n){return p(p({},t),{},(0,f.Z)({},n,e.values[n]))}),{})}}]),h}(n(4794).a);(0,f.Z)(h,"remediationName","authenticator-verification-data")},4794:function(e,t,n){"use strict";n.d(t,{a:function(){return y}});var r=n(5671),o=n(3144),i=n(7326),a=n(1752),u=n(136),c=n(2963),s=n(1120),f=n(4942),l=n(3118),p=n(7595),h=n(9344);function d(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function v(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?d(Object(n),!0).forEach((function(t){(0,f.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):d(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var y=function(e){(0,u.Z)(d,e);var t,n,l=(t=d,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function d(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return(0,r.Z)(this,d),t=l.call(this,e,n),(0,f.Z)((0,i.Z)(t),"authenticator",void 0),t.authenticator=t.getAuthenticator(),t.formatAuthenticatorData(),t}return(0,o.Z)(d,[{key:"formatAuthenticatorData",value:function(){var e=this;if(this.getAuthenticatorData())this.values.authenticatorsData=this.values.authenticatorsData.map((function(t){return(0,h.PN)(e.authenticator,t)?e.mapAuthenticatorDataFromValues(t):t}));else{var t=this.mapAuthenticatorDataFromValues();t&&this.values.authenticatorsData.push(t)}}},{key:"getAuthenticatorData",value:function(){var e=this;return this.values.authenticatorsData.find((function(t){return(0,h.PN)(e.authenticator,t)}))}},{key:"canRemediate",value:function(){var e=this;return this.values.authenticatorsData.some((function(t){return(0,h.PN)(e.authenticator,t)}))}},{key:"mapAuthenticatorDataFromValues",value:function(e){var t=this.values,n=t.methodType,r=t.authenticator;!n&&(0,p.H)(r)&&(n=null==r?void 0:r.methodType);var o=this.authenticator,i=v(v({id:o.id,enrollmentId:o.enrollmentId},e&&e),n&&{methodType:n});return i.methodType?i:null}},{key:"getAuthenticatorFromRemediation",value:function(){return this.remediation.value.find((function(e){return"authenticator"===e.name}))}},{key:"getValuesAfterProceed",value:function(){var e=this;this.values=(0,a.Z)((0,s.Z)(d.prototype),"getValuesAfterProceed",this).call(this);var t=this.values.authenticatorsData.filter((function(t){return!0!==(0,h.PN)(e.authenticator,t)}));return v(v({},this.values),{},{authenticatorsData:t})}}]),d}(l.n)},3118:function(e,t,n){"use strict";n.d(t,{n:function(){return h}});var r=n(2982),o=n(1002),i=n(5671),a=n(3144),u=n(4942),c=n(6064),s=n(9344);function f(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function l(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function p(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?l(Object(n),!0).forEach((function(t){(0,u.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):l(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var h=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};(0,i.Z)(this,e),(0,u.Z)(this,"remediation",void 0),(0,u.Z)(this,"values",void 0),(0,u.Z)(this,"options",void 0),(0,u.Z)(this,"map",void 0),this.values=p({},n),this.options=p({},r),this.formatAuthenticators(),this.remediation=t}return(0,a.Z)(e,[{key:"formatAuthenticators",value:function(){if(this.values.authenticators=this.values.authenticators||[],this.values.authenticators=this.values.authenticators.map((function(e){return(0,s.LL)(e)})),this.values.authenticator){var e=(0,s.LL)(this.values.authenticator);this.values.authenticators.some((function(t){return(0,s.PN)(e,t)}))||this.values.authenticators.push(e)}this.values.authenticatorsData=this.values.authenticators.reduce((function(e,t){return"object"===(0,o.Z)(t)&&Object.keys(t).length>1&&e.push(t),e}),this.values.authenticatorsData||[])}},{key:"getName",value:function(){return this.remediation.name}},{key:"canRemediate",value:function(e){var t=this;return!(0,c.QG)(this.remediation).find((function(e){return!t.hasData(e)}))}},{key:"getData",value:function(e){var t=this;if(!e){var n=(0,c.ix)(this.remediation).reduce((function(e,n){return e[n]=t.getData(n),e}),{});return n}if("function"==typeof this["map".concat((0,c.Qs)(e))]){var r=this["map".concat((0,c.Qs)(e))](this.remediation.value.find((function(t){return t.name===e})));if(r)return r}if(this.map&&this.map[e])for(var o=this.map[e],i=0;i<o.length;i++){var a=this.values[o[i]];if(a)return a}return this.values[e]}},{key:"hasData",value:function(e){return!!this.getData(e)}},{key:"getNextStep",value:function(e,t){var n=this.getName(),r=this.getInputs(),o=this.getAuthenticator(),i=null==o?void 0:o.type;return p(p({name:n,inputs:r},i&&{type:i}),o&&{authenticator:o})}},{key:"getInputs",value:function(){var e=this,t=[];return(this.remediation.value||[]).forEach((function(n){var r,o=n.name,i=n.type,a=n.visible,u=n.messages;if(!1!==a){if("function"==typeof e["getInput".concat((0,c.Qs)(o))])r=e["getInput".concat((0,c.Qs)(o))](n);else if("object"!==i){var s,f=(e.map?e.map[o]:null)||[];s=1===f.length?f[0]:f.find((function(t){return Object.keys(e.values).includes(t)})),s&&(r=p(p({},n),{},{name:s}))}r||(r=n),Array.isArray(r)?r.forEach((function(e){return t.push(e)})):(u&&(r.messages=u),t.push(r))}})),t}},{key:"getValuesAfterProceed",value:function(){var e,t=this.remediation.value||[],n=this.getInputs(),o=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return f(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?f(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}([].concat((0,r.Z)(t),(0,r.Z)(n)));try{for(o.s();!(e=o.n()).done;){var i=e.value;delete this.values[i.name]}}catch(e){o.e(e)}finally{o.f()}return this.values}},{key:"getAuthenticator",value:function(){var e,t,n=null===(e=this.remediation.relatesTo)||void 0===e?void 0:e.value;if(n){var r=(0,c.zg)(this.remediation);if(!r)return n;var o=r.form.value.find((function(e){return"id"===e.name})).value,i=null===(t=r.form.value.find((function(e){return"enrollmentId"===e.name})))||void 0===t?void 0:t.value;return p(p({},n),{},{id:o,enrollmentId:i})}}}],[{key:"getMessages",value:function(e){var t,n;if(e.value)return null===(t=e.value[0])||void 0===t||null===(n=t.form)||void 0===n?void 0:n.value.reduce((function(e,t){return t.messages&&(e=[].concat((0,r.Z)(e),(0,r.Z)(t.messages.value))),e}),[])}}]),e}();(0,u.Z)(h,"remediationName",void 0)},9164:function(e,t,n){"use strict";n.d(t,{n:function(){return m}});var r=n(5671),o=n(3144),i=n(7326),a=n(1752),u=n(136),c=n(2963),s=n(1120),f=n(4942),l=n(3118),p=n(6064),h=n(7595),d=n(9344);function v(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function y(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?v(Object(n),!0).forEach((function(t){(0,f.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):v(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function g(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var m=function(e){(0,u.Z)(v,e);var t,n,l=(t=v,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function v(){var e;(0,r.Z)(this,v);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return e=l.call.apply(l,[this].concat(n)),(0,f.Z)((0,i.Z)(e),"selectedAuthenticator",void 0),(0,f.Z)((0,i.Z)(e),"selectedOption",void 0),e}return(0,o.Z)(v,[{key:"findMatchedOption",value:function(e,t){var n,r,o=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return g(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?g(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}(e);try{var i=function(){var e=r.value;if(n=t.find((function(t){var n=t.relatesTo;return n.key&&n.key===e.key})))return"break"};for(o.s();!(r=o.n()).done&&"break"!==i(););}catch(e){o.e(e)}finally{o.f()}return n}},{key:"canRemediate",value:function(e){var t=this.values,n=t.authenticators,r=t.authenticator,o=(0,p.zg)(this.remediation).options;if(!n||!n.length)return!1;if((0,h.H)(r)&&r.id)return!0;var i=this.findMatchedOption(n,o);if(i){var a,u,c=(null==e?void 0:e.currentAuthenticator)&&(null==e?void 0:e.currentAuthenticator.value.id)===(null===(a=i.relatesTo)||void 0===a?void 0:a.id),s=(null==e?void 0:e.currentAuthenticatorEnrollment)&&(null==e?void 0:e.currentAuthenticatorEnrollment.value.id)===(null===(u=i.relatesTo)||void 0===u?void 0:u.id);return!c&&!s}return!1}},{key:"mapAuthenticator",value:function(e){var t=this.values,n=t.authenticators,r=t.authenticator;if((0,h.H)(r)&&r.id)return this.selectedAuthenticator=r,r;var o=e.options,i=(0,d.h_)(n,o);return this.selectedAuthenticator=i.relatesTo,this.selectedOption=i,{id:null==i?void 0:i.value.form.value.find((function(e){return"id"===e.name})).value}}},{key:"getInputAuthenticator",value:function(e){return{name:"authenticator",type:"string",options:e.options.map((function(e){return{label:e.label,value:e.relatesTo.key}}))}}},{key:"getValuesAfterProceed",value:function(){var e=this;this.values=(0,a.Z)((0,s.Z)(v.prototype),"getValuesAfterProceed",this).call(this);var t=this.values.authenticators.filter((function(t){return!0!==(0,d.PN)(t,e.selectedAuthenticator)}));return y(y({},this.values),{},{authenticators:t})}}]),v}(l.n)},9883:function(e,t,n){"use strict";n.d(t,{Q:function(){return E}});var r=n(5671),o=n(3144),i=n(7326),a=n(1752),u=n(136),c=n(2963),s=n(1120),f=n(4942),l=n(3118),p=n(7644);function h(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function d(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?h(Object(n),!0).forEach((function(t){(0,f.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):h(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var v=function(e){(0,u.Z)(a,e);var t,n,i=(t=a,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function a(){return(0,r.Z)(this,a),i.apply(this,arguments)}return(0,o.Z)(a,[{key:"canVerify",value:function(e){return!!(e.credentials||e.verificationCode||e.otp)}},{key:"mapCredentials",value:function(e){var t=e.credentials,n=e.verificationCode,r=e.otp;if(t||n||r)return t||{passcode:n||r}}},{key:"getInputs",value:function(e){var t;return d(d({},null===(t=e.form)||void 0===t?void 0:t.value[0]),{},{name:"verificationCode",type:"string",required:e.required})}}]),a}(p._);var y=function(e){(0,u.Z)(a,e);var t,n,i=(t=a,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function a(){return(0,r.Z)(this,a),i.apply(this,arguments)}return(0,o.Z)(a,[{key:"mapCredentials",value:function(e){var t=e.verificationCode;if(t)return{totp:t}}}]),a}(v),g=n(9582);var m=function(e){(0,u.Z)(a,e);var t,n,i=(t=a,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function a(){return(0,r.Z)(this,a),i.apply(this,arguments)}return(0,o.Z)(a,[{key:"canVerify",value:function(e){var t=e.credentials;if(t&&t.questionKey&&t.answer)return!0;var n=e.questionKey,r=e.question,o=e.answer;return!(!n||!o)||!(!r||!o)}},{key:"mapCredentials",value:function(e){var t=e.questionKey,n=e.question,r=e.answer;if(r&&(t||n))return{questionKey:n?"custom":t,question:n,answer:r}}},{key:"getInputs",value:function(){return[{name:"questionKey",type:"string",required:!0},{name:"question",type:"string",label:"Create a security question"},{name:"answer",type:"string",label:"Answer",required:!0}]}}]),a}(p._);var b=function(e){(0,u.Z)(a,e);var t,n,i=(t=a,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function a(){return(0,r.Z)(this,a),i.apply(this,arguments)}return(0,o.Z)(a,[{key:"canVerify",value:function(e){var t=e.credentials;return!(!t||!t.answer)||!!e.answer}},{key:"mapCredentials",value:function(e){var t=e.answer;if(t)return{questionKey:this.meta.contextualData.enrolledQuestion.questionKey,answer:t}}},{key:"getInputs",value:function(){return[{name:"answer",type:"string",label:"Answer",required:!0}]}}]),a}(p._);var k=function(e){(0,u.Z)(a,e);var t,n,i=(t=a,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function a(){return(0,r.Z)(this,a),i.apply(this,arguments)}return(0,o.Z)(a,[{key:"canVerify",value:function(e){var t=e.credentials||e,n=t.clientData,r=t.attestation;return!(!n||!r)}},{key:"mapCredentials",value:function(e){var t=e.credentials,n=e.clientData,r=e.attestation;if(t||n||r)return t||{clientData:n,attestation:r}}},{key:"getInputs",value:function(){return[{name:"clientData",type:"string",required:!0,visible:!1,label:"Client Data"},{name:"attestation",type:"string",required:!0,visible:!1,label:"Attestation"}]}}]),a}(p._);var w=function(e){(0,u.Z)(a,e);var t,n,i=(t=a,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function a(){return(0,r.Z)(this,a),i.apply(this,arguments)}return(0,o.Z)(a,[{key:"canVerify",value:function(e){var t=e.credentials||e,n=t.clientData,r=t.authenticatorData,o=t.signatureData;return!!(n&&r&&o)}},{key:"mapCredentials",value:function(e){var t=e.credentials,n=e.authenticatorData,r=e.clientData,o=e.signatureData;if(t||n||r||o)return t||{authenticatorData:n,clientData:r,signatureData:o}}},{key:"getInputs",value:function(){return[{name:"authenticatorData",type:"string",label:"Authenticator Data",required:!0,visible:!1},{name:"clientData",type:"string",label:"Client Data",required:!0,visible:!1},{name:"signatureData",type:"string",label:"Signature Data",required:!0,visible:!1}]}}]),a}(p._),O=n(7595);function Z(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function T(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Z(Object(n),!0).forEach((function(t){(0,f.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Z(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var E=function(e){(0,u.Z)(p,e);var t,n,l=(t=p,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function p(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return(0,r.Z)(this,p),t=l.call(this,e,n),(0,f.Z)((0,i.Z)(t),"authenticator",void 0),t.authenticator=function(e){var t,n,r=e.relatesTo,o=(null==r?void 0:r.value)||{};switch(o.key){case O.pc.OKTA_PASSWORD:return new g.a(o);case O.pc.SECURITY_QUESTION:return null!==(t=o.contextualData)&&void 0!==t&&t.enrolledQuestion?new b(o):new m(o);case O.pc.OKTA_VERIFY:return new y(o);case O.pc.WEBAUTHN:return null!==(n=o.contextualData)&&void 0!==n&&n.challengeData?new w(o):new k(o);default:return new v(o)}}(e),t}return(0,o.Z)(p,[{key:"getNextStep",value:function(e,t){var n,r=(0,a.Z)((0,s.Z)(p.prototype),"getNextStep",this).call(this,e,t),o=null==t||null===(n=t.authenticatorEnrollments)||void 0===n?void 0:n.value;return T(T({},r),{},{authenticatorEnrollments:o})}},{key:"canRemediate",value:function(){return this.authenticator.canVerify(this.values)}},{key:"mapCredentials",value:function(){return this.authenticator.mapCredentials(this.values)}},{key:"getInputCredentials",value:function(e){return this.authenticator.getInputs(e)}},{key:"getValuesAfterProceed",value:function(){var e=this;return this.values=(0,a.Z)((0,s.Z)(p.prototype),"getValuesAfterProceed",this).call(this),Object.keys(this.values).filter((function(e){return"credentials"!==e})).reduce((function(t,n){return T(T({},t),{},(0,f.Z)({},n,e.values[n]))}),{})}}]),p}(l.n)},4560:function(e,t,n){"use strict";n.d(t,{J:function(){return s}});var r=n(3144),o=n(5671),i=n(136),a=n(2963),u=n(1120),c=n(4942);var s=function(e){(0,i.Z)(s,e);var t,n,c=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function s(){return(0,o.Z)(this,s),c.apply(this,arguments)}return(0,r.Z)(s)}(n(9883).Q);(0,c.Z)(s,"remediationName","challenge-authenticator")},1104:function(e,t,n){"use strict";n.d(t,{U:function(){return s}});var r=n(5671),o=n(3144),i=n(136),a=n(2963),u=n(1120),c=n(4942);var s=function(e){(0,i.Z)(s,e);var t,n,c=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function s(){return(0,r.Z)(this,s),c.apply(this,arguments)}return(0,o.Z)(s,[{key:"canRemediate",value:function(){return!!this.values.startPolling||"challenge-poll"===this.options.step}}]),s}(n(2288).T);(0,c.Z)(s,"remediationName","challenge-poll")},3857:function(e,t,n){"use strict";n.d(t,{q:function(){return s}});var r=n(3144),o=n(5671),i=n(136),a=n(2963),u=n(1120),c=n(4942);var s=function(e){(0,i.Z)(s,e);var t,n,c=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function s(){return(0,o.Z)(this,s),c.apply(this,arguments)}return(0,r.Z)(s)}(n(9883).Q);(0,c.Z)(s,"remediationName","enroll-authenticator")},2288:function(e,t,n){"use strict";n.d(t,{T:function(){return p}});var r=n(5671),o=n(3144),i=n(1752),a=n(136),u=n(2963),c=n(1120),s=n(4942);function f(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function l(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?f(Object(n),!0).forEach((function(t){(0,s.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):f(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var p=function(e){(0,a.Z)(p,e);var t,n,f=(t=p,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function p(){return(0,r.Z)(this,p),f.apply(this,arguments)}return(0,o.Z)(p,[{key:"canRemediate",value:function(){return!!this.values.startPolling||"enroll-poll"===this.options.step}},{key:"getNextStep",value:function(e,t){var n=(0,i.Z)((0,c.Z)(p.prototype),"getNextStep",this).call(this,e,t),r=this.getAuthenticator();return!r&&null!=t&&t.currentAuthenticator&&(r=t.currentAuthenticator.value),l(l({},n),{},{authenticator:r,poll:{required:!0,refresh:this.remediation.refresh}})}},{key:"getValuesAfterProceed",value:function(){var e=this;return Object.keys(this.values).filter((function(e){return"startPolling"!==e})).reduce((function(t,n){return l(l({},t),{},(0,s.Z)({},n,e.values[n]))}),{})}}]),p}(n(3118).n);(0,s.Z)(p,"remediationName","enroll-poll")},7522:function(e,t,n){"use strict";n.d(t,{w:function(){return v}});var r=n(2982),o=n(5671),i=n(3144),a=n(7326),u=n(136),c=n(2963),s=n(1120),f=n(4942),l=n(3118),p=n(9582);function h(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function d(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?h(Object(n),!0).forEach((function(t){(0,f.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):h(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var v=function(e){(0,u.Z)(h,e);var t,n,l=(t=h,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function h(e){var t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return(0,o.Z)(this,h),t=l.call(this,e,n,r),(0,f.Z)((0,a.Z)(t),"authenticator",null),t.getCredentialsFromRemediation()&&(t.authenticator=t.authenticator=new p.a({})),t}return(0,i.Z)(h,[{key:"canRemediate",value:function(){if(this.authenticator&&!this.authenticator.canVerify(this.values))return!1;var e=this.getData().userProfile;return!!e&&this.remediation.value.find((function(e){return"userProfile"===e.name})).form.value.reduce((function(t,n){return n.required&&(t=t&&!!e[n.name]),t}),!0)}},{key:"getCredentialsFromRemediation",value:function(){return this.remediation.value.find((function(e){return"credentials"===e.name}))}},{key:"mapUserProfile",value:function(e){var t=this,n=e.form.value.map((function(e){return e.name})).reduce((function(e,n){return t.values[n]?d(d({},e),{},(0,f.Z)({},n,t.values[n])):e}),{});if(0!==Object.keys(n).length)return n}},{key:"mapCredentials",value:function(){var e=this.authenticator&&this.authenticator.mapCredentials(this.values);if(e)return e}},{key:"getInputUserProfile",value:function(e){return(0,r.Z)(e.form.value)}},{key:"getInputCredentials",value:function(e){return(0,r.Z)(e.form.value)}},{key:"getErrorMessages",value:function(e){return e.value[0].form.value.reduce((function(e,t){return t.messages&&e.push(t.messages.value[0].message),e}),[])}}]),h}(l.n);(0,f.Z)(v,"remediationName","enroll-profile")},3679:function(e,t,n){"use strict";n.d(t,{t:function(){return p}});var r=n(5671),o=n(3144),i=n(1752),a=n(136),u=n(2963),c=n(1120),s=n(4942);function f(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function l(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?f(Object(n),!0).forEach((function(t){(0,s.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):f(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var p=function(e){(0,a.Z)(p,e);var t,n,f=(t=p,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function p(){return(0,r.Z)(this,p),f.apply(this,arguments)}return(0,o.Z)(p,[{key:"getInputEmail",value:function(){return[{name:"email",type:"string",required:!0,label:"Email"}]}},{key:"getInputPhoneNumber",value:function(){return[{name:"phoneNumber",type:"string",required:!0,label:"Phone Number"}]}},{key:"canRemediate",value:function(){return Boolean(this.values.email||this.values.phoneNumber)}},{key:"getNextStep",value:function(e,t){var n=(0,i.Z)((0,c.Z)(p.prototype),"getNextStep",this).call(this,e,t),r=t.currentAuthenticator.value;return l(l({},n),{},{authenticator:r})}},{key:"getData",value:function(){return{stateHandle:this.values.stateHandle,email:this.values.email,phoneNumber:this.values.phoneNumber}}},{key:"getValuesAfterProceed",value:function(){var e=this;return Object.keys(this.values).filter((function(e){return!["email","phoneNumber"].includes(e)})).reduce((function(t,n){return l(l({},t),{},(0,s.Z)({},n,e.values[n]))}),{})}}]),p}(n(3118).n);(0,s.Z)(p,"remediationName","enrollment-channel-data")},9732:function(e,t,n){"use strict";n.d(t,{P:function(){return k}});var r=n(5861),o=n(4942),i=n(4925),a=n(5671),u=n(3144),c=n(136),s=n(2963),f=n(1120),l=n(4687),p=n.n(l),h=n(3118),d=n(1002),v=n(885);function y(e){if(Array.isArray(e))return e.map((function(e){return"string"==typeof e||"number"==typeof e||"boolean"==typeof e?e:y(e)}));for(var t={},n=0,r=Object.entries(e);n<r.length;n++){var o=(0,v.Z)(r[n],2),i=o[0],a=o[1];if(null!=a)if("object"===(0,d.Z)(a)){var u=Object.keys(a);if(["value","form"].includes(i)&&1===u.length&&["value","form"].includes(u[0])){var c=y(a);Object.entries(c).forEach((function(e){var n=(0,v.Z)(e,2),r=n[0],o=n[1];t[r]=o}))}else t[i]=y(a)}else t[i]=a}return t}var g=["href","method","rel","accepts","produces","value","action"];function m(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function b(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?m(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):m(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var k=function(e){(0,c.Z)(l,e);var t,n,o=(t=l,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,f.Z)(t);if(n){var o=(0,f.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,s.Z)(this,e)});function l(){return(0,a.Z)(this,l),o.apply(this,arguments)}return(0,u.Z)(l,[{key:"canRemediate",value:function(){return!("function"!=typeof this.remediation.action||"poll"!==this.remediation.name&&!this.remediation.name.endsWith("-poll")&&!this.options.step)}},{key:"getData",value:function(){var e=this;return this.getInputs().reduce((function(t,n){var r=n.name;return t[r]=e.values[r],t}),{})}},{key:"getNextStep",value:function(e,t){var n,o=this.getName(),a=this.getInputs(),u=this.remediation,c=(u.href,u.method,u.rel,u.accepts,u.produces,u.value,u.action),s=(0,i.Z)(u,g);return c?b(b(b({},s),!!a.length&&{inputs:a}),{},{action:(n=(0,r.Z)(p().mark((function t(n){return p().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",e.idx.proceed(b({step:o},n)));case 1:case"end":return t.stop()}}),t)}))),function(e){return n.apply(this,arguments)})}):b({},this.remediation)}},{key:"getInputs",value:function(){return(this.remediation.value||[]).filter((function(e){return"stateHandle"!==e.name})).map(y).map((function(e){return e.type=e.type||"string",e}))}}]),l}(h.n)},8628:function(e,t,n){"use strict";n.d(t,{h:function(){return p}});var r=n(5671),o=n(3144),i=n(7326),a=n(136),u=n(2963),c=n(1120),s=n(4942);function f(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function l(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?f(Object(n),!0).forEach((function(t){(0,s.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):f(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var p=function(e){(0,a.Z)(p,e);var t,n,f=(t=p,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function p(){var e;(0,r.Z)(this,p);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return e=f.call.apply(f,[this].concat(n)),(0,s.Z)((0,i.Z)(e),"map",{identifier:["username"]}),e}return(0,o.Z)(p,[{key:"canRemediate",value:function(){return!!this.getData().identifier}},{key:"mapCredentials",value:function(){var e=this.values,t=e.credentials,n=e.password;if(t||n)return t||{passcode:n}}},{key:"getInputCredentials",value:function(e){return l(l({},e.form.value[0]),{},{name:"password",required:e.required})}}]),p}(n(3118).n);(0,s.Z)(p,"remediationName","identify")},9024:function(e,t,n){"use strict";n.d(t,{j:function(){return l}});var r=n(5671),o=n(3144),i=n(136),a=n(2963),u=n(1120),c=n(4942);function s(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function f(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?s(Object(n),!0).forEach((function(t){(0,c.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var l=function(e){(0,i.Z)(s,e);var t,n,c=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function s(){return(0,r.Z)(this,s),c.apply(this,arguments)}return(0,o.Z)(s,[{key:"mapCredentials",value:function(){var e=this.values.newPassword;if(e)return{passcode:e}}},{key:"getInputCredentials",value:function(e){var t="password"===this.getAuthenticator().type?"newPassword":"verificationCode";return f(f({},e.form.value[0]),{},{name:t})}}]),s}(n(3118).n);(0,c.Z)(l,"remediationName","reenroll-authenticator")},8107:function(e,t,n){"use strict";n.d(t,{i:function(){return s}});var r=n(3144),o=n(5671),i=n(136),a=n(2963),u=n(1120),c=n(4942);var s=function(e){(0,i.Z)(s,e);var t,n,c=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function s(){return(0,o.Z)(this,s),c.apply(this,arguments)}return(0,r.Z)(s)}(n(9024).j);(0,c.Z)(s,"remediationName","reenroll-authenticator-warning")},8490:function(e,t,n){"use strict";n.d(t,{O:function(){return s}});var r=n(5671),o=n(3144),i=n(136),a=n(2963),u=n(1120),c=n(4942);var s=function(e){(0,i.Z)(s,e);var t,n,c=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function s(){return(0,r.Z)(this,s),c.apply(this,arguments)}return(0,o.Z)(s,[{key:"canRemediate",value:function(){return!1}},{key:"getNextStep",value:function(){var e=this.remediation;return{name:e.name,type:e.type,idp:e.idp,href:e.href}}}]),s}(n(3118).n);(0,c.Z)(s,"remediationName","redirect-idp")},1019:function(e,t,n){"use strict";n.d(t,{G:function(){return s}});var r=n(3144),o=n(5671),i=n(136),a=n(2963),u=n(1120),c=n(4942);var s=function(e){(0,i.Z)(s,e);var t,n,c=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function s(){return(0,o.Z)(this,s),c.apply(this,arguments)}return(0,r.Z)(s)}(n(9883).Q);(0,c.Z)(s,"remediationName","reset-authenticator")},7311:function(e,t,n){"use strict";n.d(t,{X:function(){return h}});var r=n(2982),o=n(3144),i=n(5671),a=n(136),u=n(2963),c=n(1120),s=n(4942),f=n(9164),l=n(6064),p=n(7595);var h=function(e){(0,a.Z)(f,e);var t,n,s=(t=f,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function f(e){var t,n,o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};(0,i.Z)(this,f);var u="recoverPassword"===(n=s.call(this,e,o,a)).options.flow;return(null===(t=(0,l.zg)(e).options)||void 0===t?void 0:t.some((function(e){var t=e.relatesTo;return(null==t?void 0:t.key)===p.pc.OKTA_PASSWORD})))&&(u||n.values.password)&&(n.values.authenticators=[].concat((0,r.Z)(n.values.authenticators||[]),[{key:p.pc.OKTA_PASSWORD}])),n}return(0,o.Z)(f)}(f.n);(0,s.Z)(h,"remediationName","select-authenticator-authenticate")},9865:function(e,t,n){"use strict";n.d(t,{j:function(){return s}});var r=n(3144),o=n(5671),i=n(136),a=n(2963),u=n(1120),c=n(4942);var s=function(e){(0,i.Z)(s,e);var t,n,c=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function s(){return(0,o.Z)(this,s),c.apply(this,arguments)}return(0,r.Z)(s)}(n(9164).n);(0,c.Z)(s,"remediationName","select-authenticator-enroll")},5272:function(e,t,n){"use strict";n.d(t,{G:function(){return h}});var r=n(5671),o=n(3144),i=n(7326),a=n(1752),u=n(136),c=n(2963),s=n(1120),f=n(4942);function l(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function p(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?l(Object(n),!0).forEach((function(t){(0,f.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):l(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var h=function(e){(0,u.Z)(h,e);var t,n,l=(t=h,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function h(){var e;(0,r.Z)(this,h);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return e=l.call.apply(l,[this].concat(n)),(0,f.Z)((0,i.Z)(e),"authenticator",void 0),(0,f.Z)((0,i.Z)(e),"map",{identifier:["username"]}),e}return(0,o.Z)(h,[{key:"canRemediate",value:function(){return!!this.getData("identifier")&&(0,a.Z)((0,s.Z)(h.prototype),"canRemediate",this).call(this)}},{key:"mapAuthenticator",value:function(e){var t,n,r,o=(0,a.Z)((0,s.Z)(h.prototype),"mapAuthenticator",this).call(this,e),i=null===(t=this.selectedOption)||void 0===t?void 0:t.value.form.value.find((function(e){return"methodType"===e.name})),u=this.values.methodType||(null==i?void 0:i.value)||(null==i||null===(n=i.options)||void 0===n||null===(r=n[0])||void 0===r?void 0:r.value);return u?p(p({},o),{},{methodType:u}):o}},{key:"getInputUsername",value:function(){return{name:"username",type:"string"}}}]),h}(n(9164).n);(0,f.Z)(h,"remediationName","select-authenticator-unlock-account")},4713:function(e,t,n){"use strict";n.d(t,{j:function(){return s}});var r=n(5671),o=n(3144),i=n(136),a=n(2963),u=n(1120),c=n(4942);var s=function(e){(0,i.Z)(s,e);var t,n,c=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function s(){return(0,r.Z)(this,s),c.apply(this,arguments)}return(0,o.Z)(s,[{key:"canRemediate",value:function(){return!0}}]),s}(n(3118).n);(0,c.Z)(s,"remediationName","select-enroll-profile")},3403:function(e,t,n){"use strict";n.d(t,{V:function(){return p}});var r=n(5671),o=n(3144),i=n(1752),a=n(136),u=n(2963),c=n(1120),s=n(4942);function f(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function l(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?f(Object(n),!0).forEach((function(t){(0,s.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):f(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var p=function(e){(0,a.Z)(p,e);var t,n,f=(t=p,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function p(){return(0,r.Z)(this,p),f.apply(this,arguments)}return(0,o.Z)(p,[{key:"canRemediate",value:function(){if(this.values.channel)return!0;if(this.values.authenticator){var e=this.values.authenticator,t=e.id,n=e.channel;if(t&&n)return!0}return!1}},{key:"getNextStep",value:function(e,t){var n=(0,i.Z)((0,c.Z)(p.prototype),"getNextStep",this).call(this,e,t),r=t.currentAuthenticator.value;return l(l({},n),{},{authenticator:r})}},{key:"getData",value:function(){var e;return{authenticator:{id:this.remediation.value[0].value.form.value[0].value,channel:(null===(e=this.values.authenticator)||void 0===e?void 0:e.channel)||this.values.channel},stateHandle:this.values.stateHandle}}},{key:"getValuesAfterProceed",value:function(){var e=this;this.values=(0,i.Z)((0,c.Z)(p.prototype),"getValuesAfterProceed",this).call(this),delete this.values.authenticators;var t=this.values.channel?"channel":"authenticator";return Object.keys(this.values).filter((function(e){return e!==t})).reduce((function(t,n){return l(l({},t),{},(0,s.Z)({},n,e.values[n]))}),{})}}]),p}(n(3118).n);(0,s.Z)(p,"remediationName","select-enrollment-channel")},8443:function(e,t,n){"use strict";n.d(t,{h:function(){return s}});var r=n(5671),o=n(3144),i=n(136),a=n(2963),u=n(1120),c=n(4942);var s=function(e){(0,i.Z)(s,e);var t,n,c=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function s(){return(0,r.Z)(this,s),c.apply(this,arguments)}return(0,o.Z)(s,[{key:"canRemediate",value:function(){return!!this.values.skip||"skip"===this.options.step}}]),s}(n(3118).n);(0,c.Z)(s,"remediationName","skip")},6064:function(e,t,n){"use strict";function r(e){var t;return null===(t=e.value)||void 0===t?void 0:t.map((function(e){return e.name}))}function o(e){var t;return null===(t=e.value)||void 0===t?void 0:t.reduce((function(e,t){return t.required&&e.push(t.name),e}),[])}function i(e){return e.charAt(0).toUpperCase()+e.substring(1)}function a(e){return e.value.find((function(e){return"authenticator"===e.name}))}n.d(t,{QG:function(){return o},Qs:function(){return i},ix:function(){return r},zg:function(){return a}})},3377:function(e,t,n){"use strict";n.d(t,{K:function(){return M}});var r=n(5861),o=n(4942),i=n(4687),a=n.n(i),u=n(6131),c=n(2660),s=n(1002),f=n(2982),l=n(9123),p=n(5031);function h(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return d(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?d(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}function d(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}function v(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function y(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?v(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):v(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function g(e,t){return Object.keys(t.actions).find((function(t){return!!e.resend&&t.includes("-resend")}))}function m(e){return y(y({},e),{},{resend:void 0})}function b(e,t){var n=e.actions||[];return n=n.filter((function(e){return"string"==typeof e?e!==t:e.name!==t})),y(y({},e),{},{actions:n})}function k(e,t,n,r){return w.apply(this,arguments)}function w(){return(w=(0,r.Z)(a().mark((function e(t,n,r,o){var i,u,c,d,v,w,O,Z,T,E,S,P,x,A,_,R,j,C;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(u=(i=n).neededToProceed,c=i.interactionCode,d=o.flow,!c){e.next=4;break}return e.abrupt("return",{idxResponse:n});case 4:if(v=(0,p.l6)(n,r,o),w=g(r,n),O=o.actions||[],!(Z=[].concat((0,f.Z)(O),(0,f.Z)(w&&[w]||[])))){e.next=28;break}T=h(Z),e.prev=10,S=a().mark((function e(){var i,c,s,f;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(i=E.value,c={},"string"!=typeof i&&(c=i.params||{},i=i.name),s=m(r),f=b(o,i),"function"!=typeof n.actions[i]){e.next=14;break}return e.next=8,n.actions[i](c);case 8:if(!1!==(n=e.sent).requestDidSucceed){e.next=11;break}return e.abrupt("return",{v:(0,p.Tc)(t,n,o)});case 11:if("cancel"!==i){e.next=13;break}return e.abrupt("return",{v:{idxResponse:n,canceled:!0}});case 13:return e.abrupt("return",{v:k(t,n,s,f)});case 14:if(!u.find((function(e){return e.name===i}))){e.next=22;break}return e.next=18,n.proceed(i,c);case 18:if(!1!==(n=e.sent).requestDidSucceed){e.next=21;break}return e.abrupt("return",{v:(0,p.Tc)(t,n,o)});case 21:return e.abrupt("return",{v:k(t,n,r,f)});case 22:case"end":return e.stop()}}),e)})),T.s();case 13:if((E=T.n()).done){e.next=20;break}return e.delegateYield(S(),"t0",15);case 15:if(P=e.t0,"object"!==(0,s.Z)(P)){e.next=18;break}return e.abrupt("return",P.v);case 18:e.next=13;break;case 20:e.next=25;break;case 22:e.prev=22,e.t1=e.catch(10),T.e(e.t1);case 25:return e.prev=25,T.f(),e.finish(25);case 28:if(!(x=(0,p.xn)(n))){e.next=31;break}return e.abrupt("return",{idxResponse:n,terminal:x});case 31:if(v){e.next=43;break}if(!o.step){e.next=40;break}return r=(0,p.Ax)(n,o.step,r),e.next=36,n.proceed(o.step,r);case 36:if(!1!==(n=e.sent).requestDidSucceed){e.next=39;break}return e.abrupt("return",(0,p.Tc)(t,n,o));case 39:return e.abrupt("return",{idxResponse:n});case 40:if("default"!==d){e.next=42;break}return e.abrupt("return",{idxResponse:n});case 42:throw new l.Z("\n      No remediation can match current flow, check policy settings in your org.\n      Remediations: [".concat(u.reduce((function(e,t){return e?e+" ,"+t.name:t.name}),""),"]\n    "));case 43:if(v.canRemediate()){e.next=46;break}return A=(0,p.TR)(t,v,n),e.abrupt("return",{idxResponse:n,nextStep:A});case 46:return _=v.getName(),R=v.getData(),e.next=50,n.proceed(_,R);case 50:if(!1!==(n=e.sent).requestDidSucceed){e.next=53;break}return e.abrupt("return",(0,p.Tc)(t,n,o));case 53:if(r=v.getValuesAfterProceed(),!(o=y(y({},o),{},{step:void 0})).useGenericRemediator||n.interactionCode||(0,p.xn)(n)){e.next=59;break}return j=(0,p.l6)(n,r,o),C=(0,p.TR)(t,j,n),e.abrupt("return",{idxResponse:n,nextStep:C});case 59:return e.abrupt("return",k(t,n,r,o));case 60:case"end":return e.stop()}}),e,null,[[10,22,25,28]])})))).apply(this,arguments)}var O=n(7595),Z=n(2620);function T(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function E(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?T(Object(n),!0).forEach((function(t){(0,o.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):T(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function S(e){var t=E({},e);return["flow","remediators","actions","withCredentials","step","useGenericRemediator","exchangeCodeForTokens"].forEach((function(e){delete t[e]})),t}function P(e,t){var n,r,o=t.options,i=o=E(E({},e.options.idx),o),a=i.flow,u=i.withCredentials,c=i.remediators,s=i.actions,f=O.Qd.PENDING;if(a=a||(null===(n=(r=e.idx).getFlow)||void 0===n?void 0:n.call(r))||"default"){var l,h;null===(l=(h=e.idx).setFlow)||void 0===l||l.call(h,a);var d=(0,p.sH)(e,a);u=void 0!==u?u:d.withCredentials,c=c||d.remediators,s=s||d.actions}return E(E({},t),{},{options:E(E({},o),{},{flow:a,withCredentials:u,remediators:c,actions:s}),status:f})}function x(e,t){return A.apply(this,arguments)}function A(){return(A=(0,r.Z)(a().mark((function e(t,n){var r,o,i,s,f,l,p,h,d,v,y,g,m,b,k,w,O;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=n.options,o=r.stateHandle,i=r.withCredentials,s=r.version,f=r.state,l=r.scopes,p=r.recoveryToken,h=r.activationToken,d=r.maxAge,v=r.acrValues,y=r.nonce,g=r.useGenericRemediator,b=(0,Z.uN)(t,{state:f,recoveryToken:p,activationToken:h}),!o){e.next=9;break}return e.next=6,(0,c.L)(t,{withCredentials:i,version:s,stateHandle:o,useGenericRemediator:g});case 6:m=e.sent,e.next=20;break;case 9:if(w=null===(k=b)||void 0===k?void 0:k.interactionHandle){e.next=17;break}return t.transactionManager.clear(),e.next=14,(0,u.E)(t,{withCredentials:i,state:f,scopes:l,activationToken:h,recoveryToken:p,maxAge:d,acrValues:v,nonce:y});case 14:O=e.sent,w=O.interactionHandle,b=O.meta;case 17:return e.next=19,(0,c.L)(t,{withCredentials:i,version:s,interactionHandle:w,useGenericRemediator:g});case 19:m=e.sent;case 20:return e.abrupt("return",E(E({},n),{},{idxResponse:m,meta:b}));case 21:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function _(e,t){return R.apply(this,arguments)}function R(){return(R=(0,r.Z)(a().mark((function e(t,n){var r,o,i,u,c,s,f,l,p,h,d,v,y;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=n.idxResponse,o=n.options,i=n.values,u=o.autoRemediate,c=o.remediators,s=o.actions,f=o.flow,l=o.step,p=o.useGenericRemediator,!1!==u&&(c||s||l)){e.next=5;break}return e.abrupt("return",n);case 5:return i=E(E({},i),{},{stateHandle:r.rawIdxState.stateHandle}),e.next=8,k(t,r,i,{remediators:c,actions:s,flow:f,step:l,useGenericRemediator:p});case 8:return h=e.sent,d=h.idxResponse,v=h.nextStep,y=h.canceled,r=d,e.abrupt("return",E(E({},n),{},{idxResponse:r,nextStep:v,canceled:y}));case 14:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function j(e,t){return C.apply(this,arguments)}function C(){return(C=(0,r.Z)(a().mark((function e(t,n){var r,o,i,u,c,s,f,l,p,h,d;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=n.meta,o=n.idxResponse,i=o.interactionCode,c=(u=r).clientId,s=u.codeVerifier,f=u.ignoreSignature,l=u.redirectUri,p=u.urls,h=u.scopes,e.next=5,t.token.exchangeCodeForTokens({interactionCode:i,clientId:c,codeVerifier:s,ignoreSignature:f,redirectUri:l,scopes:h},p);case 5:return d=e.sent,e.abrupt("return",d.tokens);case 7:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function D(e,t){return I.apply(this,arguments)}function I(){return(I=(0,r.Z)(a().mark((function e(t,n){var r,o,i,u,c,s,f,l,h,d,v,y,g,m,b,k;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=n.options,o=n.idxResponse,i=n.canceled,u=n.status,c=r.exchangeCodeForTokens,s=!1,f=!1,l=!0,o&&(s=!(!o.requestDidSucceed&&!o.stepUp),v=(0,p.KM)(o),y=(0,p.kw)(t,o,r.useGenericRemediator),g=(0,p.lx)(o,r),m=(0,p.xn)(o)),!m){e.next=15;break}u=O.Qd.TERMINAL,b=Object.keys(o.actions).length>0,k=!!g.find((function(e){return"ERROR"===e.class})),b||k||!0!==o.requestDidSucceed?s=!!b:f=!0,l=!1,e.next=32;break;case 15:if(!i){e.next=20;break}u=O.Qd.CANCELED,f=!0,e.next=32;break;case 20:if(null==o||!o.interactionCode){e.next=32;break}if(h=o.interactionCode,!1!==c){e.next=27;break}u=O.Qd.SUCCESS,f=!1,e.next=32;break;case 27:return e.next=29,j(t,n);case 29:d=e.sent,u=O.Qd.SUCCESS,f=!0;case 32:return e.abrupt("return",E(E({},n),{},{status:u,interactionCode:h,tokens:d,shouldSaveResponse:s,shouldClearTransaction:f,clearSharedStorage:l,enabledFeatures:v,availableSteps:y,messages:g,terminal:m}));case 33:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function M(e){return N.apply(this,arguments)}function N(){return N=(0,r.Z)(a().mark((function e(t){var n,r,o,i,u,c,s,f,l,p,h,d,v,y,g,m,b,k,w,O,T,A,R,j,C,I,M,N,U=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r={options:n=U.length>1&&void 0!==U[1]?U[1]:{},values:S(n)},r=P(t,r),e.next=5,x(t,r);case 5:return r=e.sent,e.next=8,_(t,r);case 8:return r=e.sent,e.next=11,D(t,r);case 11:return r=e.sent,i=(o=r).idxResponse,u=o.meta,c=o.shouldSaveResponse,s=o.shouldClearTransaction,f=o.clearSharedStorage,l=o.status,p=o.enabledFeatures,h=o.availableSteps,d=o.tokens,v=o.nextStep,y=o.messages,g=o.error,m=o.interactionCode,s?t.transactionManager.clear({clearSharedStorage:f}):((0,Z.r0)(t,E({},u)),c&&(w=(k=i).rawIdxState,O=k.requestDidSucceed,t.transactionManager.saveIdxResponse({rawIdxResponse:w,requestDidSucceed:O,stateHandle:null===(b=i.context)||void 0===b?void 0:b.stateHandle,interactionHandle:null==u?void 0:u.interactionHandle}))),A=(T=i||{}).actions,R=T.context,j=T.neededToProceed,C=T.proceed,I=T.rawIdxState,M=T.requestDidSucceed,N=T.stepUp,e.abrupt("return",E(E(E(E(E(E(E(E(E({status:l},u&&{meta:u}),p&&{enabledFeatures:p}),h&&{availableSteps:h}),d&&{tokens:d}),v&&{nextStep:v}),y&&y.length&&{messages:y}),g&&{error:g}),N&&{stepUp:N}),{},{interactionCode:m,actions:A,context:R,neededToProceed:j,proceed:C,rawIdxState:I,requestDidSucceed:M}));case 16:case"end":return e.stop()}}),e)}))),N.apply(this,arguments)}},2473:function(e,t,n){"use strict";n.d(t,{Y:function(){return f}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),u=n(3377);function c(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function s(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?c(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):c(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function f(e){return l.apply(this,arguments)}function l(){return l=(0,o.Z)(a().mark((function e(t){var n,r=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=r.length>1&&void 0!==r[1]?r[1]:{},t.transactionManager.clear(),e.abrupt("return",(0,u.K)(t,s({exchangeCodeForTokens:!1},n)));case 3:case"end":return e.stop()}}),e)}))),l.apply(this,arguments)}},4143:function(e,t,n){"use strict";n.d(t,{a:function(){return d}});var r=n(5671),o=n(3144),i=n(136),a=n(2963),u=n(1120),c=n(5763),s=n(1971),f=n(2647),l=n(415),p=n(146),h=n(9123);function d(){return function(e){(0,i.Z)(d,e);var t,n,f=(t=d,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function d(e,t,n){return(0,r.Z)(this,d),f.call(this,e,t,n)}return(0,o.Z)(d,[{key:"getIdxResponseStorage",value:function(e){var t;if((0,l.isBrowser)())try{t=this.storageUtil.getStorageByType("memory",e)}catch(e){(0,p.ZK)("No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic")}else{var n=this.getTransactionStorage(e);n&&(t={getItem:function(e){var t=n.getStorage();return t&&t[e]?t[e]:null},setItem:function(e,t){var r=n.getStorage();if(!r)throw new h.Z("Transaction has been cleared, failed to save idxState");r[e]=t,n.setStorage(r)},removeItem:function(e){var t=n.getStorage();t&&(delete t[e],n.setStorage(t))}})}return t?new c._(t,s.IDX_RESPONSE_STORAGE_NAME):null}}]),d}((0,f.a)())}},2620:function(e,t,n){"use strict";n.d(t,{$0:function(){return d},Co:function(){return y},Jm:function(){return b},UC:function(){return O},Wf:function(){return k},Xc:function(){return p},bl:function(){return w},r0:function(){return m},uN:function(){return v}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),u=n(3193),c=n(146),s=n(2865);function f(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function l(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?f(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):f(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function p(e){return h.apply(this,arguments)}function h(){return h=(0,o.Z)(a().mark((function e(t){var n,r,o,i,u,c,f,p,h,d,v,y,g,m,b,k,w,O=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=O.length>1&&void 0!==O[1]?O[1]:{},e.next=3,t.token.prepareTokenParams(n);case 3:return r=e.sent,o=(0,s.H)(t,r),i=l(l({},t.options),n),u=i.flow,c=void 0===u?"default":u,f=i.withCredentials,p=void 0===f||f,h=i.activationToken,d=void 0===h?void 0:h,v=i.recoveryToken,y=void 0===v?void 0:v,g=i.maxAge,m=void 0===g?void 0:g,b=i.acrValues,k=void 0===b?void 0:b,w=l(l({},o),{},{flow:c,withCredentials:p,activationToken:d,recoveryToken:y,maxAge:m,acrValues:k}),e.abrupt("return",w);case 8:case"end":return e.stop()}}),e)}))),h.apply(this,arguments)}function d(e,t){var n=v(e,t);return!(null==n||!n.interactionHandle)}function v(e,t){var n;t=(0,u.YY)(t),t=l(l({},e.options),t);try{n=e.transactionManager.load(t)}catch(e){}if(n)return k(n,t)?n:void(0,c.ZK)("Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.")}function y(e,t){return g.apply(this,arguments)}function g(){return(g=(0,o.Z)(a().mark((function e(t,n){var r;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=(0,u.YY)(n),n=l(l({},t.options),n),!(r=v(t,n))){e.next=5;break}return e.abrupt("return",r);case 5:return e.abrupt("return",p(t,n));case 6:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function m(e,t){e.transactionManager.save(t,{muteWarning:!0})}function b(e){e.transactionManager.clear()}function k(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return!1!==O(e,t,["issuer","clientId","redirectUri","state","codeChallenge","codeChallengeMethod","activationToken","recoveryToken"])&&!1!==w(e,t.flow)}function w(e,t){return!(t&&"default"!==t&&"proceed"!==t)||t===e.flow}function O(e,t,n){return!n.some((function(n){var r=t[n];if(r&&r!==e[n])return!0}))}},7595:function(e,t,n){"use strict";var r,o,i;function a(e){return e&&(e.key||e.id)}n.d(t,{Fw:function(){return i},H:function(){return a},Qd:function(){return r},pc:function(){return o}}),function(e){e.SUCCESS="SUCCESS",e.PENDING="PENDING",e.FAILURE="FAILURE",e.TERMINAL="TERMINAL",e.CANCELED="CANCELED"}(r||(r={})),function(e){e.OKTA_PASSWORD="okta_password",e.OKTA_EMAIL="okta_email",e.PHONE_NUMBER="phone_number",e.GOOGLE_AUTHENTICATOR="google_otp",e.SECURITY_QUESTION="security_question",e.OKTA_VERIFY="okta_verify",e.WEBAUTHN="webauthn"}(o||(o={})),function(e){e.PASSWORD_RECOVERY="recover-password",e.REGISTRATION="enroll-profile",e.SOCIAL_IDP="redirect-idp",e.ACCOUNT_UNLOCK="unlock-account"}(i||(i={}))},480:function(e,t,n){"use strict";function r(e){return e&&e.version}n.d(t,{P:function(){return r}})},8277:function(e,t,n){"use strict";n.d(t,{l:function(){return d}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),u=n(3377),c=n(2620),s=n(2473),f=n(9123),l=n(7595);function p(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function h(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?p(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):p(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function d(e){return v.apply(this,arguments)}function v(){return v=(0,o.Z)(a().mark((function e(t){var n,r,o,i=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if((n=i.length>1&&void 0!==i[1]?i[1]:{}).flow="unlockAccount",(0,c.$0)(t)){e.next=9;break}return e.next=5,(0,s.Y)(t,h(h({},n),{},{autoRemediate:!1}));case 5:if(r=e.sent,!(o=r.enabledFeatures)||o.includes(l.Fw.ACCOUNT_UNLOCK)){e.next=9;break}throw new f.Z("Self Service Account Unlock is not supported based on your current org configuration.");case 9:return e.abrupt("return",(0,u.K)(t,h({},n)));case 10:case"end":return e.stop()}}),e)}))),v.apply(this,arguments)}},5031:function(e,t,n){"use strict";n.d(t,{Ax:function(){return P},KM:function(){return E},TC:function(){return k},TR:function(){return _},Tc:function(){return R},kw:function(){return S},l6:function(){return A},lx:function(){return T},sH:function(){return w},xn:function(){return O}});var r=n(4942),o=n(4925),i=n(5861),a=n(885),u=n(2982),c=n(4687),s=n.n(c),f=n(8750),l=n(146),p=n(9732),h=n(7595),d=["href","method","rel","accepts","produces"];function v(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function y(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?v(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):v(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function g(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return m(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?m(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}function m(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var b={remediators:{},getFlowSpecification:function(e){return{remediators:{}}}};function k(e){Object.assign(b,e)}function w(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"default";return b.getFlowSpecification(e,t)}function O(e){var t=e.neededToProceed,n=e.interactionCode;return!t.length&&!n}function Z(e){if(e&&Array.isArray(e))return e.reduce((function(e,t){if(t.messages&&(e=[].concat((0,u.Z)(e),(0,u.Z)(t.messages.value))),t.form){var n=Z(t.form.value)||[];e=[].concat((0,u.Z)(e),(0,u.Z)(n))}if(t.options){var r=[];t.options.forEach((function(e){e.value&&"string"!=typeof e.value&&(r=[].concat((0,u.Z)(r),[e.value]))}));var o=Z(r)||[];e=[].concat((0,u.Z)(e),(0,u.Z)(o))}return e}),[])}function T(e,t){var n,r=[],o=e.rawIdxState,i=e.neededToProceed,a=null===(n=o.messages)||void 0===n?void 0:n.value.map((function(e){return e}));if(a&&(r=[].concat((0,u.Z)(r),(0,u.Z)(a))),!t.useGenericRemediator){var c,s=g(i);try{for(s.s();!(c=s.n()).done;){var f=Z(c.value.value);f&&(r=[].concat((0,u.Z)(r),(0,u.Z)(f)))}}catch(e){s.e(e)}finally{s.f()}}var l={};return r.reduce((function(e,t){var n,r=null===(n=t.i18n)||void 0===n?void 0:n.key;return r&&l[r]&&t.message===l[r].message?e:(l[r]=t,e=[].concat((0,u.Z)(e),[t]))}),[])}function E(e){var t=[],n=e.actions,r=e.neededToProceed;return n["currentAuthenticator-recover"]&&t.push(h.Fw.PASSWORD_RECOVERY),r.some((function(e){return"select-enroll-profile"===e.name}))&&t.push(h.Fw.REGISTRATION),r.some((function(e){return"redirect-idp"===e.name}))&&t.push(h.Fw.SOCIAL_IDP),r.some((function(e){return"unlock-account"===e.name}))&&t.push(h.Fw.ACCOUNT_UNLOCK),t}function S(e,t,n){var r,u=[],c=Object.values(b.remediators).reduce((function(e,t){return t.remediationName&&(e[t.remediationName]=t),e}),{}),l=g(t.neededToProceed);try{for(l.s();!(r=l.n()).done;){var p=r.value,h=x(p,{useGenericRemediator:n,remediators:c});if(h){var v=new h(p);u.push(v.getNextStep(e,t.context))}}}catch(e){l.e(e)}finally{l.f()}for(var m=function(){var n,r=(0,a.Z)(w[k],1)[0],c={name:r,action:(n=(0,i.Z)(s().mark((function t(n){return s().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",e.idx.proceed({actions:[{name:r,params:n}]}));case 1:case"end":return t.stop()}}),t)}))),function(e){return n.apply(this,arguments)})};if(r.startsWith("currentAuthenticator")){var l,p=(0,f.YQ)(r,"-"),h=(0,a.Z)(p,2),v=h[0],g=h[1],m=t.rawIdxState[v].value[g],b=(m.href,m.method,m.rel,m.accepts,m.produces,(0,o.Z)(m,d)),O=null===(l=m.value)||void 0===l?void 0:l.filter((function(e){return"stateHandle"!==e.name}));c=y(y(y({},b),O&&{value:O}),c)}u.push(c)},k=0,w=Object.entries(t.actions||{});k<w.length;k++)m();return u}function P(e,t,n){var r=(e.neededToProceed||[]).find((function(e){return e.name===t}));return r?r.value.reduce((function(e,t){var r=t.name,o=t.value;return e[r]="stateHandle"===r?o:n[r],e}),{}):((0,l.ZK)('filterValuesForRemediation: "'.concat(t,'" did not match any remediations')),n)}function x(e,t){var n=t.useGenericRemediator,r=t.remediators;if(e)return n?p.P:r[e.name]}function A(e,t,n){var r,o=n.remediators,i=n.useGenericRemediator,a=e.neededToProceed,u=e.context;if(!n.step){var c=[];if(i)c.push(new p.P(a[0],t,n));else{var s,f=g(a);try{for(f.s();!(s=f.n()).done;){var h=s.value;if(Object.keys(o).includes(h.name)){if((r=new(x(h,n))(h,t,n)).canRemediate(u))return r;c.push(r)}}}catch(e){f.e(e)}finally{f.f()}}return c[0]}var d=a.find((function(e){return e.name===n.step}));if(d){var v=x(d,n);return v?new v(d,t,n):void 0}(0,l.ZK)('step "'.concat(n.step,'" did not match any remediations'))}function _(e,t,n){var r=t.getNextStep(e,n.context),o=function(e){return e.neededToProceed.some((function(e){return"skip"===e.name}))}(n),i=function(e){return Object.keys(e.actions).some((function(e){return e.includes("resend")}))}(n);return y(y(y({},r),o&&{canSkip:o}),i&&{canResend:i})}function R(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=O(t),o=T(t,n);if(r)return{idxResponse:t,terminal:r,messages:o};var i=A(t,{},n),a=i&&_(e,i,t);return y({idxResponse:t,messages:o},a&&{nextStep:a})}},8716:function(e,t,n){"use strict";n.r(t),n.d(t,{buildCredentialCreationOptions:function(){return i},buildCredentialRequestOptions:function(){return a},getAssertion:function(){return c},getAttestation:function(){return u}});var r=n(7987),o=function(){var e=[];return(arguments.length>0&&void 0!==arguments[0]?arguments[0]:[]).forEach((function(t){"webauthn"===t.key&&e.push({type:"public-key",id:(0,r.dX)(t.credentialId)})})),e},i=function(e,t){return{publicKey:{rp:e.rp,user:{id:(0,r.dX)(e.user.id),name:e.user.name,displayName:e.user.displayName},challenge:(0,r.dX)(e.challenge),pubKeyCredParams:e.pubKeyCredParams,attestation:e.attestation,authenticatorSelection:e.authenticatorSelection,excludeCredentials:o(t)}}},a=function(e,t){return{publicKey:{challenge:(0,r.dX)(e.challenge),userVerification:e.userVerification,allowCredentials:o(t)}}},u=function(e){var t=e.response;return{id:e.id,clientData:(0,r.kQ)(t.clientDataJSON),attestation:(0,r.kQ)(t.attestationObject)}},c=function(e){var t=e.response;return{id:e.id,clientData:(0,r.kQ)(t.clientDataJSON),authenticatorData:(0,r.kQ)(t.authenticatorData),signatureData:(0,r.kQ)(t.signature)}}},9108:function(e,t,n){"use strict";n.r(t),n.d(t,{addEmail:function(){return B},addPhone:function(){return z},deleteEmail:function(){return H},deletePassword:function(){return oe},deletePhone:function(){return Q},enrollPassword:function(){return ne},getEmail:function(){return F},getEmailChallenge:function(){return G},getEmails:function(){return L},getPassword:function(){return te},getPhone:function(){return Y},getPhones:function(){return W},getProfile:function(){return A},getProfileSchema:function(){return R},sendEmailChallenge:function(){return K},sendPhoneChallenge:function(){return X},updatePassword:function(){return re},updateProfile:function(){return _},verifyEmailChallenge:function(){return V},verifyPhoneChallenge:function(){return J}});var r=n(5861),o=n(4687),i=n.n(o),a=n(4942),u=n(1002),c=n(4925),s=n(3144),f=n(5671),l=["headers"],p=(0,s.Z)((function e(t,n){var r=this;(0,f.Z)(this,e),(0,a.Z)(this,"headers",void 0);var o=n.res,i=o.headers,u=(0,c.Z)(o,l);i&&(this.headers=i),Object.keys(u).forEach((function(e){"_links"!==e&&(r[e]=u[e])}))})),h=n(5385),d=n(9123);function v(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function y(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?v(Object(n),!0).forEach((function(t){(0,a.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):v(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function g(e,t){return m.apply(this,arguments)}function m(){return m=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u,c,s,f,l,v,g,m,b=arguments;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=b.length>2&&void 0!==b[2]?b[2]:p,o=t.tokenManager.getTokensSync(),a=o.accessToken,u=n.accessToken||(null==a?void 0:a.accessToken),c=t.getIssuerOrigin(),s=n.url,f=n.method,l=n.payload,v=s.startsWith(c)?s:"".concat(c).concat(s),u){e.next=8;break}throw new d.Z("AccessToken is required to request MyAccount API endpoints.");case 8:return e.next=10,(0,h.c3)(t,y({headers:{Accept:"*/*;okta-version=1.0.0"},accessToken:u,url:v,method:f},l&&{args:l}));case 10:return g=e.sent,m=Array.isArray(g)?g.map((function(e){return new r(t,{res:e,accessToken:u})})):new r(t,{res:g,accessToken:u}),e.abrupt("return",m);case 13:case"end":return e.stop()}}),e)}))),m.apply(this,arguments)}function b(e){for(var t=e.oktaAuth,n=e.accessToken,o=e.methodName,a=e.links,c=arguments.length>1&&void 0!==arguments[1]?arguments[1]:p,s=function(){var e,u=l[f];if(u.toLowerCase()===o){var s=a.self;return{v:(e=(0,r.Z)(i().mark((function e(r){return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",g(t,{accessToken:n,url:s.href,method:u,payload:r},c));case 1:case"end":return e.stop()}}),e)}))),function(t){return e.apply(this,arguments)})}}},f=0,l=["GET","POST","PUT","DELETE"];f<l.length;f++){var h=s();if("object"===(0,u.Z)(h))return h.v}var v,y=a[o];if(!y)throw new d.Z("No link is found with methodName: ".concat(o));return v=(0,r.Z)(i().mark((function e(r){return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",g(t,{accessToken:n,url:y.href,method:y.hints.allow[0],payload:r},c));case 1:case"end":return e.stop()}}),e)}))),function(e){return v.apply(this,arguments)}}var k=n(7326),w=n(136),O=n(2963),Z=n(1120);var T=function(e){(0,w.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,Z.Z)(t);if(n){var o=(0,Z.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,O.Z)(this,e)});function o(e,t){var n;(0,f.Z)(this,o),n=r.call(this,e,t),(0,a.Z)((0,k.Z)(n),"createdAt",void 0),(0,a.Z)((0,k.Z)(n),"modifiedAt",void 0),(0,a.Z)((0,k.Z)(n),"profile",void 0);var i=t.res,u=i.createdAt,c=i.modifiedAt,s=i.profile;return n.createdAt=u,n.modifiedAt=c,n.profile=s,n}return(0,s.Z)(o)}(p);var E,S,P,x=function(e){(0,w.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,Z.Z)(t);if(n){var o=(0,Z.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,O.Z)(this,e)});function o(e,t){var n;return(0,f.Z)(this,o),n=r.call(this,e,t),(0,a.Z)((0,k.Z)(n),"properties",void 0),n.properties=t.res.properties,n}return(0,s.Z)(o)}(p),A=(E=(0,r.Z)(i().mark((function e(t,n){var r;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,g(t,{url:"/idp/myaccount/profile",method:"GET",accessToken:null==n?void 0:n.accessToken},T);case 2:return r=e.sent,e.abrupt("return",r);case 4:case"end":return e.stop()}}),e)}))),function(e,t){return E.apply(this,arguments)}),_=(S=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).payload,a=r.accessToken,e.next=3,g(t,{url:"/idp/myaccount/profile",method:"PUT",payload:o,accessToken:a},T);case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return S.apply(this,arguments)}),R=(P=(0,r.Z)(i().mark((function e(t,n){var r;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,g(t,{url:"/idp/myaccount/profile/schema",method:"GET",accessToken:null==n?void 0:n.accessToken},x);case 2:return r=e.sent,e.abrupt("return",r);case 4:case"end":return e.stop()}}),e)}))),function(e,t){return P.apply(this,arguments)});var j=function(e){(0,w.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,Z.Z)(t);if(n){var o=(0,Z.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,O.Z)(this,e)});function o(e,t){var n;(0,f.Z)(this,o),n=r.call(this,e,t),(0,a.Z)((0,k.Z)(n),"id",void 0),(0,a.Z)((0,k.Z)(n),"expiresAt",void 0),(0,a.Z)((0,k.Z)(n),"profile",void 0),(0,a.Z)((0,k.Z)(n),"status",void 0);var i=t.res,u=i.id,c=i.profile,s=i.expiresAt,l=i.status;return n.id=u,n.expiresAt=s,n.profile=c,n.status=l,n}return(0,s.Z)(o)}(p);var C=function(e){(0,w.Z)(u,e);var t,n,o=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,Z.Z)(t);if(n){var o=(0,Z.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,O.Z)(this,e)});function u(e,t){var n;(0,f.Z)(this,u),n=o.call(this,e,t),(0,a.Z)((0,k.Z)(n),"id",void 0),(0,a.Z)((0,k.Z)(n),"expiresAt",void 0),(0,a.Z)((0,k.Z)(n),"profile",void 0),(0,a.Z)((0,k.Z)(n),"status",void 0),(0,a.Z)((0,k.Z)(n),"poll",void 0),(0,a.Z)((0,k.Z)(n),"verify",void 0);var c=t.accessToken,s=t.res,l=s.id,p=s.expiresAt,h=s.profile,d=s.status,v=s._links;return n.id=l,n.expiresAt=p,n.profile=h,n.status=d,n.poll=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:c,methodName:"poll",links:v},j),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.verify=function(){var t=(0,r.Z)(i().mark((function t(n){var r;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=b({oktaAuth:e,accessToken:c,methodName:"verify",links:v},u),t.next=3,r(n);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)})));return function(e){return t.apply(this,arguments)}}(),n}return(0,s.Z)(u)}(p);var D,I,M,N,U=function(e){(0,w.Z)(u,e);var t,n,o=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,Z.Z)(t);if(n){var o=(0,Z.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,O.Z)(this,e)});function u(e,t){var n;(0,f.Z)(this,u),n=o.call(this,e,t),(0,a.Z)((0,k.Z)(n),"id",void 0),(0,a.Z)((0,k.Z)(n),"profile",void 0),(0,a.Z)((0,k.Z)(n),"roles",void 0),(0,a.Z)((0,k.Z)(n),"status",void 0),(0,a.Z)((0,k.Z)(n),"get",void 0),(0,a.Z)((0,k.Z)(n),"delete",void 0),(0,a.Z)((0,k.Z)(n),"challenge",void 0),(0,a.Z)((0,k.Z)(n),"poll",void 0),(0,a.Z)((0,k.Z)(n),"verify",void 0);var c,s=t.accessToken,l=t.res,p=l.id,h=l.profile,d=l.roles,v=l.status,y=l._links;return n.id=p,n.profile=h,n.roles=d,n.status=v,n.get=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:s,methodName:"get",links:y},u),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.delete=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:s,methodName:"delete",links:y}),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.challenge=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:s,methodName:"challenge",links:y},C),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),y.poll&&(n.poll=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:s,methodName:"poll",links:y},j),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)})))),y.verify&&(n.verify=(c=(0,r.Z)(i().mark((function t(n){var r;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=b({oktaAuth:e,accessToken:s,methodName:"verify",links:y}),t.next=3,r(n);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),function(e){return c.apply(this,arguments)})),n}return(0,s.Z)(u)}(p),L=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,g(t,{url:"/idp/myaccount/emails",method:"GET",accessToken:null==n?void 0:n.accessToken},U);case 2:return r=e.sent,e.abrupt("return",r);case 4:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),F=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).id,a=r.accessToken,e.next=3,g(t,{url:"/idp/myaccount/emails/".concat(o),method:"GET",accessToken:a},U);case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),B=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).accessToken,a=r.payload,e.next=3,g(t,{url:"/idp/myaccount/emails",method:"POST",payload:a,accessToken:o},U);case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),H=(D=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).id,a=r.accessToken,e.next=3,g(t,{url:"/idp/myaccount/emails/".concat(o),method:"DELETE",accessToken:a});case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return D.apply(this,arguments)}),K=(I=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).id,a=r.accessToken,e.next=3,g(t,{url:"/idp/myaccount/emails/".concat(o,"/challenge"),method:"POST",accessToken:a},C);case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return I.apply(this,arguments)}),G=(M=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u,c;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).emailId,a=r.challengeId,u=r.accessToken,e.next=3,g(t,{url:"/idp/myaccount/emails/".concat(o,"/challenge/").concat(a),method:"POST",accessToken:u},C);case 3:return c=e.sent,e.abrupt("return",c);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return M.apply(this,arguments)}),V=(N=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u,c,s;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).emailId,a=r.challengeId,u=r.payload,c=r.accessToken,e.next=3,g(t,{url:"/idp/myaccount/emails/".concat(o,"/challenge/").concat(a,"/verify"),method:"POST",payload:u,accessToken:c});case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return N.apply(this,arguments)});var q=function(e){(0,w.Z)(u,e);var t,n,o=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,Z.Z)(t);if(n){var o=(0,Z.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,O.Z)(this,e)});function u(e,t){var n;(0,f.Z)(this,u),n=o.call(this,e,t),(0,a.Z)((0,k.Z)(n),"id",void 0),(0,a.Z)((0,k.Z)(n),"profile",void 0),(0,a.Z)((0,k.Z)(n),"status",void 0),(0,a.Z)((0,k.Z)(n),"get",void 0),(0,a.Z)((0,k.Z)(n),"delete",void 0),(0,a.Z)((0,k.Z)(n),"challenge",void 0),(0,a.Z)((0,k.Z)(n),"verify",void 0);var c,s=t.res,l=t.accessToken,p=s.id,h=s.profile,d=s.status,v=s._links;return n.id=p,n.profile=h,n.status=d,n.get=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:l,methodName:"get",links:v},u),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.delete=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:l,methodName:"delete",links:v}),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.challenge=(c=(0,r.Z)(i().mark((function t(n){var r;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=b({oktaAuth:e,accessToken:l,methodName:"challenge",links:v}),t.next=3,r(n);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),function(e){return c.apply(this,arguments)}),v.verify&&(n.verify=function(){var t=(0,r.Z)(i().mark((function t(n){var r;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=b({oktaAuth:e,accessToken:l,methodName:"verify",links:v}),t.next=3,r(n);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)})));return function(e){return t.apply(this,arguments)}}()),n}return(0,s.Z)(u)}(p),W=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,g(t,{url:"/idp/myaccount/phones",method:"GET",accessToken:null==n?void 0:n.accessToken},q);case 2:return r=e.sent,e.abrupt("return",r);case 4:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),Y=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).accessToken,a=r.id,e.next=3,g(t,{url:"/idp/myaccount/phones/".concat(a),method:"GET",accessToken:o},q);case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),z=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).accessToken,a=r.payload,e.next=3,g(t,{url:"/idp/myaccount/phones",method:"POST",payload:a,accessToken:o},q);case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),Q=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).id,a=r.accessToken,e.next=3,g(t,{url:"/idp/myaccount/phones/".concat(o),method:"DELETE",accessToken:a});case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),X=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u,c;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).accessToken,a=r.id,u=r.payload,e.next=3,g(t,{url:"/idp/myaccount/phones/".concat(a,"/challenge"),method:"POST",payload:u,accessToken:o});case 3:return c=e.sent,e.abrupt("return",c);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),J=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u,c;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).id,a=r.payload,u=r.accessToken,e.next=3,g(t,{url:"/idp/myaccount/phones/".concat(o,"/verify"),method:"POST",payload:a,accessToken:u});case 3:return c=e.sent,e.abrupt("return",c);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),$=n(8008);var ee=function(e){(0,w.Z)(u,e);var t,n,o=(t=u,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,Z.Z)(t);if(n){var o=(0,Z.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,O.Z)(this,e)});function u(e,t){var n;(0,f.Z)(this,u),n=o.call(this,e,t),(0,a.Z)((0,k.Z)(n),"id",void 0),(0,a.Z)((0,k.Z)(n),"created",void 0),(0,a.Z)((0,k.Z)(n),"lastUpdated",void 0),(0,a.Z)((0,k.Z)(n),"status",void 0),(0,a.Z)((0,k.Z)(n),"get",void 0),(0,a.Z)((0,k.Z)(n),"enroll",void 0),(0,a.Z)((0,k.Z)(n),"update",void 0),(0,a.Z)((0,k.Z)(n),"delete",void 0);var c,s=t.res,l=t.accessToken,p=s.id,h=s.status,d=s.created,v=s.lastUpdated,y=s._links;return n.id=p,n.status=h,n.created=d,n.lastUpdated=v,n.status==$.Fn.NOT_ENROLLED?n.enroll=function(){var t=(0,r.Z)(i().mark((function t(n){var r;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=b({oktaAuth:e,accessToken:l,methodName:"enroll",links:y},u),t.next=3,r(n);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)})));return function(e){return t.apply(this,arguments)}}():(n.get=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:l,methodName:"get",links:y},u),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),n.update=(c=(0,r.Z)(i().mark((function t(n){var r;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=b({oktaAuth:e,accessToken:l,methodName:"put",links:y},u),t.next=3,r(n);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),function(e){return c.apply(this,arguments)}),n.delete=(0,r.Z)(i().mark((function t(){var n;return i().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=b({oktaAuth:e,accessToken:l,methodName:"delete",links:y}),t.next=3,n();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)})))),n}return(0,s.Z)(u)}(p),te=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,g(t,{url:"/idp/myaccount/password",method:"GET",accessToken:null==n?void 0:n.accessToken},ee);case 2:return r=e.sent,e.abrupt("return",r);case 4:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),ne=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).accessToken,a=r.payload,e.next=3,g(t,{url:"/idp/myaccount/password",method:"POST",payload:a,accessToken:o},ee);case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),re=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r,o,a,u;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(r=n).accessToken,a=r.payload,e.next=3,g(t,{url:"/idp/myaccount/password",method:"PUT",payload:a,accessToken:o},ee);case 3:return u=e.sent,e.abrupt("return",u);case 5:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}(),oe=function(){var e=(0,r.Z)(i().mark((function e(t,n){var r;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,g(t,{url:"/idp/myaccount/password",method:"DELETE",accessToken:null==n?void 0:n.accessToken});case 2:return r=e.sent,e.abrupt("return",r);case 4:case"end":return e.stop()}}),e)})));return function(t,n){return e.apply(this,arguments)}}()},1132:function(e,t,n){"use strict";n.d(t,{aw:function(){return u.aw},Fn:function(){return u.Fn},qb:function(){return u.qb},no:function(){return r.addEmail},Z1:function(){return r.addPhone},Xc:function(){return a},nd:function(){return r.deleteEmail},QN:function(){return r.deletePassword},qj:function(){return r.deletePhone},xg:function(){return r.enrollPassword},OD:function(){return r.getEmail},hG:function(){return r.getEmailChallenge},G5:function(){return r.getEmails},Ij:function(){return r.getPassword},u_:function(){return r.getPhone},Po:function(){return r.getPhones},Ai:function(){return r.getProfile},aF:function(){return r.getProfileSchema},HT:function(){return i.H},ME:function(){return r.sendEmailChallenge},dv:function(){return r.sendPhoneChallenge},gQ:function(){return r.updatePassword},ck:function(){return r.updateProfile},T8:function(){return r.verifyEmailChallenge},Lo:function(){return r.verifyPhoneChallenge}});var r=n(9108),o=n(1578),i=n(6794);function a(e,t,n){var r=(0,o.K)(e,t,n);return(0,i.H)(r)}var u=n(8008)},6794:function(e,t,n){"use strict";n.d(t,{H:function(){return p}});var r=n(885),o=n(3144),i=n(5671),a=n(7326),u=n(136),c=n(2963),s=n(1120),f=n(4942),l=n(9108);function p(e){return function(e){(0,u.Z)(h,e);var t,n,p=(t=h,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function h(){var e;(0,i.Z)(this,h);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return e=p.call.apply(p,[this].concat(n)),(0,f.Z)((0,a.Z)(e),"myaccount",void 0),e.myaccount=Object.entries(l).filter((function(e){return"default"!==(0,r.Z)(e,1)[0]})).reduce((function(t,n){var o=(0,r.Z)(n,2),i=o[0],u=o[1];return t[i]=u.bind(null,(0,a.Z)(e)),t}),{}),e}return(0,o.Z)(h)}(e)}},8008:function(e,t,n){"use strict";var r,o,i;n.d(t,{Fn:function(){return i},aw:function(){return r},qb:function(){return o}}),function(e){e.PRIMARY="PRIMARY",e.SECONDARY="SECONDARY"}(r||(r={})),function(e){e.VERIFIED="VERIFIED",e.UNVERIFIED="UNVERIFIED"}(o||(o={})),function(e){e.NOT_ENROLLED="NOT_ENROLLED",e.ACTIVE="ACTIVE"}(i||(i={}))},2427:function(e,t,n){"use strict";n.d(t,{M:function(){return w}});var r=n(5861),o=n(1002),i=n(5671),a=n(3144),u=n(4942),c=n(4687),s=n.n(c),f=n(3193),l=n(9123),p=n(2482),h=n(415),d=function(){function e(t){(0,i.Z)(this,e),(0,u.Z)(this,"localOffset",void 0),this.localOffset=parseInt(t||0)}return(0,a.Z)(e,[{key:"now",value:function(){return(Date.now()+this.localOffset)/1e3}}],[{key:"create",value:function(){return new e(0)}}]),e}(),v=n(7088),y=n(6488),g=n(1971);function m(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function b(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?m(Object(n),!0).forEach((function(t){(0,u.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):m(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var k={autoRenew:!0,autoRemove:!0,syncStorage:!0,clearPendingRemoveTokens:!0,storage:void 0,expireEarlySeconds:30,storageKey:g.TOKEN_STORAGE_NAME},w=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if((0,i.Z)(this,e),(0,u.Z)(this,"sdk",void 0),(0,u.Z)(this,"clock",void 0),(0,u.Z)(this,"emitter",void 0),(0,u.Z)(this,"storage",void 0),(0,u.Z)(this,"state",void 0),(0,u.Z)(this,"options",void 0),this.sdk=t,this.emitter=t.emitter,!this.emitter)throw new l.Z("Emitter should be initialized before TokenManager");n=Object.assign({},k,(0,f.YY)(n)),(0,h.isLocalhost)()||(n.expireEarlySeconds=k.expireEarlySeconds),this.options=n;var r=(0,f.YY)({storageKey:n.storageKey,secure:n.secure});"object"===(0,o.Z)(n.storage)?r.storageProvider=n.storage:n.storage&&(r.storageType=n.storage),this.storage=t.storageManager.getTokenStorage(b(b({},r),{},{useSeparateCookies:!0})),this.clock=d.create(),this.state={expireTimeouts:{},renewPromise:null}}var t,n,c;return(0,a.Z)(e,[{key:"on",value:function(e,t,n){n?this.emitter.on(e,t,n):this.emitter.on(e,t)}},{key:"off",value:function(e,t){t?this.emitter.off(e,t):this.emitter.off(e)}},{key:"start",value:function(){this.options.clearPendingRemoveTokens&&this.clearPendingRemoveTokens(),this.setExpireEventTimeoutAll(),this.state.started=!0}},{key:"stop",value:function(){this.clearExpireEventTimeoutAll(),this.state.started=!1}},{key:"isStarted",value:function(){return!!this.state.started}},{key:"getOptions",value:function(){return(0,f.d9)(this.options)}},{key:"getExpireTime",value:function(e){var t=this.options.expireEarlySeconds||0;return e.expiresAt-t}},{key:"hasExpired",value:function(e){return this.getExpireTime(e)<=this.clock.now()}},{key:"emitExpired",value:function(e,t){this.emitter.emit(v.$Y,e,t)}},{key:"emitRenewed",value:function(e,t,n){this.emitter.emit(v.E,e,t,n)}},{key:"emitAdded",value:function(e,t){this.emitter.emit(v.O3,e,t)}},{key:"emitRemoved",value:function(e,t){this.emitter.emit(v.FT,e,t)}},{key:"emitError",value:function(e){this.emitter.emit(v.$I,e)}},{key:"clearExpireEventTimeout",value:function(e){clearTimeout(this.state.expireTimeouts[e]),delete this.state.expireTimeouts[e],this.state.renewPromise=null}},{key:"clearExpireEventTimeoutAll",value:function(){var e=this.state.expireTimeouts;for(var t in e)Object.prototype.hasOwnProperty.call(e,t)&&this.clearExpireEventTimeout(t)}},{key:"setExpireEventTimeout",value:function(e,t){var n=this;if(!(0,y.z9)(t)){var r=this.getExpireTime(t),o=1e3*Math.max(r-this.clock.now(),0);this.clearExpireEventTimeout(e);var i=setTimeout((function(){n.emitExpired(e,t)}),o);this.state.expireTimeouts[e]=i}}},{key:"setExpireEventTimeoutAll",value:function(){var e=this.storage.getStorage();for(var t in e)if(Object.prototype.hasOwnProperty.call(e,t)){var n=e[t];this.setExpireEventTimeout(t,n)}}},{key:"resetExpireEventTimeoutAll",value:function(){this.clearExpireEventTimeoutAll(),this.setExpireEventTimeoutAll()}},{key:"add",value:function(e,t){var n=this.storage.getStorage();(0,p.R)(t),n[e]=t,this.storage.setStorage(n),this.emitSetStorageEvent(),this.emitAdded(e,t),this.setExpireEventTimeout(e,t)}},{key:"getSync",value:function(e){return this.storage.getStorage()[e]}},{key:"get",value:(c=(0,r.Z)(s().mark((function e(t){return s().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.getSync(t));case 1:case"end":return e.stop()}}),e,this)}))),function(e){return c.apply(this,arguments)})},{key:"getTokensSync",value:function(){var e={},t=this.storage.getStorage();return Object.keys(t).forEach((function(n){var r=t[n];(0,y.hv)(r)?e.accessToken=r:(0,y.sI)(r)?e.idToken=r:(0,y.z9)(r)&&(e.refreshToken=r)})),e}},{key:"getTokens",value:(n=(0,r.Z)(s().mark((function e(){return s().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.getTokensSync());case 1:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"getStorageKeyByType",value:function(e){var t=this.storage.getStorage();return Object.keys(t).filter((function(n){var r=t[n];return(0,y.hv)(r)&&"accessToken"===e||(0,y.sI)(r)&&"idToken"===e||(0,y.z9)(r)&&"refreshToken"===e}))[0]}},{key:"getTokenType",value:function(e){if((0,y.hv)(e))return"accessToken";if((0,y.sI)(e))return"idToken";if((0,y.z9)(e))return"refreshToken";throw new l.Z("Unknown token type")}},{key:"emitSetStorageEvent",value:function(){if((0,h.isIE11OrLess)()){var e=this.storage.getStorage();this.emitter.emit(v.zr,e)}}},{key:"getStorage",value:function(){return this.storage}},{key:"setTokens",value:function(e,t,n,r){var o=this,i=function(e,i){var a=o.getTokenType(i);"accessToken"===a?t&&t(e,i):"idToken"===a?n&&n(e,i):"refreshToken"===a&&r&&r(e,i)},a=function(e,t){o.emitAdded(e,t),o.setExpireEventTimeout(e,t),i(e,t)},u=function(e,t){o.clearExpireEventTimeout(e),o.emitRemoved(e,t),i(e,t)},c=["idToken","accessToken","refreshToken"],s=this.getTokensSync();c.forEach((function(t){var n=e[t];n&&(0,p.R)(n,t)}));var f=c.reduce((function(t,n){var r=e[n];return r&&(t[o.getStorageKeyByType(n)||n]=r),t}),{});this.storage.setStorage(f),this.emitSetStorageEvent(),c.forEach((function(t){var n,r,c,f=e[t],l=s[t],p=o.getStorageKeyByType(t)||t;f&&l?(u(p,l),a(p,f),n=p,r=f,c=l,o.emitRenewed(n,r,c),o.clearExpireEventTimeout(n),o.setExpireEventTimeout(n,r),i(n,r)):f?a(p,f):l&&u(p,l)}))}},{key:"remove",value:function(e){this.clearExpireEventTimeout(e);var t=this.storage.getStorage(),n=t[e];delete t[e],this.storage.setStorage(t),this.emitSetStorageEvent(),this.emitRemoved(e,n)}},{key:"renewToken",value:(t=(0,r.Z)(s().mark((function e(t){var n;return s().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",null===(n=this.sdk.token)||void 0===n?void 0:n.renew(t));case 1:case"end":return e.stop()}}),e,this)}))),function(e){return t.apply(this,arguments)})},{key:"validateToken",value:function(e){return(0,p.R)(e)}},{key:"renew",value:function(e){var t=this;if(this.state.renewPromise)return this.state.renewPromise;try{var n=this.getSync(e),r=void 0!==n;if(!n&&"accessToken"===e){var o=this.getStorageKeyByType("refreshToken");r=void 0!==this.getSync(o)}if(!r)throw new l.Z("The tokenManager has no token for the key: "+e)}catch(e){return this.emitError(e),Promise.reject(e)}return this.clearExpireEventTimeout(e),this.state.renewPromise=this.sdk.token.renewTokens().then((function(r){if(t.setTokens(r),!n&&"accessToken"===e){var o=r.accessToken;return t.emitRenewed(e,o,null),o}return r[t.getTokenType(n)]})).catch((function(n){throw t.remove(e),n.tokenKey=e,t.emitError(n),n})).finally((function(){t.state.renewPromise=null}))}},{key:"clear",value:function(){var e=this,t=this.getTokensSync();this.clearExpireEventTimeoutAll(),this.storage.clearStorage(),this.emitSetStorageEvent(),Object.keys(t).forEach((function(n){e.emitRemoved(n,t[n])}))}},{key:"clearPendingRemoveTokens",value:function(){var e=this,t=this.storage.getStorage(),n={};Object.keys(t).forEach((function(e){t[e].pendingRemove&&(n[e]=t[e],delete t[e])})),this.storage.setStorage(t),this.emitSetStorageEvent(),Object.keys(n).forEach((function(t){e.clearExpireEventTimeout(t),e.emitRemoved(t,n[t])}))}},{key:"updateRefreshToken",value:function(e){var t=this.getStorageKeyByType("refreshToken")||g.REFRESH_TOKEN_STORAGE_KEY,n=this.storage.getStorage();(0,p.R)(e),n[t]=e,this.storage.setStorage(n),this.emitSetStorageEvent()}},{key:"removeRefreshToken",value:function(){var e=this.getStorageKeyByType("refreshToken")||g.REFRESH_TOKEN_STORAGE_KEY;this.remove(e)}},{key:"addPendingRemoveFlags",value:function(){var e=this.getTokensSync();Object.keys(e).forEach((function(t){e[t].pendingRemove=!0})),this.setTokens(e)}}]),e}()},1646:function(e,t,n){"use strict";n.d(t,{P:function(){return s}});var r=n(5671),o=n(3144),i=n(4942),a=n(4319),u=n(146),c=18e5;function s(){return function(){function e(t){(0,r.Z)(this,e),(0,i.Z)(this,"options",void 0),(0,i.Z)(this,"storageManager",void 0),(0,i.Z)(this,"enableSharedStorage",void 0),(0,i.Z)(this,"saveLastResponse",void 0),this.storageManager=t.storageManager,this.enableSharedStorage=!1!==t.enableSharedStorage,this.saveLastResponse=!1!==t.saveLastResponse,this.options=t}return(0,o.Z)(e,[{key:"clear",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=this.storageManager.getTransactionStorage(),n=t.getStorage();if(t.clearStorage(),this.enableSharedStorage&&!1!==e.clearSharedStorage){var r=e.state||(null==n?void 0:n.state);r&&function(e,t){var n=e.getSharedTansactionStorage(),r=n.getStorage();delete r[t],n.setStorage(r)}(this.storageManager,r)}}},{key:"save",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=this.storageManager.getTransactionStorage(),r=n.getStorage();(0,a.mH)(r)&&!t.muteWarning&&(0,u.ZK)("a saved auth transaction exists in storage. This may indicate another auth flow is already in progress."),n.setStorage(e),this.enableSharedStorage&&e.state&&function(e,t,n){var r=e.getSharedTansactionStorage(),o=r.getStorage();o[t]={dateCreated:Date.now(),transaction:n},r.setStorage(o)}(this.storageManager,e.state,e)}},{key:"exists",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};try{return!!this.load(e)}catch(e){return!1}}},{key:"load",value:function(){var e,t,n,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this.enableSharedStorage&&r.state&&(t=this.storageManager.getSharedTansactionStorage(),n=t.getStorage(),Object.keys(n).forEach((function(e){var t=n[e];Date.now()-t.dateCreated>c&&delete n[e]})),t.setStorage(n),e=function(e,t){var n=e.getSharedTansactionStorage().getStorage()[t];return n&&n.transaction&&(0,a.mH)(n.transaction)?n.transaction:null}(this.storageManager,r.state),(0,a.mH)(e))?e:(e=this.storageManager.getTransactionStorage().getStorage(),(0,a.mH)(e)?e:null)}}]),e}()}},1237:function(e,t,n){"use strict";n.d(t,{T:function(){return i}});var r=n(9123),o=n(7987);function i(e){var t,n=e.split(".");try{t={header:JSON.parse((0,o.Wy)(n[0])),payload:JSON.parse((0,o.Wy)(n[1])),signature:n[2]}}catch(e){throw new r.Z("Malformed token")}return t}},7659:function(e,t,n){"use strict";n.d(t,{SO:function(){return h},V7:function(){return A},aW:function(){return I},ao:function(){return C},cE:function(){return N},lk:function(){return E},sd:function(){return P},vX:function(){return R}});var r=n(2982),o=n(5861),i=n(4687),a=n.n(i),u=n(7987),c=n(7594),s=n(5728),f=n(9123),l="OktaAuthJs",p="DPoPKeys";function h(e){return((0,s.isOAuthError)(e)||(0,s.isWWWAuthError)(e))&&"use_dpop_nonce"===e.errorCode}function d(e,t,n){return v.apply(this,arguments)}function v(){return(v=(0,o.Z)(a().mark((function e(t,n,r){var o,i,s;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(0,u.NL)(JSON.stringify(t)),i=(0,u.NL)(JSON.stringify(n)),e.next=4,c.KP.subtle.sign({name:r.algorithm.name},r,(0,u.k8)("".concat(o,".").concat(i)));case 4:return s=e.sent,e.abrupt("return","".concat(o,".").concat(i,".").concat((0,u.aR)((0,u.kQ)(s))));case 6:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function y(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:32;return(0,r.Z)(c.KP.getRandomValues(new Uint8Array(e))).map((function(e){return e.toString(16)})).join("")}function g(){return m.apply(this,arguments)}function m(){return(m=(0,o.Z)(a().mark((function e(){var t;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t={name:"RSASSA-PKCS1-v1_5",hash:"SHA-256",modulusLength:2048,publicExponent:new Uint8Array([1,0,1])},e.abrupt("return",c.KP.subtle.generateKey(t,!1,["sign","verify"]));case 2:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function b(e){return k.apply(this,arguments)}function k(){return(k=(0,o.Z)(a().mark((function e(t){var n,r;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=(new TextEncoder).encode(t),e.next=3,c.KP.subtle.digest("SHA-256",n);case 3:return r=e.sent,e.abrupt("return",(0,c.r3)(String.fromCharCode.apply(null,new Uint8Array(r))).replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,""));case 5:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function w(e){return O.apply(this,arguments)}function O(){return O=(0,o.Z)(a().mark((function e(t){var n,r,o,i,u=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:for(n=u.length,r=new Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=u[o];return e.next=3,new Promise((function(e,t){try{var n=window.indexedDB.open(l,1);n.onerror=function(){t(n.error)},n.onupgradeneeded=function(){n.result.createObjectStore(p)},n.onsuccess=function(){var r=n.result,o=r.transaction(p,"readwrite");o.onerror=function(){t(o.error)};var i=o.objectStore(p);e(i),o.oncomplete=function(){r.close()}}}catch(e){t(e)}}));case 3:return i=e.sent,e.abrupt("return",new Promise((function(e,n){var o=i[t].apply(i,r);o.onsuccess=function(){e(o)},o.onerror=function(){n(o.error)}})));case 5:case"end":return e.stop()}}),e)}))),O.apply(this,arguments)}function Z(e,t){return T.apply(this,arguments)}function T(){return(T=(0,o.Z)(a().mark((function e(t,n){return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,w("add",n,t);case 2:return e.abrupt("return",n);case 3:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function E(e){return S.apply(this,arguments)}function S(){return(S=(0,o.Z)(a().mark((function e(t){var n;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!t){e.next=6;break}return e.next=3,w("get",t);case 3:if(!(n=e.sent).result){e.next=6;break}return e.abrupt("return",n.result);case 6:throw new f.Z("Unable to locate dpop key pair required for refresh".concat(t?" (".concat(t,")"):""));case 7:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function P(e){return x.apply(this,arguments)}function x(){return(x=(0,o.Z)(a().mark((function e(t){return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,w("delete",t);case 2:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function A(){return _.apply(this,arguments)}function _(){return(_=(0,o.Z)(a().mark((function e(){return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,w("clear");case 2:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function R(){return j.apply(this,arguments)}function j(){return(j=(0,o.Z)(a().mark((function e(){var t,n;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t=y(4),e.next=3,g();case 3:return n=e.sent,e.next=6,Z(t,n);case 6:return e.abrupt("return",{keyPair:n,keyPairId:t});case 7:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function C(e,t){return D.apply(this,arguments)}function D(){return(D=(0,o.Z)(a().mark((function e(t,n){var r,o,i,u,c;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(o=!1,i=n.accessToken,u=n.refreshToken,"access"===t&&i&&"DPoP"===i.tokenType&&!u&&(o=!0),"refresh"===t&&u&&!i&&(o=!0),c=null!==(r=null==i?void 0:i.dpopPairId)&&void 0!==r?r:null==u?void 0:u.dpopPairId,!o||!c){e.next=8;break}return e.next=8,P(c);case 8:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function I(e){return M.apply(this,arguments)}function M(){return(M=(0,o.Z)(a().mark((function e(t){var n,r,o,i,u,s,f,l,p,h,v,g,m,k;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=t.keyPair,r=t.url,o=t.method,i=t.nonce,u=t.accessToken,e.next=3,c.KP.subtle.exportKey("jwk",n.publicKey);case 3:if(s=e.sent,f=s.kty,l=s.crv,p=s.e,h=s.n,v=s.x,g=s.y,m={alg:"RS256",typ:"dpop+jwt",jwk:{kty:f,crv:l,e:p,n:h,x:v,y:g}},k={htm:o,htu:r,iat:Math.floor(Date.now()/1e3),jti:y()},i&&(k.nonce=i),!u){e.next=17;break}return e.next=16,b(u);case 16:k.ath=e.sent;case 17:return e.abrupt("return",d(m,k,n.privateKey));case 18:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function N(e){return U.apply(this,arguments)}function U(){return(U=(0,o.Z)(a().mark((function e(t){var n,r,o,i,u;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=t.keyPair,r=t.url,o=t.method,i=t.nonce,u={keyPair:n,url:r,method:o},i&&(u.nonce=i),e.abrupt("return",I(u));case 4:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},2206:function(e,t,n){"use strict";n.d(t,{R:function(){return l},_:function(){return f}});var r=n(4942),o=n(4771),i=n(3193),a=n(6718),u=n(9123);function c(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function s(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?c(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):c(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function f(e){if(!e.clientId)throw new u.Z("A clientId must be specified in the OktaAuth constructor to get a token");if((0,o.HD)(e.responseType)&&-1!==e.responseType.indexOf(" "))throw new u.Z("Multiple OAuth responseTypes must be defined as an array");var t={client_id:e.clientId,code_challenge:e.codeChallenge,code_challenge_method:e.codeChallengeMethod,display:e.display,idp:e.idp,idp_scope:e.idpScope,login_hint:e.loginHint,max_age:e.maxAge,nonce:e.nonce,prompt:e.prompt,redirect_uri:e.redirectUri,response_mode:e.responseMode,response_type:e.responseType,sessionToken:e.sessionToken,state:e.state,acr_values:e.acrValues,enroll_amr_values:e.enrollAmrValues};if(t=(0,i.YY)(t),["idp_scope","response_type","enroll_amr_values"].forEach((function(e){Array.isArray(t[e])&&(t[e]=t[e].join(" "))})),-1!==e.responseType.indexOf("id_token")&&-1===e.scopes.indexOf("openid"))throw new u.Z("openid scope must be specified in the scopes argument when requesting an id_token");return e.scopes&&(t.scope=e.scopes.join(" ")),t}function l(e){var t=f(e);return(0,a.UK)(s(s({},t),e.extraParams&&s({},e.extraParams)))}},2642:function(e,t,n){"use strict";n.d(t,{Dp:function(){return o.D},ES:function(){return i.E},R0:function(){return r.R},_6:function(){return r._},km:function(){return i.k},ti:function(){return o.t}});var r=n(2206),o=n(9231),i=n(52)},9231:function(e,t,n){"use strict";n.d(t,{D:function(){return b},t:function(){return g}});var r=n(885),o=n(5861),i=n(4687),a=n.n(i),u=n(9123),c=n(3983),s=n(3193),f=n(6718),l=n(5385),p=n(7659);function h(e){if(!e.clientId)throw new u.Z("A clientId must be specified in the OktaAuth constructor to get a token");if(!e.redirectUri)throw new u.Z("The redirectUri passed to /authorize must also be passed to /token");if(!e.authorizationCode&&!e.interactionCode)throw new u.Z("An authorization code (returned from /authorize) must be passed to /token");if(!e.codeVerifier)throw new u.Z('The "codeVerifier" (generated and saved by your app) must be passed to /token')}function d(e,t){var n=(0,s.YY)({client_id:t.clientId,redirect_uri:t.redirectUri,grant_type:t.interactionCode?"interaction_code":"authorization_code",code_verifier:t.codeVerifier});t.interactionCode?n.interaction_code=t.interactionCode:t.authorizationCode&&(n.code=t.authorizationCode);var r=e.options.clientSecret;return r&&(n.client_secret=r),(0,f.UK)(n).slice(1)}function v(e,t){return y.apply(this,arguments)}function y(){return(y=(0,o.Z)(a().mark((function e(t,n){var r,o,i,s,f,h,d,y,g,m,b;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=n.url,o=n.data,i=n.nonce,s=n.dpopKeyPair,f="POST",h={"Content-Type":"application/x-www-form-urlencoded"},!t.options.dpop){e.next=10;break}if(s){e.next=6;break}throw new u.Z("DPoP is configured but no key pair was provided");case 6:return e.next=8,(0,p.cE)({url:r,method:f,nonce:i,keyPair:s});case 8:d=e.sent,h.DPoP=d;case 10:return e.prev=10,e.next=13,(0,l.c3)(t,{url:r,method:f,args:o,headers:h});case 13:return y=e.sent,e.abrupt("return",y);case 17:if(e.prev=17,e.t0=e.catch(10),!(0,p.SO)(e.t0)||i){e.next=24;break}if(m=null===(g=e.t0.resp)||void 0===g?void 0:g.headers["dpop-nonce"]){e.next=23;break}throw new c.Z({errorSummary:"No `dpop-nonce` header found when required"},null!==(b=e.t0.resp)&&void 0!==b?b:void 0);case 23:return e.abrupt("return",v(t,{url:r,data:o,dpopKeyPair:s,nonce:m}));case 24:throw e.t0;case 25:case"end":return e.stop()}}),e,null,[[10,17]])})))).apply(this,arguments)}function g(e,t,n){return m.apply(this,arguments)}function m(){return(m=(0,o.Z)(a().mark((function e(t,n,r){var o,i;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return h(n),o=d(t,n),i={url:r.tokenUrl,data:o,dpopKeyPair:null==n?void 0:n.dpopKeyPair},e.abrupt("return",v(t,i));case 4:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function b(e,t,n){return k.apply(this,arguments)}function k(){return(k=(0,o.Z)(a().mark((function e(t,n,o){var i,u;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return i=Object.entries({client_id:n.clientId,grant_type:"refresh_token",scope:o.scopes.join(" "),refresh_token:o.refreshToken}).map((function(e){var t=(0,r.Z)(e,2),n=t[0],o=t[1];return n+"="+encodeURIComponent(o)})).join("&"),u={url:o.tokenUrl,data:i,dpopKeyPair:null==n?void 0:n.dpopKeyPair},e.abrupt("return",v(t,u));case 3:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},52:function(e,t,n){"use strict";n.d(t,{E:function(){return a},k:function(){return u}});var r=n(5385),o=n(3193),i=n(9123);function a(e,t){var n=t||e.options.issuer;return(0,r.U2)(e,n+"/.well-known/openid-configuration",{cacheResponse:!0})}function u(e,t,n){var u=e.storageManager.getHttpCache(e.options.cookies);return a(e,t).then((function(t){var a=t.jwks_uri,c=u.getStorage()[a];if(c&&Date.now()/1e3<c.expiresAt){var s=(0,o.sE)(c.response.keys,{kid:n});if(s)return s}return u.clearStorage(a),(0,r.U2)(e,a,{cacheResponse:!0}).then((function(e){var t=(0,o.sE)(e.keys,{kid:n});if(t)return t;throw new i.Z("The key id, "+n+", was not found in the server's keys")}))}))}},8707:function(e,t,n){"use strict";n.d(t,{r:function(){return p}});var r=n(5861),o=n(4687),i=n.n(o),a=n(7599),u=n(7756),c=n(3193),s=n(9231),f=n(8676),l=n(7659);function p(e,t,n){return h.apply(this,arguments)}function h(){return(h=(0,r.Z)(i().mark((function e(t,n,r){var o,p,h,d,v,y,g,m,b,k,w,O,Z,T,E,S,P,x,A,_,R;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=r||(0,a.Fc)(t,n),n=Object.assign({},(0,u.D)(t),(0,c.d9)(n)),p=(o=n).authorizationCode,h=o.interactionCode,d=o.codeVerifier,v=o.clientId,y=o.redirectUri,g=o.scopes,m=o.ignoreSignature,b=o.state,k=o.acrValues,w=o.dpop,O=o.dpopPairId,Z={clientId:v,redirectUri:y,authorizationCode:p,interactionCode:h,codeVerifier:d,dpop:w},T=["token"],-1!==g.indexOf("openid")&&T.push("id_token"),E={clientId:v,redirectUri:y,scopes:g,responseType:T,ignoreSignature:m,acrValues:k},e.prev=7,!w){e.next=26;break}if(!O){e.next=18;break}return e.next=12,(0,l.lk)(O);case 12:S=e.sent,Z.dpopKeyPair=S,E.dpop=w,E.dpopPairId=O,e.next=26;break;case 18:return e.next=20,(0,l.vX)();case 20:P=e.sent,x=P.keyPair,A=P.keyPairId,Z.dpopKeyPair=x,E.dpop=w,E.dpopPairId=A;case 26:return e.next=28,(0,s.t)(t,Z,r);case 28:return _=e.sent,e.next=31,(0,f.s)(t,E,_,r);case 31:return(R=e.sent).code=p,R.state=b,e.abrupt("return",R);case 35:return e.prev=35,t.transactionManager.clear(),e.finish(35);case 38:case"end":return e.stop()}}),e,null,[[7,,35,38]])})))).apply(this,arguments)}},5324:function(e,t,n){"use strict";n.d(t,{$:function(){return E},o:function(){return T}});var r=n(3548),o=n(1237),i=n(8707),a=n(6844),u=n(7625),c=n(9770),s=n(6803),f=n(5372),l=n(2476),p=n(6268),h=n(781),d=n(6466),v=n(8113),y=n(6898),g=n(8221),m=n(1260),b=n(3193),k=n(6757),w=n(8080),O=n(2206);function Z(e,t){t=(0,b.d9)(t)||{};var n=(0,k.U)(e,t),r=(0,w.A)(e,n),o=r.urls.authorizeUrl+(0,O.R)(n);e.transactionManager.save(r),e.options.setLocation?e.options.setLocation(o):window.location.assign(o)}function T(e,t){var n=function(e){return r.b.prototype.push.bind(t,e,null)},b=n(s.H.bind(null,e)),k=n(f.ko.bind(null,e)),w=Object.assign(k,{_getHistory:function(){return window.history},_getLocation:function(){return window.location},_getDocument:function(){return window.document}}),O={prepareTokenParams:y.wu.bind(null,e),exchangeCodeForTokens:i.r.bind(null,e),getWithoutPrompt:u.y.bind(null,e),getWithPopup:c.d.bind(null,e),getWithRedirect:b,parseFromUrl:w,decode:o.T,revoke:d.P.bind(null,e),renew:l.$.bind(null,e),renewTokensWithRefresh:h.R.bind(null,e),renewTokens:p.I.bind(null,e),getUserInfo:function(t,n){return(0,a.b)(e,t,n)},verify:m.W.bind(null,e),isLoginRedirect:g.gM.bind(null,e),introspect:v.j.bind(null,e)};return["getWithoutPrompt","getWithPopup","revoke","renew","renewTokensWithRefresh","renewTokens"].forEach((function(e){O[e]=n(O[e])})),O}function E(e){return{authorize:{enrollAuthenticator:Z.bind(null,e)}}}},231:function(e,t,n){"use strict";n.d(t,{$V:function(){return r.$},zr:function(){return s},o5:function(){return r.o}});var r=n(5324),o=n(9893),i=n(265),a=n(3980),u=n(279),c=n(2724);function s(e,t,n){var r=(0,o.a)(t),s=(0,i.H)(r,e),f=(0,u.A)(s),l=(0,a.Z)(f);return(0,c.J)(l,n)}},3253:function(e,t,n){"use strict";n.d(t,{L:function(){return s}});var r=n(7599),o=n(4970),i=n(9123),a=n(6898),u=n(2206),c=n(8676);function s(e,t){if(arguments.length>2)return Promise.reject(new i.Z('As of version 3.0, "getToken" takes only a single set of options'));var n=(t=t||{}).popupWindow;return t.popupWindow=void 0,(0,a.wu)(e,t).then((function(a){var s,f;switch(t.sessionToken?Object.assign(a,{prompt:"none",responseMode:"okta_post_message",display:null}):t.idp&&Object.assign(a,{display:"popup"}),f=(0,r.Fc)(e,a),s=(t.codeVerifier?f.tokenUrl:f.authorizeUrl)+(0,u.R)(a),a.sessionToken||null===a.display?"IFRAME":"popup"===a.display?"POPUP":"IMPLICIT"){case"IFRAME":var l=(0,o.iC)(e,t.timeout,a.state),p=(0,o.Rl)(s);return l.then((function(t){return(0,c.s)(e,a,t,f)})).finally((function(){var e;document.body.contains(p)&&(null===(e=p.parentElement)||void 0===e||e.removeChild(p))}));case"POPUP":var h;if("okta_post_message"===a.responseMode){if(!e.features.isPopupPostMessageSupported())throw new i.Z("This browser doesn't have full postMessage support");h=(0,o.iC)(e,t.timeout,a.state)}return n&&n.location.assign(s),new Promise((function(e,t){var r=setInterval((function(){n&&!n.closed||(clearInterval(r),t(new i.Z("Unable to parse OAuth flow response")))}),100);h.then((function(t){clearInterval(r),e(t)})).catch((function(e){clearInterval(r),t(e)}))})).then((function(t){return(0,c.s)(e,a,t,f)})).finally((function(){n&&!n.closed&&n.close()}));default:throw new i.Z("The full page redirect flow is not supported")}}))}},6844:function(e,t,n){"use strict";n.d(t,{b:function(){return v}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),u=n(9123),c=n(3114),s=n(2886),f=n(3983),l=n(5385),p=n(6488);function h(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function d(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?h(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):h(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function v(e,t,n){return y.apply(this,arguments)}function y(){return(y=(0,o.Z)(a().mark((function e(t,n,r){var o,i;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n){e.next=4;break}return e.next=3,t.tokenManager.getTokens();case 3:n=e.sent.accessToken;case 4:if(r){e.next=8;break}return e.next=7,t.tokenManager.getTokens();case 7:r=e.sent.idToken;case 8:if(n&&(0,p.hv)(n)){e.next=10;break}return e.abrupt("return",Promise.reject(new u.Z("getUserInfo requires an access token object")));case 10:if(r&&(0,p.sI)(r)){e.next=12;break}return e.abrupt("return",Promise.reject(new u.Z("getUserInfo requires an ID token object")));case 12:if(o={url:n.userinfoUrl,method:"GET",accessToken:n.accessToken},!t.options.dpop){e.next=19;break}return e.next=16,t.getDPoPAuthorizationHeaders(d(d({},o),{},{accessToken:n}));case 16:i=e.sent,o.headers=i,delete o.accessToken;case 19:return e.abrupt("return",(0,l.c3)(t,o).then((function(e){return e.sub===r.claims.sub?e:Promise.reject(new u.Z("getUserInfo request was rejected due to token mismatch"))})).catch((function(e){if(e instanceof c.Z&&!t.options.dpop){var n=e.error,r=e.errorDescription;throw new s.Z(n,r)}if(!t.options.dpop){var o,i=e;if(e instanceof f.Z&&null!=e&&null!==(o=e.meta)&&void 0!==o&&o.wwwAuthHeader&&(i=c.Z.parseHeader(e.meta.wwwAuthHeader)),i instanceof c.Z){var a=i,u=a.error,l=a.errorDescription;throw new s.Z(u,l)}}throw e})));case 20:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},9770:function(e,t,n){"use strict";n.d(t,{d:function(){return u}});var r=n(9123),o=n(3193),i=n(3253),a=n(4970);function u(e,t){if(arguments.length>2)return Promise.reject(new r.Z('As of version 3.0, "getWithPopup" takes only a single set of options'));var n=(0,a.pU)("/",t);return t=(0,o.d9)(t)||{},Object.assign(t,{display:"popup",responseMode:"okta_post_message",popupWindow:n}),(0,i.L)(e,t)}},6803:function(e,t,n){"use strict";n.d(t,{H:function(){return l}});var r=n(5861),o=n(4687),i=n.n(o),a=n(9123),u=n(3193),c=n(6898),s=n(2865),f=n(2206);function l(e,t){return p.apply(this,arguments)}function p(){return p=(0,r.Z)(i().mark((function e(t,n){var r,o,l,p=arguments;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!(p.length>2)){e.next=2;break}return e.abrupt("return",Promise.reject(new a.Z('As of version 3.0, "getWithRedirect" takes only a single set of options')));case 2:return n=(0,u.d9)(n)||{},e.next=5,(0,c.wu)(t,n);case 5:r=e.sent,o=(0,s.H)(t,r),l=o.urls.authorizeUrl+(0,f.R)(r),t.transactionManager.save(o),t.options.setLocation?t.options.setLocation(l):window.location.assign(l);case 10:case"end":return e.stop()}}),e)}))),p.apply(this,arguments)}},7625:function(e,t,n){"use strict";n.d(t,{y:function(){return a}});var r=n(9123),o=n(3193),i=n(3253);function a(e,t){return arguments.length>2?Promise.reject(new r.Z('As of version 3.0, "getWithoutPrompt" takes only a single set of options')):(t=(0,o.d9)(t)||{},Object.assign(t,{prompt:"none",responseMode:"okta_post_message",display:null}),(0,i.L)(e,t))}},8676:function(e,t,n){"use strict";n.d(t,{s:function(){return h}});var r=n(5861),o=n(4687),i=n.n(o),a=n(3193),u=n(7599),c=n(2886),s=n(9123),f=n(1260),l=n(7756);function p(e,t){if(e.error&&e.error_description)throw new c.Z(e.error,e.error_description);if(e.state!==t.state)throw new s.Z("OAuth flow response state doesn't match request state");if(t.dpop&&"DPoP"!==e.token_type)throw new s.Z('Unable to parse OAuth flow response: DPoP was configured but "token_type" was not DPoP')}function h(e,t,n,r){return d.apply(this,arguments)}function d(){return(d=(0,r.Z)(i().mark((function e(t,n,r,o){var c,h,d,v,y,g,m,b,k,w,O,Z,T,E;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!1===t.options.pkce||!r.code&&!r.interaction_code){e.next=3;break}return e.abrupt("return",t.token.exchangeCodeForTokens(Object.assign({},n,{authorizationCode:r.code,interactionCode:r.interaction_code}),o));case 3:if(n=n||(0,l.D)(t),o=o||(0,u.Fc)(t,n),c=n.responseType||[],Array.isArray(c)||"none"===c||(c=[c]),h=r.scope?r.scope.split(" "):(0,a.d9)(n.scopes),d=n.clientId||t.options.clientId,p(r,n),v={},y=r.expires_in,g=r.token_type,m=r.access_token,b=r.id_token,k=r.refresh_token,w=Math.floor(Date.now()/1e3),m&&(O=t.token.decode(m),v.accessToken={accessToken:m,claims:O.payload,expiresAt:Number(y)+w,tokenType:g,scopes:h,authorizeUrl:o.authorizeUrl,userinfoUrl:o.userinfoUrl},n.dpopPairId&&(v.accessToken.dpopPairId=n.dpopPairId)),k&&(v.refreshToken={refreshToken:k,expiresAt:Number(y)+w,scopes:h,tokenUrl:o.tokenUrl,authorizeUrl:o.authorizeUrl,issuer:o.issuer},n.dpopPairId&&(v.refreshToken.dpopPairId=n.dpopPairId)),!b){e.next=27;break}return Z=t.token.decode(b),T={idToken:b,claims:Z.payload,expiresAt:Z.payload.exp-Z.payload.iat+w,scopes:h,authorizeUrl:o.authorizeUrl,issuer:o.issuer,clientId:d},E={clientId:d,issuer:o.issuer,nonce:n.nonce,accessToken:m,acrValues:n.acrValues},void 0!==n.ignoreSignature&&(E.ignoreSignature=n.ignoreSignature),e.next=26,(0,f.W)(t,T,E);case 26:v.idToken=T;case 27:if(-1===c.indexOf("token")||v.accessToken){e.next=29;break}throw new s.Z('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');case 29:if(-1===c.indexOf("id_token")||v.idToken){e.next=31;break}throw new s.Z('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');case 31:return e.abrupt("return",{tokens:v,state:r.state,code:r.code,responseType:c});case 32:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},9443:function(e,t,n){"use strict";n.r(t),n.d(t,{TokenManager:function(){return l.M},addListener:function(){return h.NH},addPostMessageListener:function(){return h.iC},assertPKCESupport:function(){return h.vz},buildAuthorizeParams:function(){return a.R0},convertTokenParamsToOAuthParams:function(){return a._6},createEndpoints:function(){return r.$V},createEnrollAuthenticatorMeta:function(){return h.AW},createOAuthMeta:function(){return h.H},createOAuthOptionsConstructor:function(){return u.m},createOAuthStorageManager:function(){return i.a},createOktaAuthOAuth:function(){return r.zr},createTokenAPI:function(){return r.o5},createTransactionManager:function(){return p.P},decodeToken:function(){return d.T},exchangeCodeForTokens:function(){return O.r},generateNonce:function(){return h.PY},generateState:function(){return h.aV},getDefaultEnrollAuthenticatorParams:function(){return h.cE},getDefaultTokenParams:function(){return h.Dx},getHashOrSearch:function(){return h.O2},getKey:function(){return a.km},getOAuthBaseUrl:function(){return h.zf},getOAuthDomain:function(){return h.Xp},getOAuthUrls:function(){return h.Fc},getToken:function(){return Z.L},getUserInfo:function(){return k.b},getWellKnown:function(){return a.ES},getWithPopup:function(){return E.d},getWithRedirect:function(){return S.H},getWithoutPrompt:function(){return T.y},handleOAuthResponse:function(){return w.s},hasAuthorizationCode:function(){return h.ZP},hasErrorInUrl:function(){return h.hg},hasInteractionCode:function(){return h.d_},hasResponseType:function(){return h.wV},hasTokensInHash:function(){return h.kU},isAuthorizationCodeError:function(){return h.tC},isCodeFlow:function(){return h.Ik},isInteractionRequired:function(){return h.wc},isInteractionRequiredError:function(){return h.Cf},isLoginRedirect:function(){return h.gM},isRedirectUri:function(){return h.Qs},isRefreshTokenError:function(){return h.Yo},isRefreshTokenInvalidError:function(){return h.$E},isSameRefreshToken:function(){return h.q0},loadFrame:function(){return h.Rl},loadPopup:function(){return h.pU},mixinOAuth:function(){return o.J},oidcIntrospect:function(){return x.j},parseFromUrl:function(){return P.ko},pkce:function(){return h.U5},postRefreshToken:function(){return a.Dp},postToTokenEndpoint:function(){return a.ti},prepareEnrollAuthenticatorParams:function(){return h.Uc},preparePKCE:function(){return h.mi},prepareTokenParams:function(){return h.wu},removeListener:function(){return h.ys},renewToken:function(){return y.$},renewTokens:function(){return m.I},renewTokensWithRefresh:function(){return g.R},revokeToken:function(){return v.P},urlParamsToObject:function(){return h.vL},validateClaims:function(){return h.pj},validateCodeChallengeMethod:function(){return h.br},validateToken:function(){return h.Rp},verifyToken:function(){return b.W}});var r=n(231),o=n(2724),i=n(2333),a=n(2642),u=n(3775),c=n(8927),s={};for(var f in c)["default","decodeToken","revokeToken","renewToken","renewTokensWithRefresh","renewTokens","verifyToken","getUserInfo","handleOAuthResponse","exchangeCodeForTokens","getToken","getWithoutPrompt","getWithPopup","getWithRedirect","parseFromUrl","oidcIntrospect","createEndpoints","createOktaAuthOAuth","createTokenAPI","mixinOAuth","createOAuthStorageManager","buildAuthorizeParams","convertTokenParamsToOAuthParams","getKey","getWellKnown","postRefreshToken","postToTokenEndpoint","createOAuthOptionsConstructor"].indexOf(f)<0&&(s[f]=function(e){return c[e]}.bind(0,f));n.d(t,s);var l=n(2427),p=n(1646),h=n(8785),d=n(1237),v=n(6466),y=n(2476),g=n(781),m=n(6268),b=n(1260),k=n(6844),w=n(8676),O=n(8707),Z=n(3253),T=n(7625),E=n(9770),S=n(6803),P=n(5372),x=n(8113)},8113:function(e,t,n){"use strict";n.d(t,{j:function(){return h}});var r=n(5861),o=n(4687),i=n.n(o),a=n(9123),u=n(52),c=n(5385),s=n(6718),f=n(7594),l=n(6488),p={accessToken:"access_token",idToken:"id_token",refreshToken:"refresh_token"};function h(e,t,n){return d.apply(this,arguments)}function d(){return(d=(0,r.Z)(i().mark((function e(t,n,r){var o,h,d,v,y,g,m,b,k,w;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(h=t.options.clientId,d=t.options.clientSecret,r||(r=t.tokenManager.getTokens()[n]),r){e.next=5;break}throw new a.Z("unable to find ".concat(n," in storage or fn params"));case 5:if(o=(o=n!==l.T6.ACCESS?null===(v=r)||void 0===v?void 0:v.issuer:null===(y=r)||void 0===y||null===(g=y.claims)||void 0===g?void 0:g.iss)||t.options.issuer,h){e.next=9;break}throw new a.Z("A clientId must be specified in the OktaAuth constructor to introspect a token");case 9:if(o){e.next=11;break}throw new a.Z("Unable to find issuer");case 11:return e.next=13,(0,u.E)(t,o);case 13:return m=e.sent,b=m.introspection_endpoint,k=d?(0,f.r3)("".concat(h,":").concat(d)):(0,f.r3)(h),w=(0,s.UK)({token_type_hint:p[n],token:r[n]}).slice(1),e.abrupt("return",(0,c.v_)(t,b,w,{headers:{"Content-Type":"application/x-www-form-urlencoded",Authorization:"Basic "+k}}));case 18:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},2724:function(e,t,n){"use strict";n.d(t,{J:function(){return j}});var r=n(4925),o=n(5861),i=n(5671),a=n(3144),u=n(7326),c=n(1752),s=n(136),f=n(2963),l=n(1120),p=n(4942),h=n(4687),d=n.n(h),v=n(5385),y=n(3548),g=n(4771),m=n(9718),b=n(3611),k=n(5324),w=n(2427),O=n(8221),Z=n(7599),T=n(7659),E=n(9123),S=n(3114),P=n(1971),x=n(4858);var A=["originalUri"];function _(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function R(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?_(Object(n),!0).forEach((function(t){(0,p.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):_(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function j(e,t){var n,h=function(e){(0,s.Z)(o,e);var t,n,r=(t=o,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,l.Z)(t);if(n){var o=(0,l.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,f.Z)(this,e)});function o(){return(0,i.Z)(this,o),r.apply(this,arguments)}return(0,a.Z)(o,[{key:"setOriginalUri",value:function(e,t){x.Z.getSessionStorage().setItem(P.REFERRER_PATH_STORAGE_KEY,e),(t=t||this.options.state)&&this.storageManager.getOriginalUriStorage().setItem(t,e)}},{key:"getOriginalUri",value:function(e){if(e=e||this.options.state){var t=this.storageManager.getOriginalUriStorage().getItem(e);if(t)return t}var n=x.Z.getSessionStorage();return n&&n.getItem(P.REFERRER_PATH_STORAGE_KEY)||void 0}},{key:"removeOriginalUri",value:function(e){if(x.Z.getSessionStorage().removeItem(P.REFERRER_PATH_STORAGE_KEY),e=e||this.options.state){var t=this.storageManager.getOriginalUriStorage();t.removeItem&&t.removeItem(e)}}}]),o}(e);return n=function(e){(0,s.Z)(F,e);var n,h,m,P,x,_,j,C,D,I,M,N,U,L=(N=F,U=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=(0,l.Z)(N);if(U){var n=(0,l.Z)(this).constructor;e=Reflect.construct(t,arguments,n)}else e=t.apply(this,arguments);return(0,f.Z)(this,e)});function F(){var e;(0,i.Z)(this,F);for(var n=arguments.length,r=new Array(n),o=0;o<n;o++)r[o]=arguments[o];return e=L.call.apply(L,[this].concat(r)),(0,p.Z)((0,u.Z)(e),"token",void 0),(0,p.Z)((0,u.Z)(e),"tokenManager",void 0),(0,p.Z)((0,u.Z)(e),"transactionManager",void 0),(0,p.Z)((0,u.Z)(e),"pkce",void 0),(0,p.Z)((0,u.Z)(e),"endpoints",void 0),(0,p.Z)((0,u.Z)(e),"_pending",void 0),(0,p.Z)((0,u.Z)(e),"_tokenQueue",void 0),e.transactionManager=new t(Object.assign({storageManager:e.storageManager},e.options.transactionManager)),e.pkce={DEFAULT_CODE_CHALLENGE_METHOD:b.Z.DEFAULT_CODE_CHALLENGE_METHOD,generateVerifier:b.Z.generateVerifier,computeChallenge:b.Z.computeChallenge},e._pending={handleLogin:!1},e._tokenQueue=new y.b,e.token=(0,k.o)((0,u.Z)(e),e._tokenQueue),e.tokenManager=new w.M((0,u.Z)(e),e.options.tokenManager),e.endpoints=(0,k.$)((0,u.Z)(e)),e}return(0,a.Z)(F,[{key:"clearStorage",value:function(){(0,c.Z)((0,l.Z)(F.prototype),"clearStorage",this).call(this),this.tokenManager.clear()}},{key:"isAuthenticated",value:(M=(0,o.Z)(d().mark((function e(){var t,n,r,o,i,a,u,c,s,f,l=arguments;return d().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=l.length>0&&void 0!==l[0]?l[0]:{},n=this.tokenManager.getOptions(),r=n.autoRenew,o=n.autoRemove,i=t.onExpiredToken?"renew"===t.onExpiredToken:r,a=t.onExpiredToken?"remove"===t.onExpiredToken:o,u=this.tokenManager.getTokensSync(),!(c=u.accessToken)||!this.tokenManager.hasExpired(c)){e.next=19;break}if(c=void 0,!i){e.next=18;break}return e.prev=8,e.next=11,this.tokenManager.renew("accessToken");case 11:c=e.sent,e.next=16;break;case 14:e.prev=14,e.t0=e.catch(8);case 16:e.next=19;break;case 18:a&&this.tokenManager.remove("accessToken");case 19:if(s=this.tokenManager.getTokensSync(),!(f=s.idToken)||!this.tokenManager.hasExpired(f)){e.next=34;break}if(f=void 0,!i){e.next=33;break}return e.prev=23,e.next=26,this.tokenManager.renew("idToken");case 26:f=e.sent,e.next=31;break;case 29:e.prev=29,e.t1=e.catch(23);case 31:e.next=34;break;case 33:a&&this.tokenManager.remove("idToken");case 34:return e.abrupt("return",!(!c||!f));case 35:case"end":return e.stop()}}),e,this,[[8,14],[23,29]])}))),function(){return M.apply(this,arguments)})},{key:"signInWithRedirect",value:(I=(0,o.Z)(d().mark((function e(){var t,n,o,i,a=arguments;return d().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=(t=a.length>0&&void 0!==a[0]?a[0]:{}).originalUri,o=(0,r.Z)(t,A),!this._pending.handleLogin){e.next=4;break}return e.abrupt("return");case 4:return this._pending.handleLogin=!0,e.prev=5,n&&this.setOriginalUri(n),i=Object.assign({scopes:this.options.scopes||["openid","email","profile"]},o),e.next=10,this.token.getWithRedirect(i);case 10:return e.prev=10,this._pending.handleLogin=!1,e.finish(10);case 13:case"end":return e.stop()}}),e,this,[[5,,10,13]])}))),function(){return I.apply(this,arguments)})},{key:"getUser",value:(D=(0,o.Z)(d().mark((function e(){var t,n,r;return d().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t=this.tokenManager.getTokensSync(),n=t.idToken,r=t.accessToken,e.abrupt("return",this.token.getUserInfo(r,n));case 2:case"end":return e.stop()}}),e,this)}))),function(){return D.apply(this,arguments)})},{key:"getIdToken",value:function(){var e=this.tokenManager.getTokensSync().idToken;return e?e.idToken:void 0}},{key:"getAccessToken",value:function(){var e=this.tokenManager.getTokensSync().accessToken;return e?e.accessToken:void 0}},{key:"getRefreshToken",value:function(){var e=this.tokenManager.getTokensSync().refreshToken;return e?e.refreshToken:void 0}},{key:"getOrRenewAccessToken",value:(C=(0,o.Z)(d().mark((function e(){var t,n,r,o,i;return d().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=this.tokenManager.getTokensSync(),!(n=t.accessToken)||this.tokenManager.hasExpired(n)){e.next=3;break}return e.abrupt("return",n.accessToken);case 3:return e.prev=3,o=this.tokenManager.getStorageKeyByType("accessToken"),e.next=7,this.tokenManager.renew(null!=o?o:"accessToken");case 7:return i=e.sent,e.abrupt("return",null!==(r=null==i?void 0:i.accessToken)&&void 0!==r?r:null);case 11:return e.prev=11,e.t0=e.catch(3),this.emitter.emit("error",e.t0),e.abrupt("return",null);case 15:case"end":return e.stop()}}),e,this,[[3,11]])}))),function(){return C.apply(this,arguments)})},{key:"storeTokensFromRedirect",value:(j=(0,o.Z)(d().mark((function e(){var t,n;return d().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.token.parseFromUrl();case 2:t=e.sent,n=t.tokens,"none"!==t.responseType&&this.tokenManager.setTokens(n);case 6:case"end":return e.stop()}}),e,this)}))),function(){return j.apply(this,arguments)})},{key:"isLoginRedirect",value:function(){return(0,O.gM)(this)}},{key:"isPKCE",value:function(){return!!this.options.pkce}},{key:"hasResponseType",value:function(e){return(0,O.wV)(e,this.options)}},{key:"isAuthorizationCodeFlow",value:function(){return this.hasResponseType("code")}},{key:"invokeApiMethod",value:(_=(0,o.Z)(d().mark((function e(t){var n;return d().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t.accessToken){e.next=5;break}return e.next=3,this.tokenManager.getTokens();case 3:n=e.sent.accessToken,t.accessToken=null==n?void 0:n.accessToken;case 5:return e.abrupt("return",(0,v.c3)(this,t));case 6:case"end":return e.stop()}}),e,this)}))),function(e){return _.apply(this,arguments)})},{key:"revokeAccessToken",value:(x=(0,o.Z)(d().mark((function e(t){var n,r;return d().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t){e.next=10;break}return e.next=3,this.tokenManager.getTokens();case 3:if(n=e.sent,t=n.accessToken,r=this.tokenManager.getStorageKeyByType("accessToken"),this.tokenManager.remove(r),!this.options.dpop){e.next=10;break}return e.next=10,(0,T.ao)("access",n);case 10:if(t){e.next=12;break}return e.abrupt("return",Promise.resolve(null));case 12:return e.abrupt("return",this.token.revoke(t));case 13:case"end":return e.stop()}}),e,this)}))),function(e){return x.apply(this,arguments)})},{key:"revokeRefreshToken",value:(P=(0,o.Z)(d().mark((function e(t){var n,r;return d().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t){e.next=10;break}return e.next=3,this.tokenManager.getTokens();case 3:if(n=e.sent,t=n.refreshToken,r=this.tokenManager.getStorageKeyByType("refreshToken"),this.tokenManager.remove(r),!this.options.dpop){e.next=10;break}return e.next=10,(0,T.ao)("refresh",n);case 10:if(t){e.next=12;break}return e.abrupt("return",Promise.resolve(null));case 12:return e.abrupt("return",this.token.revoke(t));case 13:case"end":return e.stop()}}),e,this)}))),function(e){return P.apply(this,arguments)})},{key:"getSignOutRedirectUrl",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.idToken,n=e.postLogoutRedirectUri,r=e.state;if(t||(t=this.tokenManager.getTokensSync().idToken),!t)return"";void 0===n&&(n=this.options.postLogoutRedirectUri);var o=(0,Z.Fc)(this).logoutUrl,i=t.idToken,a=o+"?id_token_hint="+encodeURIComponent(i);return n&&(a+="&post_logout_redirect_uri="+encodeURIComponent(n)),r&&(a+="&state="+encodeURIComponent(r)),a}},{key:"signOut",value:(m=(0,o.Z)(d().mark((function e(t){var n,r,o,i,a,u,c,s,f,l,p,h,v,y,g,m;return d().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=Object.assign({},t),a=window.location.origin,u=window.location.href,c=null===t.postLogoutRedirectUri?null:t.postLogoutRedirectUri||this.options.postLogoutRedirectUri||a,s=null===(n=t)||void 0===n?void 0:n.state,f=t.accessToken,l=t.refreshToken,p=!1!==t.revokeAccessToken,(h=!1!==t.revokeRefreshToken)&&void 0===l&&(l=this.tokenManager.getTokensSync().refreshToken),p&&void 0===f&&(f=this.tokenManager.getTokensSync().accessToken),t.idToken||(t.idToken=this.tokenManager.getTokensSync().idToken),!h||!l){e.next=15;break}return e.next=15,this.revokeRefreshToken(l);case 15:if(!p||!f){e.next=18;break}return e.next=18,this.revokeAccessToken(f);case 18:if(v=null!==(r=null===(o=f)||void 0===o?void 0:o.dpopPairId)&&void 0!==r?r:null===(i=l)||void 0===i?void 0:i.dpopPairId,!this.options.dpop||!v){e.next=22;break}return e.next=22,(0,T.sd)(v);case 22:if(y=this.getSignOutRedirectUrl(R(R({},t),{},{postLogoutRedirectUri:c}))){e.next=33;break}return e.next=26,this.closeSession();case 26:return g=e.sent,m=new URL(c||a),s&&m.searchParams.append("state",s),c===u?window.location.href=m.href:window.location.assign(m.href),e.abrupt("return",g);case 33:return t.clearTokensBeforeRedirect?this.tokenManager.clear():this.tokenManager.addPendingRemoveFlags(),window.location.assign(y),e.abrupt("return",!0);case 36:case"end":return e.stop()}}),e,this)}))),function(e){return m.apply(this,arguments)})},{key:"getDPoPAuthorizationHeaders",value:(h=(0,o.Z)(d().mark((function e(t){var n,r,o,i;return d().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(this.options.dpop){e.next=2;break}throw new E.Z("DPoP is not configured for this client instance");case 2:if((r=t.accessToken)||(r=this.tokenManager.getTokensSync().accessToken),r){e.next=6;break}throw new E.Z("AccessToken is required to generate a DPoP Proof");case 6:return e.next=8,(0,T.lk)(null===(n=r)||void 0===n?void 0:n.dpopPairId);case 8:return o=e.sent,e.next=11,(0,T.aW)(R(R({},t),{},{keyPair:o,accessToken:r.accessToken}));case 11:return i=e.sent,e.abrupt("return",{Authorization:"DPoP ".concat(r.accessToken),Dpop:i});case 13:case"end":return e.stop()}}),e,this)}))),function(e){return h.apply(this,arguments)})},{key:"clearDPoPStorage",value:(n=(0,o.Z)(d().mark((function e(){var t,n,r,o,i=arguments;return d().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!(i.length>0&&void 0!==i[0]&&i[0])){e.next=3;break}return e.abrupt("return",(0,T.V7)());case 3:return e.next=5,this.tokenManager.getTokens();case 5:if(r=e.sent,!(o=(null===(t=r.accessToken)||void 0===t?void 0:t.dpopPairId)||(null===(n=r.refreshToken)||void 0===n?void 0:n.dpopPairId))){e.next=10;break}return e.next=10,(0,T.sd)(o);case 10:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"parseUseDPoPNonceError",value:function(e){var t=S.Z.getWWWAuthenticateHeader(e),n=S.Z.parseHeader(null!=t?t:"");if((0,T.SO)(n)){var r,o,i=null;return(0,g.mf)(null==e?void 0:e.get)&&(i=e.get("DPoP-Nonce")),null!==(r=null!==(o=i)&&void 0!==o?o:e["dpop-nonce"])&&void 0!==r?r:e["DPoP-Nonce"]}return null}}]),F}(h),(0,p.Z)(n,"crypto",m),n}},9453:function(e,t,n){"use strict";n.d(t,{m:function(){return g}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),u=n(2963),c=n(1120),s=n(4942),f=n(1971),l=n(6718),p=n(415),h=n(8817),d=!0,v=n(9123);function y(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function g(){return function(e){(0,a.Z)(g,e);var t,n,h=(t=g,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function g(e){var t;return(0,o.Z)(this,g),t=h.call(this,e),(0,s.Z)((0,i.Z)(t),"issuer",void 0),(0,s.Z)((0,i.Z)(t),"authorizeUrl",void 0),(0,s.Z)((0,i.Z)(t),"userinfoUrl",void 0),(0,s.Z)((0,i.Z)(t),"tokenUrl",void 0),(0,s.Z)((0,i.Z)(t),"revokeUrl",void 0),(0,s.Z)((0,i.Z)(t),"logoutUrl",void 0),(0,s.Z)((0,i.Z)(t),"pkce",void 0),(0,s.Z)((0,i.Z)(t),"clientId",void 0),(0,s.Z)((0,i.Z)(t),"redirectUri",void 0),(0,s.Z)((0,i.Z)(t),"responseType",void 0),(0,s.Z)((0,i.Z)(t),"responseMode",void 0),(0,s.Z)((0,i.Z)(t),"state",void 0),(0,s.Z)((0,i.Z)(t),"scopes",void 0),(0,s.Z)((0,i.Z)(t),"ignoreSignature",void 0),(0,s.Z)((0,i.Z)(t),"codeChallenge",void 0),(0,s.Z)((0,i.Z)(t),"codeChallengeMethod",void 0),(0,s.Z)((0,i.Z)(t),"acrValues",void 0),(0,s.Z)((0,i.Z)(t),"maxAge",void 0),(0,s.Z)((0,i.Z)(t),"dpop",void 0),(0,s.Z)((0,i.Z)(t),"tokenManager",void 0),(0,s.Z)((0,i.Z)(t),"postLogoutRedirectUri",void 0),(0,s.Z)((0,i.Z)(t),"restoreOriginalUri",void 0),(0,s.Z)((0,i.Z)(t),"transactionManager",void 0),(0,s.Z)((0,i.Z)(t),"clientSecret",void 0),(0,s.Z)((0,i.Z)(t),"setLocation",void 0),(0,s.Z)((0,i.Z)(t),"ignoreLifetime",void 0),(0,s.Z)((0,i.Z)(t),"maxClockSkew",void 0),function(e){var t=(e=e||{}).scopes;if(t&&!Array.isArray(t))throw new v.Z('scopes must be a array of strings. Required usage: new OktaAuth({scopes: ["openid", "email"]})');var n=e.issuer;if(!n)throw new v.Z('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');if(!new RegExp("^http?s?://.+").test(n))throw new v.Z('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');if(-1!==n.indexOf("-admin.okta"))throw new v.Z('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})')}(e),t.issuer=(0,l.Qj)(e.issuer),t.tokenUrl=(0,l.Qj)(e.tokenUrl),t.authorizeUrl=(0,l.Qj)(e.authorizeUrl),t.userinfoUrl=(0,l.Qj)(e.userinfoUrl),t.revokeUrl=(0,l.Qj)(e.revokeUrl),t.logoutUrl=(0,l.Qj)(e.logoutUrl),t.pkce=!1!==e.pkce,t.clientId=e.clientId,t.redirectUri=e.redirectUri,(0,p.isBrowser)()&&(t.redirectUri=(0,l.BY)(e.redirectUri,window.location.origin)),t.responseType=e.responseType,t.responseMode=e.responseMode,t.state=e.state,t.scopes=e.scopes,t.ignoreSignature=!!e.ignoreSignature,t.codeChallenge=e.codeChallenge,t.codeChallengeMethod=e.codeChallengeMethod,t.acrValues=e.acrValues,t.maxAge=e.maxAge,t.dpop=!0===e.dpop,t.tokenManager=e.tokenManager,t.postLogoutRedirectUri=e.postLogoutRedirectUri,t.restoreOriginalUri=e.restoreOriginalUri,t.transactionManager=function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?y(Object(n),!0).forEach((function(t){(0,s.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):y(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({enableSharedStorage:d},e.transactionManager),t.clientSecret=e.clientSecret,t.setLocation=e.setLocation,t.ignoreLifetime=!!e.ignoreLifetime,e.maxClockSkew||0===e.maxClockSkew?t.maxClockSkew=e.maxClockSkew:t.maxClockSkew=f.DEFAULT_MAX_CLOCK_SKEW,t}return(0,r.Z)(g)}((0,h.Z)())}},3775:function(e,t,n){"use strict";n.d(t,{m:function(){return r.m}});var r=n(9453)},5372:function(e,t,n){"use strict";n.d(t,{Tp:function(){return p},ko:function(){return d}});var r=n(5861),o=n(4687),i=n.n(o),a=n(9123),u=n(1969),c=n(9912),s=n(4771),f=n(8676);function l(e){var t=e.options.pkce?"query":"fragment";return e.options.responseMode||t}function p(e,t){t=t||{},(0,s.HD)(t)&&(t={url:t});var n,r=t.url,o=t.responseMode||l(e),i=e.token.parseFromUrl._getLocation();if(!(n="query"===o?r?r.substring(r.indexOf("?")):i.search:r?r.substring(r.indexOf("#")):i.hash))throw new a.Z("Unable to parse a token from the url");return(0,u.v)(n)}function h(e,t){"query"===(t.responseMode||l(e))?function(e){var t=e.token.parseFromUrl._getHistory(),n=e.token.parseFromUrl._getDocument(),r=e.token.parseFromUrl._getLocation();t&&t.replaceState?t.replaceState(null,n.title,r.pathname+r.hash):r.search=""}(e):function(e){var t=e.token.parseFromUrl._getHistory(),n=e.token.parseFromUrl._getDocument(),r=e.token.parseFromUrl._getLocation();t&&t.replaceState?t.replaceState(null,n.title,r.pathname+r.search):r.hash=""}(e)}function d(e,t){return v.apply(this,arguments)}function v(){return(v=(0,r.Z)(i().mark((function e(t,n){var r,o,u,l;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=n||{},(0,s.HD)(n)&&(n={url:n}),r=p(t,n),o=r.state,u=t.transactionManager.load({state:o})){e.next=9;break}if(!t.options.pkce){e.next=8;break}throw new a.Z("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.",void 0);case 8:throw new a.Z("Unable to retrieve OAuth redirect params from storage");case 9:return l=u.urls,delete u.urls,n.url||h(t,n),e.abrupt("return",(0,f.s)(t,u,r,l).catch((function(e){throw(0,c.Cf)(e)||t.transactionManager.clear({state:o}),e})).then((function(e){return t.transactionManager.clear({state:o}),e})));case 13:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},2476:function(e,t,n){"use strict";n.d(t,{$:function(){return p}});var r=n(5861),o=n(4687),i=n.n(o),a=n(9123),u=n(6488),c=n(7625),s=n(781);function f(){throw new a.Z("Renew must be passed a token with an array of scopes and an accessToken or idToken")}function l(e,t){return(0,u.sI)(e)?t.idToken:(0,u.hv)(e)?t.accessToken:void f()}function p(e,t){return h.apply(this,arguments)}function h(){return(h=(0,r.Z)(i().mark((function e(t,n){var r,o,a,p,h,d,v,y;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if((0,u.sI)(n)||(0,u.hv)(n)||f(),!(r=t.tokenManager.getTokensSync()).refreshToken){e.next=7;break}return e.next=5,(0,s.R)(t,{scopes:n.scopes},r.refreshToken);case 5:return r=e.sent,e.abrupt("return",l(n,r));case 7:return o=t.options.pkce?"code":(0,u.hv)(n)?"token":"id_token",p=(a=n).scopes,h=a.authorizeUrl,d=a.userinfoUrl,v=a.issuer,y=a.dpopPairId,e.abrupt("return",(0,c.y)(t,{responseType:o,scopes:p,authorizeUrl:h,userinfoUrl:d,issuer:v,dpopPairId:y}).then((function(e){return l(n,e.tokens)})));case 10:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},6268:function(e,t,n){"use strict";n.d(t,{I:function(){return f}});var r=n(5861),o=n(4687),i=n.n(o),a=n(9123),u=n(7625),c=n(781),s=n(7756);function f(e,t){return l.apply(this,arguments)}function l(){return(l=(0,r.Z)(i().mark((function e(t,n){var r,o,f,l,p,h,d,v,y,g,m,b;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!(f=null!==(r=null===(o=n)||void 0===o?void 0:o.tokens)&&void 0!==r?r:t.tokenManager.getTokensSync()).refreshToken){e.next=3;break}return e.abrupt("return",(0,c.R)(t,n||{},f.refreshToken));case 3:if(f.accessToken||f.idToken){e.next=5;break}throw new a.Z("renewTokens() was called but there is no existing token");case 5:if(l=f.accessToken||{},p=f.idToken||{},h=l.scopes||p.scopes){e.next=10;break}throw new a.Z("renewTokens: invalid tokens: could not read scopes");case 10:if(d=l.authorizeUrl||p.authorizeUrl){e.next=13;break}throw new a.Z("renewTokens: invalid tokens: could not read authorizeUrl");case 13:return v=l.userinfoUrl||t.options.userinfoUrl,y=p.issuer||t.options.issuer,g=null==l?void 0:l.dpopPairId,n=Object.assign({scopes:h,authorizeUrl:d,userinfoUrl:v,issuer:y,dpopPairId:g},n),t.options.pkce?n.responseType="code":(m=(0,s.D)(t),b=m.responseType,n.responseType=b),e.abrupt("return",(0,u.y)(t,n).then((function(e){return e.tokens})));case 19:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},781:function(e,t,n){"use strict";n.d(t,{R:function(){return y}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),u=n(9123),c=n(7599),s=n(6635),f=n(8676),l=n(9231),p=n(7659),h=n(9912);function d(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function v(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?d(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):d(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function y(e,t,n){return g.apply(this,arguments)}function g(){return(g=(0,o.Z)(a().mark((function e(t,n,r){var o,i,d,y,g,m,b,k,w,O,Z;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(o=t.options,i=o.clientId,d=o.dpop,i){e.next=3;break}throw new u.Z("A clientId must be specified in the OktaAuth constructor to renew tokens");case 3:if(e.prev=3,y=Object.assign({},n,{clientId:i}),g=v({},y),!d){e.next=13;break}return e.next=9,(0,p.lk)(null==r?void 0:r.dpopPairId);case 9:m=e.sent,g.dpopKeyPair=m,y.dpop=d,y.dpopPairId=r.dpopPairId;case 13:return e.next=15,(0,l.D)(t,g,r);case 15:return b=e.sent,k=(0,c.Fc)(t,n),e.next=19,(0,f.s)(t,y,b,k);case 19:return w=e.sent,O=w.tokens,(Z=O.refreshToken)&&!(0,s.q)(Z,r)&&t.tokenManager.updateRefreshToken(Z),e.abrupt("return",O);case 26:throw e.prev=26,e.t0=e.catch(3),(0,h.$E)(e.t0)&&t.tokenManager.removeRefreshToken(),e.t0;case 30:case"end":return e.stop()}}),e,null,[[3,26]])})))).apply(this,arguments)}},6466:function(e,t,n){"use strict";n.d(t,{P:function(){return l}});var r=n(5861),o=n(4687),i=n.n(o),a=n(5385),u=n(6718),c=n(7599),s=n(7594),f=n(9123);function l(e,t){return p.apply(this,arguments)}function p(){return(p=(0,r.Z)(i().mark((function e(t,n){var r,o,l,p,h,d,v;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r="",o="",n&&(r=n.accessToken,o=n.refreshToken),r||o){e.next=5;break}throw new f.Z("A valid access or refresh token object is required");case 5:if(l=t.options.clientId,p=t.options.clientSecret,l){e.next=9;break}throw new f.Z("A clientId must be specified in the OktaAuth constructor to revoke a token");case 9:return h=(0,c.Fc)(t).revokeUrl,d=(0,u.UK)({token_type_hint:o?"refresh_token":"access_token",token:o||r}).slice(1),v=p?(0,s.r3)("".concat(l,":").concat(p)):(0,s.r3)(l),e.abrupt("return",(0,a.v_)(t,h,d,{headers:{"Content-Type":"application/x-www-form-urlencoded",Authorization:"Basic "+v}}));case 13:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},2333:function(e,t,n){"use strict";n.d(t,{a:function(){return l}});var r=n(5671),o=n(3144),i=n(136),a=n(2963),u=n(1120),c=n(5437),s=n(5763),f=n(1971);function l(){return function(e){(0,i.Z)(p,e);var t,n,l=(t=p,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,u.Z)(t);if(n){var o=(0,u.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,a.Z)(this,e)});function p(e,t,n){return(0,r.Z)(this,p),l.call(this,e,t,n)}return(0,o.Z)(p,[{key:"getTransactionStorage",value:function(e){e=this.getOptionsForSection("transaction",e),(0,c.V)(e);var t=this.getStorage(e),n=e.storageKey||f.TRANSACTION_STORAGE_NAME;return new s._(t,n)}},{key:"getSharedTansactionStorage",value:function(e){e=this.getOptionsForSection("shared-transaction",e),(0,c.V)(e);var t=this.getStorage(e),n=e.storageKey||f.SHARED_TRANSACTION_STORAGE_NAME;return new s._(t,n)}},{key:"getOriginalUriStorage",value:function(e){e=this.getOptionsForSection("original-uri",e),(0,c.V)(e);var t=this.getStorage(e),n=e.storageKey||f.ORIGINAL_URI_STORAGE_NAME;return new s._(t,n)}}]),p}(c.W)}},6488:function(e,t,n){"use strict";var r;function o(e){return!!(e&&(e.accessToken||e.idToken||e.refreshToken)&&Array.isArray(e.scopes))}function i(e){return e&&e.accessToken}function a(e){return e&&e.idToken}function u(e){return e&&e.refreshToken}n.d(t,{T6:function(){return r},hD:function(){return o},hv:function(){return i},sI:function(){return a},z9:function(){return u}}),function(e){e.ACCESS="accessToken",e.ID="idToken",e.REFRESH="refreshToken"}(r||(r={}))},7088:function(e,t,n){"use strict";n.d(t,{$I:function(){return u},$Y:function(){return r},E:function(){return o},FT:function(){return a},O3:function(){return i},zr:function(){return c}});var r="expired",o="renewed",i="added",a="removed",u="error",c="set_storage"},4319:function(e,t,n){"use strict";n.d(t,{G5:function(){return i},ZT:function(){return a},mH:function(){return s},rZ:function(){return c},sG:function(){return u}});var r=n(1002);function o(e){return!(!e||"object"!==(0,r.Z)(e)||0===Object.values(e).length)}function i(e){return!(!o(e)||!e.redirectUri&&!e.responseType)}function a(e){return!!i(e)&&!!e.codeVerifier}function u(e){return!!a(e)&&!!e.interactionHandle}function c(e){return!!o(e)&&void 0===Object.values(e).find((function(e){return"string"!=typeof e}))}function s(e){return!(!i(e)&&!c(e))}},7615:function(){},8927:function(e,t,n){"use strict";n.r(t),n.d(t,{EVENT_ADDED:function(){return u.O3},EVENT_ERROR:function(){return u.$I},EVENT_EXPIRED:function(){return u.$Y},EVENT_REMOVED:function(){return u.FT},EVENT_RENEWED:function(){return u.E},EVENT_SET_STORAGE:function(){return u.zr},TokenKind:function(){return a.T6},isAccessToken:function(){return a.hv},isCustomAuthTransactionMeta:function(){return c.rZ},isIDToken:function(){return a.sI},isIdxTransactionMeta:function(){return c.sG},isOAuthTransactionMeta:function(){return c.G5},isPKCETransactionMeta:function(){return c.ZT},isRefreshToken:function(){return a.z9},isToken:function(){return a.hD},isTransactionMeta:function(){return c.mH}});var r=n(9263),o={};for(var i in r)"default"!==i&&(o[i]=function(e){return r[e]}.bind(0,i));n.d(t,o);var a=n(6488),u=n(7088),c=n(4319),s=n(7615);for(var i in o={},s)["default","TokenKind","isAccessToken","isIDToken","isRefreshToken","isToken","EVENT_ADDED","EVENT_ERROR","EVENT_EXPIRED","EVENT_REMOVED","EVENT_RENEWED","EVENT_SET_STORAGE","isCustomAuthTransactionMeta","isIdxTransactionMeta","isOAuthTransactionMeta","isPKCETransactionMeta","isTransactionMeta"].indexOf(i)<0&&(o[i]=function(e){return s[e]}.bind(0,i));n.d(t,o)},9263:function(){},4970:function(e,t,n){"use strict";n.d(t,{NH:function(){return o},Rl:function(){return a},iC:function(){return c},pU:function(){return u},ys:function(){return i}});var r=n(9123);function o(e,t,n){e.addEventListener?e.addEventListener(t,n):e.attachEvent("on"+t,n)}function i(e,t,n){e.removeEventListener?e.removeEventListener(t,n):e.detachEvent("on"+t,n)}function a(e){var t=document.createElement("iframe");return t.style.display="none",t.src=e,document.body.appendChild(t)}function u(e,t){var n=t.popupTitle||"External Identity Provider User Authentication";return window.open(e,n,"toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600")}function c(e,t,n){var a,u;return new Promise((function(i,c){a=function(t){if(t.data&&t.data.state===n)return t.origin!==e.getIssuerOrigin()?c(new r.Z("The request does not match client configuration")):void i(t.data)},o(window,"message",a),u=setTimeout((function(){c(new r.Z("OAuth flow timed out"))}),t||12e4)})).finally((function(){clearTimeout(u),i(window,"message",a)}))}},5078:function(e,t,n){"use strict";n.d(t,{c:function(){return a}});var r=n(7599),o=n(415),i=n(3193);function a(e){var t=e.options,n=t.clientId,a=t.redirectUri,u=t.responseMode,c=t.state,s=(0,o.isBrowser)()?window.location.href:void 0;return(0,i.YY)({clientId:n,redirectUri:a||s,responseMode:u,state:c||(0,r.aV)(),responseType:"none",prompt:"enroll_authenticator"})}},7756:function(e,t,n){"use strict";n.d(t,{D:function(){return a}});var r=n(7599),o=n(415),i=n(3193);function a(e){var t=e.options,n=t.pkce,a=t.clientId,u=t.redirectUri,c=t.responseType,s=t.responseMode,f=t.scopes,l=t.acrValues,p=t.maxAge,h=t.state,d=t.ignoreSignature,v=t.dpop,y=(0,o.isBrowser)()?window.location.href:void 0;return(0,i.YY)({pkce:n,clientId:a,redirectUri:u||y,responseType:c||["token","id_token"],responseMode:s,state:h||(0,r.aV)(),nonce:(0,r.NH)(),scopes:f||["openid","email"],acrValues:l,maxAge:p,ignoreSignature:d,dpop:v})}},8080:function(e,t,n){"use strict";n.d(t,{A:function(){return o}});var r=n(7599);function o(e,t){return{issuer:e.options.issuer,urls:(0,r.Fc)(e,t),clientId:t.clientId,redirectUri:t.redirectUri,responseType:t.responseType,responseMode:t.responseMode,state:t.state,acrValues:t.acrValues,enrollAmrValues:t.enrollAmrValues}}},9912:function(e,t,n){"use strict";n.d(t,{$E:function(){return a},Cf:function(){return o},tC:function(){return i}});var r=n(5728);function o(e){return"OAuthError"===e.name&&"interaction_required"===e.errorCode}function i(e,t){if("AuthApiError"!==t.name)return!1;var n=t.xhr,r=null==n?void 0:n.responseJSON;return e.options.pkce&&"invalid_grant"===(null==r?void 0:r.error)}function a(e){return(0,r.isOAuthError)(e)&&"invalid_grant"===e.errorCode&&"The refresh token is invalid or expired."===e.errorSummary}},8785:function(e,t,n){"use strict";n.d(t,{$E:function(){return a.$E},AW:function(){return f.A},Cf:function(){return a.Cf},Dx:function(){return o.D},Fc:function(){return c.Fc},H:function(){return s.H},Ik:function(){return u.Ik},NH:function(){return r.NH},O2:function(){return u.O2},PY:function(){return c.NH},Qs:function(){return u.Qs},Rl:function(){return r.Rl},Rp:function(){return g.R},U5:function(){return l.Z},Uc:function(){return h.U},Xp:function(){return c.Xp},Yo:function(){return d.Y},ZP:function(){return u.ZP},aV:function(){return c.aV},br:function(){return p.br},cE:function(){return i.c},d_:function(){return u.d_},gM:function(){return u.gM},hg:function(){return u.hg},iC:function(){return r.iC},kU:function(){return u.kU},mi:function(){return p.mi},pU:function(){return r.pU},pj:function(){return y.p},q0:function(){return d.q},tC:function(){return a.tC},vL:function(){return v.v},vz:function(){return p.vz},wV:function(){return u.wV},wc:function(){return u.wc},wu:function(){return p.wu},ys:function(){return r.ys},zf:function(){return c.zf}});var r=n(4970),o=n(7756),i=n(5078),a=n(9912),u=n(8221),c=n(7599),s=n(2865),f=n(8080),l=n(3611),p=n(6898),h=n(6757),d=n(6635),v=n(1969),y=n(6003),g=n(2482)},8221:function(e,t,n){"use strict";function r(e){return/((id|access)_token=)/i.test(e)}function o(e){return/(code=)/i.test(e)}function i(e){return/(interaction_code=)/i.test(e)}function a(e){return/(error=)/i.test(e)||/(error_description)/i.test(e)}function u(e,t){var n=t.options;return!(!e||!n.redirectUri)&&0===e.indexOf(n.redirectUri)}function c(e){return e.pkce||"code"===e.responseType||"query"===e.responseMode}function s(e,t){return Array.isArray(t.responseType)&&t.responseType.length?t.responseType.indexOf(e)>=0:t.responseType===e}function f(e){return c(e)&&"fragment"!==e.responseMode?window.location.search:window.location.hash}function l(e){if(!u(window.location.href,e))return!1;var t=c(e.options),n=f(e.options);return!!a(n)||(t?o(n)||i(n):r(window.location.hash))}function p(e,t){if(!t){if(!l(e))return!1;t=f(e.options)}return/(error=interaction_required)/i.test(t)}n.d(t,{Ik:function(){return c},O2:function(){return f},Qs:function(){return u},ZP:function(){return o},d_:function(){return i},gM:function(){return l},hg:function(){return a},kU:function(){return r},wV:function(){return s},wc:function(){return p}})},7599:function(e,t,n){"use strict";n.d(t,{Fc:function(){return l},NH:function(){return u},Xp:function(){return f},aV:function(){return a},zf:function(){return s}});var r=n(8750),o=n(6718),i=n(9123);function a(){return(0,r.uh)(64)}function u(){return(0,r.uh)(64)}function c(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return(0,o.Qj)(t.issuer)||e.options.issuer}function s(e){var t=c(e,arguments.length>1&&void 0!==arguments[1]?arguments[1]:{});return t.indexOf("/oauth2")>0?t:t+"/oauth2"}function f(e){return c(e,arguments.length>1&&void 0!==arguments[1]?arguments[1]:{}).split("/oauth2")[0]}function l(e,t){if(arguments.length>2)throw new i.Z('As of version 3.0, "getOAuthUrls" takes only a single set of options');t=t||{};var n=(0,o.Qj)(t.authorizeUrl)||e.options.authorizeUrl,r=c(e,t),a=(0,o.Qj)(t.userinfoUrl)||e.options.userinfoUrl,u=(0,o.Qj)(t.tokenUrl)||e.options.tokenUrl,f=(0,o.Qj)(t.logoutUrl)||e.options.logoutUrl,l=(0,o.Qj)(t.revokeUrl)||e.options.revokeUrl,p=s(e,t);return{issuer:r,authorizeUrl:n=n||p+"/v1/authorize",userinfoUrl:a=a||p+"/v1/userinfo",tokenUrl:u=u||p+"/v1/token",revokeUrl:l=l||p+"/v1/revoke",logoutUrl:f=f||p+"/v1/logout"}}},2865:function(e,t,n){"use strict";n.d(t,{H:function(){return u}});var r=n(4942),o=n(7599);function i(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function a(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?i(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):i(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function u(e,t){var n={issuer:e.options.issuer,urls:(0,o.Fc)(e,t),clientId:t.clientId,redirectUri:t.redirectUri,responseType:t.responseType,responseMode:t.responseMode,scopes:t.scopes,state:t.state,nonce:t.nonce,ignoreSignature:t.ignoreSignature,acrValues:t.acrValues};return!1===t.pkce?n:a(a({},n),{},{codeVerifier:t.codeVerifier,codeChallengeMethod:t.codeChallengeMethod,codeChallenge:t.codeChallenge})}},3611:function(e,t,n){"use strict";var r=n(7594),o=n(7987),i=n(1971);function a(e){return("0"+e.toString(16)).substr(-2)}t.Z={DEFAULT_CODE_CHALLENGE_METHOD:i.DEFAULT_CODE_CHALLENGE_METHOD,generateVerifier:function(e){var t,n,o=e||"";return o.length<i.MIN_VERIFIER_LENGTH&&(o+=(t=i.MIN_VERIFIER_LENGTH-o.length,n=new Uint8Array(Math.ceil(t/2)),r.KP.getRandomValues(n),Array.from(n,a).join("").slice(0,t))),encodeURIComponent(o).slice(0,i.MAX_VERIFIER_LENGTH)},computeChallenge:function(e){var t=(new TextEncoder).encode(e);return r.KP.subtle.digest("SHA-256",t).then((function(e){var t=String.fromCharCode.apply(null,new Uint8Array(e));return(0,o.NL)(t)}))}}},6757:function(e,t,n){"use strict";n.d(t,{U:function(){return c}});var r=n(4942),o=n(9123),i=n(5078);function a(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function u(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?a(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):a(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function c(e,t){return function(e){if(!(e=u(u({},e),{},{responseType:"none",prompt:"enroll_authenticator",maxAge:0})).enrollAmrValues)throw new o.Z("enroll_amr_values must be specified");if(!e.acrValues)throw new o.Z("acr_values must be specified");return delete e.scopes,delete e.nonce,e}(u(u({},(0,i.c)(e)),t))}},6898:function(e,t,n){"use strict";n.d(t,{br:function(){return v},mi:function(){return g},vz:function(){return d},wu:function(){return b}});var r=n(4942),o=n(5861),i=n(4687),a=n.n(i),u=n(52),c=n(9123),s=n(7756),f=n(1971),l=n(3611);function p(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function h(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?p(Object(n),!0).forEach((function(t){(0,r.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):p(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function d(e){if(!e.features.isPKCESupported()){var t="PKCE requires a modern browser with encryption support running in a secure context.";throw e.features.isHTTPS()||(t+="\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."),e.features.hasTextEncoder()||(t+='\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'),new c.Z(t)}}function v(e,t){return y.apply(this,arguments)}function y(){return(y=(0,o.Z)(a().mark((function e(t,n){return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=n||t.options.codeChallengeMethod||f.DEFAULT_CODE_CHALLENGE_METHOD,e.next=3,(0,u.E)(t);case 3:if(-1!==(e.sent.code_challenge_methods_supported||[]).indexOf(n)){e.next=7;break}throw new c.Z("Invalid code_challenge_method");case 7:return e.abrupt("return",n);case 8:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function g(e,t){return m.apply(this,arguments)}function m(){return(m=(0,o.Z)(a().mark((function e(t,n){var r,o,i,u;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(o=(r=n).codeVerifier,i=r.codeChallenge,u=r.codeChallengeMethod,i=i||t.options.codeChallenge){e.next=8;break}return d(t),o=o||l.Z.generateVerifier(),e.next=7,l.Z.computeChallenge(o);case 7:i=e.sent;case 8:return e.next=10,v(t,u);case 10:return u=e.sent,n=h(h({},n),{},{responseType:"code",codeVerifier:o,codeChallenge:i,codeChallengeMethod:u}),e.abrupt("return",n);case 13:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function b(e){return k.apply(this,arguments)}function k(){return k=(0,o.Z)(a().mark((function e(t){var n,r,o=arguments;return a().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=o.length>1&&void 0!==o[1]?o[1]:{},r=(0,s.D)(t),!(n=h(h({},r),n)).dpop||t.features.isDPoPSupported()){e.next=5;break}throw new c.Z("DPoP has been configured, but is not supported by browser");case 5:if(!1!==n.pkce){e.next=7;break}return e.abrupt("return",n);case 7:return e.abrupt("return",g(t,n));case 8:case"end":return e.stop()}}),e)}))),k.apply(this,arguments)}},6635:function(e,t,n){"use strict";n.d(t,{Y:function(){return i},q:function(){return o}});var r=n(5728);function o(e,t){return e.refreshToken===t.refreshToken}function i(e){return!(!(0,r.isAuthApiError)(e)||!e.xhr||!e.xhr.responseJSON||"invalid_grant"!==e.xhr.responseJSON.error)}},1969:function(e,t,n){"use strict";function r(e){var t=/\+/g,n=/([^&=]+)=?([^&]*)/g,r=e||"";"#"===r.charAt(0)&&"/"===r.charAt(1)&&(r=r.substring(2)),"#"!==r.charAt(0)&&"?"!==r.charAt(0)||(r=r.substring(1));for(var o,i={};o=n.exec(r);){var a=o[1],u=o[2];i[a]="id_token"===a||"access_token"===a||"code"===a?u:decodeURIComponent(u.replace(t," "))}return i}n.d(t,{v:function(){return r}})},6003:function(e,t,n){"use strict";n.d(t,{p:function(){return o}});var r=n(9123);function o(e,t,n){var o=n.clientId,i=n.issuer,a=n.nonce,u=n.acrValues;if(!t||!i||!o)throw new r.Z("The jwt, iss, and aud arguments are all required");if(a&&t.nonce!==a)throw new r.Z("OAuth flow response nonce doesn't match request nonce");var c=Math.floor(Date.now()/1e3);if(t.iss!==i)throw new r.Z("The issuer ["+t.iss+"] does not match ["+i+"]");if(Array.isArray(t.aud)&&t.aud.indexOf(o)<0||!Array.isArray(t.aud)&&t.aud!==o)throw new r.Z("The audience ["+t.aud+"] does not match ["+o+"]");if(u&&t.acr!==u)throw new r.Z("The acr ["+t.acr+"] does not match acr_values ["+u+"]");if(t.iat>t.exp)throw new r.Z("The JWT expired before it was issued");if(!e.options.ignoreLifetime){if(c-e.options.maxClockSkew>t.exp)throw new r.Z("The JWT expired and is no longer valid");if(t.iat>c+e.options.maxClockSkew)throw new r.Z("The JWT was issued in the future")}}},2482:function(e,t,n){"use strict";n.d(t,{R:function(){return i}});var r=n(9123),o=n(6488);function i(e,t){if(!(0,o.sI)(e)&&!(0,o.hv)(e)&&!(0,o.z9)(e))throw new r.Z("Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property");if("accessToken"===t&&!(0,o.hv)(e))throw new r.Z("invalid accessToken");if("idToken"===t&&!(0,o.sI)(e))throw new r.Z("invalid idToken");if("refreshToken"===t&&!(0,o.z9)(e))throw new r.Z("invalid refreshToken")}},1260:function(e,t,n){"use strict";n.d(t,{W:function(){return p}});var r=n(5861),o=n(4687),i=n.n(o),a=n(52),u=n(6003),c=n(9123),s=n(1237),f=n(3154),l=n(5698);function p(e,t,n){return h.apply(this,arguments)}function h(){return(h=(0,r.Z)(i().mark((function e(t,n,r){var o,p,h,d,v,y;return i().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n&&n.idToken){e.next=2;break}throw new c.Z("Only idTokens may be verified");case 2:return o=(0,s.T)(n.idToken),p=(null==r?void 0:r.issuer)||t.options.issuer,e.next=6,(0,a.E)(t,p);case 6:if(h=e.sent,d=h.issuer,v=Object.assign({clientId:t.options.clientId,ignoreSignature:t.options.ignoreSignature},r,{issuer:d}),(0,u.p)(t,o.payload,v),1!=v.ignoreSignature&&t.features.isTokenVerifySupported()){e.next=12;break}return e.abrupt("return",n);case 12:return e.next=14,(0,a.k)(t,n.issuer,o.header.kid);case 14:return y=e.sent,e.next=17,f.W(n.idToken,y);case 17:if(e.sent){e.next=20;break}throw new c.Z("The token signature is not valid");case 20:if(!(r&&r.accessToken&&n.claims.at_hash)){e.next=26;break}return e.next=23,l.X(r.accessToken);case 23:if(e.sent===n.claims.at_hash){e.next=26;break}throw new c.Z("Token hash verification failed");case 26:return e.abrupt("return",n);case 27:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},3719:function(e,t,n){"use strict";n.d(t,{Gg:function(){return u},OT:function(){return f},RJ:function(){return c},dx:function(){return s},sH:function(){return a}});var r=n(3193),o=n(6718),i=n(5385);function a(e){return e.session.get().then((function(e){return"ACTIVE"===e.status})).catch((function(){return!1}))}function u(e){return(0,i.U2)(e,"/api/v1/sessions/me",{withCredentials:!0}).then((function(t){var n=(0,r.CE)(t,"_links");return n.refresh=function(){return(0,i.v_)(e,(0,r.Rg)(t,"refresh").href,{},{withCredentials:!0})},n.user=function(){return(0,i.U2)(e,(0,r.Rg)(t,"user").href,{withCredentials:!0})},n})).catch((function(){return{status:"INACTIVE"}}))}function c(e){return(0,i.c3)(e,{url:e.getIssuerOrigin()+"/api/v1/sessions/me",method:"DELETE",withCredentials:!0})}function s(e){return(0,i.v_)(e,"/api/v1/sessions/me/lifecycle/refresh",{},{withCredentials:!0})}function f(e,t,n){n=n||window.location.href,window.location.assign(e.getIssuerOrigin()+"/login/sessionCookieRedirect"+(0,o.UK)({checkAccountSetupComplete:!0,token:t,redirectUrl:n}))}},2815:function(e,t,n){"use strict";n.d(t,{M:function(){return o}});var r=n(3719);function o(e){return{close:r.RJ.bind(null,e),exists:r.sH.bind(null,e),get:r.Gg.bind(null,e),refresh:r.dx.bind(null,e),setCookieAndRedirect:r.OT.bind(null,e)}}},8041:function(e,t,n){"use strict";n.d(t,{Gg:function(){return r.Gg},MG:function(){return o.M},OT:function(){return r.OT},RJ:function(){return r.RJ},Zg:function(){return i.Z},dx:function(){return r.dx},sH:function(){return r.sH}});var r=n(3719),o=n(2815),i=n(3980)},3980:function(e,t,n){"use strict";n.d(t,{Z:function(){return d}});var r=n(5861),o=n(5671),i=n(3144),a=n(7326),u=n(136),c=n(2963),s=n(1120),f=n(4942),l=n(4687),p=n.n(l),h=n(2815);function d(e){return function(e){(0,u.Z)(d,e);var t,n,l=(t=d,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,s.Z)(t);if(n){var o=(0,s.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,c.Z)(this,e)});function d(){var e;(0,o.Z)(this,d);for(var t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];return e=l.call.apply(l,[this].concat(n)),(0,f.Z)((0,a.Z)(e),"session",void 0),e.session=(0,h.M)((0,a.Z)(e)),e}return(0,i.Z)(d,[{key:"closeSession",value:function(){var e=this;return this.session.close().then((0,r.Z)(p().mark((function t(){return p().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return e.clearStorage(),t.abrupt("return",!0);case 2:case"end":return t.stop()}}),t)})))).catch((function(e){if("AuthApiError"===e.name&&"E0000007"===e.errorCode)return!1;throw e}))}}]),d}(e)}},5437:function(e,t,n){"use strict";n.d(t,{V:function(){return f},W:function(){return l}});var r=n(5671),o=n(3144),i=n(4942),a=n(1971),u=n(5763),c=n(415),s=n(146);function f(e){(0,c.isBrowser)()||e.storageProvider||e.storageKey||(0,s.ZK)("Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.")}var l=function(){function e(t,n,o){(0,r.Z)(this,e),(0,i.Z)(this,"storageManagerOptions",void 0),(0,i.Z)(this,"cookieOptions",void 0),(0,i.Z)(this,"storageUtil",void 0),this.storageManagerOptions=t,this.cookieOptions=n,this.storageUtil=o}return(0,o.Z)(e,[{key:"getOptionsForSection",value:function(e,t){return Object.assign({},this.storageManagerOptions[e],t)}},{key:"getStorage",value:function(e){if((e=Object.assign({},this.cookieOptions,e)).storageProvider)return e.storageProvider;var t=e,n=t.storageType,r=t.storageTypes;if("sessionStorage"===n&&(e.sessionCookie=!0),n&&r){var o=r.indexOf(n);o>=0&&(r=r.slice(o),n=void 0)}return n||(n=this.storageUtil.findStorageType(r)),this.storageUtil.getStorageByType(n,e)}},{key:"getTokenStorage",value:function(e){f(e=this.getOptionsForSection("token",e));var t=this.getStorage(e),n=e.storageKey||a.TOKEN_STORAGE_NAME;return new u._(t,n)}},{key:"getHttpCache",value:function(e){e=this.getOptionsForSection("cache",e);var t=this.getStorage(e),n=e.storageKey||a.CACHE_STORAGE_NAME;return new u._(t,n)}}]),e}()},5763:function(e,t,n){"use strict";n.d(t,{_:function(){return u}});var r=n(5671),o=n(3144),i=n(4942),a=n(9123),u=function(){function e(t,n){if((0,r.Z)(this,e),(0,i.Z)(this,"storageProvider",void 0),(0,i.Z)(this,"storageName",void 0),!t)throw new a.Z('"storage" is required');if("string"!=typeof n||!n.length)throw new a.Z('"storageName" is required');this.storageName=n,this.storageProvider=t}return(0,o.Z)(e,[{key:"getItem",value:function(e){return this.getStorage()[e]}},{key:"setItem",value:function(e,t){return this.updateStorage(e,t)}},{key:"removeItem",value:function(e){return this.clearStorage(e)}},{key:"getStorage",value:function(){var e=this.storageProvider.getItem(this.storageName);e=e||"{}";try{return JSON.parse(e)}catch(e){throw new a.Z("Unable to parse storage string: "+this.storageName)}}},{key:"setStorage",value:function(e){try{var t=e?JSON.stringify(e):"{}";this.storageProvider.setItem(this.storageName,t)}catch(e){throw new a.Z("Unable to set storage: "+this.storageName)}}},{key:"clearStorage",value:function(e){if(e){var t=this.getStorage();delete t[e],this.setStorage(t)}else this.storageProvider.removeItem?this.storageProvider.removeItem(this.storageName):this.setStorage()}},{key:"updateStorage",value:function(e,t){var n=this.getStorage();n[e]=t,this.setStorage(n)}}]),e}()},9927:function(e,t,n){"use strict";n.d(t,{Ho:function(){return i.H},Tp:function(){return r.T},Vp:function(){return o.V},W8:function(){return o.W},_e:function(){return a._}});var r=n(3849),o=n(5437),i=n(265),a=n(5763)},265:function(e,t,n){"use strict";n.d(t,{H:function(){return f}});var r=n(5671),o=n(3144),i=n(7326),a=n(136),u=n(2963),c=n(1120),s=n(4942);function f(e,t){return function(e){(0,a.Z)(p,e);var n,f,l=(n=p,f=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=(0,c.Z)(n);if(f){var r=(0,c.Z)(this).constructor;e=Reflect.construct(t,arguments,r)}else e=t.apply(this,arguments);return(0,u.Z)(this,e)});function p(){var e;(0,r.Z)(this,p);for(var n=arguments.length,o=new Array(n),a=0;a<n;a++)o[a]=arguments[a];e=l.call.apply(l,[this].concat(o)),(0,s.Z)((0,i.Z)(e),"storageManager",void 0);var u=e.options,c=u.storageManager,f=u.cookies,h=u.storageUtil;return e.storageManager=new t(c,f,h),e}return(0,o.Z)(p,[{key:"clearStorage",value:function(){}}]),p}(e)}},3849:function(e,t,n){"use strict";n.d(t,{T:function(){return g}});var r=n(3144),o=n(5671),i=n(7326),a=n(136),u=n(2963),c=n(1120),s=n(4942),f=n(5093),l=n(146),p=n(4858),h={token:{storageTypes:["localStorage","sessionStorage","cookie"]},cache:{storageTypes:["localStorage","sessionStorage","cookie"]},transaction:{storageTypes:["sessionStorage","localStorage","cookie"]},"shared-transaction":{storageTypes:["localStorage"]},"original-uri":{storageTypes:["localStorage"]}},d=n(415);function v(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function y(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?v(Object(n),!0).forEach((function(t){(0,s.Z)(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):v(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function g(){return function(e){(0,a.Z)(v,e);var t,n,f=(t=v,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=(0,c.Z)(t);if(n){var o=(0,c.Z)(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return(0,u.Z)(this,e)});function v(e){var t;return(0,o.Z)(this,v),t=f.call(this,e),(0,s.Z)((0,i.Z)(t),"cookies",void 0),(0,s.Z)((0,i.Z)(t),"storageUtil",void 0),(0,s.Z)((0,i.Z)(t),"storageManager",void 0),t.cookies=function(){var e=arguments.length>1?arguments[1]:void 0,t=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).cookies||{};return void 0===t.secure&&(t.secure=e),void 0===t.sameSite&&(t.sameSite=t.secure?"none":"lax"),t.secure&&!e&&((0,l.ZK)('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'),t.secure=!1),"none"!==t.sameSite||t.secure||(t.sameSite="lax"),t}(e,(0,d.isHTTPS)()),t.storageUtil=e.storageUtil||Object.assign({},p.Z,{inMemoryStore:{}}),t.storageManager=y(y({},h),e.storageManager),t}return(0,r.Z)(v)}((0,f.X)())}},3548:function(e,t,n){"use strict";n.d(t,{b:function(){return c}});var r=n(5671),o=n(3144),i=n(4942),a=n(4771),u=n(146),c=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{quiet:!1};(0,r.Z)(this,e),(0,i.Z)(this,"queue",void 0),(0,i.Z)(this,"running",void 0),(0,i.Z)(this,"options",void 0),this.queue=[],this.running=!1,this.options=t}return(0,o.Z)(e,[{key:"push",value:function(e,t){for(var n=this,r=arguments.length,o=new Array(r>2?r-2:0),i=2;i<r;i++)o[i-2]=arguments[i];return new Promise((function(r,i){n.queue.length>0&&!1!==n.options.quiet&&(0,u.ZK)("Async method is being called but another async method is already running. The new method will be delayed until the previous method completes."),n.queue.push({method:e,thisObject:t,args:o,resolve:r,reject:i}),n.run()}))}},{key:"run",value:function(){var e=this;if(!this.running&&0!==this.queue.length){this.running=!0;var t=this.queue.shift(),n=t.method.apply(t.thisObject,t.args);(0,a.tI)(n)?n.then(t.resolve,t.reject).finally((function(){e.running=!1,e.run()})):(t.resolve(n),this.running=!1,this.run())}}}]),e}()},146:function(e,t,n){"use strict";function r(){return"undefined"!=typeof window?window.console:"undefined"!=typeof console?console:void 0}function o(){var e=r();return e&&e.log?e:{log:function(){},warn:function(){},group:function(){},groupEnd:function(){}}}function i(e){o().warn("[okta-auth-sdk] WARN: "+e)}function a(e){o().warn("[okta-auth-sdk] DEPRECATION: "+e)}function u(e,t){return function(){return a(e),t.apply(null,arguments)}}n.d(t,{Rn:function(){return a},VA:function(){return u},ZK:function(){return i},dr:function(){return o},sW:function(){return r}})},305:function(e,t,n){"use strict";n.d(t,{BY:function(){return c.BY},CE:function(){return i.CE},HD:function(){return u.HD},Kn:function(){return u.Kn},QN:function(){return c.QN},Qj:function(){return c.Qj},Rg:function(){return i.Rg},Rn:function(){return r.Rn},UK:function(){return c.UK},VA:function(){return r.VA},YQ:function(){return o.YQ},YY:function(){return i.YY},ZK:function(){return r.ZK},ak:function(){return i.ak},bo:function(){return a.b},d9:function(){return i.d9},dr:function(){return r.dr},gw:function(){return o.gw},hj:function(){return u.hj},l7:function(){return i.l7},mf:function(){return u.mf},ng:function(){return o.ng},sD:function(){return c.sD},sE:function(){return i.sE},sW:function(){return r.sW},tI:function(){return u.tI},uh:function(){return o.uh}});var r=n(146),o=n(8750),i=n(3193),a=n(3548),u=n(4771),c=n(6718)},8750:function(e,t,n){"use strict";function r(e){var t=e.match(/\d+/g),n=Date.UTC(t[0],t[1]-1,t[2],t[3],t[4],t[5]);return new Date(n).toUTCString()}function o(e){for(var t="",n=0;n<e;++n)t+="abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"[Math.floor(61*Math.random())];return t}function i(e){return new Promise((function(t){setTimeout(t,e)}))}function a(e,t){var n=e.split(t);return[n[0],n.splice(1,n.length).join(t)]}n.d(t,{YQ:function(){return a},gw:function(){return i},ng:function(){return r},uh:function(){return o}})},3193:function(e,t,n){"use strict";function r(e,t){var n=Array.prototype.slice.call(arguments,2);return function(){var r=Array.prototype.slice.call(arguments);return r=n.concat(r),e.apply(t,r)}}function o(){var e=arguments[0];return[].slice.call(arguments,1).forEach((function(t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&void 0!==t[n]&&(e[n]=t[n])})),e}function i(e){var t={};for(var n in e)if(Object.prototype.hasOwnProperty.call(e,n)){var r=e[n];null!=r&&(t[n]=r)}return t}function a(e){if(e){var t=JSON.stringify(e);if(t)return JSON.parse(t)}return e}function u(e){for(var t={},n=arguments.length,r=new Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=arguments[o];for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&-1==r.indexOf(i)&&(t[i]=e[i]);return a(t)}function c(e,t){for(var n=e.length;n--;){var r=e[n],o=!0;for(var i in t)if(Object.prototype.hasOwnProperty.call(t,i)&&r[i]!==t[i]){o=!1;break}if(o)return r}}function s(e,t,n){if(e&&e._links){var r=a(e._links[t]);return r&&r.name&&n?r.name===n?r:void 0:r}}n.d(t,{CE:function(){return u},Rg:function(){return s},YY:function(){return i},ak:function(){return r},d9:function(){return a},l7:function(){return o},sE:function(){return c}})},4771:function(e,t,n){"use strict";function r(e){return"[object String]"===Object.prototype.toString.call(e)}function o(e){return"[object Object]"===Object.prototype.toString.call(e)}function i(e){return"[object Number]"===Object.prototype.toString.call(e)}function a(e){return!!e&&"[object Function]"==={}.toString.call(e)}function u(e){return e&&e.finally&&"function"==typeof e.finally}n.d(t,{HD:function(){return r},Kn:function(){return o},hj:function(){return i},mf:function(){return a},tI:function(){return u}})},6718:function(e,t,n){"use strict";function r(e){return/^[a-z][a-z0-9+.-]*:/i.test(e)}function o(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1?arguments[1]:void 0;return r(e)?e:(t=u(t),"/"===e[0]?"".concat(t).concat(e):"".concat(t,"/").concat(e))}function i(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1?arguments[1]:void 0;return r(e)&&(e=e.substring(t.length)),"/"===e[0]?e:"/".concat(e)}function a(e){var t=[];if(null!==e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&void 0!==e[n]&&null!==e[n]&&t.push(n+"="+encodeURIComponent(e[n]));return t.length?"?"+t.join("&"):""}function u(e){if(e){var t=e.replace(/^\s+|\s+$/gm,"");return t.replace(/\/+$/,"")}}n.d(t,{BY:function(){return o},QN:function(){return i},Qj:function(){return u},UK:function(){return a},sD:function(){return r}})},3615:function(e,t,n){"use strict";var r=n(6690),o=n(9728),i=n(1655),a=n(4993),u=n(3808);function c(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}var s=function(e){i(s,e);var t,n,c=(t=s,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,r=u(t);if(n){var o=u(this).constructor;e=Reflect.construct(r,arguments,o)}else e=r.apply(this,arguments);return a(this,e)});function s(e){var t;return r(this,s),(t=c.call(this,e||"Promise was canceled")).name="CancelError",t}return o(s,[{key:"isCanceled",get:function(){return!0}}]),s}(n(3496)(Error)),f=function(){function e(t){var n=this;r(this,e),this._cancelHandlers=[],this._isPending=!0,this._isCanceled=!1,this._rejectOnCancel=!0,this._promise=new Promise((function(e,r){n._reject=r;var o=function(e){if(!n._isPending)throw new Error("The `onCancel` handler was attached after the promise settled.");n._cancelHandlers.push(e)};return Object.defineProperties(o,{shouldReject:{get:function(){return n._rejectOnCancel},set:function(e){n._rejectOnCancel=e}}}),t((function(t){n._isCanceled&&o.shouldReject||(n._isPending=!1,e(t))}),(function(e){n._isPending=!1,r(e)}),o)}))}return o(e,[{key:"then",value:function(e,t){return this._promise.then(e,t)}},{key:"catch",value:function(e){return this._promise.catch(e)}},{key:"finally",value:function(e){return this._promise.finally(e)}},{key:"cancel",value:function(e){if(this._isPending&&!this._isCanceled){if(this._isCanceled=!0,this._cancelHandlers.length>0)try{var t,n=function(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=function(e,t){if(e){if("string"==typeof e)return c(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?c(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,u=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){u=!0,i=e},f:function(){try{a||null==n.return||n.return()}finally{if(u)throw i}}}}(this._cancelHandlers);try{for(n.s();!(t=n.n()).done;)(0,t.value)()}catch(e){n.e(e)}finally{n.f()}}catch(e){return void this._reject(e)}this._rejectOnCancel&&this._reject(new s(e))}}},{key:"isCanceled",get:function(){return this._isCanceled}}],[{key:"fn",value:function(t){return function(){for(var n=arguments.length,r=new Array(n),o=0;o<n;o++)r[o]=arguments[o];return new e((function(e,n,o){r.push(o),t.apply(void 0,r).then(e,n)}))}}}]),e}();Object.setPrototypeOf(f.prototype,Promise.prototype),e.exports=f,e.exports.CancelError=s},4098:function(e,t){var n="undefined"!=typeof self?self:this,r=function(){function e(){this.fetch=!1,this.DOMException=n.DOMException}return e.prototype=n,new e}();!function(e){!function(t){var n={searchParams:"URLSearchParams"in e,iterable:"Symbol"in e&&"iterator"in Symbol,blob:"FileReader"in e&&"Blob"in e&&function(){try{return new Blob,!0}catch(e){return!1}}(),formData:"FormData"in e,arrayBuffer:"ArrayBuffer"in e};if(n.arrayBuffer)var r=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],o=ArrayBuffer.isView||function(e){return e&&r.indexOf(Object.prototype.toString.call(e))>-1};function i(e){if("string"!=typeof e&&(e=String(e)),/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e))throw new TypeError("Invalid character in header field name");return e.toLowerCase()}function a(e){return"string"!=typeof e&&(e=String(e)),e}function u(e){var t={next:function(){var t=e.shift();return{done:void 0===t,value:t}}};return n.iterable&&(t[Symbol.iterator]=function(){return t}),t}function c(e){this.map={},e instanceof c?e.forEach((function(e,t){this.append(t,e)}),this):Array.isArray(e)?e.forEach((function(e){this.append(e[0],e[1])}),this):e&&Object.getOwnPropertyNames(e).forEach((function(t){this.append(t,e[t])}),this)}function s(e){if(e.bodyUsed)return Promise.reject(new TypeError("Already read"));e.bodyUsed=!0}function f(e){return new Promise((function(t,n){e.onload=function(){t(e.result)},e.onerror=function(){n(e.error)}}))}function l(e){var t=new FileReader,n=f(t);return t.readAsArrayBuffer(e),n}function p(e){if(e.slice)return e.slice(0);var t=new Uint8Array(e.byteLength);return t.set(new Uint8Array(e)),t.buffer}function h(){return this.bodyUsed=!1,this._initBody=function(e){var t;this._bodyInit=e,e?"string"==typeof e?this._bodyText=e:n.blob&&Blob.prototype.isPrototypeOf(e)?this._bodyBlob=e:n.formData&&FormData.prototype.isPrototypeOf(e)?this._bodyFormData=e:n.searchParams&&URLSearchParams.prototype.isPrototypeOf(e)?this._bodyText=e.toString():n.arrayBuffer&&n.blob&&(t=e)&&DataView.prototype.isPrototypeOf(t)?(this._bodyArrayBuffer=p(e.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer])):n.arrayBuffer&&(ArrayBuffer.prototype.isPrototypeOf(e)||o(e))?this._bodyArrayBuffer=p(e):this._bodyText=e=Object.prototype.toString.call(e):this._bodyText="",this.headers.get("content-type")||("string"==typeof e?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):n.searchParams&&URLSearchParams.prototype.isPrototypeOf(e)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"))},n.blob&&(this.blob=function(){var e=s(this);if(e)return e;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){return this._bodyArrayBuffer?s(this)||Promise.resolve(this._bodyArrayBuffer):this.blob().then(l)}),this.text=function(){var e,t,n,r=s(this);if(r)return r;if(this._bodyBlob)return e=this._bodyBlob,n=f(t=new FileReader),t.readAsText(e),n;if(this._bodyArrayBuffer)return Promise.resolve(function(e){for(var t=new Uint8Array(e),n=new Array(t.length),r=0;r<t.length;r++)n[r]=String.fromCharCode(t[r]);return n.join("")}(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)},n.formData&&(this.formData=function(){return this.text().then(y)}),this.json=function(){return this.text().then(JSON.parse)},this}c.prototype.append=function(e,t){e=i(e),t=a(t);var n=this.map[e];this.map[e]=n?n+", "+t:t},c.prototype.delete=function(e){delete this.map[i(e)]},c.prototype.get=function(e){return e=i(e),this.has(e)?this.map[e]:null},c.prototype.has=function(e){return this.map.hasOwnProperty(i(e))},c.prototype.set=function(e,t){this.map[i(e)]=a(t)},c.prototype.forEach=function(e,t){for(var n in this.map)this.map.hasOwnProperty(n)&&e.call(t,this.map[n],n,this)},c.prototype.keys=function(){var e=[];return this.forEach((function(t,n){e.push(n)})),u(e)},c.prototype.values=function(){var e=[];return this.forEach((function(t){e.push(t)})),u(e)},c.prototype.entries=function(){var e=[];return this.forEach((function(t,n){e.push([n,t])})),u(e)},n.iterable&&(c.prototype[Symbol.iterator]=c.prototype.entries);var d=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];function v(e,t){var n,r,o=(t=t||{}).body;if(e instanceof v){if(e.bodyUsed)throw new TypeError("Already read");this.url=e.url,this.credentials=e.credentials,t.headers||(this.headers=new c(e.headers)),this.method=e.method,this.mode=e.mode,this.signal=e.signal,o||null==e._bodyInit||(o=e._bodyInit,e.bodyUsed=!0)}else this.url=String(e);if(this.credentials=t.credentials||this.credentials||"same-origin",!t.headers&&this.headers||(this.headers=new c(t.headers)),this.method=(r=(n=t.method||this.method||"GET").toUpperCase(),d.indexOf(r)>-1?r:n),this.mode=t.mode||this.mode||null,this.signal=t.signal||this.signal,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&o)throw new TypeError("Body not allowed for GET or HEAD requests");this._initBody(o)}function y(e){var t=new FormData;return e.trim().split("&").forEach((function(e){if(e){var n=e.split("="),r=n.shift().replace(/\+/g," "),o=n.join("=").replace(/\+/g," ");t.append(decodeURIComponent(r),decodeURIComponent(o))}})),t}function g(e,t){t||(t={}),this.type="default",this.status=void 0===t.status?200:t.status,this.ok=this.status>=200&&this.status<300,this.statusText="statusText"in t?t.statusText:"OK",this.headers=new c(t.headers),this.url=t.url||"",this._initBody(e)}v.prototype.clone=function(){return new v(this,{body:this._bodyInit})},h.call(v.prototype),h.call(g.prototype),g.prototype.clone=function(){return new g(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new c(this.headers),url:this.url})},g.error=function(){var e=new g(null,{status:0,statusText:""});return e.type="error",e};var m=[301,302,303,307,308];g.redirect=function(e,t){if(-1===m.indexOf(t))throw new RangeError("Invalid status code");return new g(null,{status:t,headers:{location:e}})},t.DOMException=e.DOMException;try{new t.DOMException}catch(e){t.DOMException=function(e,t){this.message=e,this.name=t;var n=Error(e);this.stack=n.stack},t.DOMException.prototype=Object.create(Error.prototype),t.DOMException.prototype.constructor=t.DOMException}function b(e,r){return new Promise((function(o,i){var a=new v(e,r);if(a.signal&&a.signal.aborted)return i(new t.DOMException("Aborted","AbortError"));var u=new XMLHttpRequest;function s(){u.abort()}u.onload=function(){var e,t,n={status:u.status,statusText:u.statusText,headers:(e=u.getAllResponseHeaders()||"",t=new c,e.replace(/\r?\n[\t ]+/g," ").split(/\r?\n/).forEach((function(e){var n=e.split(":"),r=n.shift().trim();if(r){var o=n.join(":").trim();t.append(r,o)}})),t)};n.url="responseURL"in u?u.responseURL:n.headers.get("X-Request-URL");var r="response"in u?u.response:u.responseText;o(new g(r,n))},u.onerror=function(){i(new TypeError("Network request failed"))},u.ontimeout=function(){i(new TypeError("Network request failed"))},u.onabort=function(){i(new t.DOMException("Aborted","AbortError"))},u.open(a.method,a.url,!0),"include"===a.credentials?u.withCredentials=!0:"omit"===a.credentials&&(u.withCredentials=!1),"responseType"in u&&n.blob&&(u.responseType="blob"),a.headers.forEach((function(e,t){u.setRequestHeader(t,e)})),a.signal&&(a.signal.addEventListener("abort",s),u.onreadystatechange=function(){4===u.readyState&&a.signal.removeEventListener("abort",s)}),u.send(void 0===a._bodyInit?null:a._bodyInit)}))}b.polyfill=!0,e.fetch||(e.fetch=b,e.Headers=c,e.Request=v,e.Response=g),t.Headers=c,t.Request=v,t.Response=g,t.fetch=b,Object.defineProperty(t,"__esModule",{value:!0})}({})}(r),r.fetch.ponyfill=!0,delete r.fetch.polyfill;var o=r;(t=o.fetch).default=o.fetch,t.fetch=o.fetch,t.Headers=o.Headers,t.Request=o.Request,t.Response=o.Response,e.exports=t},4279:function(e){function t(){}t.prototype={on:function(e,t,n){var r=this.e||(this.e={});return(r[e]||(r[e]=[])).push({fn:t,ctx:n}),this},once:function(e,t,n){var r=this;function o(){r.off(e,o),t.apply(n,arguments)}return o._=t,this.on(e,o,n)},emit:function(e){for(var t=[].slice.call(arguments,1),n=((this.e||(this.e={}))[e]||[]).slice(),r=0,o=n.length;r<o;r++)n[r].fn.apply(n[r].ctx,t);return this},off:function(e,t){var n=this.e||(this.e={}),r=n[e],o=[];if(r&&t)for(var i=0,a=r.length;i<a;i++)r[i].fn!==t&&r[i].fn._!==t&&o.push(r[i]);return o.length?n[e]=o:delete n[e],this}},e.exports=t},6115:function(e){e.exports=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e},e.exports.__esModule=!0,e.exports.default=e.exports},6690:function(e){e.exports=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},e.exports.__esModule=!0,e.exports.default=e.exports},3515:function(e,t,n){var r=n(6015),o=n(9617);function i(t,n,a){return o()?(e.exports=i=Reflect.construct.bind(),e.exports.__esModule=!0,e.exports.default=e.exports):(e.exports=i=function(e,t,n){var o=[null];o.push.apply(o,t);var i=new(Function.bind.apply(e,o));return n&&r(i,n.prototype),i},e.exports.__esModule=!0,e.exports.default=e.exports),i.apply(null,arguments)}e.exports=i,e.exports.__esModule=!0,e.exports.default=e.exports},9728:function(e){function t(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}e.exports=function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),Object.defineProperty(e,"prototype",{writable:!1}),e},e.exports.__esModule=!0,e.exports.default=e.exports},3808:function(e){function t(n){return e.exports=t=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},e.exports.__esModule=!0,e.exports.default=e.exports,t(n)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},1655:function(e,t,n){var r=n(6015);e.exports=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&r(e,t)},e.exports.__esModule=!0,e.exports.default=e.exports},6035:function(e){e.exports=function(e){return-1!==Function.toString.call(e).indexOf("[native code]")},e.exports.__esModule=!0,e.exports.default=e.exports},9617:function(e){e.exports=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}},e.exports.__esModule=!0,e.exports.default=e.exports},4993:function(e,t,n){var r=n(8698).default,o=n(6115);e.exports=function(e,t){if(t&&("object"===r(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return o(e)},e.exports.__esModule=!0,e.exports.default=e.exports},7061:function(e,t,n){var r=n(8698).default;function o(){"use strict";e.exports=o=function(){return t},e.exports.__esModule=!0,e.exports.default=e.exports;var t={},n=Object.prototype,i=n.hasOwnProperty,a="function"==typeof Symbol?Symbol:{},u=a.iterator||"@@iterator",c=a.asyncIterator||"@@asyncIterator",s=a.toStringTag||"@@toStringTag";function f(e,t,n){return Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}),e[t]}try{f({},"")}catch(e){f=function(e,t,n){return e[t]=n}}function l(e,t,n,r){var o=t&&t.prototype instanceof d?t:d,i=Object.create(o.prototype),a=new S(r||[]);return i._invoke=function(e,t,n){var r="suspendedStart";return function(o,i){if("executing"===r)throw new Error("Generator is already running");if("completed"===r){if("throw"===o)throw i;return{value:void 0,done:!0}}for(n.method=o,n.arg=i;;){var a=n.delegate;if(a){var u=Z(a,n);if(u){if(u===h)continue;return u}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if("suspendedStart"===r)throw r="completed",n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);r="executing";var c=p(e,t,n);if("normal"===c.type){if(r=n.done?"completed":"suspendedYield",c.arg===h)continue;return{value:c.arg,done:n.done}}"throw"===c.type&&(r="completed",n.method="throw",n.arg=c.arg)}}}(e,n,a),i}function p(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(e){return{type:"throw",arg:e}}}t.wrap=l;var h={};function d(){}function v(){}function y(){}var g={};f(g,u,(function(){return this}));var m=Object.getPrototypeOf,b=m&&m(m(P([])));b&&b!==n&&i.call(b,u)&&(g=b);var k=y.prototype=d.prototype=Object.create(g);function w(e){["next","throw","return"].forEach((function(t){f(e,t,(function(e){return this._invoke(t,e)}))}))}function O(e,t){function n(o,a,u,c){var s=p(e[o],e,a);if("throw"!==s.type){var f=s.arg,l=f.value;return l&&"object"==r(l)&&i.call(l,"__await")?t.resolve(l.__await).then((function(e){n("next",e,u,c)}),(function(e){n("throw",e,u,c)})):t.resolve(l).then((function(e){f.value=e,u(f)}),(function(e){return n("throw",e,u,c)}))}c(s.arg)}var o;this._invoke=function(e,r){function i(){return new t((function(t,o){n(e,r,t,o)}))}return o=o?o.then(i,i):i()}}function Z(e,t){var n=e.iterator[t.method];if(void 0===n){if(t.delegate=null,"throw"===t.method){if(e.iterator.return&&(t.method="return",t.arg=void 0,Z(e,t),"throw"===t.method))return h;t.method="throw",t.arg=new TypeError("The iterator does not provide a 'throw' method")}return h}var r=p(n,e.iterator,t.arg);if("throw"===r.type)return t.method="throw",t.arg=r.arg,t.delegate=null,h;var o=r.arg;return o?o.done?(t[e.resultName]=o.value,t.next=e.nextLoc,"return"!==t.method&&(t.method="next",t.arg=void 0),t.delegate=null,h):o:(t.method="throw",t.arg=new TypeError("iterator result is not an object"),t.delegate=null,h)}function T(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function E(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function S(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(T,this),this.reset(!0)}function P(e){if(e){var t=e[u];if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var n=-1,r=function t(){for(;++n<e.length;)if(i.call(e,n))return t.value=e[n],t.done=!1,t;return t.value=void 0,t.done=!0,t};return r.next=r}}return{next:x}}function x(){return{value:void 0,done:!0}}return v.prototype=y,f(k,"constructor",y),f(y,"constructor",v),v.displayName=f(y,s,"GeneratorFunction"),t.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===v||"GeneratorFunction"===(t.displayName||t.name))},t.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,y):(e.__proto__=y,f(e,s,"GeneratorFunction")),e.prototype=Object.create(k),e},t.awrap=function(e){return{__await:e}},w(O.prototype),f(O.prototype,c,(function(){return this})),t.AsyncIterator=O,t.async=function(e,n,r,o,i){void 0===i&&(i=Promise);var a=new O(l(e,n,r,o),i);return t.isGeneratorFunction(n)?a:a.next().then((function(e){return e.done?e.value:a.next()}))},w(k),f(k,s,"Generator"),f(k,u,(function(){return this})),f(k,"toString",(function(){return"[object Generator]"})),t.keys=function(e){var t=[];for(var n in e)t.push(n);return t.reverse(),function n(){for(;t.length;){var r=t.pop();if(r in e)return n.value=r,n.done=!1,n}return n.done=!0,n}},t.values=P,S.prototype={constructor:S,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(E),!e)for(var t in this)"t"===t.charAt(0)&&i.call(this,t)&&!isNaN(+t.slice(1))&&(this[t]=void 0)},stop:function(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(e){if(this.done)throw e;var t=this;function n(n,r){return a.type="throw",a.arg=e,t.next=n,r&&(t.method="next",t.arg=void 0),!!r}for(var r=this.tryEntries.length-1;r>=0;--r){var o=this.tryEntries[r],a=o.completion;if("root"===o.tryLoc)return n("end");if(o.tryLoc<=this.prev){var u=i.call(o,"catchLoc"),c=i.call(o,"finallyLoc");if(u&&c){if(this.prev<o.catchLoc)return n(o.catchLoc,!0);if(this.prev<o.finallyLoc)return n(o.finallyLoc)}else if(u){if(this.prev<o.catchLoc)return n(o.catchLoc,!0)}else{if(!c)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return n(o.finallyLoc)}}}},abrupt:function(e,t){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&i.call(r,"finallyLoc")&&this.prev<r.finallyLoc){var o=r;break}}o&&("break"===e||"continue"===e)&&o.tryLoc<=t&&t<=o.finallyLoc&&(o=null);var a=o?o.completion:{};return a.type=e,a.arg=t,o?(this.method="next",this.next=o.finallyLoc,h):this.complete(a)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),h},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),E(n),h}},catch:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var r=n.completion;if("throw"===r.type){var o=r.arg;E(n)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(e,t,n){return this.delegate={iterator:P(e),resultName:t,nextLoc:n},"next"===this.method&&(this.arg=void 0),h}},t}e.exports=o,e.exports.__esModule=!0,e.exports.default=e.exports},6015:function(e){function t(n,r){return e.exports=t=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},e.exports.__esModule=!0,e.exports.default=e.exports,t(n,r)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},8698:function(e){function t(n){return e.exports=t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports.__esModule=!0,e.exports.default=e.exports,t(n)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},3496:function(e,t,n){var r=n(3808),o=n(6015),i=n(6035),a=n(3515);function u(t){var n="function"==typeof Map?new Map:void 0;return e.exports=u=function(e){if(null===e||!i(e))return e;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==n){if(n.has(e))return n.get(e);n.set(e,t)}function t(){return a(e,arguments,r(this).constructor)}return t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),o(t,e)},e.exports.__esModule=!0,e.exports.default=e.exports,u(t)}e.exports=u,e.exports.__esModule=!0,e.exports.default=e.exports},4687:function(e,t,n){var r=n(7061)();e.exports=r;try{regeneratorRuntime=r}catch(e){"object"==typeof globalThis?globalThis.regeneratorRuntime=r:Function("r","regeneratorRuntime = r")(r)}},907:function(e,t,n){"use strict";function r(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=new Array(t);n<t;n++)r[n]=e[n];return r}n.d(t,{Z:function(){return r}})},7326:function(e,t,n){"use strict";function r(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}n.d(t,{Z:function(){return r}})},5861:function(e,t,n){"use strict";function r(e,t,n,r,o,i,a){try{var u=e[i](a),c=u.value}catch(e){return void n(e)}u.done?t(c):Promise.resolve(c).then(r,o)}function o(e){return function(){var t=this,n=arguments;return new Promise((function(o,i){var a=e.apply(t,n);function u(e){r(a,o,i,u,c,"next",e)}function c(e){r(a,o,i,u,c,"throw",e)}u(void 0)}))}}n.d(t,{Z:function(){return o}})},5671:function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}n.d(t,{Z:function(){return r}})},3144:function(e,t,n){"use strict";function r(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function o(e,t,n){return t&&r(e.prototype,t),n&&r(e,n),Object.defineProperty(e,"prototype",{writable:!1}),e}n.d(t,{Z:function(){return o}})},4942:function(e,t,n){"use strict";function r(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}n.d(t,{Z:function(){return r}})},1752:function(e,t,n){"use strict";n.d(t,{Z:function(){return o}});var r=n(1120);function o(){return o="undefined"!=typeof Reflect&&Reflect.get?Reflect.get.bind():function(e,t,n){var o=function(e,t){for(;!Object.prototype.hasOwnProperty.call(e,t)&&null!==(e=(0,r.Z)(e)););return e}(e,t);if(o){var i=Object.getOwnPropertyDescriptor(o,t);return i.get?i.get.call(arguments.length<3?e:n):i.value}},o.apply(this,arguments)}},1120:function(e,t,n){"use strict";function r(e){return r=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},r(e)}n.d(t,{Z:function(){return r}})},136:function(e,t,n){"use strict";n.d(t,{Z:function(){return o}});var r=n(9611);function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&(0,r.Z)(e,t)}},4925:function(e,t,n){"use strict";function r(e,t){if(null==e)return{};var n,r,o=function(e,t){if(null==e)return{};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}n.d(t,{Z:function(){return r}})},2963:function(e,t,n){"use strict";n.d(t,{Z:function(){return i}});var r=n(1002),o=n(7326);function i(e,t){if(t&&("object"===(0,r.Z)(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return(0,o.Z)(e)}},9611:function(e,t,n){"use strict";function r(e,t){return r=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},r(e,t)}n.d(t,{Z:function(){return r}})},885:function(e,t,n){"use strict";n.d(t,{Z:function(){return o}});var r=n(181);function o(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){var n=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=n){var r,o,i=[],a=!0,u=!1;try{for(n=n.call(e);!(a=(r=n.next()).done)&&(i.push(r.value),!t||i.length!==t);a=!0);}catch(e){u=!0,o=e}finally{try{a||null==n.return||n.return()}finally{if(u)throw o}}return i}}(e,t)||(0,r.Z)(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}},2982:function(e,t,n){"use strict";n.d(t,{Z:function(){return i}});var r=n(907),o=n(181);function i(e){return function(e){if(Array.isArray(e))return(0,r.Z)(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||(0,o.Z)(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}},1002:function(e,t,n){"use strict";function r(e){return r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},r(e)}n.d(t,{Z:function(){return r}})},181:function(e,t,n){"use strict";n.d(t,{Z:function(){return o}});var r=n(907);function o(e,t){if(e){if("string"==typeof e)return(0,r.Z)(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?(0,r.Z)(e,t):void 0}}}},t={};function n(r){var o=t[r];if(void 0!==o)return o.exports;var i=t[r]={exports:{}};return e[r].call(i.exports,i,i.exports,n),i.exports}n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,{a:t}),t},n.d=function(e,t){for(var r in t)n.o(t,r)&&!n.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},n.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var r={};return function(){"use strict";n.r(r),n.d(r,{AuthenticatorKey:function(){return y.pc},EmailRole:function(){return g.aw},IdxFeature:function(){return y.Fw},IdxStatus:function(){return y.Qd},OktaAuth:function(){return T},PasswordStatus:function(){return g.Fn},Status:function(){return g.qb},addEmail:function(){return g.no},addPhone:function(){return g.Z1},authenticate:function(){return y.YR},canProceed:function(){return y.Ch},cancel:function(){return y.al},clearTransactionMeta:function(){return y.Jm},createAuthnTransactionAPI:function(){return m.b},createIdxAPI:function(){return y.F4},createIdxOptionsConstructor:function(){return y.SL},createIdxStorageManager:function(){return y.aT},createIdxTransactionManager:function(){return y.vK},createMinimalOktaAuthIdx:function(){return y.UB},createOktaAuthIdx:function(){return y.Yn},createOktaAuthMyAccount:function(){return g.Xc},createTransactionMeta:function(){return y.Xc},deleteEmail:function(){return g.nd},deletePassword:function(){return g.QN},deletePhone:function(){return g.qj},enrollPassword:function(){return g.xg},getEmail:function(){return g.OD},getEmailChallenge:function(){return g.hG},getEmails:function(){return g.G5},getPassword:function(){return g.Ij},getPhone:function(){return g.u_},getPhones:function(){return g.Po},getProfile:function(){return g.Ai},getProfileSchema:function(){return g.aF},getSavedTransactionMeta:function(){return y.uN},getTransactionMeta:function(){return y.Co},handleEmailVerifyCallback:function(){return y.Jn},handleInteractionCodeRedirect:function(){return y.Xx},hasSavedInteractionHandle:function(){return y.$0},interact:function(){return y.EW},introspect:function(){return y.L8},isAuthenticator:function(){return y.H},isEmailVerifyCallback:function(){return y.GA},isEmailVerifyCallbackError:function(){return y.gc},isTransactionMetaValid:function(){return y.Wf},isTransactionMetaValidForFlow:function(){return y.bl},isTransactionMetaValidForOptions:function(){return y.UC},mixinAuthn:function(){return m.t},mixinIdx:function(){return y.B_},mixinMyAccount:function(){return g.HT},parseEmailVerifyCallback:function(){return y.mo},poll:function(){return y.$l},proceed:function(){return y.xc},recoverPassword:function(){return y.M4},register:function(){return y.z2},saveTransactionMeta:function(){return y.r0},sendEmailChallenge:function(){return g.ME},sendPhoneChallenge:function(){return g.dv},startTransaction:function(){return y.Yr},unlockAccount:function(){return y.le},updatePassword:function(){return g.gQ},updateProfile:function(){return g.ck},verifyEmailChallenge:function(){return g.T8},verifyPhoneChallenge:function(){return g.Lo}});var e=n(3144),t=n(5671),o=n(136),i=n(2963),a=n(1120),u=n(4602),c=n(4143),s=n(3334),f=n(2144),l=n(6794),p=n(8284),h=n(6736),d={};for(var v in h)["default","OktaAuth"].indexOf(v)<0&&(d[v]=function(e){return h[e]}.bind(0,v));n.d(r,d);var y=n(9999),g=n(1132),m=n(3398);var b=(0,u.S)(),k=(0,c.a)(),w=(0,s.v)(),O=(0,f.Y)(k,b,w),Z=(0,l.H)(O),T=function(n){(0,o.Z)(s,n);var r,u,c=(r=s,u=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=(0,a.Z)(r);if(u){var n=(0,a.Z)(this).constructor;e=Reflect.construct(t,arguments,n)}else e=t.apply(this,arguments);return(0,i.Z)(this,e)});function s(e){return(0,t.Z)(this,s),c.call(this,e)}return(0,e.Z)(s)}((0,p.t)(Z));r.default=T}(),r}()}));


/***/ }),

/***/ "./node_modules/clipboard/lib/clipboard-action.js":
/*!********************************************************!*\
  !*** ./node_modules/clipboard/lib/clipboard-action.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(/*! select */ "./node_modules/select/src/select.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else { var mod; }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.container = options.container;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                this.container.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    this.container.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    this.container.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.trigger) {
                    this.trigger.focus();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

/***/ }),

/***/ "./node_modules/clipboard/lib/clipboard.js":
/*!*************************************************!*\
  !*** ./node_modules/clipboard/lib/clipboard.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(/*! ./clipboard-action */ "./node_modules/clipboard/lib/clipboard-action.js"), __webpack_require__(/*! tiny-emitter */ "./node_modules/tiny-emitter/index.js"), __webpack_require__(/*! good-listener */ "./node_modules/good-listener/src/listen.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else { var mod; }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    container: this.container,
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

/***/ }),

/***/ "./node_modules/cross-fetch/dist/browser-ponyfill.js":
/*!***********************************************************!*\
  !*** ./node_modules/cross-fetch/dist/browser-ponyfill.js ***!
  \***********************************************************/
/***/ (function(module, exports) {

var global = typeof self !== 'undefined' ? self : this;
var __self__ = (function () {
function F() {
this.fetch = false;
this.DOMException = global.DOMException
}
F.prototype = global;
return new F();
})();
(function(self) {

var irrelevant = (function (exports) {

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ "./node_modules/delegate/src/closest.js":
/*!**********************************************!*\
  !*** ./node_modules/delegate/src/closest.js ***!
  \**********************************************/
/***/ (function(module) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),

/***/ "./node_modules/delegate/src/delegate.js":
/*!***********************************************!*\
  !*** ./node_modules/delegate/src/delegate.js ***!
  \***********************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var closest = __webpack_require__(/*! ./closest */ "./node_modules/delegate/src/closest.js");

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),

/***/ "./node_modules/good-listener/src/is.js":
/*!**********************************************!*\
  !*** ./node_modules/good-listener/src/is.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),

/***/ "./node_modules/good-listener/src/listen.js":
/*!**************************************************!*\
  !*** ./node_modules/good-listener/src/listen.js ***!
  \**************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var is = __webpack_require__(/*! ./is */ "./node_modules/good-listener/src/is.js");
var delegate = __webpack_require__(/*! delegate */ "./node_modules/delegate/src/delegate.js");

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),

/***/ "./node_modules/jquery/dist/jquery.js":
/*!********************************************!*\
  !*** ./node_modules/jquery/dist/jquery.js ***!
  \********************************************/
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.6.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2022-08-26T17:52Z
 */
( function( global, factory ) {

	"use strict";

	if (  true && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.6.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						// Support: Chrome 86+
						// In Chrome, if an element having a focusout handler is blurred by
						// clicking outside of it, it invokes the handler synchronously. If
						// that handler calls `.remove()` on the element, the data is cleared,
						// leaving `result` undefined. We need to guard against this.
						return result && result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );

var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		// trim whitespace for custom property (issue gh-4926)
		if ( isCustomProp ) {

			// rtrim treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" );
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),

/***/ "./node_modules/q/q.js":
/*!*****************************!*\
  !*** ./node_modules/q/q.js ***!
  \*****************************/
/***/ (function(module) {

// vim:ts=4:sts=4:sw=4:
/*!
 *
 * Copyright 2009-2012 Kris Kowal under the terms of the MIT
 * license found at http://github.com/kriskowal/q/raw/master/LICENSE
 *
 * With parts by Tyler Close
 * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
 * at http://www.opensource.org/licenses/mit-license.html
 * Forked at ref_send.js version: 2009-05-11
 *
 * With parts by Mark Miller
 * Copyright (C) 2011 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

(function (definition) {
    "use strict";

    // This file will function properly as a <script> tag, or a module
    // using CommonJS and NodeJS or RequireJS module formats.  In
    // Common/Node/RequireJS, the module exports the Q API and when
    // executed as a simple <script>, it creates a Q global instead.

    // Montage Require
    if (typeof bootstrap === "function") {
        bootstrap("promise", definition);

    // CommonJS
    } else if (true) {
        module.exports = definition();

    // RequireJS
    } else { var previousQ, global; }

})(function () {
"use strict";

var hasStacks = false;
try {
    throw new Error();
} catch (e) {
    hasStacks = !!e.stack;
}

// All code after this point will be filtered from stack traces reported
// by Q.
var qStartingLine = captureLine();
var qFileName;

// shims

// used for fallback in "allResolved"
var noop = function () {};

// Use the fastest possible means to execute a task in a future turn
// of the event loop.
var nextTick =(function () {
    // linked list of tasks (single, with head node)
    var head = {task: void 0, next: null};
    var tail = head;
    var flushing = false;
    var requestTick = void 0;
    var isNodeJS = false;
    // queue for late tasks, used by unhandled rejection tracking
    var laterQueue = [];

    function flush() {
        /* jshint loopfunc: true */
        var task, domain;

        while (head.next) {
            head = head.next;
            task = head.task;
            head.task = void 0;
            domain = head.domain;

            if (domain) {
                head.domain = void 0;
                domain.enter();
            }
            runSingle(task, domain);

        }
        while (laterQueue.length) {
            task = laterQueue.pop();
            runSingle(task);
        }
        flushing = false;
    }
    // runs a single function in the async queue
    function runSingle(task, domain) {
        try {
            task();

        } catch (e) {
            if (isNodeJS) {
                // In node, uncaught exceptions are considered fatal errors.
                // Re-throw them synchronously to interrupt flushing!

                // Ensure continuation if the uncaught exception is suppressed
                // listening "uncaughtException" events (as domains does).
                // Continue in next event to avoid tick recursion.
                if (domain) {
                    domain.exit();
                }
                setTimeout(flush, 0);
                if (domain) {
                    domain.enter();
                }

                throw e;

            } else {
                // In browsers, uncaught exceptions are not fatal.
                // Re-throw them asynchronously to avoid slow-downs.
                setTimeout(function () {
                    throw e;
                }, 0);
            }
        }

        if (domain) {
            domain.exit();
        }
    }

    nextTick = function (task) {
        tail = tail.next = {
            task: task,
            domain: isNodeJS && process.domain,
            next: null
        };

        if (!flushing) {
            flushing = true;
            requestTick();
        }
    };

    if (typeof process === "object" &&
        process.toString() === "[object process]" && process.nextTick) {
        // Ensure Q is in a real Node environment, with a `process.nextTick`.
        // To see through fake Node environments:
        // * Mocha test runner - exposes a `process` global without a `nextTick`
        // * Browserify - exposes a `process.nexTick` function that uses
        //   `setTimeout`. In this case `setImmediate` is preferred because
        //    it is faster. Browserify's `process.toString()` yields
        //   "[object Object]", while in a real Node environment
        //   `process.nextTick()` yields "[object process]".
        isNodeJS = true;

        requestTick = function () {
            process.nextTick(flush);
        };

    } else if (typeof setImmediate === "function") {
        // In IE10, Node.js 0.9+, or https://github.com/NobleJS/setImmediate
        if (typeof window !== "undefined") {
            requestTick = setImmediate.bind(window, flush);
        } else {
            requestTick = function () {
                setImmediate(flush);
            };
        }

    } else if (typeof MessageChannel !== "undefined") {
        // modern browsers
        // http://www.nonblocking.io/2011/06/windownexttick.html
        var channel = new MessageChannel();
        // At least Safari Version 6.0.5 (8536.30.1) intermittently cannot create
        // working message ports the first time a page loads.
        channel.port1.onmessage = function () {
            requestTick = requestPortTick;
            channel.port1.onmessage = flush;
            flush();
        };
        var requestPortTick = function () {
            // Opera requires us to provide a message payload, regardless of
            // whether we use it.
            channel.port2.postMessage(0);
        };
        requestTick = function () {
            setTimeout(flush, 0);
            requestPortTick();
        };

    } else {
        // old browsers
        requestTick = function () {
            setTimeout(flush, 0);
        };
    }
    // runs a task after all other tasks have been run
    // this is useful for unhandled rejection tracking that needs to happen
    // after all `then`d tasks have been run.
    nextTick.runAfter = function (task) {
        laterQueue.push(task);
        if (!flushing) {
            flushing = true;
            requestTick();
        }
    };
    return nextTick;
})();

// Attempt to make generics safe in the face of downstream
// modifications.
// There is no situation where this is necessary.
// If you need a security guarantee, these primordials need to be
// deeply frozen anyway, and if you don’t need a security guarantee,
// this is just plain paranoid.
// However, this **might** have the nice side-effect of reducing the size of
// the minified code by reducing x.call() to merely x()
// See Mark Miller’s explanation of what this does.
// http://wiki.ecmascript.org/doku.php?id=conventions:safe_meta_programming
var call = Function.call;
function uncurryThis(f) {
    return function () {
        return call.apply(f, arguments);
    };
}
// This is equivalent, but slower:
// uncurryThis = Function_bind.bind(Function_bind.call);
// http://jsperf.com/uncurrythis

var array_slice = uncurryThis(Array.prototype.slice);

var array_reduce = uncurryThis(
    Array.prototype.reduce || function (callback, basis) {
        var index = 0,
            length = this.length;
        // concerning the initial value, if one is not provided
        if (arguments.length === 1) {
            // seek to the first value in the array, accounting
            // for the possibility that is is a sparse array
            do {
                if (index in this) {
                    basis = this[index++];
                    break;
                }
                if (++index >= length) {
                    throw new TypeError();
                }
            } while (1);
        }
        // reduce
        for (; index < length; index++) {
            // account for the possibility that the array is sparse
            if (index in this) {
                basis = callback(basis, this[index], index);
            }
        }
        return basis;
    }
);

var array_indexOf = uncurryThis(
    Array.prototype.indexOf || function (value) {
        // not a very good shim, but good enough for our one use of it
        for (var i = 0; i < this.length; i++) {
            if (this[i] === value) {
                return i;
            }
        }
        return -1;
    }
);

var array_map = uncurryThis(
    Array.prototype.map || function (callback, thisp) {
        var self = this;
        var collect = [];
        array_reduce(self, function (undefined, value, index) {
            collect.push(callback.call(thisp, value, index, self));
        }, void 0);
        return collect;
    }
);

var object_create = Object.create || function (prototype) {
    function Type() { }
    Type.prototype = prototype;
    return new Type();
};

var object_hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);

var object_keys = Object.keys || function (object) {
    var keys = [];
    for (var key in object) {
        if (object_hasOwnProperty(object, key)) {
            keys.push(key);
        }
    }
    return keys;
};

var object_toString = uncurryThis(Object.prototype.toString);

function isObject(value) {
    return value === Object(value);
}

// generator related shims

// FIXME: Remove this function once ES6 generators are in SpiderMonkey.
function isStopIteration(exception) {
    return (
        object_toString(exception) === "[object StopIteration]" ||
        exception instanceof QReturnValue
    );
}

// FIXME: Remove this helper and Q.return once ES6 generators are in
// SpiderMonkey.
var QReturnValue;
if (typeof ReturnValue !== "undefined") {
    QReturnValue = ReturnValue;
} else {
    QReturnValue = function (value) {
        this.value = value;
    };
}

// long stack traces

var STACK_JUMP_SEPARATOR = "From previous event:";

function makeStackTraceLong(error, promise) {
    // If possible, transform the error stack trace by removing Node and Q
    // cruft, then concatenating with the stack trace of `promise`. See #57.
    if (hasStacks &&
        promise.stack &&
        typeof error === "object" &&
        error !== null &&
        error.stack &&
        error.stack.indexOf(STACK_JUMP_SEPARATOR) === -1
    ) {
        var stacks = [];
        for (var p = promise; !!p; p = p.source) {
            if (p.stack) {
                stacks.unshift(p.stack);
            }
        }
        stacks.unshift(error.stack);

        var concatedStacks = stacks.join("\n" + STACK_JUMP_SEPARATOR + "\n");
        error.stack = filterStackString(concatedStacks);
    }
}

function filterStackString(stackString) {
    var lines = stackString.split("\n");
    var desiredLines = [];
    for (var i = 0; i < lines.length; ++i) {
        var line = lines[i];

        if (!isInternalFrame(line) && !isNodeFrame(line) && line) {
            desiredLines.push(line);
        }
    }
    return desiredLines.join("\n");
}

function isNodeFrame(stackLine) {
    return stackLine.indexOf("(module.js:") !== -1 ||
           stackLine.indexOf("(node.js:") !== -1;
}

function getFileNameAndLineNumber(stackLine) {
    // Named functions: "at functionName (filename:lineNumber:columnNumber)"
    // In IE10 function name can have spaces ("Anonymous function") O_o
    var attempt1 = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(stackLine);
    if (attempt1) {
        return [attempt1[1], Number(attempt1[2])];
    }

    // Anonymous functions: "at filename:lineNumber:columnNumber"
    var attempt2 = /at ([^ ]+):(\d+):(?:\d+)$/.exec(stackLine);
    if (attempt2) {
        return [attempt2[1], Number(attempt2[2])];
    }

    // Firefox style: "function@filename:lineNumber or @filename:lineNumber"
    var attempt3 = /.*@(.+):(\d+)$/.exec(stackLine);
    if (attempt3) {
        return [attempt3[1], Number(attempt3[2])];
    }
}

function isInternalFrame(stackLine) {
    var fileNameAndLineNumber = getFileNameAndLineNumber(stackLine);

    if (!fileNameAndLineNumber) {
        return false;
    }

    var fileName = fileNameAndLineNumber[0];
    var lineNumber = fileNameAndLineNumber[1];

    return fileName === qFileName &&
        lineNumber >= qStartingLine &&
        lineNumber <= qEndingLine;
}

// discover own file name and line number range for filtering stack
// traces
function captureLine() {
    if (!hasStacks) {
        return;
    }

    try {
        throw new Error();
    } catch (e) {
        var lines = e.stack.split("\n");
        var firstLine = lines[0].indexOf("@") > 0 ? lines[1] : lines[2];
        var fileNameAndLineNumber = getFileNameAndLineNumber(firstLine);
        if (!fileNameAndLineNumber) {
            return;
        }

        qFileName = fileNameAndLineNumber[0];
        return fileNameAndLineNumber[1];
    }
}

function deprecate(callback, name, alternative) {
    return function () {
        if (typeof console !== "undefined" &&
            typeof console.warn === "function") {
            console.warn(name + " is deprecated, use " + alternative +
                         " instead.", new Error("").stack);
        }
        return callback.apply(callback, arguments);
    };
}

// end of shims
// beginning of real work

/**
 * Constructs a promise for an immediate reference, passes promises through, or
 * coerces promises from different systems.
 * @param value immediate reference or promise
 */
function Q(value) {
    // If the object is already a Promise, return it directly.  This enables
    // the resolve function to both be used to created references from objects,
    // but to tolerably coerce non-promises to promises.
    if (value instanceof Promise) {
        return value;
    }

    // assimilate thenables
    if (isPromiseAlike(value)) {
        return coerce(value);
    } else {
        return fulfill(value);
    }
}
Q.resolve = Q;

/**
 * Performs a task in a future turn of the event loop.
 * @param {Function} task
 */
Q.nextTick = nextTick;

/**
 * Controls whether or not long stack traces will be on
 */
Q.longStackSupport = false;

// enable long stacks if Q_DEBUG is set
if (typeof process === "object" && process && process.env && process.env.Q_DEBUG) {
    Q.longStackSupport = true;
}

/**
 * Constructs a {promise, resolve, reject} object.
 *
 * `resolve` is a callback to invoke with a more resolved value for the
 * promise. To fulfill the promise, invoke `resolve` with any value that is
 * not a thenable. To reject the promise, invoke `resolve` with a rejected
 * thenable, or invoke `reject` with the reason directly. To resolve the
 * promise to another thenable, thus putting it in the same state, invoke
 * `resolve` with that other thenable.
 */
Q.defer = defer;
function defer() {
    // if "messages" is an "Array", that indicates that the promise has not yet
    // been resolved.  If it is "undefined", it has been resolved.  Each
    // element of the messages array is itself an array of complete arguments to
    // forward to the resolved promise.  We coerce the resolution value to a
    // promise using the `resolve` function because it handles both fully
    // non-thenable values and other thenables gracefully.
    var messages = [], progressListeners = [], resolvedPromise;

    var deferred = object_create(defer.prototype);
    var promise = object_create(Promise.prototype);

    promise.promiseDispatch = function (resolve, op, operands) {
        var args = array_slice(arguments);
        if (messages) {
            messages.push(args);
            if (op === "when" && operands[1]) { // progress operand
                progressListeners.push(operands[1]);
            }
        } else {
            Q.nextTick(function () {
                resolvedPromise.promiseDispatch.apply(resolvedPromise, args);
            });
        }
    };

    // XXX deprecated
    promise.valueOf = function () {
        if (messages) {
            return promise;
        }
        var nearerValue = nearer(resolvedPromise);
        if (isPromise(nearerValue)) {
            resolvedPromise = nearerValue; // shorten chain
        }
        return nearerValue;
    };

    promise.inspect = function () {
        if (!resolvedPromise) {
            return { state: "pending" };
        }
        return resolvedPromise.inspect();
    };

    if (Q.longStackSupport && hasStacks) {
        try {
            throw new Error();
        } catch (e) {
            // NOTE: don't try to use `Error.captureStackTrace` or transfer the
            // accessor around; that causes memory leaks as per GH-111. Just
            // reify the stack trace as a string ASAP.
            //
            // At the same time, cut off the first line; it's always just
            // "[object Promise]\n", as per the `toString`.
            promise.stack = e.stack.substring(e.stack.indexOf("\n") + 1);
        }
    }

    // NOTE: we do the checks for `resolvedPromise` in each method, instead of
    // consolidating them into `become`, since otherwise we'd create new
    // promises with the lines `become(whatever(value))`. See e.g. GH-252.

    function become(newPromise) {
        resolvedPromise = newPromise;
        promise.source = newPromise;

        array_reduce(messages, function (undefined, message) {
            Q.nextTick(function () {
                newPromise.promiseDispatch.apply(newPromise, message);
            });
        }, void 0);

        messages = void 0;
        progressListeners = void 0;
    }

    deferred.promise = promise;
    deferred.resolve = function (value) {
        if (resolvedPromise) {
            return;
        }

        become(Q(value));
    };

    deferred.fulfill = function (value) {
        if (resolvedPromise) {
            return;
        }

        become(fulfill(value));
    };
    deferred.reject = function (reason) {
        if (resolvedPromise) {
            return;
        }

        become(reject(reason));
    };
    deferred.notify = function (progress) {
        if (resolvedPromise) {
            return;
        }

        array_reduce(progressListeners, function (undefined, progressListener) {
            Q.nextTick(function () {
                progressListener(progress);
            });
        }, void 0);
    };

    return deferred;
}

/**
 * Creates a Node-style callback that will resolve or reject the deferred
 * promise.
 * @returns a nodeback
 */
defer.prototype.makeNodeResolver = function () {
    var self = this;
    return function (error, value) {
        if (error) {
            self.reject(error);
        } else if (arguments.length > 2) {
            self.resolve(array_slice(arguments, 1));
        } else {
            self.resolve(value);
        }
    };
};

/**
 * @param resolver {Function} a function that returns nothing and accepts
 * the resolve, reject, and notify functions for a deferred.
 * @returns a promise that may be resolved with the given resolve and reject
 * functions, or rejected by a thrown exception in resolver
 */
Q.Promise = promise; // ES6
Q.promise = promise;
function promise(resolver) {
    if (typeof resolver !== "function") {
        throw new TypeError("resolver must be a function.");
    }
    var deferred = defer();
    try {
        resolver(deferred.resolve, deferred.reject, deferred.notify);
    } catch (reason) {
        deferred.reject(reason);
    }
    return deferred.promise;
}

promise.race = race; // ES6
promise.all = all; // ES6
promise.reject = reject; // ES6
promise.resolve = Q; // ES6

// XXX experimental.  This method is a way to denote that a local value is
// serializable and should be immediately dispatched to a remote upon request,
// instead of passing a reference.
Q.passByCopy = function (object) {
    //freeze(object);
    //passByCopies.set(object, true);
    return object;
};

Promise.prototype.passByCopy = function () {
    //freeze(object);
    //passByCopies.set(object, true);
    return this;
};

/**
 * If two promises eventually fulfill to the same value, promises that value,
 * but otherwise rejects.
 * @param x {Any*}
 * @param y {Any*}
 * @returns {Any*} a promise for x and y if they are the same, but a rejection
 * otherwise.
 *
 */
Q.join = function (x, y) {
    return Q(x).join(y);
};

Promise.prototype.join = function (that) {
    return Q([this, that]).spread(function (x, y) {
        if (x === y) {
            // TODO: "===" should be Object.is or equiv
            return x;
        } else {
            throw new Error("Can't join: not the same: " + x + " " + y);
        }
    });
};

/**
 * Returns a promise for the first of an array of promises to become settled.
 * @param answers {Array[Any*]} promises to race
 * @returns {Any*} the first promise to be settled
 */
Q.race = race;
function race(answerPs) {
    return promise(function (resolve, reject) {
        // Switch to this once we can assume at least ES5
        // answerPs.forEach(function (answerP) {
        //     Q(answerP).then(resolve, reject);
        // });
        // Use this in the meantime
        for (var i = 0, len = answerPs.length; i < len; i++) {
            Q(answerPs[i]).then(resolve, reject);
        }
    });
}

Promise.prototype.race = function () {
    return this.then(Q.race);
};

/**
 * Constructs a Promise with a promise descriptor object and optional fallback
 * function.  The descriptor contains methods like when(rejected), get(name),
 * set(name, value), post(name, args), and delete(name), which all
 * return either a value, a promise for a value, or a rejection.  The fallback
 * accepts the operation name, a resolver, and any further arguments that would
 * have been forwarded to the appropriate method above had a method been
 * provided with the proper name.  The API makes no guarantees about the nature
 * of the returned object, apart from that it is usable whereever promises are
 * bought and sold.
 */
Q.makePromise = Promise;
function Promise(descriptor, fallback, inspect) {
    if (fallback === void 0) {
        fallback = function (op) {
            return reject(new Error(
                "Promise does not support operation: " + op
            ));
        };
    }
    if (inspect === void 0) {
        inspect = function () {
            return {state: "unknown"};
        };
    }

    var promise = object_create(Promise.prototype);

    promise.promiseDispatch = function (resolve, op, args) {
        var result;
        try {
            if (descriptor[op]) {
                result = descriptor[op].apply(promise, args);
            } else {
                result = fallback.call(promise, op, args);
            }
        } catch (exception) {
            result = reject(exception);
        }
        if (resolve) {
            resolve(result);
        }
    };

    promise.inspect = inspect;

    // XXX deprecated `valueOf` and `exception` support
    if (inspect) {
        var inspected = inspect();
        if (inspected.state === "rejected") {
            promise.exception = inspected.reason;
        }

        promise.valueOf = function () {
            var inspected = inspect();
            if (inspected.state === "pending" ||
                inspected.state === "rejected") {
                return promise;
            }
            return inspected.value;
        };
    }

    return promise;
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.then = function (fulfilled, rejected, progressed) {
    var self = this;
    var deferred = defer();
    var done = false;   // ensure the untrusted promise makes at most a
                        // single call to one of the callbacks

    function _fulfilled(value) {
        try {
            return typeof fulfilled === "function" ? fulfilled(value) : value;
        } catch (exception) {
            return reject(exception);
        }
    }

    function _rejected(exception) {
        if (typeof rejected === "function") {
            makeStackTraceLong(exception, self);
            try {
                return rejected(exception);
            } catch (newException) {
                return reject(newException);
            }
        }
        return reject(exception);
    }

    function _progressed(value) {
        return typeof progressed === "function" ? progressed(value) : value;
    }

    Q.nextTick(function () {
        self.promiseDispatch(function (value) {
            if (done) {
                return;
            }
            done = true;

            deferred.resolve(_fulfilled(value));
        }, "when", [function (exception) {
            if (done) {
                return;
            }
            done = true;

            deferred.resolve(_rejected(exception));
        }]);
    });

    // Progress propagator need to be attached in the current tick.
    self.promiseDispatch(void 0, "when", [void 0, function (value) {
        var newValue;
        var threw = false;
        try {
            newValue = _progressed(value);
        } catch (e) {
            threw = true;
            if (Q.onerror) {
                Q.onerror(e);
            } else {
                throw e;
            }
        }

        if (!threw) {
            deferred.notify(newValue);
        }
    }]);

    return deferred.promise;
};

Q.tap = function (promise, callback) {
    return Q(promise).tap(callback);
};

/**
 * Works almost like "finally", but not called for rejections.
 * Original resolution value is passed through callback unaffected.
 * Callback may return a promise that will be awaited for.
 * @param {Function} callback
 * @returns {Q.Promise}
 * @example
 * doSomething()
 *   .then(...)
 *   .tap(console.log)
 *   .then(...);
 */
Promise.prototype.tap = function (callback) {
    callback = Q(callback);

    return this.then(function (value) {
        return callback.fcall(value).thenResolve(value);
    });
};

/**
 * Registers an observer on a promise.
 *
 * Guarantees:
 *
 * 1. that fulfilled and rejected will be called only once.
 * 2. that either the fulfilled callback or the rejected callback will be
 *    called, but not both.
 * 3. that fulfilled and rejected will not be called in this turn.
 *
 * @param value      promise or immediate reference to observe
 * @param fulfilled  function to be called with the fulfilled value
 * @param rejected   function to be called with the rejection exception
 * @param progressed function to be called on any progress notifications
 * @return promise for the return value from the invoked callback
 */
Q.when = when;
function when(value, fulfilled, rejected, progressed) {
    return Q(value).then(fulfilled, rejected, progressed);
}

Promise.prototype.thenResolve = function (value) {
    return this.then(function () { return value; });
};

Q.thenResolve = function (promise, value) {
    return Q(promise).thenResolve(value);
};

Promise.prototype.thenReject = function (reason) {
    return this.then(function () { throw reason; });
};

Q.thenReject = function (promise, reason) {
    return Q(promise).thenReject(reason);
};

/**
 * If an object is not a promise, it is as "near" as possible.
 * If a promise is rejected, it is as "near" as possible too.
 * If it’s a fulfilled promise, the fulfillment value is nearer.
 * If it’s a deferred promise and the deferred has been resolved, the
 * resolution is "nearer".
 * @param object
 * @returns most resolved (nearest) form of the object
 */

// XXX should we re-do this?
Q.nearer = nearer;
function nearer(value) {
    if (isPromise(value)) {
        var inspected = value.inspect();
        if (inspected.state === "fulfilled") {
            return inspected.value;
        }
    }
    return value;
}

/**
 * @returns whether the given object is a promise.
 * Otherwise it is a fulfilled value.
 */
Q.isPromise = isPromise;
function isPromise(object) {
    return object instanceof Promise;
}

Q.isPromiseAlike = isPromiseAlike;
function isPromiseAlike(object) {
    return isObject(object) && typeof object.then === "function";
}

/**
 * @returns whether the given object is a pending promise, meaning not
 * fulfilled or rejected.
 */
Q.isPending = isPending;
function isPending(object) {
    return isPromise(object) && object.inspect().state === "pending";
}

Promise.prototype.isPending = function () {
    return this.inspect().state === "pending";
};

/**
 * @returns whether the given object is a value or fulfilled
 * promise.
 */
Q.isFulfilled = isFulfilled;
function isFulfilled(object) {
    return !isPromise(object) || object.inspect().state === "fulfilled";
}

Promise.prototype.isFulfilled = function () {
    return this.inspect().state === "fulfilled";
};

/**
 * @returns whether the given object is a rejected promise.
 */
Q.isRejected = isRejected;
function isRejected(object) {
    return isPromise(object) && object.inspect().state === "rejected";
}

Promise.prototype.isRejected = function () {
    return this.inspect().state === "rejected";
};

//// BEGIN UNHANDLED REJECTION TRACKING

// This promise library consumes exceptions thrown in handlers so they can be
// handled by a subsequent promise.  The exceptions get added to this array when
// they are created, and removed when they are handled.  Note that in ES6 or
// shimmed environments, this would naturally be a `Set`.
var unhandledReasons = [];
var unhandledRejections = [];
var reportedUnhandledRejections = [];
var trackUnhandledRejections = true;

function resetUnhandledRejections() {
    unhandledReasons.length = 0;
    unhandledRejections.length = 0;

    if (!trackUnhandledRejections) {
        trackUnhandledRejections = true;
    }
}

function trackRejection(promise, reason) {
    if (!trackUnhandledRejections) {
        return;
    }
    if (typeof process === "object" && typeof process.emit === "function") {
        Q.nextTick.runAfter(function () {
            if (array_indexOf(unhandledRejections, promise) !== -1) {
                process.emit("unhandledRejection", reason, promise);
                reportedUnhandledRejections.push(promise);
            }
        });
    }

    unhandledRejections.push(promise);
    if (reason && typeof reason.stack !== "undefined") {
        unhandledReasons.push(reason.stack);
    } else {
        unhandledReasons.push("(no stack) " + reason);
    }
}

function untrackRejection(promise) {
    if (!trackUnhandledRejections) {
        return;
    }

    var at = array_indexOf(unhandledRejections, promise);
    if (at !== -1) {
        if (typeof process === "object" && typeof process.emit === "function") {
            Q.nextTick.runAfter(function () {
                var atReport = array_indexOf(reportedUnhandledRejections, promise);
                if (atReport !== -1) {
                    process.emit("rejectionHandled", unhandledReasons[at], promise);
                    reportedUnhandledRejections.splice(atReport, 1);
                }
            });
        }
        unhandledRejections.splice(at, 1);
        unhandledReasons.splice(at, 1);
    }
}

Q.resetUnhandledRejections = resetUnhandledRejections;

Q.getUnhandledReasons = function () {
    // Make a copy so that consumers can't interfere with our internal state.
    return unhandledReasons.slice();
};

Q.stopUnhandledRejectionTracking = function () {
    resetUnhandledRejections();
    trackUnhandledRejections = false;
};

resetUnhandledRejections();

//// END UNHANDLED REJECTION TRACKING

/**
 * Constructs a rejected promise.
 * @param reason value describing the failure
 */
Q.reject = reject;
function reject(reason) {
    var rejection = Promise({
        "when": function (rejected) {
            // note that the error has been handled
            if (rejected) {
                untrackRejection(this);
            }
            return rejected ? rejected(reason) : this;
        }
    }, function fallback() {
        return this;
    }, function inspect() {
        return { state: "rejected", reason: reason };
    });

    // Note that the reason has not been handled.
    trackRejection(rejection, reason);

    return rejection;
}

/**
 * Constructs a fulfilled promise for an immediate reference.
 * @param value immediate reference
 */
Q.fulfill = fulfill;
function fulfill(value) {
    return Promise({
        "when": function () {
            return value;
        },
        "get": function (name) {
            return value[name];
        },
        "set": function (name, rhs) {
            value[name] = rhs;
        },
        "delete": function (name) {
            delete value[name];
        },
        "post": function (name, args) {
            // Mark Miller proposes that post with no name should apply a
            // promised function.
            if (name === null || name === void 0) {
                return value.apply(void 0, args);
            } else {
                return value[name].apply(value, args);
            }
        },
        "apply": function (thisp, args) {
            return value.apply(thisp, args);
        },
        "keys": function () {
            return object_keys(value);
        }
    }, void 0, function inspect() {
        return { state: "fulfilled", value: value };
    });
}

/**
 * Converts thenables to Q promises.
 * @param promise thenable promise
 * @returns a Q promise
 */
function coerce(promise) {
    var deferred = defer();
    Q.nextTick(function () {
        try {
            promise.then(deferred.resolve, deferred.reject, deferred.notify);
        } catch (exception) {
            deferred.reject(exception);
        }
    });
    return deferred.promise;
}

/**
 * Annotates an object such that it will never be
 * transferred away from this process over any promise
 * communication channel.
 * @param object
 * @returns promise a wrapping of that object that
 * additionally responds to the "isDef" message
 * without a rejection.
 */
Q.master = master;
function master(object) {
    return Promise({
        "isDef": function () {}
    }, function fallback(op, args) {
        return dispatch(object, op, args);
    }, function () {
        return Q(object).inspect();
    });
}

/**
 * Spreads the values of a promised array of arguments into the
 * fulfillment callback.
 * @param fulfilled callback that receives variadic arguments from the
 * promised array
 * @param rejected callback that receives the exception if the promise
 * is rejected.
 * @returns a promise for the return value or thrown exception of
 * either callback.
 */
Q.spread = spread;
function spread(value, fulfilled, rejected) {
    return Q(value).spread(fulfilled, rejected);
}

Promise.prototype.spread = function (fulfilled, rejected) {
    return this.all().then(function (array) {
        return fulfilled.apply(void 0, array);
    }, rejected);
};

/**
 * The async function is a decorator for generator functions, turning
 * them into asynchronous generators.  Although generators are only part
 * of the newest ECMAScript 6 drafts, this code does not cause syntax
 * errors in older engines.  This code should continue to work and will
 * in fact improve over time as the language improves.
 *
 * ES6 generators are currently part of V8 version 3.19 with the
 * --harmony-generators runtime flag enabled.  SpiderMonkey has had them
 * for longer, but under an older Python-inspired form.  This function
 * works on both kinds of generators.
 *
 * Decorates a generator function such that:
 *  - it may yield promises
 *  - execution will continue when that promise is fulfilled
 *  - the value of the yield expression will be the fulfilled value
 *  - it returns a promise for the return value (when the generator
 *    stops iterating)
 *  - the decorated function returns a promise for the return value
 *    of the generator or the first rejected promise among those
 *    yielded.
 *  - if an error is thrown in the generator, it propagates through
 *    every following yield until it is caught, or until it escapes
 *    the generator function altogether, and is translated into a
 *    rejection for the promise returned by the decorated generator.
 */
Q.async = async;
function async(makeGenerator) {
    return function () {
        // when verb is "send", arg is a value
        // when verb is "throw", arg is an exception
        function continuer(verb, arg) {
            var result;

            // Until V8 3.19 / Chromium 29 is released, SpiderMonkey is the only
            // engine that has a deployed base of browsers that support generators.
            // However, SM's generators use the Python-inspired semantics of
            // outdated ES6 drafts.  We would like to support ES6, but we'd also
            // like to make it possible to use generators in deployed browsers, so
            // we also support Python-style generators.  At some point we can remove
            // this block.

            if (typeof StopIteration === "undefined") {
                // ES6 Generators
                try {
                    result = generator[verb](arg);
                } catch (exception) {
                    return reject(exception);
                }
                if (result.done) {
                    return Q(result.value);
                } else {
                    return when(result.value, callback, errback);
                }
            } else {
                // SpiderMonkey Generators
                // FIXME: Remove this case when SM does ES6 generators.
                try {
                    result = generator[verb](arg);
                } catch (exception) {
                    if (isStopIteration(exception)) {
                        return Q(exception.value);
                    } else {
                        return reject(exception);
                    }
                }
                return when(result, callback, errback);
            }
        }
        var generator = makeGenerator.apply(this, arguments);
        var callback = continuer.bind(continuer, "next");
        var errback = continuer.bind(continuer, "throw");
        return callback();
    };
}

/**
 * The spawn function is a small wrapper around async that immediately
 * calls the generator and also ends the promise chain, so that any
 * unhandled errors are thrown instead of forwarded to the error
 * handler. This is useful because it's extremely common to run
 * generators at the top-level to work with libraries.
 */
Q.spawn = spawn;
function spawn(makeGenerator) {
    Q.done(Q.async(makeGenerator)());
}

// FIXME: Remove this interface once ES6 generators are in SpiderMonkey.
/**
 * Throws a ReturnValue exception to stop an asynchronous generator.
 *
 * This interface is a stop-gap measure to support generator return
 * values in older Firefox/SpiderMonkey.  In browsers that support ES6
 * generators like Chromium 29, just use "return" in your generator
 * functions.
 *
 * @param value the return value for the surrounding generator
 * @throws ReturnValue exception with the value.
 * @example
 * // ES6 style
 * Q.async(function* () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      return foo + bar;
 * })
 * // Older SpiderMonkey style
 * Q.async(function () {
 *      var foo = yield getFooPromise();
 *      var bar = yield getBarPromise();
 *      Q.return(foo + bar);
 * })
 */
Q["return"] = _return;
function _return(value) {
    throw new QReturnValue(value);
}

/**
 * The promised function decorator ensures that any promise arguments
 * are settled and passed as values (`this` is also settled and passed
 * as a value).  It will also ensure that the result of a function is
 * always a promise.
 *
 * @example
 * var add = Q.promised(function (a, b) {
 *     return a + b;
 * });
 * add(Q(a), Q(B));
 *
 * @param {function} callback The function to decorate
 * @returns {function} a function that has been decorated.
 */
Q.promised = promised;
function promised(callback) {
    return function () {
        return spread([this, all(arguments)], function (self, args) {
            return callback.apply(self, args);
        });
    };
}

/**
 * sends a message to a value in a future turn
 * @param object* the recipient
 * @param op the name of the message operation, e.g., "when",
 * @param args further arguments to be forwarded to the operation
 * @returns result {Promise} a promise for the result of the operation
 */
Q.dispatch = dispatch;
function dispatch(object, op, args) {
    return Q(object).dispatch(op, args);
}

Promise.prototype.dispatch = function (op, args) {
    var self = this;
    var deferred = defer();
    Q.nextTick(function () {
        self.promiseDispatch(deferred.resolve, op, args);
    });
    return deferred.promise;
};

/**
 * Gets the value of a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to get
 * @return promise for the property value
 */
Q.get = function (object, key) {
    return Q(object).dispatch("get", [key]);
};

Promise.prototype.get = function (key) {
    return this.dispatch("get", [key]);
};

/**
 * Sets the value of a property in a future turn.
 * @param object    promise or immediate reference for object object
 * @param name      name of property to set
 * @param value     new value of property
 * @return promise for the return value
 */
Q.set = function (object, key, value) {
    return Q(object).dispatch("set", [key, value]);
};

Promise.prototype.set = function (key, value) {
    return this.dispatch("set", [key, value]);
};

/**
 * Deletes a property in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of property to delete
 * @return promise for the return value
 */
Q.del = // XXX legacy
Q["delete"] = function (object, key) {
    return Q(object).dispatch("delete", [key]);
};

Promise.prototype.del = // XXX legacy
Promise.prototype["delete"] = function (key) {
    return this.dispatch("delete", [key]);
};

/**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param value     a value to post, typically an array of
 *                  invocation arguments for promises that
 *                  are ultimately backed with `resolve` values,
 *                  as opposed to those backed with URLs
 *                  wherein the posted value can be any
 *                  JSON serializable object.
 * @return promise for the return value
 */
// bound locally because it is used by other methods
Q.mapply = // XXX As proposed by "Redsandro"
Q.post = function (object, name, args) {
    return Q(object).dispatch("post", [name, args]);
};

Promise.prototype.mapply = // XXX As proposed by "Redsandro"
Promise.prototype.post = function (name, args) {
    return this.dispatch("post", [name, args]);
};

/**
 * Invokes a method in a future turn.
 * @param object    promise or immediate reference for target object
 * @param name      name of method to invoke
 * @param ...args   array of invocation arguments
 * @return promise for the return value
 */
Q.send = // XXX Mark Miller's proposed parlance
Q.mcall = // XXX As proposed by "Redsandro"
Q.invoke = function (object, name /*...args*/) {
    return Q(object).dispatch("post", [name, array_slice(arguments, 2)]);
};

Promise.prototype.send = // XXX Mark Miller's proposed parlance
Promise.prototype.mcall = // XXX As proposed by "Redsandro"
Promise.prototype.invoke = function (name /*...args*/) {
    return this.dispatch("post", [name, array_slice(arguments, 1)]);
};

/**
 * Applies the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param args      array of application arguments
 */
Q.fapply = function (object, args) {
    return Q(object).dispatch("apply", [void 0, args]);
};

Promise.prototype.fapply = function (args) {
    return this.dispatch("apply", [void 0, args]);
};

/**
 * Calls the promised function in a future turn.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */
Q["try"] =
Q.fcall = function (object /* ...args*/) {
    return Q(object).dispatch("apply", [void 0, array_slice(arguments, 1)]);
};

Promise.prototype.fcall = function (/*...args*/) {
    return this.dispatch("apply", [void 0, array_slice(arguments)]);
};

/**
 * Binds the promised function, transforming return values into a fulfilled
 * promise and thrown errors into a rejected one.
 * @param object    promise or immediate reference for target function
 * @param ...args   array of application arguments
 */
Q.fbind = function (object /*...args*/) {
    var promise = Q(object);
    var args = array_slice(arguments, 1);
    return function fbound() {
        return promise.dispatch("apply", [
            this,
            args.concat(array_slice(arguments))
        ]);
    };
};
Promise.prototype.fbind = function (/*...args*/) {
    var promise = this;
    var args = array_slice(arguments);
    return function fbound() {
        return promise.dispatch("apply", [
            this,
            args.concat(array_slice(arguments))
        ]);
    };
};

/**
 * Requests the names of the owned properties of a promised
 * object in a future turn.
 * @param object    promise or immediate reference for target object
 * @return promise for the keys of the eventually settled object
 */
Q.keys = function (object) {
    return Q(object).dispatch("keys", []);
};

Promise.prototype.keys = function () {
    return this.dispatch("keys", []);
};

/**
 * Turns an array of promises into a promise for an array.  If any of
 * the promises gets rejected, the whole array is rejected immediately.
 * @param {Array*} an array (or promise for an array) of values (or
 * promises for values)
 * @returns a promise for an array of the corresponding values
 */
// By Mark Miller
// http://wiki.ecmascript.org/doku.php?id=strawman:concurrency&rev=1308776521#allfulfilled
Q.all = all;
function all(promises) {
    return when(promises, function (promises) {
        var pendingCount = 0;
        var deferred = defer();
        array_reduce(promises, function (undefined, promise, index) {
            var snapshot;
            if (
                isPromise(promise) &&
                (snapshot = promise.inspect()).state === "fulfilled"
            ) {
                promises[index] = snapshot.value;
            } else {
                ++pendingCount;
                when(
                    promise,
                    function (value) {
                        promises[index] = value;
                        if (--pendingCount === 0) {
                            deferred.resolve(promises);
                        }
                    },
                    deferred.reject,
                    function (progress) {
                        deferred.notify({ index: index, value: progress });
                    }
                );
            }
        }, void 0);
        if (pendingCount === 0) {
            deferred.resolve(promises);
        }
        return deferred.promise;
    });
}

Promise.prototype.all = function () {
    return all(this);
};

/**
 * Returns the first resolved promise of an array. Prior rejected promises are
 * ignored.  Rejects only if all promises are rejected.
 * @param {Array*} an array containing values or promises for values
 * @returns a promise fulfilled with the value of the first resolved promise,
 * or a rejected promise if all promises are rejected.
 */
Q.any = any;

function any(promises) {
    if (promises.length === 0) {
        return Q.resolve();
    }

    var deferred = Q.defer();
    var pendingCount = 0;
    array_reduce(promises, function (prev, current, index) {
        var promise = promises[index];

        pendingCount++;

        when(promise, onFulfilled, onRejected, onProgress);
        function onFulfilled(result) {
            deferred.resolve(result);
        }
        function onRejected() {
            pendingCount--;
            if (pendingCount === 0) {
                deferred.reject(new Error(
                    "Can't get fulfillment value from any promise, all " +
                    "promises were rejected."
                ));
            }
        }
        function onProgress(progress) {
            deferred.notify({
                index: index,
                value: progress
            });
        }
    }, undefined);

    return deferred.promise;
}

Promise.prototype.any = function () {
    return any(this);
};

/**
 * Waits for all promises to be settled, either fulfilled or
 * rejected.  This is distinct from `all` since that would stop
 * waiting at the first rejection.  The promise returned by
 * `allResolved` will never be rejected.
 * @param promises a promise for an array (or an array) of promises
 * (or values)
 * @return a promise for an array of promises
 */
Q.allResolved = deprecate(allResolved, "allResolved", "allSettled");
function allResolved(promises) {
    return when(promises, function (promises) {
        promises = array_map(promises, Q);
        return when(all(array_map(promises, function (promise) {
            return when(promise, noop, noop);
        })), function () {
            return promises;
        });
    });
}

Promise.prototype.allResolved = function () {
    return allResolved(this);
};

/**
 * @see Promise#allSettled
 */
Q.allSettled = allSettled;
function allSettled(promises) {
    return Q(promises).allSettled();
}

/**
 * Turns an array of promises into a promise for an array of their states (as
 * returned by `inspect`) when they have all settled.
 * @param {Array[Any*]} values an array (or promise for an array) of values (or
 * promises for values)
 * @returns {Array[State]} an array of states for the respective values.
 */
Promise.prototype.allSettled = function () {
    return this.then(function (promises) {
        return all(array_map(promises, function (promise) {
            promise = Q(promise);
            function regardless() {
                return promise.inspect();
            }
            return promise.then(regardless, regardless);
        }));
    });
};

/**
 * Captures the failure of a promise, giving an oportunity to recover
 * with a callback.  If the given promise is fulfilled, the returned
 * promise is fulfilled.
 * @param {Any*} promise for something
 * @param {Function} callback to fulfill the returned promise if the
 * given promise is rejected
 * @returns a promise for the return value of the callback
 */
Q.fail = // XXX legacy
Q["catch"] = function (object, rejected) {
    return Q(object).then(void 0, rejected);
};

Promise.prototype.fail = // XXX legacy
Promise.prototype["catch"] = function (rejected) {
    return this.then(void 0, rejected);
};

/**
 * Attaches a listener that can respond to progress notifications from a
 * promise's originating deferred. This listener receives the exact arguments
 * passed to ``deferred.notify``.
 * @param {Any*} promise for something
 * @param {Function} callback to receive any progress notifications
 * @returns the given promise, unchanged
 */
Q.progress = progress;
function progress(object, progressed) {
    return Q(object).then(void 0, void 0, progressed);
}

Promise.prototype.progress = function (progressed) {
    return this.then(void 0, void 0, progressed);
};

/**
 * Provides an opportunity to observe the settling of a promise,
 * regardless of whether the promise is fulfilled or rejected.  Forwards
 * the resolution to the returned promise when the callback is done.
 * The callback can return a promise to defer completion.
 * @param {Any*} promise
 * @param {Function} callback to observe the resolution of the given
 * promise, takes no arguments.
 * @returns a promise for the resolution of the given promise when
 * ``fin`` is done.
 */
Q.fin = // XXX legacy
Q["finally"] = function (object, callback) {
    return Q(object)["finally"](callback);
};

Promise.prototype.fin = // XXX legacy
Promise.prototype["finally"] = function (callback) {
    callback = Q(callback);
    return this.then(function (value) {
        return callback.fcall().then(function () {
            return value;
        });
    }, function (reason) {
        // TODO attempt to recycle the rejection with "this".
        return callback.fcall().then(function () {
            throw reason;
        });
    });
};

/**
 * Terminates a chain of promises, forcing rejections to be
 * thrown as exceptions.
 * @param {Any*} promise at the end of a chain of promises
 * @returns nothing
 */
Q.done = function (object, fulfilled, rejected, progress) {
    return Q(object).done(fulfilled, rejected, progress);
};

Promise.prototype.done = function (fulfilled, rejected, progress) {
    var onUnhandledError = function (error) {
        // forward to a future turn so that ``when``
        // does not catch it and turn it into a rejection.
        Q.nextTick(function () {
            makeStackTraceLong(error, promise);
            if (Q.onerror) {
                Q.onerror(error);
            } else {
                throw error;
            }
        });
    };

    // Avoid unnecessary `nextTick`ing via an unnecessary `when`.
    var promise = fulfilled || rejected || progress ?
        this.then(fulfilled, rejected, progress) :
        this;

    if (typeof process === "object" && process && process.domain) {
        onUnhandledError = process.domain.bind(onUnhandledError);
    }

    promise.then(void 0, onUnhandledError);
};

/**
 * Causes a promise to be rejected if it does not get fulfilled before
 * some milliseconds time out.
 * @param {Any*} promise
 * @param {Number} milliseconds timeout
 * @param {Any*} custom error message or Error object (optional)
 * @returns a promise for the resolution of the given promise if it is
 * fulfilled before the timeout, otherwise rejected.
 */
Q.timeout = function (object, ms, error) {
    return Q(object).timeout(ms, error);
};

Promise.prototype.timeout = function (ms, error) {
    var deferred = defer();
    var timeoutId = setTimeout(function () {
        if (!error || "string" === typeof error) {
            error = new Error(error || "Timed out after " + ms + " ms");
            error.code = "ETIMEDOUT";
        }
        deferred.reject(error);
    }, ms);

    this.then(function (value) {
        clearTimeout(timeoutId);
        deferred.resolve(value);
    }, function (exception) {
        clearTimeout(timeoutId);
        deferred.reject(exception);
    }, deferred.notify);

    return deferred.promise;
};

/**
 * Returns a promise for the given value (or promised value), some
 * milliseconds after it resolved. Passes rejections immediately.
 * @param {Any*} promise
 * @param {Number} milliseconds
 * @returns a promise for the resolution of the given promise after milliseconds
 * time has elapsed since the resolution of the given promise.
 * If the given promise rejects, that is passed immediately.
 */
Q.delay = function (object, timeout) {
    if (timeout === void 0) {
        timeout = object;
        object = void 0;
    }
    return Q(object).delay(timeout);
};

Promise.prototype.delay = function (timeout) {
    return this.then(function (value) {
        var deferred = defer();
        setTimeout(function () {
            deferred.resolve(value);
        }, timeout);
        return deferred.promise;
    });
};

/**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided as an array, and returns a promise.
 *
 *      Q.nfapply(FS.readFile, [__filename])
 *      .then(function (content) {
 *      })
 *
 */
Q.nfapply = function (callback, args) {
    return Q(callback).nfapply(args);
};

Promise.prototype.nfapply = function (args) {
    var deferred = defer();
    var nodeArgs = array_slice(args);
    nodeArgs.push(deferred.makeNodeResolver());
    this.fapply(nodeArgs).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Passes a continuation to a Node function, which is called with the given
 * arguments provided individually, and returns a promise.
 * @example
 * Q.nfcall(FS.readFile, __filename)
 * .then(function (content) {
 * })
 *
 */
Q.nfcall = function (callback /*...args*/) {
    var args = array_slice(arguments, 1);
    return Q(callback).nfapply(args);
};

Promise.prototype.nfcall = function (/*...args*/) {
    var nodeArgs = array_slice(arguments);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.fapply(nodeArgs).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Wraps a NodeJS continuation passing function and returns an equivalent
 * version that returns a promise.
 * @example
 * Q.nfbind(FS.readFile, __filename)("utf-8")
 * .then(console.log)
 * .done()
 */
Q.nfbind =
Q.denodeify = function (callback /*...args*/) {
    var baseArgs = array_slice(arguments, 1);
    return function () {
        var nodeArgs = baseArgs.concat(array_slice(arguments));
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        Q(callback).fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
};

Promise.prototype.nfbind =
Promise.prototype.denodeify = function (/*...args*/) {
    var args = array_slice(arguments);
    args.unshift(this);
    return Q.denodeify.apply(void 0, args);
};

Q.nbind = function (callback, thisp /*...args*/) {
    var baseArgs = array_slice(arguments, 2);
    return function () {
        var nodeArgs = baseArgs.concat(array_slice(arguments));
        var deferred = defer();
        nodeArgs.push(deferred.makeNodeResolver());
        function bound() {
            return callback.apply(thisp, arguments);
        }
        Q(bound).fapply(nodeArgs).fail(deferred.reject);
        return deferred.promise;
    };
};

Promise.prototype.nbind = function (/*thisp, ...args*/) {
    var args = array_slice(arguments, 0);
    args.unshift(this);
    return Q.nbind.apply(void 0, args);
};

/**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback with a given array of arguments, plus a provided callback.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param {Array} args arguments to pass to the method; the callback
 * will be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */
Q.nmapply = // XXX As proposed by "Redsandro"
Q.npost = function (object, name, args) {
    return Q(object).npost(name, args);
};

Promise.prototype.nmapply = // XXX As proposed by "Redsandro"
Promise.prototype.npost = function (name, args) {
    var nodeArgs = array_slice(args || []);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

/**
 * Calls a method of a Node-style object that accepts a Node-style
 * callback, forwarding the given variadic arguments, plus a provided
 * callback argument.
 * @param object an object that has the named method
 * @param {String} name name of the method of object
 * @param ...args arguments to pass to the method; the callback will
 * be provided by Q and appended to these arguments.
 * @returns a promise for the value or error
 */
Q.nsend = // XXX Based on Mark Miller's proposed "send"
Q.nmcall = // XXX Based on "Redsandro's" proposal
Q.ninvoke = function (object, name /*...args*/) {
    var nodeArgs = array_slice(arguments, 2);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    Q(object).dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

Promise.prototype.nsend = // XXX Based on Mark Miller's proposed "send"
Promise.prototype.nmcall = // XXX Based on "Redsandro's" proposal
Promise.prototype.ninvoke = function (name /*...args*/) {
    var nodeArgs = array_slice(arguments, 1);
    var deferred = defer();
    nodeArgs.push(deferred.makeNodeResolver());
    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
    return deferred.promise;
};

/**
 * If a function would like to support both Node continuation-passing-style and
 * promise-returning-style, it can end its internal promise chain with
 * `nodeify(nodeback)`, forwarding the optional nodeback argument.  If the user
 * elects to use a nodeback, the result will be sent there.  If they do not
 * pass a nodeback, they will receive the result promise.
 * @param object a result (or a promise for a result)
 * @param {Function} nodeback a Node.js-style callback
 * @returns either the promise or nothing
 */
Q.nodeify = nodeify;
function nodeify(object, nodeback) {
    return Q(object).nodeify(nodeback);
}

Promise.prototype.nodeify = function (nodeback) {
    if (nodeback) {
        this.then(function (value) {
            Q.nextTick(function () {
                nodeback(null, value);
            });
        }, function (error) {
            Q.nextTick(function () {
                nodeback(error);
            });
        });
    } else {
        return this;
    }
};

Q.noConflict = function() {
    throw new Error("Q.noConflict only works when Q is used as a global");
};

// All code before this point will be filtered from stack traces.
var qEndingLine = captureLine();

return Q;

});


/***/ }),

/***/ "./node_modules/select/src/select.js":
/*!*******************************************!*\
  !*** ./node_modules/select/src/select.js ***!
  \*******************************************/
/***/ (function(module) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),

/***/ "./node_modules/tiny-emitter/index.js":
/*!********************************************!*\
  !*** ./node_modules/tiny-emitter/index.js ***!
  \********************************************/
/***/ (function(module) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;
module.exports.TinyEmitter = E;


/***/ }),

/***/ "./node_modules/u2f-api-polyfill/u2f-api-polyfill.js":
/*!***********************************************************!*\
  !*** ./node_modules/u2f-api-polyfill/u2f-api-polyfill.js ***!
  \***********************************************************/
/***/ (function() {

"use strict";

//Copyright 2014-2015 Google Inc. All rights reserved.

//Use of this source code is governed by a BSD-style
//license that can be found in the LICENSE file or at
//https://developers.google.com/open-source/licenses/bsd

/**
 * @fileoverview The U2F api.
 */


(function (){
  var isChrome = 'chrome' in window && window.navigator.userAgent.indexOf('Edge') < 0;
  if ('u2f' in window || !isChrome) {
    return;
  }

  /** Namespace for the U2F api.
   * @type {Object}
   */
  var u2f = window.u2f = {};

  /**
   * FIDO U2F Javascript API Version
   * @number
   */
  var js_api_version;

  /**
   * The U2F extension id
   * @const {string}
   */
  // The Chrome packaged app extension ID.
  // Uncomment this if you want to deploy a server instance that uses
  // the package Chrome app and does not require installing the U2F Chrome extension.
   u2f.EXTENSION_ID = 'kmendfapggjehodndflmmgagdbamhnfd';
  // The U2F Chrome extension ID.
  // Uncomment this if you want to deploy a server instance that uses
  // the U2F Chrome extension to authenticate.
  // u2f.EXTENSION_ID = 'pfboblefjcgdjicmnffhdgionmgcdmne';


  /**
   * Message types for messsages to/from the extension
   * @const
   * @enum {string}
   */
  u2f.MessageTypes = {
      'U2F_REGISTER_REQUEST': 'u2f_register_request',
      'U2F_REGISTER_RESPONSE': 'u2f_register_response',
      'U2F_SIGN_REQUEST': 'u2f_sign_request',
      'U2F_SIGN_RESPONSE': 'u2f_sign_response',
      'U2F_GET_API_VERSION_REQUEST': 'u2f_get_api_version_request',
      'U2F_GET_API_VERSION_RESPONSE': 'u2f_get_api_version_response'
  };


  /**
   * Response status codes
   * @const
   * @enum {number}
   */
  u2f.ErrorCodes = {
      'OK': 0,
      'OTHER_ERROR': 1,
      'BAD_REQUEST': 2,
      'CONFIGURATION_UNSUPPORTED': 3,
      'DEVICE_INELIGIBLE': 4,
      'TIMEOUT': 5
  };


  /**
   * A message for registration requests
   * @typedef {{
   *   type: u2f.MessageTypes,
   *   appId: ?string,
   *   timeoutSeconds: ?number,
   *   requestId: ?number
   * }}
   */
  u2f.U2fRequest;


  /**
   * A message for registration responses
   * @typedef {{
   *   type: u2f.MessageTypes,
   *   responseData: (u2f.Error | u2f.RegisterResponse | u2f.SignResponse),
   *   requestId: ?number
   * }}
   */
  u2f.U2fResponse;


  /**
   * An error object for responses
   * @typedef {{
   *   errorCode: u2f.ErrorCodes,
   *   errorMessage: ?string
   * }}
   */
  u2f.Error;

  /**
   * Data object for a single sign request.
   * @typedef {enum {BLUETOOTH_RADIO, BLUETOOTH_LOW_ENERGY, USB, NFC}}
   */
  u2f.Transport;


  /**
   * Data object for a single sign request.
   * @typedef {Array<u2f.Transport>}
   */
  u2f.Transports;

  /**
   * Data object for a single sign request.
   * @typedef {{
   *   version: string,
   *   challenge: string,
   *   keyHandle: string,
   *   appId: string
   * }}
   */
  u2f.SignRequest;


  /**
   * Data object for a sign response.
   * @typedef {{
   *   keyHandle: string,
   *   signatureData: string,
   *   clientData: string
   * }}
   */
  u2f.SignResponse;


  /**
   * Data object for a registration request.
   * @typedef {{
   *   version: string,
   *   challenge: string
   * }}
   */
  u2f.RegisterRequest;


  /**
   * Data object for a registration response.
   * @typedef {{
   *   version: string,
   *   keyHandle: string,
   *   transports: Transports,
   *   appId: string
   * }}
   */
  u2f.RegisterResponse;


  /**
   * Data object for a registered key.
   * @typedef {{
   *   version: string,
   *   keyHandle: string,
   *   transports: ?Transports,
   *   appId: ?string
   * }}
   */
  u2f.RegisteredKey;


  /**
   * Data object for a get API register response.
   * @typedef {{
   *   js_api_version: number
   * }}
   */
  u2f.GetJsApiVersionResponse;


  //Low level MessagePort API support

  /**
   * Sets up a MessagePort to the U2F extension using the
   * available mechanisms.
   * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
   */
  u2f.getMessagePort = function(callback) {
    if (typeof chrome != 'undefined' && chrome.runtime) {
      // The actual message here does not matter, but we need to get a reply
      // for the callback to run. Thus, send an empty signature request
      // in order to get a failure response.
      var msg = {
          type: u2f.MessageTypes.U2F_SIGN_REQUEST,
          signRequests: []
      };
      chrome.runtime.sendMessage(u2f.EXTENSION_ID, msg, function() {
        if (!chrome.runtime.lastError) {
          // We are on a whitelisted origin and can talk directly
          // with the extension.
          u2f.getChromeRuntimePort_(callback);
        } else {
          // chrome.runtime was available, but we couldn't message
          // the extension directly, use iframe
          u2f.getIframePort_(callback);
        }
      });
    } else if (u2f.isAndroidChrome_()) {
      u2f.getAuthenticatorPort_(callback);
    } else if (u2f.isIosChrome_()) {
      u2f.getIosPort_(callback);
    } else {
      // chrome.runtime was not available at all, which is normal
      // when this origin doesn't have access to any extensions.
      u2f.getIframePort_(callback);
    }
  };

  /**
   * Detect chrome running on android based on the browser's useragent.
   * @private
   */
  u2f.isAndroidChrome_ = function() {
    var userAgent = navigator.userAgent;
    return userAgent.indexOf('Chrome') != -1 &&
    userAgent.indexOf('Android') != -1;
  };

  /**
   * Detect chrome running on iOS based on the browser's platform.
   * @private
   */
  u2f.isIosChrome_ = function() {
    return ["iPhone", "iPad", "iPod"].indexOf(navigator.platform) > -1;
  };

  /**
   * Connects directly to the extension via chrome.runtime.connect.
   * @param {function(u2f.WrappedChromeRuntimePort_)} callback
   * @private
   */
  u2f.getChromeRuntimePort_ = function(callback) {
    var port = chrome.runtime.connect(u2f.EXTENSION_ID,
        {'includeTlsChannelId': true});
    setTimeout(function() {
      callback(new u2f.WrappedChromeRuntimePort_(port));
    }, 0);
  };

  /**
   * Return a 'port' abstraction to the Authenticator app.
   * @param {function(u2f.WrappedAuthenticatorPort_)} callback
   * @private
   */
  u2f.getAuthenticatorPort_ = function(callback) {
    setTimeout(function() {
      callback(new u2f.WrappedAuthenticatorPort_());
    }, 0);
  };

  /**
   * Return a 'port' abstraction to the iOS client app.
   * @param {function(u2f.WrappedIosPort_)} callback
   * @private
   */
  u2f.getIosPort_ = function(callback) {
    setTimeout(function() {
      callback(new u2f.WrappedIosPort_());
    }, 0);
  };

  /**
   * A wrapper for chrome.runtime.Port that is compatible with MessagePort.
   * @param {Port} port
   * @constructor
   * @private
   */
  u2f.WrappedChromeRuntimePort_ = function(port) {
    this.port_ = port;
  };

  /**
   * Format and return a sign request compliant with the JS API version supported by the extension.
   * @param {Array<u2f.SignRequest>} signRequests
   * @param {number} timeoutSeconds
   * @param {number} reqId
   * @return {Object}
   */
  u2f.formatSignRequest_ =
    function(appId, challenge, registeredKeys, timeoutSeconds, reqId) {
    if (js_api_version === undefined || js_api_version < 1.1) {
      // Adapt request to the 1.0 JS API
      var signRequests = [];
      for (var i = 0; i < registeredKeys.length; i++) {
        signRequests[i] = {
            version: registeredKeys[i].version,
            challenge: challenge,
            keyHandle: registeredKeys[i].keyHandle,
            appId: appId
        };
      }
      return {
        type: u2f.MessageTypes.U2F_SIGN_REQUEST,
        signRequests: signRequests,
        timeoutSeconds: timeoutSeconds,
        requestId: reqId
      };
    }
    // JS 1.1 API
    return {
      type: u2f.MessageTypes.U2F_SIGN_REQUEST,
      appId: appId,
      challenge: challenge,
      registeredKeys: registeredKeys,
      timeoutSeconds: timeoutSeconds,
      requestId: reqId
    };
  };

  /**
   * Format and return a register request compliant with the JS API version supported by the extension..
   * @param {Array<u2f.SignRequest>} signRequests
   * @param {Array<u2f.RegisterRequest>} signRequests
   * @param {number} timeoutSeconds
   * @param {number} reqId
   * @return {Object}
   */
  u2f.formatRegisterRequest_ =
    function(appId, registeredKeys, registerRequests, timeoutSeconds, reqId) {
    if (js_api_version === undefined || js_api_version < 1.1) {
      // Adapt request to the 1.0 JS API
      for (var i = 0; i < registerRequests.length; i++) {
        registerRequests[i].appId = appId;
      }
      var signRequests = [];
      for (var i = 0; i < registeredKeys.length; i++) {
        signRequests[i] = {
            version: registeredKeys[i].version,
            challenge: registerRequests[0],
            keyHandle: registeredKeys[i].keyHandle,
            appId: appId
        };
      }
      return {
        type: u2f.MessageTypes.U2F_REGISTER_REQUEST,
        signRequests: signRequests,
        registerRequests: registerRequests,
        timeoutSeconds: timeoutSeconds,
        requestId: reqId
      };
    }
    // JS 1.1 API
    return {
      type: u2f.MessageTypes.U2F_REGISTER_REQUEST,
      appId: appId,
      registerRequests: registerRequests,
      registeredKeys: registeredKeys,
      timeoutSeconds: timeoutSeconds,
      requestId: reqId
    };
  };


  /**
   * Posts a message on the underlying channel.
   * @param {Object} message
   */
  u2f.WrappedChromeRuntimePort_.prototype.postMessage = function(message) {
    this.port_.postMessage(message);
  };


  /**
   * Emulates the HTML 5 addEventListener interface. Works only for the
   * onmessage event, which is hooked up to the chrome.runtime.Port.onMessage.
   * @param {string} eventName
   * @param {function({data: Object})} handler
   */
  u2f.WrappedChromeRuntimePort_.prototype.addEventListener =
      function(eventName, handler) {
    var name = eventName.toLowerCase();
    if (name == 'message' || name == 'onmessage') {
      this.port_.onMessage.addListener(function(message) {
        // Emulate a minimal MessageEvent object
        handler({'data': message});
      });
    } else {
      console.error('WrappedChromeRuntimePort only supports onMessage');
    }
  };

  /**
   * Wrap the Authenticator app with a MessagePort interface.
   * @constructor
   * @private
   */
  u2f.WrappedAuthenticatorPort_ = function() {
    this.requestId_ = -1;
    this.requestObject_ = null;
  }

  /**
   * Launch the Authenticator intent.
   * @param {Object} message
   */
  u2f.WrappedAuthenticatorPort_.prototype.postMessage = function(message) {
    var intentUrl =
      u2f.WrappedAuthenticatorPort_.INTENT_URL_BASE_ +
      ';S.request=' + encodeURIComponent(JSON.stringify(message)) +
      ';end';
    document.location = intentUrl;
  };

  /**
   * Tells what type of port this is.
   * @return {String} port type
   */
  u2f.WrappedAuthenticatorPort_.prototype.getPortType = function() {
    return "WrappedAuthenticatorPort_";
  };


  /**
   * Emulates the HTML 5 addEventListener interface.
   * @param {string} eventName
   * @param {function({data: Object})} handler
   */
  u2f.WrappedAuthenticatorPort_.prototype.addEventListener = function(eventName, handler) {
    var name = eventName.toLowerCase();
    if (name == 'message') {
      var self = this;
      /* Register a callback to that executes when
       * chrome injects the response. */
      window.addEventListener(
          'message', self.onRequestUpdate_.bind(self, handler), false);
    } else {
      console.error('WrappedAuthenticatorPort only supports message');
    }
  };

  /**
   * Callback invoked  when a response is received from the Authenticator.
   * @param function({data: Object}) callback
   * @param {Object} message message Object
   */
  u2f.WrappedAuthenticatorPort_.prototype.onRequestUpdate_ =
      function(callback, message) {
    var messageObject = JSON.parse(message.data);
    var intentUrl = messageObject['intentURL'];

    var errorCode = messageObject['errorCode'];
    var responseObject = null;
    if (messageObject.hasOwnProperty('data')) {
      responseObject = /** @type {Object} */ (
          JSON.parse(messageObject['data']));
    }

    callback({'data': responseObject});
  };

  /**
   * Base URL for intents to Authenticator.
   * @const
   * @private
   */
  u2f.WrappedAuthenticatorPort_.INTENT_URL_BASE_ =
    'intent:#Intent;action=com.google.android.apps.authenticator.AUTHENTICATE';

  /**
   * Wrap the iOS client app with a MessagePort interface.
   * @constructor
   * @private
   */
  u2f.WrappedIosPort_ = function() {};

  /**
   * Launch the iOS client app request
   * @param {Object} message
   */
  u2f.WrappedIosPort_.prototype.postMessage = function(message) {
    var str = JSON.stringify(message);
    var url = "u2f://auth?" + encodeURI(str);
    location.replace(url);
  };

  /**
   * Tells what type of port this is.
   * @return {String} port type
   */
  u2f.WrappedIosPort_.prototype.getPortType = function() {
    return "WrappedIosPort_";
  };

  /**
   * Emulates the HTML 5 addEventListener interface.
   * @param {string} eventName
   * @param {function({data: Object})} handler
   */
  u2f.WrappedIosPort_.prototype.addEventListener = function(eventName, handler) {
    var name = eventName.toLowerCase();
    if (name !== 'message') {
      console.error('WrappedIosPort only supports message');
    }
  };

  /**
   * Sets up an embedded trampoline iframe, sourced from the extension.
   * @param {function(MessagePort)} callback
   * @private
   */
  u2f.getIframePort_ = function(callback) {
    // Create the iframe
    var iframeOrigin = 'chrome-extension://' + u2f.EXTENSION_ID;
    var iframe = document.createElement('iframe');
    iframe.src = iframeOrigin + '/u2f-comms.html';
    iframe.setAttribute('style', 'display:none');
    document.body.appendChild(iframe);

    var channel = new MessageChannel();
    var ready = function(message) {
      if (message.data == 'ready') {
        channel.port1.removeEventListener('message', ready);
        callback(channel.port1);
      } else {
        console.error('First event on iframe port was not "ready"');
      }
    };
    channel.port1.addEventListener('message', ready);
    channel.port1.start();

    iframe.addEventListener('load', function() {
      // Deliver the port to the iframe and initialize
      iframe.contentWindow.postMessage('init', iframeOrigin, [channel.port2]);
    });
  };


  //High-level JS API

  /**
   * Default extension response timeout in seconds.
   * @const
   */
  u2f.EXTENSION_TIMEOUT_SEC = 30;

  /**
   * A singleton instance for a MessagePort to the extension.
   * @type {MessagePort|u2f.WrappedChromeRuntimePort_}
   * @private
   */
  u2f.port_ = null;

  /**
   * Callbacks waiting for a port
   * @type {Array<function((MessagePort|u2f.WrappedChromeRuntimePort_))>}
   * @private
   */
  u2f.waitingForPort_ = [];

  /**
   * A counter for requestIds.
   * @type {number}
   * @private
   */
  u2f.reqCounter_ = 0;

  /**
   * A map from requestIds to client callbacks
   * @type {Object.<number,(function((u2f.Error|u2f.RegisterResponse))
   *                       |function((u2f.Error|u2f.SignResponse)))>}
   * @private
   */
  u2f.callbackMap_ = {};

  /**
   * Creates or retrieves the MessagePort singleton to use.
   * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
   * @private
   */
  u2f.getPortSingleton_ = function(callback) {
    if (u2f.port_) {
      callback(u2f.port_);
    } else {
      if (u2f.waitingForPort_.length == 0) {
        u2f.getMessagePort(function(port) {
          u2f.port_ = port;
          u2f.port_.addEventListener('message',
              /** @type {function(Event)} */ (u2f.responseHandler_));

          // Careful, here be async callbacks. Maybe.
          while (u2f.waitingForPort_.length)
            u2f.waitingForPort_.shift()(u2f.port_);
        });
      }
      u2f.waitingForPort_.push(callback);
    }
  };

  /**
   * Handles response messages from the extension.
   * @param {MessageEvent.<u2f.Response>} message
   * @private
   */
  u2f.responseHandler_ = function(message) {
    var response = message.data;
    var reqId = response['requestId'];
    if (!reqId || !u2f.callbackMap_[reqId]) {
      console.error('Unknown or missing requestId in response.');
      return;
    }
    var cb = u2f.callbackMap_[reqId];
    delete u2f.callbackMap_[reqId];
    cb(response['responseData']);
  };

  /**
   * Dispatches an array of sign requests to available U2F tokens.
   * If the JS API version supported by the extension is unknown, it first sends a
   * message to the extension to find out the supported API version and then it sends
   * the sign request.
   * @param {string=} appId
   * @param {string=} challenge
   * @param {Array<u2f.RegisteredKey>} registeredKeys
   * @param {function((u2f.Error|u2f.SignResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */
  u2f.sign = function(appId, challenge, registeredKeys, callback, opt_timeoutSeconds) {
    if (js_api_version === undefined) {
      // Send a message to get the extension to JS API version, then send the actual sign request.
      u2f.getApiVersion(
          function (response) {
            js_api_version = response['js_api_version'] === undefined ? 0 : response['js_api_version'];
            console.log("Extension JS API Version: ", js_api_version);
            u2f.sendSignRequest(appId, challenge, registeredKeys, callback, opt_timeoutSeconds);
          });
    } else {
      // We know the JS API version. Send the actual sign request in the supported API version.
      u2f.sendSignRequest(appId, challenge, registeredKeys, callback, opt_timeoutSeconds);
    }
  };

  /**
   * Dispatches an array of sign requests to available U2F tokens.
   * @param {string=} appId
   * @param {string=} challenge
   * @param {Array<u2f.RegisteredKey>} registeredKeys
   * @param {function((u2f.Error|u2f.SignResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */
  u2f.sendSignRequest = function(appId, challenge, registeredKeys, callback, opt_timeoutSeconds) {
    u2f.getPortSingleton_(function(port) {
      var reqId = ++u2f.reqCounter_;
      u2f.callbackMap_[reqId] = callback;
      var timeoutSeconds = (typeof opt_timeoutSeconds !== 'undefined' ?
          opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC);
      var req = u2f.formatSignRequest_(appId, challenge, registeredKeys, timeoutSeconds, reqId);
      port.postMessage(req);
    });
  };

  /**
   * Dispatches register requests to available U2F tokens. An array of sign
   * requests identifies already registered tokens.
   * If the JS API version supported by the extension is unknown, it first sends a
   * message to the extension to find out the supported API version and then it sends
   * the register request.
   * @param {string=} appId
   * @param {Array<u2f.RegisterRequest>} registerRequests
   * @param {Array<u2f.RegisteredKey>} registeredKeys
   * @param {function((u2f.Error|u2f.RegisterResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */
  u2f.register = function(appId, registerRequests, registeredKeys, callback, opt_timeoutSeconds) {
    if (js_api_version === undefined) {
      // Send a message to get the extension to JS API version, then send the actual register request.
      u2f.getApiVersion(
          function (response) {
            js_api_version = response['js_api_version'] === undefined ? 0: response['js_api_version'];
            console.log("Extension JS API Version: ", js_api_version);
            u2f.sendRegisterRequest(appId, registerRequests, registeredKeys,
                callback, opt_timeoutSeconds);
          });
    } else {
      // We know the JS API version. Send the actual register request in the supported API version.
      u2f.sendRegisterRequest(appId, registerRequests, registeredKeys,
          callback, opt_timeoutSeconds);
    }
  };

  /**
   * Dispatches register requests to available U2F tokens. An array of sign
   * requests identifies already registered tokens.
   * @param {string=} appId
   * @param {Array<u2f.RegisterRequest>} registerRequests
   * @param {Array<u2f.RegisteredKey>} registeredKeys
   * @param {function((u2f.Error|u2f.RegisterResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */
  u2f.sendRegisterRequest = function(appId, registerRequests, registeredKeys, callback, opt_timeoutSeconds) {
    u2f.getPortSingleton_(function(port) {
      var reqId = ++u2f.reqCounter_;
      u2f.callbackMap_[reqId] = callback;
      var timeoutSeconds = (typeof opt_timeoutSeconds !== 'undefined' ?
          opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC);
      var req = u2f.formatRegisterRequest_(
          appId, registeredKeys, registerRequests, timeoutSeconds, reqId);
      port.postMessage(req);
    });
  };


  /**
   * Dispatches a message to the extension to find out the supported
   * JS API version.
   * If the user is on a mobile phone and is thus using Google Authenticator instead
   * of the Chrome extension, don't send the request and simply return 0.
   * @param {function((u2f.Error|u2f.GetJsApiVersionResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */
  u2f.getApiVersion = function(callback, opt_timeoutSeconds) {
   u2f.getPortSingleton_(function(port) {
     // If we are using Android Google Authenticator or iOS client app,
     // do not fire an intent to ask which JS API version to use.
     if (port.getPortType) {
       var apiVersion;
       switch (port.getPortType()) {
         case 'WrappedIosPort_':
         case 'WrappedAuthenticatorPort_':
           apiVersion = 1.1;
           break;

         default:
           apiVersion = 0;
           break;
       }
       callback({ 'js_api_version': apiVersion });
       return;
     }
      var reqId = ++u2f.reqCounter_;
      u2f.callbackMap_[reqId] = callback;
      var req = {
        type: u2f.MessageTypes.U2F_GET_API_VERSION_REQUEST,
        timeoutSeconds: (typeof opt_timeoutSeconds !== 'undefined' ?
            opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC),
        requestId: reqId
      };
      port.postMessage(req);
    });
  };
})();


/***/ }),

/***/ "./packages/@okta/qtip2/dist/jquery.qtip.js":
/*!**************************************************!*\
  !*** ./packages/@okta/qtip2/dist/jquery.qtip.js ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/*
 * qTip2 - Pretty powerful tooltips - v3.0.3-5-g
 * http://qtip2.com
 *
 * Copyright (c) 2017 
 * Released under the MIT licenses
 * http://jquery.org/license
 *
 * Date: Wed May 24 2017 01:22 UTC+0000
 * Plugins: tips modal viewport svg imagemap ie6
 * Styles: core basic css3
 */
/*global window: false, jQuery: false, console: false, define: false */

// Modified to support ESM - OKTA-369648


/* Cache window, document, undefined */
(function( window, document, undefined ) {

(function( factory ) {
	"use strict";
 	if(!(jquery__WEBPACK_IMPORTED_MODULE_0___default().fn).qtip) {
		factory((jquery__WEBPACK_IMPORTED_MODULE_0___default()));
	}
}
(function($) {
	"use strict"; // Enable ECMAScript "strict" operation for this function. See more: http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
;// Munge the primitives - Paul Irish tip
var TRUE = true,
FALSE = false,
NULL = null,

// Common variables
X = 'x', Y = 'y',
WIDTH = 'width',
HEIGHT = 'height',

// Positioning sides
TOP = 'top',
LEFT = 'left',
BOTTOM = 'bottom',
RIGHT = 'right',
CENTER = 'center',

// Position adjustment types
FLIP = 'flip',
FLIPINVERT = 'flipinvert',
SHIFT = 'shift',

// Shortcut vars
QTIP, PROTOTYPE, CORNER, CHECKS,
PLUGINS = {},
NAMESPACE = 'qtip',
ATTR_HAS = 'data-hasqtip',
ATTR_ID = 'data-qtip-id',
WIDGET = ['ui-widget', 'ui-tooltip'],
SELECTOR = '.'+NAMESPACE,
INACTIVE_EVENTS = 'click dblclick mousedown mouseup mousemove mouseleave mouseenter'.split(' '),

CLASS_FIXED = NAMESPACE+'-fixed',
CLASS_DEFAULT = NAMESPACE + '-default',
CLASS_FOCUS = NAMESPACE + '-focus',
CLASS_HOVER = NAMESPACE + '-hover',
CLASS_DISABLED = NAMESPACE+'-disabled',

replaceSuffix = '_replacedByqTip',
oldtitle = 'oldtitle',
trackingBound,

// Browser detection
BROWSER = {
	/*
	 * IE version detection
	 *
	 * Adapted from: http://ajaxian.com/archives/attack-of-the-ie-conditional-comment
	 * Credit to James Padolsey for the original implemntation!
	 */
	ie: (function() {
		/* eslint-disable no-empty */
		var v, i;
		for (
			v = 4, i = document.createElement('div');
			(i.innerHTML = '<!--[if gt IE ' + v + ']><i></i><![endif]-->') && i.getElementsByTagName('i')[0];
			v+=1
		) {}
		return v > 4 ? v : NaN;
		/* eslint-enable no-empty */
	})(),

	/*
	 * iOS version detection
	 */
	iOS: parseFloat(
		('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0,''])[1])
		.replace('undefined', '3_2').replace('_', '.').replace('_', '')
	) || FALSE
};
;function QTip(target, options, id, attr) {
	// Elements and ID
	this.id = id;
	this.target = target;
	this.tooltip = NULL;
	this.elements = { target: target };

	// Internal constructs
	this._id = NAMESPACE + '-' + id;
	this.timers = { img: {} };
	this.options = options;
	this.plugins = {};

	// Cache object
	this.cache = {
		event: {},
		target: $(),
		disabled: FALSE,
		attr: attr,
		onTooltip: FALSE,
		lastClass: ''
	};

	// Set the initial flags
	this.rendered = this.destroyed = this.disabled = this.waiting =
		this.hiddenDuringWait = this.positioning = this.triggering = FALSE;
}
PROTOTYPE = QTip.prototype;

PROTOTYPE._when = function(deferreds) {
	return $.when.apply($, deferreds);
};

PROTOTYPE.render = function(show) {
	if(this.rendered || this.destroyed) { return this; } // If tooltip has already been rendered, exit

	var self = this,
		options = this.options,
		cache = this.cache,
		elements = this.elements,
		text = options.content.text,
		title = options.content.title,
		button = options.content.button,
		posOptions = options.position,
		deferreds = [];

	// Add ARIA attributes to target
	$.attr(this.target[0], 'aria-describedby', this._id);

	// Create public position object that tracks current position corners
	cache.posClass = this._createPosClass(
		(this.position = { my: posOptions.my, at: posOptions.at }).my
	);

	// Create tooltip element
	this.tooltip = elements.tooltip = $('<div/>', {
		'id': this._id,
		'class': [ NAMESPACE, CLASS_DEFAULT, options.style.classes, cache.posClass ].join(' '),
		'width': options.style.width || '',
		'height': options.style.height || '',
		'tracking': posOptions.target === 'mouse' && posOptions.adjust.mouse,

		/* ARIA specific attributes */
		'role': 'alert',
		'aria-live': 'polite',
		'aria-atomic': FALSE,
		'aria-describedby': this._id + '-content',
		'aria-hidden': TRUE
	})
	.toggleClass(CLASS_DISABLED, this.disabled)
	.attr(ATTR_ID, this.id)
	.data(NAMESPACE, this)
	.appendTo(posOptions.container)
	.append(
		// Create content element
		elements.content = $('<div />', {
			'class': NAMESPACE + '-content',
			'id': this._id + '-content',
			'aria-atomic': TRUE
		})
	);

	// Set rendered flag and prevent redundant reposition calls for now
	this.rendered = -1;
	this.positioning = TRUE;

	// Create title...
	if(title) {
		this._createTitle();

		// Update title only if its not a callback (called in toggle if so)
		if(!$.isFunction(title)) {
			deferreds.push( this._updateTitle(title, FALSE) );
		}
	}

	// Create button
	if(button) { this._createButton(); }

	// Set proper rendered flag and update content if not a callback function (called in toggle)
	if(!$.isFunction(text)) {
		deferreds.push( this._updateContent(text, FALSE) );
	}
	this.rendered = TRUE;

	// Setup widget classes
	this._setWidget();

	// Initialize 'render' plugins
	$.each(PLUGINS, function(name) {
		var instance;
		if(this.initialize === 'render' && (instance = this(self))) {
			self.plugins[name] = instance;
		}
	});

	// Unassign initial events and assign proper events
	this._unassignEvents();
	this._assignEvents();

	// When deferreds have completed
	this._when(deferreds).then(function() {
		// tooltiprender event
		self._trigger('render');

		// Reset flags
		self.positioning = FALSE;

		// Show tooltip if not hidden during wait period
		if(!self.hiddenDuringWait && (options.show.ready || show)) {
			self.toggle(TRUE, cache.event, FALSE);
		}
		self.hiddenDuringWait = FALSE;
	});

	// Expose API
	QTIP.api[this.id] = this;

	return this;
};

PROTOTYPE.destroy = function(immediate) {
	// Set flag the signify destroy is taking place to plugins
	// and ensure it only gets destroyed once!
	if(this.destroyed) { return this.target; }

	function process() {
		if(this.destroyed) { return; }
		this.destroyed = TRUE;

		var target = this.target,
			title = target.attr(oldtitle),
			timer;

		// Destroy tooltip if rendered
		if(this.rendered) {
			this.tooltip.stop(1,0).find('*').remove().end().remove();
		}

		// Destroy all plugins
		$.each(this.plugins, function() {
			this.destroy && this.destroy();
		});

		// Clear timers
		for (timer in this.timers) {
			if (this.timers.hasOwnProperty(timer)) {
				clearTimeout(this.timers[timer]);
			}
		}

		// Remove api object and ARIA attributes
		target.removeData(NAMESPACE)
			.removeAttr(ATTR_ID)
			.removeAttr(ATTR_HAS)
			.removeAttr('aria-describedby');

		// Reset old title attribute if removed
		if(this.options.suppress && title) {
			target.attr('title', title).removeAttr(oldtitle);
		}

		// Remove qTip events associated with this API
		this._unassignEvents();

		// Remove ID from used id objects, and delete object references
		// for better garbage collection and leak protection
		this.options = this.elements = this.cache = this.timers =
			this.plugins = this.mouse = NULL;

		// Delete epoxsed API object
		delete QTIP.api[this.id];
	}

	// If an immediate destroy is needed
	if((immediate !== TRUE || this.triggering === 'hide') && this.rendered) {
		this.tooltip.one('tooltiphidden', $.proxy(process, this));
		!this.triggering && this.hide();
	}

	// If we're not in the process of hiding... process
	else { process.call(this); }

	return this.target;
};
;function invalidOpt(a) {
	return a === NULL || $.type(a) !== 'object';
}

function invalidContent(c) {
	return !($.isFunction(c) || 
            c && c.attr || 
            c.length || 
            $.type(c) === 'object' && (c.jquery || c.then));
}

// Option object sanitizer
function sanitizeOptions(opts) {
	var content, text, ajax, once;

	if(invalidOpt(opts)) { return FALSE; }

	if(invalidOpt(opts.metadata)) {
		opts.metadata = { type: opts.metadata };
	}

	if('content' in opts) {
		content = opts.content;

		if(invalidOpt(content) || content.jquery || content.done) {
			text = invalidContent(content) ? FALSE : content;
			content = opts.content = {
				text: text
			};
		}
		else { text = content.text; }

		// DEPRECATED - Old content.ajax plugin functionality
		// Converts it into the proper Deferred syntax
		if('ajax' in content) {
			ajax = content.ajax;
			once = ajax && ajax.once !== FALSE;
			delete content.ajax;

			content.text = function(event, api) {
				var loading = text || $(this).attr(api.options.content.attr) || 'Loading...',

				deferred = $.ajax(
					$.extend({}, ajax, { context: api })
				)
				.then(ajax.success, NULL, ajax.error)
				.then(function(newContent) {
					if(newContent && once) { api.set('content.text', newContent); }
					return newContent;
				},
				function(xhr, status, error) {
					if(api.destroyed || xhr.status === 0) { return; }
					api.set('content.text', status + ': ' + error);
				});

				return !once ? (api.set('content.text', loading), deferred) : loading;
			};
		}

		if('title' in content) {
			if($.isPlainObject(content.title)) {
				content.button = content.title.button;
				content.title = content.title.text;
			}

			if(invalidContent(content.title || FALSE)) {
				content.title = FALSE;
			}
		}
	}

	if('position' in opts && invalidOpt(opts.position)) {
		opts.position = { my: opts.position, at: opts.position };
	}

	if('show' in opts && invalidOpt(opts.show)) {
		opts.show = opts.show.jquery ? { target: opts.show } :
			opts.show === TRUE ? { ready: TRUE } : { event: opts.show };
	}

	if('hide' in opts && invalidOpt(opts.hide)) {
		opts.hide = opts.hide.jquery ? { target: opts.hide } : { event: opts.hide };
	}

	if('style' in opts && invalidOpt(opts.style)) {
		opts.style = { classes: opts.style };
	}

	// Sanitize plugin options
	$.each(PLUGINS, function() {
		this.sanitize && this.sanitize(opts);
	});

	return opts;
}

// Setup builtin .set() option checks
CHECKS = PROTOTYPE.checks = {
	builtin: {
		// Core checks
		'^id$': function(obj, o, v, prev) {
			var id = v === TRUE ? QTIP.nextid : v,
				newId = NAMESPACE + '-' + id;

			if(id !== FALSE && id.length > 0 && !$('#'+newId).length) {
				this._id = newId;

				if(this.rendered) {
					this.tooltip[0].id = this._id;
					this.elements.content[0].id = this._id + '-content';
					this.elements.title[0].id = this._id + '-title';
				}
			}
			else { obj[o] = prev; }
		},
		'^prerender': function(obj, o, v) {
			v && !this.rendered && this.render(this.options.show.ready);
		},

		// Content checks
		'^content.text$': function(obj, o, v) {
			this._updateContent(v);
		},
		'^content.attr$': function(obj, o, v, prev) {
			if(this.options.content.text === this.target.attr(prev)) {
				this._updateContent( this.target.attr(v) );
			}
		},
		'^content.title$': function(obj, o, v) {
			// Remove title if content is null
			if(!v) { return this._removeTitle(); }

			// If title isn't already created, create it now and update
			v && !this.elements.title && this._createTitle();
			this._updateTitle(v);
		},
		'^content.button$': function(obj, o, v) {
			this._updateButton(v);
		},
		'^content.title.(text|button)$': function(obj, o, v) {
			this.set('content.'+o, v); // Backwards title.text/button compat
		},

		// Position checks
		'^position.(my|at)$': function(obj, o, v){
			if('string' === typeof v) {
				this.position[o] = obj[o] = new CORNER(v, o === 'at');
			}
		},
		'^position.container$': function(obj, o, v){
			this.rendered && this.tooltip.appendTo(v);
		},

		// Show checks
		'^show.ready$': function(obj, o, v) {
			v && (!this.rendered && this.render(TRUE) || this.toggle(TRUE));
		},

		// Style checks
		'^style.classes$': function(obj, o, v, p) {
			this.rendered && this.tooltip.removeClass(p).addClass(v);
		},
		'^style.(width|height)': function(obj, o, v) {
			this.rendered && this.tooltip.css(o, v);
		},
		'^style.widget|content.title': function() {
			this.rendered && this._setWidget();
		},
		'^style.def': function(obj, o, v) {
			this.rendered && this.tooltip.toggleClass(CLASS_DEFAULT, !!v);
		},

		// Events check
		'^events.(render|show|move|hide|focus|blur)$': function(obj, o, v) {
			this.rendered && this.tooltip[($.isFunction(v) ? '' : 'un') + 'bind']('tooltip'+o, v);
		},

		// Properties which require event reassignment
		'^(show|hide|position).(event|target|fixed|inactive|leave|distance|viewport|adjust)': function() {
			if(!this.rendered) { return; }

			// Set tracking flag
			var posOptions = this.options.position;
			this.tooltip.attr('tracking', posOptions.target === 'mouse' && posOptions.adjust.mouse);

			// Reassign events
			this._unassignEvents();
			this._assignEvents();
		}
	}
};

// Dot notation converter
function convertNotation(options, notation) {
	var i = 0, obj, option = options,

	// Split notation into array
	levels = notation.split('.');

	// Loop through
	while(option = option[ levels[i++] ]) {
		if(i < levels.length) { obj = option; }
	}

	return [obj || options, levels.pop()];
}

PROTOTYPE.get = function(notation) {
	if(this.destroyed) { return this; }

	var o = convertNotation(this.options, notation.toLowerCase()),
		result = o[0][ o[1] ];

	return result.precedance ? result.string() : result;
};

function setCallback(notation, args) {
	var category, rule, match;

	for(category in this.checks) {
		if (!this.checks.hasOwnProperty(category)) { continue; }

		for(rule in this.checks[category]) {
			if (!this.checks[category].hasOwnProperty(rule)) { continue; }

			if(match = (new RegExp(rule, 'i')).exec(notation)) {
				args.push(match);

				if(category === 'builtin' || this.plugins[category]) {
					this.checks[category][rule].apply(
						this.plugins[category] || this, args
					);
				}
			}
		}
	}
}

var rmove = /^position\.(my|at|adjust|target|container|viewport)|style|content|show\.ready/i,
	rrender = /^prerender|show\.ready/i;

PROTOTYPE.set = function(option, value) {
	if(this.destroyed) { return this; }

	var rendered = this.rendered,
		reposition = FALSE,
		options = this.options,
		name;

	// Convert singular option/value pair into object form
	if('string' === typeof option) {
		name = option; option = {}; option[name] = value;
	}
	else { option = $.extend({}, option); }

	// Set all of the defined options to their new values
	$.each(option, function(notation, val) {
		if(rendered && rrender.test(notation)) {
			delete option[notation]; return;
		}

		// Set new obj value
		var obj = convertNotation(options, notation.toLowerCase()), previous;
		previous = obj[0][ obj[1] ];
		obj[0][ obj[1] ] = val && val.nodeType ? $(val) : val;

		// Also check if we need to reposition
		reposition = rmove.test(notation) || reposition;

		// Set the new params for the callback
		option[notation] = [obj[0], obj[1], val, previous];
	});

	// Re-sanitize options
	sanitizeOptions(options);

	/*
	 * Execute any valid callbacks for the set options
	 * Also set positioning flag so we don't get loads of redundant repositioning calls.
	 */
	this.positioning = TRUE;
	$.each(option, $.proxy(setCallback, this));
	this.positioning = FALSE;

	// Update position if needed
	if(this.rendered && this.tooltip[0].offsetWidth > 0 && reposition) {
		this.reposition( options.position.target === 'mouse' ? NULL : this.cache.event );
	}

	return this;
};
;PROTOTYPE._update = function(content, element) {
	var self = this,
		cache = this.cache;

	// Make sure tooltip is rendered and content is defined. If not return
	if(!this.rendered || !content) { return FALSE; }

	// Use function to parse content
	if($.isFunction(content)) {
		content = content.call(this.elements.target, cache.event, this) || '';
	}

	// Handle deferred content
	if($.isFunction(content.then)) {
		cache.waiting = TRUE;
		return content.then(function(c) {
			cache.waiting = FALSE;
			return self._update(c, element);
		}, NULL, function(e) {
			return self._update(e, element);
		});
	}

	// If content is null... return false
	if(content === FALSE || !content && content !== '') { return FALSE; }

	// Append new content if its a DOM array and show it if hidden
	if(content.jquery && content.length > 0) {
		element.empty().append(
			content.css({ display: 'block', visibility: 'visible' })
		);
	}

	// Content is a regular string, insert the new content
	else { element.html(content); }

	// Wait for content to be loaded, and reposition
	return this._waitForContent(element).then(function(images) {
		if(self.rendered && self.tooltip[0].offsetWidth > 0) {
			self.reposition(cache.event, !images.length);
		}
	});
};

PROTOTYPE._waitForContent = function(element) {
	var cache = this.cache;

	// Set flag
	cache.waiting = TRUE;

	// If imagesLoaded is included, ensure images have loaded and return promise
	return ( $.fn.imagesLoaded ? element.imagesLoaded() : new $.Deferred().resolve([]) )
		.done(function() { cache.waiting = FALSE; })
		.promise();
};

PROTOTYPE._updateContent = function(content, reposition) {
	this._update(content, this.elements.content, reposition);
};

PROTOTYPE._updateTitle = function(content, reposition) {
	if(this._update(content, this.elements.title, reposition) === FALSE) {
		this._removeTitle(FALSE);
	}
};

PROTOTYPE._createTitle = function()
{
	var elements = this.elements,
		id = this._id+'-title';

	// Destroy previous title element, if present
	if(elements.titlebar) { this._removeTitle(); }

	// Create title bar and title elements
	elements.titlebar = $('<div />', {
		'class': NAMESPACE + '-titlebar ' + (this.options.style.widget ? createWidgetClass('header') : '')
	})
	.append(
		elements.title = $('<div />', {
			'id': id,
			'class': NAMESPACE + '-title',
			'aria-atomic': TRUE
		})
	)
	.insertBefore(elements.content)

	// Button-specific events
	.delegate('.qtip-close', 'mousedown keydown mouseup keyup mouseout', function(event) {
		$(this).toggleClass('ui-state-active ui-state-focus', event.type.substr(-4) === 'down');
	})
	.delegate('.qtip-close', 'mouseover mouseout', function(event){
		$(this).toggleClass('ui-state-hover', event.type === 'mouseover');
	});

	// Create button if enabled
	if(this.options.content.button) { this._createButton(); }
};

PROTOTYPE._removeTitle = function(reposition)
{
	var elements = this.elements;

	if(elements.title) {
		elements.titlebar.remove();
		elements.titlebar = elements.title = elements.button = NULL;

		// Reposition if enabled
		if(reposition !== FALSE) { this.reposition(); }
	}
};
;PROTOTYPE._createPosClass = function(my) {
	return NAMESPACE + '-pos-' + (my || this.options.position.my).abbrev();
};

PROTOTYPE.reposition = function(event, effect) {
	if(!this.rendered || this.positioning || this.destroyed) { return this; }

	// Set positioning flag
	this.positioning = TRUE;

	var cache = this.cache,
		tooltip = this.tooltip,
		posOptions = this.options.position,
		target = posOptions.target,
		my = posOptions.my,
		at = posOptions.at,
		viewport = posOptions.viewport,
		container = posOptions.container,
		adjust = posOptions.adjust,
		method = adjust.method.split(' '),
		tooltipWidth = tooltip.outerWidth(FALSE),
		tooltipHeight = tooltip.outerHeight(FALSE),
		targetWidth = 0,
		targetHeight = 0,
		type = tooltip.css('position'),
		position = { left: 0, top: 0 },
		visible = tooltip[0].offsetWidth > 0,
		isScroll = event && event.type === 'scroll',
		win = $(window),
		doc = container[0].ownerDocument,
		mouse = this.mouse,
		pluginCalculations, offset, adjusted, newClass;

	// Check if absolute position was passed
	if($.isArray(target) && target.length === 2) {
		// Force left top and set position
		at = { x: LEFT, y: TOP };
		position = { left: target[0], top: target[1] };
	}

	// Check if mouse was the target
	else if(target === 'mouse') {
		// Force left top to allow flipping
		at = { x: LEFT, y: TOP };

		// Use the mouse origin that caused the show event, if distance hiding is enabled
		if((!adjust.mouse || this.options.hide.distance) && cache.origin && cache.origin.pageX) {
			event =  cache.origin;
		}

		// Use cached event for resize/scroll events
		else if(!event || event && (event.type === 'resize' || event.type === 'scroll')) {
			event = cache.event;
		}

		// Otherwise, use the cached mouse coordinates if available
		else if(mouse && mouse.pageX) {
			event = mouse;
		}

		// Calculate body and container offset and take them into account below
		if(type !== 'static') { position = container.offset(); }
		if(doc.body.offsetWidth !== (window.innerWidth || doc.documentElement.clientWidth)) {
			offset = $(document.body).offset();
		}

		// Use event coordinates for position
		position = {
			left: event.pageX - position.left + (offset && offset.left || 0),
			top: event.pageY - position.top + (offset && offset.top || 0)
		};

		// Scroll events are a pain, some browsers
		if(adjust.mouse && isScroll && mouse) {
			position.left -= (mouse.scrollX || 0) - win.scrollLeft();
			position.top -= (mouse.scrollY || 0) - win.scrollTop();
		}
	}

	// Target wasn't mouse or absolute...
	else {
		// Check if event targetting is being used
		if(target === 'event') {
			if(event && event.target && event.type !== 'scroll' && event.type !== 'resize') {
				cache.target = $(event.target);
			}
			else if(!event.target) {
				cache.target = this.elements.target;
			}
		}
		else if(target !== 'event'){
			cache.target = $(target.jquery ? target : this.elements.target);
		}
		target = cache.target;

		// Parse the target into a jQuery object and make sure there's an element present
		target = $(target).eq(0);
		if(target.length === 0) { return this; }

		// Check if window or document is the target
		else if(target[0] === document || target[0] === window) {
			targetWidth = BROWSER.iOS ? window.innerWidth : target.width();
			targetHeight = BROWSER.iOS ? window.innerHeight : target.height();

			if(target[0] === window) {
				position = {
					top: (viewport || target).scrollTop(),
					left: (viewport || target).scrollLeft()
				};
			}
		}

		// Check if the target is an <AREA> element
		else if(PLUGINS.imagemap && target.is('area')) {
			pluginCalculations = PLUGINS.imagemap(this, target, at, PLUGINS.viewport ? method : FALSE);
		}

		// Check if the target is an SVG element
		else if(PLUGINS.svg && target && target[0].ownerSVGElement) {
			pluginCalculations = PLUGINS.svg(this, target, at, PLUGINS.viewport ? method : FALSE);
		}

		// Otherwise use regular jQuery methods
		else {
			targetWidth = target.outerWidth(FALSE);
			targetHeight = target.outerHeight(FALSE);
			position = target.offset();
		}

		// Parse returned plugin values into proper variables
		if(pluginCalculations) {
			targetWidth = pluginCalculations.width;
			targetHeight = pluginCalculations.height;
			offset = pluginCalculations.offset;
			position = pluginCalculations.position;
		}

		// Adjust position to take into account offset parents
		position = this.reposition.offset(target, position, container);

		// Adjust for position.fixed tooltips (and also iOS scroll bug in v3.2-4.0 & v4.3-4.3.2)
		if(BROWSER.iOS > 3.1 && BROWSER.iOS < 4.1 ||
			BROWSER.iOS >= 4.3 && BROWSER.iOS < 4.33 ||
			!BROWSER.iOS && type === 'fixed'
		){
			position.left -= win.scrollLeft();
			position.top -= win.scrollTop();
		}

		// Adjust position relative to target
		if(!pluginCalculations || pluginCalculations && pluginCalculations.adjustable !== FALSE) {
			position.left += at.x === RIGHT ? targetWidth : at.x === CENTER ? targetWidth / 2 : 0;
			position.top += at.y === BOTTOM ? targetHeight : at.y === CENTER ? targetHeight / 2 : 0;
		}
	}

	// Adjust position relative to tooltip
	position.left += adjust.x + (my.x === RIGHT ? -tooltipWidth : my.x === CENTER ? -tooltipWidth / 2 : 0);
	position.top += adjust.y + (my.y === BOTTOM ? -tooltipHeight : my.y === CENTER ? -tooltipHeight / 2 : 0);

	// Use viewport adjustment plugin if enabled
	if(PLUGINS.viewport) {
		adjusted = position.adjusted = PLUGINS.viewport(
			this, position, posOptions, targetWidth, targetHeight, tooltipWidth, tooltipHeight
		);

		// Apply offsets supplied by positioning plugin (if used)
		if(offset && adjusted.left) { position.left += offset.left; }
		if(offset && adjusted.top) {  position.top += offset.top; }

		// Apply any new 'my' position
		if(adjusted.my) { this.position.my = adjusted.my; }
	}

	// Viewport adjustment is disabled, set values to zero
	else { position.adjusted = { left: 0, top: 0 }; }

	// Set tooltip position class if it's changed
	if(cache.posClass !== (newClass = this._createPosClass(this.position.my))) {
		cache.posClass = newClass;
		tooltip.removeClass(cache.posClass).addClass(newClass);
	}

	// tooltipmove event
	if(!this._trigger('move', [position, viewport.elem || viewport], event)) { return this; }
	delete position.adjusted;

	// If effect is disabled, target it mouse, no animation is defined or positioning gives NaN out, set CSS directly
	if(effect === FALSE || !visible || isNaN(position.left) || isNaN(position.top) || target === 'mouse' || !$.isFunction(posOptions.effect)) {
		tooltip.css(position);
	}

	// Use custom function if provided
	else if($.isFunction(posOptions.effect)) {
		posOptions.effect.call(tooltip, this, $.extend({}, position));
		tooltip.queue(function(next) {
			// Reset attributes to avoid cross-browser rendering bugs
			$(this).css({ opacity: '', height: '' });
			if(BROWSER.ie) { this.style.removeAttribute('filter'); }

			next();
		});
	}

	// Set positioning flag
	this.positioning = FALSE;

	return this;
};

// Custom (more correct for qTip!) offset calculator
PROTOTYPE.reposition.offset = function(elem, pos, container) {
	if(!container[0]) { return pos; }

	var ownerDocument = $(elem[0].ownerDocument),
		quirks = !!BROWSER.ie && document.compatMode !== 'CSS1Compat',
		parent = container[0],
		scrolled, position, parentOffset, overflow;

	function scroll(e, i) {
		pos.left += i * e.scrollLeft();
		pos.top += i * e.scrollTop();
	}

	// Compensate for non-static containers offset
	do {
		if((position = $.css(parent, 'position')) !== 'static') {
			if(position === 'fixed') {
				parentOffset = parent.getBoundingClientRect();
				scroll(ownerDocument, -1);
			}
			else {
				parentOffset = $(parent).position();
				parentOffset.left += parseFloat($.css(parent, 'borderLeftWidth')) || 0;
				parentOffset.top += parseFloat($.css(parent, 'borderTopWidth')) || 0;
			}

			pos.left -= parentOffset.left + (parseFloat($.css(parent, 'marginLeft')) || 0);
			pos.top -= parentOffset.top + (parseFloat($.css(parent, 'marginTop')) || 0);

			// If this is the first parent element with an overflow of "scroll" or "auto", store it
			if(!scrolled && (overflow = $.css(parent, 'overflow')) !== 'hidden' && overflow !== 'visible' && $.prop(parent, 'tagName') !== 'BODY') { scrolled = $(parent); }
		}
	}
	while(parent = parent.offsetParent);

	// Compensate for containers scroll if it also has an offsetParent (or in IE quirks mode)
	if(scrolled && (scrolled[0] !== ownerDocument[0] || quirks)) {
		scroll(scrolled, 1);
	}

	return pos;
};

// Corner class
var C = (CORNER = PROTOTYPE.reposition.Corner = function(corner, forceY) {
	corner = ('' + corner).replace(/([A-Z])/, ' $1').replace(/middle/gi, CENTER).toLowerCase();
	this.x = (corner.match(/left|right/i) || corner.match(/center/) || ['inherit'])[0].toLowerCase();
	this.y = (corner.match(/top|bottom|center/i) || ['inherit'])[0].toLowerCase();
	this.forceY = !!forceY;

	var f = corner.charAt(0);
	this.precedance = f === 't' || f === 'b' ? Y : X;
}).prototype;

C.invert = function(z, center) {
	this[z] = this[z] === LEFT ? RIGHT : this[z] === RIGHT ? LEFT : center || this[z];
};

C.string = function(join) {
	var x = this.x, y = this.y;

	var result = x !== y ?
		x === 'center' || y !== 'center' && (this.precedance === Y || this.forceY) ? 
			[y,x] : 
			[x,y] :
		[x];

	return join !== false ? result.join(' ') : result;
};

C.abbrev = function() {
	var result = this.string(false);
	return result[0].charAt(0) + (result[1] && result[1].charAt(0) || '');
};

C.clone = function() {
	return new CORNER( this.string(), this.forceY );
};

;
PROTOTYPE.toggle = function(state, event) {
	var cache = this.cache,
		options = this.options,
		tooltip = this.tooltip;

	// Try to prevent flickering when tooltip overlaps show element
	if(event) {
		if((/over|enter/).test(event.type) && cache.event && (/out|leave/).test(cache.event.type) &&
			options.show.target.add(event.target).length === options.show.target.length &&
			tooltip.has(event.relatedTarget).length) {
			return this;
		}

		// Cache event
		cache.event = $.event.fix(event);
	}

	// If we're currently waiting and we've just hidden... stop it
	this.waiting && !state && (this.hiddenDuringWait = TRUE);

	// Render the tooltip if showing and it isn't already
	if(!this.rendered) { return state ? this.render(1) : this; }
	else if(this.destroyed || this.disabled) { return this; }

	var type = state ? 'show' : 'hide',
		opts = this.options[type],
		posOptions = this.options.position,
		contentOptions = this.options.content,
		width = this.tooltip.css('width'),
		visible = this.tooltip.is(':visible'),
		animate = state || opts.target.length === 1,
		sameTarget = !event || opts.target.length < 2 || cache.target[0] === event.target,
		identicalState, allow, after;

	// Detect state if valid one isn't provided
	if((typeof state).search('boolean|number')) { state = !visible; }

	// Check if the tooltip is in an identical state to the new would-be state
	identicalState = !tooltip.is(':animated') && visible === state && sameTarget;

	// Fire tooltip(show/hide) event and check if destroyed
	allow = !identicalState ? !!this._trigger(type, [90]) : NULL;

	// Check to make sure the tooltip wasn't destroyed in the callback
	if(this.destroyed) { return this; }

	// If the user didn't stop the method prematurely and we're showing the tooltip, focus it
	if(allow !== FALSE && state) { this.focus(event); }

	// If the state hasn't changed or the user stopped it, return early
	if(!allow || identicalState) { return this; }

	// Set ARIA hidden attribute
	$.attr(tooltip[0], 'aria-hidden', !!!state);

	// Execute state specific properties
	if(state) {
		// Store show origin coordinates
		this.mouse && (cache.origin = $.event.fix(this.mouse));

		// Update tooltip content & title if it's a dynamic function
		if($.isFunction(contentOptions.text)) { this._updateContent(contentOptions.text, FALSE); }
		if($.isFunction(contentOptions.title)) { this._updateTitle(contentOptions.title, FALSE); }

		// Cache mousemove events for positioning purposes (if not already tracking)
		if(!trackingBound && posOptions.target === 'mouse' && posOptions.adjust.mouse) {
			$(document).bind('mousemove.'+NAMESPACE, this._storeMouse);
			trackingBound = TRUE;
		}

		// Update the tooltip position (set width first to prevent viewport/max-width issues)
		if(!width) { tooltip.css('width', tooltip.outerWidth(FALSE)); }
		this.reposition(event, arguments[2]);
		if(!width) { tooltip.css('width', ''); }

		// Hide other tooltips if tooltip is solo
		if(!!opts.solo) {
			(typeof opts.solo === 'string' ? $(opts.solo) : $(SELECTOR, opts.solo))
				.not(tooltip).not(opts.target).qtip('hide', new $.Event('tooltipsolo'));
		}
	}
	else {
		// Clear show timer if we're hiding
		clearTimeout(this.timers.show);

		// Remove cached origin on hide
		delete cache.origin;

		// Remove mouse tracking event if not needed (all tracking qTips are hidden)
		if(trackingBound && !$(SELECTOR+'[tracking="true"]:visible', opts.solo).not(tooltip).length) {
			$(document).unbind('mousemove.'+NAMESPACE);
			trackingBound = FALSE;
		}

		// Blur the tooltip
		this.blur(event);
	}

	// Define post-animation, state specific properties
	after = $.proxy(function() {
		if(state) {
			// Prevent antialias from disappearing in IE by removing filter
			if(BROWSER.ie) { tooltip[0].style.removeAttribute('filter'); }

			// Remove overflow setting to prevent tip bugs
			tooltip.css('overflow', '');

			// Autofocus elements if enabled
			if('string' === typeof opts.autofocus) {
				$(this.options.show.autofocus, tooltip).focus();
			}

			// If set, hide tooltip when inactive for delay period
			this.options.show.target.trigger('qtip-'+this.id+'-inactive');
		}
		else {
			// Reset CSS states
			tooltip.css({
				display: '',
				visibility: '',
				opacity: '',
				left: '',
				top: ''
			});
		}

		// tooltipvisible/tooltiphidden events
		this._trigger(state ? 'visible' : 'hidden');
	}, this);

	// If no effect type is supplied, use a simple toggle
	if(opts.effect === FALSE || animate === FALSE) {
		tooltip[ type ]();
		after();
	}

	// Use custom function if provided
	else if($.isFunction(opts.effect)) {
		tooltip.stop(1, 1);
		opts.effect.call(tooltip, this);
		tooltip.queue('fx', function(n) {
			after(); n();
		});
	}

	// Use basic fade function by default
	else { tooltip.fadeTo(90, state ? 1 : 0, after); }

	// If inactive hide method is set, active it
	if(state) { opts.target.trigger('qtip-'+this.id+'-inactive'); }

	return this;
};

PROTOTYPE.show = function(event) { return this.toggle(TRUE, event); };

PROTOTYPE.hide = function(event) { return this.toggle(FALSE, event); };
;PROTOTYPE.focus = function(event) {
	if(!this.rendered || this.destroyed) { return this; }

	var qtips = $(SELECTOR),
		tooltip = this.tooltip,
		curIndex = parseInt(tooltip[0].style.zIndex, 10),
		newIndex = QTIP.zindex + qtips.length;

	// Only update the z-index if it has changed and tooltip is not already focused
	if(!tooltip.hasClass(CLASS_FOCUS)) {
		// tooltipfocus event
		if(this._trigger('focus', [newIndex], event)) {
			// Only update z-index's if they've changed
			if(curIndex !== newIndex) {
				// Reduce our z-index's and keep them properly ordered
				qtips.each(function() {
					if(this.style.zIndex > curIndex) {
						this.style.zIndex = this.style.zIndex - 1;
					}
				});

				// Fire blur event for focused tooltip
				qtips.filter('.' + CLASS_FOCUS).qtip('blur', event);
			}

			// Set the new z-index
			tooltip.addClass(CLASS_FOCUS)[0].style.zIndex = newIndex;
		}
	}

	return this;
};

PROTOTYPE.blur = function(event) {
	if(!this.rendered || this.destroyed) { return this; }

	// Set focused status to FALSE
	this.tooltip.removeClass(CLASS_FOCUS);

	// tooltipblur event
	this._trigger('blur', [ this.tooltip.css('zIndex') ], event);

	return this;
};
;PROTOTYPE.disable = function(state) {
	if(this.destroyed) { return this; }

	// If 'toggle' is passed, toggle the current state
	if(state === 'toggle') {
		state = !(this.rendered ? this.tooltip.hasClass(CLASS_DISABLED) : this.disabled);
	}

	// Disable if no state passed
	else if('boolean' !== typeof state) {
		state = TRUE;
	}

	if(this.rendered) {
		this.tooltip.toggleClass(CLASS_DISABLED, state)
			.attr('aria-disabled', state);
	}

	this.disabled = !!state;

	return this;
};

PROTOTYPE.enable = function() { return this.disable(FALSE); };
;PROTOTYPE._createButton = function()
{
	var self = this,
		elements = this.elements,
		tooltip = elements.tooltip,
		button = this.options.content.button,
		isString = typeof button === 'string',
		close = isString ? button : 'Close tooltip';

	if(elements.button) { elements.button.remove(); }

	// Use custom button if one was supplied by user, else use default
	if(button.jquery) {
		elements.button = button;
	}
	else {
		elements.button = $('<a />', {
			'class': 'qtip-close ' + (this.options.style.widget ? '' : NAMESPACE+'-icon'),
			'title': close,
			'aria-label': close
		})
		.prepend(
			$('<span />', {
				'class': 'ui-icon ui-icon-close',
				'html': '&times;'
			})
		);
	}

	// Create button and setup attributes
	elements.button.appendTo(elements.titlebar || tooltip)
		.attr('role', 'button')
		.click(function(event) {
			if(!tooltip.hasClass(CLASS_DISABLED)) { self.hide(event); }
			return FALSE;
		});
};

PROTOTYPE._updateButton = function(button)
{
	// Make sure tooltip is rendered and if not, return
	if(!this.rendered) { return FALSE; }

	var elem = this.elements.button;
	if(button) { this._createButton(); }
	else { elem.remove(); }
};
;// Widget class creator
function createWidgetClass(cls) {
	return WIDGET.concat('').join(cls ? '-'+cls+' ' : ' ');
}

// Widget class setter method
PROTOTYPE._setWidget = function()
{
	var on = this.options.style.widget,
		elements = this.elements,
		tooltip = elements.tooltip,
		disabled = tooltip.hasClass(CLASS_DISABLED);

	tooltip.removeClass(CLASS_DISABLED);
	CLASS_DISABLED = on ? 'ui-state-disabled' : 'qtip-disabled';
	tooltip.toggleClass(CLASS_DISABLED, disabled);

	tooltip.toggleClass('ui-helper-reset '+createWidgetClass(), on).toggleClass(CLASS_DEFAULT, this.options.style.def && !on);

	if(elements.content) {
		elements.content.toggleClass( createWidgetClass('content'), on);
	}
	if(elements.titlebar) {
		elements.titlebar.toggleClass( createWidgetClass('header'), on);
	}
	if(elements.button) {
		elements.button.toggleClass(NAMESPACE+'-icon', !on);
	}
};
;function delay(callback, duration) {
	// If tooltip has displayed, start hide timer
	if(duration > 0) {
		return setTimeout(
			$.proxy(callback, this), duration
		);
	}
	else{ callback.call(this); }
}

function showMethod(event) {
	if(this.tooltip.hasClass(CLASS_DISABLED)) { return; }

	// Clear hide timers
	clearTimeout(this.timers.show);
	clearTimeout(this.timers.hide);

	// Start show timer
	this.timers.show = delay.call(this,
		function() { this.toggle(TRUE, event); },
		this.options.show.delay
	);
}

function hideMethod(event) {
	if(this.tooltip.hasClass(CLASS_DISABLED) || this.destroyed) { return; }

	// Check if new target was actually the tooltip element
	var relatedTarget = $(event.relatedTarget),
		ontoTooltip = relatedTarget.closest(SELECTOR)[0] === this.tooltip[0],
		ontoTarget = relatedTarget[0] === this.options.show.target[0];

	// Clear timers and stop animation queue
	clearTimeout(this.timers.show);
	clearTimeout(this.timers.hide);

	// Prevent hiding if tooltip is fixed and event target is the tooltip.
	// Or if mouse positioning is enabled and cursor momentarily overlaps
	if(this !== relatedTarget[0] &&
		(this.options.position.target === 'mouse' && ontoTooltip) ||
		this.options.hide.fixed && (
			(/mouse(out|leave|move)/).test(event.type) && (ontoTooltip || ontoTarget))
		)
	{
		/* eslint-disable no-empty */
		try {
			event.preventDefault();
			event.stopImmediatePropagation();
		} catch(e) {}
		/* eslint-enable no-empty */

		return;
	}

	// If tooltip has displayed, start hide timer
	this.timers.hide = delay.call(this,
		function() { this.toggle(FALSE, event); },
		this.options.hide.delay,
		this
	);
}

function inactiveMethod(event) {
	if(this.tooltip.hasClass(CLASS_DISABLED) || !this.options.hide.inactive) { return; }

	// Clear timer
	clearTimeout(this.timers.inactive);

	this.timers.inactive = delay.call(this,
		function(){ this.hide(event); },
		this.options.hide.inactive
	);
}

function repositionMethod(event) {
	if(this.rendered && this.tooltip[0].offsetWidth > 0) { this.reposition(event); }
}

// Store mouse coordinates
PROTOTYPE._storeMouse = function(event) {
	(this.mouse = $.event.fix(event)).type = 'mousemove';
	return this;
};

// Bind events
PROTOTYPE._bind = function(targets, events, method, suffix, context) {
	if(!targets || !method || !events.length) { return; }
	var ns = '.' + this._id + (suffix ? '-'+suffix : '');
	$(targets).bind(
		(events.split ? events : events.join(ns + ' ')) + ns,
		$.proxy(method, context || this)
	);
	return this;
};
PROTOTYPE._unbind = function(targets, suffix) {
	targets && $(targets).unbind('.' + this._id + (suffix ? '-'+suffix : ''));
	return this;
};

// Global delegation helper
function delegate(selector, events, method) {
	$(document.body).delegate(selector,
		(events.split ? events : events.join('.'+NAMESPACE + ' ')) + '.'+NAMESPACE,
		function() {
			var api = QTIP.api[ $.attr(this, ATTR_ID) ];
			api && !api.disabled && method.apply(api, arguments);
		}
	);
}
// Event trigger
PROTOTYPE._trigger = function(type, args, event) {
	var callback = new $.Event('tooltip'+type);
	callback.originalEvent = event && $.extend({}, event) || this.cache.event || NULL;

	this.triggering = type;
	this.tooltip.trigger(callback, [this].concat(args || []));
	this.triggering = FALSE;

	return !callback.isDefaultPrevented();
};

PROTOTYPE._bindEvents = function(showEvents, hideEvents, showTargets, hideTargets, showCallback, hideCallback) {
	// Get tasrgets that lye within both
	var similarTargets = showTargets.filter( hideTargets ).add( hideTargets.filter(showTargets) ),
		toggleEvents = [];

	// If hide and show targets are the same...
	if(similarTargets.length) {

		// Filter identical show/hide events
		$.each(hideEvents, function(i, type) {
			var showIndex = $.inArray(type, showEvents);

			// Both events are identical, remove from both hide and show events
			// and append to toggleEvents
			showIndex > -1 && toggleEvents.push( showEvents.splice( showIndex, 1 )[0] );
		});

		// Toggle events are special case of identical show/hide events, which happen in sequence
		if(toggleEvents.length) {
			// Bind toggle events to the similar targets
			this._bind(similarTargets, toggleEvents, function(event) {
				var state = this.rendered ? this.tooltip[0].offsetWidth > 0 : false;
				(state ? hideCallback : showCallback).call(this, event);
			});

			// Remove the similar targets from the regular show/hide bindings
			showTargets = showTargets.not(similarTargets);
			hideTargets = hideTargets.not(similarTargets);
		}
	}

	// Apply show/hide/toggle events
	this._bind(showTargets, showEvents, showCallback);
	this._bind(hideTargets, hideEvents, hideCallback);
};

PROTOTYPE._assignInitialEvents = function(event) {
	var options = this.options,
		showTarget = options.show.target,
		hideTarget = options.hide.target,
		showEvents = options.show.event ? $.trim('' + options.show.event).split(' ') : [],
		hideEvents = options.hide.event ? $.trim('' + options.hide.event).split(' ') : [];

	// Catch remove/removeqtip events on target element to destroy redundant tooltips
	this._bind(this.elements.target, ['remove', 'removeqtip'], function() {
		this.destroy(true);
	}, 'destroy');

	/*
	 * Make sure hoverIntent functions properly by using mouseleave as a hide event if
	 * mouseenter/mouseout is used for show.event, even if it isn't in the users options.
	 */
	if(/mouse(over|enter)/i.test(options.show.event) && !/mouse(out|leave)/i.test(options.hide.event)) {
		hideEvents.push('mouseleave');
	}

	/*
	 * Also make sure initial mouse targetting works correctly by caching mousemove coords
	 * on show targets before the tooltip has rendered. Also set onTarget when triggered to
	 * keep mouse tracking working.
	 */
	this._bind(showTarget, 'mousemove', function(moveEvent) {
		this._storeMouse(moveEvent);
		this.cache.onTarget = TRUE;
	});

	// Define hoverIntent function
	function hoverIntent(hoverEvent) {
		// Only continue if tooltip isn't disabled
		if(this.disabled || this.destroyed) { return FALSE; }

		// Cache the event data
		this.cache.event = hoverEvent && $.event.fix(hoverEvent);
		this.cache.target = hoverEvent && $(hoverEvent.target);

		// Start the event sequence
		clearTimeout(this.timers.show);
		this.timers.show = delay.call(this,
			function() { this.render(typeof hoverEvent === 'object' || options.show.ready); },
			options.prerender ? 0 : options.show.delay
		);
	}

	// Filter and bind events
	this._bindEvents(showEvents, hideEvents, showTarget, hideTarget, hoverIntent, function() {
		if(!this.timers) { return FALSE; }
		clearTimeout(this.timers.show);
	});

	// Prerendering is enabled, create tooltip now
	if(options.show.ready || options.prerender) { hoverIntent.call(this, event); }
};

// Event assignment method
PROTOTYPE._assignEvents = function() {
	var self = this,
		options = this.options,
		posOptions = options.position,

		tooltip = this.tooltip,
		showTarget = options.show.target,
		hideTarget = options.hide.target,
		containerTarget = posOptions.container,
		viewportTarget = posOptions.viewport,
		documentTarget = $(document),
		windowTarget = $(window),

		showEvents = options.show.event ? $.trim('' + options.show.event).split(' ') : [],
		hideEvents = options.hide.event ? $.trim('' + options.hide.event).split(' ') : [];


	// Assign passed event callbacks
	$.each(options.events, function(name, callback) {
		self._bind(tooltip, name === 'toggle' ? ['tooltipshow','tooltiphide'] : ['tooltip'+name], callback, null, tooltip);
	});

	// Hide tooltips when leaving current window/frame (but not select/option elements)
	if(/mouse(out|leave)/i.test(options.hide.event) && options.hide.leave === 'window') {
		this._bind(documentTarget, ['mouseout', 'blur'], function(event) {
			if(!/select|option/.test(event.target.nodeName) && !event.relatedTarget) {
				this.hide(event);
			}
		});
	}

	// Enable hide.fixed by adding appropriate class
	if(options.hide.fixed) {
		hideTarget = hideTarget.add( tooltip.addClass(CLASS_FIXED) );
	}

	/*
	 * Make sure hoverIntent functions properly by using mouseleave to clear show timer if
	 * mouseenter/mouseout is used for show.event, even if it isn't in the users options.
	 */
	else if(/mouse(over|enter)/i.test(options.show.event)) {
		this._bind(hideTarget, 'mouseleave', function() {
			clearTimeout(this.timers.show);
		});
	}

	// Hide tooltip on document mousedown if unfocus events are enabled
	if(('' + options.hide.event).indexOf('unfocus') > -1) {
		this._bind(containerTarget.closest('html'), ['mousedown', 'touchstart'], function(event) {
			var elem = $(event.target),
				enabled = this.rendered && !this.tooltip.hasClass(CLASS_DISABLED) && this.tooltip[0].offsetWidth > 0,
				isAncestor = elem.parents(SELECTOR).filter(this.tooltip[0]).length > 0;

			if(elem[0] !== this.target[0] && elem[0] !== this.tooltip[0] && !isAncestor &&
				!this.target.has(elem[0]).length && enabled
			) {
				this.hide(event);
			}
		});
	}

	// Check if the tooltip hides when inactive
	if('number' === typeof options.hide.inactive) {
		// Bind inactive method to show target(s) as a custom event
		this._bind(showTarget, 'qtip-'+this.id+'-inactive', inactiveMethod, 'inactive');

		// Define events which reset the 'inactive' event handler
		this._bind(hideTarget.add(tooltip), QTIP.inactiveEvents, inactiveMethod);
	}

	// Filter and bind events
	this._bindEvents(showEvents, hideEvents, showTarget, hideTarget, showMethod, hideMethod);

	// Mouse movement bindings
	this._bind(showTarget.add(tooltip), 'mousemove', function(event) {
		// Check if the tooltip hides when mouse is moved a certain distance
		if('number' === typeof options.hide.distance) {
			var origin = this.cache.origin || {},
				limit = this.options.hide.distance,
				abs = Math.abs;

			// Check if the movement has gone beyond the limit, and hide it if so
			if(abs(event.pageX - origin.pageX) >= limit || abs(event.pageY - origin.pageY) >= limit) {
				this.hide(event);
			}
		}

		// Cache mousemove coords on show targets
		this._storeMouse(event);
	});

	// Mouse positioning events
	if(posOptions.target === 'mouse') {
		// If mouse adjustment is on...
		if(posOptions.adjust.mouse) {
			// Apply a mouseleave event so we don't get problems with overlapping
			if(options.hide.event) {
				// Track if we're on the target or not
				this._bind(showTarget, ['mouseenter', 'mouseleave'], function(event) {
					if(!this.cache) {return FALSE; }
					this.cache.onTarget = event.type === 'mouseenter';
				});
			}

			// Update tooltip position on mousemove
			this._bind(documentTarget, 'mousemove', function(event) {
				// Update the tooltip position only if the tooltip is visible and adjustment is enabled
				if(this.rendered && this.cache.onTarget && !this.tooltip.hasClass(CLASS_DISABLED) && this.tooltip[0].offsetWidth > 0) {
					this.reposition(event);
				}
			});
		}
	}

	// Adjust positions of the tooltip on window resize if enabled
	if(posOptions.adjust.resize || viewportTarget.length) {
		this._bind( $.event.special.resize ? viewportTarget : windowTarget, 'resize', repositionMethod );
	}

	// Adjust tooltip position on scroll of the window or viewport element if present
	if(posOptions.adjust.scroll) {
		this._bind( windowTarget.add(posOptions.container), 'scroll', repositionMethod );
	}
};

// Un-assignment method
PROTOTYPE._unassignEvents = function() {
	var options = this.options,
		showTargets = options.show.target,
		hideTargets = options.hide.target,
		targets = $.grep([
			this.elements.target[0],
			this.rendered && this.tooltip[0],
			options.position.container[0],
			options.position.viewport[0],
			options.position.container.closest('html')[0], // unfocus
			window,
			document
		], function(i) {
			return typeof i === 'object';
		});

	// Add show and hide targets if they're valid
	if(showTargets && showTargets.toArray) {
		targets = targets.concat(showTargets.toArray());
	}
	if(hideTargets && hideTargets.toArray) {
		targets = targets.concat(hideTargets.toArray());
	}

	// Unbind the events
	this._unbind(targets)
		._unbind(targets, 'destroy')
		._unbind(targets, 'inactive');
};

// Apply common event handlers using delegate (avoids excessive .bind calls!)
$(function() {
	delegate(SELECTOR, ['mouseenter', 'mouseleave'], function(event) {
		var state = event.type === 'mouseenter',
			tooltip = $(event.currentTarget),
			target = $(event.relatedTarget || event.target),
			options = this.options;

		// On mouseenter...
		if(state) {
			// Focus the tooltip on mouseenter (z-index stacking)
			this.focus(event);

			// Clear hide timer on tooltip hover to prevent it from closing
			tooltip.hasClass(CLASS_FIXED) && !tooltip.hasClass(CLASS_DISABLED) && clearTimeout(this.timers.hide);
		}

		// On mouseleave...
		else {
			// When mouse tracking is enabled, hide when we leave the tooltip and not onto the show target (if a hide event is set)
			if(options.position.target === 'mouse' && options.position.adjust.mouse &&
				options.hide.event && options.show.target && !target.closest(options.show.target[0]).length) {
				this.hide(event);
			}
		}

		// Add hover class
		tooltip.toggleClass(CLASS_HOVER, state);
	});

	// Define events which reset the 'inactive' event handler
	delegate('['+ATTR_ID+']', INACTIVE_EVENTS, inactiveMethod);
});
;// Initialization method
function init(elem, id, opts) {
	var obj, posOptions, attr, config, title,

	// Setup element references
	docBody = $(document.body),

	// Use document body instead of document element if needed
	newTarget = elem[0] === document ? docBody : elem,

	// Grab metadata from element if plugin is present
	metadata = elem.metadata ? elem.metadata(opts.metadata) : NULL,

	// If metadata type if HTML5, grab 'name' from the object instead, or use the regular data object otherwise
	metadata5 = opts.metadata.type === 'html5' && metadata ? metadata[opts.metadata.name] : NULL,

	// Grab data from metadata.name (or data-qtipopts as fallback) using .data() method,
	html5 = elem.data(opts.metadata.name || 'qtipopts');

	// If we don't get an object returned attempt to parse it manualyl without parseJSON
	/* eslint-disable no-empty */
	try { html5 = typeof html5 === 'string' ? $.parseJSON(html5) : html5; }
	catch(e) {}
	/* eslint-enable no-empty */

	// Merge in and sanitize metadata
	config = $.extend(TRUE, {}, QTIP.defaults, opts,
		typeof html5 === 'object' ? sanitizeOptions(html5) : NULL,
		sanitizeOptions(metadata5 || metadata));

	// Re-grab our positioning options now we've merged our metadata and set id to passed value
	posOptions = config.position;
	config.id = id;

	// Setup missing content if none is detected
	if('boolean' === typeof config.content.text) {
		attr = elem.attr(config.content.attr);

		// Grab from supplied attribute if available
		if(config.content.attr !== FALSE && attr) { config.content.text = attr; }

		// No valid content was found, abort render
		else { return FALSE; }
	}

	// Setup target options
	if(!posOptions.container.length) { posOptions.container = docBody; }
	if(posOptions.target === FALSE) { posOptions.target = newTarget; }
	if(config.show.target === FALSE) { config.show.target = newTarget; }
	if(config.show.solo === TRUE) { config.show.solo = posOptions.container.closest('body'); }
	if(config.hide.target === FALSE) { config.hide.target = newTarget; }
	if(config.position.viewport === TRUE) { config.position.viewport = posOptions.container; }

	// Ensure we only use a single container
	posOptions.container = posOptions.container.eq(0);

	// Convert position corner values into x and y strings
	posOptions.at = new CORNER(posOptions.at, TRUE);
	posOptions.my = new CORNER(posOptions.my);

	// Destroy previous tooltip if overwrite is enabled, or skip element if not
	if(elem.data(NAMESPACE)) {
		if(config.overwrite) {
			elem.qtip('destroy', true);
		}
		else if(config.overwrite === FALSE) {
			return FALSE;
		}
	}

	// Add has-qtip attribute
	elem.attr(ATTR_HAS, id);

	// Remove title attribute and store it if present
	if(config.suppress && (title = elem.attr('title'))) {
		// Final attr call fixes event delegation and IE default tooltip showing problem
		elem.removeAttr('title').attr(oldtitle, title).attr('title', '');
	}

	// Initialize the tooltip and add API reference
	obj = new QTip(elem, config, id, !!attr);
	elem.data(NAMESPACE, obj);

	return obj;
}

// jQuery $.fn extension method
QTIP = $.fn.qtip = function(options, notation, newValue)
{
	var command = ('' + options).toLowerCase(), // Parse command
		returned = NULL,
		args = $.makeArray(arguments).slice(1),
		event = args[args.length - 1],
		opts = this[0] ? $.data(this[0], NAMESPACE) : NULL;

	// Check for API request
	if(!arguments.length && opts || command === 'api') {
		return opts;
	}

	// Execute API command if present
	else if('string' === typeof options) {
		this.each(function() {
			var api = $.data(this, NAMESPACE);
			if(!api) { return TRUE; }

			// Cache the event if possible
			if(event && event.timeStamp) { api.cache.event = event; }

			// Check for specific API commands
			if(notation && (command === 'option' || command === 'options')) {
				if(newValue !== undefined || $.isPlainObject(notation)) {
					api.set(notation, newValue);
				}
				else {
					returned = api.get(notation);
					return FALSE;
				}
			}

			// Execute API command
			else if(api[command]) {
				api[command].apply(api, args);
			}
		});

		return returned !== NULL ? returned : this;
	}

	// No API commands. validate provided options and setup qTips
	else if('object' === typeof options || !arguments.length) {
		// Sanitize options first
		opts = sanitizeOptions($.extend(TRUE, {}, options));

		return this.each(function(i) {
			var api, id;

			// Find next available ID, or use custom ID if provided
			id = $.isArray(opts.id) ? opts.id[i] : opts.id;
			id = !id || id === FALSE || id.length < 1 || QTIP.api[id] ? QTIP.nextid++ : id;

			// Initialize the qTip and re-grab newly sanitized options
			api = init($(this), id, opts);
			if(api === FALSE) { return TRUE; }
			else { QTIP.api[id] = api; }

			// Initialize plugins
			$.each(PLUGINS, function() {
				if(this.initialize === 'initialize') { this(api); }
			});

			// Assign initial pre-render events
			api._assignInitialEvents(event);
		});
	}
};

// Expose class
$.qtip = QTip;

// Populated in render method
QTIP.api = {};
;$.each({
	/* Allow other plugins to successfully retrieve the title of an element with a qTip applied */
	attr: function(attr, val) {
		if(this.length) {
			var self = this[0],
				title = 'title',
				api = $.data(self, 'qtip');

			if(attr === title && api && api.options && 'object' === typeof api && 'object' === typeof api.options && api.options.suppress) {
				if(arguments.length < 2) {
					return $.attr(self, oldtitle);
				}

				// If qTip is rendered and title was originally used as content, update it
				if(api && api.options.content.attr === title && api.cache.attr) {
					api.set('content.text', val);
				}

				// Use the regular attr method to set, then cache the result
				return this.attr(oldtitle, val);
			}
		}

		return $.fn['attr'+replaceSuffix].apply(this, arguments);
	},

	/* Allow clone to correctly retrieve cached title attributes */
	clone: function(keepData) {
		// Clone our element using the real clone method
		var elems = $.fn['clone'+replaceSuffix].apply(this, arguments);

		// Grab all elements with an oldtitle set, and change it to regular title attribute, if keepData is false
		if(!keepData) {
			elems.filter('['+oldtitle+']').attr('title', function() {
				return $.attr(this, oldtitle);
			})
			.removeAttr(oldtitle);
		}

		return elems;
	}
}, function(name, func) {
	if(!func || $.fn[name+replaceSuffix]) { return TRUE; }

	var old = $.fn[name+replaceSuffix] = $.fn[name];
	$.fn[name] = function() {
		return func.apply(this, arguments) || old.apply(this, arguments);
	};
});

/* Fire off 'removeqtip' handler in $.cleanData if jQuery UI not present (it already does similar).
 * This snippet is taken directly from jQuery UI source code found here:
 *     http://code.jquery.com/ui/jquery-ui-git.js
 */
if(!$.ui) {
	$['cleanData'+replaceSuffix] = $.cleanData;
	$.cleanData = function( elems ) {
		for(var i = 0, elem; (elem = $( elems[i] )).length; i++) {
			if(elem.attr(ATTR_HAS)) {
				/* eslint-disable no-empty */
				try { elem.triggerHandler('removeqtip'); }
				catch( e ) {}
				/* eslint-enable no-empty */
			}
		}
		$['cleanData'+replaceSuffix].apply(this, arguments);
	};
}
;// qTip version
QTIP.version = '3.0.3-5-g';

// Base ID for all qTips
QTIP.nextid = 0;

// Inactive events array
QTIP.inactiveEvents = INACTIVE_EVENTS;

// Base z-index for all qTips
QTIP.zindex = 15000;

// Define configuration defaults
QTIP.defaults = {
	prerender: FALSE,
	id: FALSE,
	overwrite: TRUE,
	suppress: TRUE,
	content: {
		text: TRUE,
		attr: 'title',
		title: FALSE,
		button: FALSE
	},
	position: {
		my: 'top left',
		at: 'bottom right',
		target: FALSE,
		container: FALSE,
		viewport: FALSE,
		adjust: {
			x: 0, y: 0,
			mouse: TRUE,
			scroll: TRUE,
			resize: TRUE,
			method: 'flipinvert flipinvert'
		},
		effect: function(api, pos) {
			$(this).animate(pos, {
				duration: 200,
				queue: FALSE
			});
		}
	},
	show: {
		target: FALSE,
		event: 'mouseenter',
		effect: TRUE,
		delay: 90,
		solo: FALSE,
		ready: FALSE,
		autofocus: FALSE
	},
	hide: {
		target: FALSE,
		event: 'mouseleave',
		effect: TRUE,
		delay: 0,
		fixed: FALSE,
		inactive: FALSE,
		leave: 'window',
		distance: FALSE
	},
	style: {
		classes: '',
		widget: FALSE,
		width: FALSE,
		height: FALSE,
		def: TRUE
	},
	events: {
		render: NULL,
		move: NULL,
		show: NULL,
		hide: NULL,
		toggle: NULL,
		visible: NULL,
		hidden: NULL,
		focus: NULL,
		blur: NULL
	}
};
;var TIP,
createVML,
SCALE,
PIXEL_RATIO,
BACKING_STORE_RATIO,

// Common CSS strings
MARGIN = 'margin',
BORDER = 'border',
COLOR = 'color',
BG_COLOR = 'background-color',
TRANSPARENT = 'transparent',
IMPORTANT = ' !important',

// Check if the browser supports <canvas/> elements
HASCANVAS = !!document.createElement('canvas').getContext,

// Invalid colour values used in parseColours()
INVALID = /rgba?\(0, 0, 0(, 0)?\)|transparent|#123456/i;

// Camel-case method, taken from jQuery source
// http://code.jquery.com/jquery-1.8.0.js
function camel(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

/*
 * Modified from Modernizr's testPropsAll()
 * http://modernizr.com/downloads/modernizr-latest.js
 */
var cssProps = {}, cssPrefixes = ['Webkit', 'O', 'Moz', 'ms'];
function vendorCss(elem, prop) {
	var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
		props = (prop + ' ' + cssPrefixes.join(ucProp + ' ') + ucProp).split(' '),
		cur, val, i = 0;

	// If the property has already been mapped...
	if(cssProps[prop]) { return elem.css(cssProps[prop]); }

	while(cur = props[i++]) {
		if((val = elem.css(cur)) !== undefined) {
			cssProps[prop] = cur;
			return val;
		}
	}
}

// Parse a given elements CSS property into an int
function intCss(elem, prop) {
	return Math.ceil(parseFloat(vendorCss(elem, prop)));
}


// VML creation (for IE only)
if(!HASCANVAS) {
	createVML = function(tag, props, style) {
		return '<qtipvml:'+tag+' xmlns="urn:schemas-microsoft.com:vml" class="qtip-vml" '+(props||'')+
			' style="behavior: url(#default#VML); '+(style||'')+ '" />';
	};
}

// Canvas only definitions
else {
	PIXEL_RATIO = window.devicePixelRatio || 1;
	BACKING_STORE_RATIO = (function() {
		var context = document.createElement('canvas').getContext('2d');
		return context.backingStorePixelRatio || context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio ||
				context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || 1;
	})();
	SCALE = PIXEL_RATIO / BACKING_STORE_RATIO;
}


function Tip(qtip, options) {
	this._ns = 'tip';
	this.options = options;
	this.offset = options.offset;
	this.size = [ options.width, options.height ];

	// Initialize
	this.qtip = qtip;
	this.init(qtip);
}

$.extend(Tip.prototype, {
	init: function(qtip) {
		var context, tip;

		// Create tip element and prepend to the tooltip
		tip = this.element = qtip.elements.tip = $('<div />', { 'class': NAMESPACE+'-tip' }).prependTo(qtip.tooltip);

		// Create tip drawing element(s)
		if(HASCANVAS) {
			// save() as soon as we create the canvas element so FF2 doesn't bork on our first restore()!
			context = $('<canvas />').appendTo(this.element)[0].getContext('2d');

			// Setup constant parameters
			context.lineJoin = 'miter';
			context.miterLimit = 100000;
			context.save();
		}
		else {
			context = createVML('shape', 'coordorigin="0,0"', 'position:absolute;');
			this.element.html(context + context);

			// Prevent mousing down on the tip since it causes problems with .live() handling in IE due to VML
			qtip._bind( $('*', tip).add(tip), ['click', 'mousedown'], function(event) { event.stopPropagation(); }, this._ns);
		}

		// Bind update events
		qtip._bind(qtip.tooltip, 'tooltipmove', this.reposition, this._ns, this);

		// Create it
		this.create();
	},

	_swapDimensions: function() {
		this.size[0] = this.options.height;
		this.size[1] = this.options.width;
	},
	_resetDimensions: function() {
		this.size[0] = this.options.width;
		this.size[1] = this.options.height;
	},

	_useTitle: function(corner) {
		var titlebar = this.qtip.elements.titlebar;
		return titlebar && (
			corner.y === TOP || corner.y === CENTER && this.element.position().top + this.size[1] / 2 + this.options.offset < titlebar.outerHeight(TRUE)
		);
	},

	_parseCorner: function(corner) {
		var my = this.qtip.options.position.my;

		// Detect corner and mimic properties
		if(corner === FALSE || my === FALSE) {
			corner = FALSE;
		}
		else if(corner === TRUE) {
			corner = new CORNER( my.string() );
		}
		else if(!corner.string) {
			corner = new CORNER(corner);
			corner.fixed = TRUE;
		}

		return corner;
	},

	_parseWidth: function(corner, side, use) {
		var elements = this.qtip.elements,
			prop = BORDER + camel(side) + 'Width';

		return (use ? intCss(use, prop) : 
			intCss(elements.content, prop) ||
			intCss(this._useTitle(corner) && elements.titlebar || elements.content, prop) ||
			intCss(elements.tooltip, prop)
		) || 0;
	},

	_parseRadius: function(corner) {
		var elements = this.qtip.elements,
			prop = BORDER + camel(corner.y) + camel(corner.x) + 'Radius';

		return BROWSER.ie < 9 ? 0 :
			intCss(this._useTitle(corner) && elements.titlebar || elements.content, prop) ||
			intCss(elements.tooltip, prop) || 0;
	},

	_invalidColour: function(elem, prop, compare) {
		var val = elem.css(prop);
		return !val || compare && val === elem.css(compare) || INVALID.test(val) ? FALSE : val;
	},

	_parseColours: function(corner) {
		var elements = this.qtip.elements,
			tip = this.element.css('cssText', ''),
			borderSide = BORDER + camel(corner[ corner.precedance ]) + camel(COLOR),
			colorElem = this._useTitle(corner) && elements.titlebar || elements.content,
			css = this._invalidColour, color = [];

		// Attempt to detect the background colour from various elements, left-to-right precedance
		color[0] = css(tip, BG_COLOR) || css(colorElem, BG_COLOR) || css(elements.content, BG_COLOR) ||
			css(elements.tooltip, BG_COLOR) || tip.css(BG_COLOR);

		// Attempt to detect the correct border side colour from various elements, left-to-right precedance
		color[1] = css(tip, borderSide, COLOR) || css(colorElem, borderSide, COLOR) ||
			css(elements.content, borderSide, COLOR) || css(elements.tooltip, borderSide, COLOR) || elements.tooltip.css(borderSide);

		// Reset background and border colours
		$('*', tip).add(tip).css('cssText', BG_COLOR+':'+TRANSPARENT+IMPORTANT+';'+BORDER+':0'+IMPORTANT+';');

		return color;
	},

	_calculateSize: function(corner) {
		var y = corner.precedance === Y,
			width = this.options.width,
			height = this.options.height,
			isCenter = corner.abbrev() === 'c',
			base = (y ? width: height) * (isCenter ? 0.5 : 1),
			pow = Math.pow,
			round = Math.round,
			bigHyp, ratio, result,

		smallHyp = Math.sqrt( pow(base, 2) + pow(height, 2) ),
		hyp = [
			this.border / base * smallHyp,
			this.border / height * smallHyp
		];

		hyp[2] = Math.sqrt( pow(hyp[0], 2) - pow(this.border, 2) );
		hyp[3] = Math.sqrt( pow(hyp[1], 2) - pow(this.border, 2) );

		bigHyp = smallHyp + hyp[2] + hyp[3] + (isCenter ? 0 : hyp[0]);
		ratio = bigHyp / smallHyp;

		result = [ round(ratio * width), round(ratio * height) ];
		return y ? result : result.reverse();
	},

	// Tip coordinates calculator
	_calculateTip: function(corner, size, scale) {
		scale = scale || 1;
		size = size || this.size;

		var width = size[0] * scale,
			height = size[1] * scale,
			width2 = Math.ceil(width / 2), height2 = Math.ceil(height / 2),

		// Define tip coordinates in terms of height and width values
		tips = {
			br:	[0,0,		width,height,	width,0],
			bl:	[0,0,		width,0,		0,height],
			tr:	[0,height,	width,0,		width,height],
			tl:	[0,0,		0,height,		width,height],
			tc:	[0,height,	width2,0,		width,height],
			bc:	[0,0,		width,0,		width2,height],
			rc:	[0,0,		width,height2,	0,height],
			lc:	[width,0,	width,height,	0,height2]
		};

		// Set common side shapes
		tips.lt = tips.br; tips.rt = tips.bl;
		tips.lb = tips.tr; tips.rb = tips.tl;

		return tips[ corner.abbrev() ];
	},

	// Tip coordinates drawer (canvas)
	_drawCoords: function(context, coords) {
		context.beginPath();
		context.moveTo(coords[0], coords[1]);
		context.lineTo(coords[2], coords[3]);
		context.lineTo(coords[4], coords[5]);
		context.closePath();
	},

	create: function() {
		// Determine tip corner
		var c = this.corner = (HASCANVAS || BROWSER.ie) && this._parseCorner(this.options.corner);

		// If we have a tip corner...
		this.enabled = !!this.corner && this.corner.abbrev() !== 'c';
		if(this.enabled) {
			// Cache it
			this.qtip.cache.corner = c.clone();

			// Create it
			this.update();
		}

		// Toggle tip element
		this.element.toggle(this.enabled);

		return this.corner;
	},

	update: function(corner, position) {
		if(!this.enabled) { return this; }

		var elements = this.qtip.elements,
			tip = this.element,
			inner = tip.children(),
			options = this.options,
			curSize = this.size,
			mimic = options.mimic,
			round = Math.round,
			color, precedance, context,
			coords, bigCoords, translate, newSize, border;

		// Re-determine tip if not already set
		if(!corner) { corner = this.qtip.cache.corner || this.corner; }

		// Use corner property if we detect an invalid mimic value
		if(mimic === FALSE) { mimic = corner; }

		// Otherwise inherit mimic properties from the corner object as necessary
		else {
			mimic = new CORNER(mimic);
			mimic.precedance = corner.precedance;

			if(mimic.x === 'inherit') { mimic.x = corner.x; }
			else if(mimic.y === 'inherit') { mimic.y = corner.y; }
			else if(mimic.x === mimic.y) {
				mimic[ corner.precedance ] = corner[ corner.precedance ];
			}
		}
		precedance = mimic.precedance;

		// Ensure the tip width.height are relative to the tip position
		if(corner.precedance === X) { this._swapDimensions(); }
		else { this._resetDimensions(); }

		// Update our colours
		color = this.color = this._parseColours(corner);

		// Detect border width, taking into account colours
		if(color[1] !== TRANSPARENT) {
			// Grab border width
			border = this.border = this._parseWidth(corner, corner[corner.precedance]);

			// If border width isn't zero, use border color as fill if it's not invalid (1.0 style tips)
			if(options.border && border < 1 && !INVALID.test(color[1])) { color[0] = color[1]; }

			// Set border width (use detected border width if options.border is true)
			this.border = border = options.border !== TRUE ? options.border : border;
		}

		// Border colour was invalid, set border to zero
		else { this.border = border = 0; }

		// Determine tip size
		newSize = this.size = this._calculateSize(corner);
		tip.css({
			width: newSize[0],
			height: newSize[1],
			lineHeight: newSize[1]+'px'
		});

		// Calculate tip translation
		if(corner.precedance === Y) {
			translate = [
				round(mimic.x === LEFT ? border : mimic.x === RIGHT ? newSize[0] - curSize[0] - border : (newSize[0] - curSize[0]) / 2),
				round(mimic.y === TOP ? newSize[1] - curSize[1] : 0)
			];
		}
		else {
			translate = [
				round(mimic.x === LEFT ? newSize[0] - curSize[0] : 0),
				round(mimic.y === TOP ? border : mimic.y === BOTTOM ? newSize[1] - curSize[1] - border : (newSize[1] - curSize[1]) / 2)
			];
		}

		// Canvas drawing implementation
		if(HASCANVAS) {
			// Grab canvas context and clear/save it
			context = inner[0].getContext('2d');
			context.restore(); context.save();
			context.clearRect(0,0,6000,6000);

			// Calculate coordinates
			coords = this._calculateTip(mimic, curSize, SCALE);
			bigCoords = this._calculateTip(mimic, this.size, SCALE);

			// Set the canvas size using calculated size
			inner.attr(WIDTH, newSize[0] * SCALE).attr(HEIGHT, newSize[1] * SCALE);
			inner.css(WIDTH, newSize[0]).css(HEIGHT, newSize[1]);

			// Draw the outer-stroke tip
			this._drawCoords(context, bigCoords);
			context.fillStyle = color[1];
			context.fill();

			// Draw the actual tip
			context.translate(translate[0] * SCALE, translate[1] * SCALE);
			this._drawCoords(context, coords);
			context.fillStyle = color[0];
			context.fill();
		}

		// VML (IE Proprietary implementation)
		else {
			// Calculate coordinates
			coords = this._calculateTip(mimic);

			// Setup coordinates string
			coords = 'm' + coords[0] + ',' + coords[1] + ' l' + coords[2] +
				',' + coords[3] + ' ' + coords[4] + ',' + coords[5] + ' xe';

			// Setup VML-specific offset for pixel-perfection
			translate[2] = border && /^(r|b)/i.test(corner.string()) ?
				BROWSER.ie === 8 ? 2 : 1 : 0;

			// Set initial CSS
			inner.css({
				coordsize: newSize[0]+border + ' ' + newSize[1]+border,
				antialias: ''+(mimic.string().indexOf(CENTER) > -1),
				left: translate[0] - translate[2] * Number(precedance === X),
				top: translate[1] - translate[2] * Number(precedance === Y),
				width: newSize[0] + border,
				height: newSize[1] + border
			})
			.each(function(i) {
				var $this = $(this);

				// Set shape specific attributes
				$this[ $this.prop ? 'prop' : 'attr' ]({
					coordsize: newSize[0]+border + ' ' + newSize[1]+border,
					path: coords,
					fillcolor: color[0],
					filled: !!i,
					stroked: !i
				})
				.toggle(!!(border || i));

				// Check if border is enabled and add stroke element
				!i && $this.html( createVML(
					'stroke', 'weight="'+border*2+'px" color="'+color[1]+'" miterlimit="1000" joinstyle="miter"'
				) );
			});
		}

		// Opera bug #357 - Incorrect tip position
		// https://github.com/Craga89/qTip2/issues/367
		window.opera && setTimeout(function() {
			elements.tip.css({
				display: 'inline-block',
				visibility: 'visible'
			});
		}, 1);

		// Position if needed
		if(position !== FALSE) { this.calculate(corner, newSize); }
	},

	calculate: function(corner, size) {
		if(!this.enabled) { return FALSE; }

		var self = this,
			elements = this.qtip.elements,
			tip = this.element,
			userOffset = this.options.offset,
			position = {},
			precedance, corners;

		// Inherit corner if not provided
		corner = corner || this.corner;
		precedance = corner.precedance;

		// Determine which tip dimension to use for adjustment
		size = size || this._calculateSize(corner);

		// Setup corners and offset array
		corners = [ corner.x, corner.y ];
		if(precedance === X) { corners.reverse(); }

		// Calculate tip position
		$.each(corners, function(i, side) {
			var b, bc, br;

			if(side === CENTER) {
				b = precedance === Y ? LEFT : TOP;
				position[ b ] = '50%';
				position[MARGIN+'-' + b] = -Math.round(size[ precedance === Y ? 0 : 1 ] / 2) + userOffset;
			}
			else {
				b = self._parseWidth(corner, side, elements.tooltip);
				bc = self._parseWidth(corner, side, elements.content);
				br = self._parseRadius(corner);

				position[ side ] = Math.max(-self.border, i ? bc : userOffset + (br > b ? br : -b));
			}
		});

		// Adjust for tip size
		position[ corner[precedance] ] -= size[ precedance === X ? 0 : 1 ];

		// Set and return new position
		tip.css({ margin: '', top: '', bottom: '', left: '', right: '' }).css(position);
		return position;
	},

	reposition: function(event, api, pos) {
		if(!this.enabled) { return; }

		var cache = api.cache,
			newCorner = this.corner.clone(),
			adjust = pos.adjusted,
			method = api.options.position.adjust.method.split(' '),
			horizontal = method[0],
			vertical = method[1] || method[0],
			shift = { left: FALSE, top: FALSE, x: 0, y: 0 },
			offset, css = {}, props;

		function shiftflip(direction, precedance, popposite, side, opposite) {
			// Horizontal - Shift or flip method
			if(direction === SHIFT && newCorner.precedance === precedance && adjust[side] && newCorner[popposite] !== CENTER) {
				newCorner.precedance = newCorner.precedance === X ? Y : X;
			}
			else if(direction !== SHIFT && adjust[side]){
				newCorner[precedance] = newCorner[precedance] === CENTER ?
					adjust[side] > 0 ? side : opposite :
					newCorner[precedance] === side ? opposite : side;
			}
		}

		function shiftonly(xy, side, opposite) {
			if(newCorner[xy] === CENTER) {
				css[MARGIN+'-'+side] = shift[xy] = offset[MARGIN+'-'+side] - adjust[side];
			}
			else {
				props = offset[opposite] !== undefined ?
					[ adjust[side], -offset[side] ] : [ -adjust[side], offset[side] ];

				if( (shift[xy] = Math.max(props[0], props[1])) > props[0] ) {
					pos[side] -= adjust[side];
					shift[side] = FALSE;
				}

				css[ offset[opposite] !== undefined ? opposite : side ] = shift[xy];
			}
		}

		// If our tip position isn't fixed e.g. doesn't adjust with viewport...
		if(this.corner.fixed !== TRUE) {
			// Perform shift/flip adjustments
			shiftflip(horizontal, X, Y, LEFT, RIGHT);
			shiftflip(vertical, Y, X, TOP, BOTTOM);

			// Update and redraw the tip if needed (check cached details of last drawn tip)
			if(newCorner.string() !== cache.corner.string() || cache.cornerTop !== adjust.top || cache.cornerLeft !== adjust.left) {
				this.update(newCorner, FALSE);
			}
		}

		// Setup tip offset properties
		offset = this.calculate(newCorner);

		// Readjust offset object to make it left/top
		if(offset.right !== undefined) { offset.left = -offset.right; }
		if(offset.bottom !== undefined) { offset.top = -offset.bottom; }
		offset.user = this.offset;

		// Perform shift adjustments
		shift.left = horizontal === SHIFT && !!adjust.left;
		if(shift.left) {
			shiftonly(X, LEFT, RIGHT);
		}
		shift.top = vertical === SHIFT && !!adjust.top;
		if(shift.top) {
			shiftonly(Y, TOP, BOTTOM);
		}

		/*
		* If the tip is adjusted in both dimensions, or in a
		* direction that would cause it to be anywhere but the
		* outer border, hide it!
		*/
		this.element.css(css).toggle(
			!(shift.x && shift.y || newCorner.x === CENTER && shift.y || newCorner.y === CENTER && shift.x)
		);

		// Adjust position to accomodate tip dimensions
		pos.left -= offset.left.charAt ? offset.user :
			horizontal !== SHIFT || shift.top || !shift.left && !shift.top ? offset.left + this.border : 0;
		pos.top -= offset.top.charAt ? offset.user :
			vertical !== SHIFT || shift.left || !shift.left && !shift.top ? offset.top + this.border : 0;

		// Cache details
		cache.cornerLeft = adjust.left; cache.cornerTop = adjust.top;
		cache.corner = newCorner.clone();
	},

	destroy: function() {
		// Unbind events
		this.qtip._unbind(this.qtip.tooltip, this._ns);

		// Remove the tip element(s)
		if(this.qtip.elements.tip) {
			this.qtip.elements.tip.find('*')
				.remove().end().remove();
		}
	}
});

TIP = PLUGINS.tip = function(api) {
	return new Tip(api, api.options.style.tip);
};

// Initialize tip on render
TIP.initialize = 'render';

// Setup plugin sanitization options
TIP.sanitize = function(options) {
	if(options.style && 'tip' in options.style) {
		var opts = options.style.tip;
		if(typeof opts !== 'object') { opts = options.style.tip = { corner: opts }; }
		if(!(/string|boolean/i).test(typeof opts.corner)) { opts.corner = TRUE; }
	}
};

// Add new option checks for the plugin
CHECKS.tip = {
	'^position.my|style.tip.(corner|mimic|border)$': function() {
		// Make sure a tip can be drawn
		this.create();

		// Reposition the tooltip
		this.qtip.reposition();
	},
	'^style.tip.(height|width)$': function(obj) {
		// Re-set dimensions and redraw the tip
		this.size = [ obj.width, obj.height ];
		this.update();

		// Reposition the tooltip
		this.qtip.reposition();
	},
	'^content.title|style.(classes|widget)$': function() {
		this.update();
	}
};

// Extend original qTip defaults
$.extend(TRUE, QTIP.defaults, {
	style: {
		tip: {
			corner: TRUE,
			mimic: FALSE,
			width: 6,
			height: 6,
			border: TRUE,
			offset: 0
		}
	}
});
;var MODAL, OVERLAY,
	MODALCLASS = 'qtip-modal',
	MODALSELECTOR = '.'+MODALCLASS;

OVERLAY = function()
{
	var self = this,
		focusableElems = {},
		current,
		prevState,
		elem;

	// Modified code from jQuery UI 1.10.0 source
	// http://code.jquery.com/ui/1.10.0/jquery-ui.js
	function focusable(element) {
		// Use the defined focusable checker when possible
		if($.expr[':'].focusable) { return $.expr[':'].focusable; }

		var isTabIndexNotNaN = !isNaN($.attr(element, 'tabindex')),
			nodeName = element.nodeName && element.nodeName.toLowerCase(),
			map, mapName, img;

		if('area' === nodeName) {
			map = element.parentNode;
			mapName = map.name;
			if(!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
				return false;
			}
			img = $('img[usemap=#' + mapName + ']')[0];
			return !!img && img.is(':visible');
		}

		return /input|select|textarea|button|object/.test( nodeName ) ?
			!element.disabled :
			'a' === nodeName ?
				element.href || isTabIndexNotNaN :
				isTabIndexNotNaN
		;
	}

	// Focus inputs using cached focusable elements (see update())
	function focusInputs(blurElems) {
		// Blurring body element in IE causes window.open windows to unfocus!
		if(focusableElems.length < 1 && blurElems.length) { blurElems.not('body').blur(); }

		// Focus the inputs
		else { focusableElems.first().focus(); }
	}

	// Steal focus from elements outside tooltip
	function stealFocus(event) {
		if(!elem.is(':visible')) { return; }

		var target = $(event.target),
			tooltip = current.tooltip,
			container = target.closest(SELECTOR),
			targetOnTop;

		// Determine if input container target is above this
		targetOnTop = container.length < 1 ? FALSE :
			parseInt(container[0].style.zIndex, 10) > parseInt(tooltip[0].style.zIndex, 10);

		// If we're showing a modal, but focus has landed on an input below
		// this modal, divert focus to the first visible input in this modal
		// or if we can't find one... the tooltip itself
		if(!targetOnTop && target.closest(SELECTOR)[0] !== tooltip[0]) {
			focusInputs(target);
		}
	}

	$.extend(self, {
		init: function() {
			// Create document overlay
			elem = self.elem = $('<div />', {
				id: 'qtip-overlay',
				html: '<div></div>',
				mousedown: function() { return FALSE; }
			})
			.hide();

			// Make sure we can't focus anything outside the tooltip
			$(document.body).bind('focusin'+MODALSELECTOR, stealFocus);

			// Apply keyboard "Escape key" close handler
			$(document).bind('keydown'+MODALSELECTOR, function(event) {
				if(current && current.options.show.modal.escape && event.keyCode === 27) {
					current.hide(event);
				}
			});

			// Apply click handler for blur option
			elem.bind('click'+MODALSELECTOR, function(event) {
				if(current && current.options.show.modal.blur) {
					current.hide(event);
				}
			});

			return self;
		},

		update: function(api) {
			// Update current API reference
			current = api;

			// Update focusable elements if enabled
			if(api.options.show.modal.stealfocus !== FALSE) {
				focusableElems = api.tooltip.find('*').filter(function() {
					return focusable(this);
				});
			}
			else { focusableElems = []; }
		},

		toggle: function(api, state, duration) {
			var tooltip = api.tooltip,
				options = api.options.show.modal,
				effect = options.effect,
				type = state ? 'show': 'hide',
				visible = elem.is(':visible'),
				visibleModals = $(MODALSELECTOR).filter(':visible:not(:animated)').not(tooltip);

			// Set active tooltip API reference
			self.update(api);

			// If the modal can steal the focus...
			// Blur the current item and focus anything in the modal we an
			if(state && options.stealfocus !== FALSE) {
				focusInputs( $(':focus') );
			}

			// Toggle backdrop cursor style on show
			elem.toggleClass('blurs', options.blur);

			// Append to body on show
			if(state) {
				elem.appendTo(document.body);
			}

			// Prevent modal from conflicting with show.solo, and don't hide backdrop is other modals are visible
			if(elem.is(':animated') && visible === state && prevState !== FALSE || !state && visibleModals.length) {
				return self;
			}

			// Stop all animations
			elem.stop(TRUE, FALSE);

			// Use custom function if provided
			if($.isFunction(effect)) {
				effect.call(elem, state);
			}

			// If no effect type is supplied, use a simple toggle
			else if(effect === FALSE) {
				elem[ type ]();
			}

			// Use basic fade function
			else {
				elem.fadeTo( parseInt(duration, 10) || 90, state ? 1 : 0, function() {
					if(!state) { elem.hide(); }
				});
			}

			// Reset position and detach from body on hide
			if(!state) {
				elem.queue(function(next) {
					elem.css({ left: '', top: '' });
					if(!$(MODALSELECTOR).length) { elem.detach(); }
					next();
				});
			}

			// Cache the state
			prevState = state;

			// If the tooltip is destroyed, set reference to null
			if(current.destroyed) { current = NULL; }

			return self;
		}
	});

	self.init();
};
OVERLAY = new OVERLAY();

function Modal(api, options) {
	this.options = options;
	this._ns = '-modal';

	this.qtip = api;
	this.init(api);
}

$.extend(Modal.prototype, {
	init: function(qtip) {
		var tooltip = qtip.tooltip;

		// If modal is disabled... return
		if(!this.options.on) { return this; }

		// Set overlay reference
		qtip.elements.overlay = OVERLAY.elem;

		// Add unique attribute so we can grab modal tooltips easily via a SELECTOR, and set z-index
		tooltip.addClass(MODALCLASS).css('z-index', QTIP.modal_zindex + $(MODALSELECTOR).length);

		// Apply our show/hide/focus modal events
		qtip._bind(tooltip, ['tooltipshow', 'tooltiphide'], function(event, api, duration) {
			var oEvent = event.originalEvent;

			// Make sure mouseout doesn't trigger a hide when showing the modal and mousing onto backdrop
			if(event.target === tooltip[0]) {
				if(oEvent && event.type === 'tooltiphide' && /mouse(leave|enter)/.test(oEvent.type) && $(oEvent.relatedTarget).closest(OVERLAY.elem[0]).length) {
					/* eslint-disable no-empty */
					try { event.preventDefault(); }
					catch(e) {}
					/* eslint-enable no-empty */
				}
				else if(!oEvent || oEvent && oEvent.type !== 'tooltipsolo') {
					this.toggle(event, event.type === 'tooltipshow', duration);
				}
			}
		}, this._ns, this);

		// Adjust modal z-index on tooltip focus
		qtip._bind(tooltip, 'tooltipfocus', function(event, api) {
			// If focus was cancelled before it reached us, don't do anything
			if(event.isDefaultPrevented() || event.target !== tooltip[0]) { return; }

			var qtips = $(MODALSELECTOR),

			// Keep the modal's lower than other, regular qtips
			newIndex = QTIP.modal_zindex + qtips.length,
			curIndex = parseInt(tooltip[0].style.zIndex, 10);

			// Set overlay z-index
			OVERLAY.elem[0].style.zIndex = newIndex - 1;

			// Reduce modal z-index's and keep them properly ordered
			qtips.each(function() {
				if(this.style.zIndex > curIndex) {
					this.style.zIndex -= 1;
				}
			});

			// Fire blur event for focused tooltip
			qtips.filter('.' + CLASS_FOCUS).qtip('blur', event.originalEvent);

			// Set the new z-index
			tooltip.addClass(CLASS_FOCUS)[0].style.zIndex = newIndex;

			// Set current
			OVERLAY.update(api);

			// Prevent default handling
			/* eslint-disable no-empty */
			try { event.preventDefault(); }
			catch(e) {}
			/* eslint-enable no-empty */
		}, this._ns, this);

		// Focus any other visible modals when this one hides
		qtip._bind(tooltip, 'tooltiphide', function(event) {
			if(event.target === tooltip[0]) {
				$(MODALSELECTOR).filter(':visible').not(tooltip).last().qtip('focus', event);
			}
		}, this._ns, this);
	},

	toggle: function(event, state, duration) {
		// Make sure default event hasn't been prevented
		if(event && event.isDefaultPrevented()) { return this; }

		// Toggle it
		OVERLAY.toggle(this.qtip, !!state, duration);
	},

	destroy: function() {
		// Remove modal class
		this.qtip.tooltip.removeClass(MODALCLASS);

		// Remove bound events
		this.qtip._unbind(this.qtip.tooltip, this._ns);

		// Delete element reference
		OVERLAY.toggle(this.qtip, FALSE);
		delete this.qtip.elements.overlay;
	}
});


MODAL = PLUGINS.modal = function(api) {
	return new Modal(api, api.options.show.modal);
};

// Setup sanitiztion rules
MODAL.sanitize = function(opts) {
	if(opts.show) {
		if(typeof opts.show.modal !== 'object') { opts.show.modal = { on: !!opts.show.modal }; }
		else if(typeof opts.show.modal.on === 'undefined') { opts.show.modal.on = TRUE; }
	}
};

// Base z-index for all modal tooltips (use qTip core z-index as a base)
/* eslint-disable camelcase */
QTIP.modal_zindex = QTIP.zindex - 200;
/* eslint-enable camelcase */

// Plugin needs to be initialized on render
MODAL.initialize = 'render';

// Setup option set checks
CHECKS.modal = {
	'^show.modal.(on|blur)$': function() {
		// Initialise
		this.destroy();
		this.init();

		// Show the modal if not visible already and tooltip is visible
		this.qtip.elems.overlay.toggle(
			this.qtip.tooltip[0].offsetWidth > 0
		);
	}
};

// Extend original api defaults
$.extend(TRUE, QTIP.defaults, {
	show: {
		modal: {
			on: FALSE,
			effect: TRUE,
			blur: TRUE,
			stealfocus: TRUE,
			escape: TRUE
		}
	}
});
;PLUGINS.viewport = function(api, position, posOptions, targetWidth, targetHeight, elemWidth, elemHeight)
{
	var target = posOptions.target,
		tooltip = api.elements.tooltip,
		my = posOptions.my,
		at = posOptions.at,
		adjust = posOptions.adjust,
		method = adjust.method.split(' '),
		methodX = method[0],
		methodY = method[1] || method[0],
		viewport = posOptions.viewport,
		container = posOptions.container,
		adjusted = { left: 0, top: 0 },
		fixed, newMy, containerOffset, containerStatic,
		viewportWidth, viewportHeight, viewportScroll, viewportOffset;

	// If viewport is not a jQuery element, or it's the window/document, or no adjustment method is used... return
	if(!viewport.jquery || target[0] === window || target[0] === document.body || adjust.method === 'none') {
		return adjusted;
	}

	// Cach container details
	containerOffset = container.offset() || adjusted;
	containerStatic = container.css('position') === 'static';

	// Cache our viewport details
	fixed = tooltip.css('position') === 'fixed';
	viewportWidth = viewport[0] === window ? viewport.width() : viewport.outerWidth(FALSE);
	viewportHeight = viewport[0] === window ? viewport.height() : viewport.outerHeight(FALSE);
	viewportScroll = { left: fixed ? 0 : viewport.scrollLeft(), top: fixed ? 0 : viewport.scrollTop() };
	viewportOffset = viewport.offset() || adjusted;

	// Generic calculation method
	function calculate(side, otherSide, type, adjustment, side1, side2, lengthName, targetLength, elemLength) {
		var initialPos = position[side1],
			mySide = my[side],
			atSide = at[side],
			isShift = type === SHIFT,
			myLength = mySide === side1 ? elemLength : mySide === side2 ? -elemLength : -elemLength / 2,
			atLength = atSide === side1 ? targetLength : atSide === side2 ? -targetLength : -targetLength / 2,
			sideOffset = viewportScroll[side1] + viewportOffset[side1] - (containerStatic ? 0 : containerOffset[side1]),
			overflow1 = sideOffset - initialPos,
			overflow2 = initialPos + elemLength - (lengthName === WIDTH ? viewportWidth : viewportHeight) - sideOffset,
			offset = myLength - (my.precedance === side || mySide === my[otherSide] ? atLength : 0) - (atSide === CENTER ? targetLength / 2 : 0);

		// shift
		if(isShift) {
			offset = (mySide === side1 ? 1 : -1) * myLength;

			// Adjust position but keep it within viewport dimensions
			position[side1] += overflow1 > 0 ? overflow1 : overflow2 > 0 ? -overflow2 : 0;
			position[side1] = Math.max(
				-containerOffset[side1] + viewportOffset[side1],
				initialPos - offset,
				Math.min(
					Math.max(
						-containerOffset[side1] + viewportOffset[side1] + (lengthName === WIDTH ? viewportWidth : viewportHeight),
						initialPos + offset
					),
					position[side1],

					// Make sure we don't adjust complete off the element when using 'center'
					mySide === 'center' ? initialPos - myLength : 1E9
				)
			);

		}

		// flip/flipinvert
		else {
			// Update adjustment amount depending on if using flipinvert or flip
			adjustment *= type === FLIPINVERT ? 2 : 0;

			// Check for overflow on the left/top
			if(overflow1 > 0 && (mySide !== side1 || overflow2 > 0)) {
				position[side1] -= offset + adjustment;
				newMy.invert(side, side1);
			}

			// Check for overflow on the bottom/right
			else if(overflow2 > 0 && (mySide !== side2 || overflow1 > 0)  ) {
				position[side1] -= (mySide === CENTER ? -offset : offset) + adjustment;
				newMy.invert(side, side2);
			}

			// Make sure we haven't made things worse with the adjustment and reset if so
			if(position[side1] < viewportScroll[side1] && -position[side1] > overflow2) {
				position[side1] = initialPos; newMy = my.clone();
			}
		}

		return position[side1] - initialPos;
	}

	// Set newMy if using flip or flipinvert methods
	if(methodX !== 'shift' || methodY !== 'shift') { newMy = my.clone(); }

	// Adjust position based onviewport and adjustment options
	adjusted = {
		left: methodX !== 'none' ? calculate( X, Y, methodX, adjust.x, LEFT, RIGHT, WIDTH, targetWidth, elemWidth ) : 0,
		top: methodY !== 'none' ? calculate( Y, X, methodY, adjust.y, TOP, BOTTOM, HEIGHT, targetHeight, elemHeight ) : 0,
		my: newMy
	};

	return adjusted;
};
;PLUGINS.polys = {
	// POLY area coordinate calculator
	//	Special thanks to Ed Cradock for helping out with this.
	//	Uses a binary search algorithm to find suitable coordinates.
	polygon: function(baseCoords, corner) {
		var result = {
			width: 0, height: 0,
			position: {
				top: 1e10, right: 0,
				bottom: 0, left: 1e10
			},
			adjustable: FALSE
		},
		i = 0, next,
		coords = [],
		compareX = 1, compareY = 1,
		realX = 0, realY = 0,
		newWidth, newHeight;

		// First pass, sanitize coords and determine outer edges
		i = baseCoords.length; 
		while(i--) {
			next = [ parseInt(baseCoords[--i], 10), parseInt(baseCoords[i+1], 10) ];

			if(next[0] > result.position.right){ result.position.right = next[0]; }
			if(next[0] < result.position.left){ result.position.left = next[0]; }
			if(next[1] > result.position.bottom){ result.position.bottom = next[1]; }
			if(next[1] < result.position.top){ result.position.top = next[1]; }

			coords.push(next);
		}

		// Calculate height and width from outer edges
		newWidth = result.width = Math.abs(result.position.right - result.position.left);
		newHeight = result.height = Math.abs(result.position.bottom - result.position.top);

		// If it's the center corner...
		if(corner.abbrev() === 'c') {
			result.position = {
				left: result.position.left + result.width / 2,
				top: result.position.top + result.height / 2
			};
		}
		else {
			// Second pass, use a binary search algorithm to locate most suitable coordinate
			while(newWidth > 0 && newHeight > 0 && compareX > 0 && compareY > 0)
			{
				newWidth = Math.floor(newWidth / 2);
				newHeight = Math.floor(newHeight / 2);

				if(corner.x === LEFT){ compareX = newWidth; }
				else if(corner.x === RIGHT){ compareX = result.width - newWidth; }
				else{ compareX += Math.floor(newWidth / 2); }

				if(corner.y === TOP){ compareY = newHeight; }
				else if(corner.y === BOTTOM){ compareY = result.height - newHeight; }
				else{ compareY += Math.floor(newHeight / 2); }

				i = coords.length;
				while(i--)
				{
					if(coords.length < 2){ break; }

					realX = coords[i][0] - result.position.left;
					realY = coords[i][1] - result.position.top;

					if(
						corner.x === LEFT && realX >= compareX ||
						corner.x === RIGHT && realX <= compareX ||
						corner.x === CENTER && (realX < compareX || realX > result.width - compareX) ||
						corner.y === TOP && realY >= compareY ||
						corner.y === BOTTOM && realY <= compareY ||
						corner.y === CENTER && (realY < compareY || realY > result.height - compareY)) {
						coords.splice(i, 1);
					}
				}
			}
			result.position = { left: coords[0][0], top: coords[0][1] };
		}

		return result;
	},

	rect: function(ax, ay, bx, by) {
		return {
			width: Math.abs(bx - ax),
			height: Math.abs(by - ay),
			position: {
				left: Math.min(ax, bx),
				top: Math.min(ay, by)
			}
		};
	},

	_angles: {
		tc: 3 / 2, tr: 7 / 4, tl: 5 / 4,
		bc: 1 / 2, br: 1 / 4, bl: 3 / 4,
		rc: 2, lc: 1, c: 0
	},
	ellipse: function(cx, cy, rx, ry, corner) {
		var c = PLUGINS.polys._angles[ corner.abbrev() ],
			rxc = c === 0 ? 0 : rx * Math.cos( c * Math.PI ),
			rys = ry * Math.sin( c * Math.PI );

		return {
			width: rx * 2 - Math.abs(rxc),
			height: ry * 2 - Math.abs(rys),
			position: {
				left: cx + rxc,
				top: cy + rys
			},
			adjustable: FALSE
		};
	},
	circle: function(cx, cy, r, corner) {
		return PLUGINS.polys.ellipse(cx, cy, r, r, corner);
	}
};
;PLUGINS.svg = function(api, svg, corner)
{
	var elem = svg[0],
		root = $(elem.ownerSVGElement),
		ownerDocument = elem.ownerDocument,
		strokeWidth2 = (parseInt(svg.css('stroke-width'), 10) || 0) / 2,
		frameOffset, mtx, transformed,
		len, next, i, points,
		result, position;

	// Ascend the parentNode chain until we find an element with getBBox()
	while(!elem.getBBox) { elem = elem.parentNode; }
	if(!elem.getBBox || !elem.parentNode) { return FALSE; }

	// Determine which shape calculation to use
	switch(elem.nodeName) {
		case 'ellipse':
		case 'circle':
			result = PLUGINS.polys.ellipse(
				elem.cx.baseVal.value,
				elem.cy.baseVal.value,
				(elem.rx || elem.r).baseVal.value + strokeWidth2,
				(elem.ry || elem.r).baseVal.value + strokeWidth2,
				corner
			);
		break;

		case 'line':
		case 'polygon':
		case 'polyline':
			// Determine points object (line has none, so mimic using array)
			points = elem.points || [
				{ x: elem.x1.baseVal.value, y: elem.y1.baseVal.value },
				{ x: elem.x2.baseVal.value, y: elem.y2.baseVal.value }
			];

			for(result = [], i = -1, len = points.numberOfItems || points.length; ++i < len;) {
				next = points.getItem ? points.getItem(i) : points[i];
				result.push.apply(result, [next.x, next.y]);
			}

			result = PLUGINS.polys.polygon(result, corner);
		break;

		// Unknown shape or rectangle? Use bounding box
		default:
			result = elem.getBBox();
			result = {
				width: result.width,
				height: result.height,
				position: {
					left: result.x,
					top: result.y
				}
			};
		break;
	}

	// Shortcut assignments
	position = result.position;
	root = root[0];

	// Convert position into a pixel value
	if(root.createSVGPoint) {
		mtx = elem.getScreenCTM();
		points = root.createSVGPoint();

		points.x = position.left;
		points.y = position.top;
		transformed = points.matrixTransform( mtx );
		position.left = transformed.x;
		position.top = transformed.y;
	}

	// Check the element is not in a child document, and if so, adjust for frame elements offset
	if(ownerDocument !== document && api.position.target !== 'mouse') {
		frameOffset = $((ownerDocument.defaultView || ownerDocument.parentWindow).frameElement).offset();
		if(frameOffset) {
			position.left += frameOffset.left;
			position.top += frameOffset.top;
		}
	}

	// Adjust by scroll offset of owner document
	ownerDocument = $(ownerDocument);
	position.left += ownerDocument.scrollLeft();
	position.top += ownerDocument.scrollTop();

	return result;
};
;PLUGINS.imagemap = function(api, area, corner)
{
	if(!area.jquery) { area = $(area); }

	var shape = (area.attr('shape') || 'rect').toLowerCase().replace('poly', 'polygon'),
		image = $('img[usemap="#'+area.parent('map').attr('name')+'"]'),
		coordsString = $.trim(area.attr('coords')),
		coordsArray = coordsString.replace(/,$/, '').split(','),
		imageOffset, coords, i, result, len;

	// If we can't find the image using the map...
	if(!image.length) { return FALSE; }

	// Pass coordinates string if polygon
	if(shape === 'polygon') {
		result = PLUGINS.polys.polygon(coordsArray, corner);
	}

	// Otherwise parse the coordinates and pass them as arguments
	else if(PLUGINS.polys[shape]) {
		for(i = -1, len = coordsArray.length, coords = []; ++i < len;) {
			coords.push( parseInt(coordsArray[i], 10) );
		}

		result = PLUGINS.polys[shape].apply(
			this, coords.concat(corner)
		);
	}

	// If no shapre calculation method was found, return false
	else { return FALSE; }

	// Make sure we account for padding and borders on the image
	imageOffset = image.offset();
	imageOffset.left += Math.ceil((image.outerWidth(FALSE) - image.width()) / 2);
	imageOffset.top += Math.ceil((image.outerHeight(FALSE) - image.height()) / 2);

	// Add image position to offset coordinates
	result.position.left += imageOffset.left;
	result.position.top += imageOffset.top;

	return result;
};
;var IE6,

/*
 * BGIFrame adaption (http://plugins.jquery.com/project/bgiframe)
 * Special thanks to Brandon Aaron
 */
BGIFRAME = '<iframe class="qtip-bgiframe" frameborder="0" tabindex="-1" src="javascript:\'\';" ' +
	' style="display:block; position:absolute; z-index:-1; filter:alpha(opacity=0); ' +
		'-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";"></iframe>';

function Ie6(api) {
	this._ns = 'ie6';

	this.qtip = api;
	this.init(api);
}

$.extend(Ie6.prototype, {
	_scroll : function() {
		var overlay = this.qtip.elements.overlay;
		overlay && (overlay[0].style.top = $(window).scrollTop() + 'px');
	},

	init: function(qtip) {
		var tooltip = qtip.tooltip;

		// Create the BGIFrame element if needed
		if($('select, object').length < 1) {
			this.bgiframe = qtip.elements.bgiframe = $(BGIFRAME).appendTo(tooltip);

			// Update BGIFrame on tooltip move
			qtip._bind(tooltip, 'tooltipmove', this.adjustBGIFrame, this._ns, this);
		}

		// redraw() container for width/height calculations
		this.redrawContainer = $('<div/>', { id: NAMESPACE+'-rcontainer' })
			.appendTo(document.body);

		// Fixup modal plugin if present too
		if( qtip.elements.overlay && qtip.elements.overlay.addClass('qtipmodal-ie6fix') ) {
			qtip._bind(window, ['scroll', 'resize'], this._scroll, this._ns, this);
			qtip._bind(tooltip, ['tooltipshow'], this._scroll, this._ns, this);
		}

		// Set dimensions
		this.redraw();
	},

	adjustBGIFrame: function() {
		var tooltip = this.qtip.tooltip,
			dimensions = {
				height: tooltip.outerHeight(FALSE),
				width: tooltip.outerWidth(FALSE)
			},
			plugin = this.qtip.plugins.tip,
			tip = this.qtip.elements.tip,
			tipAdjust, offset;

		// Adjust border offset
		offset = parseInt(tooltip.css('borderLeftWidth'), 10) || 0;
		offset = { left: -offset, top: -offset };

		// Adjust for tips plugin
		if(plugin && tip) {
			tipAdjust = plugin.corner.precedance === 'x' ? [WIDTH, LEFT] : [HEIGHT, TOP];
			offset[ tipAdjust[1] ] -= tip[ tipAdjust[0] ]();
		}

		// Update bgiframe
		this.bgiframe.css(offset).css(dimensions);
	},

	// Max/min width simulator function
	redraw: function() {
		if(this.qtip.rendered < 1 || this.drawing) { return this; }

		var tooltip = this.qtip.tooltip,
			style = this.qtip.options.style,
			container = this.qtip.options.position.container,
			perc, width, max, min;

		// Set drawing flag
		this.qtip.drawing = 1;

		// If tooltip has a set height/width, just set it... like a boss!
		if(style.height) { tooltip.css(HEIGHT, style.height); }
		if(style.width) { tooltip.css(WIDTH, style.width); }

		// Simulate max/min width if not set width present...
		else {
			// Reset width and add fluid class
			tooltip.css(WIDTH, '').appendTo(this.redrawContainer);

			// Grab our tooltip width (add 1 if odd so we don't get wrapping problems.. huzzah!)
			width = tooltip.width();
			if(width % 2 < 1) { width += 1; }

			// Grab our max/min properties
			max = tooltip.css('maxWidth') || '';
			min = tooltip.css('minWidth') || '';

			// Parse into proper pixel values
			perc = (max + min).indexOf('%') > -1 ? container.width() / 100 : 0;
			max = (max.indexOf('%') > -1 ? perc : 1 * parseInt(max, 10)) || width;
			min = (min.indexOf('%') > -1 ? perc : 1 * parseInt(min, 10)) || 0;

			// Determine new dimension size based on max/min/current values
			width = max + min ? Math.min(Math.max(width, min), max) : width;

			// Set the newly calculated width and remvoe fluid class
			tooltip.css(WIDTH, Math.round(width)).appendTo(container);
		}

		// Set drawing flag
		this.drawing = 0;

		return this;
	},

	destroy: function() {
		// Remove iframe
		this.bgiframe && this.bgiframe.remove();

		// Remove bound events
		this.qtip._unbind([window, this.qtip.tooltip], this._ns);
	}
});

IE6 = PLUGINS.ie6 = function(api) {
	// Proceed only if the browser is IE6
	return BROWSER.ie === 6 ? new Ie6(api) : FALSE;
};

IE6.initialize = 'render';

CHECKS.ie6 = {
	'^content|style$': function() {
		this.redraw();
	}
};
;}));
}( window, document ));


/***/ }),

/***/ "./node_modules/underscore/underscore-umd.js":
/*!***************************************************!*\
  !*** ./node_modules/underscore/underscore-umd.js ***!
  \***************************************************/
/***/ (function(module) {

(function (global, factory) {
   true ? module.exports = factory() :
  0;
}(this, (function () {
  //     Underscore.js 1.13.1
  //     https://underscorejs.org
  //     (c) 2009-2021 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
  //     Underscore may be freely distributed under the MIT license.

  // Current version.
  var VERSION = '1.13.1';

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global ||
            Function('return this')() ||
            {};

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // Modern feature detection.
  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
      supportsDataView = typeof DataView !== 'undefined';

  // All **ECMAScript 5+** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create,
      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;

  // Create references to these builtin functions because we override them.
  var _isNaN = isNaN,
      _isFinite = isFinite;

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  // The largest integer that can be represented exactly.
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  function restArguments(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  }

  // Is a given variable an object?
  function isObject(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  }

  // Is a given value equal to null?
  function isNull(obj) {
    return obj === null;
  }

  // Is a given variable undefined?
  function isUndefined(obj) {
    return obj === void 0;
  }

  // Is a given value a boolean?
  function isBoolean(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  }

  // Is a given value a DOM element?
  function isElement(obj) {
    return !!(obj && obj.nodeType === 1);
  }

  // Internal function for creating a `toString`-based type tester.
  function tagTester(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
      return toString.call(obj) === tag;
    };
  }

  var isString = tagTester('String');

  var isNumber = tagTester('Number');

  var isDate = tagTester('Date');

  var isRegExp = tagTester('RegExp');

  var isError = tagTester('Error');

  var isSymbol = tagTester('Symbol');

  var isArrayBuffer = tagTester('ArrayBuffer');

  var isFunction = tagTester('Function');

  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if ( true && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  var isFunction$1 = isFunction;

  var hasObjectTag = tagTester('Object');

  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
  // In IE 11, the most common among them, this problem also applies to
  // `Map`, `WeakMap` and `Set`.
  var hasStringTagBug = (
        supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8)))
      ),
      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));

  var isDataView = tagTester('DataView');

  // In IE 10 - Edge 13, we need a different heuristic
  // to determine whether an object is a `DataView`.
  function ie10IsDataView(obj) {
    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
  }

  var isDataView$1 = (hasStringTagBug ? ie10IsDataView : isDataView);

  // Is a given value an array?
  // Delegates to ECMA5's native `Array.isArray`.
  var isArray = nativeIsArray || tagTester('Array');

  // Internal function to check whether `key` is an own property name of `obj`.
  function has$1(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  }

  var isArguments = tagTester('Arguments');

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  (function() {
    if (!isArguments(arguments)) {
      isArguments = function(obj) {
        return has$1(obj, 'callee');
      };
    }
  }());

  var isArguments$1 = isArguments;

  // Is a given object a finite number?
  function isFinite$1(obj) {
    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
  }

  // Is the given value `NaN`?
  function isNaN$1(obj) {
    return isNumber(obj) && _isNaN(obj);
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function constant(value) {
    return function() {
      return value;
    };
  }

  // Common internal logic for `isArrayLike` and `isBufferLike`.
  function createSizePropertyCheck(getSizeProperty) {
    return function(collection) {
      var sizeProperty = getSizeProperty(collection);
      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
    }
  }

  // Internal helper to generate a function to obtain property `key` from `obj`.
  function shallowProperty(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  }

  // Internal helper to obtain the `byteLength` property of an object.
  var getByteLength = shallowProperty('byteLength');

  // Internal helper to determine whether we should spend extensive checks against
  // `ArrayBuffer` et al.
  var isBufferLike = createSizePropertyCheck(getByteLength);

  // Is a given value a typed array?
  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
  function isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
  }

  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);

  // Internal helper to obtain the `length` property of an object.
  var getLength = shallowProperty('length');

  // Internal helper to create a simple lookup structure.
  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
  // circular imports. `emulatedSet` is a one-off solution that only works for
  // arrays of strings.
  function emulatedSet(keys) {
    var hash = {};
    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
    return {
      contains: function(key) { return hash[key]; },
      push: function(key) {
        hash[key] = true;
        return keys.push(key);
      }
    };
  }

  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
  // needed.
  function collectNonEnumProps(obj, keys) {
    keys = emulatedSet(keys);
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = isFunction$1(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  function keys(obj) {
    if (!isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has$1(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  function isEmpty(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = getLength(obj);
    if (typeof length == 'number' && (
      isArray(obj) || isString(obj) || isArguments$1(obj)
    )) return length === 0;
    return getLength(keys(obj)) === 0;
  }

  // Returns whether an object has a given set of `key:value` pairs.
  function isMatch(object, attrs) {
    var _keys = keys(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = _keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  }

  // If Underscore is called as a function, it returns a wrapped object that can
  // be used OO-style. This wrapper holds altered versions of all functions added
  // through `_.mixin`. Wrapped objects may be chained.
  function _$1(obj) {
    if (obj instanceof _$1) return obj;
    if (!(this instanceof _$1)) return new _$1(obj);
    this._wrapped = obj;
  }

  _$1.VERSION = VERSION;

  // Extracts the result from a wrapped and chained object.
  _$1.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxies for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;

  _$1.prototype.toString = function() {
    return String(this._wrapped);
  };

  // Internal function to wrap or shallow-copy an ArrayBuffer,
  // typed array or DataView to a new view, reusing the buffer.
  function toBufferView(bufferSource) {
    return new Uint8Array(
      bufferSource.buffer || bufferSource,
      bufferSource.byteOffset || 0,
      getByteLength(bufferSource)
    );
  }

  // We use this string twice, so give it a name for minification.
  var tagDataView = '[object DataView]';

  // Internal recursive comparison function for `_.isEqual`.
  function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  }

  // Internal recursive comparison function for `_.isEqual`.
  function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _$1) a = a._wrapped;
    if (b instanceof _$1) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if (hasStringTagBug && className == '[object Object]' && isDataView$1(a)) {
      if (!isDataView$1(b)) return false;
      className = tagDataView;
    }
    switch (className) {
      // These types are compared by value.
      case '[object RegExp]':
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
      case '[object ArrayBuffer]':
      case tagDataView:
        // Coerce to typed array so we can fall through.
        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays && isTypedArray$1(a)) {
        var byteLength = getByteLength(a);
        if (byteLength !== getByteLength(b)) return false;
        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
        areArrays = true;
    }
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
                               isFunction$1(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var _keys = keys(a), key;
      length = _keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = _keys[length];
        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  }

  // Perform a deep comparison to check if two objects are equal.
  function isEqual(a, b) {
    return eq(a, b);
  }

  // Retrieve all the enumerable property names of an object.
  function allKeys(obj) {
    if (!isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Since the regular `Object.prototype.toString` type tests don't work for
  // some types in IE 11, we use a fingerprinting heuristic instead, based
  // on the methods. It's not great, but it's the best we got.
  // The fingerprint method lists are defined below.
  function ie11fingerprint(methods) {
    var length = getLength(methods);
    return function(obj) {
      if (obj == null) return false;
      // `Map`, `WeakMap` and `Set` have no enumerable keys.
      var keys = allKeys(obj);
      if (getLength(keys)) return false;
      for (var i = 0; i < length; i++) {
        if (!isFunction$1(obj[methods[i]])) return false;
      }
      // If we are testing against `WeakMap`, we need to ensure that
      // `obj` doesn't have a `forEach` method in order to distinguish
      // it from a regular `Map`.
      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
    };
  }

  // In the interest of compact minification, we write
  // each string in the fingerprints only once.
  var forEachName = 'forEach',
      hasName = 'has',
      commonInit = ['clear', 'delete'],
      mapTail = ['get', hasName, 'set'];

  // `Map`, `WeakMap` and `Set` each have slightly different
  // combinations of the above sublists.
  var mapMethods = commonInit.concat(forEachName, mapTail),
      weakMapMethods = commonInit.concat(mapTail),
      setMethods = ['add'].concat(commonInit, forEachName, hasName);

  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');

  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');

  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');

  var isWeakSet = tagTester('WeakSet');

  // Retrieve the values of an object's properties.
  function values(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[_keys[i]];
    }
    return values;
  }

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of `_.object` with one argument.
  function pairs(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [_keys[i], obj[_keys[i]]];
    }
    return pairs;
  }

  // Invert the keys and values of an object. The values must be serializable.
  function invert(obj) {
    var result = {};
    var _keys = keys(obj);
    for (var i = 0, length = _keys.length; i < length; i++) {
      result[obj[_keys[i]]] = _keys[i];
    }
    return result;
  }

  // Return a sorted list of the function names available on the object.
  function functions(obj) {
    var names = [];
    for (var key in obj) {
      if (isFunction$1(obj[key])) names.push(key);
    }
    return names.sort();
  }

  // An internal function for creating assigner functions.
  function createAssigner(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  }

  // Extend a given object with all the properties in passed-in object(s).
  var extend = createAssigner(allKeys);

  // Assigns a given object with all the own properties in the passed-in
  // object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  var extendOwn = createAssigner(keys);

  // Fill in a given object with default properties.
  var defaults = createAssigner(allKeys, true);

  // Create a naked function reference for surrogate-prototype-swapping.
  function ctor() {
    return function(){};
  }

  // An internal function for creating a new object that inherits from another.
  function baseCreate(prototype) {
    if (!isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    var Ctor = ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  }

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  function create(prototype, props) {
    var result = baseCreate(prototype);
    if (props) extendOwn(result, props);
    return result;
  }

  // Create a (shallow-cloned) duplicate of an object.
  function clone(obj) {
    if (!isObject(obj)) return obj;
    return isArray(obj) ? obj.slice() : extend({}, obj);
  }

  // Invokes `interceptor` with the `obj` and then returns `obj`.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  function tap(obj, interceptor) {
    interceptor(obj);
    return obj;
  }

  // Normalize a (deep) property `path` to array.
  // Like `_.iteratee`, this function can be customized.
  function toPath$1(path) {
    return isArray(path) ? path : [path];
  }
  _$1.toPath = toPath$1;

  // Internal wrapper for `_.toPath` to enable minification.
  // Similar to `cb` for `_.iteratee`.
  function toPath(path) {
    return _$1.toPath(path);
  }

  // Internal function to obtain a nested property in `obj` along `path`.
  function deepGet(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  }

  // Get the value of the (deep) property on `path` from `object`.
  // If any property in `path` does not exist or if the value is
  // `undefined`, return `defaultValue` instead.
  // The `path` is normalized through `_.toPath`.
  function get(object, path, defaultValue) {
    var value = deepGet(object, toPath(path));
    return isUndefined(value) ? defaultValue : value;
  }

  // Shortcut function for checking if an object has a given property directly on
  // itself (in other words, not on a prototype). Unlike the internal `has`
  // function, this public version can also traverse nested properties.
  function has(obj, path) {
    path = toPath(path);
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (!has$1(obj, key)) return false;
      obj = obj[key];
    }
    return !!length;
  }

  // Keep the identity function around for default iteratees.
  function identity(value) {
    return value;
  }

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  function matcher(attrs) {
    attrs = extendOwn({}, attrs);
    return function(obj) {
      return isMatch(obj, attrs);
    };
  }

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indices.
  function property(path) {
    path = toPath(path);
    return function(obj) {
      return deepGet(obj, path);
    };
  }

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  function optimizeCb(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  }

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `_.identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  function baseIteratee(value, context, argCount) {
    if (value == null) return identity;
    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
    if (isObject(value) && !isArray(value)) return matcher(value);
    return property(value);
  }

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only `argCount` argument.
  function iteratee(value, context) {
    return baseIteratee(value, context, Infinity);
  }
  _$1.iteratee = iteratee;

  // The function we call internally to generate a callback. It invokes
  // `_.iteratee` if overridden, otherwise `baseIteratee`.
  function cb(value, context, argCount) {
    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
    return baseIteratee(value, context, argCount);
  }

  // Returns the results of applying the `iteratee` to each element of `obj`.
  // In contrast to `_.map` it returns an object.
  function mapObject(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = keys(obj),
        length = _keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = _keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function noop(){}

  // Generates a function for a given object that returns a given property.
  function propertyOf(obj) {
    if (obj == null) return noop;
    return function(path) {
      return get(obj, path);
    };
  }

  // Run a function **n** times.
  function times(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  }

  // Return a random integer between `min` and `max` (inclusive).
  function random(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  }

  // A (possibly faster) way to get the current timestamp as an integer.
  var now = Date.now || function() {
    return new Date().getTime();
  };

  // Internal helper to generate functions for escaping and unescaping strings
  // to/from HTML interpolation.
  function createEscaper(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  }

  // Internal list of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };

  // Function for escaping strings to HTML interpolation.
  var _escape = createEscaper(escapeMap);

  // Internal list of HTML entities for unescaping.
  var unescapeMap = invert(escapeMap);

  // Function for unescaping strings from HTML interpolation.
  var _unescape = createEscaper(unescapeMap);

  // By default, Underscore uses ERB-style template delimiters. Change the
  // following template settings to use alternative delimiters.
  var templateSettings = _$1.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `_.templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  function escapeChar(match) {
    return '\\' + escapes[match];
  }

  // In order to prevent third-party code injection through
  // `_.templateSettings.variable`, we test it against the following regular
  // expression. It is intentionally a bit more liberal than just matching valid
  // identifiers, but still prevents possible loopholes through defaults or
  // destructuring assignment.
  var bareIdentifier = /^\s*(\w|\$)+\s*$/;

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  function template(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = defaults({}, settings, _$1.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    var argument = settings.variable;
    if (argument) {
      // Insure against third-party code injection. (CVE-2021-23358)
      if (!bareIdentifier.test(argument)) throw new Error(
        'variable is not a bare identifier: ' + argument
      );
    } else {
      // If a variable is not specified, place data values in local scope.
      source = 'with(obj||{}){\n' + source + '}\n';
      argument = 'obj';
    }

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(argument, '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _$1);
    };

    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  }

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  function result(obj, path, fallback) {
    path = toPath(path);
    var length = path.length;
    if (!length) {
      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = isFunction$1(prop) ? prop.call(obj) : prop;
    }
    return obj;
  }

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  function uniqueId(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  }

  // Start chaining a wrapped Underscore object.
  function chain(obj) {
    var instance = _$1(obj);
    instance._chain = true;
    return instance;
  }

  // Internal function to execute `sourceFunc` bound to `context` with optional
  // `args`. Determines whether to execute a function as a constructor or as a
  // normal function.
  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (isObject(result)) return result;
    return self;
  }

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  var partial = restArguments(function(func, boundArgs) {
    var placeholder = partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  partial.placeholder = _$1;

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally).
  var bind = restArguments(function(func, context, args) {
    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Internal helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var isArrayLike = createSizePropertyCheck(getLength);

  // Internal implementation of a recursive `flatten` function.
  function flatten$1(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) {
      depth = Infinity;
    } else if (depth <= 0) {
      return output.concat(input);
    }
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
        // Flatten current level of array or arguments object.
        if (depth > 1) {
          flatten$1(value, depth - 1, strict, output);
          idx = output.length;
        } else {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  }

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  var bindAll = restArguments(function(obj, keys) {
    keys = flatten$1(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = bind(obj[key], obj);
    }
    return obj;
  });

  // Memoize an expensive function by storing its results.
  function memoize(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  }

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  var delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  var defer = partial(delay, _$1, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  function throttle(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var _now = now();
      if (!previous && options.leading === false) previous = _now;
      var remaining = wait - (_now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = _now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  }

  // When a sequence of calls of the returned function ends, the argument
  // function is triggered. The end of a sequence is defined by the `wait`
  // parameter. If `immediate` is passed, the argument function will be
  // triggered at the beginning of the sequence instead of at the end.
  function debounce(func, wait, immediate) {
    var timeout, previous, args, result, context;

    var later = function() {
      var passed = now() - previous;
      if (wait > passed) {
        timeout = setTimeout(later, wait - passed);
      } else {
        timeout = null;
        if (!immediate) result = func.apply(context, args);
        // This check is needed because `func` can recursively invoke `debounced`.
        if (!timeout) args = context = null;
      }
    };

    var debounced = restArguments(function(_args) {
      context = this;
      args = _args;
      previous = now();
      if (!timeout) {
        timeout = setTimeout(later, wait);
        if (immediate) result = func.apply(context, args);
      }
      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = args = context = null;
    };

    return debounced;
  }

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  function wrap(func, wrapper) {
    return partial(wrapper, func);
  }

  // Returns a negated version of the passed-in predicate.
  function negate(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  }

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  function compose() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  }

  // Returns a function that will only be executed on and after the Nth call.
  function after(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  }

  // Returns a function that will only be executed up to (but not including) the
  // Nth call.
  function before(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  }

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  var once = partial(before, 2);

  // Returns the first key on an object that passes a truth test.
  function findKey(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = keys(obj), key;
    for (var i = 0, length = _keys.length; i < length; i++) {
      key = _keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  }

  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a truth test.
  var findIndex = createPredicateIndexFinder(1);

  // Returns the last index on an array-like that passes a truth test.
  var findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  function sortedIndex(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  }

  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), isNaN$1);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  var indexOf = createIndexFinder(1, findIndex, sortedIndex);

  // Return the position of the last occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  var lastIndexOf = createIndexFinder(-1, findLastIndex);

  // Return the first value which passes a truth test.
  function find(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  }

  // Convenience version of a common use case of `_.find`: getting the first
  // object containing specific `key:value` pairs.
  function findWhere(obj, attrs) {
    return find(obj, matcher(attrs));
  }

  // The cornerstone for collection functions, an `each`
  // implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  function each(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var _keys = keys(obj);
      for (i = 0, length = _keys.length; i < length; i++) {
        iteratee(obj[_keys[i]], _keys[i], obj);
      }
    }
    return obj;
  }

  // Return the results of applying the iteratee to each element.
  function map(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Internal helper to create a reducing function, iterating left or right.
  function createReduce(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var _keys = !isArrayLike(obj) && keys(obj),
          length = (_keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[_keys ? _keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = _keys ? _keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  var reduce = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  var reduceRight = createReduce(-1);

  // Return all the elements that pass a truth test.
  function filter(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  }

  // Return all the elements for which a truth test fails.
  function reject(obj, predicate, context) {
    return filter(obj, negate(cb(predicate)), context);
  }

  // Determine whether all of the elements pass a truth test.
  function every(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  }

  // Determine if at least one element in the object passes a truth test.
  function some(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  }

  // Determine if the array or object contains a given item (using `===`).
  function contains(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return indexOf(obj, item, fromIndex) >= 0;
  }

  // Invoke a method (with arguments) on every item in a collection.
  var invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (isFunction$1(path)) {
      func = path;
    } else {
      path = toPath(path);
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `_.map`: fetching a property.
  function pluck(obj, key) {
    return map(obj, property(key));
  }

  // Convenience version of a common use case of `_.filter`: selecting only
  // objects containing specific `key:value` pairs.
  function where(obj, attrs) {
    return filter(obj, matcher(attrs));
  }

  // Return the maximum element (or element-based computation).
  function max(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Return the minimum element (or element-based computation).
  function min(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `_.map`.
  function sample(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = values(obj);
      return obj[random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? clone(obj) : values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  }

  // Shuffle a collection.
  function shuffle(obj) {
    return sample(obj, Infinity);
  }

  // Sort the object's values by a criterion produced by an iteratee.
  function sortBy(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return pluck(map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  }

  // An internal function used for aggregate "group by" operations.
  function group(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  }

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  var groupBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
  // when you know that your index values will be unique.
  var indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  var countBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key]++; else result[key] = 1;
  });

  // Split a collection into two arrays: one whose elements all pass the given
  // truth test, and one whose elements all do not pass the truth test.
  var partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Safely create a real, live array from anything iterable.
  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  function toArray(obj) {
    if (!obj) return [];
    if (isArray(obj)) return slice.call(obj);
    if (isString(obj)) {
      // Keep surrogate pair characters together.
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return map(obj, identity);
    return values(obj);
  }

  // Return the number of elements in a collection.
  function size(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : keys(obj).length;
  }

  // Internal `_.pick` helper function to determine whether `key` is an enumerable
  // property name of `obj`.
  function keyInObj(value, key, obj) {
    return key in obj;
  }

  // Return a copy of the object only containing the allowed properties.
  var pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (isFunction$1(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten$1(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the disallowed properties.
  var omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (isFunction$1(iteratee)) {
      iteratee = negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = map(flatten$1(keys, false, false), String);
      iteratee = function(value, key) {
        return !contains(keys, key);
      };
    }
    return pick(obj, iteratee, context);
  });

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  function initial(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  }

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. The **guard** check allows it to work with `_.map`.
  function first(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return initial(array, array.length - n);
  }

  // Returns everything but the first entry of the `array`. Especially useful on
  // the `arguments` object. Passing an **n** will return the rest N values in the
  // `array`.
  function rest(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  }

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  function last(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return rest(array, Math.max(0, array.length - n));
  }

  // Trim out all falsy values from an array.
  function compact(array) {
    return filter(array, Boolean);
  }

  // Flatten out an array, either recursively (by default), or up to `depth`.
  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
  function flatten(array, depth) {
    return flatten$1(array, depth, false);
  }

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  var difference = restArguments(function(array, rest) {
    rest = flatten$1(rest, true, true);
    return filter(array, function(value){
      return !contains(rest, value);
    });
  });

  // Return a version of the array that does not contain the specified value(s).
  var without = restArguments(function(array, otherArrays) {
    return difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  function uniq(array, isSorted, iteratee, context) {
    if (!isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  }

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  var union = restArguments(function(arrays) {
    return uniq(flatten$1(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  function intersection(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  }

  // Complement of zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  function unzip(array) {
    var length = array && max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = pluck(array, index);
    }
    return result;
  }

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  var zip = restArguments(unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
  function object(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  }

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](https://docs.python.org/library/functions.html#range).
  function range(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  }

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  function chunk(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  }

  // Helper function to continue chaining intermediate results.
  function chainResult(instance, obj) {
    return instance._chain ? _$1(obj).chain() : obj;
  }

  // Add your own custom functions to the Underscore object.
  function mixin(obj) {
    each(functions(obj), function(name) {
      var func = _$1[name] = obj[name];
      _$1.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_$1, args));
      };
    });
    return _$1;
  }

  // Add all mutator `Array` functions to the wrapper.
  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) {
        method.apply(obj, arguments);
        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
          delete obj[0];
        }
      }
      return chainResult(this, obj);
    };
  });

  // Add all accessor `Array` functions to the wrapper.
  each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) obj = method.apply(obj, arguments);
      return chainResult(this, obj);
    };
  });

  // Named Exports

  var allExports = {
    __proto__: null,
    VERSION: VERSION,
    restArguments: restArguments,
    isObject: isObject,
    isNull: isNull,
    isUndefined: isUndefined,
    isBoolean: isBoolean,
    isElement: isElement,
    isString: isString,
    isNumber: isNumber,
    isDate: isDate,
    isRegExp: isRegExp,
    isError: isError,
    isSymbol: isSymbol,
    isArrayBuffer: isArrayBuffer,
    isDataView: isDataView$1,
    isArray: isArray,
    isFunction: isFunction$1,
    isArguments: isArguments$1,
    isFinite: isFinite$1,
    isNaN: isNaN$1,
    isTypedArray: isTypedArray$1,
    isEmpty: isEmpty,
    isMatch: isMatch,
    isEqual: isEqual,
    isMap: isMap,
    isWeakMap: isWeakMap,
    isSet: isSet,
    isWeakSet: isWeakSet,
    keys: keys,
    allKeys: allKeys,
    values: values,
    pairs: pairs,
    invert: invert,
    functions: functions,
    methods: functions,
    extend: extend,
    extendOwn: extendOwn,
    assign: extendOwn,
    defaults: defaults,
    create: create,
    clone: clone,
    tap: tap,
    get: get,
    has: has,
    mapObject: mapObject,
    identity: identity,
    constant: constant,
    noop: noop,
    toPath: toPath$1,
    property: property,
    propertyOf: propertyOf,
    matcher: matcher,
    matches: matcher,
    times: times,
    random: random,
    now: now,
    escape: _escape,
    unescape: _unescape,
    templateSettings: templateSettings,
    template: template,
    result: result,
    uniqueId: uniqueId,
    chain: chain,
    iteratee: iteratee,
    partial: partial,
    bind: bind,
    bindAll: bindAll,
    memoize: memoize,
    delay: delay,
    defer: defer,
    throttle: throttle,
    debounce: debounce,
    wrap: wrap,
    negate: negate,
    compose: compose,
    after: after,
    before: before,
    once: once,
    findKey: findKey,
    findIndex: findIndex,
    findLastIndex: findLastIndex,
    sortedIndex: sortedIndex,
    indexOf: indexOf,
    lastIndexOf: lastIndexOf,
    find: find,
    detect: find,
    findWhere: findWhere,
    each: each,
    forEach: each,
    map: map,
    collect: map,
    reduce: reduce,
    foldl: reduce,
    inject: reduce,
    reduceRight: reduceRight,
    foldr: reduceRight,
    filter: filter,
    select: filter,
    reject: reject,
    every: every,
    all: every,
    some: some,
    any: some,
    contains: contains,
    includes: contains,
    include: contains,
    invoke: invoke,
    pluck: pluck,
    where: where,
    max: max,
    min: min,
    shuffle: shuffle,
    sample: sample,
    sortBy: sortBy,
    groupBy: groupBy,
    indexBy: indexBy,
    countBy: countBy,
    partition: partition,
    toArray: toArray,
    size: size,
    pick: pick,
    omit: omit,
    first: first,
    head: first,
    take: first,
    initial: initial,
    last: last,
    rest: rest,
    tail: rest,
    drop: rest,
    compact: compact,
    flatten: flatten,
    without: without,
    uniq: uniq,
    unique: uniq,
    union: union,
    intersection: intersection,
    difference: difference,
    unzip: unzip,
    transpose: unzip,
    zip: zip,
    object: object,
    range: range,
    chunk: chunk,
    mixin: mixin,
    'default': _$1
  };

  // Default Export

  // Add all of the Underscore functions to the wrapper object.
  var _ = mixin(allExports);
  // Legacy Node.js API.
  _._ = _;

  return _;

})));


/***/ }),

/***/ "./packages/@okta/i18n/src/json/country.json":
/*!***************************************************!*\
  !*** ./packages/@okta/i18n/src/json/country.json ***!
  \***************************************************/
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"AF":"Afghanistan","AX":"Åland Islands","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia, Plurinational State of","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","VG":"Virgin Islands, British","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CO":"Colombia","KM":"Comoros","CG":"Congo","CK":"Cook Islands","CR":"Costa Rica","CI":"Côte d\'Ivoire","HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":"Czech Republic","CD":"Congo, the Democratic Republic of the","DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","TL":"Timor-Leste","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran, Islamic Republic of","IQ":"Iraq","IE":"Ireland","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JE":"Jersey","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KR":"Korea, Republic of","XK":"Kosovo, Republic of","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People\'s Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MK":"Macedonia, the former Yugoslav Republic of","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","ME":"Montenegro","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","AN":"Netherlands Antilles","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","KP":"Korea, Democratic People\'s Republic of","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestine, State of","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Réunion","RO":"Romania","RU":"Russian Federation","RW":"Rwanda","SH":"Saint Helena, Ascension and Tristan da Cunha","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"São Tomé and Príncipe","SA":"Saudi Arabia","SN":"Senegal","RS":"Serbia","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","SS":"South Sudan","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Swaziland","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":"Taiwan","TJ":"Tajikistan","TZ":"Tanzania, United Republic of","TH":"Thailand","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","VI":"Virgin Islands, U.S.","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":"United Kingdom","US":"United States","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VA":"Holy See (Vatican City State)","VE":"Venezuela, Bolivarian Republic of","VN":"Viet Nam","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe"}');

/***/ }),

/***/ "./packages/@okta/i18n/src/json/login.json":
/*!*************************************************!*\
  !*** ./packages/@okta/i18n/src/json/login.json ***!
  \*************************************************/
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"signout":"Sign Out","signin":"Sign In","signup":"Sign Up","remember":"Remember me","rememberDevice":"Trust this device","rememberDevice.timebased":"Do not challenge me on this device for the next {0}","rememberDevice.devicebased":"Do not challenge me on this device again","autoPush":"Send push automatically","unlockaccount":"Unlock account?","haveaccount":"Already have an account?","needhelp":"Need help signing in?","forgotpassword":"Forgot password?","help":"Help","retry":"Retry","iphone":"iPhone","android":"Android","goback":"Back to sign in","closeWindow":"You can close this window","country.option.label":"{0} ({1})","phone.extention.label":"Extension","select.default_value":"Select an option","select.filter.no_match":"No results found for \\"{0}\\"","sensitive.input.show":"Show","sensitive.input.hide":"Hide","processing.alt.text":"Processing...","logo.default.alt.text":"Logo","identifier.icon.alt.text":"User","icon.title.application":"Application","icon.title.browser":"Browser","icon.title.mobileBrowser":"Mobile browser","icon.title.location":"Location","icon.title.mobileDevice":"Mobile Device","skip.to.main.content":"Skip to main content","minutes.oneMinute":"minute","minutes":"{0} minutes","hours":"{0} hours","days":"{0} days","error.config":"There was a configuration error","error.required.authParams":"Missing parameters for the configured authentication scheme - \\"OAUTH2\\"","error.required.baseUrl":"\\"baseUrl\\" is a required widget parameter","error.required.success":"A success handler is required","error.required.el":"\\"el\\" is a required widget parameter","error.invalid.colors.brand":"\\"colors.brand\\" must be in six-digit hex format","error.unsupported.browser":"Unsupported browser","error.unsupported.cors":"Unsupported browser - missing CORS support","error.unsupported.localStorage":"Unsupported browser - missing localStorage support","error.enabled.cors":"There was an error sending the request - have you enabled CORS?","error.expired.session":"Your session has expired. Please try to sign in again.","error.mfa.only.expired.session":"Unable to authenticate at this time.","error.auth.lockedOut":"Your account is locked. Please contact your administrator.","error.oauth.idToken":"There was a problem generating the id_token for the user. Please try again.","error.network.connection":"Unable to connect to the server. Please check your network connection.","error.username.required":"Please enter a username","error.password.required":"Please enter a password","error.mfa.required":"The current sign on policy requires this client to redirect for re-authentication or MFA. Please contact your administrator.","error.unsupported.response":"There was an unsupported response from server.","error.jit_failure":"Unable to sign in, please try another sign in method.","error.unsynced.clock":"Unable to sign in. Please check that your device\'s clock is accurate and try again.","errors.E0000004":"Unable to sign in","errors.E0000069":"Your account is locked because of too many authentication attempts.","errors.E0000047":"You exceeded the maximum number of requests. Try again in a while.","errors.E0000079":"The operation is not allowed. Please refresh the page to proceed.","errors.E0000001":"Api validation failed: {0}","errors.E0000002":"The request was not valid: {0}","errors.E0000003":"The request body was not well-formed.","errors.E0000005":"Invalid session","errors.E0000006":"You do not have permission to perform the requested action","errors.E0000007":"Not found: {0}","errors.E0000008":"The requested path was not found","errors.E0000009":"Internal Server Error","errors.E0000010":"Service is in read only mode","errors.E0000011":"Invalid token provided","errors.E0000012":"Unsupported media type","errors.E0000013":"Invalid client app id","errors.E0000015":"You do not have permission to access the feature you are requesting","errors.E0000016":"Activation failed because the user is already active","errors.E0000017":"Password reset failed","errors.E0000018":"Bad request.  Accept and/or Content-Type headers are likely not set.","errors.E0000019":"Bad request.  Accept and/or Content-Type headers likely do not match supported values.","errors.E0000020":"Bad request.","errors.E0000021":"Bad request.  Accept and/or Content-Type headers likely do not match supported values.","errors.E0000022":"The endpoint does not support the provided HTTP method","errors.E0000023":"Operation failed because user profile is mastered under another system","errors.E0000024":"Bad request.  This operation on app metadata is not yet supported.","errors.E0000025":"App version assignment failed.","errors.E0000026":"This endpoint has been deprecated.","errors.E0000027":"Group push bad request : {0}","errors.E0000028":"The request is missing a required parameter.","errors.E0000029":"Invalid paging request.","errors.E0000030":"Bad request. Invalid date. Dates must be of the form yyyy-MM-dd\'\'T\'\'HH:mm:ss.SSSZZ, e.g. 2013-01-01T12:00:00.000-07:00.","errors.E0000031":"Invalid search criteria.","errors.E0000032":"Unlock is not allowed for this user.","errors.E0000033":"Bad request. Can\'t specify a search query and filter in the same request.","errors.E0000034":"Forgot password not allowed on specified user.","errors.E0000035":"Change password not allowed on specified user.","errors.E0000036":"Change recovery question not allowed on specified user.","errors.E0000037":"Type mismatch exception.","errors.E0000038":"This operation is not allowed in the user\'\'s current status.","errors.E0000039":"Operation on application settings failed.","errors.E0000040":"Application label must not be the same as an existing application label.","errors.E0000041":"Credentials should not be set on this resource based on the scheme.","errors.E0000042":"Setting the error page redirect URL failed.","errors.E0000043":"Self service application assignment is not enabled.","errors.E0000044":"Self service application assignment is not supported.","errors.E0000045":"Field mapping bad request.","errors.E0000046":"Deactivate application for user forbidden.","errors.E0000048":"Entity not found exception.","errors.E0000049":"Invalid SCIM data from SCIM implementation.","errors.E0000050":"Invalid SCIM data from client.","errors.E0000051":"No response from SCIM implementation.","errors.E0000052":"Endpoint not implemented.","errors.E0000053":"Invalid SCIM filter.","errors.E0000054":"Invalid pagination properties.","errors.E0000055":"Duplicate group.","errors.E0000056":"Delete application forbidden.","errors.E0000057":"Access to this application is denied due to a policy.","errors.E0000058":"Access to this application requires MFA: {0}","errors.E0000059":"The connector configuration could not be tested. Make sure that the URL, Authentication Parameters are correct and that there is an implementation available at the URL provided.","errors.E0000060":"Unsupported operation.","errors.E0000061":"Tab error: {0}","errors.E0000062":"The specified user is already assigned to the application.","errors.E0000063":"Invalid combination of parameters specified.","errors.E0000064":"Password is expired and must be changed.","errors.E0000065":"Internal error processing app metadata.","errors.E0000066":"APNS is not configured, contact your admin","errors.E0000067":"Factors Service Error.","errors.E0000070":"Waiting for ACK","errors.E0000071":"Unsupported OS Version: {0}","errors.E0000072":"MIM policy settings have disallowed enrollment for this user","errors.E0000073":"User rejected authentication","errors.E0000074":"Factor Service Error","errors.E0000075":"Cannot modify the {0} attribute because it has a field mapping and profile push is enabled.","errors.E0000076":"Cannot modify the app user because it is mastered by an external app.","errors.E0000077":"Cannot modify the {0} attribute because it is read-only.","errors.E0000078":"Cannot modify the {0} attribute because it is immutable.","errors.E0000081":"Cannot modify the {0} attribute because it is a reserved attribute for this application.","errors.E0000082":"Each code can only be used once. Please wait for a new code and try again.","errors.E0000083":"PassCode is valid but exceeded time window.","errors.E0000084":"App evaluation error.","errors.E0000085":"You do not have permission to access your account at this time.","errors.E0000086":"This policy cannot be activated at this time.","errors.E0000087":"The recovery question answer did not match our records.","errors.E0000090":"The role specified is already assigned to the user.","errors.E0000091":"The provided role type was not the same as required role type.","errors.E0000092":"Access to this application requires re-authentication: {0}","errors.E0000093":"Target count limit exceeded","errors.E0000094":"The provided filter is unsupported.","errors.E0000095":"Recovery not allowed for unknown user.","errors.E0000096":"This certificate has already been uploaded with kid={0}.","errors.E0000097":"There is no verified phone number on file.","errors.E0000098":"This phone number is invalid.","errors.E0000099":"Only numbers located in US and Canada are allowed.  Contact your administrator if this is a problem.","errors.E0000100":"Unable to perform search query.","errors.E0000101":"Upload failed because of a problem with your ipa file, {0}","errors.E0000102":"YubiKey cannot be deleted while assigned to an user. Please deactivate YubiKey using reset MFA and try again","errors.E0000103":"Action on device already in queue or in progress","errors.E0000104":"Device is already locked and cannot be locked again","errors.E0000105":"You have accessed an account recovery link that has expired or been previously used.","errors.E0000106":"Wait for token to change, then enter the new tokencode.","errors.E0000107":"The entity is not in the expected state for the requested transition.","errors.E0000109":"An SMS message was recently sent. Please wait 30 seconds before trying again.","errors.E0000110":"You have accessed a link that has expired or has been previously used.","errors.E0000111":"Cannot modify the {0} object because it is read-only.","errors.E0000112":"Cannot update this user because they are still being activated. Please try again in a few minutes.","errors.E0000113":"{0}.","errors.E0000114":"A user with this login already exists in the current organization.","errors.E0000115":"Upload failed, {0}","errors.E0000116":"{0}","errors.E0000119":"Your account is locked. Please contact your administrator.","errors.E0000124":"Could not create user. To create a user and expire their password immediately, a password must be specified","errors.E0000125":"Could not create user. To create a user and expire their password immediately, \\"activate\\" must be true","errors.E0000133":"A phone call was recently made. Please wait 30 seconds before trying again.","errors.E0000207":"The username and/or the password you entered is incorrect. Please try again.","oform.next":"Next","oform.verify":"Verify","oform.send":"Send","oform.back":"Back","oform.title.authenticate":"Authenticate","oform.save":"Save","oform.cancel":"Cancel","oform.edit":"Edit","oform.previous":"Previous","oform.error.icon.ariaLabel":"Error","oform.errorbanner.title":"We found some errors. Please review the form and make corrections.","oform.errormsg.title":"Please review the form to correct the following errors:","oform.error.unexpected":"There was an unexpected internal error. Please try again.","oform.error.webfinger":"Unable to determine user identification method. Please contact your administrator for assistance.","oform.selectInput.country":"{0} selected","model.validation.field.blank":"This field cannot be left blank","model.validation.field.wrong.type":"This field is of the wrong type","model.validation.field.invalid":"This field has an invalid value","model.validation.field.value.not.allowed":"This field value is not allowed","model.validation.field.array.minItems":"This array does not have enough items","model.validation.field.array.maxItems":"This array contains too many items","model.validation.field.array.unique":"This array can only have unique values","model.validation.field.string.minLength":"This field cannot be less than the minimum required characters","model.validation.field.string.maxLength":"This field cannot exceed the maximum allowed characters","model.validation.field.invalid.format.email":"This value is not a valid email address","model.validation.field.invalid.format.uri":"This value is not a valid URI","model.validation.field.invalid.format.ipv4":"This value is not a valid IPv4 address","model.validation.field.invalid.format.hostname":"This value is not a valid hostname","model.validation.field.username":"Please check your username","schema.validation.field.value.must.string":"Value must be a string","schema.validation.field.value.must.number":"Value must be a number","schema.validation.field.value.must.integer":"Value must be an integer","schema.validation.field.value.must.object":"Value must be an object","universal-directory.profiles.attribute.source.oktamastered":"Inherit from Okta","universal-directory.profiles.attribute.source.override":"Override profile source","universal-directory.profiles.attribute.form.union.disable.display":"Combine values across groups","universal-directory.profiles.attribute.source.inherit":"Inherit from profile source","universal-directory.profiles.attribute.enduser.permission.readonly":"Read Only","universal-directory.profiles.attribute.enduser.permission.hide":"Hide","universal-directory.profiles.attribute.enduser.permission.readwrite":"Read-Write","universal-directory.profiles.attribute.form.union.enable.display":"Use Group Priority","factor.totpSoft.oktaVerify":"Okta Verify","factor.totpSoft.googleAuthenticator":"Google Authenticator","factor.totpSoft.description":"Enter single-use code from the mobile app.","factor.totpHard.rsaSecurId":"RSA SecurID","factor.totpHard.symantecVip":"Symantec VIP","factor.totpHard.description":"Enter a single-use code from a hardware token.","factor.totpHard.yubikey":"YubiKey","factor.totpHard.yubikey.description":"Insert your YubiKey and tap it to get a verification code.","factor.totpHard.yubikey.placeholder":"Click here, then tap your YubiKey","factor.oktaVerifyPush":"Okta Verify","factor.push.description":"Use a push notification sent to the mobile app.","factor.duo":"Duo Security","factor.duo.description":"Use Push Notification, SMS, or Voice call to authenticate.","factor.sms":"SMS Authentication","factor.sms.description":"Enter a single-use code sent to your mobile phone.","factor.sms.time.warning":"Haven\'t received an SMS? To try again, click <$1>Re-send code</$1>.","factor.call":"Voice Call Authentication","factor.call.description":"Use a phone to authenticate by following voice instructions.","factor.call.time.warning":"Haven\'t received a voice call? To try again, click <$1>Redial</$1>.","factor.securityQuestion":"Security Question","factor.securityQuestion.description":"Use the answer to a security question to authenticate.","factor.windowsHello":"Windows Hello","factor.windowsHello.signin.description":"Sign in to Okta using Windows Hello.","factor.windowsHello.signin.description.generic":"Sign in using Windows Hello.","factor.windowsHello.signin.description.specific":"Sign in to {0} using Windows Hello.","factor.u2f":"Security Key (U2F)","factor.u2f.description":"Use a Universal 2nd Factor (U2F) security key to sign on to Okta.","factor.u2f.description.generic":"Use a Universal 2nd Factor (U2F) security key to sign in.","factor.u2f.description.specific":"Use a Universal 2nd Factor (U2F) security key to sign in to {0}.","factor.email":"Email Authentication","factor.email.description":"Enter a verification code sent to your email.","factor.password":"Password","factor.customFactor.description":"Redirect to a third party MFA provider to sign in to Okta.","factor.customFactor.description.generic":"Redirect to a third party MFA provider to sign in.","factor.customFactor.description.specific":"Redirect to a third party MFA provider to sign in to {0}.","factor.webauthn.biometric":"Security Key or Biometric Authenticator","factor.webauthn.biometric.description":"Use a security key (USB or bluetooth) or a biometric authenticator (Windows Hello, Touch ID, etc.)","factor.hotp.description":"Enter a single-use code from an authenticator.","mfa.challenge.verify":"Verify","mfa.challenge.answer.placeholder":"Answer","mfa.challenge.answer.tooltip":"Answer","mfa.challenge.answer.showAnswer":"Show","mfa.challenge.answer.hideAnswer":"Hide","mfa.challenge.enterCode.placeholder":"Enter Code","mfa.challenge.enterCode.tooltip":"Enter Code","mfa.challenge.password.placeholder":"Password","mfa.backToFactors":"Back to factor list","mfa.enroll":"Enroll","mfa.setupOptions":"Setup Options","mfa.country":"Country/region","mfa.phoneNumber.placeholder":"Phone number","mfa.phoneNumber.ext.placeholder":"Extension","mfa.sendCode":"Send code","mfa.sent":"Sent","mfa.resendCode":"Re-send code","mfa.call":"Call","mfa.calling":"Calling","mfa.redial":"Redial","mfa.sendEmail":"Send email","mfa.resendEmail":"Re-send email","mfa.scanBarcode":"Scan QR code","mfa.altQrCode":"QR code. If you can\'t scan, click on the link below to select an alternative activation method","mfa.noAccessToEmail":"Can\'t access email","password.reset":"Reset Password","password.oldPassword.placeholder":"Old password","password.oldPassword.tooltip":"Old password","password.newPassword.placeholder":"New password","password.newPassword.tooltip":"New password","password.confirmPassword.placeholder":"Repeat password","password.confirmPassword.tooltip":"Repeat password","password.error.match":"New passwords must match","password.enroll.error.match":"Passwords must match","recovery.sms.hint":"SMS can only be used if a mobile phone number has been configured.","recovery.mobile.hint":"{0} can only be used if a mobile phone number has been configured.","recovery.sms":"SMS","recovery.call":"Voice Call","recovery.smsOrCall":"SMS or Voice Call","verify.choices.description":"Verify with one of the following factors.","email.button.send":"Send me the code","email.button.resend":"Send again","email.code.label":"Verification code","email.code.not.received":"Haven\'t received an email?","email.enroll.title":"Set up Email Authentication","email.enroll.description":"Send a verification code to your registered email.","email.enroll.enterCode":"Enter code","email.link.terminal.msg":"To finish signing in, return to the screen where you requested the email link.","email.mfa.title":"Verify with Email Authentication","email.mfa.description":"Send a verification code to {0}.","email.mfa.email.sent.description":"A verification code was sent to {0}. Check your email and enter the code below.","email.mfa.email.sent.description.sentText":"A verification code was sent to","email.mfa.email.sent.description.emailCodeText":"Check your email and enter the code below.","email.unregistered_email.error":"Enter the email where you received the Welcome instructions from your administrator.","enroll.choices.title":"Set up multifactor authentication","enroll.choices.description":"Your company requires multifactor authentication to add an additional layer of security when signing in to your Okta account","enroll.choices.description.generic":"Your company requires multifactor authentication to add an additional layer of security when signing in to your account","enroll.choices.description.specific":"Your company requires multifactor authentication to add an additional layer of security when signing in to your {0} account","enroll.choices.description.gracePeriod.bold":"Your company recommends setting up additional factors for authentication. Set up will be required in: <b>{0} day(s)</b>.","enroll.choices.description.gracePeriod.oneDay.bold":"Your company recommends setting up additional factors for authentication. Set up will be required in: <b>less than 1 day</b>.","enroll.choices.optional":"You can configure any additional optional factor or click finish","enroll.choices.list.setup":"Setup required","enroll.choices.list.enrolled":"Enrolled factors","enroll.choices.list.optional":"Additional optional factors","enroll.choices.setup":"Setup","enroll.choices.setup.another":"Set up another","enroll.choices.submit.finish":"Finish","enroll.choices.submit.configure":"Configure factor","enroll.choices.submit.next":"Configure next factor","enroll.choices.cardinality.setup":"({0} set up)","enroll.choices.cardinality.setup.remaining":"({0} of {1} set up)","enroll.choices.setup.skip":"Skip set up","enroll.securityQuestion.setup":"Setup secret question authentication","security.disliked_food":"What is the food you least liked as a child?","security.name_of_first_plush_toy":"What is the name of your first stuffed animal?","security.first_award":"What did you earn your first medal or award for?","security.favorite_security_question":"What is your favorite security question?","security.favorite_toy":"What is the toy/stuffed animal you liked the most as a kid?","security.first_computer_game":"What was the first computer game you played?","security.favorite_movie_quote":"What is your favorite movie quote?","security.first_sports_team_mascot":"What was the mascot of the first sports team you played on?","security.first_music_purchase":"What music album or song did you first purchase?","security.favorite_art_piece":"What is your favorite piece of art?","security.grandmother_favorite_desert":"What was your grandmother\'s favorite dessert?","security.first_thing_cooked":"What was the first thing you learned to cook?","security.childhood_dream_job":"What was your dream job as a child?","security.first_kiss_location":"Where did you have your first kiss?","security.place_where_significant_other_was_met":"Where did you meet your spouse/significant other?","security.favorite_vacation_location":"Where did you go for your favorite vacation?","security.new_years_two_thousand":"Where were you on New Year\'s Eve in the year 2000?","security.favorite_speaker_actor":"Who is your favorite speaker/orator?","security.favorite_book_movie_character":"Who is your favorite book/movie character?","security.favorite_sports_player":"Who is your favorite sports player?","enroll.password.setup":"Select a password","save.password":"Save password","enroll.sms.setup":"Receive a code via SMS to authenticate","enroll.sms.try_again":"The number you entered seems invalid. If the number is correct, please try again.","enroll.call.setup":"Follow phone call instructions to authenticate","enroll.onprem.username.placeholder":"Enter {0} username","enroll.onprem.username.tooltip":"Enter {0} username","enroll.onprem.passcode.placeholder":"Enter {0} passcode","enroll.onprem.passcode.tooltip":"Enter {0} passcode","enroll.symantecVip.subtitle":"Enter Credential ID and two consecutive generated codes","enroll.symantecVip.credentialId.placeholder":"Enter credential ID","enroll.symantecVip.credentialId.tooltip":"Enter credential ID","enroll.symantecVip.passcode1.placeholder":"Security code 1","enroll.symantecVip.passcode1.tooltip":"Security code 1","enroll.symantecVip.passcode2.placeholder":"Security code 2","enroll.symantecVip.passcode2.tooltip":"Security code 2","enroll.yubikey.title":"Setup YubiKey","enroll.yubikey.subtitle":"Insert your YubiKey into a USB port and tap it to generate a verification code","enroll.totp.title":"Setup {0}","enroll.totp.selectDevice":"Select your device type","enroll.totp.downloadApp":"Download <a href=\\"{0}\\" class=\\"inline-link\\">{1} from the {2}</a> onto your mobile device.","enroll.hotp.restricted":"Contact your administrator to continue enrollment.","enroll.duo.title":"Setup Duo Security","enroll.windowsHello.title":"Enroll Windows Hello","enroll.windowsHello.subtitle":"Click below to enroll Windows Hello as a second form of authentication","enroll.windowsHello.subtitle.loading":"Please wait while Windows Hello is loading...","enroll.windowsHello.save":"Enroll Windows Hello","enroll.windowsHello.error.notWindows":"Windows Hello can only be used on Windows Edge with Windows 10. Contact your admin for assistance.","enroll.windowsHello.error.notConfiguredHtml":"Windows Hello is not configured. Select the <b>Start</b> button, then select <b>Settings</b> - <b>Accounts</b> - <b>Sign-in</b> to configure Windows Hello.","verify.windowsHello.subtitle":"Verify your identity with Windows Hello","verify.windowsHello.subtitle.loading":"Please wait while Windows Hello is loading...","verify.windowsHello.subtitle.signingIn":"Signing in to Okta...","verify.windowsHello.subtitle.signingIn.generic":"Signing in...","verify.windowsHello.subtitle.signingIn.specific":"Signing in to {0}...","verify.windowsHello.save":"Verify with Windows Hello","verify.windowsHello.error.notFound":"Your Windows Hello enrollment does not match our records. Contact your administrator for assistance.","verify.windowsHello.error.notFound.selectAnother":"Your Windows Hello enrollment does not match our records. Select another factor or contact your administrator for assistance.","enroll.u2f.title":"Setup Security Key (U2F)","enroll.u2f.save":"Register Security Key","enroll.u2f.general2":"Make sure you have a Security Key. If already inserted, remove it now.<br>If you have a Bluetooth Security Key, turn on your computer\'s Bluetooth.","enroll.u2f.general3":"Click the button below to register","enroll.u2f.instructions":"Insert your Security Key into a USB port on this computer. If it has a button or gold disk, tap it.","enroll.u2f.instructionsBluetooth":"If you are using a Bluetooth Security Key, press the button.","u2f.error.factorNotSupported":"Security Key (U2F) is not supported on this browser. Select another factor or contact your admin for assistance.","u2f.error.factorNotSupported.oneFactor":"Security Key (U2F) is not supported on this browser. Contact your admin for assistance.","u2f.error.other":"An unknown error has occured. Try again or select another factor.","u2f.error.other.oneFactor":"An unknown error has occured. Try again or contact your admin for assistance.","u2f.error.badRequest":"There was an error with the U2F request. Try again or select another factor.","u2f.error.badRequest.oneFactor":"There was an error with the U2F request. Try again or contact your admin for assistance.","u2f.error.unsupported":"The security key is unsupported. Select another factor.","u2f.error.unsupported.oneFactor":"The security key is unsupported. Contact your admin for assistance.","u2f.error.timeout":"You have timed out of the authentication period. Please try again.","verify.u2f.instructions":"Insert your Security Key. If it has a button or gold disk, tap it.","verify.u2f.instructionsBluetooth":"If you are using a Bluetooth Security Key, turn on your computer\'s Bluetooth and press the button.","verify.u2f.retry":"Retry","enroll.customFactor.subtitle":"Clicking below will redirect to MFA enrollment with {0}","enroll.customFactor.save":"Enroll","verify.customFactor.subtitle":"Clicking below will redirect to verification with {0}","verify.customFactor.subtitle.redirect":"Redirecting to {0}...","enroll.webauthn.biometric.title":"Set up security key or biometric authenticator","enroll.webauthn.save":"Enroll","enroll.webauthn.biometric.instructions":"Your browser will prompt to register a security key or biometric authenticator (Windows Hello, Touch ID, etc.). Follow the instructions to complete enrollment.","enroll.webauthn.biometric.instructions.edge":"Note: If you are enrolling a security key and Windows Hello or PIN is enabled, you will need to select \'<b>Cancel</b>\' in the prompt before continuing.","verify.webauthn.biometric.instructions":"Your browser or device will prompt you to verify with a security key or biometric authenticator. Follow the instructions to complete authentication.","webauthn.biometric.error.factorNotSupported":"Security key or biometric authenticator is not supported on this browser. Select another factor or contact your admin for assistance.","webauthn.biometric.error.factorNotSupported.oneFactor":"Security key or biometric authenticator is not supported on this browser. Contact your admin for assistance.","enroll.webauthn.instructions.noSupportForBiometric":"Note: Some browsers may not support biometric authenticators.","authfactor.webauthn.error":"You are currently unable to use a Security key or biometric authenticator. Try again.","enroll.totp.enterCode":"Enter code displayed from the application","enroll.totp.setupApp":"Launch {0} on your mobile device and select “Add an account”. Scan the QR code to continue.","enroll.totp.setupGoogleAuthApp":"Launch {0}, tap the \\"+\\" icon, then select \\"Scan a QR code\\".","enroll.totp.cannotScan":"Can\'t scan?","enroll.totp.aria.cannotScan":"Setup without scanning a QR code.","enroll.totp.refreshBarcode":"Refresh code","enroll.totp.cannotScanBarcode":"Can\'t scan QR code?","enroll.totp.manualSetupInstructions":"To set up manually enter your Okta Account username and then input the following in the Secret Key Field","enroll.totp.manualSetupInstructions.generic":"To set up manually enter your Account username and then input the following in the Secret Key Field","enroll.totp.manualSetupInstructions.specific":"To set up manually enter your {0} Account username and then input the following in the Secret Key Field","enroll.totp.sharedSecretInstructions":"Enter your Okta Account username and enter the following in the Secret Key Field","enroll.totp.sharedSecretInstructions.generic":"Enter your Account username and enter the following in the Secret Key Field","enroll.totp.sharedSecretInstructions.specific":"Enter your {0} Account username and enter the following in the Secret Key Field","enroll.totp.sendSms":"Send activation link via SMS","enroll.totp.sendEmail":"Send activation link via email","enroll.totp.setupManually":"Setup manually without push notification","enroll.totp.sharedSecretInstructions.aria.secretKey":"setup key {0}","enroll.totp.enrollViaEmail.title":"Activation email sent!","enroll.totp.enrollViaEmail.msg":"Open the email from your mobile device.","enroll.totp.enrollViaSms.title":"SMS sent!","enroll.totp.enrollViaSms.msg":"View the SMS on your mobile device.","recoveryChallenge.sms.title":"Enter verification code sent via SMS","recoveryChallenge.call.title":"Enter verification code received via Voice Call","mfa.factors.dropdown.title":"Select an authentication factor","mfa.factors.dropdown.sr.text":"Select Authentication Factor - {0} Factor Selected","mfa.duoSecurity.push":"Push — {0}","mfa.duoSecurity.sms":"SMS — {0}","mfa.duoSecurity.call":"Call — {0}","mfa.switch":"Switch Factor","mfa.challenge.title":"Enter your {0} passcode","mfa.challenge.orEnterCode":"Or enter code","mfa.challenge.totp.subtitle.multiple":"Enter code from any registered {0} device.","mfa.emailVerification.checkEmail":"To finish signing in, click the link in your email.","mfa.emailVerification.title":"Sign in using a link sent to your email.","mfa.emailVerification.subtitle":"Emails will be sent to {0}","mfa.emailVerification.otc.finish":"To finish signing in, enter the code which was emailed to you.","oktaverify.send":"Send Push","oktaverify.resend":"Re-send Push","oktaverify.sent":"Push sent!","oktaverify.rejected":"You have chosen to reject this login.","oktaverify.rejected.upgradeRequired.ios":"Verification failed because your Okta Verify version is no longer supported. To sign in, please update Okta Verify on the App Store, then try again.","oktaverify.rejected.upgradeRequired.android":"Verification failed because your Okta Verify version is no longer supported. To sign in, please update Okta Verify on Google Play, then try again.","oktaverify.timeout":"Your push notification has expired.","oktaverify.warning":"Haven\'t received a push notification yet? Try opening the Okta Verify App on your phone.","oktaverify.numberchallenge.instruction":"On your phone, tap <span class=\\"challenge-number\\">{0}</span> on Okta Verify prompt to continue.","oktaverify.numberchallenge.explain":"This extra step helps us make sure it\'s really you signing in.","primaryauth.title":"Sign In","primaryauth.username.placeholder":"Username","primaryauth.username.tooltip":"Username","primaryauth.password.placeholder":"Password","primaryauth.password.tooltip":"Password","primaryauth.submit":"Sign In","primaryauth.newUser.tooltip":"This is the first time you are connecting to {0} from this browser","primaryauth.newUser.tooltip.close":"Close","oktaVerify.description":"To access this resource, your organization requires you to sign in with Okta FastPass.","oktaVerify.appDescription":"To access {0}, your organization requires you to sign in with Okta FastPass.","oktaVerify.button":"Sign in with Okta FastPass","signinWithWebAuthn.button":"Sign in with security key or biometrics","idpDiscovery.email.placeholder":"Email","password.forgot.email.or.username.placeholder":"Email or Username","password.forgot.email.or.username.tooltip":"Email or Username","password.forgot.sendText":"Reset via SMS","password.forgot.sendEmail":"Reset via Email","password.forgot.call":"Reset via Voice Call","password.forgot.emailSent.title":"Email sent!","password.forgot.emailSent.desc":"Email has been sent to {0} with instructions on resetting your password.","password.forgot.question.title":"Answer Forgotten Password Challenge","password.forgot.question.submit":"Reset Password","password.forgot.code.notReceived":"Didn\'t receive a code? Reset via email","password.forgot.noFactorsEnabled":"No password reset options available. Please contact your administrator.","password.reset.title":"Reset your Okta password","password.reset.title.generic":"Reset your password","password.reset.title.specific":"Reset your {0} password","password.complexity.requirements":"Password requirements: {0}.","password.complexity.history":"Your password cannot be any of your last {0} password(s).","password.complexity.minAgeMinutes":"At least {0} minute(s) must have elapsed since you last changed your password.","password.complexity.minAgeHours":"At least {0} hour(s) must have elapsed since you last changed your password.","password.complexity.minAgeDays":"At least {0} day(s) must have elapsed since you last changed your password.","password.reset.verification":"Verify with one of the following factors to reset your password.","password.reset.revokeSessions":"Sign me out of all other devices.","password.complexity.length":"at least {0} characters","password.complexity.list.element":", {0}","password.complexity.lowercase":"a lowercase letter","password.complexity.uppercase":"an uppercase letter","password.complexity.number":"a number","password.complexity.symbol":"a symbol","password.complexity.no_username":"no parts of your username","password.complexity.no_first_name":"does not include your first name","password.complexity.no_last_name":"does not include your last name","password.complexity.adRequirements":"at least 3 of the following: lowercase letter, uppercase letter, number, symbol","password.complexity.requirements.header":"Password requirements:","password.complexity.length.description":"At least {0} characters","password.complexity.lowercase.description":"A lowercase letter","password.complexity.uppercase.description":"An uppercase letter","password.complexity.number.description":"A number","password.complexity.symbol.description":"A symbol","password.complexity.no_username.description":"No parts of your username","password.complexity.no_first_name.description":"Does not include your first name","password.complexity.no_last_name.description":"Does not include your last name","password.complexity.history.one.description":"Password can\'t be the same as your last password","password.complexity.adRequirements.description":"At least 3 of the following: lowercase letter, uppercase letter, number, symbol","password.complexity.history.description":"Password can\'t be the same as your last {0} passwords","password.complexity.minAgeMinutes.description":"At least {0} minute(s) must have elapsed since you last changed your password","password.complexity.minAgeHours.description":"At least {0} hour(s) must have elapsed since you last changed your password","password.complexity.minAgeDays.description":"At least {0} day(s) must have elapsed since you last changed your password","password.expired.submit":"Change Password","password.expired.title":"Your Okta password has expired","password.expired.title.generic":"Your password has expired","password.expired.title.specific":"Your {0} password has expired","password.expiring.later":"Remind me later","password.expiring.title":"Your password will expire in {0} days","password.expiring.today":"Your password will expire later today","password.expiring.soon":"Your password is expiring soon","password.expiring.subtitle":"When password expires you may be locked out of Okta Mobile, mobile email, and other services.","password.expiring.subtitle.generic":"When password expires you will be locked out of your account.","password.expiring.subtitle.specific":"When password expires you will be locked out of your {0} account.","password.expired.custom.submit":"Go to {0}","password.expired.custom.subtitle":"This password is set on another website. Click the button below to go there and set a new password.","password.expiring.soon.subtitle.generic":"When password expires you will be locked out of your account. This password is set on another website. Click the button below to go there and set a new password.","password.expiring.soon.subtitle.specific":"When password expires you will be locked out of your {0} account. This password is set on another website. Click the button below to go there and set a new password.","hcaptcha.footer.label":"This site is protected by hCaptcha and its <$1>Privacy Policy</$1> and <$2>Terms of Service</$2> apply.","account.unlock.title":"Unlock account","account.unlock.email.or.username.placeholder":"Email or username","account.unlock.email.or.username.tooltip":"Email or username","account.unlock.sendText":"Send SMS","account.unlock.voiceCall":"Voice Call","account.unlock.sendEmail":"Send Email","account.unlock.emailSent.title":"Email sent!","account.unlock.emailSent.desc":"Email has been sent to {0} with instructions on unlocking your account.","account.unlock.question.title":"Answer Unlock Account Challenge","account.unlock.question.submit":"Unlock Account","account.unlock.unlocked.title":"Account successfully unlocked!","account.unlock.unlocked.desc":"You can log in using your existing username and password.","account.unlock.code.notReceived":"Didn\'t receive a code? Unlock via email","account.unlock.noFactorsEnabled":"No unlock options available. Please contact your administrator.","account.unlock.authenticatorRequired.single":"To unlock your account, select the following authenticator.","account.unlock.authenticatorRequired.multiple":"To unlock your account, select one of the following authenticators.","contact.support":"If you didn\'t provide a secondary email address or don\'t have access to email, please contact your administrator at {0}","customauth.sign.in.with.label":"Sign in with {0}","socialauth.divider.text":"OR","socialauth.facebook.label":"Sign in with Facebook","socialauth.google.label":"Sign in with Google","socialauth.linkedin.label":"Sign in with LinkedIn","socialauth.microsoft.label":"Sign in with Microsoft","socialauth.apple.label":"Sign in with Apple","socialauth.github.label":"Sign in with GitHub","socialauth.gitlab.label":"Sign in with GitLab","socialauth.yahoo.label":"Sign in with Yahoo","socialauth.line.label":"Sign in with LINE","socialauth.paypal.label":"Sign in with PayPal","socialauth.paypal_sandbox.label":"Sign in with PayPal Sandbox","socialauth.salesforce.label":"Sign in with Salesforce","socialauth.amazon.label":"Sign in with Amazon","socialauth.yahoojp.label":"Sign in with Yahoo Japan","socialauth.discord.label":"Sign in with Discord","socialauth.adobe.label":"Sign in with Adobe","socialauth.orcid.label":"Sign in with ORCiD","socialauth.spotify.label":"Sign in with Spotify","socialauth.xero.label":"Sign in with Xero","socialauth.quickbooks.label":"Sign in with Quickbooks","socialauth.popup.title":"External Identity Provider User Authentication","authbutton.divider.text":"or","registration.signup.label":"Don\'t have an account?","registration.signup.text":"Sign up","registration.complete.title":"Verification email sent","registration.complete.confirm.text":"To finish signing in, check your email.","registration.form.title":"Create Account","registration.form.submit":"Register","registration.passwordComplexity.minLength":"At least {0} character(s)","registration.passwordComplexity.minLower":"At least {0} lowercase letter(s)","registration.passwordComplexity.minUpper":"At least {0} uppercase letter(s)","registration.passwordComplexity.minNumber":"At least {0} number(s)","registration.passwordComplexity.minSymbol":"At least {0} symbol(s)","registration.passwordComplexity.excludeUsername":"Does not contain part of username","registration.passwordComplexity.excludeAttribute":"Does not contain \'{0}\'","registration.required.fields.label":"* indicates required field","registration.default.callbackhook.error":"We could not process your registration at this time. Please try again later.","registration.error.userName.invalidEmail":"Invalid email address","registration.error.password.passwordRequirementsNotMet":"Password requirements were not met","registration.error.password.passwordRequirementsNotMet.prefix":"Password requirements were not met:","registration.error.userName.notUniqueWithinOrg":"An account with that {0} already exists","registration.error.notUniqueWithinOrg.Email":"A user with this Email already exists","registration.error.notUniqueWithinOrg.custom":"A user with this {0} already exists","registration.error.invalidLoginEmail.Email":"\'Email\' must be in the form of an email address","registration.error.invalidLoginEmail.custom":"\'{0}\' must be in the form of an email address","registration.error.doesNotMatchPattern.Email":"Provided value for property \'Email\' does not match required pattern","registration.error.doesNotMatchPattern.custom":"Provided value for property \'{0}\' does not match required pattern","registration.error.generic":"There was an error creating your account. Please try registering again.","registration.error.request.not.completed":"Your request could not be completed. Try again later.","registration.model.validation.field.string.too.short":"Please enter something at least {0} characters long","registration.model.validation.field.string.too.long":"Please enter something shorter than {0} characters","piv.card":"PIV Card","piv.card.insert":"Please insert your PIV card and select the user certificate.","piv.card.error":"Certificate authentication failed. Contact your admin.","piv.card.error.empty":"No certificate selected. Choose a certificate and try again.","piv.card.error.invalid":"Certificate validation failed. Choose another certificate and try again.","piv.cac.card":"Sign in with PIV / CAC card","piv.cac.title":"PIV / CAC card","piv.cac.card.insert":"Please insert your PIV / CAC card and select the user certificate.","piv.cac.error":"There was an error signing in. Click the button below to try again.","unsupported.oneDrive.title":"Your OneDrive version is not supported","unsupported.oneDrive.desc":"Upgrade now by installing the OneDrive for Business Next Generation Sync Client to login to Okta","unsupported.oneDrive.action":"Learn how to upgrade","unsupported.cookies.title":"Cookies are required","unsupported.cookies.desc":"Cookies are disabled on your browser. Please enable Cookies and refresh this page.","unsupported.cookies.action":"Refresh","deviceTrust.sso.text":"Sign in to access company resources","deviceTrust.sso.subtitle.2":"Your company uses Okta Mobile to get you approved to access this app.","deviceTrust.sso.button":"Sign in with Okta Mobile","deviceTrust.sso.expire.title":"Oops let\'s get you back on track","deviceTrust.sso.redirectText":"Verifying your identity","deviceTrust.sso.expire.subtitle":"Unfortunately the steps required to sign in took longer than expected and your attempt timed out.","deviceTrust.sso.expire.button":"Sign in using Okta Mobile","deviceTrust.universalLink.fallback.getOktaMobile.title":"Get Okta Mobile","deviceTrust.universalLink.fallback.getOktaMobile.subtitle":"Go to the {0}AppStore{1}, {0}search{1} for {0}Okta Mobile{1} and tap on {0}GET{1} Okta Mobile. Once installed, sign in to Okta Mobile and follow the instructions to secure your device.","core.auth.factor.signedNonce.error.invalidDevice":"Your device or account was invalidated. If this is unexpected, contact your administrator for help.","core.auth.factor.signedNonce.error":"Your device or account was invalidated. Re-enroll your account on Okta Verify and try again.","user.fail.verifyIdentity":"Couldn’t verify your identity","loopback.polling.cancel.link":"Cancel and take me to sign in","loopback.polling.cancel.link.with.form.error":"Take me to sign in","customUri.subtitle":"Launching Okta Verify...","customUri.content":"<div class=\\"skinny-content\\"> If nothing prompts from the browser, <a href=\\"#\\" id=\\"launch-ov\\" class=\\"link\\">click here</a> to launch Okta Verify, or make sure Okta Verify is installed.</div>","customUri.title":"Click \\"Open Okta Verify\\" on the browser prompt","customUri.required.content.prompt":"Didn’t get a prompt?","customUri.required.content.download.title":"Don’t have Okta Verify?","customUri.required.content.download.linkText":"Download here","customUri.required.content.button":"Launch Okta Verify","universalLink.title":"Sign in with Okta FastPass","universalLink.content":"If Okta Verify did not open automatically, tap Open Okta Verify.","appLink.title":"Sign in with Okta FastPass","appLink.content":"If Okta Verify did not open automatically, tap Open Okta Verify.","oktaVerify.open.button":"Open Okta Verify","oktaVerify.reopen.button":"Reopen Okta Verify","consent.required.text":"<b>{0}</b> would like to access:","consent.required.description":"By clicking Allow Access, you allow the actions listed above.","consent.required.termsOfService":"Terms of Service","consent.required.privacyPolicy":"Privacy Policy","consent.required.consentButton":"Allow Access","consent.required.cancelButton":"Don\'t Allow","granular.consent.scopes.title":"<$1>{0}</$1> <$2>wants to access your account</$2>","granular.consent.scopes.description":"Allowing access will share","admin.consent.group.user.group":"User and groups","admin.consent.group.resource.policy":"Resource and policies","admin.consent.group.hook":"Hooks","admin.consent.group.system":"System","polling.title":"There are too many users trying to sign in right now. We will automatically retry in {0} seconds.","poll.form.title":"Unable to complete your request","poll.form.message":"We will automatically retry in <$1>{0}</$1> seconds.","cert.authentication.title":"Certificate authentication","common.logo.alt":"aria logo","oie.authenticator.enroll.error.fail":"Unable to enroll authenticator. Try again.","oie.authenticator.verify.error.fail":"Unable to verify authenticator. Try again.","oie.configuration.error":"Something went wrong. Potential misconfiguration detected. Please contact support.","oie.auth.logo.aria.label":"Authenticator logo","oie.challenge.answer.showAnswer":"Show answer","oie.challenge.answer.hideAnswer":"Hide answer","oie.form.field.optional":"Optional","oie.form.field.optional.description":"Fields are required unless marked optional.","oie.password.label":"Password","oie.password.newPasswordLabel":"New password","oie.password.authenticator.description":"Choose a password for your account","oie.password.challenge.title":"Verify with your password","oie.password.enroll.title":"Set up password","oie.password.passwordLabel":"Enter password","oie.password.confirmPasswordLabel":"Re-enter password","oie.password.showPassword":"Show password","oie.password.showConfirmPassword":"Show re-entered password","oie.password.hidePassword":"Hide password","oie.password.hideConfirmPassword":"Hide re-entered password","oie.password.reset.verification":"Verify with one of the following security methods to reset your password.","idx.password.expiring.message":"When your password expires, you will have to change your password before you can login to your {0} account.","oie.password.incorrect.message":"Password is incorrect","oie.selfservice.reset.password.not.allowed":"Reset password is not allowed at this time. Please contact support for assistance.","password.common":"This password was found in a list of commonly used passwords. Please try another password.","idx.recovery.completed":"You can now sign in with your existing username and new password.","oie.phone.label":"Phone","oie.phone.authenticator.description":"Verify with a code sent to your phone","oie.phone.enroll.sms.label":"SMS","oie.phone.enroll.voice.label":"Voice call","oie.phone.enroll.title":"Set up phone authentication","oie.phone.enroll.call.subtitle":"Enter your phone number to receive a verification code via voice call.","oie.phone.enroll.sms.subtitle":"Enter your phone number to receive a verification code via SMS.","oie.phone.sms.primaryButton":"Receive a code via SMS","oie.phone.sms.secondaryButton":"Receive an SMS instead","oie.phone.call.primaryButton":"Receive a code via voice call","oie.phone.call.secondaryButton":"Receive a voice call instead","oie.phone.verify.sms.resendText":"Haven\'t received an SMS?","oie.phone.verify.sms.codeSentText":"A code was sent to","oie.phone.verify.sms.sendText":"Send a code via SMS to","oie.phone.verify.call.sendText":"Send a code via voice call to","oie.phone.verify.call.resendText":"Haven\'t received a call?","oie.phone.verify.call.resendLinkText":"Call again","oie.phone.verify.sms.resendLinkText":"Send again","oie.phone.verify.enterCodeText":"Enter the code below to verify.","oie.phone.verify.title":"Verify with your phone","oie.phone.alternate.title":"your phone","oie.phone.carrier.charges":"Carrier messaging charges may apply","oie.phone.invalid":"Invalid Phone Number.","oie.phone.verify.sms.sendText.with.phone.with.nickname":"Send a code via SMS to <$1>{0}</$1> <$2>({1})</$2>.","oie.phone.verify.call.sendText.with.phone.with.nickname":"Send a code via voice call to <$1>{0}</$1> <$2>({1})</$2>.","oie.phone.verify.sms.sendText.with.phone.without.nickname":"Send a code via SMS to <$1>{0}</$1>.","oie.phone.verify.call.sendText.with.phone.without.nickname":"Send a code via voice call to <$1>{0}</$1>.","oie.phone.verify.sms.sendText.without.phone":"Send a code via SMS to your phone.","oie.phone.verify.call.sendText.without.phone":"Send a code via voice call to your phone.","oie.phone.verify.sms.codeSentText.with.phone.with.nickname":"A code was sent to <$1>{0}</$1> <$2>({1})</$2>. Enter the code below to verify.","oie.phone.verify.mfa.calling.with.phone.with.nickname":"Calling <$1>{0}</$1> <$2>({1})</$2>. Enter the code below to verify.","oie.phone.verify.sms.codeSentText.with.phone.without.nickname":"A code was sent to <$1>{0}</$1>. Enter the code below to verify.","oie.phone.verify.mfa.calling.with.phone.without.nickname":"Calling <$1>{0}</$1>. Enter the code below to verify.","oie.phone.verify.sms.codeSentText.without.phone":"A code was sent to your phone. Enter the code below to verify.","oie.phone.verify.mfa.calling.without.phone":"Calling your phone. Enter the code below to verify.","oie.email.label":"Email","oie.email.authenticator.description":"Verify with a link or code sent to your email","oie.email.mfa.title":"Verify with your email","oie.email.challenge.mfa.title":"Get a verification email","oie.email.verify.primaryButton":"Send me an email","oie.email.verify.subtitle.text.with.email":"Send a verification email to <$1>{0}</$1> by clicking on \\"Send me an email\\".","oie.email.verify.subtitle.text.with.email.and.secondary.email":"Send a verification email to <$1>{0}</$1> and <$2>{1}</$2> by clicking on \\"Send me an email\\".","oie.email.verify.subtitle.text.without.email":"Send a verification email by clicking on \\"Send me an email\\".","oie.email.verify.alternate.magicLinkToEmailAddress":"We sent an email to <$1>{0}</$1>. ","oie.email.verify.alternate.magicLinkToEmailAddress.with.secondary.email":"We sent an email to <$1>{0}</$1> and <$2>{1}</$2>. ","oie.email.verify.alternate.magicLinkToYourEmail":"We sent you a verification email. ","oie.email.verify.alternate.instructions":"Click the verification link in your email to continue or enter the code below.","oie.email.verify.alternate.show.verificationCode.text":"Enter a verification code instead","oie.email.verify.alternate.verificationCode.instructions":"Enter the verification code in the text box.","oie.email.enroll.subtitle":"Please check your email and enter the code below.","oie.email.return.link.expired.title":"Verify with your email","oie.profile.additional.title":"Additional Profile information","oie.profile.additional.secondemail.subtitle":"Use a second email to <$1> recover your account </$1> in case you become locked out. This email must be verified after setup.","oie.webauthn.label":"Security Key or Biometric Authenticator","oie.webauthn.description":"Use a security key or a biometric authenticator to sign in","oie.enroll.webauthn.title":"Set up security key or biometric authenticator","oie.enroll.webauthn.instructions":"You will be prompted to register a security key or biometric authenticator (Windows Hello, Touch ID, Face ID, etc.). Follow the instructions to complete set up.","oie.enroll.webauthn.uv.required.instructions":"Biometric verification or a PIN is required to setup this authenticator.","oie.enroll.webauthn.instructions.edge":"Note: If you are enrolling a security key and Windows Hello or PIN is enabled, you will need to select \'Cancel\' in the prompt before continuing.","oie.enroll.webauthn.save":"Set up","oie.webauthn.error.not.supported":"Security key or biometric authenticator is not supported on this browser. Contact your admin for assistance.","oie.verify.webauth.title":"Verify with Security Key or Biometric Authenticator","oie.verify.webauthn.instructions":"You will be prompted to use a security key or biometric verification (Windows Hello, Touch ID, etc.). Follow the instructions to complete verification.","oie.verify.webauthn.uv.required.instructions":"Biometric verification or a PIN is required to sign in with this authenticator.","oie.verify.webauthn.cant.verify":"Can\'t verify?","oie.verify.webauthn.cant.verify.biometric.authenticator.title":"Are you trying to use a biometric authenticator?","oie.verify.webauthn.cant.verify.biometric.authenticator.description1":"Biometric authenticators (fingerprint, face recognition, PIN) will only work on the same device on which they were set up.","oie.verify.webauthn.cant.verify.biometric.authenticator.description2":"If available, set up another security method on the device you used to set up your biometric authenticator.","oie.verify.webauthn.cant.verify.security.key.title":"Are you trying to use a security key?","oie.verify.webauthn.cant.verify.security.key.description":"If you have set up a security key, insert it in a USB port when prompted by the browser and tap on the button or gold disk. Security keys can work on multiple devices.","oie.verify.webauthn.cant.verify.enrollment.step1":"Open your Okta Dashboard (e.g. yourcompany.okta.com) on the device you used to setup your security key or biometric authenticator","oie.verify.webauthn.cant.verify.enrollment.step2":"Go to Settings > Security Methods","oie.verify.webauthn.cant.verify.enrollment.step3":"On Okta Verify, click \\"Set up\\"","oie.verify.webauthn.cant.verify.enrollment.step4":"Scan the QR code using Okta Verify and follow instructions to finish enrolling your account","oie.enroll.webauthn.rk.link":"If you haven\'t set up your security key or biometric authentication, you can complete the process after you sign in using <a href=\\"#\\" class=\\"setup-webauthn-residentkey-link\\">this link</a>.","oie.select.authenticator.verify.email.label":"Select Email.","oie.select.authenticator.verify.email.with.email.label":"Select Email - {0}.","oie.select.authenticator.verify.password.label":"Select Password.","oie.select.authenticator.verify.phone.label":"Select Phone.","oie.select.authenticator.verify.phone.with.phone.label":"Select Phone - {0}.","oie.select.authenticator.verify.webauthn.label":"Select Security Key or Biometric Authenticator.","oie.select.authenticator.verify.security.question.label":"Select Security Question.","oie.select.authenticator.okta_verify.totp.label":"Select to enter a code from the Okta Verify app.","oie.select.authenticator.okta_verify.push.label":"Select to get a push notification to the Okta Verify app.","oie.select.authenticator.okta_verify.signed_nonce.label":"Select Okta FastPass.","oie.select.authenticator.verify.okta_verify.label":"Select Okta Verify.","oie.select.authenticator.verify.named.authenticator.label":"Select {0}.","oie.select.authenticator.enroll.email.label":"Set up Email.","oie.select.authenticator.enroll.password.label":"Set up Password.","oie.select.authenticator.enroll.phone.label":"Set up Phone.","oie.select.authenticator.enroll.webauthn.label":"Set up Security Key or Biometric Authenticator.","oie.select.authenticator.enroll.security.question.label":"Set up Security Question.","oie.select.authenticator.enroll.okta_verify.authenticator.label":"Set up Okta Verify.","oie.select.authenticator.enroll.named.authenticator.label":"Set up {0}.","oie.security.question.label":"Security Question","oie.security.question.enroll.title":"Set up security question","oie.security.question.challenge.title":"Verify with your Security Question","oie.security.question.questionKey.label":"Choose a security question","oie.security.question.createQuestion.label":"Create my own security question","oie.security.question.authenticator.description":"Choose a security question and answer that will be used for signing in","securityQuestion.answer.tooShort.arg":"The security question answer must be at least {0} characters in length","oie.okta_verify.label":"Okta Verify","oie.enroll.okta_verify.setup.subtitle":"To continue, you\'ll need an Okta Verify account on this device.","oie.enroll.okta_verify.setup.download":"If you don\'t have Okta Verify installed, <$1>download the app</$1>.","oie.enroll.okta_verify.setup.openOv":"Open Okta Verify and follow the steps to add your account.","oie.enroll.okta_verify.setup.signInUrl":"When prompted, choose Sign In, then enter the sign-in URL:","oie.enroll.okta_verify.setup.instructions":"Follow the instructions to set up Okta Verify on this device, then return here and refresh this page.","oie.okta_verify.authenticator.description":"Okta Verify is an authenticator app, installed on your phone or computer, used to prove your identity","oie.enroll.okta_verify.setup.title":"Set up Okta Verify","oie.enroll.okta_verify.setup.email.title":"Check your email","oie.enroll.okta_verify.setup.sms.title":"Check your text messages","oie.enroll.okta_verify.setup.skipAuth.subtitle":"To set up Okta Verify on additional devices, you can copy an existing Okta Verify account onto a new device.","oie.enroll.okta_verify.setup.skipAuth.openOv":"Open Okta Verify on any of your other Okta Verify devices (<$1>{0}</$1>).","oie.enroll.okta_verify.setup.skipAuth.openOv.suchAs":"Open Okta Verify on any of your other Okta Verify devices (Such as your <$1>{0}</$1>).","oie.enroll.okta_verify.setup.skipAuth.selectAccount":"In the app, select your account.","oie.enroll.okta_verify.setup.skipAuth.addAccount":"Choose <$1>Add Account to Another Device.</$1>","oie.enroll.okta_verify.setup.skipAuth.followInstruction":"Follow the rest of the instructions shown in Okta Verify.","oie.enroll.okta_verify.setup.skipAuth.canBeClosed":"This screen can be closed at any time.","oie.enroll.okta_verify.setup.customUri.makeSureHaveOVToContinue":"To continue, make sure you have the Okta Verify app.","oie.enroll.okta_verify.setup.customUri.setup":"Once Okta Verify is installed, return to this page and tap <$1>Set up Okta Verify</$1>.","oie.enroll.okta_verify.setup.customUri.prompt":"Click <$1>\\"Open Okta Verify\\"</$1> on the browser prompt to set up Okta Verify.","oie.enroll.okta_verify.setup.customUri.noPrompt":"<$1>Didn\'t see the prompt?</$1>","oie.enroll.okta_verify.setup.customUri.makeSureHaveOV":"Make sure you have Okta Verify installed.","oie.enroll.okta_verify.setup.customUri.orMobile":"Or <$1>set up Okta Verify on another mobile device</$1>","oie.enroll.okta_verify.setup.customUri.orOnMobile":"Or <$1>set up Okta Verify on a mobile device</$1>","oie.enroll.okta_verify.select.channel.description":"Which option do you want to try?","oie.enroll.okta_verify.select.channel.qrcode.label":"Scan a QR code","oie.enroll.okta_verify.select.channel.subtitle":"How would you like to set up Okta Verify?","oie.enroll.okta_verify.select.channel.email.label":"Email me a setup link","oie.enroll.okta_verify.select.channel.sms.label":"Text me a setup link","oie.enroll.okta_verify.select.channel.ovOnThisDevice":"Or <$1>set up Okta Verify on this device</$1>","oie.enroll.okta_verify.select.channel.title":"More options","oie.enroll.okta_verify.select.channel.title.updated":"Set up Okta Verify on another mobile device","oie.enroll.okta_verify.channel.email.label":"Email","oie.enroll.okta_verify.enroll.channel.email.title":"Set up Okta Verify via email link","oie.enroll.okta_verify.enroll.channel.email.subtitle":"Make sure you can access the email on the receiving device","oie.enroll.okta_verify.enroll.channel.sms.title":"Set up Okta Verify via SMS","oie.enroll.okta_verify.channel.email.description":"Make sure you can access the email on your mobile device.","oie.enroll.okta_verify.channel.sms.description":"Make sure you can access the text on your mobile device.","oie.enroll.okta_verify.channel.sms.description.updated":"Make sure you can access the text on the receiving device","oie.enroll.okta_verify.qrcode.title":"Set up Okta Verify via QR code","oie.enroll.okta_verify.qrcode.step1":"On your mobile device, download the Okta Verify app from the App Store (iPhone and iPad) or Google Play (Android devices).","oie.enroll.okta_verify.qrcode.step1.updated":"On your other device, download the Okta Verify app from the App Store® (iPhone® and iPad®) or on Google Play (Android? devices).","oie.enroll.okta_verify.qrcode.step2":"Open the app and follow the instructions to add your account","oie.enroll.okta_verify.qrcode.step3.updated":"When prompted, tap <$1>Scan a QR code</$1>, then scan the QR code below:","oie.enroll.okta_verify.qrcode.step3":"When prompted, tap Scan a QR code, then scan the QR code below:","oie.enroll.okta_verify.qrcode.cannotScan":"Can\'t scan?","oie.enroll.okta_verify.switch.channel.link.text":"Or <a href=\\"#\\" class=\\"switch-channel-link\\">try a different way</a> to set up Okta Verify.","oie.enroll.okta_verify.email.info":"We sent an email to <span class=\\"strong\\">{0}</span> with an Okta Verify setup link. To continue, open the link on your mobile device.","oie.enroll.okta_verify.email.info.updated":"We sent an email to <$1>{0}</$1> with an Okta Verify setup link. To continue, open the link on your receiving device.","oie.enroll.okta_verify.email.notReceived":"Haven’t received an email? Check your spam folder or <a href=\\"#\\" class=\\"resend-link\\">send again</a>","oie.enroll.okta_verify.sms.info":"We sent an SMS to <span class=\\"strong\\">{0}</span> with an Okta Verify setup link. To continue, open the link on your mobile device.","oie.enroll.okta_verify.sms.info.updated":"We sent an SMS to <$1>{0}</$1> with an Okta Verify setup link. To continue, open the link on your receiving device.","oie.enroll.okta_verify.sms.notReceived":"Haven’t received an SMS? <a href=\\"#\\" class=\\"resend-link\\">Send again</a>","oie.enroll.okta_verify.setupLink":"Send me the setup link","oie.okta_verify.totp.title":"Enter a code","oie.okta_verify.totp.enterCodeText":"Enter code from Okta Verify app","oie.okta_verify.push.title":"Get a push notification","oie.okta_verify.push.sent":"Push notification sent","oie.okta_verify.push.resend":"Resend push notification","oie.okta_verify.sendPushButton":"Send push","oie.okta_verify.signed_nonce.label":"Use Okta FastPass","oie.okta_verify.enroll.force.upgrade.title":"Update Okta Verify","oie.authenticator.app.non_fips_compliant_enrollment_device_incompatible":"The device used to set up Okta Verify does not meet your organization’s security requirements because it is not FIPS compliant. Contact your administrator for help.","oie.authenticator.app.non_fips_compliant_enrollment_app_update_required":"The Okta Verify version on the device used does not meet your organization’s security requirements. To add your account, update Okta Verify to the latest version, then try again.","oie.authenticator.app.method.push.verify.enable.biometrics":"Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date and biometrics are enabled for your account in Okta Verify, then try again.","oie.authenticator.app.method.push.verify.enable.biometrics.title":"Enable biometrics in Okta Verify","oie.authenticator.app.method.push.verify.enable.biometrics.description":"Your response was received, but your organization requires biometrics. Make sure you meet the following requirements, then try again:","oie.authenticator.app.method.push.verify.enable.biometrics.point1":"Your device supports biometrics","oie.authenticator.app.method.push.verify.enable.biometrics.point2":"Okta Verify is up-to-date","oie.authenticator.app.method.push.verify.enable.biometrics.point3":"In Okta Verify, biometrics are enabled for your account","oie.authenticator.app.method.push.enroll.enable.biometrics":"Your organization requires biometrics. To proceed, ensure your device supports biometrics, then add your account and enable biometrics when prompted.","oie.authenticator.app.method.push.enroll.enable.biometrics.title":"Enable biometrics to add an account in Okta Verify","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics":"Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date and biometrics are enabled for your account in Okta Verify, then try again.","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.title":"Enable biometrics in Okta Verify","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.description":"Your response was received, but your organization requires biometrics. Make sure you meet the following requirements, then try again:","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.point1":"Your device supports biometrics","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.point2":"Okta Verify is up-to-date","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.point3":"In Okta Verify, biometrics are enabled for your account","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.mobile":"Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date and biometrics are enabled for your account in Okta Verify, then try again.","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.desktop":"Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date, biometrics are enabled for your account in Okta Verify and your device\'s biometric sensors are accessible, then try again.","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.title":"Biometrics needed for Okta Verify","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.description":"Your response was received, but your organization requires biometrics. Make sure you meet the following requirements, then try again:","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point1":"Your device supports biometrics","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point2":"Okta Verify is up-to-date","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point3":"In Okta Verify, biometrics are enabled for your account","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point4":"Your device\'s biometric sensors are accessible","oie.google_authenticator.label":"Google Authenticator","oie.google_authenticator.authenticator.description":"Enter a temporary code generated from the Google Authenticator app.","oie.enroll.google_authenticator.setup.title":"Set up Google Authenticator","oie.enroll.google_authenticator.scanBarcode.title":"Scan QR code","oie.enroll.google_authenticator.scanBarcode.description":"Launch Google Authenticator, tap the \\"+\\" icon, then select \\"Scan a QR code\\".","oie.enroll.google_authenticator.scanBarcode.cannotScan":"Can\'t scan?","oie.enroll.google_authenticator.cannotScanBarcode.title":"Can\'t scan QR code?","oie.enroll.google_authenticator.manualSetupInstructions":"To set up manually enter your Okta Account username and then input the following in the Secret Key Field","oie.enroll.google_authenticator.enterCode.title":"Enter code displayed from application","oie.verify.google_authenticator.otp.title":"Verify with Google Authenticator","oie.verify.google_authenticator.otp.description":"Enter the temporary code generated in your Google Authenticator app","oie.google_authenticator.otp.enterCodeText":"Enter code","oie.verify.custom_otp.title":"Verify with {0}","oie.verify.custom_otp.description":"Enter the code generated on your authenticator and verify.","oie.custom_otp.description":"Enter a temporary code generated from an authenticator device.","oie.custom_otp.authenticator.default.vendorName":"Custom OTP Authenticator","oie.custom_otp.verify.passcode.label":"Enter code","oie.verify.custom_app.title":"Verify with {0}","oie.custom_app.push.sent":"Push notification sent","oie.custom_app.push.resend":"Resend push notification","oie.custom_app.push.warning":"Haven\'t received a push notification yet? Try opening {0} on your phone.","oie.authenticator.custom_app.method.push.verify.enable.biometrics":"Your response was received, but your organization requires biometrics—like a fingerprint or facial scan—for access. Make sure your device meets the following requirements, then try again:","oie.authenticator.custom_app.method.push.verify.enable.biometrics.title":"Enable biometrics in {0}","oie.authenticator.custom_app.method.push.verify.enable.biometrics.description":"Your response was received, but your organization requires biometrics—like a fingerprint or facial scan—for access. Make sure your device meets the following requirements, then try again:","oie.authenticator.custom_app.method.push.verify.enable.biometrics.point1":"Your device supports biometrics","oie.authenticator.custom_app.method.push.verify.enable.biometrics.point2":"{0} is up-to-date","oie.authenticator.custom_app.method.push.verify.enable.biometrics.point3":"In {0}, biometrics are enabled for your account","oie.custom_app.sendPushButton":"Send push","oie.custom_app.push.title":"Get a push notification","oie.on_prem.authenticator.description":"Verify by entering a code generated by {0}.","oie.on_prem.authenticator.default.vendorName":"Custom On-prem Authenticator","oie.on_prem.enroll.title":"Set up {0}","oie.on_prem.verify.title":"Verify with {0}","oie.numberchallenge.warning":"Haven\'t received a push notification yet? Try opening the Okta Verify app on your device, or <$1>resend the push notification</$1>.","oie.numberchallenge.instruction":"On your mobile device, open the Okta Verify prompt, then tap <$1>{0}</$1> in Okta Verify to continue.","oie.numberchallenge.force.upgrade.title":"Update Okta Verify","oie.authenticator.app.method.push.force.upgrade.number_challenge":"Your response was received, but your Okta Verify version is no longer supported by your organization. To verify your identity with push notifications, update Okta Verify to the latest version, then try again.","oie.rsa.authenticator.description":"Verify by entering a code generated by RSA SecurID","oie.duo.authenticator.description":"Verify your identity using Duo Security.","oie.duo.enroll.title":"Set up Duo Security","oie.duo.verify.title":"Verify with Duo Security","oie.duo.iFrameError":"Error loading Duo. Try again or contact your admin for assistance.","oie.authenticator.duo.error":"We were unable to verify with Duo. Try again.","oie.idp.authenticator.description":"Redirect to verify with {0}.","oie.idp.enroll.title":"Set up {0}","oie.idp.enroll.description":"You will be redirected to enroll in {0}","oie.idp.challenge.title":"Verify with {0}","oie.idp.challenge.description":"You will be redirected to verify with {0}","idx.identity.provider.auth.error":"There was a problem signing you into your identity provider. Please contact your administrator for help.","oie.symantecVip.authenticator.description":"Verify by entering a temporary code from the {0} app.","oie.symantecVip.enroll.title":"Set up {0}","oie.symantecVip.enroll.description":"From the {0} app, enter your credential ID and two consecutive generated codes","oie.symantecVip.challenge.title":"Verify with {0}","oie.symantecVip.challenge.description":"Enter the generated security code from the {0} app.","oie.symantecVip.verify.passcode.label":"Enter security code","oie.yubikey.label":"YubiKey Authenticator","oie.yubikey.authenticator.description":"Verify your identity using YubiKey","oie.yubikey.enroll.title":"Set up YubiKey","oie.yubikey.challenge.title":"Verify with YubiKey","oie.yubikey.description":"Use your YubiKey to insert a verification code.","oie.yubikey.passcode.label":"Insert then tap your YubiKey","oie.custom.app.authenticator.title":"Get a push notification","oie.custom.app.authenticator.description":"{0} is an authenticator app, installed on your phone, used to prove your identity","oie.smartcard.authenticator.description":"Use a physical smart card, such as PIV or CAC, to sign in","oie.select.authenticators.enroll.title":"Set up security methods","oie.select.authenticators.enroll.subtitle":"Security methods help protect your account by ensuring only you have access.","oie.select.authenticators.enroll.subtitle.custom":"Security methods help protect your {0} account by ensuring only you have access.","oie.setup.required":"Set up required","oie.setup.optional":"Set up optional","oie.optional.authenticator.button.title":"Continue","oie.verify.authenticator.button.text":"Select","oie.enroll.authenticator.button.text":"Set up","oie.enroll.authenticator.usage.text.access.recovery":"Used for access or recovery","oie.enroll.authenticator.usage.text.recovery":"Used for recovery","oie.enroll.authenticator.usage.text.access":"Used for access","oie.select.authenticators.verify.title":"Verify it\'s you with a security method","oie.select.authenticators.verify.subtitle":"Select from the following options","oie.success.text.signingIn":"Signing in","oie.success.text.signingIn.with.ellipsis":"Signing in...","oie.success.text.signingIn.with.appName":"Signing in to {0}","oie.success.text.signingIn.with.appName.android.ov.enrollment":"To continue, tap \\"Open Okta Verify\\"","oie.success.text.signingIn.with.appName.and.identifier":"Signing in to {0} as {1}","oie.go.back":"Go back","oie.enroll.switch.authenticator":"Return to authenticator list","oie.enroll.skip.setup":"Skip set up","oie.enroll.skip.profile":"Skip Profile","oie.verification.switch.authenticator":"Verify with something else","oie.remember":"Keep me signed in","oie.try.again":"Try again","enroll.title.oda":"Download Okta Verify","enroll.title.oda.with.account":"Additional setup required to use Okta FastPass","enroll.title.oda.without.account":"Set up an Okta Verify account","enroll.title.mdm":"Additional setup required","enroll.subtitle.fastpass":"On this device, do you already have an Okta Verify account for {0}?","enroll.option.noaccount.fastpass":"No, I don’t have an account","enroll.option.account.fastpass":"Yes, I already have an account","enroll.explanation.p1":"To sign in using Okta Verify, you will need to set up Okta Verify on this device.","enroll.explanation.p2":"In the app, follow the instructions to add an organizational account. When prompted, choose <span class=\\"semi-strong\\">Sign In</span>, then enter the <span class=\\"semi-strong\\">sign-in URL</span>:","enroll.oda.android.step1":"On Google Play, download the Okta Verify app.","enroll.oda.step1":"Open Okta Verify and follow the steps to add your account.","enroll.oda.step2":"When prompted, choose Sign In, then enter the sign-in URL:","enroll.oda.step3":"Download the Okta Verify app.","enroll.oda.step6":"Finish setting up your account in Okta Verify, then try accessing this app again.","enroll.oda.with.account.explanation":"Okta FastPass is a security method that can sign you in without needing your username.","enroll.oda.with.account.subtitile1":"Already have Okta FastPass enabled for your account?","enroll.oda.with.account.subtitile2":"Need to set up Okta FastPass for your account?","enroll.oda.with.account.step1":"Make sure your Okta Verify is up-to-date, then try signing in again.","enroll.oda.with.account.step2":"If your device has a work profile, make sure you are signing in from the same profile that Okta Verify is installed in.","enroll.oda.with.account.step3":"On certain browsers and applications, Okta FastPass is not supported.","enroll.oda.with.account.step4":"On this device, open the Okta Verify app.","enroll.oda.with.account.step5":"On the list of accounts, tap your account for {0}.","enroll.oda.with.account.step6":"Under the “Okta FastPass” section, tap Setup, then follow the instructions.","enroll.oda.with.account.step7":"After your setup is complete, return here to try signing in again.","enroll.oda.without.account.explanation":"To sign in with Okta FastPass, you’ll need to set up Okta Verify on this device.","enroll.oda.without.account.step1":"If you don’t have Okta Verify installed, <a href=\\"{0}\\" target=\\"_blank\\" class=\\"download-ov-link\\" id=\\"download-ov\\">download the app.</a>","enroll.oda.without.account.step4":"Finish setting up your account in Okta Verify, then try signing in again.","enroll.appleStore":"the App Store","enroll.googleStore":"Google Play","enroll.copy.ios":"Apple®, App Store, and the Apple logo are trademarks of Apple Inc.","enroll.copy.android":"Google Play and the Google Play logo are trademarks of Google LLC.","enroll.explanation.mdm":"To access this app, your device needs to meet your organization\'s security requirements. Follow the instructions below to continue.","enroll.oda.org.copyLink":"Copy sign-in URL to clipboard","enroll.oda.org.copyLink.success":"Sign-in URL copied.","enroll.mdm.copyLink":"Copy link to clipboard","enroll.mdm.copyLink.success":"Link copied.","enroll.mdm.step.copyLink":"Tap the Copy Link button below.","enroll.mdm.step.pasteLink":"On this device, open your browser, then paste the copied link into the address bar.","enroll.mdm.step.followInstructions":"Follow the instructions in your browser to set up <$1>{0}</$1>.","enroll.mdm.step.relogin":"Logout and re-login and then try accessing the app again.","oie.safe.mode.title":"Authenticator set up unavailable","idx.error.server.safe.mode.enrollment.unavailable":"Set up is temporarily unavailable due to server maintenance. Try again later.","oie.primaryauth.submit":"Sign in","oie.registration.form.title":"Sign up","oie.registration.form.submit":"Sign Up","oie.registration.form.update.submit":"Submit","oie.registration.form.customize.label":"{0}","oie.registration.form.customize.buttonLabel":"{0}","oie.user.profile.login":"Username","oie.user.profile.lastname":"Last name","oie.user.profile.firstname":"First name","oie.user.profile.primary.email":"Email","oie.user.profile.secondary.email":"Secondary email","oie.user.profile.middleName":"Middle name","oie.user.profile.honorificPrefix":"Honorific prefix","oie.user.profile.honorificSuffix":"Honorific suffix","oie.user.profile.primaryEmail":"Primary email","oie.user.profile.title":"Title","oie.user.profile.displayName":"Display name","oie.user.profile.nickName":"Nickname","oie.user.profile.profileUrl":"Profile URL","oie.user.profile.mobilePhone":"Mobile phone","oie.user.profile.primaryPhone":"Primary phone","oie.user.profile.streetAddress":"Street address","oie.user.profile.city":"City","oie.user.profile.state":"State","oie.user.profile.zipCode":"ZIP Code","oie.user.profile.postalCode":"Postal code","oie.user.profile.countryCode":"Country code","oie.user.profile.postalAddress":"Postal address","oie.user.profile.preferredLanguage":"Preferred language","oie.user.profile.locale":"Locale","oie.user.profile.timezone":"Time zone","oie.user.profile.userType":"User type","oie.user.profile.employeeNumber":"Employee number","oie.user.profile.costCenter":"Cost center","oie.user.profile.organization":"Organization","oie.user.profile.division":"Division","oie.user.profile.department":"Department","oie.user.profile.managerId":"Manager ID","oie.user.profile.manager":"Manager","oie.selfservice.unlock_user.landing.to.app.success.message":"Account successfully unlocked! Verify your account with a security method to continue.","oie.selfservice.unlock_user.landing.to.app.signing.in.message":"Account successfully unlocked!","oie.selfservice.unlock_user.success.message":"You can log in using your existing username and password.","oie.selfservice.unlock_user.failed.message":"We are unable to unlock your account at this time, please contact your administrator","oie.selfservice.user.unlock.not.allowed":"Self Service Unlock is not allowed at this time. Please contact support for assistance.","oie.kmsi.title":"Keep me signed in","oie.kmsi.subtitle":"Sign in and enter security methods less frequently.","oie.kmsi.accept":"Stay signed in","oie.kmsi.reject":"Don\'t stay signed in","idx.session.expired":"You have been logged out due to inactivity. Refresh or return to the sign in screen.","oie.registration.is.not.enabled":"Sign up is not enabled for this organization.","oie.forgot.password.is.not.enabled":"Forgot password is not enabled for this organization.","idx.return.error":"Could not process this email link. Return to the screen where you requested it.","idx.return.stale":"This email link is out of date. Return to the screen where you requested it.","idx.invalid.forgot.password.token":"Your reset password token is no longer valid.","idx.invalid.reset.password.token":"Your reset password token is no longer valid. Contact your administrator to obtain a new token.","idx.reset.password.activating.user":"Reset password cannot be performed while the user is activating. Contact your administrator to obtain a new token.","tagsNotAllowed":"The field must not contain HTML tags","api.authn.error.PASSCODE_INVALID":"Invalid code. Try again.","oie.feature.disabled":"The requested feature is not enabled in this environment.","authfactor.challenge.suspended_factor":"This factor is suspended for your account due to too many failed attempts","oie.post.password.update.auth.failure.error":"Your password has been updated but there was a problem signing you in. Please try again or contact your administrator.","oie.assurance.unsatisfiable":"Unable to login to \\"{0}\\" at this time. For assistance, please contact your administrator.","errors.E0000150":"You have reached the limit of sms requests, please try again later.","errors.E0000151":"You have reached the limit of call requests, please try again later.","oie.invalid.recovery.token":"The recovery token is invalid.","oie.consent.scopes.admin.title":"would like to access:","oie.consent.scopes.enduser.title":"would like to:","oie.consent.scopes.granular.title":"<$1>{0}</$1> <$2>wants to access</$2>","oie.consent.scopes.granular.description":"Allowing access will share","oie.consent.enduser.accept.label":"Yes, it\'s me","oie.consent.enduser.deny.label":"No, it\'s not me","oie.consent.enduser.title":"Did you just try to sign in?","oie.consent.enduser.email.allow.title":"Success! Return to the original tab or window","oie.consent.enduser.email.allow.description":"To continue, please return to the original browser tab or window you used to verify.","oie.consent.enduser.deny.description":"Close this window anytime.","oie.return.to.original.tab":"Close this window anytime.","idx.operation.cancelled.by.user":"Operation cancelled by user.","idx.transferred.to.new.tab":"Flow continued in a new tab.","idx.return.link.expired":"This email link has expired. To resend it, return to the screen where you requested it.","idx.return.link.otponly.your.verification.code":"Your verification code","idx.return.link.otponly.enter.code.on.page":"Enter this code on the {0} page.","idx.return.link.otponly.enter.code.on.page.sign.in":"sign-in","idx.return.link.otponly.enter.code.on.page.password.reset":"password reset","idx.return.link.otponly.enter.code.on.page.account.unlock":"account unlock","idx.return.link.otponly.enter.code.on.page.registration":"sign up","idx.return.link.otponly.enter.code.on.sign.in.page":"Enter this code on the sign-in page.","idx.return.link.otponly.enter.code.on.password.reset.page":"Enter this code on the password reset page.","idx.return.link.otponly.enter.code.on.account.unlock.page":"Enter this code on the account unlock page.","idx.return.link.otponly.enter.code.on.sign.up.page":"Enter this code on the sign up page.","idx.return.link.otponly.request":"Request from:","idx.return.link.otponly.warning.text":"If you didn’t request this code, you can ignore this message. Your account is safe and can only be accessed with this code.","idx.enter.otp.in.original.tab":"Enter the OTP in your original authentication location.","idx.return.link.otponly.app":"{0}","idx.return.link.otponly.browser.on.os":"{0} on {1}","geolocation.formatting.all":"{0}, {1}, {2}","geolocation.formatting.partial":"{0}, {1}","consent.scopes.email.label":"View your email address.","consent.scopes.profile.label":"View your profile information.","consent.scopes.phone.label":"View your phone number.","consent.scopes.address.label":"View your address.","consent.scopes.offlineAccess.label":"Keep you signed in to the app.","consent.scopes.onlineAccess.label":"Keep you signed in to the app.","consent.scopes.deviceSSO.label":"Request device secret.","consent.scopes.openid.desc":"Signals that a request is an OpenID request.","consent.scopes.profile.desc":"The exact data varies based on what profile information you have provided, such as: name, time zone, picture, or birthday.","consent.scopes.email.desc":"This allows the app to view your email address.","consent.scopes.address.desc":"This allows the app to view your address, such as: street address, city, state, and zip code.","consent.scopes.phone.desc":"This allows the app to view your phone number.","consent.scopes.offlineAccess.desc":"This keeps you signed in to the app, even when you are not using it.","consent.scopes.onlineAccess.desc":"This allows the app to access your data only when you are logged in to the application.","consent.scopes.deviceSSO.desc":"This allows you to single sign on between native client applications on your device.","consent.scopes.okta.users.manage.desc":"Allows the app to create new users and to manage all users\'\' profile and credentials information.","consent.scopes.okta.users.manage.self.desc":"Allows the app to manage the signed-in user\'\'s profile and credentials.","consent.scopes.okta.users.read.desc":"Allows the app to read the existing users\'\' profiles and credentials.","consent.scopes.okta.users.read.self.desc":"Allows the app to read the signed-in user\'\'s profile and credentials.","consent.scopes.okta.linkedObjects.manage.desc":"Allows the app to manage linked object definitions in your Okta organization.","consent.scopes.okta.linkedObjects.read.desc":"Allows the app to read linked object definitions in your Okta organization.","consent.scopes.okta.myAccount.manage.desc":"Allows the end-user to manage their account profile.","consent.scopes.okta.myAccount.read.desc":"Allows the end-user to read their account profile.","consent.scopes.okta.riskEvents.manage.desc":"Allows the app to publish risk events to your Okta organization.","consent.scopes.okta.clients.manage.desc":"Allows the app to manage clients in your Okta organization.","consent.scopes.okta.clients.read.desc":"Allows the app to read information about clients in your Okta organization.","consent.scopes.okta.clients.register.desc":"Allows the app to create new clients in your Okta organization.","consent.scopes.okta.authorizationServers.manage.desc":"Allows the app to create and manage Authorization Servers in your Okta organization.","consent.scopes.okta.authorizationServers.read.desc":"Allows the app to read information about Authorization Servers in your Okta organization.","consent.scopes.okta.groups.manage.desc":"Allows the app to manage existing groups in your Okta organization.","consent.scopes.okta.groups.read.desc":"Allows the app to read information about groups and their members in your Okta organization.","consent.scopes.okta.groups.register.desc":"Allows the app to create new groups in your Okta organization.","consent.scopes.okta.events.read.desc":"Allows the app to read information about deprecated Events v1 API entries in your Okta organization.","consent.scopes.okta.logs.read.desc":"Allows the app to read information about System Log entries in your Okta organization.","consent.scopes.okta.inlineHooks.manage.desc":"Allows the app to create and manage Inline Hooks in your Okta organization.","consent.scopes.okta.inlineHooks.read.desc":"Allows the app to read information about Inline Hooks in your Okta organization.","consent.scopes.okta.eventHooks.manage.desc":"Allows the app to create and manage Event Hooks in your Okta organization.","consent.scopes.okta.eventHooks.read.desc":"Allows the app to read information about Event Hooks in your Okta organization.","consent.scopes.okta.apps.manage.desc":"Allows the app to create and manage Apps in your Okta organization.","consent.scopes.okta.apps.read.desc":"Allows the app to read information about Apps in your Okta organization.","consent.scopes.okta.schemas.manage.desc":"Allows the app to create and manage Schemas in your Okta organization.","consent.scopes.okta.schemas.read.desc":"Allows the app to read information about Schemas in your Okta organization.","consent.scopes.okta.idps.manage.desc":"Allows the app to create and manage Identity Providers in your Okta organization.","consent.scopes.okta.idps.read.desc":"Allows the app to read information about Identity Providers in your Okta organization.","consent.scopes.okta.roles.manage.desc":"Allows the app to manage administrative role assignments for users in your Okta organization.","consent.scopes.okta.roles.read.desc":"Allows the app to read administrative role assignments for users in your Okta organization.","consent.scopes.okta.policies.manage.desc":"Allows the app to manage policies in your Okta organization.","consent.scopes.okta.policies.read.desc":"Allows the app to read information about policies in your Okta organization.","consent.scopes.okta.orgs.manage.desc":"Allows the app to manage organization-specific details for your Okta organization.","consent.scopes.okta.orgs.read.desc":"Allows the app to read organization-specific details about your Okta organization.","consent.scopes.okta.captchas.manage.desc":"Allows the app to create and manage CAPTCHAs in your Okta organization.","consent.scopes.okta.captchas.read.desc":"Allows the app to read information about CAPTCHAs in your Okta organization.","consent.scopes.okta.sessions.manage.desc":"Allows the app to manage all sessions in your Okta organization.","consent.scopes.okta.sessions.read.desc":"Allows the app to read all sessions in your Okta organization.","consent.scopes.okta.trustedOrigins.manage.desc":"Allows the app to manage all Trusted Origins in your Okta organization.","consent.scopes.okta.trustedOrigins.read.desc":"Allows the app to read all Trusted Origins in your Okta organization.","consent.scopes.okta.templates.manage.desc":"Allows the app to manage all custom templates in your Okta organization.","consent.scopes.okta.templates.read.desc":"Allows the app to read all custom templates in your Okta organization.","consent.scopes.okta.factors.manage.desc":"Allows the app to manage all admin operations for org factors (e.g. activate, deactivate, read).","consent.scopes.okta.factors.read.desc":"Allows the app to read org factors information.","consent.scopes.okta.authenticators.manage.desc":"Allows the app to manage all security methods (e.g. enrollments, reset).","consent.scopes.okta.authenticators.read.desc":"Allows the app to read org security method information.","consent.scopes.okta.authenticators.manage.self.desc":"Allows the app to manage users own security methods (e.g. enrollments, reset).","consent.scopes.idSnapshot.read.desc":"Allows the app to read your identity snapshot attestation.","consent.scopes.idSnapshot.manage.desc":"Allows the app to create and manage your identity snapshot attestation.","logo.for.the.app.alt.text":"Logo for the app","device.code.activate.title":"Activate your device","device.code.activate.subtitle":"Follow the instructions on your device to get an activation code","device.code.activate.label":"Activation Code","device.code.activated.success.title":"Device activated","device.code.activated.error.title":"Device not activated","idx.device.activated":"Follow the instructions on your device for next steps","idx.device.not.activated.consent.denied":"Your device cannot be activated because you did not allow access","idx.device.not.activated.internal.error":"Your device cannot be activated because of an internal error","idx.invalid.device.code":"Invalid code. Try again.","idx.operation.cancelled.on.other.device":"Access denied on other device.","idx.expired.activation.token":"Your account activation link is no longer valid. Request a new activation email below.","idx.missing.activation.token":"This can happen if you have already activated your account, or if the URL you are trying to use is invalid. Contact your administrator for further assistance.","idx.activating.inactive.user":"Your account has been temporarily suspended. Contact your administrator for further assistance.","idx.request.activation.email":"New activation link requested. If your information matches our records, you will receive a new activation link in your inbox soon.","oie.activation.request.email.title.expire":"Activation link has expired","oie.activation.request.email.title.invalid":"Activation link no longer valid","oie.activation.request.email.title.suspended":"Account suspended","oie.activation.request.email.title.submitted":"Request submitted","oie.activation.request.email.button":"Request activation email","oie.browser.error.NotAllowedError":"The operation either timed out or was not allowed.","authfactor.challenge.soft_token.invalid_passcode":"Your code doesn\'t match our records. Please try again.","authfactor.challenge.soft_token.used_passcode":"Each code can only be used once. Please wait for a new code and try again.","oie.tooManyRequests":"Too many attempts. Try again later.","E0000010":"Server is unable to respond at the moment.","idx.error.registration.unavailable":"Registration is currently unavailable.","idx.error.user.not.assigned.to.app":"User is not assigned to this application.","idx.error.code.user_not_assigned":"You are not allowed to access this app. To request access, contact an admin.","idx.error.code.access_denied.device_assurance.remediation.title":"Your device doesn\'t meet the security requirements","idx.error.code.access_denied.device_assurance.remediation.explanation_one_rule":"To sign in, make the following updates. Then, access the app again.","idx.error.code.access_denied.device_assurance.remediation.explanation_multiple_rules":"To sign in, pick an option and make the updates. Then, access the app again.","idx.error.code.access_denied.device_assurance.remediation.option_index":"Option {0}:","idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version":"Update to Android {0}","idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version.at_least":"Update to at least Android {0}","idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version.exactly":"Update to exactly Android {0}","idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version.one_of_the_following":"Update to one of the following: Android {0}","idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version.exactly_one_of_the_following":"Update to exactly one of the following: Android {0}","idx.error.code.access_denied.device_assurance.remediation.android.device_disk_encrypted":"Encrypt your device","idx.error.code.access_denied.device_assurance.remediation.android.use_lock_screen":"Enable lock screen","idx.error.code.access_denied.device_assurance.remediation.android.use_biometric_lock_screen":"Enable lock screen and biometrics","idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version":"Update to iOS {0}","idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version.at_least":"Update to at least iOS {0}","idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version.exactly":"Update to exactly iOS {0}","idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version.one_of_the_following":"Update to one of the following: iOS {0}","idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version.exactly_one_of_the_following":"Update to exactly one of the following: iOS {0}","idx.error.code.access_denied.device_assurance.remediation.ios.use_lock_screen":"Set a passcode for the lock screen","idx.error.code.access_denied.device_assurance.remediation.ios.use_biometric_lock_screen":"Set a passcode for the lock screen and enable Touch ID or Face ID","idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version":"Update to macOS {0}","idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version.at_least":"Update to at least macOS {0}","idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version.exactly":"Update to exactly macOS {0}","idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version.one_of_the_following":"Update to one of the following: macOS {0}","idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version.exactly_one_of_the_following":"Update to exactly one of the following: macOS {0}","idx.error.code.access_denied.device_assurance.remediation.macos.use_lock_screen":"Set a passcode for the lock screen","idx.error.code.access_denied.device_assurance.remediation.macos.device_disk_encrypted":"Turn on FileVault","idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version":"Update to Windows {0}","idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version.at_least":"Update to at least Windows {0}","idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version.exactly":"Update to exactly Windows {0}","idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version.one_of_the_following":"Update to one of the following: Windows {0}","idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version.exactly_one_of_the_following":"Update to exactly one of the following: Windows {0}","idx.error.code.access_denied.device_assurance.remediation.windows.device_disk_encrypted":"Encrypt all internal disks with BitLocker","idx.error.code.access_denied.device_assurance.remediation.windows.use_biometric_lock_screen":"Enable Windows Hello for the lock screen","idx.error.code.access_denied.device_assurance.remediation.additional_help_default":"For more information, follow the instructions on <$1>the help page</$1> or contact your administrator for help","idx.error.code.access_denied.device_assurance.remediation.additional_help_custom":"For more information, follow the instructions on <$1>your organization\'s help page</$1> or contact your administrator for help","idx.error.code.access_denied.device_assurance.remediation.chrome.disk_encrypted":"Turn on disk encryption","idx.error.code.access_denied.device_assurance.remediation.chrome.os_firewall":"Turn on your device\'s firewall","idx.error.code.access_denied.device_assurance.remediation.chrome.screen_lock_secured":"Turn on automatic screen saver and screen locking when idle","idx.error.code.access_denied.device_assurance.remediation.chrome.upgrade_browser_version":"Update Chrome browser to {0}","idx.error.code.access_denied.device_assurance.remediation.chrome.chromeos.upgrade_os_version":"Update to ChromeOS {0}","idx.error.code.access_denied.device_assurance.remediation.chrome.chromeos.key_trust_level.verified_mode":"Switch your device to verified mode","idx.error.code.access_denied.device_assurance.remediation.chrome.chromeos.key_trust_level.developer_mode":"Switch your device to developer mode","api.policy.okta.account.management.insufficient.authenticators.unable.to.sign.in":"Unable to sign in. Contact support for assistance."}');

/***/ }),

/***/ "./src/config/config.json":
/*!********************************!*\
  !*** ./src/config/config.json ***!
  \********************************/
/***/ (function(module) {

"use strict";
module.exports = /*#__PURE__*/JSON.parse('{"defaultLanguage":"en","version":"7.20.1","supportedLanguages":["en","cs","da","de","el","es","fi","fr","hu","id","in","it","ja","ko","ms","nb","nl-NL","ok-PL","ok-SK","pl","pt-BR","ro","ru","sv","th","tr","uk","vi","zh-CN","zh-TW"]}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/exports/cdn/default.ts");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=okta-sign-in.js.map